/* eslint-disable */
import { useState, useRef, useEffect, Component, Fragment } from "react";
import { flushSync } from "react-dom";
import { createRoot } from "react-dom/client";
import { BbotPercentileReport } from "./BbotPercentile";   // Phase D: player-facing percentile report (dormant until PERCENTILE_MODE flips)
// THE PRE-1.0 REPORT RENDERER IS NO LONGER IMPORTED. `BbotBoxReport` was the component the
// hand-written sample rendered through, and after the sample became a real generated card nothing
// rendered it at all -- but the import stayed, which is how a dead surface stays one edit away
// from being live again. Its SHARED HELPERS are still used and still imported; the renderer is not.
import { gradeForField, timedGradeBasis, AGE_RULE } from "./BbotBoxReport";  // shared timed-metric grade helper + disclosure basis + the documented age rule
import { BbotCaptureGuide } from "./BbotCaptureGuide";     // Phase D: tiered filming guide, surfaced in the upload flow
import { BbotManualVeloEntry } from "./BbotVeloEntry";   // attested manual velo -> bbot_velo_entries
import { BbotPercentileSearch } from "./BbotPercentileSearch"; // Phase E: coach percentile/range search (dormant until percentile data exists)
import { buildReportPdf } from "./bbotPdfText";           // text-native PDF: real text for every value, so the customer artifact is readable AND checkable
import { toolIsMeasured } from "./bbotMeasured";  // ONE answer to "is this tool measured?", shared with the PDF — see that file for why it is not a grade, and why no percentile renders

const LOGO_BBOT = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAYAAADDPmHLAAAvjklEQVR42u29eZRd1XUn/Nvn3Hvf/F5VSVWlWQKhGZCELANikBCDGJpYhJTS6a9j1G6TuEPabocQB4dYlO0FndjYMStOJ7bbwe58yddUCLJpzCCDJIMEmEESRjMCSSWVVFVSVb35vXvvOfv74w5VT0KgqaQqdZ213qrpvVv37r3PHn97H8KZLmZa/PA6ub71Bjf4VcsqtsrYd6nWfJXWaj5rNRPARIAboFUSRISR9VG0ZAhZAKgHQDsJuUMIuUkIej2Gye+1tZIdvHXxqrXG+oeXKBDxmfzLM2AEU8uTEG0rSAHAgn9gs+nA/iXQznJmvgGsLxFmxCQQmBW0csGsAOYRRn8sRwhEEkIaIJJgMLRTdUDifSJaC2Gu7powad3bf0gOALQ8ybJtBTRweoJwWgLQ0sKyrc1j/M2rDjUZurwSWt9D0pgthAnlVqBdG8xag4jBTEQgYGTnn7QqYHA/7YQQhgVpRKG1A1buNgjxE1fEnljTOrbrWJ4MogAwtbS0iba2FWrxqveScR37Imv9RcOMNyu3AuVUNIE0AAECnZmGGVkDCQ8GA9AMFtKMCmlE4TqlThLi8ZIoP76+9dJCS8uTsq2t5ZS0wUkzaNUqFq2tpAHgtod2LwfEo9KMzXSrebByXQYEEYkRXp0T/aAJ0CQNw4ikoJzyDkA/+Nw3p60+lldnRQA8O0Pq5vs3J2Qs9V0pjHu1dqGdigtAjjh159FpBJQwo4YQBpR2f6jK+S+veWxeMeDZJ13iE3fs4lVrjbYVpG55cMdMI5Z61TCj9zp2USmnokFkjDD/vDqMBCJDORXt2EVlmNF7jVjq1Vse3DGzbQWpxavWGmekARavWmusb73BveXB7TcYRvR/g6hRVYsuiIwR6g9JjeDKSMIAc7frVn73xUdnrQ14eMoCEHxw2Ve3LxPCWg3WUeXaiojkCKWHtFVQ0rAkSFS0tpe/8MisFz5OCOjjbP6tD25bLGTkea1VVCtbE4kRJ29YCIHWQlpCCFnRqnrr84/OXn8in0B8lLfftoLUsoc+mEEy8hSzjmrXGWH+sHINhNCuo5l1lGTkqWUPfTCjbQWpVatYfIIAMAHAzfcfSpB220jIUcq1FYmR8G7YCYEg4fFOjiLttt18/6HEQB5/pAC0PAnR2kpaWrm/MSLJy9xK0R2x+cM6SJBupegakeRl0sr9TWsr6ZYna3ke/tDS8qRsW0Hqtod2/TtpxT7vlPpcEiPe/gWgCQyn1OdKK/b52x7a9e/aVpBqaXlS1goAM82evZVv/tahhFb6b7RymMEjav9CcQrBQiuHtdJ/c/O3DiVmz97KYM8UCABoWQHR2tqqZV/+v5rR9FTtVNRIWveCMgVCOxVlRtNTZV/+v7a2tuqWFR7vCcwEIix/5EBDOV/cQUSjWLkMwogAXFhqQJM0iJmPxlKJmau/OqEHzBCLH14nAXC5UPycGU2O1srRI8y/ENUAhFaONqPJ0eVC8XMAePHD6yQBTC2rYObsnb8R0pymnQpjRP1foFqAtTCjpJWzO23NuKytFY4AiPP2zuukGZ2uLnDmkw9JEcFL+C//Z7rQIStEQjkVlmZ0et7eeR1AbHjmQf62ECaHYI4LYHkMJV/wGYoBpRhKez9rDXCoHT1BICJIAQhBkMd8Xl8gSDYCaSFMUnB+G8BLdOv3dkVwWG8R0pzhl3jFcN3dwmeYqxi2q+G4HozGlIRYRCAZk0hEBeIRgVhEwvSjYUcB5apCqapRrGgUygrlqoajGATANAiWIWBI7/qaefhCG5m1NKNCK2cnxoi5Bndac4Dqxcq1MRyZL4THFNvRqNgKREAmYeDisTFcPDaKaeOjmNQUweiMgfqUgaglYMqP1vOOYlRsjd68iyNZF/u7qth9sIIPDlXQ3m0jW3TBDEQtAcv0SKWHm2ogEh6vxcXotOYYjOoi04yYTrWoh0vsH+x2pRmFklfgGjvKwrypcSyckcTsyTGMG2V9wkaoNQFEnqYwYxKpmMSkpgiumJYI399x1Ma2fWW8ubOAzXtKOHTUQ2jHowJS0LDSCsxam1bMdNzqIkMQzYUH2B3yt0/+jndcjVxVIR2XWDw3jRvnZ7BgWgKpeG3ZQunjmULk18AHeHsMgLVnLj7q/VIQxo2yMG6UhZuuyCBfUnh7dxEvbcrirV0F9BVdJCICpiGg/esM8R3EAEEQzTVY80wWCkFCaKguKQiOYuQKLprqTNx17Sjc/uk6TG6OhO8Jic+etAginLROO8GzM3uCFFyTAKTiEkvmprFkbhr7Oqv4xa/78OJbfejqc5CISZjS005DWAUQswJrnknLHtyxT5CYpLXDQzEIEuTRPl9SaEgZuPPqeiy/pgGNGdN3yAJsZL+GGLhyJYWOozYOHrHR2eugO+sgV9Ko2Bqu6wFnDUMgagmk4wKNGRPN9SbGj/Z2fPoYrTJwhxMRgn/XnXWwekMPnnmtFz15F6m4BPn3NxQlQAiTNOv9tOzBHTmAU0PRgElBKFc1GIxln6rDZ29uDG270gwCgcGQA5herChs21fGlj0lbN1XQnu3jb6Ci6rD0Jr9WJ98M9BvA9gP95g9IYqYhLqkgYmNFuZMjmPu1DhmT44hEZU1JubYe+g4auOna7rxwlt9IHjRx5DUBkQAKE/LvrJNDbXUb2CnsyWF6eNj+KPfasbCGcl+ohOBuZ/oWjPe3l3Eui05vL27gMM9DhzFMCTBMgiGpDBEHGj3B7qBx6o+zeyHk95XUxLGNJhYMC2JJXPTWDAtEWqbj7qnN3cW8Hc/78Sug2Vk4vIj/YvzrwigadmfbxtStyUE4LqMisO4+7oG/MEdzYhZAlp7gsHMIeHzJYU172Tx3Jt92H2gDFexF6IZFDLkTAgfCGJwLdv1wkRDEqZNiOG2hXW4+YpM6HzqUBC85yjbGj94thNPvdKDqEkwDILWQ0wRDCUBkIJQqigkYhJfvnssbpyf8QnrM9/3CcpVjdUbe7B6Qw8OHrFhGgIxy2P6YIZjQfjJzCjbDMfVGD/awvJrGrB8UQNiEQHNntAEQgAAL23K4rtPHUKxrBCPyiFlEoaMABiCkC25uGhsFK2fnYiLxkSgtLfbWfcT8+VNWTzxYjf2dFQQiwhETHFeUrVBqrnqaJSrGlPHRbHylkYsHSi0wtMKUhA+PFzFqp+248NDFWTiBtwhIgRDQgAMSegruFgwLYnWeyagLmlA+YQLvh7udfD9nx3Gui1ZWL7XPhSSL4FWqNgatquxZG4G931mDMbUm8c9Q1/BxaqfHMDbuwuoSxpwFY8IgCEJvQUX185J4+srJyBi9qvRgMDrtuTwvX87hO6cg0zcGJLFmUAjZEsuGtMmvvTbY7FkbjoU0MB8VR2Nrz1xAK9uzaF+CAiBvOTa+x4+nzY/W3Rx7ZwUvrFyUg3zyW8u/8H/6cTjqw9DM5CIePZzKIbWgbMZsyTKNuOX72RhO4wFM5JhdiUoTC2+PI09HRXsPlhBLCLPqxYT55P5+bLCgulJfH3lRFgmecz3a/JVR+Ohf2zHT17sRjImYEgM7ezagNyAIYFkTOAnL3bjoX9sR9XR4XNpBiyT8PWVE7FgehL5sqrJY/xfIQBSEEpVhSnNEXzjnom1ap+BI1kHX/z+Xvzq3Swa0oZXux9GRTdmzwlsSBv41btZfPH7e9HV5wD+M2oGIqbAN+6ZiCnNEZSq508IzrkAEAGO0khEJb6xciLSCQmtPfsYGH4pvASOl2UbvovRny4emIcS5AlIOuHRIBGVcJQ+L4n48yAAXnr3gZZxmNwchHp+Xd0vuNSnDDz2h1Nw1ewk+gpuCMQ4+w/PEIMkYkFkc9WsJL73Rxd5tQtfyLX/zEozJjdH8EDLOJSr+ryMWjinAiAFIVtwsWLxKCyemw7DoyD/TuRtG/bt5DdXTsKi2Sn0DoIQEBglMlEi86zrmSCyWTQ7hW+unBT6N4EJEP4zByHi4rlprFg8CtmCe85NwTkTAEFAqaowbUIU997eDM3sZ9U89fjsG33oLbhhxi9wllrvmYgF0xLIFhXkWRICAlCFgbnuYcx1D8OGcdamWUlJyBYVFkxLoPWefuc2MH/5ksKLb/f5aW0vh6CZce/tzZg2IYpSVeFcysA5E4Bgj33prrGIWsLfgx5RNryXx8M/bcdf/LgdfYV+AmgG4hGBR/7zJMycGEXhLHjMAowSGVjs7MV3Cs/hO4XncJ2zFyUyztgcSEEolBRmTozikf88CXE/NRxsgL6Cwp//z/34ix+3Y8N7+VDYAULUEvjSXWNraHXBCIAUhFxJ4baF9Zh/SSIM5whAV5+Db7V1YFTawHt7S/izH+5DtugJQeAxJ6MS3/xPk9Bcb6Ji6+Mqe6e6+10IzFBH4GtlXKo64UKckRYIsoFjGkx88z9NQjIqw8hGEJAtKvzZD/fhNx+UMCpt4FttHejqc8L/qTRj/iUJ3LawHrnSuYsKBl0ACICrNBpSBlYua/RVvmfsiYC//dlhHMk5kIKQjkts31/GV3+8H8WKDqtxWgPN9Sa+uXISDIP88uuZ3VeerJD4zhkyn8hjoGlQKKha9ye0ihWNr/54P7bvLyOdkJCCcCTn4G9/dth/jv4q4spljWhIGXCVPidDFgddAIQgFMoayxc1oKnOhGbPyxNE+NW7Oby8OYtM3Mv9u4qRTkhs3lPCqp+2o2Jrz1fwPebpE6L405ZxKFfVGXvMA9U9nbGQe3mN+39nHKaNj/ZHNuyVj1f9tB2b95SQTki4iqE0IxM38PLmLH71bs7TaMzQzGiqM7F8UQMKZX0cumnYCQAR4Ljaw/Bd0xDufvLV5Y+e64JliBDSBXjNG/VJiY1b8/h2W0foKQsiKMW4+YoM7r7e95jl+UewSUnIlVzcdc0o3Lwgc1wB6NttHdi4NY/6pIQakPdnZliGwI+e60LF1iFdmIG7rvE2i+MOfm5gUAVAEKFY0bh1YZ2X0fN3PxHwzGu92HOogrgljivsuIrRkDLw7Bu9+KeXuvuFwIdf/8HtzZg+IYZS5dx6zB8V2ZSrGpObI/jCnc3Q3A9Xl4LwTy9149k3en2VXvuQmoG4JbDnUAXPvNbrh8CeFmhIG7h1YR2KlTPzd867ALjaU+l3XFXv53g8KS+WFf71laOIWQLqBDleVzHqkwZ++IsuvLGjAEP2R+uxiMCfrhgHQ9IpVQXJT/xI6JrYn/zfCfAp5QQCHOGX7x6LeESEv5OC8OudBfzwF10fW/FTzIhZAv/6ylEUy8rHKnp3cMdV9Z7JGOT6x6AJQIDuWTgjiQmjLR+e5e3+X27K4kC37YM5Pp7AlkF49F8O4OAR27fV3g6bMzmGu65tQP4kPOYg4+dAIk8W+igGm4xwmrUDA30UQ54sOJAnlSGUgpArKvzWogZ8anqyJrI51OPg0X85CNP4eHFivyZwoNvGLzdl/bCQwcyYMNrCwhlJlCqDGxEMngZgjxw3X5EJS6VCEFzFePaNPj9B8vFEZgYsQ+BoTuE7Tx0K7WFgK//DDY0YO8pC9QS2MtjxRbJQIAuNXMJS5wP8SXkjrrf3okISVZJY6B7El8sbsdT5AI1cQoEsFMk6oUYIfZt6E/fc1BgmdALz9v2fHUZ3n4OIIT6xiKWZYZmEZ9/og6s4zBIygJuvyHgiNYhKYFCGQBEBVVdj/CgLV0xL9oM7ALz7QQm7DpQRj8qT6qtTmpGOS7yxPY9nXu/FnVfV+529jLqkxOdubcIj/3wAkYRRY04kGBWScCGxwDmI251dmO8cQoYrkGCUyYTtP/4EncU9lSNQIGQpik3mWPzCnI63zfEwoBBlBTUgVhBEyFUU/uCOZr9ayWHE88tNWax/N4tMwjip8jUzEItI7DpQxrsflMJ2NAJwxbQkxo+ycCTneNqEh4kGCJIi8y6JIxH12qUC4PXLm7Nw/a7bk12aGbGIwI+f60JPzvXBIh5Bbroig6njoijb/VpAgpEnC026iK8VX8ZfFV/EEvtDmNAokoUKGYiwizRXkOYKouyiQgaKZMGExhL7Q/xV8UV8rfgymnQRebIgg5ydj1WY2BTBbZ+u85jie/B9RYW/f6bTL2+fPLfI93le3pwNw0qtGYmowLxL4mec/DovJoAI+LSP5Wd4oM5SVeOtXcUQz3fS1oQByxTo6nPw/607UuMxWwbht68ZharjEUmCkaMIFjnteDz/LJY6HyLvMz3FVRAYe0QDXrQuwUvWVLxkTcWL1iXYIxpAYKS4igoZyJOFpc6HeDz/LBY57chRBBJeOFq2NX7r6nokotLHJXqqf/WGHnQctRGxxCntVs0enP2tXUWUqhpC9Gv9Tw9AFA0bE+AqRiZhYM6UeE0hYPu+Eg732DU58pNdSjFScYn/83ov7ry6ARMbrbBN66YFGfzz2m705RyUzChure7Gn5VegUMCvRRFHVdwSKTwL5HLscGcjA6RQpnM0NHTIMTYwTidxzXOPtxu78JYnUcvRZGAjW8Uf4m/jl+H5yPTkHAraKozcevCunD3CkHo7nPw9Ks9SMYE9Cni/Dxfh3C4x8b2fSUsmJ4MaTZnShyZhAHH5UERBHH21T9QdRiTmiw01ZmBLwgA2LSn5A1dOM0n8TCECs+81hsqz0BVLr40hS7HxHXufjxQegUVMuBAIs1VPB2ZjfuSd+KJ6BVolxkIf6cn2EaCbaS4CgFGu8zgiegVuC95J56OzEaaq3AgUSEDD5RewXXufnTZJhbNTKAhZdT4MM+92YfurANTnl5Jichrft20pxTaBQbQVGdiUpOFqsODkvMQZ1/1E1zl4eQpAD/4DN+6twRDEE4X1qk1Ix4VWPduFvmywsDx1Qsvq8cUyuP+0qtwyYv0o+ziO/Fr8FjsGpTIRB2XYbEb7vqBLwCw2EUdl1EiE4/FrsF34tcgyi40CC5J3F96FRM5hysvbxhg2ggVHwQaO0XTVhs0MQxB2Lq3FPpRQS/j1HFRrzYwCCpg0HyAqeOioXoL6uDt3TYs8/S9WS8vINBxxMYb2ws1f5s+OYqHE1uQsouokoEE2/he/Go8bc1GPZchoaH8wC7IDUj/JcJOQYKCgIRGPZfxtDUb34tfjQTbqJKBtF3E1+JbMGdqvOZ/b3q/gL2d1VO2/cf7OYT2bhv5kgrxAgNpOSycQGavKXNSY6Tm9weP2iG860zDGSLglfdy3vf+xdIffogZ3XtQNGOo02X8LDILq61ZaODScYwHgBKZyFIEWYqgRGbN3wJBaOASVluz8LPILNTpMgpmDHN69qBh/4c1/3v9u3k/0jkTuvXDyA4etWv+Nqkx4tONh74AaPZStY11Zs3vO47Yoad+ZtdnREyBXe0VL1fuG8byy6+jUlWIkkaHSOF/ReYhyTb0gEcUYJTJgAuBee4h3F3dirurWzHPPQQXAuVjQCEaAkm28b8i89AhUoiS1wZWefl1aF8jVWyNHe2lUw79ThQ+Vx2NjiO1AtBYZ4Z9h0M6CiDyIoC6pIH6ZO1ghcO9zlnpjGX2pnZ19jn48FAZl16UgOrNQW1/H4hFEFM2fhG9DN0ijjquhgkcLyNoYoY6ivvKb2CW2wUD3g25ENhuNOH7sSuxU45Cgp2wWmBCo1vE8QtrOu6tvI1qLAK1/X3o3hyQSeHDQ2W/QfXsJGq09mg1cNUnJZIxedY06OBqAA0kosKHffXDoY9kndMOYwbaawmGSQzlKBzsLANKw929F5wrwpCEHEWw0ZyMCCvomp1vYro6ir8qvIBL3U6UyUSOIshRBGUycanbib8qvIDp6ugxISIQYYWN5mTkyFPFOleE2r0XBhg9vVW4toIpau/xdOFlRB6tBtIuagk/oTbEfQDyU7eJiAxRvAHPs75jczrXLJKFPooiSxH0UQRZiqEXEezJSUAKqI4usNawoLFfZnBQpBCBCu0+g2Cwxh+X30Caq8hR5DgnMEcRpLmKPy6/AYN1zWcjUDgoUtgvM7CgobWG6ugChMCevMRRjiBHMf/eIuijKIoDEEenKgBZf/JZ8HlDUtgWR0PZBICC3LYI1XXwGAHogU+R+VVILLU/wHR1xCeqFw9XNGPm5ihsnYF6dwc4YsHQLvabGZTJQIpteCPPPfj3PPcQZrldKJAVqv5aQmgUyMIstwtzVCc2G2MR900B+Rpkv8hgttMNRCzod3fAjpq4ZFsO/0WVES17pWkGIcE2dsnRWG9O8QXx5KOcACwTlrP8KCoW8SMMwlktDp31TCADkLKmIBhmB2vSgieh9ktk4nL3MB4qrauZ6Rd8437AqOxgkGWCTAPQVRioxdIFINApqg8mNEqfcO8mNKaoPrxljD/uOga0l/Y1DHBHJypPHsAVJuFKg4By7dMRgKPJ2/CuMSYUpJMsofbTisJeGUg5OEXBYTcZlGtEiHBejqimY6Xx2PsaPssYDNoo1f99oLb6O3tOTod5+XkXW2UzvpFYgjluJ1xI3wR44dLUcREsmJlC9d2d4MNHAIPgHuN+sb9z98q6T0T/euAQgb2yztvtx1zHhfDMmKNAY0fDumwG3n2/gB0HKmEYyCAYUNhqNGOrbEbMzySeimSFtBowuE+pwZFz42xvT/JxcoFDw74ERC0P/EmnuNstKKw1L8Ya85IQnCGF13r1hYWNWHRLPZQw4PzsRbhWFJN0FjF2QyduoCBtN5pwqdvpefPH+AEuBNJcxXsfwTj2rzFJZ+EKA6hWIebNQWT5Tdj+Sg7ffuow6uP99X9PCDTi7Jyyz8N+ZTCgQJD+9XoHz76aEWdbPUtBKFZVaMeC+83ET28QAgNIsI06LiPDVf9VQT2qmJrWgNaQ45tAQsCGwCSVxXidR9XXFr4rBZcE/jZ2ZejtaxCU/9KgMDr429iVcEnUfLYKifE6j0kqCxvCGyc/rgnQGlPTCg1URZor4f3VcRkJtk+LV8werQbSzlWMot9CfrbNzNmvBgqvESLwZAOmj86Yp53A0H5qNmCYwwRpSoxvjgJCwJg2BZROeH0FXMUiZx+qJMOHC8q9u+QofCW5DO8ZzYixgzRXkeYqYuzgPaMZX0kuwy45CrEBTpsAUCWJRc4+pLnqwbbSCchpU+CC0FAXgWlJOLpfoBQETretg9mj1UDaVWztZz2HuAkIOl4LZYXegkIy1p8NHFNvnpUH8PB4jOY6ExeNjQHMkPVpyFmXQL2+BeVkBLfbu/CsNQMlMiH92qMGIcEOdssG3J+4FZeqTkxWfQCAfbIO78lmKKIwCzjQJ2jUJdxu70JZWuBCFXLuTIj6NFhpXDQ2ivGjLbR3nVmha+AGGlNfm0bvLaiwL5J5qGsA3wfo7qtNZ44bbZ3VfPn0idEQbgYAsaVXIRqRqLDAOJ3H71c3o0AWxABbH/gDBjQ2G2PxVGQOnorMwWZjLAzo4xw24ecGfr+6GeN0HhUWiEUEokuvgvAFJGoJzJwYP6t1jnGja0fdd/c5KFf1cMIDMPZ3V2t+P36UFY5GO9OyNjNw3aVp73v/YrmLLsLOxqlIOGX0iRg+U92O5fZ29FC8pg8gYHCcndBmx9mp+VvQJ9BDcSy3t+Mz1e3oEzEknTK2NkxFz6SLav734stTHpr3LNVRxh9z1sH+7qpPt2GEB9jTURkQCXgj1ic2WrCd0xcAAmC7GuNGW7hyVrLmb7v2VfBwcS7yVgIRdlEkC18qvYa77G3opVhY5x8oCAOdwIGMVxDopRjusrfhS6XXUCQLEXaRsxL4emkutu6pTSfNvySJKc0RVO3Tb+UiAmyHMbHRQsp3mINrBbQcjDVIeACBPR2VsBcgUPtzpsThDkAIn7p9JJQqGksuzyAVkzXFkTd/04u9nMJj8WthsIcAqJCBPyltwP3lDYizEzaEBJnGgS8AsMlrEImzg/vLG/AnpQ2o+CVigxUei1+LdkrjjXd7QoHUmhG1CDddkUH5DNC7BIKrOcRRau7vEdjTUYEhxfDBA0RMwv4uu7//3b/v+VPjMM8A2KA0I5OQuPPq+jBIFMLrP1z/Xh5NpoNXjEn4Vvw6RNmFCYUcRXBXdRu+X3gGKyvvYKLKQoOQpwiKfgNIniLQIExUWaysvIPvF57BXdVtyFEEJhSi7OJb8evwijEJTZaDjTuK6Mm7Nd27ty2sQ2PG9IY9nebGMSVh/tR+IG0wP2F/l42ISUMfDxBeVHoDILfuLaG5PhOmsGZNjmNMg4Uj2VNvdJCS0Jd38f/cOLoGESwA/PLtLA4csVGXMJDWVTxvTUOeIri/9CpGcwm9FEWGK/h85W38bvU32C/q0C4zNXiAiSqLSboPKbZRJBN9FEU9V3CE4ngscS02mJOQ1lXAkOjqc/D8m334D0tHg33BbKwzcde1DfjBs52oTxk1ncAnpf5dxpgGC7Mmx2vSzFv3lpAtukjHjUGZkzhoPgAz8OudhQGq0hv38qnpiVNudPDso9dm/u+XjA6bMQQRbJfxbxuOhhGG8pM6G82J+GLqDrxsXoQU24iyizxFwCBM1T24xX4fN9p7cKO9B7fY72Oq7gH7miHKLlJs42XzInwxdQc2mhOR9sEl2m/o/PlrvShWlHcsjd+ksvyaBowbZZ2yLxA00nxqesKDzOv+tO+vdxYGdUbioAhA0Oiw+f1SCNsKkMBL52VqOn1PlkDlqsbnbmtCQ9rwCOI3Y/zynaw3OXwAIFOBkGIbXSKBryeW4iuJW7DOuggOBBK+MFTJQI6iyFEUFTIQZRcJtuFAYJ11Eb6SuAVfTyxFl0ggxXaILAoaOtu7qnju131hkwozoy4h8YU7m085JGRfay6dl/F/7jdtm98vnXIjzXk3AcxAxBA4eNTGO7sLuPaydPigl18cx/QJMew+WPbrA5+g+v35QlfOSnl9geHhTYS+gsKPn+9CNHI8gRQIFitEoPC2OR5vmeMxXucxS3Vhksri084BTNFef0G7qMNr5kTslxlsl004KFIgPwXN/rWOFfBEVOD/ffkIls7LoD7lkVFrxk3zM1i3OYd1W06uP9CrnShMnxDD5RfHMbBo/s7uAg4etZGOyRO20Q9ZExB4f2veyYazcrT2EMN3XFkH2+FP3CWebdQYlZb4k7vH9k/e9nf/P6/txqGj9gm7cNkP8RJsI8k2uimOl82L8Z3YIvzKmoIoK0RY4U1jPL4bW4SXzYvRTXEk/YYRL2ikjxRw0xDo6nXwk192+zOAOexXvO8zY9BYZ56wa/lY7WY7jDuurPPgZsG5RgDWvJPt9waHkwkIPPZ4VOLNnQUcOGL3Dz9g4Kb5GUxotMIhyh8f9zMe/L0JGD/aCkHbUhC27ivj6Vd7kIp/8gkcQfOHCYWUX1iy2A1r+Ca8hpAU2zChappFPu750gmJn2/swVu7CmEPPwMY22Diwd8b77VzfYKAVx2NCY0Wbpqf8WJ/f4jGgSM23txZGPQTRgYVEGL4QxSefb3XRwF4tjIRk/id60ahbGvIE0hAMG3z3tubcOXMZE1Hcbmq8e0nO7zCzCnsjkAjDOwTCH4fFHBOpWAdnCf03acOoRSUwH3h+PSMJO69veljp5xKv9H0d64bhURM9g/RAPDs673IFRUMMYxHxAS28vk3+9CTcz2V76vJO6+ux9SxUZTs43PchiT05F3ccWU9/uONjeHMnaDN7Ae/6OyfMXAeYThBD8S+zir+/plObwg09w+J+o83NuKOK+vRkz9eCAQBJVtj6tgo7ry6viay6cm5eP7NPq/WwTx8BSC0lX0Ont7QEwJEAtDD529rgu3W9rxJSegtKCyak8KftozrZz4zpCSseSeLp351FJnkqcXag2bqFCMdN/D0hqNY83a2ZkKY0ow/bRmHRXNS6C3UjrolItiuxudvawrBMoFv8/SGHnT1OTANMehj8gcdE6g1IxkTWL3Re6hAC2hmXH95GkvnZZAteUOSDemZjHlT42j97ERELeE3SXrRwK4DFXy7rcM/ZePMKKNRe3bwGQk6GPGIxGP/2oHdByu+tvIcvKgl0PrZiZg3Ne6pdElel3PJxdJ5GVx/eTp0IAURuvocrN7ot5mfA/U26ALgxbgCPXkXT7zQXQMTYwb++DNjMDrtHbCUKynMmhTDI5+bhERUhLNyhAA6ex089MR+uC6flbp4agBixzwG/3c6mk4KguMyHvrH/ejsdcIhD8xeo8wjn5uEWZNiyBUVlGaMTpv448+MCaHzwe5/4oVu32SIcwIyPSeo4GDOz3Nv9mLT+8Uaj7mpzsQDLeNwNOfi0ilx/PW9k5FJSATHBwgCChUVEvZMkyIBSHSnHB0Cit+TzceBQE83+XW4x8FD/7gfBX+GYTD5PJOQ+Ot7J+Oyi+M4mnPxQMu4/vkJfr5j0/tFPPdmL9Lxc3e24Dk7NUyQd5Lm5OYI/v5LF8MyKawKBuPiF81Joj5p1EzYLlU1/vxH+7DpfW/U6tmw+0HDyWWqE/AFwDqFBo5PqlnkigrzL4njv39+8nETw/Mlhde253HLgroBJ4oxbIfxhe99gH2dVX/OwLnxYc7ZqWEML4XaccSG7WpcNStVU/KcPiEapnODCdu2w/jLJ9rx653eOXtn0+kzoHFAZtApkojCxdlqumJ/xP0Hh6vY01HBkstrU98RS2DquGhY7w+ihv/xzGH86t08UnHjnEY257QxRGlGJmngyfVHsX5LLvSUgyxh0EMQgCMeemI/Nm7LD8r5egxCnB0fun12Y+1gyunGbXk89MR+P+uJsNMnyPYF0cL6LTk8ud6PbM5xXHvOO4PYH/n2rbYO7Ous9nvMwQEBDPTmXdz/D3vx+rbBPWHzZDJ+ZyIEdUkDr28v4Et/9yG6s07YPiREf2Szr7OKb7V1+L1/5z6sPQ8CAJhSoFhR+Msn2pErKn+0en88prR3UjeDcf7ngZ+ZrxGccjqQt9o/WDpX9GhQrChvuNR5SGucl95Apb24eW9nFX/5k3a/fNrfTDo6Y+Lx+6bg+sszXgZR4LwcqXbajCePwT05F9dfnsHj901BU50ZmoDgCNm//Ek79nZWEY+cvxPFz9vRscwepPrDwxXs6ahgceAscX86eOn8DJRivL27CEHkw8mGNvOlIDjKq1f8/k2NeOB3x4XPxQOc26890Y43dhQGDekz5AUg9JijErsOVrCno4rrL095TB7wnk/NSOKiMVFs2l1ET8FFzJIYhBa5sxLmCj/DV58w8ODvjcfvXD8qvNHjD4/2nNvzfRzueRWAwB4mohK7D5axdW8ZV89O+gORvBBRacbFY6NYMi+D7j4XOw+UARAsY2h0thN5u77qMEpVhRvmZtC6ciIunRKvOeQiOD7+L37cjjd25IfEyeHnNBH0iXG5v3suGhtF62cn4qIxkZCArBG2lb28KYsnXuz2YGAR4Z85cO6Pkw+Oi6863uSwqeOiWHlLI5bO92BdWgPkn4gqBeHDw1Ws+mk7PjxUQSZuDPpBEMNOAAL7WaooJGISX757LG4cSMwBDlS5qrF6Yw9Wb+jxJ3QJxCwPSOENbx5E5468vH3ZZjiuxvjRFpZf04DlixrCUW7BXIRAaF/alMV3nzqEYlkNOsBjWAsA4BHNdRkVh3H3dQ34gzuavdSo7p83EODx8yWFNe9k8dybfdh9oAxXefl4ywiQuhwWZE6X4QHog9kLTSu2hiEJ0ybEcNvCOtx8RQYpv53bS/BQyPyyrfGDZzvx1Cs9iJoEw6BBmfR1ZgLwlW0KNLRGxQSEz5YUpo+P4Y9+qxkL/dHzKiQyh0Ulrb1IYd2WHN7eXcDhHgeO8vCHluGVmY/FH9ZOLzi+V0mzd4yd7XpfTUkY02BiwbQklsxNY8G0RCiIH3VPb+4s4O9+3oldB8vebIQzEMTB88KhadmDO3IAp4ZifCWFBwdnMJZ9qg6fvbkR4/zGSeW3mDG45kydYkVh274ytuwpYeu+Etq7vRG1VYf7AZfkM5z6pSE4ACpoZ4uYhLqkgYmNFuZMjmPu1DhmT44hEZU1+Yxj76HjqI2frunGC2/1gUCIRcSQUvk1uwyUp2UP7tgnSEzS2uGhmG4JEkT5kkJDysCdV9dj+TUN3nHsfhQRpFCD2f0DV66k0HHUxsEjNjp7HXRnHeRK3gAL1/X0sWF4gy3TcYHGjInmehPjR1sYN8pCOl478TToSIJvGoJ/1511sHpDD555rRc9eRepuAyPvh16i1kIkzTr/bTswZ2vSMO81rXLmoiG7NQwL8HCKJYVmupM3PKpOtz+6TpMbo4czxy/qOR17Zx5rkIHWRw6Xsj2dVbxi1/34cW3+tDV5yARkzAlDc1dHz4Ta8OKCeU6rxokaAeRvBZEQzrHpjRDElCXNFCsKPzTS934+Ws9+NT0JG6cn8GCaYnQGRv4GdYf7V8cJxkncBiDOH/gypcU3t5dxEubsnhrVwG5kkIiIlCX9A6RGMrM9x+KiSRIuDsMzbxFggFmGuoJ96ARU0pCnd91s35LDuu35DB2lIV5U+NYOCOJ2ZNjGDfK+tjz9oJNHZgO+gT4dcdRG9v2lfHmzgI27ynhkD/SPR4VqEt4p6IOecb3PzwBDM28hZZ9de8V4OrrYG0Ox1GHgTq2He2PowUyCc95u3hsFNPGRzGpKYLRGQP1KQNRS8A8AU7fUV6Y15t3cSTrYn9XFbsPVvDBoQrau21ki25Yw7BMEZqd4bcIIOGAIlfRrd/bFcFhvUVIc4ZyKhpD2A84mSQNAD9803BcT62b0vPGkzGJRFQgHhGIRSRMGTDe688rVb1pXIWyQrmqvfON4I2ntwwRYvsHM9l0Dna/lmZUaOXsxBgxlwBg2YO7v29G4v/FKWcVaHAaRs9H9BD0GzAzFMO3z36NXteaAK/kTJDC0yrymM9rxoWxGK4Zy0inWvofLzw67T7DI4D6N62dP2KwoGENwRiYyKn16AheidmQA9I+VJMV6u/M5eM/jwuG/yy0doig/g0ABMCUsma8opzKLmlGCcwaF+jyT6+HDl7afzFC1M4FyPNj1T8pp7IrZc14BWASi1etk22tZIPoR9KMEg/Podcj6+SiKJZmlED0o7ZWshevWicpCP+WP3KgoZwv7iCiUaxcHmr1gZF1xtzXJA1i5qOxVGLm6q9O6AEzBIi4pYXF6q9OOEqCHjMiSQIuXDPwf7EEaCOSJBL02OqvTjja0sICRBy4ubTq4YdpY/ILMdGT3SKkebFyKkzDNCQcWceafs/2a+V8oBsycxcV/r7c+vDDDCIOjvbibdvm0JoHxhaFFP9NSJMINKIFLpBFIC2kSUKK/7bmgbHFbdvmUJD6r4n5Wp5k2baC1K0P7vyhEU193i72uiTIGCHhcFb87FqJesOt5H/0/KMz7g14PDA8Hvh2WrUKtLFwOCYj+deEYV3mVouKiOQIKYel6ldGJCG1a/9GVVNXL0qOKbe2goH+wt8xNt77w5rHxhZZGC2s1VFpWJL1iFM4DHe+9ninjrIwWtY8NrY4kMcn0ADHmoJti4WMPK+1implayIx4hQOi52vtZCWEEJWtKre+vyjs9cfq/pPoAG81baC1OJVa43nH529Xml7OQlZkUZEMLMaIe/QV/vSiAgSsqK0vfz5R2evX7xqrfFRzD+hAADA+tYb3MWr1hovPDLrBaXs20kY3UYkIcHsjpB5yHLfNSIJScLoVsq+/YVHZr2weNVaY33rDSfk2ceq9EAIXnx01lrXrV7PWm0243UGA4p5xC8YSnE+A8qM1xms1WbXrV7/4qOz1n4S80/oA5zIJ7j5/s0JGUt9VwrjXq1daKfiApCDcpbJyDopzgNQwowaQhhQ2v2hKue/vOaxecUT2fzTEgAAWLWKRWurlxy67aHdywHxqDRjM91qHqxclwExkjk8dzueAE3SMIxICsop7wD0g899c9rqY3l11gQgyBO0tLSJtrYVavGq95JxHfsia/1Fw4w3K7cC5VS0n0EUftF9RDOcJZ4Hp98xWEgzKqQRheuUOkmIx0ui/Pj61ksLLS1Pyra2Fn1sqHcWBcA3CS0s29o89XLzqkNNhi6vhNb3kDRmC2FCuRVo1waz1iBiMPu9GCOm4qT3OIP7aSeEMCxIIwqtHbByt0GIn7gi9sSa1rFdx/LkVNYZMISp5UmIwM4s+Ac2mw7sXwLtLGfmG8D6EmFGTG9CuIJWLpjVBY64OAuLCEQSQhog8o691E7VAYn3iWgthLm6a8KkdW//ITn9/hlOadefJQEIhZUWP7xODvQ2W1axVca+S7Xmq7RW81mrmQAmAtwArZIjTuPHOHVCFgDqAdBOQu4QQm4Sgl6PYfJ7ba1kB29dvGqtsf7hJepM+zn+f99nlV4fGqcKAAAAAElFTkSuQmCC";

// BBOT verified-member badge — a small, slick blue checkmark using the BBOT mark, shown beside
// a verified 643 player/staff. Tiny but legible; scales with the `size` prop.
function BBOTCheck({size}){
  var s = size || 14;
  return (
    <span title="Verified BBOT member" style={{display:"inline-flex",alignItems:"center",justifyContent:"center",width:s,height:s,borderRadius:"50%",background:"#1a2f5a",flexShrink:0,verticalAlign:"middle",boxShadow:"0 0 0 1.5px rgba(255,255,255,.55)"}}>
      <svg width={s*0.6} height={s*0.6} viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M5 12.5l4.2 4.2L19 7" stroke="#e8526a" strokeWidth="3.4" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    </span>
  );
}


// BBOT logo — inline vector so it's crisp at every size with no external image request.
// Rounded-square blue tile, white baseball seams, coral precision-reticle lock at center.
// `size` is the tile edge in px. `tile` bg defaults to brand blue; pass tile="navy" for the
// reversed mark on light surfaces, or tile="transparent" to drop the square (seams on blue).
function BbotMark({size, tile}){
  var s = size || 32;
  var bg = tile==="navy" ? "#16243d" : tile==="transparent" ? "none" : "#2970b8";
  var rx = Math.round(s*0.23);
  // geometry scales from a 100-unit reference
  var u = s/100;
  var cx = 50*u, cy = 50*u;
  var sw = Math.max(1.4, 3.5*u);       // seam stroke
  var tickW = Math.max(1.0, 2.4*u);    // reticle tick stroke
  var R = 33*u;                        // ball radius
  return (
    <svg width={s} height={s} viewBox={"0 0 "+s+" "+s} style={{display:"block",flexShrink:0}} aria-label="BBOT">
      {bg!=="none" && <rect x="0" y="0" width={s} height={s} rx={rx} fill={bg}/>}
      <circle cx={cx} cy={cy} r={R} fill="none" stroke="#fff" strokeWidth={sw}/>
      <path d={"M"+(28*u)+" "+(30*u)+" Q"+cx+" "+cy+" "+(28*u)+" "+(70*u)} fill="none" stroke="#fff" strokeWidth={sw} strokeLinecap="round"/>
      <path d={"M"+(72*u)+" "+(30*u)+" Q"+cx+" "+cy+" "+(72*u)+" "+(70*u)} fill="none" stroke="#fff" strokeWidth={sw} strokeLinecap="round"/>
      <g stroke="#e8526a" strokeWidth={tickW} strokeLinecap="round">
        <line x1={cx} y1={33*u} x2={cx} y2={40*u}/>
        <line x1={cx} y1={60*u} x2={cx} y2={67*u}/>
        <line x1={33*u} y1={cy} x2={40*u} y2={cy}/>
        <line x1={60*u} y1={cy} x2={67*u} y2={cy}/>
      </g>
      <circle cx={cx} cy={cy} r={11.5*u} fill="none" stroke="#e8526a" strokeWidth={Math.max(1.1,2.6*u)}/>
      <circle cx={cx} cy={cy} r={Math.max(1.2,4.2*u)} fill="#e8526a"/>
    </svg>
  );
}

// Horizontal lockup: mark + "BBOT" wordmark + "by 643 Sports MGMT" parent endorsement.
// Used in headers, footer, and marketing surfaces where there's room for the full brand.


// CANONICAL SESSION TYPES — single source of truth. These exact values are sent to
// BBOT and must match the SESSION TYPE GATES in the backend prompt verbatim. Every
// session-type dropdown in this file renders from this list. Do NOT introduce other
// values (no "Game", "Practice", "Tryout", "Catch & Throw", "OF/IF Drill" variants).
// label = what the user sees; value = what is sent to the backend / BBOT.
// VISUAL-TOOL GRADE PUBLISH FLAGS — single on/off switch per visual tool.
// false = BBOT's provisional grade for that tool is ADMIN-ONLY (review/calibration phase).
// true  = the grade is published to players for that tool.
// Flip a tool to true ONLY after its provisional grades have been calibrated against
// scout review and consistently agree. KEYS MUST MATCH the section 'key' BBOT emits AND
// provisionalVisualGrades[].toolKey (batBall, hit, plateDis, approach, fielding, field,
// receiving, command), so the published grade attaches to the right tool.
const VISUAL_GRADE_PUBLISHED = {
  batBall: false, hit: false, plateDis: false, approach: false,
  fielding: false, field: false, receiving: false, command: false,
};

const SESSION_TYPES = [
  { value: "Live Game",      label: "Live Game" },
  { value: "BP",             label: "Batting Practice" },
  { value: "Bullpen",        label: "Bullpen" },
  { value: "Fielding Drill", label: "Fielding Drill" },
  { value: "Showcase",       label: "Showcase" },
];

// seasonAge — baseball "league age" with an AUGUST 1 rollover. A player's age for
// benchmarking is the age they are as of Aug 1 of the current season year. A player
// rolls up to the next bracket on Aug 1 (e.g. a 16U who turns 17 after Aug 1 is
// evaluated as 17U for that season). asOf lets callers pass the session date so a
// past session benchmarks against the correct season; defaults to today.
//
// AGE COMES ONLY FROM DOB. Grad year is a SEPARATE, independent field (academic class /
// recruiting context) and is NOT a reliable proxy for age — a player can be 19 and a
// junior, or 17 and a senior (reclass, held back, redshirt, late birthday). We must
// never derive age from grad year. If there is no usable DOB, age is unknown (null) and
// callers handle that explicitly.
// Returns an integer age, or null if there is no usable DOB.
// Map a bbot_users ROW into the rich user object the app expects. Shared by the bulk loader and by
// login, so the two can never disagree about what a user looks like.
function mapUserRow(r){
  var profile = (r && r.profile) || {};
  return Object.assign({}, profile, {
    id: r.id, type: r.type, firstName: r.first_name, lastName: r.last_name,
    email: r.email,
    gradYear: profile.gradYear || r.grad_year || null,
    jerseyNum: (r.jersey_number!=null && r.jersey_number!=="") ? String(r.jersey_number) : (profile.jerseyNum||""),
  });
}

function seasonAge(player, asOf) {
  var ref = asOf ? new Date(asOf) : new Date();
  if (isNaN(ref.getTime())) ref = new Date();
  // Anchor comes from AGE_RULE (mirrored from bbot_rubric_config.json) — never hard-coded here.
  // Default rule may_1@v1: age on May 1 of the SESSION's own year, a fixed per-season anchor.
  // anchorYear "prior_season" would instead roll to the season that began on/before ref.
  var m = AGE_RULE.anchorMonth - 1, d = AGE_RULE.anchorDay;
  var cutoffYear = ref.getFullYear();
  if (AGE_RULE.anchorYear === "prior_season" &&
      (ref.getMonth() < m || (ref.getMonth() === m && ref.getDate() < d))) cutoffYear -= 1;
  var cutoff = new Date(cutoffYear, m, d);
  if (player && player.dob) {
    var d = new Date(player.dob);
    if (!isNaN(d.getTime())) {
      var age = cutoff.getFullYear() - d.getFullYear()
        - ((cutoff.getMonth() < d.getMonth()
            || (cutoff.getMonth() === d.getMonth() && cutoff.getDate() < d.getDate())) ? 1 : 0);
      return age < 0 ? null : age; // guard against a future/typo DOB
    }
  }
  return null; // no DOB → age unknown. Do NOT infer from grad year.
}

// Map a DOB (or player) to the age-cohort bracket used for benchmarks + calibration.
// Single source of truth so eval display and correction-capture agree.
function bbotAgeGroup(dobOrPlayer, asOf){
  var player = (dobOrPlayer && typeof dobOrPlayer==="object") ? dobOrPlayer : {dob: dobOrPlayer};
  var age = seasonAge(player, asOf);
  if(age==null) return "unknown";
  if(age<=13) return "12U-13U";
  if(age===14) return "14U"; if(age===15) return "15U";
  if(age===16) return "16U"; if(age===17) return "17U";
  if(age===18) return "18U"; return "19+";
}


// Color system — restricted palette for visual cohesion
// Primary: navy (brand) · Accent: coral (CTAs only) · Status: emerald/amber/red · Neutrals: gray scale
const C = {
  // Brand mineral blue (one family, with depth variants) — blends with pink coral
  navy:"#2970b8", navyMid:"#3a66c0", navyLight:"#6a96e6",
  // Steel blue — secondary surfaces and info states
  blue:"#2970b8", blueBright:"#6a96e6", blueLight:"#dbe6fb", blueFaint:"#eef3fc",
  // Status colors — single hue each
  orange:"#d97706", orangeLight:"#fef3c7",     // amber for below-average grades
  green:"#059669", greenLight:"#d1fae5",       // emerald
  red:"#dc2626",   redLight:"#fee2e2",
  yellow:"#ca8a04", yellowLight:"#fef9c3",
  white:"#ffffff",  cream:"#fbf7ee",
  // Refined gray scale (Tailwind slate-aligned)
  gray50:"#f8fafc",  gray100:"#f1f5f9", gray200:"#e2e8f0",
  gray300:"#cbd5e1", gray400:"#94a3b8", gray500:"#64748b",
  gray600:"#475569", gray700:"#334155", gray800:"#1e293b", gray900:"#0f172a",
  border:"#e5e9ef",  // slightly warmer than gray200
  // Pink coral — reserved for primary CTAs and brand accent
  coral:"#e8526a",  coralLight:"#ffe1e6",  coralFaint:"#fff5f6",
  // Shadows — subtle, single elevation
  shadow:"0 1px 2px rgba(41,112,184,.06)",
  shadowMd:"0 2px 6px rgba(41,112,184,.08)",
  shadowLg:"0 8px 20px rgba(41,112,184,.10)",
};





const BACKEND_URL  = 'https://gracious-wonder-production-df2d.up.railway.app';  // Railway backend
// Compact icon letters + short labels for the mobile bottom bar (mirrors the top nav `nav` array).
// GUARDIAN CONSENT TEXT — VERSIONED. Counsel will refine this wording; the version travels with
// every stored record so a consent given today always reads back as exactly what was agreed then,
// never reinterpreted under language written later. Flagged LEGAL-REFINE-LATER in the copy inventory.
const GUARDIAN_CONSENT_VERSION = "v1-2026-08-07";
const GUARDIAN_CONSENT_TEXT =
  "I am the parent/legal guardian of this player and consent to their use of BBOT, " +
  "including video evaluation and measurement.";

const NAV_ICON = {home:"H", activity:"⚡", events:"📅", feed:"F", "upload-video":"+", "coach-upload":"+", players:"P", coaches:"C", staff:"S", blogs:"B", about:"i", faq:"?", leaderboard:"L", messages:"M", profile:"Me", admin:"⚙", "run-bbot":"▶", "my-roster":"R", recaps:"GR", "saved-searches":"🔎", compare:"⚖", "percentile-search":"%"};
const NAV_SHORT = {home:"Home", activity:"Activity", events:"Events", feed:"Feed", "upload-video":"Upload", "coach-upload":"Submit", players:"Players", coaches:"Coaches", staff:"Staff", blogs:"Blogs", about:"About", faq:"FAQ", leaderboard:"Boards", messages:"Messages", profile:"Profile", admin:"Dashboard", "run-bbot":"Run BBOT", "my-roster":"Roster", recaps:"Session Reports", "saved-searches":"Searches", compare:"Compare", "percentile-search":"Pctile Search"};
// Staff invite token — only people with the invite link can register as staff.
// Change this string anytime to invalidate all old invite links.
const STAFF_INVITE_TOKEN = "643-staff-2026";
// Second layer: staff must also enter this passcode at signup.
const STAFF_PASSCODE = "643SportsBBOT";
// THE PRICE. ONE NUMBER, ONE HOME (ruled 2026-08-16): every evaluation -- single session AND
// cumulative -- is $9.99. The backend's BBOT_PRICE (main.py) is what actually gets charged; this
// is what the site is allowed to SAY, and the two must agree.
//
// THEY DID NOT. This file said $19.99 on eleven customer-facing surfaces -- the landing subtext,
// the FAQ, the Terms, the price table, both payment buttons -- while the server had already been
// charging $9.99 for a single session. Nobody decided that; it happened one edit at a time,
// because the figure had six homes and copy is free to drift from a constant it does not use.
// So the copy no longer contains the number: it interpolates BBOT_PRICE_LABEL, and
// `_gt/_price_sweep.py` asserts that no price literal survives anywhere else in this file.
// ─── STATUS PREDICATES — ONE DEFINITION PER CONCEPT ────────────────────────────────────────────
// RULED 2026-08-17, after a status string spelled out in two places inside ONE component took a
// whole surface dark: PublicProfileView filtered one list on "approved" and another on "published",
// the workflow never issues "published", and the evaluation block therefore never rendered on any
// public profile for any player. Nobody mis-typed anything. The concept simply had two homes.
//
// This file had 86 inline status comparisons across FOUR different entities, each with its own
// vocabulary. They are named here, per concept, so a concept cannot be spelled two ways again.
//
// ONE BEHAVIOUR CHANGE, DELIBERATE AND NAMED: eight places asked a REPORT `status === "approved"`
// alone, which silently excludes "published". They work today only because nothing is ever
// published — the same latent drift, one edit away from the same outage. They use isLiveEval now.

// A report the player and the world may see.
// THE TOOLS THAT MAY CARRY A GRADE. Mirrors `bbot_grade_integrity.GRADED_TOOLS` server-side; every
// historical spelling is listed rather than normalised, because a label this list does not know is
// treated as UNGRADABLE and that is the safe direction to fail.
var BBOT_GRADED_TOOLS = ["Run","Pop Time","Hit","Power","Throw (Arm Strength)","Throw (OF)",
  "Throw (OF/3B)","Throw / Arm Strength","Throw","Fastball Velocity"];

// ---- THE LEAD STAT ON A PLAYER CARD -------------------------------------------------------
// TWO DEFECTS THIS REPLACES, both live on the players directory:
//   1. EXIT VELO WAS FORCED ONTO EVERYONE. `var ev = getEV(u.id)` ran for every player, pitchers
//      included. A pitcher has no exit velocity; the honest lead stat for him is his pitch velo,
//      and where he has neither the tile belongs blank rather than borrowing a hitter's number.
//   2. IT DID NOT COME FROM A RECEIPTED VALUE. It read the `metrics` table, which is filtered only
//      for REJECTED reports -- so a number the credibility law withholds could lead a player's card
//      on the surface a coach browses first.
// The value is taken from LIVE reports' own measuredValues and refused when the row's
// `credibilityWithheld` declaration names it. Coral comes from the one token, C.coral.
var BBOT_PITCHER_POS = ["P","RHP","LHP","SP","RP"];

// ---- A GRADE THE WRITE GATE REFUSED MUST NOT RENDER (ruled by Luis 2026-08-21: DROP it) -------
// THE DEFECT THIS CLOSES, found live on a public profile. Jhosuil Colon's card showed
// "Run — 75" while the prose in that same tile read "run grade not assigned". The write gate had
// refused the grade under the zero-grades law (a measured tool expresses as a percentile, never as
// a bare 20-80) and had DECLARED the refusal correctly: `credibilityWithheld.withheld` carries
// "sections[0].grade". Nothing read it. The surfaces honour `gradeIntegrity`, which is a DIFFERENT
// declaration written by a different check, and on that row it does not exist.
//
// So a refusal was recorded into a key nobody consumes, which is a sentence and not a receipt.
//
// STRIPPED AT THE MAPPING BOUNDARY, not at each surface. `s.grade` is read in a dozen places --
// the leaderboard, the achievement triggers, the profile hero, the tool-grade list, the PDF -- and
// a fix applied per surface is a fix that the next surface will not have. Removing it here means no
// component downstream can render what the gate refused, because the number never reaches them.
// The tool KEEPS ITS SECTION and its prose; only the refused number goes.
//
// ---- THE STRIP WAS CONDITIONAL ON A DECLARATION, AND THE LAW IS NOT (2026-10-09) --------------
// Luis found a 20-80 grade live on Diego Cotto. It was real: `sections[2].grade = 45` on an
// APPROVED report, rendering on his profile and in the share card's "Top Tool" slot.
//
// The gap was not the law and not this function's placement -- it was the early return above.
// A grade only got stripped if some other check had DECLARED it withheld, so a grade written by a
// path that declares nothing walked straight through. `saveMeasuredTime` is that path: it stamps a
// bare grade onto the section AFTER the backend's zero-grades pass has already retired the grades
// it knew about, which is why exactly one tool per affected report carried a number.
//
// MEASURED BY RUNNING THIS FUNCTION, BOTH VERSIONS, OVER EVERY STORED REPORT -- not by reading the
// rows and reasoning about them, which is how I first got it wrong and reported five times the real
// number. 31 bare grades sit in storage across 18 reports; 26 were ALREADY removed here, because
// some other check had declared them, and never reached a surface. FIVE got through:
//
//     Zaid Basco Padilla  1788493188900  approved  run      75
//     Diego Cotto         1790731624800  approved  popTime  45   <- the one Luis found
//     Edil Sanchez        1790382852852  archived  run      50 / popTime 30
//     Jeniel Perez        1785193036907  archived  popTime  40
//
// Both live ones carry `zeroGradesApplied: 3` -- the law DID run and retired three grades each --
// and the surviving grade is in every case the tool an admin later saved a time onto. Its
// `gradeBasis` is missing the `dial` and `ageRule` keys the composition-written ones carry, which
// is the writer's fingerprint. [[a-limitation-in-prose-is-not-a-guard]] [[set-vs-count-law]]
//
// THE LAW IS UNCONDITIONAL (zero-grades, Luis 2026-08-13: a measured tool expresses as a
// percentile, never a bare 20-80). So the strip is now unconditional too: ANY bare grade goes,
// declared or not. `gradeBasis` -- the percentile -- is untouched; it is the replacement, not a
// casualty. The declaration is still read, but only to say WHY, because "no receipt" and
// "zero-grades" are different sentences to an admin reading the row.
//
// Nothing a publish flag could ever intend to show is lost: a published visual-tool grade renders
// from `provisionalVisualGrades[].provisionalGrade`, never from `sections[].grade`.
function bbotStripWithheldGrades(sections, full){
  if(!Array.isArray(sections) || !sections.length) return sections || [];
  var w = ((full||{}).credibilityWithheld||{}).withheld || [];
  var gi = ((full||{}).gradeIntegrity||{}).withheld || [];
  var byIndex = {};
  (w||[]).forEach(function(path){
    String(path||"").split(",").forEach(function(seg){
      var m = String(seg||"").trim().match(/^sections\[(\d+)\]\.grade$/);
      if(m) byIndex[Number(m[1])] = true;
    });
  });
  var byLabel = {};
  (gi||[]).forEach(function(x){ if(x && x.label) byLabel[String(x.label)] = true; });
  return sections.map(function(s, i){
    if(!s || s.grade == null) return s;
    return Object.assign({}, s, {
      grade: null,
      gradeWithheld: true,
      // WORDED AROUND A STANDING CHECK, DELIBERATELY. The first version of this string read
      // "expresses as a percentile, not a bare grade" -- and the served-bytes verifier failed the
      // build, because "as a percentile" is a phrase the About page is forbidden to carry:
      // percentile bars are admin-only, so any customer-facing copy promising one describes
      // something the reader cannot see. This string is not rendered today, but a phrase sitting
      // in the bundle is one edit away from being rendered, and weakening the check to admit my
      // own wording is the exact move that check exists to prevent.
      // THE DEFAULT REASON IS THE LAW, not the receipt check. An undeclared grade used to fall
      // through this function entirely; now that it is stripped, it must not borrow the other
      // check's explanation -- it was removed because no measured tool carries a bare grade.
      gradeWithheldWhy: (byLabel[String(s.label||"")] && !byIndex[i])
        ? "this grade does not trace to a value with a receipt"
        : "a measured tool is not reported as a bare 20-80 grade (zero-grades law)"
    });
  });
}

function bbotWithheldKeys(rep){
  var fr = (rep && rep.fullReport) || {};
  var w = ((fr.credibilityWithheld||{}).withheld)||[];
  var out = {};
  (w||[]).forEach(function(path){
    String(path||"").split(",").forEach(function(seg){
      var t = seg.trim(); if(!t) return;
      var leaf = t.split(".").pop().replace(/\[\]$/,"");
      out[leaf] = true;
    });
  });
  return out;
}

function bbotLeadStat(u, scoutReports){
  var pos = String((u&&u.position)||"").toUpperCase().trim();
  var pitcher = BBOT_PITCHER_POS.indexOf(pos) >= 0;
  var key = pitcher ? "pitchVeloPeak" : "exitVeloPeak";
  var label = pitcher ? "FB" : "EV";
  var best = null;
  (scoutReports||[]).forEach(function(r){
    if(!isLiveEval(r)) return;
    if(String(r.playerId)!==String(u.id)) return;
    var mv = r.measuredValues || ((r.fullReport&&r.fullReport.measuredValues)||{});
    var v = mv && mv[key];
    if(v==null || isNaN(Number(v))) return;
    if(bbotWithheldKeys(r)[key]) return;          // the row itself says this value has no receipt
    v = Number(v);
    if(best===null || v>best) best = v;
  });
  return best===null ? null : {value:best, label:label};
}

function isLiveEval(r){ var st = r && r.status; return st === "approved" || st === "published"; }
// A report still in BBOT's hands.
// THIS LINE WAS `return !!r && isDraftEval(r)` — it called ITSELF. Every one of the 16 call sites
// threw RangeError: Maximum call stack size exceeded, and the error boundary replaced the page with
// "Something went wrong". It shipped in the refactor that introduced this block (2026-08-17 18:39)
// and took the admin dashboard down within the hour, while a signed-in player never saw it: the
// player surfaces only reach this predicate when a draft row is actually in hand.
// The body is the comparison it replaced at all 16 sites, unchanged.
function isDraftEval(r){ return !!r && r.status === "draft"; }
function isAwaitingPayment(r){ return !!r && r.status === "awaiting_payment"; }
function isRejectedEval(r){ return !!r && r.status === "rejected"; }
function isFailedAudit(r){ return !!r && (r.status === "failed_audit" || r.failedAudit === true); }
// A recap is a different entity with its own lifecycle; "published" means something else here.
function isPublishedRecap(r){ return !!r && r.status === "published"; }
// A blog post, or a staged social post awaiting approval — both carry the same lifecycle field,
// and the question "has this been approved for posting?" has ONE home rather than a literal
// repeated at each queue that happens to ask it.
function isApprovedPost(p){ return !!p && p.status === "approved"; }
// "Was this report released to the buyer?" — a payment question, NOT a lifecycle one. Collapsing it
// into isLiveEval would count an approved-but-unpaid report as bought, which is a different and
// wrong answer, so it is named on its own.
function isReleasedToBuyer(r){
  return !!r && (((r.amountCents||r.amount_cents||0) > 0) || r.status === "published");
}
// Clip / job lifecycle — not a report status, and must never be collapsed into one.
function isJobReady(x){ return !!x && x.status === "ready"; }
function isJobFailed(x){ return !!x && (x.status === "error" || x.status === "failed"); }
function isJobComplete(x){ return !!x && x.status === "complete"; }

const BBOT_PRICE_USD = 9.99;
const BBOT_PRICE_LABEL = "$" + BBOT_PRICE_USD.toFixed(2);
const BBOT_PRICE_SESSION_USD = BBOT_PRICE_USD;  // Individual Session Evaluation — report + stamped clips
const BBOT_PRICE_PLAYER_USD = BBOT_PRICE_USD;   // Cumulative Player Evaluation — 2+ approved sessions
function bbotPriceFor(report){
  // Both products are BBOT_PRICE_USD and always include the stamped clips.
  // The cumulative Player Evaluation is a distinct product triggered separately.
  if(report && report.reportType === "player_eval") return BBOT_PRICE_PLAYER_USD;
  return BBOT_PRICE_SESSION_USD;
}
// Report and user status constants (DRY — single source of truth for status strings)
const STATUS = {
  DRAFT: "draft",
  APPROVED: "approved",
  REJECTED: "rejected",
  PUBLISHED: "published",
  PENDING: "pending",
  PENDING_PAYMENT: "pending_payment"
};
// ─── ATH Móvil Business — THE SOLE PAYMENT PATH (ruled by Luis 2026-08-21) ───
// Drop the public token here once the ATH Business account is created.
// The token is found in the ATH Business app under Settings. It is safe to
// expose client-side (the PRIVATE token is backend-only, used for refunds).
//
// THE MOMENT THIS STRING IS SET, ATH GOES LIVE WITH NO FURTHER WORK. Stripe is
// already gone; nothing else is waiting on a second change.
// THE TOKEN COMES FROM THE SERVER, SO SWITCHING PAYMENTS ON IS ONE PLACE AND NOT TWO.
//
// It was a hardcoded constant here, which made going live a CODE CHANGE: edit this line, build,
// deploy -- while the same token also had to be set on the backend for /athm-confirm to verify
// anything. Two places, one of them a commit, and a window where they disagree and a customer pays
// into a checkout the server cannot confirm.
//
// `/public-config` serves it now. Setting ATHM_PUBLIC_TOKEN (and the private one) in Railway turns
// the button on with no rebuild. The value is a PUBLIC token -- ATH's own widget renders it into
// the page -- so serving it changes nothing about what a visitor can see.
//
// THE DEFAULT IS STILL OFF, AND THE TWO-STATE RULE BELOW IS UNCHANGED: until the fetch returns a
// token the UI shows the coming-soon state, never a button that cannot complete.
var BBOT_ATHM_PUBLIC_TOKEN = "";
var BBOT_ATHM_ENABLED = false;
const BBOT_ATHM_LANG = "en";                    // "en" | "es" — payment modal language

if (typeof window !== "undefined" && !window.__bbotConfigAsked) {
  window.__bbotConfigAsked = true;
  fetch(BACKEND_URL + "/public-config")
    .then(function (r) { return r.ok ? r.json() : null; })
    .then(function (cfg) {
      if (!cfg || !cfg.athmPublicToken || !cfg.athmEnabled) return;
      BBOT_ATHM_PUBLIC_TOKEN = String(cfg.athmPublicToken);
      BBOT_ATHM_ENABLED = true;
      // A LIVE TOKEN ARRIVING MID-SESSION MUST REPAINT, or the first visitor after it is set still
      // sees "coming soon" until they happen to reload. The flag is read at render time, so nudging
      // React is enough; there is no state to migrate.
      try { window.dispatchEvent(new Event("bbot-config")); } catch (e) {}
    })
    .catch(function () { /* stays off: the coming-soon state is the safe default */ });
}

// ─── STRIPE IS RETIRED ──────────────────────────────────────────────────────
// Ruled 2026-08-21: ATH Móvil is the only method BBOT offers. No customer surface
// starts a Stripe checkout any more -- `startCheckout` is retired in place rather
// than deleted, so any caller reached by a stale bundle or a bookmark gets the
// coming-soon state instead of a request that could create a charge.
//
// THE SEQUENCING IS THE WHOLE POINT, because the naive version of this change has
// a hole in it: removing Stripe while BBOT_ATHM_PUBLIC_TOKEN is still empty would
// leave a customer facing NOTHING -- no button, no explanation, no way to pay. So
// there are exactly two states and no third:
//     token set    -> ATH Móvil, and only ATH Móvil
//     token empty  -> a clear "payment coming soon" panel that says what to do
// Neither state offers a card checkout, and neither is a dead end.
//
// WHAT IS DELIBERATELY KEPT: the backend /stripe-webhook. Somebody who already
// paid by card must still receive their unlock, and retiring a checkout is not a
// reason to strand a purchase that already happened.
const BBOT_STRIPE_RETIRED = true;

// ── ADMIN IDENTITY ──────────────────────────────────────────────────────────
// ONE HOME FOR THE ADMIN LIST. Previously ~25 surfaces each carried their own
// literal "643sportsmgmt@gmail.com", so adding a second admin meant editing ~25
// places and any one of them silently staying behind.
//
// PARSED EXACTLY AS THE SERVER PARSES IT (main.py:3532): comma-separated, each
// entry .strip().lower(), empties dropped, compared against a lowercased email.
// The build-time override lets an admin be added in Vercel's env without a code
// change, mirroring BBOT_ADMIN_EMAILS on Railway. The DEFAULT must stay in step
// with the Railway value — a name here that the server does not hold gets admin
// UI that then 401s on every action.
//
// THIS GATE IS COSMETIC, AND DELIBERATELY SO. It decides what a browser DRAWS.
// Authority lives on the backend, which re-derives the email from the verified
// Supabase token; nothing here can grant a permission the server withholds.
const BBOT_ADMIN_EMAILS = (
  (typeof process !== "undefined" && process.env && process.env.REACT_APP_BBOT_ADMIN_EMAILS) ||
  "643sportsmgmt@gmail.com,pcotto643sportsmgmt@gmail.com"
).split(",").map(function(e){ return String(e).trim().toLowerCase(); }).filter(Boolean);

// The signed-in email, for AUDIT fields that record who performed an action.
// Reads the Supabase session rather than component state so it is the same
// identity the backend re-derives from the token. Never used to authorise.
function _bbotActorEmail(){
  try{
    var s = bbotLoadSession();
    return ((s && s.user && s.user.email) || "").trim().toLowerCase() || null;
  }catch(e){ return null; }
}

// Accepts an email string OR a user object, because the call sites hold both.
function bbotIsAdmin(who){
  if(!who) return false;
  var email = (typeof who === "string") ? who : who.email;
  if(!email) return false;
  return BBOT_ADMIN_EMAILS.indexOf(String(email).trim().toLowerCase()) !== -1;
}

const SUPABASE_URL = "https://denmyqgxexvvqflsgwrr.supabase.co";
const SUPABASE_ANON_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRlbm15cWd4ZXh2dnFmbHNnd3JyIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Nzc3ODg4MjgsImV4cCI6MjA5MzM2NDgyOH0.5miBraQVBZFnIDHtt8yp-QdWAILML1z6adulD0u6Gcc";

// Minimal Supabase REST helpers (no SDK needed — saves bundle weight)
// ── AUTH SESSION ────────────────────────────────────────────────────────────
// We use Supabase Auth (GoTrue) for real, secure login. The logged-in user's
// access token is kept in memory + localStorage and sent on DB calls so Row-Level
// Security can enforce per-user access. NO passwords are ever stored by the app.
var __bbotSession = null; // { access_token, refresh_token, user }
function bbotLoadSession(){
  if(__bbotSession) return __bbotSession;
  try{ var s=JSON.parse(localStorage.getItem("bbot_session")||"null"); __bbotSession=s; return s; }catch(e){ return null; }
}
function bbotSaveSession(s){
  __bbotSession = s || null;
  try{ if(s) localStorage.setItem("bbot_session", JSON.stringify(s)); else localStorage.removeItem("bbot_session"); }catch(e){}
}
function bbotAuthToken(){
  var s = bbotLoadSession();
  if(s && s.__dead) return null;   // known-bad: fall back to anon rather than 401 every call
  return (s && s.access_token) ? s.access_token : null;
}
// Sign in with email + password via Supabase Auth. Resolves to {access_token,...,user}.
function bbotSignIn(email, password){
  return fetch(SUPABASE_URL + "/auth/v1/token?grant_type=password", {
    method:"POST",
    headers:{ "Content-Type":"application/json", "apikey": SUPABASE_ANON_KEY },
    body: JSON.stringify({ email: email, password: password })
  }).then(function(r){ return r.json().then(function(j){ if(!r.ok) throw new Error(j.error_description||j.msg||j.error||"Login failed"); return j; }); })
    .then(function(j){ var sess={access_token:j.access_token, refresh_token:j.refresh_token, user:j.user}; bbotSaveSession(sess); return sess; });
}
// Create an auth account (does NOT store a password anywhere in our app/DB).
function bbotSignUp(email, password){
  return fetch(SUPABASE_URL + "/auth/v1/signup", {
    method:"POST",
    headers:{ "Content-Type":"application/json", "apikey": SUPABASE_ANON_KEY },
    body: JSON.stringify({ email: email, password: password })
  }).then(function(r){ return r.json().then(function(j){ if(!r.ok) throw new Error(j.error_description||j.msg||j.error||"Sign up failed"); return j; }); });
}
// Send a "set/reset your password" email (used to migrate existing users + forgot-password).
// THIS NO LONGER GOES THROUGH SUPABASE'S MAILER. It called /auth/v1/recover, which sends via
// Supabase's built-in email -- a testing facility with no sending domain behind it. Measured
// 2026-10-17: 10 of 28 accounts had NEVER signed in, several of them sent a recovery mail weeks
// before that never arrived. Supabase recorded every send; nothing was delivered, and because
// the request succeeded the failure stayed invisible for two months.
//
// The backend now mints the same Supabase recovery link with the admin API and delivers it over
// Resend, proven to accept mail to arbitrary recipients from noreply@643sportsmgmt.com. The link
// is never returned to the browser -- it goes to the address it belongs to.
function bbotSendPasswordReset(email){
  return fetch(BACKEND_URL + "/auth/send-recovery", {
    method:"POST",
    headers:{ "Content-Type":"application/json" },
    body: JSON.stringify({ email: email })
  }).then(function(r){ return r.ok ? true : r.text().then(function(t){throw new Error(t||"Could not send reset email");}); });
}
// SETTING A PASSWORD FROM THE RECOVERY EMAIL. Supabase sends the user back with
// #access_token=...&type=recovery in the URL. Nothing in this app read that, so the link appeared to
// do nothing: the mail arrived, the redirect worked, and the token was dropped on the floor. The
// token is a normal bearer for one purpose -- PUT /auth/v1/user with a new password.
function bbotRecoveryToken(){
  if(typeof window==="undefined") return null;
  var h=(window.location.hash||"").replace(/^#/,"");
  if(h.indexOf("access_token=")<0) return null;
  var out={};
  h.split("&").forEach(function(kv){ var i=kv.indexOf("="); if(i>0) out[kv.slice(0,i)]=decodeURIComponent(kv.slice(i+1)); });
  if(out.type && out.type!=="recovery") return null;
  return out.access_token||null;
}
function bbotSetPasswordWithToken(token, password){
  return fetch(SUPABASE_URL+"/auth/v1/user",{
    method:"PUT",
    headers:{ "Content-Type":"application/json", "apikey":SUPABASE_ANON_KEY, "Authorization":"Bearer "+token },
    body: JSON.stringify({ password: password })
  }).then(function(r){ return r.json().then(function(j){
      if(!r.ok) throw new Error(j.msg||j.error_description||j.error||"Could not set the password");
      return j; }); });
}
function bbotSignOut(){ bbotSaveSession(null); }

// Trade a saved refresh_token for a fresh access_token. Supabase access tokens expire
// (~1 hour); without this a returning user would get logged out. Returns the refreshed
// session, or null if the refresh token is missing/expired (user must log in again).
function bbotRefreshSession(){
  var s = bbotLoadSession();
  if(!s || !s.refresh_token) return Promise.resolve(null);
  return fetch(SUPABASE_URL + "/auth/v1/token?grant_type=refresh_token", {
    method:"POST",
    headers:{ "Content-Type":"application/json", "apikey": SUPABASE_ANON_KEY },
    body: JSON.stringify({ refresh_token: s.refresh_token })
  }).then(function(r){
      return r.json().then(function(j){ return {ok:r.ok, status:r.status, body:j}; },
                            function(){ return {ok:r.ok, status:r.status, body:null}; });
    })
    .then(function(res){
      var j = res.body;
      if(res.ok && j && j.access_token){
        var sess={access_token:j.access_token, refresh_token:j.refresh_token||s.refresh_token, user:j.user||s.user};
        bbotSaveSession(sess); return sess;
      }
      // Only HARD-clear when Supabase explicitly says the refresh token itself is bad
      // (400/401 invalid_grant-style). For transient failures (network, 5xx, rate limit) keep
      // the existing session so a still-valid access token isn't thrown away — wiping it was
      // causing "expired session" on uploads after a single flaky refresh.
      var errCode = (j && (j.error || j.error_code || j.msg || "")) + "";
      var invalidGrant = (res.status===400 || res.status===401) && /invalid|grant|expired|not.?found/i.test(errCode);
      if(invalidGrant){
        // Clear it AND mark it dead first, so any request racing this refresh stops sending the
        // revoked token. Without the mark, the bootstrap reads fire with a dead bearer and 401.
        try{ s.__dead = true; }catch(_){}
        bbotSaveSession(null); return null;
      }
      return s; // transient — leave session intact
    }).catch(function(){ return s; }); // network error: keep existing session
}

// Headers for calling the backend's admin-only endpoints. Sends the logged-in admin's
// Supabase token so the server can verify the caller is really staff.
// AUDIT WRITES AND THE ROSTER GO THROUGH THE BACKEND NOW (2026-09-02). Both tables were readable
// AND writable by anyone holding the anon key, which ships in this bundle; RLS closed them. These
// helpers replace the direct PostgREST calls. The backend stamps the actor from a VERIFIED token,
// so an audit line can no longer be forged or attributed to someone else by whoever wrote it.
function bbotAdminLog(entry){
  try{
    return fetch(BACKEND_URL+"/admin-log",{method:"POST",headers:bbotAdminHeaders(),
      body:JSON.stringify(entry||{})}).catch(function(){});
  }catch(_){ return Promise.resolve(); }
}
// Reading the log is admin-only server-side; opts = {action, limit, select}.
function bbotAdminLogRead(opts){
  var o=opts||{}, q=[];
  if(o.action) q.push("action="+encodeURIComponent(o.action));
  if(o.limit)  q.push("limit="+encodeURIComponent(o.limit));
  if(o.select) q.push("select="+encodeURIComponent(o.select));
  return fetch(BACKEND_URL+"/admin-log"+(q.length?("?"+q.join("&")):""),{headers:bbotAdminHeaders()})
    .then(function(r){ return r.ok?r.json():[]; }).catch(function(){ return []; });
}
function bbotAdminHeaders(){
  var h={"Content-Type":"application/json"};
  var tok=bbotAuthToken();
  if(tok) h["Authorization"]="Bearer "+tok;
  return h;
}

// AUTO-WARM the pose/mechanics engine for a clip BEFORE evaluating, so the report carries mechanics /
// box-plots / delivery-floor instead of shipping thin (the completeness gate flags thin reports — this
// is the fix that actually populates them). Warming is client-driven + synchronous PER WINDOW because
// the host can't run background tasks; each POST /warm-pose computes ONE ~2-min window and persists it
// durably, so the loop is idempotent + resumable (a closed tab just resumes next run). BEST-EFFORT: any
// failure / pipeline-off / timeout resolves and proceeds to /evaluate — the completeness gate is the net,
// never block an eval on warming. onProgress(done,total,status) drives a UI indicator.
function bbotWarmPose(objectKey, sessionType, onProgress, kind, heightInches, playerInfo){
  if(!objectKey) return Promise.resolve({status:"skipped"});
  var MAX=24, RETRY=3;  // window-count bound + per-window transient-error retries
  return new Promise(function(resolve){
    function step(i, tries){
      if(i>=MAX){ resolve({status:"timeout"}); return; }
      // Pass an explicit kind when known — server-side derivation maps only BP->hitter (Showcase/Game
      // default to pitcher), which would give a Showcase HITTER pitcher-mechanics. kind wins over sessionType.
      fetch(BACKEND_URL+"/warm-pose",{method:"POST",headers:bbotAdminHeaders(),
        // heightInches (parsed from the player's profile height) scales pose mechanics into real units —
        // hand speed (mph), stride/head-movement (inches). Omitting it leaves those markers blank (never guessed).
        body:JSON.stringify({objectKey:objectKey, kind:(kind||null), sessionType:sessionType||null, heightInches:(heightInches!=null?heightInches:null), playerName:(playerInfo&&playerInfo.name)||null, playerPosition:(playerInfo&&playerInfo.position)||null, playerAge:(playerInfo&&playerInfo.age)||null, playerThrows:(playerInfo&&playerInfo.throws)||null})})
        .then(function(r){
          if(r.status===409){ resolve({status:"disabled"}); return null; }  // pipeline off — don't block
          if(!r.ok) return r.text().then(function(t){throw new Error(t||("HTTP "+r.status));});
          return r.json();
        })
        .then(function(res){
          if(res===null) return;  // already resolved (409)
          if(onProgress){ try{ onProgress(res.segments_done||0, res.segments_total||0, res.status); }catch(e){} }
          if(res.status==="complete"||res.status==="failed"){ resolve(res); return; }
          step(i+1, 0);  // pending -> compute the next window
        })
        .catch(function(e){
          // A single window fetch timing out / erroring must NOT resolve early and race the eval into a
          // thin report — each /warm-pose is idempotent + resumable, so RETRY the SAME window a few times
          // before giving up. Only after exhausting retries do we fall through (completeness gate = net).
          if(tries < RETRY){ setTimeout(function(){ step(i, tries+1); }, 1500); }
          else { resolve({status:"error", error:(e&&e.message)||"warm error"}); }
        });
    }
    step(0, 0);
  });
}

// ── A WRITE THAT FAILS WITH NOBODY LISTENING NOW SAYS SO ────────────────────────────────────────
// Swept 2026-09-21: 23 write sites fail mutely, 11 of them on a flow where a person is waiting --
// a profile save, an upload URL, a warm-pose call. Each threw correctly; nothing was listening. The
// user saw a spinner stop, or nothing at all, and believed the thing had worked.
//
// ONE HANDLER INSTEAD OF ELEVEN EDITS. A rejected promise that no `.catch` claims reaches
// `unhandledrejection`. Catching it here covers every fire-and-forget write in the file -- including
// the `try { asyncThing(); } catch(e){}` sites, where the synchronous catch cannot catch a rejection
// and only LOOKS handled -- and it keeps covering the ones added next week.
//
// IT DOES NOT REPLACE A PROPER MESSAGE, AND IS NOT MEANT TO. A caller that knows what failed still
// says so precisely; this is the floor, so the worst case is a plain honest sentence rather than
// silence. Sites with an EMPTY `.catch` are invisible to this by definition -- a swallowed
// rejection never reaches here -- so those are fixed individually below.
//
// THROTTLED, BECAUSE A STORM IS STILL ONE FACT. A dropped connection can reject a dozen promises at
// once, and twelve identical toasts tell a user less than one does.
if (typeof window !== "undefined" && !window.__bbotRejectionHooked) {
  window.__bbotRejectionHooked = true;
  var __bbotLastReject = 0;
  window.addEventListener("unhandledrejection", function (ev) {
    try {
      var err = ev && ev.reason;
      var msg = (err && (err.message || err.detail)) || String(err || "");
      // Aborted fetches are the browser doing what it was told (navigation, a cancelled upload):
      // reporting them as failures teaches a user to ignore the toast that matters.
      if (/AbortError|aborted|cancell?ed/i.test(msg)) return;
      var now = Date.now();
      if (now - __bbotLastReject < 4000) return;
      __bbotLastReject = now;
      try { console.warn("unhandled rejection:", msg); } catch (e2) {}
      if (window.__bbotNotify) {
        // THE USER IS TOLD WHAT IT MEANS FOR THEM, not what threw. "persistUser HTTP 403" is our
        // vocabulary; "that didn't save" is theirs, and the detail is in the console for us.
        window.__bbotNotify("Something didn't save. Check your connection and try again.", "error");
      }
    } catch (e) { /* an error reporter that throws is worse than none */ }
  });
}

// SHARED retry-eval core — ONE code path for both the report-view Retry and the admin errored-queue Retry
// (consolidates the two former retryEval copies). Warms pose first (so the retry repopulates mechanics),
// then POSTs /evaluate with the rich player-context prompt + unified payload, writing back into the SAME row
// (targetReportId) so a retry never duplicates. Returns the fetch promise. Uses window.__bbotNotify.
function retryEvalCore(r, player){
  r = r || {}; player = player || {};
  if(!r.objectKey){ if(typeof window!=="undefined"&&window.__bbotNotify) window.__bbotNotify("No objectKey on this report — cannot retry","error"); return Promise.reject(new Error("no objectKey")); }
  var _rst=String(r.sessionType||"").toUpperCase();
  var _rkind=(_rst.indexOf("BP")>=0||_rst.indexOf("BATTING")>=0)?"hitter":(_rst.indexOf("BULLPEN")>=0?"pitcher":((player.position==="P"||r.isPitcher)?"pitcher":"hitter"));
  var ageS=(typeof seasonAge==="function") ? seasonAge(player, r.date) : null;
  var ageStr=(ageS==null) ? "Unknown (no DOB on file — do NOT infer age from grad year; benchmark conservatively)" : String(ageS);
  var classStr = player.gradYear ? ("Class of "+player.gradYear+" (academic class — NOT a basis for age)") : "Unknown";
  var prompt = "Re-evaluate the following player. Respond ONLY with valid JSON matching the schema in your instructions.\n\n"+
    "PLAYER: "+(player.firstName||"")+" "+(player.lastName||"")+"\n"+
    "AGE: "+ageStr+"\nCLASS: "+classStr+"\n"+
    "POSITION: "+(player.position||"Unknown")+"\nBATS: "+(player.bats||"Unknown")+"\nTHROWS: "+(player.throws||"Unknown")+"\n"+
    "SESSION TYPE: "+(r.sessionType||"Session")+"\nSESSION DATE: "+(r.date||"Unknown")+"\n\nGenerate a complete BBOT evaluation.";
  if(typeof window!=="undefined"&&window.__bbotNotify) window.__bbotNotify("Warming mechanics engine (pose)… ~1–2 min per window.");
  var _hi=(player.heightInches||heightToInches(player.height))||null;
  var _pinfo=(player.firstName||player.lastName)?{name:((player.firstName||"")+" "+(player.lastName||"")).trim()||null, position:player.position||null, age:ageS, throws:player.throws||null}:null;
  return bbotWarmPose(r.objectKey, r.sessionType, function(done,total){ if(total>1&&typeof window!=="undefined"&&window.__bbotNotify) window.__bbotNotify("Warming pose "+done+"/"+total+"…"); }, _rkind, _hi, _pinfo).then(function(){
    return fetch(BACKEND_URL+"/evaluate", {
      method:"POST",
      headers: (typeof bbotAdminHeaders==="function"?bbotAdminHeaders():{"Content-Type":"application/json"}),
      body: JSON.stringify({
        prompt: prompt,
        playerId: r.playerId,
        position: player.position||"",
        sessionDate: r.date,
        sessionType: r.sessionType,
        videoUrl: r.videoUrl || r.video_url || null,
        objectKey: r.objectKey,
        sessionMode: r.sessionMode || (r.fullReport && r.fullReport.sessionMode) || "individual",
        adminSpec: null,  // retries don't carry admin spec (use original eval's context)
        targetReportId: r.id,
      })
    });
  });
}

// Safely turn any backend error "detail" into a readable string. FastAPI 422 returns an ARRAY of
// {type,loc,msg,input} objects — rendering that array as a React child throws error #31 and crashes
// the page. This collapses strings, arrays, and objects into plain text so error display is crash-safe.
function errText(d, fallback){
  fallback = fallback || "Something went wrong";
  if(d==null) return fallback;
  if(typeof d==="string") return d;
  // FastAPI validation array
  if(Array.isArray(d)){
    var parts = d.map(function(e){
      if(e && typeof e==="object") return (e.msg || e.message || JSON.stringify(e));
      return String(e);
    }).filter(Boolean);
    return parts.length ? parts.join("; ") : fallback;
  }
  if(typeof d==="object"){
    if(typeof d.detail!=="undefined") return errText(d.detail, fallback);
    if(d.msg) return String(d.msg);
    if(d.message) return String(d.message);
    if(d.error) return String(d.error);
    try{ return JSON.stringify(d); }catch(e){ return fallback; }
  }
  return String(d);
}

function sbHeaders() {
  // Send the logged-in user's token when available (RLS-aware); fall back to anon.
  var tok = bbotAuthToken() || SUPABASE_ANON_KEY;
  return {
    "Content-Type": "application/json",
    "apikey": SUPABASE_ANON_KEY,
    "Authorization": "Bearer " + tok,
    "Prefer": "return=representation"
  };
}
// ── ACTIVITY BLOCKS — the evidence /evaluate resolves a reading's KIND against ────────────────────
// One spelling per kind, mirroring _canon_kind() in main.py. This map is the whole reason the class
// existed: the tagger emits "at_bat" but the registry stores "At Bat", and the old code decided
// whether a throw was a swing with `=== "at_bat"`. A case difference filed outfield throws as exit
// velocity on a customer report. Anything unrecognised returns null and is DROPPED — an unknown
// label must never be coerced into a kind.
var BBOT_KIND_ALIASES = {
  at_bat:"hitting", atbat:"hitting", "at bat":"hitting", hit:"hitting", hitting:"hitting",
  bp:"hitting", batting:"hitting",
  throwing:"throwing", "throw":"throwing", fielding_play:"throwing", "fielding play":"throwing",
  fielding:"throwing", infield:"throwing", outfield:"throwing", catcher_throw:"throwing",
  pitching:"pitching", pitch:"pitching", bullpen:"pitching",
  baserunning:"running", running:"running", run:"running",
  // CATCHING HAD NO ALIAS AT ALL, so a catcher's receiving segment could never reach the tool that
  // reports pop time — it fell through to null and filed nowhere. `summary_compose.TOOLS` has
  // carried a "catching" tool the whole time; nothing on this side could name it.
  catching:"catching", receiving:"catching", receive:"catching", framing:"catching",
  pop_time:"catching", "pop time":"catching"
};

// ---- THE ACTIVITY VOCABULARY, KEYED ON THE CANONICAL KIND (ruled by Luis 2026-08-20) ---------
// What an admin tags at segmentation decides which tool a reading is filed to, so the tag names the
// tool it feeds. Each entry states that destination in `files`.
//
// THE KEYS ARE ACTIVITY KINDS, NOT TOOL NAMES, and the difference is not cosmetic. There are two
// namespaces here and they do not use the same words:
//     ACTIVITY KIND  (what _canon_kind / bbotCanonKind return, and what the record stores)
//         hitting · pitching · THROWING · RUNNING · catching
//     TOOL          (summary_compose.TOOLS, which decides marks and benchmarks)
//         hitting · pitching · THROW    · RUN     · catching
//
// A first cut of this map keyed it on the TOOL names. `bbotCanonKind("throw")` returns "throwing",
// so BBOT_TOOL_ACTIVITY["throwing"] was undefined: the caption dereferenced it and CRASHED the
// segmentation view outright, and the <select> — whose value was the canon kind while its options
// carried tool names — showed every tagged throw and run as untagged. Keying on the canon kind
// makes canon(tag) === key by construction, which is the only version of this that cannot drift.
//
// THE OPTIONS OFFERED DEPEND ON THE PLAYER TYPE, because a pitcher has no at-bat tool and a second
// baseman has no fastball tool. Offering the whole list invites a tag that files to a tool the
// player's card does not carry, and the reading then lands in a section that will never render.
var BBOT_TOOL_ACTIVITY = {
  hitting:  {label:"At-bat / swing",   files:"Hit & Power (exit velocity)"},
  pitching: {label:"Delivery / pitch", files:"Fastball Velocity"},
  throwing: {label:"Throw",            files:"Throw (arm strength)"},
  running:  {label:"Run",              files:"Run (home-to-first, 60)"},
  catching: {label:"Receiving",        files:"Pop Time"}
};
// The segment tag value is the CANONICAL KIND itself, so no alias lookup can lose it on the way in.
var BBOT_ACTIVITY_FOR_PITCHER  = ["pitching", "throwing", "running"];
var BBOT_ACTIVITY_FOR_CATCHER  = ["hitting", "catching", "throwing", "running"];
var BBOT_ACTIVITY_FOR_POSITION = ["hitting", "throwing", "running"];

function bbotActivityOptions(player){
  var pos = String((player && (player.position || (player.profile||{}).position)) || "")
              .toUpperCase().trim();
  if(BBOT_PITCHER_POS.indexOf(pos) >= 0) return BBOT_ACTIVITY_FOR_PITCHER;
  if(pos === "C") return BBOT_ACTIVITY_FOR_CATCHER;
  return BBOT_ACTIVITY_FOR_POSITION;
}
function bbotCanonKind(raw){
  var k = String(raw==null?"":raw).trim().toLowerCase().replace(/[\s-]+/g,"_");
  return BBOT_KIND_ALIASES[k] || BBOT_KIND_ALIASES[k.replace(/_/g," ")] || null;
}
// Segments -> blocks in CLIP TIME. Fragments concatenate in start order, so a block's position in
// the finished clip is the running sum of the durations before it — the same arithmetic the hitting
// window used, applied to EVERY activity instead of only the hitting one.
function bbotActivityBlocks(segs, playerId){
  var mine = (segs||[]).filter(function(s){ return String(s.playerId)===String(playerId); })
    .slice().sort(function(a,b){ return (Number(a.startSec)||0)-(Number(b.startSec)||0); });
  var off = 0, out = [];
  mine.forEach(function(s){
    var d = Math.max(0,(Number(s.endSec)||0)-(Number(s.startSec)||0));
    var k = bbotCanonKind(s.actionType);
    if(k && d>0) out.push({ kind:k, startS:Number(off.toFixed(3)), endS:Number((off+d).toFixed(3)) });
    off += d;
  });
  return out;
}
// SOLO BLOCKS ARE IN SOURCE TIME, AND THAT IS THE WHOLE DIFFERENCE FROM bbotActivityBlocks.
//
// The mass path concatenates a player's fragments into one clip, so its blocks are in CONCAT time:
// each span is offset by the cumulative duration of the fragments before it, and the dead air
// between them is squeezed out. An INDIVIDUAL evaluation runs against one continuous master, where
// no squeezing happens and 60.5s means 60.5s. Reusing bbotActivityBlocks here would shift every
// boundary left by however much dead time preceded it — the blocks would look plausible and be
// wrong, which is the failure mode that put ten of Jeniel's exit velocities in a throwing span.
//
// So: consecutive tags, in source seconds, each span running to the next tag and the last to the
// end of the video. Same rule the mass tagger uses for ownership, one dimension fewer.
// [[substituted-events-and-segment-local-time]] [[one-source-name-what-it-counts]]
function bbotSoloActivityBlocks(tags, durationSec){
  var t=(tags||[]).slice().sort(function(a,b){return (Number(a.timeSec)||0)-(Number(b.timeSec)||0);});
  var out=[];
  for(var i=0;i<t.length;i++){
    var k=bbotCanonKind(t[i].actionType);
    var s=Number(t[i].timeSec)||0;
    var e=(i+1<t.length)?(Number(t[i+1].timeSec)||0):(Number(durationSec)||0);
    if(k && e>s) out.push({kind:k, startS:Number(s.toFixed(3)), endS:Number(e.toFixed(3))});
  }
  return out;
}
// EVERY CLIENT WRITE GOES THROUGH THE BACKEND NOW (2026-09-02).
//
// RLS stopped anonymous writes, but the interim policies still let ANY signed-in account write these
// tables directly -- because the browser did. The server checks who is asking and what table they
// named, then writes with the service key. The browser no longer holds write access to the database
// at all, which is what lets the `authenticated` write policies be dropped.
// REPORT READS GO THROUGH THE BACKEND (2026-09-02). A policy cannot tell an admin from a player:
// the one that let an admin see a PENDING report also let every signed-in account read all 67 keys
// of every approved one. GET /reports makes that distinction server-side -- admins get every status
// and column, everyone else gets approved rows with full_report reduced. Logged-out callers still
// read the bbot_reports_public view, which is the same reduction expressed as SQL.
function bbotReports(opts){
  var o=opts||{}, q=[];
  if(o.status)   q.push("status="+encodeURIComponent(o.status));
  if(o.playerId) q.push("player_id="+encodeURIComponent(String(o.playerId)));
  if(o.select)   q.push("select="+encodeURIComponent(o.select));
  if(o.limit)    q.push("limit="+encodeURIComponent(o.limit));
  return fetch(BACKEND_URL+"/reports"+(q.length?("?"+q.join("&")):""),{headers:bbotAdminHeaders()})
    .then(function(r){ return r.ok?r.json():{reports:[]}; })
    .then(function(j){ return (j&&j.reports)||[]; });
}
function bbotWrite(table, op, rows, filter){
  return fetch(BACKEND_URL+"/db/write",{
    method:"POST", headers:bbotAdminHeaders(),
    body: JSON.stringify({table:table, op:op, rows:rows, filter:filter||null})
  }).then(function(r){
    if(!r.ok) return r.text().then(function(t){ throw new Error("write "+r.status+": "+t.slice(0,140)); });
    return r.json();
  }).then(function(j){ return (j&&j.rows)||[]; });
}
function sbInsert(table, row) {
  return bbotWrite(table, "insert", row);
}
// Upsert: insert OR update-on-primary-key. Prevents duplicate rows when the
// backend has already inserted the same id (e.g. /evaluate persists server-side).
function sbUpsert(table, row) {
  return bbotWrite(table, "upsert", row);
}
function sbSelect(table, queryString) {
  return fetch(SUPABASE_URL + "/rest/v1/" + table + (queryString||""), {
    headers: sbHeaders()
  }).then(function(r){ if(!r.ok) return r.text().then(function(t){throw new Error("SB "+r.status+": "+t);}); return r.json(); });
}

// NOTE: sbClearReportRows lived here. It DELETED a report's per-event rows so the following insert
// would replace rather than stack them -- but clear-then-insert means a failed insert leaves the
// report empty. That ordering is now the backend's "replace" op, which inserts first and drops the
// previous generation afterwards, so the group is never empty at any point.

// LEADERBOARD SOURCE GATE. Per-event rows (pitches, batted balls) are only ever ranked when they
// belong to an APPROVED report that still exists. Previously the boards read the raw table with a
// flat row limit, so rows from deleted and rejected reports ranked alongside published ones, and the
// limit silently truncated once a table outgrew it. Fetching by approved report id fixes both: the
// result set is bounded by real reports, not by an arbitrary cap. Ids are chunked so the query
// cannot outgrow a URL length limit as the report count climbs.
function sbRowsForApprovedReports(table){
  return bbotReports({status:"eq.approved",select:"id",limit:5000}).then(function(reps){
    var ids = (reps||[]).map(function(r){ return r.id; }).filter(function(x){ return x!=null; });
    if(!ids.length) return [];
    var chunks = [];
    for(var i=0;i<ids.length;i+=100) chunks.push(ids.slice(i,i+100));
    var out = [];
    return chunks.reduce(function(p, c){
      return p.then(function(){
        return sbSelect(table, "?select=*&report_id=in.("+c.join(",")+")").then(function(rs){
          out = out.concat(rs||[]);
        });
      });
    }, Promise.resolve()).then(function(){ return out; });
  });
}

// Persist a recap (game/session report). Stores key columns + the full object as JSON so
// either recap shape (game recap or per-player session recap) round-trips intact. Upsert by
// id so publish/edit updates the same row instead of duplicating.
function persistRecap(rec){
  if(!rec || rec.id==null) return Promise.resolve(null);
  return sbUpsert("bbot_recaps", {
    id: rec.id,
    player_id: rec.playerId!=null ? String(rec.playerId) : null,
    session_key: rec.sessionKey || null,
    status: rec.status || "draft",
    date: rec.date || null,
    session_type: rec.sessionType || null,
    created_by: rec.createdBy || rec.staffName || null,
    full_data: rec
  });
}
function deleteRecapRow(id){
  if(id==null) return Promise.resolve(null);
  return bbotWrite("bbot_recaps","delete",null,"id=eq." + encodeURIComponent(String(id)));
}
// Persist a lineup. Same key-columns + JSON-blob pattern.
function persistLineup(lu){
  if(!lu || lu.id==null) return Promise.resolve(null);
  return sbUpsert("bbot_lineups", {
    id: lu.id, name: lu.name||null, type: lu.type||null,
    date: lu.date||null, created_by: lu.createdBy||null, full_data: lu
  });
}
function deleteLineupRow(id){
  if(id==null) return Promise.resolve(null);
  return bbotWrite("bbot_lineups","delete",null,"id=eq." + encodeURIComponent(String(id)));
}

// NCAA-compliant messaging eligibility:
// Players become eligible on Aug 1 of their junior year (gradYear - 2).
// Class of 2027 → eligible Aug 1, 2025. Class of 2026 → eligible Aug 1, 2024.
function isMessagingEligible(player){
  if(!player) return false;
  if(player.type!=="player") return true; // coaches & staff: always
  var gy = parseInt(player.gradYear,10);
  if(!gy || isNaN(gy)) return false; // no grad year set → blocked by default
  var eligibleDate = new Date(Date.UTC(gy - 2, 7, 1)); // month 7 = August (0-indexed)
  return new Date() >= eligibleDate;
}

function messagingEligibleDate(player){
  if(!player || player.type!=="player") return null;
  var gy = parseInt(player.gradYear,10);
  if(!gy || isNaN(gy)) return null;
  return new Date(Date.UTC(gy - 2, 7, 1));
}

// Can `sender` message `recipient`? Combines NCAA date-eligibility (the player
// side must be eligible) with the recipient's opt-out preference.

// Save one user record. bbot_users is RLS-locked, so the client NO LONGER writes it
// directly — the backend /user-save endpoint performs the write with the service key and
// enforces who may change what: a non-admin may only save THEIR OWN row (matched by the
// JWT email) and cannot alter role/approval/verification on themselves; an admin (logged-in
// admin JWT) may save any row. We send the app-shape user object; the backend does the
// identical column/profile mapping persistUser used to do here. (Cross-user social writes —
// follow / interest / notifications / profile views — go through their own endpoints.)
function persistUser(user) {
  if(!user || !user.id) return Promise.resolve(null);
  return fetch(BACKEND_URL + "/user-save", {
    method:"POST",
    headers: bbotAdminHeaders(),   // sends the logged-in user's JWT (admin JWT for admins)
    body: JSON.stringify({ user: user })
  }).then(function(r){
    // Throw on HTTP error so admin actions (approve/deny/edit) and signup don't silently
    // succeed in the UI while the write was rejected. Callers that care can .catch and notify.
    if(!r.ok) return r.text().then(function(t){ throw new Error("persistUser HTTP "+r.status+": "+(t||"").slice(0,200)); });
    return r;
  }).catch(function(err){ console.warn("persistUser failed:", err.message); throw err; });
}

// ── bbot_reports / bbot_measurements writes (#3 Section B) ──────────────────────────────
// These tables are RLS-locked, so the client routes every write through the backend (service
// key). _beWrite ALWAYS logs a failure (console.warn) before rethrowing — so an RLS rejection
// is visible, never a silent no-op. Callers add their own .then/.catch for UI revert/notify.
// A STATUS THE CALLER IS BUILT TO HANDLE IS NOT A FAILURE. This threw on every non-ok response,
// so approveReport's `if(r.status===409)` branch -- the credibility review dialog and its override
// -- was unreachable code: the throw fired first and the admin got a raw "HTTP 409" toast instead
// of the two flagged claims and a decision. Zaid's report has carried an unsourced 57 mph throw
// velocity and a banned descriptor since it was written, and there was no way to see either.
//
// THE ALLOWLIST IS OPT-IN, PER CALL. Passing 409 through globally would let every caller that does
// NOT check the status treat a refused write as a saved one, which is the failure this helper was
// added to prevent. A caller says which statuses it is prepared to read.
function _beWrite(path, body, passStatuses){
  var pass = passStatuses || [];
  return fetch(BACKEND_URL + path, {
    method:"POST", headers: bbotAdminHeaders(), body: JSON.stringify(body)
  }).then(function(r){
    if(!r.ok && pass.indexOf(r.status) < 0) return r.text().then(function(t){ throw new Error(path+" HTTP "+r.status+": "+(t||"").slice(0,160)); });
    return r;
  }).catch(function(err){ console.warn("[bbot write] "+path+" failed:", err && err.message); throw err; });
}
function reportSave(report){ return _beWrite("/report-save", {report: report}).then(function(r){ return r.json(); }); }
function reportPatch(target, fields, opts){
  // target: a reportId (number/string) OR {match:{col:val,...}} for a filtered patch.
  // `_pass` is TRANSPORT, not payload: statuses this caller will read itself. It is stripped from
  // the body so it can never reach the server as a field to patch.
  var o = Object.assign({}, opts||{});
  var pass = o._pass; delete o._pass;
  var body = Object.assign({fields: fields}, (target && typeof target==="object") ? target : {reportId: target}, o);
  return _beWrite("/report-patch", body, pass);
}
function reportDelete(ids){ return _beWrite("/report-delete", {reportIds: [].concat(ids)}); }
// Apply an admin-entered run/pop time to a report END TO END: patch measuredValues + basis, feed the
// age-bracketed leaderboard, and stamp the badge onto the player's per-activity clip. Shared by the report
// display and the dashboard "times to add" queue so there is ONE code path. Returns the reportPatch promise.
function _timeAgeGroup(player, report){
  var age = (typeof seasonAge==="function") ? seasonAge(player, report && (report.sessionDate||report.session_date)) : null;
  return age==null?"unknown":(age<=13?"12U-13U":age===14?"14U":age===15?"15U":age===16?"16U":age===17?"17U":age===18?"18U":"19+");
}
// Build a tool-section description that reflects an added time: strip any prior measured line AND, when a
// time now EXISTS, remove now-false "no timer / not measured / requires a verified time" disclaimers, then
// lead with the admin-verified measured sentence. No contradiction between the verified time and the prose.
function _reconcileTimeText(text, sentence, stripRe, v){
  var t = String(text||"").replace(stripRe, "");
  if(v!=null) t = t.replace(/[^.!?]*\b(no on[- ]?screen tim|not measured|requires a verified time|run grade requires|no timer|no radar)\b[^.!?]*[.!?]\s*/gi, "");
  return ((sentence||"") + t).trim();
}
function saveMeasuredTime(report, player, field, val, grade){
  // THE BROWSER NO LONGER WRITES THE DOCUMENT BACK (Luis, 2026-10-09: "close the browser
  // write-back path on the admin time entry now").
  //
  // This function used to deep-copy the WHOLE full_report it happened to be holding, edit three
  // fields and PATCH the entire object back. That is not an edit, it is a replacement with one
  // field changed -- and everything the server had decided since this tab loaded was undone by it.
  // Two live defects came out of that one shape: the bare 20-80 grade Luis found on Diego Cotto's
  // Pop Time, and 128 reps across 10 reports still carrying mechanics values the server had
  // withheld, each sitting beside its own admin copy.
  //
  // The server now owns the edit. We send three values -- which report, which time, what reading --
  // and it changes the four things that change, from its own copy of the row: the measured value
  // and its receipt, the section's age-reference basis, the admin-verified sentence, and the
  // card-stale stamp. No grade is written at any point. See /admin/measured-time-save.
  //
  // `grade` is still accepted so the two callers need not change, and is deliberately unused.
  var v = (val==null||val==="")?null:Number(val);
  var label = field==="dash60" ? "60-Yard" : field==="popTime" ? "Top Pop Time" : "Home-to-1st";

  var p = _beWrite("/admin/measured-time-save",
                   {reportId: String(report.id), field: field, seconds: v})
    .then(function(r){ return r.json(); })
    .then(function(res){
      // LOCAL STATE FOLLOWS THE SERVER'S ANSWER, not our guess at it. The response carries the
      // values it actually stored, so the screen cannot show a number the row does not hold.
      try{
        if(res && res.measuredValues){
          if(report.measuredValues) Object.assign(report.measuredValues, res.measuredValues);
          var _fr = report.fullReport || report.full_report;
          if(_fr){
            _fr.measuredValues = res.measuredValues;
            _fr.measuredValuesBasis = res.measuredValuesBasis;
          }
        }
      }catch(e){}
      if(typeof window!=="undefined"&&window.__bbotNotify){
        window.__bbotNotify(v==null?(label+" cleared"):(label+" saved ("+v.toFixed(2)+"s)"),"success");
      }
      return res;
    })
    .catch(function(err){
      // A FAILED SAVE SAYS SO. The old path reported success from a fire-and-forget patch; a time
      // an admin believes is recorded and is not is worse than a visible error.
      if(typeof window!=="undefined"&&window.__bbotNotify){
        window.__bbotNotify("Time save failed — nothing was recorded. "+((err&&err.message)||""),"error");
      }
      throw err;
    });

  // FEED THE LEADERBOARD (age-bracketed timed boards read bbot_measurements by tool_key).
  // grade: null, ALWAYS -- the boards rank on measured_value and print it; a grade column on a row
  // captioned "device-measured" is a judgement sitting in a measurement's seat.
  p.then(function(){
    try{
      if(v!=null && player){
        var TKEY={h2f:"h2f",dash60:"sixtyYard",popTime:"popTime"};
        measurementsLog([{report_id:report.id, player_id:String(player.id), age_group:_timeAgeGroup(player,report),
          position:player.position||null, tool_key:TKEY[field]||field, tool_label:label,
          grade:null, measured_value:String(v), confidence:"Confirmed",
          session_type:report.sessionType||report.session_type||null,
          session_date:report.sessionDate||report.session_date||null}]).catch(function(){});
      }
    }catch(e){}
    // STAMP THE RINSED CLIP -- time only; the backend has never put a grade on a clip.
    try{
      if(v!=null && player){
        var _tl=field==="dash60"?"60-Yd":field==="popTime"?"Top Pop Time":"H2F";
        sbSelect("bbot_clips","?player_id=eq."+encodeURIComponent(String(player.id))+"&clip_type=neq.skeleton&order=created_at.desc&limit=1&select=clip_object_key")
          .then(function(rows){ var ck=rows&&rows[0]&&rows[0].clip_object_key; if(!ck) return null;
            return fetch(BACKEND_URL+"/stamp-time-on-clip",{method:"POST",headers:bbotAdminHeaders(),body:JSON.stringify({clipObjectKey:ck,timeLabel:_tl,seconds:Number(v)})}); })
          .then(function(resp){ if(resp&&resp.ok&&typeof window!=="undefined"&&window.__bbotNotify) window.__bbotNotify(_tl+" placed on the rinsed clip footer","success"); })
          .catch(function(){});
      }
    }catch(e){}
  }).catch(function(){});

  return p;
}
// Which timed activities can a report take? EVERY non-pitcher report is eligible for a run time (H2F or 60,
// pick one); every catcher for a pop time. Not gated on observed activity — admin can add a time to any
// report. Optionality: Skip sets runTimeOptedOut so a dismissed report never returns. Never forces a value.
function timeQueueNeeds(report, player){
  var pos = String((player && player.position) || "").trim().toUpperCase();
  var isPitcher = /^(P|RHP|LHP|SP|RP|CP)$/.test(pos.split(/[\s,\/]/)[0]) || (report && report.isPitcher);
  if(isPitcher) return [];
  var fr = (report && (report.fullReport || report.full_report)) || report || {};
  if(fr.runTimeOptedOut) return [];   // admin dismissed this one — optionality, no nagging
  var mv = (report && report.measuredValues) || fr.measuredValues || {};
  var isCatcher = pos==="C" || pos==="CATCHER";
  var needs = [];
  var hasRun = (mv.h2f!=null && mv.h2f!=="") || (mv.dash60!=null && mv.dash60!=="");   // h2f OR 60 satisfies it
  if(isCatcher && (mv.popTime==null||mv.popTime==="")) needs.push("popTime");
  if(!hasRun) needs.push("run");   // any non-pitcher: run = H2F or 60 (pick one)
  return needs;
}
function measurementsLog(rows){ if(!rows || !rows.length) return Promise.resolve(null); return _beWrite("/measurements-log", {rows: rows}); }
function reportRequestReview(reportId, reason){ return _beWrite("/report-request-review", {reportId: reportId, reason: reason}); }
function playerMerge(stubId, targetId){ return _beWrite("/player-merge", {stubId: stubId, targetId: targetId}); }

// Create (or reuse) a PROVISIONAL player profile for an unidentified jersey in a multi-player
// session. No DOB / email / password required — the placeholder exists only so the session's
// data is never orphaned. Flagged provisional:true so it's excluded from leaderboards/percentiles
// (which need age) until an admin identifies it. Keyed by jersey + team/session context.
// Returns the player object (existing match or newly created stub).
// Assign a per-EVENT jersey number. The number only needs to be unique WITHIN one event — it's
// just the on-video lookup key for that day. Data attribution flows through the player's PROFILE
// (they registered from their account), so a player can wear different numbers at different events
// and all clips/evals/graphs still land on the same profile. Returns next free 1-99 for the event.
function nextEventNumber(eventNumbers){
  // eventNumbers: map of { playerId: number } already assigned for this event
  var taken={}; Object.keys(eventNumbers||{}).forEach(function(pid){ var n=eventNumbers[pid]; if(n!=null) taken[String(n)]=true; });
  for(var i=1;i<=99;i++){ if(!taken[String(i)]) return i; }
  for(var j=100;j<=999;j++){ if(!taken[String(j)]) return j; } // overflow if >99 players in one event
  return null;
}
// Shared event registration writers — used by BOTH EventsHomeSection and EventsView so the two
// registration entry points can never silently diverge. Callers pass their setEvents/notify.
//
// IT GOES THROUGH THE SERVER NOW, AND IT HAD TO. This PATCHed `bbot_events` through `bbotWrite`,
// and `bbot_events` is "admin" in the backend's WRITE_TABLES — so every attempt by a player to
// register themselves answered 403 and self-registration has never once worked. It could not be
// fixed by widening that permission either: the write sends the WHOLE `event_registrations`
// column, so a "user" grant would let any player rewrite another registrant's payment status or
// release someone else's jersey number. The merge belongs where one key can be changed in place,
// so `/event-register` reads the row, adds this player, assigns the number and writes it back.
//
// THE NUMBER COMES BACK FROM THE SERVER rather than being computed here. Two players registering
// at once both read the same `event_numbers` map in their own browser and both picked the same
// free number; whoever wrote second took a number the first was already wearing. One assigner,
// server-side, is the only version of this that holds. [[one-source-name-what-it-counts]]
function saveEventRegistration(ev, reg, setEvents, notify, onDone){
  var body = {eventId:Number(ev.id), size:reg.size, altJersey:reg.altJersey,
              twoWay:!!reg.twoWay, waiverAccepted:!!reg.waiverAccepted};
  // Present ONLY when an admin is registering somebody else; the server refuses it from anyone
  // who is not an admin, so a player cannot name a player.
  if(reg.targetPlayerId) body.targetPlayerId = String(reg.targetPlayerId);
  if(reg.note) body.note = reg.note;
  return fetch(BACKEND_URL+"/event-register",{method:"POST",headers:bbotAdminHeaders(),
                                              body:JSON.stringify(body)})
    .then(function(r){ return r.json().then(function(j){
      if(!r.ok) throw new Error(j.detail||j.message||("HTTP "+r.status)); return j; }); })
    .then(function(j){
      var pid = String(reg.targetPlayerId || reg.playerId);
      var num = j.eventNumber;
      if(setEvents) setEvents(function(list){ return (list||[]).map(function(e){
        if(String(e.id)!==String(ev.id)) return e;
        var next = Object.assign({},e);
        // The derived fields every renderer reads. Only meaningful when the registrant IS the
        // viewer, which is why the admin-on-behalf path refetches instead of trusting this.
        if(!reg.targetPlayerId){ next.my_registration = {size:reg.size, altJersey:reg.altJersey,
          twoWay:!!reg.twoWay, waiverAccepted:!!reg.waiverAccepted, paid:false};
          next.my_event_number = num; next.i_am_registered = true; }
        next.registered_count = (Number(e.registered_count)||0) + 1;
        // An admin holds the full row, so keep it consistent for the roster/payment screens.
        if(e.event_registrations){
          next.event_registrations = Object.assign({},e.event_registrations);
          next.event_registrations[pid] = {size:reg.size, altJersey:reg.altJersey,
            twoWay:!!reg.twoWay, paid:false, addedBy:(reg.targetPlayerId?"admin":"self")};
          next.event_numbers = Object.assign({},e.event_numbers||{}); next.event_numbers[pid]=num;
          next.attending_player_ids = (e.attending_player_ids||[]).map(String)
            .filter(function(x){return x!==pid;}).concat([pid]);
        }
        return next; }); });
      if(j.alreadyRegistered && notify) notify("Already registered for this event");
      if(onDone) onDone(num);
      return j;
    })
    .catch(function(err){
      // NAME THE FAILURE. A silent catch here is what makes a Register button look dead.
      if(notify) notify("Could not register: "+((err&&err.message)||"unknown"),"error");
      throw err;
    });
}
// AFTER A VERIFIED ATH PAYMENT. State only — the WRITE is the server's.
//
// THIS USED TO PATCH `bbot_events` FROM THE BROWSER, which could never have worked for the person
// actually paying: `bbot_events` is "admin" in WRITE_TABLES, so a player's confirmation answered
// 403, rolled its own optimistic update back, and told them the payment was "not saved" moments
// after ATH took their money.
//
// AND THE WRITE WAS ALREADY REDUNDANT. `/athm-confirm-event` verifies the payment with ATH and
// sets `paid` server-side from `eventCtx.eventId` + `playerId` — which is the only version that
// survives a closed tab. (That block raised NameError on `datetime` until 2026-10-22, so for a
// while NEITHER path persisted; both are fixed.) `paid` has one writer now, and it is the one that
// checked with ATH first. [[one-home-per-value]] [[admission-is-the-value]]
function markEventRegistrationPaid(ev, pid, setEvents){
  var key=String(pid);
  var stamp={paid:true, paidAt:new Date().toISOString()};
  if(setEvents) setEvents(function(list){ return (list||[]).map(function(e){
    if(String(e.id)!==String(ev.id)) return e;
    var next=Object.assign({},e);
    if(e.event_registrations){
      // The admin shape — the full map. `key` may be somebody other than the viewer, so the
      // viewer's own `my_registration` is deliberately left alone here.
      next.event_registrations=Object.assign({},e.event_registrations);
      next.event_registrations[key]=Object.assign({},e.event_registrations[key]||{},stamp);
    } else if(e.my_registration){
      // The redacted shape carries exactly one seat — the viewer's — so that is who just paid.
      next.my_registration=Object.assign({},e.my_registration,stamp);
    }
    return next; }); });
}
// REMOVE A REGISTRATION, AND TELL THE PLAYER WHY IT HAPPENED.
//
// An admin needs this when a registrant does not meet the event's requirements -- wrong age
// bracket, wrong level, event full. Silently deleting the row would leave a family planning
// around a game they are no longer in, so the removal and the notice are ONE action: the email
// is not an optional follow-up an admin might forget.
//
// THE ROW GOES BEFORE THE EMAIL. If the email fails, the player is still unregistered and the
// admin is told the notice did not go out -- they can resend. The reverse order risks telling
// someone they are removed while the registration is still live, which is the worse of the two.
//
// THE NUMBER IS RELEASED WITH THE SEAT. `event_numbers` is keyed per player and `nextEventNumber`
// fills gaps, so leaving a stale entry would hold a jersey number nobody is wearing.
//
// WHY IT SAYS SO LITTLE. The notice states the removal and asks them to email 643 -- it does not
// argue the reason in writing. The admin knows the circumstance; a templated sentence guessing at
// it would be wrong as often as right, and an eligibility decision about a minor is a conversation,
// not a form letter. [[credibility-decision-all-surfaces]]
function unregisterEventPlayer(ev, pid, player, setEvents, notify, onDone){
  var key = String(pid);
  var regs = Object.assign({}, ev.event_registrations||{});
  var enums = Object.assign({}, ev.event_numbers||{});
  var hadNumber = enums[key];
  delete regs[key];
  delete enums[key];
  var attending = (ev.attending_player_ids||[]).map(String).filter(function(x){ return x!==key; });
  var before = {regs: ev.event_registrations||{}, enums: ev.event_numbers||{}, att: ev.attending_player_ids||[]};

  bbotWrite("bbot_events","update",
            { event_registrations:regs, attending_player_ids:attending, event_numbers:enums },
            "id=eq."+encodeURIComponent(String(ev.id)))
    .then(function(){
      if(setEvents) setEvents(function(list){ return list.map(function(e){
        return e.id===ev.id ? Object.assign({},e,{event_registrations:regs,attending_player_ids:attending,event_numbers:enums}) : e; }); });
      var email = player && player.email;
      if(!email){
        if(notify) notify("Removed from the event — no email on file, so no notice was sent","error");
        if(onDone) onDone(false);
        return;
      }
      var first = (player.firstName||"there");
      var evName = ev.name || "the event";
      var html =
        "<p>Hi "+first+",</p>"+
        "<p>Your registration for <strong>"+evName+"</strong> has been released, and you are no "+
        "longer on the roster for this event.</p>"+
        (hadNumber?("<p>Event number "+hadNumber+" has been returned to the pool.</p>"):"")+
        "<p>If you have already paid, or you would like to know more, please reply to this email "+
        "or contact 643 Sports MGMT at <a href=\"mailto:643sportsmgmt@gmail.com\">643sportsmgmt@gmail.com</a> "+
        "and we will help.</p>"+
        "<p>— 643 BBOT</p>";
      return fetch(BACKEND_URL+"/send-event-blast",{
        method:"POST", headers:Object.assign({},bbotAdminHeaders(),{"Content-Type":"application/json"}),
        body:JSON.stringify({ eventName:evName, subject:"Your registration for "+evName,
                              bodyHtml:html, recipients:[email] })
      }).then(function(r){ return r.json(); }).then(function(out){
        // SAY WHICH HALF WORKED. "Removed" alone would read as "and they were told".
        if(out && out.sent) { if(notify) notify("Removed from the event — notice emailed to "+email); }
        else { if(notify) notify("Removed from the event, but the email did NOT send — contact them directly","error"); }
        if(onDone) onDone(!!(out&&out.sent));
      });
    })
    .catch(function(){
      if(setEvents) setEvents(function(list){ return list.map(function(e){
        return e.id===ev.id ? Object.assign({},e,{event_registrations:before.regs,attending_player_ids:before.att,event_numbers:before.enums}) : e; }); });
      if(notify) notify("Could not remove the registration — nothing was changed","error");
      if(onDone) onDone(false);
    });
}

function makeProvisionalPlayer(opts){
  opts = opts || {};
  var jersey = (opts.jerseyNum!=null ? String(opts.jerseyNum).trim() : "");
  var teamName = opts.teamName || "";
  var existing = (opts.users||[]).find(function(u){
    return u && u.provisional && String(u.jerseyNum||"")===jersey && (u.provisionalTeam||"")===teamName;
  });
  if(existing) return existing;
  var stub = {
    id: Date.now() + Math.floor(Math.random()*1000),
    type: "player",
    provisional: true,                       // <- excluded from leaderboards/percentiles until identified
    provisionalTeam: teamName,
    firstName: "#" + (jersey||"??"),
    lastName: "(Unassigned)",
    email: null, password: null, dob: null,  // storage allowed with no DOB
    jerseyNum: jersey,
    position: opts.position || "",
    approvalStatus: "approved",              // staff-created stub; not a self-signup awaiting review
    createdAt: new Date().toISOString(),
    profileViews: [], notifications: []
  };
  if(opts.setUsers) opts.setUsers(function(prev){ return (prev||[]).concat([stub]); });
  try { persistUser(stub); } catch(e){ /* persistUser logs; stub still usable in-session */ }
  return stub;
}
function deviceId() {
  var id = localStorage.getItem("bbot_device_id");
  if(!id) { id = "dev_" + Math.random().toString(36).slice(2) + Date.now().toString(36); localStorage.setItem("bbot_device_id", id); }
  return id;
}
const USE_BACKEND  = true; // Backend active


const css = `
  @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');
  *,*::before,*::after{box-sizing:border-box;margin:0;padding:0}
  html{-webkit-text-size-adjust:100%;-webkit-tap-highlight-color:transparent}
  body{background:${C.gray50};color:${C.gray800};font-family:'Inter',system-ui,sans-serif;min-height:100vh;-webkit-font-smoothing:antialiased;font-size:14px;line-height:1.5}
  ::-webkit-scrollbar{width:4px;height:4px}::-webkit-scrollbar-thumb{background:${C.gray300};border-radius:4px}
  input,select,textarea{background:${C.white};border:1.5px solid ${C.border};color:${C.gray800};padding:12px 14px;border-radius:10px;font-family:'Inter',sans-serif;font-size:15px;width:100%;outline:none;transition:border .15s,box-shadow .15s;-webkit-appearance:none;appearance:none;min-height:44px}
  input:focus,select:focus,textarea:focus{border-color:${C.blue};box-shadow:0 0 0 3px rgba(26,75,191,.12)}
  input::placeholder,textarea::placeholder{color:${C.gray400}}
  select{background-image:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8'%3E%3Cpath fill='%2394a3b8' d='M1 1l5 5 5-5'/%3E%3C/svg%3E");background-repeat:no-repeat;background-position:right 14px center;padding-right:36px}
  button{cursor:pointer;font-family:'Inter',sans-serif;font-weight:600;transition:all .15s;border:none;-webkit-tap-highlight-color:transparent;min-height:40px;font-size:14px}
  button:active{opacity:.85;transform:scale(.98)}
  button:focus-visible{outline:2px solid ${C.coral};outline-offset:2px}
  label{font-size:11px;font-weight:600;color:${C.gray500};display:block;margin-bottom:5px;text-transform:uppercase;letter-spacing:.6px}
  h1{font-size:24px;font-weight:700;color:${C.navy};line-height:1.25}
  h2{font-size:20px;font-weight:700;color:${C.navy};line-height:1.3}
  h3{font-size:16px;font-weight:700;color:${C.navy};line-height:1.35}
  p{font-size:14px;line-height:1.6;color:${C.gray700}}
  @keyframes fadeUp{from{opacity:0;transform:translateY(8px)}to{opacity:1;transform:translateY(0)}}
  @keyframes pulse{0%,100%{opacity:1}50%{opacity:.4}}
  @keyframes spin{to{transform:rotate(360deg)}}
  @keyframes shimmer{0%{background-position:-200% 0}100%{background-position:200% 0}}
  .skeleton{background:linear-gradient(90deg,${C.gray100} 0%,${C.gray200} 50%,${C.gray100} 100%);background-size:200% 100%;animation:shimmer 1.5s infinite;border-radius:8px}
  .fade-up{animation:fadeUp .2s ease}
  /* -- Checkbox sizing: keep all checkboxes compact + consistent site-wide -- */
  input[type="checkbox"]{ width:14px; height:14px; min-width:14px; min-height:14px; accent-color:#2563eb; cursor:pointer; }
  @media (hover:hover){ .lift{transition:transform .15s ease, box-shadow .15s ease} .lift:hover{transform:translateY(-3px); box-shadow:0 10px 28px rgba(41,112,184,.14)} }
  /* -- Responsive -- */
  @media(max-width:480px){
    .hide-mobile{display:none!important}
    .stack-mobile{flex-direction:column!important}
  }
  @media(min-width:768px){
    .desktop-2col{grid-template-columns:1fr 1fr!important}
    .desktop-3col{grid-template-columns:1fr 1fr 1fr!important}
  }
`;

// Known organizations (used as autocomplete seed for org search)
// New orgs added by users will be persisted in bbot_organizations table
const KNOWN_ORGS = [
  {name:"643 Sports MGMT LLC", state:"PR", type:"travel"},
];



const HEIGHTS=(function(){var a=[];for(var n=54;n<=82;n+=0.5){var f=Math.floor(n/12),i=n-f*12;a.push(f+"'"+(i%1===0?i:(Math.floor(i)+"½"))+"\"");}return a;})();
// Parse a height display string (e.g. 5'10½") to inches (70.5) for the pose scale reference.
function heightToInches(s){if(s==null||s==="")return null;s=String(s).replace("½",".5").replace(/["”]/g,"");var m=s.match(/^\s*(\d+)\s*'\s*(\d+(?:\.\d+)?)?\s*$/);if(m){return parseInt(m[1],10)*12+(m[2]?parseFloat(m[2]):0);}var n=parseFloat(s);return isNaN(n)?null:n;}
const POSITIONS=["P","C","1B","2B","3B","SS","LF","CF","RF","OF","DH","UTIL"];
const GPAS=["4.0","3.9","3.8","3.7","3.6","3.5","3.4","3.3","3.2","3.1","3.0","2.9","2.8"];
const GRAD_YEARS=["2025","2026","2027","2028","2029"];
const COACH_POSITIONS=["Head Coach","Assistant Coach","Pitching Coach","Hitting Coach","Recruiting Coordinator"];
const COACH_LEVELS=["High School","Travel/Club","College","Professional"];
const STAFF_ROLES=["Director","Scout / Analyst","Metrics Staff","Admin","Coach"];


function Btn({children,v,onClick,style,disabled,full}){
  v=v||"primary";
  const base={display:"inline-flex",alignItems:"center",justifyContent:"center",gap:6,padding:"10px 18px",borderRadius:10,fontSize:14,fontWeight:600,cursor:"pointer",border:"none",whiteSpace:"nowrap",letterSpacing:.1,transition:"all .15s ease"};
  const map={
    primary: {...base,background:C.navy,   color:C.white, boxShadow:"0 1px 3px rgba(41,112,184,.18)"},
    orange:  {...base,background:C.coral,  color:C.white, boxShadow:"0 2px 6px rgba(232,82,106,.22)"},
    coral:   {...base,background:C.coral,  color:C.white, boxShadow:"0 2px 6px rgba(232,82,106,.22)"},
    green:   {...base,background:C.green,  color:C.white},
    outline: {...base,background:C.white,  color:C.navy,  border:"1.5px solid "+C.navy},
    outlineW:{...base,background:"transparent",color:C.white,border:"1.5px solid rgba(255,255,255,.4)"},
    ghost:   {...base,background:C.white,  color:C.gray600,border:"1px solid "+C.border},
    ghostBlue:{...base,background:C.blueFaint,color:C.blue,border:"1px solid "+C.blueLight},
    danger:  {...base,background:C.red,    color:C.white},
    link:    {background:"transparent",color:C.blue,border:"none",padding:"4px 0",fontSize:14,fontWeight:600,display:"inline-flex",alignItems:"center",gap:4},
  };
  const s=map[v]||map.primary;
  return <button onClick={onClick} disabled={disabled} style={Object.assign({},s,{opacity:disabled?0.5:1,width:full?"100%":"auto"},style||{})}>{children}</button>;
}

function Avatar({user,size}){
  size=size||40;
  const i=((user.firstName||"")[0]||"")+((user.lastName||"")[0]||"");
  const cols={player:C.blue,coach:C.navyMid,staff:C.orange};
  // 1. Personal photo if uploaded
  if(user.photoUrl){
    return <img src={user.photoUrl} alt={i} style={{width:size,height:size,borderRadius:"50%",objectFit:"cover",flexShrink:0,background:C.gray100}}/>;
  }
  // 2. BBOT branded fallback for users without initials (no first/last name set)
  if(!i || i.trim()===""){
    return <div style={{width:size,height:size,borderRadius:"50%",background:C.navy,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,overflow:"hidden"}}>
      <BbotMark size={Math.round(size*.85)}/>
    </div>;
  }
  // 3. Initials in colored circle
  return <div style={{width:size,height:size,borderRadius:"50%",background:cols[user.type]||C.blue,display:"flex",alignItems:"center",justifyContent:"center",color:C.white,fontWeight:700,fontSize:Math.round(size*.36),flexShrink:0,fontFamily:"Inter,system-ui,sans-serif"}}>{i}</div>;
}

// ONCLICK IS FORWARDED, and it was not. The signature took {children, style, className} and
// silently DROPPED every other prop -- so `<Card onClick={...}>` attached no handler at all. The
// blog index has been passing one for as long as it has existed, which means no reader has ever
// been able to open a post by clicking its card; the "Read more" line was decoration. Found by a
// probe that clicked a headline on the deployed site and stayed on the index.
//
// A component that accepts a handler and ignores it is worse than one that refuses it: the call
// site looks correct, so nobody goes looking.
function Card({children,style,className,onClick}){
  return <div className={className||""} onClick={onClick}
    style={{background:C.white,border:"1px solid "+C.border,borderRadius:12,padding:"clamp(14px,4vw,18px)",boxShadow:C.shadow,transition:"box-shadow 150ms ease, border-color 150ms ease, transform 150ms ease",...(style||{})}}>{children}</div>;
}

// Fade-and-rise into view on scroll. Wraps any block; reveals once when visible.
function Reveal({children, delay}){
  var ref = useRef(null);
  var seenS = useState(false); var seen = seenS[0]; var setSeen = seenS[1];
  useEffect(function(){
    if(typeof IntersectionObserver==="undefined"){ setSeen(true); return; }
    var el = ref.current; if(!el) return;
    var obs = new IntersectionObserver(function(entries){
      entries.forEach(function(e){ if(e.isIntersecting){ setSeen(true); obs.disconnect(); } });
    }, {threshold:0.12});
    obs.observe(el);
    return function(){ obs.disconnect(); };
  }, []);
  return <div ref={ref} style={{opacity:seen?1:0, transform:seen?"translateY(0)":"translateY(18px)", transition:"opacity .55s ease "+(delay||0)+"ms, transform .55s ease "+(delay||0)+"ms"}}>{children}</div>;
}

// Tooltip wrapper — small ⓘ next to a label, hover/tap to see definition
function Tooltip({term, def, children}){
  return (
    <span style={{display:"inline-flex",alignItems:"center",gap:3,position:"relative"}}>
      {children}
      <span title={def||""} style={{display:"inline-flex",alignItems:"center",justifyContent:"center",width:13,height:13,borderRadius:"50%",background:C.gray200,color:C.gray600,fontSize:9,fontWeight:700,cursor:"help",fontFamily:"serif",lineHeight:1}}>i</span>
    </span>
  );
}

// OrgInput — typeahead organization picker with autocomplete + "add new" option
// Fetches known orgs from bbot_organizations (created on the fly when users add new ones)
// Combined with KNOWN_ORGS seed list. Returns the chosen org name via onChange.
function OrgInput({value, onChange, placeholder, label}){
  var [query, setQuery] = useState(value||"");
  var [dbOrgs, setDbOrgs] = useState([]);
  var [open, setOpen] = useState(false);
  var [loaded, setLoaded] = useState(false);

  useEffect(function(){
    setQuery(value||"");
  }, [value]);

  // Fetch existing orgs from Supabase on first focus
  function loadOrgs(){
    if(loaded) return;
    setLoaded(true);
    fetch(SUPABASE_URL+"/rest/v1/bbot_organizations?select=name,state,type&order=name.asc", {
      headers: sbHeaders()
    }).then(function(r){return r.json();}).then(function(rows){
      setDbOrgs(rows||[]);
    }).catch(function(){});
  }

  // Merge KNOWN_ORGS + dbOrgs, dedupe by name
  var allOrgs = (function(){
    var combined = (KNOWN_ORGS||[]).concat(dbOrgs||[]);
    var seen = {};
    return combined.filter(function(o){
      var key = (o.name||"").toLowerCase().trim();
      if(!key || seen[key]) return false;
      seen[key] = true;
      return true;
    });
  })();

  var q = (query||"").toLowerCase().trim();
  var matches = q ? allOrgs.filter(function(o){
    return (o.name||"").toLowerCase().indexOf(q)>=0;
  }).slice(0,6) : allOrgs.slice(0,6);

  var exactMatch = allOrgs.some(function(o){return (o.name||"").toLowerCase() === q;});
  var canAddNew = q.length >= 3 && !exactMatch;

  function pick(name){
    setQuery(name);
    setOpen(false);
    onChange(name);
  }

  function addNew(){
    var name = query.trim();
    if(!name) return;
    // Persist to Supabase so future users see it in autocomplete
    bbotWrite("bbot_organizations","insert",[{name:name, state:null, type:null, created_at:new Date().toISOString()}],null).catch(function(){});
    // Add locally too
    setDbOrgs(function(prev){return prev.concat([{name:name, state:null, type:null}]);});
    pick(name);
  }

  return (
    <div style={{position:"relative"}}>
      {label && <label style={{fontSize:11,color:C.gray500,fontWeight:600,letterSpacing:.5,display:"block",marginBottom:4}}>{label}</label>}
      <input
        value={query}
        onChange={function(e){setQuery(e.target.value); setOpen(true); onChange(e.target.value);}}
        onFocus={function(){loadOrgs(); setOpen(true);}}
        onBlur={function(){setTimeout(function(){setOpen(false);}, 200);}}
        placeholder={placeholder||"Type to search or add organization..."}
        style={{width:"100%",padding:"8px 10px",border:"1px solid "+C.border,borderRadius:6,fontSize:13,boxSizing:"border-box"}}
      />
      {open && (matches.length>0 || canAddNew) && (
        <div style={{position:"absolute",top:"100%",left:0,right:0,zIndex:100,background:C.white,border:"1px solid "+C.border,borderRadius:8,marginTop:4,boxShadow:C.shadowMd,maxHeight:240,overflowY:"auto"}}>
          {matches.map(function(o,i){return (
            <div key={i} onMouseDown={function(){pick(o.name);}} style={{padding:"8px 12px",cursor:"pointer",borderBottom:"1px solid "+C.gray100,fontSize:13,color:C.navy}}>
              <div style={{fontWeight:600}}>{o.name}</div>
              {(o.state||o.type) && <div style={{fontSize:10,color:C.gray500,marginTop:1}}>{[o.state,o.type].filter(Boolean).join(" · ")}</div>}
            </div>
          );})}
          {canAddNew && (
            <div onMouseDown={addNew} style={{padding:"8px 12px",cursor:"pointer",background:C.coralFaint,fontSize:13,color:C.coral,fontWeight:600,display:"flex",alignItems:"center",gap:6}}>
              <span style={{display:"inline-flex",width:16,height:16,alignItems:"center",justifyContent:"center",background:C.coral,color:C.white,borderRadius:"50%",fontSize:11,fontWeight:700}}>+</span>
              <span>Add "{query}" as new organization</span>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

function Badge({children,color}){
  color=color||"blue";
  const map={blue:{bg:C.blueLight,t:C.blue},orange:{bg:C.orangeLight,t:C.orange},coral:{bg:C.coralLight,t:C.coral},gray:{bg:C.gray100,t:C.gray600},green:{bg:C.greenLight,t:C.green},yellow:{bg:C.yellowLight,t:"#854d0e"}};
  const c=map[color]||map.gray;
  return <span style={{background:c.bg,color:c.t,fontSize:11,fontWeight:600,padding:"3px 10px",borderRadius:99,display:"inline-block",letterSpacing:.3,whiteSpace:"nowrap"}}>{children}</span>;
}

function Toast({msg,type}){
  if(!msg)return null;
  const bg=type==="error"?C.red:(type==="welcome"?C.coral:C.green);
  return <div style={{position:"fixed",top:20,right:16,left:16,zIndex:9999,background:bg,color:C.white,padding:"14px 18px",borderRadius:12,fontWeight:600,fontSize:14,boxShadow:C.shadowLg,animation:"fadeUp .2s ease",display:"flex",alignItems:"center",gap:8,maxWidth:400,margin:"0 auto"}}><span>{type==="error"?"⚠":"v"}</span>{msg}</div>;
}

function Skeleton({h, w, style}){
  return <div className="skeleton" style={{height:h||16,width:w||"100%",borderRadius:8,...(style||{})}}/>;
}

function SkeletonCard(){
  return (
    <div style={{padding:14,background:"#fff",borderRadius:12,border:"1px solid "+C.border,marginBottom:8}}>
      <Skeleton h={20} w="40%" style={{marginBottom:10}}/>
      <Skeleton h={12} w="80%" style={{marginBottom:6}}/>
      <Skeleton h={12} w="60%"/>
    </div>
  );
}

function FieldInput({label,value,onChange,type,options,placeholder}){
  return(
    <div>
      <label>{label}</label>
      {options?(<select value={value||""} onChange={onChange}><option value="">Select...</option>{options.map(function(o){return<option key={o} value={o}>{o}</option>;})}</select>):(<input type={type||"text"} value={value||""} onChange={onChange} placeholder={placeholder||""}/>)}
    </div>
  );
}

function SectionHeader({children,id}){
  return(
    <div id={id} style={{display:"flex",alignItems:"center",gap:10,margin:"28px 0 14px",scrollMarginTop:20}}>
      <img src={LOGO_BBOT} alt="BBOT" style={{height:22,width:22,borderRadius:"50%",flexShrink:0,boxShadow:"0 1px 3px rgba(0,0,0,.15)"}}/>
      <h2 style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:16,color:C.gray700,letterSpacing:1.5,textTransform:"uppercase",fontWeight:600,whiteSpace:"nowrap"}}>{children}</h2>
      <div style={{flex:1,height:1,background:C.border}}/>
    </div>
  );
}

function EmptyCard({icon,title,sub,action,onAction}){
  return(
    <Card style={{textAlign:"center",padding:"48px 24px",background:C.gray50,border:"1px dashed "+C.gray200,boxShadow:"none"}}>
      {/* Always the BBOT mark — no letter-in-a-circle placeholders (icon prop kept for call-site compatibility) */}
      <div style={{display:"inline-flex",marginBottom:14}}><BbotMark size={52}/></div>
      <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:15,color:C.gray800,letterSpacing:1,marginBottom:6}}>{title}</div>
      {sub&&<div style={{fontSize:13,color:C.gray500,marginBottom:action?18:0,lineHeight:1.6,maxWidth:380,margin:action?"0 auto 18px":"0 auto"}}>{sub}</div>}
      {action&&<Btn v="primary" style={{fontSize:13}} onClick={onAction}>{action}</Btn>}
    </Card>
  );
}

// In-app "How To Use" — concise, role-specific, collapsible. Mirrors the welcome email.
var HOWTO = {
  player: ["Complete your profile — position, class year, height/weight, and a short bio. Full profiles rank higher when coaches search.",
           "Upload a session video (or have 643 film you) to request an evaluation.",
           "Pay once after admin review — you get measured results on every captured tool, verified measurements, a spray/pitch chart, and stamped clips, all on your profile.",
           "Upload again every few weeks. Your progression timeline is your edge — coaches want to see a player improving.",
           "After 2+ sessions, 643 can compile a cumulative evaluation across your sessions — ask your coach or 643 staff.",
           "Maximize it: keep your profile 100% complete, upload regularly, and share your public profile link with coaches."],
  coach:  ["Set up your profile with your program/organization so players know who's interested.",
           "Search and filter players by position, class year, and metrics (exit velo, throw velo, 60-time).",
           "Save your recruiting needs as a Search — BBOT surfaces matching players and flags new evaluations.",
           "Request an evaluation on any player's profile — they're notified to start one, and you're alerted when it's released.",
           "Use Compare to line up to 10 players side by side on tools + metrics.",
           "Maximize it: save your top searches and check your matches widget for fresh evals."],
  staff:  ["Run BBOT: pick a player, upload their video, run the evaluation.",
           "It goes to admin for review (the calibration step).",
           "Once approved, it unlocks for the player to purchase.",
           "Pull players onto your roster to track reports, clips, leaderboards.",
           "Running an evaluation triggers the request only — it never charges anyone."],
};
function HowToUse({role, defaultOpen}){
  var openS=useState(!!defaultOpen); var open=openS[0]; var setOpen=openS[1];
  var steps=HOWTO[role]||HOWTO.player;
  return (
    <Card style={{padding:0,marginBottom:14,overflow:"hidden",border:"1px solid "+C.blue}}>
      <button onClick={function(){setOpen(!open);}} style={{width:"100%",display:"flex",alignItems:"center",justifyContent:"space-between",background:C.blue,border:"none",padding:"14px 16px",cursor:"pointer"}}>
        <span style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:16,color:C.coral,letterSpacing:1,fontWeight:700}}>HOW TO USE YOUR PROFILE</span>
        <span style={{color:C.coral,fontSize:15}}>{open?"▲":"▼"}</span>
      </button>
      {open&&<ol style={{margin:0,padding:"14px 16px 14px 34px",lineHeight:1.75,fontSize:14,color:C.gray700,background:C.white}}>
        {steps.map(function(s,i){return <li key={i} style={{marginBottom:7}}>{s}</li>;})}
      </ol>}
    </Card>
  );
}

// ATH Móvil — the payment integration for Puerto Rico, and now the only one (#22).
// Searchable single-select dropdown. Used wherever a player must be picked from
// a long roster. options: [{value, label, sub}]. Calls onChange(value).
function SearchSelect({value, onChange, options, placeholder, allowCustom}){
  var qS=useState(""); var q=qS[0]; var setQ=qS[1];
  var openS=useState(false); var open=openS[0]; var setOpen=openS[1];
  var opts=options||[];
  var selected=opts.find(function(o){return String(o.value)===String(value);});
  var ql=q.trim().toLowerCase();
  var filtered=ql ? opts.filter(function(o){
    return String(o.label||"").toLowerCase().indexOf(ql)>=0 || String(o.sub||"").toLowerCase().indexOf(ql)>=0;
  }) : opts;
  filtered=filtered.slice(0,50);
  function pick(o){ onChange&&onChange(o.value); setOpen(false); setQ(""); }
  return (
    <div style={{position:"relative"}}>
      <div onClick={function(){setOpen(!open);}} style={{display:"flex",alignItems:"center",justifyContent:"space-between",padding:"9px 12px",border:"1px solid "+C.border,borderRadius:8,cursor:"pointer",background:C.white,fontSize:13}}>
        <span style={{color:selected?C.navy:C.gray400,fontWeight:selected?600:400}}>{selected?selected.label:(placeholder||"Select...")}</span>
        <span style={{color:C.gray400,fontSize:11}}>{open?"▲":"▼"}</span>
      </div>
      {open&&(
        <div style={{position:"absolute",top:"calc(100% + 4px)",left:0,right:0,background:C.white,border:"1px solid "+C.border,borderRadius:8,boxShadow:"0 2px 6px rgba(0,0,0,.15)",zIndex:50,maxHeight:280,overflow:"hidden",display:"flex",flexDirection:"column"}}>
          <input autoFocus value={q} onChange={function(e){setQ(e.target.value);}} placeholder="Type to search..." style={{padding:"9px 12px",border:"none",borderBottom:"1px solid "+C.gray100,fontSize:13,outline:"none",boxSizing:"border-box"}}/>
          <div style={{overflowY:"auto"}}>
            {filtered.length===0
              ? <div style={{padding:"10px 12px",fontSize:12,color:C.gray400}}>{allowCustom&&q?("Use \""+q+"\""):"No matches"}</div>
              : filtered.map(function(o){
                  var sel=String(o.value)===String(value);
                  return <div key={String(o.value)} onClick={function(){pick(o);}} style={{padding:"8px 12px",cursor:"pointer",background:sel?C.blueFaint:"transparent",borderBottom:"1px solid "+C.gray50}}>
                    <div style={{fontSize:13,fontWeight:600,color:C.navy}}>{o.label}</div>
                    {o.sub&&<div style={{fontSize:10,color:C.gray400,marginTop:1}}>{o.sub}</div>}
                  </div>;
                })}
            {allowCustom&&q&&filtered.length>0&&(
              <div onClick={function(){onChange&&onChange(q);setOpen(false);setQ("");}} style={{padding:"8px 12px",cursor:"pointer",borderTop:"1px solid "+C.gray100,fontSize:12,color:C.blue,fontWeight:600}}>Use "{q}"</div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

// ATH Móvil Business payment button (primary method in PR).
// Props:
//   reportId   – bbot_reports row id this payment unlocks (required)
//   amountUSD  – total to charge (required, 1.00–1500.00 per ATH limits)
//   playerId   – player the report belongs to (for the confirm call)
//   videoSource– carried through so post-payment generation tags correctly
//   label      – small caption above the button
//   onPaid     – called after the backend VERIFIES the payment is COMPLETED
//
// Security: the ATH JS success callback fires in the browser and cannot be
// trusted on its own. On success we send the referenceNumber + ecommerceId to
// our backend /athm-confirm, which re-checks the payment with ATH's API using
// the PRIVATE token (server-side only) before flipping the report to draft and
// generating. The browser callback never directly unlocks anything.
//
// ATH exposes ONE set of global callbacks (authorizationATHM/cancelATHM/
// expiredATHM) and one button div per page, so we route those globals to the
// currently-mounted button via a module-level "active" pointer.
var __athmActive = null; // { reportId, playerId, amountUSD, videoSource, onPaid, notify }

function __athmInstallGlobals(){
  if(typeof window === "undefined" || window.__athmGlobalsInstalled) return;
  window.__athmGlobalsInstalled = true;
  window.authorizationATHM = function(){
    try {
      // ATH's own JS exposes authorization(); call it to get the final object.
      var p = (typeof authorization === "function") ? authorization() : Promise.resolve(null);
      Promise.resolve(p).then(function(resp){
        var data = (resp && resp.data) || {};
        var ctx = __athmActive;
        if(!ctx){ return; }
        var ref = data.referenceNumber || data.ecommerceId || "";
        // EVENT REGISTRATION path — verify server-side via /athm-confirm-event.
        if(ctx.kind === "event_registration"){
          fetch(BACKEND_URL+"/athm-confirm-event", {
            method:"POST", headers:{"Content-Type":"application/json"},
            body: JSON.stringify({
              eventId: ctx.eventId, eventName: ctx.eventName,
              playerId: ctx.playerId, playerName: ctx.playerName,
              playerEmail: ctx.playerEmail, eventNumber: ctx.eventNumber,
              expectedAmount: ctx.amountUSD,
              referenceNumber: data.referenceNumber || "",
              ecommerceId: data.ecommerceId || ""
            })
          }).then(function(r){return r.json();}).then(function(out){
            if(out && out.ok){
              ctx.notify && ctx.notify("Registration confirmed — instructions will be emailed before the event.","success");
              ctx.onPaid && ctx.onPaid(out);
            } else {
              ctx.notify && ctx.notify((out && out.reason) || "We couldn't verify that payment yet. If you were charged, 643 will confirm.","error");
            }
          }).catch(function(){
            ctx.notify && ctx.notify("Payment received but verification is delayed. 643 will confirm your registration.","error");
          });
          return;
        }
        // VERIFY SERVER-SIDE before treating as paid.
        fetch(BACKEND_URL+"/athm-confirm", {
          method:"POST", headers:{"Content-Type":"application/json"},
          body: JSON.stringify({
            reportId: ctx.reportId,
            playerId: ctx.playerId,
            referenceNumber: data.referenceNumber || "",
            ecommerceId: data.ecommerceId || "",
            videoSource: ctx.videoSource || "bbot_recorded"
          })
        }).then(function(r){return r.json();}).then(function(out){
          if(out && out.ok){
            ctx.notify && ctx.notify("Payment confirmed — your evaluation is being prepared.","success");
            ctx.onPaid && ctx.onPaid(out);
          } else {
            ctx.notify && ctx.notify((out && out.reason) || "We couldn't verify that payment yet. If you were charged, it will be reviewed.","error");
          }
        }).catch(function(){
          ctx.notify && ctx.notify("Payment received but verification is delayed. 643 will confirm and release your report.","error");
        });
      });
    } catch(_){}
  };
  window.cancelATHM = function(){
    if(__athmActive && __athmActive.notify) __athmActive.notify("Payment canceled.","error");
  };
  window.expiredATHM = function(){
    if(__athmActive && __athmActive.notify) __athmActive.notify("Payment timed out — please try again.","error");
  };
}

function AthMovilButton(props){
  // THE GATE LISTENS, because the token now arrives from /public-config a moment AFTER first paint.
  // Without this the first visitor after the token is set keeps seeing "coming soon" until they
  // happen to reload -- the switch would be on and the customer would not know.
  //
  // The subscription is unconditional, so hook order is stable however the flag lands; only the
  // RETURN is conditional, which is what the Rules of Hooks actually require. The inner component
  // (which uses its own hooks) still mounts only when ATH is genuinely enabled.
  var enabledS = useState(BBOT_ATHM_ENABLED);
  var enabled = enabledS[0], setEnabled = enabledS[1];
  useEffect(function(){
    function sync(){ setEnabled(BBOT_ATHM_ENABLED); }
    sync();                       // the fetch may have resolved before this mounted
    window.addEventListener("bbot-config", sync);
    return function(){ window.removeEventListener("bbot-config", sync); };
  },[]);
  if(!enabled) return <PaymentComingSoon/>;
  return <AthMovilButtonLive {...props}/>;
}

// THE ONLY THING A CUSTOMER SEES UNTIL THE TOKEN IS IN, so it has to carry its own
// instructions. The version this replaces was a dashed grey "ATH Móvil — coming soon"
// note that sat BESIDE a working card button; with Stripe retired it would have been
// the entire payment surface, and a greyed-out label is not a payment surface. It says
// what is happening and how to complete a purchase in the meantime.
function PaymentComingSoon(){
  return (
    <div style={{marginTop:8,padding:"14px 16px",border:"1px solid "+C.coral,borderRadius:10,
                 background:C.white,textAlign:"center"}}>
      <div style={{fontSize:10,letterSpacing:1,color:C.coral,fontWeight:700,marginBottom:6}}>
        ONLINE PAYMENT COMING SOON
      </div>
      <div style={{fontSize:12,color:C.gray600||C.gray500,lineHeight:1.6}}>
        BBOT is moving to <strong style={{color:C.navy}}>ATH Móvil</strong> for all payments.
        Online checkout is unavailable for a short time.
      </div>
      <div style={{fontSize:11,color:C.gray500,lineHeight:1.6,marginTop:8}}>
        To complete your evaluation now, contact 643 Sports MGMT and we will arrange payment
        and release your report.
      </div>
    </div>
  );
}

function AthMovilButtonLive({reportId, amountUSD, playerId, videoSource, label, onPaid, notify, eventCtx}){
  var holderRef = useRef(null);
  var total = Math.round((Number(amountUSD)||0)*100)/100;

  useEffect(function(){
    __athmInstallGlobals();
    // Mark this button as the active payment target while mounted. Event registrations carry
    // an eventCtx; evals carry reportId. The global callback routes on ctx.kind.
    if(eventCtx){
      __athmActive = Object.assign({ kind:"event_registration", amountUSD: total, onPaid: onPaid, notify: notify }, eventCtx);
    } else {
      __athmActive = { reportId: reportId, playerId: playerId, amountUSD: total, videoSource: videoSource, onPaid: onPaid, notify: notify };
    }

    // ATH reads its config from a global ATHM_Checkout object. The ATH Móvil modal offers
    // BOTH ATH Móvil and credit/debit card (when card is enabled on the business account).
    var itemName = eventCtx ? ("Registration — "+(eventCtx.eventName||"Event")) : "BBOT Evaluation";
    var metaId = eventCtx ? ("event:"+String(eventCtx.eventId||"")) : ("report:"+String(reportId));
    window.ATHM_Checkout = {
      env: "production",
      publicToken: BBOT_ATHM_PUBLIC_TOKEN,
      timeout: 600,
      theme: "btn",
      lang: BBOT_ATHM_LANG,
      total: total,
      subtotal: total,
      tax: 0,
      metadata1: metaId,
      metadata2: eventCtx ? ("player:"+String(eventCtx.playerId||"")) : ("player:"+String(playerId||"")),
      items: [{
        name: itemName,
        description: eventCtx ? "BBOT — event registration" : "BBOT player evaluation",
        quantity: "1",
        price: String(total),
        tax: null,
        metadata: metaId
      }],
      phoneNumber: ""
    };

    // Inject the ATH base script once; it renders into the holder div by id.
    var existing = document.getElementById("athm-base-js");
    if(!existing){
      var s = document.createElement("script");
      s.id = "athm-base-js";
      s.src = "https://payments.athmovil.com/api/modal/js/athmovil_base.js";
      s.async = true;
      document.body.appendChild(s);
    }
    return function(){
      // On unmount, release the active pointer if it's still us.
      var mine = eventCtx ? (__athmActive && __athmActive.kind==="event_registration" && String(__athmActive.eventId)===String(eventCtx.eventId) && String(__athmActive.playerId)===String(eventCtx.playerId))
                          : (__athmActive && String(__athmActive.reportId)===String(reportId));
      if(mine) __athmActive = null;
    };
  }, [reportId, total, playerId, videoSource, eventCtx && eventCtx.eventId, eventCtx && eventCtx.playerId]);

  return (
    <div style={{marginTop:8}}>
      {label && <div style={{fontSize:10,letterSpacing:.5,color:C.gray400,textAlign:"center",marginBottom:4}}>{label}</div>}
      {/* ATH renders the "Pay with ATH Móvil" button (incl. card option) into this div by id. */}
      <div id="ATHMovil_Checkout_Button_payment" ref={holderRef}></div>
    </div>
  );
}

function BaseballLike({liked,onClick,count}){
  return(
    <button onClick={onClick} style={{background:"none",border:"none",display:"flex",flexDirection:"column",alignItems:"center",cursor:"pointer",gap:2,padding:"6px 8px",borderRadius:8,minWidth:36}}>
      <span style={{fontSize:22,filter:liked?"sepia(1) saturate(4) hue-rotate(190deg)":"none",transition:"filter .2s"}}>⚾</span>
      <span style={{fontSize:11,color:liked?C.blue:C.gray400,fontWeight:600}}>{count}</span>
    </button>
  );
}



// WHERE THE CRASH HAPPENED, WHICH THE LOG COULD NOT SAY. The boundary logged `err.message` and
// nothing else, so the site recorded "Maximum call stack size exceeded" four times without once
// naming the page — and finding it took reading a diff rather than reading the diary. Pages here
// are React STATE, not URLs, so `location.pathname` cannot answer it either. AppInner keeps this in
// step with the page it is showing, and the boundary reports it.
var __bbotCrashPage = "landing";
function bbotSetCrashPage(p){ __bbotCrashPage = p || "landing"; }

// App-wide error boundary. Without this, a render-time throw anywhere (e.g. an undefined
// variable in one card) unmounts the ENTIRE app to a blank white screen. With it, the crash
// is contained: the user sees a recoverable message and can reload, and the error is logged.
class ErrorBoundary extends Component {
  constructor(props){ super(props); this.state={hasError:false, msg:""}; }
  static getDerivedStateFromError(err){ return {hasError:true, msg:(err&&err.message)||"Unexpected error"}; }
  componentDidCatch(err, info){
    try { console.error("App crash:", err, info); } catch(_){}
    // Best-effort: log to backend audit if available (never block on it).
    try {
      if(typeof fetch==="function" && typeof SUPABASE_URL!=="undefined"){
        bbotAdminLog({action:"client_error", target_id:String((err&&err.message)||"").slice(0,200), timestamp:new Date().toISOString(),
            metadata:{ page: __bbotCrashPage,
                       stack: String((err&&err.stack)||"").slice(0,1500),
                       component: String((info&&info.componentStack)||"").slice(0,800) }}).catch(function(){});
      }
    } catch(_){}
  }
  render(){
    if(this.state.hasError){
      if(this.props.fallback!==undefined) return this.props.fallback;   // compact inline fallback (e.g. one report) instead of blanking the page
      return (
        <div style={{minHeight:"100vh",display:"flex",alignItems:"center",justifyContent:"center",background:"#16243d",padding:24,fontFamily:"Inter,system-ui,sans-serif"}}>
          <div style={{maxWidth:420,textAlign:"center",color:"#fff"}}>
            <div style={{fontSize:42,marginBottom:12}}>⚠️</div>
            <div style={{fontSize:20,fontWeight:700,marginBottom:8}}>Something went wrong</div>
            <div style={{fontSize:14,color:"rgba(255,255,255,.7)",lineHeight:1.6,marginBottom:20}}>The page hit an unexpected error. Reloading usually fixes it. If it keeps happening, let us know at 643sportsmgmt@gmail.com.</div>
            <button onClick={function(){ try{ window.location.reload(); }catch(_){} }} style={{background:"#2970b8",color:"#fff",border:"none",padding:"11px 22px",borderRadius:10,fontSize:14,fontWeight:700,cursor:"pointer"}}>Reload</button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default function App(){
  return <ErrorBoundary><AppInner/></ErrorBoundary>;
}

function AppInner(){
  const [page,setPage]=useState("landing");
  // Keep the crash log's idea of "where" in step with what is on screen. A page here is state, not
  // a URL, so without this the boundary can only report the message.
  useEffect(function(){ bbotSetCrashPage(page); }, [page]);
  const [authMode,setAuthMode]=useState("login");
  const [cu,setCu]=useState(null);
  // THE ONE PLACE THE DOWNLOAD EXEMPTION IS DECIDED. bbotVideoGuard reads this; nothing else does.
  // Kept here rather than threaded as a prop because eleven of the twenty-one video surfaces never
  // receive the current user, and a prop missed on one of them is a leak nobody would notice.
  //
  // Written during render, not in an effect: effects run AFTER children have rendered, so on the
  // first paint every video would read a stale flag. That direction is safe for a visitor (they
  // get the guard either way) but wrong for an admin, who would lose their download button until
  // something unrelated re-rendered. App's body runs before its children, so this is correct on
  // the first paint and on every change of `cu`.
  if(typeof window!=="undefined") window.__bbotIsAdmin = bbotIsAdmin(cu);
  // A RECOVERY LINK MUST LAND SOMEWHERE. Without this the email's redirect drops the user on the
  // landing page with the token still in the hash and no way to use it.
  useEffect(function(){
    if(typeof window==="undefined") return;
    if(bbotRecoveryToken()){ setAuthMode("recovery"); go("auth"); }
  }, []);
  // RELOAD THE ROSTER ONCE A SESSION EXISTS -- INLINE, not via a window global.
  //
  // /roster needs a signed-in caller and the bootstrap load runs BEFORE anyone signs in, so the
  // first call is refused and `users` stays empty: 0 PLAYERS, 0 PENDING, 0 APPROVED on a dashboard
  // that should read 11/0/9. Doing the fetch here rather than calling window.__bbotLoadRoster means
  // it cannot silently do nothing because the global was never assigned on some boot path.
  useEffect(function(){
    if(!(cu && cu.id)) return;
    fetch(BACKEND_URL+"/roster",{headers:bbotAdminHeaders()})
      .then(function(r){ return r.ok?r.json():{users:[]}; })
      .then(function(j){
        var rows=(j&&j.users)||[];
        if(rows.length) setUsers(rows.map(mapUserRow));
      })
      .catch(function(err){ try{ console.error("roster reload FAILED:", err&&err.message); }catch(_){} });
  }, [cu && cu.id]);
  const [publicShareToken,setPublicShareToken]=useState(function(){
    if(typeof window!=="undefined") {
      // Check hash on mount: #share/<token>
      var h = window.location.hash || "";
      // Team invite: #join/<coachId> — remember it so signup can tag the player to this coach.
      var j = h.match(/^#join\/(.+)$/);
      if(j){ try{ window.__bbotInviteCoachId = decodeURIComponent(j[1]); }catch(e){ window.__bbotInviteCoachId = j[1]; } }
      // EVENT LINK: #event/<id> — the QR-code target. Stashed the same way the coach invite is,
      // because the journey is the same shape: a stranger arrives holding one fact, creates an
      // account, and that fact has to survive the signup to be acted on afterwards. Without the
      // stash the player lands on a generic home screen and has to find the event again, which is
      // the "flow fluidly" requirement failing at the last step.
      var evm = h.match(/^#event\/([^/?]+)/);
      if(evm){ try{ window.__bbotPendingEventId = decodeURIComponent(evm[1]); }catch(e){ window.__bbotPendingEventId = evm[1]; } }
      // SESSION REPORT LINK: #recap/<id> — the shareable target for a published report.
      var m = h.match(/^#share\/(.+)$/);
      if(m) return m[1];
      if(window.__bbotPendingShareToken) return window.__bbotPendingShareToken;
    }
    return null;
  });
  // WHICH EVENT THIS VISITOR ARRIVED FOR. Separate from the stash on `window`: the stash survives
  // the signup, this drives what is on screen right now. Both are needed -- one is memory, the
  // other is the view.
  const [publicEventId,setPublicEventId]=useState(function(){
    if(typeof window==="undefined") return null;
    var m=(window.location.hash||"").match(/^#event\/([^/?]+)/);
    return m?decodeURIComponent(m[1]):null;
  });
  const [publicRecapId,setPublicRecapId]=useState(function(){
    if(typeof window==="undefined") return null;
    var r=bbotReadShareRoute();
    return (r && r.kind==="recap") ? r.id : null;
  });
  // WHERE A SHARED CLIP LANDS. /s/clip/<id> answers the crawler, then sends the person here.
  const [publicClipId,setPublicClipId]=useState(function(){
    if(typeof window==="undefined") return null;
    var r=bbotReadShareRoute();
    return (r && r.kind==="clip") ? r.id : null;
  });
  // The public player preview. Reached by a visitor clicking a name anywhere on a public page.
  const [publicPlayerId,setPublicPlayerId]=useState(function(){
    if(typeof window==="undefined") return null;
    var r=bbotReadShareRoute();
    return (r && r.kind==="player") ? r.id : null;
  });
  // ON ARRIVAL, NOT JUST ON CHANGE. A reader coming from a shared link reaches the app through
  // the backend's redirect, which lands them on the fragment -- that is an initial load, and no
  // hashchange fires for it. Without this the first page a shared link opens is the one page
  // whose address cannot be shared onward.
  useEffect(function(){
    if(publicRecapId) bbotSyncShareUrl("recap", publicRecapId);
    else if(publicClipId) bbotSyncShareUrl("clip", publicClipId);
    else if(publicPlayerId) bbotSyncShareUrl("player", publicPlayerId);
  }, [publicRecapId, publicClipId, publicPlayerId]);
  // The event whose registration modal is open from the public page. Held here rather than inside
  // PublicEventView so the modal survives that component re-fetching the event after a write.
  const [eventToRegister,setEventToRegister]=useState(null);
  // React to hash changes (e.g. user pastes a new share link)
  useEffect(function(){
    if(typeof window==="undefined") return;
    function onHash(){
      var h = window.location.hash || "";
      var m = h.match(/^#share\/(.+)$/);
      if(m) setPublicShareToken(m[1]);
      else setPublicShareToken(null);
      var e = h.match(/^#event\/([^/?]+)/);
      if(e){
        var id=decodeURIComponent(e[1]);
        setPublicEventId(id);
        window.__bbotPendingEventId=id;
      } else setPublicEventId(null);
      var sr = bbotReadShareRoute();
      setPublicRecapId(sr && sr.kind==="recap" ? sr.id : null);
      setPublicClipId(sr && sr.kind==="clip" ? sr.id : null);
      setPublicPlayerId(sr && sr.kind==="player" ? sr.id : null);
      // Swap the fragment for the shareable path the moment one of these opens, so the address
      // bar holds a URL that previews. See bbotSyncShareUrl.
      if(sr) bbotSyncShareUrl(sr.kind, sr.id);
    }
    window.addEventListener("hashchange", onHash);
    // The address can now change WITHOUT the fragment changing -- replaceState rewrites the path
    // -- so a Back or Forward across one of those fires popstate and no hashchange at all.
    window.addEventListener("popstate", onHash);
    return function(){
      window.removeEventListener("hashchange", onHash);
      window.removeEventListener("popstate", onHash);
    };
  }, []);
  // PRODUCTION: all collections start EMPTY. No demo/seed records are ever shown.
  // Real data is loaded from Supabase on mount (users, scoutReports, metrics from
  // bbot_measurements, blog templates) and built up by real session activity (feed).
  const [users,setUsers]=useState([]);
  const [metrics,setMetrics]=useState({});
  const [reviews,setReviews]=useState({});
  const [blogs,setBlogs]=useState([]);
  const [feed,setFeed]=useState([]);
  const [vp,setVp]=useState(null);
  const [scoutReports,setScoutReports]=useState([]);
  const [unlockedReports,setUnlockedReports]=useState(function(){try{return JSON.parse(localStorage.getItem("bbot_unlocked")||"{}");}catch(e){return{};}});
const [fields,setFields]=useState([]);
const [battedBalls,setBattedBalls]=useState([]);
const [recaps,setRecaps]=useState([]);
const [lineups,setLineups]=useState([]);
const [highlights,setHighlights]=useState([]);
  if(typeof window !== "undefined"){ window.__approveReport = approveReport; window.__rejectReport = rejectReport; window.__deleteReport = deleteReport; }
// One-time loader: pull persisted highlights + battedBalls + reports from Supabase
if(typeof window !== "undefined" && !window.__bbotDataBootstrapped){
  window.__bbotDataBootstrapped = true;
  sbSelect("bbot_highlights","?select=*&order=created_at.desc&limit=500").then(function(rows){
    if(!rows||!rows.length) return;
    var mapped = rows.map(function(h){return{
      id:h.id, reportId:h.report_id, playerId:h.player_id, playerJersey:h.player_jersey,
      videoUrl:h.video_url, startSec:h.start_sec, endSec:h.end_sec, actionType:h.action_type,
      label:h.label, metricValue:h.metric_value, metricUnit:h.metric_unit, confidence:h.confidence,
      approved:h.approved
    };});
    setHighlights(mapped);
  }).catch(function(){});
  sbSelect("bbot_batted_balls","?select=*&order=created_at.desc&limit=1000").then(function(rows){
    if(!rows||!rows.length) return;
    var normType=function(t){var s=String(t||"").toLowerCase().replace(/[\s_]/g,"");return s==="groundball"?"Ground Ball":s==="linedrive"?"Line Drive":s==="flyball"?"Fly Ball":s==="homerun"?"Home Run":(t||"");};
    var normDir=function(d){var s=String(d||"").toLowerCase().replace(/[\s_]/g,"");return s==="pull"?"Pull":s==="middle"?"Middle":s==="oppo"||s==="opposite"?"Oppo":(d||"");};
    var mapped = rows.map(function(b){return{
      id:b.id, reportId:b.report_id, playerId:b.player_id, playerJersey:b.player_jersey,
      type:normType(b.type), direction:normDir(b.direction), distance:b.distance,
      exitVelo:(b.exit_velo!=null?Number(b.exit_velo):null),
      confidence:b.confidence
    };});
    setBattedBalls(mapped);
    if(typeof window!=="undefined"){window.__bbotBattedBalls=mapped;}
  }).catch(function(){});
  sbSelect("bbot_pitches","?select=*&order=created_at.desc&limit=2000").then(function(rows){
    if(!rows||!rows.length) return;
    var mapped = rows.map(function(p){return{
      id:p.id, reportId:p.report_id, playerId:p.player_id, playerJersey:p.player_jersey,
      pitchType:p.pitch_type, velocityMph:p.velocity_mph,
      plateX:p.plate_x, plateZ:p.plate_z, result:p.result,
      batterSide:p.batter_side, count:p.count, confidence:p.confidence
    };});
    if(typeof window!=="undefined"){window.__bbotPitches=mapped;}
  }).catch(function(){});
  // TILE METRICS — hydrate auto-logged BBOT measurements back into the `metrics` state
  // so the profile metric tiles persist across reloads (not just in-session).
  sbSelect("bbot_measurements","?select=*&tool_key=eq.tile_metrics&order=session_date.asc&limit=2000").then(function(rows){
    if(!rows||!rows.length) return;
    // Defensive: skip measurements whose parent report was rejected. Measurements get
    // written on approval, but if a report is later rejected, its measurement rows would
    // otherwise still populate the player's metric tiles. setScoutReports may not have
    // resolved yet on first load; we read from the current state via the setter callback
    // so the check uses the freshest report-status data available.
    setScoutReports(function(currentReports){
      var rejected = {};
      (currentReports||[]).forEach(function(rep){
        if(rep && isRejectedEval(rep)) rejected[String(rep.id)] = true;
      });
      setMetrics(function(prev){
        var copy = Object.assign({}, prev);
        rows.forEach(function(r){
          if(r.report_id!=null && rejected[String(r.report_id)]) return; // skip rejected
          var pid = r.player_id;
          if(!pid) return;
        var vals = {};
        try { vals = JSON.parse(r.measured_value||"{}"); } catch(e){ vals = {}; }
        var row = {
          date: r.session_date || (r.created_at||"").slice(0,10),
          exitVelo: vals.exitVelo!=null?Number(vals.exitVelo):null,
          throwVelo: vals.throwVelo!=null?Number(vals.throwVelo):null,
          pitchVelo: vals.pitchVelo!=null?Number(vals.pitchVelo):null,
          dash60: vals.dash60!=null?Number(vals.dash60):null,
          popTime: vals.popTime!=null?Number(vals.popTime):null,
          basis: vals.basis || {},
          notes: "Auto-logged from BBOT evaluation",
          addedBy: "BBOT",
          source: "bbot_eval",
          reportId: r.report_id,
        };
        var arr = (copy[pid] || []).slice();
        var already = arr.some(function(x){return String(x.reportId)===String(r.report_id) && x.source==="bbot_eval";});
        if(!already){ arr.push(row); copy[pid] = arr; }
      });
      return copy;
    });
    return currentReports; // wrapper used only to READ current report statuses; no mutation
    });
  }).catch(function(){});
  // SUPERSEDED REPORTS NEVER REACH THE CLIENT. They were filtered per-view, and one view filtered by
  // author instead of status, so a superseded report appeared in the approval queue beside the report
  // that replaced it -- two reports for one player, contradicting each other on core marks, both
  // looking approvable. Excluding them at the fetch means no view can show one by omission: the only
  // reports the app holds are live ones.
  // ANON READS THE REDUCED VIEW, SIGNED-IN READS THE TABLE.
  //
  // bbot_reports.full_report carries 67 top-level keys on an approved row and the client reads 28.
  // The other 39 are internal machinery -- approvalGatesPassed, complianceStripped, corpusSignature,
  // gradeIntegrity -- and they were being served to anyone who opened the page. bbot_reports_public
  // is the same rows with full_report reduced to what the client actually uses.
  //
  // A signed-in user still reads the table, because admins need every status (a view of approved
  // rows cannot show a pending report to the person whose job is approving it) and the detail the
  // review screens read. The public surface is what needed narrowing, and it is what narrowed.
  (bbotAuthToken()
      ? bbotReports({limit:500})
      : sbSelect("bbot_reports_public","?select=*&order=created_at.desc&limit=500")
   ).then(function(rows){
    if(!rows||!rows.length) return;
    var mapped = rows.map(function(r){
      var full = r.full_report || {};
      if(typeof full === "string"){ try{ full = JSON.parse(full); }catch(e){ full = {}; } }
      return Object.assign({}, full, {
        id: r.id, playerId: r.player_id, date: r.session_date,
        // THE NAME THE ROW ALREADY CARRIES. `bbot_reports_public` denormalises `player_name`
        // precisely so a logged-out reader needs no roster, and this mapper was dropping it --
        // which is why the public activity feed had to join against a roster it cannot read, and
        // discarded every published evaluation when that join came back empty.
        playerName: r.player_name || full.playerName || null,
        created_at: r.created_at || null,
        sessionType: r.session_type, score: r.score, status: r.status,
        videoUrl: r.video_url, summary: r.summary, sections: bbotStripWithheldGrades((Array.isArray(full.sections) && full.sections.length) ? full.sections : (r.sections || []), full),   // prefer full_report (holds admin edits) over the denormalized top-level column; fall back if empty
        reviewRequested: r.review_requested, reviewReason: r.review_reason,
        coachNotes: r.coach_notes, sessionContext: r.session_context,
        reportType: r.report_type || null, fullReport: full,
        reelUrl: r.reel_url || full.reelUrl || null,
        errorMessage: r.error_message || full.error_message || null,
        amountCents: r.amount_cents || 0,
        staffId: r.staff_id || full.staffId || null, staffName: r.staff_name || full.staffName || null,
        objectKey: r.object_key || full.objectKey || null
      });
    });
    setScoutReports(mapped);
  }).catch(function(){});

  // BLOGS, LOADED FROM THEIR OWN ROW. Without this the Blogs page starts empty on every visit no
  // matter what was published, which is what it did before today.
  sbSelect("bbot_site_content","?id=eq."+BBOT_BLOG_ROW+"&select=content&limit=1").then(function(rows){
    var c=(rows&&rows[0]&&rows[0].content)||null;
    if(c && Array.isArray(c.posts)) setBlogs(c.posts);
  }).catch(function(){});

  // Load persisted feed items so the activity feed survives page refresh.
  // Table uses camelCase (userId, type, content, timestamp). Map back to the
  // in-memory shape (text, date, likes, likedBy) the FeedPage already renders.
  sbSelect("feed_items", "?select=*&order=timestamp.desc&limit=500").then(function(rows){
    if(!rows || !rows.length) return;
    var mapped = rows.map(function(r){
      return {
        id: r.id,
        userId: r.userId || r.userid || r.user_id,
        type: r.type,
        text: r.content,
        date: (r.timestamp||"").slice(0,10),
        likes: 0,
        likedBy: []
      };
    });
    setFeed(mapped);
  }).catch(function(){});
  // Game/Session Reports (recaps) — persisted so they survive reload. full_data holds the
  // complete object; we spread it back so the UI gets the exact shape it created.
  sbSelect("bbot_recaps","?select=*&order=created_at.desc&limit=500").then(function(rows){
    if(!Array.isArray(rows)) return;
    var mapped = rows.map(function(r){
      var d = r.full_data; if(typeof d==="string"){ try{ d=JSON.parse(d); }catch(e){ d={}; } }
      return Object.assign({}, d||{}, { id:r.id, status:r.status||(d&&d.status)||"draft" });
    });
    setRecaps(mapped);
  }).catch(function(){ try{ console.warn("bbot_recaps load failed"); }catch(_){} });
  // Lineups — same pattern.
  sbSelect("bbot_lineups","?select=*&order=created_at.desc&limit=500").then(function(rows){
    if(!Array.isArray(rows)) return;
    var mapped = rows.map(function(r){
      var d = r.full_data; if(typeof d==="string"){ try{ d=JSON.parse(d); }catch(e){ d={}; } }
      return Object.assign({}, d||{}, { id:r.id });
    });
    setLineups(mapped);
  }).catch(function(){ try{ console.warn("bbot_lineups load failed"); }catch(_){} });
  // THE ROSTER COMES FROM THE BACKEND NOW (2026-09-02). This was a direct `select=*` on bbot_users
  // with the anon key -- every account's email, readable by anyone who opened the bundle. RLS closed
  // the table; /roster returns the same shape but REDACTED for non-admins (names, jersey, type and
  // the profile fields the UI draws -- no other person's email). Admins still get the full row.
  // AND IT MUST RE-RUN AFTER LOGIN. The old direct query worked anonymously, so loading the roster
  // once on mount was fine. /roster requires a signed-in caller, and this effect runs BEFORE anyone
  // signs in -- so the first call 401s, `users` stays empty, and every screen keyed on it (admin,
  // directory, approvals) comes up blank with no error. Exposed on the window so the auth effect can
  // call it again once a token exists.
  window.__bbotLoadRoster = function(){
  // DO NOT ASK WHEN THERE IS DEMONSTRABLY NOBODY TO ASK AS. /roster requires a signed-in caller, so
  // on a logged-out visit this fired and 401'd -- eight refused calls and the only console error on
  // a cold public visit, every time, for nothing.
  //
  // THE GUARD IS THE TOKEN, NOT `cu`. A returning reader arrives with a token already in storage
  // and `cu` not yet resolved, so gating on `cu` would delay the roster for exactly the people
  // entitled to it -- which is the bug the comment above this function describes. A token is the
  // question the server is going to ask anyway; with none, the answer is known before the round
  // trip. The auth effect still calls this again once a session exists, so nothing is lost.
  if(!bbotAuthToken()){
    // A VISITOR STILL NEEDS A PLAYER LIST (Luis, 2026-10-08: the public tier). Without one,
    // `users` is empty for anyone not signed in -- so the public leaderboards render blank, and
    // a standout named in a public session report cannot be matched to a player at all.
    //
    // It comes from bbot_players_public, which is name, position and graduation year, and which
    // EXCLUDES COACHES at the source. So the public list is the ruled tier by construction: it
    // cannot carry an email or a date of birth because the view does not select one, and it
    // cannot leak a coach because the view has a WHERE clause the client cannot override.
    // The /roster call above stays exactly as it was for people who are signed in.
    fetch(SUPABASE_URL+"/rest/v1/bbot_players_public?select=*&limit=1000",{headers:sbHeaders()})
      .then(function(r){ return r.ok?r.json():[]; })
      .then(function(rows){
        if(!Array.isArray(rows)||!rows.length) return;
        setUsers(rows.map(function(u){
          return {id:u.id, firstName:u.first_name||"", lastName:u.last_name||"",
                  position:u.position||"", position2:u.position2||"",
                  gradYear:u.grad_year||"", type:"player", _publicOnly:true};
        }));
      })
      .catch(function(){});
    return;
  }
  fetch(BACKEND_URL+"/roster",{headers:bbotAdminHeaders()})
    .then(function(r){ return r.ok?r.json():{users:[]}; })
    .then(function(j){ return (j&&j.users)||[]; })
    .then(function(rows){
    if(!rows||!rows.length){
      try{ console.warn("roster load returned 0 rows (not signed in, or backend unavailable)"); }catch(_){}
      return;
    }
    // Convert flat columns back into the rich profile object the app expects
    // gradYear drives messaging eligibility; jersey_number is what mass-segmentation matches on —
    // both handled in the shared mapper so login and this loader stay identical.
    var mapped = rows.map(mapUserRow);
    // PRODUCTION: the DB (bbot_users) is the sole source of truth for accounts. State
    // starts empty and is populated entirely from here, so no demo records ever appear.
    setUsers(mapped);
  }).catch(function(err){
    // CRITICAL load. Swallowing this silently is what makes the directory/approvals show
    // zero with no explanation. Log it loudly so the real cause (RLS, auth, network) is visible.
    try{ console.error("roster load FAILED:", err && err.message); }catch(_){}
  });
  };
  window.__bbotLoadRoster();
}

// Public share token check: supports #share/<token> and clean #p/<slug>~<token>
if(typeof window !== "undefined" && !window.__bbotShareChecked){
  window.__bbotShareChecked = true;
  var h = (window.location.hash||"").replace(/^#/,"");
  if(h.indexOf("share/")===0){
    window.__bbotPendingShareToken = h.replace("share/","");
  } else if(h.indexOf("p/")===0){
    // Clean URL format: #p/firstname-lastname-class-2027~tok_abc123
    // Token is after the tilde for unambiguous parsing
    var slugAndTok = h.replace("p/","");
    var tildeIdx = slugAndTok.indexOf("~");
    if(tildeIdx > 0){
      window.__bbotPendingShareToken = slugAndTok.substring(tildeIdx+1);
    }
  }
}
  const [coachUpdates,setCoachUpdates]=useState([]);
  const [siteContent,setSiteContent]=useState({
    // ABOUT, ALIGNED TO WHAT THE PRODUCT ACTUALLY DOES (refined by Luis 2026-08-19). The
    // differentiator is not that BBOT measures more; it is that every mark carries a receipt or is
    // disclosed as absent. Angle / rotation / separation and inactive percentile language is gone:
    // none of it is extractable from one camera, and copy that promises it is a claim the report
    // cannot honour.
    aboutHero:"Most evaluations ask you to trust an opinion. BBOT's are measured — and every report says exactly what it's based on, including what couldn't be measured. Measured with a receipt, or disclosed as absent. Never fabricated.",
    aboutP1:"Every player gets one profile: measured results, session history, video, and the evaluations built from them — in a single page a coach can open and trust.",
    aboutP2:"Staff log every session — recaps, video, and performance data in one place, creating a full development record over time.",
    aboutP3:"Every 643 evaluation is built on what BBOT could actually measure. What it reports: device-verified velocities read from a radar display visible in the footage, at any frame rate; run and pop times that name who hand-timed them and against what; the count of reps certified to be this athlete; and relative movement sampling — the shape of effort across a session, stated as a shape and never as a speed. What it will not report: any angle, rotation or separation, and any velocity a device did not read. Every reading is tied to the action that produced it — a throw is a throw, a swing is a swing — and when a session supports nothing, the report says so.",
    aboutP4:"College coaches and recruiters subscribe to players they follow, receiving real-time notifications when new video or evaluations are posted.",
    landingTagline:"BBOT",
    landingSub:"Measured data and clean, verified results — one objective measuring stick for every player, at every level.",
    landingHeadline:"A complete player evaluation from a single session.",
    // RADAR-BACKED, SAID ON THE FRONT PAGE (ruled by Luis 2026-08-19). The product's credible
    // measurements come off a radar reading visible in the footage — that is what "device-verified"
    // has meant since the receipt work, and the front page now says which footage produces it
    // rather than leaving a customer to find out after uploading.
    landingSubtext:"Upload a radar-backed session. Get back device-verified measurements, clean measured results, and a recruiter-ready report. " + BBOT_PRICE_LABEL + " per session evaluation.",
    whatBbotDelivers:"WHAT BBOT DELIVERS",
    pricingSessionNote:"One session evaluation — full report plus highlight clips.",
    // The cumulative player evaluation is admin-triggered and is not sold on the landing page;
    // the note is kept as editable copy so it can return when that product is offered publicly.
    pricingPlayerNote:"",
    footerTagline:"Objective baseball evaluation for every player.",
    contactEmail:"643sportsmgmt@gmail.com",
  });

  // PP6 — site-wide content is persisted to bbot_site_content (single row id=1).
  // Load on mount so admin edits survive reload and show for all visitors.
  useEffect(function(){
    sbSelect("bbot_site_content","?id=eq.1&select=content").then(function(rows){
      if(rows && rows[0] && rows[0].content && typeof rows[0].content==="object"){
        setSiteContent(function(prev){return Object.assign({}, prev, rows[0].content);});
      }
    }).catch(function(){});
  }, []);

  // SESSION RESTORE — if a saved Supabase session exists, keep the user logged in across
  // page refreshes. We refresh the access token first (it expires ~hourly), then match the
  // session's email to a loaded profile and set them as the current user.
  useEffect(function(){
    if(typeof window==="undefined") return;
    var s = bbotLoadSession();
    if(!(s && s.refresh_token)) return;
    // Refresh immediately on load (covers a token that expired while the tab was closed),
    // then every 45 min (Supabase access tokens live ~60 min), and whenever the tab regains
    // focus after being idle. Without this, any backend call after ~1h fails with
    // "Invalid or expired session" — which previously broke uploads/evals mid-session.
    bbotRefreshSession();
    var iv = setInterval(function(){ bbotRefreshSession(); }, 45*60*1000);
    var onFocus = function(){
      var last = window.__bbotLastRefresh || 0;
      if(Date.now() - last > 10*60*1000){ window.__bbotLastRefresh = Date.now(); bbotRefreshSession(); }
    };
    window.addEventListener("focus", onFocus);
    window.__bbotLastRefresh = Date.now();
    return function(){ clearInterval(iv); window.removeEventListener("focus", onFocus); };
  }, []);
  useEffect(function(){
    // A SYNTHETIC USER IS UPGRADED THE MOMENT THE REAL ROW ARRIVES. This began `if(cu) return;`,
    // which is right for a real profile and wrong for the placeholder sign-in builds when the
    // row lookup comes back empty. That placeholder has no staffRole, no title, no approval
    // flags — and it persisted for the entire session, so an admin who hit one slow lookup
    // stayed a stub until he signed out. Now only a REAL cu short-circuits; a synthetic one
    // keeps waiting for its row. [[absent-capability-reads-as-legitimate-absence]]
    if(cu && !cu._synthetic) return;     // already signed in with a real profile
    var sess = bbotLoadSession();
    if(!sess || !sess.user || !sess.user.email) return;
    if(!users || !users.length) return;  // wait until profiles are available
    var email = String(sess.user.email).toLowerCase();
    var u = users.find(function(x){ return (x.email||"").toLowerCase()===email; });
    if(u) {
      setCu(u);
    } else if(cu && cu._synthetic) {
      // The row still is not here. Keep the placeholder rather than signing him out — the
      // branch below exists for a session whose profile was DELETED, which is a different
      // thing from one that has not loaded yet.
      return;
    } else {
      // Session exists but the matching profile is gone (e.g. admin deleted the user
      // while a stale session was cached in this browser). Clear the bad session so
      // the user lands on a clean signed-out state instead of a weird half-logged-in
      // limbo where auth is set but the app shows nothing.
      try { bbotSaveSession(null); } catch(e){}
    }
  }, [users]);

  function saveSiteContent(next){
    setSiteContent(next);
    return sbUpsert("bbot_site_content", {id:1, content:next, updated_at:new Date().toISOString()});
  }

  function approveReport(reportIdOrObj) {
    // Accept either a report id or a full report object — call sites pass both.
    var reportId = (reportIdOrObj && typeof reportIdOrObj === "object") ? reportIdOrObj.id : reportIdOrObj;
    // Double-click guard: if this report is already approved in our state, do nothing.
    // Without this, an admin rapidly clicking Approve would double-fire measurement writes,
    // duplicate notifications, and burn token budget.
    var existing = (scoutReports||[]).find(function(r){return String(r.id)===String(reportId);});
    if(existing && isLiveEval(existing)){
      notify && notify("Already approved");
      return;
    }
    // COMPLETENESS GATE (hard-block, covers single + bulk approve): never release an INCOMPLETE report
    // (pose/mechanics did not run — no mechanics, box-plots, or delivery floor). Re-eval with pose first.
    if(existing && (existing.mechanicsIncomplete || (existing.fullReport && existing.fullReport.mechanicsIncomplete))){
      notify && notify("Cannot approve — report is INCOMPLETE (mechanics did not run). Re-eval with pose before releasing.","error");
      return;
    }
    // PROSE-AUDIT GATE (hard-block, covers single + bulk approve). A report that failed the
    // prose-structure audit must not be approvable at all — the point of moving those checks into the
    // eval path was to make admin approval the SECOND gate, not the only one. The exact findings are
    // surfaced so the reason is never a mystery.
    var _pa = (existing && (existing.proseAuditFindings ||
                            (existing.fullReport && existing.fullReport.proseAuditFindings))) || [];
    var _failedAudit = existing && (isFailedAudit(existing) || existing.failedAudit ||
                                    (existing.fullReport && existing.fullReport.failedAudit));
    if(_failedAudit || (_pa && _pa.length)){
      var _why = (_pa || []).map(function(f){ return f.check + (f.section ? " ("+f.section+")" : ""); }).join(", ");
      notify && notify("Cannot approve — report FAILED the prose audit" + (_why ? ": " + _why : "") +
                       ". Re-run the evaluation after the finding is resolved.","error");
      return;
    }
    setScoutReports(function(prev) {
      var updated = prev.map(function(r) {
        return String(r.id) === String(reportId) ? Object.assign({}, r, {status:"approved"}) : r;
      });
      var report = updated.find(function(r){return String(r.id)===String(reportId);});
      if(report){
        var player = users.find(function(u){return String(u.id)===String(report.playerId);});
        if(player){
          var releaseNote = player.firstName+" "+player.lastName+" received a new BBOT evaluation report";
          var subscribedCoachIds = (coachUpdates||[]).filter(function(s){return String(s.playerId)===String(player.id);}).map(function(s){return String(s.coachId);});
          subscribedCoachIds.forEach(function(cid){
            pushFeed(cid,"bbot",releaseNote);
          });
          if(subscribedCoachIds.length){
            var cidSet={}; subscribedCoachIds.forEach(function(c){cidSet[c]=true;});
            setUsers(function(all){return all.map(function(u){
              if(!cidSet[String(u.id)]) return u;
              var n={id:Date.now()+Math.floor(Math.random()*1000),type:"eval_released",text:"New evaluation available for "+player.firstName+" "+player.lastName,date:new Date().toISOString().slice(0,10),read:false};
              var upd=Object.assign({},u,{notifications:[n].concat(u.notifications||[])});
              persistUser(upd).catch(function(e){ try{ console.warn("profile save failed:", e && e.message); }catch(_){} if(window.__bbotNotify) window.__bbotNotify("Your change didn't save — please try again.","error"); });
              return upd;
            });});
          }
          // #3 MILESTONES — celebrate real, earned progress to the player.
          (function(){
            var today=new Date().toISOString().slice(0,10);
            var playerEvals=updated.filter(function(r){return String(r.playerId)===String(player.id) && (isLiveEval(r));});
            var count=playerEvals.length;
            var msgs=[];
            if(count===1) msgs.push("🎉 First evaluation complete! Your verified profile is live.");
            else if(count===2) msgs.push("📈 2 sessions logged — 643 can now compile a cumulative evaluation showing your progression across sessions.");
            else if(count===3) msgs.push("🔥 3 sessions logged — your progression timeline is building.");
            else if(count===5) msgs.push("💪 5 evaluations! Coaches can see real, tracked development.");
            else if(count===10) msgs.push("🏆 10 sessions logged — that's serious commitment.");
            // grade-threshold crossings on this report
            var graded=(report.sections||[]).filter(function(s){return typeof s.grade==="number" && s.grade>0;});
            var topTool=graded.sort(function(a,b){return b.grade-a.grade;})[0];
            if(topTool && topTool.grade>=60) msgs.push("⭐ Plus grade earned: "+cleanToolLabel(topTool.label)+" graded "+topTool.grade+".");
            // average-grade improvement vs previous eval
            if(count>=2){
              var byDate=playerEvals.slice().sort(function(a,b){return String(a.date||"").localeCompare(String(b.date||""));});
              function avgOf(r){var g=(r.sections||[]).filter(function(s){return typeof s.grade==="number"&&s.grade>0;});return g.length?g.reduce(function(x,s){return x+s.grade;},0)/g.length:null;}
              var prevA=avgOf(byDate[byDate.length-2]), curA=avgOf(byDate[byDate.length-1]);
              if(prevA!=null && curA!=null && curA-prevA>=2) msgs.push("📈 Trending up — your average grade rose "+(curA-prevA).toFixed(1)+" since last session.");
            }
            if(msgs.length){
              setUsers(function(all){return all.map(function(u){
                if(String(u.id)!==String(player.id)) return u;
                var notifs=msgs.map(function(m,i){return {id:Date.now()+5000+i,type:"milestone",text:m,date:today,read:false};});
                var upd=Object.assign({},u,{notifications:notifs.concat(u.notifications||[])});
                persistUser(upd).catch(function(e){ try{ console.warn("profile save failed:", e && e.message); }catch(_){} if(window.__bbotNotify) window.__bbotNotify("Your change didn't save — please try again.","error"); });
                return upd;
              });});
            }
          })();
          // MEASUREMENTS LOGGING — every Confirmed/Measured tool value becomes a data point
          // for BBOT's own age-percentile repository (future benchmark calibration)
          try {
            var ageGroup = (function(){
              var age = seasonAge(player, report.sessionDate);
              if(age==null) return "unknown";
              if(age<=13) return "12U-13U";
              if(age===14) return "14U"; if(age===15) return "15U";
              if(age===16) return "16U"; if(age===17) return "17U";
              if(age===18) return "18U"; return "19+";
            })();
            var measurementRows = [];
            (report.sections||[]).forEach(function(s){
              if(s.confidence==="Confirmed"||s.confidence==="Measured"){
                measurementRows.push({
                  report_id: reportId,
                  player_id: String(player.id),
                  age_group: ageGroup,
                  position: player.position||null,
                  tool_key: s.key,
                  tool_label: s.label,
                  // NEVER THE GRADE (zero-grades law). `report.sections` arrives stripped, so this
                  // reads null today -- stating it outright means a future un-stripped caller
                  // cannot quietly re-seed the boards with judgements.
                  grade: null,
                  measured_value: s.measuredValue||null,
                  confidence: s.confidence,
                  session_type: report.sessionType||null,
                  session_date: report.sessionDate||null,
                });
              }
            });
            if(measurementRows.length){
              // RLS-locked table → write via backend (service key). _beWrite logs failures.
              measurementsLog(measurementRows).catch(function(){});
            }
          } catch(e) { /* never block approval on measurement logging */ }

          // METRIC TILES — pull BBOT's confirmed numeric measurements into the profile
          // metric tiles (exitVelo, throwVelo, dash60, popTime, pitchVelo).
          // Source: the structured measuredValues object the eval emits. Numbers only.
          try {
            var mv = report.measuredValues || (report.full_report && report.full_report.measuredValues) || null;
            var mvb = report.measuredValuesBasis || (report.full_report && report.full_report.measuredValuesBasis) || {};
            if(mv && typeof mv === "object"){
              var num = function(v){ var n = (v==null?null:Number(v)); return (n!=null && !isNaN(n) && n>0) ? n : null; };
              var ev = num(mv.exitVeloPeak) || num(mv.exitVeloAvg);
              var evBasis = mvb.exitVeloPeak || mvb.exitVeloAvg || null;
              var row = {
                date: (report.sessionDate || new Date().toISOString().slice(0,10)),
                exitVelo: ev,
                throwVelo: num(mv.throwVelo),
                pitchVelo: num(mv.pitchVeloPeak),
                h2f: num(mv.h2f),
                dash60: num(mv.dash60),
                popTime: num(mv.popTime),
                basis: {exitVelo: evBasis, throwVelo: mvb.throwVelo||null, pitchVelo: mvb.pitchVeloPeak||null, h2f: mvb.h2f||null, dash60: mvb.dash60||null, popTime: mvb.popTime||null},
                notes: "Auto-logged from BBOT evaluation",
                addedBy: "BBOT",
                source: "bbot_eval",
                reportId: reportId,
              };
              // Only add a row if at least one real measurement is present
              var hasAny = row.exitVelo || row.throwVelo || row.pitchVelo || row.h2f || row.dash60 || row.popTime;
              if(hasAny){
                setMetrics(function(prev){
                  var copy = Object.assign({}, prev);
                  var arr = (copy[player.id] || []).slice();
                  // Avoid duplicate auto-log for the same report
                  var already = arr.some(function(x){return x.reportId===reportId && x.source==="bbot_eval";});
                  if(!already){ arr.push(row); copy[player.id] = arr; }
                  return copy;
                });
                // Persist to bbot_measurements_tiles-style storage? Tiles read from `metrics` state,
                // which hydrates from bbot_measurements on load — write a tile row there too.
                measurementsLog([{
                    report_id: reportId,
                    player_id: String(player.id),
                    age_group: ageGroup,
                    position: player.position||null,
                    tool_key: "tile_metrics",
                    tool_label: "Tile Metrics",
                    measured_value: JSON.stringify({exitVelo:row.exitVelo,throwVelo:row.throwVelo,pitchVelo:row.pitchVelo,dash60:row.dash60,popTime:row.popTime,basis:row.basis}),
                    confidence: "Confirmed",
                    session_type: report.sessionType||null,
                    session_date: row.date,
                  }]).catch(function(){});
              }
            }
          } catch(e) { /* never block approval on tile population */ }

          // POSE-METRICS HISTORY (#3): log measured mechanics to bbot_measurements so trends
          // accumulate across sessions, keyed by the same metric keys as the grading rubric.
          // Logs BOTH (a) the representative delivery's per-rep metrics AND (b) SESSION-LEVEL
          // cross-pitch aggregates (e.g. release_drift — consistency across pitches), which live
          // on poseMetrics TOP-LEVEL, not in a single delivery. grade=null until a rubric is live.
          // Additive + fallback-safe — no pose / metric not yet computed => nothing written.
          try {
            var pm2 = report.poseMetrics || (report.full_report && report.full_report.poseMetrics) || null;
            if(pm2){
              var CONF_MAP = {arm_slot_deg:"arm_slot",release_height_pct:"release_height",release_height_inches:"release_height",stride_pct_height:"stride",stride_inches:"stride",hip_shoulder_separation_deg:"hip_shoulder_separation",max_hip_shoulder_separation_deg:"hip_shoulder_separation",peak_hand_speed_px_s:"hand_speed",hand_speed_mph:"hand_speed",head_movement_pct:"head_movement",head_movement_inches:"head_movement",weight_shift_pct:"weight_shift",weight_shift_inches:"weight_shift",torso_tilt_deg_at_contact:"torso_tilt",peak_shoulder_turn_deg_s:"shoulder_turn",foot_plant_to_contact_s:"tempo"};
              var poseRows = [];
              var pushMetric = function(k, v, confLevel){
                if(v==null || isNaN(Number(v))) return;
                poseRows.push({
                  report_id: reportId, player_id: String(player.id), age_group: ageGroup,
                  position: player.position||null, tool_key: k, tool_label: k, grade: null,
                  measured_value: String(v), confidence: confLevel || "Pose-measured",
                  session_type: report.sessionType||null, session_date: report.sessionDate||null,
                });
              };
              // (a) per-rep metrics from the representative (rank-1) delivery. PLAYER-TYPE-AWARE:
              // only the keys for this report's type are attempted (backend already emits only
              // those; this keeps intent explicit so a wrong-type key can't be logged).
              var d0 = pm2.deliveries && pm2.deliveries[0];
              if(d0){
                var conf2 = d0.confidence || {};
                var _isHit = String(pm2.kind||"").toLowerCase().indexOf("hit")===0;
                var _shared = ["stride_pct_height","stride_inches","hip_shoulder_separation_deg","max_hip_shoulder_separation_deg"];
                var _pitch = ["arm_slot_deg","release_height_pct","release_height_inches"];
                var _hit = ["peak_hand_speed_px_s","hand_speed_mph","head_movement_pct","head_movement_inches","weight_shift_pct","weight_shift_inches","torso_tilt_deg_at_contact","peak_shoulder_turn_deg_s","foot_plant_to_contact_s"];
                _shared.concat(_isHit?_hit:_pitch).forEach(function(k){
                  pushMetric(k, d0[k], conf2[CONF_MAP[k]]);
                });
              }
              // (b) session-level aggregates — pitcher: release_drift; hitter: swing_tempo (+ the
              // reserved contact_rate/zone_swing_rate, null until Phase 2). Type-gated.
              var _isHit2 = String(pm2.kind||"").toLowerCase().indexOf("hit")===0;
              (_isHit2?["swing_tempo","contact_rate","zone_swing_rate"]:["release_drift"]).forEach(function(k){
                pushMetric(k, pm2[k], null);
              });
              if(poseRows.length){
                measurementsLog(poseRows).catch(function(){});
              }
            }
          } catch(e) { /* never block approval on pose-metric logging */ }
        }
      }
      return updated;
    });
    // Persist to Supabase. The status PATCH is the critical write — if it fails
    // (RLS deny, network blip, schema issue) we revert the optimistic local
    // change and tell the admin so they can retry. Without this, admin would
    // see "approved" in the UI while the DB stayed on draft — players never
    // get their report.
    // 409 IS READ HERE, SO IT IS DECLARED HERE. Without this the helper throws and the branch
    // below never runs.
    reportPatch(reportId, {status:STATUS.APPROVED}, {_pass:[409]}).then(function(r){
      // ENFORCEMENT GATE: the backend blocks approval (409) when the report has unresolved credibility
      // flags (unsourced velocity, arm-slot asserted while the measurement was withheld, etc.). Surface
      // them and let the admin CONSCIOUSLY override — nothing ships wrong by accident.
      if(r.status===409){
        return r.json().then(function(j){
          var d=(j&&j.detail)||j||{};
          if(d && d.error==="credibility_review_required"){
            setScoutReports(function(prev){ return prev.map(function(x){ return String(x.id)===String(reportId)?Object.assign({},x,{status: existing?existing.status:"draft"}):x; }); });
            var vs=d.enforcementReview||[];
            var lines=vs.map(function(v){ return "• ["+(v.loc||"?")+"] "+(v.why||v.kind||"")+(v.token?(" ("+v.token+")"):""); });
            var msg="BBOT flagged "+vs.length+" credibility issue"+(vs.length===1?"":"s")+" on this report:\n\n"+lines.join("\n")+"\n\nFix them in the report, or approve anyway (override)?";
            if(typeof window!=="undefined" && window.confirm(msg)){
              return reportPatch(reportId, {status:STATUS.APPROVED}, {overrideReview:true}).then(function(r2){
                if(!r2.ok) return r2.text().then(function(t){ throw new Error("HTTP "+r2.status+": "+(t||"").slice(0,120)); });
                setScoutReports(function(prev){ return prev.map(function(x){ return String(x.id)===String(reportId)?Object.assign({},x,{status:"approved"}):x; }); });
                notify && notify("Report approved (credibility flags overridden).","success");
              });
            }
            notify && notify("Approval held — resolve the flagged claims first.","error");
            return;
          }
          throw new Error("HTTP 409");
        });
      }
      if(!r.ok) return r.text().then(function(t){ throw new Error("HTTP "+r.status+": "+(t||"").slice(0,120)); });
      // ONE-CLICK PUBLISH: approving the report also approves ITS pending clips (rinsed video + skeleton),
      // so "Approve & Release" publishes everything in one action — no separate clip-approval step.
      // Matched by the report's master video + player; safe no-op if none exist yet. Fully fallback-safe.
      try {
        var _ok = existing && (existing.objectKey || existing.object_key);
        var _pid = existing && existing.playerId;
        if(_ok && _pid){
          sbSelect("bbot_clips","?master_object_key=eq."+encodeURIComponent(_ok)+"&player_id=eq."+encodeURIComponent(_pid)+"&status=eq.pending_approval&select=id")
            .then(function(cl){
              var ids=(cl||[]).map(function(c){return c.id;}).filter(Boolean);
              if(ids.length){
                fetch(BACKEND_URL+"/approve-clips",{method:"POST",headers:bbotAdminHeaders(),body:JSON.stringify({clipIds:ids,approved:true})})
                  .then(function(){ notify && notify("Report + "+ids.length+" clip"+(ids.length===1?"":"s")+" published to the profile"); }).catch(function(){});
              }
            }).catch(function(){});
        }
      } catch(e){ /* never block report approval on clip auto-approve */ }
    }).catch(function(err){
      console.warn("approveReport persist failed:", err && err.message);
      // Revert the optimistic UI change so admin doesn't believe a failed approval succeeded.
      setScoutReports(function(prev){
        return prev.map(function(r){ return String(r.id)===String(reportId) ? Object.assign({}, r, {status: existing ? existing.status : "draft"}) : r; });
      });
      notify && notify("Could not save approval — please try again. ("+(err && err.message ? err.message.slice(0,80) : "DB write failed")+")", "error");
    });
    // NOTIFICATION: write a player notification row so the bell icon updates
    try {
      var report = (scoutReports||[]).find(function(r){return String(r.id)===String(reportId);});
      if(report && report.playerId){
        bbotWrite("bbot_notifications","insert",[{
            player_id: String(report.playerId),
            type: "report_ready",
            report_id: Number(reportId),
            message: "Your BBOT evaluation is ready.",
            read: false,
            created_at: new Date().toISOString()
          }],null).catch(function(){});

        // #6 RELEASE EMAIL — the report is now visible to the player, so email them.
        // Best-effort: a failure here never blocks approval. Backend is admin-gated + no-ops
        // if Resend isn't configured.
        try {
          var pl = (users||[]).find(function(u){return String(u.id)===String(report.playerId);});
          if(pl && pl.email){
            fetch(BACKEND_URL+"/send-release-email", {
              method:"POST", headers:bbotAdminHeaders(),
              body: JSON.stringify({email: pl.email, playerName: (pl.firstName? pl.firstName+"'s" : "your")})
            }).catch(function(){});
          }
        } catch(_e){}

        // ACHIEVEMENT TRIGGER: any tool grade >= 60 (Plus or better) → milestone notification
        var topTools = (report.sections||[]).filter(function(s){return s.grade && s.grade >= 60;});
        if(topTools.length > 0){
          var topTool = topTools.sort(function(a,b){return b.grade-a.grade;})[0];
          bbotWrite("bbot_notifications","insert",[{
              player_id: String(report.playerId),
              type: "achievement",
              report_id: Number(reportId),
              message: "🏆 New achievement: "+topTool.label+" graded "+topTool.grade+" — above-average tool",
              read: false,
              created_at: new Date().toISOString()
            }],null).catch(function(){});
        }
      }
      // FOLLOWER FAN-OUT (#20): notify everyone following this player that a new
      // evaluation was released, so coaches who follow the player get updates.
      try {
        var pl = (users||[]).find(function(u){return String(u.id)===String(report.playerId);});
        var followers = (pl && pl.followers) || [];
        if(followers.length){
          var pname = pl ? (pl.firstName+" "+pl.lastName) : "A player you follow";
          // STANDOUT TRIGGER: if this report flags a standout (a notable rep — e.g. a hard-hit
          // ball, a premium throw), send a distinct higher-signal alert. This is the exposure
          // lever: coaches following a player hear about standouts immediately.
          var fr = report.fullReport || report.full_report || report || {};
          var standoutReason = "";
          if(fr.standout===true || fr.standout){ standoutReason = fr.standoutReason || (typeof fr.standout==="string"?fr.standout:""); }
          if(!standoutReason && Array.isArray(fr.standouts) && fr.standouts.length){ standoutReason = fr.standouts[0].reason || ""; }
          // also detect a section/tool that BBOT marked standout
          if(!standoutReason && Array.isArray(fr.sections)){ var so=fr.sections.find(function(s){return s && s.standout;}); if(so) standoutReason = so.standoutReason || so.title || ""; }
          var isStandout = !!standoutReason;
          var msg = isStandout
            ? (pname+" had a standout: "+standoutReason)
            : (pname+" has a new BBOT evaluation.");
          bbotWrite("bbot_notifications","insert",followers.map(function(fid){return {
              player_id: String(fid),
              type: isStandout ? "standout" : "followed_player_update",
              report_id: Number(reportId),
              message: msg,
              read: false,
              created_at: new Date().toISOString()
            };}),null).catch(function(){});
        }
      } catch(_){}
    } catch(_){}
    // #5 SAVED-SEARCH ALERTS — when a player's eval is released, notify any coach whose
    // saved search now matches this player. Best-effort & guarded; never blocks approval.
    try {
      var relReport = (scoutReports||[]).find(function(r){return String(r.id)===String(reportId);});
      var relPlayer = relReport && (users||[]).find(function(u){return String(u.id)===String(relReport.playerId);});
      if(relPlayer){
        var latestMetric = function(pid,key){
          var pM=(metrics||{})[pid]||[];
          for(var i=pM.length-1;i>=0;i--){ if(pM[i][key]!=null) return Number(pM[i][key]); }
          return null;
        };
        fetch(SUPABASE_URL+"/rest/v1/bbot_wants?active=eq.true&select=id,coach_id,filters,description", {headers:sbHeaders()})
          .then(function(r){return r.ok?r.json():[];})
          .then(function(wants){
            (wants||[]).forEach(function(w){
              if(!playerMatchesWant(relPlayer, w.filters, latestMetric)) return;
              var coachId = w.coach_id;
              if(!coachId) return;
              // Write a notification to the matching coach.
              bbotWrite("bbot_notifications","insert",[{
                  player_id: String(coachId),
                  type: "saved_search_match",
                  report_id: Number(reportId),
                  message: (relPlayer.firstName+" "+relPlayer.lastName)+(relPlayer.position?" ("+relPlayer.position+")":"")+" matches your saved search"+(w.description?" — "+String(w.description).slice(0,40):"")+".",
                  read: false,
                  created_at: new Date().toISOString()
                }],null).catch(function(){});
            });
          }).catch(function(){});
      }
    } catch(_){}
    // AUDIT LOG
    try { bbotAdminLog({action:"approve_report",target_id:String(reportId),admin_id:cu?String(cu.id):null,timestamp:new Date().toISOString()}).catch(function(){}); } catch(_){}
  }
  // Hard-delete a report: removes the bbot_reports row entirely (not just status). Use for
  // orphaned/phantom reports — e.g. an approved report whose clips/eval were removed but the
  // row lingered and still shows on the profile. Also clears derived measurements + local state.
  function deleteReport(reportId){
    var snapshot = null;
    setScoutReports(function(prev){
      snapshot = prev;
      return (prev||[]).filter(function(r){ return String(r.id)!==String(reportId); });
    });
    // /report-delete removes the report AND its derived bbot_measurements server-side (both RLS-locked).
    reportDelete([reportId]).then(function(){
      notify && notify("Report deleted.");
    }).catch(function(err){
      // Revert local removal if the delete failed, so UI doesn't lie about what's stored.
      if(snapshot) setScoutReports(function(){ return snapshot; });
      notify && notify("Could not delete report — please try again. ("+(err&&err.message?err.message.slice(0,80):"delete failed")+")","error");
    });
    // Clear local tiles tied to this report (DB measurement rows handled server-side above).
    setMetrics(function(prev){
      var copy = Object.assign({}, prev);
      Object.keys(copy).forEach(function(pid){ copy[pid] = (copy[pid]||[]).filter(function(m){return String(m.reportId)!==String(reportId);}); });
      return copy;
    });
    try { bbotAdminLog({action:"delete_report",target_id:String(reportId),admin_id:cu?String(cu.id):null,timestamp:new Date().toISOString()}).catch(function(){}); } catch(_){}
  }

  function rejectReport(reportId) {
    // Capture pre-change status so we can revert if the DB write fails.
    var prevStatus = null;
    setScoutReports(function(prev) {
      var found = prev.find(function(r){ return r.id === reportId; });
      if(found) prevStatus = found.status;
      return prev.map(function(r){ return r.id === reportId ? Object.assign({}, r, {status:"rejected"}) : r; });
    });
    reportPatch(Number(reportId), {status:STATUS.REJECTED}, {clearMeasurements:true}).then(function(r){
      if(!r.ok) return r.text().then(function(t){ throw new Error("HTTP "+r.status+": "+(t||"").slice(0,120)); });
    }).catch(function(err){
      console.warn("rejectReport persist failed:", err && err.message);
      // Revert: rejected reports gate measurements/leaderboard, so a silent failure
      // here would leave stale data referenced by a report admin thinks is rejected.
      setScoutReports(function(prev){
        return prev.map(function(r){ return r.id === reportId ? Object.assign({}, r, {status: prevStatus || "ready"}) : r; });
      });
      notify && notify("Could not save rejection — please try again. ("+(err && err.message ? err.message.slice(0,80) : "DB write failed")+")", "error");
    });
    // Audit log — destructive admin action gets recorded for accountability + refund/legal trail.
    try { bbotAdminLog({action:"reject_report",target_id:String(reportId),admin_id:cu?String(cu.id):null,timestamp:new Date().toISOString()}).catch(function(){}); } catch(_){}
    // Derived measurement rows are cleared server-side by /report-patch (clearMeasurements) above.
    // Also clear from local state so tiles update immediately without a refresh.
    setMetrics(function(prev){
      var copy = Object.assign({}, prev);
      Object.keys(copy).forEach(function(pid){
        copy[pid] = (copy[pid]||[]).filter(function(m){return String(m.reportId)!==String(reportId);});
      });
      return copy;
    });
  }
  const [adminTab,setAdminTab]=useState("metrics");
  const [toastQueue,setToastQueue]=useState([]);
  const toast = toastQueue.length>0 ? toastQueue[0] : null;

  function notify(msg,type){
    var id = Date.now()+Math.random();
    setToastQueue(function(q){return q.concat([{id:id, msg:msg, type:type||"ok"}]);});
    setTimeout(function(){
      setToastQueue(function(q){return q.filter(function(t){return t.id!==id;});});
    }, 3200);
  }
  // Expose notify so non-React helpers (Stripe return, etc.) can trigger it
  if(typeof window!=="undefined") window.__bbotNotify = notify;
  if(typeof window!=="undefined") window.__bbotGo = go;
  // VELOCITY GATING: raw velocity readings are admin/staff-only until BBOT's
  // video-inferred velo is calibrated against radar/device readings.
  if(typeof window!=="undefined") window.__bbotVeloVisible = !!(cu && (cu.type==="staff" || bbotIsAdmin(cu)));

  // Card preview modal — card generators call this instead of force-downloading
  var cardPreviewState=useState(null); var cardPreview=cardPreviewState[0]; var setCardPreview=cardPreviewState[1];
  if(typeof window!=="undefined"){
    window.__bbotShowCardPreview = function(dataUrl, blob, fname){ setCardPreview({dataUrl:dataUrl, blob:blob, fname:fname}); };
  }

  // Expose grade override fn for inline editing in ReportCard
  if(typeof window!=="undefined"){
    window.__bbotUpdateGrade = function(reportId, sectionKey, newGrade, reason){
      setScoutReports(function(rs){
        return (rs||[]).map(function(rep){
          if(String(rep.id)!==String(reportId)) return rep;
          var newSections = (rep.sections||[]).map(function(s){
            if(s.key!==sectionKey) return s;
            return Object.assign({}, s, {
              grade: newGrade,
              _originalGrade: s._originalGrade || s.grade,
              _editedBy: cu ? cu.firstName+" "+cu.lastName : "Admin",
              _editedAt: new Date().toISOString(),
            });
          });
          return Object.assign({}, rep, {sections: newSections});
        });
      });
      // Persist to Supabase
      reportPatch(Number(reportId), {sections_updated_at: new Date().toISOString()}).catch(function(){});
      // Audit log — capture the FULL delta for calibration:
      // what BBOT said, what admin corrected it to, and the context where it drifted.
      var _rep = (scoutReports||[]).find(function(rr){return String(rr.id)===String(reportId);}) || {};
      var _sec = ((_rep.sections)||[]).find(function(ss){return ss.key===sectionKey;}) || {};
      var _origGrade = (_sec._originalGrade!=null ? _sec._originalGrade : _sec.grade);
      var _player = (users||[]).find(function(uu){return String(uu.id)===String(_rep.playerId);}) || {};
      // THE REASON IS COLLECTED WHERE THE CORRECTION HAPPENS. The server refuses a grade_override
      // without one, because a delta with no why cannot be learned from -- it cannot distinguish
      // "BBOT misread the footage" from "wrong benchmark" from "this tool should not be graded at
      // all", and those imply opposite fixes. Cancelling the prompt cancels the LOG, never the
      // grade: the correction is the admin's to make, the calibration record is what needs the why.
      var _why = (typeof window!=="undefined" && window.prompt)
        ? window.prompt("Why is this grade wrong? (what BBOT got wrong, and how you know)") : "";
      if(!_why || String(_why).trim().length < 4){
        if(typeof window!=="undefined" && window.__bbotNotify)
          window.__bbotNotify("Grade saved. Calibration note skipped — no reason given.","info");
      } else {
      bbotAdminLog({
          action: "grade_override",
          target_id: String(reportId),
          admin_id: cu ? String(cu.id) : null,
          timestamp: new Date().toISOString(),
          metadata: {
            sectionKey: sectionKey,
            toolLabel: _sec.label || sectionKey,
            reason: String(_why).trim().slice(0,400),
            bbotGrade: _origGrade,        // what BBOT predicted
            correctedGrade: newGrade,     // what admin set
            delta: (typeof _origGrade==="number") ? (newGrade - _origGrade) : null,
            source: _sec.source || null,  // verified vs estimated basis
            reason: (reason||"").trim() || null,  // WHY corrected — which cue drifted (calibration signal #1)
            position: _player.position || null,
            gradYear: _player.gradYear || null,
            ageGroup: (typeof bbotAgeGroup==="function" ? bbotAgeGroup(_player.dob) : null), // age cohort for per-age calibration
            sessionType: _rep.sessionType || null
          }
        }).then(function(r){
        if(r && r.ok===false){ notify("Could not save grade override — try again","error"); return; }
        notify("Grade override saved — original logged in audit");
      }).catch(function(){ notify("Could not save grade override — try again","error"); });
      }
    };

    window.__bbotApplyCorrectedSections = function(reportId, correctedSections, calibrationNote){
      var applied = null;
      setScoutReports(function(rs){
        return (rs||[]).map(function(rep){
          if(String(rep.id)!==String(reportId)) return rep;
          // Apply ONLY the corrected sections. The admin/calibration change-note is stored
          // SEPARATELY as calibrationNote and must NEVER overwrite the summary — the summary is
          // the player-facing BBOT-generated scout narrative; the note is internal admin language.
          var merged = Object.assign({}, rep, {sections: correctedSections});
          // Rebuild full_report from the existing blob so we don't drop other fields (summary preserved).
          // The loader maps the row into `fullReport` (camelCase) — reading `rep.full_report` here found
          // NOTHING and silently replaced the whole blob with {sections, calibrationNote}, destroying
          // isPitcher / poseMetrics / measuredValues / pitches on save. Read the mapped key first.
          var base = rep.fullReport || rep.full_report || null;
          var fr = Object.assign({}, base||{}, {sections: correctedSections});
          if(calibrationNote){ merged.calibrationNote = calibrationNote; fr.calibrationNote = calibrationNote; }
          merged.full_report = fr;
          merged.fullReport = fr;
          merged._frBaseMissing = !base;   // guard: never PATCH a blob we couldn't read
          applied = merged;
          return merged;
        });
      });
      if(applied){
        // Persist corrected sections + the separate calibrationNote (rides inside the full_report
        // jsonb, no schema change). Do NOT patch the summary column — the original scout narrative
        // stays intact and player-facing; admin notes are never written to summary.
        // SAFETY: if the report's full_report blob was not loaded, patch ONLY the sections column —
        // writing a rebuilt blob would overwrite the stored measurements with an empty shell.
        var patchBody = applied._frBaseMissing
          ? {sections: correctedSections}
          : {full_report: applied.full_report, sections: correctedSections};
        reportPatch(Number(reportId), patchBody).then(function(r){
          if(r && r.ok===false){ notify("Could not save corrections — try again","error"); }
        }).catch(function(){ notify("Could not save corrections — try again","error"); });
      }
    };

    window.__bbotUpdateCoachNotes = function(reportId, notes){
      setScoutReports(function(rs){
        return (rs||[]).map(function(rep){
          if(String(rep.id)!==String(reportId)) return rep;
          return Object.assign({}, rep, {coachNotes: notes});
        });
      });
      reportPatch(Number(reportId), {coach_notes: notes}).then(function(r){
        if(r && r.ok===false){ notify("Could not save coach notes — try again","error"); return; }
        notify("Coach notes saved");
      }).catch(function(){ notify("Could not save coach notes — try again","error"); });
    };

    window.__bbotUpdateSessionContext = function(reportId, ctx){
      setScoutReports(function(rs){
        return (rs||[]).map(function(rep){
          if(String(rep.id)!==String(reportId)) return rep;
          return Object.assign({}, rep, {sessionContext: ctx});
        });
      });
      reportPatch(Number(reportId), {session_context: ctx}).then(function(r){
        if(r && r.ok===false){ notify("Could not save session context — try again","error"); return; }
        notify("Session context saved");
      }).catch(function(){ notify("Could not save session context — try again","error"); });
    };

    // Expose scoutReports + users for cross-report lookups (per-section deltas)
    // AND as the canonical data source for the clean PDF render (downloadReportPdf).
    window.__bbotReports = scoutReports;
    window.__bbotUsers = users;
    window.__bbotCU = cu;   // current admin — read by refinement-capture log (onGradeOverride) for attribution
  }
  // Flush any deferred payment-return message
  if(typeof window!=="undefined" && window.__bbotPaymentSuccess && !window.__bbotPaymentSuccessFlushed) {
    window.__bbotPaymentSuccessFlushed = true;
    setTimeout(function(){ notify(window.__bbotPaymentSuccess); }, 200);
  }
  function pushFeed(uid,type,text){
    var item = {id:Date.now(),userId:uid,type:type,text:text,date:new Date().toISOString().slice(0,10),likes:0,likedBy:[]};
    setFeed(function(f){return [item].concat(f);});
    // Persist so the feed survives page refresh. Table schema uses camelCase
    // (userId, type, content, timestamp). Best-effort write — if DB persistence
    // fails (RLS, network), the in-memory copy still shows for this session.
    try {
      bbotWrite("feed_items","insert",[{userId: uid, type: type, content: text, timestamp: new Date().toISOString()}],null).catch(function(){});
    } catch(_) {}
  }

  function recordView(viewer,targetId){
    if(viewer.id===targetId)return;
    setUsers(function(all){return all.map(function(u){
      if(u.id!==targetId)return u;
      var today=new Date().toISOString().slice(0,10);
      var already=(u.profileViews||[]).some(function(v){return v.viewerId===viewer.id&&v.date===today;});
      if(already)return u;
      var who = viewer.type==="coach" ? ("Coach "+viewer.lastName)
              : viewer.type==="staff" ? "643 Staff"
              : (viewer.firstName+" "+viewer.lastName);
      var notif={id:Date.now(),type:"profile_view",text:who+" viewed your profile",date:today,read:false};
      var updated={...u,profileViews:(u.profileViews||[]).concat([{viewerId:viewer.id,date:today}]),notifications:[notif].concat(u.notifications||[])};
      // Cross-user write (target's row): goes through /user-notify, not persistUser — the client
      // can't write another user's bbot_users row under RLS. Backend appends notif + view server-side.
      fetch(BACKEND_URL+"/user-notify",{method:"POST",headers:bbotAdminHeaders(),body:JSON.stringify({targetId:targetId,notification:notif,view:{viewerId:viewer.id,date:today}})}).catch(function(){});
      return updated;
    });});
  }

  // ── ADMIN IMPERSONATION ("View as user") ──────────────────────────────
  // Lets the admin step into any coach/player account to see exactly what they
  // see. The real admin is stashed in impersonator; a banner stays pinned with
  // a one-tap return. No password needed; admin-only.
  const [impersonator,setImpersonator]=useState(null);
  function startImpersonate(target){
    if(!target) return;
    var realAdmin = impersonator || cu; // don't nest — always return to the true admin
    if(!realAdmin || !bbotIsAdmin(realAdmin)){ notify("Only admin can view as another user","error"); return; }
    if(String(target.id)===String(realAdmin.id)){ notify("That's already you"); return; }
    setImpersonator(realAdmin);
    setCu(target);
    setVp(null);
    setPage(target.type==="player"?"home":"home");
    notify("Viewing as "+target.firstName+" "+target.lastName);
  }
  function stopImpersonate(){
    if(!impersonator) return;
    var admin = impersonator;
    setImpersonator(null);
    setCu(admin);
    setVp(null);
    setPage("admin");
    notify("Back to admin");
  }

  function go(p,prof){
    // Support "profile-<id>" shorthand used by activity feed / cards.
    if(typeof p==="string" && p.indexOf("profile-")===0 && !prof){
      var pid = p.slice("profile-".length);
      // A VISITOR GETS THE PUBLIC PREVIEW, NOT THE PROFILE. ProfilePage is built for a signed-in
      // viewer -- it reads cu.id to work out whether the profile is your own -- so sending a
      // logged-out reader there crashes the page, and it would disclose far more than the ruled
      // tier even if it did not. Routed through the hash so the preview is also a real,
      // shareable address rather than a dead end.
      if(!cu){
        if(typeof window!=="undefined") window.location.hash = "player/"+encodeURIComponent(String(pid));
        setPublicPlayerId(String(pid));
        return;
      }
      var found = (users||[]).find(function(u){return String(u.id)===String(pid);});
      setPage("profile"); setVp(found||null);
      if(found&&cu&&found.id!==cu.id)recordView(cu,found.id);
      return;
    }
    setPage(p);setVp(prof||null);
    if(prof&&cu&&prof.id!==cu.id)recordView(cu,prof.id);
    // A LEGAL HASH MUST NOT OUTLIVE THE PAGE IT NAMES. Leaving #terms on the URL while the reader
    // walks to the Blog means a refresh silently returns them to the contract, which is worse than
    // having no deep link at all. Cleared with replaceState so it costs no history entry.
    if(typeof window!=="undefined" && p!=="terms" && bbotLegalHashKey()){
      try{ window.history.replaceState({}, "", window.location.pathname+window.location.search); }catch(e){}
    }
  }

  // ---- LEGAL DEEP LINKS -------------------------------------------------------------------
  // TERMS AND PRIVACY HAVE TO BE LINKABLE, and until now nothing on this site was: every page is
  // React state, so a reader could reach the contract but never send anyone to it. That is a
  // compliance exposure rather than a convenience, because the documents a user agrees to must be
  // citable.
  //
  // IT USES THE HASH SCHEME THIS APP ALREADY HAS -- #share/<token>, #p/<slug>~<token>, #auth,
  // #join/<id> -- rather than introducing pathname routing. Pathname routing would mean a router
  // dependency and mapping every `go(...)` in a 1.4 MB file where "pages are React STATE, not
  // URLs"; that is a separate, much larger change. A hash is a real URL: it survives reload, copy
  // and paste, and never reaches the server.
  //
  // THE THREE KEYS MATCH THE THREE FOOTER LINKS, and each lands on the section its label names --
  // the same `goLegal` anchors the clicks already use, so a link and a click land identically.
  // `compliance` is included because it is the third link in the same footer and leaving one of
  // three uncitable would be its own inconsistency.
  useEffect(function(){
    function openFromHash(){
      var k = bbotLegalHashKey();
      if(k){ goLegal(go, BBOT_LEGAL_HASHES[k]); return; }
      // THE HASH LEFT THE DOCUMENT, SO THE DOCUMENT SHOULD LEAVE THE SCREEN. Without this, Back
      // from #compliance changed the URL to "/" and left the contract showing -- a URL and a page
      // disagreeing about where the reader is, which is worse than no history at all.
      //
      // ONLY FROM THE CONTRACT, and via the functional form so it reads the CURRENT page rather
      // than the one captured when this effect was created. An unrelated hash change must not yank
      // a reader off whatever page they are actually on.
      setPage(function(cur){ return cur === "terms" ? "landing" : cur; });
    }
    openFromHash();
    window.addEventListener("hashchange", openFromHash);
    return function(){ window.removeEventListener("hashchange", openFromHash); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);

  function toggleFollow(tid){
    var t=users.find(function(u){return u.id===tid;});
    if(!t) return;
    var prevCu=cu, prevT=t;
    var isF=(cu.following||[]).includes(tid);
    var newCu={...cu,following:isF?(cu.following||[]).filter(function(x){return x!==tid;}):(cu.following||[]).concat([tid])};
    var notif={id:Date.now(),text:cu.firstName+" "+cu.lastName+" started following you",date:new Date().toISOString().slice(0,10),read:false};
    var newT={...t,followers:isF?(t.followers||[]).filter(function(x){return x!==cu.id;}):(t.followers||[]).concat([cu.id]),notifications:isF?(t.notifications||[]):[notif].concat(t.notifications||[])};
    setCu(newCu);setUsers(function(all){return all.map(function(u){return u.id===cu.id?newCu:u.id===tid?newT:u;});});
    if(!isF)pushFeed(cu.id,"follow",cu.firstName+" "+cu.lastName+" started following "+t.firstName+" "+t.lastName);
    // Both sides (caller.following + target.followers + notification) are written server-side by
    // /user-follow — the client can't write the target's row under RLS. Revert UI if it fails.
    fetch(BACKEND_URL+"/user-follow",{method:"POST",headers:bbotAdminHeaders(),body:JSON.stringify({targetId:tid,follow:!isF})})
    .then(function(r){ if(!r.ok) throw new Error("follow"); notify(isF?"Unfollowed":"Now following "+t.firstName+"!"); })
    .catch(function(){
      setCu(prevCu);setUsers(function(all){return all.map(function(u){return u.id===prevCu.id?prevCu:u.id===tid?prevT:u;});});
      notify("Could not update — try again","error");
    });
  }

  function markRead(){
    var upd={...cu,notifications:(cu.notifications||[]).map(function(n){return{...n,read:true};})};
    setCu(upd);setUsers(function(all){return all.map(function(u){return u.id===cu.id?upd:u;});});
  }

  // #8 Player → coach interest signal. One tap; records that a player flagged interest in a
  // coach/program and notifies that coach. Compliance-safe: it's an interest flag, not a
  // message, so it isn't gated by NCAA messaging-eligibility dates. Toggleable (un-flag).
  function toggleInterest(coachId){
    if(!cu || cu.type!=="player") return;
    var coach = users.find(function(u){return u.id===coachId;});
    if(!coach) return;
    var already = (cu.interestedIn||[]).includes(coachId);
    var newCu = Object.assign({}, cu, {interestedIn: already ? (cu.interestedIn||[]).filter(function(x){return x!==coachId;}) : (cu.interestedIn||[]).concat([coachId])});
    var updatedCoach = coach;
    if(!already){
      var notif = {id:Date.now(),type:"player_interest",text:cu.firstName+" "+cu.lastName+(cu.gradYear?" (Class "+cu.gradYear+")":"")+(cu.position?" · "+cu.position:"")+" expressed interest in your program.",date:new Date().toISOString().slice(0,10),read:false};
      updatedCoach = Object.assign({}, coach, {notifications:[notif].concat(coach.notifications||[])});
    }
    setCu(newCu);
    setUsers(function(all){return all.map(function(u){return u.id===cu.id?newCu:(u.id===coachId?updatedCoach:u);});});
    // Both sides (player.interestedIn + coach notification) are written server-side by
    // /user-interest — the player can't write the coach's row under RLS.
    fetch(BACKEND_URL+"/user-interest",{method:"POST",headers:bbotAdminHeaders(),body:JSON.stringify({coachId:coachId,interested:!already,notification:(!already?notif:null)})})
      .catch(function(){ notify("Couldn't save — try again","error"); });
    if(!already){
      pushFeed(cu.id,"player_interest","You expressed interest in "+(coach.orgName?coach.orgName:coach.firstName+" "+coach.lastName));
      notify("Interest sent to "+(coach.firstName||"coach")+"!");
    } else {
      notify("Interest withdrawn");
    }
  }

  // Permission model:
  // - isAdmin: full power (money, deletes, coach verification, refunds, staff approval)
  // - isApprovedStaff: limited — add players + run evals; their evals still need approval
  // - isStaff: kept for existing dashboard access checks (admin OR approved staff)
  var isAdmin = cu && bbotIsAdmin(cu);
  var isApprovedStaff = cu && cu.type==="staff" && (cu.staffApproved===true || isAdmin);
  var isStaff = cu && cu.type==="staff" && (cu.staffApproved!==false || isAdmin);

  return(
    <div>
      <style>{css}</style>
      <Toast msg={toast?toast.msg:null} type={toast?toast.type:null}/>
      {impersonator && cu && (
        <div style={{position:"fixed",top:0,left:0,right:0,zIndex:9000,background:C.coral,color:C.white,padding:"7px 14px",display:"flex",alignItems:"center",justifyContent:"center",gap:12,fontSize:12,fontWeight:600,boxShadow:"0 2px 6px rgba(0,0,0,.15)"}}>
          <span>👁 Viewing as <strong>{cu.firstName} {cu.lastName}</strong> ({cu.type}{cu.email?" · "+cu.email:""})</span>
          <button onClick={stopImpersonate} style={{background:C.white,color:C.coral,border:"none",padding:"4px 12px",borderRadius:6,fontSize:11,fontWeight:700,cursor:"pointer",letterSpacing:.3}}>RETURN TO ADMIN</button>
        </div>
      )}
      {impersonator && <div style={{height:34}}/>}
      {cardPreview && (
        <div onClick={function(){setCardPreview(null);}} style={{position:"fixed",inset:0,zIndex:10000,background:"rgba(0,0,0,.8)",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",padding:20,overflow:"auto"}}>
          <div onClick={function(e){e.stopPropagation();}} style={{maxWidth:480,width:"100%",textAlign:"center"}}>
            <img src={cardPreview.dataUrl} alt="BBOT Card" style={{width:"100%",borderRadius:12,boxShadow:"0 8px 40px rgba(0,0,0,.5)",marginBottom:14}}/>
            <div style={{display:"flex",gap:10,justifyContent:"center"}}>
              <button onClick={function(){
                var blob=cardPreview.blob, fname=cardPreview.fname;
                var file=null; try{file=new File([blob],fname,{type:"image/png"});}catch(e){}
                if(file && navigator.share && navigator.canShare && navigator.canShare({files:[file]})){
                  navigator.share({files:[file],title:"BBOT Card"}).catch(function(){});
                } else {
                  var u=URL.createObjectURL(blob);var a=document.createElement("a");a.href=u;a.download=fname;a.click();setTimeout(function(){URL.revokeObjectURL(u);},2000);
                }
              }} style={{background:C.coral,color:C.white,border:"none",padding:"12px 24px",borderRadius:8,fontSize:14,fontWeight:700,cursor:"pointer"}}>Save / Share</button>
              <button onClick={function(){setCardPreview(null);}} style={{background:"rgba(255,255,255,.15)",color:C.white,border:"none",padding:"12px 24px",borderRadius:8,fontSize:14,fontWeight:600,cursor:"pointer"}}>Close</button>
            </div>
          </div>
        </div>
      )}
      {publicShareToken && <PublicProfileView token={publicShareToken} users={users} scoutReports={scoutReports} battedBalls={battedBalls} metrics={metrics} onClose={function(){
        setPublicShareToken(null);
        if(typeof window!=="undefined") window.location.hash="";
      }}/>}
      {/* A PUBLISHED SESSION REPORT — openable by anyone holding the link, like a blog post. */}
      {!publicShareToken && publicRecapId && (
        <PublicRecapView recapId={publicRecapId} users={users} go={go}
          onClose={function(){
            setPublicRecapId(null);
            bbotClearShareUrl();
          }}/>
      )}
      {/* THE PUBLIC PLAYER PREVIEW — name, position and class, plus the most recent clip and
          skeleton. Everything else needs an account. */}
      {!publicShareToken && !cu && publicPlayerId && (
        <PublicPlayerView playerId={publicPlayerId} go={go} onClose={function(){
          setPublicPlayerId(null);
          bbotClearShareUrl();
        }}/>
      )}
      {/* A SHARED CLIP OR SKELETON — watchable by anyone holding the link. */}
      {!publicShareToken && !publicRecapId && publicClipId && (
        <PublicClipView clipId={publicClipId} onClose={function(){
          setPublicClipId(null);
          bbotClearShareUrl();
        }}/>
      )}
      {/* THE QR TARGET. Sits above every page route and beside the share-token view, because a
          visitor holding an event link has not chosen a page -- the link IS the destination.
          Clearing the hash is what returns them to the normal site. */}
      {!publicShareToken && publicEventId && page!=="auth" && (
        <PublicEventView
          eventId={publicEventId}
          cu={cu}
          go={go}
          setAuthMode={setAuthMode}
          onRegister={function(ev){ setEventToRegister(ev); }}
          onClose={function(){
            setPublicEventId(null);
            if(typeof window!=="undefined"){ window.__bbotPendingEventId=null; window.location.hash=""; }
          }}/>
      )}
      {/* ONE REGISTRATION CODE PATH. This is the same modal the logged-in events list opens, so a
          player arriving by QR code goes through exactly the flow that is already tested --
          jersey size, two-way confirmation, waiver, number assignment, payment. `setEvents` is a
          no-op here because the public page re-reads the event from the view afterwards; it has
          no local list to keep in step. */}
      {eventToRegister && (
        <EventRegisterModal
          ev={eventToRegister}
          cu={cu||{}}
          notify={notify}
          onClose={function(){ setEventToRegister(null); }}
          onRegistered={function(reg,onDone){
            saveEventRegistration(eventToRegister, reg, function(){}, notify, onDone);
          }}
          onPaid={function(ev,pid){ markEventRegistrationPaid(ev, pid, function(){}); }}/>
      )}
      {!publicShareToken && !publicEventId && !publicRecapId && !publicClipId && !publicPlayerId && page==="landing"&&<Landing go={go} setAuthMode={setAuthMode} siteContent={siteContent}/>}
      {/* PUBLIC, AS RULED. The stream is the product's shop window, so it must render for someone
          who has never signed in — the same component the signed-in shell mounts, not a cut-down
          copy that could drift from it. */}
      {!publicShareToken && !cu && page==="activity"&&<div style={{padding:"18px 0 40px"}}>
        <ActivityPage scoutReports={scoutReports} users={users} highlights={highlights} go={go}/></div>}
      {/* THE BLOG IS A CUSTOMER SURFACE and was signed-in only, which makes it useless as one:
          the audience a blog is written for is exactly the audience that has not signed up yet. */}
      {/* SESSION REPORTS ARE PUBLIC, like the blog. The audience for a published report -- a
          parent, a travel coach, a recruiter -- is exactly the audience with no account, and the
          page rendered only inside the signed-in routes. RecapsPage shows published reports to a
          signed-out reader and keeps its staff controls behind isStaff. */}
      {!publicShareToken && !publicRecapId && !cu && page==="recaps"&&<div style={{padding:"18px 0 40px"}}>
        <RecapsPage recaps={recaps} setRecaps={setRecaps} users={users} cu={null} notify={notify}
          isStaff={false} scoutReports={scoutReports} go={go}/></div>}
      {/* LEADERBOARDS ARE PUBLIC (Luis, 2026-10-08). The boards list measured readings -- radar
          MPH and admin-timed runs -- in order. They are the clearest evidence of what BBOT
          actually does, and they were visible only to people who had already signed up. Same
          component the signed-in shell mounts, not a cut-down copy that could drift from it. */}
      {!publicShareToken && !cu && page==="leaderboard"&&<div style={{padding:"18px 0 40px"}}>
        <LeaderboardPage users={users} scoutReports={scoutReports} cu={null}/></div>}
      {!publicShareToken && !cu && page==="blogs"&&<div style={{padding:"18px 0 40px"}}>
        <BlogsPage blogs={blogs} setBlogs={setBlogs} cu={null} notify={notify}
          scoutReports={scoutReports} users={users} go={go}/></div>}
      {!publicShareToken && !cu && page==="sample-report"&&<SampleReportPage go={go} setAuthMode={setAuthMode}/>}
      {!publicShareToken && page==="for-coaches"&&<ForCoachesPage go={go} setAuthMode={setAuthMode}/>}
      {!publicShareToken && page==="methodology"&&<MethodologyPage go={go}/>}
      {!publicShareToken && page==="privacy"&&<PrivacyPage go={go}/>}
      {!publicShareToken && page==="terms"&&!cu&&<TermsPage/>}
      {!publicShareToken && page==="auth"&&<Auth mode={authMode} setMode={setAuthMode} users={users} setUsers={setUsers} setCu={setCu} go={go} notify={notify} adminUser={cu} setPublicEventId={setPublicEventId}/>}
      {!publicShareToken && cu&&page!=="landing"&&page!=="auth"&&(
        <Shell page={page} go={go} cu={cu} setCu={setCu} users={users} setUsers={setUsers}
          metrics={metrics} setMetrics={setMetrics} reviews={reviews} setReviews={setReviews}
          blogs={blogs} setBlogs={setBlogs} feed={feed} setFeed={setFeed} vp={vp}
          toggleFollow={toggleFollow} toggleInterest={toggleInterest} pushFeed={pushFeed} notify={notify} markRead={markRead}
          isStaff={isStaff} scoutReports={scoutReports} setScoutReports={setScoutReports}
          adminTab={adminTab} setAdminTab={setAdminTab}
          fields={fields} setFields={setFields} battedBalls={battedBalls} setBattedBalls={setBattedBalls} recaps={recaps} setRecaps={setRecaps} lineups={lineups} setLineups={setLineups} approveReport={approveReport} highlights={highlights} setHighlights={setHighlights} coachUpdates={coachUpdates} setCoachUpdates={setCoachUpdates} siteContent={siteContent} setSiteContent={setSiteContent} saveSiteContent={saveSiteContent} startImpersonate={startImpersonate} setAuthMode={setAuthMode}/>
      )}
      {/* EVERY PAGE, EVERY ROLE, SIGNED IN OR NOT. Placed outside every page branch on purpose:
          a new page cannot be added without the legal links, and no role can lose them. */}
      <LegalFooter go={go} cu={cu}/>
    </div>
  );
}


function PublicProfileView({token, users, scoutReports, battedBalls, metrics, onClose}){
  // Find user with matching publicToken
  var player = (users||[]).find(function(u){
    return u.publicToken === token && u.type === "player";
  });

  // EMBED MODE: ?embed=1 in URL → render compact iframe-friendly card
  var isEmbed = typeof window!=="undefined" && new URLSearchParams(window.location.search).get("embed")==="1";

  if(!player){
    return (
      <div style={{minHeight:"100vh",background:C.gray50,padding:40,display:"flex",alignItems:"center",justifyContent:"center"}}>
        <Card style={{maxWidth:420,textAlign:"center",padding:30}}>
          <div style={{margin:"0 auto 16px",width:60}}><BbotMark size={60}/></div>
          <h2 style={{marginBottom:10}}>Profile Not Found</h2>
          <p style={{fontSize:13,color:C.gray500,marginBottom:18}}>This share link may have been revoked, or the player has disabled public sharing.</p>
          <Btn v="primary" onClick={onClose}>Visit BBOT Homepage</Btn>
        </Card>
      </div>
    );
  }

  // EMBED CARD: ultra-compact for iframe use
  if(isEmbed){
    var latestEv = (scoutReports||[]).filter(function(r){return String(r.playerId)===String(player.id)&&isLiveEval(r);}).sort(function(a,b){return (b.date||"").localeCompare(a.date||"");})[0];
    var pubUrl = window.location.origin + window.location.pathname + "#share/" + token;
    return (
      <div style={{padding:14,background:"linear-gradient(135deg,"+C.navy+","+C.navyMid+")",borderRadius:12,color:C.white,maxWidth:380,fontFamily:"Inter,system-ui,sans-serif"}}>
        <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:10}}>
          <Avatar user={player} size={42}/>
          <div style={{flex:1,minWidth:0}}>
            <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:14,letterSpacing:.5,lineHeight:1.1}}>{player.firstName} {player.lastName}</div>
            <div style={{fontSize:10,color:"rgba(255,255,255,.6)",marginTop:2}}>{[player.position,player.gradYear?"Class "+player.gradYear:null,player.height].filter(Boolean).join(" · ")}</div>
          </div>
          <BbotMark size={24}/>
        </div>
        {(function(){
          var secs = (latestEv && latestEv.sections || []).filter(function(s){return s.grade!=null;}).sort(function(a,b){return b.grade-a.grade;});
          var top = secs[0];
          if(!top) return null;
          return (
            <div style={{display:"flex",alignItems:"center",gap:8,padding:"8px 10px",background:"rgba(255,255,255,.08)",borderRadius:6,marginBottom:8}}>
              <div style={{fontSize:9,color:"rgba(255,255,255,.5)",letterSpacing:.4,textTransform:"uppercase"}}>Top Tool · {top.label}</div>
              <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:18,fontWeight:700,color:C.coral,marginLeft:"auto"}}>{top.grade}</div>
            </div>
          );
        })()}
        <a href={pubUrl} target="_blank" rel="noopener noreferrer" style={{display:"block",textAlign:"center",padding:"6px",background:C.coral,color:C.white,borderRadius:6,textDecoration:"none",fontSize:10,fontWeight:700,letterSpacing:.5}}>VIEW FULL PROFILE ↗</a>
      </div>
    );
  }

  var playerReports = (scoutReports||[]).filter(function(r){
    return String(r.playerId)===String(player.id) && isLiveEval(r);
  });
  var playerMetrics = ((metrics||{})[player.id])||[];
  var playerBalls = (battedBalls||[]).filter(function(b){return String(b.playerId)===String(player.id);});

  return (
    <div style={{minHeight:"100vh",background:C.gray50}}>
      {/* Public banner header */}
      <div style={{background:C.navy,padding:"12px 16px",display:"flex",alignItems:"center",justifyContent:"space-between",position:"sticky",top:0,zIndex:50}}>
        <div style={{display:"flex",alignItems:"center",gap:10}}>
          <BbotMark tile="transparent" size={32}/>
          <div style={{color:C.white,fontSize:12,fontWeight:600,letterSpacing:.5}}>Public Profile · BBOT</div>
        </div>
        <button onClick={onClose} style={{background:"rgba(255,255,255,.1)",border:"none",color:C.white,padding:"6px 12px",borderRadius:6,fontSize:11,cursor:"pointer"}}>Create Profile</button>
      </div>

      <div style={{maxWidth:760,margin:"0 auto",padding:"20px 14px 40px"}}>
        {/* Player header */}
        <div style={{background:C.navy,borderRadius:16,padding:20,marginBottom:18,color:C.white}}>
          <div style={{display:"flex",gap:14,alignItems:"center",marginBottom:12}}>
            <Avatar user={player} size={68}/>
            <div style={{flex:1,minWidth:0}}>
              <h2 style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:24,letterSpacing:1,marginBottom:4,wordBreak:"break-word"}}>{player.firstName} {player.lastName}</h2>
              <div style={{display:"flex",flexWrap:"wrap",gap:6}}>
                {player.position && <Badge color="coral">{player.position}</Badge>}
                {player.gradYear && <span style={{background:"rgba(255,255,255,.12)",fontSize:11,fontWeight:600,padding:"3px 9px",borderRadius:99}}>Class {player.gradYear}</span>}
                {player.height && <span style={{background:"rgba(255,255,255,.12)",fontSize:11,fontWeight:600,padding:"3px 9px",borderRadius:99}}>{player.height}</span>}
                {player.weight && <span style={{background:"rgba(255,255,255,.12)",fontSize:11,fontWeight:600,padding:"3px 9px",borderRadius:99}}>{player.weight} lbs</span>}
              </div>
            </div>
          </div>
          {player.bio && <p style={{fontSize:13,color:"rgba(255,255,255,.75)",lineHeight:1.6,margin:0}}>{player.bio}</p>}
          <div style={{display:"flex",gap:18,marginTop:14,paddingTop:14,borderTop:"1px solid rgba(255,255,255,.1)"}}>
            {player.hsName && <div style={{fontSize:11}}><div style={{color:"rgba(255,255,255,.58)",marginBottom:2,letterSpacing:.5,textTransform:"uppercase"}}>High School</div><div style={{color:C.white,fontWeight:600}}>{player.hsName}</div></div>}
            {player.clubName && <div style={{fontSize:11}}><div style={{color:"rgba(255,255,255,.58)",marginBottom:2,letterSpacing:.5,textTransform:"uppercase"}}>Club</div><div style={{color:C.white,fontWeight:600}}>{player.clubName}</div></div>}
            {player.gpa && <div style={{fontSize:11}}><div style={{color:"rgba(255,255,255,.58)",marginBottom:2,letterSpacing:.5,textTransform:"uppercase"}}>GPA</div><div style={{color:C.white,fontWeight:600}}>{player.gpa}</div></div>}
          </div>
        </div>

        {/* Metrics */}
        {playerMetrics.length>0 && (
          <div style={{marginBottom:18}}>
            <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:13,color:C.navy,letterSpacing:1,marginBottom:10}}>METRICS</div>
            <MetricsView uM={playerMetrics}/>
          </div>
        )}

        {/* Charts */}
        {(playerBalls.length>0) && (
          <div style={{marginBottom:18}}>
            <PlayerCharts userId={player.id} playerName={player.firstName+" "+player.lastName} position={player.position} twoWay={player.twoWay} battedBalls={playerBalls} pitches={(typeof window!=="undefined"?window.__bbotPitches:null)||[]} scoutReports={scoutReports||[]}/>
          </div>
        )}

        {/* Tool grades — visible to recruiters (credibility hook) */}
        {(function(){
          var latest = playerReports.slice().sort(function(a,b){return (b.date||"").localeCompare(a.date||"");})[0];
          // A WITHHELD GRADE MUST NOT TAKE THE WHOLE SECTION WITH IT. This filtered on
          // `s.grade != null`, so the moment the zero-grades law withheld Jhosuil Colon's Run
          // grade his entire TOOL GRADES block vanished -- and with it the scout summary and the
          // PDF button, which live inside this same block. His public profile went from 1,503
          // characters to 870: dropping one refused number deleted three receipted measurements
          // from the page a recruiter opens.
          //
          // The rule is DROP THE NUMBER, KEEP THE EVIDENCE. A tool with prose still has something
          // to say -- Jhosuil's run text names an admin-verified 4.1 home-to-first -- and the
          // summary paragraph is not a grade at all.
          var secs = (latest && latest.sections || []).filter(function(s){
            return s && (s.grade!=null || (s.text && String(s.text).trim()));
          });
          if(!secs.length && !(latest && latest.summary)) return null;
          var gw=function(g){return g>=80?"Top of Scale":g>=70?"Plus-Plus":g>=60?"Plus":g>=50?"Average":g>=40?"Fringe Avg":g>=30?"Below Avg":"Well Below";};
          return (
            <div style={{marginBottom:18}}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:10}}>
                <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:13,color:C.navy,letterSpacing:1}}>TOOL GRADES</div>
                <button onClick={function(){downloadReportPdf(latest.id, (sc&&(sc.firstName+" "+sc.lastName))||"");}} style={{background:C.navy,color:C.white,border:"none",padding:"6px 12px",borderRadius:6,fontSize:11,fontWeight:700,cursor:"pointer",letterSpacing:.5}}>DOWNLOAD PDF</button>
              </div>
              <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(150px,1fr))",gap:8}}>
                {secs.map(function(s,i){
                  var has = s.grade!=null;
                  var col=s.grade>=60?C.blue:s.grade>=50?C.orange:C.coral;
                  return <Card key={i} style={{padding:12}}>
                    <div style={{display:"flex",justifyContent:"space-between",alignItems:"baseline"}}>
                      <div style={{fontWeight:700,fontSize:13,color:C.gray900}}>{cleanToolLabel(s.label)}</div>
                      {has && <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:22,fontWeight:700,color:col}}>{s.grade}</div>}
                    </div>
                    {has && <div style={{fontSize:10,color:C.gray400,marginBottom:4}}>{gw(s.grade)}</div>}
                    {s.text && <div style={{fontSize:11,color:C.gray600,lineHeight:1.5}}>{s.text}</div>}
                  </Card>;
                })}
              </div>
              {latest.summary && <p style={{fontSize:12,color:C.gray600,fontStyle:"italic",lineHeight:1.6,marginTop:10}}>{latest.summary}</p>}
            </div>
          );
        })()}

        {/* Eval count + sign-up */}
        {playerReports.length>0 && (
          <Card style={{marginBottom:18,textAlign:"center",padding:30}}>
            <div style={{fontSize:32,color:C.coral,fontWeight:700,marginBottom:4}}>{playerReports.length}</div>
            <div style={{fontSize:12,color:C.gray500,letterSpacing:.5}}>BBOT Evaluation{playerReports.length===1?"":"s"} on File</div>
            <Btn v="primary" style={{marginTop:14}} onClick={onClose}>Sign Up for Full History</Btn>
          </Card>
        )}

        {/* Footer */}
        <div style={{textAlign:"center",padding:"20px 0",fontSize:10,color:C.gray400}}>
          Powered by BBOT · 643 Sports MGMT LLC
        </div>
      </div>
    </div>
  );
}

function SampleReportPage({go, setAuthMode}){
  return (
    <div style={{minHeight:"100vh",background:C.gray50}}>
      <div style={{background:C.navy,padding:"12px 16px",display:"flex",alignItems:"center",justifyContent:"space-between",position:"sticky",top:0,zIndex:50}}>
        <div onClick={function(){go("landing");}} style={{display:"flex",alignItems:"center",gap:10,cursor:"pointer"}}>
          <BbotMark tile="transparent" size={32}/>
          <div style={{color:C.white,fontSize:12,fontWeight:600,letterSpacing:.5}}>← Back to BBOT</div>
        </div>
        <Btn v="primary" style={{padding:"6px 14px",fontSize:12}} onClick={function(){setAuthMode("register");go("auth");}}>Create Profile</Btn>
      </div>

      <div style={{maxWidth:720,margin:"0 auto",padding:"24px 14px 40px"}}>
        <div style={{textAlign:"center",marginBottom:18}}>
          <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:22,letterSpacing:2,color:C.navy,marginBottom:6}}>SAMPLE REPORT</div>
          <div style={{fontSize:12,color:C.gray500,marginBottom:14}}>Real format · Anonymized player · Class of 2026 SS</div>
          <div style={{display:"inline-block",background:C.coralLight,color:C.coral,fontSize:10,fontWeight:700,padding:"4px 10px",borderRadius:99,letterSpacing:.5}}>EXAMPLE ONLY · NOT A REAL PLAYER</div>
        </div>

        {/* Sample uses the REAL ReportCard so it matches the live report format exactly
            (two-column tools, observations, chart, scout summary). Anonymized sample data. */}
        {/* THE SAMPLE IS THE PRODUCT, NOT A PICTURE OF IT (ruled 2026-08-16).

            What was here was a 35KB hand-written report object, and the comment above it said, in
            as many words, "Regenerate it from a current report whenever the format moves." The
            format moved repeatedly and it was never regenerated, so this page -- the one a
            prospective customer reads BEFORE PAYING -- ended up advertising "Hip-shoulder
            separation 27 degrees with stride 35%", a measurement MECHANICS_PLAYER_FACING=False has
            withheld from every real card since 2026-08-07. The shop window sold something the
            product is built to refuse.

            A promise to regenerate is a checklist. The sample is now BUILT from a live row through
            the same _card_data -> _card_render path every real card takes (_gt/_sample_build.py),
            it passes the same 15 surface rulings, and _gt/_sample_verify.py refuses it if it ever
            carries a refused measurement or drifts from the current template. It cannot advertise
            what the product will not deliver, because it IS what the product delivers. */}
        <iframe
          src="/sample-card.html"
          title="BBOT sample evaluation"
          style={{width:"100%",height:1120,border:"1px solid "+C.border,borderRadius:12,
                  background:C.white,display:"block"}}
        />

        {/* CTA */}
        <div style={{background:"linear-gradient(135deg,"+C.navy+","+C.navyMid+")",borderRadius:14,padding:20,textAlign:"center",color:C.white}}>
          <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:18,letterSpacing:1,marginBottom:6}}>GET A REAL EVALUATION</div>
          <div style={{fontSize:13,color:"rgba(255,255,255,.7)",marginBottom:16}}>Upload your session video. Evaluated by BBOT.</div>
          <div style={{display:"flex",gap:8,justifyContent:"center",flexWrap:"wrap"}}>
            <Btn v="primary" onClick={function(){setAuthMode("register");go("auth");}}>Create Free Profile</Btn>
            <Btn v="outlineW" onClick={function(){go("landing");}}>Back to Pricing</Btn>
          </div>
        </div>
      </div>
    </div>
  );
}

function PublicEventsSection({go, setAuthMode}){
  var evS=useState([]); var events=evS[0], setEvents=evS[1];
  var loadS=useState(true); var loading=loadS[0], setLoading=loadS[1];
  useEffect(function(){
    // READ THE PUBLIC VIEW, NOT THE TABLE. This is the LOGGED-OUT landing section, and `sbHeaders`
    // falls back to the anon key -- which reads zero rows from `bbot_events`, because that table
    // is RLS-protected and carries every registered minor's size, waiver and payment status. So
    // this section rendered nothing for exactly the visitors it exists for, and returned null on
    // empty, which hides the failure completely. `bbot_events_public` exposes published rows and
    // safe columns only. [[anon-caller-not-admin-view]]
    fetch(SUPABASE_URL+"/rest/v1/bbot_events_public?order=start_date.asc", {headers:sbHeaders()})
      .then(function(r){return r.json();})
      .then(function(rows){ setEvents(Array.isArray(rows)?rows:[]); setLoading(false); })
      .catch(function(){ setEvents([]); setLoading(false); });
  }, []);
  var today = new Date().toISOString().slice(0,10);
  // ANY LAUNCHED EVENT, NOT JUST PICKUP GAMES. This required event_type==="pickup_game", so a
  // showcase or a tryout could be Launched and still appear NOWHERE -- the admin's own publish
  // button did nothing visible, which is how the Perkiomen tryout stayed invisible after it went
  // live. `published` IS the decision, and it is already made in the admin tab; a second hidden
  // rule about the TYPE just means Launch cannot be trusted to mean launched.
  //
  // The view is pre-filtered to published rows, so there is no `published` flag to re-check here.
  var upcoming = (events||[]).filter(function(e){ return (!e.start_date || String(e.end_date||e.start_date) >= today); }).slice(0,6);
  if(loading || upcoming.length===0) return null;
  function fmt(d){ if(!d) return ""; var p=String(d).split("-"); return p.length===3?(p[1]+"/"+p[2]+"/"+p[0].slice(2)):d; }
  return (
    <Reveal><div style={{padding:"24px 18px 8px",maxWidth:900,margin:"0 auto"}}>
      <h2 style={{fontFamily:"Inter,system-ui,sans-serif",textAlign:"center",fontSize:22,letterSpacing:2,color:C.navy,marginBottom:6}}>UPCOMING EVENTS</h2>
      <p style={{textAlign:"center",fontSize:13,color:C.gray500,marginBottom:24}}>Get filmed, evaluated by BBOT, and take home a report. Create a profile to register.</p>
      <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(min(260px,100%),1fr))",gap:14}}>
        {upcoming.map(function(ev){
          var dateStr = ev.start_date ? (fmt(ev.start_date)+(ev.end_date&&ev.end_date!==ev.start_date?(" – "+fmt(ev.end_date)):"")) : "Date TBA";
          var costStr = ev.cost ? ("$"+String(ev.cost).replace(/[^0-9.]/g,"")) : "";
          return (
            <Card key={ev.id} className="lift" style={{padding:"18px 16px",borderTop:"3px solid "+C.coral}}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",gap:8,marginBottom:4}}>
                <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:15,color:C.navy,letterSpacing:.5}}>{ev.name||"Pickup Game"}</div>
                {costStr&&<span style={{padding:"3px 9px",background:C.coral,color:C.white,borderRadius:99,fontSize:12,fontWeight:700,flexShrink:0}}>{costStr}</span>}
              </div>
              <div style={{fontSize:11,color:C.gray500,marginBottom:10}}>{[dateStr, ev.start_time, (ev.venue||ev.location)].filter(Boolean).join(" · ")}</div>
              <div style={{fontSize:11,color:C.gray700,lineHeight:1.6,marginBottom:12}}>
                <div>✓ Performance video + BBOT report</div>
                <div>✓ Event jersey included</div>
                <div>✓ 5 at-bats / pitchers 6 batters faced</div>
              </div>
              {/* GO TO THE EVENT, NOT STRAIGHT TO SIGNUP. Sending someone to the auth screen from
                  here skipped the event page entirely -- so nothing recorded WHICH event they
                  came for, and after signing up they landed on a generic home feed. Routing
                  through #event/<id> is the same path a QR code takes, so every entry point
                  remembers the event and returns to it. One journey, however it is entered. */}
              <Btn v="coral" style={{fontSize:12,padding:"8px 16px",width:"100%",justifyContent:"center"}}
                onClick={function(){
                  if(typeof window!=="undefined"){
                    window.__bbotPendingEventId = String(ev.id);
                    window.location.hash = "#event/"+encodeURIComponent(String(ev.id));
                  }
                }}>View event &amp; register</Btn>
            </Card>
          );
        })}
      </div>
    </div></Reveal>
  );
}

// THE SHAREABLE EVENT PAGE — what a QR code points at.
//
// IT MUST RENDER FOR SOMEONE WITH NO ACCOUNT, because that is the entire point: a parent scans a
// code on a flyer, reads what the event is, and decides. So it reads `bbot_events_public`, a view
// that exposes only published events and only the columns a stranger may see. It never touches
// `bbot_events`, which carries every registered minor's size, waiver and payment status.
//
// WHO IS REGISTERED IS A COUNT, NEVER A LIST. `registered_count` is computed inside the view, so
// no identity crosses the boundary even if this component is wrong.
//
// THE REGISTRATION PATH IS THE SAME ONE THE SITE ALREADY USES. No player can register without a
// profile, so a visitor with no account is sent to signup with the event remembered
// (`__bbotPendingEventId`) and comes back to this page with the modal open. A logged-in player
// goes straight to the modal. One flow, two entry points, no second registration code path.
function PublicEventView({eventId, cu, go, setAuthMode, onClose, onRegister}){
  var evS=useState(null); var ev=evS[0], setEv=evS[1];
  var stS=useState("loading"); var st=stS[0], setSt=stS[1];   // loading | ok | missing | error
  useEffect(function(){
    if(!eventId) return;
    var dead=false;
    fetch(SUPABASE_URL+"/rest/v1/bbot_events_public?id=eq."+encodeURIComponent(String(eventId))+"&limit=1",
          {headers:sbHeaders()})
      .then(function(r){ if(!r.ok) throw new Error("HTTP "+r.status); return r.json(); })
      .then(function(rows){
        if(dead) return;
        // AN EMPTY RESULT IS NOT AN ERROR AND NOT A BLANK PAGE. The view only carries PUBLISHED
        // events, so "no row" means the organiser has not launched it (or the link is wrong), and
        // the page says which rather than rendering nothing. [[absence-is-not-a-finding]]
        if(Array.isArray(rows)&&rows.length){ setEv(rows[0]); setSt("ok"); }
        else setSt("missing");
      })
      .catch(function(){ if(!dead) setSt("error"); });
    return function(){ dead=true; };
  },[eventId]);

  function fmt(d){ if(!d) return ""; var p=String(d).split("-"); return p.length===3?(p[1]+"/"+p[2]+"/"+p[0].slice(2)):d; }
  // "COST · 0" READS AS BROKEN. `cost` is a free-text admin field and arrives as "0", "$0",
  // "$100 Position Players / $75 Pitchers" or empty. A bare zero looks like a missing value
  // rather than a free event, which is the one case where getting it wrong costs a registration.
  // Anything with no digits at all, or whose digits are all zero, IS free and says so; anything
  // else is the admin's own wording and is passed through untouched -- a split price must not be
  // mangled by a formatter trying to be clever.
  function costLabel(raw){
    var s=String(raw==null?"":raw).trim();
    if(!s) return null;
    var nums=s.match(/\d+(?:\.\d+)?/g);
    if(!nums) return s;
    var allZero=nums.every(function(n){ return parseFloat(n)===0; });
    if(allZero) return "Free";
    return /^\s*\d+(?:\.\d+)?\s*$/.test(s) ? ("$"+s) : s;   // bare number -> add the sign
  }
  // NO 100vh. The page sits ABOVE the site footer, so forcing it to a full viewport left a tall
  // empty band between the card and the footer -- which on a phone reads as a page that failed
  // to finish loading. It takes the height its content needs.
  var wrap={background:C.gray50,padding:"28px 16px 36px"};
  var inner={maxWidth:560,margin:"0 auto"};

  if(st==="loading") return <div style={wrap}><div style={inner}><Card style={{padding:28,textAlign:"center",color:C.gray500,fontSize:13}}>Loading event…</Card></div></div>;
  if(st!=="ok"){
    return <div style={wrap}><div style={inner}><Card style={{padding:28,textAlign:"center"}}>
      <BbotMark size={44} tile="transparent"/>
      <div style={{fontSize:15,fontWeight:700,color:C.navy,margin:"14px 0 6px"}}>
        {st==="missing"?"This event isn’t open yet":"Couldn’t load this event"}</div>
      <div style={{fontSize:13,color:C.gray500,lineHeight:1.6,marginBottom:16}}>
        {st==="missing"
          ? "The organiser hasn’t launched it, or the link is out of date. Check with 643 Sports MGMT."
          : "Something went wrong fetching it. Try again in a moment."}</div>
      <Btn v="ghost" onClick={onClose}>Go to 643 BBOT</Btn>
    </Card></div></div>;
  }

  var dateStr = ev.start_date ? (fmt(ev.start_date)+(ev.end_date&&ev.end_date!==ev.start_date?(" – "+fmt(ev.end_date)):"")) : "Date TBA";
  // Registration stays open until the organiser un-launches the event -- the 14-day cutoff was
  // ruled off 2026-10-08. An unpublished event never reaches this page at all, because the public
  // view carries published rows only, so "closed" has exactly one meaning now.
  var closed = false;
  var isPlayer = cu && cu.type==="player";

  return (
    <div style={wrap}><div style={inner}>
      {/* THE REAL MARKS, NOT THE DRAWN ONE. `BbotMark` strokes WHITE and expects a navy or blue
          tile behind it; with tile="transparent" on this page's light grey it was white-on-white
          and read as a broken, distorted logo. These are the same two PNGs the branded emails
          carry -- the 643 wordmark and the BBOT badge -- served from our own domain, so a
          stranger scanning a QR code sees the mark they will see everywhere else. */}
      <div style={{display:"flex",alignItems:"center",justifyContent:"center",gap:12,marginBottom:16}}>
        <img src="/brand/logo-643.png" alt="643 Sports MGMT" width="46" height="46"
          style={{display:"block",border:0}}/>
        <img src="/brand/logo-bbot.png" alt="BBOT" width="34" height="34"
          style={{display:"block",border:0}}/>
      </div>
      <Card style={{padding:0,overflow:"hidden",borderTop:"3px solid "+C.coral}}>
        {/* THE GALLERY, SIZED BY A FIXED BOX RATHER THAN BY THE PICTURE.
            `maxHeight` alone lets a tall flyer set its own height until the clamp bites, which is
            why a portrait photo read as huge. A fixed-height strip with object-fit cover gives
            every picture the same box whatever shape it was shot in, and the row scrolls sideways
            instead of growing downwards. Falls back to the single cover for events that predate
            the gallery column. */}
        {(function(){
          var pics = Array.isArray(ev.image_urls)&&ev.image_urls.length ? ev.image_urls
                   : (ev.image_url ? [ev.image_url] : []);
          if(!pics.length) return null;
          if(pics.length===1) return <img src={pics[0]} alt="" style={{width:"100%",height:190,objectFit:"cover",display:"block",background:C.gray100}}/>;
          return (
            <div style={{display:"flex",gap:4,overflowX:"auto",WebkitOverflowScrolling:"touch",background:C.gray100}}>
              {pics.map(function(src,i){
                return <img key={i} src={src} alt={"event picture "+(i+1)}
                  style={{height:190,width:pics.length===2?"50%":"72%",flex:"0 0 auto",objectFit:"cover",display:"block"}}/>;
              })}
            </div>
          );
        })()}
        <div style={{padding:"18px 18px 20px"}}>
          <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:19,color:C.navy,lineHeight:1.25,marginBottom:6}}>{ev.name||"643 Event"}</div>
          <div style={{fontSize:12.5,color:C.gray600,lineHeight:1.7,marginBottom:14}}>
            <div><b>When</b> · {[dateStr,ev.start_time].filter(Boolean).join(" at ")}</div>
            {(ev.venue||ev.location) && <div><b>Where</b> · {[ev.venue,ev.location].filter(Boolean).join(", ")}</div>}
            {costLabel(ev.cost) && <div><b>Cost</b> · {costLabel(ev.cost)}</div>}
            {ev.requirements && <div><b>Bring / wear</b> · {ev.requirements}</div>}
          </div>
          {ev.notes && <div style={{fontSize:12.5,color:C.gray700,lineHeight:1.65,background:C.gray50,
            borderLeft:"3px solid "+C.blue,padding:"10px 12px",borderRadius:"0 8px 8px 0",marginBottom:14}}>{ev.notes}</div>}
          <div style={{fontSize:11.5,color:C.gray500,marginBottom:14}}>
            {(ev.registered_count||0)} registered
          </div>
          {closed ? (
            <div style={{fontSize:12.5,color:C.coral,fontWeight:700,textAlign:"center",padding:"10px 0"}}>
              Registration has closed for this event.
            </div>
          ) : isPlayer ? (
            <Btn v="coral" style={{width:"100%",justifyContent:"center"}} onClick={function(){ onRegister(ev); }}>Register for this event</Btn>
          ) : cu ? (
            <div style={{fontSize:12.5,color:C.gray500,textAlign:"center",padding:"8px 0",lineHeight:1.6}}>
              You’re signed in as a {cu.type}. Only player profiles can register for events.
            </div>
          ) : (
            // TWO DOORS, BOTH NAMED, BOTH RETURNING HERE. A visitor arrives in one of exactly two
            // states -- they have a BBOT profile or they do not -- and the page has to answer both
            // without making anyone guess which button is theirs. Whichever they take, signup and
            // sign-in BOTH route a player straight back to this event with registration open.
            <div>
              <Btn v="coral" style={{width:"100%",justifyContent:"center"}}
                onClick={function(){ setAuthMode("register"); go("auth"); }}>
                I’m new — create a profile &amp; register
              </Btn>
              <Btn v="outline" style={{width:"100%",justifyContent:"center",marginTop:8}}
                onClick={function(){ setAuthMode("login"); go("auth"); }}>
                I already have a profile — sign in &amp; register
              </Btn>
              <div style={{fontSize:11.5,color:C.gray500,textAlign:"center",marginTop:10,lineHeight:1.6}}>
                Every player needs a BBOT profile to register. Either way you’ll come straight back
                to this event.
              </div>
            </div>
          )}
        </div>
      </Card>
      {/* THE WAY OUT IS NOT THE WAY IN. This read "Browse 643 BBOT", which is a vague escape
          hatch sitting where a reader looks for the next step -- and for a signed-in staff or
          coach it was the ONLY action on the page. The registration doors live in the card above;
          this is just the exit, and it says so. */}
      <div style={{textAlign:"center",marginTop:14}}>
        <button onClick={onClose} style={{background:"none",border:"none",color:C.gray400,fontSize:11.5,cursor:"pointer"}}>
          {cu ? "Go to my BBOT dashboard" : "Not registering? Visit 643sportsmgmt.com"}
        </button>
      </div>
    </div></div>
  );
}

// A PUBLISHED SESSION REPORT, OPENABLE BY ANYONE WITH THE LINK.
//
// Reports were signed-in only, which makes a published report useless as the thing it is: the
// audience for a session recap -- a parent, a travel coach, a college recruiter -- is exactly the
// audience that has no BBOT account. The blog already had a logged-out route for the same reason;
// reports did not.
//
// Reads `bbot_recaps_public`, which carries PUBLISHED rows and only the fields the article
// renders. A draft, with unreviewed prose about named minors, never reaches this component.
function PublicRecapView({recapId, users, go, onClose}){
  var rS=useState(null); var rec=rS[0], setRec=rS[1];
  var stS=useState("loading"); var st=stS[0], setSt=stS[1];
  useEffect(function(){
    if(!recapId) return;
    var dead=false;
    fetch(SUPABASE_URL+"/rest/v1/bbot_recaps_public?id=eq."+encodeURIComponent(String(recapId))+"&limit=1",
          {headers:sbHeaders()})
      .then(function(r){ if(!r.ok) throw new Error("HTTP "+r.status); return r.json(); })
      .then(function(rows){
        if(dead) return;
        if(Array.isArray(rows)&&rows.length){ setRec(rows[0]); setSt("ok"); } else setSt("missing");
      })
      .catch(function(){ if(!dead) setSt("error"); });
    return function(){ dead=true; };
  },[recapId]);

  var wrap={background:C.gray50,padding:"28px 16px 40px"};
  if(st==="loading") return <div style={wrap}><div style={{maxWidth:760,margin:"0 auto"}}><Card style={{padding:28,textAlign:"center",color:C.gray500,fontSize:13}}>Loading report…</Card></div></div>;
  if(st!=="ok") return (
    <div style={wrap}><div style={{maxWidth:760,margin:"0 auto"}}><Card style={{padding:28,textAlign:"center"}}>
      <img src="/brand/logo-bbot.png" alt="BBOT" width="40" height="40" style={{display:"inline-block",border:0}}/>
      <div style={{fontSize:15,fontWeight:700,color:C.navy,margin:"14px 0 6px"}}>
        {st==="missing"?"This report isn’t published":"Couldn’t load this report"}</div>
      <div style={{fontSize:13,color:C.gray500,lineHeight:1.6,marginBottom:16}}>
        {st==="missing"
          ? "It may still be a draft, or the link is out of date."
          : "Something went wrong fetching it. Try again in a moment."}</div>
      <Btn v="ghost" onClick={onClose}>Go to 643 BBOT</Btn>
    </Card></div></div>
  );

  // THE ARTICLE IS THE ONE THE SIGNED-IN SITE ALREADY DRAWS. RecapArticle owns the blog-template
  // measurements; rebuilding them here would be a second copy that drifts the first time either
  // is edited. It is handed `cu:null`, so the clip gate inside it requests no URL for anything a
  // stranger may not watch. [[one-home-per-value]]
  var shaped = {id:rec.id, title:rec.title, summary:rec.summary, date:rec.date,
                sessionType:rec.session_type,
                // The cover the admin set. Lifted out of full_data by the view like every other
                // display field, so a key added to that blob stays private until named there.
                coverImage:rec.cover_image||"",
                standouts:Array.isArray(rec.standouts)?rec.standouts:[]};
  return (
    <div style={wrap}>
      <div style={{maxWidth:760,margin:"0 auto"}}>
        <div style={{display:"flex",alignItems:"center",justifyContent:"center",gap:12,marginBottom:18}}>
          <img src="/brand/logo-643.png" alt="643 Sports MGMT" width="46" height="46" style={{display:"block",border:0}}/>
          <img src="/brand/logo-bbot.png" alt="BBOT" width="34" height="34" style={{display:"block",border:0}}/>
        </div>
        <RecapArticle r={shaped} users={users||[]} scoutReports={[]} cu={null} go={go}/>
        {/* THE PUBLIC SESSION REPORT IS A SECOND RENDER PATH, and the first mount missed it.
            `RecapArticle` is drawn twice in this file: once inside RecapsPage for a signed-in
            admin, and once here for anyone holding a share link. I mounted the footer on the first
            only, so Luis opened a session report and saw nothing -- on the path that matters most,
            since the shared link is the one a parent actually receives. Both now carry it. */}
        <FlyerFooter/>
        <div style={{textAlign:"center",marginTop:18}}>
          <button onClick={onClose} style={{background:"none",border:"none",color:C.gray400,fontSize:11.5,cursor:"pointer"}}>
            More from 643 Sports MGMT
          </button>
        </div>
      </div>
    </div>
  );
}

function Landing({go,setAuthMode,siteContent}){
  siteContent=siteContent||{};
  return(
    <div style={{minHeight:"100vh",background:C.white}}>
      <div style={{background:C.navy,padding:"12px 18px",display:"flex",justifyContent:"space-between",alignItems:"center",position:"sticky",top:0,zIndex:100}}>
        <div style={{display:"flex",alignItems:"center",gap:10}}>
          <BbotMark tile="transparent" size={30}/>
          <span style={{fontFamily:"Inter,system-ui,sans-serif",color:C.white,fontSize:14,letterSpacing:2,display:"none"}} className="hide-mobile">643 BASEBALL PROFILES</span>
        </div>
        <div style={{display:"flex",gap:8}}>
          <Btn v="outlineW" style={{padding:"7px 14px",fontSize:13}} onClick={function(){setAuthMode("login");go("auth");}}>Sign In</Btn>
          <Btn v="primary" style={{padding:"7px 14px",fontSize:13}} onClick={function(){setAuthMode("register");go("auth");}}>Create Profile</Btn>
        </div>
      </div>
      <div style={{background:"linear-gradient(150deg,"+C.navy+" 0%,"+C.navyMid+" 60%,#2f54a8 100%)",padding:"clamp(36px,8vw,60px) 18px clamp(32px,6vw,52px)",textAlign:"center",color:C.white,position:"relative",overflow:"hidden"}}>
        <div style={{position:"absolute",inset:0,background:"radial-gradient(ellipse 70% 50% at 50% 0%, rgba(37,99,235,.12) 0%, transparent 70%)",pointerEvents:"none"}}/>
        <div style={{position:"relative"}}>
          <div style={{display:"flex",flexDirection:"column",justifyContent:"center",alignItems:"center",gap:10,marginBottom:22}}>
            <BbotMark size={96} tile="transparent"/>
            <div style={{textAlign:"center",lineHeight:1.1}}>
              <div style={{fontFamily:"Inter,system-ui,sans-serif",fontWeight:700,fontSize:"clamp(34px,9vw,56px)",letterSpacing:"-0.03em",color:C.white}}>BB<span style={{color:C.coral}}>O</span>T</div>
              <div style={{fontFamily:"Inter,system-ui,sans-serif",fontWeight:500,fontSize:"clamp(11px,3vw,14px)",letterSpacing:"0.04em",color:"rgba(255,255,255,.7)",marginTop:4}}>by <span style={{fontWeight:700,color:C.white}}>643</span> Sports MGMT</div>
            </div>
          </div>
          <h1 style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:"clamp(28px,6vw,54px)",fontWeight:700,letterSpacing:"clamp(1px,.6vw,3px)",marginBottom:12,lineHeight:1.08,color:C.white}}>{siteContent.landingHeadline||"Verified evaluations from a single session."}</h1>
          <div style={{display:"flex",alignItems:"center",justifyContent:"center",gap:10,marginBottom:18}}>
            <div style={{height:1,width:36,background:"rgba(255,255,255,.2)"}}/>
            <span style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:"clamp(13px,2.8vw,17px)",fontWeight:600,color:C.coral,letterSpacing:"clamp(2px,1vw,4px)"}}>BASEBALL PROFILES</span>
            <div style={{height:1,width:36,background:"rgba(255,255,255,.2)"}}/>
          </div>
          <p style={{maxWidth:480,margin:"0 auto 28px",color:"rgba(255,255,255,.85)",fontSize:"clamp(14px,2vw,16px)",lineHeight:1.7,padding:"0 12px"}}>{siteContent.landingSubtext||siteContent.landingSub||"Upload a radar-backed session. Get back device-verified measurements, clean measured results, and a recruiter-ready report."}</p>
          <div style={{display:"flex",flexDirection:"column",alignItems:"center",gap:12,padding:"0 12px",width:"100%"}}>
            <Btn v="coral" style={{fontSize:15,padding:"16px 0",boxShadow:"0 4px 14px rgba(232,82,106,.45)",borderRadius:12,width:"100%",maxWidth:300,justifyContent:"center"}} onClick={function(){setAuthMode("register");go("auth");}}>Create a FREE Profile</Btn>
            <Btn v="outlineW" style={{fontSize:15,padding:"15px 0",borderRadius:12,width:"100%",maxWidth:300,justifyContent:"center"}} onClick={function(){setAuthMode("login");go("auth");}}>Sign In</Btn>
          </div>
        </div>
      </div>
      <div style={{background:C.navy,padding:"28px 20px"}}>
        <div style={{maxWidth:800,margin:"0 auto",display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(min(140px,45%),1fr))",gap:"26px 16px",justifyItems:"center"}}>
          {[["G","Measured Results","Clean visuals of every captured tool"],["P","Progression","Track results over time"],["M","Measurements","Verified velo, pop, exit velo"],["S","Shareable","Public link + embed"]].map(function(item){return(
            <div key={item[1]} style={{textAlign:"center",maxWidth:160,padding:"0 4px"}}>
              <div style={{margin:"0 auto 8px",display:"inline-flex"}}><BbotMark size={40}/></div>
              <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:13,color:C.white,fontWeight:600,letterSpacing:.6,lineHeight:1.25}}>{item[1]}</div>
              <div style={{fontSize:11,color:"rgba(255,255,255,.82)",marginTop:4,lineHeight:1.4}}>{item[2]}</div>
            </div>
          );})}
        </div>
      </div>

      {/* EVALUATION TYPES */}
      <Reveal><div style={{padding:"40px 18px 24px",maxWidth:900,margin:"0 auto"}}>
        {/* ONE PRODUCT IS SOLD HERE. The page advertised a cumulative evaluation beside the session
            card, but that product is admin-triggered and cannot be bought from this page -- so the
            landing sold something a visitor could not obtain. The session evaluation stands alone;
            the cumulative card returns when it is genuinely purchasable. */}
        <h2 style={{fontFamily:"Inter,system-ui,sans-serif",textAlign:"center",fontSize:22,letterSpacing:2,color:C.navy,marginBottom:6}}>THE SESSION EVALUATION</h2>
        <p style={{textAlign:"center",fontSize:13,color:C.gray500,marginBottom:24}}>Upload one session. Get every measured tool, the observations, and your stamped clips. <span style={{color:C.navy,fontWeight:700}}>${BBOT_PRICE_SESSION_USD.toFixed(2)}.</span></p>
        <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(min(260px,100%),1fr))",gap:14,marginBottom:20}}>
          <Card className="lift" style={{padding:"22px 20px",borderTop:"3px solid "+C.blue,textAlign:"center"}}>
            <div style={{fontSize:11,letterSpacing:1.2,color:C.gray500,fontWeight:600,marginBottom:6}}>INDIVIDUAL SESSION EVALUATION</div>
            <div style={{fontSize:12,color:C.gray500,marginBottom:14,lineHeight:1.5}}>One session — measured results on every captured tool, scouting observations, charts, and stamped clips.</div>
            <div style={{fontSize:11,color:C.gray700,lineHeight:1.8,textAlign:"left"}}>
              ✓ Measured results on every captured tool<br/>
              ✓ Clean visuals + progression tracking<br/>
              ✓ Every measured mark, with what it came from<br/>
              ✓ Spray / pitch chart + stamped video clips
            </div>
          </Card>
        </div>
        <div style={{textAlign:"center",display:"flex",gap:10,justifyContent:"center",flexWrap:"wrap"}}>
          <Btn v="outline" style={{fontSize:13,padding:"12px 24px"}} onClick={function(){go("sample-report");}}>View Sample Report</Btn>
          <Btn v="primary" style={{fontSize:13,padding:"12px 24px"}} onClick={function(){go("for-coaches");}}>For Coaches & Scouts →</Btn>
        </div>
      </div></Reveal>

      {/* #5 PUBLIC EVENTS — posted on the landing page with a register link to drive interest */}
      <PublicEventsSection go={go} setAuthMode={setAuthMode}/>

      <Reveal><div style={{padding:"24px 18px 48px",maxWidth:900,margin:"0 auto"}}>
        <h2 style={{fontFamily:"Inter,system-ui,sans-serif",textAlign:"center",fontSize:22,letterSpacing:2,marginBottom:28,color:C.coral}}>{siteContent.whatBbotDelivers||"WHAT BBOT DELIVERS"}</h2>
        <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(min(200px,100%),1fr))",gap:16}}>
          {[
            ["G","Measured Results","Clean, aesthetic visuals of every captured tool."],
            ["P","Progression","Track results across sessions over time."],
            ["C","Charts","Position-aware spray or pitch chart with every eval."],
            ["V","Compare","Coaches stack up to 10 players side-by-side on tools + metrics."],
          ].map(function(item){
            return(
            <Card key={item[1]} style={{padding:"16px 18px"}}>
              <div style={{display:"flex",alignItems:"center",gap:14}}>
                <div style={{flexShrink:0,textAlign:"center"}}>
                  <div style={{display:"inline-flex"}}><BbotMark size={40}/></div>
                </div>
                <div>
                  <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:14,color:C.gray900,marginBottom:4,letterSpacing:.5}}>{item[1]}</div>
                  <div style={{fontSize:13,color:C.gray500,lineHeight:1.6}}>{item[2]}</div>
                </div>
              </div>
            </Card>
            );
          })}
        </div>
      </div></Reveal>
    </div>
  );
}


function Auth({mode,setMode,users,setUsers,setCu,go,notify,adminUser,setPublicEventId}){
  const [form,setForm]=useState({firstName:"",lastName:"",email:"",password:"",type:"player",coachRole:"",orgName:"",complianceAck:false});
  var setF=function(k,v){setForm(function(p){var o=Object.assign({},p);o[k]=v;return o;});};
  // GUARDIAN ATTESTATION STATE. Whether this setup link owes an attestation is answered by the
  // SERVER from the token, never from a URL flag — a query parameter can be appended to anybody's
  // password-reset link, and then the attestation screen appears for accounts it has nothing to do
  // with. null = not asked yet, so the form does not flash the wrong shape while it loads.
  const [gStatus,setGStatus]=useState(null);
  const [gTry,setGTry]=useState(0);
  // IT FAILED OPEN, AND THE ONE THING IT GUARDS IS A MINOR'S CONSENT.
  //
  // Both the non-ok branch and the .catch resolved to {needsAttestation:false} -- so a 500, a
  // dropped connection or a cold backend produced the PLAIN PASSWORD SCREEN. The guardian sets a
  // password, the account opens, and no consent row is ever written: the exact outcome the
  // attestation exists to prevent, reached by the network having a bad second. An unknown answer is
  // not "no". [[absence-is-not-a-finding]]
  //
  // AND `null` FELL THROUGH TOO. The comment above says null means "not asked yet, so the form does
  // not flash the wrong shape" -- but the render tested `gStatus && gStatus.needsAttestation`, so
  // while the answer was in flight it drew SET A NEW PASSWORD. The intent was written down and
  // never implemented; the render waits now.
  //
  // RETRY FIRST, BECAUSE MOST FAILURES ARE A BLIP. Three attempts with backoff, then a stated error
  // and a retry button -- never the password form. Nobody is silently let past, and nobody is
  // permanently stuck on a transient fault either.
  useEffect(function(){
    if(mode!=="recovery") return;
    var tok=bbotRecoveryToken();
    if(!tok){ setGStatus({needsAttestation:false}); return; }
    var dead=false, tries=0;
    function ask(){
      tries++;
      fetch(BACKEND_URL+"/guardian-status",{headers:{Authorization:"Bearer "+tok}})
        .then(function(r){
          if(!r.ok) throw new Error("guardian-status HTTP "+r.status);
          return r.json();
        })
        .then(function(j){
          if(dead) return;
          setGStatus(j||{needsAttestation:false});
          if(j&&j.guardianEmail) setF("gEmail",j.guardianEmail);
        })
        .catch(function(err){
          if(dead) return;
          if(tries<3){ setTimeout(ask, 900*tries); return; }
          try{ console.warn("guardian-status failed after 3 tries:", err && err.message); }catch(e){}
          setGStatus({error:true});
        });
    }
    ask();
    return function(){ dead=true; };
  },[mode,gTry]);
  var COACH_ROLES = [
    "HS Coach",
    "Travel Coach",
    "College Coach",
    "MLB Scout",
    "Recruiting Coordinator",
    "Cross-checker",
    "Analytics Staff",
    "Player Development"
  ];
  function submit(){
    if(mode==="login"){
      // SECURE LOGIN via Supabase Auth. We no longer match a plain-text password list.
      // On success, attach the user's profile (name/type/etc.) loaded from bbot_users.
      var email=(form.email||"").trim().toLowerCase();
      if(!email||!form.password) return notify("Enter your email and password","error");
      notify("Signing in…");
      bbotSignIn(email, form.password).then(function(sess){
        // RACE FIX: the in-memory `users` list is loaded asynchronously at boot. Signing in before it
        // resolved meant this find() missed, we fell through to the minimal placeholder below, and the
        // user landed with a fabricated id and no profile — everything keyed on their real id (reports,
        // clips, profile) came up empty until a manual refresh. Resolve the profile from the SOURCE
        // instead, falling back to the list, and only then to the placeholder.
        return sbSelect("bbot_users", "?select=*&limit=1&email=eq." + encodeURIComponent(email))
          .then(function(rows){ return (rows && rows.length) ? mapUserRow(rows[0]) : null; })
          .catch(function(){ return null; })
          .then(function(fetched){ return finishLogin(sess, fetched); });
      }).catch(function(err){
        notify((err&&err.message)?err.message:"Invalid email or password","error");
      });

      function finishLogin(sess, fetched){
        var u = fetched || (users||[]).find(function(x){return (x.email||"").toLowerCase()===email;});
        // keep the freshly-fetched row in the list too, so the rest of the app sees it immediately
        if(fetched) setUsers(function(all){
          var others=(all||[]).filter(function(x){return String(x.id)!==String(fetched.id);});
          return others.concat([fetched]);
        });
        if(!u){
          // Auth succeeded but no profile row yet — build a minimal one so the app works;
          // the profile fields fill in once bbot_users finishes loading / on profile edit.
          //
          // TYPE IS NOT ASSUMED TO BE "player" ANY MORE. Anon cannot read bbot_users at all
          // (RLS), so this branch fires whenever the row lookup comes back empty for any
          // reason — a token not yet written, a slow network, a transient 4xx. It then handed
          // an ADMIN a `type:"player"` object, and because the boot effect below starts with
          // `if(cu) return;` nothing ever corrected it: the admin spent the whole session as a
          // player. That is the "old dashboard" an admin sees while every server-side check
          // says he is an admin. A known admin email is staff here, and `_synthetic` marks the
          // object so the real row can replace it the moment it loads.
          // [[absent-capability-reads-as-legitimate-absence]]
          u={id:(sess.user&&sess.user.id)||Date.now(), email:email, firstName:(email.split("@")[0]||"User"),
             lastName:"", type:(bbotIsAdmin(email)?"staff":"player"), _synthetic:true,
             followers:[], following:[], profileViews:[], notifications:[]};
        }
        var _isAdm=bbotIsAdmin(email);
        var _isStf=u.type==="staff";
        var _pending=u.approvalStatus==="pending";
        // Pending accounts always land on home (where the unified pending banner shows),
        // never on the staff/admin work screens.
        setCu(u);
        // CAME FOR AN EVENT? GO BACK TO IT -- the same rule signup already follows. A player who
        // scanned a QR code, tapped "Already have a profile? Sign in" and then landed on the home
        // feed has been dropped one step from the thing they came to do, and has to find the
        // event again. Admins and staff keep their own landings; only a PLAYER is mid-errand.
        var _evId = (typeof window!=="undefined") ? window.__bbotPendingEventId : null;
        if(_evId && u.type==="player"){
          try{ window.location.hash = "#event/"+encodeURIComponent(String(_evId)); }catch(_e){}
          if(typeof setPublicEventId==="function") setPublicEventId(String(_evId));
          go("landing");
          notify("Welcome back, "+(u.firstName||"")+" — you can register below.","welcome");
        } else {
          go(_pending?"home":_isAdm?"admin":_isStf?"run-bbot":"home"); notify("Welcome back, "+(u.firstName||"")+"!","welcome");
        }
      }
    }else{
      var email=(form.email||"").trim().toLowerCase();
      if(!form.firstName||!form.lastName||!email||!form.password)return notify("Please fill all fields","error");
      if(form.password.length<8) return notify("Password must be at least 8 characters","error");
      if(users.find(function(u){return (u.email||"").toLowerCase()===email;}))return notify("Email already in use","error");
      if(form.type==="player"){
        // DOB is MANDATORY for players — BBOT grades by age bracket and
        // gathers age-based percentiles, so a player cannot exist without a valid DOB.
        if(!form.dob) return notify("Date of birth is required","error");
        var _d=new Date(form.dob);
        if(isNaN(_d.getTime())) return notify("Please enter a valid date of birth","error");
        if(_d.getTime()>Date.now()) return notify("Date of birth cannot be in the future","error");
        var _yrs=(Date.now()-_d.getTime())/(365.25*24*3600*1000);
        if(_yrs<5||_yrs>50) return notify("Please check the date of birth — it looks out of range","error");
        // GUARDIAN CONSENT IS ENFORCED, NOT OPTIONAL. The Terms already state that under-18 users
        // require verified parent or legal guardian consent before account creation. The product
        // collected DOB — so it always knew who was a minor — and enforced nothing, publishing a
        // commitment it did not keep. From here a minor account cannot be created without a consent
        // record: the site does what its Terms say.
        if(_yrs<18){
          if(!String(form.guardianName||"").trim())
            return notify("Parent/guardian name is required for players under 18","error");
          if(!String(form.guardianRelationship||"").trim())
            return notify("Please state the guardian's relationship to the player","error");
          if(!form.guardianConsent)
            return notify("Parent/guardian consent is required for players under 18","error");
        }
      }
      if(form.type==="coach"){
        if(!form.coachRole) return notify("Please select your role","error");
        if(!form.complianceAck) return notify("You must acknowledge the compliance terms","error");
      }
      if(form.type==="staff"){
        if((form.staffPasscode||"").trim()!==STAFF_PASSCODE) return notify("Invalid staff passcode","error");
      }
      var extra={};
      // GUARDIAN CONSENT IS NOW KEPT, NOT JUST DEMANDED. The under-18 check above has always
      // refused to submit without a guardian name, a relationship and a ticked box -- and all three
      // were then dropped on the floor. Nothing was written to the profile, nothing to
      // bbot_guardian_consents (which held zero rows), while the comment above the check claimed a
      // consent record existed and the Terms promised verified consent. The enforcement was real
      // and visible, so it read as working; only the STORAGE was missing, and missing storage
      // announces itself to nobody. These three fields now travel with the profile.
      if(form.type==="player")extra={dob:form.dob||"",gradYear:"",hsName:"",clubName:"",position:"",height:"",weight:"",gpa:"",videos:[],bio:"",followers:[],following:[],
        guardianName:(form.guardianName||"").trim()||null,
        guardianRelationship:(form.guardianRelationship||"")||null,
        // THE FIELD THE SERVER ACTUALLY CHECKS. /user-save refuses an under-18 profile unless
        // `guardianConsent` is truthy -- and this payload sent guardianConsentAt and
        // guardianConsentText, never `guardianConsent` itself. The key appeared ZERO times.
        //
        // WHAT THAT COST: every under-18 self-registration since the server gate shipped got a
        // 403 from /user-save AFTER bbotSignUp had already created the auth account and
        // bbotSignIn had signed them in. The player sees a working profile -- the session object
        // is real -- while no bbot_users row exists. Diego Diaz, 16, registered 2026-10-22 and
        // was invisible on every admin surface because there was no row to find; three orphan
        // auth accounts were swept the same day.
        //
        // The two timestamp/text fields stay: they are the RECORD of what was agreed and when,
        // which is the thing [[guardian-consent-never-recorded]] exists about. This adds the
        // BOOLEAN the gate reads. Fix the client to send it -- never loosen the server, which is
        // enforcing a Terms promise the browser alone cannot keep.
        guardianConsent:!!form.guardianConsent,
        guardianConsentAt:(form.guardianConsent?new Date().toISOString():null),
        guardianConsentText:(form.guardianConsent?GUARDIAN_CONSENT_TEXT:null)};
      else if(form.type==="staff")extra={orgName:"643 Sports MGMT LLC",orgState:"PR",staffRole:"",title:"",phone:"",bio:"",staffApproved:false,followers:[],following:[]};
      else extra={
        coachRole:form.coachRole,
        level:form.coachRole==="College Coach"?"College":form.coachRole==="HS Coach"?"HS":form.coachRole==="Travel Coach"?"Travel":"Other",
        orgName:form.orgName||"",orgState:"",coachPosition:"",
        verified:false,
        verificationStatus:"pending",
        complianceAcknowledged:true,
        complianceAckDate:new Date().toISOString(),
        followers:[],following:[]
      };
      // Build the profile WITHOUT a password — the password lives only in Supabase Auth.
      // EVERY new profile starts pending admin approval. This protects the site from spam
      // signups and maliciously-triggered backend costs: a pending account cannot run evals,
      // upload, or trigger any paid work until an admin approves it.
      var nu={id:Date.now(),type:form.type,...extra,firstName:form.firstName,lastName:form.lastName,email:email,profileViews:[],notifications:[],approvalStatus:"pending",createdAt:new Date().toISOString()};
      // Team invite: if player arrived via a coach's #join link, tag them to that coach.
      if(form.type==="player" && typeof window!=="undefined" && window.__bbotInviteCoachId){
        nu.invitedByCoachId = String(window.__bbotInviteCoachId);
        nu.followers = [Number(window.__bbotInviteCoachId)].filter(function(x){return !isNaN(x);});
      }
      notify("Creating your account…");
      // 1) Create the secure auth account, 2) sign in, 3) save the profile (no password).
      // NOTE: the welcome email is intentionally NOT sent here — it fires only when an admin
      // approves the profile, so the email endpoint can't be abused to spam arbitrary addresses.
      bbotSignUp(email, form.password).then(function(){
        return bbotSignIn(email, form.password);
      }).then(function(){
        // persistUser writes the bbot_users row. If this fails after auth was created,
        // the user ends up in a half-state (auth exists, profile doesn't). Chain it so
        // a failure rolls back UI state and surfaces an error the user can act on.
        // (Note: we cannot un-create the Supabase Auth account from the client — admin
        //  may need to clean those up manually if profile writes fail repeatedly.)
        return persistUser(nu).then(function(){
          setUsers(function(all){return all.concat([nu]);});
          setCu(nu);
          // CAME FOR AN EVENT? GO BACK TO IT. A player who scanned a QR code has one errand, and
          // dropping them on the home screen with a pending-approval banner makes them hunt for
          // the event again -- the last step of the flow failing after the hard part worked.
          //
          // REGISTRATION IS NOT GATED ON APPROVAL, so this is not a way past the pending state.
          // The pending gates gate what COSTS BBOT money -- running and buying evaluations
          // (`approvalStatus==="pending"` checks on those two paths). Signing up for an event the
          // player pays 643 for is not that, and never was.
          var _evId = (typeof window!=="undefined") ? window.__bbotPendingEventId : null;
          if(form.type==="player" && _evId){
            try{ window.location.hash = "#event/"+encodeURIComponent(String(_evId)); }catch(_e){}
            if(typeof setPublicEventId==="function") setPublicEventId(String(_evId));
            go("landing");
            notify("Profile created — you can register for the event now. Admin approval is still pending for evaluations.");
          } else {
            // All new accounts land on a "pending approval" state — route to home, where the
            // pending banner shows. No upload/eval routing until approved.
            go("home");
            notify("Account created! Your profile is pending admin approval — you'll get a welcome email and full access once approved.");
          }
        });
      }).catch(function(err){
        var m=(err&&err.message)||"";
        if(/already|registered|exists/i.test(m)) notify("That email already has an account. Try signing in, or use 'Forgot password'.","error");
        else if(/persistUser/i.test(m)) notify("Your login was created but we couldn't save your profile. Please contact 643sportsmgmt@gmail.com — they can fix this in a minute.","error");
        else notify(m||"Could not create account","error");
      });
      return;
    }
  }
  var types=[["player","⚾ Player"],["coach","🎓 Coach / Scout"]];
  // Staff is invite-only — appears only when arriving via a valid staff invite link.
  var hasStaffInvite = (typeof window!=="undefined") && (new URLSearchParams(window.location.search).get("staff_invite")===STAFF_INVITE_TOKEN || (window.location.hash||"").indexOf("staff_invite="+STAFF_INVITE_TOKEN)>=0);
  if(hasStaffInvite || (adminUser&&adminUser.type==="staff")) types.push(["staff","⚙ Staff"]);
  if(mode==="recovery"){
    // THE PASSWORD FORM DOES NOT RENDER UNTIL THE ANSWER IS KNOWN. While the status is in flight
    // (null) or could not be obtained ({error:true}), showing "SET A NEW PASSWORD" would let a
    // guardian complete setup without ever being asked for consent -- which is precisely what the
    // fail-open bug did, just from the render side instead of the fetch side. Both doors are shut.
    if(gStatus===null || gStatus.error){
      var _gErr = !!gStatus && !!gStatus.error;
      return (
        <div style={{minHeight:"100vh",background:C.gray50,display:"flex",alignItems:"center",
                     justifyContent:"center",padding:20}}>
          <div style={{width:"100%",maxWidth:400,textAlign:"center"}}>
            <Card style={{padding:24}}>
              {!_gErr ? (
                <div style={{fontSize:13,color:C.gray500}}>Checking this link…</div>
              ) : (
                <div>
                  <div style={{fontSize:11,letterSpacing:1,color:C.coral,fontWeight:700,marginBottom:8}}>
                    COULDN'T CHECK THIS LINK
                  </div>
                  <div style={{fontSize:13,color:C.gray600||C.gray500,lineHeight:1.6,marginBottom:14}}>
                    We could not confirm what this setup link needs. Your account has not
                    changed. Please try again — if it keeps failing, contact 643 Sports MGMT.
                  </div>
                  <button onClick={function(){ setGStatus(null); setGTry(function(n){return n+1;}); }}
                    style={{background:C.blue,color:C.white,border:"none",borderRadius:8,
                            padding:"10px 18px",fontSize:13,fontWeight:700,cursor:"pointer"}}>
                    Try again
                  </button>
                </div>
              )}
            </Card>
          </div>
        </div>
      );
    }
    return (
      <div style={{minHeight:"100vh",background:C.gray50,display:"flex",alignItems:"center",justifyContent:"center",padding:20}}>
        <div style={{width:"100%",maxWidth:400}}>
          <div style={{textAlign:"center",marginBottom:20}}>
            <h2 style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:24,letterSpacing:2,color:C.gray900,marginBottom:4}}>
              {(gStatus&&gStatus.needsAttestation)?"PARENT / GUARDIAN CONFIRMATION":"SET A NEW PASSWORD"}</h2>
            <p style={{fontSize:13,color:C.gray400}}>
              {(gStatus&&gStatus.needsAttestation)
                ? ((gStatus.playerName||"This player")+" is under 18. Choose a password below. If you are their parent or guardian, you can confirm that at the same time.")
                : "Choose a password for your BBOT account."}</p>
          </div>
          <Card style={{padding:20}}>
            {gStatus&&gStatus.needsAttestation&&(
              <div style={{marginBottom:16,paddingBottom:16,borderBottom:"1px solid "+C.border}}>
                <label style={{fontSize:11,fontWeight:600,color:C.gray700,letterSpacing:.5,marginBottom:6,display:"block"}}>YOUR EMAIL ADDRESS (optional)</label>
                <input type="email" placeholder="you@example.com" value={form.gEmail||""}
                  onChange={function(e){setF("gEmail",e.target.value);}}
                  style={{width:"100%",padding:"11px 12px",border:"1px solid "+C.border,borderRadius:8,fontSize:14,marginBottom:12,boxSizing:"border-box"}}/>
                <label style={{fontSize:11,fontWeight:600,color:C.gray700,letterSpacing:.5,marginBottom:6,display:"block"}}>
                  YOUR RELATIONSHIP TO {(gStatus.playerName||"THIS PLAYER").toUpperCase()} (optional)</label>
                <select value={form.gRel||""} onChange={function(e){setF("gRel",e.target.value);}}
                  style={{width:"100%",padding:"10px 12px",border:"1px solid "+C.border,borderRadius:8,fontSize:14,marginBottom:12,boxSizing:"border-box"}}>
                  <option value="">Select…</option>
                  {(gStatus.relationships||["parent","stepparent","legal guardian"]).map(function(r){
                    return <option key={r} value={r}>{r.charAt(0).toUpperCase()+r.slice(1)}</option>;})}
                </select>
                <label style={{display:"flex",gap:8,alignItems:"flex-start",fontSize:12,color:C.gray700,lineHeight:1.5}}>
                  <input type="checkbox" checked={!!form.gAttest} onChange={function(e){setF("gAttest",e.target.checked);}} style={{marginTop:2}}/>
                  <span>{gStatus.consentText}</span>
                </label>
              </div>
            )}
            <input type="password" placeholder="New password (min 8 characters)" value={form.password}
              onChange={function(e){setF("password",e.target.value);}}
              style={{width:"100%",padding:"11px 12px",border:"1px solid "+C.border,borderRadius:8,fontSize:14,marginBottom:10,boxSizing:"border-box"}}/>
            <input type="password" placeholder="Confirm new password" value={form.password2||""}
              onChange={function(e){setF("password2",e.target.value);}}
              style={{width:"100%",padding:"11px 12px",border:"1px solid "+C.border,borderRadius:8,fontSize:14,marginBottom:14,boxSizing:"border-box"}}/>
            <Btn v="coral" style={{width:"100%",justifyContent:"center"}} onClick={function(){
              var tok=bbotRecoveryToken();
              if(!tok) return notify("This reset link has expired — request a new one","error");
              // THE ATTESTATION IS A RECORD, NOT A GATE. Luis ruled 2026-08-13: "there is no
              // guardian gate -- once a player and adults accept terms and create a profile, you
              // stop gating people." That ruling killed `_guardian_consent_ok` because it blocked
              // every minor in a batch for a record the product never created.
              //
              // THIS PATH REBUILT THE GATE SOMEWHERE ELSE. A guardian could not set a password
              // without attesting, so Diego Cotto's parent was stopped on 2026-10-08 by
              // "Tick the box to confirm you are the parent or guardian" -- the same outage, on
              // the password-reset screen instead of the eval screen. The memory is explicit:
              // re-wiring consent for a RECORD is fine, re-wiring it into anything that BLOCKS
              // resurrects that outage. [[guardian-consent-never-recorded]]
              //
              // SO: attest when the guardian actually attests, and never stand between a parent
              // and their child's password when they do not. A half-filled attestation still gets
              // a message, because that is helping someone finish -- not refusing to proceed.
              var needs=!!(gStatus&&gStatus.needsAttestation);
              var gEmailOk=/^[^@\s]+@[^@\s.]+\.[^@\s]+$/.test(String(form.gEmail||"").trim());
              var attesting = needs && !!form.gAttest;
              if(attesting && !gEmailOk) return notify("Enter your email address to record the confirmation","error");
              if(attesting && !form.gRel) return notify("Select your relationship to the player","error");
              if((form.password||"").length<8) return notify("Password must be at least 8 characters","error");
              if(form.password!==form.password2) return notify("The two passwords do not match","error");
              // ATTEST FIRST, THEN SET THE PASSWORD. If the order were reversed, a failure on the
              // consent write would leave a usable account with no record that anyone consented --
              // which is the exact gap this feature exists to close. This way the worst case is a
              // recorded consent and no password, which is accurate and simply retried.
              var step = attesting
                ? fetch(BACKEND_URL+"/guardian-attest",{method:"POST",
                    headers:{"Content-Type":"application/json",Authorization:"Bearer "+tok},
                    body:JSON.stringify({guardianEmail:String(form.gEmail||"").trim(),relationship:form.gRel})})
                    .then(function(r){ if(r.ok) return true;
                      return r.text().then(function(t){ throw new Error(t.slice(0,160)||"Could not record the confirmation"); }); })
                : Promise.resolve(true);
              step.then(function(){ return bbotSetPasswordWithToken(tok, form.password); }).then(function(){
                try{ window.location.hash=""; }catch(_){}
                bbotSaveSession(null);
                setMode("login");
                // SAY WHAT ACTUALLY HAPPENED. This read "Confirmed" whenever the screen had ASKED
                // for an attestation, which after the gate came off would claim a consent record
                // that was never written. [[receipt-is-an-artifact-not-a-sentence]]
                notify(attesting?"Confirmed and recorded — the player can now sign in with their own email and this password"
                                :"Password set — sign in with it now","success");
              }).catch(function(err){ notify(err.message||"Could not set the password","error"); });
            }}>{(gStatus&&gStatus.needsAttestation&&form.gAttest)?"Confirm & set password":"Set password"}</Btn>
          </Card>
        </div>
      </div>
    );
  }
  return(
    <div style={{minHeight:"100vh",background:C.gray50,display:"flex",flexDirection:"column"}}>
      <div style={{background:C.navy,padding:"12px 18px",display:"flex",alignItems:"center",gap:10,cursor:"pointer"}} onClick={function(){go("landing");}}>
        <BbotMark tile="transparent" size={30}/>
        <span style={{fontFamily:"Inter,system-ui,sans-serif",color:C.white,fontSize:14,letterSpacing:2,display:"none"}} className="hide-mobile">643 BASEBALL PROFILES</span>
      </div>
      <div style={{flex:1,display:"flex",alignItems:"center",justifyContent:"center",padding:20}}>
        <div style={{width:"100%",maxWidth:400}}>
          <div style={{textAlign:"center",marginBottom:24}}>
            <h2 style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:26,letterSpacing:2,color:C.gray900,marginBottom:4}}>{mode==="login"?"WELCOME BACK":"CREATE ACCOUNT"}</h2>
            <p style={{fontSize:14,color:C.gray400}}>{mode==="login"?"Sign in to your profile":"Create a BBOT Profile"}</p>
          </div>
          <Card style={{padding:"clamp(16px,5vw,24px)"}}>
            {mode==="register"&&(
              <div>
                <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(min(200px,100%),1fr))",gap:12,marginBottom:14}}>
                  <FieldInput label="First Name" value={form.firstName} onChange={function(e){setF("firstName",e.target.value);}} placeholder="John"/>
                  <FieldInput label="Last Name"  value={form.lastName}  onChange={function(e){setF("lastName",e.target.value);}}  placeholder="Smith"/>
                </div>
                <div style={{marginBottom:14}}>
                  <label>Account Type</label>
                  <div style={{display:"flex",gap:8}}>
                    {types.map(function(pair){return(
                      <button key={pair[0]} onClick={function(){setF("type",pair[0]);}}
                        style={{flex:1,padding:"10px 4px",borderRadius:10,border:"1.5px solid "+(form.type===pair[0]?C.blue:C.border),background:form.type===pair[0]?C.blueFaint:C.white,color:form.type===pair[0]?C.blue:C.gray500,fontWeight:600,fontSize:12,cursor:"pointer"}}>
                        {pair[1]}
                      </button>
                    );})}
                  </div>
                </div>
                {form.type==="player"&&(
                  <div style={{marginBottom:14}}>
                    <label style={{fontSize:11,fontWeight:600,color:C.gray700,letterSpacing:.5,marginBottom:4,display:"block"}}>DATE OF BIRTH *</label>
                    <input type="date" value={form.dob||""} max={new Date().toISOString().slice(0,10)} onChange={function(e){setF("dob",e.target.value);}} style={{width:"100%",padding:"10px",border:"1px solid "+C.border,borderRadius:6,fontSize:13,background:C.white,boxSizing:"border-box"}}/>
                    <div style={{fontSize:10,color:C.gray500,marginTop:3}}>Required — BBOT grades each tool against its age bracket, and names the bracket on the report.</div>
                  </div>
                )}
                {/* GUARDIAN CONSENT — appears the moment the entered DOB is under 18, and blocks
                    account creation until completed. Shown conditionally rather than always, so an
                    adult player is not asked for a guardian. */}
                {form.type==="player"&&form.dob&&(function(){
                  var _d=new Date(form.dob);
                  if(isNaN(_d.getTime())) return null;
                  var _yrs=(Date.now()-_d.getTime())/(365.25*24*3600*1000);
                  if(_yrs>=18) return null;
                  return (
                    <div style={{marginBottom:14,padding:"12px 14px",background:C.blueFaint,borderLeft:"3px solid "+C.blue,borderRadius:8}}>
                      <div style={{fontSize:11,fontWeight:700,color:C.blue,letterSpacing:.5,marginBottom:8}}>PARENT / GUARDIAN CONSENT — REQUIRED UNDER 18</div>
                      <label style={{fontSize:11,fontWeight:600,color:C.gray700,marginBottom:4,display:"block"}}>PARENT / GUARDIAN FULL NAME *</label>
                      <input type="text" value={form.guardianName||""} onChange={function(e){setF("guardianName",e.target.value);}} style={{width:"100%",padding:"9px 11px",borderRadius:8,border:"1.5px solid "+C.border,fontSize:14,marginBottom:9,boxSizing:"border-box"}}/>
                      <label style={{fontSize:11,fontWeight:600,color:C.gray700,marginBottom:4,display:"block"}}>RELATIONSHIP TO PLAYER *</label>
                      <select value={form.guardianRelationship||""} onChange={function(e){setF("guardianRelationship",e.target.value);}} style={{width:"100%",padding:"9px 11px",borderRadius:8,border:"1.5px solid "+C.border,fontSize:14,marginBottom:9,boxSizing:"border-box"}}>
                        <option value="">Select…</option>
                        <option value="parent">Parent</option>
                        <option value="legal guardian">Legal guardian</option>
                      </select>
                      <label style={{display:"flex",gap:8,alignItems:"flex-start",fontSize:12,color:C.gray700,lineHeight:1.5}}>
                        <input type="checkbox" checked={!!form.guardianConsent} onChange={function(e){setF("guardianConsent",e.target.checked);}} style={{marginTop:2}}/>
                        <span>{GUARDIAN_CONSENT_TEXT}</span>
                      </label>
                    </div>
                  );
                })()}
                {form.type==="coach"&&(
                  <div style={{marginBottom:14,padding:12,background:C.gray50,borderRadius:8,border:"1px solid "+C.border}}>
                    <label style={{fontSize:11,fontWeight:600,color:C.gray700,letterSpacing:.5,marginBottom:6,display:"block"}}>YOUR ROLE *</label>
                    <select value={form.coachRole} onChange={function(e){setF("coachRole",e.target.value); setF("orgName","");}} style={{width:"100%",padding:"8px 10px",border:"1px solid "+C.border,borderRadius:6,fontSize:13,marginBottom:10,background:C.white}}>
                      <option value="">— Select Role —</option>
                      {COACH_ROLES.map(function(r){return <option key={r} value={r}>{r}</option>;})}
                    </select>
                    <label style={{fontSize:11,fontWeight:600,color:C.gray700,letterSpacing:.5,marginBottom:4,display:"block"}}>ORGANIZATION</label>
                    <OrgInput
                      value={form.orgName}
                      onChange={function(v){setF("orgName",v);}}
                      placeholder={form.coachRole?"Search or add your organization...":"Select role first"}
                    />
                    <div style={{marginTop:10,padding:10,background:C.white,borderRadius:6,border:"1px solid "+C.border}}>
                      <label style={{display:"flex",gap:8,fontSize:11,color:C.gray700,cursor:"pointer",lineHeight:1.45,alignItems:"flex-start"}}>
                        <input type="checkbox" checked={!!form.complianceAck} onChange={function(e){setF("complianceAck",e.target.checked);}} style={{marginTop:2,flexShrink:0}}/>
                        <span><strong>I acknowledge</strong> that BBOT is a neutral evaluation/data platform. I am NOT using this platform as an unlicensed agent, pay-for-access broker, or recruiting intermediary. I will comply with NCAA, MLB, NIL, and state athlete-agent regulations in my jurisdiction. All player communications through BBOT may be logged for compliance purposes. <a href="#" onClick={function(e){e.preventDefault();go&&go("terms");}} style={{color:C.coral,fontWeight:600,textDecoration:"underline"}}>Read full Terms & Conditions</a></span>
                      </label>
                    </div>
                    <div style={{marginTop:10,fontSize:10,color:C.gray500,fontStyle:"italic"}}>
                      Your role will be reviewed by admin for verified status. Until verified, certain features are limited.
                    </div>
                  </div>
                )}
                {form.type==="staff"&&(
                  <div style={{marginBottom:14,padding:12,background:C.gray50,borderRadius:8,border:"1px solid "+C.border}}>
                    <label style={{fontSize:11,fontWeight:600,color:C.gray700,letterSpacing:.5,marginBottom:6,display:"block"}}>STAFF PASSCODE *</label>
                    <FieldInput value={form.staffPasscode||""} onChange={function(e){setF("staffPasscode",e.target.value);}} type="password" placeholder="Enter the staff passcode"/>
                    <div style={{marginTop:8,fontSize:10,color:C.gray500,fontStyle:"italic"}}>Staff accounts require this passcode plus admin approval before access is granted.</div>
                  </div>
                )}
              </div>
            )}
            <div style={{marginBottom:12}}><FieldInput label="Email" value={form.email} onChange={function(e){setF("email",e.target.value);}} type="email" placeholder="you@email.com"/></div>
            <div style={{marginBottom:20}}><FieldInput label="Password" value={form.password} onChange={function(e){setF("password",e.target.value);}} type="password" placeholder="••••••••"/></div>
            <Btn v="primary" full onClick={submit} style={{fontSize:15,padding:14}}>{mode==="login"?"Sign In":"Create a BBOT Profile"}</Btn>
            {mode==="login" && (
              <div style={{textAlign:"center",marginTop:12,fontSize:13}}>
                <span style={{color:C.blue,fontWeight:600,cursor:"pointer"}} onClick={function(){
                  var email=(form.email||"").trim().toLowerCase();
                  if(!email){ notify("Enter your email above first, then tap 'Forgot password'.","error"); return; }
                  bbotSendPasswordReset(email).then(function(){
                    notify("If that email has an account, a password-reset link is on its way. Check your inbox.");
                  }).catch(function(){ notify("Could not send reset email — please try again.","error"); });
                }}>Forgot / set password?</span>
              </div>
            )}
            <div style={{textAlign:"center",marginTop:16,fontSize:14,color:C.gray500}}>
              {mode==="login"?"Don't have an account? ":"Already have an account? "}
              <span style={{color:C.blue,fontWeight:600,cursor:"pointer"}} onClick={function(){setMode(mode==="login"?"register":"login");}}>
                {mode==="login"?"Register":"Sign in"}
              </span>
            </div>
          </Card>
          <div style={{textAlign:"center",marginTop:14}}><Btn v="link" onClick={function(){go("landing");}}>← Back to home</Btn></div>
        </div>
      </div>
    </div>
  );
}


function Shell(props){
  var{page,go,cu,setCu,users,setUsers,metrics,setMetrics,reviews,setReviews,blogs,setBlogs,feed,setFeed,vp,toggleFollow,toggleInterest,pushFeed,notify,markRead,isStaff,scoutReports,setScoutReports,adminTab,setAdminTab,fields,setFields,battedBalls,setBattedBalls,recaps,setRecaps,lineups,setLineups,approveReport,highlights,setHighlights,coachUpdates,setCoachUpdates,siteContent,setSiteContent,saveSiteContent,startImpersonate,setAuthMode}=props;
  var showNotifsS=useState(false); var showNotifs=showNotifsS[0]; var setShowNotifs=showNotifsS[1];
  var isAdmin = cu && bbotIsAdmin(cu);
  var showSearchS=useState(false); var showSearch=showSearchS[0]; var setShowSearch=showSearchS[1];
  var showMoreS=useState(false); var showMore=showMoreS[0]; var setShowMore=showMoreS[1];
  var searchQS=useState(""); var searchQ=searchQS[0]; var setSearchQ=searchQS[1];
  var unread=(cu.notifications||[]).filter(function(n){return!n.read;}).length;

  // Streamlined nav: each role surfaces ~5 primary items in the bar; the rest live under a
  // "More" dropdown so the header stays uncluttered. Routes/IDs are unchanged — this only
  // reorganizes which items show where.
  var navPrimary, navMore;
  if(isAdmin){
    navPrimary=[
      {id:"admin",  l:"Dashboard"},
      {id:"players",l:"Players"},
      {id:"my-roster",l:"Roster"},
      {id:"recaps",l:"Session Reports"},
      {id:"messages",l:"Messages"},
    ];
    navMore=[
      {id:"activity",l:"Activity"},
      {id:"coaches",l:"Coaches"},
      {id:"staff",  l:"Staff"},
      {id:"leaderboard",l:"Leaderboards"},
      {id:"compare",l:"Compare"},
      {id:"blogs",  l:"Blogs"},
      {id:"about",  l:"About"},
      {id:"faq",    l:"FAQ"},
      {id:"profile",l:"My Profile"},
    ];
  } else if(isStaff){
    navPrimary=[
      {id:"run-bbot",l:"Run BBOT"},
      {id:"my-roster",l:"Roster"},
      {id:"players",l:"Players"},
      {id:"leaderboard",l:"Leaderboards"},
      {id:"messages",l:"Messages"},
    ];
    navMore=[
      {id:"activity",l:"Activity"},
      {id:"events", l:"Events"},
      {id:"faq",    l:"FAQ"},
      {id:"profile",l:"My Profile"},
    ];
  } else if(cu.type==="coach"){
    navPrimary=[
      {id:"home",   l:"Home"},
      {id:"players",l:"Players"},
      {id:"my-roster",l:"Roster"},
      {id:"coach-upload",l:"Submit"},
      {id:"messages",l:"Messages"},
    ];
    navMore=[
      {id:"activity",l:"Activity"},
      {id:"events", l:"Events"},
      {id:"leaderboard",l:"Leaderboards"},
      {id:"compare",l:"Compare"},
      {id:"about",  l:"About"},
      {id:"faq",    l:"FAQ"},
      {id:"profile",l:"My Profile"},
    ];
  } else {
    navPrimary=[
      {id:"home",   l:"Home"},
      {id:"upload-video",l:"Upload"},
      // IN THE PRIMARY BAR ON PURPOSE. Events were only ever a card on Home that returned null
      // when the list was empty, so there was no place a player could go to look -- and a seat at
      // a showcase is the thing they are most likely to be hunting for. [[prefer-direct-action-no-question-cards]]
      {id:"events", l:"Events"},
      {id:"players",l:"Players"},
      {id:"leaderboard",l:"Leaderboards"},
      {id:"messages",l:"Messages"},
    ];
    navMore=[
      {id:"activity",l:"Activity"},
      {id:"feed",   l:"Feed"},
      {id:"coaches",l:"Coaches"},
      {id:"staff",  l:"Staff"},
      {id:"blogs",  l:"Blogs"},
      {id:"about",  l:"About"},
      {id:"faq",    l:"FAQ"},
      {id:"profile",l:"My Profile"},
    ];
  }
  // PHASE E — coach percentile search, in the "More" menu for coach/staff/admin. Appears ONLY once
  // percentile data exists (dormant until BBOT_PERCENTILE_MODE is on; no report carries percentiles
  // before that, so the entry stays hidden and the page returns nothing).
  var hasPctData = (scoutReports||[]).some(function(r){ return r.percentiles || (r.fullReport && r.fullReport.percentiles); });
  if(hasPctData && (isAdmin || isStaff || (cu && cu.type==="coach"))){
    navMore = navMore.concat([{id:"percentile-search", l:"Percentile Search"}]);
  }
  var nav = navPrimary.concat(navMore);

  // Mobile bottom bar mirrors the top nav's primary items (navPrimary is already curated to
  // ~5 per role), so the two navs share one source and can never drift out of sync. Overflow
  // items remain reachable via the "More" menu, same as the top bar.
  var mobileNav = navPrimary.map(function(n){
    return nav.find(function(x){return x.id===n.id;});
  }).filter(Boolean);

  return(
    <div style={{minHeight:"100vh",display:"flex",flexDirection:"column",background:C.gray50}}>
      <header style={{background:C.navy,padding:"0 14px",display:"flex",alignItems:"center",justifyContent:"space-between",height:52,position:"sticky",top:0,zIndex:200,boxShadow:"0 2px 6px rgba(0,0,0,.15)"}}>
        <div style={{display:"flex",alignItems:"center",gap:8,cursor:"pointer",flexShrink:0}} onClick={function(){go(isAdmin?"admin":isStaff?"run-bbot":"home");}}>
          <BbotMark tile="transparent" size={30}/>
        </div>
        <div style={{position:"relative",overflow:"hidden",flex:1,minWidth:0}}>
          <nav style={{display:"flex",gap:0,overflowX:"auto",scrollbarWidth:"none",msOverflowStyle:"none"}}>
          {navPrimary.map(function(n){
            var active=page===n.id;
            return(
              <button key={n.id} onClick={function(){go(n.id);}}
                style={{background:"transparent",color:active?C.coral:"rgba(255,255,255,.72)",border:"none",borderBottom:active?"2.5px solid "+C.coral:"2.5px solid transparent",padding:"0 12px",height:52,fontSize:13,fontWeight:active?700:500,letterSpacing:.2,cursor:"pointer",whiteSpace:"nowrap",transition:"all .15s"}}>
                {n.l}
              </button>
            );
          })}
          {navMore.length>0 && (function(){
            var moreActive=navMore.some(function(n){return n.id===page;});
            return (
              <button key="__more" onClick={function(){setShowMore(function(s){return!s;});}}
                style={{background:"transparent",color:moreActive?C.coral:"rgba(255,255,255,.72)",border:"none",borderBottom:moreActive?"2.5px solid "+C.coral:"2.5px solid transparent",padding:"0 12px",height:52,fontSize:13,fontWeight:moreActive?700:500,letterSpacing:.2,cursor:"pointer",whiteSpace:"nowrap"}}>
                More ▾
              </button>
            );
          })()}
          </nav>
          {/* Right-edge fade hint that more tabs exist */}
          <div style={{position:"absolute",right:0,top:0,bottom:0,width:24,background:"linear-gradient(to right,transparent,"+C.navy+")",pointerEvents:"none"}}/>
        </div>
        {showMore && (
          <div style={{position:"fixed",inset:0,zIndex:290}} onClick={function(){setShowMore(false);}}>
            <div onClick={function(e){e.stopPropagation();}} style={{position:"absolute",top:52,left:0,right:0,background:C.white,borderBottom:"1px solid "+C.border,boxShadow:C.shadowLg,animation:"fadeUp .15s ease"}}>
              <div style={{maxWidth:600,margin:"0 auto",padding:"6px 8px",display:"flex",flexWrap:"wrap"}}>
                {navMore.map(function(n){
                  var active=page===n.id;
                  return (
                    <button key={n.id} onClick={function(){setShowMore(false);go(n.id);}}
                      style={{background:active?C.blueFaint:"transparent",color:active?C.blue:C.gray700,border:"none",borderRadius:8,padding:"11px 16px",fontSize:14,fontWeight:active?700:500,cursor:"pointer",textAlign:"left",flex:"1 1 45%",minWidth:120}}>
                      {n.l}
                    </button>
                  );
                })}
              </div>
            </div>
          </div>
        )}
        <div style={{display:"flex",alignItems:"center",gap:6,flexShrink:0,position:"relative",background:C.navy,paddingLeft:6,zIndex:2}}>
          <div className="hide-mobile" style={{position:"relative",cursor:"pointer",padding:6}} onClick={function(){go("messages");}} title="Messages">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,.65)" strokeWidth="2"><path d="M4 4h16v16H4z"/><path d="M22 6l-10 7L2 6"/></svg>
          </div>
          <div style={{position:"relative",cursor:"pointer",padding:6}} onClick={function(){setShowSearch(true);}}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,.65)" strokeWidth="2"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
          </div>
          <div style={{position:"relative",cursor:"pointer",padding:6}} onClick={function(){setShowNotifs(function(s){return!s;});markRead();}}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,.65)" strokeWidth="2"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/></svg>
            {unread>0&&<span style={{position:"absolute",top:2,right:2,background:C.coral,color:C.white,borderRadius:"50%",width:14,height:14,fontSize:9,fontWeight:700,display:"flex",alignItems:"center",justifyContent:"center"}}>{unread}</span>}
          </div>
          {showNotifs&&(
            <div style={{position:"absolute",top:50,right:0,background:C.white,border:"1px solid "+C.border,borderRadius:12,width:290,maxHeight:340,overflowY:"auto",boxShadow:C.shadowLg,zIndex:300,animation:"fadeUp .15s ease"}}>
              <div style={{padding:"12px 16px",borderBottom:"1px solid "+C.border,fontFamily:"Inter,system-ui,sans-serif",fontSize:13,color:C.blue,letterSpacing:1}}>NOTIFICATIONS</div>
              {(cu.notifications||[]).length===0?<div style={{padding:"24px 16px",textAlign:"center",color:C.gray400,fontSize:13}}>All caught up!</div>
              :(cu.notifications||[]).map(function(n){
                var isMsg=(n.type==="message")||/message/i.test(n.text||"");
                var isStandout=(n.type==="standout");
                var dest=null, cta=null;
                if(n.type==="eval_request"){ dest="upload-video"; cta="Start"; }
                else if(n.type==="eval_released"||n.type==="milestone"){ dest="profile"; cta="View"; }
                else if(n.type==="profile_view"){ dest="profile"; cta=null; }
                // THESE POINTED AT A PAGE THAT NO LONGER RENDERS. When the cross-player rankings
                // came off (2026-09-13) the nav entry went with them, but three notification types
                // still deep-linked to "leaderboard" -- and LeaderboardPage returns null, so the
                // "View" button dropped the reader on a blank screen with no way back except the
                // nav. 54 followed_player_update rows are live in bbot_notifications today.
                //
                // THE NOTIFICATION ALREADY NAMES ITS SUBJECT: it carries the report_id that
                // triggered it, and the message reads "<player> has a new BBOT evaluation". So it
                // goes to that player, which is what the reader was told they were opening. A
                // ranking was never the subject of this sentence.
                //
                // WHERE THE SUBJECT CANNOT BE RESOLVED THE ROW IS NOT CLICKABLE. `clickable=!!dest`
                // below already handles that, and no destination is better than a wrong one --
                // sending every unresolvable notification to a generic page would be the
                // substitution this codebase keeps removing. saved_search_match is dormant (saved
                // searches were removed and the table holds none), and it is covered by the same
                // rule rather than left pointing somewhere dead.
                else if(isStandout||n.type==="followed_player_update"||n.type==="saved_search_match"){
                  var _subj=(scoutReports||[]).find(function(r){return String(r.id)===String(n.report_id);});
                  var _sid=_subj&&_subj.playerId;
                  if(_sid){ dest="profile-"+_sid; cta="View"; }
                }
                else if(isMsg){ dest="messages"; cta="Open"; }
                var clickable=!!dest;
                return(
                <div key={n.id} onClick={clickable?function(){setShowNotifs(false);go(dest);}:null} style={{padding:"11px 16px",borderBottom:"1px solid "+C.border,background:isStandout?C.coralFaint:(n.read?C.white:C.blueFaint),cursor:clickable?"pointer":"default"}}>
                  <div style={{fontSize:13,color:C.gray700,lineHeight:1.5}}>{isStandout&&<span style={{color:C.coral,fontWeight:700}}>★ </span>}{n.text||n.message}{cta&&<span style={{color:C.coral,fontWeight:600}}> · {cta}</span>}</div>
                  <div style={{fontSize:11,color:C.gray400,marginTop:3}}>{n.date}</div>
                </div>
              );})}
            </div>
          )}
          <div style={{cursor:"pointer"}} onClick={function(){go("profile");}}>
            <Avatar user={cu} size={30}/>
          </div>
          <button onClick={function(){bbotSignOut();setCu(null);go("landing");}} style={{background:"rgba(255,255,255,.08)",border:"1px solid rgba(255,255,255,.1)",color:"rgba(255,255,255,.55)",padding:"4px 10px",borderRadius:6,fontSize:11,cursor:"pointer"}}>Sign Out</button>
        </div>
      </header>

      {/* GLOBAL SEARCH MODAL */}
      {showSearch && (
        <div onClick={function(){setShowSearch(false);}} style={{position:"fixed",top:0,left:0,right:0,bottom:0,background:"rgba(0,0,0,0.5)",zIndex:300,display:"flex",alignItems:"flex-start",justifyContent:"center",padding:"60px 16px 16px"}}>
          <div onClick={function(e){e.stopPropagation();}} style={{background:C.white,borderRadius:12,maxWidth:520,width:"100%",maxHeight:"calc(100vh - 80px)",overflow:"hidden",display:"flex",flexDirection:"column",boxShadow:C.shadowLg}}>
            <div style={{padding:"12px 16px",borderBottom:"1px solid "+C.border,display:"flex",alignItems:"center",gap:8}}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={C.gray400} strokeWidth="2"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
              <input autoFocus value={searchQ} onChange={function(e){setSearchQ(e.target.value);}} placeholder="Search players, coaches, reports..." style={{flex:1,border:"none",outline:"none",fontSize:15,padding:"8px 0",background:"transparent",minHeight:"auto"}}/>
              <button onClick={function(){setShowSearch(false);setSearchQ("");}} style={{background:"transparent",border:"none",color:C.gray400,fontSize:18,cursor:"pointer",padding:4}}>×</button>
            </div>
            <div style={{flex:1,overflowY:"auto"}}>
              {(function(){
                var q = searchQ.toLowerCase().trim();
                if(!q) return <div style={{padding:30,textAlign:"center",color:C.gray400,fontSize:13}}>Type to search across players, coaches, and reports</div>;
                var matched = (users||[]).filter(function(u){
                  var name = ((u.firstName||"")+" "+(u.lastName||"")).toLowerCase();
                  var email = (u.email||"").toLowerCase();
                  var org = (u.orgName||u.hsName||u.clubName||"").toLowerCase();
                  var pos = (u.position||"").toLowerCase();
                  return name.indexOf(q)>=0 || email.indexOf(q)>=0 || org.indexOf(q)>=0 || pos.indexOf(q)>=0;
                }).slice(0,12);
                if(matched.length===0) return <div style={{padding:30,textAlign:"center",color:C.gray400,fontSize:13}}>No matches for "{searchQ}"</div>;
                return matched.map(function(u){
                  var sub = u.type==="player" ? [u.position,u.gradYear?"Class "+u.gradYear:null,u.hsName||u.clubName].filter(Boolean).join(" · ") : [u.coachRole||u.type,u.orgName].filter(Boolean).join(" · ");
                  return (
                    <div key={u.id} onClick={function(){vp(u.id);setShowSearch(false);setSearchQ("");}} style={{padding:"10px 16px",borderBottom:"1px solid "+C.gray100,cursor:"pointer",display:"flex",alignItems:"center",gap:10}}>
                      <Avatar user={u} size={32}/>
                      <div style={{flex:1,minWidth:0}}>
                        <div style={{fontSize:14,fontWeight:600,color:C.navy,display:"flex",alignItems:"center",gap:4}}>
                          <span>{u.firstName} {u.lastName}</span>
                          {u.type==="coach" && u.verified && <span title="Verified" style={{display:"inline-flex",alignItems:"center",justifyContent:"center",width:14,height:14,borderRadius:"50%",background:C.blue,color:C.white,fontSize:8,fontWeight:700,flexShrink:0}}>✓</span>}
                        </div>
                        <div style={{fontSize:11,color:C.gray500,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{sub||u.email}</div>
                      </div>
                      <span style={{fontSize:10,color:C.gray400,letterSpacing:.5,textTransform:"uppercase"}}>{u.type}</span>
                    </div>
                  );
                });
              })()}
            </div>
          </div>
        </div>
      )}

      <main style={{flex:1,padding:"14px 12px",maxWidth:1060,margin:"0 auto",width:"100%"}} onClick={function(){if(showNotifs)setShowNotifs(false);}}>
        {page==="home"    &&<HomePage    go={go} users={users} cu={cu} feed={feed} setFeed={setFeed} toggleFollow={toggleFollow} setAdminTab={setAdminTab} scoutReports={scoutReports} metrics={metrics}/>}
        {page==="activity"&&<ActivityPage scoutReports={scoutReports} users={users} highlights={highlights} go={go} cu={cu} notify={notify}/>}
        {/* EVENTS AS A DESTINATION. The same section shown on Home, but reachable: it was only
            ever a card that collapsed to null when empty, so a player had no way to look up what
            was coming. [[public-tier-and-download-limits]] */}
        {page==="events"  &&<EventsHomeSection cu={cu} asPage={true}/>}
        {page==="feed"    &&<FeedPage    feed={feed} setFeed={setFeed} users={users} cu={cu} go={go}/>}
        {page==="players" &&<DirPage type="player" users={users} cu={cu} go={go} toggleFollow={toggleFollow} metrics={metrics} scoutReports={scoutReports} setUsers={setUsers} pushFeed={pushFeed} notify={notify} coachUpdates={coachUpdates} setCoachUpdates={setCoachUpdates}/>}
        {page==="coaches" &&<DirPage type="coach" users={users} cu={cu} go={go} toggleFollow={toggleFollow} metrics={metrics} scoutReports={scoutReports}/>}
        {page==="staff" &&<DirPage type="staff" users={users} cu={cu} go={go} toggleFollow={toggleFollow} metrics={metrics} scoutReports={scoutReports}/>}
        {page==="blogs"   &&<BlogsPage   blogs={blogs} setBlogs={setBlogs} cu={cu} notify={notify} scoutReports={scoutReports} users={users} go={go}/>}
        {page==="about"&&<AboutPage go={go} siteContent={siteContent} cu={cu}/>}
        {page==="faq"&&<FaqPage siteContent={siteContent}/>}
        {page==="sample-report"&&<SampleReportPage go={go} setAuthMode={setAuthMode}/>}
        {page==="terms"&&<TermsPage/>}
        {page==="methodology"&&<MethodologyPage go={go}/>}
        {page==="privacy"&&<PrivacyPage go={go}/>}
        {/* SAVED SEARCHES page REMOVED 2026-09-13 -- its save button wrote to `bbot_saved_searches`, a table that was never created. Nothing read it, so no search was ever saved and no user could retrieve one. */}
        {page==="compare"&&cu&&(cu.type==="coach"||cu.type==="staff"||bbotIsAdmin(cu))&&<div style={{maxWidth:960,margin:"0 auto",padding:"0 16px 40px"}}><CompareView users={users||[]} scoutReports={scoutReports||[]} metrics={metrics||{}}/></div>}
        {page==="percentile-search"&&cu&&(isAdmin||isStaff||cu.type==="coach")&&hasPctData&&<div style={{maxWidth:720,margin:"0 auto",padding:"0 16px 40px"}}><BbotPercentileSearch reports={scoutReports} users={users} go={go}/></div>}
{page==="leaderboard"&&<LeaderboardPage users={users} scoutReports={scoutReports} cu={cu}/>}
{page==="messages"&&<MessagesView cu={cu} users={users} go={go} notify={notify}/>}
{page==="recaps"&&<RecapsPage recaps={recaps} setRecaps={setRecaps} users={users} cu={cu} notify={notify} isStaff={isStaff} scoutReports={scoutReports} go={go}/>}
        {page==="profile" &&<ProfilePage user={vp||cu} isOwn={!vp||vp.id===cu.id} cu={cu} setCu={setCu} battedBalls={battedBalls} setBattedBalls={setBattedBalls} recaps={recaps} users={users} setUsers={setUsers} metrics={metrics} reviews={reviews} scoutReports={scoutReports} setScoutReports={setScoutReports} blogs={blogs} highlights={highlights} setHighlights={setHighlights} coachUpdates={coachUpdates} setCoachUpdates={setCoachUpdates} toggleFollow={toggleFollow} toggleInterest={toggleInterest} pushFeed={pushFeed} feed={feed} setFeed={setFeed} notify={notify} go={go} isAdmin={isAdmin} startImpersonate={startImpersonate}/>}
        {page==="upload-video" && cu && cu.type==="player" && (cu.height ? <PlayerSelfUploadView cu={cu} notify={notify} go={go}/> : <div style={{maxWidth:480,margin:"40px auto",padding:24,textAlign:"center"}}><div style={{fontSize:16,fontWeight:700,color:C.navy,marginBottom:8}}>Add your height to continue</div><div style={{fontSize:13,color:C.gray600,lineHeight:1.6,marginBottom:16}}>BBOT uses your height to scale the movement it draws to your own body, so one rep can be compared with another. Add it to your profile, then start your evaluation.</div><Btn v="coral" onClick={function(){go("profile");}}>Go to Profile</Btn></div>)}
        {page==="coach-upload" && cu && cu.type==="coach" && <CoachUploadView cu={cu} users={users} notify={notify}/>}
        {page==="invite-team" && cu && (cu.type==="coach"||cu.type==="staff") && <InviteTeamView cu={cu} notify={notify}/>}
        {page==="admin"   &&isAdmin&&<AdminPanel key={adminTab} users={users} setUsers={setUsers} cu={cu} metrics={metrics} setMetrics={setMetrics} scoutReports={scoutReports} setScoutReports={setScoutReports} pushFeed={pushFeed} notify={notify} go={go} lineups={lineups} setLineups={setLineups} approveReport={approveReport} highlights={highlights} setHighlights={setHighlights} coachUpdates={coachUpdates} setCoachUpdates={setCoachUpdates} siteContent={siteContent} setSiteContent={setSiteContent} saveSiteContent={saveSiteContent} fields={fields} setFields={setFields} battedBalls={battedBalls} setBattedBalls={setBattedBalls} recaps={recaps} setRecaps={setRecaps} adminTab={adminTab} setAdminTab={setAdminTab} initialTab={adminTab}/> }
        {page==="run-bbot" &&cu&&cu.type==="staff"&&!isStaff&&<div style={{maxWidth:600,margin:"40px auto",padding:"0 14px"}}><Card style={{padding:"24px 20px",textAlign:"center"}}><div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:18,color:C.navy,letterSpacing:1,marginBottom:8}}>ACCOUNT PENDING APPROVAL</div><div style={{fontSize:13,color:C.gray500,lineHeight:1.6}}>An admin is reviewing your staff account. Once approved, you'll be able to run BBOT evaluations and build your roster. You'll be notified.</div></Card></div>}
        {page==="run-bbot" &&isStaff&&<div style={{maxWidth:760,margin:"0 auto",padding:"16px 14px"}}><div style={{marginBottom:14}}><div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:20,color:C.navy,letterSpacing:1}}>RUN BBOT</div><div style={{fontSize:12,color:C.gray500,marginTop:2,lineHeight:1.5}}>Pick a player, upload their session video, and run the evaluation. It goes to admin for review, then unlocks for the player to purchase.</div></div><HowToUse role="staff"/><BbotRunner users={users} setUsers={setUsers} cu={cu} metrics={metrics} scoutReports={scoutReports} setScoutReports={setScoutReports} pushFeed={pushFeed} notify={notify} lineups={lineups} approveReport={approveReport} fields={fields} battedBalls={battedBalls} setBattedBalls={setBattedBalls} highlights={highlights} setHighlights={setHighlights} coachUpdates={coachUpdates} setCoachUpdates={setCoachUpdates} recaps={recaps} setRecaps={setRecaps} go={go}/>
          {/* ATTESTED VELO. Lives here because this is the screen open while a session is being
              worked, which is when someone has a radar reading in hand. It writes through the
              backend proxy like every other client write -- the browser has no table access. */}
          <div style={{marginTop:18}}>
            <BbotManualVeloEntry attestedBy={(cu&&(cu.firstName||"")+" "+(cu.lastName||"")).trim()||String(cu&&cu.id||"")}
              onSubmit={function(rec){
                var rows=BbotManualVeloEntry.toRows(rec);
                if(!rows.length) return Promise.reject(new Error("nothing to save"));
                // RETURNED, not fired and forgotten -- the form waits on this before it says saved.
                return bbotWrite("bbot_velo_entries","insert",rows)
                  .then(function(){ notify(rows.length+" velo reading"+(rows.length>1?"s":"")+" recorded","success"); })
                  .catch(function(err){ notify("Could not record the readings: "+(err&&err.message||""),"error"); throw err; });
              }}/>
          </div></div>}
        {page==="my-roster" &&(isStaff||cu.type==="coach"||bbotIsAdmin(cu))&&<MyRosterView cu={cu} users={users} setUsers={setUsers} scoutReports={scoutReports} setScoutReports={setScoutReports} battedBalls={battedBalls} metrics={metrics} notify={notify} go={go} lineups={lineups} setLineups={setLineups}/>}
      </main>

      {/* MOBILE BOTTOM NAV — only on small screens, only for non-staff (staff has sidebar tabs) */}
      <nav style={{position:"fixed",bottom:0,left:0,right:0,background:C.white,borderTop:"1px solid "+C.border,boxShadow:"0 -2px 10px rgba(0,0,0,.05)",zIndex:150,padding:"6px 0 calc(6px + env(safe-area-inset-bottom, 0px))",display:"none",justifyContent:"space-around"}} className="mobile-bottom-nav">
        {mobileNav.map(function(item){
          var active = page===item.id;
          var icon = NAV_ICON[item.id] || (item.l||"?").replace(/[^A-Za-z]/g,"").charAt(0).toUpperCase();
          var lbl = NAV_SHORT[item.id] || item.l.replace(/[^A-Za-z ]/g,"").trim();
          return (
            <button key={item.id} onClick={function(){go(item.id);}} style={{flex:"1 1 0",minWidth:0,background:"transparent",border:"none",padding:"4px 2px",display:"flex",flexDirection:"column",alignItems:"center",gap:3,cursor:"pointer",color:active?C.coral:C.gray600,minHeight:"auto"}}>
              <div style={{width:26,height:26,borderRadius:"50%",background:active?C.coral:"transparent",color:active?C.white:C.gray500,display:"flex",alignItems:"center",justifyContent:"center",fontFamily:"Inter,system-ui,sans-serif",fontSize:12,fontWeight:700,letterSpacing:.3,border:active?"none":"1px solid "+C.gray300,position:"relative",overflow:"hidden"}}>{item.id==="messages"?<BbotMark tile="transparent" size={20}/>:icon}{item.id==="messages"&&unread>0&&<span style={{position:"absolute",top:-3,right:-3,background:C.coral,color:C.white,borderRadius:"50%",width:13,height:13,fontSize:8,fontWeight:700,display:"flex",alignItems:"center",justifyContent:"center"}}>{unread}</span>}</div>
              <div style={{fontSize:10,fontWeight:active?700:600,letterSpacing:.2,whiteSpace:"nowrap",color:active?C.coral:C.gray600}}>{lbl}</div>
            </button>
          );
        })}
      </nav>
      <style>{`
        @media (max-width: 720px) {
          .mobile-bottom-nav { display: flex !important; }
          main { padding-bottom: calc(104px + env(safe-area-inset-bottom, 0px)) !important; }
        }
      `}</style>
    </div>
  );
}


// ── WORKFLOW GUIDE ────────────────────────────────────────────────────────
// One calm, role-aware card that shows the user exactly where they are in the
// BBOT loop and the single next action. Absorbs the old completeness /
// re-engage / first-eval nudges into one stateful sequence (progressive
// disclosure). DNA: practical, efficient, concise.
function WorkflowStrip({steps, current}){
  var nodes=[];
  steps.forEach(function(s,i){
    var done = i < current;
    var active = i === current;
    var col = done ? C.green : active ? C.coral : C.gray200;
    nodes.push(
      <div key={"s"+i} style={{display:"flex",flexDirection:"column",alignItems:"center",flex:"0 0 auto"}}>
        <div style={{width:26,height:26,borderRadius:"50%",background:col,color:done||active?C.white:C.gray500,display:"flex",alignItems:"center",justifyContent:"center",fontSize:12,fontWeight:700,fontFamily:"Inter,system-ui,sans-serif"}}>{done?"✓":(i+1)}</div>
        <div style={{fontSize:8.5,color:active?C.coral:C.gray400,marginTop:3,fontWeight:active?700:500,letterSpacing:.3,textAlign:"center",maxWidth:54,lineHeight:1.2}}>{s}</div>
      </div>
    );
    if(i<steps.length-1) nodes.push(<div key={"l"+i} style={{flex:1,height:2,background:i<current?C.green:C.gray200,margin:"0 4px",marginBottom:14}}/>);
  });
  return <div style={{display:"flex",alignItems:"center",gap:0,marginBottom:12}}>{nodes}</div>;
}

function CoachWorkflowGuide({cu, go}){
  var [wantsCount,setWantsCount]=useState(null); // null = loading
  useEffect(function(){
    fetch(SUPABASE_URL+"/rest/v1/bbot_wants?coach_id=eq."+String(cu.id)+"&select=id", {headers:sbHeaders()})
      .then(function(r){return r.json();})
      .then(function(rows){ setWantsCount(Array.isArray(rows)?rows.length:0); })
      .catch(function(){ setWantsCount(0); });
  },[]);
  var csteps=["Search","Save Needs","Request","Get Alerts"];
  var hasWants = wantsCount!=null && wantsCount>0;
  var ccurrent, ctitle, cbody, ccta, caction;
  if(!hasWants){
    ccurrent=0;
    ctitle="Step 1 · Find players";
    cbody="Search and filter by position, class year, and metrics. Save your needs to get matches.";
    ccta="Browse Players"; caction=function(){go("players");};
  } else {
    ccurrent=2;
    ctitle="Step 3 · Request evaluations";
    cbody="Open a player's profile and tap Request Evaluation. They're notified to start one — and you're alerted the moment it's released.";
    ccta="Browse Players"; caction=function(){go("players");};
  }
  return (
    <Card style={{marginBottom:16,padding:16,borderTop:"3px solid "+C.coral}}>
      <WorkflowStrip steps={csteps} current={ccurrent}/>
      <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:14,color:C.navy,letterSpacing:.5,marginBottom:4}}>{ctitle}</div>
      <div style={{fontSize:13,color:C.gray600,lineHeight:1.55,marginBottom:12}}>{cbody}</div>
      <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
        <Btn v="primary" style={{fontSize:13,padding:"9px 18px"}} onClick={caction}>{ccta}</Btn>
        
      </div>
    </Card>
  );
}

function WorkflowGuide({cu, scoutReports, go}){
  if(!cu) return null;

  if(cu.type==="player"){
    var steps=["Profile","Upload","Report","Improve"];
    var hasEval=(scoutReports||[]).some(function(r){return String(r.playerId)===String(cu.id);});
    var approvedEvals=(scoutReports||[]).filter(function(r){return String(r.playerId)===String(cu.id) && (isLiveEval(r));});
    var profileComplete = !!(cu.position && cu.height && cu.weight && cu.gradYear && cu.bio && cu.bio.trim().length>10);
    var current, title, body, cta, action;
    if(!profileComplete){
      current=0;
      title="Step 1 · Complete your profile";
      body="Add your position, class year, height/weight, and a short bio. Full profiles rank higher when coaches search.";
      cta="Finish My Profile"; action=function(){go("profile");};
    } else if(!hasEval){
      current=1;
      title="Step 2 · Upload your first session";
      body="Upload one session video. BBOT returns measured results on every captured tool, verified measurements, a chart, and stamped clips.";
      cta="Upload a Session"; action=function(){go("upload-video");};
    } else if(approvedEvals.length<2){
      current=2;
      title="Step 3 · Your report is live";
      body="Share your public profile with coaches — then upload another session to start building your progression.";
      cta="Upload Again"; action=function(){go("upload-video");};
    } else {
      current=3;
      // days since last eval — gentle re-engagement
      var lastDate=approvedEvals.map(function(r){return r.date||"";}).sort().reverse()[0];
      var days=lastDate?Math.floor((Date.now()-new Date(lastDate).getTime())/86400000):0;
      title="You're rolling — "+approvedEvals.length+" sessions logged";
      body=days>=45 ? ("It's been "+days+" days. A fresh session keeps your progression current and keeps you visible to coaches.")
                    : "Keep uploading every few weeks. Your progression timeline is your edge.";
      cta="Upload New Session"; action=function(){go("upload-video");};
    }
    return (
      <Card style={{marginBottom:16,padding:16,borderTop:"3px solid "+C.coral}}>
        <WorkflowStrip steps={steps} current={current}/>
        <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:14,color:C.navy,letterSpacing:.5,marginBottom:4}}>{title}</div>
        <div style={{fontSize:13,color:C.gray600,lineHeight:1.55,marginBottom:12}}>{body}</div>
        <Btn v="primary" style={{fontSize:13,padding:"9px 18px"}} onClick={action}>{cta}</Btn>
      </Card>
    );
  }

  if(cu.type==="coach"){
    return <CoachWorkflowGuide cu={cu} go={go}/>;
  }
  return null;
}

function CoachMatchesCard({cu, users, scoutReports, go, embedded}){
  var [wants,setWants]=useState([]);
  var [loaded,setLoaded]=useState(false);
  useEffect(function(){
    fetch(SUPABASE_URL+"/rest/v1/bbot_wants?coach_id=eq."+String(cu.id)+"&order=created_at.desc", {headers:sbHeaders()})
      .then(function(r){return r.json();})
      .then(function(rows){ setWants(Array.isArray(rows)?rows:[]); setLoaded(true); })
      .catch(function(){ setLoaded(true); });
  },[]);
  if(!loaded || !wants.length) return null;

  // Latest metric value for a player + key, scanning all their approved evals' sections + measurements.
  function latestMetric(pid, key){
    var evs = (scoutReports||[]).filter(function(r){return String(r.playerId)===String(pid) && (isLiveEval(r));})
      .sort(function(a,b){return String(b.date||"").localeCompare(String(a.date||""));});
    for(var i=0;i<evs.length;i++){
      var secs = evs[i].sections||[];
      var hit = secs.find(function(s){return s.key===key && typeof s.measuredValue==="number";});
      if(hit) return hit.measuredValue;
    }
    return null;
  }
  // Build set of players who have at least one approved eval in the last 21 days.
  var cutoff = new Date(Date.now()-21*86400000).toISOString().slice(0,10);
  var freshPlayerIds = {};
  (scoutReports||[]).forEach(function(r){
    if((isLiveEval(r)) && String(r.date||"")>=cutoff) freshPlayerIds[String(r.playerId)]=true;
  });

  // Match each want's filters against fresh players.
  function matchesWant(player, f){
    if(!f) return false;
    if(f.gradYear && String(player.gradYear)!==String(f.gradYear)) return false;
    if(f.position && player.position && String(player.position).toLowerCase()!==String(f.position).toLowerCase()) return false;
    if(f.exitVeloMin){ var ev=latestMetric(player.id,"exitVelo"); if(ev==null||ev<Number(f.exitVeloMin)) return false; }
    if(f.throwVeloMin){ var tv=latestMetric(player.id,"throwVelo"); if(tv==null||tv<Number(f.throwVeloMin)) return false; }
    if(f.pitchVeloMin){ var pv=latestMetric(player.id,"pitchVelo"); if(pv==null||pv<Number(f.pitchVeloMin)) return false; }
    if(f.dash60Max){ var d=latestMetric(player.id,"dash60"); if(d==null||d>Number(f.dash60Max)) return false; }
    if(f.popTimeMax){ var pt=latestMetric(player.id,"popTime"); if(pt==null||pt>Number(f.popTimeMax)) return false; }
    // require at least one real criterion to have been set
    var hasCriterion = f.gradYear||f.position||f.exitVeloMin||f.throwVeloMin||f.pitchVeloMin||f.dash60Max||f.popTimeMax;
    return !!hasCriterion;
  }
  var playersList = (users||[]).filter(function(u){return u.type==="player" && freshPlayerIds[String(u.id)];});
  var matched = [];
  var seen = {};
  wants.forEach(function(w){
    var f = w.filters || w; // filters may be nested or flat
    playersList.forEach(function(p){
      if(seen[String(p.id)]) return;
      if(matchesWant(p,f)){ seen[String(p.id)]=true; matched.push(p); }
    });
  });
  if(!matched.length) return null;
  var inner = (
    <>
      <div style={{padding:"12px 16px",borderBottom:"1px solid "+C.border,borderTop:embedded?"1px solid "+C.border:"none",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
        <span style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:13,color:C.gray800,letterSpacing:1}}>🎯 MATCHES YOUR SEARCHES</span>
        
      </div>
      {matched.slice(0,5).map(function(p){return (
        <div key={p.id} onClick={function(){go("profile",p);}} style={{display:"flex",alignItems:"center",gap:10,padding:"11px 16px",cursor:"pointer",borderBottom:"1px solid "+C.border}}>
          <Avatar user={p} size={36}/>
          <div style={{flex:1,minWidth:0}}>
            <div style={{fontWeight:600,fontSize:14}}>{p.firstName} {p.lastName}</div>
            <div style={{fontSize:12,color:C.gray400,marginTop:1}}>{p.position||"—"}{p.gradYear?" · Class of "+p.gradYear:""} · new evaluation</div>
          </div>
          <Badge color="blue">NEW</Badge>
        </div>
      );})}
    </>
  );
  if(embedded) return inner;
  return (
    <Card style={{marginBottom:16,padding:0,overflow:"hidden",borderTop:"3px solid "+C.blue}}>
      {inner}
    </Card>
  );
}

// EVENTS A SIGNED-IN USER CAN SEE AND JOIN. Used twice: as a card on Home, and as the whole
// Events page (`asPage`) the nav points at.
//
// IT READS `/events`, NOT THE TABLE. The direct read worked only because `bbot_events` is granted
// to `authenticated` -- and that same grant handed every signed-in account `event_registrations`,
// which is every registered minor's jersey size, waiver and payment status. Proven 2026-10-22 with
// a throwaway account holding no profile row at all. The endpoint returns the public columns plus
// THIS viewer's own seat, so this page keeps working once the grant is revoked.
// [[anon-caller-not-admin-view]] [[sample-data-is-published-data]]
//
// SO IT NEVER REACHES INTO `event_registrations` ITSELF. `my_registration`, `my_event_number` and
// `registered_count` are computed server-side for admin and player alike, which is what lets one
// component render both shapes. [[one-source-name-what-it-counts]]
function EventsHomeSection({cu, asPage}){
  var evS=useState([]); var events=evS[0], setEvents=evS[1];
  var loadS=useState(true); var loading=loadS[0], setLoading=loadS[1];
  var errS=useState(""); var loadErr=errS[0], setLoadErr=errS[1];
  var [registerFor, setRegisterFor] = useState(null);

  useEffect(function(){
    fetch(BACKEND_URL+"/events",{headers:bbotAdminHeaders()})
      .then(function(r){
        if(!r.ok) throw new Error(r.status===401?"you are not signed in — sign out and back in":("the server answered HTTP "+r.status));
        return r.json();
      })
      .then(function(j){ setEvents((j&&j.events)||[]); setLoading(false); setLoadErr(""); })
      // WHY IT IS EMPTY IS ITSELF INFORMATION. Resolving to [] on failure renders the same nothing
      // as "no events scheduled", so a dead session looked identical to an empty calendar.
      .catch(function(err){ setEvents([]); setLoading(false); setLoadErr((err&&err.message)||"could not reach the backend"); });
  }, []);

  var today = new Date().toISOString().slice(0,10);
  var isPlayer = cu && cu.type==="player";
  // ANY LAUNCHED EVENT, same rule as the public section -- `published` is the decision, and a
  // second hidden test on the TYPE meant a launched showcase appeared nowhere.
  var upcoming = (events||[]).filter(function(e){ return e.published===true && (!e.start_date || String(e.end_date||e.start_date) >= today); });
  if(!asPage) upcoming = upcoming.slice(0,6);

  // Events this player is registered for (show their number + payment status).
  var mine = isPlayer ? (events||[]).filter(function(e){ return e.my_registration; }) : [];

  // AS A PAGE IT ALWAYS RENDERS SOMETHING. Collapsing to null is right for a home-page card and
  // wrong for a destination -- a nav entry leading to a blank screen reads as a broken site rather
  // than an empty calendar. [[absence-is-not-a-finding]]
  if(!asPage && (loading || (upcoming.length===0 && mine.length===0))) return null;

  function fmt(d){ if(!d) return ""; var p=String(d).split("-"); return p.length===3?(p[1]+"/"+p[2]+"/"+p[0].slice(2)):d; }
  function notify(m,t){ if(typeof window!=="undefined"&&window.__bbotNotify) window.__bbotNotify(m,t); }

  // Proper registration: store size/alt/waiver, assign number, then payment (same as EventsView).
  function handleRegistered(ev, reg, onDone){ saveEventRegistration(ev, reg, setEvents, notify, onDone); }
  function handleEventPaid(ev, pid){ markEventRegistrationPaid(ev, pid, setEvents); }

  return (
    <div style={{marginBottom:16}}>
      {asPage && (
        <div style={{marginBottom:14}}>
          <h2 style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:20,letterSpacing:1.5,color:C.navy,margin:"0 0 4px"}}>EVENTS</h2>
          <div style={{fontSize:12,color:C.gray500}}>Showcases, tryouts and pickup games. Register and your jersey number is assigned on the spot.</div>
        </div>
      )}
      {asPage && loading && <Card style={{padding:16,fontSize:12,color:C.gray500}}>Loading events…</Card>}
      {/* THE REASON, NOT A BLANK PAGE. A failed load and an empty calendar look identical
          otherwise, and one of them is something the viewer can act on. */}
      {asPage && !loading && loadErr && (
        <Card style={{padding:16,borderLeft:"3px solid "+C.coral}}>
          <div style={{fontSize:13,fontWeight:700,color:C.navy,marginBottom:4}}>Events could not be loaded</div>
          <div style={{fontSize:12,color:C.gray600}}>{loadErr}</div>
        </Card>
      )}
      {asPage && !loading && !loadErr && upcoming.length===0 && mine.length===0 && (
        <Card style={{padding:"20px 16px"}}>
          <div style={{fontSize:13,fontWeight:700,color:C.navy,marginBottom:4}}>No events scheduled right now</div>
          <div style={{fontSize:12,color:C.gray600,lineHeight:1.6}}>When 643 launches a showcase, tryout or pickup game it appears here and on the Activity page. Nothing is hidden from you — there is simply nothing on the calendar yet.</div>
        </Card>
      )}
      {/* YOUR EVENTS — what this player is registered for */}
      {isPlayer && mine.length>0 && (
        <Card style={{marginBottom:12,padding:16,borderLeft:"3px solid "+C.green}}>
          <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:13,color:C.navy,letterSpacing:1,marginBottom:10}}>✓ YOUR EVENTS</div>
          <div style={{display:"flex",flexDirection:"column",gap:8}}>
            {mine.map(function(ev){
              var reg=ev.my_registration||{};
              var num=ev.my_event_number;
              return (
                <div key={ev.id} style={{border:"1px solid "+C.border,borderRadius:10,padding:"10px 12px"}}>
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",gap:8,flexWrap:"wrap"}}>
                    <div style={{fontSize:13,fontWeight:700,color:C.navy}}>{ev.name} <span style={{color:C.coral}}>#{num||"—"}</span></div>
                    <span style={{fontSize:10,fontWeight:700,padding:"2px 8px",borderRadius:99,background:reg.paid?C.green:C.gray100,color:reg.paid?C.white:C.gray500}}>{reg.paid?"PAID":"PAYMENT DUE"}</span>
                  </div>
                  <div style={{fontSize:11,color:C.gray500,marginTop:3}}>{[fmt(ev.start_date),ev.start_time,(ev.venue||ev.location)].filter(Boolean).join(" · ")}{reg.size?(" · Size "+reg.size):""}</div>
                  {!reg.paid && <button onClick={function(){setRegisterFor(ev);}} style={{marginTop:8,padding:"6px 12px",borderRadius:7,border:"none",background:C.coral,color:C.white,fontSize:11,fontWeight:700,cursor:"pointer"}}>Complete payment</button>}
                </div>
              );
            })}
          </div>
        </Card>
      )}

      {/* UPCOMING — register */}
      {upcoming.length>0 && (
        <Card style={{padding:16,borderLeft:"3px solid "+C.coral}}>
          <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:13,color:C.navy,letterSpacing:1,marginBottom:10}}>📅 UPCOMING EVENTS</div>
          <div style={{display:"flex",flexDirection:"column",gap:8}}>
            {upcoming.map(function(ev){
              var reg = isPlayer && ev.my_registration;
              var dateStr = ev.start_date ? (fmt(ev.start_date) + (ev.end_date&&ev.end_date!==ev.start_date?(" – "+fmt(ev.end_date)):"")) : "Date TBA";
              var costStr = ev.cost ? ("$"+String(ev.cost).replace(/[^0-9.]/g,"")) : "";
              return (
                <div key={ev.id} style={{border:"1px solid "+C.border,borderRadius:10,padding:"10px 12px",display:"flex",justifyContent:"space-between",alignItems:"center",gap:10,flexWrap:"wrap"}}>
                  <div style={{flex:"1 1 auto",minWidth:160}}>
                    <div style={{fontSize:13,fontWeight:700,color:C.navy}}>{ev.name||"Pickup Game"}{costStr?(" · "+costStr):""}</div>
                    <div style={{fontSize:11,color:C.gray500,marginTop:2}}>{[dateStr,ev.start_time,(ev.venue||ev.location)].filter(Boolean).join(" · ")}</div>
                  </div>
                  {isPlayer ? (
                    reg ? <span style={{flexShrink:0,fontSize:12,color:C.green,fontWeight:700}}>✓ Registered (#{ev.my_event_number||"—"})</span>
                        : <button onClick={function(){setRegisterFor(ev);}} style={{flexShrink:0,padding:"7px 14px",borderRadius:8,border:"none",background:C.coral,color:C.white,fontSize:12,fontWeight:700,cursor:"pointer"}}>Register</button>
                  ) : (
                    <span style={{flexShrink:0,fontSize:11,color:C.gray400}}>{Number(ev.registered_count)||0} registered</span>
                  )}
                </div>
              );
            })}
          </div>
        </Card>
      )}

      {registerFor && <EventRegisterModal ev={registerFor} cu={cu} notify={notify} onClose={function(){setRegisterFor(null);}} onRegistered={function(reg,onDone){ handleRegistered(registerFor, reg, onDone); }} onPaid={function(ev,pid){ handleEventPaid(ev,pid); }}/>}
    </div>
  );
}

function HomePage({go,users,cu,feed,setFeed,toggleFollow,setAdminTab,scoutReports,metrics}){
  var players=users.filter(function(u){return u.type==="player";}).slice(0,4);
  var coaches=users.filter(function(u){return u.type==="coach";}).slice(0,3);
  function like(id){setFeed(function(f){return f.map(function(item){if(item.id!==id)return item;var liked=(item.likedBy||[]).includes(cu.id);return{...item,likes:liked?item.likes-1:item.likes+1,likedBy:liked?(item.likedBy||[]).filter(function(x){return x!==cu.id;}):(item.likedBy||[]).concat([cu.id])};});});}

  // Universal pending-approval banner. Every new account is pending until an admin approves
  // it; until then paid actions (upload/eval) are blocked. Shown across all account types.
  var pendingBanner = (cu.approvalStatus==="pending") ? (
    <div style={{background:"#fffbeb",border:"1px solid #fcd34d",borderRadius:12,padding:"14px 18px",marginBottom:16}}>
      <div style={{fontWeight:700,color:"#92400e",fontSize:14,marginBottom:3}}>Account pending approval</div>
      <div style={{fontSize:12,color:"#78350f",lineHeight:1.5}}>Welcome! Your profile is being reviewed by an admin. Once approved you'll get a welcome email and full access — including uploads and evaluations. You can fill out your profile in the meantime.</div>
    </div>
  ) : null;

  if(cu.type==="staff")return(
    <div>
      {pendingBanner}
      {cu.staffApproved===false && (
        <div style={{background:"#fffbeb",border:"1px solid #fcd34d",borderRadius:12,padding:"14px 18px",marginBottom:16}}>
          <div style={{fontWeight:700,color:"#92400e",fontSize:14,marginBottom:3}}>Account pending approval</div>
          <div style={{fontSize:12,color:"#78350f",lineHeight:1.5}}>An admin is reviewing your staff account. Once approved, you can add players and run evaluations. You will be notified.</div>
        </div>
      )}
      <div style={{background:"linear-gradient(135deg,"+C.navy+","+C.navyMid+")",borderRadius:16,padding:"24px 20px",marginBottom:20,boxShadow:C.shadowMd}}>
        <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:18}}>
          <BbotMark tile="transparent" size={32}/>
          <div>
            <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:20,color:C.white,letterSpacing:1}}>Staff Dashboard</div>
            <div style={{color:"rgba(255,255,255,.62)",fontSize:13,marginTop:1}}>{cu.firstName} {cu.lastName}  -  {cu.staffRole||"Staff"}</div>
          </div>
          <div style={{marginLeft:"auto",display:"flex",gap:8}}>
            {bbotIsAdmin(cu) && <button onClick={function(){
              var link=window.location.origin+window.location.pathname+"?staff_invite="+STAFF_INVITE_TOKEN+"#auth";
              if(navigator.clipboard){navigator.clipboard.writeText(link).then(function(){notify("Staff invite link copied");}).catch(function(){window.prompt("Copy staff invite link:",link);});}
              else window.prompt("Copy staff invite link:",link);
            }} style={{background:"rgba(255,255,255,0.1)",color:C.white,border:"1px solid rgba(255,255,255,0.25)",padding:"6px 12px",borderRadius:8,fontSize:11,cursor:"pointer",fontWeight:600}}>＋ Staff Invite Link (passcode: {STAFF_PASSCODE})</button>}
            <button onClick={function(){go("landing");}} style={{background:"rgba(255,255,255,0.1)",color:C.white,border:"1px solid rgba(255,255,255,0.25)",padding:"6px 12px",borderRadius:8,fontSize:11,cursor:"pointer",fontWeight:600}}>View Public Site</button>
          </div>
        </div>
        <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(min(180px,100%),1fr))",gap:10}}>
          <button onClick={function(){setAdminTab("metrics");go("admin");}} style={{background:C.coral,color:C.white,border:"none",padding:"16px 14px",borderRadius:12,fontWeight:700,fontSize:13,cursor:"pointer",textAlign:"left",boxShadow:"0 4px 12px rgba(232,82,106,.35)"}}>
            <div style={{fontSize:22,marginBottom:6}}>📊</div>
            <div style={{fontSize:14}}>Enter Metrics</div>
            <div style={{fontSize:11,opacity:.8,marginTop:2}}>Log session data</div>
          </button>
          <button onClick={function(){setAdminTab("scout");go("admin");}} style={{background:"rgba(255,255,255,.1)",color:C.white,border:"1px solid rgba(255,255,255,.15)",padding:"16px 14px",borderRadius:12,fontWeight:700,fontSize:13,cursor:"pointer",textAlign:"left"}}>
            <div style={{fontSize:22,marginBottom:6}}>⚾</div>
            <div style={{fontSize:14}}>Scout Report</div>
            <div style={{fontSize:11,opacity:.55,marginTop:2}}>AI evaluation</div>
          </button>
        </div>
      </div>
      <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(min(180px,100%),1fr))",gap:12}}>
        {([["📋","My Reports","View generated reports","myreports"],["📁","History","Session metrics log","history"],["⚾","Players","Browse player profiles","players"],["🎓","Coaches","Coach directory","coaches"],["⚖️","Compare","Stack up to 10 players side-by-side","compare"]].concat((cu.type==="coach"||bbotIsAdmin(cu))?[]:[])).map(function(item){return(
          <Card key={item[1]} style={{cursor:"pointer",padding:16}} onClick={function(){if(item[3]==="myreports"||item[3]==="history"){setAdminTab(item[3]);go("admin");}else go(item[3]);}}>
            <div style={{fontSize:26,marginBottom:8}}>{item[0]}</div>
            <div style={{fontWeight:700,fontSize:14,color:C.gray800,marginBottom:3}}>{item[1]}</div>
            <div style={{fontSize:12,color:C.gray400}}>{item[2]}</div>
          </Card>
        );})}
      </div>
      {/* The footer that used to live here now renders once for EVERY page and every role —
          see LegalFooter. It sat inside `if(cu.type==="staff")` in this component, which meant the
          Terms / Privacy / Compliance links were reachable only by a staff signup awaiting
          approval. Legal documents are not role-gated content. (Ruled by Luis 2026-08-17.) */}
    </div>
  );

  return(
    <div>
      {pendingBanner}
      <div style={{background:"linear-gradient(135deg,"+C.navy+","+C.navyMid+")",borderRadius:16,padding:"20px 18px",marginBottom:16,boxShadow:C.shadowMd}}>
        <div style={{display:"flex",alignItems:"center",gap:12}}>
          <BbotMark tile="transparent" size={32}/>
          <div>
            <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:20,color:C.white,letterSpacing:1}}>Welcome, {cu.firstName}!</div>
            <div style={{color:"rgba(255,255,255,.62)",fontSize:12,marginTop:1}}>{cu.type==="coach"?"Find and track your next prospects.":"Your verified baseball profile."}</div>
          </div>
        </div>
      </div>

      {/* WORKFLOW GUIDE — the spine. One card, current step only, single action. */}
      <WorkflowGuide cu={cu} scoutReports={scoutReports} go={go}/>

      {/* #8 EVENTS & TOURNAMENTS — visible to players & coaches; players can sign up */}
      <EventsHomeSection cu={cu}/>

      {/* #1 COACHES WATCHING YOU — players see real coach interest (private to them) */}
      {cu.type==="player" && (function(){
        var views = (cu.profileViews||[]);
        if(!views.length) return null;
        var weekAgo = new Date(Date.now()-7*86400000).toISOString().slice(0,10);
        var recent = views.filter(function(v){return String(v.date)>=weekAgo;});
        var viewerIds = {}; recent.forEach(function(v){viewerIds[String(v.viewerId)]=true;});
        var coachViewers = Object.keys(viewerIds).map(function(id){return users.find(function(u){return String(u.id)===id;});}).filter(function(u){return u && (u.type==="coach"||u.type==="staff");});
        var totalRecent = Object.keys(viewerIds).length;
        if(totalRecent===0) return null;
        return (
          <Card style={{marginBottom:16,padding:16,borderLeft:"3px solid "+C.blue,background:C.blueFaint}}>
            <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:13,color:C.navy,letterSpacing:.5,marginBottom:6}}>👀 WHO'S WATCHING</div>
            <div style={{fontSize:13,color:C.gray700,lineHeight:1.5,marginBottom:coachViewers.length?10:0}}>
              <strong>{totalRecent}</strong> {totalRecent===1?"person":"people"} viewed your profile this week{coachViewers.length?(" — including "+coachViewers.length+" "+(coachViewers.length===1?"coach":"coaches")+"."):"."}
            </div>
            {coachViewers.length>0 && (
              <div style={{display:"flex",flexWrap:"wrap",gap:8}}>
                {coachViewers.slice(0,6).map(function(c){return (
                  <div key={c.id} onClick={function(){go("profile",c);}} style={{display:"flex",alignItems:"center",gap:6,background:C.white,border:"1px solid "+C.border,borderRadius:99,padding:"4px 10px 4px 4px",cursor:"pointer"}}>
                    <Avatar user={c} size={22}/>
                    <span style={{fontSize:11,fontWeight:600,color:C.navy}}>{c.type==="staff"?"643 Staff":("Coach "+c.lastName)}</span>
                  </div>
                );})}
              </div>
            )}
          </Card>
        );
      })()}

      {/* #4 PERSONAL BEST — celebrate the player's career-high on a key metric */}
      {cu.type==="player" && (function(){
        var hist = (metrics && metrics[cu.id]) || [];
        if(!hist.length) return null;
        var defs = [["exitVelo","Exit Velo","mph",true],["throwVelo","Throw Velo","mph",true],["pitchVelo","Pitch Velo","mph",true],["dash60","60-Yard Dash","s",false],["popTime","Top Pop Time","s",false]];
        var bests = [];
        defs.forEach(function(d){
          var vals = hist.map(function(m){return m[d[0]];}).filter(function(v){return typeof v==="number" && v>0;});
          if(!vals.length) return;
          var best = d[3] ? Math.max.apply(null,vals) : Math.min.apply(null,vals);
          bests.push({label:d[1],val:best,unit:d[2]});
        });
        if(!bests.length) return null;
        return (
          <Card style={{marginBottom:16,padding:14,borderLeft:"3px solid "+C.green,background:"linear-gradient(135deg,#fff,#f0fdf4)"}}>
            <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:11,color:C.green,letterSpacing:1.2,marginBottom:8,fontWeight:700}}>🏆 YOUR PERSONAL BESTS</div>
            <div style={{display:"flex",flexWrap:"wrap",gap:14}}>
              {bests.map(function(b,i){return (
                <div key={i}>
                  <div style={{fontSize:18,fontWeight:700,color:C.navy,lineHeight:1}}>{b.val}<span style={{fontSize:11,color:C.gray400,marginLeft:2}}>{b.unit}</span></div>
                  <div style={{fontSize:10,color:C.gray500,marginTop:2,textTransform:"uppercase",letterSpacing:.5}}>{b.label}</div>
                </div>
              );})}
            </div>
          </Card>
        );
      })()}

      {/* RECRUITING HUB — coach command center: matches + tools */}
      {cu.type==="coach" && (function(){
        var tools=[["Compare","compare"],["My Roster","my-roster"],["Invite Team","invite-team"]];
        return (
          <Card style={{marginBottom:16,padding:0,overflow:"hidden",borderTop:"3px solid "+C.coral}}>
            <div style={{padding:"14px 16px 12px"}}>
              <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:13,color:C.coral,letterSpacing:1.2,fontWeight:700,marginBottom:10}}>RECRUITING HUB</div>
              <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
                {tools.map(function(t){return (
                  <button key={t[1]} onClick={function(){go(t[1]);}} style={{fontSize:11,fontWeight:700,padding:"7px 12px",background:C.gray50,color:C.navy,border:"1px solid "+C.border,borderRadius:8,cursor:"pointer"}}>{t[0]}</button>
                );})}
              </div>
            </div>
            {/* Matches your searches (dynamic) */}
            <CoachMatchesCard cu={cu} users={users} scoutReports={scoutReports} go={go} embedded={true}/>
          </Card>
        );
      })()}

      {/* REFERRAL CODE — for players to share */}
      {cu.type==="player" && (function(){
        var refCode = "BBOT-" + String(cu.id).slice(-4) + "-" + (cu.firstName||"").slice(0,3).toUpperCase();
        return (
          <Card style={{padding:14,marginBottom:16,borderLeft:"3px solid "+C.green,background:"linear-gradient(135deg,#fff,#f0fdf4)"}}>
            <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:11,color:C.green,letterSpacing:1.2,marginBottom:6,fontWeight:700}}>REFER A TEAMMATE</div>
            <div style={{fontSize:12,color:C.gray700,marginBottom:10,lineHeight:1.5}}>Share BBOT with teammates — send them your code so they can build their own profile.</div>
            <div style={{display:"flex",gap:8,alignItems:"center",flexWrap:"wrap"}}>
              <div style={{flex:"1 1 160px",padding:"8px 12px",background:C.white,border:"1.5px dashed "+C.green,borderRadius:6,fontFamily:"monospace",fontSize:13,fontWeight:700,color:C.navy,textAlign:"center",letterSpacing:1}}>{refCode}</div>
              <button onClick={function(){
                var url = window.location.origin+window.location.pathname+"?ref="+encodeURIComponent(refCode);
                if(navigator.clipboard){
                  navigator.clipboard.writeText(url).then(function(){
                    notify("Referral link copied — share with teammates");
                  }).catch(function(){window.prompt("Copy referral link:",url);});
                } else {
                  window.prompt("Copy referral link:",url);
                }
              }} style={{padding:"8px 14px",background:C.green,color:C.white,border:"none",borderRadius:6,fontSize:11,fontWeight:700,cursor:"pointer"}}>↗ Copy Link</button>
            </div>
          </Card>
        );
      })()}

      {(function(){
        // PLAYERS TRENDING UP — public discovery. For each player, compare avg tool
        // grade of their two most recent approved evals; rank by positive improvement.
        var byPlayer = {};
        (scoutReports||[]).forEach(function(r){
          if(!(isLiveEval(r))) return;
          if(!r.sections || !r.sections.length) return;
          var graded = r.sections.filter(function(s){return typeof s.grade==="number" && s.grade>0;});
          if(!graded.length) return;
          var avg = graded.reduce(function(a,s){return a+s.grade;},0)/graded.length;
          var pid = String(r.playerId);
          (byPlayer[pid] = byPlayer[pid] || []).push({date:r.date||"", avg:avg});
        });
        var trending = Object.keys(byPlayer).map(function(pid){
          var evs = byPlayer[pid].sort(function(a,b){return String(a.date).localeCompare(String(b.date));});
          if(evs.length<2) return null;
          var prev = evs[evs.length-2].avg, latest = evs[evs.length-1].avg;
          var delta = latest - prev;
          if(delta<=0) return null;
          var p = users.find(function(u){return String(u.id)===pid && u.type==="player";});
          if(!p) return null;
          return {player:p, delta:delta, latest:latest, sessions:evs.length};
        }).filter(Boolean).sort(function(a,b){return b.delta-a.delta;}).slice(0,5);
        if(trending.length===0) return null;
        return (
          <Card style={{padding:0,overflow:"hidden",marginBottom:16,borderTop:"3px solid "+C.green}}>
            <div style={{padding:"14px 18px",borderBottom:"1px solid "+C.border,display:"flex",justifyContent:"space-between",alignItems:"center"}}>
              <span style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:13,color:C.gray800,letterSpacing:1}}>📈 TRENDING UP</span>
              <span style={{fontSize:10,color:C.gray400,letterSpacing:.3}}>Biggest grade gains across sessions</span>
            </div>
            {trending.map(function(t){return(
              <div key={t.player.id} style={{display:"flex",alignItems:"center",gap:10,padding:"11px 18px",cursor:"pointer",borderBottom:"1px solid "+C.border}} onClick={function(){go("profile",t.player);}}>
                <Avatar user={t.player} size={36}/>
                <div style={{flex:1,minWidth:0}}>
                  <div style={{fontWeight:600,fontSize:14}}>{t.player.firstName} {t.player.lastName}</div>
                  <div style={{fontSize:12,color:C.gray400,marginTop:1}}>{t.player.position||"—"}{t.player.gradYear?" · Class of "+t.player.gradYear:""} · {t.sessions} sessions</div>
                </div>
                <div style={{textAlign:"right",flexShrink:0}}>
                  <div style={{fontSize:13,fontWeight:700,color:C.green}}>↑ {t.delta.toFixed(1)}</div>
                  <div style={{fontSize:10,color:C.gray400}}>avg grade</div>
                </div>
              </div>
            );})}
          </Card>
        );
      })()}

      <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(min(290px,100%),1fr))",gap:16,marginBottom:16}}>
        <Card style={{padding:0,overflow:"hidden"}}>
          <div style={{padding:"14px 18px",borderBottom:"1px solid "+C.border,display:"flex",justifyContent:"space-between",alignItems:"center"}}>
            <span style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:13,color:C.gray800,letterSpacing:1}}>FEATURED PLAYERS</span>
            <Btn v="link" style={{fontSize:12}} onClick={function(){go("players");}}>View all Next</Btn>
          </div>
          {players.map(function(p){return(
            <div key={p.id} style={{display:"flex",alignItems:"center",gap:10,padding:"11px 18px",cursor:"pointer"}} onClick={function(){go("profile",p);}}>
              <Avatar user={p} size={36}/>
              <div style={{flex:1}}><div style={{fontWeight:600,fontSize:14}}>{p.firstName} {p.lastName}</div><div style={{fontSize:12,color:C.gray400,marginTop:1}}>{p.position}  -  Class of {p.gradYear}</div></div>
              {p.position&&<Badge color="blue">{p.position}</Badge>}
            </div>
          );})}
        </Card>
        <Card style={{padding:0,overflow:"hidden"}}>
          <div style={{padding:"14px 18px",borderBottom:"1px solid "+C.border,display:"flex",justifyContent:"space-between",alignItems:"center"}}>
            <span style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:13,color:C.gray800,letterSpacing:1}}>COACHES and PROGRAMS</span>
            <Btn v="link" style={{fontSize:12}} onClick={function(){go("coaches");}}>View all Next</Btn>
          </div>
          {coaches.map(function(c){return(
            <div key={c.id} style={{display:"flex",alignItems:"center",gap:10,padding:"11px 18px",cursor:"pointer"}} onClick={function(){go("profile",c);}}>
              <Avatar user={c} size={36}/>
              <div style={{flex:1}}><div style={{fontWeight:600,fontSize:14}}>{c.firstName} {c.lastName}</div><div style={{fontSize:12,color:C.gray400,marginTop:1}}>{c.orgName}</div></div>
              {c.level&&<Badge color="gray">{c.level}</Badge>}
            </div>
          );})}
        </Card>
      </div>
      <Card style={{padding:0,overflow:"hidden"}}>
        <div style={{padding:"14px 18px",borderBottom:"1px solid "+C.border,display:"flex",justifyContent:"space-between",alignItems:"center"}}>
          <span style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:13,color:C.gray800,letterSpacing:1}}>YOUR RECENT ACTIVITY</span>
          <Btn v="link" style={{fontSize:12}} onClick={function(){go("feed");}}>Full feed →</Btn>
        </div>
        {(function(){
          var mine = (feed||[]).filter(function(item){return String(item.userId)===String(cu.id);});
          if(mine.length===0){
            return <div style={{padding:"20px 18px",fontSize:13,color:C.gray400,textAlign:"center"}}>No activity yet. Upload a session to get started.</div>;
          }
          return mine.slice(0,4).map(function(item){
          var u=users.find(function(x){return x.id===item.userId;});
          var liked=(item.likedBy||[]).includes(cu.id);
          return(
            <div key={item.id} style={{display:"flex",gap:10,alignItems:"center",padding:"11px 18px",borderBottom:"1px solid "+C.border}}>
              {u&&<div style={{cursor:"pointer",flexShrink:0}} onClick={function(){go("profile",u);}}><Avatar user={u} size={32}/></div>}
              <div style={{flex:1,minWidth:0}}><div style={{fontSize:13,color:C.gray700,lineHeight:1.5}}>{item.text}</div><div style={{fontSize:11,color:C.gray400,marginTop:2}}>{item.date}</div></div>
              <BaseballLike liked={liked} count={item.likes} onClick={function(){like(item.id);}}/>
            </div>
          );
        });
        })()}
      </Card>

      {/* FULL GUIDE — collapsed reference at the bottom; WorkflowGuide leads up top */}
      {(cu.type==="player"||cu.type==="coach") && (
        <div style={{marginTop:16}}>
          <HowToUse role={cu.type} defaultOpen={false}/>
        </div>
      )}
    </div>
  );
}


// PRIVATE FEED TYPES — these are written to feed_items for the user's own personal record
// (so they show on "Your Activity") but are NEVER shown in the site-wide Feed. Things like
// who requested an eval, who viewed whose profile, follows — those are private to the
// parties involved, not community activity.
var PRIVATE_FEED_TYPES = ["eval_request", "update_request", "follow", "profile_view", "player_interest"];

// Shared saved-search matcher (#5). Returns true if a player satisfies all of a saved
// search's filters. metricFn(playerId, key) returns the player's latest numeric value for
// that metric (exitVelo, throwVelo, etc.) or null. Used both by the Saved Searches page and
// by the release-time alert fan-out so the two never drift in how they judge a "match".
function playerMatchesWant(player, filters, metricFn){
  if(!player || player.type!=="player") return false;
  var f = filters || {};
  if(f.gradYear && String(player.gradYear||"").indexOf(String(f.gradYear))<0) return false;
  if(f.position){
    var pos=String(f.position).toUpperCase();
    if((player.position||"").toUpperCase().indexOf(pos)<0 && (player.position2||"").toUpperCase().indexOf(pos)<0) return false;
  }
  if(f.region){
    var rg=String(f.region).toUpperCase();
    if((player.state||"").toUpperCase().indexOf(rg)<0 && (player.city||"").toUpperCase().indexOf(rg)<0 && (player.hsName||"").toUpperCase().indexOf(rg)<0) return false;
  }
  var m=function(k){ return metricFn ? metricFn(player.id,k) : null; };
  if(f.exitVeloMin){ var ev=m("exitVelo"); if(ev==null || ev<Number(f.exitVeloMin)) return false; }
  if(f.throwVeloMin){ var tv=m("throwVelo"); if(tv==null || tv<Number(f.throwVeloMin)) return false; }
  if(f.pitchVeloMin){ var pv=m("pitchVelo"); if(pv==null || pv<Number(f.pitchVeloMin)) return false; }
  if(f.dash60Max){ var d=m("dash60"); if(d==null || d>Number(f.dash60Max)) return false; }
  if(f.popTimeMax){ var pt=m("popTime"); if(pt==null || pt>Number(f.popTimeMax)) return false; }
  return true;
}

function FeedPage({feed,setFeed,users,cu,go}){
  function like(id){setFeed(function(f){return f.map(function(item){if(item.id!==id)return item;var liked=(item.likedBy||[]).includes(cu.id);return{...item,likes:liked?item.likes-1:item.likes+1,likedBy:liked?(item.likedBy||[]).filter(function(x){return x!==cu.id;}):(item.likedBy||[]).concat([cu.id])};});});}
  var typeCol={metric:C.orange,video:C.blue,follow:C.green,review:C.orange,report:C.blue,bbot:C.blue,profile:C.gray500};
  // Site-wide feed: everyone's PUBLIC activity. Private types stay hidden from this view.
  var publicItems = (feed||[]).filter(function(item){return PRIVATE_FEED_TYPES.indexOf(item.type) === -1;});
  return(
    <div style={{maxWidth:600,margin:"0 auto",width:"100%"}}>
      <div style={{marginBottom:20}}><h1 style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:26,letterSpacing:2,color:C.gray900}}>FEED</h1><p style={{color:C.gray400,fontSize:13,marginTop:3}}>Community activity across 643</p></div>
      {publicItems.map(function(item){
        var u=users.find(function(x){return x.id===item.userId;});
        var liked=(item.likedBy||[]).includes(cu.id);
        return(
          <Card key={item.id} style={{marginBottom:10,padding:0,overflow:"hidden"}}>
            <div style={{display:"flex",gap:0}}>
              <div style={{width:3,background:typeCol[item.type]||C.gray300,flexShrink:0}}/>
              <div style={{display:"flex",gap:10,alignItems:"flex-start",padding:"14px",flex:1}}>
                <div style={{cursor:"pointer",flexShrink:0}} onClick={function(){if(u)go("profile",u);}}>
                  {u?<Avatar user={u} size={38}/>:<div style={{width:38,height:38,borderRadius:"50%",background:C.gray100,display:"flex",alignItems:"center",justifyContent:"center"}}>⚾</div>}
                </div>
                <div style={{flex:1,minWidth:0}}>
                  <div style={{fontSize:13,color:C.gray700,lineHeight:1.5,marginBottom:6}}>{item.text}</div>
                  <div style={{display:"flex",gap:8,alignItems:"center"}}>
                    <span style={{fontSize:11,color:C.gray400}}>{item.date}</span>
                    <span style={{fontSize:10,fontWeight:700,color:typeCol[item.type]||C.gray400,textTransform:"uppercase",letterSpacing:.5}}>{item.type}</span>
                  </div>
                </div>
                <BaseballLike liked={liked} count={item.likes} onClick={function(){like(item.id);}}/>
              </div>
            </div>
          </Card>
        );
      })}
      {publicItems.length===0 && (
        <Card style={{padding:"28px 18px",textAlign:"center"}}>
          <div style={{fontSize:13,color:C.gray400}}>No activity yet. Once players upload sessions or reports get released, you'll see them here.</div>
        </Card>
      )}
    </div>
  );
}

// Profile "Feed" tab — shows the PROFILE OWNER's activity history.
// Visibility rules:
//   - Profile owner viewing their own profile: sees ALL their items (incl. private)
//   - Anyone else viewing the profile: sees the owner's items with private types omitted
// The same private-type filter the site-wide Feed uses (eval_request, update_request,
// follow, profile_view) applies here for non-owners.
function YourActivityPage({feed,setFeed,users,cu,go,profileUser,isOwn}){
  function like(id){setFeed(function(f){return f.map(function(item){if(item.id!==id)return item;var liked=(item.likedBy||[]).includes(cu.id);return{...item,likes:liked?item.likes-1:item.likes+1,likedBy:liked?(item.likedBy||[]).filter(function(x){return x!==cu.id;}):(item.likedBy||[]).concat([cu.id])};});});}
  var typeCol={metric:C.orange,video:C.blue,follow:C.green,review:C.orange,report:C.blue,bbot:C.blue,profile:C.gray500,eval_request:C.coral,update_request:C.coral,profile_view:C.gray500};
  var ownerId = (profileUser && profileUser.id) || (cu && cu.id);
  var ownerItems = (feed||[]).filter(function(item){return String(item.userId)===String(ownerId);});
  // Private items stay visible only to the profile owner themselves.
  var visibleItems = isOwn ? ownerItems : ownerItems.filter(function(item){return PRIVATE_FEED_TYPES.indexOf(item.type) === -1;});
  var headerTitle = isOwn ? "Your Feed" : "Feed";
  var headerSub = isOwn ? "Your uploads, evaluations, follows, and requests" : ((profileUser&&profileUser.firstName)||"This user")+"'s recent public activity";
  return(
    <div style={{maxWidth:600,margin:"0 auto",width:"100%"}}>
      <div style={{marginBottom:20}}><h1 style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:26,letterSpacing:2,color:C.gray900}}>{headerTitle}</h1><p style={{color:C.gray400,fontSize:13,marginTop:3}}>{headerSub}</p></div>
      {visibleItems.map(function(item){
        var u=users.find(function(x){return x.id===item.userId;});
        var liked=(item.likedBy||[]).includes(cu.id);
        return(
          <Card key={item.id} style={{marginBottom:10,padding:0,overflow:"hidden"}}>
            <div style={{display:"flex",gap:0}}>
              <div style={{width:3,background:typeCol[item.type]||C.gray300,flexShrink:0}}/>
              <div style={{display:"flex",gap:10,alignItems:"flex-start",padding:"14px",flex:1}}>
                <div style={{cursor:"pointer",flexShrink:0}} onClick={function(){if(u)go("profile",u);}}>
                  {u?<Avatar user={u} size={38}/>:<div style={{width:38,height:38,borderRadius:"50%",background:C.gray100,display:"flex",alignItems:"center",justifyContent:"center"}}>⚾</div>}
                </div>
                <div style={{flex:1,minWidth:0}}>
                  <div style={{fontSize:13,color:C.gray700,lineHeight:1.5,marginBottom:6}}>{item.text}</div>
                  <div style={{display:"flex",gap:8,alignItems:"center"}}>
                    <span style={{fontSize:11,color:C.gray400}}>{item.date}</span>
                    <span style={{fontSize:10,fontWeight:700,color:typeCol[item.type]||C.gray400,textTransform:"uppercase",letterSpacing:.5}}>{item.type}</span>
                  </div>
                </div>
                <BaseballLike liked={liked} count={item.likes} onClick={function(){like(item.id);}}/>
              </div>
            </div>
          </Card>
        );
      })}
      {visibleItems.length===0 && (
        <Card style={{padding:"28px 18px",textAlign:"center"}}>
          <div style={{fontSize:13,color:C.gray400}}>{isOwn ? "No activity yet. Upload a session to get started." : "No public activity yet."}</div>
        </Card>
      )}
    </div>
  );
}


function DirPage({type,users,cu,go,toggleFollow,metrics,scoutReports,setUsers,pushFeed,notify,coachUpdates,setCoachUpdates}){
  var qState=useState(""); var q=qState[0]; var setQ=qState[1];
  var sortState=useState("exitVelo"); var sortBy=sortState[0]; var setSortBy=sortState[1];
  var posFilterState=useState("All"); var posFilter=posFilterState[0]; var setPosFilter=posFilterState[1];
  var yearFilterState=useState("All"); var yearFilter=yearFilterState[0]; var setYearFilter=yearFilterState[1];
  var minScoreState=useState(""); var minScore=minScoreState[0]; var setMinScore=minScoreState[1];
  var minEVState=useState(""); var minEV=minEVState[0]; var setMinEV=minEVState[1];
  var minAvgEVState=useState(""); var minAvgEV=minAvgEVState[0]; var setMinAvgEV=minAvgEVState[1];
  var minThrowState=useState(""); var minThrow=minThrowState[0]; var setMinThrow=minThrowState[1];
  var minPitchState=useState(""); var minPitch=minPitchState[0]; var setMinPitch=minPitchState[1];
  var maxDashState=useState(""); var maxDash=maxDashState[0]; var setMaxDash=maxDashState[1];
  var advState=useState(false); var advOpen=advState[0]; var setAdvOpen=advState[1];

  // RECALL SAVED SEARCH on mount if coach clicked "Run" from home
  useEffect(function(){
    if(typeof window!=="undefined" && window.__bbotSearchRecall){
      var c = window.__bbotSearchRecall;
      if(c.q) setQ(c.q);
      if(c.position) setPosFilter(c.position);
      if(c.gradYear) setYearFilter(c.gradYear);
      if(c.minScore) setMinScore(c.minScore);
      if(c.minEV) setMinEV(c.minEV);
      if(c.minAvgEV) { setMinAvgEV(c.minAvgEV); setAdvOpen(true); }
      if(c.minThrow) { setMinThrow(c.minThrow); setAdvOpen(true); }
      if(c.minPitch) { setMinPitch(c.minPitch); setAdvOpen(true); }
      if(c.maxDash) { setMaxDash(c.maxDash); setAdvOpen(true); }
      window.__bbotSearchRecall = null;
    }
  }, []);
  var isCoachOrAdmin=cu.type==="coach"||bbotIsAdmin(cu)||cu.type==="staff";
  var cfg={player:{title:"PLAYERS",sub:"Find and evaluate players"},coach:{title:"COACHES",sub:"Browse coaching staff"},staff:{title:"643 SPORTS MGMT",sub:"643 / BBOT team"}};
  var c=cfg[type]||cfg.player;

  var getScore=function(uid){var reports=(scoutReports||[]).filter(function(r){return Number(r.playerId)===Number(uid)&&isLiveEval(r);});if(!reports.length)return null;return reports[reports.length-1].score||null;};
  // Latest released-eval date for a player — powers the "last activity" hint on cards so
  // coaches can see who's actively adding evaluations. Returns an ISO date string or null.
  var getLastEvalDate=function(uid){
    var rs=(scoutReports||[]).filter(function(r){return Number(r.playerId)===Number(uid)&&(isLiveEval(r));});
    if(!rs.length) return null;
    var dates=rs.map(function(r){return r.date||r.sessionDate||"";}).filter(Boolean).sort();
    return dates.length?dates[dates.length-1]:null;
  };
  // Metric accessors — pull from the player's measurement history.
  var _vals=function(uid,key){var m=(metrics||{})[uid]||[];return m.filter(function(x){return x[key]!=null&&x[key]!=="";}).map(function(x){return Number(x[key]);}).filter(function(n){return !isNaN(n);});};
  var getEV=function(uid){var v=_vals(uid,"exitVelo");return v.length?Math.max.apply(null,v):null;};               // peak exit velo
  var getAvgEV=function(uid){var v=_vals(uid,"exitVelo");return v.length?Math.round(v.reduce(function(a,b){return a+b;},0)/v.length):null;}; // avg exit velo
  var getThrow=function(uid){var v=_vals(uid,"throwVelo");return v.length?Math.max.apply(null,v):null;};            // peak throw velo
  var getPitch=function(uid){var v=_vals(uid,"pitchVelo");return v.length?Math.max.apply(null,v):null;};            // peak pitch velo
  var getDash=function(uid){var v=_vals(uid,"dash60");return v.length?Math.min.apply(null,v):null;};                // best (lowest) 60-time

  var positions=["All"].concat(Array.from(new Set((users||[]).filter(function(u){return u.type==="player"&&u.position;}).map(function(u){return u.position;}))).sort());
  var gradYears=["All"].concat(Array.from(new Set((users||[]).filter(function(u){return u.type==="player"&&u.gradYear;}).map(function(u){return String(u.gradYear)}))).sort());

  var _viewerIsAdmin = cu && bbotIsAdmin(cu);
  var list=(users||[]).filter(function(u){
    if(u.type!==type) return false;
    // Provisional placeholders (unidentified jerseys from multi-player sessions) never show in
    // the public directory — they live in the admin "Unassigned Players" queue until identified.
    if(u.provisional && !_viewerIsAdmin) return false;
    // Hide not-yet-approved (pending) and denied profiles from the public directory so spam/
    // unreviewed signups aren't visible. Legacy accounts (no approvalStatus) stay visible.
    // Admin sees everyone. A user always sees their own card.
    if(!_viewerIsAdmin && cu && String(u.id)!==String(cu.id)){
      if(u.approvalStatus==="pending" || u.approvalStatus==="denied") return false;
    }
    if(q&&!(u.firstName+" "+u.lastName+" "+(u.hsName||"")+" "+(u.position||"")).toLowerCase().includes(q.toLowerCase())) return false;
    if(type==="player"&&posFilter!=="All"&&u.position!==posFilter) return false;
    if(type==="player"&&yearFilter!=="All"&&String(u.gradYear)!==yearFilter) return false;
    // Min-score filtering removed — composite player score is no longer used.
    if(type==="player"&&minEV&&(getEV(u.id)||0)<parseFloat(minEV)) return false;
    if(type==="player"&&minAvgEV&&(getAvgEV(u.id)||0)<parseFloat(minAvgEV)) return false;
    if(type==="player"&&minThrow&&(getThrow(u.id)||0)<parseFloat(minThrow)) return false;
    if(type==="player"&&minPitch&&(getPitch(u.id)||0)<parseFloat(minPitch)) return false;
    if(type==="player"&&maxDash){var d=getDash(u.id);if(d==null||d>parseFloat(maxDash)) return false;}
    return true;
  });

  var sorted=list.slice().sort(function(a,b){
    if(sortBy==="score"){var sa=getScore(a.id)||0;var sb=getScore(b.id)||0;return sb-sa;}
    if(sortBy==="exitVelo"){var ea=getEV(a.id)||0;var eb=getEV(b.id)||0;return eb-ea;}
    if(sortBy==="avgExitVelo"){var aea=getAvgEV(a.id)||0;var aeb=getAvgEV(b.id)||0;return aeb-aea;}
    if(sortBy==="throwVelo"){var ta=getThrow(a.id)||0;var tb=getThrow(b.id)||0;return tb-ta;}
    if(sortBy==="pitchVelo"){var pa=getPitch(a.id)||0;var pb=getPitch(b.id)||0;return pb-pa;}
    if(sortBy==="dash60"){var da=getDash(a.id);var db=getDash(b.id);if(da==null)return 1;if(db==null)return -1;return da-db;}
    if(sortBy==="gradYear") return (a.gradYear||9999)-(b.gradYear||9999);
    return (a.firstName+" "+a.lastName).localeCompare(b.firstName+" "+b.lastName);
  });

  // 1280, WIDENED FROM 960 (Luis, 2026-10-03: five tiles per row). The page width is what actually
  // sets tile width, so asking for five inside 960 would have squeezed each tile to ~182px and
  // re-created the 2026-09-07 truncation this file already reverted once. Widening the page buys
  // the columns instead of taking the space out of the names.
  return(
    <div style={{maxWidth:1280,margin:"0 auto",padding:"0 16px 40px"}}>
      {/* Header trimmed (Luis, 2026-10-03: "smaller but still clearly legible"). 26->20 on the
          title and 13->12 on the subtitle; both stay well above the 11px used for tile metadata,
          so this is a quieter header, not a cramped one. */}
      <div style={{marginBottom:12}}><h1 style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:20,letterSpacing:1.1,color:C.navy,margin:"0 0 2px"}}>{c.title}</h1><div style={{fontSize:12,color:C.gray400}}>{c.sub}</div></div>

      <div style={{display:"flex",gap:8,marginBottom:12,flexWrap:"wrap",alignItems:"center"}}>
        <div style={{position:"relative",flex:"1 1 200px"}}>
          <svg style={{position:"absolute",left:10,top:"50%",transform:"translateY(-50%)",pointerEvents:"none"}} width="14" height="14" viewBox="0 0 24 24" fill="none" stroke={C.gray400} strokeWidth="2"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
          <input placeholder={"Search "+c.title.toLowerCase()+"..."} value={q} onChange={function(e){setQ(e.target.value);}} style={{width:"100%",padding:"8px 12px 8px 32px",borderRadius:10,border:"1px solid "+C.border,fontSize:13,boxSizing:"border-box"}}/>
        </div>
        {type==="player"&&(
          <select value={posFilter} onChange={function(e){setPosFilter(e.target.value);}} style={{padding:"8px 10px",borderRadius:8,border:"1px solid "+C.border,fontSize:12,color:C.gray600}}>
            {positions.map(function(p){return <option key={p} value={p}>{p==="All"?"All Positions":p}</option>;})}
          </select>
        )}
        {type==="player"&&(
          <select value={yearFilter} onChange={function(e){setYearFilter(e.target.value);}} style={{padding:"8px 10px",borderRadius:8,border:"1px solid "+C.border,fontSize:12,color:C.gray600}}>
            {gradYears.map(function(y){return <option key={y} value={y}>{y==="All"?"All Classes":"Class "+y}</option>;})}
          </select>
        )}
        {type==="player"&&isCoachOrAdmin&&(
          <select value={sortBy} onChange={function(e){setSortBy(e.target.value);}} style={{padding:"8px 10px",borderRadius:8,border:"1px solid "+C.border,fontSize:12,color:C.gray600}}>
            <option value="exitVelo">Sort: Peak Exit Velo</option>
            <option value="avgExitVelo">Sort: Avg Exit Velo</option>
            <option value="throwVelo">Sort: Throw Velo</option>
            <option value="pitchVelo">Sort: Pitch Velo</option>
            <option value="dash60">Sort: 60-Time</option>
            <option value="gradYear">Sort: Grad Year</option>
          </select>
        )}
        {type==="player"&&isCoachOrAdmin&&(
          <button onClick={function(){setAdvOpen(!advOpen);}} style={{padding:"8px 12px",borderRadius:8,border:"1px solid "+(advOpen?C.coral:C.border),background:advOpen?"rgba(232,82,106,.06)":"transparent",color:advOpen?C.coral:C.gray600,fontSize:12,fontWeight:600,cursor:"pointer",whiteSpace:"nowrap"}}>{advOpen?"▲ Fewer filters":"▼ More filters"}</button>
        )}
        {type==="player"&&isCoachOrAdmin&&(
          <button onClick={function(){
            var hasCriteria = (q && q.trim()) || (posFilter!=="All") || (yearFilter!=="All") || minScore || minEV || minAvgEV || minThrow || minPitch || maxDash;
            if(!hasCriteria){ if(typeof window!=="undefined"&&window.__bbotNotify) window.__bbotNotify("Set at least one filter before saving","error"); return; }
            var name = window.prompt("Name this search (e.g. '2027 SS PR 88+ EV'):", [posFilter!=="All"?posFilter:null, yearFilter!=="All"?"Class "+yearFilter:null, minEV?minEV+"+ EV":null, minThrow?minThrow+"+ throw":null, minPitch?minPitch+"+ FB":null, maxDash?"≤"+maxDash+" 60":null].filter(Boolean).join(" "));
            if(!name) return;
              // THIS BUTTON WROTE TO A TABLE THAT DOES NOT EXIST. `bbot_saved_searches` was never
              // created, nothing reads it, and the whole saved-search feature -- the Saved Searches
              // page, the nav badge, and the match alerts fired on report release -- runs on
              // `bbot_wants`. So this saved nothing anywhere and surfaced nowhere. Same table now.
              //
              // ONLY THE FILTERS THE MATCHER HONOURS GET SAVED AS FILTERS. playerMatchesWant
              // understands position/gradYear/region/exitVeloMin/throwVeloMin/pitchVeloMin/
              // dash60Max/popTimeMax. Score, average EV and the free-text box have no equivalent,
              // and quietly dropping them would make the saved search BROADER than the one the
              // coach was looking at -- alerting them about players the on-screen filters excluded.
              // They are named in the confirmation instead of being silently discarded.
              var filters={};
              if(posFilter!=="All") filters.position=posFilter;
              if(yearFilter!=="All") filters.gradYear=yearFilter;
              if(minEV) filters.exitVeloMin=minEV;
              if(minThrow) filters.throwVeloMin=minThrow;
              if(minPitch) filters.pitchVeloMin=minPitch;
              if(maxDash) filters.dash60Max=maxDash;
              var dropped=[];
              if(minScore) dropped.push("minimum score");
              if(minAvgEV) dropped.push("average exit velo");
              if(q&&q.trim()) dropped.push("the text search");
              bbotWrite("bbot_wants","insert",[{
                  coach_id: String(cu.id),
                  description: name,
                  filters: filters,
                  created_at: new Date().toISOString(),
                  expires_at: new Date(Date.now() + 60*24*60*60*1000).toISOString(),
                  active: true,
                }],null).then(function(){
                if(typeof window!=="undefined"&&window.__bbotNotify){
                  window.__bbotNotify(dropped.length
                    ? "Search saved — alerts use the filters BBOT can match; "+dropped.join(", ")+" "+(dropped.length>1?"are":"is")+" not part of the alert"
                    : "Search saved — "+sorted.length+" current matches");
                }
              }).catch(function(){
                if(typeof window!=="undefined"&&window.__bbotNotify) window.__bbotNotify("Could not save search","error");
              });
          }} style={{padding:"8px 12px",border:"1px solid "+C.coral,background:"transparent",color:C.coral,borderRadius:8,fontSize:11,fontWeight:700,cursor:"pointer",minHeight:"auto",letterSpacing:.3}}>★ Save Search</button>
        )}
        <div style={{fontSize:12,color:C.gray400,marginLeft:"auto"}}>{sorted.length} {type==="player"?"players":"coaches"}</div>
      </div>

      {/* ADVANCED METRIC FILTERS — collapsible to keep the default view clean */}
      {type==="player"&&isCoachOrAdmin&&advOpen&&(
        <div style={{display:"flex",gap:8,marginBottom:12,flexWrap:"wrap",alignItems:"flex-end",padding:"12px 14px",background:C.gray50,border:"1px solid "+C.border,borderRadius:10}}>
          {[
            ["Peak Exit Velo ≥","mph",minEV,setMinEV],
            ["Avg Exit Velo ≥","mph",minAvgEV,setMinAvgEV],
            ["Throw Velo ≥","mph",minThrow,setMinThrow],
            ["Pitch Velo ≥","mph",minPitch,setMinPitch],
            ["60-Time ≤","sec",maxDash,setMaxDash],
          ].map(function(f){return (
            <div key={f[0]} style={{display:"flex",flexDirection:"column",gap:3}}>
              <label style={{fontSize:10,color:C.gray500,fontWeight:600,letterSpacing:.3}}>{f[0]}</label>
              <input type="number" step="any" placeholder={f[1]} value={f[2]} onChange={function(e){f[3](e.target.value);}} style={{width:96,padding:"7px 9px",borderRadius:8,border:"1px solid "+C.border,fontSize:12,boxSizing:"border-box"}}/>
            </div>
          );})}
          {(minEV||minAvgEV||minThrow||minPitch||maxDash)&&(
            <button onClick={function(){setMinEV("");setMinAvgEV("");setMinThrow("");setMinPitch("");setMaxDash("");setMinScore("");}} style={{padding:"7px 12px",border:"1px solid "+C.border,background:"transparent",color:C.gray500,borderRadius:8,fontSize:11,fontWeight:600,cursor:"pointer"}}>Clear metrics</button>
          )}
          <div style={{flexBasis:"100%",fontSize:10,color:C.gray400,lineHeight:1.4,marginTop:2}}>Filters read each player's measured peaks and averages from their evaluation history. Players without a recorded value for a metric are excluded when that filter is set.</div>
        </div>
      )}

      {sorted.length===0&&<EmptyCard icon="S" title="No Results" sub="Try adjusting your filters"/>}
      {/* FIVE PER ROW (Luis, 2026-10-03), WITHOUT re-breaking what 2026-09-07 fixed.
          The prior note here is the thing to read before touching this line: 150px was reverted to
          260px because "whats there now cuts the names" -- the name line was nowrap/ellipsis, so
          tile width WAS name width and nearly every player truncated.
          That trade is gone now, because the cause was removed rather than the count: the name
          below WRAPS TO TWO LINES instead of being clipped, so a narrower tile costs a line of
          height and not a surname. 230 is chosen to land exactly five columns in the widened
          1280 page -- floor((1248+12)/(230+12)) = 5, tile ~240px -- and auto-fill still steps
          down to 4/3/2/1 on smaller screens on its own. */}
      <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(min(230px,100%),1fr))",gap:12}}>
        {sorted.map(function(u){
          var isF=(cu.following||[]).includes(u.id);
          var lead=type==="player"?bbotLeadStat(u,scoutReports):null;
          var ev=lead?lead.value:null;
          var canReq = (cu.type==="coach"||cu.type==="staff") && u.type==="player" && setUsers;
          var reqd = (coachUpdates||[]).some(function(s){return String(s.coachId)===String(cu.id)&&String(s.playerId)===String(u.id)&&s.reason==="eval_request";});
          var doReq = function(e){
            e.stopPropagation();
            var coachName = cu.type==="coach"?("Coach "+cu.lastName):(cu.firstName+" "+cu.lastName);
            var today = new Date().toISOString().slice(0,10);
            var notif = {id:Date.now(),type:"eval_request",text:coachName+" requested a BBOT evaluation — start one to share your verified report.",date:today,read:false};
            setUsers(function(all){return all.map(function(x){if(String(x.id)!==String(u.id))return x;var up=Object.assign({},x,{notifications:[notif].concat(x.notifications||[])});fetch(BACKEND_URL+"/user-notify",{method:"POST",headers:bbotAdminHeaders(),body:JSON.stringify({targetId:u.id,notification:notif})}).catch(function(){});return up;});});
            if(setCoachUpdates&&!reqd) setCoachUpdates(function(p){return (p||[]).concat([{coachId:cu.id,playerId:u.id,reason:"eval_request",date:today}]);});
            pushFeed&&pushFeed(cu.id,"eval_request","You requested an evaluation for "+u.firstName+" "+u.lastName);
            notify&&notify("Evaluation requested — "+u.firstName+" notified");
          };
          return(
            <Card key={u.id} style={{padding:0,overflow:"hidden",cursor:"pointer"}} onClick={function(){go("profile",u);}}>
              <div style={{height:3,background:u.type==="player"?C.blue:u.type==="staff"?C.orange:C.coral}}/>
              <div style={{padding:14}}>
                <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:10}}>
                  <Avatar user={u} size={42}/>
                  <div style={{flex:1,minWidth:0}}>
                    {/* WRAPS, NEVER CLIPS. This was nowrap+ellipsis, which is why narrowing the
                        tile used to cut names and why six-per-row was reverted in 2026-09-07.
                        Two lines of 14px is ~40px of height; a truncated surname is a card you
                        cannot identify. Clamped at 2 so one absurd name cannot stretch a row. */}
                    <div style={{fontWeight:700,fontSize:14,color:C.gray900,lineHeight:1.25,display:"-webkit-box",WebkitLineClamp:2,WebkitBoxOrient:"vertical",overflow:"hidden",wordBreak:"break-word"}}>{u.firstName} {u.lastName}</div>
                    <div style={{fontSize:11,color:C.gray400}}>{u.type==="player"?(u.position||"Player"):(u.type==="coach"?"Coach":"Staff")}{u.gradYear?" · Class "+u.gradYear:""}</div>
                    {type==="player"&&(function(){
                      var d=getLastEvalDate(u.id);
                      if(!d) return null;
                      var days=Math.floor((Date.now()-new Date(d).getTime())/86400000);
                      var txt = isNaN(days) ? null : (days<=0?"Active today":days===1?"1 day ago":days<30?days+" days ago":days<60?"1 month ago":Math.floor(days/30)+" months ago");
                      if(!txt) return null;
                      var fresh = !isNaN(days) && days<=14;
                      return <div style={{fontSize:10,color:fresh?C.blue:C.gray400,marginTop:2,fontWeight:fresh?600:400}}>{fresh?"● ":""}Last eval {txt}</div>;
                    })()}
                  </div>
                  {lead&&isCoachOrAdmin&&<div style={{textAlign:"center",flexShrink:0}}><div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:20,color:C.coral,lineHeight:1,fontWeight:700}}>{lead.value}</div><div style={{fontSize:9,color:C.gray400}}>{lead.label}</div></div>}
                </div>
                <div style={{display:"flex",flexWrap:"wrap",gap:5,marginBottom:10}}>
                  {u.hsName&&<span style={{fontSize:11,background:C.blueFaint,color:C.blue,padding:"2px 8px",borderRadius:99}}>{u.hsName}</span>}
                  {u.clubName&&<span style={{fontSize:11,background:C.blueFaint,color:C.blue,padding:"2px 8px",borderRadius:99}}>{u.clubName}</span>}
                  {lead&&isCoachOrAdmin&&<span style={{fontSize:11,background:C.coralFaint,color:C.coral,padding:"2px 8px",borderRadius:99}}>{lead.value} mph {lead.label}</span>}
                </div>
                <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
                  <Btn v="primary" style={{flex:1,fontSize:11,padding:"6px 0"}} onClick={function(e){e.stopPropagation();go("profile",u);}}>View Profile</Btn>
                  {canReq&&<Btn v={reqd?"ghost":"coral"} style={{fontSize:11,padding:"6px 10px"}} onClick={reqd?function(e){e.stopPropagation();}:doReq}>{reqd?"✓ Requested":"Request Eval"}</Btn>}
                  {!isF&&u.id!==cu.id&&<Btn v="ghost" style={{fontSize:11,padding:"6px 10px"}} onClick={function(e){e.stopPropagation();toggleFollow(u.id);}}>+ Follow</Btn>}
                  {isF&&<Btn v="ghost" style={{fontSize:11,padding:"6px 10px"}} onClick={function(e){e.stopPropagation();toggleFollow(u.id);}}>Following</Btn>}
                </div>
              </div>
            </Card>
          );
        })}
      </div>
    </div>
  );
}

// Shared pitcher-stat computation. Identifies the "top-end velocity" cluster (the
// pitcher's fastballs) by velocity proximity to their hardest reading — NOT by pitch-type
// naming, which single-angle video can't reliably do. Velocity uses Verified-style readings
// (velocityMph present). The exact grouping window is intentionally not surfaced anywhere.
function computePitcherStats(pitches){
  var ps = (pitches||[]);
  var total = ps.length;
  var velos = ps.map(function(p){var v=Number(p.velocityMph!=null?p.velocityMph:p.velocity); return isNaN(v)?null:v;}).filter(function(v){return v!=null && v>0;});
  var fb = {count:0, avg:null, top:null};
  if(velos.length){
    var top = Math.max.apply(null, velos);
    var WINDOW = 6; // top-end cluster width — internal only, never displayed
    var cluster = velos.filter(function(v){return v >= top - WINDOW;});
    fb.count = cluster.length;
    fb.top = Math.round(top);
    fb.avg = Math.round(cluster.reduce(function(a,b){return a+b;},0)/cluster.length);
  }
  // Whiff% denominator = pitches thrown to a batter in the box (live), not warmups.
  var live = ps.filter(function(p){return p.batterInBox!==false && p.batter_in_box!==false;});
  var whiffs = live.filter(function(p){return p.result==="SwingMiss";}).length;
  var whiffPct = live.length>0 ? Math.round(whiffs/live.length*100) : null;
  return {total:total, fbCount:fb.count, fbAvg:fb.avg, fbTop:fb.top, whiffPct:whiffPct, liveCount:live.length, hasVelo:velos.length>0};
}

function PitcherMetrics({pitches,verifiedVelos}){
  var _veloOK=(typeof window!=="undefined")?window.__bbotVeloVisible:false;
  var s = computePitcherStats(pitches);
  // Device-verified velo set (the overlay read every pitch's velo; BBOT logs only some). When present,
  // use it for the complete velo picture (count/avg/top); pitch types/results stay from logged pitches.
  var dv=(Array.isArray(verifiedVelos)?verifiedVelos.filter(function(v){return v!=null&&v>0;}):[]);
  var devCount=dv.length, devAvg=dv.length?Math.round(dv.reduce(function(a,b){return a+b;},0)/dv.length):null, devTop=dv.length?Math.round(Math.max.apply(null,dv)):null;
  var cells = [
    {label:"PITCHES", val:(devCount||s.total), show:true},
    {label:"FASTBALLS", val:s.hasVelo?s.fbCount:null, show:s.hasVelo, note:"top-end velocity"},
    {label:"AVG FB", val:(devAvg!=null?devAvg+" mph":((s.hasVelo&&s.fbAvg!=null)?s.fbAvg+" mph":null)), show:_veloOK, velo:true},
    {label:"TOP FB", val:(devTop!=null?devTop+" mph":((s.hasVelo&&s.fbTop!=null)?s.fbTop+" mph":null)), show:_veloOK, velo:true},
    {label:"WHIFF %", val:s.whiffPct!=null?s.whiffPct+"%":null, show:s.liveCount>0},
  // EMPTY-ABSENT-BY-CONSTRUCTION, applied to stat blocks. A card whose value does not exist is not
  // rendered as an em dash -- a dash is a claim that the figure was looked for and is being withheld,
  // when in truth the session never produced one. Josue's PITCHER PROFILE was four dashes and a
  // paragraph explaining figures that were not there.
  ].filter(function(c){return c.show && c.val!=null && c.val!=="";});
  // No cards survived -> the block itself does not exist. A heading over nothing, followed by a
  // paragraph explaining absent figures, tells a reader the data was expected and is missing; the
  // truth is the session did not produce it, which the report says once in its not-measured line.
  if (!cells.length) return null;
  return (
    <div style={{marginBottom:8}}>
      <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:13,color:C.navy,letterSpacing:1,marginBottom:10}}>PITCHER PROFILE</div>
      <div style={{display:"grid",gridTemplateColumns:"repeat("+cells.length+",1fr)",gap:6}}>
        {cells.map(function(c){return (
          <div key={c.label} style={{background:C.gray50,border:"1px solid "+C.border,borderRadius:8,padding:"10px 6px",textAlign:"center"}}>
            <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:18,color:C.coral,lineHeight:1}}>{c.val}</div>
            <div style={{fontSize:8,color:C.gray500,letterSpacing:.4,marginTop:4}}>{c.label}</div>
          </div>
        );})}
      </div>
      <div style={{fontSize:10,color:C.gray500,marginTop:8,lineHeight:1.45}}>
        Fastball figures reflect top-end velocity pitches only; clearly slower pitches are excluded so the average isn't diluted. Whiff % is swinging strikes per pitch thrown to a batter. Velocity is shown when read from a device/overlay in the video.
      </div>
    </div>
  );
}

// Device-read exit-velo readings for a player, pulled from the APPROVED reports' measuredValues —
// the same reconciled source the report and the leaderboard use, so the chart can never disagree with
// the report it came from. The per-batted-ball rows carry no velocity (that moved into measuredValues),
// which is why anything reading those rows shows nothing.
function evReadingsFromReports(scoutReports){
  var out=[];
  (scoutReports||[]).forEach(function(r){
    if(!r) return;
    var st=String(r.status||"").toLowerCase();
    if(st && st!=="approved" && st!=="published") return;
    var fr=r.fullReport||r.full_report||r;
    if(typeof fr==="string"){ try{ fr=JSON.parse(fr); }catch(e){ return; } }
    var mv=(fr&&fr.measuredValues)||{};
    var reads=Array.isArray(mv.exitVeloReadings)?mv.exitVeloReadings:[];
    reads.forEach(function(v){ if(v!=null && v>0) out.push(Number(v)); });
    if(!reads.length){
      var vv=(fr&&fr.verifiedExitVelos);
      if(Array.isArray(vv)) vv.forEach(function(v){ if(v!=null && v>0) out.push(Number(v)); });
    }
  });
  return out;
}

function PlayerCharts({userId,playerName,position,battedBalls,pitches,scoutReports,twoWay}){
  var isPitcher = position && /^(P|RHP|LHP|SP|RP|CP)$/i.test(String(position||"").trim().split(/[\s,\/]/)[0]);
  // ONLY show pitch + batted-ball data tied to APPROVED reports. Pitches/balls are written
  // to the DB at eval time (before admin approval), so without this filter a draft, errored,
  // or rejected eval leaves orphaned rows that appear in the Pitcher/Hitter Profile even
  // though no report or clip exists on the profile. The filter is permissive for legacy
  // data (rows with no report_id are kept — they predate this gating).
  var approvedReportIds = {};
  (scoutReports||[]).forEach(function(r){
    if(r && (isLiveEval(r))) approvedReportIds[String(r.id)] = true;
  });
  function fromApproved(row){
    if(!row) return false;
    var rid = row.reportId!=null ? row.reportId : row.report_id;
    if(rid==null || rid==="") return true;       // legacy row — keep
    return !!approvedReportIds[String(rid)];
  }
  var allPlayerBalls=(battedBalls||[]).filter(function(b){return String(b.playerId)===String(userId) && fromApproved(b);});
  // Session selector — default "all" = total historical spray across every session
  var sessSel=useState("all"); var sessFilter=sessSel[0]; var setSessFilter=sessSel[1];
  var sessionDates=[];
  allPlayerBalls.forEach(function(b){ if(b.date && sessionDates.indexOf(b.date)<0) sessionDates.push(b.date); });
  sessionDates.sort(function(a,b){return String(b).localeCompare(String(a));});
  var playerBalls = sessFilter==="all" ? allPlayerBalls : allPlayerBalls.filter(function(b){return b.date===sessFilter;});
  var playerPitches=(pitches||[]).filter(function(p){return String(p.playerId)===String(userId) && fromApproved(p);});
  var legacyPitches = playerBalls.filter(function(b){return !!b.pitchType;});
  var sprayData=playerBalls.filter(function(b){return !b.pitchType;});
  var pitchData = playerPitches.length ? playerPitches : legacyPitches;
  var hasSpray=sprayData.length>0;
  var hasPitch=pitchData.length>0;
  // BATTED-BALL SPRAY CHART REMOVED: it plots balls by direction/contact-type (pull/oppo/GB/FB),
  // which BBOT does not reliably capture from video — so it asserted unmeasured data (e.g. "pulled
  // 70% of batted balls"). Charts now show pitch data only. Exit velocity stays in the report's
  // measured values (device/overlay reading), not here.
  // A pure hitter used to return null here, so the section rendered nothing while still being gated
  // visible by empty batted-ball rows. Give hitters their measured exit velocity instead.
  var _evReads = evReadingsFromReports(scoutReports);
  if(!hasPitch && !_evReads.length) return null;

  // THREE FORMATS:
  //  1 position-only -> spray chart
  //  2 pitcher-only  -> pitch chart
  //  3 two-way       -> BOTH (player confirmed two-way, OR data shows both pitching + hitting)
  // twoWay is the confirmed signal from profile/registration; data presence is the fallback.
  // Two-way combined format ONLY when explicitly confirmed (profile/registration flag). Data
  // presence alone does NOT trigger it — keeps the default workflow simple (one chart by role;
  // a player who also pitches gets a separate report). Flip behavior by setting the twoWay flag.
  var isTwoWay = !!twoWay;
  var pitchPlateLocated = pitchData.some(function(p){return p.plateX!=null&&p.plateZ!=null&&!isNaN(Number(p.plateX))&&!isNaN(Number(p.plateZ));});

  // L/R splits for hitters when pitcherHand data exists
  var splits = null;
  if(!isPitcher && hasSpray){
    var vL = sprayData.filter(function(b){return (b.pitcherHand||"").toUpperCase()==="L";});
    var vR = sprayData.filter(function(b){return (b.pitcherHand||"").toUpperCase()==="R";});
    if(vL.length>0 || vR.length>0){
      var avgEV = function(arr){ var ev = arr.filter(function(b){return b.exitVelo;}).map(function(b){return Number(b.exitVelo);}); return ev.length ? Math.round(ev.reduce(function(a,c){return a+c;},0)/ev.length) : null; };
      splits = {
        vL: {count:vL.length, avgEV:avgEV(vL)},
        vR: {count:vR.length, avgEV:avgEV(vR)},
      };
    }
  }

  return(
    <div style={{display:"flex",flexDirection:"column",gap:20}}>
      {!isPitcher && sessionDates.length>1 && (
        <div style={{display:"flex",alignItems:"center",gap:8,flexWrap:"wrap"}}>
          <span style={{fontSize:10,color:C.gray500,letterSpacing:.5}}>VIEW</span>
          <button onClick={function(){setSessFilter("all");}} style={{padding:"4px 10px",borderRadius:99,fontSize:11,fontWeight:600,border:sessFilter==="all"?"none":"1px solid "+C.border,background:sessFilter==="all"?C.coral:"transparent",color:sessFilter==="all"?C.white:C.gray400,cursor:"pointer"}}>All Sessions</button>
          {sessionDates.map(function(d){return <button key={d} onClick={function(){setSessFilter(d);}} style={{padding:"4px 10px",borderRadius:99,fontSize:11,fontWeight:600,border:sessFilter===d?"none":"1px solid "+C.border,background:sessFilter===d?C.coral:"transparent",color:sessFilter===d?C.white:C.gray400,cursor:"pointer"}}>{d}</button>;})}
        </div>
      )}
      {(function(){
        // Reusable sections so two-way can stack both.
        var pitchSection = (
          hasPitch ? <div><PitcherMetrics pitches={pitchData} verifiedVelos={(function(){var out=[];(scoutReports||[]).forEach(function(rr){var vv=(rr&&rr.verifiedPitchVelos)||(rr&&rr.full_report&&rr.full_report.verifiedPitchVelos);if(Array.isArray(vv))out=out.concat(vv);});return out;})()}/>{pitchPlateLocated ? <div><div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:13,color:C.navy,letterSpacing:1,marginBottom:10,marginTop:16}}>PITCH CHART</div><PitchChart pitches={pitchData} playerName={playerName}/></div> : <div style={{fontSize:11,color:C.gray500,fontStyle:"italic",padding:"10px 0 2px"}}>Pitch locations not tracked this session — no zone chart shown. Pitch counts reflected above.</div>}</div>
                   : <div style={{fontSize:12,color:C.gray400,fontStyle:"italic",padding:14}}>Pitch chart N/A — no pitch data logged.</div>
        );
        // Batted-ball spray chart REMOVED (direction/contact-type not reliably captured from video) — charts
        // show PITCH data only. A pure hitter with no pitch data returned null above; two-way players get their
        // pitch chart. (The old spray section + SprayChart component were dead code and have been deleted.)
        var hitterSection = _evReads.length ? (
          <div><div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:13,color:C.navy,letterSpacing:1,marginBottom:10}}>EXIT VELOCITY</div>
            <SprayChart battedBalls={sprayData} playerName={playerName} verifiedEvs={_evReads}/>
          </div>
        ) : null;
        if(!hasPitch) return hitterSection;
        return <div>{pitchSection}{hitterSection}</div>;
      })()}
    </div>
  );
}

// Player-facing single offer: session report + stamped clips (BBOT_PRICE_USD).
function SessionPurchaseChoice({playerId, playerName, sessionDate, sessionType, clipCount, clips, position, notify}){
  // THE ROW MINTS AT PURCHASE INTENT, NEVER AT MOUNT (ruled by Luis 2026-08-18).
  //
  // It used to mint in a useEffect on mount: RENDERING the offer wrote a bbot_reports row, with
  // id = Date.now() so every view wrote a NEW one. A read-only coach walk that clicked nothing but
  // navigation left a pending_payment row on a real player's record, which is how this was found.
  // Anyone who could see a player's profile was writing to that player's data by looking at it.
  //
  // The id is still fixed at render — that part of ATH Móvil's requirement is real, its button
  // needs an id to put in metadata at the time it renders. But an id is just a number; only the
  // WRITE moves, to the moment a human presses a pay button.
  //
  // IDEMPOTENT ON DOUBLE-PRESS by construction, two ways: the promise is memoised in a ref so a
  // second press joins the first mint instead of starting another, and the write carries the SAME
  // id either way, so even a racing duplicate is an upsert of one row rather than a second row.
  // A FAILED mint clears the memo, because a network blip must not permanently block a purchase.
  var ridState = useState(function(){ return Date.now(); });
  var rid = ridState[0];
  var mintRef = useRef(null);
  var clip = (clips||[]).find(function(c){return c.approved && c.clip_object_key;}) || (clips||[])[0] || {};
  var objKey = clip.clip_object_key || null;

  function mintRow(){
    if(mintRef.current) return mintRef.current;
    mintRef.current = reportSave({
      id: rid,
      player_id: String(playerId),
      player_name: playerName,
      session_type: sessionType || "Session",
      session_date: sessionDate || "",
      status: "pending_payment",
      object_key: objKey,
      summary: "",
      sections: []
    }).catch(function(err){
      mintRef.current = null;
      console.warn("Pending report create failed:", err && err.message);
      throw err;
    });
    return mintRef.current;
  }

  // RETIRED 2026-08-21 -- this posted to /create-checkout-session and sent the buyer to Stripe.
  // Removed rather than rewired: with Stripe gone there is nothing for it to start, and the
  // payment surface below decides between ATH and the coming-soon panel on its own.
  return (
    <div style={{padding:14,background:C.white,borderRadius:10,border:"1px solid "+C.border,marginBottom:12}}>
      <div style={{fontSize:13,fontWeight:700,color:C.navy,marginBottom:2}}>Get your evaluation for this session</div>
      <div style={{fontSize:11,color:C.gray500,marginBottom:12}}>Full per-tool evaluation plus your {clipCount} stamped clip{clipCount===1?"":"s"} to keep and share.</div>
      <div style={{border:"2px solid "+C.coral,borderRadius:10,padding:16,textAlign:"center"}}>
        <div style={{fontSize:10,letterSpacing:1,color:C.coral,fontWeight:600,marginBottom:4}}>SESSION EVALUATION + CLIPS</div>
        <div style={{fontSize:30,fontWeight:700,color:C.navy,marginBottom:6}}>${BBOT_PRICE_SESSION_USD.toFixed(2)}</div>
        <div style={{fontSize:11,color:C.gray500,lineHeight:1.5,marginBottom:12}}>Per-tool grades, spray/pitch chart, shareable report, and your {clipCount} stamped video clip{clipCount===1?"":"s"}.</div>
        {/* ATH renders its own button inside this wrapper via their script, so there is no onClick
            of ours to hang the mint on. The wrapper catches the press in the CAPTURE phase — before
            ATH's own handler runs — which is the same "a human pressed pay" moment, reached the only
            way a third-party button allows. mintRow() is idempotent, so a press that ATH ignores
            costs nothing and a second press joins the first mint. */}
        {/* ONE PAYMENT SURFACE, NOT A CHOICE BETWEEN TWO. AthMovilButton renders the live ATH
            button when the token is present and the coming-soon panel when it is not, so this
            call site does not need to know which state it is in -- and there is no branch here
            that could reintroduce a card checkout. The mint stays on the CAPTURE phase for the
            same reason as before: ATH injects its own button and gives us no onClick to hang on. */}
        <div onClickCapture={function(){ mintRow().catch(function(){}); }}>
          <AthMovilButton reportId={rid} amountUSD={BBOT_PRICE_SESSION_USD} playerId={playerId}
            videoSource="bbot_recorded" label="Pay with ATH Móvil"
            onPaid={function(){ notify && notify("Payment confirmed — 643 will review and release your report.","success"); }}
            notify={notify}/>
        </div>
      </div>
    </div>
  );
}

// SKELETON CLIPS — the clean computer-tracked dots-and-sticks recreation of the movement (clip_type
// "skeleton" in bbot_clips), shown as its OWN section on the profile, separate from the video clips. Each
// clip's R2 key is turned into a signed URL for playback. Non-admins see only approved ones.
function SkeletonClipsSection({clips, isAdmin}){
  var uS=useState({}); var urls=uS[0], setUrls=uS[1];
  var vis=(clips||[]).filter(function(c){return c && (c.approved || isAdmin);});
  useEffect(function(){
    vis.forEach(function(c){
      if(urls[c.id] || !c.clip_object_key) return;
      fetch(BACKEND_URL+"/r2-read-url?objectKey="+encodeURIComponent(c.clip_object_key))
        .then(function(r){return r.json();}).then(function(d){ if(d&&d.url) setUrls(function(p){var n=Object.assign({},p);n[c.id]=d.url;return n;}); })
        .catch(function(){});
    });
  }, [clips]);   // eslint-disable-line
  // Download a skeleton clip on MOBILE the same reliable way as normal clips: ask the backend for a
  // forced-download signed URL (the object itself sets Content-Disposition: attachment). The <a download>
  // attribute is ignored cross-origin on mobile, so the plain playback URL only OPENED the video.
  function dlSkel(c){
    if(!c || !c.clip_object_key) return;
    var fn=((c.action_type||"skeleton").replace(/[^A-Za-z0-9]+/g,"_"))+"_skeleton.mp4";
    fetch(BACKEND_URL+"/r2-read-url?download=1&filename="+encodeURIComponent(fn)+"&objectKey="+encodeURIComponent(c.clip_object_key))
      .then(function(r){return r.json();}).then(function(d){
        if(!d||!d.url) return;
        var a=document.createElement("a"); a.href=d.url; a.download=fn; a.target="_blank"; a.rel="noopener";
        document.body.appendChild(a); a.click(); setTimeout(function(){try{document.body.removeChild(a);}catch(e){}},1500);
      }).catch(function(){});
  }
  if(!vis.length) return null;
  return (
    <div style={{marginBottom:16}}>
      <div style={{fontSize:11,fontWeight:700,color:C.navy,letterSpacing:.6}}>SKELETON &middot; MEASURED MOTION</div>
      <div style={{fontSize:10,color:C.gray500,marginBottom:8}}>Computer-tracked dots-and-sticks recreation of the movement &mdash; separate from the video clips.</div>
      {/* 150px TILES MADE THE PROOF UNREADABLE. A skeleton clip is dots and thin sticks on a pale
          background: at 150px wide the limbs are a couple of pixels each and the thing the overlay
          exists to demonstrate cannot be seen at all. This is the artefact that shows the movement
          was MEASURED, so it is the last place to save space. 300px minimum, and the tile grows to
          fill the column rather than staying tiny on a wide screen. */}
      <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(min(300px,100%),1fr))",gap:12}}>
        {vis.map(function(c){return (
          <div key={c.id} style={{border:"1px solid "+C.border,borderRadius:8,overflow:"hidden",background:"#fbfcfe"}}>
            {urls[c.id] ? <video {...bbotVideoGuard()} src={urls[c.id]+"#t=0.1"} preload="metadata" controls loop muted playsInline style={{width:"100%",display:"block",background:"#fbfcfe"}}/>
                        : <div style={{padding:"28px 8px",textAlign:"center",fontSize:10,color:C.gray400}}>Loading&hellip;</div>}
            {c.action_type && c.action_type!=="skeleton" && <div style={{fontSize:10,fontWeight:700,color:C.navy,padding:"4px 8px 0"}}>{c.action_type}</div>}
            {(Number(c.end_sec)>Number(c.start_sec)) && (function(){var f=function(s){s=Math.max(0,Math.round(Number(s)||0));var m=Math.floor(s/60);var ss=s%60;return m+":"+(ss<10?"0":"")+ss;};return <div title="The rep this skeleton recreates — find it at this time in the source video" style={{display:"inline-block",margin:"4px 8px 0",padding:"2px 7px",background:C.blueFaint,color:C.blue,borderRadius:99,fontSize:9,fontWeight:700,letterSpacing:.3}}>▶ Rep · {f(c.start_sec)}–{f(c.end_sec)}</div>;})()}
            <div style={{fontSize:9,color:C.gray400,padding:"2px 8px 4px"}}>{c.session_date||""}{c.approved?"":" · pending"}</div>
            {/* Share stays open to everyone — only the file download is admin-only. */}
            {c.approved && <a onClick={function(e){e.preventDefault();bbotShareClip(c, null);}} href="#" style={{display:"block",textAlign:"center",fontSize:10,fontWeight:700,color:C.blue,padding:"5px",borderTop:"1px solid "+C.border,textDecoration:"none",cursor:"pointer"}}>↗ Share</a>}
            {/* Admin-only, for the same reason as the clip download above. */}
            {isAdmin && <a onClick={function(e){e.preventDefault();dlSkel(c);}} href="#" style={{display:"block",textAlign:"center",fontSize:10,fontWeight:700,color:C.blue,padding:"5px",borderTop:"1px solid "+C.border,textDecoration:"none",cursor:"pointer"}}>↓ Download</a>}
          </div>
        );})}
      </div>
    </div>
  );
}

function PlayerClipsView({userId, playerName, dob, gradYear, ageBracket, isAdmin, cu, notify, scoutReports, setScoutReports}){
  var [clips, setClips] = useState([]);
  var [loading, setLoading] = useState(true);
  var [refreshing, setRefreshing] = useState({});
  var [evalStatus, setEvalStatus] = useState({});  // groupKey or clipKey -> {state:"running"|"done"|"error", t0, t1, msg, clips, frames}
  var [sessionNotes, setSessionNotes] = useState({});  // groupKey -> admin observation notes that aid BBOT's report
  var [, setTick] = useState(0);  // forces re-render every second while an eval is running so "Xs elapsed" updates
  useEffect(function(){
    var anyRunning = Object.keys(evalStatus||{}).some(function(k){return (evalStatus[k]||{}).state==="running";});
    if(!anyRunning) return;
    var iv = setInterval(function(){ setTick(function(n){return n+1;}); }, 1000);
    return function(){ clearInterval(iv); };
  }, [evalStatus]);

  function loadClips(){
    // Guard: without a valid userId the filter becomes player_id=eq.undefined → Supabase 422,
    // whose error body could get rendered and crash the page. Skip the call instead.
    if(userId==null || String(userId)==="" || String(userId)==="undefined"){ setClips([]); setLoading(false); return; }
    setLoading(true);
    sbSelect("bbot_clips","?player_id=eq."+encodeURIComponent(String(userId))+"&order=created_at.desc&limit=200")
      .then(function(rows){
        // Only accept an array of real clip rows; an error body (object/422) becomes empty.
        var clean = Array.isArray(rows) ? rows.filter(function(r){return r && typeof r==="object" && ("id" in r);}) : [];
        setClips(clean); setLoading(false);
      })
      .catch(function(){ setClips([]); setLoading(false); });
  }
  useEffect(loadClips, [userId]);

  // After generating an evaluation the DB row exists but the in-memory scoutReports array
  // (what the BBOT Evaluations tab reads) is stale — so the new report won't appear until a
  // full page reload. Refetch this player's reports and merge them into shared state so the
  // report shows immediately. Maps DB columns to the same shape the bootstrap loader uses.
  function refreshReports(){
    if(!setScoutReports) return;
    bbotReports({playerId:userId,limit:200})
      .then(function(rows){
        if(!Array.isArray(rows)) return;
        var mapped = rows.map(function(r){
          var full = r.full_report;
          if(typeof full === "string"){ try{ full = JSON.parse(full); }catch(e){ full = {}; } }
          full = full || {};
          return Object.assign({}, {
            id: r.id, playerId: r.player_id, date: r.session_date,
            sessionType: r.session_type, sessionDate: r.session_date,
            status: r.status, summary: r.summary || full.summary || "",
            sections: (Array.isArray(full.sections) && full.sections.length) ? full.sections : (r.sections || []),   // prefer full_report (holds admin edits) over the denormalized top-level column; fall back if empty
            reportType: r.report_type || null, fullReport: full,
            score: r.score!=null?r.score:null,
            staffName: r.staff_name || null, staffId: r.staff_id || null,
            poseMetrics: full.poseMetrics || null
          });
        });
        setScoutReports(function(prev){
          // Drop any existing copies of these reports (match by id), then add the fresh set.
          // Dedupe by report id rather than playerId so a non-numeric id can't cause dupes.
          var freshIds = {};
          mapped.forEach(function(m){ freshIds[String(m.id)] = true; });
          var others = (prev||[]).filter(function(p){ return !freshIds[String(p.id)]; });
          return others.concat(mapped);
        });
      }).catch(function(){ /* non-fatal: reload still works */ });
  }

  // Segment clips by the selected age bracket (career = all).
  // BBOT percentiles are AGE-based, so the bracket must reflect the player's real age
  // (from DOB) at the time of that session — NOT grad year (a player can be 19 and a
  // junior). seasonAge applies the Aug 1 rollover. If there is no DOB we cannot place
  // the session in an age bracket reliably, so we INCLUDE it (don't hide data) rather
  // than guess from grad year.
  function inBracket(c){
    if(!ageBracket || ageBracket==="career") return true;
    var d = c.session_date || c.created_at || "";
    if(!d) return true;
    var ag = seasonAge({dob: dob}, d);
    if(ag==null) return true; // no DOB → can't bucket by age; don't exclude
    var b = ag>=19?"19+":(ag<14?"14U":ag+"U");
    return b===ageBracket;
  }

  // THE CLIP PREVIEW (built 2026-08-18). The clips tab listed every clip as a title, a duration and
  // a Play button that called window.open() — so the video only ever existed in ANOTHER TAB, and
  // the profile showed no frame of it. The skeleton overlays right below on the same profile have
  // always rendered inline, which is why one showed and the other did not.
  //
  // Same pattern as SkeletonClipsSection, deliberately — one visual language for both kinds of
  // media on this profile: an inline <video {...bbotVideoGuard()}> with `#t=0.1` so the browser paints the frame at 0.1s
  // as the poster (a bare src shows an empty black box until the user presses play), preload
  // metadata so a profile with several clips does not pull several videos, and controls so the
  // viewer plays it in place.
  //
  // GATED TO EXACTLY WHAT MAY BE SEEN: previews are requested only for clips that already pass
  // `canPlay` (admin, or approved AND paid). A locked clip keeps its honest placeholder and no URL
  // is ever fetched for it — the paywall is not a CSS state, it is a URL that was never requested.
  // ONE DEFINITION OF WHO MAY WATCH, used by the preview fetch AND by the card below it. Two
  // copies of a viewer test is how a paywall ends up open in one place and shut in the other.
  var mayWatch = !!isAdmin || (cu && (cu.type === "coach" || cu.type === "staff"))
                 || (cu && String(cu.id) === String(userId));
  var previewS = useState({}); var previewUrls = previewS[0], setPreviewUrls = previewS[1];
  useEffect(function(){
    var want = (clips||[]).filter(function(c){
      return c && c.clip_object_key && (isAdmin || (c.approved && mayWatch));
    });
    want.forEach(function(c){
      if(previewUrls[c.id]) return;
      fetch(BACKEND_URL+"/r2-read-url?objectKey="+encodeURIComponent(c.clip_object_key))
        .then(function(r){ return r.json(); })
        .then(function(d){
          if(d && d.url) setPreviewUrls(function(p){
            var n = Object.assign({}, p); n[c.id] = d.url; return n;
          });
        })
        .catch(function(){ /* a clip whose source will not sign shows its absence, not a broken frame */ });
    });
  }, [clips, isAdmin, mayWatch]);   // eslint-disable-line

  function getFreshUrl(clip){
    // Signed URLs in stored read_url field expire — request a fresh one before playing
    setRefreshing(function(p){var o=Object.assign({},p);o[clip.id]=true;return o;});
    return fetch(BACKEND_URL+"/r2-read-url?objectKey="+encodeURIComponent(clip.clip_object_key))
      .then(function(r){return r.json();})
      .then(function(d){
        setRefreshing(function(p){var o=Object.assign({},p);delete o[clip.id];return o;});
        return d.url;
      }).catch(function(){
        setRefreshing(function(p){var o=Object.assign({},p);delete o[clip.id];return o;});
        return null;
      });
  }

  function playClip(clip){
    getFreshUrl(clip).then(function(url){
      if(!url){ notify("Could not load clip","error"); return; }
      window.open(url, "_blank");
    });
  }
  // Download the clip (works on MOBILE): ask the backend for a forced-download signed URL (the object itself
  // sets Content-Disposition: attachment), then click a link to it. The <a download> attr is ignored cross-
  // origin, but the attachment URL downloads everywhere. Fall back to opening it if the click is blocked.
  function downloadClip(clip){
    if(!clip||!clip.clip_object_key){ notify("No clip to download","error"); return; }
    var fn = ((playerName||"clip").replace(/[^A-Za-z0-9]+/g,"_"))+"_"+((clip.action_type||clip.clip_type||"clip").replace(/[^A-Za-z0-9]+/g,"_"))+".mp4";
    setRefreshing(function(p){var o=Object.assign({},p);o[clip.id]=true;return o;});
    fetch(BACKEND_URL+"/r2-read-url?download=1&filename="+encodeURIComponent(fn)+"&objectKey="+encodeURIComponent(clip.clip_object_key))
      .then(function(r){return r.json();})
      .then(function(d){
        setRefreshing(function(p){var o=Object.assign({},p);delete o[clip.id];return o;});
        if(!d||!d.url){ notify("Could not prepare download","error"); return; }
        var a=document.createElement("a"); a.href=d.url; a.download=fn; a.target="_blank"; a.rel="noopener";
        document.body.appendChild(a); a.click(); document.body.removeChild(a);
      })
      .catch(function(){ setRefreshing(function(p){var o=Object.assign({},p);delete o[clip.id];return o;}); notify("Download failed","error"); });
  }

  // Group clips by session_date + clip_type for one-eval-per-session model.
  // clip_type ("pregame"|"game") keeps a pickup event's pregame work and game action as
  // SEPARATE session reports (they're distinct deliverables and graded differently).
  function groupBySession(clipList){
    var groups = {};
    (clipList||[]).forEach(function(c){
      var ct = c.clip_type || null;
      var key = (c.session_date||"unknown")+"|"+(c.session_type||"Evaluation")+"|"+(ct||"");
      if(!groups[key]) groups[key] = {date:c.session_date||"Unknown", type:c.session_type||"Evaluation", clipType:ct, clips:[]};
      groups[key].clips.push(c);
    });
    return Object.values(groups).sort(function(a,b){return (b.date||"").localeCompare(a.date||"");});
  }

  function runSessionEval(grp){
    if(!isAdmin){ notify("Admin only","error"); return; }
    var groupKey = (grp.date||"")+"|"+(grp.type||"")+"|"+(grp.clipType||"");
    setEvalStatus(function(prev){ var n=Object.assign({},prev||{}); n[groupKey]={state:"running",t0:Date.now()}; return n; });
    fetch(BACKEND_URL+"/evaluate-session", {
      method:"POST",
      headers:bbotAdminHeaders(),
      body: JSON.stringify({
        playerId: String(userId),
        playerName: playerName,
        sessionDate: grp.date,
        sessionType: grp.type,
        clipType: grp.clipType || null,
        adminNotes: (sessionNotes[groupKey]||"").trim() || null,
      })
    }).then(function(r){
      if(!r.ok) return r.text().then(function(t){throw new Error(t||("HTTP "+r.status));});
      return r.json();
    }).then(function(out){
      setEvalStatus(function(prev){ var n=Object.assign({},prev||{}); n[groupKey]={state:"done",clips:out.clipsAnalyzed,frames:out.framesAnalyzed,t1:Date.now()}; return n; });
      refreshReports();
      notify("✓ Session report ready — "+out.clipsAnalyzed+" clips, "+out.framesAnalyzed+" frames.");
    }).catch(function(err){
      setEvalStatus(function(prev){ var n=Object.assign({},prev||{}); n[groupKey]={state:"error",msg:err.message||"unknown"}; return n; });
      notify("Session eval failed: "+(err.message||"unknown"),"error");
    });
  }

  function runBbotEval(clip){
    if(!isAdmin){ notify("Only admin can trigger evaluations from clips","error"); return; }
    var clipKey = "clip:"+(clip.clip_object_key||clip.id||Math.random());
    setEvalStatus(function(prev){ var n=Object.assign({},prev||{}); n[clipKey]={state:"running",t0:Date.now()}; return n; });
    // Unified payload: match runBbot to prevent eval output drift (CLAUDE.md §12)
    var player = (users||[]).find(function(u){return String(u.id)===String(userId);});
    fetch(BACKEND_URL+"/evaluate", {
      method:"POST",
      headers: bbotAdminHeaders(),
      body: JSON.stringify({
        prompt: "Evaluate this "+(clip.session_type||"session")+" clip for "+playerName+".",
        playerId: String(userId),
        position: player ? (player.position || "") : "",
        sessionDate: clip.session_date,
        sessionType: clip.session_type,
        videoUrl: null,  // clip-based eval has objectKey, not videoUrl
        objectKey: clip.clip_object_key,
        sessionMode: "individual",  // clips are individual sessions
        adminSpec: null,  // no custom admin spec from clip trigger
      })
    }).then(function(r){
      if(!r.ok) return r.text().then(function(t){throw new Error(t||("HTTP "+r.status));});
      return r.json();
    }).then(function(){
      setEvalStatus(function(prev){ var n=Object.assign({},prev||{}); n[clipKey]={state:"done",t1:Date.now()}; return n; });
      refreshReports();
      notify("✓ Evaluation complete — see BBOT Evaluations tab.");
    }).catch(function(err){
      setEvalStatus(function(prev){ var n=Object.assign({},prev||{}); n[clipKey]={state:"error",msg:err.message||"unknown"}; return n; });
      notify("Eval failed: "+(err.message||"unknown"),"error");
    });
  }

  return (
    <div>
      {loading ? (
        <div style={{padding:8}}>
          <SkeletonCard/><SkeletonCard/><SkeletonCard/>
        </div>
      ) : clips.length===0 ? (
        <EmptyCard icon="C" title="No Clips Yet" sub="Clips from segmented master sessions appear here." action={isAdmin?"Go to Master Sessions":null} onAction={isAdmin?function(){if(typeof window!=="undefined")window.location.hash="admin-sessions";}:null}/>
      ) : (function(){
        // Skeleton clips render in their OWN section, separate from the video-clip flow below.
        var skelClips = clips.filter(function(c){return c.clip_type==="skeleton" && inBracket(c);});
        var skelSection = <SkeletonClipsSection clips={skelClips} isAdmin={isAdmin}/>;
        var shownClips = clips.filter(inBracket).filter(function(c){return c.clip_type!=="skeleton";});
        if(shownClips.length===0){
          var evalCount=(scoutReports||[]).filter(function(r){return String(r.playerId)===String(userId) && !r.reportType && (r.sections&&r.sections.length) && (isLiveEval(r));}).length;
          return <div>
            {skelSection}
            <EmptyCard icon="C" title={"No "+(ageBracket&&ageBracket!=="career"?ageBracket+" ":"")+"Clips"} sub={ageBracket&&ageBracket!=="career"?"No clips recorded in this age bracket. Switch to Career to see all.":"Clips from segmented master sessions appear here."}/>
            {isAdmin && evalCount>0 && <div style={{marginTop:12,padding:"10px 12px",borderRadius:8,fontSize:11,lineHeight:1.5,background:C.coralFaint,border:"1px solid "+C.coralLight,color:C.coral}}>This player has {evalCount} evaluated session{evalCount===1?"":"s"} but no generated clips yet. Open the master video under Master Sessions to segment and generate clips for each session.</div>}
          </div>;
        }
        var groups = groupBySession(shownClips);
        return (
        <div>
          {skelSection}
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:12}}>
            <div style={{fontSize:12,color:C.gray500}}>{shownClips.length} clip{shownClips.length===1?"":"s"} across {groups.length} session{groups.length===1?"":"s"}{ageBracket&&ageBracket!=="career"?" · "+ageBracket:""}</div>
            <Btn v="ghost" style={{fontSize:11,padding:"4px 10px"}} onClick={loadClips}>Refresh</Btn>
          </div>

          {isAdmin && (function(){
            // Coverage: which approved eval sessions have NO clips generated yet.
            var evalSessions=(scoutReports||[]).filter(function(r){
              return String(r.playerId)===String(userId)
                && !r.reportType
                && (r.sections && r.sections.length)
                && (isLiveEval(r));
            });
            var missing=evalSessions.filter(function(r){
              var d=r.date||r.sessionDate||"";
              // a session is "covered" if any clip shares its date
              return !(clips||[]).some(function(c){return String(c.session_date||"")===String(d);});
            });
            if(evalSessions.length===0) return null;
            return <div style={{marginBottom:14,padding:"10px 12px",borderRadius:8,fontSize:11,lineHeight:1.5,background:missing.length?C.coralFaint:C.blueFaint,border:"1px solid "+(missing.length?C.coralLight:C.blueLight),color:missing.length?C.coral:C.blue}}>
              Clips are generated per session video. This player has clips from {groups.length} of {evalSessions.length} evaluated session{evalSessions.length===1?"":"s"}.
              {missing.length>0 && <span> {missing.length} session{missing.length===1?"":"s"} ha{missing.length===1?"s":"ve"} no clips yet — open that session's master video under Master Sessions to segment and generate clips.</span>}
            </div>;
          })()}

          {groups.map(function(grp,gi){
            // WHO MAY WATCH (ruled by Luis 2026-08-18): clips are open to coach/scout accounts the
            // same way profiles are. The `paid` requirement is GONE from visibility — it gated
            // clips behind a purchase while the ruling says a coach may see them, and since `paid`
            // is false on every clip on file it made the whole library invisible to everyone but
            // an admin. APPROVED still gates: an unapproved clip is unreviewed media and stays out
            // of view, which is the same rule the skeleton section already applies.
            //
            // WHERE `paid` STILL BELONGS, and it is not here: releasing the EVALUATION to the
            // buyer. That is a payment question about a report, answered by the Stripe webhook
            // writing bbot_unlocks server-side, and it is untouched by this.
            var approvedClips = grp.clips.filter(function(c){return c.approved;});
            var _viewerIsOwner = cu && String(cu.id) === String(userId);
            var _mayWatch = mayWatch;
            var pendingClips = grp.clips.filter(function(c){return !c.approved;});
            var groupKey = (grp.date||"")+"|"+(grp.type||"")+"|"+(grp.clipType||"");
            // Only offer "generate report" when this session has NO report yet — otherwise it's redundant
            // (would make a duplicate) and misleading. Tag & Evaluate already auto-generates reports.
            var hasReport = (scoutReports||[]).some(function(rp){
              return String(rp.playerId)===String(userId) && rp.sessionDate===grp.date && (!grp.type || !rp.sessionType || rp.sessionType===grp.type);
            });
            return <div key={gi} style={{marginBottom:18,padding:14,background:C.gray50,borderRadius:10,border:"1px solid "+C.border}}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",flexWrap:"wrap",gap:10,marginBottom:12}}>
                <div>
                  {/* THE LABEL MUST NAME THE LANE IT IS SHOWING. This read `==="game" ? "Game" :
                      "Pregame"`, so every clip_type that was not "game" rendered as "Pregame" --
                      and a pitcher's isolated delivery work, cut as its own "bullpen" clip from
                      2026-09-26, would sit under a heading calling it pregame fielding. A label
                      that defaults to a name is a label that will be wrong the first time the
                      vocabulary grows, which it just did. */}
                  <div style={{fontSize:14,fontWeight:700,color:C.navy}}>{grp.date} · {grp.type}{grp.clipType?(" · "+({game:"Game",bullpen:"Bullpen",pregame:"Pregame"}[String(grp.clipType).toLowerCase()]||"Pregame")):""}</div>
                  <div style={{fontSize:11,color:C.gray500,marginTop:2}}>{grp.clips.length} clip{grp.clips.length===1?"":"s"}{isAdmin&&pendingClips.length?(" · "+pendingClips.length+" pending approval"):""}</div>
                </div>
                {isAdmin && !hasReport && <Btn v="primary" style={{fontSize:12,padding:"7px 14px"}} onClick={function(){runSessionEval(grp);}} disabled={(evalStatus[groupKey]||{}).state==="running"}>{(evalStatus[groupKey]||{}).state==="running"?"Generating…":"↑ Generate Session Report"}</Btn>}
              </div>

              {isAdmin && (function(){ var gk=groupKey; return (
                <textarea value={sessionNotes[gk]||""} onChange={function(e){var v=e.target.value;setSessionNotes(function(p){var n=Object.assign({},p||{});n[gk]=v;return n;});}}
                  placeholder="Admin observation notes (optional) — e.g. plays the camera missed, standouts, context. BBOT folds these into the report as observed input."
                  rows={2} style={{width:"100%",marginTop:8,marginBottom:4,padding:"7px 9px",border:"1px solid "+C.border,borderRadius:6,fontSize:11,boxSizing:"border-box",fontFamily:"inherit",lineHeight:1.4,resize:"vertical"}}/>
              ); })()}

              {/* Inline BBOT eval progress strip — replaces the disappearing toast so the user can SEE the eval running and know it landed. */}
              {isAdmin && (function(){
                var st = evalStatus[groupKey];
                if(!st) return null;
                if(st.state==="running"){
                  var sec = Math.floor(((Date.now()-st.t0)||0)/1000);
                  return (
                    <div style={{marginBottom:12,padding:"10px 12px",borderRadius:8,background:C.blueFaint,border:"1px solid "+C.blueLight}}>
                      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:6}}>
                        <div style={{fontSize:12,fontWeight:600,color:C.navy}}>Generating BBOT evaluation… {sec}s elapsed</div>
                        <div style={{fontSize:10,color:C.gray500}}>{playerName}</div>
                      </div>
                      <div style={{height:6,background:C.gray200,borderRadius:3,overflow:"hidden",position:"relative"}}>
                        <div style={{position:"absolute",top:0,bottom:0,left:0,width:"30%",background:C.blue,borderRadius:3,animation:"bbotProgress 1.4s ease-in-out infinite"}}/>
                      </div>
                      <style>{"@keyframes bbotProgress { 0% { left:-30%; } 100% { left:100%; } }"}</style>
                    </div>
                  );
                }
                if(st.state==="done"){
                  return (
                    <div style={{marginBottom:12,padding:"10px 12px",borderRadius:8,background:C.blueFaint,border:"1px solid "+C.blueLight,fontSize:12,color:C.navy,display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                      <div>✓ Evaluation generated{st.clips?" — "+st.clips+" clips, "+st.frames+" frames":""}. Find it under the <strong>BBOT Evaluations</strong> tab.</div>
                      <button onClick={function(){setEvalStatus(function(p){var n=Object.assign({},p);delete n[groupKey];return n;});}} style={{background:"none",border:"none",color:C.gray500,fontSize:14,cursor:"pointer",padding:"0 6px"}}>×</button>
                    </div>
                  );
                }
                if(st.state==="error"){
                  return (
                    <div style={{marginBottom:12,padding:"10px 12px",borderRadius:8,background:C.coralFaint,border:"1px solid "+C.coralLight,fontSize:12,color:C.coral,display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                      <div>✗ Eval failed — {st.msg||"unknown"}</div>
                      <button onClick={function(){setEvalStatus(function(p){var n=Object.assign({},p);delete n[groupKey];return n;});}} style={{background:"none",border:"none",color:C.coral,fontSize:14,cursor:"pointer",padding:"0 6px"}}>×</button>
                    </div>
                  );
                }
                return null;
              })()}

              {/* PLAYER-FACING, AND NOW ACTUALLY PLAYER-ONLY. The unlock offer rendered for ANY
                  non-admin viewer, so a coach opening a player's profile was shown a checkout for
                  somebody else's evaluation, sitting where that player's clip should have
                  previewed. It is the buyer's card and only the buyer sees it.
                  (The price itself is never written here — it comes from BBOT_PRICE_USD, its one
                  home. Quoting it in this comment was itself a second copy, and the price sweep
                  was right to say so.) */}
              {_viewerIsOwner && approvedClips.length>0 && !approvedClips.some(function(c){return c.paid;}) && (
                <SessionPurchaseChoice playerId={userId} playerName={playerName} sessionDate={grp.date} sessionType={grp.type} clipCount={approvedClips.length} clips={approvedClips} notify={notify}/>
              )}
              {!isAdmin && approvedClips.length===0 && (
                <div style={{padding:"10px 12px",background:C.white,borderRadius:8,fontSize:12,color:C.gray500,fontStyle:"italic"}}>Clips from this session are being reviewed. They'll be available shortly.</div>
              )}

              <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(220px,1fr))",gap:10}}>
                {grp.clips.map(function(c){
                  var lowConf = c.player_id_confidence && c.player_id_confidence.toLowerCase().indexOf("low")>=0;
                  // Approved clips play for anyone who may watch this profile; an
                  // unapproved clip is unreviewed media and stays out of view.
                  var canPlay = isAdmin || (c.approved && _mayWatch);
                  if(!canPlay){
                    // Locked placeholder — clip exists but is paywalled (or pending approval)
                    return <Card key={c.id} style={{padding:0,overflow:"hidden",opacity:0.85}}>
                      <div style={{height:2,background:C.gray300}}/>
                      <div style={{padding:10,textAlign:"center"}}>
                        <div style={{fontSize:12,fontWeight:700,color:C.gray500,textTransform:"capitalize",marginBottom:6}}>{(c.action_type||"play").replace(/_/g," ")}</div>
                        <div style={{fontSize:22,marginBottom:4}}>🔒</div>
                        <div style={{fontSize:10,color:C.gray400}}>{c.approved?"Unlock with report + clips":"Pending review"}</div>
                      </div>
                    </Card>;
                  }
                  return <Card key={c.id} style={{padding:0,overflow:"hidden",border:lowConf?"1.5px solid "+C.orange:undefined}}>
                    <div style={{height:2,background:lowConf?C.orange:C.coral}}/>
                    {/* THE PREVIEW — same inline element and same `#t=0.1` poster trick the
                        skeleton section uses, so the two kinds of media on this profile look like
                        one product. A clip whose URL has not signed yet holds its space with a
                        quiet panel rather than a broken frame. */}
                    {previewUrls[c.id]
                      ? <video {...bbotVideoGuard()} src={previewUrls[c.id]+"#t=0.1"} preload="metadata" controls
                               playsInline
                               style={{width:"100%",display:"block",background:C.gray50,
                                       maxHeight:220,objectFit:"contain"}}/>
                      : <div style={{width:"100%",height:96,background:C.gray50,display:"flex",
                                     alignItems:"center",justifyContent:"center",
                                     fontSize:10,color:C.gray400,letterSpacing:.5}}>
                          loading preview&hellip;
                        </div>}
                    <div style={{padding:10}}>
                      <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:6}}>
                        <div style={{fontSize:12,fontWeight:700,color:C.navy,textTransform:"capitalize"}}>{(c.action_type||"play").replace(/_/g," ")}</div>
                        <div style={{fontSize:10,color:C.gray500,fontWeight:600}}>{Math.round(c.duration_sec||0)}s</div>
                      </div>
                      {lowConf && <div style={{fontSize:9,color:C.orange,marginBottom:4,fontWeight:600,letterSpacing:.3}}>⚠ LOW PLAYER ID CONFIDENCE</div>}
                      <Btn v="primary" style={{width:"100%",fontSize:11,padding:"5px",justifyContent:"center",marginBottom:4}} onClick={function(){playClip(c);}}>{refreshing[c.id]?"Loading...":"▶ Play"}</Btn>
{/* DOWNLOAD IS ADMIN-ONLY (Luis, 2026-10-08). Clips and skeletons are now watchable by
                          anyone, including people with no account -- so the button that hands over
                          the FILE is the line between showing a player's footage and giving it away.
                          Honest about what this is: removing the button, the native player's download
                          control and right-click save defeats casual copying, not someone who opens
                          developer tools. A browser must receive the bytes to play them. The Terms
                          carry the prohibition; this removes the easy path. */}
                      {isAdmin && <Btn v="ghost" style={{width:"100%",fontSize:11,padding:"5px",justifyContent:"center",marginBottom:4}} onClick={function(){downloadClip(c);}}>↓ Download</Btn>}
                      {/* SHARE IS FOR EVERYONE, download is not. See bbotShareClip. */}
                      {c.approved && <Btn v="ghost" style={{width:"100%",fontSize:11,padding:"5px",justifyContent:"center",marginBottom:isAdmin?4:0}} onClick={function(){bbotShareClip(c, notify);}}>↗ Share</Btn>}
                      {isAdmin && (
                        <button onClick={function(){
                          var newId = window.prompt("Reassign this clip to which player ID?\\n(Current: "+(c.player_id||"unknown")+", jersey #"+(c.player_jersey||"?")+")\\n\\nEnter new player ID or leave blank to cancel:", String(c.player_id||""));
                          if(!newId || newId===String(c.player_id||"")) return;
                          bbotWrite("bbot_clips","update",{player_id: newId, player_id_confidence: "high (manually verified)"},"id=eq." + Number(c.id)).then(function(){
                            // Audit log
                            bbotAdminLog({action:"clip_player_reassigned",target_id:String(c.id),admin_id:cu?String(cu.id):null,timestamp:new Date().toISOString(),metadata:{from:c.player_id,to:newId}}).catch(function(){});
                            notify("Player reassigned · refresh to see");
                            loadClips();
                          }).catch(function(){notify("Reassign failed","error");});
                        }} style={{width:"100%",fontSize:10,padding:"4px",background:"transparent",border:"1px solid "+C.border,borderRadius:6,color:C.gray600,cursor:"pointer",fontWeight:600,minHeight:"auto"}}>↻ Reassign Player</button>
                      )}
                    </div>
                  </Card>;
                })}
              </div>
            </div>;
          })}
        </div>
      );})()}
    </div>
  );
}

function ProfileTabBar({tab,setTab,isPlayer,isStaffViewer,showCompare,isOwn}){
  var tabs=isPlayer?["overview","clips","evaluations","performance","recaps"].concat(isStaffViewer?["notes"]:[]):["overview"].concat(showCompare?["compare"]:[]);
  // "Your Feed" — visible to everyone, but the page itself filters private items out for
  // non-owners. The tab shows on every profile so other users can scan public activity.
  tabs.push("feed");
  var label=function(t){return t==="overview"?"Overview":t==="clips"?"Clips":t==="evaluations"?"BBOT Evaluations":t==="performance"?"Performance":t==="recaps"?"Session Reports":t==="notes"?"Notes":t==="compare"?"Compare Players":"";};
  return(
    <div style={{display:"flex",gap:0,borderBottom:"2px solid #e5e7eb",marginBottom:20,overflowX:"auto",alignItems:"center"}}>
      <img src={LOGO_BBOT} alt="BBOT" style={{height:20,width:20,borderRadius:"50%",flexShrink:0,margin:"0 10px 2px 2px",boxShadow:"0 1px 3px rgba(0,0,0,.15)"}}/>
      {tabs.map(function(t){return <button key={t} onClick={function(){setTab(t);}} style={{background:"none",border:"none",borderBottom:tab===t?"2.5px solid #E97A7A":"2.5px solid transparent",padding:"10px 14px",fontSize:12,fontWeight:tab===t?700:500,color:tab===t?"#E97A7A":"#6b7280",cursor:"pointer",whiteSpace:"nowrap",marginBottom:"-2px",flexShrink:0}}>{label(t)}</button>;})}
    </div>
  );
}

function ProfilePage({user,isOwn,isAdmin,cu,setCu,users,setUsers,metrics,reviews,scoutReports,setScoutReports,blogs,highlights,setHighlights,toggleFollow,toggleInterest,pushFeed,feed,setFeed,notify,go,battedBalls,setBattedBalls,recaps,coachUpdates,setCoachUpdates,startImpersonate}){
  var isAdmin = cu && bbotIsAdmin(cu);
  var editingState=useState(false); var editing=editingState[0]; var setEditing=editingState[1];
  var formState=useState(Object.assign({},user)); var form=formState[0]; var setForm=formState[1];
  var nvState=useState({title:"",url:""}); var nv=nvState[0]; var setNv=nvState[1];
  var isStaff=cu.type==="staff";
  var uM=metrics[user.id]||[];
  var _uSRseen={};
  var uSR=(scoutReports||[]).filter(function(r){return Number(r.playerId)===Number(user.id);}).filter(function(r){var k=String(r.id);if(_uSRseen[k])return false;_uSRseen[k]=true;return true;}).sort(function(a,b){return String(a.date||"").localeCompare(String(b.date||""));});
  var isF=(cu.following||[]).includes(user.id);
  var isStaffViewer=cu.type==="staff";
  var latestScore=uSR.length>0?uSR[uSR.length-1].score:null;
  var scoreCol=latestScore>=70?C.blue:latestScore>=50?C.orange:C.red;
  var profileTabS=useState("overview"); var profileTab=profileTabS[0]; var setProfileTab=profileTabS[1];
  var messageOpenS=useState(false); var messageOpen=messageOpenS[0]; var setMessageOpen=messageOpenS[1];
  var messageTextS=useState(""); var messageText=messageTextS[0]; var setMessageText=messageTextS[1];

  function sendMessage(){
    if(!messageText.trim()) return notify("Type a message first","error");
    // Admin/staff are the platform operator, not recruiters — exempt from NCAA contact-date gating.
    if(!isAdmin && !isStaff && !isMessagingEligible(user)) return notify("Player not yet eligible for messaging","error");
    // Persist message to a messages table + audit + log
    var msg = {
      from_user_id: cu?String(cu.id):null,
      from_name: cu?(cu.firstName+" "+cu.lastName):"Unknown",
      to_user_id: String(user.id),
      to_name: user.firstName+" "+user.lastName,
      body: messageText.trim(),
      created_at: new Date().toISOString(),
      eligible_verified: true,
      grad_year: user.gradYear || null,
    };
    // Log under audit for compliance
    bbotWrite("bbot_communication_log","insert",[msg],null).then(function(){
      // Also notify the recipient
      bbotWrite("bbot_notifications","insert",[{
          player_id: String(user.id),
          type: "message",
          message: "New message from "+msg.from_name,
          read: false,
          created_at: new Date().toISOString()
        }],null).catch(function(){});
      notify("Message sent — logged for compliance");
      setMessageText("");
      setMessageOpen(false);
    }).catch(function(){ notify("Failed to send","error"); });
  }
  var ageBracketS=useState("career"); var ageBracket=ageBracketS[0]; var setAgeBracket=ageBracketS[1];
  var canSubscribe=user.type==="player"&&!isOwn&&(cu.type==="coach"||bbotIsAdmin(cu));
  // Age-group of a session = the player's REAL age (from DOB) at that session, with the
  // Aug 1 rollover. BBOT percentiles are age-based, so we must use DOB, not grad year
  // (class ≠ age: a player can be 19 and a junior). No DOB → no reliable bucket → null.
  var bucketForDate=function(d){
    if(!d) return null;
    var ag=seasonAge({dob:user.dob}, d);
    if(ag==null) return null; // no DOB → can't bucket by age
    if(ag>=19) return "19+";
    if(ag<14) return "14U"; // floor display bucket
    return ag+"U";
  };
  var filterByAge=function(arr,dateField){
    if(ageBracket==="career") return arr||[];
    return (arr||[]).filter(function(item){
      var d=item[dateField||"date"]||item.sessionDate||item.created_at||"";
      return bucketForDate(d)===ageBracket;
    });
  };
  // Which age buckets actually have data (for showing only relevant sections)
  var bucketsWithData=function(arr,dateField){
    var set={};
    (arr||[]).forEach(function(item){
      var d=item[dateField||"date"]||item.sessionDate||item.created_at||"";
      var b=bucketForDate(d); if(b) set[b]=true;
    });
    return ["19+","18U","17U","16U","15U","14U"].filter(function(b){return set[b];});
  };
  var filteredSR=filterByAge(uSR,"sessionDate");
  var filteredM=filterByAge(uM,"date");
  var isSubscribed=(coachUpdates||[]).some(function(s){return String(s.coachId)===String(cu.id)&&String(s.playerId)===String(user.id);});
  var setF=function(k,v){setForm(function(p){var o=Object.assign({},p);o[k]=v;return o;});};
  var save=function(){if(user.type==="player"&&!form.height){notify("Add your height to save — it scales the movement BBOT draws to your own body","error");return;}var updated=Object.assign({},user,form);setUsers(function(all){return all.map(function(u){return u.id===user.id?updated:u;});});if(isOwn)setCu(function(c){return Object.assign({},c,form);});persistUser(updated).then(function(){setEditing(false);notify("Profile updated!");if(user.type==="player"&&typeof coachUpdates!=="undefined"){(coachUpdates||[]).filter(function(s){return String(s.playerId)===String(user.id);}).forEach(function(s){pushFeed&&pushFeed(s.coachId,"profile",user.firstName+" "+user.lastName+" updated their profile");});}}).catch(function(){notify("Could not save your profile — check your connection and try again","error");});};
  var toggleSubscribe=function(){if(!setCoachUpdates)return;if(isSubscribed){setCoachUpdates(function(prev){return prev.filter(function(s){return!(String(s.coachId)===String(cu.id)&&String(s.playerId)===String(user.id));});});notify("Unsubscribed");}else{setCoachUpdates(function(prev){return(prev||[]).concat([{coachId:cu.id,playerId:user.id}]);});notify("Subscribed!");}};
  // COACH → PLAYER EVAL REQUEST. Coach expresses interest; the PLAYER is notified
  // and initiates the (payment-first) evaluation themselves. Coach is auto-notified
  // when the report is released (see eval release path). Coaches only trigger interest.
  var requestEvaluation=function(){
    var coachName = cu.type==="coach" ? ("Coach "+cu.lastName) : (cu.firstName+" "+cu.lastName);
    var today = new Date().toISOString().slice(0,10);
    var notif = {id:Date.now(),type:"eval_request",text:coachName+" requested a BBOT evaluation — start one to share your verified report.",date:today,read:false};
    // Notify the player + persist
    setUsers(function(all){return all.map(function(u){
      if(String(u.id)!==String(user.id)) return u;
      var updated = Object.assign({},u,{notifications:[notif].concat(u.notifications||[])});
      // Cross-user notification to the player → /user-notify (coach can't write the player's row under RLS).
      fetch(BACKEND_URL+"/user-notify",{method:"POST",headers:bbotAdminHeaders(),body:JSON.stringify({targetId:user.id,notification:notif})}).catch(function(){});
      return updated;
    });});
    // Subscribe the coach to this player's updates so they're notified on release
    if(setCoachUpdates && !isSubscribed){
      setCoachUpdates(function(prev){return (prev||[]).concat([{coachId:cu.id,playerId:user.id,reason:"eval_request",date:today}]);});
    }
    // Activity for the coach's own private feed
    pushFeed && pushFeed(cu.id,"eval_request","You requested an evaluation for "+user.firstName+" "+user.lastName);
    // Notify admin so they can follow up
    setUsers(function(all){return all.map(function(u){
      if(!bbotIsAdmin(u)) return u;
      var an = {id:Date.now()+1,type:"eval_request",text:coachName+" requested an eval for "+user.firstName+" "+user.lastName,date:today,read:false};
      return Object.assign({},u,{notifications:[an].concat(u.notifications||[])});
    });});
    notify("Evaluation requested — "+user.firstName+" has been notified");
  };
  var alreadyRequested=(coachUpdates||[]).some(function(s){return String(s.coachId)===String(cu.id)&&String(s.playerId)===String(user.id)&&s.reason==="eval_request";});
  return(
    <div style={{maxWidth:780,margin:"0 auto",padding:"0 0 40px 0"}}>

      <div style={{background:C.navy,borderRadius:16,padding:"18px",marginBottom:16,overflow:"hidden",position:"relative"}}>
        <div style={{position:"absolute",top:-30,right:-30,width:160,height:160,borderRadius:"50%",background:"rgba(255,255,255,.03)",pointerEvents:"none"}}/>
        <div style={{display:"flex",gap:14,alignItems:"flex-start",marginBottom:14}}>
          {/* Admins manage player profiles, so they get the same upload affordance as the owner.
              Who performed the upload is recorded on the row (photoUploadedBy/At) — an admin setting
              someone else's photo should never look like the player did it. */}
          {(isOwn || isAdmin) ? (
            <div style={{position:"relative",cursor:"pointer"}} onClick={function(){
              var input = document.createElement("input");
              input.type = "file";
              input.accept = "image/*";
              input.onchange = function(e){
                var f = e.target.files && e.target.files[0];
                if(!f) return;
                // RESIZED BEFORE IT IS STORED. This kept whatever the phone produced -- a 5MB file
                // passed the size guard and became a ~6.7MB base64 string inside
                // bbot_users.profile, which the app re-reads on EVERY roster fetch for the life of
                // the account. The avatar renders at 28-64px; 512 is generous even for retina, and
                // it takes a camera-roll portrait from hundreds of KB to a few tens.
                bbotDownscaleImage(f, 512).then(function(dataUrl){
                  var _byAdmin = !isOwn && isAdmin;
                  var updated = Object.assign({}, user, {photoUrl: dataUrl,
                    photoUploadedBy: _byAdmin ? String(cu && cu.id) : String(user.id),
                    photoUploadedAt: new Date().toISOString()});
                  if(setCu && String(cu.id)===String(user.id)) setCu(updated);
                  if(setUsers) setUsers(function(all){return (all||[]).map(function(u){return String(u.id)===String(user.id)?updated:u;});});
                  persistUser(updated).then(function(){ notify(_byAdmin ? ("Photo set for "+(user.firstName||"player")+" (admin)") : "Profile photo updated"); }).catch(function(){ notify("Could not save photo — try again","error"); });
                }).catch(function(err){
                  notify(err&&err.message?("Could not use that photo — "+err.message):"Could not use that photo","error");
                });
              };
              input.click();
            }} title="Click to update photo">
              <Avatar user={user} size={64}/>
              <div style={{position:"absolute",bottom:-2,right:-2,width:22,height:22,borderRadius:"50%",background:C.coral,color:C.white,display:"flex",alignItems:"center",justifyContent:"center",fontSize:11,fontWeight:700,border:"2px solid "+C.navy}}>+</div>
            </div>
          ) : (
            <Avatar user={user} size={64}/>
          )}
          <div style={{flex:1,minWidth:0}}>
            <h2 style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:22,letterSpacing:1,color:C.white,marginBottom:3,lineHeight:1.1,wordBreak:"break-word",display:"flex",alignItems:"center",gap:6,flexWrap:"wrap"}}>
              <span>{user.firstName} {user.lastName}</span>
              {user.type==="coach" && user.verified && (
                <span title="Verified coach" style={{display:"inline-flex",alignItems:"center",justifyContent:"center",width:18,height:18,borderRadius:"50%",background:C.blue,color:C.white,fontSize:10,fontWeight:700,flexShrink:0}}>✓</span>
              )}
              {user.verified643 && <BBOTCheck size={14}/>}
              {user.type==="staff" && (
                <span title="BBOT staff" style={{display:"inline-flex",alignItems:"center",justifyContent:"center",padding:"2px 7px",borderRadius:99,background:C.coral,color:C.white,fontSize:9,fontWeight:700,letterSpacing:.5}}>STAFF</span>
              )}
            </h2>
            <div style={{color:"rgba(255,255,255,.62)",fontSize:11,marginBottom:8,wordBreak:"break-all"}}>{user.email}</div>
            {isAdmin && (
              <button onClick={function(){
                var nv=!user.verified643; var updated=Object.assign({},user,{verified643:nv});
                setUsers(function(all){return all.map(function(u){return u.id===user.id?updated:u;});});
                if(isOwn)setCu(function(c){return Object.assign({},c,{verified643:nv});});
                persistUser(updated).then(function(){notify(nv?"Marked as verified 643 member":"Removed 643 verification");}).catch(function(){notify("Could not update verification","error");});
              }} style={{display:"inline-flex",alignItems:"center",gap:4,marginBottom:8,padding:"2px 7px",borderRadius:5,border:"1px solid rgba(255,255,255,.3)",background:user.verified643?"#1a2f5a":"transparent",color:C.white,fontSize:9,fontWeight:700,letterSpacing:.3,cursor:"pointer"}}>
                <BBOTCheck size={11}/>{user.verified643?"643 Verified":"Mark 643 Verified"}
              </button>
            )}
            <div style={{display:"flex",flexWrap:"wrap",gap:5}}>{user.type==="player"&&<span style={{display:"contents"}}>{user.position&&<span style={{background:C.coral,color:C.white,fontSize:11,fontWeight:700,padding:"3px 10px",borderRadius:99,letterSpacing:.3}}>{user.position}</span>}{user.position2&&<span style={{background:C.coral,color:C.white,fontSize:11,fontWeight:700,padding:"3px 10px",borderRadius:99,letterSpacing:.3}}>{user.position2}</span>}{user.gradYear&&<span style={{background:"rgba(255,255,255,.12)",color:C.white,fontSize:11,fontWeight:600,padding:"3px 9px",borderRadius:99}}>{"Class "+user.gradYear}</span>}{user.dob&&(function(){var d=new Date(user.dob);if(isNaN(d))return null;var t=new Date();var a=t.getFullYear()-d.getFullYear();var m=t.getMonth()-d.getMonth();if(m<0||(m===0&&t.getDate()<d.getDate()))a--;return <span style={{background:"rgba(255,255,255,.12)",color:C.white,fontSize:11,fontWeight:600,padding:"3px 9px",borderRadius:99}}>{a+" yrs"}</span>;})()}{user.height&&<span style={{background:"rgba(255,255,255,.12)",color:C.white,fontSize:11,fontWeight:600,padding:"3px 9px",borderRadius:99}}>{user.height}</span>}</span>}{user.type==="coach"&&<span style={{display:"contents"}}>{user.level&&<Badge color="orange">{user.level}</Badge>}{user.orgName&&<span style={{background:"rgba(255,255,255,.12)",color:C.white,fontSize:11,fontWeight:600,padding:"3px 9px",borderRadius:99}}>{user.orgName}</span>}</span>}</div>
            {/* VERIFIED DATA BADGE — surfaces BBOT's data integrity stance */}
            {user.type==="player" && (uSR||[]).filter(function(r){return isLiveEval(r);}).length>0 && (
              <div style={{display:"inline-flex",alignItems:"center",gap:5,marginTop:8,padding:"3px 10px",background:"rgba(5,150,105,.15)",border:"1px solid rgba(5,150,105,.4)",borderRadius:99,fontSize:10,color:"#a7f3d0",fontWeight:600,letterSpacing:.3}} title="All metrics on this profile are derived from video evidence — no self-reported data">
                <span style={{display:"inline-flex",alignItems:"center",justifyContent:"center",width:12,height:12,borderRadius:"50%",background:"#10b981",color:C.white,fontSize:8,fontWeight:700}}>✓</span>
                VIDEO-VERIFIED METRICS ONLY
              </div>
            )}
          </div>
        </div>

        {/* Action row — stacks cleanly on mobile */}
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",gap:10,flexWrap:"wrap",paddingTop:12,borderTop:"1px solid rgba(255,255,255,0.08)"}}>
          <div style={{display:"flex",gap:18}}>
            <div style={{textAlign:"left"}}>
              <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:18,color:C.white,lineHeight:1}}>{(user.followers||[]).length}</div>
              <div style={{fontSize:9,color:"rgba(255,255,255,.58)",marginTop:2,letterSpacing:.5,textTransform:"uppercase"}}>Followers</div>
            </div>
          </div>
          <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
            {isOwn ? (
              <>
                <Btn v="outlineW" style={{fontSize:12,padding:"7px 14px"}} onClick={function(){setEditing(!editing);}}>{editing?"Cancel":"Edit Profile"}</Btn>
                <button onClick={function(){
                  var token = user.publicToken || ("pub_"+user.id+"_"+Math.random().toString(36).slice(2,6));
                  if(!user.publicToken){
                    var updated = Object.assign({}, user, {publicToken: token, publicShared: true});
                    persistUser(updated).catch(function(){});
                  }
                  // Clean URL format: #p/firstname-lastname-class-2027~token
                  var slug = (user.firstName+" "+user.lastName+" "+(user.position||"")+" "+(user.gradYear?"class-"+user.gradYear:"")).toLowerCase().replace(/[^a-z0-9]+/g,"-").replace(/^-+|-+$/g,"");
                  var url = window.location.origin+window.location.pathname+"#p/"+slug+"~"+token;
                  if(navigator.clipboard){
                    navigator.clipboard.writeText(url).then(function(){
                      notify("Public link copied to clipboard");
                    }).catch(function(){
                      window.prompt("Copy your public profile link:", url);
                    });
                  } else {
                    window.prompt("Copy your public profile link:", url);
                  }
                }} style={{fontSize:12,fontWeight:700,padding:"7px 14px",borderRadius:8,border:"none",background:C.coral,color:C.white,cursor:"pointer"}}>↗ {user.type==="player"?"Share with Coaches":"Share"}</button>
              </>
            ) : (
              <>
                <button onClick={function(){toggleFollow(user.id);}} style={{fontSize:12,fontWeight:700,padding:"7px 14px",borderRadius:8,cursor:"pointer",border:isF?"1.5px solid "+C.coral:"none",background:isF?C.white:C.coral,color:isF?C.coral:C.white}}>{isF?"Following":"+ Follow"}</button>
                {cu && cu.type==="player" && user.type==="coach" && toggleInterest && (function(){
                  var interested=(cu.interestedIn||[]).indexOf(user.id)>=0;
                  return <button onClick={function(){toggleInterest(user.id);}} title="Signal interest to this coach/program" style={{fontSize:12,fontWeight:700,padding:"7px 12px",borderRadius:8,cursor:"pointer",border:interested?"1.5px solid "+C.blue:"none",background:interested?C.white:C.blue,color:interested?C.blue:C.white}}>{interested?"✓ Interested":"Express Interest"}</button>;
                })()}
                {cu && (cu.type==="coach"||cu.type==="staff") && user.type==="player" && (
                  <Btn v={alreadyRequested?"ghost":"coral"} style={{fontSize:12,padding:"7px 12px"}} onClick={requestEvaluation}>{alreadyRequested?"✓ Eval Requested":"Request Evaluation"}</Btn>
                )}
                {cu && (cu.type==="coach"||cu.type==="staff") && user.type==="player" && (function(){
                  var myId=String(cu.id);
                  var onRoster=(user.rosterStaffIds||[]).map(String).indexOf(myId)>=0;
                  return <button onClick={function(){
                    var prevUser = user;
                    var updated = onRoster
                      ? Object.assign({},user,{rosterStaffIds:(user.rosterStaffIds||[]).map(String).filter(function(x){return x!==myId;})})
                      : Object.assign({},user,{rosterStaffIds:((user.rosterStaffIds||[]).map(String).concat([myId]))});
                    if(setUsers) setUsers(function(all){return all.map(function(u){return String(u.id)===String(user.id)?updated:u;});});
                    persistUser(updated).then(function(){
                      notify(onRoster?"Removed from your roster":(user.firstName+" added to your roster"));
                    }).catch(function(){
                      if(setUsers) setUsers(function(all){return all.map(function(u){return String(u.id)===String(prevUser.id)?prevUser:u;});});
                      notify("Could not update roster — try again","error");
                    });
                  }} style={{fontSize:12,fontWeight:700,padding:"7px 12px",borderRadius:8,cursor:"pointer",border:onRoster?"1.5px solid "+C.coral:"none",background:onRoster?C.white:C.coral,color:onRoster?C.coral:C.white}}>{onRoster?"✓ On Roster":"+ Add to Roster"}</button>;
                })()}
                {isAdmin && startImpersonate && !isOwn && (
                  <Btn v="coral" style={{fontSize:12,padding:"7px 12px"}} onClick={function(){startImpersonate(user);}}>👁 View as this user</Btn>
                )}
                {/* CHANGE EMAIL — admin only, and it goes through the backend on purpose.
                    An email lives in TWO systems: Supabase Auth (what you sign in with) and
                    bbot_users (what the app matches that session against). Writing only the
                    profile row makes the lookup fail at next sign-in and drops the person into
                    a placeholder profile with none of their real role — the exact fault that
                    made an admin see a player's dashboard. /admin/user-email-change moves both
                    or neither, rejects an address already in use, and reads both back. */}
                {isAdmin && !isOwn && (
                  <Btn v="outlineW" style={{fontSize:12,padding:"7px 12px"}} onClick={function(){
                    var cur=(user.email||"").trim();
                    if(!cur){ notify("This profile has no email on record to change","error"); return; }
                    var next=(typeof window!=="undefined") ? window.prompt("New email for "+user.firstName+" "+user.lastName+"\n\nCurrently: "+cur+"\n\nThey will sign in with the new address. Their password does not change.", cur) : null;
                    if(next===null) return;
                    next=String(next).trim().toLowerCase();
                    if(!next || next===cur.toLowerCase()) return;
                    // Checked here too so an obvious typo never reaches the server — a bad
                    // address on an identity key locks the person out of their own account.
                    if((next.match(/@/g)||[]).length!==1 || next.indexOf(".")<0){
                      notify("That is not a valid email address","error"); return;
                    }
                    fetch(BACKEND_URL+"/admin/user-email-change",{
                      method:"POST",
                      // The admin's own Supabase session authorises this; `_require_admin`
                      // accepts a token whose email is in ADMIN_EMAILS. No key in the browser.
                      headers:{"Content-Type":"application/json",
                               "Authorization":"Bearer "+(bbotAuthToken()||"")},
                      body:JSON.stringify({currentEmail:cur, newEmail:next})
                    }).then(function(r){ return r.json().then(function(j){ return {ok:r.ok, j:j}; }); })
                     .then(function(res){
                       if(!res.ok){ notify((res.j&&res.j.detail)||"Could not change the email","error"); return; }
                       var updated=Object.assign({},user,{email:next});
                       setUsers(function(all){return (all||[]).map(function(x){return x.id===user.id?updated:x;});});
                       notify("Email changed to "+next+" — they sign in with it from now on");
                     }).catch(function(){ notify("Could not reach the server","error"); });
                  }}>✉ Change email</Btn>
                )}
                {canSubscribe && <button onClick={toggleSubscribe} style={{fontSize:11,fontWeight:700,padding:"7px 10px",borderRadius:8,border:isSubscribed?"1.5px solid "+C.coral:"none",background:isSubscribed?C.white:C.coral,color:isSubscribed?C.coral:C.white,cursor:"pointer"}}>{isSubscribed?"🔔 Following":"🔔 Follow for updates"}</button>}
                {/* Coach/staff → player message button — gated by NCAA Aug-1 rule */}
                {cu && cu.type!=="player" && user.type==="player" && (function(){
                  var eligible = isAdmin || isStaff || isMessagingEligible(user);
                  var elDate = messagingEligibleDate(user);
                  if(eligible){
                    return <Btn v="coral" style={{fontSize:12,padding:"7px 12px"}} onClick={function(){
                      if(typeof window!=="undefined") window.__bbotOpenThread={otherId:String(user.id), otherName:(user.firstName+" "+user.lastName)};
                      go("messages");
                    }}>Message</Btn>;
                  }
                  return <button disabled title={elDate?"Messaging opens "+elDate.toDateString():"Grad year required"} style={{fontSize:11,fontWeight:700,padding:"7px 10px",borderRadius:8,border:"1px solid rgba(255,255,255,.15)",background:"rgba(255,255,255,.04)",color:"rgba(255,255,255,.35)",cursor:"not-allowed"}}>🔒 {elDate?"Opens "+(elDate.getMonth()+1)+"/"+elDate.getFullYear():"Messaging Locked"}</button>;
                })()}
                {/* Player → coach message button — respects coach opt-out + player eligibility */}
                {cu && cu.type==="player" && user.type==="coach" && (function(){
                  if(user.acceptsMessages===false){
                    return <button disabled title="This coach isn't accepting player messages" style={{fontSize:11,fontWeight:700,padding:"7px 10px",borderRadius:8,border:"1px solid rgba(255,255,255,.15)",background:"rgba(255,255,255,.04)",color:"rgba(255,255,255,.35)",cursor:"not-allowed"}}>Not accepting messages</button>;
                  }
                  if(!isMessagingEligible(cu)){
                    var ed=messagingEligibleDate(cu);
                    return <button disabled title={ed?"Messaging opens "+ed.toDateString():"Grad year required"} style={{fontSize:11,fontWeight:700,padding:"7px 10px",borderRadius:8,border:"1px solid rgba(255,255,255,.15)",background:"rgba(255,255,255,.04)",color:"rgba(255,255,255,.35)",cursor:"not-allowed"}}>🔒 {ed?"Opens "+(ed.getMonth()+1)+"/"+ed.getFullYear():"Messaging Locked"}</button>;
                  }
                  return <Btn v="coral" style={{fontSize:12,padding:"7px 12px"}} onClick={function(){
                    if(typeof window!=="undefined") window.__bbotOpenThread={otherId:String(user.id), otherName:(user.firstName+" "+user.lastName)};
                    go("messages");
                  }}>Message</Btn>;
                })()}
                {/* Coach/staff → coach: peers can start a thread (respects opt-out). */}
                {cu && (cu.type==="coach"||cu.type==="staff") && user.type==="coach" && cu.id!==user.id && (
                  user.acceptsMessages===false
                    ? <button disabled title="This coach isn't accepting messages" style={{fontSize:11,fontWeight:700,padding:"7px 10px",borderRadius:8,border:"1px solid rgba(255,255,255,.15)",background:"rgba(255,255,255,.04)",color:"rgba(255,255,255,.35)",cursor:"not-allowed"}}>Not accepting messages</button>
                    : <Btn v="coral" style={{fontSize:12,padding:"7px 12px"}} onClick={function(){
                        if(typeof window!=="undefined") window.__bbotOpenThread={otherId:String(user.id), otherName:(user.firstName+" "+user.lastName)};
                        go("messages");
                      }}>Message</Btn>
                )}
                {/* Anyone → 643/BBOT Admin: the Admin profile is always reachable (no eligibility lock). */}
                {cu && cu.id!==user.id && user.type==="staff" && (
                  <Btn v="coral" style={{fontSize:12,padding:"7px 12px"}} onClick={function(){
                    if(typeof window!=="undefined") window.__bbotOpenThread={otherId:String(user.id), otherName:(user.firstName+" "+user.lastName)};
                    go("messages");
                  }}>Message</Btn>
                )}
              </>
            )}
          </div>
        </div>
      </div>

      {/* COMPLIANCE-LOGGED MESSAGE MODAL */}
      {messageOpen && (
        <div onClick={function(){setMessageOpen(false);}} style={{position:"fixed",top:0,left:0,right:0,bottom:0,background:"rgba(0,0,0,0.55)",zIndex:400,display:"flex",alignItems:"center",justifyContent:"center",padding:16}}>
          <div onClick={function(e){e.stopPropagation();}} style={{background:C.white,borderRadius:14,maxWidth:480,width:"100%",padding:20,boxShadow:C.shadowLg}}>
            <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:14,color:C.navy,letterSpacing:1,marginBottom:6}}>MESSAGE {(user.firstName||"PLAYER").toUpperCase()}</div>
            <div style={{fontSize:11,color:C.gray500,marginBottom:14}}>NCAA-compliant communication · logged for audit · player is in/past their junior year</div>
            <textarea value={messageText} onChange={function(e){setMessageText(e.target.value);}} placeholder="Be respectful and concise. Avoid recruiting-restricted content." rows={6} style={{width:"100%",padding:12,borderRadius:8,border:"1.5px solid "+C.border,fontSize:14,resize:"vertical",fontFamily:"inherit"}}/>
            <div style={{fontSize:10,color:C.gray400,marginTop:8,lineHeight:1.5}}>This message will be logged in BBOT's communication record per NCAA, MLB, and state athlete-agent regulations. Both parties retain visibility.</div>
            <div style={{display:"flex",gap:8,marginTop:14,justifyContent:"flex-end"}}>
              <Btn v="ghost" onClick={function(){setMessageOpen(false);setMessageText("");}}>Cancel</Btn>
              <Btn v="coral" onClick={sendMessage} disabled={!messageText.trim()}>Send</Btn>
            </div>
          </div>
        </div>
      )}

      <ProfileTabBar tab={profileTab} setTab={setProfileTab} isPlayer={user.type==="player"} isStaffViewer={isStaffViewer} showCompare={(isOwn||bbotIsAdmin(cu)) && (user.type==="coach"||user.type==="staff")} isOwn={isOwn}/>

      {user.type==="player"&&(function(){
        var dataB = bucketsWithData(uSR,"sessionDate");
        // include any bucket that has clips/metrics too
        var clipB = bucketsWithData(uM,"date");
        var all = {}; dataB.concat(clipB).forEach(function(b){all[b]=true;});
        var ordered = ["19+","18U","17U","16U","15U","14U"].filter(function(b){return all[b];});
        var pills = ["career"].concat(ordered);
        if(pills.length<=1) return null; // nothing to segment
        return <div style={{display:"flex",gap:5,marginBottom:16,flexWrap:"wrap",alignItems:"center"}}>
          <span style={{fontSize:11,color:"#6b7280",fontWeight:600,marginRight:2}}>AGE:</span>
          {pills.map(function(b){return <button key={b} onClick={function(){setAgeBracket(b);}} style={{padding:"3px 10px",borderRadius:99,fontSize:11,fontWeight:600,border:ageBracket===b?"none":"1px solid #e5e7eb",background:ageBracket===b?"#2970b8":"transparent",color:ageBracket===b?"white":"#6b7280",cursor:"pointer"}}>{b==="career"?"Career":b}</button>;})}
        </div>;
      })()}

      {/* AI PLAYER SNAPSHOT — auto-generated single-paragraph summary */}
      {/* 643 MEMBER PACKAGE removed 2026-07-13 — killed per the two-product rinse (only the individual + cumulative evaluations exist as products, both at BBOT_PRICE_USD). */}
      {profileTab==="overview" && user.type==="player" && !editing && isOwn && (function(){
        // Profile completeness — nudges the owner to fill key fields so coaches see a full
        // profile. Owner-only (visitors never see "incomplete"). Hidden once everything's set.
        var checks = [
          {key:"position", label:"Primary position", ok:!!user.position},
          {key:"height",   label:"Height",           ok:!!user.height},
          {key:"weight",   label:"Weight",           ok:!!user.weight},
          {key:"bats",     label:"Bats",             ok:!!user.bats},
          {key:"throws",   label:"Throws",           ok:!!user.throws},
          {key:"gradYear", label:"Grad year",        ok:!!user.gradYear},
          {key:"dob",      label:"Date of birth",    ok:!!user.dob},
          {key:"school",   label:"School or club",   ok:!!(user.hsName||user.clubName)},
          {key:"bio",      label:"Short bio",         ok:!!(user.bio&&user.bio.trim())},
        ];
        var doneCount = checks.filter(function(c){return c.ok;}).length;
        var pct = Math.round((doneCount/checks.length)*100);
        if(pct===100) return null; // complete — no nudge
        var missing = checks.filter(function(c){return !c.ok;});
        return (
          <Card style={{marginBottom:10,padding:14}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:8}}>
              <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:10,color:C.blue,letterSpacing:1.2,fontWeight:700}}>PROFILE {pct}% COMPLETE</div>
              <button onClick={function(){setEditing(true);}} style={{background:"transparent",border:"1px solid "+C.blue,color:C.blue,fontSize:11,fontWeight:600,padding:"3px 10px",borderRadius:6,cursor:"pointer"}}>Complete it</button>
            </div>
            <div style={{height:6,borderRadius:99,background:C.gray200,overflow:"hidden",marginBottom:8}}>
              <div style={{height:"100%",width:pct+"%",background:C.blue,borderRadius:99,transition:"width .4s"}}/>
            </div>
            <div style={{fontSize:11,color:C.gray500,lineHeight:1.5}}>
              Coaches see fuller profiles first. Add: {missing.slice(0,4).map(function(c){return c.label;}).join(", ")}{missing.length>4?", and more":""}.
            </div>
          </Card>
        );
      })()}

      {profileTab==="overview" && user.type==="player" && !editing && (function(){
        // Latest approved/published eval that actually has graded sections.
        var latestEval = (uSR||[]).slice().reverse().find(function(r){
          return (isLiveEval(r)) && r.sections && r.sections.length;
        });
        if(!latestEval) return null;
        // Use latest eval summary if available, else compose
        var snapshot = latestEval.summary || null;
        if(!snapshot){
          var topGrades = (latestEval.sections||[]).filter(function(s){return s.grade>=55;}).sort(function(a,b){return b.grade-a.grade;});
          if(topGrades.length===0) return null;
          var pos = user.position || "player";
          var topNames = topGrades.slice(0,2).map(function(s){return String(s.label||"tool").toLowerCase()+" ("+s.grade+")";}).join(" and ");
          snapshot = "Latest BBOT evaluation highlights "+topNames+" as standout tools for this "+pos+".";
        }
        return (
          <Card style={{marginBottom:10,padding:14,borderLeft:"3px solid "+C.coral,background:"linear-gradient(135deg,#fff,"+C.coralFaint+")"}}>
            <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:10,color:C.coral,letterSpacing:1.2,marginBottom:6,fontWeight:700}}>BBOT SNAPSHOT</div>
            <p style={{fontSize:13,color:C.gray700,lineHeight:1.6,margin:0}}>{snapshot}</p>
            {latestEval.date && <div style={{fontSize:10,color:C.gray400,marginTop:8,fontStyle:"italic"}}>Based on {latestEval.sessionType||"recent eval"} · {latestEval.date}</div>}
          </Card>
        );
      })()}

      {/* PROGRESSION HERO — the moat. No showcase shows a player improving over time. BBOT owns the timeline.
          Tracks average graded-tool value across evals (composite score retired). */}
      {profileTab==="overview" && user.type==="player" && !editing && (function(){
        var avgGrade = function(r){
          var gs = (r.sections||[]).map(function(s){return s.grade;}).filter(function(g){return g!=null;});
          if(!gs.length) return null;
          return Math.round(gs.reduce(function(a,b){return a+b;},0)/gs.length);
        };
        var approved = (uSR||[]).filter(function(r){return (isLiveEval(r)) && avgGrade(r)!=null;}).sort(function(a,b){return (a.date||"").localeCompare(b.date||"");});
        if(approved.length < 2) return null;
        var first = approved[0], last = approved[approved.length-1];
        var firstV = avgGrade(first), lastV = avgGrade(last);
        var delta = lastV - firstV;
        var spanMonths = (function(){
          try{
            var d1=new Date(first.date), d2=new Date(last.date);
            var m = (d2.getFullYear()-d1.getFullYear())*12 + (d2.getMonth()-d1.getMonth());
            return m;
          }catch(e){return null;}
        })();
        var scores = approved.map(avgGrade);
        var mn = Math.min.apply(null,scores), mx = Math.max.apply(null,scores);
        var range = mx-mn || 1;
        return (
          <Card style={{marginBottom:10,padding:16,background:"linear-gradient(135deg,"+C.navy+","+C.navyMid+")",border:"none"}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:10,flexWrap:"wrap",gap:8}}>
              <div>
                <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:11,color:C.coral,letterSpacing:1.2,fontWeight:700}}>PROGRESSION</div>
                <div style={{fontSize:11,color:"rgba(255,255,255,.6)",marginTop:2}}>{approved.length} evaluations{spanMonths!=null && spanMonths>0?" over "+spanMonths+" month"+(spanMonths===1?"":"s"):""}</div>
              </div>
              <div style={{textAlign:"right"}}>
                <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:26,fontWeight:700,color:delta>=0?C.coral:"#fca5a5",lineHeight:1}}>{delta>=0?"+":""}{delta}</div>
                <div style={{fontSize:9,color:"rgba(255,255,255,.5)",letterSpacing:.5}}>AVG TOOL GRADE</div>
              </div>
            </div>
            {/* VERTICAL BARS — one bar per evaluation over time */}
            <div style={{display:"flex",alignItems:"flex-end",justifyContent:"space-between",gap:4,height:96,marginTop:6}}>
              {approved.map(function(r,i){
                var v=scores[i];
                var h=Math.max(6,Math.round(((v-mn)/range)*72)+12);
                var isLast=i===approved.length-1;
                return <div key={i} style={{flex:1,display:"flex",flexDirection:"column",alignItems:"center",minWidth:0}}>
                  <div style={{fontSize:12,fontWeight:700,color:isLast?C.coral:"rgba(255,255,255,.85)",marginBottom:3,fontFamily:"Inter,system-ui,sans-serif"}}>{v}</div>
                  <div style={{width:"100%",maxWidth:30,height:h+"px",background:isLast?C.coral:"rgba(255,255,255,.35)",borderRadius:"3px 3px 0 0"}}/>
                  <div style={{fontSize:9,color:"rgba(255,255,255,.6)",marginTop:4,whiteSpace:"nowrap"}}>{(r.date||"").slice(5)}</div>
                </div>;
              })}
            </div>
          </Card>
        );
      })()}

      {/* DATA CONSISTENCY — only when 2+ evals; surfaces trustworthiness over time */}
      {profileTab==="overview" && user.type==="player" && !editing && (function(){
        var approved = (uSR||[]).filter(function(r){return isLiveEval(r);});
        if(approved.length < 2) return null;
        // Check velocity consistency: look at EV peak across all evals via batted balls
        var pBB = (battedBalls||[]).filter(function(b){return String(b.playerId)===String(user.id) && b.exitVelo;});
        var evReadings = pBB.map(function(b){return Number(b.exitVelo);}).filter(function(n){return !isNaN(n);});
        var peakSpread = evReadings.length>=3 ? Math.max.apply(null,evReadings) - Math.min.apply(null,evReadings) : null;
        // A wildly inconsistent peak (>20mph spread across sessions) is suspicious
        var consistent = peakSpread === null || peakSpread <= 18;
        return (
          <Card style={{marginBottom:10,padding:12,borderLeft:"3px solid "+(consistent?C.green:C.orange)}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",gap:8,flexWrap:"wrap"}}>
              <div style={{flex:"1 1 200px"}}>
                <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:10,color:consistent?C.green:C.orange,letterSpacing:1.2,marginBottom:4,fontWeight:700}}>DATA CONSISTENCY</div>
                <div style={{fontSize:11,color:C.gray600,lineHeight:1.5}}>
                  {consistent
                    ? approved.length+" evals on file. Metrics align across sessions — trustworthy data over time."
                    : approved.length+" evals on file. Variability detected across sessions — review individual reports for context."}
                </div>
              </div>
              {peakSpread !== null && <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:14,color:consistent?C.green:C.orange,fontWeight:700,whiteSpace:"nowrap"}}>±{Math.round(peakSpread/2)}mph<div style={{fontSize:8,color:C.gray400,fontWeight:400,letterSpacing:.4}}>EV variance</div></div>}
            </div>
          </Card>
        );
      })()}

      {profileTab==="overview"&&isOwn&&user.type==="coach"&&(
        <Card style={{marginTop:12,padding:"10px 14px"}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",gap:10}}>
            <div>
              <div style={{fontWeight:700,fontSize:12,color:C.gray900,marginBottom:1}}>Player Messages</div>
              <div style={{fontSize:11,color:C.gray500,lineHeight:1.4}}>{user.acceptsMessages===false?"Not accepting player messages.":"Eligible players can message you."}</div>
            </div>
            <button onClick={function(){
              var next = !(user.acceptsMessages===false) ? false : true; // toggle (default true → false)
              var updated = Object.assign({}, user, {acceptsMessages: next});
              if(setUsers) setUsers(function(prev){return (prev||[]).map(function(u){return String(u.id)===String(user.id)?updated:u;});});
              if(setCu && isOwn) setCu(updated);
              persistUser(updated).then(function(){notify(next?"Now accepting player messages":"Opted out of player messages");}).catch(function(){notify("Could not save setting — try again","error");});
            }} style={{flexShrink:0,width:40,height:23,borderRadius:99,border:"none",cursor:"pointer",background:user.acceptsMessages===false?C.gray300:C.green,position:"relative",transition:"background .15s"}}>
              <span style={{position:"absolute",top:2.5,left:user.acceptsMessages===false?2.5:19.5,width:18,height:18,borderRadius:"50%",background:C.white,transition:"left .15s"}}/>
            </button>
          </div>
        </Card>
      )}{profileTab==="overview"&&user.type==="player"&&(<Card style={{marginTop:12,padding:20}}>{editing?(<div><div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:11,color:C.coral,letterSpacing:1.2,marginBottom:8,paddingBottom:6,borderBottom:"1px solid "+C.gray100}}>BASIC INFO</div><div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(180px,1fr))",gap:12,marginBottom:18}}><FieldInput label="First Name" value={form.firstName} onChange={function(e){setF("firstName",e.target.value);}}/><FieldInput label="Last Name" value={form.lastName} onChange={function(e){setF("lastName",e.target.value);}}/><FieldInput label="Grad Year" value={form.gradYear} onChange={function(e){setF("gradYear",e.target.value);}}/><div><div style={{fontSize:11,color:C.gray500,fontWeight:600,marginBottom:4,letterSpacing:.5}}>DATE OF BIRTH</div><input type="date" value={form.dob||""} max={new Date().toISOString().slice(0,10)} onChange={function(e){setF("dob",e.target.value);}} style={{width:"100%",padding:"8px 10px",border:"1px solid "+C.border,borderRadius:6,fontSize:13,background:C.white,boxSizing:"border-box"}}/></div><FieldInput label="GPA" value={form.gpa||""} onChange={function(e){setF("gpa",e.target.value);}}/></div><div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:11,color:C.coral,letterSpacing:1.2,marginBottom:8,paddingBottom:6,borderBottom:"1px solid "+C.gray100}}>POSITION & PHYSICAL</div><div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(180px,1fr))",gap:12,marginBottom:18}}><div><div style={{fontSize:11,color:C.gray500,fontWeight:600,marginBottom:4,letterSpacing:.5}}>PRIMARY POS</div><select value={form.position||""} onChange={function(e){setF("position",e.target.value);}} style={{width:"100%",padding:"8px 10px",border:"1px solid "+C.border,borderRadius:6,fontSize:13,background:C.white}}><option value="">Select</option><option value="P">P</option><option value="RHP">RHP</option><option value="LHP">LHP</option><option value="C">C</option><option value="1B">1B</option><option value="2B">2B</option><option value="3B">3B</option><option value="SS">SS</option><option value="LF">LF</option><option value="CF">CF</option><option value="RF">RF</option><option value="OF">OF</option><option value="UTL">UTL</option><option value="DH">DH</option></select></div><div><div style={{fontSize:11,color:C.gray500,fontWeight:600,marginBottom:4,letterSpacing:.5}}>SECONDARY POS</div><select value={form.position2||""} onChange={function(e){setF("position2",e.target.value);}} style={{width:"100%",padding:"8px 10px",border:"1px solid "+C.border,borderRadius:6,fontSize:13,background:C.white}}><option value="">None</option><option value="P">P</option><option value="RHP">RHP</option><option value="LHP">LHP</option><option value="C">C</option><option value="1B">1B</option><option value="2B">2B</option><option value="3B">3B</option><option value="SS">SS</option><option value="LF">LF</option><option value="CF">CF</option><option value="RF">RF</option><option value="OF">OF</option><option value="UTL">UTL</option><option value="DH">DH</option></select></div><div>{(function(){var P=(form.position||"").toUpperCase();var P2=(form.position2||"").toUpperCase();var pitchInvolved=["P","RHP","LHP"].some(function(x){return P===x||P2===x;});var nonPitch=function(x){return x&&!["P","RHP","LHP"].includes(x);};var hasBoth=pitchInvolved&&(nonPitch(P)||nonPitch(P2));return (<div><div style={{fontSize:11,color:C.gray500,fontWeight:600,marginBottom:4,letterSpacing:.5}}>TWO-WAY PLAYER {pitchInvolved&&<span style={{color:C.coral}}>*</span>}</div><label style={{display:"flex",alignItems:"center",gap:8,padding:"8px 10px",border:"1px solid "+(form.twoWay?C.coral:C.border),borderRadius:6,fontSize:13,background:form.twoWay?C.coralFaint:C.white,cursor:"pointer"}}><input type="checkbox" checked={!!form.twoWay} onChange={function(e){setF("twoWay",e.target.checked);}} style={{width:16,height:16,accentColor:C.coral}}/><span style={{color:C.gray700}}>Pitches AND hits</span></label>{pitchInvolved&&<div style={{fontSize:10,color:C.gray500,marginTop:4,lineHeight:1.4}}>Confirm if this player both pitches and plays a position — BBOT will generate one combined report (spray + pitch charts).</div>}</div>);})()}</div><div><div style={{fontSize:11,color:C.gray500,fontWeight:600,marginBottom:4,letterSpacing:.5}}>HEIGHT *</div><select value={form.height||""} onChange={function(e){var v=e.target.value;setF("height",v);setF("heightInches",heightToInches(v));}} style={{width:"100%",padding:"8px 10px",border:"1px solid "+C.border,borderRadius:6,fontSize:13,background:C.white}}><option value="">Select</option>{HEIGHTS.map(function(h){return <option key={h} value={h}>{h}</option>;})}</select></div><FieldInput label="Weight (lbs)" value={form.weight||""} onChange={function(e){setF("weight",e.target.value);}}/><FieldInput label="Jersey #" value={form.jerseyNum||""} onChange={function(e){setF("jerseyNum",e.target.value);}}/><div><div style={{fontSize:11,color:C.gray500,fontWeight:600,marginBottom:4,letterSpacing:.5}}>BATS *</div><select value={form.bats||""} onChange={function(e){setF("bats",e.target.value);}} style={{width:"100%",padding:"8px 10px",border:"1px solid "+C.border,borderRadius:6,fontSize:13,background:C.white}}><option value="">Select</option><option value="R">Right</option><option value="L">Left</option><option value="S">Switch</option></select></div><div><div style={{fontSize:11,color:C.gray500,fontWeight:600,marginBottom:4,letterSpacing:.5}}>THROWS *</div><select value={form.throws||""} onChange={function(e){setF("throws",e.target.value);}} style={{width:"100%",padding:"8px 10px",border:"1px solid "+C.border,borderRadius:6,fontSize:13,background:C.white}}><option value="">Select</option><option value="R">Right</option><option value="L">Left</option></select></div></div><div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:11,color:C.coral,letterSpacing:1.2,marginBottom:8,paddingBottom:6,borderBottom:"1px solid "+C.gray100}}>SCHOOL & TEAM</div><div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(180px,1fr))",gap:12}}><OrgInput label="HIGH SCHOOL" value={form.hsName} onChange={function(v){setF("hsName",v);}} placeholder="Search or add high school..."/><OrgInput label="CLUB / TRAVEL TEAM" value={form.clubName||""} onChange={function(v){setF("clubName",v);}} placeholder="Search or add club..."/></div><div style={{marginTop:16,display:"flex",gap:10}}><Btn v="primary" onClick={save}>Save</Btn><Btn v="ghost" onClick={function(){setEditing(false);}}>Cancel</Btn></div></div>):(<div style={{display:"flex",flexDirection:"column",gap:8}}>{user.bio&&<p style={{fontSize:14,color:C.gray600,lineHeight:1.8,margin:0}}>{user.bio}</p>}{!user.bio&&isOwn&&<p style={{fontSize:13,color:C.gray400,fontStyle:"italic",margin:0}}>Add a bio to introduce yourself.</p>}{user.type==="player"&&<div style={{display:"flex",flexWrap:"wrap",gap:8}}>{user.hsName&&<span style={{fontSize:12,background:C.blueFaint,color:C.blue,padding:"3px 10px",borderRadius:99}}>{user.hsName}</span>}{user.clubName&&<span style={{fontSize:12,background:C.blueFaint,color:C.blue,padding:"3px 10px",borderRadius:99}}>{user.clubName}</span>}{user.gradYear&&<span style={{fontSize:12,background:C.blueFaint,color:C.blue,padding:"3px 10px",borderRadius:99}}>{"Class "+user.gradYear}</span>}{(user.bats||user.throws)&&<span style={{fontSize:12,background:C.blueFaint,color:C.blue,padding:"3px 10px",borderRadius:99}}>B/T: {user.bats||"-"}/{user.throws||"-"}</span>}</div>}</div>)}</Card>)}

      {profileTab==="compare"&&(user.type==="coach"||user.type==="staff")&&(isOwn||bbotIsAdmin(cu))&&(
        <CompareView users={users||[]} scoutReports={scoutReports||[]} metrics={metrics||{}}/>
      )}
      {profileTab==="clips"&&user.type==="player"&&<PlayerClipsView userId={user.id} playerName={user.firstName+" "+user.lastName} dob={user.dob} gradYear={user.gradYear} ageBracket={ageBracket} isAdmin={isStaffViewer} cu={cu} notify={notify} scoutReports={scoutReports} setScoutReports={setScoutReports}/>}
      {profileTab==="evaluations"&&user.type==="player"&&(function(){
        var approvedSessions = (uSR||[]).filter(function(r){return (isLiveEval(r)) && !r.reportType && r.sections;});
        var hasPlayerEval = (uSR||[]).some(function(r){return r.reportType==="player_eval";});
        if(hasPlayerEval) return null;
        // CUMULATIVE IS ADMIN-TRIGGERED, SO IT IS ADMIN-VISIBLE. This card offered a player a
        // product they cannot buy and cannot start -- the run is admin-only, and the landing page
        // no longer sells it either. Showing the offer to the one person who cannot act on it is
        // the same defect as the landing card, one surface further in.
        if(!isStaffViewer) return null;
        var enough = approvedSessions.length >= 2;
        return <Card style={{padding:16,marginBottom:10,background:"linear-gradient(135deg,"+C.coral+",#d94f63)",border:"none"}}>
          <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:12,color:C.white,letterSpacing:1.2,fontWeight:700,marginBottom:6}}>PLAYER EVALUATION</div>
          <div style={{fontSize:13,color:"rgba(255,255,255,.92)",lineHeight:1.55,marginBottom:10}}>A cumulative read — recency-weighted per-tool grades, progression trend, and a QR-linked highlight reel.{approvedSessions.length>0?" Compiles your "+approvedSessions.length+" session"+(approvedSessions.length===1?"":"s")+".":""}</div>
          <div style={{fontSize:11,color:"rgba(255,255,255,.92)",lineHeight:1.5,marginBottom:12,padding:"8px 10px",background:"rgba(255,255,255,.15)",borderRadius:6}}>
            {enough
              ? "The more sessions on file, the richer the trajectory read."
              : "This works best with 2+ session evaluations on file, or one video that clearly shows every tool (hitting, fielding, throwing, running). With fewer, it reads from more limited data."}
          </div>
          {isOwn && <Btn v="outline" style={{fontSize:13,padding:"10px 20px",background:C.white,color:C.coral,border:"none"}} onClick={function(){
            reportSave({player_id:String(user.id),session_type:"Player Evaluation",status:"pending_payment",report_type:"player_eval",score:null})
            .then(function(j){
              var rid = j && j.id;
              if(!rid){ notify&&notify("Could not start — try again","error"); return; }
              startCheckout({id:rid,playerId:user.id,reportType:"player_eval",sessionType:"Player Evaluation"}, user);
            }).catch(function(){ notify&&notify("Could not start payment","error"); });
          }}>Get Player Evaluation · ${BBOT_PRICE_PLAYER_USD.toFixed(2)}</Btn>}
        </Card>;
      })()}
      {profileTab==="evaluations"&&user.type==="player"&&(function(){
        // Staff/coach-triggered evaluations awaiting the player's payment.
        // STATUS NAMING (intentional, do not unify): a report awaiting payment uses
        //   "awaiting_payment" when staff/coach triggered it on the player's behalf, and
        //   "pending_payment" when the player started a self-upload (handled in-flow on the
        //   upload page, not here). The backend treats both as equivalent payment-pending
        //   states; the FE keeps them separate so each flow's UI doesn't show the other's.
        // Only the player (isOwn) sees the pay prompt; nothing was generated yet.
        var awaiting = (uSR||[]).filter(function(r){return isAwaitingPayment(r);});
        var isAdminViewer = cu && bbotIsAdmin(cu);
        if((isOwn||isAdminViewer) && awaiting.length>0){
          return <div style={{marginBottom:14}}>
            {awaiting.map(function(r, idx){
              var amt = (r.reportType==="player_eval") ? BBOT_PRICE_PLAYER_USD : BBOT_PRICE_SESSION_USD;
              var vsrc = (r.fullReport&&r.fullReport.videoSource)||"bbot_recorded";
              return (
              <Card key={r.id} style={{padding:16,marginBottom:10,border:"2px solid "+C.coral}}>
                <div style={{fontSize:10,letterSpacing:1,color:C.coral,fontWeight:700,marginBottom:4}}>EVALUATION READY TO UNLOCK</div>
                <div style={{fontSize:14,fontWeight:700,color:C.navy,marginBottom:2}}>{r.sessionType||"Session"} · {r.date||r.sessionDate||""}</div>
                <div style={{fontSize:11.5,color:C.gray500,lineHeight:1.5,marginBottom:10}}>{(r.staffName?r.staffName+" requested this evaluation. ":"")}Pay to have BBOT generate your report — every eval is reviewed by 643 before it's released to your profile.</div>
                <div style={{fontSize:11,color:C.gray600,lineHeight:1.5,marginBottom:12,padding:"8px 10px",background:C.gray50,borderRadius:6,border:"1px solid "+C.gray100}}>
                  <strong style={{color:C.navy}}>Pay now.</strong> Your report is on your profile within a day.
                </div>
                {isAdminViewer ? (
                  <AdminOffsitePaidButton report={r} amountUSD={amt} notify={notify}/>
                ) : (
                  // ONE SURFACE AGAIN. The card-checkout branch and the "pay by card instead"
                  // escape hatch are both gone; AthMovilButton resolves live-vs-coming-soon.
                  <AthMovilButton reportId={r.id} amountUSD={amt} playerId={user.id}
                    videoSource={vsrc} label="Pay with ATH Móvil" notify={notify}/>
                )}
              </Card>
            );})}
          </div>;
        }
        return null;
      })()}
      {profileTab==="evaluations"&&user.type==="player"&&(function(){
        var bracketSessions = (uSR||[]).filter(function(r){
          return !r.reportType && (r.sections&&r.sections.length) && (isLiveEval(r)||isDraftEval(r));
        });
        var playerEvals = (uSR||[]).filter(function(r){return r.reportType==="player_eval" && (r.fullReport&&r.fullReport.tools);});
        // Reports that have been PAID and are mid-flight: generating, generated and
        // awaiting admin release ("ready"), or errored. These don't yet have visible
        // sections/tools, so without this they'd silently vanish from the player's view.
        var inFlight = (uSR||[]).filter(function(r){
          return isJobReady(r) || r.status==="generating" || r.status==="processing" || r.status==="error";
        });
        // For a specific age bracket, show that bracket's cumulative eval if one exists; on Career, show all cumulative evals.
        var shownPlayerEvals = ageBracket==="career" ? playerEvals : filterByAge(playerEvals,"sessionDate");
        var nothing = bracketSessions.length===0 && shownPlayerEvals.length===0 && inFlight.length===0;
        if(nothing){
          return <EmptyCard icon="E" title={ageBracket==="career"?"No Evaluations Yet":"No "+ageBracket+" Evaluations"} sub={isOwn?"Upload a session video to get your first BBOT evaluation":"BBOT evaluations will appear here once generated"} action={isOwn?"Upload Video":null} onAction={isOwn?function(){go("upload-video");}:null}/>;
        }
        return <div style={{display:"flex",flexDirection:"column",gap:10}}>
          {/* In-flight reports: paid, generating or awaiting release */}
          {inFlight.slice().reverse().map(function(r){
            var isErr = r.status==="error";
            var label = isErr ? "Evaluation failed" : (isJobReady(r) ? "In final review" : "Generating your evaluation");
            var sub = isErr
              ? "Something went wrong on our end. This is eligible for a refund — contact 643 and we'll make it right."
              : (isJobReady(r)
                  ? "BBOT finished your report — 643 is reviewing it for accuracy before it's released. You'll be notified the moment it's live."
                  : "BBOT is analyzing your session. You can leave this page — we'll notify you when it's ready.");
            // 4-step status tracker. The "current" step is the first one not yet completed.
            // Paid (always done if we're here) -> Processed (BBOT done = status ready) ->
            // In Review (643 checking) -> Released (approved; report leaves in-flight then).
            var stepIndex = (isJobReady(r)) ? 2 : 1; // generating/processing = at step 1 (Processed in progress)
            var steps = ["Paid","Processed","In review","Released"];
            return (
              <Card key={r.id} style={{padding:16}}>
                <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:isErr?0:16}}>
                  {isErr
                    ? <div style={{width:34,height:34,borderRadius:"50%",background:"#fee2e2",color:"#dc2626",display:"flex",alignItems:"center",justifyContent:"center",fontSize:18,fontWeight:700,flexShrink:0}}>!</div>
                    : <div style={{width:34,height:34,border:"3px solid "+C.gray200,borderTopColor:C.coral,borderRadius:"50%",animation:"spin 0.8s linear infinite",flexShrink:0}}/>}
                  <div style={{flex:1,minWidth:0}}>
                    <div style={{fontSize:13,fontWeight:700,color:isErr?"#dc2626":C.navy,marginBottom:2}}>{label}</div>
                    <div style={{fontSize:11,color:C.gray500,lineHeight:1.5}}>{sub}</div>
                  </div>
                </div>
                {!isErr && (
                  <div style={{display:"flex",alignItems:"center",gap:0}}>
                    {steps.map(function(st, i){
                      var done = i < stepIndex;       // completed
                      var current = i === stepIndex;  // in progress now
                      var dotColor = done ? C.coral : (current ? C.coral : C.gray200);
                      var ringStyle = current ? {boxShadow:"0 0 0 3px rgba(232,82,106,.2)"} : {};
                      return (
                        <div key={st} style={{display:"flex",alignItems:"center",flex:i<steps.length-1?1:"0 0 auto"}}>
                          <div style={{display:"flex",flexDirection:"column",alignItems:"center",gap:5,flexShrink:0,width:62}}>
                            <div style={Object.assign({width:18,height:18,borderRadius:"50%",background:dotColor,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,transition:"all .3s"},ringStyle)}>
                              {done && <span style={{color:C.white,fontSize:11,fontWeight:700,lineHeight:1}}>✓</span>}
                            </div>
                            <span style={{fontSize:9.5,fontWeight:(done||current)?700:500,color:(done||current)?C.navy:C.gray400,letterSpacing:.2,textAlign:"center",lineHeight:1.2}}>{st}</span>
                          </div>
                          {i < steps.length-1 && <div style={{flex:1,height:2,background:i<stepIndex?C.coral:C.gray200,marginTop:-16,transition:"background .3s"}}/>}
                        </div>
                      );
                    })}
                  </div>
                )}
              </Card>
            );
          })}
          {shownPlayerEvals.slice().reverse().map(function(r){return <ReportCard key={r.id} r={r} sc={user} isAdmin={isStaffViewer}/>;})}
          {shownPlayerEvals.length>0 && bracketSessions.length>0 && <div style={{fontSize:10,color:C.gray400,letterSpacing:1,fontWeight:600,margin:"6px 0 0"}}>SESSION EVALUATIONS{ageBracket!=="career"?" · "+ageBracket:""}</div>}
          {bracketSessions.slice().reverse().map(function(r){return <ReportCard key={r.id} r={r} sc={user} isDraft={isDraftEval(r)} isAdmin={isStaffViewer}/>;})}
        </div>;
      })()}

      {profileTab==="performance"&&user.type==="player"&&(
        <div style={{display:"flex",gap:18,alignItems:"flex-start",flexWrap:"wrap"}}>
        <div style={{flex:"1 1 420px",minWidth:0,display:"flex",flexDirection:"column",gap:18}}>
          <MetricsView uM={filteredM}/>
          {/* Tool grade progression — when player has 2+ evals — VERTICAL BARS, grouped by session, never green */}
          {(function(){
            var approvedEvals = (uSR||[]).filter(function(r){return isLiveEval(r);}).sort(function(a,b){return (a.date||"").localeCompare(b.date||"");});
            if(approvedEvals.length < 1) return null;   // show graded tools even for a single session (was 2+, which left 1-session profiles with no graph)
            var allToolKeys = ["hit","power","run","arm","field"];
            var toolLabels = {hit:"Hit", power:"Power", run:"Run", arm:"Arm", field:"Field"};
            // For each session: { date, grades: {...} } — only tools that carry an actual grade.
            var bySessionAll = approvedEvals.map(function(r){
              var grades = {};
              allToolKeys.forEach(function(k){
                var sec = (r.sections||[]).find(function(s){return (s.key||"").toLowerCase()===k;});
                grades[k] = (sec && sec.grade!=null) ? sec.grade : null;
              });
              return {date:r.date||"", grades:grades};
            });
            // Benchmarked-only: keep tools that have a grade in at least one session. Observation-only
            // tools (no number) are excluded from the progression chart entirely.
            var toolKeys = allToolKeys.filter(function(k){ return bySessionAll.some(function(s){return s.grades[k]!=null;}); });
            if(!toolKeys.length) return null;
            var bySession = bySessionAll;
            var anyData = true;
            // Bar colors per tool — NEVER green (locked design rule)
            var colors = {hit:C.blue, power:C.coral, run:C.orange, arm:C.navy, field:"#7c5fc7"};
            var H = 220, padT = 18, padB = 50, padL = 38, padR = 12;
            var sessionCount = bySession.length;
            var GAP_SLOTS = 1.5;
            var slotsPerSession = toolKeys.length + GAP_SLOTS;
            var totalSlots = sessionCount * slotsPerSession;
            return (
              <div>
                <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:13,color:C.navy,letterSpacing:1,marginBottom:10}}>TOOL PROGRESSION <span style={{fontSize:10,color:C.gray400,fontWeight:400,letterSpacing:.3}}>· {approvedEvals.length} evals · graded tools only · no peer group stands behind these numbers</span></div>
                <Card style={{padding:12,overflow:"hidden"}}>
                  {(function(){
                    var W = Math.max(560, Math.round(totalSlots * 26) + padL + padR);
                    var plotW = W - padL - padR;
                    var plotH = H - padT - padB;
                    var slotW = plotW / totalSlots;
                    var barW = Math.max(6, slotW * 0.85);
                    return (
                      <svg viewBox={"0 0 "+W+" "+H} style={{width:"100%",height:"auto",display:"block"}}>
                        {/* Y-axis gridlines and labels: 20-80 in 10s — core blue, larger */}
                        {[20,30,40,50,60,70,80].map(function(g){
                          var y = padT + (1 - (g-20)/60) * plotH;
                          return (
                            <g key={g}>
                              <line x1={padL} y1={y} x2={W-padR} y2={y} stroke="#e5e7eb" strokeWidth="0.5"/>
                              <text x={padL-6} y={y+4} fontSize="12" fontWeight="700" fill={C.blue} textAnchor="end">{g}</text>
                            </g>
                          );
                        })}
                        {/* Bars: each session = cluster of graded tools, separated by a gap slot */}
                        {bySession.map(function(s,si){
                          var groupX = padL + si * slotsPerSession * slotW;
                          return (
                            <g key={si}>
                              {toolKeys.map(function(k,ti){
                                var g = s.grades[k];
                                if(g==null) return null;
                                var x = groupX + ti * slotW + (slotW-barW)/2;
                                var barHeight = ((g-20)/60) * plotH;
                                var y = padT + plotH - barHeight;
                                return <rect key={k} x={x} y={y} width={barW} height={Math.max(1,barHeight)} fill={colors[k]} rx="1"/>;
                              })}
                              {/* X-axis session date label (centered under the cluster) — core blue, larger */}
                              <text x={groupX + (toolKeys.length*slotW)/2} y={H-padB+18} fontSize="11" fill={C.blue} textAnchor="middle" fontWeight="700">{(s.date||"").slice(5)}</text>
                              <text x={groupX + (toolKeys.length*slotW)/2} y={H-padB+30} fontSize="9" fill="#94a3b8" textAnchor="middle">{(s.date||"").slice(0,4)}</text>
                            </g>
                          );
                        })}
                      </svg>
                    );
                  })()}
                  <div style={{display:"flex",gap:12,flexWrap:"wrap",justifyContent:"center",marginTop:6,fontSize:10}}>
                    {toolKeys.map(function(k){return (
                      <div key={k} style={{display:"flex",alignItems:"center",gap:5,color:C.gray700}}>
                        <span style={{width:11,height:11,background:colors[k],borderRadius:2}}/>{toolLabels[k]}
                      </div>
                    );})}
                  </div>
                </Card>
              </div>
            );
          })()}
          <PlayerCharts userId={user.id} playerName={user.firstName+" "+user.lastName} position={user.position} twoWay={user.twoWay} battedBalls={battedBalls||[]} pitches={(typeof window!=="undefined"?window.__bbotPitches:null)||[]} scoutReports={scoutReports||[]}/>
          {/* Age-cohort percentile removed — composite player score was retired in favor of per-tool grades */}
          {/* Latest motion analysis from most recent BBOT eval */}
          {(function(){
            var latestEval = (uSR||[]).slice().reverse().find(function(r){return r.motionAnalysis;});
            if(!latestEval) return null;
            return (
              <div>
                <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:13,color:C.navy,letterSpacing:1,marginBottom:10}}>MOTION ANALYSIS <span style={{fontSize:10,color:C.gray400,fontWeight:400,letterSpacing:.3}}>· Latest from {latestEval.date||"recent eval"}</span></div>
                <MotionAnalysisCard analysis={latestEval.motionAnalysis}/>
              </div>
            );
          })()}
        </div>
        <div style={{flex:"1 1 280px",minWidth:0,maxWidth:380}}>
          <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:13,color:C.navy,letterSpacing:1,marginBottom:10}}>ACTIVITY</div>
          <YourActivityPage feed={feed} setFeed={setFeed} users={users} cu={cu} go={go} profileUser={user} isOwn={isOwn} embedded={true}/>
        </div>
        </div>
      )}

      {profileTab==="recaps"&&user.type==="player"&&((recaps||[]).filter(function(r){return isPublishedRecap(r)&&r.taggedPlayers&&r.taggedPlayers.some(function(j){return String(j)===String(user.id);});}).length===0?<EmptyCard icon="bbot" title="No Session Reports" sub="Published session reports will appear here"/>:<div style={{display:"flex",flexDirection:"column",gap:10}}>{(recaps||[]).filter(function(r){return isPublishedRecap(r)&&r.taggedPlayers&&r.taggedPlayers.some(function(j){return String(j)===String(user.id);});}).map(function(r){return <RecapCard key={r.id} r={r} users={users} cu={cu}/>;})}</div>)}

      {profileTab==="notes"&&user.type==="player"&&isStaffViewer&&<div style={{padding:"12px 0",fontSize:13,color:C.gray500}}>{"Staff notes will appear here."}</div>}

    </div>
  );
}
function GradeBar({grade}){
  if(!grade) return null;
  var w=Math.max(0,Math.min(100,grade/80*100));
  var col=grade>=60?C.blue:grade>=45?C.orange:C.coral;
  return(
    <div style={{width:"100%",height:5,background:C.border,borderRadius:99,overflow:"hidden"}}>
      <div style={{width:w+"%",height:"100%",background:col,borderRadius:99}}/>
    </div>
  );
}

function AdminReportControls({report, player}) {
  var savingS = useState(false); var saving = savingS[0], setSaving = savingS[1];
  var srBusyS = useState(false); var srBusy = srBusyS[0], setSrBusy = srBusyS[1];
  var srResultS = useState(null); var srResult = srResultS[0], setSrResult = srResultS[1];
  var srCorrS = useState(null); var srCorr = srCorrS[0], setSrCorr = srCorrS[1];
  var srCorrBusyS = useState(false); var srCorrBusy = srCorrBusyS[0], setSrCorrBusy = srCorrBusyS[1];
  var clipBusyS = useState(false); var clipBusy = clipBusyS[0], setClipBusy = clipBusyS[1];

  // Admin: turn THIS eval's video into a rinsed + stamped (BBOT + 643 lockup) clip on the player's
  // profile. Reuses /generate-clips-from-report (cuts the master, brands it, registers a pending_approval
  // bbot_clips row). Admin decides per eval; the clip still needs a second approval under Clips before it
  // publishes. Idempotent (per player/clip_type/date) so a re-click won't duplicate.
  function doRinseClip(){
    setClipBusy(true);
    fetch(BACKEND_URL+"/generate-clips-from-report", {
      method:"POST", headers:bbotAdminHeaders(),
      body: JSON.stringify({ reportId: report.id })
    }).then(function(r){ if(!r.ok) return r.text().then(function(t){throw new Error(t||("HTTP "+r.status));}); return r.json(); })
      .then(function(d){
        setClipBusy(false);
        var n = (d && d.result && d.result.clipsCreated) || 0;
        var skel = d && d.skeletonAdded;
        if(window.__bbotNotify) window.__bbotNotify(
          n>0 ? ("✓ Rinsed clip"+(skel?" + skeleton motion clip":"")+" added to profile — review + approve under the player's Clips tab.")
              : ("No clip produced — "+((d && d.detail) || "the eval had no usable video windows.")),
          n>0 ? "success" : "error");
      })
      .catch(function(err){ setClipBusy(false); if(window.__bbotNotify) window.__bbotNotify("Clip generation failed: "+((err&&err.message)||"error"),"error"); });
  }

  function runSelfReview(){
    setSrBusy(true); setSrResult(null);
    fetch(BACKEND_URL+"/self-review", {
      method:"POST", headers:bbotAdminHeaders(),
      body: JSON.stringify({ reportId:report.id, report:report })
    }).then(function(r){ if(!r.ok) return r.text().then(function(t){throw new Error(t||("HTTP "+r.status));}); return r.json(); })
      .then(function(out){ setSrResult(out); setSrBusy(false); })
      .catch(function(err){ setSrBusy(false); if(window.__bbotNotify) window.__bbotNotify("Audit failed: "+(err.message||"unknown"),"error"); });
  }

  // Patch one or more fields on this report, mutate in-place for instant UI reflect.
  function saveField(payload) {
    setSaving(true);
    bbotWrite("bbot_reports","update",Object.assign({},payload,{full_report:Object.assign({},report,payload)}),"id=eq." + Number(report.id)).then(function(r){
      setSaving(false);
      if(r.ok){ Object.assign(report,payload); if(window.__bbotNotify) window.__bbotNotify("Saved"); }
      else if(window.__bbotNotify) window.__bbotNotify("Save failed","error");
    }).catch(function(){ setSaving(false); if(window.__bbotNotify) window.__bbotNotify("Save error","error"); });
  }

  function handleSectionBlur(i, val){
    var s=(report.sections||[])[i];
    if(!s||val===s.text) return;
    var updated=(report.sections||[]).map(function(sec,j){ return j===i?Object.assign({},sec,{text:val}):sec; });
    saveField({sections:updated});
  }

  function doApproveAndRelease(){
    if(!window.__approveReport){ alert("Approve handler not wired"); return; }
    window.__approveReport(report.id);
    report.status="approved";
  }
  function doHold(){ if(window.__bbotNotify) window.__bbotNotify("Report held in queue"); }
  function doReeval(){
    if(!window.confirm("Send this report back for a full BBOT re-evaluation?\n\nThe current draft will be rejected. You can re-run BBOT from the Sessions panel.")) return;
    if(window.__rejectReport){ window.__rejectReport(report.id); report.status="rejected"; }
    if(window.__bbotNotify) window.__bbotNotify("Sent back for re-eval — run BBOT again from Sessions");
  }
  function doDelete(){
    if(!window.confirm("Permanently DELETE this report? Cannot be undone.")) return;
    if(!window.__deleteReport){ alert("Delete handler not wired"); return; }
    window.__deleteReport(report.id);
  }

  var isDraft=isDraftEval(report);
  return (
    <div onClick={function(e){e.stopPropagation();}}>
      {/* Inline edit fields — always open for draft reports; each field auto-saves on blur */}
      {isDraft&&(
        <div style={{borderTop:"1px solid "+C.border,marginTop:10,paddingTop:10}}>
          <div style={{fontSize:10,color:C.gray400,letterSpacing:1,marginBottom:8}}>
            EDIT{saving?" · saving…":""}<span style={{color:C.gray300,marginLeft:6}}>· click away to save each field</span>
          </div>
          <div style={{marginBottom:8}}>
            <label style={{fontSize:10,color:C.gray500,fontWeight:600,letterSpacing:.5,display:"block",marginBottom:3}}>SUMMARY</label>
            <textarea key={"sum-"+report.id} defaultValue={report.summary||""} onBlur={function(e){var v=e.target.value;if(v!==(report.summary||""))saveField({summary:v});}} rows={3} style={{width:"100%",padding:"6px 10px",border:"1px solid "+C.border,borderRadius:6,fontSize:12,fontFamily:"inherit",resize:"vertical",boxSizing:"border-box"}}/>
          </div>
          {(report.sections||[]).map(function(s,i){return(
            <div key={i} style={{display:"flex",gap:6,alignItems:"flex-start",marginBottom:6,flexWrap:"wrap"}}>
              <span style={{fontSize:11,fontWeight:700,color:C.navy,minWidth:90,paddingTop:5,flexShrink:0}}>{cleanToolLabel(s.label)}</span>
              <textarea key={"sec-"+report.id+"-"+i} defaultValue={s.text||""} onBlur={function(e){handleSectionBlur(i,e.target.value);}} rows={2} style={{flex:1,minWidth:180,padding:"4px 8px",border:"1px solid "+C.border,borderRadius:4,fontSize:11,fontFamily:"inherit",resize:"vertical",boxSizing:"border-box"}}/>
            </div>
          );})}
        </div>
      )}

      {/* Audit result */}
      {srResult&&(
        <div onClick={function(e){e.stopPropagation();}} style={{marginTop:10,padding:"10px 12px",borderRadius:8,border:"1px solid "+((srResult.flagCount>0)?C.coralLight:(C.green||"#16a34a")),background:(srResult.flagCount>0)?C.coralFaint:"#f0fdf4"}}>
          <div style={{fontSize:12,fontWeight:700,color:(srResult.flagCount>0)?C.coral:(C.green||"#16a34a"),marginBottom:4}}>
            {srResult.flagCount>0?("⚑ "+srResult.flagCount+" flag"+(srResult.flagCount===1?"":"s")+" — review before release"):"✓ No issues flagged"} <span style={{fontWeight:500,color:C.gray500}}>· confidence: {srResult.overallConfidence}{srResult.deep?" · deep":""}</span>
          </div>
          {srResult.summary&&<div style={{fontSize:11,color:C.gray700,marginBottom:srResult.flagCount?8:0,lineHeight:1.5}}>{srResult.summary}</div>}
          {(srResult.flags||[]).map(function(f,i){return(
            <div key={i} style={{padding:"6px 8px",background:C.white,borderRadius:6,marginBottom:5,borderLeft:"3px solid "+(f.severity==="high"?"#dc2626":(f.severity==="medium"?C.coral:C.gray300))}}>
              <div style={{fontSize:11,fontWeight:700,color:C.navy}}>{(f.toolKey||"?")} <span style={{fontSize:9,color:C.gray400,fontWeight:600}}>· {f.issue} · {f.severity}</span></div>
              <div style={{fontSize:11,color:C.gray700,marginTop:2,lineHeight:1.4}}>{f.detail}</div>
              {f.suggestedAction&&<div style={{fontSize:10,color:C.coral,marginTop:2}}>→ {f.suggestedAction}</div>}
            </div>
          );})}
          {(srResult.flags||[]).length>0&&(
            <div style={{marginTop:8}}>
              {!srCorr&&<button onClick={function(e){e.stopPropagation();setSrCorrBusy(true);fetch(BACKEND_URL+"/apply-audit-corrections",{method:"POST",headers:bbotAdminHeaders(),body:JSON.stringify({report:report,flags:srResult.flags})}).then(function(r){return r.json();}).then(function(d){setSrCorr(d);setSrCorrBusy(false);}).catch(function(){setSrCorrBusy(false);notify("Could not generate corrections","error");});}} disabled={srCorrBusy} style={{background:C.coral,color:C.white,border:"none",padding:"6px 12px",borderRadius:6,fontSize:11,fontWeight:700,cursor:srCorrBusy?"default":"pointer",letterSpacing:.4}}>{srCorrBusy?"BBOT CORRECTING…":"⚙ BBOT: APPLY CORRECTIONS"}</button>}
              {srCorr&&(
                <div style={{marginTop:6,padding:"8px 10px",background:C.white,borderRadius:6,border:"1px solid "+C.blueLight}}>
                  <div style={{fontSize:11,fontWeight:700,color:C.blue,marginBottom:4}}>BBOT PROPOSED CORRECTIONS</div>
                  {srCorr.summary&&<div style={{fontSize:11,color:C.gray700,marginBottom:6,lineHeight:1.5}}>{srCorr.summary}</div>}
                  {(srCorr.corrections||[]).map(function(c,i){return(<div key={i} style={{fontSize:10,color:C.gray700,marginBottom:3,lineHeight:1.4}}><strong>{c.toolKey}</strong> · {c.field}: <span style={{color:C.gray400}}>{String(c.from)}</span> → <span style={{color:C.coral,fontWeight:700}}>{String(c.to)}</span> <span style={{color:C.gray400}}>({c.reason})</span></div>);})}
                  {(srCorr.correctedSections||[]).length>0&&<button onClick={function(e){e.stopPropagation();if(!window.confirm("Apply these corrections to the report? You can still edit before release."))return;if(window.__bbotApplyCorrectedSections){window.__bbotApplyCorrectedSections(report.id,srCorr.correctedSections,srCorr.summary);notify("Corrections applied — review and release","success");setSrCorr(null);setSrResult(null);}}} style={{marginTop:6,background:C.navy,color:C.white,border:"none",padding:"5px 12px",borderRadius:6,fontSize:11,fontWeight:700,cursor:"pointer"}}>Apply to report</button>}
                </div>
              )}
            </div>
          )}
        </div>
      )}

      {/* COMPLETENESS GATE banner — pose/mechanics did not run for this session; approval is blocked. */}
      {(report.mechanicsIncomplete||(report.fullReport&&report.fullReport.mechanicsIncomplete))&&(
        <div style={{background:C.redLight||"#fef2f2",border:"1px solid "+(C.red||"#dc2626"),borderRadius:8,padding:"8px 12px",marginTop:10,fontSize:11,color:C.red||"#dc2626",lineHeight:1.45}}>
          <strong>⚠ Incomplete — pose did not run.</strong> Mechanics, box-plots, and the delivery floor are missing for this session. Re-eval with pose before approving.
        </div>
      )}
      {/* Action bar */}
      <div style={{display:"flex",gap:8,alignItems:"center",flexWrap:"wrap",borderTop:"1px solid "+C.border,paddingTop:10,marginTop:10}}>
        {isDraft&&(function(){var _inc=report.mechanicsIncomplete||(report.fullReport&&report.fullReport.mechanicsIncomplete);return <button disabled={_inc} onClick={function(e){e.stopPropagation();if(_inc)return;doApproveAndRelease();}} style={{background:_inc?(C.gray300||"#d1d5db"):(C.green||"#16a34a"),color:C.white,border:"none",padding:"8px 16px",borderRadius:6,fontSize:12,fontWeight:700,cursor:_inc?"not-allowed":"pointer",letterSpacing:.3,opacity:_inc?0.6:1}} title={_inc?"Report incomplete — pose did not run":""}>✓ Approve & Release</button>;})()}
        {isDraft&&<button onClick={function(e){e.stopPropagation();doHold();}} style={{background:C.white,color:C.navy,border:"1px solid "+C.navy,padding:"8px 14px",borderRadius:6,fontSize:12,fontWeight:600,cursor:"pointer"}}>Hold</button>}
        {isDraft&&<button onClick={function(e){e.stopPropagation();doReeval();}} style={{background:C.white,color:C.gray500,border:"1px solid "+C.border,padding:"8px 14px",borderRadius:6,fontSize:12,fontWeight:600,cursor:"pointer"}}>↺ Re-eval</button>}
        <button onClick={function(e){e.stopPropagation();doRinseClip();}} disabled={clipBusy} title="Rinse + stamp this session's video (BBOT + 643 lockup) and add it — with the skeleton motion clip — to the player's profile, pending approval." style={{background:clipBusy?C.gray300:C.coral,color:C.white,border:"none",padding:"8px 14px",borderRadius:6,fontSize:12,fontWeight:700,cursor:clipBusy?"default":"pointer",letterSpacing:.3,opacity:clipBusy?0.7:1}}>{clipBusy?"Rinsing…":"🎬 Rinse & add to profile"}</button>
        <div style={{marginLeft:"auto",display:"flex",gap:12,alignItems:"center"}}>
          <button onClick={function(e){e.stopPropagation();runSelfReview();}} disabled={srBusy} style={{background:"none",border:"none",fontSize:11,color:C.coral,cursor:srBusy?"default":"pointer",padding:0}}>{srBusy?"auditing…":"⚑ audit"}</button>
          <button onClick={function(e){e.stopPropagation();doDelete();}} style={{background:"none",border:"none",fontSize:11,color:C.gray400,cursor:"pointer",padding:0,textDecoration:"underline"}}>delete</button>
        </div>
      </div>
    </div>
  );
}

// Stripe Checkout integration — backend creates session, frontend redirects
function isReportUnlocked(reportId) {
  try {
    var unlocked = JSON.parse(localStorage.getItem("bbot_unlocked") || "{}");
    return !!unlocked[reportId];
  } catch(e) { return false; }
}

// Cross-device unlock check — releases the report if ANY unlock row exists for this report_id.
// Unlocks are now written SERVER-SIDE ONLY (signature-verified Stripe webhook / ATH-verified
// confirm / admin off-site override) and protected by RLS, so the mere EXISTENCE of a row is
// proof of a verified payment — it releases on every device regardless of which method paid.
// (Before #3 this matched only THIS device's row or buyer_device_id="offsite_admin", which
// never matched the webhook row — no buyer_device_id — or the ATH row, so Stripe/ATH purchases
// failed to release cross-device. report_id-existence fixes all three payment methods uniformly.)
function checkUnlockRemote(reportId) {
  var q = "?report_id=eq." + Number(reportId) + "&select=id&limit=1";
  return sbSelect("bbot_unlocks", q).then(function(rows){
    if(rows && rows.length > 0) {
      try {
        var unlocked = JSON.parse(localStorage.getItem("bbot_unlocked") || "{}");
        unlocked[reportId] = { paid: true, paidAt: new Date().toISOString(), source: "supabase" };
        localStorage.setItem("bbot_unlocked", JSON.stringify(unlocked));
      } catch(e) {}
      return true;
    }
    return false;
  }).catch(function(){ return false; });
}

// markReportUnlocked() was REMOVED (#2 webhook hardening): the client must NEVER write
// bbot_unlocks — that table is the backend's payment source of truth. Unlocks are written
// server-side ONLY (signature-verified Stripe webhook / ATH-verified confirm / admin override)
// and read back via checkUnlockRemote(). A spoofed ?bbot_paid= URL now grants nothing.

// ADMIN OFF-SITE PAYMENT OVERRIDE — the device-agnostic unlock for an off-site payment is now
// written SERVER-SIDE by POST /admin-mark-paid (#3): the client must never write bbot_unlocks
// (RLS blocks it). markReportPaidOffsite() was removed; AdminOffsitePaidButton just calls the
// backend, which records the "offsite_admin" unlock once it confirms the override.

// Admin-only control on an awaiting_payment report. Lets the admin proceed when
// payment was collected OFF-SITE (cash, Venmo, invoice). It (1) tells the backend
// to generate the eval via the same path a real payment uses, and (2) records a
// device-agnostic unlock so the player sees the released report on their profile.
function AdminOffsitePaidButton({report, amountUSD, notify}){
  var busyS = useState(false); var busy = busyS[0], setBusy = busyS[1];
  var doneS = useState(false); var done = doneS[0], setDone = doneS[1];
  function notifyMsg(m,k){ if(typeof window!=="undefined"&&window.__bbotNotify) window.__bbotNotify(m,k); else if(notify) notify(m,k); }
  function run(){
    if(busy||done) return;
    var ok = window.confirm("Mark this evaluation as PAID OFF-SITE?\n\nUse this only when payment was already received outside the site (cash, Venmo, invoice). BBOT will generate the report and send it to admin review, just like a normal paid eval.");
    if(!ok) return;
    var note = window.prompt("Optional note for the record (e.g. \"Cash 5/24\", \"Venmo @coach\"):","") || "";
    setBusy(true);
    fetch(BACKEND_URL+"/admin-mark-paid",{
      method:"POST",
      headers:bbotAdminHeaders(),
      // WHO actually pressed it. This is an AUDIT field, not a permission — the backend
      // authorises via _require_admin and never reads this to decide anything. It used to
      // be the literal 643 address, which with a second admin would have stamped Luis's
      // name on somebody else's off-site payment override.
      body:JSON.stringify({reportId:report.id, adminEmail:_bbotActorEmail(), note:note})
    })
    .then(function(r){ return r.json().then(function(j){ return {ok:r.ok, j:j}; }); })
    .then(function(res){
      // The backend (/admin-mark-paid) records the device-agnostic unlock server-side once it
      // confirms the override — the client no longer writes bbot_unlocks (#3 RLS lockdown).
      setBusy(false);
      if(res.ok && res.j && (res.j.generated || res.j.alreadyProcessed)){
        setDone(true);
        notifyMsg("Marked paid off-site — report is generating and will appear in review.","success");
      } else if(res.ok && res.j && res.j.generated===false){
        setDone(true);
        notifyMsg(res.j.reason || "Marked paid, but no video on file — follow up needed.","info");
      } else {
        notifyMsg((res.j&&res.j.detail) ? String(res.j.detail) : "Could not mark paid — try again.","error");
      }
    })
    .catch(function(){ setBusy(false); notifyMsg("Could not reach server — try again.","error"); });
  }
  return (
    <div style={{borderTop:"1px dashed "+C.border,paddingTop:10}}>
      <div style={{fontSize:10,letterSpacing:1,color:C.gray500,fontWeight:700,marginBottom:6}}>ADMIN OVERRIDE</div>
      <button onClick={run} disabled={busy||done} style={{width:"100%",background:done?(C.green||"#16a34a"):C.navy,color:C.white,border:"none",padding:"11px",borderRadius:6,fontSize:13,fontWeight:700,letterSpacing:.5,cursor:(busy||done)?"default":"pointer",opacity:busy?.7:1}}>
        {done ? "✓ Marked Paid Off-Site" : busy ? "Processing…" : "Mark Paid Off-Site (payment received elsewhere)"}
      </button>
      <div style={{fontSize:10.5,color:C.gray400,lineHeight:1.5,marginTop:6}}>Use only when payment was collected outside the site. Generates the report and sends it to review.</div>
    </div>
  );
}

// RETIRED IN PLACE 2026-08-21 -- it used to POST /create-checkout-session and send the buyer to
// Stripe. It is kept as a named function, and not deleted, for one reason: a browser holding a
// stale bundle, or any caller this sweep did not find, still reaches SOMETHING. What it reaches now
// tells the truth instead of opening a card checkout that is no longer the product's payment path.
//
// It deliberately does NOT try to "helpfully" start an ATH payment. ATH injects its own button into
// a specific div and cannot be launched from an arbitrary click handler, so pretending otherwise
// would swap a working checkout for a silent no-op.
function startCheckout(report, player) {
  var msg = BBOT_ATHM_ENABLED
    ? "Payment is now handled by ATH Móvil — use the ATH Móvil button on your evaluation to pay."
    : "Online payment is moving to ATH Móvil and is unavailable for a short time. Contact 643 Sports MGMT and we will arrange payment and release your report.";
  if(typeof window !== "undefined" && window.__bbotNotify) window.__bbotNotify(msg, "error");
  else if(typeof window !== "undefined") alert(msg);
}

// Check URL on load for post-payment return. Stripe checkouts in this app return with
// either ?bbot_paid=<reportId> (eval upload flow) or ?paid=<reportId> (clips/session
// purchase flow). We accept both so neither flow lands back to a silent page.
function checkPaymentReturn() {
  if(typeof window === "undefined") return;
  var params = new URLSearchParams(window.location.search);
  var paidId = params.get("bbot_paid") || params.get("paid");
  if(!paidId) return;
  // Clean the URL immediately so a refresh can't re-trigger this.
  var clean = window.location.pathname + window.location.hash;
  window.history.replaceState({}, "", clean);
  // SECURITY: the URL param is NOT proof of payment and grants NO access on its own. A report is
  // released ONLY when the server-side unlock — written by the signature-verified Stripe webhook
  // (or the ATH-verified confirm / admin override) — is confirmed. We show a processing message and
  // poll the server for that unlock (the webhook can lag the Stripe redirect by a few seconds).
  function note(msg){
    if(typeof window.__bbotNotify==="function") window.__bbotNotify(msg);
    else window.__bbotPaymentSuccess = msg;
  }
  note("✓ Payment received. Your evaluation is processing — we'll notify you when it's ready.");
  var tries = 0;
  (function poll(){
    checkUnlockRemote(paidId).then(function(found){
      if(found) return;                          // server confirmed → checkUnlockRemote set the local flag
      if(++tries < 12) setTimeout(poll, 3000);   // retry ~36s while the webhook lands
    }).catch(function(){ if(++tries < 12) setTimeout(poll, 3000); });
  })();
}
if(typeof window !== "undefined" && !window.__bbotPaymentChecked) {
  window.__bbotPaymentChecked = true;
  checkPaymentReturn();
}

function PdfUnlockButton({report, player}) {
  var unlockedS = useState(isReportUnlocked(report.id));
  var unlocked = unlockedS[0], setUnlocked = unlockedS[1];
  // On mount: re-check local unlock (payment may have just completed) and do a one-time
  // cross-device check via Supabase. Runs in an effect — never mutate state during render.
  useEffect(function(){
    if(unlocked) return;
    if(isReportUnlocked(report.id)){ setUnlocked(true); return; }
    var alive = true;
    checkUnlockRemote(report.id).then(function(found){ if(alive && found) setUnlocked(true); });
    return function(){ alive = false; };
  }, [report.id]);
  if(unlocked) {
    // CALIBRATION GATE: even once paid/unlocked, the player PDF only releases after admin has
    // reviewed BBOT's inferred grades and marked the eval calibrated. Until then the player sees
    // a "being finalized" state — not the download — so no uncalibrated inferred grades leak out.
    var _calibrated = (report.calibrated===true) || (isLiveEval(report) && report.calibrated!==false);
    if(!_calibrated){
      return <span style={{fontSize:10,color:C.gray500,fontStyle:"italic"}}>Report is being finalized by 643 — download available once review is complete.</span>;
    }
    return <span style={{display:"inline-flex",gap:6}}>
      <button onClick={function(e){e.stopPropagation();downloadReportPdf(report.id, (sc&&(sc.firstName+" "+sc.lastName))||"");}} style={{background:C.navy,color:C.white,border:"none",padding:"6px 12px",borderRadius:6,fontSize:11,fontWeight:600,cursor:"pointer",letterSpacing:.5}}>DOWNLOAD PDF</button>
    </span>;
  }
  // $9.99 unlock prompt removed from the report card — the purchase lives in the offer card.
  // When not yet unlocked, the card shows NO lock widget; the DOWNLOAD PDF button above
  // appears only once the report is unlocked (and calibrated).
  return null;
}

// ============================================================
// MediaPipe Pose Analyzer
// Loads MediaPipe Tasks Vision lazily from CDN on first use.
// Best practice: analyze 3-10 second clips of ONE swing or pitch.
// Long videos will be slow and may freeze on low-end devices.
// ============================================================
var __mpLoader = null;
function loadMediaPipe() {
  if(__mpLoader) return __mpLoader;
  __mpLoader = new Promise(function(resolve, reject){
    if(window.__mpPose) { resolve(window.__mpPose); return; }
    var s = document.createElement("script");
    s.type = "module";
    s.textContent = [
      'import {PoseLandmarker, FilesetResolver} from "https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@0.10.14";',
      'const vision = await FilesetResolver.forVisionTasks("https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@0.10.14/wasm");',
      'window.__mpPose = await PoseLandmarker.createFromOptions(vision, {',
      '  baseOptions: { modelAssetPath: "https://storage.googleapis.com/mediapipe-models/pose_landmarker/pose_landmarker_lite/float16/1/pose_landmarker_lite.task", delegate: "GPU" },',
      '  runningMode: "VIDEO", numPoses: 1',
      '});',
      'window.dispatchEvent(new Event("__mpReady"));'
    ].join("\n");
    window.addEventListener("__mpReady", function once(){ window.removeEventListener("__mpReady", once); resolve(window.__mpPose); }, {once:true});
    s.onerror = function(){ reject(new Error("Failed to load MediaPipe")); };
    document.head.appendChild(s);
  });
  return __mpLoader;
}

// Geometry helper: angle between three landmarks (degrees)
function angleBetween(a, b, c) {
  var v1x = a.x - b.x, v1y = a.y - b.y;
  var v2x = c.x - b.x, v2y = c.y - b.y;
  var dot = v1x*v2x + v1y*v2y;
  var m1 = Math.sqrt(v1x*v1x + v1y*v1y);
  var m2 = Math.sqrt(v2x*v2x + v2y*v2y);
  if(m1 === 0 || m2 === 0) return 0;
  var cos = Math.max(-1, Math.min(1, dot/(m1*m2)));
  return Math.acos(cos) * 180/Math.PI;
}

// MediaPipe landmark indices (subset we use)
var LM = {
  LEFT_SHOULDER:11, RIGHT_SHOULDER:12,
  LEFT_ELBOW:13, RIGHT_ELBOW:14,
  LEFT_WRIST:15, RIGHT_WRIST:16,
  LEFT_HIP:23, RIGHT_HIP:24,
  LEFT_KNEE:25, RIGHT_KNEE:26,
  LEFT_ANKLE:27, RIGHT_ANKLE:28
};

// Pose connections for drawing skeleton
var POSE_LINES = [
  [11,12],[11,13],[13,15],[12,14],[14,16],
  [11,23],[12,24],[23,24],
  [23,25],[25,27],[24,26],[26,28]
];

function drawPose(ctx, landmarks, w, h) {
  if(!landmarks || !landmarks.length) return;
  ctx.strokeStyle = "#FF6B4A"; ctx.lineWidth = 3;
  POSE_LINES.forEach(function(pair){
    var a = landmarks[pair[0]], b = landmarks[pair[1]];
    if(!a || !b) return;
    ctx.beginPath();
    ctx.moveTo(a.x*w, a.y*h);
    ctx.lineTo(b.x*w, b.y*h);
    ctx.stroke();
  });
  ctx.fillStyle = "#2970b8";
  landmarks.forEach(function(p){
    ctx.beginPath();
    ctx.arc(p.x*w, p.y*h, 4, 0, Math.PI*2);
    ctx.fill();
  });
}

// Computes per-frame metrics, returns peak/extreme values across clip
function computeMotionMetrics(framesLandmarks, handedness) {
  if(!framesLandmarks.length) return null;
  var isLefty = handedness === "L";
  var FRONT_HIP    = isLefty ? LM.RIGHT_HIP      : LM.LEFT_HIP;
  var FRONT_KNEE   = isLefty ? LM.RIGHT_KNEE     : LM.LEFT_KNEE;
  var FRONT_ANKLE  = isLefty ? LM.RIGHT_ANKLE    : LM.LEFT_ANKLE;
  var LEAD_SHOULDER= isLefty ? LM.RIGHT_SHOULDER : LM.LEFT_SHOULDER;
  var LEAD_ELBOW   = isLefty ? LM.RIGHT_ELBOW    : LM.LEFT_ELBOW;
  var LEAD_WRIST   = isLefty ? LM.RIGHT_WRIST    : LM.LEFT_WRIST;
  var peakHipRot = 0, peakShoulderRot = 0;
  var minKneeAngle = 180, maxArmExt = 0;
  framesLandmarks.forEach(function(lms){
    if(!lms || lms.length < 29) return;
    var lh = lms[LM.LEFT_HIP], rh = lms[LM.RIGHT_HIP];
    var hipAng = Math.abs(Math.atan2(rh.y - lh.y, rh.x - lh.x) * 180/Math.PI);
    if(hipAng > peakHipRot) peakHipRot = hipAng;
    var ls = lms[LM.LEFT_SHOULDER], rs = lms[LM.RIGHT_SHOULDER];
    var shAng = Math.abs(Math.atan2(rs.y - ls.y, rs.x - ls.x) * 180/Math.PI);
    if(shAng > peakShoulderRot) peakShoulderRot = shAng;
    var ka = angleBetween(lms[FRONT_HIP], lms[FRONT_KNEE], lms[FRONT_ANKLE]);
    if(ka < minKneeAngle && ka > 30) minKneeAngle = ka;
    var ae = angleBetween(lms[LEAD_SHOULDER], lms[LEAD_ELBOW], lms[LEAD_WRIST]);
    if(ae > maxArmExt) maxArmExt = ae;
  });
  return {
    handedness: handedness || "R",
    hipShoulderSeparation: Math.abs(peakHipRot - peakShoulderRot).toFixed(1),
    peakHipRotation: peakHipRot.toFixed(1),
    peakShoulderRotation: peakShoulderRot.toFixed(1),
    frontKneeFlex: minKneeAngle.toFixed(1),
    leadArmExtension: maxArmExt.toFixed(1),
    framesAnalyzed: framesLandmarks.length
  };
}

// ============================================================
// Auto-clip detector — scans full video at low fps, finds the
// 15s window with peak motion, classifies the action.
// Heuristic-based (not a trained classifier) — may misidentify
// on busy multi-player frames. Staff can override pick.
// ============================================================

function motionEnergy(prev, curr) {
  if(!prev || !curr || prev.length !== curr.length) return 0;
  var sum = 0, n = 0;
  for(var i = 0; i < curr.length; i++) {
    if(prev[i] && curr[i]) {
      var dx = curr[i].x - prev[i].x;
      var dy = curr[i].y - prev[i].y;
      sum += Math.sqrt(dx*dx + dy*dy);
      n++;
    }
  }
  return n ? sum/n : 0;
}

function classifyAction(framesLandmarks) {
  // Heuristic classifier — looks at which body parts moved most
  if(!framesLandmarks || framesLandmarks.length < 3) return "motion";
  var wristTravel = 0, ankleTravel = 0, shoulderTravel = 0, hipTravel = 0;
  var prev = framesLandmarks[0];
  for(var i = 1; i < framesLandmarks.length; i++) {
    var cur = framesLandmarks[i];
    if(!cur || !prev) { prev = cur; continue; }
    if(cur[LM.LEFT_WRIST] && prev[LM.LEFT_WRIST]) {
      wristTravel += Math.hypot(cur[LM.LEFT_WRIST].x-prev[LM.LEFT_WRIST].x, cur[LM.LEFT_WRIST].y-prev[LM.LEFT_WRIST].y);
      wristTravel += Math.hypot(cur[LM.RIGHT_WRIST].x-prev[LM.RIGHT_WRIST].x, cur[LM.RIGHT_WRIST].y-prev[LM.RIGHT_WRIST].y);
    }
    if(cur[LM.LEFT_ANKLE] && prev[LM.LEFT_ANKLE]) {
      ankleTravel += Math.hypot(cur[LM.LEFT_ANKLE].x-prev[LM.LEFT_ANKLE].x, cur[LM.LEFT_ANKLE].y-prev[LM.LEFT_ANKLE].y);
      ankleTravel += Math.hypot(cur[LM.RIGHT_ANKLE].x-prev[LM.RIGHT_ANKLE].x, cur[LM.RIGHT_ANKLE].y-prev[LM.RIGHT_ANKLE].y);
    }
    if(cur[LM.LEFT_SHOULDER] && prev[LM.LEFT_SHOULDER]) {
      shoulderTravel += Math.hypot(cur[LM.LEFT_SHOULDER].x-prev[LM.LEFT_SHOULDER].x, cur[LM.LEFT_SHOULDER].y-prev[LM.LEFT_SHOULDER].y);
    }
    if(cur[LM.LEFT_HIP] && prev[LM.LEFT_HIP]) {
      hipTravel += Math.hypot(cur[LM.LEFT_HIP].x-prev[LM.LEFT_HIP].x, cur[LM.LEFT_HIP].y-prev[LM.LEFT_HIP].y);
    }
    prev = cur;
  }
  // Heuristics:
  // - Running: high ankle travel + high hip travel (whole body translating)
  // - Pitching: high wrist + moderate ankle (stride) + low hip translation
  // - Swing: high wrist + low overall translation (rotational, stays in box)
  // - Throw (fielded): high wrist + moderate translation (less stride than pitching)
  // - Fielded ball: low-moderate wrist, moderate ankle (lateral movement)
  if(ankleTravel > 2.5 && hipTravel > 1.5) return "run";
  if(wristTravel > 4.0 && hipTravel < 0.8) return "swing";
  if(wristTravel > 3.5 && ankleTravel > 1.5) return "pitch";
  if(wristTravel > 2.0 && ankleTravel > 1.0) return "throw";
  if(ankleTravel > 1.0) return "fielded_ball";
  return "motion";
}

function actionLabel(code) {
  return ({swing:"Swing", pitch:"Pitch", throw:"Throw", fielded_ball:"Fielded Ball", run:"Run", motion:"Motion"})[code] || "Motion";
}

// Scans video at low resolution + low fps, returns
// { startTime, endTime, action, confidence }
async function autoSelectClip(video, pose, onProgress) {
  var dur = video.duration;
  var WINDOW = 15; // seconds
  if(dur <= WINDOW) return { startTime: 0, endTime: dur, action: "motion", landmarks: [] };
  var SCAN_FPS = 4; // low fps for fast scan
  var step = 1/SCAN_FPS;
  var allLms = []; // [{t, landmarks}]
  var canvas = document.createElement("canvas");
  var scanWidth = 320;
  var scale = scanWidth / video.videoWidth;
  canvas.width = scanWidth;
  canvas.height = Math.round(video.videoHeight * scale);
  var ctx = canvas.getContext("2d");
  var totalScanFrames = Math.floor(dur / step);
  var idx = 0;
  for(var t = 0; t < dur; t += step, idx++) {
    video.currentTime = t;
    await new Promise(function(res){ video.onseeked = res; });
    try {
      ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
      var r = pose.detectForVideo(video, performance.now());
      if(r && r.landmarks && r.landmarks[0]) {
        allLms.push({ t: t, lms: r.landmarks[0] });
      }
    } catch(e) {}
    if(onProgress) onProgress(Math.round((idx+1)/totalScanFrames*100));
  }
  if(allLms.length < 4) return { startTime: 0, endTime: Math.min(WINDOW, dur), action: "motion", landmarks: [] };
  // Compute motion energy per frame
  var energies = [];
  for(var i = 1; i < allLms.length; i++) {
    energies.push({ t: allLms[i].t, e: motionEnergy(allLms[i-1].lms, allLms[i].lms), lms: allLms[i].lms });
  }
  // Sliding window of WINDOW seconds — find max summed energy
  var bestStart = 0, bestSum = -1;
  for(var s = 0; s + WINDOW <= dur; s += step) {
    var sum = 0;
    for(var k = 0; k < energies.length; k++) {
      if(energies[k].t >= s && energies[k].t < s + WINDOW) sum += energies[k].e;
    }
    if(sum > bestSum) { bestSum = sum; bestStart = s; }
  }
  // Classify using the landmarks inside the chosen window
  var windowLms = energies.filter(function(x){ return x.t >= bestStart && x.t < bestStart + WINDOW; }).map(function(x){return x.lms;});
  var action = classifyAction(windowLms);
  return { startTime: bestStart, endTime: bestStart + WINDOW, action: action, landmarks: windowLms };
}

var MOTION_MAX_DURATION_S = 15;
var MOTION_MAX_FILE_MB = 50;
var MOTION_MAX_FRAMES = 150;
var MOTION_TARGET_WIDTH = 720;

function MotionAnalyzer({player, onMetrics}) {
  var fileS = useState(null); var file = fileS[0], setFile = fileS[1];
  var statusS = useState("idle"); var status = statusS[0], setStatus = statusS[1];
  var metricsS = useState(null); var metrics = metricsS[0], setMetrics = metricsS[1];
  var errorS = useState(null); var error = errorS[0], setError = errorS[1];
  var progressS = useState(0); var progress = progressS[0], setProgress = progressS[1];
  var phaseS = useState(""); var phase = phaseS[0], setPhase = phaseS[1];
  var detectedS = useState(null); var detected = detectedS[0], setDetected = detectedS[1];
  var defaultHand = (player && player.bats) ? player.bats : "R";
  var handS = useState(defaultHand); var hand = handS[0], setHand = handS[1];
  var helpOpenS = useState(false); var helpOpen = helpOpenS[0], setHelpOpen = helpOpenS[1];
  var cancelRef = useRef(false);
  var videoRef = useRef(null);
  var canvasRef = useRef(null);
  var isMobile = typeof navigator !== "undefined" && /Mobi|Android|iPhone|iPad/i.test(navigator.userAgent);

  function onPick(e) {
    var f = e.target.files && e.target.files[0];
    if(!f) return;
    if(f.size > MOTION_MAX_FILE_MB * 1024 * 1024) {
      setError("File is " + (f.size/1024/1024).toFixed(1) + " MB. Max is " + MOTION_MAX_FILE_MB + " MB. Compress or trim the clip.");
      setFile(null); return;
    }
    setFile(f); setMetrics(null); setError(null); setStatus("ready"); setProgress(0); setDetected(null);
  }

  function cancel() { cancelRef.current = true; }

  async function analyze() {
    if(!file) return;
    cancelRef.current = false;
    setStatus("loading"); setError(null); setProgress(0); setDetected(null);
    try {
      var video = videoRef.current;
      video.src = URL.createObjectURL(file);
      await new Promise(function(res){ video.onloadedmetadata = res; });
      var dur = video.duration;
      var pose;
      try { pose = await loadMediaPipe(); }
      catch(loadErr) { setError("Could not load pose model. Check internet connection."); setStatus("idle"); return; }

      // ----- Auto-select key 15s window (always on) -----
      var startT = 0, endT = dur, autoAction = null;
      if(dur > MOTION_MAX_DURATION_S) {
        setStatus("scanning"); setPhase("Scanning video for key moment…");
        var pick = await autoSelectClip(video, pose, function(p){ setProgress(p); });
        if(cancelRef.current) { setStatus("idle"); setError("Canceled."); return; }
        startT = pick.startTime; endT = pick.endTime; autoAction = pick.action;
        setDetected({ start: startT, end: endT, action: autoAction });
        setProgress(0);
      }

      // ----- FULL-RES PASS on chosen window -----
      setStatus("analyzing"); setPhase("Analyzing motion…");
      var scale = video.videoWidth > MOTION_TARGET_WIDTH ? MOTION_TARGET_WIDTH / video.videoWidth : 1;
      var canvas = canvasRef.current;
      canvas.width = Math.round(video.videoWidth * scale);
      canvas.height = Math.round(video.videoHeight * scale);
      var ctx = canvas.getContext("2d");
      var frames = [];
      var winDur = endT - startT;
      var idealStep = 1/15;
      var minStep = winDur / MOTION_MAX_FRAMES;
      var step = Math.max(idealStep, minStep);
      var totalFrames = Math.max(1, Math.min(MOTION_MAX_FRAMES, Math.floor(winDur / step)));
      var frameIdx = 0;
      for(var t = startT; t < endT && frameIdx < MOTION_MAX_FRAMES; t += step, frameIdx++) {
        if(cancelRef.current) { setStatus("idle"); setError("Canceled."); return; }
        video.currentTime = t;
        await new Promise(function(res){ video.onseeked = res; });
        try {
          ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
          var result = pose.detectForVideo(video, performance.now());
          if(result && result.landmarks && result.landmarks[0]) {
            frames.push(result.landmarks[0]);
            drawPose(ctx, result.landmarks[0], canvas.width, canvas.height);
          }
        } catch(frameErr) {}
        setProgress(Math.round((frameIdx+1)/totalFrames*100));
      }
      if(frames.length < 5) {
        setError("Could not detect pose in enough frames. Ensure the player is fully in frame and well-lit.");
        setStatus("idle"); return;
      }
      var m = computeMotionMetrics(frames, hand);
      if(autoAction) m.action = autoAction;
      if(autoAction) m.clipStart = startT.toFixed(1);
      if(autoAction) m.clipEnd = endT.toFixed(1);
      setMetrics(m); setStatus("done"); setPhase("");
      if(onMetrics && m) onMetrics(m);
    } catch(err) {
      console.error(err);
      setError(err.message || "Analysis failed");
      setStatus("idle");
    }
  }

  var busy = status==="analyzing"||status==="loading"||status==="scanning";

  return (
    <Card style={{padding:14,marginTop:12}}>
      <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:10,flexWrap:"wrap",gap:8}}>
        <div>
          <div style={{fontSize:12,fontWeight:700,color:C.navy,letterSpacing:.5}}>MOTION ANALYSIS</div>
          <div style={{fontSize:10,color:C.gray500,marginTop:2,fontStyle:"italic"}}>Upload a clip — 15 seconds recommended. BBOT auto-selects the key window. Tap ? for upload tips. Separate from YouTube context video.</div>
        </div>
        <div style={{display:"flex",gap:6,alignItems:"center",flexWrap:"wrap"}}>
<select value={hand} onChange={function(e){setHand(e.target.value);}} disabled={busy} style={{padding:"6px 8px",border:"1px solid "+C.border,borderRadius:6,fontSize:11,background:C.white}}>
            <option value="R">R-handed</option>
            <option value="L">L-handed</option>
          </select>
          <button type="button" onClick={function(){setHelpOpen(!helpOpen);}} title="Tips for best results" style={{width:22,height:22,borderRadius:"50%",border:"1px solid "+C.border,background:helpOpen?C.navy:C.white,color:helpOpen?C.white:C.navy,fontSize:12,fontWeight:700,cursor:"pointer",lineHeight:1,padding:0}}>?</button>
          <input type="file" accept="video/*" onChange={onPick} disabled={busy} style={{fontSize:11}}/>
          {busy
            ? <Btn v="ghost" onClick={cancel}>Cancel</Btn>
            : <Btn v={file?"primary":"ghost"} onClick={analyze} disabled={!file}>{status==="loading"?"Loading…":"Analyze"}</Btn>}
        </div>
      </div>
      {helpOpen&&<div style={{padding:"10px 12px",background:"#f4f8fc",border:"1px solid "+C.border,borderRadius:6,fontSize:11,color:C.gray700,marginBottom:8,lineHeight:1.6}}>
        <div style={{fontWeight:700,color:C.navy,marginBottom:6,fontSize:11,letterSpacing:.5}}>FOR BEST RESULTS</div>
        <ul style={{margin:0,paddingLeft:18}}>
          <li><strong>15 seconds recommended</strong> — longer is OK, BBOT will auto-trim to the key moment</li>
          <li><strong>One player, full body in frame</strong> — head to feet, no cropping</li>
          <li><strong>Side angle preferred</strong> for swing/pitch (catcher’s POV is OK)</li>
          <li><strong>Good lighting</strong> — avoid heavy shadows or backlight</li>
          <li><strong>Steady camera</strong> — tripod or braced phone, not handheld zoom</li>
          <li><strong>Background contrast</strong> — player should stand out from surroundings</li>
          <li><strong>Under 50 MB</strong> — compress 4K to 1080p before uploading</li>
          <li><strong>Avoid busy frames</strong> with multiple players in motion</li>
        </ul>
      </div>}
      {isMobile&&!busy&&!metrics&&<div style={{padding:"6px 10px",background:"#fffbe8",border:"1px solid #f0d97a",borderRadius:6,fontSize:10,color:"#7a6010",marginBottom:8}}>Mobile detected. Desktop recommended for longer videos.</div>}
      {error&&<div style={{padding:"8px 10px",background:"#fff3f0",border:"1px solid "+C.coral,borderRadius:6,fontSize:11,color:"#b03a26",marginBottom:8}}>{error}</div>}
      {busy&&<div style={{marginBottom:8}}><div style={{height:4,background:C.gray100,borderRadius:2,overflow:"hidden"}}><div style={{width:progress+"%",height:"100%",background:C.coral,transition:"width .2s"}}/></div><div style={{fontSize:10,color:C.gray500,marginTop:4}}>{phase||(status==="loading"?"Loading pose model…":"Working…")} {progress}%</div></div>}
      {detected&&!busy&&<div style={{padding:"8px 10px",background:"#e8f4fd",border:"1px solid "+C.blue,borderRadius:6,fontSize:11,color:C.navy,marginBottom:8}}><strong>Auto-detected: {actionLabel(detected.action)}</strong> &middot; window {detected.start.toFixed(1)}s–{detected.end.toFixed(1)}s</div>}
      <div style={{position:"relative",background:C.gray50,borderRadius:6,overflow:"hidden",minHeight:file?180:0}}>
        <video {...bbotVideoGuard()} ref={videoRef} style={{display:"none"}} muted playsInline/>
        <canvas ref={canvasRef} style={{maxWidth:"100%",display:file?"block":"none"}}/>
      </div>
      {metrics&&(
        <div style={{marginTop:10,display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(140px,1fr))",gap:8}}>
          {[
            ["Action", metrics.action ? actionLabel(metrics.action) : "—"],
            ["Hip-Shoulder Sep", metrics.hipShoulderSeparation+"°"],
            ["Peak Hip Rot", metrics.peakHipRotation+"°"],
            ["Peak Shoulder Rot", metrics.peakShoulderRotation+"°"],
            ["Front Knee Flex", metrics.frontKneeFlex+"°"],
            ["Lead Arm Ext", metrics.leadArmExtension+"°"],
            ["Frames", metrics.framesAnalyzed]
          ].map(function(pair,i){
            return <div key={i} style={{background:C.white,border:"1px solid "+C.border,borderRadius:6,padding:"8px 10px"}}>
              <div style={{fontSize:9,color:C.gray500,letterSpacing:.5,fontWeight:600,textTransform:"uppercase"}}>{pair[0]}</div>
              <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:18,color:C.navy,marginTop:2}}>{pair[1]}</div>
            </div>;
          })}
        </div>
      )}
      {metrics&&<div style={{fontSize:9,color:C.gray500,marginTop:10,fontStyle:"italic",lineHeight:1.5,borderTop:"1px solid "+C.border,paddingTop:8}}>Metrics derived from pose estimation. Educational and directional indicators only. Handedness applied: {metrics.handedness==="L"?"Left":"Right"}. Metrics auto-attach to the next BBOT evaluation.</div>}
    </Card>
  );
}

// ============================================================
// PLAYER CARD — replaces PDF. Renders a 1080×1350 PNG (4:5, IG-optimal)
// with tool grades + measurements, saved to camera roll / shared.
// No file download, no print, no iOS PDF issues — it's an image.
// ============================================================
// ============================================================
// ONE UNIFORM PLAYER REPORT — print-to-PDF.
// There is a single report renderer (ReportCard). Downloading a report
// prints that exact on-screen report to a clean ONE-PAGE PDF, so the PDF,
// the profile view, the dashboard view, and the admin copy are identical.
// No canvas/PNG cards.
// ============================================================
function printPlayerReport(reportId){
  try{
    var srcId = "bbot-report-"+reportId;
    var el = (typeof document!=="undefined") ? document.getElementById(srcId) : null;
    if(!el){ alert("Open the report first, then download."); return; }
    var videoUrl = el.getAttribute("data-video-url") || "";
    var clone = el.cloneNode(true);
    // THE PDF IS ALWAYS THE PLAYER VIEW. This clones the LIVE DOM, so an admin pressing Download
    // would otherwise ship the admin grade block and the graded-observations section inside the
    // artifact a coach opens. The PDF is the thing that leaves the building; it carries what the
    // customer receives, never what the operator sees.
    try {
      var _adminOnly = clone.querySelectorAll(".bbot-admin-only");
      for (var _i = 0; _i < _adminOnly.length; _i++) {
        _adminOnly[_i].parentNode && _adminOnly[_i].parentNode.removeChild(_adminOnly[_i]);
      }
    } catch (_e) { /* stripping must never block the download */ }
    // Remove things that don't belong in a print: video players, buttons, inputs, the no-print bar.
    ["video","button","input","textarea","iframe","audio",".no-print",".bbot-clip-players"].forEach(function(sel){
      var nodes = clone.querySelectorAll(sel);
      for(var i=nodes.length-1;i>=0;i--){ nodes[i].parentNode && nodes[i].parentNode.removeChild(nodes[i]); }
    });
    // Also remove any leftover video container (R2Video wrapper / "Open session video" link).
    var vids = clone.querySelectorAll("[data-r2video], a[href*='video']");
    for(var j=vids.length-1;j>=0;j--){ vids[j].parentNode && vids[j].parentNode.removeChild(vids[j]); }
    // PLAYER PDF INTEGRITY: strip anything flagged admin-only (e.g. BBOT inferred-grade panels,
    // calibration controls) so the player copy never carries inferred grades — even if an admin
    // is the one triggering the print. Elements opt in by class "admin-only" or data-admin-only.
    var adminEls = clone.querySelectorAll(".admin-only,[data-admin-only]");
    for(var k=adminEls.length-1;k>=0;k--){ adminEls[k].parentNode && adminEls[k].parentNode.removeChild(adminEls[k]); }
    // NO BLANK SECTIONS IN THE PDF. The strips above remove video and iframe content a print cannot
    // carry, which left FILM & CHARTS as a heading over nothing. A heading with no content under it
    // reads as something missing rather than something that was never there. Runs after every strip,
    // so it judges what actually remains: a section whose content is gone is removed with it.
    try {
      var _dropables = clone.querySelectorAll("[data-drop-if-empty]");
      for (var _d = _dropables.length - 1; _d >= 0; _d--) {
        var _sec = _dropables[_d];
        var _hasText = (_sec.textContent || "").replace(/\s|·/g, "").length > 0;
        var _hasVisual = _sec.querySelectorAll("img,svg,canvas").length > 0;
        // Header text alone is not content — ignore the section's own heading when judging.
        var _heads = _sec.querySelectorAll("[data-section-heading]");
        if (_heads.length && _hasText) {
          var _headText = "";
          for (var _h = 0; _h < _heads.length; _h++) { _headText += (_heads[_h].textContent || ""); }
          _hasText = (_sec.textContent || "").replace(_headText, "").replace(/\s|·/g, "").length > 0;
        }
        if (!_hasText && !_hasVisual) { _sec.parentNode && _sec.parentNode.removeChild(_sec); }
      }
    } catch (_e) { /* never block the download */ }
    // Flatten the outer card so it sits flush on the page, and let it fill the page width.
    clone.style.border="none"; clone.style.borderRadius="0"; clone.style.marginBottom="0"; clone.style.boxShadow="none"; clone.style.overflow="visible";
    clone.style.maxWidth="none"; clone.style.width="100%";
    var html = clone.outerHTML;
    // QR block linking to the video source (PDF can't embed video).
    var qrBlock = "";
    if(videoUrl){
      var qr = "https://api.qrserver.com/v1/create-qr-code/?size=150x150&margin=0&data="+encodeURIComponent(videoUrl);
      qrBlock = "<div style='display:flex;align-items:center;gap:14px;border:1px solid #e2e8f0;border-radius:10px;padding:12px 14px;margin-top:14px;background:#f8fafc'>"+
        "<img src='"+qr+"' alt='Video source QR' style='width:84px;height:84px;flex-shrink:0'/>"+
        "<div><div style='font-family:Inter,system-ui,sans-serif;font-size:12px;letter-spacing:1px;color:#3366cc;font-weight:700'>VIDEO SOURCE</div>"+
        "<div style='font-size:11px;color:#64748b;margin-top:3px;line-height:1.4'>Scan to view the video source for this evaluation.</div></div></div>";
    }
    var w = window.open("", "_blank");
    if(!w){ alert("Allow pop-ups to download the report PDF."); return; }
    var doc = w.document;
    doc.open();
    doc.write(
      "<!DOCTYPE html><html><head><meta charset='utf-8'>"+
      "<meta name='viewport' content='width=816, initial-scale=1'>"+   // fixed canvas width so mobile Safari can't reflow to screen width
      "<title>643 BBOT Player Report</title>"+
      "<style>"+
      "@page{ size: letter portrait; margin: 0.4in 0.45in; }"+
      "*{ -webkit-print-color-adjust:exact !important; print-color-adjust:exact !important; box-sizing:border-box; }"+
      "html,body{ margin:0; padding:0; background:#fff; font-family:Inter,system-ui,sans-serif; -webkit-text-size-adjust:100%; color:#0f172a; }"+
      "#bbot-page{ width:100%; max-width:none; margin:0 auto; padding:0; position:relative; }"+
      "#bbot-fit{ width:100%; font-size:13px; line-height:1.5; }"+
      "#bbot-fit svg{ max-width:100%; height:auto; }"+
      "#bbot-fit img{ max-width:100%; }"+
      "#bbot-fit > div{ width:100% !important; }"+
      // Branded letterhead so the PDF reads as a refined, official 643/BBOT document.
      ".bbot-letterhead{ display:flex; align-items:center; justify-content:space-between; background:#2970b8; border-radius:10px; padding:14px 18px; margin-bottom:16px; }"+
      ".bbot-letterhead .lh-logo{ height:50px; width:auto; }"+
      ".bbot-letterhead .lh-title{ text-align:right; }"+
      ".bbot-letterhead .lh-title .t1{ font-size:18px; font-weight:800; letter-spacing:1px; color:#e8526a; }"+
      ".bbot-letterhead .lh-title .t2{ font-size:11px; letter-spacing:2px; color:rgba(255,255,255,.85); font-weight:700; margin-top:2px; }"+
      ".bbot-foot{ margin-top:18px; padding-top:10px; border-top:1px solid #e2e8f0; font-size:9px; color:#94a3b8; text-align:center; letter-spacing:.5px; }"+
      "button,input,textarea,.no-print{ display:none !important; }"+
      "@media print{"+
      "  html,body{ width:100%; }"+
      "  #bbot-fit{ font-size:13px; }"+
      "  #bbot-fit p, #bbot-fit div, #bbot-fit span{ line-height:1.5 !important; }"+
      // A PAGE MAY ONLY BREAK AT A SECTION BOUNDARY. The old rule guarded only the direct children of
      // #bbot-fit, so a break could land inside a metric bar or between a bar and its label -- a value
      // split across pages reads as two different values, which is the one thing this report must
      // never do. Guard every nested block, then release the guard ONLY on section headers.
      "  #bbot-fit div, #bbot-fit table, #bbot-fit tr, #bbot-fit svg{ break-inside:avoid; page-break-inside:avoid; }"+
      "  .bbot-sec{ break-inside:avoid; page-break-inside:avoid; }"+
      // A heading must never be the last thing on a page.
      "  .bbot-sec-hdr{ break-after:avoid; page-break-after:avoid; }"+
      "  .bbot-letterhead{ break-after:avoid; page-break-after:avoid; }"+
      // Backgrounds carry meaning here (the blue->coral reference track IS the scale), so printing
      // them white would strip the information the bar exists to convey.
      "  *{ -webkit-print-color-adjust:exact !important; print-color-adjust:exact !important; }"+
      "}"+
      "</style></head><body>"+
      "<div id='bbot-page'>"+
      "<div class='bbot-letterhead'>"+
      "<img class='lh-logo' src='"+LOGO_BBOT.replace("/upload/","/upload/w_300,h_300,c_fit/")+"' alt='BBOT'/>"+
      "<div class='lh-title'><div class='t1'>PLAYER EVALUATION</div><div class='t2'>BBOT &middot; 643 SPORTS MGMT</div></div>"+
      "</div>"+
      "<div id='bbot-fit'>"+html+qrBlock+"</div>"+
      "<div class='bbot-foot'>Produced by BBOT for 643 Sports MGMT LLC. Every mark on this report was measured or observed in the session footage; nothing is inferred.</div>"+
      "</div>"+
      "<script>"+
      "function fitAndPrint(){"+
      "  try{"+
      "    var page=document.getElementById('bbot-page');"+
      "    var fit=document.getElementById('bbot-fit');"+
      "    if(page&&fit){"+
      "      // CONTENT-AWARE BASE SIZE (handles the big variance between players). Before the gentle"+
      "      // fit nudge, pick a base font from how much the report actually contains: a thin report"+
      "      // (partial eval, few tools) breathes at a larger base so it fills the page; a dense one"+
      "      // (full showcase, pitcher with pitch data) condenses so it stays on one page. This is the"+
      "      // honest variance fix \u2014 the design adapts to content, then the nudge only tidies the edge."+
      "      var availH=979;"+
      "      var raw=fit.scrollHeight;"+
      "      if(raw>0){"+
      "        var ratio=availH/raw;"+   // how the natural content compares to one page
      "        var base= ratio>1.25 ? 15 : ratio>1.08 ? 14 : ratio>0.92 ? 13 : ratio>0.80 ? 12 : 11;"+
      "        fit.style.fontSize=base+'px';"+
      "      }"+
      "      // Re-measure after the base change, then apply only a GENTLE nudge (max +/-10%) to tidy"+
      "      // the page edge \u2014 never enough to visibly distort. Reports keep consistent visual weight."+
      "      var h=fit.scrollHeight;"+
      "      if(h>0){"+
      "        var s=availH/h;"+
      "        if(s>1.10) s=1.10;"+
      "        if(s<0.90) s=0.90;"+
      "        if(Math.abs(s-1)>0.012){"+
      "          fit.style.transformOrigin='top center';"+
      "          fit.style.transform='scale('+s+')';"+
      "          fit.style.width=(100/s)+'%';"+
      "          fit.style.marginLeft=(-(100/s-100)/2)+'%';"+
      "        }"+
      "      }"+
      "    }"+
      "  }catch(e){}"+
      "  setTimeout(function(){ try{window.focus();}catch(e){} window.print(); }, 300);"+
      "}"+
      // Wait for ALL images (logo + QR) to finish loading so they aren't blank in the PDF.
      "function whenImagesReady(cb){"+
      "  var imgs=Array.prototype.slice.call(document.images||[]);"+
      "  var pending=imgs.filter(function(im){return !im.complete;});"+
      "  if(pending.length===0){ cb(); return; }"+
      "  var done=0, fired=false;"+
      "  function one(){ done++; if(done>=pending.length && !fired){ fired=true; cb(); } }"+
      "  pending.forEach(function(im){ im.addEventListener('load',one); im.addEventListener('error',one); });"+
      "  setTimeout(function(){ if(!fired){ fired=true; cb(); } }, 2500);"+  // safety timeout
      "}"+
      "window.onload=function(){ whenImagesReady(fitAndPrint); };"+
      "<\/script>"+
      "</body></html>"
    );
    doc.close();
  }catch(e){ alert("Could not generate PDF: "+e.message); }
}

// ============================================================================
// PDF PATH SELECTION — text-native by default, photograph as fallback
// ============================================================================
// The html2pdf path below PHOTOGRAPHS the DOM and embeds the JPEG: zero extractable characters,
// nothing selectable or searchable, nothing for a screen reader, and nothing any checker can read.
// The text-native path (src/bbotPdfText.js) draws the same report with the jsPDF TEXT api.
//
// VERIFIED, NOT ASSUMED: generated headless and run through _pdf_verify (extractable text ·
// nine-class leak sweep · granularity · fidelity vs row, both directions) over every live report.
// The default flips only because that evidence exists.
//
// THE FALLBACK STAYS. If jsPDF fails to load or the build throws, the photograph is still a
// visually correct document — a customer with no PDF is worse off than one with an unsearchable
// PDF. Set window.__BBOT_PDF_TEXT_NATIVE = false to force the old path.
var PDF_TEXT_NATIVE_DEFAULT = true;
function pdfTextNativeEnabled(){
  if (typeof window === "undefined") return PDF_TEXT_NATIVE_DEFAULT;
  return window.__BBOT_PDF_TEXT_NATIVE === undefined
    ? PDF_TEXT_NATIVE_DEFAULT : !!window.__BBOT_PDF_TEXT_NATIVE;
}

// Load jsPDF alone (no html2canvas) once, from CDN. Resolves with the jsPDF constructor.
function loadJsPdf(){
  return new Promise(function(resolve, reject){
    if(typeof window!=="undefined" && window.jspdf && window.jspdf.jsPDF){ resolve(window.jspdf.jsPDF); return; }
    var existing = document.getElementById("jspdf-js");
    if(existing){
      existing.addEventListener("load", function(){ resolve(window.jspdf && window.jspdf.jsPDF); });
      existing.addEventListener("error", function(){ reject(new Error("Failed to load PDF library")); });
      if(window.jspdf && window.jspdf.jsPDF) resolve(window.jspdf.jsPDF);
      return;
    }
    var s = document.createElement("script");
    s.id = "jspdf-js";
    s.src = "https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js";
    s.async = true;
    s.onload = function(){
      if(window.jspdf && window.jspdf.jsPDF) resolve(window.jspdf.jsPDF);
      else reject(new Error("jsPDF did not register"));
    };
    s.onerror = function(){ reject(new Error("Failed to load PDF library")); };
    document.body.appendChild(s);
  });
}

// Load html2pdf (bundles jsPDF + html2canvas) once, from CDN. Resolves when window.html2pdf exists.
function loadHtml2Pdf(){
  return new Promise(function(resolve, reject){
    if(typeof window!=="undefined" && window.html2pdf){ resolve(window.html2pdf); return; }
    var existing = document.getElementById("html2pdf-js");
    if(existing){
      existing.addEventListener("load", function(){ resolve(window.html2pdf); });
      existing.addEventListener("error", function(){ reject(new Error("Failed to load PDF library")); });
      if(window.html2pdf) resolve(window.html2pdf);
      return;
    }
    var s = document.createElement("script");
    s.id = "html2pdf-js";
    s.src = "https://cdnjs.cloudflare.com/ajax/libs/html2pdf.js/0.10.1/html2pdf.bundle.min.js";
    s.async = true;
    s.onload = function(){ resolve(window.html2pdf); };
    s.onerror = function(){ reject(new Error("Failed to load PDF library")); };
    document.body.appendChild(s);
  });
}

// ============================================================================
// CLEAN PDF COMPONENT — renders document content only (no UI chrome)
// ============================================================================
// CREDIBILITY FRAME — why this document can be trusted, ON the document.
// A coach reading a report should not have to take the grades on faith: this states what the marks
// came from, what could not be measured, and which age bracket was applied. It reveals nothing
// about HOW anything is computed (CLAUDE.md §3) -- no dial names, no thresholds, no method.
// Percentile is deliberately NOT shown: percentile bars are admin-only, so printing one here would
// describe something the reader cannot see anywhere else.
function CredibilityFrame({report, compact}) {
  if (!report) return null;
  var secs = report.sections || [];
  var mvb = report.measuredValuesBasis || {};
  var deviceMarks = Object.keys(mvb).filter(function(k){
    return String(mvb[k] || "").toLowerCase().indexOf("verified") === 0;
  });
  // A TOOL IS MEASURED WHEN IT HAS A VALUE, NOT WHEN IT HAS A GRADE (ratified 2026-08-13).
  //
  // These two lines asked "is this tool measured?" by looking for a grade -- and the zero-grades
  // law removes the grade from exactly the tools that ARE measured. So the frame printed the
  // opposite of the truth: with the grade gone, a device-timed Run or a hand-timed Pop Time fell
  // into "Not measurable, disclosed", on the PDF, which is the one artifact a customer keeps.
  //
  // This is the same defect the admission law was ratified over: four surfaces each decided
  // "measured?" their own way, and the one that keyed on `grade` named the very tools it had just
  // measured as unmeasured. The test is the VALUE. `gradeBasis.value` is the measured quantity the
  // age reference was read against (4.05 s, 2.15 s, 72.9 mph), and a Confirmed/Measured confidence
  // is the other way a tool says a device or a clock produced it.
  // [[admission-is-the-value]] [[absence-is-not-a-finding]]
  // The test lives in `bbotMeasured.js` because THREE surfaces got this wrong in the same hour and
  // the PDF module cannot import from here. It also credits an admin-entered time that never got a
  // percentile -- Ethan Ortiz's hand-timed 4.40 and 2.30 read as unmeasurable without it.
  function _frameMeasured(x){ return toolIsMeasured(x, mvb); }
  var measured = secs.filter(_frameMeasured)
                     .map(function(x){ return x.label || x.key; });
  var disclosed = secs.filter(function(x){ return !_frameMeasured(x); })
                      .map(function(x){ return x.label || x.key; });
  var gb = null;
  for (var i = 0; i < secs.length; i++) { if (secs[i] && secs[i].gradeBasis) { gb = secs[i].gradeBasis; break; } }
  var sources = [];
  if (deviceMarks.length) sources.push("Device readings (" + deviceMarks.length + ")");
  if ((report.poseMetrics && Object.keys(report.poseMetrics).length) || report.skeletonUrl) sources.push("Video measurement");
  sources.push("643 staff review");
  var L = {fontSize: compact ? 8 : 10, color: C.gray600, lineHeight: 1.5};
  var Hd = {fontSize: compact ? 8 : 9, fontWeight: 700, letterSpacing: .6, color: C.blue,
            textTransform: "uppercase", marginBottom: 3};
  return (
    <div style={{border: "1px solid " + C.border, borderLeft: "3px solid " + C.blue, borderRadius: 6,
                 padding: compact ? "6px 8px" : "10px 12px", background: C.blueFaint, marginTop: 8}}>
      <div style={Hd}>What this report is based on</div>
      <div style={L}><strong>Sources:</strong> {sources.join(" · ")}</div>
      {measured.length ? <div style={L}><strong>Measured this session:</strong> {measured.join(", ")}</div> : null}
      {disclosed.length ? <div style={L}><strong>Not measurable, disclosed:</strong> {disclosed.join(", ")}</div> : null}
      {gb && gb.bracket ? <div style={L}><strong>Benchmarks:</strong> {gb.bracket} age group · age rule {gb.ageRule || "may_1@v1"}</div> : null}
      {report.partialReason ? <div style={L}><strong>Scope:</strong> {report.partialReason}</div> : null}
      <div style={{...L, marginTop: 3, fontStyle: "italic"}}>
        Every mark was measured or observed in the session footage; nothing is inferred.
      </div>
    </div>
  );
}


function ReportPdfContent({r, sc}) {
  if (!r) return null;

  var report = r.fullReport || r;
  var sessionType = r.sessionType || "Evaluation";
  var sessionMode = (r.sessionMode || (report.sessionMode) || "").toLowerCase();
  var sessionModeLabel = sessionMode === "pickup" ? " · Pickup Game" :
                         sessionMode === "multi" ? " · Group Showcase" :
                         sessionMode === "individual" ? " · Individual" : "";
  var date = r.date || r.sessionDate || "";
  var evaluator = r.evaluator || "BBOT";
  var isPitcher = (r.isPitcher === true) || /^(P|RHP|LHP|SP|RP|CP)$/i.test(String((sc && sc.position) || r.position || "").trim().split(/[\s,\/]/)[0]);
  var pitcherHideKeys = ["run", "receiving", "fielding", "plateDis", "batBall", "exitVelo", "popTime", "throw"];
  var pitcherToolKeys = ["fastball", "fastballvelo", "pitchvelo", "velocity", "armaction", "mechanics", "movement", "pitchmovement", "spinning", "spin", "changingspeeds", "command", "mix", "delivery", "athleticism"];

  function isPitcherTool(s) {
    var k = String(s.key || "").toLowerCase().replace(/[^a-z]/g, "");
    var lbl = String(s.label || "").toLowerCase();
    if (pitcherToolKeys.indexOf(k) >= 0) return true;
    return /arm action|mechanic|pitch movement|spinning|changing speed|fastball|pitch velocity|delivery|command|pitch mix/.test(lbl);
  }
  function keepSection(s) {
    if (isPitcher) return pitcherHideKeys.indexOf(s.key) < 0;
    return !isPitcherTool(s);
  }

  var allSections = (r.sections || (report && report.sections) || []).filter(keepSection);
  // MEASURED, NOT GRADED. This filtered on `s.grade`, and the zero-grades law takes the grade off
  // exactly the measured tools -- so this block emptied on the customer PDF and its tools
  // reappeared below under SCOUTING OBSERVATIONS. A hand-timed pop time presented as somebody's
  // impression is a worse statement than the grade that was removed. [[admission-is-the-value]]
  var _pdfMvb = r.measuredValuesBasis || (r.fullReport && r.fullReport.measuredValuesBasis) || {};
  var gradedSections = allSections.filter(function(s) { return toolIsMeasured(s, _pdfMvb); });
  var mv = r.measuredValues || (report.measuredValues) || {};
  var chip = function(label) {
    var c = (r.summaryChips || []).find(function(x) {
      return String(x.label || "").toLowerCase().indexOf(label.toLowerCase()) >= 0;
    });
    return c ? c.value : null;
  };

  var stats = [
    ["H-TO-1ST", chip("h-to-1") || chip("home") || (mv.h2f ? mv.h2f + "s" : null)],
    ["TOP EV", chip("ev") || chip("exit") || (mv.exitVeloPeak ? mv.exitVeloPeak + " mph" : null)],
    ["THROW", chip("throw") || chip("arm") || (mv.throwVelo ? mv.throwVelo + " mph" : null)]
  ].filter(function(s) { return s[1]; });

  var sessionContext = r.sessionContext || (report.sessionContext);
  var evaluationScope = r.evaluationScope || (report.evaluationScope) || "";
  var isPartial = evaluationScope.toLowerCase() === "partial";
  var partialText = r.partialWarning || (report.partialWarning) || "";

  function cleanToolLabel(lbl) {
    return String(lbl || "").replace(/\s*\(.*?\)\s*/g, "").trim();
  }

  var S = {
    blue: "#2970b8", coral: "#e8526a", coralDeep: "#e3475f", navy: "#0f172a",
    gray700: "#334155", gray600: "#475569", gray500: "#64748b", gray400: "#94a3b8",
    gray200: "#e2e8f0", gray100: "#f1f5f9", gray50: "#f8fafc", white: "#ffffff"
  };

  return (
    <div style={{fontFamily: "Inter,system-ui,sans-serif", color: S.navy, background: S.white, padding: "16px", width: "760px", boxSizing: "border-box"}}>
      {sc && (
        <div style={{background: S.navy, borderRadius: 10, padding: 14, marginBottom: 12, color: S.white}}>
          <div style={{fontSize: 16, letterSpacing: 1, marginBottom: 3}}>
            {(sc.firstName || "") + " " + (sc.lastName || "")}
          </div>
          <div style={{fontSize: 11, color: "rgba(255,255,255,.6)"}}>
            {[
              sc.position,
              sc.gradYear ? ("Class " + sc.gradYear) : null,
              sc.height,
              sc.weight ? (sc.weight + " lbs") : null,
              (sc.bats || sc.throws) ? ((sc.bats || "-") + "/" + (sc.throws || "-")) : null
            ].filter(Boolean).join(" · ")}
          </div>
        </div>
      )}

      <div style={{marginBottom: 12, paddingBottom: 10, borderBottom: "2px solid " + S.blue}}>
        <div style={{fontSize: 11, color: S.blue, letterSpacing: 1, fontWeight: 700}}>SESSION REPORT</div>
        <div style={{fontSize: 13, color: S.navy, letterSpacing: 0.5, marginTop: 2}}>
          {sessionType + sessionModeLabel}
        </div>
        <div style={{fontSize: 11, color: S.gray500, marginTop: 2}}>
          {date && (date + " · ")}Evaluator: {evaluator}
        </div>
      </div>

      {isPartial && (
        <div style={{marginBottom: 12}}>
          <div style={{display: "inline-block", background: "#fef3cd", color: "#8b6914", padding: "4px 10px", borderRadius: 4, fontSize: 10, fontWeight: 700, letterSpacing: 0.5, marginBottom: 6}}>
            PARTIAL
          </div>
          {partialText && (
            <div style={{background: "#fef3cd", border: "1px solid #fde68a", borderRadius: 6, padding: "8px 10px", fontSize: 11, color: S.gray700, lineHeight: 1.5}}>
              <strong>PARTIAL</strong> — {partialText}
            </div>
          )}
        </div>
      )}

      {stats.length > 0 && (
        <div style={{display: "flex", gap: 8, background: S.blue, borderRadius: 10, padding: "10px 12px", marginBottom: 12}}>
          {stats.map(function(stat, i) {
            return (
              <div key={i} style={{flex: 1, textAlign: "center", color: S.white}}>
                <div style={{fontSize: 9, color: "rgba(255,255,255,.7)", letterSpacing: 0.5}}>{stat[0]}</div>
                <div style={{fontSize: 16, fontWeight: 700, marginTop: 2}}>{stat[1]}</div>
              </div>
            );
          })}
        </div>
      )}

      {r.summary && (
        <div style={{marginBottom: 14}}>
          <div style={{fontSize: 11, color: S.coral, letterSpacing: 1.2, marginBottom: 8, fontWeight: 700}}>BBOT SUMMARY</div>
          <div style={{borderLeft: "3px solid " + S.coral, paddingLeft: 12}}>
            <p style={{fontSize: 13, color: S.gray700, lineHeight: 1.7, margin: 0}}>{r.summary}</p>
          </div>
          <div style={{display: "flex", gap: 12, marginTop: 6}}>
            <div style={{fontSize: 11, color: S.gray500}}>
              <strong>Bats</strong> {sc ? (sc.bats || "?") : "?"}
            </div>
            <div style={{fontSize: 11, color: S.gray500}}>
              <strong>Throws</strong> {sc ? (sc.throws || "?") : "?"}
            </div>
          </div>
        </div>
      )}

      {sessionContext && (
        <div style={{marginBottom: 12, fontSize: 11, color: S.gray600, fontStyle: "italic", padding: "8px 10px", background: S.gray50, borderRadius: 6}}>
          {sessionContext}
        </div>
      )}

      {gradedSections.length > 0 && (
        <div style={{marginBottom: 14}}>
          <div style={{fontSize: 11, color: S.coral, letterSpacing: 1.2, marginBottom: 10, fontWeight: 700}}>MEASURED TOOLS</div>
          {gradedSections.map(function(section, i) {
            var confidence = section.confidence || "";
            var isConfirmed = confidence.toLowerCase().indexOf("confirmed") >= 0 ||
                              confidence.toLowerCase().indexOf("measured") >= 0;

            return (
              <div key={i} style={{marginBottom: 12, paddingBottom: 10, borderBottom: i < gradedSections.length - 1 ? "1px solid " + S.gray100 : "none", pageBreakInside: "avoid"}}>
                <div style={{display: "flex", alignItems: "center", gap: 8, marginBottom: 6}}>
                  <div style={{fontWeight: 700, color: S.navy, fontSize: 13, flex: 0, minWidth: 80}}>
                    {cleanToolLabel(section.label)}
                  </div>
                  {isConfirmed && (
                    <div style={{fontSize: 9, background: "#d1fae5", color: "#065f46", padding: "2px 6px", borderRadius: 3, fontWeight: 700, letterSpacing: 0.3}}>
                      CONFIRMED
                    </div>
                  )}
                </div>
                {/* NO NUMBER HERE. The 20-80 is gone under the zero-grades law, and the measured
                    MARK is not reprinted in its place either: it already has a home on this same
                    page in the measured values, and the same fact printed twice is how two
                    surfaces start to disagree about it. [[one-home-per-value]]

                    AND NO AGE-PEER TRACK. It used to draw here, ungated, on the customer PDF. Its
                    percentile comes off a fixed curve written into BbotBoxReport.js -- an anchor, a
                    bracket multiplier, a fixed spread -- so no player, rep or session is in it and
                    it cannot say where anyone stands among peers. REMOVED, not switched off (Luis,
                    2026-10-09: "the record doesn't keep two paths alive ... delete the flag"). A
                    real placement is counted against a named pool with its n stated, and when
                    that pool exists it gets built against the pool. See `bbotMeasured.js`. */}
                {section.text && (
                  <div style={{fontSize: 11, color: S.gray700, lineHeight: 1.5}}>{section.text}</div>
                )}
              </div>
            );
          })}
        </div>
      )}

      {allSections.filter(function(s) { return !toolIsMeasured(s, _pdfMvb) && s.text; }).length > 0 && (
        <div style={{marginBottom: 14}}>
          <div style={{fontSize: 11, color: S.coral, letterSpacing: 1.2, marginBottom: 10, fontWeight: 700}}>SCOUTING OBSERVATIONS</div>
          {allSections.filter(function(s) { return !toolIsMeasured(s, _pdfMvb) && s.text; }).map(function(section, i) {
            return (
              <div key={i} style={{padding: "7px 9px", background: S.gray50, borderRadius: 6, borderLeft: "3px solid " + S.navy, marginBottom: 6}}>
                <div style={{fontSize: 11, fontWeight: 700, color: S.navy, marginBottom: 2}}>
                  {cleanToolLabel(section.label)}
                </div>
                {section.source && (
                  <div style={{fontSize: 8, color: S.gray500, fontStyle: "italic", marginBottom: 2, lineHeight: 1.3}}>
                    Source: {section.source}
                  </div>
                )}
                <div style={{fontSize: 10, color: S.gray700, lineHeight: 1.45}}>{section.text}</div>
              </div>
            );
          })}
        </div>
      )}

      {/* THE MEASURED MECHANICS BLOCK WAS HERE. DELETED 2026-10-09 BY RULING.
          Luis: *"A drawing path that only fails to print by accident is the percentile track
          again. Same treatment: gone, not disabled."*

          It drew five rows on the CUSTOMER PDF with no admin gate: Hand speed (mph, read from
          `real_units.hand_speed_mph`), Swing tempo (`foot_plant_to_contact_s`), Hip-shoulder,
          Stride and Head move. Measured on the public view before deleting it: 0 of 19 reports
          drew it -- but for two accidents, not a gate. `real_units` happened to be empty on all
          159 public reps, and the `_pct` keys happened to be withheld. One populated `real_units`
          and it would have printed uncalibrated pixels-to-mph on the artifact a family keeps.

          Every row is dead or re-homed: hand speed mph is pixels (uncalibrated by construction);
          swing tempo read `contact_frame`, which is peak hand speed under an old name and lands in
          follow-through; hip-shoulder is the rotation family, dead on physics; stride and head
          move return in Part 2 computed per-frame, where translation and zoom cancel. */}


      {/* A TOOL CANNOT BE BOTH GRADED AND NOT EVALUATED. The absence test reads `source`, so a
          graded tool still sourced "Pending" printed as "Hit 60" under TOOL GRADES and as "Hit"
          under NOT EVALUATED on the same page. A grade IS an evaluation; carrying one settles it.
          Mirrors deriveReportModel() in src/bbotPdfText.js — one rule, both PDF paths. */}
      {allSections.filter(function(s) {
        if (s.grade) return false;
        var txt = (s.text || "").trim();
        if (!txt) return true;
        var src = (s.source || "").toLowerCase();
        var head = txt.toLowerCase().slice(0, 60);
        var phrase = /not observ|not applicable|not measured|not evaluable|requires .*footage|n\/a|pending/;
        return phrase.test(src) || phrase.test(head);
      }).length > 0 && (
        <div style={{marginTop: 14, paddingTop: 10, borderTop: "1px solid " + S.gray200}}>
          <div style={{fontSize: 10, color: S.gray500, fontWeight: 700, marginBottom: 4}}>NOT EVALUATED BY BBOT:</div>
          <div style={{fontSize: 9, color: S.gray500, lineHeight: 1.5}}>
            {allSections.filter(function(s) {
              if (s.grade) return false;
              var txt = (s.text || "").trim();
              if (!txt) return true;
              var src = (s.source || "").toLowerCase();
              var head = txt.toLowerCase().slice(0, 60);
              var phrase = /not observ|not applicable|not measured|not evaluable|requires .*footage|n\/a|pending/;
              return phrase.test(src) || phrase.test(head);
            }).map(function(s) { return cleanToolLabel(s.label); }).join(", ")}
          </div>
        </div>
      )}
    </div>
  );
}

// ============================================================================
// PDF EXPORT — uses clean PDF component (no UI chrome)
// ============================================================================
// MOBILE-FRIENDLY: generate a REAL .pdf file from the on-screen report card and hand it to the
// device. On phones this opens the native share sheet (Save to Files / share anywhere); on desktop
// it downloads the file. Falls back to printPlayerReport() if the library can't load.
function downloadReportPdf(reportId, playerName){
  var srcId = "bbot-report-"+reportId;
  var src = document.getElementById(srcId);
  if(!src){ printPlayerReport(reportId); return; }

  // Resolve report + player from the canonical globals (NOT React-fiber introspection,
  // which is version-fragile and broke on React 19 — when it returned null this function
  // silently fell back to cloneNode below, dragging UI chrome + whitespace into the PDF).
  // Sourcing from window.__bbotReports keeps ReportPdfContent the active, clean render path.
  var _allRpts = (typeof window!=="undefined" && window.__bbotReports) || [];
  var reportData = _allRpts.find(function(x){ return String(x.id)===String(reportId); }) || null;
  var _allUsrs = (typeof window!=="undefined" && window.__bbotUsers) || [];
  var playerCard = reportData ? ((_allUsrs.find(function(u){ return String(u.id)===String(reportData.playerId); })) || reportData.sc || reportData.playerCard || null) : null;

  var wrap, pdfContainer, pdfRoot;
  // If we can't extract data, fall back to cloning (old behavior with enhanced cleanup)
  if (!reportData) {
    var clone = src.cloneNode(true);
    // Remove admin-only content, PDF-omit elements
    Array.prototype.slice.call(clone.querySelectorAll(".admin-only, .bbot-pdf-omit")).forEach(function(el){
      el.parentNode && el.parentNode.removeChild(el);
    });
    // Remove ALL video/iframe/audio elements (creates massive white space)
    Array.prototype.slice.call(clone.querySelectorAll("video, iframe, audio")).forEach(function(el){
      el.parentNode && el.parentNode.removeChild(el);
    });
    // Remove empty div containers that previously held video (background:#000 is typical video container)
    Array.prototype.slice.call(clone.querySelectorAll("div")).forEach(function(el){
      if (el.style.background === "rgb(0, 0, 0)" || el.style.background === "#000") {
        if (!el.textContent.trim() && el.children.length === 0) {
          el.parentNode && el.parentNode.removeChild(el);
        }
      }
    });
    wrap = document.createElement("div");
    wrap.style.cssText = "background:#fff;padding:16px;width:760px;";
    wrap.appendChild(clone);
  } else {
    // Render clean PDF component into temporary container
    pdfContainer = document.createElement("div");
    pdfContainer.style.cssText = "position:absolute;left:-9999px;top:0;";
    document.body.appendChild(pdfContainer);
    // React 19: ReactDOM.render was removed. createRoot commits asynchronously, so flushSync
    // forces a synchronous commit — pdfContainer.firstChild (the node html2pdf captures) must
    // exist before we read it on the next line.
    pdfRoot = createRoot(pdfContainer);
    flushSync(function(){ pdfRoot.render(<ReportPdfContent r={reportData} sc={playerCard}/>); });
    wrap = pdfContainer.firstChild;
  }

  var safeName = (playerName||"BBOT_Report").replace(/[^A-Za-z0-9]+/g,"_").replace(/^_+|_+$/g,"");
  var filename = "643_BBOT_"+safeName+".pdf";
  var opt = {
    margin: [8,8,8,8],
    filename: filename,
    image: { type:"jpeg", quality:0.96 },
    html2canvas: { scale:2, useCORS:true, backgroundColor:"#ffffff", logging:false, windowHeight: wrap.scrollHeight + 100 },
    jsPDF: { unit:"pt", format:"letter", orientation:"portrait" },
    pagebreak: { mode:"css", before:".pdf-page-break" }
  };
  var isMobile = (typeof navigator!=="undefined") && /Android|iPhone|iPad|iPod|Mobile/i.test(navigator.userAgent||"");
  function _cleanupPdf(){ if (pdfContainer && pdfContainer.parentNode){ if (pdfRoot) pdfRoot.unmount(); pdfContainer.parentNode.removeChild(pdfContainer); } }
  function _saveBlob(blob){
    var url = URL.createObjectURL(blob);
    if(isMobile){
      // Mobile: a forced download often fails (iOS Safari). Open the PDF — the viewer has Save/Share.
      window.open(url, "_blank");
    } else {
      var a=document.createElement("a"); a.href=url; a.download=filename; document.body.appendChild(a); a.click(); document.body.removeChild(a);
    }
    setTimeout(function(){ try{ URL.revokeObjectURL(url); }catch(e){} }, 60000);
  }
  // TEXT-NATIVE FIRST. Needs the resolved row (reportData); the clone fallback above has no model
  // to draw from, so that case still photographs.
  if (pdfTextNativeEnabled() && reportData) {
    loadJsPdf().then(function(JsPDF){
      var doc = buildReportPdf(JsPDF, reportData, playerCard);
      if (!doc) throw new Error("no model");
      _cleanupPdf();
      var blob = doc.output("blob");
      try{
        var f = new File([blob], filename, {type:"application/pdf"});
        if(navigator.canShare && navigator.share && navigator.canShare({files:[f]})){
          navigator.share({files:[f], title:filename}).catch(function(){ _saveBlob(blob); });
          return;
        }
      }catch(e){}
      _saveBlob(blob);
    }).catch(function(){
      // fall through to the photograph rather than leave the customer with nothing
      _rasterisePdf();
    });
    return;
  }
  _rasterisePdf();

  function _rasterisePdf(){
  loadHtml2Pdf().then(function(html2pdf){
    // Render the PDF to a blob FIRST (async), THEN clean up the temp DOM — cleaning up before the render
    // finishes was blanking the PDF. One blob drives share (mobile) / open (mobile) / download (desktop).
    html2pdf().set(opt).from(wrap).outputPdf("blob").then(function(blob){
      _cleanupPdf();
      try{
        var file = new File([blob], filename, {type:"application/pdf"});
        if(navigator.canShare && navigator.share && navigator.canShare({files:[file]})){
          navigator.share({files:[file], title:filename}).catch(function(){ _saveBlob(blob); });
          return;
        }
      }catch(e){}
      _saveBlob(blob);
    }).catch(function(){ _cleanupPdf(); printPlayerReport(reportId); });
  }).catch(function(){
    _cleanupPdf();
    printPlayerReport(reportId);
  });
  }
}






function PercentileCard({playerScore, ageGroup, position, userId}){
  var [cohortScores, setCohortScores] = useState(null);
  var [loading, setLoading] = useState(true);

  useEffect(function(){
    // Query approved reports for same age-group cohort to compute percentile
    bbotReports({status:"eq.approved",select:"score,playerId",limit:5000}).then(function(rows){
      rows=(rows||[]).filter(function(x){return x && x.score!=null;});
      // We don't have age_group on reports table, so fall back to a global percentile
      // until backend joins through bbot_measurements
      var scores = (rows||[]).map(function(r){return r.score;}).filter(function(s){return s!=null;});
      setCohortScores(scores);
      setLoading(false);
    }).catch(function(){
      setLoading(false);
    });
  }, [ageGroup, position]);

  var percentile = null;
  if(cohortScores && cohortScores.length >= 5){
    var below = cohortScores.filter(function(s){return s < playerScore;}).length;
    percentile = Math.round((below / cohortScores.length) * 100);
  }

  return (
    <Card style={{padding:14}}>
      <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:11,color:C.coral,letterSpacing:1.2,marginBottom:6}}>AGE-COHORT RANKING</div>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",gap:10,flexWrap:"wrap"}}>
        <div style={{flex:"1 1 160px"}}>
          <div style={{fontSize:13,color:C.gray700}}>Score <strong style={{color:C.navy,fontSize:16}}>{playerScore}</strong></div>
          <div style={{fontSize:11,color:C.gray500,marginTop:2}}>{ageGroup} · {position||"player"}</div>
        </div>
        {loading ? (
          <div style={{fontSize:10,color:C.gray400,fontStyle:"italic"}}>Calculating...</div>
        ) : percentile !== null ? (
          <div style={{textAlign:"right"}}>
            <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:24,color:C.coral,fontWeight:700,lineHeight:1}}>{percentile}<span style={{fontSize:12,color:C.gray500,fontWeight:400}}>th</span></div>
            <div style={{fontSize:9,color:C.gray500,letterSpacing:.5}}>PERCENTILE</div>
          </div>
        ) : (
          <div style={{fontSize:10,color:C.gray400,fontStyle:"italic",maxWidth:160,textAlign:"right",lineHeight:1.4}}>Cohort still building — need 5+ comparable evals</div>
        )}
      </div>
      {percentile !== null && cohortScores && (
        <div style={{marginTop:10,height:5,background:C.gray100,borderRadius:3,overflow:"hidden"}}>
          <div style={{width:percentile+"%",height:"100%",background:"linear-gradient(90deg,"+C.coral+","+C.green+")"}}/>
        </div>
      )}
      {percentile !== null && (
        <div style={{fontSize:9,color:C.gray400,marginTop:6,fontStyle:"italic"}}>Anonymized across {cohortScores.length} BBOT-evaluated players</div>
      )}
    </Card>
  );
}




function R2Video({objectKey}){
  var s=useState(null); var url=s[0]; var setUrl=s[1];
  var e=useState(false); var err=e[0]; var setErr=e[1];
  useEffect(function(){
    if(!objectKey) return;
    fetch(BACKEND_URL+"/r2-read-url?objectKey="+encodeURIComponent(objectKey))
      .then(function(r){return r.json();})
      .then(function(d){ if(d&&d.url) setUrl(d.url); else setErr(true); })
      .catch(function(){ setErr(true); });
  },[objectKey]);
  if(err) return <div style={{padding:"10px 12px",fontSize:11,color:C.gray400,textAlign:"center"}}>Session video unavailable</div>;
  if(!url) return <div style={{padding:"10px 12px",fontSize:11,color:C.gray400,textAlign:"center"}}>Loading video…</div>;
  return <div style={{background:"#000"}}><video {...bbotVideoGuard()} src={url} controls playsInline style={{width:"100%",maxHeight:240,display:"block"}}/></div>;
}

// Looping native preview of an uploaded master video (resolves R2 objectKey → signed URL)
function MasterVideoPreview({objectKey}){
  var s=useState(null); var url=s[0]; var setUrl=s[1];
  var e=useState(false); var err=e[0]; var setErr=e[1];
  useEffect(function(){
    if(!objectKey) return;
    fetch(BACKEND_URL+"/r2-read-url?objectKey="+encodeURIComponent(objectKey))
      .then(function(r){return r.json();}).then(function(d){ if(d&&d.url) setUrl(d.url); else setErr(true); })
      .catch(function(){ setErr(true); });
  },[objectKey]);
  if(err) return null;
  if(!url) return <div style={{padding:"10px",fontSize:11,color:C.gray400,textAlign:"center",marginBottom:14}}>Loading master video preview…</div>;
  return <div style={{marginBottom:14,borderRadius:8,overflow:"hidden",background:"#000"}}>
    <div style={{fontSize:10,color:C.gray400,letterSpacing:.5,padding:"6px 8px",background:C.gray50}}>MASTER VIDEO PREVIEW (loops)</div>
    <video {...bbotVideoGuard()} src={url} controls autoPlay loop muted playsInline style={{width:"100%",maxHeight:300,display:"block"}}/>
  </div>;
}

// TAGGING MVP — deterministic segmentation (no AI, no guessing, no API cost). Admin scrubs the master and
// tags (time + player) where each player's segment STARTS; each player owns [their tag -> the next tag),
// last -> end of video. Builds ClipSegment-shaped segments via /segment-from-tags and hands them to the
// existing review + generate-clips flow (onProposal). Cross-contamination is impossible by construction.
// SOLO MODE, ruled by Luis 2026-10-20: *"on individual only tag activity and clone everything else
// from mass segmentation tagging including the frame and reduced video speed capabilities"* and
// *"no need to tag player name as its already individually labeled."*
//
// WHY A MODE AND NOT A SECOND COMPONENT. An individual evaluation needs exactly this tagger minus
// the player dimension — same activity vocabulary, same millisecond readout, same frame step, same
// 0.1x-1x preview speed, same /segment-from-tags. Cloning it would create two implementations of
// the tagging contract that drift apart, and the frame/speed controls are precisely the part that
// must not drift: they are how an admin lands a boundary on the right frame.
//
// WHY IT MATTERS, measured 2026-10-20: an individual evaluation with no segmentation row produces
// NO activityBlocks, so the backend falls back to `nearest-velocity-frame` and derives the blocks.
// Jeniel's derived blocks put 10 of his 15 exit velocities inside a `throwing` span — the device
// said he was hitting and the tagging said otherwise, because nothing tagged it.
// [[mass-seg-tag-at-upload-architecture]] [[existing-pattern-before-assumed-api]]
//
// `soloPlayer` = {playerId, playerName, jerseyNum}. Present -> the player picker is hidden and every
// tag carries that player. Absent -> unchanged behaviour, which is what the mass path keeps using.
function TagSegmenter({objectKey, lineup, sessionType, sessionDate, onProposal, notify, soloPlayer}){
  var uS=useState(""); var url=uS[0], setUrl=uS[1];
  var tS=useState([]); var tags=tS[0], setTags=tS[1];
  var pS=useState(""); var pick=pS[0], setPick=pS[1];
  var bS=useState(false); var busy=bS[0], setBusy=bS[1];
  var acS=useState([]); var chunks=acS[0], setChunks=acS[1];
  var adS=useState(false); var detecting=adS[0], setDetecting=adS[1];
  var spS=useState(1); var speed=spS[0], setSpeedState=spS[1];   // PREVIEW playback speed only (slow-mo for precise tagging)
  var ctS=useState(0); var curT=ctS[0], setCurT=ctS[1];          // live preview time for a millisecond readout
  var catS=useState("at_bat"); var cat=catS[0], setCat=catS[1];  // sticky activity → BBOT renders ONE skeleton per activity
  var vid=useRef(null);
  // Activity per tag (Run/Field/Hit) — the canonical actionType values match the review table. BBOT renders
  // one tracked-motion skeleton PER activity a player did; the tag is how it knows which is which (never guessed).
  var CAT_OPTS=[{v:"baserunning",l:"Run"},{v:"fielding_play",l:"Field"},{v:"at_bat",l:"Hit"},{v:"throwing",l:"Throw"},{v:"pitching",l:"Pitch"}];
  function catLabel(a){ var o=CAT_OPTS.find(function(x){return x.v===a;}); return o?o.l:(a||"Play"); }
  // Slow the TAGGING PREVIEW only — a browser playbackRate on the <video {...bbotVideoGuard()}>, never the file. Tag timestamps
  // are real seconds regardless of play speed, and this never touches the rinse/clip.
  function setSpeed(r){ setSpeedState(r); var v=vid.current; if(v){ try{ v.playbackRate=r; }catch(e){} } }
  function fmtMs(s){ s=Math.max(0,s||0); var m=Math.floor(s/60); var ss=s-m*60; return m+":"+(ss<10?"0":"")+ss.toFixed(3); }
  // Frame-step the PREVIEW for millisecond-precise tagging: pause, nudge currentTime by ~one 30fps frame.
  function step(delta){ var v=vid.current; if(!v) return; try{ v.pause(); }catch(e){} try{ v.currentTime=Math.max(0,(v.currentTime||0)+delta); setCurT(v.currentTime); }catch(e){} }
  useEffect(function(){
    if(!objectKey) return;
    fetch(BACKEND_URL+"/r2-read-url?objectKey="+encodeURIComponent(objectKey),{headers:bbotAdminHeaders()})
      .then(function(r){return r.json();}).then(function(d){ if(d&&d.url) setUrl(d.url); }).catch(function(){});
  },[objectKey]);
  function fmt(s){ s=Math.max(0,Math.round(s||0)); var m=Math.floor(s/60); var ss=s%60; return m+":"+(ss<10?"0":"")+ss; }
  function tagHere(){
    var v=vid.current; if(!v){ notify&&notify("Video not ready","error"); return; }
    // IN SOLO MODE THE PLAYER IS NOT A QUESTION. Every tag on an individual evaluation belongs to
    // the one athlete the session is already labelled with, so asking again is a chance to answer
    // it wrong. [[human-input-is-a-defect]]
    var e;
    if(soloPlayer){
      e={playerId:soloPlayer.playerId?String(soloPlayer.playerId):null,
         playerName:soloPlayer.playerName||"", jerseyNum:String(soloPlayer.jerseyNum||"")};
    } else {
      if(pick===""){ notify&&notify("Pick a player for this tag first","error"); return; }
      e=(lineup||[])[Number(pick)]; if(!e){ return; }
    }
    var t=Math.round((v.currentTime||0)*1000)/1000;   // millisecond precision — keep the exact tagged instant
    setTags(function(prev){
      return prev.concat([{timeSec:t, playerId:e.playerId?String(e.playerId):null, playerName:e.playerName||("#"+e.jerseyNum), jerseyNum:String(e.jerseyNum||""), actionType:cat}])
        .sort(function(a,b){return a.timeSec-b.timeSec;});
    });
  }
  function del(i){ setTags(function(prev){return prev.filter(function(_,idx){return idx!==i;});}); }
  function jumpTo(t){ var v=vid.current; if(v){ try{ v.currentTime=Math.max(0,t); v.play&&v.play(); }catch(e){} } }
  // AUTO-DETECT ACTIVITY: BBOT scans the master for the chunks where something is happening (dead time
  // dropped) so you jump to each active region and tag WHO — instead of hunting boundaries. Timing only,
  // never identity. Fallback-safe: on any failure it returns nothing and you tag by hand as before.
  function detectActivity(){
    if(detecting) return;
    setDetecting(true);
    setChunks([]);
    notify&&notify("Scanning for activity… this can take a minute on a long video.");
    var dur=(vid.current&&isFinite(vid.current.duration))?vid.current.duration:null;
    fetch(BACKEND_URL+"/detect-activity",{method:"POST",headers:bbotAdminHeaders(),
      body:JSON.stringify({objectKey:objectKey, videoDurationSec:dur})})
      .then(function(r){ if(!r.ok) return r.text().then(function(t){throw new Error(t||("HTTP "+r.status));}); return r.json(); })
      .then(function(res){
        var w=res.windows||[];
        setChunks(w);
        notify&&notify(w.length?((w.length)+" activity chunk"+(w.length===1?"":"s")+" found — tap one to jump there, then tag who's active."):"No clear activity chunks — tag by hand.");
      })
      .catch(function(err){ notify&&notify("Auto-detect unavailable ("+(err.message||"error")+") — tag by hand.","error"); })
      .finally(function(){ setDetecting(false); });
  }
  function build(){
    if(!tags.length){ notify&&notify("Add at least one tag","error"); return; }
    var dur=(vid.current&&isFinite(vid.current.duration))?vid.current.duration:null;
    // SOLO MODE DOES NOT CUT SEGMENTS, IT NAMES ACTIVITIES. There is one player and one continuous
    // video, so there is nothing to split by identity -- the output is the activity blocks the
    // evaluation needs, in source time. Going through /segment-from-tags here would build a
    // concatenated clip out of a video that was never fragmented.
    if(soloPlayer){
      var _b=bbotSoloActivityBlocks(tags, dur);
      if(!_b.length){ notify&&notify("No activity spans — check the tags","error"); return; }
      notify&&notify(_b.length+" activity block"+(_b.length===1?"":"s")+" tagged");
      onProposal&&onProposal({soloBlocks:_b, tags:tags, videoDurationSec:dur});
      return;
    }
    setBusy(true);
    fetch(BACKEND_URL+"/segment-from-tags",{method:"POST",headers:bbotAdminHeaders(),
      body:JSON.stringify({objectKey:objectKey, tags:tags, videoDurationSec:dur, sessionType:sessionType, sessionDate:sessionDate})})
      .then(function(r){ if(!r.ok) return r.text().then(function(t){throw new Error(t||("HTTP "+r.status));}); return r.json(); })
      .then(function(res){ notify&&notify(res.count+" segment"+(res.count===1?"":"s")+" from "+tags.length+" tag"+(tags.length===1?"":"s")); onProposal&&onProposal(res); })
      .catch(function(err){ notify&&notify("Build failed: "+(err.message||"error"),"error"); })
      .finally(function(){ setBusy(false); });
  }
  return (
    <div style={{border:"1px solid "+C.border,borderRadius:8,padding:12,marginBottom:14,background:C.white}}>
      <div style={{fontSize:11,fontWeight:700,color:C.navy,letterSpacing:.5,marginBottom:2}}>{soloPlayer?"TAG ACTIVITIES":"TAG MANUALLY"}</div>
      <div style={{fontSize:10,color:C.gray500,marginBottom:8}}>{soloPlayer
        ? ("Free · deterministic · no guessing. Scrub to where each activity STARTS, pick Run / Field / Hit / Throw / Pitch, tap Tag. Every tag belongs to "+(soloPlayer.playerName||"this player")+" — the session is already individually labelled.")
        : "Free · deterministic · no guessing. Scrub to where a player's segment starts, pick the player, tap Tag."}</div>
      {url ? <video {...bbotVideoGuard()} ref={vid} src={url} controls playsInline onLoadedMetadata={function(){var v=vid.current; if(v){try{v.playbackRate=speed;}catch(e){}}}} onPlay={function(){var v=vid.current; if(v){try{v.playbackRate=speed;}catch(e){}}}} onTimeUpdate={function(){var v=vid.current; if(v) setCurT(v.currentTime);}} onSeeked={function(){var v=vid.current; if(v) setCurT(v.currentTime);}} style={{width:"100%",maxHeight:320,borderRadius:6,background:"#000",display:"block",marginBottom:10}}/>
           : <div style={{padding:16,fontSize:11,color:C.gray400,textAlign:"center"}}>Loading video…</div>}
      <div style={{display:"flex",gap:6,alignItems:"center",flexWrap:"wrap",marginBottom:8}}>
        <span style={{fontSize:11,color:C.gray500,fontWeight:600}}>Speed:</span>
        {[0.1,0.25,0.5,1].map(function(r){return <button key={r} onClick={function(){setSpeed(r);}} style={{padding:"4px 10px",borderRadius:6,border:"1px solid "+(speed===r?C.blue:C.border),background:speed===r?C.blue:C.white,color:speed===r?C.white:C.navy,fontSize:11,fontWeight:700,cursor:"pointer"}}>{r===1?"Normal":(r+"×")}</button>;})}
      </div>
      <div style={{display:"flex",gap:6,alignItems:"center",flexWrap:"wrap",marginBottom:10}}>
        <span style={{fontSize:11,color:C.gray500,fontWeight:600}}>Frame:</span>
        <button onClick={function(){step(-1/30);}} title="Back one frame (~33ms)" style={{padding:"4px 10px",borderRadius:6,border:"1px solid "+C.border,background:C.white,color:C.navy,fontSize:11,fontWeight:700,cursor:"pointer"}}>◀ frame</button>
        <button onClick={function(){step(1/30);}} title="Forward one frame (~33ms)" style={{padding:"4px 10px",borderRadius:6,border:"1px solid "+C.border,background:C.white,color:C.navy,fontSize:11,fontWeight:700,cursor:"pointer"}}>frame ▶</button>
        <span style={{fontSize:12,color:C.blue,fontWeight:700,fontFamily:"monospace",marginLeft:4}}>{fmtMs(curT)}</span>
        <span style={{fontSize:10,color:C.gray400}}>pause + step frame-by-frame for exact tags · preview only, never affects the clip</span>
      </div>
      <div style={{display:"flex",gap:8,alignItems:"center",flexWrap:"wrap",marginBottom:10}}>
        {soloPlayer
          ? <span style={{padding:"7px 10px",border:"1px solid "+C.border,borderRadius:6,fontSize:12,
                          background:C.gray50,color:C.navy,fontWeight:600,minWidth:170,
                          display:"inline-block"}}
                  title="This session is an individual evaluation — every tag belongs to this player">
              {soloPlayer.playerName||"This player"}{soloPlayer.jerseyNum?(" · #"+soloPlayer.jerseyNum):""}
            </span>
          : <select value={pick} onChange={function(e){setPick(e.target.value);}} style={{padding:"7px 10px",border:"1px solid "+C.border,borderRadius:6,fontSize:12,background:C.white,minWidth:170}}>
              <option value="">Player for this tag…</option>
              {(lineup||[]).map(function(e,i){return <option key={i} value={i}>{(e.playerName||("#"+e.jerseyNum||"?"))+(e.jerseyNum?(" · #"+e.jerseyNum):"")}</option>;})}
            </select>}
        <select value={cat} onChange={function(e){setCat(e.target.value);}} title="Activity — BBOT renders one skeleton per activity a player did (Run / Field / Hit)" style={{padding:"7px 10px",border:"1px solid "+C.coral,borderRadius:6,fontSize:12,background:C.white,fontWeight:600,color:C.navy}}>
          {CAT_OPTS.map(function(o){return <option key={o.v} value={o.v}>{o.l}</option>;})}
        </select>
        <Btn v="primary" style={{fontSize:12}} onClick={tagHere}>+ Tag at current time</Btn>
        <Btn v="ghost" style={{fontSize:12}} onClick={detectActivity} disabled={detecting}>{detecting?"⏳ Scanning…":"⚡ Auto-detect activity"}</Btn>
      </div>
      {chunks.length>0 && <div style={{marginBottom:10,padding:"8px 10px",background:C.blueFaint,border:"1px solid "+C.blueLight,borderRadius:8}}>
        <div style={{fontSize:10,fontWeight:700,color:C.navy,letterSpacing:.5,marginBottom:6}}>⚡ ACTIVITY CHUNKS (dead time skipped) — tap to jump, then tag who's active</div>
        <div style={{display:"flex",flexWrap:"wrap",gap:6}}>
          {chunks.map(function(c,i){return (
            <button key={i} onClick={function(){jumpTo(c.startSec);}} title={"Jump to "+fmt(c.startSec)} style={{padding:"5px 9px",borderRadius:6,border:"1px solid "+C.blue,background:C.white,color:C.blue,fontSize:11,fontWeight:600,cursor:"pointer"}}>{fmt(c.startSec)}–{fmt(c.endSec)} ({Math.round(c.durationSec)}s)</button>
          );})}
        </div>
        <div style={{fontSize:10,color:C.gray400,marginTop:6}}>{soloPlayer
          ? "BBOT found where the action is — you still tag WHAT (the activity is never guessed)."
          : "BBOT found where the action is — you still tag WHO (identity is never guessed)."}</div>
      </div>}
      {tags.length>0 && <div style={{marginBottom:10}}>
        {tags.map(function(t,i){return (
          <div key={i} style={{display:"flex",justifyContent:"space-between",alignItems:"center",fontSize:12,padding:"5px 8px",borderBottom:"1px solid "+C.gray100}}>
            <span><strong style={{color:C.navy}}>{fmt(t.timeSec)}</strong> · {t.playerName||("#"+t.jerseyNum)}{t.actionType?(" · "+catLabel(t.actionType)):""}</span>
            <span onClick={function(){del(i);}} style={{cursor:"pointer",color:C.coral,fontSize:11}}>remove</span>
          </div>
        );})}
        <div style={{fontSize:10,color:C.gray400,marginTop:6}}>Each tag owns that player's turn (dead time auto-trimmed) · tap again for a longer turn — repeated taps merge.</div>
      </div>}
      <Btn v="coral" style={{fontSize:13,opacity:busy?0.6:1}} onClick={function(){ if(!busy) build(); }}>{busy?"Building…":("Build "+tags.length+" segment"+(tags.length===1?"":"s")+" → review")}</Btn>
    </div>
  );
}

// Normalize legacy tool labels from older reports stored in the DB.
// Older prompt versions emitted "Power-Strength" / "Raw Power"; display "Power".
function cleanToolLabel(label){
  if(!label) return label;
  var l = String(label);
  if(/power[\s\-–]*strength/i.test(l) || /^raw\s+power$/i.test(l) || /^raw\s*&\s*power$/i.test(l)) return "Power";
  return l;
}

var TOOL_DESC={
  run:"Footspeed and base-running quickness (home-to-first, range).",
  throw:"Arm strength and throwing velocity.",
  arm:"Arm strength and throwing velocity.",
  popTime:"Catcher's release time, glove-to-glove on throws to second.",
  receiving:"Framing, blocking, and glove control behind the plate.",
  fielding:"Defensive actions, footwork, hands, and range.",
  plateDis:"Pitch recognition, swing decisions, and strike-zone control.",
  batBall:"Ability to make consistent, square contact.",
  exitVelo:"Ball speed off the bat at contact.",
  approach:"At-bat plan, timing, and adjustments.",
  rawPower:"Power potential and ability to drive the ball.",
  hit:"Hitting ability and contact quality.",
  power:"Game power and ability to drive the ball.",
  field:"Defensive actions, footwork, hands, and range.",
  fastball:"Fastball velocity and life.",
  command:"Ability to locate pitches in and around the zone.",
  breaking:"Shape, sharpness, and control of breaking pitches.",
  changeup:"Off-speed deception and arm-speed consistency.",
  control:"Strike-throwing and walk avoidance.",
  delivery:"Mechanics, repeatability, and arm action."
};

// PITCH ZONE MAP — 9-zone density visualization for pitcher tendency
// Gate: REACT_APP_BBOT_PITCH_ZONE (default OFF, dormant until flipped)
// Shows pitch clustering from CF angle footage. Honest absence: pitchZone null → renders nothing.
const PITCH_ZONE_ENABLED = false; // Flip to true when backend BBOT_PITCH_ZONE is ON

function PitchZoneMap({pitchZone, collapsed}) {
  var [open, setOpen] = useState(!collapsed);

  if (!PITCH_ZONE_ENABLED || !pitchZone || !pitchZone.zones || pitchZone.zones.length === 0) {
    // Honest absence — feature simply doesn't appear
    return null;
  }

  var zones = pitchZone.zones || [];
  var total = pitchZone.totalPitches || 0;
  var disclaimer = pitchZone.disclaimer || "Pitch tendency estimated from CF angle footage. Locations are approximate, not radar-tracked or sensor-measured.";

  // Build zone grid data structure (9 zones)
  var zoneGrid = {};
  zones.forEach(function(z) {
    zoneGrid[z.zone] = {count: z.count, pct: z.pct};
  });

  // Get zone data helper
  function getZone(v, h) {
    var key = v + "_" + h;
    return zoneGrid[key] || {count: 0, pct: 0};
  }

  // Color density scale based on percentage
  function densityColor(pct) {
    if (pct === 0) return C.gray50;           // No pitches
    if (pct < 16) return "rgba(232,82,106,0.2)";  // Very light coral
    if (pct < 31) return "rgba(232,82,106,0.4)";  // Light coral
    if (pct < 51) return "rgba(232,82,106,0.6)";  // Medium coral
    return "rgba(232,82,106,0.8)";                // Darker coral (51%+)
  }

  var rows = [
    {label: "UPPER", vertical: "upper"},
    {label: "MIDDLE", vertical: "middle"},
    {label: "LOWER", vertical: "lower"}
  ];
  var cols = ["glove", "middle", "arm"];
  var colLabels = {glove: "GLOVE", middle: "MIDDLE", arm: "ARM"};

  return (
    <div style={{marginBottom: 16, border: "1px solid " + C.border, borderRadius: 8, overflow: "hidden"}}>
      {/* Header - collapsible */}
      <div
        onClick={function() { setOpen(!open); }}
        style={{
          background: C.gray50,
          padding: "12px 16px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          cursor: "pointer",
          borderBottom: open ? "1px solid " + C.border : "none"
        }}
      >
        <div>
          <div style={{fontFamily: "Inter,system-ui,sans-serif", fontSize: 13, color: C.navy, letterSpacing: 1, fontWeight: 700}}>
            PITCH TENDENCY ZONE
          </div>
          <div style={{fontSize: 10, color: C.gray500, marginTop: 2}}>
            {total} pitch{total === 1 ? "" : "es"} mapped
          </div>
        </div>
        <div style={{fontSize: 14, color: C.gray400}}>{open ? "▼" : "▶"}</div>
      </div>

      {/* Zone grid - only shown when expanded */}
      {open && (
        <div style={{padding: 16}}>
          {/* Column headers */}
          <div style={{display: "grid", gridTemplateColumns: "80px repeat(3, 1fr)", gap: 8, marginBottom: 8}}>
            <div></div>
            {cols.map(function(h) {
              return (
                <div key={h} style={{textAlign: "center", fontSize: 9, color: C.gray500, fontWeight: 600, letterSpacing: 0.5}}>
                  {colLabels[h]} SIDE
                </div>
              );
            })}
          </div>

          {/* Zone grid rows */}
          {rows.map(function(row) {
            return (
              <div key={row.vertical} style={{display: "grid", gridTemplateColumns: "80px repeat(3, 1fr)", gap: 8, marginBottom: 8}}>
                {/* Row label */}
                <div style={{display: "flex", alignItems: "center", fontSize: 9, color: C.gray500, fontWeight: 600, letterSpacing: 0.5}}>
                  {row.label}
                </div>

                {/* Zone cells */}
                {cols.map(function(h) {
                  var zone = getZone(row.vertical, h);
                  var bgColor = densityColor(zone.pct);

                  return (
                    <div
                      key={h}
                      style={{
                        background: bgColor,
                        border: "1.5px solid " + C.navy,
                        borderRadius: 4,
                        padding: "16px 8px",
                        textAlign: "center",
                        minHeight: 70,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center"
                      }}
                    >
                      <div style={{fontSize: 20, fontWeight: 700, color: C.navy, lineHeight: 1}}>
                        {zone.count}
                      </div>
                      <div style={{fontSize: 11, color: C.gray600, marginTop: 4}}>
                        {zone.pct.toFixed(1)}%
                      </div>
                    </div>
                  );
                })}
              </div>
            );
          })}

          {/* Honest disclaimer - always shown */}
          <div style={{
            marginTop: 16,
            padding: 12,
            background: C.blueFaint,
            border: "1px solid " + C.blueLight,
            borderRadius: 6,
            fontSize: 10,
            color: C.gray600,
            lineHeight: 1.5,
            fontStyle: "italic"
          }}>
            {disclaimer}
          </div>
        </div>
      )}
    </div>
  );
}

// THE GRADE DISCLOSURE TRACK WAS HERE, AND IT IS GONE (Luis, 2026-10-09).
//
// It drew a value, a dot on a blue-to-coral gradient, and the words "<n>th percentile · <bracket>"
// -- on the customer PDF, ungated. The percentile behind it is interpolated off a fixed curve in
// BbotBoxReport.js (`_TIMED_CFG.dials`: an anchor, a per-bracket multiplier, a fixed spread). No
// BBOT player, rep or session is in that curve, so the sentence it printed -- this is where he
// sits among his age peers -- described a population that does not exist.
//
// DELETED RATHER THAN DISABLED, and the ruling is the reason: "the record doesn't keep two paths
// alive ... the only thing that can turn a placement back on is Part 5b clearing n for a real
// pool, built then, not flipped." A placement against a real pool is a different quantity --
// counted against a named cohort with its n stated -- and it gets written against that cohort.
// Reviving this component would not be that.
//
// `gradeBasis` itself still rides on the row: the measured value and the bracket in it are real.
// Only the drawing is gone. [[credibility-decision-all-surfaces]]

// ONE TRUTH PER PLAYER, ENFORCED AT THE QUEUE. The approval queue is the last place a report can be
// caught before it becomes the player's record, and it was showing two reports for one player that
// contradicted each other on core marks -- both looking equally approvable, with nothing on screen
// saying one had already been replaced. Deciding between them was left to whoever happened to be
// reading, which is exactly the judgement a constraint is supposed to remove.
//
// Two rules, in one place because the filter was duplicated three times and drifted:
//   1. Only live drafts are approvable (superseded rows no longer reach the client at all).
//   2. Where a player has more than one report FOR THE SAME SESSION, only the newest is offered.
//
// SCOPED PER SESSION, NOT PER PLAYER. A player legitimately has one report per session, and
// collapsing to one per player would hide his second session entirely -- turning a constraint that
// exists to prevent contradiction into one that destroys history. Two evaluations of two different
// days are both true; two evaluations of the same day are the defect this catches.
function approvableQueue(recaps, scoutReports){
  var out = (recaps||[]).filter(function(p){
    if(p.status!=="pending") return false;
    var rep=(scoutReports||[]).find(function(r){return String(r.id)===String(p.reportId);});
    return rep && isDraftEval(rep);
  });
  function sessionKeyOf(rep,p){
    // THE SESSION IS THE RECORDING, AND A RECORDING IS ITS BYTES. Keying on player-plus-date let two
    // reports of ONE recording render side by side: the same footage re-uploaded carried a different
    // session date, so the queue read two sessions and offered both, contradicting each other on the
    // marks. The ETag is stamped on every report and proves they are the same film, so it wins.
    var pid=String(rep.playerId||p.playerId||"");
    var fr=rep.fullReport||rep.full_report||rep||{};
    var prov=(rep.videoProvenance||fr.videoProvenance)||{};
    if(prov.etag) return pid+"|etag:"+String(prov.etag);
    // No fingerprint: fall back to the day, and where there is no day either, keep the report
    // distinct rather than colliding it with every other undated report for that player.
    var day=rep.date||rep.sessionDate||rep.session_date||"";
    return pid+"|"+(day||("report:"+String(p.reportId)));
  }
  var newestBySession = {};
  out.forEach(function(p){
    var rep=(scoutReports||[]).find(function(r){return String(r.id)===String(p.reportId);})||{};
    var k=sessionKeyOf(rep,p);
    var prev=newestBySession[k];
    var t=Date.parse(rep.created_at||"")||Number(rep.id)||0;
    if(!prev || t>prev.t) newestBySession[k]={t:t,reportId:String(p.reportId)};
  });
  return out.filter(function(p){
    var rep=(scoutReports||[]).find(function(r){return String(r.id)===String(p.reportId);})||{};
    var keep=newestBySession[sessionKeyOf(rep,p)];
    return !keep || keep.reportId===String(p.reportId);
  });
}


// ── ONE SURFACE: THE APP SHOWS THE CARD ITSELF ────────────────────────────────────────────────
// Ratified 2026-08-14. There is now exactly ONE composed report artifact in the product, and every
// surface serves it. This component fetches the SAME bytes the /card route publishes -- the ones
// already gated, fidelity-diffed against the row and verified 84/84 on the deployed surface -- and
// renders them. It composes nothing.
//
// WHY THIS REPLACED A LOCAL COMPOSER. The in-app view built its own text version from the stored
// row, and that second composer drifted: it printed "Home-to-first 4.25s" out of stale stored prose
// while the card's tile withheld the same value for having no timer behind it. One surface asserting
// what another refuses is not a rendering bug, it is two products. A local composer cannot be kept
// in step by discipline; the only durable fix is that there is no second composer.
//
// The iframe is deliberate: the card is a complete document with its own stylesheet, and srcDoc
// isolates it so the app's CSS cannot reach in and restyle a verified artifact.
function ServedCard({reportId, playerName}){
  var st = useState({state:"loading", html:"", err:""});
  var s = st[0], setS = st[1];
  var frameRef = useRef(null);
  var hState = useState(900); var frameH = hState[0], setFrameH = hState[1];

  useEffect(function(){
    var dead = false;
    setS({state:"loading", html:"", err:""});
    fetch(BACKEND_URL + "/card/" + encodeURIComponent(String(reportId)), {headers: bbotAdminHeaders()})
      .then(function(res){
        if(res.status === 404) return res.text().then(function(){ throw {kind:"none"}; });
        if(res.status === 403) throw {kind:"forbidden"};
        if(!res.ok) throw {kind:"error", code:res.status};
        return res.text();
      })
      .then(function(html){ if(!dead) setS({state:"ok", html:html, err:""}); })
      .catch(function(e){
        if(dead) return;
        setS({state:(e && e.kind) || "error", html:"",
              err:(e && e.code) ? ("HTTP " + e.code) : ""});
      });
    return function(){ dead = true; };
  }, [reportId]);

  // The card is a fixed-width document; measure it once loaded so the frame never scrolls
  // internally. A report inside a scrollbar is a worse artifact than the one it replaced.
  function onLoad(){
    try{
      var d = frameRef.current && frameRef.current.contentDocument;
      if(d && d.body) setFrameH(Math.max(600, d.body.scrollHeight + 24));
    }catch(e){/* cross-origin can't happen with srcDoc, but never break the page for a height */}
  }

  if(s.state === "loading"){
    return <div style={{padding:"22px",fontSize:13,color:C.gray500,fontFamily:"Inter,system-ui,sans-serif"}}>Loading the evaluation card…</div>;
  }
  if(s.state === "none"){
    return <div style={{padding:"18px 22px",fontSize:13,color:"#8a6b3d",background:"#fffbf4",
                        border:"1px dashed #e8c89a",borderRadius:10,fontFamily:"Inter,system-ui,sans-serif",lineHeight:1.6}}>
      <b>No card has been published for this evaluation yet.</b><br/>
      The card is the only report surface — nothing is composed here from stored text. Publish it and it appears.
    </div>;
  }
  if(s.state === "forbidden"){
    return <div style={{padding:"18px 22px",fontSize:13,color:C.gray500,fontFamily:"Inter,system-ui,sans-serif"}}>
      This evaluation belongs to another player. Sign in as that player, or as staff, to view it.
    </div>;
  }
  if(s.state === "error"){
    return <div style={{padding:"18px 22px",fontSize:13,color:"#b91c1c",fontFamily:"Inter,system-ui,sans-serif"}}>
      The evaluation card could not be loaded{s.err?(" ("+s.err+")"):""}. Reload the page — the card itself is unaffected.
    </div>;
  }
  return <iframe ref={frameRef} title={"BBOT card " + (playerName||reportId)} srcDoc={s.html}
                 onLoad={onLoad} scrolling="no"
                 style={{width:"100%", height:frameH+"px", border:"none", display:"block", background:"#fff"}}/>;
}


function ReportCard({r,sc,isDraft,isAdmin,defaultOpen}){
  var openState=useState(!!defaultOpen); var open=openState[0]; var setOpen=openState[1];
  var retryState=useState(false); var retrying=retryState[0]; var setRetrying=retryState[1];
  var _gradeTimer=useRef(null);   // debounce for admin grade-override saves on the box report
  var editGradeState=useState(false); var editingGrades=editGradeState[0]; var setEditingGrades=editGradeState[1];
  var chartOpenS=useState(false); var chartOpen=chartOpenS[0]; var setChartOpen=chartOpenS[1];

  // ----- PLAYER EVALUATION (cumulative) renders distinctly from session evals -----
  // Guard: only treat as cumulative if tagged player_eval AND it actually carries
  // cumulative "tools" data. A single session carries "sections" — never render it
  // as cumulative even if report_type got mis-set.
  var _peData = r.fullReport || r;
  var _isCumulative = r.reportType==="player_eval" && Array.isArray(_peData.tools) && _peData.tools.length>0 && !(Array.isArray(r.sections) && r.sections.length>0);
  if(_isCumulative){
    var pe = _peData;
    var tools = pe.tools || [];
    var trendIcon = function(t){ return t==="up"?"▲":t==="down"?"▼":"—"; };
    var trendCol = function(t){ return t==="up"?C.blue:t==="down"?C.coral:C.gray400; };
    return (
      <div id={"bbot-report-"+r.id} data-video-url={(pe.reelUrl||r.reelUrl||r.videoUrl||r.video_url||"")} style={{border:"1px solid "+C.coral,borderRadius:12,marginBottom:12,overflow:"hidden",background:C.white}}>
        <div style={{height:3,background:C.coral}}/>
        <div style={{padding:"12px 14px",display:"flex",justifyContent:"space-between",alignItems:"center",cursor:"pointer",gap:10}} onClick={function(){setOpen(!open);}}>
          <div>
            <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:13,color:C.coral,letterSpacing:1,fontWeight:700}}>PLAYER EVALUATION</div>
            <div style={{fontSize:11,color:C.gray500,marginTop:2}}>{pe.sessionsAnalyzed?pe.sessionsAnalyzed+" sessions":""}{pe.dateSpan?" · "+pe.dateSpan:""}</div>
          </div>
          <span style={{color:C.gray400,fontSize:11}}>{open?"▲":"▼"}</span>
        </div>
        {open&&(
          <div style={{padding:"0 14px 14px"}}>
            {/* PLAYER HEADER CARD — mirrors the Sample Report */}
            {sc && (function(){
              var bioLine = [sc.position, sc.gradYear?("Class "+sc.gradYear):null, sc.height, sc.weight?(sc.weight+" lbs"):null, (sc.bats||sc.throws)?((sc.bats||"-")+"/"+(sc.throws||"-")):null].filter(Boolean).join(" · ");
              var mv = pe.measuredValues || {};
              var chip = function(label){ var c=(pe.summaryChips||[]).find(function(x){return String(x.label||"").toLowerCase().indexOf(label.toLowerCase())>=0;}); return c?c.value:null; };
              var cells = [
                ["H-to-1st", chip("h-to-1")||chip("home")||(mv.h2f?mv.h2f+"s":null)],
                ["Top EV", chip("ev")||chip("exit")||(mv.exitVeloPeak?mv.exitVeloPeak+" mph":null)],
                ["60-yd", chip("60")||(mv.dash60?mv.dash60+"s":null)],
                ["Throw", chip("throw")||chip("arm")||(mv.throwVelo?mv.throwVelo+" mph":null)],
              ].filter(function(c){return c[1];});
              return (
                <div style={{background:C.navy,borderRadius:12,padding:14,marginBottom:12,color:C.white}}>
                  <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:16,letterSpacing:1,marginBottom:bioLine?3:0}}>{(sc.firstName||"")+" "+(sc.lastName||"")}</div>
                  {bioLine&&<div style={{fontSize:11,color:"rgba(255,255,255,.6)",marginBottom:cells.length?10:0}}>{bioLine}</div>}
                  {cells.length>0&&(
                    <div style={{display:"grid",gridTemplateColumns:"repeat("+Math.min(cells.length,4)+",1fr)",gap:6}}>
                      {cells.map(function(c){return (
                        <div key={c[0]} style={{background:"rgba(255,255,255,0.08)",padding:"6px 8px",borderRadius:6,textAlign:"center"}}>
                          <div style={{fontSize:8,color:"rgba(255,255,255,0.62)",letterSpacing:.5}}>{c[0].toUpperCase()}</div>
                          <div style={{fontSize:13,fontWeight:700,marginTop:2}}>{c[1]}</div>
                        </div>
                      );})}
                    </div>
                  )}
                </div>
              );
            })()}
            {/* TOOL GRADES — sample-style rows with bars */}
            {tools.length>0&&(
              <div style={{marginBottom:12}}>
                <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:11,letterSpacing:1.2,color:C.coral,marginBottom:10}}>TOOL GRADES</div>
                {/* VERTICAL BAR CHART — tool profile at a glance (20–80 scale) */}
                <div style={{display:"flex",alignItems:"flex-end",justifyContent:"space-around",gap:6,height:140,padding:"0 4px 4px",marginBottom:14,borderBottom:"2px solid "+C.gray200,position:"relative"}}>
                  {/* 50 (Average) reference line */}
                  <div style={{position:"absolute",left:0,right:0,bottom:(4+((50-20)/60*116))+"px",borderTop:"1px dashed "+C.gray300,zIndex:0}}/>
                  <div style={{position:"absolute",right:2,bottom:(6+((50-20)/60*116))+"px",fontSize:9,color:C.blue,fontWeight:700,zIndex:1}}>AVG</div>
                  {tools.map(function(t,i){
                    var g=t.cumulativeGrade||20; var gc=g>=60?C.blue:g>=45?C.orange:C.coral;
                    var barH=Math.max(4,Math.round((g-20)/60*116)); // 20→0px, 80→116px
                    return (
                      <div key={i} style={{flex:1,display:"flex",flexDirection:"column",alignItems:"center",zIndex:2}}>
                        <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:13,fontWeight:700,color:gc,marginBottom:2}}>{g}</div>
                        <div style={{width:"100%",maxWidth:34,height:barH+"px",background:gc,borderRadius:"4px 4px 0 0"}}/>
                        <div style={{fontSize:11,color:C.blue,fontWeight:700,marginTop:5,textAlign:"center",lineHeight:1.15}}>{cleanToolLabel(t.label)}</div>
                        <div style={{fontSize:11,color:trendCol(t.trend)}}>{trendIcon(t.trend)}</div>
                      </div>
                    );
                  })}
                </div>
                {tools.map(function(t,i){
                  var g=t.cumulativeGrade; var gc=g>=60?C.blue:g>=45?C.orange:C.coral;
                  var pct=Math.max(0,Math.min(100,(g-20)/60*100));
                  return (
                    <div key={i} style={{marginBottom:10,paddingBottom:10,borderBottom:"1px solid "+C.gray100}}>
                      <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:4}}>
                        <div style={{fontWeight:700,color:C.navy,fontSize:13,minWidth:54}}>{cleanToolLabel(t.label)}</div>
                        <div style={{fontWeight:700,color:gc,fontSize:14,minWidth:30}}>{g}</div>
                        <div style={{fontSize:11,color:trendCol(t.trend),minWidth:14}}>{trendIcon(t.trend)}</div>
                        <div style={{flex:1,height:10,background:C.gray100,borderRadius:5,overflow:"hidden"}}><div style={{width:pct+"%",height:"100%",background:gc,borderRadius:5}}/></div>
                      </div>
                      {t.rationale&&<div style={{fontSize:11,color:C.gray600,lineHeight:1.5}}>{t.rationale}</div>}
                    </div>
                  );
                })}
              </div>
            )}
            {pe.summary&&(
              <div style={{marginBottom:12}}>
                <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:11,letterSpacing:1.2,color:C.coral,marginBottom:8}}>SUMMARY</div>
                <p style={{fontSize:13,color:C.gray700,lineHeight:1.7,margin:0}}>{pe.summary}</p>
              </div>
            )}
            <CredibilityFrame report={pe}/>
            {/* CHARTS — spray for position players, pitch for pitchers */}
            {sc && (function(){
              var tableBalls=((typeof window!=="undefined"?window.__bbotBattedBalls:null)||[]).filter(function(b){return String(b.playerId)===String(sc.id);});
              var tablePitches=((typeof window!=="undefined"?window.__bbotPitches:null)||[]).filter(function(p){return String(p.playerId)===String(sc.id);});
              var fbBalls=(pe.battedBalls||r.battedBalls||[]).map(function(b){var ev=(b.exitVelo!=null?b.exitVelo:(b.exitVeloMph!=null?b.exitVeloMph:null));return Object.assign({},b,{playerId:sc.id,exitVelo:(ev!=null?Number(ev):null),distance:(b.distance!=null?b.distance:(b.approxDistanceFt!=null?b.approxDistanceFt:null))});});
              var fbPitches=(pe.pitches||r.pitches||[]).map(function(p){return Object.assign({},p,{playerId:sc.id});});
              var useBalls=tableBalls.length?tableBalls:fbBalls;
              var usePitches=tablePitches.length?tablePitches:fbPitches;
              if(!useBalls.length&&!usePitches.length) return null;
              return <div style={{marginBottom:12}}><PlayerCharts userId={sc.id} playerName={(sc.firstName||"")+" "+(sc.lastName||"")} position={sc.position} twoWay={(r&&r.twoWay)||(sc&&sc.twoWay)} battedBalls={useBalls} pitches={usePitches} scoutReports={[Object.assign({}, r, {status:r.status||"approved"})]}/></div>;
            })()}
            {pe.progressionNote&&<div style={{fontSize:12,color:C.gray600,lineHeight:1.5,padding:"8px 10px",background:C.blueFaint,borderRadius:6,marginBottom:10}}><strong style={{color:C.navy}}>Trajectory: </strong>{pe.progressionNote}</div>}
            {(function(){
              var reel = pe.reelUrl || r.reelUrl;
              if(!reel){
                return <div style={{padding:"10px 12px",background:C.blueFaint,border:"1px dashed "+C.blue,borderRadius:8,fontSize:11,color:C.gray600,lineHeight:1.5}}>
                  <strong style={{color:C.navy}}>Complete your evaluation:</strong> compile a highlight reel from your best clips to add a scannable QR here. Coaches can watch your top plays in seconds.
                </div>;
              }
              var qrSrc = "https://api.qrserver.com/v1/create-qr-code/?size=120x120&data="+encodeURIComponent(reel);
              return <div style={{display:"flex",alignItems:"center",gap:12,padding:"10px",border:"1px solid "+C.border,borderRadius:8}}>
                <img src={qrSrc} alt="Highlight reel QR" style={{width:72,height:72}}/>
                <div><div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:11,color:C.navy,letterSpacing:.5,marginBottom:2}}>HIGHLIGHT REEL</div><div style={{fontSize:11,color:C.gray500}}>Scan to watch · or <a href={reel} target="_blank" rel="noopener noreferrer" style={{color:C.coral}}>open link</a></div></div>
              </div>;
            })()}
            <div style={{fontSize:9,color:C.gray400,marginTop:10,letterSpacing:.3}}>Cumulative read across sessions · recency-weighted · 643 Sports MGMT · BBOT</div>
            <div className="no-print" style={{marginTop:12,display:"flex",justifyContent:"flex-end",gap:8}}>
              <button onClick={function(e){e.stopPropagation();printPlayerReport(r.id, (sc&&(sc.firstName+" "+sc.lastName))||"");}} style={{padding:"6px 12px",background:C.navy,border:"none",color:C.white,borderRadius:6,fontSize:11,fontWeight:600,cursor:"pointer",letterSpacing:.5,minHeight:"auto"}}>DOWNLOAD PDF</button>
              {isAdmin&&<AdminReportControls report={r} player={sc}/>}
            </div>
          </div>
        )}
      </div>
    );
  }

  var scoreCol=r.score>=70?C.blue:r.score>=50?C.orange:C.coral;
  var _rcIsPitcher = (r.isPitcher===true) || /^(P|RHP|LHP|SP|RP|CP)$/i.test(String((sc&&sc.position)||r.position||"").trim().split(/[\s,\/]/)[0]);
  var _pitcherHideKeys = ["run","receiving","fielding","plateDis","batBall","exitVelo","popTime","throw"];
  // Mirror case: for a POSITION PLAYER, hide any pitcher-only tools the model may have
  // added (matched by key or label) so a hitter report never shows pitching categories.
  var _pitcherToolKeys = ["fastball","fastballvelo","pitchvelo","velocity","armaction","mechanics","movement","pitchmovement","spinning","spin","changingspeeds","command","mix","delivery","athleticism"];
  function _isPitcherTool(s){
    var k=String(s.key||"").toLowerCase().replace(/[^a-z]/g,"");
    var lbl=String(s.label||"").toLowerCase();
    if(_pitcherToolKeys.indexOf(k)>=0) return true;
    return /arm action|mechanic|pitch movement|spinning|changing speed|fastball|pitch velocity|delivery|command|pitch mix/.test(lbl);
  }
  function _rcKeep(s){
    if(_rcIsPitcher) return _pitcherHideKeys.indexOf(s.key)<0;
    return !_isPitcherTool(s);
  }
  // EVIDENCE GATE (recalibrated reporting model):
  //   * DEVICE-ANCHORED grade = backed by an on-screen device/timer reading (confidence
  //     Confirmed/Measured). e.g. 102 mph on radar -> 80 FB. These show the NUMBER to everyone.
  //   * INFERRED grade = BBOT's rubric-based judgment (confidence Observed/Inferred/etc).
  //     These are ADMIN-ONLY. Players see the tool DESCRIBED (text), not a number — until and
  //     unless admin calibrates. The PDF/player release is separately gated on r.calibrated below.
  function _isDeviceAnchored(s){
    var c=(s.confidence||"").toLowerCase();
    return c.indexOf("confirmed")>=0 || c.indexOf("measured")>=0;
  }
  var _allGraded=(r.sections||[]).filter(function(s){return s.grade;}).filter(_rcKeep);
  // What renders WITH a number: device-anchored always; inferred only for admin.
  var gradedSections=_allGraded.filter(function(s){ return isAdmin || _isDeviceAnchored(s); });
  // Inferred grades hidden from a player still appear as DESCRIBED tools (text, no number).
  var _inferredHiddenForPlayer=_allGraded.filter(function(s){ return !isAdmin && !_isDeviceAnchored(s); });
  // THREE categories now: graded (measured tools, 20-80 + bar), asserted (visual tools —
  // grade:null but a real scout observation; render the text, NO bar/number), and notObserved
  // (grade:null + a "not observable this session" note). Distinguish asserted vs notObserved
  // by the source/text: a not-observed entry says so explicitly; anything else with real text
  // is a visual assertion we DO show.
  var _pvgForReport = (r.provisionalVisualGrades || (r.fullReport && r.fullReport.provisionalVisualGrades) || []);
  function _hasProvisional(s){
    return _pvgForReport.some(function(g){return g && String(g.toolKey)===String(s.key) && g.provisionalGrade!=null;});
  }
  function _isNotObserved(s){
    if(_hasProvisional(s)) return false;
    var txt=(s.text||"").trim();
    if(!txt) return true;  // no text at all = nothing to show
    // Only treat as "not observed" when the entry EXPLICITLY says it couldn't be evaluated —
    // matched against the SOURCE and the START of the text, not anywhere inside. This stops a
    // rich description (e.g. "no banana steps visible") from being mislabeled not-observed.
    var src=(s.source||"").toLowerCase();
    var head=txt.toLowerCase().slice(0,60);
    var phrase=/not observ|not applicable|not measured|not evaluable|requires .*footage|n\/a|pending/;
    return phrase.test(src) || phrase.test(head);
  }
  var _nullKept=(r.sections||[]).filter(function(s){return !s.grade;}).filter(_rcKeep);
  var assertedSections=_nullKept.filter(function(s){return !_isNotObserved(s);}).concat(_inferredHiddenForPlayer);
  var nullSections=_nullKept.filter(function(s){return _isNotObserved(s);});
  var vUrl=r.videoUrl||r.video_url||"";
  function parseYouTubeId(u){
    if(!u) return "";
    var m = u.match(/(?:youtube\.com\/(?:watch\?(?:.*&)?v=|embed\/|shorts\/|live\/)|youtu\.be\/)([A-Za-z0-9_-]{11})/);
    if(m) return m[1];
    // bare 11-char id
    if(/^[A-Za-z0-9_-]{11}$/.test(u)) return u;
    return "";
  }
  var ytId=parseYouTubeId(vUrl);
  var hasError = isJobFailed(r);
  function retryEval(e){
    if(e) e.stopPropagation();
    setRetrying(true);
    // Shared core: warm pose + rich player-context prompt + unified payload. sc = this report's player.
    retryEvalCore(r, sc).then(function(resp){
      setRetrying(false);
      if(resp && resp.ok){ if(typeof window!=="undefined"&&window.__bbotNotify) window.__bbotNotify("Re-evaluation triggered. Refresh in 30s."); }
      else { if(typeof window!=="undefined"&&window.__bbotNotify) window.__bbotNotify("Retry failed: HTTP "+(resp&&resp.status),"error"); }
    }).catch(function(err){
      setRetrying(false);
      if(typeof window!=="undefined"&&window.__bbotNotify) window.__bbotNotify("Retry failed: "+((err&&err.message)||"network"),"error");
    });
  }
  // PHASE D — when this report carries Phase-C percentiles, the player-facing card IS the clean one-page
  // percentile document: a dedicated render that BYPASSES the legacy 20–80 grade sections + inline video
  // entirely (admins still get the full grade card via the dashboard). The action bar carries
  // .bbot-pdf-omit so the downloadReportPdf clone is the report ALONE (one Letter page). Dormant until
  // BBOT_PERCENTILE_MODE flips — no real report carries percentiles yet, so nothing live changes.
  // BOX-PLOT REPORT — any report carrying percentiles OR pose mechanics renders the clean box-plot report.
  // The legacy spray/pitch chart + skeletal-overlay video are reused (built here, passed in) so the swap
  // loses no kept feature; reports with neither still fall through to the legacy grade card below.
  var _pm = r.poseMetrics || (r.fullReport && r.fullReport.poseMetrics) || null;
  var _hasPose = !!(_pm && ((_pm.deliveries||[]).length>=2 || (_pm.swings||[]).length>=2));
  var hasPct = !!(r.percentiles || (r.fullReport && r.fullReport.percentiles));
  // Admin grade override on the box report -> debounced persist into full_report.sections[i].grade.
  function onGradeOverride(idx, val){
    // Capture BBOT's ORIGINAL prediction the first time this section is touched, so the calibration
    // log always reflects what BBOT actually said (not the last hand-edit) even across repeated edits.
    var _sec0 = (r.sections && r.sections[idx]) || {};
    var _origGrade = (_sec0._originalGrade!=null ? _sec0._originalGrade : _sec0.grade);
    try{ if(r.sections && r.sections[idx]){ if(r.sections[idx]._originalGrade==null) r.sections[idx]._originalGrade=_origGrade; r.sections[idx].grade = val; } }catch(e){}
    if(_gradeTimer.current) clearTimeout(_gradeTimer.current);
    _gradeTimer.current = setTimeout(function(){
      var base = r.fullReport || r.full_report;
      var fr = base ? JSON.parse(JSON.stringify(base)) : {sections: JSON.parse(JSON.stringify(r.sections||[]))};
      if(fr.sections && fr.sections[idx]!=null){ if(fr.sections[idx]._originalGrade==null) fr.sections[idx]._originalGrade=_origGrade; fr.sections[idx].grade = val; }
      reportPatch(r.id, {full_report: fr})
        .then(function(){ if(typeof window!=="undefined"&&window.__bbotNotify) window.__bbotNotify("Grade override saved","success"); })
        .catch(function(){ if(typeof window!=="undefined"&&window.__bbotNotify) window.__bbotNotify("Grade save failed","error"); });
      // REFINEMENT CAPTURE (#31) — record BBOT's prediction vs the admin correction as a calibration
      // signal (Pass 5 reads these to recalibrate benchmarks). Fail-safe; never blocks the grade save.
      try{
        var _s = (fr.sections && fr.sections[idx]) || _sec0;
        // THE REASON IS COLLECTED WHERE THE CORRECTION HAPPENS. The server refuses a grade_override
        // without one, because a delta with no why cannot be learned from -- it cannot distinguish
        // "BBOT misread the footage" from "wrong benchmark" from "this tool should not be graded at
        // all", and those imply opposite fixes. Cancelling the prompt cancels the LOG, never the
        // grade: the correction is the admin's to make, the calibration record is what needs the why.
        var _why = (typeof window!=="undefined" && window.prompt)
          ? window.prompt("Why is this grade wrong? (what BBOT got wrong, and how you know)") : "";
        if(!_why || String(_why).trim().length < 4){
          if(typeof window!=="undefined" && window.__bbotNotify)
            window.__bbotNotify("Grade saved. Calibration note skipped — no reason given.","info");
        } else {
        bbotAdminLog({
            action:"grade_override", target_id:String(r.id),
            admin_id: (typeof window!=="undefined"&&window.__bbotCU) ? String(window.__bbotCU.id) : null,
            timestamp: new Date().toISOString(),
            metadata:{
              sectionKey: _s.key||null, toolLabel: _s.label||_s.key||null,
              reason: String(_why).trim().slice(0,400),
              bbotGrade: _origGrade, correctedGrade: val,
              delta: (typeof _origGrade==="number") ? (val-_origGrade) : null,
              source: _s.source||null,
              position: (sc&&sc.position)||null, gradYear: (sc&&sc.gradYear)||null,
              ageGroup: (typeof bbotAgeGroup==="function" && sc) ? bbotAgeGroup(sc.dob||sc.dateOfBirth) : null,
              sessionType: r.sessionType||r.session_type||null
            }
          }).catch(function(){});
        }
      }catch(e){}
    }, 700);
  }
  // Admin timer result (Home-to-1st or 60-Yard) -> BBOT digests it into measuredValues + basis, then it
  // flows to the graded MEASURED TIMES section, performance graphs and leaderboards.
  function onMeasureTime(field, val, grade){ return saveMeasuredTime(r, sc, field, val, grade); }
  if(hasPct || _hasPose){
    var _overlayUrl = _pm ? (_pm.overlayUrl || _pm.overlay_url || r.skeletonOverlayUrl) : null;
    var _videoNode = _overlayUrl ? <video {...bbotVideoGuard()} src={_overlayUrl} controls playsInline style={{width:"100%",maxWidth:420,borderRadius:8,display:"block"}}/> : null;
    var _chartNode = (function(){
      if(!sc) return null;
      var rid=String(r.id);
      var allTableBalls=((typeof window!=="undefined"?window.__bbotBattedBalls:null)||[]);
      var allTablePitches=((typeof window!=="undefined"?window.__bbotPitches:null)||[]);
      var tableBalls=allTableBalls.filter(function(b){return String(b.playerId)===String(sc.id)&&(String(b.reportId||b.report_id||"")===rid);});
      var tablePitches=allTablePitches.filter(function(p){return String(p.playerId)===String(sc.id)&&(String(p.reportId||p.report_id||"")===rid);});
      var fbBalls=(r.battedBalls||[]).map(function(b){var ev=(b.exitVelo!=null?b.exitVelo:(b.exitVeloMph!=null?b.exitVeloMph:null));return Object.assign({},b,{playerId:sc.id,exitVelo:(ev!=null?Number(ev):null),distance:(b.distance!=null?b.distance:(b.approxDistanceFt!=null?b.approxDistanceFt:null))});});
      var fbPitches=(r.pitches||[]).map(function(p){return Object.assign({},p,{playerId:sc.id});});
      var useBalls=tableBalls.length?tableBalls:fbBalls;
      var usePitches=tablePitches.length?tablePitches:fbPitches;
      if(!useBalls.length&&!usePitches.length) return null;
      return (<div style={{maxWidth:360}}><PlayerCharts userId={sc.id} playerName={sc.firstName+" "+sc.lastName} position={sc.position} twoWay={(r&&r.twoWay)||(sc&&sc.twoWay)} battedBalls={useBalls} pitches={usePitches} scoutReports={[Object.assign({},r,{status:r.status||"approved"})]}/></div>);
    })();
    var _pitchZoneNode = (function(){ var pz = r.pitchZone || (r.fullReport && r.fullReport.pitchZone) || null; return pz ? <PitchZoneMap pitchZone={pz} collapsed={false}/> : null; })();
    return(
      <div id={"bbot-report-"+r.id} data-video-url={(r.videoUrl||r.video_url||(ytId?("https://youtu.be/"+ytId):"")||"")} style={{border:"1px solid "+C.border,borderRadius:12,marginBottom:12,overflow:"hidden",background:C.white}}>
        <div className="bbot-pdf-omit no-print" style={{padding:"8px 12px",background:C.gray50,borderBottom:"1px solid "+C.border,display:"flex",justifyContent:"flex-end",alignItems:"center",gap:8,flexWrap:"wrap"}}>
          {/* ONE SOURCE FOR THE PRINT TOO. Printing the DOM would print an iframe; the card
              publishes its own PDF, built from the same bytes and verified with them. */}
          <button onClick={function(e){e.stopPropagation();
            // A CARD AWAITING APPROVAL IS STILL A CARD, AND THIS BUTTON REFUSED TO SHOW IT.
            //
            // It fetched only the PUBLISHED address, so every evaluation whose card is sitting in
            // the approval queue answered "No published PDF for this evaluation yet" -- including
            // ten finished, fully rendered cards. Luis hit it on Edil, whose pending PDF is 532 KB
            // with every section drawn. The card existed; the button was looking in one place.
            //
            // So: published first, and if there is none, the PENDING card. The pending bytes are the
            // ones approval copies to the live address, so this shows exactly what he would be
            // approving. The pending path is admin-only -- no token opens it -- so this adds no
            // reach for anyone else, and the message only appears when neither exists.
            var dl=function(b,tag){ var u=URL.createObjectURL(b); var a=document.createElement("a");
                a.href=u; a.download="BBOT_"+((sc&&(sc.firstName+"_"+sc.lastName))||r.id)+(tag||"")+".pdf";
                document.body.appendChild(a); a.click(); a.remove(); URL.revokeObjectURL(u); };
            fetch(BACKEND_URL+"/card/"+encodeURIComponent(String(r.id))+"/card.pdf",{headers:bbotAdminHeaders()})
              .then(function(res){ if(!res.ok) throw new Error("no published pdf"); return res.blob(); })
              .then(function(b){ dl(b,""); })
              .catch(function(){
                return fetch(BACKEND_URL+"/admin/card-pending/"+encodeURIComponent(String(r.id))+"/card.pdf",
                             {headers:bbotAdminHeaders()})
                  .then(function(res){ if(!res.ok) throw new Error("no pending pdf"); return res.blob(); })
                  // THE FILENAME CARRIES THE STATE, not a toast. `notify` is not used anywhere in
                  // this component and calling an out-of-scope helper inside a click handler would
                  // throw before the download ran -- breaking the button worse than the dead end it
                  // replaces. "_PENDING_APPROVAL" in the saved name says the same thing and cannot fail.
                  .then(function(b){ dl(b,"_PENDING_APPROVAL"); })
                  .catch(function(){ alert("No card has been built for this evaluation yet."); });
              });
          }} style={{padding:"6px 12px",background:C.navy,border:"none",color:C.white,borderRadius:6,fontSize:11,fontWeight:600,cursor:"pointer",letterSpacing:.5,minHeight:"auto"}}>DOWNLOAD PDF</button>
          {isAdmin&&<AdminReportControls report={r} player={sc}/>}
        </div>
        <ErrorBoundary fallback={<div style={{padding:"16px 22px",fontSize:13,color:"#64748b",fontFamily:"Inter,system-ui,sans-serif",lineHeight:1.6}}>This evaluation couldn't be displayed. Please reload the page — if it keeps happening, contact 643sportsmgmt@gmail.com.</div>}>
          <ServedCard reportId={r.id} playerName={sc&&(sc.firstName+" "+sc.lastName)}/>
        </ErrorBoundary>
      </div>
    );
  }
  return(
    <div id={"bbot-report-"+r.id} data-video-url={(r.videoUrl||r.video_url||(ytId?("https://youtu.be/"+ytId):"")||"")} style={{border:"1px solid "+C.border,borderRadius:12,marginBottom:12,overflow:"hidden",background:C.white}}>
      <div style={{height:3,background:isDraft?C.orange:C.blue}}/>
      <div style={{padding:"12px 14px",display:"flex",justifyContent:"space-between",alignItems:"center",cursor:"pointer",gap:10}} onClick={function(){setOpen(!open);}}>
        <div>
          <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:11,color:C.blue,letterSpacing:1,fontWeight:700}}>SESSION REPORT</div>
          <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:14,color:C.navy,letterSpacing:.5}}>{r.sessionType||"Evaluation"}{(function(){var m=(r.sessionMode||(r.full_report&&r.full_report.sessionMode)||"").toLowerCase();return m==="pickup"?" · Pickup Game":m==="multi"?" · Group Showcase":m==="individual"?" · Individual":"";})()}</div>
          <div style={{fontSize:11,color:C.gray400,marginTop:2}}>{r.date} · Evaluator: BBOT</div>
          <div style={{display:"flex",gap:4,marginTop:5,flexWrap:"wrap"}}>
            {/* CHAIN-OF-CUSTODY BADGE — visible immediately to coaches viewing the eval */}
            {r.videoSource==="bbot_recorded" && (
              <span title="Recorded live by BBOT staff with chain-of-custody documentation" style={{fontSize:9,padding:"2px 7px",background:C.greenLight,color:C.green,borderRadius:99,fontWeight:700,letterSpacing:.4}}>BBOT VERIFIED</span>
            )}
            {r.videoSource==="player_upload" && (
              <span title="Uploaded by player or parent" style={{fontSize:9,padding:"2px 7px",background:C.blueFaint,color:C.blue,borderRadius:99,fontWeight:600,letterSpacing:.4}}>PLAYER-UPLOADED</span>
            )}
            {r.metricsVideoVerified && (
              <span title="All metrics on this evaluation are video-verified (radar in-frame, on-screen timers, or measurable physical events). No self-reported numbers." style={{fontSize:9,padding:"2px 7px",background:C.greenLight,color:C.green,borderRadius:99,fontWeight:700,letterSpacing:.4}}>METRICS VERIFIED</span>
            )}
            {/* SESSION-LEVEL CONFIDENCE — one trust rating for the whole eval */}
            {(function(){
              var ec = (r.evalConfidence || (r.fullReport && r.fullReport.evalConfidence) || "").toLowerCase();
              if(!ec) return null;
              var cfg = ec.indexOf("high")>=0 ? {bg:C.greenLight,c:C.green,t:"HIGH CONFIDENCE"}
                      : ec.indexOf("med")>=0 ? {bg:C.orangeLight,c:"#854d0e",t:"MEDIUM CONFIDENCE"}
                      : {bg:C.gray100,c:C.gray600,t:"LIMITED CONFIDENCE"};
              return <span title="Overall trust rating for this evaluation based on data quality — measurements present, footage clarity, session completeness, and number of camera angles." style={{fontSize:9,padding:"2px 7px",background:cfg.bg,color:cfg.c,borderRadius:99,fontWeight:700,letterSpacing:.4}}>{cfg.t}</span>;
            })()}
          </div>
        </div>
        <div style={{display:"flex",alignItems:"center",gap:10}}>
          {hasError&&<span style={{fontSize:10,background:"#fee2e2",color:"#991b1b",padding:"2px 8px",borderRadius:99,fontWeight:700}}>FAILED</span>}
          {hasError&&isAdmin&&<button onClick={retryEval} disabled={retrying} style={{background:C.coral,color:C.white,border:"none",padding:"4px 10px",borderRadius:6,fontSize:11,fontWeight:700,cursor:retrying?"default":"pointer",opacity:retrying?0.6:1}}>{retrying?"Retrying...":"↻ Retry"}</button>}
          {isDraft&&<span style={{fontSize:10,background:"#fef9c3",color:"#854d0e",padding:"2px 8px",borderRadius:99}}>Draft</span>}
          {((r.evaluationScope||(r.fullReport&&r.fullReport.evaluationScope))==="partial")&&<span style={{fontSize:10,background:"#fef3c7",color:"#92400e",padding:"2px 8px",borderRadius:99,fontWeight:600,border:"0.5px solid #fcd34d"}} title="Some tools could not be observed in this footage">PARTIAL</span>}
          <span style={{color:C.gray400,fontSize:11}}>{open?"▲":"▼"}</span>
        </div>
      </div>
      {open&&(
        <div className="no-print" style={{padding:"8px 14px",background:C.gray50,borderTop:"1px solid "+C.border,display:"flex",justifyContent:"flex-end",alignItems:"center",gap:8,flexWrap:"wrap"}}>
          <button onClick={function(e){e.stopPropagation();printPlayerReport(r.id, (sc&&(sc.firstName+" "+sc.lastName))||"");}} style={{padding:"6px 12px",background:C.navy,border:"none",color:C.white,borderRadius:6,fontSize:11,fontWeight:600,cursor:"pointer",letterSpacing:.5,minHeight:"auto"}}>DOWNLOAD PDF</button>
          {isAdmin&&<AdminReportControls report={r} player={sc}/>}
          {isLiveEval(r) && !isAdmin && (
            <button onClick={function(e){e.stopPropagation();if(typeof window!=="undefined"&&window.__bbotGo)window.__bbotGo("upload-video");}} style={{padding:"6px 12px",background:C.coral,border:"none",color:C.white,borderRadius:6,fontSize:11,fontWeight:700,cursor:"pointer",minHeight:"auto"}}>+ Upload another session</button>
          )}
          {/* Request re-review — for the ~5% of evals that need a second look */}
          {isLiveEval(r) && !r.reviewRequested && (
            <button onClick={function(e){
              e.stopPropagation();
              var reason = window.prompt("What seems off about this evaluation? (Briefly describe — staff will re-review while keeping the original on file.)");
              if(!reason) return;
              // Flag the report + log + notify admin
              reportRequestReview(Number(r.id), reason).catch(function(){});
              bbotAdminLog({action:"review_requested",target_id:String(r.id),timestamp:new Date().toISOString(),metadata:{reason:reason,playerId:r.playerId}}).catch(function(){});
              if(typeof window!=="undefined" && window.__bbotNotify) window.__bbotNotify("Re-review requested. Staff will take a look — your original eval stays on file.");
            }} style={{padding:"6px 12px",background:"transparent",border:"1px solid "+C.border,color:C.gray600,borderRadius:6,fontSize:11,fontWeight:600,cursor:"pointer",minHeight:"auto"}}>Request re-review</button>
          )}
          {r.reviewRequested && (
            <span style={{fontSize:10,color:C.orange,fontWeight:600,padding:"4px 8px",background:C.orangeLight,borderRadius:99}}>Re-review pending</span>
          )}
            <button onClick={function(e){
              e.stopPropagation();
              // ---- BASEBALL-CARD share image (1080×1350, 4:5 IG) — brand colors, free resources ----
              // Draws in-browser (no AI/server cost). Description reuses r.summary (already generated).
              // Measurements are DEVICE-VERIFIED numbers only (from summaryChips) — never grades on
              // observation tools. Logo blends directly on the blue banner (no white tile). QR is free.
              var W=1080,H=1350,M=58;
              var canvas=document.createElement("canvas"); canvas.width=W; canvas.height=H;
              var ctx=canvas.getContext("2d");
              var BLUE="#2970b8",BLUEDK="#3a66c0",CORAL="#e8526a",PHOTO="#243e6e",WHITEC="#ffffff",MUTE="rgba(255,255,255,.84)";
              function ct(x,y,t,f,col){ ctx.font=f; ctx.fillStyle=col; ctx.textAlign="center"; ctx.fillText(t,x,y); }
              // frame: coral edge -> white -> core blue
              ctx.fillStyle=CORAL; ctx.fillRect(0,0,W,H);
              ctx.fillStyle=WHITEC; ctx.fillRect(18,18,W-36,H-36);
              ctx.fillStyle=BLUE; ctx.fillRect(34,34,W-68,H-68);
              // banner
              var bH=196; ctx.fillStyle=BLUEDK; ctx.fillRect(34,34,W-68,bH);
              // identity centered
              ct(W/2,150,(sc.firstName+" "+sc.lastName).toUpperCase(),"bold 44px sans-serif",WHITEC);
              var idLine=[sc.position||"PLAYER", sc.gradYear?("CLASS OF "+sc.gradYear):"", (sc.hsName||sc.clubName||"")].filter(Boolean).join("  ·  ").toUpperCase();
              ct(W/2,196,idLine,"bold 19px sans-serif",CORAL);
              // draw the rest once the logo (or fallback) is placed
              var drawBody=function(){
                // photo (smaller, centered) + monogram fallback handled by caller
                // essentials row
                var ey=photoY+photoH+74;
                var ess=[["HT",sc.height||"—"],["WT",sc.weight?String(sc.weight):"—"],["B/T",(sc.bats||"?")+"/"+(sc.throws||"?")],["GPA",sc.gpa||"—"],["POS",sc.position||"—"]];
                var ew=(W-2*M)/ess.length;
                ess.forEach(function(it,i){ var cx=M+ew*i+ew/2;
                  ct(cx,ey,it[0],"bold 19px sans-serif",MUTE); ct(cx,ey+38,String(it[1]),"bold 38px sans-serif",WHITEC); });
                ctx.fillStyle="rgba(255,255,255,.28)"; ctx.fillRect(M,ey+62,W-2*M,2);
                // description (from r.summary), centered, up to 3 lines
                var dy=ey+108; var summary=(r.summary||"").trim();
                if(summary){ ctx.font="20px sans-serif"; var words=summary.split(/\s+/),line="",lines=[];
                  for(var wi=0;wi<words.length;wi++){ var tst=line?line+" "+words[wi]:words[wi];
                    if(ctx.measureText(tst).width>W-2*M-40){ lines.push(line); line=words[wi]; if(lines.length===3)break; } else line=tst; }
                  if(lines.length<3&&line) lines.push(line);
                  lines.slice(0,3).forEach(function(ln,i){ ct(W/2,dy+i*30,ln,"20px sans-serif",WHITEC); });
                  dy+=Math.min(lines.length,3)*30; }
                // VERIFIED MEASUREMENTS — device-read numbers only (summaryChips)
                var chips=(r.summaryChips||[]).filter(function(c){return c&&c.value!=null&&String(c.value).trim()!=="";}).slice(0,3);
                var ty=dy+22;
                if(chips.length){
                  ct(W/2,ty,"VERIFIED MEASUREMENTS","bold 19px sans-serif",MUTE);
                  var cw=(W-2*M)/chips.length, cyy=ty+36;
                  chips.forEach(function(c,i){ var x0=M+cw*i;
                    if(ctx.roundRect){ ctx.beginPath(); ctx.roundRect(x0,cyy,cw-14,108,14); ctx.fillStyle=BLUEDK; ctx.fill(); }
                    else { ctx.fillStyle=BLUEDK; ctx.fillRect(x0,cyy,cw-14,108); }
                    ct(x0+(cw-14)/2,cyy+62,String(c.value),"bold 40px sans-serif",CORAL);
                    ct(x0+(cw-14)/2,cyy+92,String(c.label||"").toUpperCase(),"bold 17px sans-serif",WHITEC); });
                  var footY=cyy+108+50;
                } else {
                  ct(W/2,ty+30,"Scouting observations — scan for the full report","22px sans-serif",WHITEC);
                  var footY=ty+90;
                }
                // footer text + QR (clear gaps, safe bottom margin)
                ct(W/2,footY,"643SPORTSMGMT.COM  ·  SCAN FOR FULL PROFILE","bold 18px sans-serif",MUTE);
                var qs=120, qx=W/2-qs/2, qy=footY+40;
                var doExport=function(){
                  canvas.toBlob(function(blob){ var url=URL.createObjectURL(blob); var a=document.createElement("a");
                    a.href=url; a.download=((sc.firstName+"_"+sc.lastName).toLowerCase()+"_bbot_card.png").replace(/\s+/g,"_"); a.click();
                    setTimeout(function(){URL.revokeObjectURL(url);},1000);
                    if(typeof window!=="undefined"&&window.__bbotNotify) window.__bbotNotify("Player card downloaded — post to Instagram!");
                  },"image/png");
                };
                var profileUrl=(typeof window!=="undefined"?window.location.origin:"https://643sportsmgmt.com")+"/?p="+encodeURIComponent(String(sc.id));
                var qrImg=new Image(); qrImg.crossOrigin="anonymous";
                qrImg.onload=function(){ ctx.fillStyle="#fff"; ctx.fillRect(qx-8,qy-8,qs+16,qs+16); ctx.drawImage(qrImg,qx,qy,qs,qs); doExport(); };
                qrImg.onerror=doExport;
                qrImg.src="https://api.qrserver.com/v1/create-qr-code/?size=120x120&margin=0&data="+encodeURIComponent(profileUrl);
              };
              // photo geometry (smaller, centered)
              var ph=300, pw=420, px=(W-pw)/2, photoY=34+bH+20, photoH=ph;
              // BBOT logo on banner LEFT, blended directly on blue (no white tile), vertically centered.
              var lcx=112, lcy=34+bH/2+14, lr=44;
              var placeLogoThenBody=function(){
                // photo first
                if(sc.photoUrl){
                  var pimg=new Image(); pimg.crossOrigin="anonymous";
                  pimg.onload=function(){ var s=Math.max(pw/pimg.width,photoH/pimg.height); var dw=pimg.width*s,dh=pimg.height*s;
                    ctx.save(); ctx.beginPath(); ctx.rect(px,photoY,pw,photoH); ctx.clip(); ctx.drawImage(pimg,px+(pw-dw)/2,photoY+(photoH-dh)/2,dw,dh); ctx.restore();
                    ctx.fillStyle=CORAL; ctx.fillRect(px,photoY+photoH,pw,5); drawBody(); };
                  pimg.onerror=function(){ ctx.fillStyle=PHOTO; ctx.fillRect(px,photoY,pw,photoH); ct(W/2,photoY+photoH/2+40,((sc.firstName||"?")[0]+(sc.lastName||"")[0]).toUpperCase(),"bold 120px sans-serif",BLUEDK); ctx.fillStyle=CORAL; ctx.fillRect(px,photoY+photoH,pw,5); drawBody(); };
                  pimg.src=sc.photoUrl;
                } else {
                  ctx.fillStyle=PHOTO; ctx.fillRect(px,photoY,pw,photoH);
                  ct(W/2,photoY+photoH/2+40,((sc.firstName||"?")[0]+(sc.lastName||"")[0]).toUpperCase(),"bold 120px sans-serif",BLUEDK);
                  ctx.fillStyle=CORAL; ctx.fillRect(px,photoY+photoH,pw,5); drawBody();
                }
              };
              var logo=new Image(); logo.crossOrigin="anonymous";
              logo.onload=function(){ var d2=lr*2; ctx.drawImage(logo,lcx-lr,lcy-lr,d2,d2); ct(lcx,lcy+lr+22,"BBOT","bold 16px sans-serif",WHITEC); placeLogoThenBody(); };
              logo.onerror=function(){
                // vector-style fallback drawn directly on blue (white seam ball + coral reticle)
                ctx.strokeStyle=WHITEC; ctx.lineWidth=Math.max(3,lr*0.10); ctx.beginPath(); ctx.arc(lcx,lcy,lr,0,7); ctx.stroke();
                ctx.strokeStyle=CORAL; ctx.lineWidth=Math.max(3,lr*0.075);
                ctx.beginPath(); ctx.moveTo(lcx,lcy-lr*0.95); ctx.lineTo(lcx,lcy-lr*0.62); ctx.moveTo(lcx,lcy+lr*0.62); ctx.lineTo(lcx,lcy+lr*0.95);
                ctx.moveTo(lcx-lr*0.95,lcy); ctx.lineTo(lcx-lr*0.62,lcy); ctx.moveTo(lcx+lr*0.62,lcy); ctx.lineTo(lcx+lr*0.95,lcy); ctx.stroke();
                ctx.beginPath(); ctx.arc(lcx,lcy,lr*0.30,0,7); ctx.stroke();
                ctx.fillStyle=CORAL; ctx.beginPath(); ctx.arc(lcx,lcy,lr*0.12,0,7); ctx.fill();
                ct(lcx,lcy+lr+22,"BBOT","bold 16px sans-serif",WHITEC); placeLogoThenBody();
              };
              logo.src=LOGO_BBOT.replace("/upload/","/upload/w_300,h_300,c_fit/");
              return;
            }} className="no-print" style={{padding:"6px 12px",background:C.coral,border:"none",color:C.white,borderRadius:6,fontSize:11,fontWeight:700,cursor:"pointer",minHeight:"auto"}}>Share Card</button>
          <PdfUnlockButton report={r} player={sc}/>
        </div>
      )}
      {open&&(
        <div style={{borderTop:"1px solid "+C.border}}>
          {ytId&&<div style={{background:"#000"}}><iframe width="100%" height="160" src={"https://www.youtube.com/embed/"+ytId} frameBorder="0" allowFullScreen style={{display:"block"}}/></div>}
          {!ytId&&vUrl&&/\.(mp4|mov|webm|m3u8)/i.test(vUrl)&&<div style={{background:"#000"}}><video {...bbotVideoGuard()} src={vUrl} controls playsInline style={{width:"100%",maxHeight:240,display:"block"}}/></div>}
          {!ytId&&r.objectKey&&!(vUrl&&/\.(mp4|mov|webm|m3u8)/i.test(vUrl))&&<R2Video objectKey={r.objectKey}/>}
          {!ytId&&!r.objectKey&&vUrl&&!/\.(mp4|mov|webm|m3u8)/i.test(vUrl)&&<a href={vUrl} target="_blank" rel="noopener noreferrer" style={{display:"block",textAlign:"center",padding:"10px",background:C.gray100,color:C.blue,fontSize:12,fontWeight:600,textDecoration:"none"}}>▶ Open session video</a>}
          <div style={{padding:"10px 12px"}}>
            {/* PLAYER HEADER CARD — mirrors the Sample Report: bio line + key measurements grid */}
            {sc && (function(){
              var bioLine = [sc.position, sc.gradYear?("Class "+sc.gradYear):null, sc.height, sc.weight?(sc.weight+" lbs"):null, (sc.bats||sc.throws)?((sc.bats||"-")+"/"+(sc.throws||"-")):null].filter(Boolean).join(" · ");
              // Pull key measurements from the report (chips/measuredValues), fall back to dashes
              var mv = r.measuredValues || (r.fullReport&&r.fullReport.measuredValues) || {};
              var chip = function(label){ var c=(r.summaryChips||[]).find(function(x){return String(x.label||"").toLowerCase().indexOf(label.toLowerCase())>=0;}); return c?c.value:null; };
              var cells = [
                ["H-to-1st", chip("h-to-1") || chip("home") || (mv.h2f?mv.h2f+"s":null)],
                ["Top EV", chip("ev") || chip("exit") || (mv.exitVeloPeak?mv.exitVeloPeak+" mph":null)],
                ["60-yd", chip("60") || (mv.dash60?mv.dash60+"s":null)],
                ["Throw", chip("throw") || chip("arm") || (mv.throwVelo?mv.throwVelo+" mph":null)],
              ].filter(function(c){return c[1];});
              return (
                <div style={{background:C.navy,borderRadius:12,padding:14,marginBottom:12,color:C.white}}>
                  <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:16,letterSpacing:1,marginBottom:bioLine?3:0}}>{(sc.firstName||"")+" "+(sc.lastName||"")}</div>
                  {bioLine && <div style={{fontSize:11,color:"rgba(255,255,255,.6)",marginBottom:cells.length?10:0}}>{bioLine}</div>}
                  {cells.length>0 && (
                    <div style={{display:"grid",gridTemplateColumns:"repeat("+Math.min(cells.length,4)+",1fr)",gap:6}}>
                      {cells.map(function(c){return (
                        <div key={c[0]} style={{background:"rgba(255,255,255,0.08)",padding:"6px 8px",borderRadius:6,textAlign:"center"}}>
                          <div style={{fontSize:8,color:"rgba(255,255,255,0.62)",letterSpacing:.5}}>{c[0].toUpperCase()}</div>
                          <div style={{fontSize:13,fontWeight:700,marginTop:2}}>{c[1]}</div>
                        </div>
                      );})}
                    </div>
                  )}
                </div>
              );
            })()}

            {/* BBOT SUMMARY — first block so admin/player reads the synthesis before grades */}
            {(function(){
              var summ=(r.summary||(r.full_report&&r.full_report.summary)||"").trim();
              if(!summ) return null;
              return(
                <div style={{marginBottom:12}}>
                  <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:11,color:C.coral,letterSpacing:1.2,marginBottom:8}}>BBOT SUMMARY</div>
                  <div style={{background:C.blueFaint,borderLeft:"4px solid "+C.blue,borderRadius:8,padding:"12px 14px",fontSize:12,color:C.gray700,lineHeight:1.6}}>{summ}</div>
                </div>
              );
            })()}

            {/* CREDIBILITY FRAME — SINGLE-SESSION path. ReportCard has THREE return paths and the
                first insertion landed only in the _isCumulative branch, so single-session reports
                (Santana, Gabriel) rendered nothing. The paths do not share a render tree, so each
                needs its own mount. Source is r.fullReport here, not `pe` (that binding is
                cumulative-only). */}
            <CredibilityFrame report={(r.fullReport || r.full_report || r)}/>

            {/* Measurements shown in the navy header card above — chips removed to avoid duplication */}

            {/* KEY METRICS — scannable headline numbers, source-colored (device-verified=navy, pose-measured=coral).
                Distinct from the woven-in tool evidence below; renders only what was actually measured. */}
            {(function(){
              var pm = r.poseMetrics || (r.fullReport && r.fullReport.poseMetrics) || null;
              var mvx = r.measuredValues || (r.fullReport && r.fullReport.measuredValues) || {};
              var items = [];
              if(mvx.pitchVeloPeak) items.push(["Peak velo", mvx.pitchVeloPeak+" mph", "device", null]);
              if(pm && pm.deliveries && pm.deliveries.length){
                var d0 = pm.deliveries[0], cf = d0.confidence || {};
                if(d0.arm_slot_deg!=null) items.push(["Arm slot", Math.round(d0.arm_slot_deg)+"°", "pose", cf.arm_slot]);
                if(d0.release_height_pct!=null) items.push(["Release ht", Math.round(d0.release_height_pct)+"%", "pose", cf.release_height]);
                if(d0.max_hip_shoulder_separation_deg!=null) items.push(["Hip-shoulder", Math.round(d0.max_hip_shoulder_separation_deg)+"°", "pose", cf.hip_shoulder_separation]);
                if(d0.stride_pct_height!=null) items.push(["Stride", Math.round(d0.stride_pct_height)+"%", "pose", cf.stride]);
              }
              if(!items.length) return null;
              return (
                <div style={{marginBottom:12}}>
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"baseline",marginBottom:6,gap:8}}>
                    <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:11,letterSpacing:1.2,color:C.coral}}>KEY METRICS</div>
                    <div style={{fontSize:8,color:C.gray400}}>
                      <span style={{color:C.navy,fontWeight:700}}>device-verified</span>{"    "}<span style={{color:C.coral,fontWeight:700}}>pose-measured</span>
                    </div>
                  </div>
                  <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
                    {items.map(function(it,i){
                      var col = it[2]==="device"?C.navy:C.coral;
                      return (
                        <div key={i} style={{background:C.gray50,border:"1px solid "+C.border,borderLeft:"3px solid "+col,borderRadius:6,padding:"5px 9px",minWidth:72}}>
                          <div style={{fontSize:8,color:C.gray500,letterSpacing:.4,textTransform:"uppercase"}}>{it[0]}</div>
                          <div style={{fontSize:14,fontWeight:700,color:C.gray900,lineHeight:1.1,marginTop:1}}>{it[1]}</div>
                          {it[3] && <div style={{fontSize:7,color:C.gray400,marginTop:1,fontStyle:"italic"}}>{it[3]}</div>}
                        </div>
                      );
                    })}
                  </div>
                  {pm && pm.deliveries_measured>0 && (function(){
                    // Provenance that CREDITS both camera looks: back-view deliveries aren't "excluded" —
                    // they're radar-clocked for VELOCITY (the angle just can't give mechanics). State the
                    // two measurements positively; never imply real deliveries were discarded.
                    var iso = pm.isolation;
                    var rv = pm.radar_velocities;
                    var fl = pm.deliveryFloor;
                    var mech = (iso && iso.deliveries_measured) || pm.deliveries_measured;
                    var veloN = rv && rv.clocked_count;
                    // COUNT of record = pose-detected delivery actions (front-angle deliveries that got
                    // no overlay read still count). Radar-clocked + mechanics are ATTRIBUTES, not the count.
                    var total = (fl && fl.deliveries_detected) || (rv && rv.deliveries_probed) || 0;
                    var parts = [];
                    if(total) parts.push("~" + total + " delivery motion" + (total===1?"":"s") + " detected");
                    if(mech) parts.push(mech + " measured for mechanics");
                    if(veloN) parts.push(veloN + " radar-clocked for velocity");
                    var base = parts.length ? parts.join("  ·  ") : "Mechanics measured from video";
                    return (
                      <div style={{fontSize:8,color:C.gray400,marginTop:5,fontStyle:"italic",lineHeight:1.4}}>
                        {base}
                      </div>
                    );
                  })()}
                </div>
              );
            })()}

            {/* MEASURED DELIVERY MECHANICS — two-tier (parity with hitter): measured numbers vs observed
                nuance over the isolation subset, artifacts dropped, confidence-driven. Reads
                poseMetrics.mechanicsTiers. */}
            {(function(){
              var pm = r.poseMetrics || (r.fullReport && r.fullReport.poseMetrics) || null;
              var mt = pm && pm.mechanicsTiers;
              if(!mt || Object.keys(mt).length===0) return null;
              var mks=Object.keys(mt);
              var measured=mks.filter(function(k){return mt[k].tier!=="observed";});
              var observed=mks.filter(function(k){return mt[k].tier==="observed";});
              var fmtRange=function(m){var tr=m.typical_range||[];return (tr.length===2&&tr[0]!==tr[1])?(" ("+tr[0]+"-"+tr[1]+")"):"";};
              return (
                <div style={{marginBottom:12,padding:"8px 10px",borderRadius:8,background:C.gray50,border:"1px solid "+C.border}}>
                  <div style={{fontSize:9,fontWeight:700,color:C.navy,letterSpacing:.5,marginBottom:5}}>MEASURED DELIVERY MECHANICS{pm.mechanicsTiersN?(" · "+pm.mechanicsTiersN+" deliveries"):""}</div>
                  {measured.length>0 && <div style={{display:"flex",flexDirection:"column",gap:3}}>
                    {measured.map(function(mk){
                      var m=mt[mk];
                      return (
                        <div key={mk} style={{display:"flex",justifyContent:"space-between",alignItems:"baseline",fontSize:10,color:C.gray600}}>
                          <span>{m.label}{m.consistency?(<span style={{fontSize:8,color:(m.consistency==="consistent"?C.green:C.gray400)}}>{"  · "+m.consistency}</span>):null}</span>
                          <span style={{textAlign:"right"}}><strong style={{color:C.navy}}>{m.value} {m.unit}</strong><span style={{color:C.gray400}}>{fmtRange(m)}</span></span>
                        </div>
                      );
                    })}
                  </div>}
                  {observed.length>0 && <div style={{marginTop:measured.length>0?6:0,paddingTop:measured.length>0?6:0,borderTop:measured.length>0?("1px dashed "+C.border):"none"}}>
                    <div style={{fontSize:8,color:C.gray400,fontWeight:600,letterSpacing:.4,marginBottom:3}}>OBSERVED (approximate)</div>
                    {observed.map(function(mk){
                      var m=mt[mk];
                      return (
                        <div key={mk} style={{fontSize:9.5,color:C.gray500,marginBottom:2,lineHeight:1.35}}>
                          <span style={{color:C.gray600}}>{m.label}:</span> ~{m.value} {m.unit}{fmtRange(m)}{m.consistency?(", "+m.consistency):""}
                        </div>
                      );
                    })}
                  </div>}
                </div>
              );
            })()}

            {/* NO-RADAR PITCHER FLOOR — when the two-tier mechanics block above renders nothing
                (single-angle markers too thin) but pose still tracked deliveries, guarantee delivery
                count + tempo surface so the report is never all-prose. Reads poseMetrics.deliveryFloor. */}
            {(function(){
              var pm = r.poseMetrics || (r.fullReport && r.fullReport.poseMetrics) || null;
              var mt = pm && pm.mechanicsTiers;
              var fl = pm && pm.deliveryFloor;
              // Show the delivery COUNT even when the two-tier mechanics render, so a no-radar pitcher who
              // threw ~8 but tracked clean mechanics on only 2 never reads like "2 pitches". The tempo /
              // consistency detail + full note stay gated to when the floor is the primary mechanics display.
              if(!fl) return null;
              var _tiersShown = mt && Object.keys(mt).length>0;
              var _measured = fl.deliveries_tracked;
              var _total = (typeof fl.deliveries_total==="number" && fl.deliveries_total>_measured) ? fl.deliveries_total : null;
              return (
                <div style={{marginBottom:12,padding:"8px 10px",borderRadius:8,background:C.gray50,border:"1px solid "+C.border}}>
                  <div style={{fontSize:9,fontWeight:700,color:C.navy,letterSpacing:.5,marginBottom:5}}>DELIVERY SUMMARY</div>
                  <div style={{display:"flex",flexDirection:"column",gap:3}}>
                    <div style={{display:"flex",justifyContent:"space-between",alignItems:"baseline",fontSize:10,color:C.gray600}}>
                      <span>Deliveries{_total?" this session":" tracked"} <span style={{fontSize:8,color:C.gray400}}>· approximate</span></span>
                      <span><strong style={{color:C.navy}}>{_total?("~"+_total):_measured}</strong></span>
                    </div>
                    {_total && (
                      <div style={{display:"flex",justifyContent:"space-between",alignItems:"baseline",fontSize:9,color:C.gray400}}>
                        <span>Mechanics measured on <span style={{fontSize:8}}>· tracked cleanly this angle</span></span>
                        <span><strong style={{color:C.gray500}}>{_measured}</strong></span>
                      </div>
                    )}
                    {/* THE KINETIC-CHAIN SEQUENCE LINE WAS HERE. DELETED 2026-10-11 BY RULING.

                        It drew "Kinetic-chain sequence (hip→shoulder) — N ms" to the player behind
                        no admin gate, only `!_tiersShown`. Its quantity is the hip-shoulder
                        sequence: the ROTATION FAMILY, which is on the brief's dead list as dead on
                        physics and not to be reopened. Measured before deleting: 0 of 39 reports
                        carry `deliveryFloor.sequence_ms`, so it printed nothing — and that is the
                        reason it goes rather than the reason it stays. Luis has ruled this exact
                        shape twice: the percentile track and the MEASURED MECHANICS block, both
                        "gone, not disabled", because a drawing path that only fails to print by
                        accident prints the day the accident ends. One populated field and this
                        would have shown a reader a number from a family that cannot be measured
                        from one camera. */}
                    {!_tiersShown && typeof fl.release_consistency==="number" && (
                      <div style={{display:"flex",justifyContent:"space-between",alignItems:"baseline",fontSize:10,color:C.gray600}}>
                        <span>Release consistency <span style={{fontSize:8,color:C.gray400}}>· lower = tighter</span></span>
                        <span><strong style={{color:C.navy}}>{fl.release_consistency}</strong></span>
                      </div>
                    )}
                  </div>
                  {!_tiersShown && fl.note && <div style={{marginTop:6,fontSize:9,color:C.gray400,lineHeight:1.35}}>{fl.note}</div>}
                </div>
              );
            })()}

            {/* HANDEDNESS — bats / throws from the player PROFILE (source of truth). A value shows as a
                chip; an unset field shows a coral "needs admin" chip that an admin can resolve inline
                (writes the profile via /set-handedness). Never a guessed hand. */}
            {(function(){
              var needs = r.handednessNeedsAdmin || [];
              if(!(r.bats || r.throws || needs.length)) return null;
              function fld(key, label){
                var val = r[key];
                if(val){
                  return <span key={key} style={{background:C.gray50,padding:"3px 7px",borderRadius:99}}>{label} <strong style={{color:C.navy}}>{val==="Switch"?"Switch":val}</strong></span>;
                }
                if(needs.indexOf(key) < 0) return null;   // not set, not flagged => don't invent a chip
                // A pitching session cannot OBSERVE batting handedness (he's pitching, not hitting), so
                // BBOT must not ask an admin to fill it — it discloses what it can't see, never prompts a
                // guess. Suppress the "Bats: needs admin" chip on a pitcher/bullpen report.
                if(key==="bats" && (r.isPitcher || /bullpen|pitching/i.test(String(r.sessionType||"")))) return null;
                return (
                  <span key={key} style={{background:C.coralFaint,color:C.coral,padding:"3px 7px",borderRadius:99,display:"inline-flex",alignItems:"center",gap:6}}>
                    {label}: needs admin
                    {isAdmin && <button onClick={function(){
                      var opts = key==="bats" ? "R, L, or Switch" : "R or L";
                      var v = window.prompt("Set "+label+" for this player ("+opts+"):", "");
                      if(!v) return;
                      var body = {playerId: sc.id}; body[key] = v;
                      _beWrite("/set-handedness", body)
                        .then(function(){ window.location.reload(); })
                        .catch(function(e){ window.alert("Could not save handedness: "+((e&&e.message)||"error")); });
                    }} style={{background:C.coral,color:C.white,border:"none",borderRadius:99,padding:"1px 8px",fontSize:8,fontWeight:700,cursor:"pointer"}}>Set</button>}
                  </span>
                );
              }
              return (
                <div style={{display:"flex",gap:6,flexWrap:"wrap",marginBottom:10,paddingBottom:8,borderBottom:"1px solid "+C.border,fontSize:10,color:C.gray600,alignItems:"center"}}>
                  {fld("bats","Bats")}
                  {fld("throws","Throws")}
                </div>
              );
            })()}

            {/* SESSION ACTIVITY COUNTS — swings, contact, pitches */}
            {(function(){
              var bb = r.battedBalls || [];
              // SINGLE SOURCE OF TRUTH — scope to THIS report exactly like the PITCHER
              // PROFILE does (match report_id, else this report's embedded pitches). Filtering
              // __bbotPitches by player alone pulls EVERY run's pitches (e.g. 30 across re-runs)
              // while the profile shows this report's 6 — that mismatch is the bug. Scoping to
              // report_id makes header and profile read the identical list.
              var _rid = String(r.id);
              var _tp = ((typeof window!=="undefined"?window.__bbotPitches:null)||[]).filter(function(x){return String(x.playerId)===String(sc.id) && (String(x.reportId||x.report_id||"")===_rid);});
              var p = _tp.length ? _tp : (r.pitches || []);
              if(bb.length === 0 && p.length === 0) return null;
              var contact = bb.filter(function(b){return b.outcome && b.outcome.toLowerCase().indexOf("contact")>=0 || b.exitVelo;}).length;
              var hardHit = bb.filter(function(b){return b.exitVelo && Number(b.exitVelo)>=85;}).length;
              var strikes = p.filter(function(pi){return pi.result && pi.result.toLowerCase().indexOf("strike")>=0;}).length;
              // Swing count from the radar overlay (deterministic: fires once per contact, same every
              // run), not the vision model's frame-by-frame count (which wobbles 7-13 run-to-run). Falls
              // back to tracked balls only when no radar readings exist. This is the count fix — the eval
              // is untouched; only the displayed number's SOURCE changes to the stable device signal.
              var _vevs = (r.verifiedExitVelos) || (r.full_report && r.full_report.verifiedExitVelos) || [];
              // Swing count + corroboration from the authoritative swingSummary (union model: swings =
              // radar-confirmed + pose-verified) when present; else the deterministic verified-EV /
              // tracked-ball fallback. The report_line states the corroboration breakdown honestly.
              var ssum = r.swingSummary || (r.full_report&&r.full_report.swingSummary) || (r.fullReport&&r.fullReport.swingSummary) || null;
              var swingCount = (ssum && ssum.swings) ? ssum.swings : ((Array.isArray(_vevs) && _vevs.length) ? _vevs.length : bb.length);
              return (
                <div style={{marginBottom:10,paddingBottom:8,borderBottom:"1px solid "+C.border}}>
                  <div style={{display:"flex",gap:6,flexWrap:"wrap",fontSize:10,color:C.gray600}}>
                    {swingCount>0 && <span style={{background:C.gray50,padding:"3px 7px",borderRadius:99}}><strong style={{color:C.navy}}>{swingCount}</strong> swings</span>}
                    {contact>0 && <span style={{background:C.gray50,padding:"3px 7px",borderRadius:99}}><strong style={{color:C.navy}}>{contact}</strong> contact</span>}
                    {hardHit>0 && <span style={{background:C.gray50,padding:"3px 7px",borderRadius:99}}><strong style={{color:C.green}}>{hardHit}</strong> hard-hit (85+)</span>}
                    {p.length>0 && <span style={{background:C.gray50,padding:"3px 7px",borderRadius:99}}><strong style={{color:C.navy}}>{p.length}</strong> pitches</span>}
                    {strikes>0 && <span style={{background:C.gray50,padding:"3px 7px",borderRadius:99}}><strong style={{color:C.navy}}>{strikes}</strong> strikes</span>}
                  </div>
                  {ssum && ssum.report_line && (
                    <div style={{fontSize:8,color:C.gray400,marginTop:5,fontStyle:"italic",lineHeight:1.4}}>{ssum.report_line}</div>
                  )}
                  {ssum && ssum.mechanics && Object.keys(ssum.mechanics).length>0 && (function(){
                    var mks=Object.keys(ssum.mechanics);
                    var measured=mks.filter(function(k){return ssum.mechanics[k].tier!=="observed";});
                    var observed=mks.filter(function(k){return ssum.mechanics[k].tier==="observed";});
                    var fmtRange=function(m){var tr=m.typical_range||[];return (tr.length===2&&tr[0]!==tr[1])?(" ("+tr[0]+"-"+tr[1]+")"):"";};
                    return (
                    <div style={{marginTop:8,padding:"8px 10px",borderRadius:8,background:C.gray50,border:"1px solid "+C.border}}>
                      <div style={{fontSize:9,fontWeight:700,color:C.navy,letterSpacing:.5,marginBottom:5}}>MEASURED SWING MECHANICS{ssum.mechanics_n_swings?(" · "+ssum.mechanics_n_swings+" swings"):""}</div>
                      {measured.length>0 && <div style={{display:"flex",flexDirection:"column",gap:3}}>
                        {measured.map(function(mk){
                          var m=ssum.mechanics[mk];
                          return (
                            <div key={mk} style={{display:"flex",justifyContent:"space-between",alignItems:"baseline",fontSize:10,color:C.gray600}}>
                              <span>{m.label}{m.consistency?(<span style={{fontSize:8,color:(m.consistency==="consistent"?C.green:C.gray400)}}>{"  · "+m.consistency}</span>):null}</span>
                              <span style={{textAlign:"right"}}>
                                <strong style={{color:C.navy}}>{m.value} {m.unit}</strong>
                                <span style={{color:C.gray400}}>{fmtRange(m)}</span>
                              </span>
                            </div>
                          );
                        })}
                      </div>}
                      {observed.length>0 && <div style={{marginTop:measured.length>0?6:0,paddingTop:measured.length>0?6:0,borderTop:measured.length>0?("1px dashed "+C.border):"none"}}>
                        <div style={{fontSize:8,color:C.gray400,fontWeight:600,letterSpacing:.4,marginBottom:3}}>OBSERVED (approximate)</div>
                        {observed.map(function(mk){
                          var m=ssum.mechanics[mk];
                          return (
                            <div key={mk} style={{fontSize:9.5,color:C.gray500,marginBottom:2,lineHeight:1.35}}>
                              <span style={{color:C.gray600}}>{m.label}:</span> ~{m.value} {m.unit}{fmtRange(m)}{m.consistency?(", "+m.consistency):""}
                            </div>
                          );
                        })}
                      </div>}
                    </div>
                    );
                  })()}
                </div>
              );
            })()}

            {/* SESSION CONTEXT — venue, conditions, opponent (admin-editable) */}
            {(r.sessionContext || isAdmin) && (
              <div style={{padding:"6px 10px",background:C.gray50,borderRadius:6,marginBottom:10,fontSize:11,color:C.gray600,display:"flex",justifyContent:"space-between",alignItems:"center",gap:8,flexWrap:"wrap"}}>
                <span style={{flex:"1 1 auto",minWidth:160}}>{r.sessionContext || (isAdmin ? <em style={{color:C.gray400}}>No session context. Add manually.</em> : null)}</span>
                {isAdmin && (
                  <div style={{display:"flex",gap:4}}>
                    <button onClick={function(e){
                      e.stopPropagation();
                      var current = r.sessionContext || "";
                      var newCtx = window.prompt("Session context (field, opponent, notes):", current);
                      if(newCtx === null) return;
                      if(typeof window!=="undefined" && window.__bbotUpdateSessionContext){
                        window.__bbotUpdateSessionContext(r.id, newCtx);
                      }
                    }} style={{background:"transparent",border:"1px solid "+C.border,color:C.gray500,padding:"2px 8px",borderRadius:4,fontSize:9,fontWeight:600,cursor:"pointer",minHeight:"auto",whiteSpace:"nowrap"}}>✎ Edit</button>
                  </div>
                )}
              </div>
            )}

            {r.partial && (
              <div style={{padding:"6px 10px",background:"#fef3c7",border:"1px solid #fde68a",borderRadius:6,fontSize:10,color:"#78350f",marginBottom:10,lineHeight:1.4}}>
                <strong>PARTIAL</strong> — {r.partialReason||"Some tools not evaluated this session."}
              </div>
            )}

            {/* PITCH ZONE MAP — 9-zone density visualization for pitcher sessions */}
            {(function(){
              var pitchZone = r.pitchZone || (r.fullReport && r.fullReport.pitchZone) || null;
              if (!pitchZone) return null;
              return <PitchZoneMap pitchZone={pitchZone} collapsed={true} />;
            })()}

            {gradedSections.length>0&&(
              <div style={{marginBottom:10}}>
                <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:11,color:C.coral,letterSpacing:1.2,marginBottom:10,display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                  <span>TOOL GRADES</span>
                  {isAdmin && isDraft && (
                    <button onClick={function(e){e.stopPropagation();setEditingGrades(!editingGrades);}} style={{background:editingGrades?C.coralLight:"transparent",border:"1px solid "+(editingGrades?C.coral:C.border),color:editingGrades?C.coral:C.gray500,padding:"3px 9px",borderRadius:6,fontSize:9,fontWeight:700,letterSpacing:.4,cursor:"pointer",minHeight:"auto"}}>{editingGrades?"✓ DONE EDITING":"✎ EDIT GRADES"}</button>
                  )}
                </div>
                <div style={{display:"flex",flexDirection:"column",gap:4}}>
                  {gradedSections.map(function(s){var gc=s.grade>=60?C.blue:s.grade>=45?C.orange:C.coral;
                    var conf=(s.confidence||"").toLowerCase();
                    var confColor=(conf.indexOf("confirmed")>=0||conf.indexOf("measured")>=0)?C.green
                      :conf.indexOf("high")>=0?C.green
                      :conf.indexOf("observed")>=0?C.blue
                      :(conf.indexOf("med")>=0||conf.indexOf("inferred")>=0)?C.orange
                      :(conf.indexOf("low")>=0||conf.indexOf("pending")>=0)?C.coral:null;
                    var delta=null;
                    if(typeof window!=="undefined"&&Array.isArray(window.__bbotReports)&&sc){
                      var priorSameSec=(window.__bbotReports||[]).filter(function(pr){return String(pr.playerId)===String(sc.id)&&String(pr.id)!==String(r.id)&&(isLiveEval(pr));}).sort(function(a,b){return(b.date||"").localeCompare(a.date||"");});
                      for(var i=0;i<priorSameSec.length;i++){var priorSec=(priorSameSec[i].sections||[]).find(function(ps){return ps.key===s.key;});if(priorSec&&priorSec.grade!=null){delta=(s.grade-priorSec.grade);break;}}
                    }
                    return(
                    <details key={s.key} style={{background:C.gray50,borderRadius:6,borderLeft:"3px solid "+gc}}>
                      <summary style={{padding:"7px 9px",display:"flex",alignItems:"center",gap:6,cursor:"pointer",listStyle:"none",WebkitAppearance:"none",userSelect:"none"}}>
                        <div style={{fontSize:11,fontWeight:700,color:C.navy,flex:1,display:"flex",alignItems:"center",gap:5,flexWrap:"wrap"}}>
                          {cleanToolLabel(s.label)}
                          {confColor&&!editingGrades&&<span style={{fontSize:8,padding:"1px 5px",background:confColor+"20",color:confColor,borderRadius:99,fontWeight:600,letterSpacing:.3,textTransform:"uppercase"}}>{conf}</span>}
                          {delta!==null&&Math.abs(delta)>=0.5&&!editingGrades&&<span style={{fontSize:9,padding:"1px 5px",background:delta>0?C.greenLight:C.redLight,color:delta>0?C.green:C.red,borderRadius:99,fontWeight:700}}>{delta>0?"↑":"↓"}{Math.abs(delta).toFixed(1)}</span>}
                        </div>
                        <div style={{flexShrink:0}}>
                          {editingGrades
                            ?<input type="number" min="20" max="80" step="5" defaultValue={s.grade} onClick={function(e){e.stopPropagation();}} onBlur={function(e){var ng=parseFloat(e.target.value);if(!isNaN(ng)&&ng!==s.grade&&window.__bbotUpdateGrade){var _r=window.prompt?window.prompt("Optional: why the correction?"):"";window.__bbotUpdateGrade(r.id,s.key,ng,_r);}}} style={{width:50,padding:"3px 6px",fontSize:13,border:"1.5px solid "+C.coral,borderRadius:4,fontWeight:700,color:gc,textAlign:"center",minHeight:"auto"}}/>
                            :<span style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:14,color:gc,fontWeight:700,lineHeight:1}}>{s.grade}</span>
                          }
                        </div>
                      </summary>
                      <div style={{padding:"0 9px 8px"}}>
                        <div style={{marginBottom:4}}><GradeBar grade={s.grade}/></div>
                        {s.source&&<div style={{fontSize:9,color:C.gray500,fontStyle:"italic",marginBottom:3}}>Source: {s.source}</div>}
                        {s.text&&<div style={{fontSize:12,color:C.gray700,lineHeight:1.55}}>{s.text}</div>}
                        {isAdmin&&(function(){
                          var arr=(r.inferredReadings||(r.fullReport&&r.fullReport.inferredReadings)||[]);
                          if(!Array.isArray(arr)||arr.length===0) return null;
                          var cbp={run:["h2f","dash60"],throw:["exchange","release"],arm:["exchange","release"],receiving:["popTime"]};
                          var ownKeys=[s.key].concat(cbp[s.key]||[]);
                          var matches=arr.filter(function(x){return x&&ownKeys.indexOf(x.toolKey)>=0;});
                          if(!matches.length) return null;
                          return(<div style={{display:"flex",flexDirection:"column",gap:3,marginTop:4}}>
                            {matches.map(function(ir,mi){var unit=ir.unit||"",iv=ir.inferredValue,dv=ir.deviceValue,dl=ir.delta,hot=typeof dl==="number"&&Math.abs(dl)>=3;
                              return(<div key={mi} style={{display:"inline-flex",alignItems:"center",gap:6,fontSize:8,padding:"2px 6px",background:hot?C.coralFaint:C.white,color:hot?C.coral:C.gray600,border:"1px dashed "+(hot?C.coral:C.gray300),borderRadius:4,alignSelf:"flex-start"}}>
                                <span style={{fontWeight:700}}>BBOT EST</span>
                                {matches.length>1&&<span style={{opacity:.6}}>{ir.toolKey}</span>}
                                <span>{iv!=null?(iv+(unit?" "+unit:"")):"—"}</span>
                                {dv!=null&&<><span style={{opacity:.4}}>·</span><span>device {dv}{unit?" "+unit:""}</span></>}
                                {typeof dl==="number"&&<><span style={{opacity:.4}}>·</span><span style={{fontWeight:700}}>Δ{dl>0?"+":""}{dl}</span></>}
                              </div>);
                            })}
                          </div>);
                        })()}
                        {Array.isArray(s.evidence)&&s.evidence.length>0&&(
                          <details style={{marginTop:4}}>
                            <summary style={{fontSize:9,color:C.coral,cursor:"pointer",fontWeight:600,letterSpacing:.4,padding:"3px 0"}}>EVIDENCE ({s.evidence.length})</summary>
                            <ul style={{margin:"4px 0 0 0",paddingLeft:16,fontSize:10,color:C.gray600,lineHeight:1.6}}>
                              {s.evidence.map(function(ev,ei){return <li key={ei}>{typeof ev==="string"?ev:(ev.timestamp?"["+ev.timestamp+"] ":"")+(ev.observation||JSON.stringify(ev))}</li>;})}
                            </ul>
                          </details>
                        )}
                      </div>
                    </details>
                  );})}
                </div>
                {editingGrades&&<div style={{fontSize:10,color:C.gray500,fontStyle:"italic",marginTop:6,padding:"4px 8px",background:C.coralFaint,borderRadius:4}}>Editing grades · Changes save on blur · Original grade preserved in audit log</div>}
              </div>
            )}

            {/* ADMIN-ONLY · BBOT CALIBRATION FOOTER. Collapsed by default so it adds no noise
                to the routine approve flow. One click opens the per-tool BBOT-estimated values
                with their device readings (when both exist) and the delta. Players never see
                this. Lives where the admin is already grading, not on a separate page. */}
            {isAdmin && (function(){
              var arr = (r.inferredReadings || (r.fullReport && r.fullReport.inferredReadings) || []);
              if(!Array.isArray(arr) || arr.length===0) return null;
              return (
                <details style={{marginBottom:10,border:"1px dashed "+C.gray300,borderRadius:6,padding:"6px 10px",background:C.gray50}}>
                  <summary style={{fontSize:10,color:C.gray700,cursor:"pointer",fontWeight:700,letterSpacing:.6,fontFamily:"Inter,system-ui,sans-serif"}}>
                    BBOT CALIBRATION · {arr.length} device-reading check{arr.length===1?"":"s"} <span style={{color:C.gray400,fontWeight:400,letterSpacing:0,fontFamily:"inherit"}}>(admin only)</span>
                  </summary>
                  <div style={{marginTop:8,fontSize:10,color:C.gray700,lineHeight:1.5}}>
                    <div style={{fontSize:9,color:C.gray500,marginBottom:6,fontStyle:"italic"}}>Drift &gt;3 highlighted in coral. Δ = device − BBOT. Used to calibrate BBOT against real device readings over time.</div>
                    <div style={{display:"flex",flexDirection:"column",gap:4}}>
                      {arr.map(function(ir,i){
                        var unit = ir && ir.unit || "";
                        var iv = ir && ir.inferredValue, dv = ir && ir.deviceValue, dl = ir && ir.delta;
                        var hot = (typeof dl==="number" && Math.abs(dl)>=3);
                        return (
                          <div key={i} style={{padding:"4px 8px",background:hot?C.coralFaint:C.white,borderRadius:4,border:"1px solid "+(hot?C.coralLight:C.border)}}>
                            <div style={{display:"flex",justifyContent:"space-between",gap:8,alignItems:"baseline"}}>
                              <span style={{fontWeight:700,color:C.navy,fontSize:10}}>{(ir && ir.toolKey) || "unknown"}</span>
                              <span style={{fontSize:10,color:hot?C.coral:C.gray600}}>
                                BBOT {iv!=null?iv:"—"}{unit?" "+unit:""}
                                {dv!=null && <> · device {dv}{unit?" "+unit:""}</>}
                                {typeof dl==="number" && <> · <span style={{fontWeight:700}}>Δ{dl>0?"+":""}{dl}</span></>}
                              </span>
                            </div>
                            {ir && ir.basisNote && <div style={{fontSize:9,color:C.gray500,marginTop:2,fontStyle:"italic"}}>{ir.basisNote}</div>}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </details>
              );
            })()}

            {/* PERCENTILE RANKINGS section DELETED 2026-09-13. It rendered a heading whose only content
                was "Rankings are not part of a BBOT report" -- a section that existed solely to say it
                does not do the thing it is named after, and the empty state was the only state any
                user ever saw. There is no cohort, so there is nothing for it to hold. */}
            {/* SCOUTING OBSERVATIONS — visual tools (arm action, mechanics, field, hit, etc.).
                These are NOT measured, so they carry NO grade and NO bar — just a definitive
                scout assertion of what the footage shows. Intentionally numberless. */}
            {assertedSections.length>0&&(
              <div style={{marginBottom:10}}>
                <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:11,color:C.coral,letterSpacing:1.2,marginBottom:10}}>SCOUTING OBSERVATIONS</div>
                <div style={{display:"flex",flexDirection:"column",gap:4}}>
                  {assertedSections.map(function(s){
                    // ADMIN-ONLY provisional grade for this visual tool (dormant until a
                    // rubric exists and BBOT populates provisionalVisualGrades). Players
                    // never see this unless the tool's publish flag is flipped on.
                    var _pvgArr = (r.provisionalVisualGrades || (r.fullReport && r.fullReport.provisionalVisualGrades) || []);
                    var _pvg = _pvgArr.find(function(g){return g && String(g.toolKey)===String(s.key);});
                    var _published = !!VISUAL_GRADE_PUBLISHED[s.key];
                    var _showProvisional = _pvg && _pvg.provisionalGrade!=null && (isAdmin || _published);
                    return(
                    <div key={s.key} style={{padding:"7px 9px",background:C.gray50,borderRadius:6,borderLeft:"3px solid "+C.navyMid}}>
                      <div style={{fontSize:11,fontWeight:700,color:C.navy,marginBottom:2,display:"flex",alignItems:"center",gap:6,flexWrap:"wrap"}}>
                        {cleanToolLabel(s.label)}
                        {_showProvisional && (
                          <span title={_published?"Published grade":"Provisional — admin only, under calibration"} style={{fontSize:8,padding:"1px 6px",borderRadius:99,fontWeight:700,letterSpacing:.3,textTransform:"uppercase",background:(_published?C.blue:C.coral)+"20",color:_published?C.blue:C.coral,border:"1px solid "+(_published?C.blue:C.coral)+"55"}}>
                            {_published ? ("Grade "+_pvg.provisionalGrade) : ("BBOT "+_pvg.provisionalGrade+" · prov · admin")}
                          </span>
                        )}
                      </div>
                      {s.source && <div style={{fontSize:8,color:C.gray500,fontStyle:"italic",marginBottom:2,lineHeight:1.3}}>Source: {s.source}</div>}
                      <div style={{fontSize:10,color:C.gray700,lineHeight:1.45}}>{s.text}</div>
                      {isAdmin && !_published && _pvg && _pvg.provisionalGrade!=null && _pvg.rubricBasis && (
                        <div style={{fontSize:8,color:C.gray500,fontStyle:"italic",marginTop:3,lineHeight:1.3}}>Rubric basis: {_pvg.rubricBasis}</div>
                      )}
                    </div>
                  );})}
                </div>
              </div>
            )}

            {/* CHART: spray/pitch — collapsed by default */}
            {sc && (function(){
              var rid=String(r.id);
              var allTableBalls=((typeof window!=="undefined"?window.__bbotBattedBalls:null)||[]);
              var allTablePitches=((typeof window!=="undefined"?window.__bbotPitches:null)||[]);
              var tableBalls=allTableBalls.filter(function(b){return String(b.playerId)===String(sc.id)&&(String(b.reportId||b.report_id||"")===rid);});
              var tablePitches=allTablePitches.filter(function(p){return String(p.playerId)===String(sc.id)&&(String(p.reportId||p.report_id||"")===rid);});
              var fbBalls=(r.battedBalls||[]).map(function(b){var ev=(b.exitVelo!=null?b.exitVelo:(b.exitVeloMph!=null?b.exitVeloMph:null));return Object.assign({},b,{playerId:sc.id,exitVelo:(ev!=null?Number(ev):null),distance:(b.distance!=null?b.distance:(b.approxDistanceFt!=null?b.approxDistanceFt:null))});});
              var fbPitches=(r.pitches||[]).map(function(p){return Object.assign({},p,{playerId:sc.id});});
              var useBalls=tableBalls.length?tableBalls:fbBalls;
              var usePitches=tablePitches.length?tablePitches:fbPitches;
              if(!useBalls.length&&!usePitches.length) return null;
              return(
                <div style={{marginBottom:10}}>
                  <div onClick={function(e){e.stopPropagation();setChartOpen(function(o){return !o;});}} style={{display:"flex",alignItems:"center",justifyContent:"space-between",cursor:"pointer",padding:"5px 0",fontSize:11,color:C.coral,letterSpacing:1.2,fontFamily:"Inter,system-ui,sans-serif",fontWeight:700,userSelect:"none"}}>
                    <span>SPRAY / PITCH CHART</span>
                    <span style={{fontSize:10,color:C.gray400,fontWeight:400}}>{chartOpen?"▲":"▼"}</span>
                  </div>
                  {chartOpen&&<div style={{maxWidth:360}}><PlayerCharts userId={sc.id} playerName={sc.firstName+" "+sc.lastName} position={sc.position} twoWay={(r&&r.twoWay)||(sc&&sc.twoWay)} battedBalls={useBalls} pitches={usePitches} scoutReports={[Object.assign({},r,{status:r.status||"approved"})]}/></div>}
                </div>
              );
            })()}

            {/* MOTION ANALYSIS — frame-level mechanics breakdown */}
            {r.motionAnalysis && <div style={{marginTop:12}}><MotionAnalysisCard analysis={r.motionAnalysis}/></div>}

            {/* MEASURED MECHANICS (pose) — piece (b) skeleton-overlay proof + piece (c) rep-to-rep
                consistency. Grouped here (after the grades) to keep the top scannable; both conditional
                on pose data; brand-styled + crisp per the report-polish standard. */}
            {(function(){
              var pm = r.poseMetrics || (r.fullReport && r.fullReport.poseMetrics) || null;
              if(!pm) return null;
              var url = pm.overlayUrl || pm.overlay_url || r.skeletonOverlayUrl || null;
              var ds = pm.deliveries || [];
              var swings = pm.swings || [];
              // THE FIVE ROWS WERE HERE, AND THEY ARE GONE (2026-10-09, same ruling as the PDF).
              // This block was NOT admin-gated -- `if(!url && !rows.length)` was its only
              // condition -- so it drew Hand speed (mph), Swing tempo, Hip-shoulder, Stride and
              // Head move to whoever opened the report, the player included. Same rows, same
              // accidents keeping them blank, same ruling: gone rather than disabled.
              //
              // THE SKELETON OVERLAY STAYS. It is the approved visual proof of the analysis
              // (CLAUDE.md §6) and it is a VIDEO, not a measurement -- so the heading below now
              // says what is actually under it. A heading reading MEASURED MECHANICS over a clip
              // with no measurement beneath it is the dead-heading problem this pass keeps finding.
              var rows = [];
              if(!url && !rows.length) return null;
              var trackW = 150;
              return (
                <div style={{marginTop:12}}>
                  <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:11,color:C.coral,letterSpacing:1.2,marginBottom:10}}>SKELETON OVERLAY</div>
                  {url && (function(){
                    var isVideo = /\.(mp4|webm|mov)(\?|$)/i.test(url);
                    return (
                      <div style={{marginBottom:rows.length?14:0}}>
                        <div style={{position:"relative",borderRadius:10,overflow:"hidden",background:"#0c1118",border:"1px solid "+C.border}}>
                          {isVideo
                            ? <video {...bbotVideoGuard()} src={url} muted loop playsInline controls preload="metadata" style={{display:"block",width:"100%",height:"auto"}}/>
                            : <img src={url} alt="Pose skeleton overlay" style={{display:"block",width:"100%",height:"auto"}}/>}
                          <span style={{position:"absolute",top:8,left:8,background:C.coral,color:C.white,fontSize:8,fontWeight:700,letterSpacing:.6,padding:"2px 7px",borderRadius:99}}>MEASURED</span>
                        </div>
                        {/* WHAT THE SKELETON IS, AND WHAT IT IS NOT (ruled by Luis 2026-08-19).
                            It is a TRACKING AND CERTIFICATION instrument: 2D body-landmark
                            positions per frame, which certify the rep is this athlete, time the
                            reps, and sample relative movement. It is NOT an angle, rotation,
                            separation or velocity instrument — none of those is extractable from a
                            single camera, and the caption may not imply otherwise. */}
                        <div style={{fontSize:8,color:C.gray400,marginTop:5,fontStyle:"italic",lineHeight:1.5}}>Body-landmark positions tracked frame by frame. This certifies each rep is this athlete, times the reps, and samples relative movement. It does not measure angles, rotation, separation or speed — those are not extractable from a single camera.</div>
                      </div>
                    );
                  })()}
                  {rows.length>0 && (
                    <div>
                      <div style={{fontSize:9,color:C.gray500,marginBottom:8,fontStyle:"italic"}}>Rep-to-rep — each dot is one measured {ds.length>=2?"delivery":"swing"} ({repData.length} tracked); a tighter cluster = more repeatable.</div>
                      {rows.map(function(row,ri){
                        var span = (row.mx-row.mn)||1;
                        return (
                          <div key={ri} style={{display:"flex",alignItems:"center",gap:10,marginBottom:7}}>
                            <div style={{width:78,fontSize:9,color:C.gray600,textAlign:"right",flexShrink:0}}>{row.m.label}</div>
                            <svg width={trackW} height={14} style={{flexShrink:0,overflow:"visible"}}>
                              <line x1={3} y1={7} x2={trackW-3} y2={7} stroke={C.border} strokeWidth={2} strokeLinecap="round"/>
                              {row.vals.map(function(v,vi){
                                var x = 3+((v-row.mn)/span)*(trackW-6);
                                return <circle key={vi} cx={x} cy={7} r={vi===0?4.5:3} fill={vi===0?C.coral:C.coralFaint} stroke={C.coral} strokeWidth={vi===0?0:1.2}/>;
                              })}
                            </svg>
                            <div style={{fontSize:9,color:C.gray700,whiteSpace:"nowrap",flexShrink:0}}>{Math.round(row.mn)}–{Math.round(row.mx)}{row.m.unit}</div>
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>
              );
            })()}

            {/* COACH NOTES — admin-editable, clearly attributed (not BBOT) */}
            {(r.coachNotes || isAdmin) && (
              <div style={{marginTop:12,padding:"10px 12px",background:C.blueFaint,borderRadius:8,borderLeft:"3px solid "+C.blue}}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:6}}>
                  <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:10,color:C.blue,letterSpacing:1,fontWeight:700}}>COACH NOTES <span style={{fontSize:8,color:C.gray500,fontWeight:400}}>· Not BBOT-generated</span></div>
                  {isAdmin && (
                    <button onClick={function(e){
                      e.stopPropagation();
                      var current = r.coachNotes || "";
                      var newNotes = window.prompt("Coach Notes (appended to evaluation, attributed to staff):", current);
                      if(newNotes === null) return;
                      // Save via window helper
                      if(typeof window!=="undefined" && window.__bbotUpdateCoachNotes) {
                        window.__bbotUpdateCoachNotes(r.id, newNotes);
                      }
                    }} style={{background:"transparent",border:"1px solid "+C.blueLight,color:C.blue,padding:"3px 9px",borderRadius:6,fontSize:9,fontWeight:700,cursor:"pointer",minHeight:"auto"}}>✎ EDIT</button>
                  )}
                </div>
                {r.coachNotes ? (
                  <p style={{fontSize:12,color:C.gray700,lineHeight:1.5,margin:0,whiteSpace:"pre-wrap"}}>{r.coachNotes}</p>
                ) : (
                  isAdmin && <p style={{fontSize:11,color:C.gray400,fontStyle:"italic",margin:0}}>No coach notes added. Click EDIT to append staff observations.</p>
                )}
              </div>
            )}
            {/* OMISSIONS & CAVEATS — collapsed footnote replacing NOT OBSERVED / CAVEATS / NOT EVALUATED */}
            {(function(){
              var nullWithText=nullSections.filter(function(s){return s.text;});
              var flags=[];
              if(Array.isArray(r.adverseConditions)) flags=r.adverseConditions;
              else if(r.partial) flags.push({label:"PARTIAL SESSION",detail:r.partialReason||"Some tools not evaluable"});
              if(r.lowVideoQuality) flags.push({label:"LOW VIDEO QUALITY",detail:"Lighting / angle / resolution affected analysis"});
              if(r.noRadarInFrame) flags.push({label:"NO RADAR IN FRAME",detail:"Velocity not measured — no on-screen device reading"});
              return(
                <details style={{marginTop:10}}>
                  <summary style={{fontSize:9,color:C.gray400,cursor:"pointer",letterSpacing:.5,fontWeight:600,listStyle:"none",WebkitAppearance:"none",userSelect:"none"}}>Omissions &amp; caveats ▸</summary>
                  <div style={{marginTop:6,padding:"8px 10px",background:C.gray50,borderRadius:6,fontSize:10,color:C.gray500,lineHeight:1.6}}>
                    {nullWithText.length>0&&(
                      <div style={{marginBottom:8}}>
                        <div style={{fontSize:9,color:C.gray400,letterSpacing:1,fontWeight:700,marginBottom:4}}>NOT OBSERVED</div>
                        {nullWithText.map(function(s){return(<div key={s.key} style={{fontSize:10,color:C.gray400,marginBottom:2}}><span style={{fontWeight:600,color:C.gray500}}>{cleanToolLabel(s.label)}:</span> {s.text}</div>);})}
                      </div>
                    )}
                    {r.inferredVeloUsed&&<div style={{fontSize:9,color:C.gray400,fontStyle:"italic",marginBottom:8}}>* Velocity not on screen — reported as not measured.</div>}
                    {flags.length>0&&(
                      <div style={{marginBottom:8}}>
                        <div style={{fontSize:9,color:C.gray400,letterSpacing:.5,fontWeight:700,marginBottom:4}}>ANALYSIS CAVEATS</div>
                        {flags.map(function(f,i){return(<div key={i} style={{fontSize:10,color:C.gray600,marginBottom:2}}><strong>{f.label}</strong>{f.detail?" — "+f.detail:""}</div>);})}
                      </div>
                    )}
                    <div>
                      <div style={{fontSize:9,color:C.gray400,letterSpacing:.5,fontWeight:700,marginBottom:3}}>NOT EVALUATED BY BBOT</div>
                      <div>Makeup · Work ethic · Game IQ · Off-field character · Coachability · Mental approach</div>
                      <div style={{fontSize:9,color:C.gray400,fontStyle:"italic",marginTop:3}}>BBOT evaluates observable tools from video. Non-observable qualities require in-person assessment.</div>
                    </div>
                  </div>
                </details>
              );
            })()}

            {/* EVAL METADATA FOOTER — version, multi-angle, contextual note */}
            <div style={{marginTop:10,paddingTop:8,borderTop:"1px solid "+C.gray100,display:"flex",justifyContent:"space-between",alignItems:"center",flexWrap:"wrap",gap:6,fontSize:9,color:C.gray400,letterSpacing:.3}}>
              <div style={{display:"flex",gap:8,flexWrap:"wrap",alignItems:"center"}}>
                <span>BBOT {r.bbotVersion || "v1.0"}</span>
                {r.cameraAngles && r.cameraAngles >= 2 && <span style={{padding:"1px 6px",background:C.greenLight,color:C.green,borderRadius:99,fontWeight:600}}>{r.cameraAngles}-angle capture</span>}
                {r.cameraAngles === 1 && <span>Single angle</span>}
                {r.contextualNote && <span style={{color:C.gray500,fontStyle:"italic"}}>· {r.contextualNote}</span>}
              </div>
              {r.generatedAt && <span>Generated {new Date(r.generatedAt).toLocaleDateString()}</span>}
            </div>

          </div>
        </div>
      )}
    </div>
  );
}
function MetricsView({uM}){
  if(!uM||uM.length===0) return <EmptyCard icon="M" title="No Metrics Yet" sub="Metrics logged by staff will appear here"/>;
  var latest=uM[uM.length-1];
  var fields=[
    {key:"exitVelo",  label:"Exit Velo",   unit:"mph"},
    {key:"throwVelo", label:"Throw Velo",  unit:"mph"},
    {key:"pitchVelo", label:"Pitch Velo",  unit:"mph"},
    {key:"dash60",    label:"60 Yard",     unit:"sec"},
    {key:"popTime",   label:"Top Pop Time", unit:"sec"},
    {key:"jump",      label:"Vert Jump",   unit:"in",  area:true},
    {key:"grip",      label:"Grip",        unit:"lbs", area:true},
    {key:"squat",     label:"Squat",       unit:"lbs"},
  ];
  var veloAdmin = (typeof window!=="undefined") ? window.__bbotVeloVisible : false;
  var basis = latest.basis || {};
  // All metrics originate from BBOT evals (there is no manual staff-entry path).
  // Therefore ANY estimatable measurement — velocity OR timing — is admin-only
  // unless it carries a device-Verified basis. Players never see a BBOT estimate
  // presented as a measurement.
  var ESTIMATABLE_KEYS = {exitVelo:1, throwVelo:1, pitchVelo:1, h2f:1, dash60:1, popTime:1};
  var visible=fields.filter(function(f){
    if(!latest[f.key]) return false;
    if(ESTIMATABLE_KEYS[f.key] && !veloAdmin){
      var b = (basis[f.key]||"").toLowerCase();
      if(b!=="verified") return false;   // anything not device-Verified is admin-only
    }
    return true;
  });

  // CROSS-SESSION CONSISTENCY — flag metrics that vary widely across sessions.
  // Active at 2+ sessions to match the Cumulative Player Eval minimum (2 sessions).
  // With exactly 2 readings this is a simple delta between the two; with 3+ it
  // reflects true spread. Either way we surface metrics that move more than the
  // per-tool threshold so the scout can judge whether it's real or noise.
  var inconsistencies = [];
  if(uM.length >= 2){
    fields.forEach(function(f){
      var vals = uM.map(function(m){return m[f.key]?Number(m[f.key]):null;}).filter(function(v){return v!=null && !isNaN(v);});
      if(vals.length < 2) return;
      var max = Math.max.apply(null,vals);
      var min = Math.min.apply(null,vals);
      var spread = max - min;
      // Heuristic thresholds — flag if spread exceeds these
      var thresholds = {exitVelo:8, throwVelo:6, pitchVelo:5, dash60:0.4, popTime:0.2};
      if(thresholds[f.key] && spread > thresholds[f.key]){
        inconsistencies.push({label:f.label, max:max, min:min, unit:f.unit, spread:spread});
      }
    });
  }

  return(
    <div>
      <div style={{fontSize:11,color:C.gray400,marginBottom:10}}>{"Last updated: "+latest.date}</div>

      {inconsistencies.length > 0 && (
        <div style={{padding:"8px 10px",background:"#fef9c3",border:"1px solid #fde68a",borderRadius:6,marginBottom:10}}>
          <div style={{fontSize:9,color:"#854d0e",letterSpacing:.6,fontWeight:700,marginBottom:6}}>SESSION VARIANCE DETECTED</div>
          {inconsistencies.map(function(inc,i){return (
            <div key={i} style={{fontSize:10,color:"#78350f",lineHeight:1.4}}>
              <strong>{inc.label}:</strong> ranged {inc.min.toFixed(inc.unit==="sec"?2:0)} – {inc.max.toFixed(inc.unit==="sec"?2:0)} {inc.unit} across logged sessions
            </div>
          );})}
          <div style={{fontSize:9,color:"#854d0e",fontStyle:"italic",marginTop:4}}>Wider-than-typical spreads are flagged for transparency. Coaches should review individual session video for context.</div>
        </div>
      )}

      <MetricTilesWithTrend uM={uM} fields={fields} visible={visible} latest={latest}/>
      {latest.notes&&<div style={{marginTop:12,fontSize:12,color:C.gray500,fontStyle:"italic",padding:"10px 14px",background:C.gray50,borderRadius:8}}>{latest.notes}</div>}
    </div>
  );
}

// Metric tiles that expand into a progress-over-time line chart when tapped.
function MetricTilesWithTrend({uM, fields, visible, latest}){
  var openS=useState(null); var open=openS[0]; var setOpen=openS[1];
  // build the per-metric series across sessions (chronological)
  function series(key){
    return (uM||[]).map(function(m){
      var v=m[key]!=null?Number(m[key]):null;
      return (v!=null && !isNaN(v))?{date:m.date||"", val:v}:null;
    }).filter(Boolean);
  }
  // tiny inline mini-bars SVG (vertical bars, never green per locked design rule)
  function spark(pts, lower){
    if(pts.length<2) return null;
    var vals=pts.map(function(p){return p.val;});
    var mn=Math.min.apply(null,vals), mx=Math.max.apply(null,vals);
    var rng=(mx-mn)||1, W=120, H=34, pad=3;
    // improvement = last vs first (lower-is-better metrics invert)
    var first=vals[0], last=vals[vals.length-1];
    var better = lower ? (last<first) : (last>first);
    var col = last===first?C.gray400:(better?C.blue:C.coral);  // never green: blue=better, coral=worse
    var barW = Math.max(2, (W-pad*2)/pts.length * 0.78);
    var slotW = (W-pad*2)/pts.length;
    return (
      <svg width={W} height={H} style={{display:"block",marginTop:6}}>
        {pts.map(function(p,i){
          var hRatio = (p.val-mn)/rng;  // 0..1
          var bh = Math.max(2, (H-pad*2) * (0.15 + 0.85*hRatio));  // floor so smallest bar still visible
          var x = pad + i*slotW + (slotW-barW)/2;
          var y = pad + (H-pad*2) - bh;
          return <rect key={i} x={x} y={y} width={barW} height={bh} fill={col} rx="1"/>;
        })}
      </svg>
    );
  }
  return (
    <div>
      <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(130px,1fr))",gap:10}}>
        {visible.map(function(f){
          var pts=series(f.key);
          var lower=(f.unit==="sec");
          var hasTrend=pts.length>=2;
          var isOpen=open===f.key;
          return(
            <Card key={f.key} style={{position:"relative",overflow:"hidden",cursor:hasTrend?"pointer":"default",gridColumn:isOpen?"1 / -1":"auto"}} onClick={function(){ if(hasTrend) setOpen(isOpen?null:f.key); }}>
              <div style={{fontSize:10,color:C.gray400,textTransform:"uppercase",letterSpacing:.5,marginBottom:4}}>{f.label}{hasTrend&&<span style={{float:"right",color:C.blue,fontSize:9}}>{isOpen?"▲":"trend ▾"}</span>}</div>
              <div style={{fontSize:22,fontWeight:700,color:C.blue,lineHeight:1}}>{latest[f.key]}<span style={{fontSize:11,color:C.gray400,marginLeft:2}}>{f.unit}</span></div>
              {!isOpen && hasTrend && spark(pts, lower)}
              {isOpen && (
                <div style={{marginTop:10}}>
                  <div style={{fontSize:10,color:C.gray400,marginBottom:6}}>{pts.length} sessions · {pts[0].val} → {pts[pts.length-1].val} {f.unit}</div>
                  <MetricLineChart pts={pts} unit={f.unit} lower={lower}/>
                </div>
              )}
            </Card>
          );
        })}
      </div>
    </div>
  );
}

// Full-width VERTICAL BAR chart for one metric across sessions (never green per locked design rule)
function MetricLineChart({pts, unit, lower}){
  var W=600, H=200, padL=40, padR=16, padT=14, padB=44;
  var vals=pts.map(function(p){return p.val;});
  var mn=Math.min.apply(null,vals), mx=Math.max.apply(null,vals);
  var rng=(mx-mn)||1;
  // pad range 10%; for lower-is-better also include 0 floor pad
  var lo=mn-rng*0.1, hi=mx+rng*0.1; var R=(hi-lo)||1;
  var plotW = W-padL-padR, plotH = H-padT-padB;
  var slotW = plotW/pts.length;
  var barW = Math.max(8, slotW*0.7);
  var first=vals[0], last=vals[vals.length-1];
  var better = lower ? (last<first) : (last>first);
  var trendCol = last===first?C.gray500:(better?C.blue:C.coral);
  // 3 y gridlines
  var gridTicks = [0,0.5,1];
  return (
    <svg viewBox={"0 0 "+W+" "+H} style={{width:"100%",display:"block",background:C.gray50,borderRadius:8}}>
      {/* y gridlines + value labels */}
      {gridTicks.map(function(t,i){
        var y=padT+plotH*t;
        var v=(hi-(hi-lo)*t);
        return <g key={i}><line x1={padL} y1={y} x2={W-padR} y2={y} stroke="#e5e7eb" strokeWidth="1"/><text x={padL-6} y={y+3} fontSize="9" fill="#94a3b8" textAnchor="end">{v.toFixed(unit==="sec"?2:0)}</text></g>;
      })}
      {/* vertical bars — color by per-bar comparison to first value (improving=blue, worse=coral, neutral=gray) */}
      {pts.map(function(p,i){
        var bh = ((p.val-lo)/R) * plotH;
        var x = padL + i*slotW + (slotW-barW)/2;
        var y = padT + plotH - bh;
        var betterThanFirst = lower ? (p.val<first) : (p.val>first);
        var sameAsFirst = (p.val===first);
        var col = i===0 ? C.navy : (sameAsFirst?C.gray500:(betterThanFirst?C.blue:C.coral));
        // Label sits above the bar, but never higher than padT+10 (keeps it clear of the trend text).
        var labelY = Math.max(padT+10, y-3);
        return (
          <g key={i}>
            <rect x={x} y={y} width={barW} height={Math.max(2,bh)} fill={col} rx="2"/>
            <text x={x+barW/2} y={labelY} fontSize="9" fill={col} textAnchor="middle" fontWeight="600">{Number(p.val).toFixed(unit==="sec"?2:0)}</text>
          </g>
        );
      })}
      {/* x labels: short date below each bar; when crowded, show every Nth to avoid overlap */}
      {pts.map(function(p,i){
        var everyN = pts.length>8 ? Math.ceil(pts.length/8) : 1;
        if(i % everyN !== 0 && i !== pts.length-1) return null;
        var x = padL + i*slotW + slotW/2;
        var d = (p.date||"").slice(5,10);
        return <text key={i} x={x} y={H-padB+14} fontSize="9" fill="#475569" textAnchor="middle">{d}</text>;
      })}
      {/* trend indicator top-right */}
      <text x={W-padR} y={padT+4} fontSize="10" fill={trendCol} textAnchor="end" fontWeight="700">{first===last?"":(better?"▲ improving":"▼ regressing")}</text>
    </svg>
  );
}
function PitchChart({pitches,playerName}){
  if(!pitches||pitches.length===0) return <EmptyCard icon="P" title="No Pitch Data" sub="BBOT logs pitch locations automatically from session video"/>;
  var selState=useState(null); var sel=selState[0]; var setSel=selState[1];
  var filterState=useState("All"); var filter=filterState[0]; var setFilter=filterState[1];
  var viewState=useState("both"); var view=viewState[0]; var setView=viewState[1];

  var W=520; var H=360;
  var LX=40; var RX=290; var SZT=80; var SZB=260; var SZW=160; var SZH=SZB-SZT;

  var PITCH_COL={"Fastball":"#E97A7A","Curveball":"#3b82f6","Slider":"#f59e0b","Changeup":"#22c55e","Cutter":"#a855f7","Sinker":"#64748b","Other":"#94a3b8"};
  var PITCH_TYPES=["All","Fastball","Curveball","Slider","Changeup","Cutter","Sinker"];

  // A pitch is "located" only if it has a real plate location (not null). Pitches BBOT
  // could not attest a location for are NOT plotted (no false-precision center dots).
  var hasLoc=function(p){return p.plateX!=null && p.plateZ!=null && !isNaN(Number(p.plateX)) && !isNaN(Number(p.plateZ));};
  var locatedAll=(pitches||[]).filter(hasLoc);
  var unlocatedCount=(pitches||[]).length - locatedAll.length;

  var rhhPitches=locatedAll.filter(function(p){return p.batterSide==="RHH"||(p.batterSide!=="LHH"&&!p.batterSide);});
  var lhhPitches=locatedAll.filter(function(p){return p.batterSide==="LHH";});

  var filterPitches=function(arr){return filter==="All"?arr:arr.filter(function(p){return p.pitchType===filter;});};

  var stats=function(arr){
    var t=arr.length||0;
    var s=arr.filter(function(p){return p.result==="Strike"||p.result==="SwingMiss"||p.result==="Foul";}).length;
    var b=arr.filter(function(p){return p.result==="Ball";}).length;
    return {total:t,strikes:s,balls:b,pct:t>0?Math.round(s/t*100):0};
  };
  var rhhStats=stats(rhhPitches);
  var lhhStats=stats(lhhPitches);
  var totalStats=stats(locatedAll);

  // 3x3 ZONE BUCKETING — credible tendency map, not pinpoint tracking.
  // Each located pitch buckets into one of 9 zones by thirds. plateX/plateZ are
  // only used to assign a zone bucket, never to imply an exact coordinate.
  var zoneOf=function(p){
    var col=p.plateX<0.34?0:(p.plateX<0.67?1:2);
    var row=p.plateZ>0.67?0:(p.plateZ>0.34?1:2); // row0=top
    return row*3+col;
  };
  var zoneCount=function(arr){var z=[0,0,0,0,0,0,0,0,0];arr.forEach(function(p){var k=zoneOf(p);if(k>=0&&k<9)z[k]++;});return z;};

  var renderZoneGrid=function(arr,baseX,label,batSide){
    var z=zoneCount(arr);
    var max=Math.max.apply(null,z.concat([1]));
    var cell=SZW/3, cellH=SZH/3;
    var cx=baseX+SZW/2;
    return (
      <g>
        {z.map(function(cnt,k){
          var row=Math.floor(k/3), col=k%3;
          var x=baseX+col*cell, y=SZT+row*cellH;
          var intensity=cnt/max;
          return <g key={k}>
            <rect x={x} y={y} width={cell} height={cellH} fill={C.coral} fillOpacity={cnt===0?0.04:(0.15+intensity*0.6)} stroke="rgba(255,255,255,0.25)" strokeWidth="1"/>
            {cnt>0&&<text x={x+cell/2} y={y+cellH/2+5} fontSize="14" fill="white" textAnchor="middle" fontWeight="700" fontFamily="Inter,system-ui,sans-serif">{cnt}</text>}
          </g>;
        })}
        <text x={cx} y={SZT-20} fontSize="11" fill="white" textAnchor="middle" fontWeight="700" fontFamily="Inter,system-ui,sans-serif">{label}</text>
        <text x={cx} y={SZT-8} fontSize="9" fill="rgba(255,255,255,0.45)" textAnchor="middle">{(batSide==="RHH"?rhhStats:lhhStats).total} located · {(batSide==="RHH"?rhhStats:lhhStats).pct}% strike</text>
        <polygon points={cx+","+(SZB+8)+" "+(cx-14)+","+(SZB+24)+" "+(cx+14)+","+(SZB+24)} fill="white" fillOpacity="0.5"/>
        <text x={baseX+2} y={SZT-2} fontSize="7" fill="rgba(255,255,255,0.35)">HI</text>
        <text x={baseX+2} y={SZB+10} fontSize="7" fill="rgba(255,255,255,0.35)">LO</text>
        {batSide==="RHH"&&<text x={baseX-2} y={SZT+SZH/2+4} fontSize="7" fill="rgba(255,255,255,0.35)" textAnchor="end">IN</text>}
        {batSide==="RHH"&&<text x={baseX+SZW+2} y={SZT+SZH/2+4} fontSize="7" fill="rgba(255,255,255,0.35)">OUT</text>}
        {batSide==="LHH"&&<text x={baseX-2} y={SZT+SZH/2+4} fontSize="7" fill="rgba(255,255,255,0.35)" textAnchor="end">OUT</text>}
        {batSide==="LHH"&&<text x={baseX+SZW+2} y={SZT+SZH/2+4} fontSize="7" fill="rgba(255,255,255,0.35)">IN</text>}
      </g>
    );
  };

  return(
    <div>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:10,flexWrap:"wrap",gap:8}}>
        <div style={{fontSize:11,color:C.gray400}}>{playerName} — {(pitches||[]).length} pitches tracked{locatedAll.length!==(pitches||[]).length?(" · "+locatedAll.length+" with zone"):""}</div>
        <div style={{display:"flex",gap:12}}>
          <div style={{textAlign:"center"}}><div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:18,color:C.coral}}>{totalStats.strikes}</div><div style={{fontSize:9,color:C.gray400}}>STRIKES</div></div>
          <div style={{textAlign:"center"}}><div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:18,color:C.blue}}>{totalStats.balls}</div><div style={{fontSize:9,color:C.gray400}}>BALLS</div></div>
          <div style={{textAlign:"center"}}><div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:18,color:C.green}}>{totalStats.pct}%</div><div style={{fontSize:9,color:C.gray400}}>STR%</div></div>
        </div>
      </div>
      {/* CREDIBILITY DISCLAIMER — always shown on the pitch chart */}
      <div style={{fontSize:10,color:C.gray500,background:C.blueFaint,border:"1px solid "+C.blueLight,borderRadius:6,padding:"7px 10px",marginBottom:10,lineHeight:1.45}}>
        <strong style={{color:C.navy}}>Observed command tendencies</strong> — this grid buckets pitches into general zones from single-angle video. It reflects where a pitcher tends to work, not exact, calibrated pitch locations. It is not a ball-tracking or automated strike-zone system.
        {unlocatedCount>0&&" "+unlocatedCount+" of "+(pitches||[]).length+" pitches could not be zone-located and are excluded from the grid (their strike/ball result is still counted)."}
      </div>
      <div style={{display:"flex",gap:5,marginBottom:10,flexWrap:"wrap"}}>
        {PITCH_TYPES.map(function(t){return <button key={t} onClick={function(){setFilter(t);setSel(null);}} style={{padding:"3px 9px",borderRadius:99,fontSize:11,fontWeight:600,border:filter===t?"none":"1px solid "+C.border,background:filter===t?C.coral:"transparent",color:filter===t?C.white:C.gray400,cursor:"pointer"}}>{t}</button>;})}
      </div>
      {locatedAll.length===0 ? (
        <div style={{padding:"24px 16px",textAlign:"center",background:C.gray50,borderRadius:12,border:"1px solid "+C.border}}>
          <div style={{fontSize:13,fontWeight:700,color:C.navy,marginBottom:4}}>No zone-located pitches</div>
          <div style={{fontSize:11,color:C.gray500,lineHeight:1.5}}>Pitch locations could not be verified from this camera angle. Strike/ball results are still counted above, but no tendency grid is shown.</div>
        </div>
      ) : (
      <div style={{position:"relative",borderRadius:12,overflow:"hidden",border:"1px solid "+C.border,maxWidth:380,margin:"0 auto"}}>
        <svg width="100%" viewBox={"0 0 "+W+" "+H} style={{display:"block",background:C.navy}}>
          <rect width={W} height={H} fill={C.navy}/>
          <rect x={LX-10} y={SZT-30} width={SZW+20} height={SZH+70} fill={C.navyMid} rx="6"/>
          <rect x={RX-10} y={SZT-30} width={SZW+20} height={SZH+70} fill={C.navyMid} rx="6"/>
          <line x1={W/2} y1="20" x2={W/2} y2={H-20} stroke="rgba(255,255,255,0.08)" strokeWidth="1" strokeDasharray="4,4"/>
          {renderZoneGrid(filterPitches(rhhPitches),LX,"vs RHH","RHH")}
          {renderZoneGrid(filterPitches(lhhPitches),RX,"vs LHH","LHH")}
        </svg>
      </div>
      )}
      <div style={{display:"flex",gap:12,marginTop:10,flexWrap:"wrap"}}>
        {Object.keys(PITCH_COL).map(function(t){var cnt=(pitches||[]).filter(function(p){return p.pitchType===t;}).length;if(!cnt)return null;return <div key={t} style={{display:"flex",alignItems:"center",gap:5,fontSize:11,color:C.gray500}}><div style={{width:8,height:8,borderRadius:"50%",background:PITCH_COL[t],flexShrink:0}}/>{t} ({cnt})</div>;})}
      </div>
      <div style={{display:"flex",gap:16,marginTop:8,padding:"8px 12px",background:C.gray50,borderRadius:8}}>
        <div style={{fontSize:11,color:C.gray500}}>RHH: <span style={{fontWeight:700,color:C.gray800}}>{rhhStats.total} located</span> — {rhhStats.pct}% strike</div>
        <div style={{fontSize:11,color:C.gray500}}>LHH: <span style={{fontWeight:700,color:C.gray800}}>{lhhStats.total} located</span> — {lhhStats.pct}% strike</div>
      </div>
    </div>
  );
}

function SprayChart({battedBalls,playerName,verifiedEvs}){
  if(!battedBalls||battedBalls.length===0) return <EmptyCard icon="S" title="No Batted Ball Data" sub="BBOT logs these automatically from session video"/>;
  var W=400; var H=360; var HX=W/2; var HY=H-32; var SC=(H-70)/430;
  var ftToR=function(ft){return ft*SC;};
  var angRad=function(deg){return (deg-90)*Math.PI/180;};
  var wallPt=function(r,a){return {x:HX+ftToR(r)*Math.cos(a),y:HY+ftToR(r)*Math.sin(a)};};
  var lfA=angRad(-44);var lcA=angRad(-22);var cfA=angRad(0);var rcA=angRad(22);var rfA=angRad(44);
  var FIELD={lf:325,lc:375,cf:400,rc:375,rf:325};
  var pts={LF:wallPt(FIELD.lf,lfA),LC:wallPt(FIELD.lc,lcA),CF:wallPt(FIELD.cf,cfA),RC:wallPt(FIELD.rc,rcA),RF:wallPt(FIELD.rf,rfA)};
  var wPts={LF:wallPt(FIELD.lf-14,lfA),LC:wallPt(FIELD.lc-14,lcA),CF:wallPt(FIELD.cf-14,cfA),RC:wallPt(FIELD.rc-14,rcA),RF:wallPt(FIELD.rf-14,rfA)};
  var wallStr=[pts.LF,pts.LC,pts.CF,pts.RC,pts.RF].map(function(p){return p.x+","+p.y;}).join(" ");
  var fieldStr=HX+","+HY+" "+wallStr;
  var warnStr=[wPts.LF,wPts.LC,wPts.CF,wPts.RC,wPts.RF].map(function(p){return p.x+","+p.y;}).join(" ");
  var base=ftToR(90)*0.707;
  var B1={x:HX+base,y:HY-base};var B2={x:HX,y:HY-base*2};var B3={x:HX-base,y:HY-base};
  var TYPE_COL={"Ground Ball":"#3b82f6","Line Drive":"#f59e0b","Fly Ball":"#94a3b8","Home Run":"#E97A7A"};
  var _veloOK=(typeof window!=="undefined")?window.__bbotVeloVisible:false;

  var total=battedBalls.length;
  // Direction is OBSERVED-only: pull/oppo/middle asserted only when clearly seen; unclear -> null -> OMITTED
  // from the spray (never defaulted to "Center"/"middle"). BBOT asserts only confirmed or observed, never a guess.
  var dirGroup=function(d){d=String(d||"").toLowerCase();if(d.indexOf("pull")>=0)return"Pull";if(d.indexOf("oppo")>=0)return"Oppo";if(d.indexOf("middle")>=0||d.indexOf("center")>=0)return"Center";return null;};
  var typeGroup=function(t){t=String(t||"");if(/ground/i.test(t))return"GB";if(/line/i.test(t))return"LD";if(/fly/i.test(t))return"FB";if(/home/i.test(t))return"HR";return"FB";};
  var hasType=function(b){return b && b.type!=null && String(b.type).trim()!=="";};
  var zones={Pull:[],Center:[],Oppo:[]};
  var placed=battedBalls.filter(function(b){return dirGroup(b.direction)!=null;});
  placed.forEach(function(b){zones[dirGroup(b.direction)].push(b);});
  var dirTotal=placed.length;                   // direction-share denominator = balls with a CLEARLY OBSERVED direction
  var omittedDir=total-dirTotal;                 // observed contacts whose direction was unclear -> omitted from the spray
  // #5 EMPTY-DIAMOND GUARD: if NO ball has a clearly observed direction, don't render an empty spray
  // diamond — show an honest empty state instead (exit velo is surfaced elsewhere in the report).
  if(dirTotal===0) return <EmptyCard icon="S" title="No Spray Direction" sub="Batted-ball direction wasn't clearly observable this session — no spray chart shown."/>;
  var smallSample=dirTotal<6;  // under 6 → show counts, not percentages (a single ball would distort %)
  // Header value per zone: percentage normally, raw count when the sample is small.
  var zoneVal=function(arr){return smallSample?String(arr.length):(dirTotal>0?Math.round(arr.length/dirTotal*100)+"%":"0%");};
  var zonePct=function(arr){return dirTotal>0?Math.round(arr.length/dirTotal*100):0;};
  // Type breakdown shown ONLY when EVERY ball in that direction has a clear type (no guessing).
  var typeBreak=function(arr){
    if(!arr.length) return "—";
    if(!arr.every(hasType)) return "";  // any unknown type → show direction count only, no type line
    var c={GB:0,LD:0,FB:0,HR:0};arr.forEach(function(b){c[typeGroup(b.type)]++;});
    var parts=[];["LD","GB","FB","HR"].forEach(function(k){if(c[k]>0)parts.push(k+" "+c[k]);});
    return parts.join(" · ")||"";
  };

  // Verified exit velo only (no estimated shown here). Overall + by type.
  var evOf=function(b){var v=Number(b.exitVelo!=null?b.exitVelo:(b.exitVeloMph!=null?b.exitVeloMph:null));return isNaN(v)?null:v;};
  var evObserved=battedBalls.map(evOf).filter(function(v){return v!=null&&v>0;});
  // OVERALL uses the full device-verified reading list when available (BBOT may visually read fewer
  // than the radar measured); by-type stats stay from the balls whose type was actually observed.
  var evDevice=(Array.isArray(verifiedEvs)&&verifiedEvs.length)?verifiedEvs.filter(function(v){return v!=null&&v>0;}):[];
  var evAll=evDevice.length?evDevice:evObserved;
  var evByType=function(tg){return battedBalls.filter(function(b){return typeGroup(b.type)===tg;}).map(evOf).filter(function(v){return v!=null&&v>0;});};
  var avg=function(a){return a.length?Math.round(a.reduce(function(x,y){return x+y;},0)/a.length):null;};
  var top=function(a){return a.length?Math.round(Math.max.apply(null,a)):null;};
  var ldEv=evByType("LD"), gbEv=evByType("GB"), fbEv=evByType("FB");
  var hasEv=_veloOK && evAll.length>0;

  // Zone label position — placed out toward the outfield wall where there's the most open
  // space, so Pull/Center/Oppo labels and their type breakdowns don't crowd the infield or
  // collide with each other. Side zones nudged further out along their angle.
  var zoneLabel=function(deg,dx){return {x:HX+ftToR(255)*Math.cos(angRad(deg))+dx, y:HY+ftToR(255)*Math.sin(angRad(deg))};};
  var lPull=zoneLabel(-32,-6), lCtr=zoneLabel(0,0), lOppo=zoneLabel(32,6);

  return(
    <div>
      <div style={{fontSize:11,color:C.gray400,marginBottom:8}}>{playerName} — {(Array.isArray(verifiedEvs)&&verifiedEvs.length>total)?(total+" of "+verifiedEvs.length+" observed"):(total+" batted balls observed")} <span style={{color:C.gray400}}>· observed on video</span></div>
      <div style={{fontSize:10,color:C.gray500,background:C.blueFaint,border:"1px solid "+C.blueLight,borderRadius:6,padding:"7px 10px",marginBottom:10,lineHeight:1.45}}>
        <strong style={{color:C.navy}}>Observed — not measured.</strong> Direction tendencies (share of batted balls hit to each field) and GB/LD/FB types are visual reads from video, shown only for balls clearly seen. BBOT does not track the ball — exact landing spots and distances are NOT plotted or measured.{omittedDir>0?" "+omittedDir+" contact"+(omittedDir===1?"":"s")+" had an unclear direction and "+(omittedDir===1?"is":"are")+" omitted from the spray (never guessed).":""}{smallSample?" Small sample — shown as counts.":""}
      </div>
      <div style={{position:"relative",borderRadius:12,overflow:"hidden",border:"1px solid "+C.border,maxWidth:380,margin:"0 auto"}}>
        <svg width="100%" viewBox={"0 0 "+W+" "+H} style={{display:"block"}}>
          <defs><radialGradient id="sc_sky" cx="50%" cy="100%" r="80%"><stop offset="0%" stopColor="#0d2a0d"/><stop offset="100%" stopColor="#060e08"/></radialGradient></defs>
          <rect width={W} height={H} fill="url(#sc_sky)"/>
          <polygon points={fieldStr} fill="#1e5c1e"/>
          <polygon points={HX+","+HY+" "+[wPts.LF,wPts.LC,wPts.CF,wPts.RC,wPts.RF].map(function(p){return p.x+","+p.y;}).join(" ")} fill="#3d2510" fillOpacity="0.5"/>
          <polyline points={warnStr} fill="none" stroke="#8B4513" strokeWidth="1" strokeOpacity="0.4"/>
          <polyline points={wallStr} fill="none" stroke="white" strokeWidth="2.5" strokeOpacity="0.9"/>
          <line x1={HX} y1={HY} x2={pts.LF.x} y2={pts.LF.y} stroke="white" strokeWidth="1.5" strokeOpacity="0.9"/>
          <line x1={HX} y1={HY} x2={pts.RF.x} y2={pts.RF.y} stroke="white" strokeWidth="1.5" strokeOpacity="0.9"/>
          {/* direction zone dividers */}
          <line x1={HX} y1={HY} x2={HX+ftToR(410)*Math.cos(angRad(-15))} y2={HY+ftToR(410)*Math.sin(angRad(-15))} stroke="rgba(255,255,255,0.3)" strokeWidth="1.2" strokeDasharray="5,4"/>
          <line x1={HX} y1={HY} x2={HX+ftToR(410)*Math.cos(angRad(15))} y2={HY+ftToR(410)*Math.sin(angRad(15))} stroke="rgba(255,255,255,0.3)" strokeWidth="1.2" strokeDasharray="5,4"/>
          {/* infield */}
          <circle cx={HX} cy={HY} r={base*1.42} fill="#5c3a1e" fillOpacity="0.7"/>
          {[[HX,HY,B1.x,B1.y],[B1.x,B1.y,B2.x,B2.y],[B2.x,B2.y,B3.x,B3.y],[B3.x,B3.y,HX,HY]].map(function(c,i){return <line key={i} x1={c[0]} y1={c[1]} x2={c[2]} y2={c[3]} stroke="#e2c98a" strokeWidth="1.5" strokeOpacity="0.7"/>;})}
          {[B1,B2,B3].map(function(b,i){return <rect key={i} x={b.x-4} y={b.y-4} width="8" height="8" fill="white" fillOpacity="0.9" rx="1" transform={"rotate(45,"+b.x+","+b.y+")"}/>;})}
          <polygon points={HX+","+(HY-7)+" "+(HX-5)+","+(HY+2)+" "+HX+","+(HY+5)+" "+(HX+5)+","+(HY+2)} fill="white" fillOpacity="0.95"/>
          {/* ZONE STATS — direction % + type breakdown, no plotted balls */}
          {[["PULL",zones.Pull,lPull],["CENTER",zones.Center,lCtr],["OPPO",zones.Oppo,lOppo]].map(function(z){
            return <g key={z[0]}>
              <text x={z[2].x} y={z[2].y-8} fontSize="7" fill="rgba(255,255,255,0.85)" textAnchor="middle" fontWeight="700" fontFamily="Inter,system-ui,sans-serif">{z[0]}</text>
              <text x={z[2].x} y={z[2].y+3} fontSize="11" fill="white" textAnchor="middle" fontWeight="700" fontFamily="Inter,system-ui,sans-serif">{zoneVal(z[1])}</text>
              <text x={z[2].x} y={z[2].y+13} fontSize="6" fill="rgba(255,255,255,0.7)" textAnchor="middle">{typeBreak(z[1])}</text>
            </g>;
          })}
        </svg>
      </div>
      {/* TYPE MIX (overall) */}
      <div style={{display:"flex",gap:14,marginTop:10,flexWrap:"wrap"}}>
        {[["Line Drive","#f59e0b","LD"],["Ground Ball","#3b82f6","GB"],["Fly Ball","#94a3b8","FB"],["Home Run","#E97A7A","HR"]].map(function(r){
          var cnt=battedBalls.filter(function(b){return typeGroup(b.type)===r[2];}).length;
          if(!cnt)return null;
          return <div key={r[2]} style={{display:"flex",alignItems:"center",gap:6,fontSize:11,color:C.gray500}}><div style={{width:9,height:9,borderRadius:"50%",background:r[1],flexShrink:0}}/>{r[0]} {Math.round(cnt/total*100)}%</div>;
        })}
      </div>
      {/* BATTED BALL MPH — device-verified. Total Sampled · AVG · Top, then by-type avg. */}
      {hasEv ? (
        <div style={{marginTop:12,padding:"10px 12px",background:C.gray50,borderRadius:8}}>
          <div style={{fontSize:10,color:C.gray500,letterSpacing:.5,marginBottom:6,fontWeight:700}}>BATTED BALL MPH <span style={{color:C.gray400,fontWeight:400}}>· device-verified</span></div>
          <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:6,textAlign:"center"}}>
            {[["Total Sampled",evAll.length],["AVG",avg(evAll)],["Top",top(evAll)]].map(function(r){
              return <div key={r[0]}>
                <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:18,color:C.blue,lineHeight:1}}>{r[1]!=null?r[1]:"—"}</div>
                <div style={{fontSize:8,color:C.gray400,marginTop:3,letterSpacing:.4}}>{r[0].toUpperCase()}</div>
              </div>;
            })}
          </div>
          {/* by-type averages, only where balls of that type were charted */}
          {(ldEv.length||gbEv.length||fbEv.length) ? (
            <div style={{display:"flex",gap:12,flexWrap:"wrap",marginTop:8,fontSize:10,color:C.gray600}}>
              {ldEv.length?<span>Line drive avg <strong>{avg(ldEv)}</strong></span>:null}
              {gbEv.length?<span>Ground ball avg <strong>{avg(gbEv)}</strong></span>:null}
              {fbEv.length?<span>Fly ball avg <strong>{avg(fbEv)}</strong></span>:null}
            </div>
          ) : null}
          {evDevice.length>battedBalls.length && (
            <div style={{fontSize:9,color:C.gray500,marginTop:8,lineHeight:1.45,fontStyle:"italic"}}>
              All {evDevice.length} readings are device-verified from the radar. {battedBalls.length} were also seen clearly enough on video to chart direction and type; the other {evDevice.length-battedBalls.length} have a verified speed but not a chartable angle.
            </div>
          )}
        </div>
      ) : (
        <div style={{fontSize:10,color:C.gray400,fontStyle:"italic",marginTop:10}}>{_veloOK?"No device-verified exit-velocity readings this session.":""}</div>
      )}
    </div>
  );
}
// ════════════════════════════════════════════════════════════════════════════════════════════════
// THE SOCIAL MEDIA MANAGER — prompt it, and it drafts posts from what actually happened
// ════════════════════════════════════════════════════════════════════════════════════════════════
// It opens on REAL RECENT ACTIVITY rather than an empty box, because the useful question is not
// "what would you like to say" but "what happened worth saying". Standouts are surfaced by the
// record's own bars, so BBOT can propose a post about a player nobody asked about.
//
// EVERY DRAFT SHOWS ITS RECEIPTS. The marks the record proves for that player are listed under the
// caption, so approving a post is reading its evidence rather than trusting its tone. Copy that
// needed a fabricated figure removed is not shown at all -- it is reported as dropped, with cause.
function SocialManagerView({notify}){
  var actS=useState(null); var act=actS[0]; var setAct=actS[1];
  var promptS=useState(""); var prompt=promptS[0]; var setPrompt=promptS[1];
  var busyS=useState(false); var busy=busyS[0]; var setBusy=busyS[1];
  var outS=useState(null); var out=outS[0]; var setOut=outS[1];
  // THE QUEUE, AND THE EDITS THAT FEED IT. `edits` holds the admin's in-progress text for each
  // generated post, keyed by player, so typing does not mutate the generated draft underneath it;
  // `queue` is what the server has actually persisted, which is the only thing that survives a
  // refresh. Nothing is "staged" because the page is showing it — it is staged because /social/stage
  // wrote it and handed the row back.
  var queueS=useState([]); var queue=queueS[0]; var setQueue=queueS[1];
  var editsS=useState({}); var edits=editsS[0]; var setEdits=editsS[1];
  var stagingS=useState(""); var staging=stagingS[0]; var setStaging=stagingS[1];

  useEffect(function(){
    fetch(BACKEND_URL+"/social/activity",{headers:bbotAdminHeaders()})
      .then(function(r){return r.json();})
      .then(function(j){ if(j&&j.ok) setAct(j); })
      .catch(function(){});
    loadQueue();
  },[]);

  function loadQueue(){
    return fetch(BACKEND_URL+"/social/drafts",{headers:bbotAdminHeaders()})
      .then(function(r){return r.json();})
      .then(function(j){ if(j&&j.ok) setQueue(j.drafts||[]); })
      .catch(function(){});
  }

  // STAGING RE-GATES ON THE SERVER, and the caption it hands back is the gated one — so what the
  // queue shows is what passed, not what was typed. A 422 here is the gate refusing an edit that
  // put back a figure the record cannot prove; it is reported with its cause and nothing is saved.
  function stage(p, existingId){
    var text=(edits[p.player_id]!==undefined?edits[p.player_id]:p.caption)||"";
    if(!text.trim()){ notify("Nothing to stage","error"); return; }
    setStaging(p.player_id);
    fetch(BACKEND_URL+"/social/stage",{method:"POST",headers:bbotAdminHeaders(),
      body:JSON.stringify({id:existingId||undefined, player_id:p.player_id,
                           report_id:p.report_id, caption:text})})
      .then(function(r){return r.json().then(function(j){return {ok:r.ok,j:j};});})
      .then(function(res){
        setStaging("");
        if(!res.ok){ notify(errText(res.j&&res.j.detail,"The copy gate refused that edit"),"error"); return; }
        var f=(res.j.stripped||[]).length;
        notify(f?("Staged — "+f+" item(s) stripped by the copy gate"):"Staged for approval");
        setEdits(function(e){var n=Object.assign({},e); delete n[p.player_id]; return n;});
        loadQueue();
      }).catch(function(e){ setStaging(""); notify("Staging failed: "+(e.message||"unknown"),"error"); });
  }

  function draftUpdate(id, body){
    fetch(BACKEND_URL+"/social/draft-update",{method:"POST",headers:bbotAdminHeaders(),
      body:JSON.stringify(Object.assign({id:id}, body))})
      .then(function(r){return r.json();})
      .then(function(j){ if(j&&j.ok){ setQueue(j.drafts||[]); notify(body.delete?"Draft removed":"Draft "+(body.status||"updated")); } })
      .catch(function(e){ notify("Update failed: "+(e.message||"unknown"),"error"); });
  }

  function run(p){
    var q=(p||prompt||"").trim();
    if(!q){ notify("Tell BBOT what you want a post about","error"); return; }
    setBusy(true); setOut(null);
    fetch(BACKEND_URL+"/social/generate",{method:"POST",headers:bbotAdminHeaders(),
      body:JSON.stringify({instruction:q})})
      .then(function(r){return r.json().then(function(j){return {ok:r.ok,j:j};});})
      .then(function(res){
        setBusy(false);
        if(!res.ok||!res.j||!res.j.ok){ notify(errText(res.j&&(res.j.detail||res.j.error),"Generation failed"),"error"); return; }
        setOut(res.j);
        var n=(res.j.posts||[]).length, d=(res.j.dropped||[]).length;
        notify(n+" draft"+(n===1?"":"s")+(d?(" · "+d+" dropped by the copy gate"):""));
      }).catch(function(e){ setBusy(false); notify("Generation failed: "+(e.message||"unknown"),"error"); });
  }

  function copy(t){
    try{ navigator.clipboard.writeText(t); notify("Caption copied"); }catch(e){ notify("Copy failed","error"); }
  }

  var QUICK=["Post about this week's standouts","Highlight the most recent evaluations",
             "A post for each player who cleared a standout mark"];
  return <div style={{maxWidth:780}}>
    <SectionHeader>Social Manager</SectionHeader>
    <p style={{fontSize:12,color:C.gray500,marginBottom:14,lineHeight:1.6}}>
      Tell BBOT what you want. It writes the words; the numbers come from approved evaluations and
      it cannot invent one. Edit any draft, stage it, and approve it in the queue below — nothing
      posts anywhere; approving marks a draft ready to post by hand.
    </p>

    <Card style={{padding:14,marginBottom:14}}>
      <textarea value={prompt} onChange={function(e){setPrompt(e.target.value);}} rows={3}
        placeholder="e.g. a post for Jhosuil, or this week's standouts"
        style={{width:"100%",padding:11,border:"1px solid "+C.border,borderRadius:8,fontSize:14,
                fontFamily:"inherit",lineHeight:1.6,resize:"vertical"}}/>
      <div style={{display:"flex",gap:8,flexWrap:"wrap",marginTop:10,alignItems:"center"}}>
        <Btn v="primary" style={{fontSize:12}} disabled={busy} onClick={function(){run();}}>{busy?"Writing…":"Generate posts"}</Btn>
        {QUICK.map(function(q){return <button key={q} onClick={function(){setPrompt(q);run(q);}}
          style={{background:"none",border:"1px solid "+C.border,borderRadius:99,padding:"5px 11px",
                  fontSize:11,color:C.blue,cursor:"pointer",fontWeight:600}}>{q}</button>;})}
      </div>
    </Card>

    {act && (act.standouts||[]).length>0 && !out && (
      <Card style={{padding:14,marginBottom:14}}>
        <div style={{fontSize:10,letterSpacing:1.1,fontWeight:800,color:C.coral,marginBottom:8}}>BBOT SEES THESE STANDOUTS</div>
        {act.standouts.map(function(s){
          return <div key={s.player_id} style={{display:"flex",justifyContent:"space-between",
            gap:10,padding:"7px 0",borderBottom:"1px solid "+C.gray50,flexWrap:"wrap"}}>
            <div style={{fontSize:13,fontWeight:700,color:C.navy}}>{s.name}
              <span style={{fontWeight:600,color:C.gray500,fontSize:11}}>{s.position?(" · "+s.position):""}{s.date?(" · "+s.date):""}</span></div>
            <div style={{fontSize:12,color:C.gray600}}>
              {s.standout_marks.map(function(m,i){return <span key={i} style={{marginLeft:8}}>
                <strong style={{color:C.blue}}>{m.value}</strong> {m.unit} {m.label}</span>;})}
            </div>
          </div>;
        })}
      </Card>
    )}

    {out && (out.posts||[]).map(function(p,i){
      return <Card key={i} style={{padding:14,marginBottom:10}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"baseline",gap:10,flexWrap:"wrap"}}>
          <div style={{fontSize:13,fontWeight:700,color:C.navy}}>{p.name||"643 Sports MGMT"}
            <span style={{fontWeight:600,color:C.gray500,fontSize:11}}>{p.position?(" · "+p.position):""}{p.date?(" · "+p.date):""}</span></div>
          <div style={{display:"flex",gap:8}}>
            <button onClick={function(){copy(edits[p.player_id]!==undefined?edits[p.player_id]:p.caption);}}
              style={{background:"none",border:"1px solid "+C.border,
              borderRadius:6,padding:"4px 10px",fontSize:11,color:C.blue,cursor:"pointer",fontWeight:600}}>Copy</button>
            <Btn v="primary" style={{fontSize:11,padding:"4px 12px"}} disabled={staging===p.player_id}
              onClick={function(){stage(p);}}>{staging===p.player_id?"Staging…":"Stage for approval"}</Btn>
          </div>
        </div>
        <textarea value={edits[p.player_id]!==undefined?edits[p.player_id]:p.caption}
          onChange={function(e){var v=e.target.value; setEdits(function(s){var n=Object.assign({},s); n[p.player_id]=v; return n;});}}
          rows={3} style={{width:"100%",margin:"9px 0 10px",padding:10,border:"1px solid "+C.border,
            borderRadius:8,fontSize:14.5,lineHeight:1.65,color:C.gray900,fontFamily:"inherit",resize:"vertical"}}/>
        {(p.marks||[]).length>0 && <div style={{borderTop:"1px solid "+C.gray50,paddingTop:8}}>
          <div style={{fontSize:9.5,letterSpacing:1,fontWeight:800,color:C.gray400,marginBottom:5}}>THE RECEIPTS BEHIND THIS POST</div>
          <div style={{display:"flex",flexWrap:"wrap",gap:8}}>
            {p.marks.map(function(m,j){return <span key={j} style={{background:C.gray50,borderRadius:7,
              padding:"4px 9px",fontSize:11.5,color:C.gray700}}>
              <strong style={{color:m.standout?C.coral:C.navy}}>{m.value}</strong> {m.unit} {m.label}</span>;})}
          </div>
        </div>}
        {p.why && <div style={{fontSize:11,color:C.gray400,marginTop:8}}>{p.why}</div>}
      </Card>;
    })}

    {out && (out.dropped||[]).length>0 && (
      <Card style={{padding:12,borderColor:C.coral}}>
        <div style={{fontSize:10,letterSpacing:1.1,fontWeight:800,color:C.coral,marginBottom:6}}>DROPPED BY THE COPY GATE</div>
        {out.dropped.map(function(d,i){
          return <div key={i} style={{fontSize:12,color:C.gray600,lineHeight:1.6}}>
            <strong>{d.name||"a post"}</strong> — {(d.why||[]).join("; ")}</div>;
        })}
        <div style={{fontSize:11,color:C.gray400,marginTop:6,lineHeight:1.5}}>
          These needed a figure the record does not prove, so they were refused whole rather than
          shown with the number cut out. Run the prompt again.
        </div>
      </Card>
    )}

    {out && !(out.posts||[]).length && !(out.dropped||[]).length &&
      <EmptyCard icon="bbot" title="Nothing to post" sub="No recent activity carries a receipted mark that supports a post."/>}

    {/* THE APPROVAL QUEUE. This is the part that survives a refresh: it is read from the server on
        mount, not held in this component. Editing here re-stages through the same gate, so a
        caption cannot be edited past it after the fact. Approving marks a draft ready to post by
        hand — BBOT still posts nothing itself, which is the promise the tab has always made. */}
    <div style={{marginTop:22}}>
      <SectionHeader>Approval queue</SectionHeader>
      <p style={{fontSize:12,color:C.gray500,marginBottom:12,lineHeight:1.6}}>
        Staged drafts, saved on the server. Edit one and it is re-checked against that player's own
        record before it is saved again — the gate runs on the edit, not just on what BBOT wrote.
      </p>
      {!queue.length && <EmptyCard icon="bbot" title="Nothing staged"
        sub="Generate posts above, edit what you want, then stage them here."/>}
      {queue.map(function(d){
        var approved=isApprovedPost(d);
        return <Card key={d.id} style={{padding:14,marginBottom:10,
          borderColor:approved?C.blue:C.border}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"baseline",gap:10,flexWrap:"wrap"}}>
            <div style={{fontSize:13,fontWeight:700,color:C.navy}}>{d.name||"643 Sports MGMT"}
              <span style={{fontWeight:600,color:C.gray500,fontSize:11}}>{d.position?(" · "+d.position):""}{d.date?(" · "+d.date):""}</span>
              <span style={{marginLeft:8,fontSize:10,letterSpacing:1,fontWeight:800,
                color:approved?C.blue:C.gray400}}>{approved?"APPROVED":"STAGED"}</span></div>
            <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
              <button onClick={function(){copy(edits["q"+d.id]!==undefined?edits["q"+d.id]:d.caption);}}
                style={{background:"none",border:"1px solid "+C.border,borderRadius:6,padding:"4px 10px",
                  fontSize:11,color:C.blue,cursor:"pointer",fontWeight:600}}>Copy</button>
              <button onClick={function(){stage({player_id:d.player_id,report_id:d.report_id,
                caption:edits["q"+d.id]!==undefined?edits["q"+d.id]:d.caption}, d.id);}}
                style={{background:"none",border:"1px solid "+C.border,borderRadius:6,padding:"4px 10px",
                  fontSize:11,color:C.blue,cursor:"pointer",fontWeight:600}}>Save edit</button>
              <button onClick={function(){draftUpdate(d.id,{status:approved?"staged":"approved"});}}
                style={{background:"none",border:"1px solid "+(approved?C.border:C.blue),borderRadius:6,
                  padding:"4px 10px",fontSize:11,color:approved?C.gray500:C.blue,cursor:"pointer",fontWeight:600}}>
                {approved?"Unapprove":"Approve"}</button>
              <button onClick={function(){draftUpdate(d.id,{delete:true});}}
                style={{background:"none",border:"1px solid "+C.border,borderRadius:6,padding:"4px 10px",
                  fontSize:11,color:C.coral,cursor:"pointer",fontWeight:600}}>Delete</button>
            </div>
          </div>
          <textarea value={edits["q"+d.id]!==undefined?edits["q"+d.id]:d.caption}
            onChange={function(e){var v=e.target.value; setEdits(function(s){var n=Object.assign({},s); n["q"+d.id]=v; return n;});}}
            rows={3} style={{width:"100%",margin:"9px 0 10px",padding:10,border:"1px solid "+C.border,
              borderRadius:8,fontSize:14.5,lineHeight:1.65,color:C.gray900,fontFamily:"inherit",resize:"vertical"}}/>
          {(d.marks||[]).length>0 && <div style={{borderTop:"1px solid "+C.gray50,paddingTop:8}}>
            <div style={{fontSize:9.5,letterSpacing:1,fontWeight:800,color:C.gray400,marginBottom:5}}>THE RECEIPTS BEHIND THIS POST</div>
            <div style={{display:"flex",flexWrap:"wrap",gap:8}}>
              {d.marks.map(function(m,j){return <span key={j} style={{background:C.gray50,borderRadius:7,
                padding:"4px 9px",fontSize:11.5,color:C.gray700}}>
                <strong style={{color:m.standout?C.coral:C.navy}}>{m.value}</strong> {m.unit} {m.label}</span>;})}
            </div>
          </div>}
        </Card>;
      })}
    </div>
  </div>;
}

// ════════════════════════════════════════════════════════════════════════════════════════════════
// THE PUBLIC ACTIVITY FEED — what BBOT is doing, as it happens (built 2026-08-22)
// ════════════════════════════════════════════════════════════════════════════════════════════════
// WHAT WAS ACTUALLY THERE BEFORE, because "I don't see it" deserved a straight answer: nothing.
// The site had a signed-in COMMUNITY feed (`FeedPage`, nav More -> Feed, reading `feed_items` --
// likes, follows, profile updates) and a per-profile `YourActivityPage`. Neither is this. There was
// no public page, no `activity` route and no nav entry anywhere in the four nav arrays. The public
// real-time stream was never built, not built-and-unwired.
//
// FOUR EVENT TYPES, ALL FROM THE RECORD: an evaluation published, a clip approved, a skeleton
// rendered, a profile added. Reverse-chronological, polled so it moves without a refresh, and new
// items prepend.
//
// RECEIPTED OR SILENT. An evaluation shows ONE lead stat and only if that value survived the
// credibility gate and suits the player's position -- no exit velocity on a pitcher, no number
// without a receipt. An event with nothing provable shows its headline and no figure at all.
// Archived, superseded and unapproved rows never enter the stream.
var BBOT_ACTIVITY_POLL_MS = 30000;

function bbotActivityItems(scoutReports, users, clips, highlights, events){
  var out = [];
  var uOf = function(id){ return (users||[]).find(function(x){return String(x.id)===String(id);}); };

  (scoutReports||[]).forEach(function(r){
    if(!isLiveEval(r)) return;                     // approved/published only
    // THE PUBLIC FEED WAS DISCARDING EVERY PUBLISHED EVALUATION, and it looked like an empty feed
    // rather than a broken one.
    //
    // This read `var u = uOf(r.playerId); if(!u) return;` -- a join against the ROSTER. /roster
    // needs a signed-in caller, so for a visitor it 401s and falls back to {users:[]}, `uOf`
    // returns undefined for every row, and all nine approved evaluations were dropped on the floor.
    // The page then rendered "Nothing yet ... Updates every 30 seconds", which is indistinguishable
    // from a product with nothing in it. Twelve queries returned 200; the data was there and thrown
    // away. [[absence-is-not-a-finding]]
    //
    // THE NAME IS ALREADY ON THE ROW. `bbot_reports_public` carries `player_name` and `player_id`,
    // denormalised for exactly this -- so the join is not needed and nothing about who may read the
    // roster has to change. A signed-in reader still gets the roster record when there is one, and
    // the fields the row does NOT carry (position, grad year) simply stay empty: a feed entry with
    // no position is a smaller claim than one with a guessed position.
    var u = uOf(r.playerId);
    var pubName = String(r.playerName || r.player_name || "").trim();
    if(!u && !pubName) return;                     // no name anywhere is a row we cannot speak
    var mv = r.measuredValues || (r.fullReport&&r.fullReport.measuredValues) || {};
    var withheld = bbotWithheldKeys(r);
    var pos = String((u&&u.position)||"").toUpperCase();
    var isP = BBOT_PITCHER_POS.indexOf(pos) >= 0;
    // ONE LEAD STAT, POSITION-APPROPRIATE AND RECEIPTED. The order is what a reader of that
    // position cares about first; every candidate must clear the withheld check to be spoken.
    var order = isP ? [["pitchVeloPeak","mph fastball"],["throwVelo","mph throw"]]
                    : [["exitVeloPeak","mph exit velo"],["throwVelo","mph throw"],
                       ["h2f","s home-to-1st"],["dash60","s 60-yard"]];
    var lead = null;
    for(var i=0;i<order.length;i++){
      var k=order[i][0];
      if(mv[k]!=null && !withheld[k]){ lead={value:mv[k], unit:order[i][1]}; break; }
    }
    out.push({kind:"evaluation", at:r.date||r.sessionDate||"", id:"ev-"+r.id,
              playerId:(u?u.id:(r.playerId||r.player_id)),
              name:(u ? (u.firstName+" "+u.lastName) : pubName),
              position:(u&&u.position)||"", gradYear:(u&&u.gradYear)||"",
              lead:lead, reportId:r.id});
  });

  // CLIPS AND SKELETONS BOTH LIVE IN bbot_clips, told apart by clip_type — the first cut looked for
  // skeletons in `highlights`, where there are none, so that event type could never have appeared.
  //
  // APPROVED MEANS approved===true. It was written as "not false", which admits a row whose
  // approval is null or missing — i.e. a clip still sitting in pending_approval, published to a
  // public page before anyone cleared it. On a surface anyone can read, the default must be no.
  (clips||[]).forEach(function(c){
    if(c.approved!==true) return;
    var u = uOf(c.player_id||c.playerId); if(!u) return;
    var isSkel = String(c.clip_type||c.action_type||"").toLowerCase()==="skeleton";
    out.push({kind:isSkel?"skeleton":"clip", at:c.created_at||c.session_date||"",
              id:(isSkel?"sk-":"cl-")+(c.id),
              playerId:u.id, name:u.firstName+" "+u.lastName, position:u.position||"",
              objectKey:c.clip_object_key||null, label:c.action_type||""});
  });

  (users||[]).forEach(function(u){
    if(u.type!=="player") return;
    var created = (u.profile&&u.profile.createdAt) || u.createdAt || u.created_at;
    if(!created) return;
    out.push({kind:"profile", at:String(created).slice(0,10), id:"pr-"+u.id,
              playerId:u.id, name:u.firstName+" "+u.lastName, position:u.position||"",
              gradYear:u.gradYear||""});
  });

  // A LAUNCHED EVENT IS ACTIVITY. (Luis, 2026-10-22: "whenever an event is created it gets posted
  // on activity wall.")
  //
  // DERIVED, NOT POSTED. The obvious build is to insert a row into a posts table when an event is
  // created -- and then a failed insert, an event created before this shipped, or an edited date
  // leaves the wall disagreeing with the event itself, with no way to notice. Reading the events
  // directly means the wall cannot drift: launch one and it is there, un-launch it and it is
  // gone, change the date and the wall changes too. Nothing to backfill and nothing to keep in
  // sync. [[one-home-per-value]] [[prose-is-not-a-data-source]]
  //
  // `published` IS THE GATE, same as every other events surface -- a draft with a wrong price is
  // not an announcement. The signed-in read returns published rows only and the anon view is
  // filtered in SQL, so this re-check is belt-and-braces rather than the boundary.
  (events||[]).forEach(function(e){
    if(e.published===false) return;
    // Creation is what the wall is ordering by; `start_date` is the fallback for the anon view,
    // which does not carry `created_at` on databases where that migration has not run.
    var at = e.created_at || e.start_date;
    if(!at) return;
    out.push({kind:"event", at:String(at).slice(0,10), id:"ev-"+e.id,
              name:e.name||"Event", eventType:e.event_type||"",
              startDate:e.start_date||"", endDate:e.end_date||"", startTime:e.start_time||"",
              where:e.venue||e.location||"", cost:e.cost,
              registered:Number(e.registered_count)||0});
  });

  return out.filter(function(x){return x.at;})
            .sort(function(a,b){return String(b.at).localeCompare(String(a.at));})
            .slice(0, 60);
}

function ActivityPage({scoutReports, users, highlights, go, cu, notify}){
  var clipsS=useState([]); var clips=clipsS[0]; var setClips=clipsS[1];
  var evS=useState([]); var pageEvents=evS[0]; var setPageEvents=evS[1];
  var tickS=useState(0); var setTick=tickS[1];
  useEffect(function(){
    var alive=true;
    function pull(){
      sbSelect("bbot_clips","?select=*&order=created_at.desc&limit=60").then(function(rows){
        if(alive && Array.isArray(rows)) setClips(rows);
      }).catch(function(){});
      // EVENTS, BY WHOEVER IS LOOKING. This page renders for a logged-out visitor as well as a
      // signed-in one, and those are two different doors: a visitor has no token, so `/events`
      // would 401 and the wall would silently lose every event. The anon path reads
      // `bbot_events_public`, the published-only view that carries no registrant details.
      // [[anon-caller-not-admin-view]]
      if(bbotAuthToken()){
        fetch(BACKEND_URL+"/events",{headers:bbotAdminHeaders()})
          .then(function(r){ return r.ok?r.json():{events:[]}; })
          .then(function(j){ if(alive) setPageEvents((j&&j.events)||[]); })
          .catch(function(){});
      } else {
        fetch(SUPABASE_URL+"/rest/v1/bbot_events_public?order=start_date.asc",{headers:sbHeaders()})
          .then(function(r){ return r.ok?r.json():[]; })
          .then(function(rows){ if(alive && Array.isArray(rows)) setPageEvents(rows); })
          .catch(function(){});
      }
    }
    pull();
    // LIVE WITHOUT A SOCKET. Polling is honest here: the stream is minutes-fresh, not
    // milliseconds-fresh, and claiming realtime would need infrastructure this does not have.
    var t=setInterval(function(){ pull(); setTick(function(n){return n+1;}); }, BBOT_ACTIVITY_POLL_MS);
    return function(){ alive=false; clearInterval(t); };
  }, []);

  var items = bbotActivityItems(scoutReports, users, clips, highlights, pageEvents);

  // PREVIEWS FOR WHAT IS ON SCREEN, and only that. The clip files sit in private storage behind a
  // signed-URL endpoint, so a preview costs a request per clip -- fetching all sixty would hammer
  // the backend to fill thumbnails nobody has scrolled to yet.
  var urlS=useState({}); var urls=urlS[0]; var setUrls=urlS[1];
  // ONE HOME FOR THE FETCH. The automatic pass and the on-demand button were going to be two
  // copies of the same request, which is how they drift -- one gets the null-on-failure handling
  // and the other does not. `undefined` = never asked, `null` = asked and it failed, a string =
  // playable. Those three states are what the renderer switches on.
  function loadUrl(k){
    if(!k) return;
    setUrls(function(m){ if(m[k]!==undefined) return m; var n=Object.assign({},m); n[k]="__loading"; return n; });
    fetch(BACKEND_URL+"/r2-read-url?objectKey="+encodeURIComponent(k))
      .then(function(r){return r.json();})
      .then(function(d){ setUrls(function(m){var n=Object.assign({},m); n[k]=(d&&d.url)||null; return n;}); })
      .catch(function(){ setUrls(function(m){var n=Object.assign({},m); n[k]=null; return n;}); });
  }
  var needKeys = items.filter(function(i){return i.objectKey;}).slice(0,10)
                      .map(function(i){return i.objectKey;});
  useEffect(function(){
    needKeys.forEach(function(k){ loadUrl(k); });
  }, [needKeys.join("|")]);

  // A TIMESTAMP A PERSON CAN READ. The raw column is an ISO string with microseconds and an offset;
  // printing it verbatim put "2026-08-19T22:03:34.246241+00:00" on a public page.
  function when(s){
    var t=String(s||"");
    if(!t) return "";
    var d=new Date(t);
    if(isNaN(d.getTime())) return t.slice(0,10);
    var mins=Math.floor((Date.now()-d.getTime())/60000);
    if(mins<1) return "just now";
    if(mins<60) return mins+" min ago";
    if(mins<1440) return Math.floor(mins/60)+"h ago";
    if(mins<10080) return Math.floor(mins/1440)+"d ago";
    return d.toISOString().slice(0,10);
  }
  var META = {
    evaluation:{label:"EVALUATION PUBLISHED", col:C.blue},
    clip:{label:"CLIP READY", col:C.coral},
    skeleton:{label:"SKELETON RENDERED", col:C.navy},
    profile:{label:"PROFILE ADDED", col:C.gray500},
    event:{label:"EVENT ANNOUNCED", col:C.coral}
  };
  // THE COMPOSER GOES WHERE THE WALL IS. It was mounted only on the admin dashboard's Activity
  // TAB, which is a different screen from this one -- so "post to activity" existed and was not
  // where anybody looked for it. Admin sees the composer; everyone sees the posts and can press
  // the seam dot.
  var _wallAdmin = !!(cu && bbotIsAdmin(cu));
  var _lk = useActivityLikes(items.map(function(it){ return it.id; }), cu);
  return <div style={{maxWidth:720,margin:"0 auto",width:"100%",padding:"0 16px"}}>
    {cu && <ActivityPosts cu={cu} notify={notify||function(){}} isAdmin={_wallAdmin}/>}
    <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:6}}>
      <BbotMark size={32}/>
      <div>
        <h1 style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:26,letterSpacing:2,color:C.gray900,margin:0}}>ACTIVITY</h1>
        <p style={{color:C.gray500,fontSize:13,margin:"3px 0 0"}}>Everything BBOT measures, as it happens.</p>
      </div>
    </div>
    <div style={{height:3,width:48,background:C.coral,borderRadius:99,margin:"12px 0 18px"}}/>
    {items.length===0
      ? <EmptyCard icon="bbot" title="Nothing yet" sub="Published evaluations, clips, profiles and events appear here as they happen."/>
      : <div style={{display:"flex",flexDirection:"column",gap:7}}>
          {items.map(function(it){
            var m=META[it.kind]||META.profile;
            // THE CARD NO LONGER NAVIGATES. A click anywhere on it went to the player's profile,
            // so pressing PLAY on a clip threw the viewer off the page -- the one thing a feed
            // must never do. Navigation is now an explicit link on the name; the card itself is
            // just a card, and the video is watchable where it sits.
            return <Card key={it.id} style={{padding:"8px 10px"}}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"baseline",gap:10,flexWrap:"wrap"}}>
                <div style={{fontSize:9.5,letterSpacing:1.2,fontWeight:800,color:m.col}}>{m.label}</div>
                <div style={{fontSize:11,color:C.gray400}}>{when(it.at)}</div>
              </div>
              {/* A MEDIA ITEM IS A ROW, NOT A STACK. Bounding the tile to 300px stopped the clip
                  being magnified, and left ~400px of empty column beside it -- the fix for one
                  defect making another. The clip sits BESIDE its caption now, so the width is used
                  and the tile still never grows past the size the profile gives the same object.
                  Text-only items are untouched: they have nothing to sit beside. */}
              {(it.kind==="clip"||it.kind==="skeleton") ? (
                <div style={{display:"flex",gap:12,alignItems:"flex-start",marginTop:5,flexWrap:"wrap"}}>
                  <div style={{flex:"0 1 190px",minWidth:150,maxWidth:210}}>
                    {/* EVERY POST IS PLAYABLE, NOT JUST THE FIRST TEN.
                        Preview URLs were fetched for `items.slice(0,10)` only -- a real cost
                        control, since each one is a signed-URL request. But everything past the
                        tenth then showed "open the profile to watch it" FOREVER: no amount of
                        waiting or scrolling loaded it, and the sentence telling you where to go
                        was not even a link. A post nobody can open is not a post.
                        So the cap stays for AUTOMATIC loading and anything beyond it loads when
                        asked. The backend is still not hammered -- a request happens because
                        somebody wanted that clip. */}
                    {urls[it.objectKey]==="__loading"
                      ? <div style={{height:118,display:"flex",alignItems:"center",justifyContent:"center",
                                     borderRadius:8,background:C.gray50,fontSize:12,color:C.gray400}}>Loading…</div>
                      : urls[it.objectKey]
                      ? <BbotPreviewVideo src={urls[it.objectKey]}
                          style={{width:"100%",height:118,objectFit:"contain",borderRadius:7,
                                  display:"block",background:"#0f172a"}}/>
                      : urls[it.objectKey]===null
                        ? <div style={{fontSize:12,color:C.gray400,lineHeight:1.5}}>
                            This {it.kind==="skeleton"?"skeleton":"clip"} could not be loaded.
                            {it.playerId && go ? <> <span onClick={function(){go("profile-"+it.playerId);}} style={{color:C.blue,cursor:"pointer",textDecoration:"underline"}}>Open the profile</span>.</> : null}
                          </div>
                        : <button type="button" onClick={function(){ loadUrl(it.objectKey); }}
                            style={{width:"100%",height:118,borderRadius:7,border:"1px dashed "+C.border,
                                    background:C.gray50,color:C.blue,fontSize:12,fontWeight:700,
                                    cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",gap:6}}>
                            ▶ Play {it.kind==="skeleton"?"skeleton":"clip"}
                          </button>}
                  </div>
                  <div style={{flex:"1 1 200px",minWidth:0}}>
                    {/* NAVIGATION IS NOW AN EXPLICIT LINK, since the card stopped being one.
                        The name is the obvious place for it and makes the destination legible --
                        a whole-card click told the reader nothing about where they were going. */}
                    <div style={{fontWeight:700,fontSize:13,color:C.navy}}>
                      {it.playerId && go
                        ? <span onClick={function(){ go("profile-"+it.playerId); }}
                            style={{color:C.blue,cursor:"pointer"}} title="Open this player's profile">{it.name} &rarr;</span>
                        : it.name}
                      <span style={{fontSize:11.5,fontWeight:600,color:C.gray500}}>
                        {(it.position?" · "+it.position:"")+(it.gradYear?" · "+it.gradYear:"")}
                      </span>
                    </div>
                    <div style={{fontSize:11.5,color:C.gray500,marginTop:4,lineHeight:1.5}}>
                      {it.kind==="skeleton"
                        ? "Computer-tracked recreation of the movement — dots and sticks, separate from the video."
                        : "Clip from this session, on the player's profile."}
                    </div>
                  </div>
                </div>
              ) : (
              <div style={{fontWeight:700,fontSize:13.5,color:C.navy,marginTop:3}}>
                {it.name}
                <span style={{fontSize:12,fontWeight:600,color:C.gray500}}>
                  {(it.position?" · "+it.position:"")+(it.gradYear?" · "+it.gradYear:"")}
                </span>
              </div>
              )}
              {/* AN EVENT CARD CARRIES WHAT SOMEONE NEEDS TO DECIDE: when, where, what it costs,
                  and a way in. The registered count is a COUNT and never a list -- the endpoint
                  and the public view both compute it server-side precisely so no name crosses
                  onto a page a stranger can read. [[sample-data-is-published-data]] */}
              {it.kind==="event" && (function(){
                var dd=function(d){ if(!d) return ""; var p=String(d).split("-"); return p.length===3?(p[1]+"/"+p[2]+"/"+p[0].slice(2)):String(d); };
                var dateStr=it.startDate?(dd(it.startDate)+(it.endDate&&it.endDate!==it.startDate?(" – "+dd(it.endDate)):"")):"Date TBA";
                var costStr=(it.cost!=null&&String(it.cost).trim()!==""&&Number(String(it.cost).replace(/[^0-9.]/g,""))>0)
                  ? ("$"+String(it.cost).replace(/[^0-9.]/g,"")) : "";
                return <div style={{marginTop:4}}>
                  <div style={{fontSize:12.5,color:C.gray700}}>
                    {[dateStr,it.startTime,it.where].filter(Boolean).join(" · ")}
                    {costStr?<span style={{marginLeft:6,padding:"2px 7px",background:C.coral,color:C.white,borderRadius:99,fontSize:11,fontWeight:700}}>{costStr}</span>:null}
                  </div>
                  <div style={{marginTop:6,display:"flex",alignItems:"center",gap:10,flexWrap:"wrap"}}>
                    <button onClick={function(e){ e.stopPropagation(); go(cu?"events":"auth"); }}
                      style={{padding:"5px 12px",borderRadius:7,border:"none",background:C.navy,color:C.white,fontSize:11,fontWeight:700,cursor:"pointer"}}>
                      {cu?"View & register":"Create a profile to register"}
                    </button>
                    {it.registered>0 && <span style={{fontSize:11,color:C.gray400}}>{it.registered} registered</span>}
                  </div>
                </div>;
              })()}
              {it.kind==="evaluation" && (it.lead
                ? <div style={{marginTop:4,fontSize:12.5,color:C.gray700}}>
                    <strong style={{color:C.blue,fontSize:15}}>{it.lead.value}</strong> {it.lead.unit}
                  </div>
                : <div style={{marginTop:6,fontSize:12,color:C.gray400}}>Evaluation published — see the card for the measured detail.</div>)}
              {/* THE SEAM DOT BELONGS ON EVERY ENTRY. stopPropagation because the card itself
                  navigates to the profile -- a like must not be a click-through. */}
              {cu && (function(){
                var st=_lk.likes[it.id]||{count:0,liked:false};
                return <div style={{marginTop:8}} onClick={function(e){e.stopPropagation();}}>
                  <SeamDot liked={st.liked} count={st.count} busy={_lk.busy===it.id}
                    onPress={function(){ _lk.toggle(it.id); }}/>
                </div>;
              })()}
</Card>;
          })}
        </div>}
    <div style={{fontSize:11,color:C.gray400,textAlign:"center",marginTop:18,lineHeight:1.6}}>
      Updates every {Math.round(BBOT_ACTIVITY_POLL_MS/1000)} seconds. Every figure shown is a device
      reading or an admin-timed measurement; where a value has no receipt, none is shown.
    </div>
  </div>;
}

// ════════════════════════════════════════════════════════════════════════════════════════════════
// THE BLOG TEMPLATE — a post is FILLED IN, never formatted (built 2026-08-22)
// ════════════════════════════════════════════════════════════════════════════════════════════════
// WHY A TEMPLATE AND NOT A RICH-TEXT BOX. A free editor makes every post a fresh design decision,
// and the tenth one never looks like the first. Here the layout is fixed and the admin supplies
// CONTENT for named slots: category, title, dek, hero, sections, pull-quote, data callout, CTA.
// Brand tokens come from `C` — the one source — so a post cannot be off-brand by construction.
//
// WHAT THE BLOG SYSTEM ACTUALLY WAS BEFORE THIS. Worth recording, because "update the existing
// blogs" turned out to be a question about nothing: there is no `bbot_blogs` table in the database
// at all, `setBlogs` was never populated from any store, and `save()` only touched React state. A
// post "published" before today lived until the next page refresh and then did not exist. There
// were ZERO posts to update. Persistence is real now (see `blogsSave`).
var BBOT_BLOG_CATEGORIES = ["Player Spotlight", "Development", "How BBOT Works", "643 News"];
// Row 1 of bbot_site_content is the About copy; the blog gets its own row rather than sharing one
// blob with it, so saving a post can never overwrite the site's own text.
var BBOT_BLOG_ROW = 2;

function bbotBlogBlank(){
  return {
    category: BBOT_BLOG_CATEGORIES[0], title: "", dek: "", image: "",
    sections: [{heading: "", text: ""}],
    pullQuote: "", calloutPlayerId: "", ctaLabel: "Request an evaluation", ctaPage: "upload-video",
    published: false
  };
}

// ---- AD SLOTS ---------------------------------------------------------------------------------
// THREE FIXED PLACEMENTS, and each one is a real slot rather than a grey box: leaderboard under the
// header, an in-article unit after the opening section, and a leaderboard in the footer after the
// CTA. `tag` takes an ad-network snippet when there is one to serve.
//
// A SLOT IS NEVER BLANK. With no paid ad it falls back to a BBOT house ad, because an empty
// bordered rectangle on a customer surface reads as a broken page. The ADVERTISEMENT label is
// carried on paid inventory only -- labelling our own house promo as an advertisement would be
// telling the reader something untrue about who paid for it.
function BbotAdSlot({slot, tag, go}){
  var sizes = {leaderboard:{w:728,h:90}, inarticle:{w:300,h:250}, footer:{w:728,h:90}};
  var s = sizes[slot] || sizes.leaderboard;
  if(tag){
    return <div style={{margin:"22px 0",textAlign:"center"}}>
      <div style={{fontSize:9,letterSpacing:1.2,color:C.gray400,fontWeight:700,marginBottom:4}}>ADVERTISEMENT</div>
      <div style={{maxWidth:s.w,margin:"0 auto"}} dangerouslySetInnerHTML={{__html:tag}}/>
    </div>;
  }
  // ONE "REQUEST AN EVALUATION" PER PAGE, AND IT IS THE BUTTON. Every slot defaulted to the same
  // house ad, so an article carried that line FOUR times -- three slots plus the real CTA -- which
  // reads as a page nagging rather than a page arguing. Each slot now carries a different house
  // message pointing somewhere genuinely different, and none of them competes with the CTA.
  var HOUSE = {
    leaderboard: {head:"See a sample evaluation", sub:"The real format, on an anonymised player.",
                  page:"sample-report"},
    inarticle:   {head:"How BBOT measures", sub:"What the camera can prove, and what it refuses to guess.",
                  page:"methodology"},
    footer:      {head:"What a verified stat means", sub:"Every mark traces to a device reading or a timed measurement.",
                  page:"methodology"}
  };
  var h = HOUSE[slot] || HOUSE.leaderboard;
  return <div style={{margin:"22px 0",display:"flex",justifyContent:"center"}}>
    <div onClick={function(){ if(go) go(h.page); }}
      style={{width:"100%",maxWidth:s.w,minHeight:slot==="inarticle"?s.h:74,cursor:"pointer",
        borderRadius:12,background:"linear-gradient(135deg,"+C.navy+","+C.blue+")",color:C.white,
        display:"flex",flexDirection:slot==="inarticle"?"column":"row",alignItems:"center",
        justifyContent:"center",gap:slot==="inarticle"?6:16,padding:"16px 20px",textAlign:"center"}}>
      <div style={{fontWeight:800,fontSize:slot==="inarticle"?18:16,letterSpacing:.3}}>{h.head}</div>
      <div style={{fontSize:12,opacity:.9}}>{h.sub}</div>
    </div>
  </div>;
}

// ---- THE DATA CALLOUT, RECEIPT-GATED ----------------------------------------------------------
// A blog is a customer surface, so the same law governs it as governs a card: a number appears only
// if the record proves it. This reads the player's own APPROVED report and shows the marks that
// survived the credibility gate. If none did, it renders NOTHING rather than an empty promise --
// an honest blank, exactly as the brief requires.
function BbotBlogCallout({playerId, scoutReports, users, go}){
  if(!playerId) return null;
  var u = (users||[]).find(function(x){return String(x.id)===String(playerId);});
  var rep = (scoutReports||[]).filter(function(r){
    return String(r.playerId)===String(playerId) && isLiveEval(r);
  }).sort(function(a,b){return String(b.date||"").localeCompare(String(a.date||""));})[0];
  if(!u || !rep) return null;
  var mv = (rep.measuredValues) || (rep.fullReport&&rep.fullReport.measuredValues) || {};
  var withheld = bbotWithheldKeys(rep);
  var pos = String((u.position||"")).toUpperCase();
  var isPitcher = BBOT_PITCHER_POS.indexOf(pos) >= 0;
  // POSITION-APPROPRIATE, the same rule the players page follows: a pitcher has no exit velocity,
  // and printing one because the field is non-null is the defect that rule exists to stop.
  var want = isPitcher
    ? [["pitchVeloPeak","Fastball","mph"],["throwVelo","Throw","mph"]]
    : [["exitVeloPeak","Peak exit velo","mph"],["throwVelo","Throw velo","mph"],
       ["h2f","Home-to-1st","s"],["popTime","Pop time","s"]];
  var marks = want.map(function(w){
    var v = mv[w[0]];
    if(v==null || withheld[w[0]]) return null;
    return {label:w[1], value:v, unit:w[2]};
  }).filter(Boolean);
  if(!marks.length) return null;
  return <div style={{margin:"26px 0",borderRadius:14,background:C.navy,color:C.white,padding:"20px 22px"}}>
    <div style={{fontSize:10,letterSpacing:1.4,fontWeight:700,opacity:.8,marginBottom:8}}>MEASURED BY BBOT</div>
    <div style={{fontSize:19,fontWeight:800,marginBottom:12}}>{u.firstName+" "+u.lastName}
      <span style={{fontSize:13,fontWeight:600,opacity:.75}}>{(u.position?" · "+u.position:"")+(u.gradYear?" · "+u.gradYear:"")}</span></div>
    <div style={{display:"flex",flexWrap:"wrap",gap:10}}>
      {marks.map(function(m,i){
        return <div key={i} style={{background:"rgba(255,255,255,.12)",borderRadius:10,padding:"9px 13px"}}>
          <div style={{fontSize:10,opacity:.85,letterSpacing:.6}}>{m.label.toUpperCase()}</div>
          <div style={{fontSize:20,fontWeight:800}}>{m.value}<span style={{fontSize:11,fontWeight:700,marginLeft:3}}>{m.unit}</span></div>
        </div>;
      })}
    </div>
    <div style={{fontSize:11,opacity:.75,marginTop:12,lineHeight:1.5}}>Every mark above is a device
      reading or an admin-timed measurement from this player's evaluation.</div>
  </div>;
}

// ---- THE ARTICLE ------------------------------------------------------------------------------
// One renderer for BOTH the preview and the published page, which is the only way "preview exactly
// as it publishes" can be true. A second preview component is a second thing to drift.
function BbotBlogArticle({post, scoutReports, users, go, adTags}){
  var p = post || {};
  var words = (p.sections||[]).reduce(function(n,s){return n + String(s.text||"").split(/\s+/).length;}, 0);
  var mins = Math.max(1, Math.round(words/220));
  var secs = (p.sections||[]).filter(function(s){return (s.heading||"").trim() || (s.text||"").trim();});
  return <article style={{maxWidth:760,margin:"0 auto",width:"100%"}}>
    <BbotAdSlot slot="leaderboard" tag={(adTags||{}).leaderboard} go={go}/>
    <BbotArticleHero image={p.image}/>
    <div style={{display:"inline-block",marginTop:18,background:C.coral,color:C.white,borderRadius:99,
      padding:"5px 13px",fontSize:10,fontWeight:800,letterSpacing:1.1}}>{(p.category||"").toUpperCase()}</div>
    <h1 style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:34,lineHeight:1.18,color:C.navy,
      margin:"12px 0 10px",letterSpacing:-.4}}>{p.title||"Untitled"}</h1>
    {p.dek && <p style={{fontSize:17,lineHeight:1.6,color:C.gray600,margin:"0 0 14px"}}>{p.dek}</p>}
    <div style={{display:"flex",alignItems:"center",gap:10,flexWrap:"wrap",fontSize:12,color:C.gray500,
      paddingBottom:14,borderBottom:"1px solid "+C.border,marginBottom:6}}>
      <BbotMark size={22}/>
      <span style={{fontWeight:700,color:C.navy}}>{p.author||"643 Sports MGMT"}</span>
      <span>·</span><span>{p.date||""}</span><span>·</span><span>{mins} min read</span>
    </div>
    {secs.map(function(s,i){
      return <div key={i}>
        {s.heading && <h2 style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:21,color:C.navy,
          margin:"26px 0 10px",letterSpacing:.2}}>{s.heading}</h2>}
        {String(s.text||"").split(/\n{2,}/).filter(Boolean).map(function(par,j){
          return <p key={j} style={{fontSize:16,lineHeight:1.8,color:C.gray700,margin:"0 0 15px"}}>{par}</p>;
        })}
        {i===0 && <BbotAdSlot slot="inarticle" tag={(adTags||{}).inarticle} go={go}/>}
        {i===0 && p.pullQuote && <blockquote style={{margin:"24px 0",padding:"6px 0 6px 20px",
          borderLeft:"4px solid "+C.coral,fontSize:20,lineHeight:1.5,color:C.navy,fontWeight:700,fontStyle:"italic"}}>{p.pullQuote}</blockquote>}
      </div>;
    })}
    <BbotBlogCallout playerId={p.calloutPlayerId} scoutReports={scoutReports} users={users} go={go}/>
    <div style={{textAlign:"center",margin:"30px 0 6px"}}>
      <Btn v="primary" style={{fontSize:14,padding:"12px 26px"}} onClick={function(){ if(go) go(p.ctaPage||"upload-video"); }}>{p.ctaLabel||"Request an evaluation"}</Btn>
    </div>
    <BbotAdSlot slot="footer" tag={(adTags||{}).footer} go={go}/>
  </article>;
}

// ═══ FLYER FOOTER ═══ Part 7 of the movement brief. Two flyers, at the bottom of a session report
// and of every blog post, after the content and before the site footer.
//
// THE 4:5 BOX IS RESERVED BEFORE THE IMAGE ARRIVES (`aspectRatio`), so a lazy-loaded flyer cannot
// push the article down as it lands -- the brief asks for exactly that, and it is the difference
// between a footer and a layout shift under the reader's thumb.
//
// `contain`, NEVER `cover`. Both files are natively 4:5 (720x900 and 980x1225, checked), so nothing
// is cropped today; `contain` is what keeps that true if a future flyer is not.
//
// NO CAPTION, NO TEXT, NO BUTTON -- the brief's words. The flyers carry their own copy, including
// their own phone number and QR code, and a caption would be the site saying it again in a second
// voice. Hidden on print: a report someone prints is the report, not an advert.
function FlyerFooter(){
  // EVERY RULE IS IN THE STYLESHEET, NOT INLINE, AND THAT IS NOT A STYLE PREFERENCE.
  //
  // The first version set `flex:"1 1 0"` inline on each box. On a phone the container turns to
  // `flex-direction:column`, which moves the MAIN AXIS to vertical -- so a flex-basis of 0 became a
  // HEIGHT of zero, `aspect-ratio` could not recover it, and both flyers collapsed to a 1px line.
  // The desktop shot was perfect and the phone shot showed two hairlines, which is the whole reason
  // the brief asks for both.
  //
  // It could not be patched in the media query either: an inline style beats a stylesheet rule, so
  // the override would have needed !important. Class-based rules let the phone case simply restate
  // the basis as `auto`, which is what it has to be when the main axis is the one the 4:5 box is
  // sizing. [[validate-the-instrument-both-directions]]
  var CSS =
    ".bbot-flyer-footer{display:flex;gap:12px;flex-wrap:wrap;margin:28px 0 0}" +
    ".bbot-flyer-footer > a{flex:1 1 0;min-width:0;aspect-ratio:4 / 5;border-radius:8px;" +
      "overflow:hidden;border:1px solid " + C.border + ";display:block}" +
    ".bbot-flyer-footer img{width:100%;height:100%;object-fit:contain;display:block}" +
    // STACKED ON A PHONE: full width, and the basis back to auto so the 4:5 box sets the height.
    "@media (max-width:640px){.bbot-flyer-footer{flex-direction:column}" +
      ".bbot-flyer-footer > a{flex:0 0 auto;width:100%}}" +
    // A REPORT SOMEBODY PRINTS IS THE REPORT, NOT AN ADVERT.
    "@media print{.bbot-flyer-footer{display:none!important}}";
  return <div className="bbot-flyer-footer">
    <a href="https://wa.me/17876249831" target="_blank" rel="noopener noreferrer">
      <img src="/flyers/programa-bbot-13.jpg" alt="Programa de béisbol BBOT para jugadores 13+"
           loading="lazy" decoding="async"/>
    </a>
    <a href="#signin">
      <img src="/flyers/guia-perfil-bbot.png" alt="Qué contiene tu perfil tras tu video BBOT"
           loading="lazy" decoding="async"/>
    </a>
    <style>{CSS}</style>
  </div>;
}

function BlogsPage({blogs,setBlogs,cu,notify,scoutReports,users,go}){
  var isAdmin = cu && (bbotIsAdmin(cu) || cu.type==="staff");
  var editS=useState(null); var editing=editS[0]; var setEditing=editS[1]; // post being edited, or {} for new
  var viewS=useState(null); var viewing=viewS[0]; var setViewing=viewS[1];
  // PP5 — BBOT blog generation state
  var genOpenS=useState(false); var genOpen=genOpenS[0]; var setGenOpen=genOpenS[1];
  var instrS=useState(""); var instr=instrS[0]; var setInstr=instrS[1];
  var genBusyS=useState(false); var genBusy=genBusyS[0]; var setGenBusy=genBusyS[1];
  var tmplS=useState([]); var templates=tmplS[0]; var setTemplates=tmplS[1];
  var tmplNameS=useState(""); var tmplName=tmplNameS[0]; var setTmplName=tmplNameS[1];
  var prevS=useState(false); var preview=prevS[0]; var setPreview=prevS[1];
  // AN ADMIN SEES DRAFTS; A READER SEES PUBLISHED POSTS. Drafts used to be indistinguishable
  // because nothing was ever stored, so the distinction had nowhere to live.
  var posts=(blogs||[]).filter(function(b){return isAdmin ? true : b.published===true;})
                       .sort(function(a,b){return (b.date||"").localeCompare(a.date||"");});

  // Load saved templates from DB (synced across devices).
  useEffect(function(){
    sbSelect("bbot_blog_templates","?order=created_at.desc&limit=100").then(function(rows){
      if(Array.isArray(rows)) setTemplates(rows.map(function(r){return {id:r.id, name:r.name, instruction:r.instruction};}));
    }).catch(function(){});
  }, []);

  // Build real DATA for BBOT from approved reports (standouts + grades), so it never fabricates.
  function buildBlogData(){
    var approved=(scoutReports||[]).filter(function(r){return (isLiveEval(r));});
    var nameOf=function(pid){var u=(users||[]).find(function(x){return String(x.id)===String(pid);});return u?(u.firstName+" "+u.lastName):("Player "+pid);};
    var posOf=function(pid){var u=(users||[]).find(function(x){return String(x.id)===String(pid);});return u?(u.position||""):"";};
    // Standouts BBOT already flagged
    var standouts=approved.filter(function(r){var s=r.standout||(r.fullReport&&r.fullReport.standout);return s&&s.isStandout;})
      .slice(0,40).map(function(r){
        var s=r.standout||(r.fullReport&&r.fullReport.standout)||{};
        var grades={}; (r.sections||[]).forEach(function(sec){ if(sec.label&&sec.grade) grades[sec.label]=sec.grade; });
        return {playerName:nameOf(r.playerId), position:posOf(r.playerId), date:r.date||r.sessionDate||"", reason:s.reason||"", grades:grades, hasVideo:!!(r.reelUrl||r.videoUrl)};
      });
    return {periodLabel:"recent approved evaluations", standoutCount:standouts.length, standouts:standouts};
  }

  function generateBlog(){
    if(!instr.trim()){ notify("Describe what you want BBOT to write","error"); return; }
    setGenBusy(true);
    var data=buildBlogData();
    // STRUCTURED: the draft comes back as the TEMPLATE'S OWN FIELDS, so it lands already inside the
    // editor with every part separately editable. The old flat {title, body} arrived as one block
    // of prose that the admin then had to cut into sections by hand — formatting work, which is
    // precisely what the template exists to abolish.
    fetch(BACKEND_URL+"/generate-blog",{method:"POST",headers:bbotAdminHeaders(),body:JSON.stringify({instruction:instr, data:data, structured:true})})
      .then(function(r){return r.json().then(function(j){return {ok:r.ok,j:j};});})
      .then(function(res){
        setGenBusy(false);
        if(!res.ok||!res.j||!res.j.draft){ notify(errText(res.j&&(res.j.detail||res.j.error),"Generation failed"),"error"); return; }
        var d=res.j.draft;
        // THE MODEL NAMES A PLAYER; THE PRODUCT SUPPLIES THE MARKS. It returns a NAME, which is
        // resolved here against real users — so a name nobody has an approved report for simply
        // does not become a callout, and no figure ever comes from the model.
        var pid="";
        if(d.calloutPlayerName){
          var hit=(users||[]).find(function(u){
            return (u.firstName+" "+u.lastName).toLowerCase().trim()===String(d.calloutPlayerName).toLowerCase().trim();
          });
          if(hit && (scoutReports||[]).some(function(r){return String(r.playerId)===String(hit.id)&&isLiveEval(r);})) pid=String(hit.id);
        }
        var secs=(d.sections||[]).filter(function(s){return s && ((s.heading||"").trim()||(s.text||"").trim());});
        setEditing(Object.assign({}, bbotBlogBlank(), editing||{}, {
          category: d.category||((editing&&editing.category)||BBOT_BLOG_CATEGORIES[0]),
          title: d.title||(editing&&editing.title)||"",
          dek: d.dek||"",
          sections: secs.length?secs:[{heading:"",text:""}],
          pullQuote: d.pullQuote||"",
          calloutPlayerId: pid||((editing&&editing.calloutPlayerId)||"")
        }));
        setGenOpen(false);
        var f=(d.gate&&d.gate.findings)||[];
        notify(f.length
          ? ("Draft generated — "+f.length+" item(s) stripped by the copy gate. Edit freely, then publish.")
          : "Draft generated — edit anything, then publish.");
      }).catch(function(e){ setGenBusy(false); notify("Generation failed: "+(e.message||"unknown"),"error"); });
  }

  function saveTemplate(){
    if(!tmplName.trim()){ notify("Name the template","error"); return; }
    if(!instr.trim()){ notify("Nothing to save — write an instruction first","error"); return; }
    var t={id:Date.now(), name:tmplName.trim(), instruction:instr, created_at:new Date().toISOString()};
    setTemplates([t].concat(templates||[]));
    setTmplName("");
    sbUpsert("bbot_blog_templates", t).then(function(){notify("Template saved");}).catch(function(){notify("Saved locally; sync failed","error");});
  }
  function applyTemplate(t){ setInstr(t.instruction||""); notify("Template loaded"); }
  function deleteTemplate(id){
    setTemplates(function(list){return (list||[]).filter(function(t){return t.id!==id;});});
    // Removed from the list already, so a failed delete resurrects it on the next refresh with
    // no explanation. Say it instead.
    bbotWrite("bbot_blog_templates","delete",null,"id=eq." + Number(id)).catch(function(){ notify("Template not deleted — it will return on refresh","error"); });
  }

  // PERSISTENCE, WHICH THIS PAGE DID NOT HAVE. `save()` used to call setBlogs and stop, so a post
  // survived until the next refresh and then did not exist -- and there is no `bbot_blogs` table to
  // write to. Blogs live in `bbot_site_content` under their own row: that table is (id, content
  // jsonb, updated_at), which is exactly the shape a list of posts needs, and a blog IS site
  // content. Row 1 is the About copy; row 2 is the blog.
  function blogsSave(list){
    return sbUpsert("bbot_site_content", {id:BBOT_BLOG_ROW, content:{posts:list},
                                          updated_at:new Date().toISOString()});
  }
  function save(publish){
    var p=editing;
    if(!p.title||!p.title.trim()) return notify("Add a title","error");
    var next;
    if(p.id){
      next=(blogs||[]).map(function(b){return b.id===p.id?Object.assign({},p,{published:!!publish}):b;});
    } else {
      var np=Object.assign({},p,{id:Date.now(),date:new Date().toISOString().slice(0,10),
                                 author:(cu.firstName+" "+cu.lastName),published:!!publish});
      next=[np].concat(blogs||[]);
    }
    setBlogs(next);
    blogsSave(next)
      .then(function(){ notify(publish?"Published":"Draft saved"); })
      .catch(function(){ notify("Saved on screen, but the sync failed — it may not survive a refresh","error"); });
    setEditing(null); setPreview(false);
  }
  function del(id){
    if(!window.confirm("Delete this post?"))return;
    var next=(blogs||[]).filter(function(b){return b.id!==id;});
    setBlogs(next);
    blogsSave(next).catch(function(){ notify("Delete did not sync","error"); });
    notify("Deleted");
  }

  // Editor
  if(editing){
    return <div style={{maxWidth:780,margin:"0 auto",padding:"0 16px"}}>
      <SectionHeader>{editing.id?"Edit Post":"New Post"}</SectionHeader>
      {!editing.id && (
        <Card style={{padding:14,marginBottom:14,background:C.coralFaint,border:"1px solid "+C.coralLight}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",cursor:"pointer"}} onClick={function(){setGenOpen(!genOpen);}}>
            <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:13,color:C.coral,letterSpacing:.5,fontWeight:700}}>✨ GENERATE WITH BBOT</div>
            <span style={{color:C.coral,fontSize:13}}>{genOpen?"▲":"▼"}</span>
          </div>
          {genOpen && (
            <div style={{marginTop:12}}>
              <div style={{fontSize:11,color:C.gray600,marginBottom:6,lineHeight:1.5}}>Describe the post. BBOT writes from your approved evaluation data only — it won't invent numbers. Use <code>[AD]</code> for an ad slot and <code>[LINK:label]</code> for a site link; both are preserved.</div>
              <textarea value={instr} onChange={function(e){setInstr(e.target.value);}} rows={4} placeholder={"e.g. Write a post on the top 20 standouts from recent evaluations. Group by position, cite their best tool grade, and mention who has video. Add [AD] after the intro and end with [LINK:Book an Evaluation]."} style={{width:"100%",padding:10,border:"1px solid "+C.border,borderRadius:8,fontSize:13,fontFamily:"inherit",lineHeight:1.5,resize:"vertical",boxSizing:"border-box"}}/>
              <div style={{display:"flex",gap:8,flexWrap:"wrap",alignItems:"center",marginTop:8}}>
                <Btn v="primary" style={{fontSize:12}} disabled={genBusy} onClick={generateBlog}>{genBusy?"Generating…":"Generate Draft"}</Btn>
                <input value={tmplName} onChange={function(e){setTmplName(e.target.value);}} placeholder="Template name" style={{padding:"7px 10px",border:"1px solid "+C.border,borderRadius:6,fontSize:12,flex:"1 1 120px",minWidth:100}}/>
                <Btn v="ghost" style={{fontSize:12}} onClick={saveTemplate}>Save as Template</Btn>
              </div>
              {(templates||[]).length>0 && (
                <div style={{marginTop:10}}>
                  <div style={{fontSize:10,color:C.gray500,fontWeight:600,letterSpacing:.5,marginBottom:5}}>SAVED TEMPLATES</div>
                  <div style={{display:"flex",flexWrap:"wrap",gap:6}}>
                    {templates.map(function(t){return <span key={t.id} style={{display:"inline-flex",alignItems:"center",gap:6,padding:"4px 10px",background:C.white,border:"1px solid "+C.border,borderRadius:99,fontSize:11}}>
                      <button onClick={function(){applyTemplate(t);}} style={{background:"none",border:"none",color:C.blue,fontWeight:600,cursor:"pointer",padding:0,fontSize:11}}>{t.name}</button>
                      <button onClick={function(){deleteTemplate(t.id);}} style={{background:"none",border:"none",color:C.gray400,cursor:"pointer",padding:0,fontSize:13,lineHeight:1}}>×</button>
                    </span>;})}
                  </div>
                </div>
              )}
            </div>
          )}
        </Card>
      )}
      {/* THE PLACEHOLDER FORM. Every field is CONTENT; none of them is formatting. The admin
          cannot choose a font, a colour or a layout here, which is the point -- the template
          already made those decisions and made them once. */}
      <div style={{display:"flex",flexDirection:"column",gap:12}}>
        <div>
          <div style={{fontSize:11,color:C.gray500,fontWeight:600,marginBottom:4,letterSpacing:.5}}>CATEGORY</div>
          <select value={editing.category||BBOT_BLOG_CATEGORIES[0]} onChange={function(e){setEditing(Object.assign({},editing,{category:e.target.value}));}}
            style={{width:"100%",padding:10,border:"1px solid "+C.border,borderRadius:8,fontSize:14}}>
            {BBOT_BLOG_CATEGORIES.map(function(c){return <option key={c} value={c}>{c}</option>;})}
          </select>
        </div>
        <FieldInput label="Title" value={editing.title||""} onChange={function(e){setEditing(Object.assign({},editing,{title:e.target.value}));}} placeholder="The headline"/>
        <div>
          <div style={{fontSize:11,color:C.gray500,fontWeight:600,marginBottom:4,letterSpacing:.5}}>DEK (one-line standfirst)</div>
          <textarea value={editing.dek||""} onChange={function(e){setEditing(Object.assign({},editing,{dek:e.target.value}));}} rows={2}
            style={{width:"100%",padding:12,border:"1px solid "+C.border,borderRadius:8,fontSize:14,fontFamily:"inherit",lineHeight:1.6,resize:"vertical"}}/>
        </div>
        <BbotCoverImageControl label="COVER IMAGE" value={editing.image||""}
          onChange={function(v){ setEditing(Object.assign({},editing,{image:v})); }}/>

        <div style={{fontSize:11,color:C.gray500,fontWeight:600,letterSpacing:.5,marginTop:4}}>BODY SECTIONS</div>
        {(editing.sections||[{heading:"",text:""}]).map(function(sec,i){
          function upd(field,val){
            var next=(editing.sections||[]).slice();
            next[i]=Object.assign({},next[i],{[field]:val});
            setEditing(Object.assign({},editing,{sections:next}));
          }
          return <Card key={i} style={{padding:12}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:6}}>
              <div style={{fontSize:10,color:C.gray400,fontWeight:700,letterSpacing:.6}}>SECTION {i+1}</div>
              {/* REORDER AND REMOVE. A generated draft is a starting point, so its order has to be
                  as editable as its words — otherwise "fully editable" stops at the paragraph. */}
              <div style={{display:"flex",gap:10}}>
                {i>0 && <button onClick={function(){
                  var next=(editing.sections||[]).slice();
                  var t=next[i-1]; next[i-1]=next[i]; next[i]=t;
                  setEditing(Object.assign({},editing,{sections:next}));
                }} style={{background:"none",border:"none",color:C.blue,fontSize:11,cursor:"pointer",fontWeight:600}}>↑ Up</button>}
                {i<(editing.sections||[]).length-1 && <button onClick={function(){
                  var next=(editing.sections||[]).slice();
                  var t=next[i+1]; next[i+1]=next[i]; next[i]=t;
                  setEditing(Object.assign({},editing,{sections:next}));
                }} style={{background:"none",border:"none",color:C.blue,fontSize:11,cursor:"pointer",fontWeight:600}}>↓ Down</button>}
                {(editing.sections||[]).length>1 && <button onClick={function(){
                  var next=(editing.sections||[]).filter(function(_x,j){return j!==i;});
                  setEditing(Object.assign({},editing,{sections:next}));
                }} style={{background:"none",border:"none",color:C.red,fontSize:11,cursor:"pointer",fontWeight:600}}>Remove</button>}
              </div>
            </div>
            <input value={sec.heading||""} onChange={function(e){upd("heading",e.target.value);}} placeholder="Section heading"
              style={{width:"100%",padding:9,border:"1px solid "+C.border,borderRadius:8,fontSize:14,marginBottom:8}}/>
            <textarea value={sec.text||""} onChange={function(e){upd("text",e.target.value);}} rows={6} placeholder="Section text. Blank lines separate paragraphs."
              style={{width:"100%",padding:12,border:"1px solid "+C.border,borderRadius:8,fontSize:14,fontFamily:"inherit",lineHeight:1.6,resize:"vertical"}}/>
          </Card>;
        })}
        <Btn v="ghost" style={{fontSize:12,alignSelf:"flex-start"}} onClick={function(){
          setEditing(Object.assign({},editing,{sections:(editing.sections||[]).concat([{heading:"",text:""}])}));
        }}>+ Add section</Btn>

        <div>
          <div style={{fontSize:11,color:C.gray500,fontWeight:600,marginBottom:4,letterSpacing:.5}}>PULL QUOTE (optional)</div>
          <textarea value={editing.pullQuote||""} onChange={function(e){setEditing(Object.assign({},editing,{pullQuote:e.target.value}));}} rows={2}
            style={{width:"100%",padding:12,border:"1px solid "+C.border,borderRadius:8,fontSize:14,fontFamily:"inherit",lineHeight:1.6,resize:"vertical"}}/>
        </div>
        <div>
          <div style={{fontSize:11,color:C.gray500,fontWeight:600,marginBottom:4,letterSpacing:.5}}>PLAYER DATA CALLOUT (optional)</div>
          <select value={editing.calloutPlayerId||""} onChange={function(e){setEditing(Object.assign({},editing,{calloutPlayerId:e.target.value}));}}
            style={{width:"100%",padding:10,border:"1px solid "+C.border,borderRadius:8,fontSize:14}}>
            <option value="">— none —</option>
            {(users||[]).filter(function(u){
              return (scoutReports||[]).some(function(r){return String(r.playerId)===String(u.id) && isLiveEval(r);});
            }).map(function(u){return <option key={u.id} value={u.id}>{u.firstName+" "+u.lastName}</option>;})}
          </select>
          <div style={{fontSize:10,color:C.gray400,marginTop:4,lineHeight:1.5}}>Only players with an
            approved evaluation appear. The callout prints that player's receipted marks and nothing
            else — if none survive the credibility gate it renders nothing rather than an empty box.</div>
        </div>
        <FieldInput label="CTA button label" value={editing.ctaLabel||""} onChange={function(e){setEditing(Object.assign({},editing,{ctaLabel:e.target.value}));}} placeholder="Request an evaluation"/>

        <div style={{display:"flex",gap:10,flexWrap:"wrap"}}>
          <Btn v={preview?"ghost":"outline"} onClick={function(){setPreview(!preview);}}>{preview?"Back to editing":"Preview"}</Btn>
          <Btn v="ghost" onClick={function(){save(false);}}>Save draft</Btn>
          <Btn v="primary" onClick={function(){save(true);}}>Publish</Btn>
          <Btn v="ghost" onClick={function(){setEditing(null);setPreview(false);}}>Cancel</Btn>
        </div>
      </div>

      {/* PREVIEW IS THE PUBLISHED RENDERER, not a copy of it. Two components would drift, and the
          promise "preview exactly as it publishes" would quietly stop being true. */}
      {preview && <div style={{marginTop:24,paddingTop:20,borderTop:"2px solid "+C.border}}>
        <div style={{fontSize:10,letterSpacing:1.4,color:C.coral,fontWeight:800,marginBottom:12}}>PREVIEW — EXACTLY AS IT PUBLISHES</div>
        <BbotBlogArticle post={Object.assign({date:new Date().toISOString().slice(0,10),
          author:(cu&&(cu.firstName+" "+cu.lastName))||"643 Sports MGMT"}, editing)}
          scoutReports={scoutReports} users={users} go={go}/>
      </div>}
    </div>;
  }

  // Single post view
  if(viewing){
    // THE SAME RENDERER THE PREVIEW USES. This block used to be its own hand-rolled layout, with
    // [AD] and [LINK:] markers parsed out of a plain-text body -- a second design drifting from the
    // first, and the reason no two posts looked alike. One component draws every post now.
    return <div style={{maxWidth:820,margin:"0 auto",padding:"0 16px"}}>
      <button onClick={function(){setViewing(null);}} style={{background:"none",border:"none",color:C.blue,fontSize:13,cursor:"pointer",marginBottom:14,padding:0}}>&larr; All posts</button>
      <BbotBlogArticle post={viewing} scoutReports={scoutReports} users={users} go={go}/>
      <FlyerFooter/>
    </div>;
  }

  // List
  var AdSlot=function(){
    return <div style={{border:"1px dashed "+C.border,borderRadius:12,background:C.gray50,minHeight:150,display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",gap:4,color:C.gray400}}>
      <div style={{fontSize:10,letterSpacing:1,fontWeight:700}}>ADVERTISEMENT</div>
      <div style={{fontSize:11}}>Ad space available</div>
      <div style={{fontSize:9,color:C.gray300}}>643sportsmgmt@gmail.com</div>
    </div>;
  };
  return <div style={{maxWidth:980,margin:"0 auto",padding:"0 16px"}}>
    <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:6,flexWrap:"wrap",gap:10}}>
      <div style={{display:"flex",alignItems:"center",gap:12}}>
        <BbotMark size={34}/>
        <div>
          <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:24,color:C.navy,letterSpacing:1}}>THE 643 BLOG</div>
          <div style={{fontSize:12,color:C.gray500}}>Player spotlights, development notes, and BBOT insights.</div>
        </div>
      </div>
      {isAdmin&&<div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
        {/* TWO DOORS, ONE EDITOR. Whichever you come through, you land in the same fully editable
            template — a generated draft is not a different kind of post. */}
        <Btn v="outline" style={{fontSize:12,padding:"7px 14px"}} onClick={function(){setEditing(bbotBlogBlank());setGenOpen(true);}}>✨ Write with BBOT</Btn>
        <Btn v="primary" style={{fontSize:12,padding:"7px 14px"}} onClick={function(){setEditing(bbotBlogBlank());setGenOpen(false);}}>+ New Post</Btn>
      </div>}
    </div>
    <div style={{height:3,width:48,background:C.coral,borderRadius:99,marginBottom:18}}/>
    {posts.length===0 ? <EmptyCard icon="bbot" title="No Posts Yet" sub={isAdmin?"Tap + New Post to publish your first article.":"Check back soon for updates."}/> :
     <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(280px,1fr))",gap:16}}>
       {posts.map(function(b,i){
         var card=<Card key={b.id} style={{padding:0,overflow:"hidden",cursor:"pointer",display:"flex",flexDirection:"column"}} onClick={function(){setViewing(b);}}>
           {b.image
             ? <img src={b.image} alt="" style={{width:"100%",height:160,objectFit:"cover"}}/>
             : <div style={{width:"100%",height:160,background:"linear-gradient(135deg,"+C.navy+","+C.blue+")",display:"flex",alignItems:"center",justifyContent:"center"}}><BbotMark size={42} tile="transparent"/></div>}
           <div style={{padding:16,display:"flex",flexDirection:"column",flex:1}}>
             <div style={{fontWeight:700,fontSize:16,color:C.navy,marginBottom:5,lineHeight:1.3}}>{b.title}</div>
             <div style={{fontSize:11,color:C.gray400,marginBottom:8,letterSpacing:.3}}>{b.date}{b.author?" · "+b.author:""}</div>
             {/* THE EXCERPT COMES FROM THE TEMPLATE'S OWN FIELDS. It read `b.body`, which template
                 posts do not have, so every card showed a blank space where the standfirst belongs. */}
             <div style={{fontSize:13,color:C.gray600,lineHeight:1.55,display:"-webkit-box",WebkitLineClamp:3,WebkitBoxOrient:"vertical",overflow:"hidden",flex:1}}>
               {b.dek || ((b.sections||[])[0]||{}).text || b.body || ""}
             </div>
             <div style={{fontSize:11,color:C.coral,fontWeight:700,marginTop:10,letterSpacing:.3}}>Read more →</div>
             {isAdmin&&<div style={{display:"flex",gap:10,marginTop:10,paddingTop:10,borderTop:"1px solid "+C.gray100}} onClick={function(e){e.stopPropagation();}}>
               <button onClick={function(){setEditing(b);}} style={{background:"none",border:"none",color:C.blue,fontSize:11,cursor:"pointer",padding:0,fontWeight:600}}>Edit</button>
               <button onClick={function(){del(b.id);}} style={{background:"none",border:"none",color:C.red,fontSize:11,cursor:"pointer",padding:0,fontWeight:600}}>Delete</button>
             </div>}
           </div>
         </Card>;
         // Intersperse an ad placeholder after every 6th post.
         if((i+1)%6===0) return [card, <AdSlot key={"ad-"+i}/>];
         return card;
       })}
     </div>}
  </div>;
}

// ════════════════════════════════════════════════════════════════════════════════════════════════
// PHASE F LEGAL GATE — CLEARED AND THEN REMOVED, BY LUIS, 2026-09-15.
// The percentile / data-rights / minors+COPPA / shareability clauses on TermsPage and PrivacyPage
// were held behind a single constant while they read as drafts. That constant was cleared, and then
// the markings themselves were stripped from source, because switching them off left the copy in
// the shipped bundle where anyone could read it. See the note above TermsPage for what went and why.
//
// WHAT THIS MEANS, STATED PLAINLY: those clauses are the operative terms a user is agreeing to.
// There is no longer a flag that re-marks them as drafts; restoring that state means reverting the
// commit. Luis was told that trade and chose it.

// THE LEGAL FOOTER'S THREE LINKS, AND WHY THEY ALL OPEN ONE DOCUMENT.
// Terms of Service, Privacy Policy and Compliance all called go("terms"), which read like a
// copy-paste bug and is not one: TermsPage is titled "TERMS OF SERVICE & PRIVACY POLICY" and carries
// the NCAA compliance block, so it IS the destination all three name. What was actually wrong is
// that three differently-labelled links dropped the reader at the top of a fourteen-section document
// and left them to hunt for the part they clicked. Each lands on its own section now.
//
// IT DELIBERATELY DOES NOT POINT AT PrivacyPage, which is a plain-language "PRIVACY & DATA"
// explainer, not the contract. The Legal footer names contract documents and must reach the one
// document a user is agreeing to.
//
// THE COMPLIANCE ANCHOR IS SECTION 8, NOT THE NCAA CARD ON THE COACHES PAGE. I anchored the coaches
// page's NCAA card first and the probe caught it: the id was on a different component, so the link
// scrolled nowhere and looked like it had worked. Section 8, Coach & Scout User Conduct, is where
// the operative document states the NCAA / MLB / NIL / athlete-agent obligations.
// THE HASH KEYS THAT NAME THE LEGAL DOCUMENT'S SECTIONS. One entry per footer link, and the value
// is the very anchor that link already scrolls to -- so `#privacy` and a click on "Privacy Policy"
// are the same journey, and there is no second definition of where a label points.
var BBOT_LEGAL_HASHES = {terms:null, privacy:"legal-privacy", compliance:"legal-compliance"};

function bbotLegalHashKey(){
  if(typeof window==="undefined") return null;
  var h = (window.location.hash||"").replace(/^#/,"").trim().toLowerCase();
  return Object.prototype.hasOwnProperty.call(BBOT_LEGAL_HASHES, h) ? h : null;
}

// SETS THE URL AND OPENS THE PAGE, in that order and both every time. Setting the hash alone is not
// enough: clicking "Privacy Policy" while already at #privacy fires no `hashchange`, so the reader
// would press a link and watch nothing happen. Opening alone is not enough either -- that is the
// state the site has today, where the document is reachable and uncitable.
function goLegalHash(go, key){
  if(typeof window!=="undefined"){
    try{ window.history.pushState({}, "", window.location.pathname+window.location.search+"#"+key); }
    catch(e){ window.location.hash = key; }
  }
  goLegal(go, BBOT_LEGAL_HASHES[key]);
}

function goLegal(go, sectionId){
  go("terms");
  if(!sectionId) return;
  // The page mounts on a later paint, so the anchor does not exist yet. Poll briefly for it, and if
  // it never appears do nothing at all — a link that lands at the top of the right document is a
  // worse outcome than scrolling, and a thrown error is a worse outcome than both.
  var tries = 0;
  var tick = function(){
    var el = null;
    try { el = document.getElementById(sectionId); } catch(_){ return; }
    if(el){
      try { el.scrollIntoView({behavior:"smooth", block:"start"}); }
      catch(_){ try { el.scrollIntoView(); } catch(__){} }
      return;
    }
    if(++tries < 20) setTimeout(tick, 50);
  };
  setTimeout(tick, 50);
}

// THE SITE FOOTER — ONE COMPONENT, EVERY PAGE, EVERY ROLE (ruled by Luis 2026-08-17).
//
// This markup used to sit inside `if(cu.type==="staff") return(...)` in HomePage, which required
// BOTH type staff AND page home to render. Approved staff have no "Home" in their nav and land on
// run-bbot; players, coaches, the admin and every logged-out visitor are not type staff. So the
// Terms / Privacy / Compliance links were reachable by exactly one kind of account: a staff signup
// still awaiting approval. Legal documents are not role-gated content.
//
// It renders once at the bottom of AppInner, outside every page branch, so no page can be added
// without it and no role can lose it.
//
// THE LEGAL COLUMN IS IDENTICAL IN EVERY STATE. The other columns are not, because a footer must
// not offer a link that goes nowhere: About and the role landing pages exist only inside the
// signed-in Shell, while the sample, coaches and methodology pages are the public ones. Terms and
// Privacy render in BOTH branches (`page==="terms"` appears public-side and in the Shell), which is
// what lets the legal column stay the same for everyone.
function LegalFooter({go, cu}){
  var linkStyle = {background:"none",border:"none",fontSize:12,color:C.gray500,cursor:"pointer",
                   display:"block",marginBottom:5,padding:0,textAlign:"left"};
  var headStyle = {fontSize:10,letterSpacing:1,color:C.navy,fontWeight:700,
                   textTransform:"uppercase",marginBottom:8};
  // ACTIVITY IS IN BOTH COLUMNS, and the logged-out one is the reason. The nav arrays that carry
  // it are built for SIGNED-IN roles; a visitor who has never signed in sees the landing page and
  // this footer, and nothing else. Adding the route without this left the stream unreachable for
  // exactly the audience it exists to reach — the probe walked the site as a visitor and could not
  // find it, which is the check earning its keep.
  //
  // THE SAME TRAP CAUGHT TWO MORE PAGES (2026-10-08). Session reports were made public weeks ago
  // and leaderboards were made public today, and NEITHER was reachable: a visitor has the
  // landing page and this footer, so a public route with no link here is a page that exists and
  // cannot be found. A route is not public until something a visitor can see points at it.
  var firstCol = cu
    ? [["Activity","activity"],["About BBOT","about"],["For Players","home"],["For Coaches","home"]]
    : [["Activity","activity"],["Leaderboards","leaderboard"],["Session Reports","recaps"],
       ["Blog","blogs"],["Sample Report","sample-report"],
       ["For Coaches","for-coaches"],["Methodology","methodology"]];
  return (
    <div data-bbot-footer="legal"
         style={{borderTop:"1px solid "+C.border,marginTop:32,padding:"24px 16px 18px"}}>
      <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(140px,1fr))",gap:20,
                   maxWidth:760,margin:"0 auto",marginBottom:18}}>
        <div>
          <div style={headStyle}>643 Sports MGMT</div>
          {firstCol.map(function(it){
            return <button key={it[0]} onClick={function(){go(it[1]);}} style={linkStyle}>{it[0]}</button>;
          })}
        </div>
        <div>
          <div style={headStyle}>Legal</div>
          <button onClick={function(){goLegalHash(go,"terms");}} style={linkStyle}>Terms of Service</button>
          <button onClick={function(){goLegalHash(go,"privacy");}} style={linkStyle}>Privacy Policy</button>
          <button onClick={function(){goLegalHash(go,"compliance");}} style={linkStyle}>Compliance</button>
        </div>
        <div>
          <div style={headStyle}>Contact</div>
          <a href="mailto:643sportsmgmt@gmail.com" style={{fontSize:12,color:C.gray500,textDecoration:"none",display:"block",marginBottom:5}}>643sportsmgmt@gmail.com</a>
          <a href="https://www.instagram.com/643sportsmgmt" target="_blank" rel="noopener noreferrer" style={{fontSize:12,color:C.gray500,textDecoration:"none",display:"block",marginBottom:5}}>Instagram</a>
        </div>
      </div>
      <div style={{textAlign:"center",fontSize:10,color:C.gray400,paddingTop:12,
                   borderTop:"1px solid "+C.gray100}}>
        © 2026 643 Sports MGMT LLC · BBOT is proprietary technology · Guaynabo, PR
      </div>
    </div>
  );
}

// THE DRAFT-LEGAL MARKINGS ARE GONE FROM SOURCE (Luis, 2026-09-15), not just switched off.
//
// They were a banner ("DRAFT - PENDING LEGAL REVIEW - NOT FINAL") plus an inline DRAFT tag on
// individual clauses, held behind BBOT_LEGAL_DRAFTS_CLEARED. Flipping that constant to true
// stopped them rendering, but the copy -- including the sentence saying the percentile,
// data-rights and minors/COPPA clauses "are not legally cleared, are not the operative terms, and
// must not be relied upon" -- still shipped in the JS bundle, readable by anyone who opened it.
// Off the page is not off the wire.
//
// THE TRADE, STATED: the gate was designed so ONE constant could restore every draft marking at
// once. That reversibility is deliberately given up here; restoring them means git, not a flag.
// Luis was told that and chose it.

function TermsPage(){
  var sectionStyle={marginBottom:28};
  var h2Style={fontFamily:"Inter,system-ui,sans-serif",fontSize:15,color:C.navy,letterSpacing:1,marginBottom:8,textTransform:"uppercase"};
  var pStyle={fontSize:13,color:C.gray600,lineHeight:1.9,marginBottom:10};
  return(
    <div style={{maxWidth:780,margin:"0 auto",padding:"28px 16px 60px"}}>
      <div style={{marginBottom:32}}>
        <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:28,color:C.navy,letterSpacing:1.5,marginBottom:6}}>TERMS OF SERVICE & PRIVACY POLICY</div>
        <div style={{fontSize:12,color:C.gray400}}>643 Sports MGMT LLC — Effective 8 October 2026</div>
        <div style={{width:48,height:3,background:C.coral,borderRadius:99,marginTop:12}}/>
      </div>


      <div style={sectionStyle}>
        <div style={h2Style}>1. Proprietary Technology</div>
        <p style={pStyle}>BBOT is proprietary technology owned and operated by 643 Sports MGMT LLC. Its design and internal workings are the exclusive intellectual property of 643 Sports MGMT LLC. Unauthorized copying, scraping, reverse engineering, redistribution, or use of BBOT's systems in any form is strictly prohibited and may result in legal action.</p>
      </div>

      <div style={sectionStyle}>
        <div style={h2Style}>2. Nature of BBOT Evaluations</div>
        {/* C4 point-in-time framing · C5 approval before publication · C7 what the fee entitles ·
            D1 what is collected · D3 no sale of data (verified: no analytics/tracking present) */}
        <p style={pStyle}>An evaluation is a <strong>point-in-time assessment</strong>. It reflects performance in the footage submitted, as of the date of that session. It is not a projection, a promise of advancement, or a recruiting guarantee.</p>
        <p style={pStyle}>Every evaluation is <strong>reviewed and approved by 643 staff before it is published</strong>. Nothing reaches a player profile, a public page, or a shared report automatically.</p>
        <p style={pStyle}>A single-session evaluation is <strong>{BBOT_PRICE_LABEL}</strong> and entitles the player to one evaluation of one submitted session, delivered as one report, together with the clips produced from that session.</p>
        <p style={pStyle}>To produce an evaluation we collect the <strong>footage you submit</strong>, the <strong>measurements taken from it</strong>, and the <strong>profile information</strong> you provide. <strong>643 Sports MGMT LLC does not sell player data.</strong> Data is shared only with the service providers needed to operate the platform — hosting, storage, database, email and payment processing — and only for that purpose.</p>
        <p style={pStyle}>BBOT evaluations are produced by a video-based measurement and evaluation system and are intended to supplement, not replace, professional scouting evaluations. 643 Sports MGMT LLC makes no warranty that BBOT evaluations are free from error or that they accurately reflect a player's current ability, future potential, or professional prospects. All evaluations should be reviewed in conjunction with qualified human assessment.</p>
        <p style={pStyle}>BBOT reports a numeric measurement (velocity, run time, pop time, and similar) only when that number is read from a genuine measuring device — a radar/velocity device or an on-screen timer visible in the footage, or a time recorded by 643 during review. These are labeled <strong>device- or admin-verified</strong>. A number is published only when it is one of three things: read from a measuring device present in that session&rsquo;s captured timeline; hand-timed by 643 during review with a stated basis naming the timer, the operator and the distance; or computed from readings that are themselves receipted in one of those ways. BBOT does not estimate a real-world measurement &mdash; a velocity, a time, a distance, an angle &mdash; from the video itself, and does not read a player measurement from a scoreboard, score bug, or other non-measuring graphic. Where BBOT measures movement from video, it reports only <strong>relative shape</strong>: how one repetition compares with another in the same session, carrying no units and asserting no magnitude. When no verified number is present, the measurement is reported as <strong>not measured</strong>, with the reason stated, and the tool is evaluated as a qualitative scouting observation rather than a number. A graded tool is one anchored to a verified number; tools without one are described, not graded.</p>
        {/* THE AI-COMPOSITION CLAUSE — the same commitment the card itself closes with (R14).
            A promise made on the artifact and absent from the agreement is a promise with no
            standing, so the Terms now carry it word for word in substance. */}
        <p style={pStyle}>The written evaluation &mdash; its summary and its observations &mdash; is composed by BBOT from that session&rsquo;s own record: measured device readings, verified footage observations, and hand-timed entries. It is not a live in-person scouting view and should not be attributed as one. A BBOT administrator may refine the wording of an evaluation for clarity, and may never add an observation: every statement in a published evaluation originates from BBOT&rsquo;s verified evaluation of the submitted footage, and edits that would introduce a new claim, figure, or descriptor are rejected by the system rather than reviewed by a person.</p>
        <p style={pStyle}>BBOT measures what the submitted footage captures and shows each measured mark for a stated <strong>age bracket</strong>, as a <strong>point-in-time</strong> measurement. Peer percentile rankings are <strong>not active</strong>, and no peer group stands behind any number on a BBOT report: a report shows the measured mark and its age reference, never a rank. Actions without a captured measurement are described factually, not numbered. A reference band states where a measured mark stands against peers on the date evaluated — it is <strong>not a grade, guarantee, projection, or prediction</strong> of current ability, future potential, professional prospects, recruiting outcome, or scholarship, and is <strong>not recruiting, financial, or eligibility advice</strong>. Should percentile rankings become active, they are point-in-time and peer-relative, and any shared or exported report will carry that label so it cannot be read out of context.</p>
        <p style={pStyle}>BBOT also tracks <strong>body-landmark positions</strong> frame by frame from the submitted video. This tracking certifies that a repetition is the athlete being evaluated, times the repetitions within the session, and samples <strong>relative</strong> movement — how one repetition compares with another in the same session, carrying no units and asserting no magnitude. It is a tracking and certification instrument, not an angle, rotation, separation or velocity instrument: those quantities are not extractable from a single camera and BBOT does not report them. Tracking outputs are reported separately from device-read measurements and are never combined with them. Where a repetition does not track clearly enough, it is omitted and the report says so.</p>
        {/* THE CAPTURE REQUIREMENT, STATED WHERE A CUSTOMER AGREES TO IT (ruled by Luis 2026-08-19).
            One requirement, and the frame rate is not it. */}
        <p style={pStyle}>For customer-submitted footage, an evaluation requires a <strong>visible radar reading</strong> in the video — a radar display readable on camera — at <strong>any frame rate</strong>. This is confirmed automatically before any charge; footage without a readable reading is declined and no evaluation is created and no payment is taken. Filming at a true 60 frames per second is <strong>optional</strong>: it adds movement-timing detail on top of the measurements, and its absence does not reduce the device-verified measurements a session produces.</p>

        <p style={pStyle}><strong>Video source.</strong> Clips are labeled by origin. <strong>643-filmed</strong> clips are captured and edited by 643 Sports MGMT. <strong>Player-submitted</strong> clips are uploaded by the user and are marked as such. 643 Sports MGMT does not film, verify, audit, or warrant player-submitted video or any reading within it, and accepts no liability for its accuracy, authenticity, or condition. Evaluation of player-submitted video reflects only what that footage shows; the submitting user is solely responsible for the video's accuracy, rights, and consent to record. Branding applied to any clip indicates platform processing only and is not a representation by 643 that it filmed or authenticated the underlying footage.</p>
        <p style={pStyle}>Where footage does not clearly show a given tool, BBOT issues a <strong>partial evaluation</strong> — grading only what is observable and marking the remainder as not observable for that session. A partial evaluation is a complete, delivered report of what the submitted footage supported. See Section 5.</p>
        <p style={pStyle}>What BBOT can measure depends on the <strong>quality of the footage and the position of the camera</strong>. A session filmed from an angle that does not show a given tool will not produce a measurement for that tool, and the report will state that rather than estimate it.</p>
        <p style={pStyle}>Where something cannot be verified from the footage, BBOT <strong>discloses it rather than estimating it</strong>. A report states what it is based on, in plain terms.</p>
      </div>

      <div style={sectionStyle} id="legal-privacy">
        <div style={h2Style}>3. User Data & Privacy</div>
        <p style={pStyle}>643 Sports MGMT LLC collects player data — including metrics, evaluation results, and session history — solely for the purpose of generating evaluations and enabling platform functionality. Player data is never sold, licensed, or shared with third parties for commercial purposes. All data is stored with industry-standard encryption.</p>
        <p style={pStyle}>A limited part of a player&rsquo;s profile is <strong>publicly readable without an account</strong>: name, position, graduation year, and the most recent published clip and movement-tracking clip. Contact details, date of birth, guardian records, evaluations and session history are not. The full list, and the list of what is withheld, is in <strong>Section 4C</strong>. Because a public page may be read, indexed or forwarded by anyone, a player or guardian who does not want a public preview may request its removal under Section 4C.</p>
        <p style={pStyle}>Login credentials, player evaluations, payment methods, and personal information are encrypted at rest and in transit. 643 Sports MGMT LLC employs industry-standard authentication and security protocols.</p>
        <p style={pStyle}>By uploading video, you consent to 643 Sports MGMT LLC capturing, storing, and analyzing that video and the movement measurements derived from it to produce your evaluation, and to the use of those measurements — in <strong>anonymized aggregate, stripped of all personally identifying fields</strong> — to build and maintain the evolving same-age reference against which percentiles are computed. The aggregate reference contains no names, faces, or video. You may request deletion of your account and data at any time; measurements already incorporated into the anonymized aggregate reference may persist in de-identified form, and you may request exclusion from the reference going forward.</p>
      </div>

      <div style={sectionStyle}>
        <div style={h2Style}>4. Minor User Protections</div>
        {/* SAY WHAT ACTUALLY HAPPENS. This claimed "verified" guardian consent and "explicit written
            consent" for payment storage. Neither was true: the signup form collected a guardian name
            and a ticked box, kept no record of either, and nothing was verified or written. The
            wording now describes the real mechanism -- the guardian receives the setup link and
            confirms at that point -- which is a commitment the product can actually keep. */}
        <p style={pStyle}>Users under 18 require the consent of a parent or legal guardian before an account is created. The parent or guardian receives the account setup link, and confirms at that point that they are 18 or older and are the player's parent, stepparent, or legal guardian. Parents and guardians must approve account creation, evaluation purchases, and any optional payment method storage. Payment methods may only be stored after a parent or legal guardian has given explicit consent.</p>
        <p style={pStyle}>Consent for a minor includes the parent/guardian's consent to <strong>capture, store, and analyze</strong> the minor's video and movement measurements, to <strong>share or forward</strong> any report, and to the use of the minor's measurements in the <strong>anonymized aggregate reference</strong> (which a guardian may opt out of). Guardians control who a minor's report is shared with, may request deletion at any time, and may request the minor's data be excluded from the reference. Where COPPA (children under 13) or stricter state or jurisdictional children's-privacy laws apply, those controls govern.</p>
      </div>

      <div style={sectionStyle}>
        <div style={h2Style}>4A. Shared Evaluations &amp; Travel of Scans</div>
        <p style={pStyle}>Reports may be shared by link, PDF, or image. A shared report is viewable by anyone who holds it until the share is revoked, and travels with its point-in-time, peer-relative disclaimer ("percentile vs same-age peers, point-in-time, not a guarantee"). The sharing user is responsible for whom they share or forward a report to. For minors, sharing is controlled by the parent/guardian.</p>
        <p style={pStyle}><strong>Published pages are public.</strong> Separately from individual share links, 643 Sports MGMT may PUBLISH a session report or an event page. A published page is readable by anyone holding its address, without a BBOT account and without a revocable token, and may be indexed or forwarded beyond 643&rsquo;s control. A published session report names the players it describes. Publishing is a deliberate act by 643 staff; a page stays public until 643 unpublishes it, after which the address no longer resolves. Event pages show how many players have registered and never identify who they are.</p>
      </div>

      <div style={sectionStyle}>
        <div style={h2Style}>4C. What Is Public Without an Account</div>
        {/* THE PUBLIC TIER, ruled by Luis 2026-10-08. Written as a CLOSED LIST on both sides --
            what is public, and what is not -- because a clause that only says what is public
            leaves a reader to guess at the rest, and the rest is the part that matters to a
            parent. The list matches what the software actually enforces: bbot_players_public
            selects exactly these columns and excludes coaches with a WHERE clause, and clips are
            readable only where approved = true. If the list and the views ever disagree, the
            views are the defect. */}
        <p style={pStyle}>Parts of BBOT are readable by anyone, with no account and no shared link. This is deliberate, and it is limited to the following.</p>
        <p style={pStyle}><strong>Public for an approved player profile:</strong> the player&rsquo;s <strong>name</strong>, <strong>playing position(s)</strong>, and <strong>high-school graduation year (class)</strong>; and the player&rsquo;s <strong>most recent published clip and most recent published movement-tracking (skeleton) clip</strong>. A clip becomes public only after 643 Sports MGMT has reviewed and published it; unpublished footage is never public.</p>
        <p style={pStyle}><strong>Also public:</strong> leaderboards, published session reports, published event pages, and blog articles. Leaderboards list device-verified readings and admin-timed results by player name.</p>
        <p style={pStyle}><strong>Not public, and reachable only by a signed-in and approved account with permission:</strong> email addresses, telephone numbers, dates of birth, home or school location, guardian details and consent records, account or approval status, measured evaluations and grades, session history, performance data, notes, messages, and a player&rsquo;s remaining footage. <strong>Coach, scout and staff profiles are not public in any part.</strong></p>
        <p style={pStyle}><strong>A player may ask for the public preview to be withdrawn.</strong> A player, or the parent or legal guardian of a player under 18, may contact 643 Sports MGMT at 643sportsmgmt@gmail.com and request that the player&rsquo;s public preview and public footage be removed. 643 Sports MGMT will action the request and confirm it.</p>
      </div>

      <div style={sectionStyle}>
        <div style={h2Style}>4D. Footage Is For Viewing Only</div>
        {/* THE PROHIBITION HAS TO LIVE HERE, because it cannot live in the software. The player
            removes the download button, the native download control, picture-in-picture and
            right-click save; a browser must still receive the bytes in order to play them, so
            none of that stops a determined person. Saying so plainly is the point: a term the
            product cannot technically enforce is still enforceable as a term, and claiming a
            protection we do not have would be the kind of overstatement this product exists to
            avoid. [[prose-is-not-a-data-source]] */}
        <p style={pStyle}>All video on BBOT &mdash; clips, movement-tracking (skeleton) clips, highlight reels and session footage &mdash; is made available for <strong>viewing only</strong>. Except where 643 Sports MGMT provides an explicit download, you may not download, copy, record, screen-capture, re-host, re-upload, redistribute, sell, or create derivative works from any video on this platform, and you may not circumvent or attempt to circumvent any measure that restricts doing so. Downloading is available only to 643 Sports MGMT administrators.</p>
        <p style={pStyle}>All footage, clips, and movement-tracking outputs remain the property of 643 Sports MGMT LLC and the player as applicable, and no licence to reproduce or redistribute them is granted by their being viewable. 643 Sports MGMT does not represent that these restrictions are technically unbreakable: video must be transmitted to a viewer&rsquo;s device in order to play. The restriction above is a contractual obligation you accept by using the platform, and 643 Sports MGMT LLC reserves every remedy available for its breach, including removal of access and legal action.</p>
        <p style={pStyle}>Nothing in this section limits a player&rsquo;s own rights in footage of themselves, or a parent or guardian&rsquo;s rights on behalf of a minor; a player may request their own footage at any time.</p>
      </div>

      <div style={sectionStyle}>
        <div style={h2Style}>4B. No Guarantee · Not Recruiting Advice</div>
        <p style={pStyle}>Percentiles and measurements are point-in-time, peer-relative, and informational. 643 Sports MGMT LLC makes no representation that they will result in any recruiting, scholarship, draft, or athletic outcome, and they do not constitute recruiting, agent, financial, or eligibility advice.</p>
      </div>

      <div style={sectionStyle}>
        <div style={h2Style}>5. Payments, Triggering & Evaluation Delivery</div>
        <p style={pStyle}>Player profiles are free. BBOT evaluations are sold individually and are paid for <strong>only by the player</strong> (or the player's parent/guardian for minors). Coaches and staff may <em>trigger</em> an evaluation request on a player's behalf, but they are never charged, and triggering alone does not generate or release any report.</p>
        <p style={pStyle}><strong>Account approval.</strong> All new accounts are reviewed by 643 Sports MGMT before full access is granted. Until an account is approved, its profile is hidden from the public directory and it cannot upload video, request evaluations, or receive evaluations. 643 Sports MGMT may decline or revoke access at its discretion to protect the platform from spam, misuse, or violations of these terms.</p>
        <p style={pStyle}><strong>Order of operations.</strong> Across the platform, payment comes first. No evaluation is generated, and no human review of an evaluation is performed, until the player has paid. Upon confirmed payment, BBOT generates the evaluation, 643 Sports MGMT reviews the finished evaluation for accuracy and calibration, and it is then released to the player's profile. Untriggered or unpaid evaluations are not generated and are not accessible to anyone.</p>
        <p style={pStyle}><strong>Player-submitted (non-643) video.</strong> Video not filmed by 643 Sports MGMT may not capture every tool. By paying for an evaluation of player- or coach-submitted video, you acknowledge and accept that the result may be a <strong>partial evaluation</strong> — grading only what is observable and marking the remainder as not observable. A partial evaluation is a complete, delivered report and is not eligible for refund on the basis of being partial. Official 643-filmed sessions are designed to capture every tool.</p>
        <p style={pStyle}>All payment processing is handled via ATH Móvil, a secure, encrypted third-party provider. 643 Sports MGMT does not store card numbers or ATH Móvil credentials.</p>
        <p style={pStyle}><strong>Refund policy:</strong> All sales are final. Because each evaluation is generated only after payment, payments are non-refundable except where BBOT fails to deliver a usable evaluation due to a technical fault on our end (for example, a corrupted output or a failed run that cannot be re-run). In such cases, 643 Sports MGMT LLC will, at its discretion, either re-run the evaluation at no additional cost or issue a refund. Refunds are not available for dissatisfaction with grades, results, scouting conclusions, or for a partial evaluation that correctly reflects the footage submitted. To request a refund for a faulty evaluation, contact 643sportsmgmt@gmail.com.</p>
      </div>

      <div style={sectionStyle}>
        <div style={h2Style}>6. Limitation of Liability</div>
        <p style={pStyle}>643 Sports MGMT LLC shall not be liable for any direct, indirect, incidental, or consequential damages arising from the use of BBOT evaluations, platform data, or any decisions made based on evaluation results. By using this platform, users agree to hold 643 Sports MGMT LLC harmless from any claims arising from evaluation content or platform use.</p>
      </div>

      <div style={sectionStyle}>
        <div style={h2Style}>7. Platform Positioning &amp; Neutrality</div>
        <p style={pStyle}>BBOT is a neutral evaluation, data, and media platform. BBOT is NOT, and does not act as: an athlete agent or representation service; a pay-for-access broker; an unlicensed agent under any state athlete-agent law; a recruiting intermediary that directs or steers players to any organization; or a guarantor of recruiting outcomes, college admissions, scholarship offers, or professional opportunities. 643 Sports MGMT LLC operates BBOT as a technology service and subscription marketplace open to coaches and scouts regardless of organizational affiliation.</p>
      </div>

      <div style={sectionStyle} id="legal-compliance">
        <div style={h2Style}>8. Coach &amp; Scout User Conduct</div>
        <p style={pStyle}>Users registering as coaches, scouts, recruiting coordinators, cross-checkers, analytics staff, or player development personnel agree to comply with the rules and regulations of their respective governing bodies (including but not limited to the NCAA, MLB, NAIA, NJCAA, state high school athletic associations, and state athlete-agent statutes). Users further agree to comply with all applicable NIL (Name, Image, Likeness) regulations and state laws governing communications with minor athletes. BBOT may log all platform-facilitated communications between coaches/scouts and players for compliance and audit purposes.</p>
      </div>

      <div style={sectionStyle}>
        <div style={h2Style}>9. Coach &amp; Staff Roles, Rosters &amp; Leaderboards</div>
        <p style={pStyle}>Coaches and staff may trigger evaluation requests, build rosters (a team or organization name is required to create a roster), and pull players onto their roster to track those players' published reports, clips, and leaderboards in one place. Roster association does not transfer ownership of a player's profile, video, or evaluations, all of which remain controlled by the player (or their parent/guardian). Leaderboards are generated dynamically from released evaluation data and are segmented by age bracket; they rank device-verified measurements only (numbers read from an on-screen device/overlay). <strong>Leaderboards are public</strong> and identify players by name; see Section 4C. Qualitative scouting observations are not ranked numerically. Highlight reels and clips are published to a player's profile only after 643 Sports MGMT's review and the player's payment for the associated evaluation.</p>
      </div>

      <div style={sectionStyle}>
        <div style={h2Style}>10. Verified Status</div>
        <p style={pStyle}>The "Verified" badge displayed on certain coach and scout profiles indicates that 643 Sports MGMT LLC has reviewed credentials provided by the user and confirmed their stated role at the time of verification. Verified status is not a continuing endorsement, employment relationship, or warranty of conduct. 643 Sports MGMT LLC may revoke verified status at any time for any reason.</p>
      </div>

      <div style={sectionStyle}>
        <div style={h2Style}>11. Minor Athletes &amp; Parental Consent</div>
        <p style={pStyle}>For players under 18 years of age, parental or legal guardian consent is required for the upload of video and the creation of player profiles. Any communication initiated by a coach or scout to a minor athlete through BBOT may be subject to additional consent requirements and will be logged. 643 Sports MGMT LLC reserves the right to suspend any account engaged in conduct that violates child safety, anti-grooming, or NIL regulations affecting minors.</p>
      </div>

      <div style={sectionStyle}>
        <div style={h2Style}>12. Intellectual Property</div>
        <p style={pStyle}>All content, design, code, scouting methodology, evaluation frameworks, and data models on this platform are the property of 643 Sports MGMT LLC. Users may not reproduce, distribute, or create derivative works from any platform content without explicit written permission.</p>
      </div>

      <div style={sectionStyle}>
        <div style={h2Style}>13. Events, Leagues &amp; Showcases</div>
        <p style={pStyle}><strong>Registration &amp; eligibility.</strong> 643 Sports MGMT LLC operates in-person pickup games, developmental leagues, and showcases. Participation requires registration, payment, and acceptance of the participation waiver presented at registration. A participant under 18 must hold a BBOT profile created with parent or legal guardian consent (Section 11), and registration is made through that profile. By registering, the parent or legal guardian accepts these Terms and the participation waiver on the minor's behalf. 643 Sports MGMT may decline or remove any participant at its discretion.</p>
        <p style={pStyle}><strong>Assumption of risk &amp; release.</strong> Baseball and related athletic activities carry inherent risks of serious injury, illness, or death. By registering, each participant (and, for minors, their parent/guardian) voluntarily assumes all such risks and releases, waives, and agrees to hold harmless and indemnify 643 Sports MGMT LLC, BBOT, their owners, officers, employees, staff, volunteers, contractors, the venue/field owner and operator, sponsors, and all affiliated and organizing parties from any and all claims, demands, liabilities, or causes of action arising out of or related to participation, including those caused by ordinary negligence, to the fullest extent permitted by law. The participation waiver accepted at registration is incorporated into these Terms by reference.</p>
        <p style={pStyle}><strong>Health &amp; emergency care.</strong> Each participant confirms they are physically fit to participate and carry or have declined appropriate medical/accident insurance. 643 Sports MGMT is authorized to arrange emergency medical care if needed, at the participant's expense.</p>
        <p style={pStyle}><strong>Filming &amp; data consent.</strong> Events are filmed using multiple cameras. By registering, participants consent to being photographed and recorded and to 643 Sports MGMT's use of that footage and the resulting data for evaluation, player profiles, leaderboards, highlight reels, and promotion across 643 channels and social media, with no compensation owed. Players may be issued a machine-readable identification marker (a printed pattern) to be worn at the event solely to identify the player within event footage; this marker contains no personal, biometric, location, or tracking data and is not used for advertising or sold to any third party.</p>
        <p style={pStyle}><strong>Jerseys, fees &amp; refunds.</strong> Event fees are stated at registration. Registration stays open until 643 Sports MGMT closes it for a given event; closing is a decision made by 643 rather than a fixed deadline, and is reflected on the event page. Jerseys are ordered from the registered roster. <strong>Once a jersey has been ordered, the registration fee is non-refundable.</strong> Alternative jersey requests may carry an additional cost. Event evaluations, clips, and reports are delivered to the player's profile following the event subject to the same review and delivery terms as other BBOT evaluations (Sections 2 and 5).</p>
        <p style={pStyle}><strong>Conduct &amp; no-show.</strong> Participants agree to follow event rules, staff instructions, and venue policies. 643 Sports MGMT may remove any participant for unsafe or disruptive conduct without refund. No-shows are not eligible for refunds. Events may be rescheduled or cancelled for weather, safety, facility, or other reasons; in the event of a 643-initiated cancellation, 643 Sports MGMT will, at its discretion, offer a credit, transfer, or refund of the event fee.</p>
        <p style={pStyle}><strong>Third-party services.</strong> Any immigration, visa, college-advisory, or similar services referred in connection with events are provided by independent third parties under their own terms; 643 Sports MGMT acts only as a referral source, does not provide legal or immigration advice, and is not responsible or liable for those third-party services or their outcomes.</p>
      </div>

      <div style={{background:C.navy,borderRadius:12,padding:"18px 20px",marginTop:32}}>
        <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:13,color:C.white,letterSpacing:1,marginBottom:6}}>QUESTIONS OR CONCERNS</div>
        <div style={{fontSize:12,color:"rgba(255,255,255,.6)"}}>Contact us at 643sportsmgmt@gmail.com</div>
        <div style={{fontSize:11,color:"rgba(255,255,255,.6)",marginTop:8}}>BBOT is proprietary technology owned and operated by 643 Sports MGMT LLC.</div>
      </div>
    </div>
  );
}
function SavedSearchesPage({cu, users, scoutReports, metrics, go, notify}){
  var [searches, setSearches] = useState([]);
  var [draftText, setDraftText] = useState("");
  var [draftFilters, setDraftFilters] = useState({});
  var [loading, setLoading] = useState(true);

  // Fetch saved searches for this coach
  useEffect(function(){
    fetch(SUPABASE_URL+"/rest/v1/bbot_wants?coach_id=eq."+String(cu.id)+"&order=created_at.desc", {
      headers: sbHeaders()
    }).then(function(r){return r.json();}).then(function(rows){
      setSearches(rows||[]);
      setLoading(false);
    }).catch(function(){setLoading(false);});
  }, []);

  // Suggestion chips available to add as structured filters
  var SUGGESTIONS = [
    {key:"exitVeloMin", label:"Exit velocity threshold", placeholder:"e.g. 88", unit:"mph"},
    {key:"throwVeloMin", label:"Throwing velocity threshold", placeholder:"e.g. 80", unit:"mph"},
    {key:"pitchVeloMin", label:"Pitching velocity threshold", placeholder:"e.g. 85", unit:"mph"},
    {key:"dash60Max", label:"60-yard time (max)", placeholder:"e.g. 7.0", unit:"sec"},
    {key:"popTimeMax", label:"Pop time (max, catchers)", placeholder:"e.g. 2.05", unit:"sec"},
    {key:"gradYear", label:"Graduation year", placeholder:"e.g. 2027", unit:""},
    {key:"position", label:"Position", placeholder:"e.g. SS, OF, LHP", unit:""},
    {key:"region", label:"Region (state or city)", placeholder:"e.g. FL, San Juan", unit:""},
  ];

  function saveSearch(){
    if(!draftText.trim()){ notify("Add a description of what you're looking for","error"); return; }
    var record = {
      coach_id: String(cu.id),
      description: draftText.trim(),
      filters: draftFilters,
      created_at: new Date().toISOString(),
      expires_at: new Date(Date.now() + 60*24*60*60*1000).toISOString(), // 60 days
      active: true,
    };
    bbotWrite("bbot_wants","insert",[record],null).then(function(rows){
      setSearches(function(s){return (rows||[]).concat(s);});
      setDraftText("");
      setDraftFilters({});
      notify("Search saved · You'll be notified when new matches appear");
    }).catch(function(){notify("Save failed","error");});
  }

  function deleteSearch(id){
    if(!window.confirm("Delete this saved search?")) return;
    bbotWrite("bbot_wants","delete",null,"id=eq." + Number(id)).then(function(){
      setSearches(function(s){return s.filter(function(x){return x.id!==id;});});
    });
  }

  // Match players against a search
  function findMatches(search){
    var f = search.filters || {};
    var players = (users||[]).filter(function(u){return u.type==="player";});

    if(f.gradYear){
      players = players.filter(function(u){return String(u.gradYear||"").indexOf(String(f.gradYear))>=0;});
    }
    if(f.position){
      var pos = String(f.position).toUpperCase();
      players = players.filter(function(u){return (u.position||"").toUpperCase().indexOf(pos)>=0 || (u.position2||"").toUpperCase().indexOf(pos)>=0;});
    }
    if(f.region){
      var rg = String(f.region).toUpperCase();
      players = players.filter(function(u){return (u.state||"").toUpperCase().indexOf(rg)>=0 || (u.city||"").toUpperCase().indexOf(rg)>=0 || (u.hsName||"").toUpperCase().indexOf(rg)>=0;});
    }
    // Score / metrics filters check latest data
    function getLatestMetric(pid, key){
      var pM = (metrics||{})[pid] || [];
      if(!pM.length) return null;
      for(var i=pM.length-1; i>=0; i--){
        if(pM[i][key] != null) return Number(pM[i][key]);
      }
      return null;
    }
    function getLatestScore(pid){
      var rs = (scoutReports||[]).filter(function(r){return String(r.playerId)===String(pid) && isLiveEval(r) && r.score!=null;}).sort(function(a,b){return (b.date||"").localeCompare(a.date||"");});
      return rs[0] ? rs[0].score : null;
    }
    if(f.exitVeloMin) players = players.filter(function(u){var v=getLatestMetric(u.id,"exitVelo"); return v!=null && v>=Number(f.exitVeloMin);});
    if(f.throwVeloMin) players = players.filter(function(u){var v=getLatestMetric(u.id,"throwVelo"); return v!=null && v>=Number(f.throwVeloMin);});
    if(f.pitchVeloMin) players = players.filter(function(u){var v=getLatestMetric(u.id,"pitchVelo"); return v!=null && v>=Number(f.pitchVeloMin);});
    if(f.dash60Max) players = players.filter(function(u){var v=getLatestMetric(u.id,"dash60"); return v!=null && v<=Number(f.dash60Max);});
    if(f.popTimeMax) players = players.filter(function(u){var v=getLatestMetric(u.id,"popTime"); return v!=null && v<=Number(f.popTimeMax);});

    // Rank by exit velo (composite score retired); fall back to name
    return players.map(function(u){return {player:u, score:getLatestMetric(u.id,"exitVelo")};}).sort(function(a,b){return (b.score||0)-(a.score||0);});
  }

  return (
    <div style={{maxWidth:780,margin:"0 auto",padding:"20px 16px"}}>
      <div style={{marginBottom:18}}>
        <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:22,color:C.navy,letterSpacing:1.5,marginBottom:6}}>SAVED SEARCHES</div>
        <p style={{fontSize:13,color:C.gray500,lineHeight:1.6,margin:0}}>Describe what you're recruiting for and add optional metric thresholds. BBOT suggests matching players from verified data, ranks them, and lets you compare your top matches side by side. You'll be notified as new players match.</p>
      </div>

      {/* NEW SEARCH DRAFT */}
      <Card style={{padding:16,marginBottom:18,borderLeft:"3px solid "+C.coral}}>
        <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:11,color:C.coral,letterSpacing:1.2,marginBottom:10,fontWeight:700}}>NEW SEARCH</div>
        <label style={{fontSize:11,color:C.gray500,fontWeight:600,letterSpacing:.5,display:"block",marginBottom:4}}>WHAT ARE YOU LOOKING FOR?</label>
        <textarea value={draftText} onChange={function(e){setDraftText(e.target.value);}} placeholder="e.g. Need a 2027 LHP, command-first with a usable breaking ball. Open to projection arms." rows={3} style={{width:"100%",padding:"10px 12px",border:"1px solid "+C.border,borderRadius:8,fontSize:13,fontFamily:"inherit",resize:"vertical",boxSizing:"border-box"}}/>

        {/* Active filter chips */}
        {Object.keys(draftFilters).length>0 && (
          <div style={{display:"flex",flexWrap:"wrap",gap:6,marginTop:10,padding:"8px 10px",background:C.coralFaint,borderRadius:6}}>
            {Object.keys(draftFilters).map(function(k){
              var s = SUGGESTIONS.find(function(x){return x.key===k;});
              if(!s) return null;
              return (
                <div key={k} style={{display:"flex",alignItems:"center",gap:5,padding:"3px 8px",background:C.white,border:"1px solid "+C.coralLight,borderRadius:99,fontSize:11,color:C.navy,fontWeight:600}}>
                  <span>{s.label}: <strong style={{color:C.coral}}>{draftFilters[k]}</strong>{s.unit?" "+s.unit:""}</span>
                  <button onClick={function(){
                    setDraftFilters(function(prev){var n=Object.assign({},prev); delete n[k]; return n;});
                  }} style={{background:"none",border:"none",color:C.gray400,fontSize:14,cursor:"pointer",padding:0,minHeight:"auto",lineHeight:1}}>×</button>
                </div>
              );
            })}
          </div>
        )}

        {/* SUGGESTION CHIPS */}
        <div style={{marginTop:12}}>
          <div style={{fontSize:10,color:C.gray400,fontWeight:600,letterSpacing:.5,marginBottom:6}}>ADD OPTIONAL CRITERIA</div>
          <div style={{display:"flex",flexWrap:"wrap",gap:5}}>
            {SUGGESTIONS.filter(function(s){return draftFilters[s.key]==null;}).map(function(s){return (
              <button key={s.key} onClick={function(){
                var v = window.prompt(s.label+(s.unit?" ("+s.unit+")":""), s.placeholder);
                if(!v) return;
                setDraftFilters(function(prev){return Object.assign({},prev,{[s.key]:v});});
              }} style={{padding:"4px 10px",border:"1px dashed "+C.blue,background:C.blueFaint,color:C.blue,borderRadius:99,fontSize:10,fontWeight:600,cursor:"pointer",letterSpacing:.3,minHeight:"auto"}}>+ {s.label}</button>
            );})}
          </div>
        </div>

        <div style={{display:"flex",justifyContent:"flex-end",gap:8,marginTop:14}}>
          <Btn v="primary" onClick={saveSearch} style={{fontSize:12}}>Save Search</Btn>
        </div>
      </Card>

      {/* SAVED SEARCH LIST */}
      <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:11,color:C.gray500,letterSpacing:1.2,marginBottom:10,fontWeight:600}}>ACTIVE SEARCHES ({searches.length})</div>
      {loading ? (
        <div><SkeletonCard/><SkeletonCard/></div>
      ) : searches.length===0 ? (
        <EmptyCard icon="S" title="No Saved Searches" sub="Save searches to get notified when new players match your criteria."/>
      ) : (
        <div style={{display:"flex",flexDirection:"column",gap:10}}>
          {searches.map(function(s){
            var matches = findMatches(s);
            return (
              <Card key={s.id} style={{padding:14}}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",gap:10,marginBottom:8,flexWrap:"wrap"}}>
                  <div style={{flex:"1 1 200px"}}>
                    <p style={{fontSize:13,color:C.navy,fontWeight:600,margin:"0 0 6px 0",lineHeight:1.5}}>{s.description}</p>
                    {s.filters && Object.keys(s.filters).length>0 && (
                      <div style={{display:"flex",flexWrap:"wrap",gap:4}}>
                        {Object.keys(s.filters).map(function(k){
                          var sg = SUGGESTIONS.find(function(x){return x.key===k;});
                          return <span key={k} style={{fontSize:9,padding:"2px 7px",background:C.gray100,color:C.gray700,borderRadius:99,fontWeight:600}}>{sg?sg.label:k}: {s.filters[k]}{sg&&sg.unit?" "+sg.unit:""}</span>;
                        })}
                      </div>
                    )}
                  </div>
                  <div style={{textAlign:"right"}}>
                    <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:22,color:C.coral,fontWeight:700,lineHeight:1}}>{matches.length}</div>
                    <div style={{fontSize:9,color:C.gray500,letterSpacing:.5}}>MATCHES</div>
                  </div>
                </div>
                {matches.length>0 && (
                  <div style={{borderTop:"1px solid "+C.gray100,paddingTop:8,marginTop:6}}>
                    <div style={{fontSize:9,color:C.gray400,letterSpacing:.5,marginBottom:6}}>TOP MATCHES</div>
                    <div style={{display:"flex",flexDirection:"column",gap:4}}>
                      {matches.slice(0,5).map(function(m){return (
                        <div key={m.player.id} onClick={function(){go("profile",m.player);}} style={{display:"flex",alignItems:"center",gap:8,padding:"5px 8px",background:C.gray50,borderRadius:6,cursor:"pointer"}}>
                          <Avatar user={m.player} size={24}/>
                          <div style={{flex:1,fontSize:12,color:C.navy,fontWeight:600}}>{m.player.firstName} {m.player.lastName}</div>
                          <div style={{fontSize:10,color:C.gray500}}>{[m.player.position, m.player.gradYear?"'"+String(m.player.gradYear).slice(-2):null].filter(Boolean).join(" · ")}</div>
                          {m.score!=null && <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:13,color:C.coral,fontWeight:700,minWidth:42,textAlign:"right"}}>{m.score}<span style={{fontSize:8,color:C.gray400,fontWeight:400}}> EV</span></div>}
                        </div>
                      );})}
                      {matches.length>5 && <div style={{fontSize:10,color:C.gray400,textAlign:"center",padding:"3px 0"}}>+{matches.length-5} more match{matches.length-5===1?"":"es"}</div>}
                    </div>
                    {matches.length>=2&&(
                      <button onClick={function(){
                        if(typeof window!=="undefined") window.__bbotCompareIds=matches.slice(0,10).map(function(m){return m.player.id;});
                        go("compare");
                      }} style={{marginTop:8,width:"100%",background:C.blueFaint,color:C.blue,border:"1px solid "+C.blue,padding:"7px",borderRadius:8,fontSize:11,fontWeight:600,cursor:"pointer"}}>⚖ Compare top matches</button>
                    )}
                  </div>
                )}
                <div style={{display:"flex",justifyContent:"flex-end",marginTop:10}}>
                  <button onClick={function(){deleteSearch(s.id);}} style={{background:"transparent",border:"none",color:C.gray400,fontSize:10,cursor:"pointer",padding:"2px 6px",minHeight:"auto"}}>Delete search</button>
                </div>
              </Card>
            );
          })}
        </div>
      )}
    </div>
  );
}

function ForCoachesPage({go, setAuthMode}){
  return (
    <div style={{minHeight:"100vh",background:C.gray50}}>
      {/* Header */}
      <div style={{background:C.navy,padding:"12px 16px",display:"flex",alignItems:"center",justifyContent:"space-between",position:"sticky",top:0,zIndex:50}}>
        <div onClick={function(){go("landing");}} style={{display:"flex",alignItems:"center",gap:10,cursor:"pointer"}}>
          <BbotMark size={32}/>
          <div style={{color:C.white,fontSize:12,fontWeight:600,letterSpacing:.5}}>← Back to BBOT</div>
        </div>
        <Btn v="primary" style={{padding:"6px 14px",fontSize:12}} onClick={function(){setAuthMode("register");go("auth");}}>Coach Sign Up</Btn>
      </div>

      <div style={{maxWidth:780,margin:"0 auto",padding:"28px 16px 48px"}}>
        <div style={{textAlign:"center",marginBottom:32}}>
          <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:28,color:C.navy,letterSpacing:2,marginBottom:10}}>BBOT FOR COACHES</div>
          <div style={{width:40,height:3,background:C.coral,borderRadius:99,margin:"0 auto 14px"}}/>
          <p style={{fontSize:15,color:C.gray600,maxWidth:520,margin:"0 auto",lineHeight:1.7}}>
            Free access. Verified video data. Search by exact criteria.
          </p>
        </div>

        {/* THE PROBLEM / SOLUTION */}
        <Card style={{padding:18,marginBottom:18,borderLeft:"3px solid "+C.coral}}>
          <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:11,color:C.coral,letterSpacing:1.2,fontWeight:700,marginBottom:8}}>WHY BBOT EXISTS</div>
          <p style={{fontSize:13,color:C.gray700,lineHeight:1.7,margin:0}}>
            Most recruiting tools surface self-reported numbers tied to paid placement. BBOT only displays measurements verified in video — radar in-frame, on-screen timers, observable physical events. Every mark carries the receipt it stands on. We disclose what we did not measure, and why.
          </p>
        </Card>

        {/* WHAT YOU GET — coach-specific */}
        <div style={{marginBottom:24}}>
          <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:11,color:C.gray400,letterSpacing:1.5,marginBottom:12}}>WHAT COACHES GET</div>
          <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(min(220px,100%),1fr))",gap:10}}>
            {[
              ["Verified-Only Data","Every metric is video-confirmed. No self-reported velos, no inflated heights, no fabricated 60-yard times."],
              ["Filter By Tool","Search 2027 SS in PR with EV ≥ 90 and 60-yd ≤ 6.9 — see results in seconds. Sort by any verified metric or recency."],
              ["Compare 2-4 Players","Stack candidates side-by-side: physicals, tool grades, charts, latest eval — single screen."],
              
              ["Progression Visibility","See how a player's tool grades changed across sessions. Recruiting decisions on trajectory, not snapshots."],
              ["Timestamped Messaging","Player-coach messaging opens at Aug 1 of the player's junior year. Every message timestamped."],
            ].map(function(f){return(
              <div key={f[0]} style={{padding:"12px 14px",background:C.white,border:"1px solid "+C.border,borderRadius:8}}>
                <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:12,color:C.navy,letterSpacing:.5,marginBottom:4}}>{f[0]}</div>
                <p style={{fontSize:11,color:C.gray600,margin:0,lineHeight:1.55}}>{f[1]}</p>
              </div>
            );})}
          </div>
        </div>

        {/* DEMO SEARCH MOCKUP */}
        <div style={{marginBottom:24}}>
          <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:11,color:C.gray400,letterSpacing:1.5,marginBottom:12}}>EXAMPLE SEARCH</div>
          <Card style={{padding:16}}>
            <div style={{fontSize:12,color:C.gray500,marginBottom:10,fontStyle:"italic"}}>"2027 SS in Puerto Rico, EV ≥ 88, 60-yd ≤ 7.0"</div>
            <div style={{display:"flex",flexDirection:"column",gap:4}}>
              {[
                {name:"Player A",pos:"SS",grad:"2027",ev:92,sixty:"6.85",verified:true},
                {name:"Player B",pos:"SS",grad:"2027",ev:90,sixty:"6.95",verified:true},
                {name:"Player C",pos:"SS",grad:"2027",ev:89,sixty:"7.0",verified:true},
              ].map(function(p,i){return (
                <div key={i} style={{display:"flex",alignItems:"center",gap:10,padding:"8px 10px",background:C.gray50,borderRadius:6}}>
                  <div style={{width:28,height:28,borderRadius:"50%",background:C.navy,color:C.white,display:"flex",alignItems:"center",justifyContent:"center",fontFamily:"Inter,system-ui,sans-serif",fontSize:11,fontWeight:700}}>{i+1}</div>
                  <div style={{flex:1,minWidth:0}}>
                    <div style={{fontSize:12,fontWeight:600,color:C.navy}}>{p.name} <span style={{fontSize:9,color:C.green,background:C.greenLight,padding:"1px 5px",borderRadius:99,marginLeft:4,fontWeight:700,letterSpacing:.3}}>VERIFIED</span></div>
                    <div style={{fontSize:10,color:C.gray500}}>{p.pos} · Class {p.grad} · 60-yd {p.sixty}</div>
                  </div>
                  <div style={{textAlign:"right"}}><div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:18,fontWeight:700,color:C.coral,lineHeight:1}}>{p.ev}</div><div style={{fontSize:8,color:C.gray400}}>EV</div></div>
                </div>
              );})}
            </div>
            <div style={{fontSize:10,color:C.gray400,fontStyle:"italic",marginTop:8,textAlign:"center"}}>Anonymized example · sample data only</div>
          </Card>
        </div>

        {/* COMPLIANCE BLOCK */}
        <Card style={{padding:14,marginBottom:24,background:C.blueFaint,borderLeft:"3px solid "+C.blue}}>
          <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:11,color:C.blue,letterSpacing:1.2,fontWeight:700,marginBottom:6}}>NCAA COMPLIANCE</div>
          <p style={{fontSize:12,color:C.gray700,lineHeight:1.7,margin:0}}>
            BBOT enforces the NCAA D1/D2 contact window — direct messaging to players opens August 1 of the player's junior year. Before that, coaches can view profiles, save searches, and follow players, but cannot initiate direct contact. Every interaction is logged.
          </p>
        </Card>

        {/* CTA */}
        <div style={{background:"linear-gradient(135deg,"+C.navy+","+C.navyMid+")",borderRadius:14,padding:24,textAlign:"center",color:C.white}}>
          <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:18,letterSpacing:1,marginBottom:6}}>FREE COACH ACCESS</div>
          <p style={{fontSize:13,color:"rgba(255,255,255,.7)",marginBottom:18,maxWidth:380,margin:"0 auto 18px",lineHeight:1.6}}>
            Sign up with your coaching email. Verification typically within 24 hours.
          </p>
          <Btn v="primary" onClick={function(){setAuthMode("register");go("auth");}}>Create Free Coach Account</Btn>
          <div style={{marginTop:14,fontSize:11,color:"rgba(255,255,255,.7)"}}>Questions? <a href="mailto:643sportsmgmt@gmail.com" style={{color:C.coral}}>643sportsmgmt@gmail.com</a></div>
        </div>
      </div>
    </div>
  );
}

function MethodologyPage({go}){
  var Section = function(props){
    return (
      <div style={{marginBottom:24}}>
        <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:13,color:C.coral,letterSpacing:1.2,marginBottom:10,paddingBottom:6,borderBottom:"1px solid "+C.gray100}}>{props.title}</div>
        <div style={{fontSize:13,color:C.gray700,lineHeight:1.7}}>{props.children}</div>
      </div>
    );
  };
  var Row = function(props){
    return (
      <div style={{display:"flex",gap:12,padding:"8px 0",borderBottom:"1px solid "+C.gray100,fontSize:12}}>
        <div style={{minWidth:80,fontWeight:600,color:C.navy,letterSpacing:.3}}>{props.label}</div>
        <div style={{flex:1,color:C.gray600,lineHeight:1.55}}>{props.children}</div>
      </div>
    );
  };
  return (
    <div style={{maxWidth:760,margin:"0 auto",padding:"28px 16px 48px"}}>
      <Btn v="ghost" style={{marginBottom:14,fontSize:12}} onClick={function(){go("about");}}>← Back</Btn>
      <div style={{textAlign:"center",marginBottom:28}}>
        <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:26,color:C.navy,letterSpacing:2,marginBottom:8}}>BBOT METHODOLOGY</div>
        <div style={{width:36,height:2,background:C.coral,margin:"0 auto 12px"}}/>
        <p style={{fontSize:13,color:C.gray500,maxWidth:520,margin:"0 auto",lineHeight:1.7}}>How BBOT measures video and places each mark against same-age peers.</p>
      </div>

      <Card style={{padding:18,marginBottom:18}}>
        <Section title="WHAT BBOT MEASURES">
          BBOT reads what your footage captures. Velocity and timing come from device or overlay readings visible in the footage — radar for pitch, exit, and throw velocity; timers for run and pop times. Actions — swings, throws, deliveries, fielding — are identified on video and verified to the player before anything is drawn from them. Where BBOT measures movement from video it reports RELATIVE SHAPE only: how one repetition compares with another in the same session, carrying no units and asserting no magnitude. Every figure traces to something the footage shows.
        </Section>

        <Section title="OBJECTIVE, NOT SUBJECTIVE">
          BBOT does not hand out opinions. Where a tool has a measured number — exit velo, arm and pitch velocity, run and pop times — the number itself is what the report carries, shown against a documented age reference. The data decides, not a scout's eye. Peer percentile rankings are not active, and no peer group stands behind any number on a BBOT report. Tools with no measurement — swing and fielding mechanics, pitch shape — are reported as <strong>factual observations</strong> and clearly labeled as such. Both are honest; neither is dressed up as the other.
        </Section>

        <Section title="MEASURED MARKS vs SCOUTING OBSERVATIONS">
          A tool carries a <strong>measured number</strong> only when there's an actual measured value — a number read from a radar or timer in the footage, or a time recorded by 643 with the operator, timer and distance stated. Each measured mark is shown against a documented <strong>age reference</strong>, and the report always states the age bracket behind it. <strong>Peer percentile rankings are not active, and no peer group stands behind any number on a BBOT report</strong> — a report shows the measured mark itself, never a rank. Tools BBOT can describe but not measure — mechanics, fielding actions, pitching shape — get a <strong>factual scouting observation</strong> instead. Nothing shows where there's no measurement, and the report says why.
        </Section>

        <Section title="POINT-IN-TIME, NOT A PROJECTION">
          A percentile is a snapshot of one session against same-age peers — <strong>not a guarantee, a projection, or a prospect grade</strong>. Any shared or exported report carries that label so it can't be read out of context.
        </Section>

        <Section title="HUMAN REVIEW">
          Every evaluation is reviewed and approved by 643 staff before publication. Measured values are never adjusted. A staff review can revise a scouting observation, and the original BBOT output is preserved in an internal audit log. Coach notes added to a report are clearly marked as staff-added, not BBOT-generated.
        </Section>

        <Section title="LIMITATIONS">
          BBOT is video-based: an evaluation is only as good as the footage. Angle, distance, lighting, and frame rate all affect what can be observed. Where something can't be reliably measured or described, BBOT discloses that rather than guessing or filling in.
        </Section>

        <p style={{fontSize:10,color:C.gray400,fontStyle:"italic",lineHeight:1.6,marginTop:4}}>The specific signals, timing methods, and calibration processes BBOT uses to derive measurements are proprietary to 643 Sports MGMT LLC.</p>
      </Card>

      <div style={{textAlign:"center",fontSize:11,color:C.gray400,marginTop:18}}>Questions about BBOT methodology? <a href="mailto:643sportsmgmt@gmail.com" style={{color:C.coral}}>643sportsmgmt@gmail.com</a></div>
    </div>
  );
}

function PrivacyPage({go}){
  return (
    <div style={{maxWidth:720,margin:"0 auto",padding:"28px 16px 48px"}}>
      <Btn v="ghost" style={{marginBottom:14,fontSize:12}} onClick={function(){go("about");}}>← Back</Btn>
      <div style={{textAlign:"center",marginBottom:24}}>
        <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:24,color:C.navy,letterSpacing:2,marginBottom:8}}>PRIVACY & DATA</div>
        <div style={{width:36,height:2,background:C.coral,margin:"0 auto 12px"}}/>
        <p style={{fontSize:13,color:C.gray500}}>How BBOT handles your data, video, and account information.</p>
      </div>
      <Card style={{padding:18}}>
        {[
          ["Where is video stored?", "All uploaded videos are stored on Cloudflare R2 with TLS encryption in transit and AES-256 at rest. Master session files are deleted from R2 within 90 days of upload; consolidated clips, highlight reels, and evaluation outputs persist with the player's account."],
          // CORRECTED 2026-10-08. This answer said "only the player, staff and coaches", which
          // stopped being true the day the public preview shipped. A privacy answer that
          // understates what is visible is worse than no answer, because a parent relies on it.
          ["Who can see my video?", "Your session footage is private to you, 643 Sports MGMT staff (for moderation and post-payment evaluation review), and coaches you share with or who have pulled you onto their roster. Two exceptions are public: your most recent PUBLISHED clip and your most recent PUBLISHED movement-tracking (skeleton) clip can be watched by anyone, with no account — this is how a coach or recruiter sees you before signing up. Only clips 643 has reviewed and published are ever public; everything unpublished stays private. Videos are never sold, shared with third parties, or used for advertising, and you can ask us to remove your public preview at any time."],
          ["What can a stranger see about me?", "Without an account, anyone can see your name, your position(s), your graduation year, and the two published clips described above — plus leaderboards, published session reports and blog articles. They cannot see your email, phone, date of birth, location, guardian details, grades, measurements, session history, notes or messages. Coach and staff profiles are not public at all. To have your public preview withdrawn, email 643sportsmgmt@gmail.com."],
          ["Can people download my clips?", "No. Video on BBOT is for viewing only, and only 643 administrators can download it. We have removed the download button, the player's own download control, and right-click saving. We will not pretend that is unbreakable: any video has to be sent to a device in order to play there, so a determined person with developer tools could still capture it. That is why downloading and redistributing is prohibited by the Terms (Section 4D), which is enforceable whether or not the technical block is."],
          ["Who can request an evaluation, and who pays?", "Players, coaches, and staff can trigger an evaluation request, but only the player (or their parent/guardian) pays. Nothing is generated or reviewed until the player pays. Coaches and staff are never charged."],
          ["What is a partial evaluation?", "If player- or coach-submitted video doesn't clearly show every tool, BBOT evaluates what it can observe — measured results on the tools it could measure, scouting observations on the rest — and marks the rest not observable. You accept this possibility before paying for non-643 video."],
          ["Velocity readings", "BBOT reports velocity only when it's shown on a device/overlay in your video (radar, Pocket Radar, HitTrax) — it reads that number. It does not estimate velocity from video. If no reading is on screen, velocity is reported as not measured and the tool is described instead."],
          ["Can I delete my data?", "Yes. Email 643sportsmgmt@gmail.com or contact admin from your profile. We will delete your account, profile, videos, and evaluations within 14 days. Some anonymized aggregate measurements (used for benchmark calibration) may persist with all personally identifying fields stripped."],
          ["Players under 18", "Accounts for players under 18 require parent/guardian consent at upload, and the parent/guardian authorizes any payment. Parents may request deletion of any video or evaluation at any time."],
          ["Account review", "New signups are reviewed by 643 Sports MGMT before full access is granted. Until your account is approved, your profile is hidden from the public directory and you cannot upload, request, or receive evaluations. This protects the platform from spam and misuse."],
          ["Payment data", "Payments are processed by ATH Móvil. BBOT does not store credit card numbers or ATH Móvil credentials. The processor's own privacy policy applies to the payment data it handles."],
          ["Public profiles and share links", "Two different things. (1) The PUBLIC PREVIEW — name, position, class and your two most recent published clips — is visible to anyone, with no link needed; see the question above. (2) A SHARE LINK is something you create, and it exposes much more: your full profile, evaluations and metrics to anyone holding that link. A share link can be revoked at any time from your profile settings; the public preview is removed by emailing 643sportsmgmt@gmail.com."],
          ["Recruiting interest signals", "A player may send a one-tap interest signal to a coach or program. This notifies that coach of the player's interest. It is an interest flag, not a message, and is visible only to the coach it's sent to — never published publicly."],
          ["NCAA compliance", "Coach-to-player messaging is gated to August 1 of the player's junior year per NCAA contact rules. Every message is logged with timestamp."],
          ["What does BBOT capture and analyze?", "When you upload a session, you consent to BBOT capturing, storing, and analyzing that video and the movement measurements derived from it, to produce your evaluation and compare your measured marks against same-age peers. You can request deletion at any time (see below).", true],
          ["How are the percentiles built?", "Percentiles compare your measured marks to an evolving same-age reference. Measurements from completed evaluations may be used, in anonymized aggregate (all personally identifying fields stripped), to build and maintain that reference. The reference holds no names, faces, or video — only de-identified measurement distributions by age.", true],
          ["Shared and exported scans", "Sharing your report (link, PDF, or image) makes it viewable by anyone who has it, until you revoke the share. Every shared scan carries its point-in-time, peer-relative label (\"percentile vs same-age peers, point-in-time, not a guarantee\") so it can't be read out of context. You control who you share or forward to.", true],
          ["Minors — capture, sharing & aggregation", "For players under 18, the parent/guardian consents to capturing, storing, and analyzing the minor's video and movement measurements, and to sharing or forwarding any report. The guardian controls who a report is shared with, may request deletion at any time, and may request that the minor's measurements not contribute to the aggregate reference. Stricter children's-privacy rules (e.g. COPPA for under-13 and applicable state laws) are honored where they apply.", true],
          ["Deletion and the aggregate reference", "Deleting your data removes your account, profile, videos, and evaluations within 14 days. Measurements already incorporated into the anonymized aggregate reference — which carries no identifying fields — may persist in de-identified form; you may request that your data be excluded from the reference going forward.", true],
          ["Contact", "Privacy questions or data deletion requests: 643sportsmgmt@gmail.com · 643 Sports MGMT LLC · Guaynabo, Puerto Rico"],
        ].map(function(item,i){return (
          <div key={i} style={{marginBottom:14,paddingBottom:14,borderBottom:"1px solid "+C.gray100}}>
            <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:12,color:C.navy,letterSpacing:.5,marginBottom:4}}>{item[0]}</div>
            <p style={{fontSize:12,color:C.gray600,lineHeight:1.65,margin:0}}>{item[1]}</p>
          </div>
        );})}
      </Card>
    </div>
  );
}

function AboutPage({go,siteContent,cu}){
  siteContent=siteContent||{};
  var adminBadge=cu&&bbotIsAdmin(cu);
  return(
    <div style={{maxWidth:720,margin:"0 auto",padding:"28px 16px 48px"}}>

      <div style={{textAlign:"center",marginBottom:32}}>
        <div style={{marginBottom:14,display:"flex",justifyContent:"center"}}><BbotMark size={72}/></div>
        <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:30,fontWeight:700,color:C.navy,letterSpacing:2,marginBottom:10}}>BBOT</div>
        <div style={{width:40,height:3,background:C.coral,borderRadius:99,margin:"0 auto 16px"}}/>
        <p style={{fontSize:15,color:C.gray600,maxWidth:500,margin:"0 auto",lineHeight:1.7}}>{siteContent.aboutHero||"Video-based baseball measurement, and an honest account of its limits. BBOT reports device-verified velocities where a radar reading is visible in your footage — at any frame rate — plus hand-timed run and pop times that name who timed them, certified rep tracking, and relative movement sampling. Where a session cannot support a measurement, the report says so instead of estimating it. Every figure is measured with a receipt or disclosed as absent. Nothing is inferred."}</p>
      </div>

      {/* DEVELOPMENT */}
      <div style={{marginBottom:20,padding:"16px 18px",background:C.blueFaint,borderRadius:12,borderLeft:"4px solid "+C.blue}}>
        <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:11,color:C.blue,letterSpacing:1.5,marginBottom:8,fontWeight:700}}>DEVELOPMENT</div>
        <p style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:13,color:C.gray700,lineHeight:1.7,margin:0}}>A BBOT report shows where a player actually stands on the tools that matter: exit velo, arm strength, run times, and the shape of his movement rep to rep — each shown against a documented age reference. A player and a coach see the same objective data. When a number improves, it shows. When it doesn't, the report says exactly which tool and by how much.</p>
      </div>

      {/* THE STANDARD (A6) — the credibility case in plain English. Luis re-opened his own hold
          deliberately and approved point 4 in its PLAIN form only: no test names, no counts, no
          internals. Says the system is validated, never that each report is individually verified. */}
      <div style={{marginBottom:20,padding:"16px 18px",background:C.blueFaint,borderRadius:12,borderLeft:"4px solid "+C.blue}}>
        <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:11,color:C.blue,letterSpacing:1.5,marginBottom:8,fontWeight:700}}>THE STANDARD</div>
        <p style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:13,color:C.gray700,lineHeight:1.7,margin:"0 0 10px"}}>BBOT only reports what it can verify. When a camera angle or the quality of the footage doesn't support a measurement, the report states that plainly instead of guessing.</p>
        <p style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:13,color:C.gray700,lineHeight:1.7,margin:"0 0 10px"}}>Every measured mark is shown against a documented age reference, and every mark shows the receipt it stands on — the device that read it, or the operator, timer and distance behind a hand-timed entry.</p>
        <p style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:13,color:C.gray700,lineHeight:1.7,margin:0}}>Evaluations are tested against hand-verified footage before the system is trusted with a player's report. Nothing publishes without human review.</p>
      </div>

      {/* EXPOSURE — legally adjacent */}
      <div style={{marginBottom:28}}>
        <div style={{padding:"16px 18px",background:C.coralFaint,borderRadius:12,borderLeft:"4px solid "+C.coral}}>
          <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:11,color:C.coral,letterSpacing:1.5,marginBottom:8,fontWeight:700}}>EXPOSURE</div>
          <p style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:13,color:C.gray700,lineHeight:1.7,margin:0}}>Upperclassmen (16U+) whose measured marks stand out against the age reference are flagged in BBOT's standouts feed. That record is available for review by coaches and scouts who follow the platform. Standout status is earned by where you measure — not by who you know. BBOT reports measurements, not outcomes. Measured marks reflect one session's captures; they are not projections, guarantees, or recruiting advice.</p>
        </div>
      </div>

      {/* HOW IT WORKS — streamlined 4 steps */}
      <div style={{marginBottom:28}}>
        <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:11,color:C.gray400,letterSpacing:1.5,marginBottom:14}}>HOW BBOT WORKS</div>
        <div style={{display:"flex",flexDirection:"column",gap:10}}>
          {[
            ["1","Sign up","Email + password. New accounts are quickly reviewed by 643 before full access — you'll get a welcome email once approved."],
            ["2","Add a session","Drag and drop a clip, choose from your camera roll, or capture live. One clip per session."],
            ["3","Pay to unlock","Secure payment via ATH Móvil. BBOT generates your evaluation as soon as payment clears."],
            ["4","643 reviews, then it's live","Every evaluation is reviewed and approved by 643 staff before it's released to your profile — measured results shown against the reference for your age group, scouting observations on the rest, charts, and confirmed measurements. Each mark and observation is tied to what the video shows."],
          ].map(function(item){return(
            <div key={item[0]} style={{display:"flex",gap:14,alignItems:"flex-start",padding:"12px 14px",background:C.blueFaint,borderRadius:10,borderLeft:"3px solid "+C.blue}}>
              <div style={{minWidth:24,fontFamily:"Inter,system-ui,sans-serif",fontSize:18,color:C.coral,fontWeight:700}}>{item[0]}</div>
              <div>
                <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:12,color:C.navy,letterSpacing:.5,marginBottom:4}}>{item[1]}</div>
                <p style={{fontSize:12,color:C.gray500,margin:0,lineHeight:1.65}}>{item[2]}</p>
              </div>
            </div>
          );})}
        </div>
      </div>

      {/* HOW CLIPS ARE PRODUCED — the two video paths + admin gate */}
      <div style={{marginBottom:28}}>
        <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:11,color:C.gray400,letterSpacing:1.5,marginBottom:14}}>HOW VIDEO CLIPS ARE PRODUCED</div>
        <p style={{fontSize:12,color:C.gray600,lineHeight:1.65,marginTop:0,marginBottom:14}}>Every clip on the platform is reviewed and approved by 643 before a player can see it — BBOT never publishes on its own. Clips come from two sources, and each is labeled so you always know what you're looking at:</p>
        <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(min(240px,100%),1fr))",gap:12}}>
          <div style={{padding:"14px 16px",background:C.blueFaint,borderRadius:10,borderLeft:"3px solid "+C.blue}}>
            <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:12,color:C.navy,letterSpacing:.5,marginBottom:6}}>643-FILMED SESSIONS</div>
            <p style={{fontSize:12,color:C.gray600,margin:0,lineHeight:1.6}}>Captured by 643 staff and carrying the full 643 production mark.</p>
          </div>
          <div style={{padding:"14px 16px",background:C.gray50,borderRadius:10,borderLeft:"3px solid "+C.coral}}>
            <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:12,color:C.navy,letterSpacing:.5,marginBottom:6}}>PLAYER-SUBMITTED VIDEO</div>
            <p style={{fontSize:12,color:C.gray600,margin:0,lineHeight:1.6}}>Clearly marked <strong>"player-submitted"</strong> — uploaded by the player, cleaned and stamped with the BBOT evaluation at the same production standard. 643 didn't film the footage; the label keeps the source honest.</p>
          </div>
        </div>
      </div>

      {/* WHAT YOU GET — feature grid */}
      <div style={{marginBottom:28}}>
        <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:11,color:C.gray400,letterSpacing:1.5,marginBottom:14}}>WHAT YOU GET</div>
        <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(min(180px,100%),1fr))",gap:10}}>
          {[
            ["Measured Marks vs Age Reference","Every measured tool shown against a documented age reference, source-labeled with the receipt it stands on. Peer percentile rankings are not active, and no peer group stands behind any number on a BBOT report."],
            ["Confirmed Measurements","Exit velo, throw velo, pop time, run times — shown only when read from a device or timer in the footage. Never estimated."],
            ["Verified Repetitions","Every repetition verified to the player at its own moment, with the shape of his movement across the session — relative only, no units claimed — plus a tracked-motion skeleton clip, shown only where the rep tracked cleanly."],
            ["Branded Video Clips","Stamped clips with logos, player info, and a QR to the profile. Every clip is admin-approved before it goes live."],
            ["Progression Timeline","Scores tracked across every session — a record of measured progress over time."],
            ["Honest Confidence","When the video lacks the data for a measurement, BBOT says so instead of guessing."],
            ["Video-Verified Only","Scores come from observable actions and confirmed readings — nothing inflated, nothing invented."],
          ].map(function(f){return(
            <div key={f[0]} style={{padding:"10px 12px",background:C.white,border:"1px solid "+C.border,borderRadius:8}}>
              <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:11,color:C.coral,letterSpacing:.8,marginBottom:4}}>{f[0].toUpperCase()}</div>
              <p style={{fontSize:11,color:C.gray600,margin:0,lineHeight:1.5}}>{f[1]}</p>
            </div>
          );})}
        </div>
      </div>

      {/* SERVICES — admin badge sees prices; public sees service names only */}
      <div style={{marginBottom:28}}>
        <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:11,color:C.gray400,letterSpacing:1.5,marginBottom:14}}>{adminBadge?"SERVICES + PRICING":"SERVICES"}</div>
        <div style={{marginBottom:10}}>
          <div style={{fontSize:10,color:C.blue,fontWeight:700,letterSpacing:1,marginBottom:6}}>643-FILMED SESSIONS</div>
          <p style={{fontSize:11,color:C.gray500,margin:"0 0 0 4px",lineHeight:1.5}}>643-filmed events are arranged per event — contact 643 for details. Every player evaluation from a filmed session is the same {BBOT_PRICE_LABEL} individual product.</p>
        </div>
        <div style={{marginBottom:10}}>
          <div style={{fontSize:10,color:C.coral,fontWeight:700,letterSpacing:1,marginBottom:6}}>PLAYER-SUBMITTED VIDEO</div>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"10px 14px",background:C.gray50,borderRadius:10,borderLeft:"3px solid "+C.coral,gap:8,flexWrap:"wrap"}}>
            <div>
              <span style={{fontSize:12,color:C.navy,fontWeight:600}}>Individual Report</span>
              <span style={{fontSize:11,color:C.gray400,marginLeft:8}}>1 player</span>
            </div>
            <span style={{fontSize:12,fontWeight:700,color:C.blue}}>{BBOT_PRICE_LABEL}</span>
          </div>
          {!adminBadge&&<p style={{fontSize:11,color:C.gray500,margin:"6px 0 0 4px",lineHeight:1.5}}>Contact 643 to get started.</p>}
        </div>
        <div>
          <div style={{fontSize:10,color:C.gray500,fontWeight:700,letterSpacing:1,marginBottom:6}}>CUMULATIVE REPORT</div>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"10px 14px",background:C.gray50,borderRadius:10,borderLeft:"3px solid "+C.navyMid,gap:8,flexWrap:"wrap"}}>
            <div>
              <span style={{fontSize:12,color:C.navy,fontWeight:600}}>Cumulative Player Report</span>
              <span style={{fontSize:11,color:C.gray400,marginLeft:8}}>Historical · 2+ sessions required</span>
            </div>
            <span style={{fontSize:12,fontWeight:700,color:C.blue}}>{BBOT_PRICE_LABEL}</span>
          </div>
          <p style={{fontSize:11,color:C.gray500,margin:"6px 0 0 4px",lineHeight:1.5}}>Compiles existing approved sessions into one historical report — not a new session evaluation. Includes a stamped highlight clip from prior sessions, published to the player's profile.</p>
        </div>
      </div>

      {/* FOR PLAYERS / FOR COACHES — terse */}
      <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(min(220px,100%),1fr))",gap:12,marginBottom:28}}>
        <Card style={{borderTop:"3px solid "+C.coral,padding:14}}>
          <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:12,color:C.navy,letterSpacing:1,marginBottom:6}}>FOR PLAYERS</div>
          <p style={{fontSize:12,color:C.gray500,lineHeight:1.6,margin:0}}>Build an objective profile. Document your progression across sessions. Share your evaluations with coaches.</p>
        </Card>
        <Card style={{borderTop:"3px solid "+C.blue,padding:14}}>
          <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:12,color:C.navy,letterSpacing:1,marginBottom:6}}>FOR COACHES</div>
          <p style={{fontSize:12,color:C.gray500,lineHeight:1.6,margin:0}}>Coach-facing search and comparison tools (admin-gated while the reference set matures).</p>
        </Card>
      </div>

      {/* WHY */}
      <div style={{background:"linear-gradient(135deg,"+C.navy+","+C.navyMid+")",borderRadius:14,padding:"20px 18px",textAlign:"center",marginBottom:20}}>
        <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:14,color:C.white,letterSpacing:1.5,marginBottom:8}}>WHY BBOT</div>
        <p style={{fontSize:12,color:"rgba(255,255,255,.75)",lineHeight:1.7,maxWidth:480,margin:"0 auto 14px"}}>On-demand, video-based measurement. Measured marks shown against a documented age reference. The receipt behind every mark disclosed, and the cause stated wherever a measurement was not possible.</p>
        <a href="mailto:643sportsmgmt@gmail.com" style={{display:"inline-block",background:C.coral,color:C.white,fontFamily:"Inter,system-ui,sans-serif",fontSize:12,letterSpacing:1,padding:"9px 22px",borderRadius:8,textDecoration:"none"}}>GET IN TOUCH</a>
      </div>

      {/* THE TEAM — with 643 logo */}
      <div style={{marginBottom:24}}>
        <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:11,color:C.gray400,letterSpacing:1.5,marginBottom:14}}>THE TEAM</div>
        <Card style={{padding:16}}>
          <div style={{display:"flex",alignItems:"flex-start",gap:14,flexWrap:"wrap"}}>
            <img src="https://res.cloudinary.com/dvygobe1c/image/upload/f_auto,q_auto/305040979_506329628164485_996947483529414201_n_xyqwfk" alt="BBOT" style={{height:64,width:64,objectFit:"contain",flexShrink:0,borderRadius:8}}/>
            <div style={{flex:"1 1 240px"}}>
              <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:14,color:C.navy,letterSpacing:.5,marginBottom:6}}>643 SPORTS MGMT LLC</div>
              <p style={{fontSize:12,color:C.gray600,lineHeight:1.7,margin:0}}>
                Puerto Rico-based sports management firm. 643 Sports has advised, represented, and placed local baseball players and student-athletes at the professional and collegiate levels in the United States, while operating baseball programs for ages 5–18.
              </p>
              <p style={{fontSize:11,color:C.gray500,margin:"8px 0 0 0",letterSpacing:.3}}>Guaynabo, Puerto Rico</p>
            </div>
          </div>
        </Card>
      </div>

      {/* TRANSPARENCY LINKS */}
      <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(min(140px,100%),1fr))",gap:8,marginBottom:20}}>
        <button onClick={function(){go("methodology");}} style={{padding:"11px 14px",background:C.white,border:"1px solid "+C.border,borderRadius:10,fontFamily:"Inter,system-ui,sans-serif",fontSize:11,color:C.navy,letterSpacing:.5,cursor:"pointer",textAlign:"left",lineHeight:1.3}}>
          <div style={{color:C.coral,fontSize:9,marginBottom:2}}>READ</div>
          <div>Methodology</div>
        </button>
        <button onClick={function(){go("privacy");}} style={{padding:"11px 14px",background:C.white,border:"1px solid "+C.border,borderRadius:10,fontFamily:"Inter,system-ui,sans-serif",fontSize:11,color:C.navy,letterSpacing:.5,cursor:"pointer",textAlign:"left",lineHeight:1.3}}>
          <div style={{color:C.coral,fontSize:9,marginBottom:2}}>READ</div>
          <div>Privacy & Data</div>
        </button>
        <button onClick={function(){go("sample-report");}} style={{padding:"11px 14px",background:C.white,border:"1px solid "+C.border,borderRadius:10,fontFamily:"Inter,system-ui,sans-serif",fontSize:11,color:C.navy,letterSpacing:.5,cursor:"pointer",textAlign:"left",lineHeight:1.3}}>
          <div style={{color:C.coral,fontSize:9,marginBottom:2}}>VIEW</div>
          <div>Sample Report</div>
        </button>
        <button onClick={function(){go("terms");}} style={{padding:"11px 14px",background:C.white,border:"1px solid "+C.border,borderRadius:10,fontFamily:"Inter,system-ui,sans-serif",fontSize:11,color:C.navy,letterSpacing:.5,cursor:"pointer",textAlign:"left",lineHeight:1.3}}>
          <div style={{color:C.coral,fontSize:9,marginBottom:2}}>READ</div>
          <div>Terms of Use</div>
        </button>
      </div>

      <div style={{textAlign:"center"}}>
        <div style={{fontSize:10,color:C.gray400,letterSpacing:1}}>POWERED BY 643 SPORTS MGMT LLC · GUAYNABO, PR</div>
      </div>

    </div>
  );
}

// Default FAQ content. Lives in code so the page works the day it's deployed; admin
// edits override these via siteContent.faq in bbot_site_content. Two categories so
// players see player-relevant Qs and coaches see coach-relevant Qs without clutter.
var DEFAULT_FAQ = {
  players: [
    {q: "What is BBOT?", a: "BBOT is the measurement standard behind 643 Sports MGMT. It turns a filmed session into a report a coach can act on: measured results on the tools the session captured (exit velo, throw velo, run times), scouting observations on mechanics and actions BBOT can describe but not score, plus device-verified measurements. Every evaluation is reviewed and approved by 643 staff before it's released to your profile. Review confirms the report is sound — measurements are not adjusted."},
    {q: "How do I know the numbers are right?", a: "Every number comes from the session itself. If a radar reading appears on screen, BBOT reads it; if there isn't one, the report says so rather than filling the gap. Each reading is tied to the action that produced it, so a throw is never counted as a swing. When the camera angle or the footage doesn't support a measurement, the report states that plainly. Evaluations are tested against hand-verified footage before the system is trusted with a player's report, and nothing publishes without human review."},
    {q: "How do I get evaluated?", a: "Upload a session video on the Upload page. Pay the one-time fee, BBOT generates the evaluation, and 643 reviews it for accuracy. You'll see the report on your profile once it's released — typically within a day."},
    {q: "What gets a measured result vs. a scouting observation?", a: "BBOT reports a measured result only when there's an actual measured value — exit velocity on a radar, a run time on a clock, throw velocity on an overlay. Each one carries the receipt it came from and is shown against the documented reference for your age group, so you can see where the number stands. BBOT does not put a scouting grade on it. Everything else (swing mechanics, fielding actions, arm action, pitching delivery) is reported as a scouting observation: described in detail, not scored. BBOT never estimates or calculates a number the video doesn't show."},
    {q: "What does an evaluation cost?", a: "Both evaluations are " + BBOT_PRICE_LABEL + " — the Individual Session Evaluation (one session) and the Cumulative Player Report (compiles 2+ approved sessions). Two products, one price; video and stamped clips are included. 643-filmed events are arranged per event — contact 643 for details. No subscriptions, no recurring charges."},
    {q: "What kind of video should I upload?", a: "Clear footage of the player from a fixed angle. Hitting from behind home plate or first-base-line. Pitching from behind the plate or the side. Defense and 60-yard times from the side. Minimum 5 MB, max 5 GB. MP4, MOV, M4V, or WEBM."},
    {q: "Can I get a refund?", a: "Only when BBOT failed to deliver a usable evaluation due to a technical fault on our end (corrupted output, failed run that can't be re-run). Refunds are not available for dissatisfaction with your results or for partial evaluations that correctly reflect the footage."},
    {q: "How long does it take?", a: "After you pay, BBOT generates the evaluation and it goes to 643 for review. You'll usually see it on your profile within a day, often sooner."},
    {q: "Why is my account 'pending approval'?", a: "Every new signup is reviewed by admin before full access is granted. This protects the platform from spam and abuse. You'll get a welcome email when you're approved — usually within a day."},
    {q: "When can coaches contact me?", a: "Following NCAA rules, players become eligible for direct messaging on August 1 of their junior year (grad year minus 2). Coaches can follow your profile before that, but messaging is gated by date."},
    {q: "Can I delete my account?", a: "Yes — contact 643sportsmgmt@gmail.com. We'll permanently remove your profile, evaluations, clips, and login. This is irreversible."},
  ],
  coaches: [
    {q: "What does coach access let me do?", a: "Verified coaches can search the player directory, follow players, request evaluations, view their full evaluation history, and message NCAA-eligible players directly."},
    {q: "How do I get verified as a coach?", a: "Sign up as Coach / Scout and acknowledge the compliance terms. 643 reviews coach signups manually to confirm legitimate affiliation before granting access. Verification is required by NCAA agent and recruiting rules."},
    {q: "Are messages logged?", a: "Yes. All coach-player communications through BBOT are logged for compliance purposes. This protects both sides under NCAA, MLB, NIL, and state athlete-agent regulations."},
    {q: "Can I upload video of a player I scout?", a: "Yes — use the Submit page. You upload the video and tag the player; they pay for the evaluation if they choose to. You're just triggering a request, not purchasing on their behalf."},
    {q: "What is a Cumulative Player Report?", a: "When a player has 2+ approved session evaluations on file, BBOT compiles them into a single historical report showing measured progression across sessions — not a new evaluation, a longitudinal record. Includes a stamped highlight clip on the player's profile."},
    {q: "Do you charge for coach access?", a: "No. Coach accounts are free. The platform is funded by player evaluation fees."},
    {q: "Can I share a player's profile externally?", a: "Yes — each player has a public profile link they can share. Coaches and recruiters with that link can view the player's evaluations and measurements without an account."},
    {q: "Who do I contact about compliance issues?", a: "643sportsmgmt@gmail.com. We respond to compliance questions promptly and can flag/remove content if needed."},
  ]
};

function FaqPage({siteContent}){
  siteContent = siteContent || {};
  var faq = (siteContent.faq && typeof siteContent.faq === "object") ? siteContent.faq : DEFAULT_FAQ;
  var players = Array.isArray(faq.players) && faq.players.length ? faq.players : DEFAULT_FAQ.players;
  var coaches = Array.isArray(faq.coaches) && faq.coaches.length ? faq.coaches : DEFAULT_FAQ.coaches;
  var [category, setCategory] = useState("players");
  var [openIdx, setOpenIdx] = useState(-1);
  var items = category === "players" ? players : coaches;
  useEffect(function(){ setOpenIdx(-1); }, [category]);
  return(
    <div style={{maxWidth:720,margin:"0 auto",padding:"28px 16px 48px"}}>
      <div style={{textAlign:"center",marginBottom:24}}>
        <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:28,fontWeight:700,color:C.navy,letterSpacing:2,marginBottom:8}}>FREQUENTLY ASKED</div>
        <div style={{width:40,height:3,background:C.coral,borderRadius:99,margin:"0 auto 14px"}}/>
        <p style={{fontSize:14,color:C.gray500,maxWidth:480,margin:"0 auto",lineHeight:1.6}}>The most common questions about BBOT, evaluations, and how the platform works.</p>
      </div>

      <div style={{display:"flex",gap:8,justifyContent:"center",marginBottom:22,flexWrap:"wrap"}}>
        {[["players","Players"],["coaches","Coaches / Scouts"]].map(function(opt){
          var active = category === opt[0];
          return <button key={opt[0]} onClick={function(){setCategory(opt[0]);}} style={{padding:"8px 18px",borderRadius:99,border:"1px solid "+(active?C.coral:C.border),background:active?C.coral:"transparent",color:active?C.white:C.gray600,fontSize:13,fontWeight:600,cursor:"pointer"}}>{opt[1]}</button>;
        })}
      </div>

      <div style={{display:"flex",flexDirection:"column",gap:8}}>
        {items.map(function(item, i){
          var open = openIdx === i;
          return <Card key={i} style={{padding:0,overflow:"hidden"}}>
            <div onClick={function(){setOpenIdx(open ? -1 : i);}} style={{padding:"14px 18px",cursor:"pointer",display:"flex",justifyContent:"space-between",alignItems:"flex-start",gap:12}}>
              <div style={{fontSize:14,fontWeight:600,color:C.navy,lineHeight:1.4}}>{item.q}</div>
              <span style={{color:C.gray400,fontSize:14,flexShrink:0,marginTop:1}}>{open?"−":"+"}</span>
            </div>
            {open && <div style={{padding:"0 18px 14px",fontSize:13,color:C.gray600,lineHeight:1.7,borderTop:"1px solid "+C.gray100,paddingTop:12}}>{item.a}</div>}
          </Card>;
        })}
      </div>

      <div style={{marginTop:28,padding:18,background:C.gray50,borderRadius:12,textAlign:"center"}}>
        <div style={{fontSize:13,color:C.gray600,marginBottom:6}}>Didn't find your answer?</div>
        <div style={{fontSize:13,fontWeight:600,color:C.coral}}>Email 643sportsmgmt@gmail.com</div>
      </div>
    </div>
  );
}

function AddPlayerRow({players,existing,positions,label,onAdd}){
  var selState=useState(""); var sel=selState[0]; var setSel=selState[1];
  var posState=useState(positions?positions[0]:""); var pos=posState[0]; var setPos=posState[1];
  var numState=useState(""); var num=numState[0]; var setNum=numState[1];
  var available=(players||[]).filter(function(p){return !(existing||[]).includes(p.id);});
  var doAdd=function(){
    if(!sel) return;
    var player=available.find(function(p){return String(p.id)===String(sel);});
    if(!player) return;
    onAdd({playerId:player.id,name:player.firstName+" "+player.lastName,position:pos,jerseyNum:num||player.jerseyNum||""});
    setSel(""); setNum("");
  };
  return(
    <div style={{display:"flex",gap:6,alignItems:"center",flexWrap:"wrap",marginTop:10,paddingTop:10,borderTop:"1px solid #f3f4f6"}}>
      <select value={sel} onChange={function(e){setSel(e.target.value);}} style={{flex:"1 1 140px",padding:"7px 10px",borderRadius:8,border:"1px solid #e5e7eb",fontSize:12,color:sel?"#111827":"#9ca3af"}}>
        <option value="">Select player...</option>
        {available.map(function(p){return <option key={p.id} value={p.id}>{p.firstName} {p.lastName}{p.gradYear?" ("+p.gradYear+")":""}</option>;})}
      </select>
      {positions&&positions.length>1&&<select value={pos} onChange={function(e){setPos(e.target.value);}} style={{width:70,padding:"7px 8px",borderRadius:8,border:"1px solid #e5e7eb",fontSize:12}}>{positions.map(function(p){return <option key={p}>{p}</option>;})}</select>}
      <input value={num} onChange={function(e){setNum(e.target.value);}} placeholder="#" style={{width:48,padding:"7px 8px",borderRadius:8,border:"1px solid #e5e7eb",fontSize:12,textAlign:"center"}}/>
      <button onClick={doAdd} disabled={!sel} style={{padding:"7px 14px",borderRadius:8,background:sel?"#3a66c0":"#e5e7eb",color:sel?"white":"#9ca3af",border:"none",fontSize:12,fontWeight:700,cursor:sel?"pointer":"default"}}>{label||"+ Add"}</button>
    </div>
  );
}
function MyReportsView({myReports,users,scoutReports,setScoutReports,cu,notify,approveReport}){
  var reports=(scoutReports||[]).filter(function(r){return String(r.staffId)===String(cu.id);});
  return(
    <div>
      <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:12,color:C.blue,letterSpacing:1,marginBottom:10}}>MY REPORTS ({reports.length})</div>
      {reports.length===0
        ? <EmptyCard icon="bbot" title="No Reports" sub="Reports you generate will appear here"/>
        : <div style={{display:"flex",flexDirection:"column",gap:10}}>{reports.map(function(r){var p=(users||[]).find(function(u){return String(u.id)===String(r.playerId);})||{}; return <ReportCard key={r.id} r={r} sc={p} isDraft={isDraftEval(r)} isAdmin={true}/>;})}</div>
      }
    </div>
  );
}

function HighlightEmbed({ h, showControls, onApprove, onRemove, isAdmin }) {
  var ytId = h.videoUrl ? h.videoUrl.replace('https://youtu.be/','').replace('https://www.youtube.com/watch?v=','').split('&')[0].split('?v=').pop().split('?')[0] : null;
  var embedUrl = ytId ? 'https://www.youtube.com/embed/'+ytId+'?start='+Math.floor(h.startSec||0)+'&end='+Math.ceil(h.endSec||0)+'&rel=0&modestbranding=1&autoplay=0' : null;
  return (
    <div style={{background:C.white,border:"0.5px solid "+C.border,borderRadius:10,overflow:"hidden"}}>
      <div style={{height:3,background:h.approved?C.green:C.orange}}/>
      <div style={{padding:"12px 14px"}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:10,flexWrap:"wrap",gap:8}}>
          <div>
            <div style={{fontWeight:700,fontSize:14,color:C.gray900,marginBottom:4}}>{h.label||h.actionType}</div>
            <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
              <span style={{fontSize:11,background:C.blueFaint,color:C.blue,padding:"2px 8px",borderRadius:99,fontWeight:600}}>{h.actionType}</span>
              {h.metricValue&&<span style={{fontSize:11,background:C.greenLight,color:C.green,padding:"2px 8px",borderRadius:99,fontWeight:600}}>{h.metricValue}{h.metricUnit?" "+h.metricUnit:""}</span>}
              <span style={{fontSize:11,color:C.gray400}}>{h.date}</span>
              {!h.approved&&<span style={{fontSize:10,background:"#fef9c3",color:"#854d0e",padding:"2px 8px",borderRadius:99,fontWeight:600}}>Pending Approval</span>}
            </div>
          </div>
          {showControls&&isAdmin&&(
            <div style={{display:"flex",gap:8}}>
              {!h.approved&&<button onClick={function(){onApprove(h.id);}} style={{background:C.green,color:C.white,border:"none",padding:"6px 12px",borderRadius:8,fontWeight:600,fontSize:12,cursor:"pointer"}}>Approve</button>}
              <button onClick={function(){onRemove(h.id);}} style={{background:"none",border:"0.5px solid "+C.border,color:C.gray400,padding:"6px 10px",borderRadius:8,fontSize:12,cursor:"pointer"}}>Remove</button>
            </div>
          )}
        </div>
        {embedUrl ? (
          <div style={{position:"relative",paddingBottom:"56.25%",height:0,overflow:"hidden",borderRadius:8,background:C.gray900}}>
            <iframe src={embedUrl} title={h.label||"Highlight"}
              style={{position:"absolute",top:0,left:0,width:"100%",height:"100%",border:"none"}}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen={true}/>
          </div>
        ) : (
          <div style={{background:C.gray50,borderRadius:8,padding:"16px",textAlign:"center",fontSize:13,color:C.gray400}}>
            No YouTube URL on file
          </div>
        )}
        <div style={{marginTop:8,fontSize:11,color:C.gray400}}>
          {"BBOT  --  t="+Math.floor(h.startSec||0)+"s to t="+Math.ceil(h.endSec||0)+"s  --  "+h.confidence}
        </div>
      </div>
    </div>
  );
}

function ReelBuilderView({ users, cu, notify }) {
  // Reel builder: admin picks player → loads their clips → selects + orders → triggers backend compile
  var [selectedPlayerId, setSelectedPlayerId] = useState("");
  var [allClips, setAllClips] = useState([]);
  var [loading, setLoading] = useState(false);
  var [selectedClipIds, setSelectedClipIds] = useState([]);
  var [reelStatus, setReelStatus] = useState(""); // "" | "compiling" | "done" | "error"
  var [reelResult, setReelResult] = useState(null);
  var [pendingReels, setPendingReels] = useState([]);
  var [reviewUrls, setReviewUrls] = useState({}); // reelId -> signed preview URL

  function loadPending(){
    sbSelect("bbot_reels","?status=eq.pending_review&order=id.desc&limit=50")
      .then(function(rows){ setPendingReels(Array.isArray(rows)?rows:[]); })
      .catch(function(){ setPendingReels([]); });
  }
  useEffect(loadPending, []);

  function previewReel(reel){
    // Fetch a signed URL to watch the reel before approving.
    fetch(BACKEND_URL+"/r2-read-url",{
      method:"POST", headers:{"Content-Type":"application/json"},
      body: JSON.stringify({objectKey: reel.reel_object_key})
    }).then(function(r){return r.json();}).then(function(d){
      if(d&&d.url) setReviewUrls(function(prev){var n=Object.assign({},prev); n[reel.id]=d.url; return n;});
    }).catch(function(){ notify("Could not load reel preview","error"); });
  }

  function approveReel(reel, approved){
    fetch(BACKEND_URL+"/approve-reel",{
      method:"POST", headers:bbotAdminHeaders(),
      body: JSON.stringify({reelId: reel.id, approved: approved})
    }).then(function(r){return r.json();}).then(function(){
      if(approved){
        // On approval, wire the reel onto the player's cumulative evaluation (QR + visible).
        var signed = reviewUrls[reel.id];
        if(signed){
          reportPatch({match:{player_id:String(reel.player_id),report_type:"player_eval"}}, {reel_url: signed}).catch(function(){});
        }
        notify("Reel approved and published");
      } else {
        notify("Reel rejected");
      }
      loadPending();
    }).catch(function(){ notify("Reel action failed","error"); });
  }

  var players = (users||[]).filter(function(u){return u.type==="player";});

  useEffect(function(){
    if(!selectedPlayerId) { setAllClips([]); setSelectedClipIds([]); return; }
    setLoading(true);
    sbSelect("bbot_clips","?player_id=eq."+encodeURIComponent(selectedPlayerId)+"&status=eq.ready&order=created_at.desc&limit=100")
      .then(function(rows){ setAllClips(rows||[]); setLoading(false); })
      .catch(function(){ setAllClips([]); setLoading(false); });
  }, [selectedPlayerId]);

  function toggleClip(id){
    setSelectedClipIds(function(prev){
      if(prev.indexOf(id)>=0) return prev.filter(function(x){return x!==id;});
      return prev.concat([id]);
    });
  }
  function moveClip(idx, dir){
    setSelectedClipIds(function(prev){
      var copy = prev.slice();
      var swap = idx+dir;
      if(swap<0||swap>=copy.length) return copy;
      var t = copy[idx]; copy[idx] = copy[swap]; copy[swap] = t;
      return copy;
    });
  }
  function compileReel(){
    if(selectedClipIds.length<2) return notify("Select at least 2 clips","error");
    var player = players.filter(function(p){return String(p.id)===String(selectedPlayerId);})[0];
    if(!player) return notify("Player not found","error");
    var orderedClips = selectedClipIds.map(function(id){
      return allClips.filter(function(c){return String(c.id)===String(id);})[0];
    }).filter(Boolean);
    setReelStatus("compiling");
    fetch(BACKEND_URL+"/compile-reel", {
      method:"POST",
      headers:bbotAdminHeaders(),
      body: JSON.stringify({
        playerId: String(player.id),
        playerName: player.firstName+" "+player.lastName,
        clips: orderedClips.map(function(c){return {clipObjectKey: c.clip_object_key, durationSec: c.duration_sec};}),
        targetDurationSec: 90,
      })
    }).then(function(r){
      if(!r.ok) return r.text().then(function(t){throw new Error(t || ("HTTP "+r.status));});
      return r.json();
    }).then(function(out){
      setReelResult(out);
      setReelStatus("done");
      notify("Highlights reel compiled — review and approve to publish");
      // #12: do NOT auto-publish. The reel is saved as 'pending_review' server-side.
      // Approving it in the Pending Review queue below wires reel_url onto the
      // player's cumulative evaluation and makes it visible alongside their clips.
      loadPending();
    }).catch(function(err){
      setReelStatus("error");
      notify("Reel compile failed: "+(err.message||"unknown"),"error");
    });
  }

  var selectedClips = selectedClipIds.map(function(id){
    return allClips.filter(function(c){return String(c.id)===String(id);})[0];
  }).filter(Boolean);
  var totalDuration = selectedClips.reduce(function(a,c){return a+(c.duration_sec||0);}, 0);

  return (
    <div>
      <SectionHeader>Highlights Reel Builder</SectionHeader>
      <div style={{fontSize:12,color:C.gray500,marginBottom:14}}>Select a player, pick their best clips in order, BBOT compiles into a 1–1:30 min branded reel. Included with the ${BBOT_PRICE_PLAYER_USD.toFixed(2)} Player Evaluation and linked via QR code on the report.</div>

      {pendingReels.length>0&&(
        <Card style={{marginBottom:16,border:"1px solid "+C.orange,padding:0,overflow:"hidden"}}>
          <div style={{padding:"11px 14px",background:"#fff7ed",borderBottom:"1px solid "+C.orange}}><div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:13,color:"#9a3412",letterSpacing:1}}>REELS PENDING REVIEW ({pendingReels.length})</div><div style={{fontSize:10,color:"#9a3412",marginTop:2}}>Watch each reel, then approve to publish it on the player's profile.</div></div>
          <div style={{padding:"10px 14px",display:"flex",flexDirection:"column",gap:12}}>
            {pendingReels.map(function(reel){return (
              <div key={reel.id} style={{borderBottom:"1px solid "+C.gray100,paddingBottom:12}}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:8}}>
                  <div><div style={{fontSize:13,fontWeight:700,color:C.navy}}>{reel.player_name||"Player"}</div><div style={{fontSize:10,color:C.gray400}}>{reel.clip_count||0} clips · {reel.session_date||""}</div></div>
                  {!reviewUrls[reel.id]&&<Btn v="outline" style={{fontSize:11,padding:"5px 12px"}} onClick={function(){previewReel(reel);}}>▶ Load Preview</Btn>}
                </div>
                {reviewUrls[reel.id]&&<video {...bbotVideoGuard()} src={reviewUrls[reel.id]} controls playsInline style={{width:"100%",maxHeight:240,borderRadius:8,background:"#000",marginBottom:8}}/>}
                <div style={{display:"flex",gap:8}}>
                  <Btn v="primary" style={{fontSize:12,padding:"7px 16px"}} onClick={function(){approveReel(reel,true);}}>Approve & Publish</Btn>
                  <button onClick={function(){approveReel(reel,false);}} style={{background:C.white,color:"#dc2626",border:"1px solid #dc2626",padding:"7px 16px",borderRadius:8,fontSize:12,fontWeight:600,cursor:"pointer"}}>Reject</button>
                </div>
              </div>
            );})}
          </div>
        </Card>
      )}

      <Card style={{marginBottom:14}}>
        <label style={{fontSize:11,fontWeight:600,color:C.gray700,letterSpacing:.5,marginBottom:4,display:"block"}}>PLAYER</label>
        <SearchSelect
          value={selectedPlayerId}
          onChange={function(v){setSelectedPlayerId(v); setSelectedClipIds([]); setReelStatus(""); setReelResult(null);}}
          options={players.map(function(p){return {value:p.id, label:p.firstName+" "+p.lastName, sub:[p.position,p.jerseyNum?"#"+p.jerseyNum:null,p.hsName||p.clubName].filter(Boolean).join(" · ")};})}
          placeholder="Search roster..."
          allowCustom={false}
        />
        {selectedPlayerId && allClips.length>0 && (
          <Btn v="outline" style={{marginTop:10,width:"100%",fontSize:12}} onClick={function(){
            // Auto-pick: take clips sorted by duration desc (assume longer=more reps=better),
            // cap at 8 clips, target ~60-90s total
            var sorted = allClips.slice().sort(function(a,b){
              // Prefer clips with action_type containing "at_bat" or "fielding_play"
              var aScore = (a.action_type||"").includes("at_bat") ? 2 : (a.action_type||"").includes("fielding") ? 1.5 : 1;
              var bScore = (b.action_type||"").includes("at_bat") ? 2 : (b.action_type||"").includes("fielding") ? 1.5 : 1;
              return bScore*((b.duration_sec||0)) - aScore*((a.duration_sec||0));
            });
            var picked = [];
            var totalSec = 0;
            for(var i=0;i<sorted.length && totalSec<90 && picked.length<8;i++){
              picked.push(sorted[i].id);
              totalSec += sorted[i].duration_sec||0;
            }
            setSelectedClipIds(picked);
            notify("Auto-picked "+picked.length+" clips ("+Math.round(totalSec)+"s) — review and reorder as needed");
          }}>↑ Auto-pick Best Clips</Btn>
        )}
      </Card>

      {selectedPlayerId && (
        <div>
          {loading ? <div style={{padding:20,textAlign:"center",color:C.gray500,fontSize:12}}>Loading clips...</div> : (
            allClips.length===0 ? <EmptyCard icon="C" title="No clips" sub="This player has no ready clips. Run a master session segmentation first."/> : (
              <div style={{display:"grid",gridTemplateColumns:"1fr 320px",gap:14}}>
                <Card>
                  <div style={{fontSize:11,fontWeight:700,color:C.navy,letterSpacing:.5,marginBottom:10,textTransform:"uppercase"}}>Available Clips ({allClips.length})</div>
                  <div style={{maxHeight:480,overflow:"auto"}}>
                    {allClips.map(function(c){
                      var isSel = selectedClipIds.indexOf(c.id)>=0;
                      return <div key={c.id} onClick={function(){toggleClip(c.id);}} style={{display:"flex",alignItems:"center",gap:10,padding:"8px 10px",marginBottom:4,borderRadius:6,cursor:"pointer",background:isSel?C.blueFaint:C.gray50,border:"1px solid "+(isSel?C.blue:"transparent")}}>
                        <input type="checkbox" checked={isSel} onChange={function(){toggleClip(c.id);}} onClick={function(e){e.stopPropagation();}}/>
                        <div style={{flex:1}}>
                          <div style={{fontSize:12,fontWeight:600,color:C.navy}}>{c.action_type||"Clip"} &middot; {Math.round(c.duration_sec||0)}s</div>
                          <div style={{fontSize:10,color:C.gray500}}>{c.session_date||""} {c.session_type?" · "+c.session_type:""}</div>
                        </div>
                      </div>;
                    })}
                  </div>
                </Card>

                <Card>
                  <div style={{fontSize:11,fontWeight:700,color:C.navy,letterSpacing:.5,marginBottom:10,textTransform:"uppercase"}}>Reel Order ({selectedClipIds.length})</div>
                  {selectedClips.length===0 ? <div style={{fontSize:11,color:C.gray400,fontStyle:"italic",padding:10}}>Select clips from the left to build the reel.</div> : (
                    <div>
                      {selectedClips.map(function(c, i){
                        return <div key={c.id} style={{display:"flex",alignItems:"center",gap:6,padding:"6px 8px",marginBottom:4,background:C.gray50,borderRadius:6}}>
                          <div style={{fontSize:10,fontWeight:700,color:C.gray500,minWidth:18}}>{i+1}.</div>
                          <div style={{flex:1,fontSize:11,color:C.navy,fontWeight:600}}>{c.action_type||"Clip"} &middot; {Math.round(c.duration_sec||0)}s</div>
                          <button onClick={function(){moveClip(i,-1);}} disabled={i===0} style={{background:"none",border:"none",color:C.gray500,cursor:i===0?"default":"pointer",padding:2,fontSize:12,opacity:i===0?0.3:1}}>▲</button>
                          <button onClick={function(){moveClip(i,1);}} disabled={i===selectedClips.length-1} style={{background:"none",border:"none",color:C.gray500,cursor:i===selectedClips.length-1?"default":"pointer",padding:2,fontSize:12,opacity:i===selectedClips.length-1?0.3:1}}>▼</button>
                          <button onClick={function(){toggleClip(c.id);}} style={{background:"none",border:"none",color:C.coral,cursor:"pointer",fontSize:14,padding:2}}>×</button>
                        </div>;
                      })}
                      <div style={{fontSize:10,color:C.gray500,marginTop:8,paddingTop:8,borderTop:"1px solid "+C.gray50}}>Total: {Math.round(totalDuration)}s {totalDuration>90?"(over target 90s — will trim)":totalDuration<60?"(under target 60s — consider adding more)":"(in target range)"}</div>
                      <Btn v="primary" full style={{marginTop:10,fontSize:12}} onClick={compileReel} disabled={reelStatus==="compiling"}>{reelStatus==="compiling"?"Compiling...":"Compile Reel"}</Btn>
                    </div>
                  )}
                  {reelStatus==="done" && reelResult && (
                    <div style={{marginTop:14,padding:10,background:"#dcfce7",borderRadius:6,fontSize:11,color:"#166534"}}>
                      <strong>✓ Reel ready</strong>
                      {reelResult.reelUrl && <div style={{marginTop:6}}><a href={reelResult.reelUrl} target="_blank" rel="noreferrer" style={{color:"#166534",fontWeight:600}}>Open Reel →</a></div>}
                    </div>
                  )}
                </Card>
              </div>
            )
          )}
        </div>
      )}
    </div>
  );
}

// Reusable branded player-card PNG (SAME card as the report "Share Card"): photo + verified-measurement
// chips + QR to the profile. Draws in-browser (no server cost) and downloads a PNG. Needs the player (sc)
// and the report (r). Used by the social-posts view; the report view keeps its own inline copy.
function generatePlayerCard(sc, r){
  try{
    if(!sc){ if(typeof window!=="undefined"&&window.__bbotNotify) window.__bbotNotify("No player linked to this report — can't build the card","error"); return; }
    r = r || {};
    var W=1080,H=1350,M=58;
    var canvas=document.createElement("canvas"); canvas.width=W; canvas.height=H;
    var ctx=canvas.getContext("2d");
    var BLUE="#2970b8",BLUEDK="#3a66c0",CORAL="#e8526a",PHOTO="#243e6e",WHITEC="#ffffff",MUTE="rgba(255,255,255,.84)";
    function ct(x,y,t,f,col){ ctx.font=f; ctx.fillStyle=col; ctx.textAlign="center"; ctx.fillText(t,x,y); }
    ctx.fillStyle=CORAL; ctx.fillRect(0,0,W,H);
    ctx.fillStyle=WHITEC; ctx.fillRect(18,18,W-36,H-36);
    ctx.fillStyle=BLUE; ctx.fillRect(34,34,W-68,H-68);
    var bH=196; ctx.fillStyle=BLUEDK; ctx.fillRect(34,34,W-68,bH);
    ct(W/2,150,((sc.firstName||"")+" "+(sc.lastName||"")).toUpperCase(),"bold 44px sans-serif",WHITEC);
    var idLine=[sc.position||"PLAYER", sc.gradYear?("CLASS OF "+sc.gradYear):"", (sc.hsName||sc.clubName||"")].filter(Boolean).join("  ·  ").toUpperCase();
    ct(W/2,196,idLine,"bold 19px sans-serif",CORAL);
    var drawBody=function(){
      var ey=photoY+photoH+74;
      var ess=[["HT",sc.height||"—"],["WT",sc.weight?String(sc.weight):"—"],["B/T",(sc.bats||"?")+"/"+(sc.throws||"?")],["GPA",sc.gpa||"—"],["POS",sc.position||"—"]];
      var ew=(W-2*M)/ess.length;
      ess.forEach(function(it,i){ var cx=M+ew*i+ew/2;
        ct(cx,ey,it[0],"bold 19px sans-serif",MUTE); ct(cx,ey+38,String(it[1]),"bold 38px sans-serif",WHITEC); });
      ctx.fillStyle="rgba(255,255,255,.28)"; ctx.fillRect(M,ey+62,W-2*M,2);
      var dy=ey+108; var summary=(r.summary||"").trim();
      if(summary){ ctx.font="20px sans-serif"; var words=summary.split(/\s+/),line="",lines=[];
        for(var wi=0;wi<words.length;wi++){ var tst=line?line+" "+words[wi]:words[wi];
          if(ctx.measureText(tst).width>W-2*M-40){ lines.push(line); line=words[wi]; if(lines.length===3)break; } else line=tst; }
        if(lines.length<3&&line) lines.push(line);
        lines.slice(0,3).forEach(function(ln,i){ ct(W/2,dy+i*30,ln,"20px sans-serif",WHITEC); });
        dy+=Math.min(lines.length,3)*30; }
      var chips=(r.summaryChips||[]).filter(function(c){return c&&c.value!=null&&String(c.value).trim()!=="";}).slice(0,3);
      var ty=dy+22;
      if(chips.length){
        ct(W/2,ty,"VERIFIED MEASUREMENTS","bold 19px sans-serif",MUTE);
        var cw=(W-2*M)/chips.length, cyy=ty+36;
        chips.forEach(function(c,i){ var x0=M+cw*i;
          if(ctx.roundRect){ ctx.beginPath(); ctx.roundRect(x0,cyy,cw-14,108,14); ctx.fillStyle=BLUEDK; ctx.fill(); }
          else { ctx.fillStyle=BLUEDK; ctx.fillRect(x0,cyy,cw-14,108); }
          ct(x0+(cw-14)/2,cyy+62,String(c.value),"bold 40px sans-serif",CORAL);
          ct(x0+(cw-14)/2,cyy+92,String(c.label||"").toUpperCase(),"bold 17px sans-serif",WHITEC); });
        var footY=cyy+108+50;
      } else {
        ct(W/2,ty+30,"Scouting observations — scan for the full report","22px sans-serif",WHITEC);
        var footY=ty+90;
      }
      ct(W/2,footY,"643SPORTSMGMT.COM  ·  SCAN FOR FULL PROFILE","bold 18px sans-serif",MUTE);
      var qs=120, qx=W/2-qs/2, qy=footY+40;
      var doExport=function(){
        canvas.toBlob(function(blob){ var url=URL.createObjectURL(blob); var a=document.createElement("a");
          a.href=url; a.download=(((sc.firstName||"player")+"_"+(sc.lastName||"")).toLowerCase()+"_bbot_card.png").replace(/\s+/g,"_"); a.click();
          setTimeout(function(){URL.revokeObjectURL(url);},1000);
          if(typeof window!=="undefined"&&window.__bbotNotify) window.__bbotNotify("Player card downloaded — post to Instagram!");
        },"image/png");
      };
      var profileUrl=(typeof window!=="undefined"?window.location.origin:"https://643sportsmgmt.com")+"/?p="+encodeURIComponent(String(sc.id));
      var qrImg=new Image(); qrImg.crossOrigin="anonymous";
      qrImg.onload=function(){ ctx.fillStyle="#fff"; ctx.fillRect(qx-8,qy-8,qs+16,qs+16); ctx.drawImage(qrImg,qx,qy,qs,qs); doExport(); };
      qrImg.onerror=doExport;
      qrImg.src="https://api.qrserver.com/v1/create-qr-code/?size=120x120&margin=0&data="+encodeURIComponent(profileUrl);
    };
    var ph=300, pw=420, px=(W-pw)/2, photoY=34+bH+20, photoH=ph;
    var lcx=112, lcy=34+bH/2+14, lr=44;
    var placeLogoThenBody=function(){
      if(sc.photoUrl){
        var pimg=new Image(); pimg.crossOrigin="anonymous";
        pimg.onload=function(){ var s=Math.max(pw/pimg.width,photoH/pimg.height); var dw=pimg.width*s,dh=pimg.height*s;
          ctx.save(); ctx.beginPath(); ctx.rect(px,photoY,pw,photoH); ctx.clip(); ctx.drawImage(pimg,px+(pw-dw)/2,photoY+(photoH-dh)/2,dw,dh); ctx.restore();
          ctx.fillStyle=CORAL; ctx.fillRect(px,photoY+photoH,pw,5); drawBody(); };
        pimg.onerror=function(){ ctx.fillStyle=PHOTO; ctx.fillRect(px,photoY,pw,photoH); ct(W/2,photoY+photoH/2+40,((sc.firstName||"?")[0]+(sc.lastName||"")[0]).toUpperCase(),"bold 120px sans-serif",BLUEDK); ctx.fillStyle=CORAL; ctx.fillRect(px,photoY+photoH,pw,5); drawBody(); };
        pimg.src=sc.photoUrl;
      } else {
        ctx.fillStyle=PHOTO; ctx.fillRect(px,photoY,pw,photoH);
        ct(W/2,photoY+photoH/2+40,((sc.firstName||"?")[0]+(sc.lastName||"")[0]).toUpperCase(),"bold 120px sans-serif",BLUEDK);
        ctx.fillStyle=CORAL; ctx.fillRect(px,photoY+photoH,pw,5); drawBody();
      }
    };
    var logo=new Image(); logo.crossOrigin="anonymous";
    logo.onload=function(){ var d2=lr*2; ctx.drawImage(logo,lcx-lr,lcy-lr,d2,d2); ct(lcx,lcy+lr+22,"BBOT","bold 16px sans-serif",WHITEC); placeLogoThenBody(); };
    logo.onerror=function(){
      ctx.strokeStyle=WHITEC; ctx.lineWidth=Math.max(3,lr*0.10); ctx.beginPath(); ctx.arc(lcx,lcy,lr,0,7); ctx.stroke();
      ctx.strokeStyle=CORAL; ctx.lineWidth=Math.max(3,lr*0.075);
      ctx.beginPath(); ctx.moveTo(lcx,lcy-lr*0.95); ctx.lineTo(lcx,lcy-lr*0.62); ctx.moveTo(lcx,lcy+lr*0.62); ctx.lineTo(lcx,lcy+lr*0.95);
      ctx.moveTo(lcx-lr*0.95,lcy); ctx.lineTo(lcx-lr*0.62,lcy); ctx.moveTo(lcx+lr*0.62,lcy); ctx.lineTo(lcx+lr*0.95,lcy); ctx.stroke();
      ctx.beginPath(); ctx.arc(lcx,lcy,lr*0.30,0,7); ctx.stroke();
      ctx.fillStyle=CORAL; ctx.beginPath(); ctx.arc(lcx,lcy,lr*0.12,0,7); ctx.fill();
      ct(lcx,lcy+lr+22,"BBOT","bold 16px sans-serif",WHITEC); placeLogoThenBody();
    };
    logo.src=(typeof LOGO_BBOT==="string"?LOGO_BBOT:"").replace("/upload/","/upload/w_300,h_300,c_fit/");
  }catch(e){ if(typeof window!=="undefined"&&window.__bbotNotify) window.__bbotNotify("Card generation failed","error"); }
}

function SocialPostsView({ scoutReports, setScoutReports, users, cu, notify }) {
  var [filterPlayer, setFilterPlayer] = useState("");
  var [editId, setEditId] = useState(null);
  var [draftCaption, setDraftCaption] = useState("");

  // Standout posts = reports BBOT flagged isStandout. status lives on standout.status.
  // Dedupe by report id so the same report can't appear twice.
  var _seenPost={};
  var posts = (scoutReports||[]).filter(function(r){
    var s = r.standout || (r.fullReport && r.fullReport.standout);
    if(!(s && s.isStandout)) return false;
    var key=String(r.id);
    if(_seenPost[key]) return false;
    _seenPost[key]=true;
    return true;
  }).map(function(r){
    var s = r.standout || (r.fullReport && r.fullReport.standout) || {};
    return { r:r, s:s, status:(s.status||"pending") };
  });

  var playerOf=function(r){ return (users||[]).find(function(u){return String(u.id)===String(r.playerId);}); };
  var playerName=function(r){ var u=playerOf(r); return u?(u.firstName+" "+u.lastName):(r.playerId?("Player "+r.playerId):"Unknown"); };

  // Persist updated standout object into the report's full_report + local state.
  var saveStandout=function(report, newStandout){
    setScoutReports(function(prev){ return prev.map(function(x){
      if(String(x.id)!==String(report.id)) return x;
      var merged = Object.assign({}, x, {standout:newStandout});
      merged.fullReport = Object.assign({}, x.fullReport||{}, {standout:newStandout});
      return merged;
    }); });
    try {
      var full = Object.assign({}, report.fullReport||report, {standout:newStandout});
      reportPatch(Number(report.id), { full_report: full }).catch(function(){});
    } catch(_){}
  };

  var approve=function(p){
    var ns = Object.assign({}, p.s, {status:"approved", approvedAt:new Date().toISOString(), approvedBy:(cu&&cu.id)||null});
    saveStandout(p.r, ns);
    notify("Social post approved — ready to download & post");
  };
  var reject=function(p){
    var ns = Object.assign({}, p.s, {status:"rejected"});
    saveStandout(p.r, ns);
    notify("Social post rejected");  };
  var deletePost=function(p){
    if(!window.confirm("Delete this social post? It will be removed from the queue.")) return;
    var ns = Object.assign({}, p.s, {isStandout:false, status:"deleted"});
    saveStandout(p.r, ns);
    notify("Social post deleted");
  };
  var saveCaption=function(p){
    var ns = Object.assign({}, p.s, {caption:draftCaption});
    saveStandout(p.r, ns);
    setEditId(null);
    notify("Caption updated");
  };
  var copyCaption=function(p){
    var text = buildPostText(p);
    if(typeof navigator!=="undefined" && navigator.clipboard){ navigator.clipboard.writeText(text).then(function(){notify("Post text copied");}); }
    else notify("Copy not available","error");
  };
  var postToFacebook=function(p){
    var msg = buildPostText(p);
    notify("Posting to Facebook…");
    fetch(BACKEND_URL+"/post-to-facebook",{method:"POST",headers:bbotAdminHeaders(),body:JSON.stringify({message:msg, reportId:p.r.id})})
      .then(function(r){return r.json();})
      .then(function(d){
        if(d&&d.ok){ notify("Posted to Facebook ✓"); }
        else if(d&&d.error==="facebook_not_configured"){ notify("Facebook isn't connected yet. Add the page token on the backend to enable one-tap posting.","error"); }
        else { notify(errText(d&&d.detail,"Facebook post failed"),"error"); }
      }).catch(function(e){ notify("Facebook post failed: "+(e.message||"unknown"),"error"); });
  };

  // MANUAL ADD: BBOT only auto-flags standouts, so the queue can be empty even with good reports. Let the
  // admin add ANY approved report to the social queue (flag it as a standout post), then draft its caption.
  var [addPick, setAddPick] = useState("");
  var alreadyPosted = {}; posts.forEach(function(p){ alreadyPosted[String(p.r.id)] = true; });
  var addable = (scoutReports||[]).filter(function(r){
    var st = (r.status||"").toLowerCase();
    return (st==="approved" || st==="ready") && !alreadyPosted[String(r.id)];
  });
  var addToQueue=function(rid){
    var r = (scoutReports||[]).find(function(x){return String(x.id)===String(rid);}); if(!r) return;
    var s = (r.standout || (r.fullReport&&r.fullReport.standout)) || {};
    var ns = Object.assign({}, s, {isStandout:true, status:"pending", reason:(s.reason||"Added to social by admin"), caption:(s.caption||"")});
    saveStandout(r, ns); setAddPick("");
    notify("Added to social queue — edit the caption, then approve");
  };

  var filtered=function(list){ if(!filterPlayer) return list; return list.filter(function(p){return playerName(p.r).toLowerCase().includes(filterPlayer.toLowerCase());}); };
  var pending = filtered(posts.filter(function(p){return p.status==="pending";}));
  var approved = filtered(posts.filter(function(p){return isApprovedPost(p);}));

  var hashtagStr=function(s){
    var tags=(s.hashtags||[]).map(function(h){return String(h).replace(/^#/,"");});
    // Every BBOT social post carries the BBOT + 643Baseball tags (BBOT first), even if the eval omitted them.
    ["643Baseball","BBOT"].forEach(function(t){ if(!tags.some(function(x){return x.toLowerCase()===t.toLowerCase();})) tags.unshift(t); });
    return tags.map(function(h){return "#"+h;}).join(" ");
  };

  // BLOCK 5(4): assemble the social post on the locked formula —
  // measured fact (caption) + percentile (gated on Phase-C data; dormant-safe) + stamped clip link + profile link.
  var ord=function(n){ var s=["th","st","nd","rd"], v=n%100; return n+(s[(v-20)%10]||s[v]||s[0]); };
  var profileLink=function(r){ var o=(typeof window!=="undefined")?window.location.origin:"https://643sportsmgmt.com"; return o+"/?p="+encodeURIComponent(String(r.playerId||"")); };
  var clipLink=function(r){ return r.reelUrl || (r.fullReport&&r.fullReport.reelUrl) || r.videoUrl || r.video_url || ""; };
  // Percentile shows ONLY when the report carries Phase-C percentile data — which happens only when the
  // backend BBOT_PERCENTILE_MODE flag is on. Omits cleanly (empty) otherwise — never implies a live feature.
  var topPercentileLine=function(r){
    var pc=r.percentiles || (r.fullReport&&r.fullReport.percentiles) || (r.full_report&&r.full_report.percentiles);
    if(!pc || !pc.metrics) return "";
    var best=null;
    Object.keys(pc.metrics).forEach(function(k){ var mv=pc.metrics[k];
      if(mv && mv.percentile!=null && (best==null || Number(mv.percentile)>Number(best.percentile))) best={pct:Number(mv.percentile), label:mv.label||k}; });
    return best ? (best.label+" — "+ord(Math.round(best.pct))+" percentile vs same-age peers") : "";
  };
  var buildPostText=function(p){
    var r=p.r, parts=[];
    if(p.s.caption) parts.push(p.s.caption);              // measured fact
    var pl=topPercentileLine(r); if(pl) parts.push(pl);   // percentile (gated, dormant-safe)
    var cl=clipLink(r); if(cl) parts.push("Clip: "+cl);   // stamped clip link
    parts.push("Profile: "+profileLink(r));               // profile link
    var tags=hashtagStr(p.s);
    return parts.join("\n\n") + (tags?("\n\n"+tags):"");
  };
  // Spanish version: scaffolding (percentile line, clip/profile labels) translated; uses an eval-provided
  // Spanish caption (captionES) when present, else the drafted caption for the admin to localize.
  var topPercentileLineES=function(r){
    var pc=r.percentiles || (r.fullReport&&r.fullReport.percentiles) || (r.full_report&&r.full_report.percentiles);
    if(!pc || !pc.metrics) return "";
    var best=null;
    Object.keys(pc.metrics).forEach(function(k){ var mv=pc.metrics[k];
      if(mv && mv.percentile!=null && (best==null || Number(mv.percentile)>Number(best.percentile))) best={pct:Number(mv.percentile), label:mv.label||k}; });
    return best ? (best.label+" — percentil "+ord(Math.round(best.pct))+" vs. pares de su misma edad") : "";
  };
  var buildPostTextES=function(p){
    var r=p.r, parts=[];
    var cap=p.s.captionES || p.s.caption_es || p.s.caption;
    if(cap) parts.push(cap);
    var pl=topPercentileLineES(r); if(pl) parts.push(pl);
    var cl=clipLink(r); if(cl) parts.push("Video: "+cl);
    parts.push("Perfil: "+profileLink(r));
    var tags=hashtagStr(p.s);
    return parts.join("\n\n") + (tags?("\n\n"+tags):"");
  };

  var postCard=function(p, isApproved){
    var editing = String(editId)===String(p.r.id);
    return (
      <Card key={p.r.id} style={{padding:0,overflow:"hidden"}}>
        <div style={{height:3,background:isApproved?C.green:C.orange}}/>
        <div style={{padding:14}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:6}}>
            <div style={{fontSize:13,fontWeight:700,color:C.blue}}>{playerName(p.r)}</div>
            <div style={{fontSize:10,color:C.gray400}}>{p.r.date||""} · {p.r.sessionType||"Session"}</div>
          </div>
          {p.s.reason && <div style={{fontSize:11,color:C.gray500,fontStyle:"italic",marginBottom:8}}>Why standout: {p.s.reason}</div>}
          {editing ? (
            <div style={{marginBottom:8}}>
              <textarea value={draftCaption} onChange={function(e){setDraftCaption(e.target.value);}} rows="4" style={{width:"100%",padding:"8px 10px",border:"1px solid "+C.border,borderRadius:6,fontSize:12,resize:"vertical"}}/>
              <div style={{display:"flex",gap:8,marginTop:6}}>
                <Btn v="primary" style={{fontSize:12}} onClick={function(){saveCaption(p);}}>Save Caption</Btn>
                <Btn v="ghost" style={{fontSize:12}} onClick={function(){setEditId(null);}}>Cancel</Btn>
              </div>
            </div>
          ) : (
            <div style={{background:C.gray50||"#f8fafc",border:"1px solid "+C.border,borderRadius:8,padding:"10px 12px",marginBottom:8}}>
              <div style={{fontSize:12,color:C.gray600,lineHeight:1.5,whiteSpace:"pre-wrap"}}>{p.s.caption?buildPostText(p):"(no caption drafted)"}</div>
            </div>
          )}
          <div style={{display:"flex",flexWrap:"wrap",gap:8}}>
            {!editing && <button onClick={function(){setEditId(p.r.id);setDraftCaption(p.s.caption||"");}} style={{background:"transparent",color:C.gray600,border:"1px solid "+C.border,padding:"6px 12px",borderRadius:6,fontSize:11,fontWeight:600,cursor:"pointer"}}>EDIT CAPTION</button>}
            <button onClick={function(){copyCaption(p);}} style={{background:"transparent",color:C.gray600,border:"1px solid "+C.border,padding:"6px 12px",borderRadius:6,fontSize:11,fontWeight:600,cursor:"pointer"}}>COPY TEXT</button>
            <button onClick={function(){ var t=buildPostTextES(p); if(typeof navigator!=="undefined"&&navigator.clipboard){navigator.clipboard.writeText(t);} notify&&notify("Texto en español copiado ✓"); }} style={{background:"transparent",color:C.gray600,border:"1px solid "+C.border,padding:"6px 12px",borderRadius:6,fontSize:11,fontWeight:600,cursor:"pointer"}}>COPY (ES)</button>
            <button onClick={function(){ generatePlayerCard(playerOf(p.r), Object.assign({}, (p.r.fullReport||p.r.full_report||{}), p.r)); }} style={{background:"transparent",color:C.coral,border:"1px solid "+C.coral,padding:"6px 12px",borderRadius:6,fontSize:11,fontWeight:700,cursor:"pointer"}}>↓ CARD</button>
            {!isApproved
              ? <>
                  <button onClick={function(){approve(p);}} style={{background:C.green,color:C.white,border:"none",padding:"6px 12px",borderRadius:6,fontSize:11,fontWeight:700,cursor:"pointer",letterSpacing:.5}}>APPROVE</button>
                  <button onClick={function(){reject(p);}} style={{background:"transparent",color:"#b91c1c",border:"1px solid #fecaca",padding:"6px 12px",borderRadius:6,fontSize:11,fontWeight:600,cursor:"pointer"}}>REJECT</button>
                </>
              : <><span style={{alignSelf:"center",fontSize:10,fontWeight:700,color:C.green,letterSpacing:.5}}>APPROVED · READY TO POST</span><button onClick={function(){postToFacebook(p);}} style={{background:"#1877f2",color:C.white,border:"none",padding:"6px 12px",borderRadius:6,fontSize:11,fontWeight:700,cursor:"pointer",letterSpacing:.3}}>POST TO FACEBOOK</button></>}
            <button onClick={function(){deletePost(p);}} style={{background:"transparent",color:C.gray500,border:"1px solid "+C.border,padding:"6px 12px",borderRadius:6,fontSize:11,fontWeight:600,cursor:"pointer",marginLeft:"auto"}}>DELETE</button>
          </div>
        </div>
      </Card>
    );
  };

  return (
    <div>
      <div style={{marginBottom:16}}>
        <h3 style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:16,color:C.blue,letterSpacing:1,marginBottom:4}}>SOCIAL POSTS</h3>
        <p style={{fontSize:12,color:C.gray400}}>BBOT flags standout performances and drafts a social caption + player card. Review, edit, and approve before posting. Nothing is published automatically — approval just unlocks the post for you to download and share.</p>
      </div>
      <input value={filterPlayer} onChange={function(e){setFilterPlayer(e.target.value);}} placeholder="Filter by player name..." style={{width:"100%",padding:"8px 12px",borderRadius:8,border:"1px solid "+C.border,fontSize:13,marginBottom:10}}/>
      <div style={{display:"flex",gap:8,marginBottom:16,alignItems:"center"}}>
        <select value={addPick} onChange={function(e){setAddPick(e.target.value);}} style={{flex:1,padding:"8px 10px",borderRadius:8,border:"1px solid "+C.border,fontSize:13,background:C.white}}>
          <option value="">+ Add an approved report to the queue…</option>
          {addable.map(function(r){return <option key={r.id} value={r.id}>{playerName(r)} · {r.date||""} · {r.sessionType||"Session"}</option>;})}
        </select>
        <Btn v="primary" style={{fontSize:12,whiteSpace:"nowrap"}} onClick={function(){ if(addPick) addToQueue(addPick); else notify("Pick a report first","error"); }}>Add to Queue</Btn>
      </div>

      <div style={{marginBottom:24}}>
        <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:12,color:C.orange,letterSpacing:1.5,marginBottom:10,display:"flex",alignItems:"center",gap:8}}>
          PENDING APPROVAL
          <span style={{background:C.orange,color:C.white,fontSize:10,fontWeight:700,padding:"1px 7px",borderRadius:99}}>{pending.length}</span>
        </div>
        {pending.length===0
          ? <EmptyCard icon="P" title="No Standout Posts Pending" sub="When BBOT flags a standout performance, its draft post appears here for approval."/>
          : <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(320px,1fr))",gap:12}}>{pending.map(function(p){return postCard(p,false);})}</div>}
      </div>

      <div>
        <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:12,color:C.blue,letterSpacing:1.5,marginBottom:10}}>APPROVED ({approved.length})</div>
        {approved.length===0
          ? <EmptyCard icon="A" title="No Approved Posts" sub="Approved standout posts are ready to download and share."/>
          : <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(320px,1fr))",gap:12}}>{approved.map(function(p){return postCard(p,true);})}</div>}
      </div>
    </div>
  );
}

function HighlightsAdminView({ highlights, setHighlights, users, cu, notify }) {
  var [filterPlayer, setFilterPlayer] = useState("");
  var pending  = (highlights||[]).filter(function(h){ return !h.approved; });
  var approved = (highlights||[]).filter(function(h){ return h.approved; });

  // Gatekeeping checklist — admin must confirm each clip is properly prepped before it can be
  // approved/published. Keyed by clip id; all three boxes required to approve.
  var checklistS = useState({}); var checklist = checklistS[0]; var setChecklist = checklistS[1];
  var CHECK_ITEMS = [["segmented","Segmented correctly"],["cleaned","Cleaned (trimmed, right player/action)"],["stamped","Logo/watermark stamped"]];
  var clipReady = function(id){ var c = checklist[id]||{}; return CHECK_ITEMS.every(function(it){ return c[it[0]]; }); };
  var toggleCheck = function(id, key){ setChecklist(function(prev){ var c = Object.assign({}, prev[id]||{}); c[key]=!c[key]; var n=Object.assign({}, prev); n[id]=c; return n; }); };

  var approveHighlight=function(id) {
    if(!clipReady(id)){ notify("Confirm segmented + cleaned + stamped before approving this clip.","error"); return; }
    setHighlights(function(all){ return all.map(function(h){ return h.id===id?Object.assign({},h,{approved:true}):h; }); });
    notify("Highlight approved and published to player profile");
  }
  var removeHighlight=function(id) {
    setHighlights(function(all){ return all.filter(function(h){ return h.id!==id; }); });
    notify("Highlight removed");
  }
  var approveAll=function() {
    // Only approve clips that have passed the checklist; tell the admin if some were skipped.
    var ready = pending.filter(function(h){ return clipReady(h.id); });
    if(ready.length===0){ notify("Confirm segmented + cleaned + stamped on a clip before approving.","error"); return; }
    var readyIds = {}; ready.forEach(function(h){ readyIds[h.id]=true; });
    setHighlights(function(all){ return all.map(function(h){ return readyIds[h.id]?Object.assign({},h,{approved:true}):h; }); });
    var skipped = pending.length - ready.length;
    notify(ready.length+" clip"+(ready.length===1?"":"s")+" approved"+(skipped>0?" · "+skipped+" still need the prep checklist":""));
  }

  var playerName=function(h) {
    var u = (users||[]).find(function(u){ return String(u.id)===String(h.playerId); });
    return u ? u.firstName+" "+u.lastName : (h.playerJersey?"#"+h.playerJersey:"Unknown");
  }

  var filtered = function(list) {
    if (!filterPlayer) return list;
    return list.filter(function(h){ return playerName(h).toLowerCase().includes(filterPlayer.toLowerCase()); });
  };

  return (
    <div>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:16,flexWrap:"wrap",gap:12}}>
        <div>
          <h3 style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:16,color:C.blue,letterSpacing:1,marginBottom:4}}>HIGHLIGHT CLIPS</h3>
          <p style={{fontSize:12,color:C.gray400}}>BBOT-detected clips from session videos. Approve to publish to player profiles. Stored as YouTube timestamps -- zero storage cost.</p>
        </div>
        {pending.length>0&&<button onClick={approveAll} style={{background:C.green,color:C.white,border:"none",padding:"8px 16px",borderRadius:8,fontWeight:600,fontSize:13,cursor:"pointer"}}>Approve All ({pending.length})</button>}
      </div>

      <input value={filterPlayer} onChange={function(e){setFilterPlayer(e.target.value);}}
        placeholder="Filter by player name..." style={{width:"100%",padding:"8px 12px",borderRadius:8,border:"1px solid "+C.border,fontSize:13,marginBottom:16}}/>

      {pending.length>0&&(
        <div style={{marginBottom:24}}>
          <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:12,color:C.orange,letterSpacing:1.5,marginBottom:10,display:"flex",alignItems:"center",gap:8}}>
            PENDING APPROVAL
            <span style={{background:C.orange,color:C.white,fontSize:10,fontWeight:700,padding:"1px 7px",borderRadius:99}}>{filtered(pending).length}</span>
          </div>
          <div style={{display:"flex",flexDirection:"column",gap:10}}>
            {filtered(pending).map(function(h){
              var ready = clipReady(h.id);
              return (
                <div key={h.id}>
                  <div style={{fontSize:11,color:C.gray500,fontWeight:600,marginBottom:4}}>{playerName(h)}</div>
                  <HighlightEmbed h={h} showControls={true} onApprove={approveHighlight} onRemove={removeHighlight} isAdmin={true}/>
                  <div style={{marginTop:6,padding:"8px 10px",borderRadius:8,border:"1px solid "+(ready?C.border:C.coralLight),background:ready?C.gray50:C.coralFaint}}>
                    <div style={{fontSize:10,fontWeight:700,letterSpacing:.5,color:ready?C.gray600:C.coral,marginBottom:6}}>PREP CHECK BEFORE APPROVE</div>
                    <div style={{display:"flex",flexDirection:"column",gap:5}}>
                      {CHECK_ITEMS.map(function(it){
                        var on=(checklist[h.id]||{})[it[0]];
                        return <label key={it[0]} style={{display:"flex",alignItems:"center",gap:8,cursor:"pointer",fontSize:12,color:C.navy}}>
                          <span onClick={function(){toggleCheck(h.id,it[0]);}} style={{width:16,height:16,borderRadius:4,border:"1.5px solid "+(on?C.green:C.gray300),background:on?C.green:C.white,color:C.white,fontSize:11,fontWeight:700,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>{on?"✓":""}</span>
                          {it[1]}
                        </label>;
                      })}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}

      <div>
        <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:12,color:C.blue,letterSpacing:1.5,marginBottom:10}}>
          PUBLISHED  ({filtered(approved).length})
        </div>
        {filtered(approved).length===0
          ? <EmptyCard icon="H" title="No Published Highlights" sub="Approved BBOT clips will appear here and on player profiles"/>
          : <div style={{display:"flex",flexDirection:"column",gap:10}}>
              {filtered(approved).map(function(h){
                return (
                  <div key={h.id}>
                    <div style={{fontSize:11,color:C.gray500,fontWeight:600,marginBottom:4}}>{playerName(h)}</div>
                    <HighlightEmbed h={h} showControls={true} onApprove={approveHighlight} onRemove={removeHighlight} isAdmin={true}/>
                  </div>
                );
              })}
            </div>
        }
      </div>
    </div>
  );
}


function RecapsPage({ recaps, setRecaps, users, cu, notify, isStaff, scoutReports, go }) {
  var [sel, setSel] = useState(null);
  var [genning, setGenning] = useState(null); // session key being generated
  // Declared here, not inside the `if (sel)` branch: a hook called conditionally changes the
  // hook order between renders, which React treats as a different component.
  var [editingCover, setEditingCover] = useState(false);

  // Find sessions with 10+ evaluated players (group approved/published reports by date+type)
  var eligibleSessions = (function(){
    if(!isStaff) return [];
    var groups = {};
    (scoutReports||[]).filter(function(r){return (isLiveEval(r)) && (r.sections||[]).length;}).forEach(function(r){
      var key=(r.sessionDate||r.date||"unknown")+"|"+(r.sessionType||"Session");
      if(!groups[key]) groups[key]={key:key, date:r.sessionDate||r.date||"", sessionType:r.sessionType||"Session", reports:[]};
      groups[key].reports.push(r);
    });
    // already has a recap?
    var existing = {};
    (recaps||[]).forEach(function(rc){ if(rc.sessionKey) existing[rc.sessionKey]=true; });
    return Object.keys(groups).map(function(k){return groups[k];})
      .filter(function(g){return g.reports.length>=10 && !existing[g.key];});
  })();

  function generateGameReport(session){
    setGenning(session.key);
    var playerById=function(id){return (users||[]).find(function(u){return String(u.id)===String(id);});};
    var playersData = session.reports.map(function(r){
      var p=playerById(r.playerId);
      var grades={};
      (r.sections||[]).forEach(function(s){ if(s.grade!=null) grades[s.label||s.key]=s.grade; });
      // Prior sessions for this player (approved/published, excluding this one), oldest→newest
      var history=(scoutReports||[]).filter(function(h){
        return String(h.playerId)===String(r.playerId) && h.id!==r.id && (isLiveEval(h)) && (h.sections||[]).length;
      }).sort(function(a,b){return (a.sessionDate||a.date||"").localeCompare(b.sessionDate||b.date||"");})
        .slice(-5) // cap at last 5 prior sessions to control tokens
        .map(function(h){
          var g={}; (h.sections||[]).forEach(function(s){ if(s.grade!=null) g[s.label||s.key]=s.grade; });
          return {date:h.sessionDate||h.date||"", sessionType:h.sessionType||"Session", grades:g};
        });
      // SEND WHAT THE RECAP CAN ACTUALLY RANK ON. The payload carried `grades` only, and the
      // prompt ranked standouts by grade strength -- but measured 2026-10-04 across the served
      // corpus, 17 of 19 reports have ZERO surviving grades (a measured tool expresses as a
      // percentile, not a bare 20-80, and a grade with no basis is withheld before it is read).
      // So the model was handed {} and picked on prose appeal while the output read as
      // grade-driven. All 19 carry at least one MEASURED value, so that is the honest field.
      //
      // WITHHELD VALUES DO NOT TRAVEL. A value named in credibilityWithheld is one the card
      // refuses to show; sending it to the blog generator would publish through the side door
      // what the card closed. Same gate, same reason.
      var fullR = r.fullReport || {};
      var mvAll = fullR.measuredValues || {};
      var heldMv = {};
      ((fullR.credibilityWithheld||{}).withheld||[]).forEach(function(p){
        String(p||"").split(",").forEach(function(seg){
          var m = seg.trim().match(/^measuredValues\.(.+)$/); if(m) heldMv[m[1]] = true;
        });
      });
      // A READING TRAVELS AS READ; AN AVERAGE TRAVELS AT DISPLAYED PRECISION. exitVeloAvg is
      // stored full-width (51.095238095238095) and handing that to a prose model invites it
      // either onto the page or into a mismatch with its own verification pass. A peak is a
      // DEVICE READING and is never rounded; only the computed average is.
      var measured = {};
      ["exitVeloPeak","exitVeloAvg","throwVelo","pitchVeloPeak","h2f","dash60","popTime"]
        .forEach(function(k){
          if(mvAll[k]==null || heldMv[k]) return;
          var v = mvAll[k];
          measured[k] = (k==="exitVeloAvg" && typeof v==="number") ? Math.round(v*10)/10 : v;
        });
      return {playerId:String(r.playerId), playerName:p?(p.firstName+" "+p.lastName):"Player", position:p?(p.position||""):"", grades:grades, measured:measured, summary:r.summary||"", history:history};
    });
    fetch(BACKEND_URL+"/generate-game-report",{
      method:"POST", headers:bbotAdminHeaders(),
      body:JSON.stringify({sessionType:session.sessionType, sessionDate:session.date, players:playersData})
    }).then(function(resp){return resp.json();}).then(function(d){
      setGenning(null);
      if(!d || !d.draft){ notify("Could not generate report","error"); return; }
      var draft={
        id:Date.now(), sessionKey:session.key, status:"draft",
        title:d.draft.title||"Session Recap",
        summary:d.draft.intro||"",
        sessionType:session.sessionType, date:session.date,
        standouts:(d.draft.standouts||[]).map(function(s){
          return {playerId:s.playerId, playerName:s.playerName, highlight:s.synopsis};
        }),
        taggedPlayers:(d.draft.standouts||[]).map(function(s){return String(s.playerId);}).filter(Boolean),
        createdBy:"BBOT",
      };
      setRecaps(function(prev){return [draft].concat(prev||[]);});
      persistRecap(draft).catch(function(){ notify("Report drafted but not saved — check connection","error"); });
      notify("Game report drafted — review and publish");
    }).catch(function(){ setGenning(null); notify("Report generation failed","error"); });
  }

  var approveRecap=function(id) {
    var updated=null;
    setRecaps(function(all){ return all.map(function(r){ if(r.id===id){ updated=Object.assign({},r,{status:"published"}); return updated; } return r; }); });
    if(updated) persistRecap(updated).catch(function(){ notify("Published in view but not saved — check connection","error"); });
    notify("Report published!");
  }

  var deleteRecap=function(id) {
    setRecaps(function(all){ return all.filter(function(r){ return r.id!==id; }); });
    deleteRecapRow(id).catch(function(){ notify("Recap not deleted — it will return on refresh","error"); });
    notify("Report deleted");
  };

  var published = (recaps||[]).filter(function(r){ return isPublishedRecap(r); });
  var drafts    = (recaps||[]).filter(function(r){ return isDraftEval(r); });

  if (sel) {
    var r = (recaps||[]).find(function(x){ return x.id===sel; });
    if (!r) { setSel(null); return null; }
    var saveCover = function(v){
      var upd=Object.assign({},r,{coverImage:v});
      setRecaps(function(list){ return (list||[]).map(function(x){ return x.id===r.id?upd:x; }); });
      persistRecap(upd)
        .then(function(){ notify(v?"Cover image updated":"Cover image removed"); })
        .catch(function(){
          setRecaps(function(list){ return (list||[]).map(function(x){ return x.id===r.id?r:x; }); });
          notify("Could not save the cover image — not changed","error");
        });
    };
    return (
      // 680 -> 760 so the recap sits in the blog article's own column rather than a narrower one;
      // the article inside is max-width 760 and was being squeezed by its container.
      <div style={{maxWidth:760,margin:"0 auto"}}>
        <div style={{display:"flex",gap:8,flexWrap:"wrap",marginBottom:16,alignItems:"center"}}>
          <Btn v="ghost" style={{fontSize:13}} onClick={function(){setSel(null);}}>Back to Reports</Btn>
          {/* THE HEADLINE IS THE ADMIN'S, NOT THE MODEL'S. BBOT drafts a title from the session
              date and type; it is the first thing any reader sees and the only line that travels
              into a shared link, so an operator must be able to say it better. Edited in place
              and written straight back through persistRecap, which upserts by id -- the same
              writer Publish uses, so an edited title cannot diverge from a published one. */}
          {isStaff && <Btn v="ghost" style={{fontSize:13}} onClick={function(){
            var next=window.prompt("Report headline:", r.title||"");
            if(next===null) return;
            next=String(next).trim();
            if(!next){ notify("A report needs a headline","error"); return; }
            if(next===(r.title||"")) return;
            var upd=Object.assign({},r,{title:next});
            setRecaps(function(list){ return (list||[]).map(function(x){ return x.id===r.id?upd:x; }); });
            persistRecap(upd)
              .then(function(){ notify("Headline updated"); })
              .catch(function(){
                // PUT IT BACK. A headline that reads as changed but did not save is worse than a
                // refused edit -- the operator walks away believing the shared link says something
                // it does not.
                setRecaps(function(list){ return (list||[]).map(function(x){ return x.id===r.id?r:x; }); });
                notify("Could not save the headline — not changed","error");
              });
          }}>✎ Edit headline</Btn>}
          {/* THE COVER IMAGE IS ALWAYS THE ADMIN'S TO CHANGE (Luis, 2026-10-08). Written through
              persistRecap -- the same writer Publish and the headline edit use -- so a cover set
              here cannot diverge from the published row. Optimistic, then rolled back if the
              save refuses, for the same reason the headline is: an operator must never walk away
              believing a shared link shows a picture it does not. */}
          {isStaff && <Btn v="ghost" style={{fontSize:13}} onClick={function(){ setEditingCover(!editingCover); }}>
            {editingCover ? "✕ Close cover" : (r.coverImage ? "🖼 Change cover" : "🖼 Add cover")}
          </Btn>}
          {/* The admin controls stay OUTSIDE the article. A published recap should read exactly
              as a blog post does; Publish/Delete are the operator's chrome, not the post. */}
          {/* THE SHARE LINK — offered only once PUBLISHED, because the public view carries
              published rows only: a link copied from a draft opens "this report isn't published",
              which reads as a broken link rather than an unpublished one. */}
          {!isDraftEval(r) && <Btn v="ghost" style={{fontSize:13}} title="Copy the public link to this session report" onClick={function(){
            // SHARE THE PATH URL, NOT THE HASH ONE (Luis, 2026-10-08: the session title did not
            // show up when sharing). A URL FRAGMENT IS NEVER SENT TO A SERVER, so `/#recap/<id>`
            // could not tell Facebook, iMessage or LinkedIn which report was meant -- and those
            // crawlers do not run JavaScript, so the app could not tell them either. Every link
            // previewed with the site's generic title.
            //
            // `/s/recap/<id>` puts the id in the path, where the backend can see it and answer
            // with this report's real headline in the meta tags before sending a human on to
            // the same `#recap/<id>` page as before. Vercel rewrites /s/* to the backend
            // (vercel.json), so the link a person copies stays on the 643 domain.
            var url=bbotShareUrl("recap", r.id);
            try{
              if(navigator.clipboard&&navigator.clipboard.writeText) navigator.clipboard.writeText(url).then(function(){notify&&notify("Report link copied — anyone can open it");},function(){window.prompt("Copy this report link:",url);});
              else window.prompt("Copy this report link:",url);
            }catch(e){ window.prompt("Copy this report link:",url); }
          }}>🔗 Copy link</Btn>}
          {isStaff&&isDraftEval(r)&&<Btn v="primary" style={{fontSize:13}} onClick={function(){approveRecap(r.id);}}>Publish</Btn>}
          {isStaff&&<Btn v="ghost" style={{fontSize:13,color:C.gray400}} onClick={function(){deleteRecap(r.id);}}>Delete</Btn>}
          {isDraftEval(r)&&<span style={{fontSize:10,background:"#fef9c3",color:"#854d0e",padding:"2px 8px",borderRadius:99,fontWeight:600,border:"0.5px solid #fde047"}}>DRAFT</span>}
        </div>
        {isStaff && editingCover && <Card style={{padding:14,marginBottom:14}}>
          <BbotCoverImageControl label="SESSION REPORT COVER" value={r.coverImage||""} onChange={saveCover}/>
        </Card>}
        <RecapArticle r={r} users={users} scoutReports={scoutReports} cu={cu} go={go}/>
        <FlyerFooter/>
      </div>
    );
  }

  return (
    <div style={{maxWidth:760,margin:"0 auto"}}>
      <div style={{marginBottom:24}}>
        <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:4}}>
          <BbotMark size={36}/>
          <h2 style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:26,color:C.navy,letterSpacing:1,margin:0}}>SESSION REPORTS</h2>
        </div>
        <p style={{fontSize:13,color:C.gray400}}>Professional session and session reports generated by BBOT. Published recaps appear on tagged player profiles.</p>
      </div>

      {isStaff && eligibleSessions.length>0 && (
        <div style={{marginBottom:24,padding:14,border:"1px solid "+C.border,borderRadius:10,background:C.blueFaint}}>
          <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:12,color:C.navy,letterSpacing:1,marginBottom:4,fontWeight:700}}>GENERATE SESSION REPORT</div>
          <div style={{fontSize:12,color:C.gray600,marginBottom:12}}>Sessions with 10+ evaluated players. BBOT drafts a recap with standout performers for your approval.</div>
          <div style={{display:"flex",flexDirection:"column",gap:8}}>
            {eligibleSessions.map(function(s){
              return <div key={s.key} style={{display:"flex",justifyContent:"space-between",alignItems:"center",gap:10,padding:"8px 10px",background:C.white,borderRadius:8}}>
                <div><div style={{fontWeight:700,fontSize:13,color:C.navy}}>{s.sessionType} · {s.date||"undated"}</div><div style={{fontSize:11,color:C.gray500}}>{s.reports.length} players evaluated</div></div>
                <Btn v="primary" style={{fontSize:12,padding:"7px 14px"}} disabled={genning===s.key} onClick={function(){generateGameReport(s);}}>{genning===s.key?"Generating…":"Generate Report"}</Btn>
              </div>;
            })}
          </div>
        </div>
      )}

      {isStaff && drafts.length>0 && (
        <div style={{marginBottom:24}}>
          <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:12,color:C.orange,letterSpacing:1.5,marginBottom:10,display:"flex",alignItems:"center",gap:8}}>
            PENDING REVIEW <span style={{background:C.orange,color:C.white,fontSize:10,fontWeight:700,padding:"1px 7px",borderRadius:99}}>{drafts.length}</span>
          </div>
          <div style={{display:"flex",flexDirection:"column",gap:10}}>
            {drafts.map(function(r){
              return <RecapCard key={r.id} r={r} users={users} cu={cu} isStaff={isStaff} approveRecap={approveRecap} deleteRecap={deleteRecap} expanded={false} onOpen={function(){setSel(r.id);}}/>;
            })}
          </div>
        </div>
      )}

      <div>
        <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:12,color:C.blue,letterSpacing:1.5,marginBottom:10}}>PUBLISHED</div>
        {published.length===0
          ? <EmptyCard icon="bbot" title="No Session Reports Yet" sub="Published session reports appear automatically after each evaluation"/>
          : <div style={{display:"flex",flexDirection:"column",gap:10}}>
              {published.slice().reverse().map(function(r){
                return <RecapCard key={r.id} r={r} users={users} cu={cu} isStaff={isStaff} approveRecap={approveRecap} deleteRecap={deleteRecap} expanded={false} onOpen={function(){setSel(r.id);}}/>;
              })}
            </div>
        }
      </div>
    </div>
  );
}

// ════════════════════════════════════════════════════════════════════════════════════════════════
// THE RECAP ARTICLE — the session recap, FILLED INTO the blog template (Luis, 2026-10-03)
// ════════════════════════════════════════════════════════════════════════════════════════════════
// The recap rendered as a plain card while every other long-form surface on this site is the blog
// article. Same doctrine applies here as at BbotBlogArticle: "a post is FILLED IN, never
// formatted." So this does NOT invent a layout — it reuses that article's own measurements, token
// for token (760 column, 34/1.18 title at -.4 tracking, 17 dek, coral category pill, byline rule,
// 21 section heads, 16/1.8 body) and fills the recap's content into those slots. Every colour is
// from `C`, so this cannot drift off-brand any more than a blog post can.
//
// WHAT IS NEW HERE, and why it is not a style decision: the standouts grid. Luis asked for 2-3
// players per row with the key metric under each, so the choice inside that range is ours and it
// is settled by CLAUDE.md s14 -- "any video shown (skeleton overlays, clips) must be visually
// CRISP ... never blurry/pixelated." In the template's locked 760 column at gap 14:
//
//     3 across -> 244px cell -> 137px of 16:9 video -> 7.9x downscale from 1920px source
//     2 across -> 373px cell -> 210px of 16:9 video -> 5.1x downscale
//
// The skeleton is thin stick-figure strokes. At 137px tall they alias into mush, which is the
// precise failure that rule forbids, and the cell now stacks TWO videos so the cost is paid twice.
// Orphan rows cannot decide it -- the generator picks 3-6 standouts and neither column count is
// clean across that range (3-across orphans at 4 and 5, 2-across at 3 and 5) -- but a half-width
// orphan reads as intentional where a third-width one reads as broken.
// 330px minimum lands exactly 2 across 760 and collapses to 1 on narrow screens, no media query.
//
// THE CLIP GATE IS THE PRODUCT'S, NOT THIS COMPONENT'S. A clip renders only when the viewer may
// watch it -- admin, or an approved clip -- and the URL is requested per clip from /r2-read-url
// the same way PlayerClipsView does it. The paywall is not a CSS state here either: a clip the
// viewer may not watch has no URL fetched for it at all.
function RecapStandout({ s, users, scoutReports, cu, go, sessionDate }) {
  var p = (users || []).find(function (u) {
    return (s.playerId && String(u.id) === String(s.playerId)) ||
      (u.firstName + " " + u.lastName) === s.playerName;
  });
  var [clipUrl, setClipUrl] = useState(null);
  var [skelUrls, setSkelUrls] = useState([]);
  var [showReport, setShowReport] = useState(false);
  var isAdmin = !!(cu && (cu.type === "staff" || cu.isAdmin));

  useEffect(function () {
    if (!p) return;
    var dead = false;
    // ONE QUERY, BOTH KINDS. The clip and the skeletons are rows in the same table distinguished
    // only by clip_type, so asking twice would be two round trips for one answer.
    sbSelect("bbot_clips", "?player_id=eq." + encodeURIComponent(String(p.id)) +
      "&order=created_at.desc&limit=40&select=id,clip_object_key,approved,clip_type,action_type,session_date")
      .then(function (rows) {
        var all = rows || [];
        // Same gate PlayerClipsView applies, and it applies to the skeletons too. No URL is even
        // requested for something this viewer may not watch, so the paywall cannot be defeated
        // by reading the DOM.
        var ok = function (c) { return c && c.clip_object_key && (isAdmin || c.approved); };

        // EVERY SKELETON FROM THIS SESSION, NOT JUST THE NEWEST (Luis, 2026-10-08). A player
        // throws, runs and hits in one session and BBOT tracks each separately; showing one of
        // them made the other measurements invisible on the very page written about that session.
        //
        // SCOPED BY session_date, not by "most recent N". A recap is about ONE session, so a
        // skeleton from a different day appearing under its heading would be a measurement
        // presented against a session it was not taken in. Rows with no session_date are left
        // out rather than guessed at. If the recap carries no date at all, nothing can be scoped
        // and the newest skeleton is shown alone -- the old behaviour, which is honest about
        // being unscoped rather than silently mixing days.
        var skels = all.filter(function (c) { return ok(c) && String(c.clip_type) === "skeleton"; });
        var sd = String(sessionDate || "").slice(0, 10);
        if (sd) {
          skels = skels.filter(function (c) { return String(c.session_date || "").slice(0, 10) === sd; });
        } else {
          skels = skels.slice(0, 1);
        }
        // Oldest first: a session runs in an order and reading it left-to-right as it happened
        // beats reading it backwards.
        skels = skels.slice().reverse();

        var clip = all.filter(function (c) { return ok(c) && String(c.clip_type) !== "skeleton"; })[0] || null;
        if (clip) {
          fetch(BACKEND_URL + "/r2-read-url?objectKey=" + encodeURIComponent(clip.clip_object_key))
            .then(function (x) { return x.json(); })
            .then(function (d) { if (!dead && d && d.url) setClipUrl(d.url); })
            .catch(function () { });
        }
        // Signed in parallel but collected POSITIONALLY, so the row cannot reorder itself
        // depending on which signature came back first.
        if (skels.length) {
          Promise.all(skels.map(function (c) {
            return fetch(BACKEND_URL + "/r2-read-url?objectKey=" + encodeURIComponent(c.clip_object_key))
              .then(function (x) { return x.json(); })
              .then(function (d) { return (d && d.url) ? { id: c.id, url: d.url, label: (c.action_type || "").replace(/_/g, " ") } : null; })
              .catch(function () { return null; });
          })).then(function (out) {
            if (!dead) setSkelUrls(out.filter(Boolean));
          });
        }
      })
      .catch(function () { });
    return function () { dead = true; };
  }, [p && p.id, isAdmin, sessionDate]);

  // THE REPORT THIS STANDOUT IS ABOUT.
  //
  // `isLiveEval` is the SAME gate the roster screen applies -- a published evaluation, not a
  // draft and not a rejected one. Reusing it rather than writing a second test means the card
  // cannot become visible here under conditions it would not be visible anywhere else.
  // [[one-home-per-value]]
  //
  // The second layer is the data itself: for a logged-out reader `scoutReports` is loaded from
  // bbot_reports_public, which is approved rows with the internal machinery stripped. So a
  // report that is not in this list cannot be expanded, and the toggle simply is not drawn.
  //
  // Preferring the report from THIS session, falling back to the newest: a recap is written
  // about one day, and opening a different day's evaluation underneath its heading would
  // attribute the wrong session to the standout.
  var playerEvals = (p ? (scoutReports || []).filter(function (r) {
    return String(r.playerId) === String(p.id) && isLiveEval(r);
  }) : []);
  var sd = String(sessionDate || "").slice(0, 10);
  var rep = (sd && playerEvals.filter(function (r) { return String(r.date || "").slice(0, 10) === sd; })[0])
         || playerEvals[playerEvals.length - 1] || null;

  var lead = (p && typeof bbotLeadStat === "function") ? bbotLeadStat(p, scoutReports) : null;
  var clickable = !!(p && go);
  var name = s.playerName || (p ? p.firstName + " " + p.lastName : "Player");
  var meta = p ? [p.position, p.gradYear ? "Class " + p.gradYear : ""].filter(Boolean).join(" · ") : "";

  return <div style={{ border: "0.5px solid " + C.border, borderRadius: 12, overflow: "hidden", background: C.white }}>
    {clipUrl
      ? <BbotPreviewVideo src={clipUrl}
          style={{ width: "100%", aspectRatio: "16/9", objectFit: "cover", display: "block", background: C.navy }} />
      : <div style={{ width: "100%", aspectRatio: "16/9", background: "linear-gradient(135deg," + C.navy + "," + C.blue + ")", display: "flex", alignItems: "center", justifyContent: "center" }}>
          <BbotMark size={30} tile="transparent" />
        </div>}
    {/* THE SKELETON SITS UNDER THE CLIP AND IS LABELLED (Luis, 2026-10-03). It is the measurement
        shown as a picture, and without a label a pose overlay reads as a second camera angle
        rather than as BBOT's own tracking. Absent when there is no skeleton the viewer may watch
        -- an empty placeholder would claim a measurement that was not made. */}
    {/* THE SKELETONS SIT IN A ROW, AT THEIR TRUE SHAPE (Luis, 2026-10-08: "stack them
        horizontally and aesthetically optimally without distorting or cropping them").
        NOTHING IS STRETCHED AND NOTHING IS CUT. Each clip is given a FIXED HEIGHT and
        `width:auto`, which is the only combination that guarantees both: the browser derives the
        width from the video's own aspect ratio, so a portrait throw and a wide baserunning clip
        both keep their proportions and simply occupy different widths. Forcing a shared width --
        or a shared aspect box with `cover` -- is what crops limbs off the very overlay the
        tracking exists to show, and `fill` is what stretches them.
        A common height is what makes the row read as one strip rather than a ragged pile; the
        ground line sits at the same level across all of them. More than fits scrolls sideways
        rather than shrinking everything until none of it is legible. */}
    {skelUrls.length > 0 && <div style={{ borderTop: "0.5px solid " + C.border, background: C.navy }}>
      <div style={{ display: "flex", gap: 2, overflowX: "auto", justifyContent: skelUrls.length > 1 ? "flex-start" : "center",
                    WebkitOverflowScrolling: "touch" }}>
        {skelUrls.map(function (k) {
          return <div key={k.id} style={{ position: "relative", flex: "0 0 auto" }}>
            <BbotPreviewVideo src={k.url}
              style={{ height: 190, width: "auto", maxWidth: "100%", display: "block", background: C.navy }} />
            {k.label && <div style={{ position: "absolute", left: 0, right: 0, bottom: 0, textAlign: "center",
                                      fontSize: 8.5, letterSpacing: .7, textTransform: "uppercase", fontWeight: 700,
                                      color: "rgba(255,255,255,.88)", padding: "10px 4px 4px",
                                      background: "linear-gradient(to bottom,rgba(22,36,61,0),rgba(22,36,61,.78))" }}>
              {k.label}
            </div>}
          </div>;
        })}
      </div>
      <div style={{ fontSize: 9, color: C.gray400, letterSpacing: .8, textTransform: "uppercase", padding: "5px 12px 0", background: C.white }}>
        BBOT movement tracking{skelUrls.length > 1 ? " \u00b7 " + skelUrls.length + " tracked" : ""}
      </div>
    </div>}
    <div style={{ padding: 12 }}>
      <div onClick={clickable ? function () { go("profile-" + p.id); } : null}
        style={{ fontWeight: 700, fontSize: 14, lineHeight: 1.3, color: clickable ? C.blue : C.gray900, cursor: clickable ? "pointer" : "default" }}>
        {name}{clickable && " →"}
      </div>
      {meta && <div style={{ fontSize: 11, color: C.gray400, marginTop: 2 }}>{meta}</div>}
      {lead && lead.value != null && <div style={{ marginTop: 8, display: "flex", alignItems: "baseline", gap: 6 }}>
        <span style={{ fontFamily: "Inter,system-ui,sans-serif", fontSize: 22, fontWeight: 700, color: C.coral, lineHeight: 1 }}>{lead.value}</span>
        <span style={{ fontSize: 10, color: C.gray400, letterSpacing: .6, textTransform: "uppercase" }}>{lead.label}</span>
      </div>}
      {s.synopsis && <p style={{ fontSize: 12, lineHeight: 1.65, color: C.gray700, margin: "8px 0 0" }}>{s.synopsis}</p>}
      {/* THE REPORT OPENS IN PLACE (Luis, 2026-10-08: "clicking and expanding to show full
          player card without leaving session report" -- and it has to hide again).
          It used to navigate to the player's profile, which threw the reader out of the article
          they were reading with only the browser's Back button to return. Expanding keeps them
          where they are and the same control closes it.
          The earlier note here said the card could not be embedded because /card/{rid} is
          admin-gated. That was about the IMAGE endpoint; ReportCard is a React component the
          app already renders to non-admins on the roster screen, and what a reader may see is
          decided by `isLiveEval` plus which rows the server sent -- not by where it is drawn.
          Drawn only when a published report actually exists; a control that opens nothing
          promises a report that is not there. */}
      {rep && <div onClick={function () { setShowReport(!showReport); }}
        style={{ marginTop: 10, paddingTop: 9, borderTop: "0.5px solid " + C.border,
                 fontSize: 11.5, fontWeight: 700, color: C.blue, cursor: "pointer",
                 letterSpacing: .2, display: "flex", alignItems: "center", gap: 6 }}>
        <span style={{ fontSize: 9 }}>{showReport ? "\u25be" : "\u25b8"}</span>
        {showReport
          ? "Hide " + name.split(" ")[0] + "\u2019s report"
          : "View " + name.split(" ")[0] + "\u2019s full session report"}
      </div>}
      {rep && showReport && <div style={{ marginTop: 10 }}>
        <ReportCard r={rep} sc={p} isAdmin={isAdmin} defaultOpen={true} />
        {/* A SECOND WAY OUT. Once the card is open it is taller than the screen, so the control
            that opened it has scrolled off -- closing it would mean scrolling back up to find
            the thing you already pressed. */}
        <div onClick={function () { setShowReport(false); }}
          style={{ marginTop: 8, textAlign: "center", fontSize: 11.5, fontWeight: 700,
                   color: C.blue, cursor: "pointer", padding: "7px 0" }}>
          \u25b4 Hide report
        </div>
      </div>}
      {/* The profile is still one click away for anyone who wants the whole player, rather than
          this one session. */}
      {clickable && !showReport && <div onClick={function () { go("profile-" + p.id); }}
        style={{ marginTop: rep ? 6 : 10, paddingTop: rep ? 0 : 9,
                 borderTop: rep ? "none" : "0.5px solid " + C.border,
                 fontSize: 11, fontWeight: 600, color: C.gray500, cursor: "pointer" }}>
        Open {name.split(" ")[0]}&rsquo;s profile &rarr;
      </div>}
    </div>
  </div>;
}

function RecapArticle({ r, users, scoutReports, cu, go }) {
  var outs = (r && r.standouts) || [];
  return <article style={{ maxWidth: 760, margin: "0 auto", width: "100%" }}>
    {/* THE REPORT LEADS WITH THE LOCKUP (Luis, 2026-10-08). A bare 56px mark adrift in a 220px
        band read as a placeholder rather than a masthead -- too small to carry the top of the
        page, and it never said whose report this is. Shared with the blog post so the two
        mastheads cannot drift apart again. */}
    <BbotArticleHero image={r.coverImage} />
    <div style={{ display: "inline-block", marginTop: 18, background: C.coral, color: C.white, borderRadius: 99, padding: "5px 13px", fontSize: 10, fontWeight: 800, letterSpacing: 1.1 }}>
      {String(r.sessionType || "Session").toUpperCase()} RECAP
    </div>
    <h1 style={{ fontFamily: "Inter,system-ui,sans-serif", fontSize: 34, lineHeight: 1.18, color: C.navy, margin: "12px 0 10px", letterSpacing: -.4 }}>{r.title || "Session Recap"}</h1>
    {r.summary && <p style={{ fontSize: 17, lineHeight: 1.6, color: C.gray600, margin: "0 0 14px" }}>{r.summary}</p>}
    <div style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap", fontSize: 12, color: C.gray500, paddingBottom: 14, borderBottom: "1px solid " + C.border, marginBottom: 6 }}>
      <BbotMark size={22} />
      <span style={{ fontWeight: 700, color: C.navy }}>643 Sports MGMT</span>
      <span>·</span><span>{r.date || ""}</span>
      {outs.length > 0 && <span>·</span>}
      {outs.length > 0 && <span>{outs.length} standout{outs.length === 1 ? "" : "s"}</span>}
    </div>
    {outs.length > 0 && <div>
      <h2 style={{ fontFamily: "Inter,system-ui,sans-serif", fontSize: 21, color: C.navy, margin: "26px 0 12px", letterSpacing: .2 }}>Standout Performances</h2>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill,minmax(min(330px,100%),1fr))", gap: 14 }}>
        {outs.map(function (s, i) {
          return <RecapStandout key={i} s={s} users={users} scoutReports={scoutReports} cu={cu} go={go} sessionDate={r.date} />;
        })}
      </div>
    </div>}
    <div style={{ fontSize: 11, color: C.gray400, lineHeight: 1.6, marginTop: 22 }}>
      Every figure shown is a device reading or an admin-timed measurement; where a value has no
      receipt, none is shown.
    </div>
  </article>;
}

function RecapCard({ r, users, cu, isStaff, approveRecap, deleteRecap, expanded, onOpen, go }) {
  var isDraft = isDraftEval(r);
  var typeCol = r.sessionType==="Game"?C.orange:r.sessionType==="Showcase"?C.navyMid:C.green;

  return (
    <div style={{background:C.white,border:"0.5px solid "+(isDraft?"#fde047":C.border),borderRadius:12,overflow:"hidden"}}>
      {isDraft && <div style={{height:3,background:C.orange}}/>}
      {!isDraft && <div style={{height:3,background:typeCol}}/>}

      <div style={{padding:"16px 20px"}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",gap:12,flexWrap:"wrap",marginBottom:12}}>
          <div>
            <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:4,flexWrap:"wrap"}}>
              <span style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:16,color:C.gray900,fontWeight:700}}>{r.title}</span>
              {isDraft && <span style={{fontSize:10,background:"#fef9c3",color:"#854d0e",padding:"2px 8px",borderRadius:99,fontWeight:600,border:"0.5px solid #fde047"}}>DRAFT</span>}
              {!isDraft && <span style={{fontSize:10,background:C.greenLight,color:C.green,padding:"2px 8px",borderRadius:99,fontWeight:600}}>PUBLISHED</span>}
            </div>
            <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
              <span style={{fontSize:11,background:typeCol+"22",color:typeCol,padding:"2px 8px",borderRadius:99,fontWeight:600}}>{r.sessionType||"Session"}</span>
              <span style={{fontSize:11,color:C.gray400}}>{r.date}</span>
              {r.teams&&r.teams.length>0&&<span style={{fontSize:11,color:C.gray500}}>{r.teams.join(" vs ")}</span>}
            </div>
          </div>
          <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
            {onOpen&&<button onClick={onOpen} style={{background:C.navy,color:C.white,border:"none",padding:"7px 14px",borderRadius:8,fontWeight:600,fontSize:12,cursor:"pointer"}}>View Full Recap</button>}
            {isStaff&&isDraft&&<button onClick={function(){approveRecap(r.id);}} style={{background:C.green,color:C.white,border:"none",padding:"7px 14px",borderRadius:8,fontWeight:700,fontSize:12,cursor:"pointer"}}>Publish</button>}
            {isStaff&&<button onClick={function(){deleteRecap(r.id);}} style={{background:"none",border:"0.5px solid "+C.border,color:C.gray400,padding:"7px 10px",borderRadius:8,fontSize:12,cursor:"pointer"}}>Delete</button>}
          </div>
        </div>

        <p style={{fontSize:13,color:C.gray700,lineHeight:1.7,marginBottom:expanded?16:0}}>{r.summary}</p>

        {expanded && (
          <div>
            {r.standouts&&r.standouts.length>0&&(
              <div style={{marginBottom:16}}>
                <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:11,color:C.blue,letterSpacing:1.5,marginBottom:10,textTransform:"uppercase"}}>Standout Performances</div>
                <div style={{display:"flex",flexDirection:"column",gap:8}}>
                  {r.standouts.map(function(s,i){
                    var p = (users||[]).find(function(u){ return (s.playerId&&String(u.id)===String(s.playerId))||String(u.jerseyNum)===String(s.playerJersey)||u.firstName+" "+u.lastName===s.playerName; });
                    var clickable = !!(p && go);
                    var initials = p ? ((p.firstName||"?")[0]+(p.lastName||"?")[0]) : (s.playerJersey?("#"+s.playerJersey):"·");
                    return (
                      <div key={i} onClick={clickable?function(){go("profile-"+p.id);}:null} style={{display:"flex",alignItems:"flex-start",gap:12,padding:"10px 14px",background:C.blueFaint,border:"0.5px solid "+C.blueLight,borderRadius:8,cursor:clickable?"pointer":"default"}}>
                        <div style={{width:36,height:36,borderRadius:"50%",background:C.blue,display:"flex",alignItems:"center",justifyContent:"center",color:C.white,fontFamily:"Inter,system-ui,sans-serif",fontWeight:700,fontSize:13,flexShrink:0}}>{initials}</div>
                        <div>
                          <div style={{fontWeight:700,fontSize:13,color:clickable?C.blue:C.gray900,marginBottom:2}}>{s.playerName||(p?p.firstName+" "+p.lastName:"#"+s.playerJersey)}{clickable&&" →"}</div>
                          <div style={{fontSize:12,color:C.gray600,lineHeight:1.6}}>{s.highlight}</div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            )}

            {r.keyMetrics&&r.keyMetrics.length>0&&(
              <div style={{marginBottom:16}}>
                <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:11,color:C.blue,letterSpacing:1.5,marginBottom:10,textTransform:"uppercase"}}>Key Metrics</div>
                <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(160px,1fr))",gap:8}}>
                  {r.keyMetrics.map(function(m,i){
                    return (
                      <div key={i} style={{background:C.gray50,border:"0.5px solid "+C.border,borderRadius:8,padding:"10px 12px",textAlign:"center"}}>
                        <div style={{fontSize:9,color:C.gray400,textTransform:"uppercase",letterSpacing:1,marginBottom:4}}>{m.label}</div>
                        <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:22,color:C.navy,fontWeight:700}}>{m.value}</div>
                        {m.playerJersey&&<div style={{fontSize:10,color:C.gray400,marginTop:2}}>{"#"+m.playerJersey}</div>}
                      </div>
                    );
                  })}
                </div>
              </div>
            )}

            {r.teamNotes&&(
              <div style={{marginBottom:16}}>
                <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:11,color:C.blue,letterSpacing:1.5,marginBottom:8,textTransform:"uppercase"}}>Session Notes</div>
                <p style={{fontSize:13,color:C.gray700,lineHeight:1.7,background:C.gray50,border:"0.5px solid "+C.border,borderLeft:"3px solid "+C.navy,padding:"12px 16px",borderRadius:"0 8px 8px 0",margin:0}}>{r.teamNotes}</p>
              </div>
            )}

            {r.taggedPlayers&&r.taggedPlayers.length>0&&(
              <div style={{paddingTop:12,borderTop:"0.5px solid "+C.border}}>
                <div style={{fontSize:10,color:C.gray400,marginBottom:6}}>Tagged Players</div>
                <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
                  {r.taggedPlayers.map(function(jersey,i){
                    var p=(users||[]).find(function(u){return String(u.jerseyNum)===String(jersey);});
                    return (
                      <span key={i} style={{fontSize:11,background:C.blueFaint,color:C.blue,padding:"2px 10px",borderRadius:99,border:"0.5px solid "+C.blueLight,fontWeight:600}}>{"#"+jersey+(p?" "+p.firstName+" "+p.lastName:"")}</span>
                    );
                  })}
                </div>
              </div>
            )}

            <div style={{marginTop:14,paddingTop:12,borderTop:"0.5px solid "+C.border,display:"flex",justifyContent:"space-between",fontSize:10,color:C.gray400}}>
              <span>{"Generated by BBOT -- "+r.staffName}</span>
              <span>{r.videoUrl?"Video session":"No video"}</span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

// One-day Pickup Game format — what the $75 event includes/guarantees. Used as the default
// requirements text on creation + shown to players at registration so the deliverable is clear.
var PICKUP_GAME_FORMAT = "Home-to-1st run timing (position players) · pregame infield · pregame BP (5–8 batted balls) · live game (pitchers face batters, plus machine-pitch at-bats). Guaranteed reps: position players 5 at-bats; pitchers 6 batters faced. Includes performance video + BBOT evaluation report + event jersey.";

// Hold-harmless / liability waiver — must be opted into at registration before payment.
// NOTE (not legal advice): have a licensed attorney in your jurisdiction review/adapt this
// before relying on it, especially for minors and across PR / international events.
var HOLD_HARMLESS_TEXT = "ASSUMPTION OF RISK, RELEASE & HOLD-HARMLESS AGREEMENT. By registering and paying, I acknowledge that baseball and related athletic activities involve inherent and unforeseeable risks of serious injury, illness, or death, and I voluntarily assume all such risks. In consideration of being permitted to participate, I — for myself, and as parent/legal guardian on behalf of any registered minor, and for our heirs and representatives — release, waive, discharge, and agree to hold harmless and indemnify 643 Sports MGMT, BBOT, their owners, officers, employees, staff, volunteers, contractors, the venue/field owner and operator, sponsors, and all affiliated and organizing parties (the \"Released Parties\") from any and all claims, demands, liabilities, or causes of action of any kind arising out of or related to participation, including those caused by negligence of the Released Parties, to the fullest extent permitted by law. I confirm that the participant is physically fit to participate and that I have or have declined appropriate medical/accident insurance. I authorize the Released Parties to arrange emergency medical care if needed, at my expense. I consent to being photographed and filmed and to the use of that footage and resulting data for evaluation, player profiles, and promotion, with no compensation owed to me. I understand the registration fee is non-refundable once the jersey has been ordered. I have read this agreement, understand it is a binding release of legal rights, and accept it voluntarily.";

// Per-event registration: mandatory jersey size + alt-jersey option + REQUIRED hold-harmless
// opt-in, then payment. Registration closes 2 weeks before the event. On payment success the
// player is added to attendees, gets an event number, and a confirmation email is sent.
function EventRegisterModal({ev, cu, onClose, onRegistered, onPaid, notify}){
  var sizes=["YS","YM","YL","AS","AM","AL","AXL","A2XL"];
  var sizeS=useState(cu.jerseySize||cu.shirtSize||""); var size=sizeS[0]; var setSize=sizeS[1];
  var altS=useState(false); var alt=altS[0]; var setAlt=altS[1];
  // TWO-WAY confirmation — defaults from the player's profile flag; required to confirm when their
  // position involves pitching so BBOT produces ONE combined report (not two). Captured per-event.
  var twoWayDefault = !!(cu && cu.twoWay);
  var twoWayS=useState(twoWayDefault); var twoWay=twoWayS[0]; var setTwoWay=twoWayS[1];
  var _P=(cu&&cu.position||"").toUpperCase(); var _P2=(cu&&cu.position2||"").toUpperCase();
  var pitchInvolved=["P","RHP","LHP"].some(function(x){return _P===x||_P2===x;});
  var agreeS=useState(false); var agree=agreeS[0]; var setAgree=agreeS[1];
  var stepS=useState("form"); var step=stepS[0]; var setStep=stepS[1]; // form -> pay
  var assignedNumS=useState(null); var assignedNum=assignedNumS[0]; var setAssignedNum=assignedNumS[1];
  // NO REGISTRATION CUTOFF. This refused anyone inside 14 days of the event, which closed the
  // Perkiomen tryout two weeks early and was never asked for (it arrived 2026-05-30 in e1bb3ba).
  // Luis ruled it off 2026-10-08: "i didnt ask for any registration EXP date". Registration now
  // stays open until the organiser un-launches the event, which is a decision someone makes
  // rather than a date that passes silently.
  var closed = false;
  // MEMBER PRICING (pickup games): verified 643 members pay the member rate; everyone else pays
  // the standard rate. Non-members never see the member price; admin sees both.
  var isMember = !!(cu && cu.verified643);
  var isAdminView = !!(cu && bbotIsAdmin(cu));
  var isPickup = ev.event_type==="pickup_game";
  // Events carry an admin-set per-event rate (no fixed public price); the member/pickup fixed tiers were killed 2026-07-13.
  // Split pricing: pitchers pay the pitcher rate, everyone else the position rate; each side
  // falls back to the single `cost` when unset. Two-way (pitch AND hit) counts as pitcher.
  var _num=function(v){ return (v!=null&&String(v).trim()!=="")?Number(String(v).replace(/[^0-9.]/g,"")):null; };
  var _baseCost=_num(ev.cost), _posCost=_num(ev.cost_position), _pitCost=_num(ev.cost_pitcher);
  var payAsPitcher = pitchInvolved || twoWay;
  var baseFee = payAsPitcher ? (_pitCost!=null?_pitCost:_baseCost) : (_posCost!=null?_posCost:_baseCost);
  if(baseFee==null) baseFee = (_baseCost!=null?_baseCost:0);
  var feeNum = baseFee;
  var cost = feeNum ? ("$"+feeNum.toFixed(2)) : "";
  var memberNote = "";

  function proceed(){
    if(closed){ notify("Registration closed (within 2 weeks of the event)","error"); return; }
    if(!size){ notify("Jersey size is required","error"); return; }
    if(!agree){ notify("You must accept the waiver to register","error"); return; }
    // Save registration (size/alt/waiver) + assign event number, THEN show ATH payment.
    onRegistered({ playerId:String(cu.id), size:size, altJersey:alt, twoWay:twoWay, waiverAccepted:true, waiverAcceptedAt:new Date().toISOString() }, function(num){
      setAssignedNum(num); setStep("pay");
    });
  }

  return (
    <div onClick={onClose} style={{position:"fixed",inset:0,background:"rgba(0,0,0,.5)",zIndex:1000,display:"flex",alignItems:"center",justifyContent:"center",padding:16}}>
      <div onClick={function(e){e.stopPropagation();}} style={{background:C.white,borderRadius:12,maxWidth:460,width:"100%",maxHeight:"90vh",overflowY:"auto",padding:20}}>
        <div style={{fontWeight:700,color:C.navy,fontSize:16,marginBottom:4}}>Register — {ev.name}</div>
        <div style={{fontSize:12,color:C.gray500,marginBottom:14}}>{[ev.event_type==="pickup_game"?"Pickup Game":ev.event_type,ev.start_date,ev.start_time,ev.venue||ev.location].filter(Boolean).join(" · ")}{cost?(" · "+cost+memberNote):""}</div>
        {isAdminView && isPickup && (
          <div style={{fontSize:11,color:C.gray500,marginBottom:10,padding:"5px 9px",background:C.gray50,borderRadius:6}}>Admin view — member ${MEMBER_PICKUP.toFixed(2)} · standard ${STD_PICKUP.toFixed(2)}</div>
        )}
        {ev.event_type==="pickup_game" && (
          <div style={{padding:"10px 12px",background:C.blueFaint,border:"1px solid "+C.blue,borderRadius:8,marginBottom:14,fontSize:12,color:C.navy,lineHeight:1.55}}>
            <strong>One-day Pickup Game.</strong> Includes performance video, a BBOT evaluation report, and your event jersey — no membership required.
            <div style={{marginTop:6}}><strong>Guaranteed:</strong> position players 5 at-bats · pitchers 6 batters faced.</div>
            <div style={{marginTop:4,color:C.gray600}}>Home-to-1st timing · pregame infield · pregame BP (5–8 balls) · live game (live pitching + machine-pitch at-bats).</div>
          </div>
        )}

        {closed ? (
          <div style={{padding:12,background:C.coralFaint,border:"1px solid "+C.coralLight,borderRadius:8,color:C.coral,fontSize:13,fontWeight:600}}>Registration is closed — it ends 2 weeks before the event so jerseys can be ordered.</div>
        ) : step==="form" ? (
          <div>
            <div style={{fontSize:12,fontWeight:700,color:C.navy,marginBottom:6}}>Jersey size <span style={{color:C.coral}}>*</span></div>
            <div style={{display:"flex",flexWrap:"wrap",gap:6,marginBottom:14}}>
              {sizes.map(function(s){return <button key={s} onClick={function(){setSize(s);}} style={{padding:"7px 12px",borderRadius:6,border:"1px solid "+(size===s?C.blue:C.border),background:size===s?C.blue:C.white,color:size===s?C.white:C.gray700,fontSize:12,fontWeight:700,cursor:"pointer"}}>{s}</button>;})}
            </div>
            <label style={{display:"flex",alignItems:"center",gap:8,fontSize:12,color:C.gray700,marginBottom:14,cursor:"pointer"}}>
              <input type="checkbox" checked={alt} onChange={function(e){setAlt(e.target.checked);}}/>
              I need an alternative jersey (additional cost may apply)
            </label>

            <div style={{fontSize:12,fontWeight:700,color:C.navy,marginBottom:6}}>Two-way player {pitchInvolved&&<span style={{color:C.coral}}>*</span>}</div>
            <label style={{display:"flex",alignItems:"center",gap:8,fontSize:12,color:C.gray700,marginBottom:6,cursor:"pointer",padding:"8px 10px",border:"1px solid "+(twoWay?C.coral:C.border),borderRadius:8,background:twoWay?C.coralFaint:C.white}}>
              <input type="checkbox" checked={twoWay} onChange={function(e){setTwoWay(e.target.checked);}} style={{accentColor:C.coral}}/>
              I both pitch AND hit at this event (BBOT will produce one combined report)
            </label>
            <div style={{fontSize:11,color:C.gray500,marginBottom:14,lineHeight:1.45}}>{pitchInvolved?"Your position involves pitching — please confirm whether you also hit, so we capture both and avoid a duplicate report.":"Check only if you'll be evaluated both pitching and hitting at this event."}</div>

            <div style={{fontSize:12,fontWeight:700,color:C.navy,marginBottom:6}}>Liability waiver <span style={{color:C.coral}}>*</span></div>
            <div style={{maxHeight:130,overflowY:"auto",border:"1px solid "+C.border,borderRadius:8,padding:10,fontSize:11,color:C.gray600,lineHeight:1.5,marginBottom:10,background:C.gray50}}>{HOLD_HARMLESS_TEXT}</div>
            <label style={{display:"flex",alignItems:"flex-start",gap:8,fontSize:12,color:C.navy,fontWeight:600,marginBottom:16,cursor:"pointer"}}>
              <input type="checkbox" checked={agree} onChange={function(e){setAgree(e.target.checked);}} style={{marginTop:2}}/>
              I have read and accept the waiver above, and I understand the fee is non-refundable once my jersey is ordered.
            </label>

            <button onClick={proceed} disabled={!size||!agree} style={{width:"100%",padding:"12px",borderRadius:8,border:"none",background:(!size||!agree)?C.gray300:C.coral,color:C.white,fontSize:14,fontWeight:700,cursor:(!size||!agree)?"not-allowed":"pointer"}}>
              {cost?("Continue to payment — "+cost):"Continue to payment"}
            </button>
          </div>
        ) : (
          <div>
            <div style={{padding:"10px 12px",background:C.gray50,border:"1px solid "+C.border,borderRadius:8,marginBottom:12,fontSize:12,color:C.navy}}>
              Registered · size <strong>{size}</strong>{alt?" · alt jersey":""}{assignedNum?(" · #"+assignedNum):""}. Pay below to confirm your spot.
            </div>
            <div style={{fontSize:11,color:C.gray500,marginBottom:6}}>Pay with ATH Móvil{cost?(" — "+cost):""}.</div>
            <AthMovilButton
              amountUSD={feeNum}
              label="ATH MÓVIL"
              notify={notify}
              eventCtx={{ eventId:ev.id, eventName:ev.name, playerId:String(cu.id), playerName:(cu.firstName+" "+cu.lastName), playerEmail:cu.email||null, eventNumber:assignedNum }}
              onPaid={function(out){ if(onPaid) onPaid(ev, String(cu.id)); onClose(); }}
            />
            <div style={{fontSize:10,color:C.gray400,marginTop:8,textAlign:"center"}}>Your spot is held; payment confirms it. Fee non-refundable once the jersey is ordered.</div>
          </div>
        )}
        <button onClick={onClose} style={{width:"100%",marginTop:8,padding:"8px",borderRadius:8,border:"1px solid "+C.border,background:C.white,color:C.gray600,fontSize:12,fontWeight:600,cursor:"pointer"}}>{step==="pay"?"Close":"Cancel"}</button>
      </div>
    </div>
  );
}

// League team colors (one solid color per roster — matches the jersey designs + gives BBOT
// color as a 2nd ID signal). Navy replaces black. Add more as more teams come up.
var LEAGUE_TEAMS = [
  {key:"core_blue", label:"Core Blue", color:"#2970b8", numColor:"#ffffff"},
  {key:"coral",     label:"Coral",     color:"#e8526a", numColor:"#ffffff"},
  {key:"navy",      label:"Navy",      color:"#16243d", numColor:"#ffffff"},
  {key:"white",     label:"White",     color:"#f4f6fa", numColor:"#16243d"},
  {key:"green",     label:"Green",     color:"#2e7d46", numColor:"#ffffff"},
  {key:"gold",      label:"Gold",      color:"#caa53d", numColor:"#16243d"},
];

// Per-event roster builder. Pulls registered/attending players onto colored team rosters,
// carrying each player's permanent BBOT number. Rosters persist on the event and feed BBOT.
// FIND A PLAYER AND PUT THEM ON AN EVENT. (Luis, 2026-10-22.)
//
// An admin takes registrations by phone, in person and over WhatsApp, and until now had no way to
// record one: the only route onto an event was the player's own Register button, so a seat agreed
// off-platform existed nowhere. Searching by name against the roster already loaded is enough --
// no new read.
//
// IT DOES NOT PRETEND A WAIVER WAS SIGNED. Self-registration captures the waiver as part of the
// flow; this path cannot, because the admin is not the person agreeing to it. The server stores
// `waiverAccepted:false` with `addedBy:"admin"`, and this panel says so on screen rather than
// letting a roster row imply an acknowledgement nobody gave. [[guardian-consent-never-recorded]]
// [[human-input-is-a-defect]]
function EventAddRegistrant({ev, users, setEvents, notify}){
  var qS=useState(""); var q=qS[0], setQ=qS[1];
  var nS=useState(""); var note=nS[0], setNote=nS[1];
  var bS=useState(""); var busy=bS[0], setBusy=bS[1];
  var already = (ev.attending_player_ids||[]).map(String);
  var term = q.trim().toLowerCase();
  var hits = !term ? [] : (users||[]).filter(function(u){
    if(u.type!=="player") return false;
    if(already.indexOf(String(u.id))>=0) return false;
    return ((u.firstName||"")+" "+(u.lastName||"")).toLowerCase().indexOf(term)>=0;
  }).slice(0,6);

  function add(u){
    setBusy(String(u.id));
    saveEventRegistration(ev, {targetPlayerId:String(u.id), size:null, altJersey:null,
                               twoWay:!!u.twoWay, waiverAccepted:false, note:note.trim()||null},
                          setEvents, notify, function(num){
      notify((u.firstName+" "+u.lastName)+" registered"+(num?(" — #"+num):""));
      setQ(""); setNote("");
    }).catch(function(){}).then(function(){ setBusy(""); });
  }

  return (
    <div style={{marginTop:10,padding:"10px 10px 8px",background:C.blueFaint,border:"1px solid "+C.blue,borderRadius:8}}>
      <div style={{fontSize:11,fontWeight:700,color:C.navy,letterSpacing:.4,marginBottom:6}}>REGISTER A PLAYER</div>
      <input value={q} onChange={function(e){setQ(e.target.value);}} placeholder="Search players by name…"
             style={{width:"100%",padding:"7px 9px",borderRadius:6,border:"1px solid "+C.border,fontSize:12,marginBottom:6,boxSizing:"border-box"}}/>
      <input value={note} onChange={function(e){setNote(e.target.value);}} placeholder="Note (optional) — e.g. registered by phone"
             style={{width:"100%",padding:"7px 9px",borderRadius:6,border:"1px solid "+C.border,fontSize:12,marginBottom:6,boxSizing:"border-box"}}/>
      {term && hits.length===0 && (
        <div style={{fontSize:11,color:C.gray500,fontStyle:"italic"}}>
          No unregistered player matches “{q.trim()}”.
        </div>
      )}
      {hits.map(function(u){
        return (
          <div key={u.id} style={{display:"flex",alignItems:"center",justifyContent:"space-between",gap:8,padding:"5px 7px",background:C.white,borderRadius:6,marginBottom:4}}>
            <div style={{minWidth:0,fontSize:12,color:C.gray800}}>
              <strong>{u.firstName} {u.lastName}</strong>
              <span style={{color:C.gray500}}>{[u.position,u.gradYear].filter(Boolean).length?("  "+[u.position,u.gradYear].filter(Boolean).join(" · ")):""}</span>
            </div>
            <button disabled={!!busy} onClick={function(){add(u);}}
                    style={{flexShrink:0,padding:"4px 10px",borderRadius:6,border:"none",background:busy?C.gray300:C.coral,color:C.white,fontSize:11,fontWeight:700,cursor:busy?"default":"pointer"}}>
              {busy===String(u.id)?"Adding…":"Register"}
            </button>
          </div>
        );
      })}
      <div style={{fontSize:10,color:C.gray500,marginTop:4,lineHeight:1.5}}>
        Assigns the next free event number. The waiver is recorded as NOT accepted — only the
        player or their guardian can accept it, so collect it separately.
      </div>
    </div>
  );
}

function EventRosterBuilder({ev, users, setUsers, notify, onSaved}){
  var attendingIds = (ev.attending_player_ids||[]).map(String);
  var attending = (users||[]).filter(function(u){ return u.type==="player" && attendingIds.indexOf(String(u.id))>=0; });
  // rosters shape: { team_key: [playerId,...] } stored on ev.rosters
  var initial = ev.rosters || {};
  var rS=useState(initial); var rosters=rS[0]; var setRosters=rS[1];
  var enS=useState(ev.event_numbers||{}); var eventNumbers=enS[0]; var setEventNumbers=enS[1];
  var teamsS=useState((ev.team_keys && ev.team_keys.length)?ev.team_keys:["core_blue","coral"]); var teamKeys=teamsS[0]; var setTeamKeys=teamsS[1];
  var savingS=useState(false); var saving=savingS[0]; var setSaving=savingS[1];

  function teamOf(pid){ var k=null; Object.keys(rosters).forEach(function(tk){ if((rosters[tk]||[]).map(String).indexOf(String(pid))>=0) k=tk; }); return k; }
  function ensureNumber(pid){
    if(eventNumbers[String(pid)]!=null) return eventNumbers[String(pid)];
    var n=nextEventNumber(eventNumbers);
    setEventNumbers(function(prev){ var nx=Object.assign({},prev); nx[String(pid)]=n; return nx; });
    return n;
  }
  function overrideNumber(pid){
    var cur=eventNumbers[String(pid)];
    var v=window.prompt("Jersey # for this event (1-999):", cur!=null?String(cur):"");
    if(v==null) return;
    v=String(v).trim(); if(v==="") return;
    var num=parseInt(v,10); if(isNaN(num)||num<1){ notify("Enter a valid number","error"); return; }
    var clash=Object.keys(eventNumbers).some(function(k){ return k!==String(pid) && String(eventNumbers[k])===String(num); });
    if(clash){ notify("#"+num+" already used in this event","error"); return; }
    setEventNumbers(function(prev){ var nx=Object.assign({},prev); nx[String(pid)]=num; return nx; });
  }
  function assign(pid, teamKey){
    if(teamKey) ensureNumber(pid); // give them an event number when placed on a roster
    setRosters(function(prev){
      var next={}; Object.keys(prev).forEach(function(tk){ next[tk]=(prev[tk]||[]).filter(function(x){return String(x)!==String(pid);}); });
      if(teamKey){ next[teamKey]=(next[teamKey]||[]).concat([pid]); }
      return next;
    });
  }
  function addTeam(){
    var avail=LEAGUE_TEAMS.map(function(t){return t.key;}).filter(function(k){return teamKeys.indexOf(k)<0;});
    if(!avail.length){ notify("All team colors in use","error"); return; }
    setTeamKeys(teamKeys.concat([avail[0]]));
  }
  function saveRosters(){
    setSaving(true);
    bbotWrite("bbot_events","update",{ rosters:rosters, team_keys:teamKeys, event_numbers:eventNumbers },"id=eq." + encodeURIComponent(String(ev.id))).then(function(){ setSaving(false); notify("Rosters saved"); if(onSaved) onSaved(rosters, teamKeys, eventNumbers); })
      .catch(function(){ setSaving(false); notify("Could not save rosters","error"); });
  }

  // Generate BBOT lineups from each team roster: batting order (roster order), plus practice
  // groupings (infield / outfield / catching) inferred from each player's position. Feeds bbot_lineups
  // so BBOT has the event's lineups for segmentation/identification context.
  function generateLineups(){
    var IF=["1B","2B","3B","SS"], OF=["LF","CF","RF","OF"], C=["C"], P=["P","RHP","LHP"];
    var made=0, jobs=[];
    teamKeys.forEach(function(tk){
      var team=LEAGUE_TEAMS.find(function(t){return t.key===tk;})||{label:tk};
      var roster=(rosters[tk]||[]).map(function(pid){ var u=(users||[]).find(function(x){return String(x.id)===String(pid);}); return u?{playerId:u.id,name:u.firstName+" "+u.lastName,pos:(u.position||"").toUpperCase(),num:eventNumbers[String(u.id)]}:null; }).filter(Boolean);
      if(roster.length===0) return;
      var bucket=function(list){ return roster.filter(function(p){return list.indexOf(p.pos)>=0;}); };
      var lu={
        id:"evt_"+ev.id+"_"+tk,
        name:(ev.name||"Event")+" — "+team.label,
        type:"event_roster",
        date:ev.start_date||null,
        eventId:ev.id, teamKey:tk, teamLabel:team.label,
        battingOrder:roster.map(function(p,i){return {slot:i+1,playerId:p.playerId,name:p.name,num:p.num,pos:p.pos};}),
        pitchingOrder:bucket(P).map(function(p,i){return {slot:i+1,playerId:p.playerId,name:p.name,num:p.num};}),
        practice:{ infield:bucket(IF), outfield:bucket(OF), catching:bucket(C) }
      };
      // A bare call was an unhandled rejection AND a lineup counted as "fed to BBOT" that never landed.
      jobs.push(persistLineup(lu).then(function(){return true;}, function(){return false;})); made++;
    });
    if(made===0){ notify("Place players on rosters first","success"); return; }
    // COUNT WHAT LANDED, NOT WHAT WAS ATTEMPTED. This toast fired synchronously, before a single
    // write had resolved, so it reported every lineup fed to BBOT even when all of them failed.
    Promise.all(jobs).then(function(res){
      var ok=res.filter(Boolean).length;
      if(ok===made) notify(ok+" lineup"+(ok>1?"s":"")+" fed to BBOT","success");
      else notify(ok+" of "+made+" lineups saved — "+(made-ok)+" did not sync","error");
    });
  }
  var unassigned = attending.filter(function(p){ return !teamOf(p.id); });

  return (
    <div style={{marginTop:12,padding:"12px 14px",background:C.gray50,borderRadius:10,border:"1px solid "+C.border}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:10,flexWrap:"wrap",gap:8}}>
        <div style={{fontWeight:700,color:C.navy,fontSize:13}}>EVENT ROSTERS · {attending.length} registered</div>
        <div style={{display:"flex",gap:6}}>
          <button onClick={addTeam} style={{padding:"5px 10px",borderRadius:6,border:"1px solid "+C.border,background:C.white,color:C.gray700,fontSize:11,fontWeight:600,cursor:"pointer"}}>+ Add team</button>
          <button onClick={generateLineups} title="Feed batting/pitching order + infield/OF/catching practice groups to BBOT" style={{padding:"5px 10px",borderRadius:6,border:"1px solid "+C.coral,background:C.white,color:C.coral,fontSize:11,fontWeight:700,cursor:"pointer"}}>⚾ Lineups → BBOT</button>
          <button onClick={saveRosters} disabled={saving} style={{padding:"5px 12px",borderRadius:6,border:"none",background:C.blue,color:C.white,fontSize:11,fontWeight:700,cursor:"pointer"}}>{saving?"Saving…":"Save rosters"}</button>
        </div>
      </div>
      <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(min(180px,100%),1fr))",gap:10}}>
        {teamKeys.map(function(tk){
          var team=LEAGUE_TEAMS.find(function(t){return t.key===tk;})||{label:tk,color:"#888",numColor:"#fff"};
          var roster=(rosters[tk]||[]).map(function(pid){ return (users||[]).find(function(u){return String(u.id)===String(pid);}); }).filter(Boolean);
          return (
            <div key={tk} style={{border:"1px solid "+C.border,borderRadius:8,overflow:"hidden",background:C.white}}>
              <div style={{background:team.color,color:team.numColor,padding:"6px 10px",fontWeight:700,fontSize:12,letterSpacing:.5}}>{team.label.toUpperCase()} · {roster.length}</div>
              <div style={{padding:8,display:"flex",flexDirection:"column",gap:4,minHeight:40}}>
                {roster.map(function(p){return (
                  <div key={p.id} style={{display:"flex",justifyContent:"space-between",alignItems:"center",fontSize:12,padding:"3px 4px"}}>
                    <span><strong onClick={function(){overrideNumber(p.id);}} title="Click to change # for this event" style={{color:C.coral,cursor:"pointer"}}>#{eventNumbers[String(p.id)]!=null?eventNumbers[String(p.id)]:"—"}</strong> {p.firstName} {p.lastName} <span style={{color:C.gray400}}>{p.position||""}</span></span>
                    <button onClick={function(){assign(p.id,null);}} title="Remove" style={{border:"none",background:"transparent",color:C.gray400,cursor:"pointer",fontSize:13}}>×</button>
                  </div>
                );})}
                {roster.length===0&&<div style={{fontSize:11,color:C.gray400,fontStyle:"italic"}}>No players yet</div>}
              </div>
            </div>
          );
        })}
      </div>
      {unassigned.length>0&&<div style={{marginTop:12}}>
        <div style={{fontSize:11,color:C.gray500,fontWeight:700,marginBottom:6}}>UNASSIGNED · tap a team to place</div>
        <div style={{display:"flex",flexDirection:"column",gap:4}}>
          {unassigned.map(function(p){return (
            <div key={p.id} style={{display:"flex",justifyContent:"space-between",alignItems:"center",flexWrap:"wrap",gap:6,fontSize:12,padding:"5px 8px",background:C.white,border:"1px solid "+C.border,borderRadius:6}}>
              <span><strong style={{color:C.coral}}>#{eventNumbers[String(p.id)]!=null?eventNumbers[String(p.id)]:"new"}</strong> {p.firstName} {p.lastName} <span style={{color:C.gray400}}>{p.position||""} · {((ev.event_registrations||{})[String(p.id)]||{}).size||p.jerseySize||p.shirtSize||"no size"}</span> {((ev.event_registrations||{})[String(p.id)]||{}).paid?<span style={{color:C.green,fontWeight:700,fontSize:10}}>PAID</span>:<span style={{color:C.coral,fontWeight:700,fontSize:10}}>UNPAID</span>}</span>
              <div style={{display:"flex",gap:4,flexWrap:"wrap"}}>
                {teamKeys.map(function(tk){var t=LEAGUE_TEAMS.find(function(x){return x.key===tk;})||{};return (
                  <button key={tk} onClick={function(){assign(p.id,tk);}} style={{padding:"3px 8px",borderRadius:5,border:"1px solid "+(t.color||C.border),background:t.color||C.white,color:t.numColor||C.gray700,fontSize:10,fontWeight:700,cursor:"pointer"}}>{(t.label||tk).split(" ")[0]}</button>
                );})}
              </div>
            </div>
          );})}
        </div>
      </div>}
    </div>
  );
}

// AN IMAGE GOES INTO A ROW, SO IT IS RESIZED BEFORE IT DOES. The profile-photo path stores whatever
// the phone produced -- a 12MP JPEG becomes a ~4MB base64 string in a database column, on every read
// of that record forever. Event flyers are exactly the files people paste from a camera roll, so
// this one downscales first: longest edge to 1400px, JPEG at 0.82, which keeps a flyer legible and
// the row a few hundred KB.
//
// Resolves to a data URL, or rejects with a reason the caller can show.
// How many pictures an event may carry. Past this the row gets heavy enough to slow the event
// page itself, and nobody reads a ten-picture flyer.
var EVENT_IMG_MAX = 6;
// VIEWING IS PUBLIC; TAKING A COPY IS NOT. Ruled by Luis 2026-10-08: anyone may WATCH a player's
// most recent clip and skeleton, nobody but an admin may DOWNLOAD one.
//
// WHAT THIS HONESTLY DOES, because overstating it would be the exact defect this product exists
// to avoid: a browser must receive the bytes in order to play them, so no client-side setting can
// make a video undownloadable. This removes the DOWNLOAD BUTTON from the native player, removes
// Picture-in-Picture (which offers its own save path), and blocks right-click "Save video as".
// Someone who opens developer tools can still reach the file. The prohibition that matters is in
// the Terms; this removes the easy path and nothing more.
//
// Spread onto every <video {...bbotVideoGuard()}> through one helper so a new video surface cannot be added without it,
// and so the admin exemption is decided in a single place rather than twenty.
// Reads the admin flag from one module-level place rather than a local `cu`: eleven of the
// twenty-one <video> sites are in components that never receive the current user, and threading a
// prop into each of them is eleven chances to miss one. App keeps the flag current.
function bbotVideoGuard(){
  if(typeof window!=="undefined" && window.__bbotIsAdmin) return {};
  return {
    controlsList: "nodownload noplaybackrate",
    disablePictureInPicture: true,
    onContextMenu: function(e){ e.preventDefault(); }
  };
}

// A PREVIEW HAS TO MOVE TO READ AS A PREVIEW (Luis, 2026-10-08: the clips and skeletons on a
// session report sat on a frozen first frame and had to be pressed before anything happened).
// A still frame of a player mid-stride is indistinguishable from a broken video, so the report
// looked empty until someone took it on faith and clicked.
//
// Muted, looping, no controls until hover -- the vocabulary every feed uses for "this is footage,
// not a photograph". Muted is not a style choice: no browser will autoplay audio, so an unmuted
// autoplay is simply an autoplay that does not happen.
//
// PLAYS ONLY WHAT IS ON SCREEN. A recap with five standouts carries ten videos; starting all ten
// at once would pull tens of megabytes on a phone to show two of them. The observer starts a clip
// when it scrolls into view and pauses it when it leaves, so the cost tracks what is actually
// being watched. Without IntersectionObserver (nothing current, but it costs one line) they
// simply autoplay, which is the old behaviour plus motion -- never worse than a frozen frame.
function BbotPreviewVideo({ src, style, poster }){
  var ref = useRef(null);
  useEffect(function(){
    var el = ref.current;
    if(!el) return;
    if(typeof IntersectionObserver === "undefined"){
      el.play && el.play().catch(function(){});
      return;
    }
    var obs = new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        if(en.isIntersecting){ el.play && el.play().catch(function(){}); }
        else { el.pause && el.pause(); }
      });
    }, { threshold: 0.25 });
    obs.observe(el);
    return function(){ obs.disconnect(); };
  }, [src]);
  // preload="auto" because preload="metadata" fetches only the header -- the element would be
  // told to play something it has not started downloading, and the first loop stutters.
  return <video {...bbotVideoGuard()} ref={ref} src={src} poster={poster}
    autoPlay muted loop playsInline controls preload="auto" style={style} />;
}

// SHARING IS NOT DOWNLOADING (Luis, 2026-10-08). Locking the download button had quietly taken
// sharing with it -- there was no way for a player or a parent to pass a clip on at all. These
// are different rights: handing someone a link is not handing them the file, and a player
// wanting to show a coach their own swing is the ordinary use of this product.
//
// The link points at /s/clip/<id>, a backend route that answers crawlers with the clip's real
// title and a FRAME FROM THE CLIP ITSELF before sending a human to the page. A hash URL could
// not do this: a fragment is never sent to a server, and no social crawler runs JavaScript.
//
// Uses the native share sheet where there is one -- on a phone that is the difference between
// "copied, now go find the app" and actually sending it.
function bbotShareClip(clip, notify){
  if(!clip || !clip.id) return;
  var url=bbotShareUrl("clip", clip.id);
  var who=(clip.player_name||"").trim();
  var what=((clip.action_type||"").replace(/_/g," ")).trim();
  var title=[who,what].filter(Boolean).join(" \u2014 ")||"BBOT clip";
  function copy(){
    try{
      if(navigator.clipboard&&navigator.clipboard.writeText){
        navigator.clipboard.writeText(url).then(
          function(){ notify&&notify("Link copied \u2014 anyone can watch it"); },
          function(){ window.prompt("Copy this link:",url); });
      } else window.prompt("Copy this link:",url);
    }catch(e){ window.prompt("Copy this link:",url); }
  }
  if(typeof navigator!=="undefined" && navigator.share){
    navigator.share({title:title, url:url}).catch(function(){ copy(); });
  } else copy();
}

// THE PUBLIC CLIP PAGE -- where a shared link lands.
//
// Reads the clip straight from bbot_clips with approved = true, which anon has been able to do
// since 2026-09-25, so this needs no new boundary. An unapproved id renders the same "not
// available" card as a dead one: a stranger must not be able to tell the difference between a
// clip that is private and a clip that never existed.
//
// The player's name, position and class come from bbot_players_public -- the ruled public tier
// -- and NOT from the clip row, even though it carries player_name. One home for what may be
// shown about a person, so widening or narrowing that tier happens in one place.
function PublicClipView({clipId, onClose}){
  var cS=useState(null); var clip=cS[0], setClip=cS[1];
  var uS=useState(null); var url=uS[0], setUrl=uS[1];
  var pS=useState(null); var who=pS[0], setWho=pS[1];
  var sS=useState("loading"); var st=sS[0], setSt=sS[1];

  useEffect(function(){
    if(!clipId) return;
    var dead=false;
    fetch(SUPABASE_URL+"/rest/v1/bbot_clips?id=eq."+encodeURIComponent(String(clipId))+
          "&approved=is.true&limit=1&select=id,player_id,player_name,clip_type,action_type,session_date,session_type,clip_object_key",
          {headers:sbHeaders()})
      .then(function(r){ if(!r.ok) throw new Error("HTTP "+r.status); return r.json(); })
      .then(function(rows){
        if(dead) return;
        if(!Array.isArray(rows)||!rows.length){ setSt("missing"); return; }
        var c=rows[0]; setClip(c); setSt("ok");
        if(c.clip_object_key){
          fetch(BACKEND_URL+"/r2-read-url?objectKey="+encodeURIComponent(c.clip_object_key))
            .then(function(x){return x.json();})
            .then(function(d){ if(!dead&&d&&d.url) setUrl(d.url); })
            .catch(function(){});
        }
        if(c.player_id){
          fetch(SUPABASE_URL+"/rest/v1/bbot_players_public?id=eq."+encodeURIComponent(String(c.player_id))+"&limit=1",
                {headers:sbHeaders()})
            .then(function(x){return x.json();})
            .then(function(rs){ if(!dead&&Array.isArray(rs)&&rs.length) setWho(rs[0]); })
            .catch(function(){});
        }
      })
      .catch(function(){ if(!dead) setSt("error"); });
    return function(){ dead=true; };
  },[clipId]);

  var wrap={background:C.gray50,padding:"28px 16px 40px",minHeight:"70vh"};
  if(st==="loading") return <div style={wrap}><div style={{maxWidth:760,margin:"0 auto"}}>
    <Card style={{padding:28,textAlign:"center",color:C.gray500,fontSize:13}}>Loading&hellip;</Card></div></div>;
  if(st!=="ok") return <div style={wrap}><div style={{maxWidth:760,margin:"0 auto"}}>
    <Card style={{padding:28,textAlign:"center"}}>
      <BbotMark size={44}/>
      <div style={{fontSize:15,fontWeight:700,color:C.navy,margin:"14px 0 6px"}}>This clip isn&rsquo;t available</div>
      <div style={{fontSize:13,color:C.gray500,lineHeight:1.6,marginBottom:16}}>
        It may not be published yet, or the link is out of date.</div>
      <Btn v="ghost" onClick={onClose}>Go to 643 BBOT</Btn>
    </Card></div></div>;

  var isSkel=String(clip.clip_type)==="skeleton";
  var act=((clip.action_type||"").replace(/_/g," ")).trim();
  var nm=who?[who.first_name,who.last_name].filter(Boolean).join(" "):(clip.player_name||"");
  var meta=who?[who.position,who.grad_year?("Class "+who.grad_year):""].filter(Boolean).join(" \u00b7 "):"";
  var stamp=[clip.session_type,clip.session_date].filter(Boolean).join(" \u00b7 ");

  return <div style={wrap}><div style={{maxWidth:760,margin:"0 auto"}}>
    <div style={{display:"flex",alignItems:"center",gap:9,marginBottom:14,cursor:"pointer"}} onClick={onClose}>
      <BbotMark size={30}/>
      <span style={{fontWeight:800,color:C.navy,letterSpacing:1.4,fontSize:15}}>BBOT</span>
      <span style={{fontSize:10.5,color:C.gray400,letterSpacing:1.2,textTransform:"uppercase"}}>643 Sports MGMT</span>
    </div>
    <Card style={{padding:0,overflow:"hidden"}}>
      {url
        ? <BbotPreviewVideo src={url} style={{width:"100%",maxHeight:"62vh",display:"block",background:C.navy,objectFit:"contain"}}/>
        : <div style={{width:"100%",aspectRatio:"16/9",background:"linear-gradient(135deg,"+C.navy+","+C.blue+")",display:"flex",alignItems:"center",justifyContent:"center"}}>
            <BbotMark size={38} tile="transparent"/></div>}
      <div style={{padding:"16px 18px 18px"}}>
        {nm && <div style={{fontSize:19,fontWeight:800,color:C.navy,letterSpacing:-.2}}>{nm}</div>}
        {meta && <div style={{fontSize:12,color:C.gray500,marginTop:3}}>{meta}</div>}
        <div style={{display:"flex",gap:8,flexWrap:"wrap",alignItems:"center",marginTop:11}}>
          {act && <span style={{fontSize:10.5,background:C.blueFaint,color:C.blue,border:"0.5px solid "+C.blueLight,padding:"3px 10px",borderRadius:99,fontWeight:700,letterSpacing:.4,textTransform:"uppercase"}}>{act}</span>}
          {isSkel && <span style={{fontSize:10.5,background:C.coralFaint,color:C.coral,border:"0.5px solid "+C.coralLight,padding:"3px 10px",borderRadius:99,fontWeight:700,letterSpacing:.4,textTransform:"uppercase"}}>BBOT movement tracking</span>}
          {stamp && <span style={{fontSize:11,color:C.gray400}}>{stamp}</span>}
        </div>
        <div style={{display:"flex",gap:8,marginTop:15,flexWrap:"wrap"}}>
          <Btn v="primary" style={{fontSize:12.5}} onClick={function(){ bbotShareClip(clip, null); }}>Share this clip</Btn>
          <Btn v="ghost" style={{fontSize:12.5}} onClick={onClose}>Explore BBOT</Btn>
        </div>
      </div>
    </Card>
    <div style={{fontSize:10.5,color:C.gray400,lineHeight:1.65,marginTop:14,textAlign:"center"}}>
      Shared from BBOT by 643 Sports MGMT. This footage is provided for viewing only and may not
      be downloaded, copied or redistributed.
    </div>
  </div></div>;
}

// THE ARTICLE MASTHEAD -- one component, used by BOTH the session report and the blog post.
//
// Luis, 2026-10-08: "the blogs need to have the same logo 'bbot powered by...' as session
// reports." They were already drawing the same 220px band with the same 56px mark, as two
// separate copies -- so the moment the report's masthead was rebuilt as a lockup the blog was
// left behind, which is exactly the drift that produced the request. Extracted so there is one
// place to change and no second copy to forget. [[one-home-per-value]]
//
// A POST WITH A COVER IMAGE KEEPS ITS IMAGE. Replacing a writer's chosen photograph with a logo
// would be branding at the cost of the thing the reader came for. The lockup sits over the
// bottom of the image on a dark scrim instead, so BBOT is on the masthead either way -- which is
// what was actually asked for -- without the photo losing its place.
function BbotArticleHero({ image }){
  var lockup = (
    <div style={{display:"flex",flexDirection:"column",alignItems:"center",gap:14}}>
      <BbotMark size={image?52:96} tile="transparent"/>
      <div style={{textAlign:"center"}}>
        <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:image?22:40,fontWeight:800,color:C.white,letterSpacing:image?4:7,lineHeight:1,textIndent:image?4:7}}>BBOT</div>
        <div style={{fontSize:image?9:10.5,color:"rgba(255,255,255,.72)",letterSpacing:2.4,textTransform:"uppercase",marginTop:image?6:9,fontWeight:600}}>
          Powered by 643 Sports MGMT
        </div>
      </div>
    </div>
  );
  if(image){
    return <div style={{position:"relative",width:"100%",borderRadius:14,overflow:"hidden"}}>
      <img src={image} alt="" style={{width:"100%",height:320,objectFit:"cover",display:"block"}}/>
      {/* The scrim is what makes white type legible over an unknown photograph. Without it the
          lockup is readable on a dark image and invisible on a bright one. */}
      <div style={{position:"absolute",left:0,right:0,bottom:0,paddingBottom:18,paddingTop:52,
                   display:"flex",justifyContent:"center",
                   background:"linear-gradient(to bottom,rgba(22,36,61,0),rgba(22,36,61,.82))"}}>
        {lockup}
      </div>
    </div>;
  }
  return <div style={{width:"100%",borderRadius:14,background:"linear-gradient(135deg,"+C.navy+","+C.blue+")",display:"flex",alignItems:"center",justifyContent:"center",padding:"44px 20px 38px"}}>
    {lockup}
  </div>;
}

// THE COVER IMAGE CONTROL -- one component, used by the blog editor and the session report.
//
// LUIS, 2026-10-08: "cover images can always be changed by admin, note that and make it
// doable." It was not doable in any practical sense: the blog editor offered a bare "Hero image
// URL" text box, which requires already having the picture hosted somewhere on the internet.
// A phone photo or a flyer -- the two things an operator actually has -- could not be used at
// all. This uploads from the device, shows what is currently set, and can clear it again.
//
// ALWAYS CHANGEABLE, INCLUDING BACK TO NOTHING. "Change" has to include removal, otherwise the
// first picture set is permanent and a wrong one can only be replaced, never withdrawn. Clearing
// returns the article to the BBOT lockup, which is the designed default rather than a blank.
//
// Resized before it is stored, for the same reason the event pictures are: the image lives in
// the row as base64, so an unresized camera photo is carried by every query that reads it. See
// bbotDownscaleImage. 1200px is generous for a 320px-tall masthead on a retina screen.
function BbotCoverImageControl({ value, onChange, label }){
  var [busy, setBusy] = useState(false);
  var [err, setErr] = useState("");
  return <div>
    <div style={{fontSize:11,color:C.gray500,fontWeight:600,marginBottom:6,letterSpacing:.5}}>
      {label || "COVER IMAGE"} <span style={{fontWeight:400,textTransform:"none",letterSpacing:0}}>— optional; without one the article leads with the BBOT lockup</span>
    </div>
    {value && <div style={{position:"relative",marginBottom:8}}>
      <img src={value} alt="" style={{width:"100%",maxHeight:180,objectFit:"cover",borderRadius:8,display:"block",border:"1px solid "+C.border}}/>
    </div>}
    <div style={{display:"flex",gap:8,flexWrap:"wrap",alignItems:"center"}}>
      <label style={{display:"inline-block",padding:"7px 14px",borderRadius:7,border:"1px solid "+C.navy,
                     background:C.white,color:C.navy,fontSize:12,fontWeight:700,
                     cursor:busy?"wait":"pointer",opacity:busy?.6:1}}>
        {busy ? "Working\u2026" : (value ? "Replace image" : "Upload image")}
        <input type="file" accept="image/*" disabled={busy} style={{display:"none"}} onChange={function(e){
          var f = e.target.files && e.target.files[0];
          e.target.value = "";
          if(!f) return;
          setErr(""); setBusy(true);
          bbotDownscaleImage(f, 1200).then(function(dataUrl){
            setBusy(false);
            onChange(dataUrl);
          }).catch(function(x){
            setBusy(false);
            // SAY WHY. A file picker that silently does nothing reads as a broken button, and
            // the usual cause -- picking a PDF or a HEIC the browser cannot decode -- is one the
            // operator can fix immediately if told.
            setErr((x && x.message) || "that image could not be read");
          });
        }}/>
      </label>
      {value && <button type="button" onClick={function(){ setErr(""); onChange(""); }}
        style={{padding:"7px 12px",borderRadius:7,border:"1px solid "+C.border,background:C.white,
                color:C.gray500,fontSize:12,fontWeight:600,cursor:"pointer"}}>Remove</button>}
    </div>
    {err && <div style={{fontSize:11,color:C.coral,marginTop:6}}>{err}</div>}
    <input value={value||""} onChange={function(e){ onChange(e.target.value); }}
      placeholder="\u2026or paste an image URL"
      style={{width:"100%",marginTop:8,padding:"7px 10px",border:"1px solid "+C.border,
              borderRadius:6,fontSize:12,fontFamily:"inherit"}}/>
  </div>;
}

// THE PUBLIC PLAYER PAGE -- what someone with no account sees of a player.
//
// RULED BY LUIS 2026-10-08: "you can only make public player name, position and HS class,
// everything else blocked to non staff or coaches" -- plus "the most recent video (skeletons &
// clips) should ALSO be visible to anyone".
//
// A SEPARATE, SMALL COMPONENT RATHER THAN A MODE ON ProfilePage. The real profile is a very
// large component that assumes a signed-in viewer (it reads cu.id to decide whether the profile
// is your own, among much else) and it draws evaluations, performance history, notes, feed and
// contact details. Threading a "public" flag through it would mean every one of those branches
// being correct forever, and a single branch that forgets is a disclosure. What is public is
// SHORT, so it is safer to write the short thing than to subtract from the long one.
//
// The facts come from bbot_players_public -- the view, not bbot_users -- so this page cannot
// show a field the ruled tier does not contain even if someone later adds one to the table.
// [[anon-key-is-the-whole-boundary]]
function PublicPlayerView({playerId, go, onClose}){
  var wS=useState(null); var who=wS[0], setWho=wS[1];
  var cS=useState([]);  var vids=cS[0], setVids=cS[1];
  var sS=useState("loading"); var st=sS[0], setSt=sS[1];

  useEffect(function(){
    if(!playerId) return;
    var dead=false;
    fetch(SUPABASE_URL+"/rest/v1/bbot_players_public?id=eq."+encodeURIComponent(String(playerId))+"&limit=1",
          {headers:sbHeaders()})
      .then(function(r){ if(!r.ok) throw new Error("HTTP "+r.status); return r.json(); })
      .then(function(rows){
        if(dead) return;
        if(!Array.isArray(rows)||!rows.length){ setSt("missing"); return; }
        setWho(rows[0]); setSt("ok");
      })
      .catch(function(){ if(!dead) setSt("error"); });

    // THE MOST RECENT OF EACH KIND, which is what was ruled -- not the whole library. A visitor
    // sees the latest clip and the latest skeleton; the full set stays behind an account.
    fetch(SUPABASE_URL+"/rest/v1/bbot_clips?player_id=eq."+encodeURIComponent(String(playerId))+
          "&approved=is.true&order=created_at.desc&limit=30&select=id,clip_type,action_type,clip_object_key",
          {headers:sbHeaders()})
      .then(function(r){ return r.ok?r.json():[]; })
      .then(function(rows){
        var all=rows||[];
        var pick=function(skel){
          return all.filter(function(c){
            return c.clip_object_key && (String(c.clip_type)==="skeleton")===skel;
          })[0]||null;
        };
        var want=[pick(false),pick(true)].filter(Boolean);
        if(!want.length) return;
        Promise.all(want.map(function(c){
          return fetch(BACKEND_URL+"/r2-read-url?objectKey="+encodeURIComponent(c.clip_object_key))
            .then(function(x){return x.json();})
            .then(function(d){ return (d&&d.url)?{id:c.id,url:d.url,skel:String(c.clip_type)==="skeleton",label:(c.action_type||"").replace(/_/g," ")}:null; })
            .catch(function(){ return null; });
        })).then(function(out){ if(!dead) setVids(out.filter(Boolean)); });
      })
      .catch(function(){});
    return function(){ dead=true; };
  },[playerId]);

  var wrap={background:C.gray50,padding:"28px 16px 40px",minHeight:"70vh"};
  if(st==="loading") return <div style={wrap}><div style={{maxWidth:760,margin:"0 auto"}}>
    <Card style={{padding:28,textAlign:"center",color:C.gray500,fontSize:13}}>Loading&hellip;</Card></div></div>;
  if(st!=="ok") return <div style={wrap}><div style={{maxWidth:760,margin:"0 auto"}}>
    <Card style={{padding:28,textAlign:"center"}}>
      <BbotMark size={44}/>
      <div style={{fontSize:15,fontWeight:700,color:C.navy,margin:"14px 0 6px"}}>This player page isn&rsquo;t available</div>
      <div style={{fontSize:13,color:C.gray500,lineHeight:1.6,marginBottom:16}}>The link may be out of date.</div>
      <Btn v="ghost" onClick={onClose}>Go to 643 BBOT</Btn>
    </Card></div></div>;

  var nm=[who.first_name,who.last_name].filter(Boolean).join(" ");
  var meta=[who.position,who.position2,who.grad_year?("Class of "+who.grad_year):""].filter(Boolean).join(" \u00b7 ");

  return <div style={wrap}><div style={{maxWidth:760,margin:"0 auto"}}>
    <div style={{display:"flex",alignItems:"center",gap:9,marginBottom:14,cursor:"pointer"}} onClick={onClose}>
      <BbotMark size={30}/>
      <span style={{fontWeight:800,color:C.navy,letterSpacing:1.4,fontSize:15}}>BBOT</span>
      <span style={{fontSize:10.5,color:C.gray400,letterSpacing:1.2,textTransform:"uppercase"}}>643 Sports MGMT</span>
    </div>
    <Card style={{padding:0,overflow:"hidden"}}>
      <div style={{background:"linear-gradient(135deg,"+C.navy+","+C.blue+")",padding:"26px 20px 22px",textAlign:"center"}}>
        <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:26,fontWeight:800,color:C.white,letterSpacing:-.3}}>{nm}</div>
        {meta && <div style={{fontSize:12,color:"rgba(255,255,255,.78)",marginTop:6,letterSpacing:.5}}>{meta}</div>}
      </div>
      {vids.length>0 && <div style={{padding:"14px 14px 4px"}}>
        <div style={{fontSize:10,color:C.gray400,letterSpacing:1,textTransform:"uppercase",fontWeight:700,marginBottom:8}}>
          Most recent footage
        </div>
        <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(min(260px,100%),1fr))",gap:10}}>
          {vids.map(function(v){
            return <div key={v.id} style={{borderRadius:9,overflow:"hidden",background:C.navy,border:"0.5px solid "+C.border}}>
              {/* contain, so neither a portrait nor a wide clip is cropped */}
              <BbotPreviewVideo src={v.url} style={{width:"100%",height:210,objectFit:"contain",display:"block",background:C.navy}}/>
              <div style={{fontSize:9,letterSpacing:.8,textTransform:"uppercase",fontWeight:700,
                           color:C.gray500,background:C.white,padding:"6px 9px"}}>
                {v.skel ? "BBOT movement tracking" : "Clip"}{v.label?" \u00b7 "+v.label:""}
              </div>
            </div>;
          })}
        </div>
      </div>}
      {/* WHAT IS NOT HERE, SAID PLAINLY. A page that just omits the measurements reads as a
          player with none. Saying an account is required is both true and the honest ask. */}
      <div style={{padding:"16px 18px 18px"}}>
        <div style={{fontSize:12.5,color:C.gray600,lineHeight:1.65}}>
          Measured evaluations, session history and full footage for {who.first_name||"this player"} are
          available to signed-in coaches and staff.
        </div>
        <div style={{display:"flex",gap:8,marginTop:13,flexWrap:"wrap"}}>
          <Btn v="primary" style={{fontSize:12.5}} onClick={function(){ onClose(); go && go("auth"); }}>Sign in or create an account</Btn>
          <Btn v="ghost" style={{fontSize:12.5}} onClick={onClose}>Explore BBOT</Btn>
        </div>
      </div>
    </Card>
    <div style={{fontSize:10.5,color:C.gray400,lineHeight:1.65,marginTop:14,textAlign:"center"}}>
      Footage is provided for viewing only and may not be downloaded, copied or redistributed.
    </div>
  </div></div>;
}

// EVERY SHAREABLE ADDRESS IN BBOT, BUILT IN ONE PLACE.
//
// Luis, 2026-10-08: "whatever i copy needs to work." That is a harder requirement than "the
// Copy button works", and it is the right one. A person copies from wherever the address is --
// the button, or the browser's own address bar -- and until now those were two different URLs:
// the button gave a server path that previews correctly, the address bar gave a `#` URL that
// never can, because a fragment is not sent to a server and no crawler runs JavaScript.
//
// So the app now PUTS THE SHAREABLE ADDRESS IN THE ADDRESS BAR (see bbotSyncShareUrl). The two
// are the same string, and that string comes from here so they cannot drift.
//
// Short paths -- /r/, /c/, /p/ -- because a share link is read by people, and because Facebook
// caches a URL's preview for about a month from the FIRST time it sees it: it saw the old path
// while that route still carried a redirect it followed to the wrong tags. A cached wrong
// answer cannot be corrected by serving a right one, only by re-scraping through Facebook's own
// tools or by using an address it has never seen. The old paths still resolve, so nothing
// already pasted into a message or a QR code dies.
// READ A SHARE PATH OUT OF THE ADDRESS, whatever form it is in.
//
// The app has to understand /r/<id> itself, not just the server, for two reasons. A refresh on
// a shared page currently costs a round trip out to the backend and back through a redirect,
// which is a visible flicker for no gain. And if the rewrite that sends /r/* to the backend
// ever stops working, the request falls through to this app with a 200 and the landing page --
// a dead share link that reports no error anywhere. Parsing the path here means the link still
// opens the right thing in both cases.
//
// Accepts the long forms as well, so an address pasted from an older message is understood.
function bbotReadShareRoute(){
  if(typeof window==="undefined") return null;
  var h = window.location.hash||"";
  var hm = h.match(/^#(recap|clip|player)\/([^/?]+)/);
  if(hm) return {kind: hm[1]==="recap"?"recap":hm[1], id: decodeURIComponent(hm[2])};
  var pth = window.location.pathname||"";
  var pm = pth.match(/^\/(r|c|p)\/([^/?]+)\/?$/);
  if(pm) return {kind: pm[1]==="r"?"recap":pm[1]==="c"?"clip":"player", id: decodeURIComponent(pm[2])};
  var lm = pth.match(/^\/s\/(recap|clip)\/([^/?]+)\/?$/);
  if(lm) return {kind: lm[1], id: decodeURIComponent(lm[2])};
  return null;
}

function bbotShareUrl(kind, id){
  if(id==null) return "";
  var base=(typeof window!=="undefined")
    ? (window.location.origin+window.location.pathname).replace(/\/+$/,"")
    : "";
  var seg = kind==="clip" ? "c" : kind==="player" ? "p" : "r";
  return base+"/"+seg+"/"+encodeURIComponent(String(id));
}

// THE ADDRESS BAR IS A SHARE CONTROL WHETHER WE TREAT IT AS ONE OR NOT.
//
// `replaceState`, not `pushState`: this is the same page under a better name, not a new entry,
// so the Back button must still go wherever the reader came from rather than to the URL they
// were already looking at.
//
// The hash is cleared in the same call. Leaving `#recap/<id>` behind the new path would mean a
// refresh re-entering through the fragment and the address flipping back -- and the stale hash
// is exactly the thing being removed from a reader's reach.
function bbotSyncShareUrl(kind, id){
  if(typeof window==="undefined" || !window.history || !window.history.replaceState) return;
  try{
    var want = bbotShareUrl(kind,id).replace(window.location.origin,"");
    if(!want) return;
    if(window.location.pathname+window.location.hash !== want){
      window.history.replaceState({}, "", want);
    }
  }catch(e){}
}

// CLOSING HAS TO PUT THE ADDRESS BACK, or the path outlives the page it names. Once the address
// bar reads /r/<id>, clearing only the hash leaves that path in place -- so a reader who closed
// the report and then refreshed would be dropped straight back into it, and a link copied after
// closing would point at something they had deliberately left.
function bbotClearShareUrl(){
  if(typeof window==="undefined") return;
  try{
    if(window.history && window.history.replaceState){
      window.history.replaceState({}, "", window.location.pathname.replace(/^\/(r|c|p|s)\/.*$/, "/") || "/");
    } else {
      window.location.hash="";
    }
  }catch(e){ try{ window.location.hash=""; }catch(_){} }
}

function bbotDownscaleImage(file, maxEdge){
  maxEdge = maxEdge || 1400;
  return new Promise(function(resolve, reject){
    if(!file) return reject(new Error("no file"));
    if(!/^image\//.test(file.type||"")) return reject(new Error("that is not an image file"));
    if(file.size > 25*1024*1024) return reject(new Error("image too large (max 25MB)"));
    var fr = new FileReader();
    fr.onerror = function(){ reject(new Error("could not read the file")); };
    fr.onload = function(e){
      var img = new Image();
      img.onerror = function(){ reject(new Error("could not decode that image")); };
      img.onload = function(){
        try{
          var w = img.naturalWidth || img.width, h = img.naturalHeight || img.height;
          if(!w || !h) return reject(new Error("that image has no dimensions"));
          var sc = Math.min(1, maxEdge / Math.max(w, h));
          var cw = Math.round(w * sc), ch = Math.round(h * sc);
          var cv = document.createElement("canvas"); cv.width = cw; cv.height = ch;
          cv.getContext("2d").drawImage(img, 0, 0, cw, ch);
          // PNG screenshots keep their transparency; everything else takes JPEG's compression.
          var mime = (file.type === "image/png") ? "image/png" : "image/jpeg";
          resolve(cv.toDataURL(mime, 0.82));
        }catch(err){ reject(new Error("could not resize that image")); }
      };
      img.src = e.target.result;
    };
    fr.readAsDataURL(file);
  });
}

function EventsView({users, setUsers, cu, notify, go}){
  cu = cu || {};
  notify = notify || function(){};
  var [events, setEvents] = useState([]);
  var [loading, setLoading] = useState(true);
  var [form, setForm] = useState({name:"", event_type:"game", location:"", venue:"", start_date:"", start_time:"", end_date:"", cost:"", cost_position:"", cost_pitcher:"", requirements:"", notes:"", image_url:"", image_urls:[]});
  var [showForm, setShowForm] = useState(false);
  // Feature-detect the split-price columns so this is SAFE even if deployed before the DB
  // migration runs: if they don't exist yet, we show/behave exactly like the single-price form.
  var [splitPricing, setSplitPricing] = useState(false);
  // SAME SAFE SELF-ENABLE AS THE SPLIT PRICES. `image_url` may not exist yet; if it does not, the
  // picker stays hidden and the key is dropped from the payload, so PostgREST never sees a column
  // that is not there (which would 400 the whole save and lose the event).
  var [hasEventImage, setHasEventImage] = useState(false);
  var [hasEventGallery, setHasEventGallery] = useState(false);
  var [imgBusy, setImgBusy] = useState(false);
  var [expandedId, setExpandedId] = useState(null);
  var [editingId, setEditingId] = useState(null); // event id being edited (null = creating new)
  var [savingEvent, setSavingEvent] = useState(false); // in-flight guard: one write per click
  var [socialFor, setSocialFor] = useState(null); // event id whose social post is open
  var [registerFor, setRegisterFor] = useState(null); // event being registered for (modal)
  var [blastFor, setBlastFor] = useState(null);        // event id whose instructions-blast editor is open
  var [blastSubject, setBlastSubject] = useState("");
  var [blastBody, setBlastBody] = useState("");
  var [blastSending, setBlastSending] = useState(false);

  function openBlast(ev){
    setBlastFor(ev.id);
    setBlastSubject("Instructions — " + (ev.name||"Event"));
    // Default instructions template (admin edits before sending). Pulls event details in.
    var when=[ev.start_date, ev.start_time].filter(Boolean).join(" at ");
    setBlastBody(
      "<p>Your event is coming up"+(when?(" — <strong>"+when+"</strong>"):"")+".</p>"+
      "<p><strong>Where:</strong> "+((ev.venue||ev.location)||"TBD")+"</p>"+
      (ev.requirements?("<p><strong>What to bring / wear:</strong> "+ev.requirements+"</p>"):"")+
      "<p><strong>Check-in:</strong> Please arrive 30 minutes early to check in and warm up.</p>"+
      "<p>Your session will be filmed and evaluated by BBOT. Clips and your report will appear on your profile afterward.</p>"+
      "<p>See you there!</p>"
    );
  }
  function sendBlast(ev){
    var ids=(ev.attending_player_ids||[]);
    var emails=ids.map(function(pid){ var u=(users||[]).find(function(x){return String(x.id)===String(pid);}); return u&&u.email?u.email:null; }).filter(Boolean);
    if(emails.length===0){ notify("No registered player emails to send to","error"); return; }
    setBlastSending(true);
    fetch(BACKEND_URL+"/send-event-blast", {
      method:"POST", headers:Object.assign({},bbotAdminHeaders(),{"Content-Type":"application/json"}),
      body:JSON.stringify({ eventName:ev.name||"Event", subject:blastSubject, bodyHtml:blastBody, recipients:emails })
    }).then(function(r){return r.json();}).then(function(out){
      setBlastSending(false); setBlastFor(null);
      notify((out.sent||0)+" of "+(out.total||emails.length)+" instruction emails sent"+(out.failed?(" · "+out.failed+" failed"):""));
    }).catch(function(){ setBlastSending(false); notify("Could not send blast","error"); });
  }

  // Player registration: store size/alt/waiver on the event, assign an event number, persist,
  // then hand off to payment. Confirmation email fires after payment (see number+email note).
  // Uses the shared writers so this entry point can never diverge from the home-page one.
  function handleRegistered(ev, reg, onDone){ saveEventRegistration(ev, reg, setEvents, notify, onDone); }
  // Called when ATH/card payment is verified — flip the registration to paid.
  function handleEventPaid(ev, pid){ markEventRegistrationPaid(ev, pid, setEvents); }

  // Build a prepackaged, copyable promo post for an event (no fabricated claims).
  function buildEventPost(ev){
    var when = ev.start_date + (ev.end_date && ev.end_date!==ev.start_date ? (" – "+ev.end_date) : "");
    var lines = [];
    lines.push("📣 "+ev.name);
    if(ev.location) lines.push("📍 "+ev.location);
    if(when) lines.push("🗓️ "+when);
    if(ev.notes) lines.push("");
    if(ev.notes) lines.push(ev.notes);
    lines.push("");
    var pc=(ev.attending_player_ids||[]).length;
    if(pc>0) lines.push(pc+" player"+(pc===1?"":"s")+" already signed up.");
    lines.push("Get evaluated by BBOT.");
    // Registration link — where a player creates a profile and signs up for this event.
    var origin = (typeof window!=="undefined") ? (window.location.origin+window.location.pathname).replace(/\/+$/,"") : "https://www.643sportsmgmt.com";
    lines.push("");
    lines.push("👉 Create your profile & register: "+origin+"/#auth");
    var caption = lines.join("\n");
    var hashtags = ["643Baseball","BBOT","PRBaseball","Showcase","Tournament"];
    return {caption:caption, hashtags:hashtags};
  }

  // ONE REQUEST, THROUGH THE SERVER. This was four reads straight against `bbot_events` -- the
  // list plus three column probes that self-enable split pricing and the image gallery by reading
  // the HTTP status. All four depended on the `authenticated` SELECT grant that also leaked every
  // registrant's details, so `/events` answers both questions with the service key and the tab
  // keeps working after that grant is revoked. [[anon-caller-not-admin-view]]
  useEffect(function(){
    fetch(BACKEND_URL+"/events",{headers:bbotAdminHeaders()})
      .then(function(r){ if(!r.ok) throw new Error("HTTP "+r.status); return r.json(); })
      .then(function(j){
        var rows=(j&&j.events)||[];
        // The admin tab lists newest first; the endpoint sorts ascending for the player page.
        setEvents(rows.slice().sort(function(a,b){ return String(b.start_date||"").localeCompare(String(a.start_date||"")); }));
        var cols=(j&&j.columns)||{};
        setSplitPricing(!!cols.cost_pitcher);
        setHasEventImage(!!cols.image_url);
        setHasEventGallery(!!cols.image_urls);
        setLoading(false);
      })
      .catch(function(){ setEvents([]); setLoading(false); });
  }, []);

  function resetForm(){
    setForm({name:"", event_type:"game", location:"", venue:"", start_date:"", start_time:"", end_date:"", cost:"", cost_position:"", cost_pitcher:"", requirements:"", notes:"", image_url:"", image_urls:[]});
    setEditingId(null);
  }
  // Load an existing event into the form to edit it (rather than only being able to create).
  function startEdit(ev){
    setForm({name:ev.name||"", event_type:ev.event_type||"game", location:ev.location||"", venue:ev.venue||"",
      start_date:ev.start_date||"", start_time:ev.start_time||"", end_date:ev.end_date||"",
      cost:ev.cost!=null?String(ev.cost):"",
      cost_position:ev.cost_position!=null?String(ev.cost_position):"", cost_pitcher:ev.cost_pitcher!=null?String(ev.cost_pitcher):"",
      requirements:ev.requirements||"", notes:ev.notes||"", image_url:ev.image_url||"",
      image_urls:Array.isArray(ev.image_urls)?ev.image_urls:[]});
    setEditingId(ev.id); setShowForm(true);
    if(typeof window!=="undefined" && window.scrollTo) window.scrollTo({top:0,behavior:"smooth"});
  }
  // `bbotWrite` RESOLVES TO THE ROWS, NOT TO A RESPONSE. Both branches below used to chain
  // `.then(function(r){return r.json();})` onto it -- but it already unwraps the response and
  // hands back `j.rows || []`, and an Array has no `.json()`. So every save threw a TypeError
  // into the catch and reported "Could not update event" / "Could not save event" while the
  // write had ALREADY SUCCEEDED.
  //
  // THAT IS WHERE THE DUPLICATE EVENTS CAME FROM. Five identical "Perkiomen School Tryout" rows
  // were created inside 49 seconds on 2026-09-29 -- Save, "failed", Save, "failed". The error
  // message was the bug, and the admin was doing exactly the right thing in response to it.
  //
  // AND A GUARD, because the message was only half of it: a save that takes a moment invites a
  // second click, and nothing stopped the second write. [[silent-failure-write-sweep]]
  function saveEvent(){
    if(savingEvent) return;
    if(!form.name||!form.start_date){ notify("Name and start date required","error"); return; }
    // Build the DB payload. When split pricing exists, keep `cost` as a sensible legacy
    // fallback (=position, else pitcher). When it doesn't, drop the split keys entirely so
    // PostgREST never sees a non-existent column (which would 400 the whole save).
    var payload=Object.assign({},form);
    if(splitPricing){
      var cp=String(form.cost_position||"").trim(), ck=String(form.cost_pitcher||"").trim();
      payload.cost=String(form.cost||"").trim()||cp||ck;
    } else {
      delete payload.cost_position; delete payload.cost_pitcher;
    }
    // `_covers` is a UI-only map (full picture -> its small cover) used to keep the cover in step
    // when a picture is deleted. It must never reach PostgREST, which would 400 on an unknown
    // column and lose the whole save.
    delete payload._covers;
    if(!hasEventImage){ delete payload.image_url; delete payload.image_urls; }
    else if(!hasEventGallery) delete payload.image_urls;
    if(editingId!=null){
      // EDIT existing event — PATCH the row by id (only the editable fields in `payload`).
      setSavingEvent(true);
      bbotWrite("bbot_events","update",payload,"id=eq." + encodeURIComponent(String(editingId))).then(function(rows){
        var upd=(Array.isArray(rows)&&rows[0])?rows[0]:null;
        setEvents(function(list){return list.map(function(e){return e.id===editingId?(upd?Object.assign({},e,upd):Object.assign({},e,payload)):e;});});
        resetForm(); setShowForm(false); notify("Event updated");
      }).catch(function(err){
        notify("Could not update event: "+((err&&err.message)||"unknown"),"error");
      }).then(function(){ setSavingEvent(false); });
      return;
    }
    setSavingEvent(true);
    bbotWrite("bbot_events","insert",[payload],null).then(function(rows){
      setEvents(function(e){return (Array.isArray(rows)?rows:[]).concat(e);});
      resetForm();
      setShowForm(false);
      notify("Event added");
    }).catch(function(err){
      // NAME THE FAILURE. "Could not save event" with no cause is what sent an admin back to
      // click Save four more times.
      notify("Could not save event: "+((err&&err.message)||"unknown"),"error");
    }).then(function(){ setSavingEvent(false); });
  }

  function markEventPaid(ev, pid){
    if(!window.confirm("Mark this player as PAID for "+(ev.name||"this event")+"? Use for cash/ATH/offline payments.")) return;
    var regs=Object.assign({}, ev.event_registrations||{});
    regs[String(pid)]=Object.assign({}, regs[String(pid)]||{}, {paid:true, paidBy:"admin", paidAt:new Date().toISOString()});
    bbotWrite("bbot_events","update",{ event_registrations: regs },"id=eq." + encodeURIComponent(String(ev.id))).then(function(){
      setEvents(function(es){return es.map(function(e){return e.id===ev.id?Object.assign({},e,{event_registrations:regs}):e;});});
      notify("Marked paid");
    }).catch(function(){ notify("Could not update","error"); });
  }
  function togglePublished(ev){
    var next = !(ev.published===true);
    bbotWrite("bbot_events","update",{ published: next },"id=eq." + encodeURIComponent(String(ev.id))).then(function(){
      setEvents(function(es){return es.map(function(e){return e.id===ev.id?Object.assign({},e,{published:next}):e;});});
      notify(next?"Event launched — now live to players":"Event hidden from players");
    }).catch(function(){ notify("Could not update event","error"); });
  }
  function toggleAttending(ev, asPlayer){
    var key = asPlayer ? "attending_player_ids" : "attending_coach_ids";
    var current = ev[key] || [];
    var uid = String(cu.id);
    var updated = current.indexOf(uid)>=0 ? current.filter(function(x){return x!==uid;}) : current.concat([uid]);
    // State only moves on success, so this never lied -- but with no catch a failed click did
    // NOTHING and said nothing, which reads as a dead button.
    bbotWrite("bbot_events","update",{[key]: updated},"id=eq." + Number(ev.id)).then(function(){
      setEvents(function(es){return es.map(function(e){return e.id===ev.id?Object.assign({},e,{[key]:updated}):e;});});
      notify(updated.indexOf(uid)>=0?"Marked attending":"Removed");
    }).catch(function(){ notify("Could not update attendance","error"); });
  }

  function deleteEvent(id){
    if(!window.confirm("Delete this event?")) return;
    bbotWrite("bbot_events","delete",null,"id=eq." + Number(id)).then(function(){
      setEvents(function(es){return es.filter(function(e){return e.id!==id;});});
    }).catch(function(){ notify("Could not delete the event","error"); });
  }

  return (
    <div>
      <SectionHeader>Events & Tournaments</SectionHeader>
      <div style={{fontSize:12,color:C.gray500,marginBottom:14}}>Showcases, tryouts, and tournaments. Coaches can mark attendance to surface them in their pre-event recon.</div>

      <Btn v="primary" style={{fontSize:12,marginBottom:14}} onClick={function(){ if(showForm){ resetForm(); setShowForm(false); } else { resetForm(); setShowForm(true); } }}>{showForm?"Cancel":"+ Add Event"}</Btn>

      {showForm && (
        <Card style={{padding:14,marginBottom:14}}>
          <div style={{fontSize:13,fontWeight:700,color:C.navy,marginBottom:10}}>{editingId!=null?"Edit event":"New event"}</div>
          <input value={form.name} onChange={function(e){setForm(Object.assign({},form,{name:e.target.value}));}} placeholder="Event name" style={{width:"100%",padding:"8px 10px",marginBottom:8,border:"1px solid "+C.border,borderRadius:6,fontSize:13,boxSizing:"border-box"}}/>
          <div style={{display:"flex",gap:8,marginBottom:8}}>
            <select value={form.event_type} onChange={function(e){var t=e.target.value; setForm(Object.assign({},form,{event_type:t},(t==="pickup_game")?Object.assign({},!form.requirements?{requirements:PICKUP_GAME_FORMAT}:{}):{}));}} style={{flex:1,padding:"8px 10px",border:"1px solid "+C.border,borderRadius:6,fontSize:13,background:C.white}}>
              <option value="practice">Practice</option>
              <option value="game">Game</option>
              <option value="pickup_game">Pickup Game (video + report + jersey · admin-set rate)</option>
              <option value="showcase">Showcase</option>
            </select>
            {!splitPricing && <input value={form.cost} onChange={function(e){setForm(Object.assign({},form,{cost:e.target.value}));}} placeholder="Cost (e.g. 200)" style={{flex:1,padding:"8px 10px",border:"1px solid "+C.border,borderRadius:6,fontSize:13,boxSizing:"border-box"}}/>}
          </div>
          {splitPricing && (
            <div style={{display:"flex",gap:8,marginBottom:8}}>
              <input value={form.cost_position} onChange={function(e){setForm(Object.assign({},form,{cost_position:e.target.value}));}} placeholder="Position player price (e.g. 200)" style={{flex:1,padding:"8px 10px",border:"1px solid "+C.border,borderRadius:6,fontSize:13,boxSizing:"border-box"}}/>
              <input value={form.cost_pitcher} onChange={function(e){setForm(Object.assign({},form,{cost_pitcher:e.target.value}));}} placeholder="Pitcher price (e.g. 175)" style={{flex:1,padding:"8px 10px",border:"1px solid "+C.border,borderRadius:6,fontSize:13,boxSizing:"border-box"}}/>
            </div>
          )}
          <input value={form.location} onChange={function(e){setForm(Object.assign({},form,{location:e.target.value}));}} placeholder="Location (e.g. Guaynabo PR)" style={{width:"100%",padding:"8px 10px",marginBottom:8,border:"1px solid "+C.border,borderRadius:6,fontSize:13,boxSizing:"border-box"}}/>
          <input value={form.venue} onChange={function(e){setForm(Object.assign({},form,{venue:e.target.value}));}} placeholder="Venue / Field name" style={{width:"100%",padding:"8px 10px",marginBottom:8,border:"1px solid "+C.border,borderRadius:6,fontSize:13,boxSizing:"border-box"}}/>
          <div style={{display:"flex",gap:8,marginBottom:8}}>
            <input type="date" value={form.start_date} onChange={function(e){setForm(Object.assign({},form,{start_date:e.target.value}));}} style={{flex:1,padding:"8px 10px",border:"1px solid "+C.border,borderRadius:6,fontSize:13}}/>
            <input type="time" value={form.start_time} onChange={function(e){setForm(Object.assign({},form,{start_time:e.target.value}));}} style={{flex:1,padding:"8px 10px",border:"1px solid "+C.border,borderRadius:6,fontSize:13}}/>
            <input type="date" value={form.end_date} onChange={function(e){setForm(Object.assign({},form,{end_date:e.target.value}));}} title="End date (multi-day showcase)" style={{flex:1,padding:"8px 10px",border:"1px solid "+C.border,borderRadius:6,fontSize:13}}/>
          </div>
          {/* EVENT PICTURE. A flyer or a field photo, resized before it is stored -- see
              bbotDownscaleImage. Hidden entirely when the column does not exist yet, so this cannot
              offer a control whose save would fail. */}
          {/* MULTIPLE PICTURES, AND THE FIRST ONE PAYS FOR THE LISTS.
              Pictures live in the row as base64, so every list query carries whatever is in
              `image_url`. The gallery therefore goes in `image_urls` (read only on the event
              page) and `image_url` holds a SMALL cover derived from the first picture -- 520px
              instead of 1200px, roughly a tenth of the bytes. That is what keeps the admin list,
              the logged-in home and the public landing section fast however many pictures an
              event has.
              Capped at EVENT_IMG_MAX: past that the row gets heavy enough to slow the event page
              itself, and nobody reads a ten-picture flyer. */}
          {hasEventImage && (
            <div style={{marginBottom:8}}>
              <label style={{fontSize:11,fontWeight:600,color:C.gray700,letterSpacing:.5,display:"block",marginBottom:5}}>
                PICTURES {(form.image_urls||[]).length>0 && <span style={{color:C.gray400,fontWeight:500}}>\u00b7 {(form.image_urls||[]).length} of {EVENT_IMG_MAX}</span>}
              </label>
              {(form.image_urls||[]).length>0 && (
                <div style={{display:"flex",gap:8,flexWrap:"wrap",marginBottom:8}}>
                  {(form.image_urls||[]).map(function(src,i){
                    return (
                      <div key={i} style={{position:"relative"}}>
                        <img src={src} alt={"event picture "+(i+1)}
                          style={{width:108,height:72,objectFit:"cover",borderRadius:8,border:"1px solid "+C.border,background:C.gray100,display:"block"}}/>
                        {i===0 && <span style={{position:"absolute",left:4,bottom:4,background:"rgba(0,0,0,.6)",color:"#fff",fontSize:9,fontWeight:700,padding:"1px 5px",borderRadius:4,letterSpacing:.4}}>COVER</span>}
                        <button type="button" title="Remove this picture" onClick={function(){
                          setForm(function(prev){
                            var next=(prev.image_urls||[]).slice(); next.splice(i,1);
                            // THE COVER FOLLOWS THE FIRST PICTURE. Deleting picture one must not
                            // leave the old cover on the card -- it would show a picture that is
                            // no longer in the gallery.
                            return Object.assign({},prev,{image_urls:next,image_url:next.length?(prev._covers&&prev._covers[next[0]])||next[0]:""});
                          });
                        }} style={{position:"absolute",top:-6,right:-6,width:20,height:20,borderRadius:"50%",border:"none",background:C.coral,color:"#fff",fontSize:12,lineHeight:"20px",fontWeight:700,cursor:"pointer",padding:0}}>\u00d7</button>
                      </div>
                    );
                  })}
                </div>
              )}
              {(form.image_urls||[]).length < EVENT_IMG_MAX && (
                <button type="button" disabled={imgBusy} onClick={function(){
                  var input=document.createElement("input");
                  input.type="file"; input.accept="image/*"; input.multiple=true;
                  input.onchange=function(e){
                    var files=Array.prototype.slice.call((e.target.files||[]));
                    if(!files.length) return;
                    var room=EVENT_IMG_MAX-((form.image_urls||[]).length);
                    if(files.length>room){ notify("Only "+room+" more picture"+(room===1?"":"s")+" will be added (max "+EVENT_IMG_MAX+")","error"); files=files.slice(0,room); }
                    setImgBusy(true);
                    // GALLERY SIZE AND COVER SIZE, from the same file. Resizing twice is cheaper
                    // than shipping a 1200px picture into every list query.
                    Promise.all(files.map(function(f){
                      return Promise.all([bbotDownscaleImage(f,1200), bbotDownscaleImage(f,520)])
                        .then(function(pair){ return {full:pair[0], cover:pair[1]}; });
                    })).then(function(added){
                      setImgBusy(false);
                      setForm(function(prev){
                        var next=(prev.image_urls||[]).concat(added.map(function(a){return a.full;}));
                        var covers=Object.assign({},prev._covers||{});
                        added.forEach(function(a){ covers[a.full]=a.cover; });
                        return Object.assign({},prev,{image_urls:next,_covers:covers,
                          image_url: prev.image_url || added[0].cover});
                      });
                    }).catch(function(err){
                      setImgBusy(false);
                      // THE REASON, NOT "upload failed". Too big, not an image and undecodable are
                      // three different things the admin can act on differently.
                      notify(err&&err.message?("Could not add that picture \u2014 "+err.message):"Could not add that picture","error");
                    });
                  };
                  input.click();
                }} style={{padding:"8px 14px",background:C.white,border:"1px dashed "+C.border,borderRadius:8,fontSize:12,fontWeight:600,color:C.gray600,cursor:imgBusy?"wait":"pointer"}}>
                  {imgBusy?"Resizing\u2026":((form.image_urls||[]).length?"+ Add more pictures":"+ Add pictures")}
                </button>
              )}
            </div>
          )}
          <textarea value={form.requirements} onChange={function(e){setForm(Object.assign({},form,{requirements:e.target.value}));}} placeholder="Requirements — special rules, pant color, what to bring, etc." rows={2} style={{width:"100%",padding:"8px 10px",marginBottom:8,border:"1px solid "+C.border,borderRadius:6,fontSize:13,boxSizing:"border-box",fontFamily:"inherit"}}/>
          <textarea value={form.notes} onChange={function(e){setForm(Object.assign({},form,{notes:e.target.value}));}} placeholder="Notes (age groups, format)" rows={2} style={{width:"100%",padding:"8px 10px",marginBottom:8,border:"1px solid "+C.border,borderRadius:6,fontSize:13,boxSizing:"border-box",fontFamily:"inherit"}}/>
          <Btn v="primary" style={{fontSize:12}} disabled={savingEvent} onClick={saveEvent}>{savingEvent?"Saving…":(editingId!=null?"Update Event":"Save Event")}</Btn>
        </Card>
      )}

      {loading ? <SkeletonCard/> : events.length===0 ? (
        <EmptyCard icon="E" title="No Events" sub="Add a tournament, showcase, or tryout."/>
      ) : (
        <div style={{display:"flex",flexDirection:"column",gap:8}}>
          {events.map(function(ev){
            var coachCount = (ev.attending_coach_ids||[]).length;
            var playerCount = (ev.attending_player_ids||[]).length;
            var isCoachAttending = (ev.attending_coach_ids||[]).indexOf(String(cu.id))>=0;
            return (
              <Card key={ev.id} style={{padding:14}}>
                {/* THE PICTURE LEADS THE CARD when there is one, and takes no space when there is
                    not -- no placeholder frame, no "no image" line. Object-fit cover so a portrait
                    flyer and a landscape field photo both fill the strip without distorting. */}
                {ev.image_url && (
                  <img src={ev.image_url} alt={ev.name||"event"}
                       style={{width:"100%",height:160,objectFit:"cover",borderRadius:8,
                               display:"block",marginBottom:11,background:C.gray100}}/>
                )}
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",gap:10,flexWrap:"wrap"}}>
                  <div style={{flex:1,minWidth:200}}>
                    <div style={{display:"flex",alignItems:"center",gap:8,flexWrap:"wrap",marginBottom:4}}>
                      <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:15,color:C.navy,letterSpacing:.5}}>{ev.name}</div>
                      {ev.event_type && <span style={{padding:"2px 8px",background:ev.event_type==="pickup_game"?C.coral:C.blueFaint,color:ev.event_type==="pickup_game"?C.white:C.blue,borderRadius:99,fontSize:9,fontWeight:700,letterSpacing:.5,textTransform:"uppercase"}}>{ev.event_type==="pickup_game"?"Pickup Game":ev.event_type}</span>}
                      {(function(){
                        var clean=function(v){ return (v!=null&&String(v).trim()!=="")?String(v).replace(/[^0-9.]/g,""):null; };
                        var pos=clean(ev.cost_position), pit=clean(ev.cost_pitcher), base=clean(ev.cost);
                        var badge={padding:"2px 8px",background:C.gray100,color:C.navy,borderRadius:99,fontSize:10,fontWeight:700};
                        if(pos||pit) return <span style={badge}>Pos ${pos||base||"—"} · Pitch ${pit||base||"—"}</span>;
                        return base?<span style={badge}>${base}</span>:null;
                      })()}
                    </div>
                    <div style={{fontSize:11,color:C.gray500,marginBottom:6}}>{[ (ev.venue||ev.location), ev.start_date, ev.start_time, ev.end_date && ev.end_date!==ev.start_date?"→ "+ev.end_date:null].filter(Boolean).join(" · ")}</div>
                    {ev.requirements && <p style={{fontSize:12,color:C.gray700,margin:"0 0 6px 0",lineHeight:1.5}}><strong style={{color:C.navy}}>What to know: </strong>{ev.requirements}</p>}
                    {ev.notes && <p style={{fontSize:12,color:C.gray600,margin:"0 0 6px 0",lineHeight:1.5}}>{ev.notes}</p>}
                    <div style={{display:"flex",gap:6,flexWrap:"wrap",fontSize:10}}>
                      {coachCount>0 && <span style={{padding:"2px 7px",background:C.blueFaint,color:C.blue,borderRadius:99,fontWeight:600}}>{coachCount} coach{coachCount===1?"":"es"} attending</span>}
                      {playerCount>0 && <span style={{padding:"2px 7px",background:C.coralFaint,color:C.coral,borderRadius:99,fontWeight:600}}>{playerCount} player{playerCount===1?"":"s"} attending</span>}
                      {(cu.type==="staff"||bbotIsAdmin(cu)) && ev.published!==true && <span style={{padding:"2px 7px",background:C.gray100,color:C.gray500,borderRadius:99,fontWeight:600,fontStyle:"italic"}}>Draft — not yet launched</span>}
                    </div>
                  </div>
                  <div style={{display:"flex",gap:6,flexShrink:0}}>
                    {(cu.type==="coach"||cu.type==="staff") && (
                      <Btn v={isCoachAttending?"ghost":"primary"} style={{fontSize:11,padding:"6px 12px"}} onClick={function(){toggleAttending(ev,false);}}>{isCoachAttending?"✓ Attending":"Mark Attending"}</Btn>
                    )}
                    {cu.type==="player" && (function(){
                      var reg=(ev.event_registrations||{})[String(cu.id)];
                      if(reg) return <span style={{fontSize:11,padding:"6px 12px",color:C.green,fontWeight:700}}>✓ Registered (#{(ev.event_numbers||{})[String(cu.id)]||"—"})</span>;
                      if(ev.published!==true) return <span style={{fontSize:11,padding:"6px 12px",color:C.gray400,fontStyle:"italic"}}>Not open yet</span>;
                      return <Btn v="primary" style={{fontSize:11,padding:"6px 12px"}} onClick={function(){setRegisterFor(ev);}}>Register</Btn>;
                    })()}
                    {/* THE SHAREABLE LINK — what goes into a QR code. Only offered once the event
                        is LIVE, because `bbot_events_public` carries published rows only: a link
                        copied from a draft opens "this event isn't open yet", which looks like a
                        broken link rather than an unlaunched event. Offering it only when it
                        works is the honest order. */}
                    {(cu.type==="staff"||bbotIsAdmin(cu)) && ev.published===true && (
                      <Btn v="ghost" style={{fontSize:11,padding:"6px 10px"}}
                        title="Copy the public link for this event — paste into a QR code generator"
                        onClick={function(){
                          var base=(typeof window!=="undefined")
                            ? (window.location.origin+window.location.pathname).replace(/\/+$/,"") : "";
                          var url=base+"/#event/"+encodeURIComponent(String(ev.id));
                          var done=function(){ notify("Event link copied — paste it into your QR generator"); };
                          try{
                            if(navigator.clipboard&&navigator.clipboard.writeText) navigator.clipboard.writeText(url).then(done,function(){ window.prompt("Copy this event link:",url); });
                            else window.prompt("Copy this event link:",url);
                          }catch(e){ window.prompt("Copy this event link:",url); }
                        }}>🔗 Copy link</Btn>
                    )}
                    {/* EMAIL THE ROSTER — ON THE CARD, NOT BURIED.
                        This lived inside the "View signups" panel, which an admin has to expand
                        first, and that panel swaps the whole toolset for "No players have signed
                        up yet" when the count is zero -- so the feature was invisible twice over
                        and read as missing. It is an action ON the event, so it sits with the
                        other actions on the event.
                        It stays visible at zero registrations and says so rather than vanishing;
                        an absent button is indistinguishable from an absent feature. */}
                    {(cu.type==="staff"||bbotIsAdmin(cu)) && (
                      <Btn v="ghost" style={{fontSize:11,padding:"6px 10px",
                             color:playerCount?C.coral:C.gray400,
                             borderColor:playerCount?C.coral:C.border}}
                        title={playerCount?("Email all "+playerCount+" registered player"+(playerCount===1?"":"s")):"Nobody is registered for this event yet"}
                        onClick={function(){
                          if(!playerCount){ notify("Nobody is registered for this event yet","error"); return; }
                          blastFor===ev.id?setBlastFor(null):openBlast(ev);
                        }}>✉ {blastFor===ev.id?"Close":("Email roster"+(playerCount?(" ("+playerCount+")"):""))}</Btn>
                    )}
                    {(cu.type==="staff"||bbotIsAdmin(cu)) && <Btn v={ev.published===true?"ghost":"primary"} style={{fontSize:11,padding:"6px 10px"}} onClick={function(){togglePublished(ev);}} title={ev.published===true?"Live & registerable by players":"Hidden from players until you launch it"}>{ev.published===true?"● Live":"Launch"}</Btn>}
                    {(cu.type==="staff"||bbotIsAdmin(cu)) && <Btn v="ghost" style={{fontSize:11,padding:"6px 10px"}} onClick={function(){setSocialFor(socialFor===ev.id?null:ev.id);}}>{socialFor===ev.id?"Close":"Social Post"}</Btn>}
                    {(cu.type==="staff"||bbotIsAdmin(cu)) && <Btn v="ghost" style={{fontSize:11,padding:"6px 10px"}} onClick={function(){startEdit(ev);}}>Edit</Btn>}
                    {cu.type==="staff" && <Btn v="ghost" style={{fontSize:11,padding:"6px 10px",color:C.red}} onClick={function(){deleteEvent(ev.id);}}>Del</Btn>}
                  </div>
                </div>
                {/* Prepackaged social post (staff) — copyable promo for this event */}
                {socialFor===ev.id && (cu.type==="staff"||bbotIsAdmin(cu)) && (function(){
                  var post=buildEventPost(ev);
                  var full=post.caption+"\n\n"+post.hashtags.map(function(h){return "#"+h;}).join(" ");
                  return <div style={{marginTop:10,padding:12,background:C.coralFaint,border:"1px solid "+C.coralLight,borderRadius:8}}>
                    <div style={{fontSize:10,fontWeight:700,color:C.coral,letterSpacing:.5,marginBottom:6}}>READY-TO-POST</div>
                    <div style={{fontSize:12,color:C.gray800,whiteSpace:"pre-wrap",lineHeight:1.5,background:C.white,padding:10,borderRadius:6,marginBottom:8}}>{full}</div>
                    <Btn v="primary" style={{fontSize:11,padding:"6px 12px"}} onClick={function(){
                      if(navigator.clipboard&&navigator.clipboard.writeText){ navigator.clipboard.writeText(full).then(function(){notify("Post copied");}).catch(function(){notify("Copy failed","error");}); }
                      else { window.prompt("Copy this post:", full); }
                    }}>Copy Post</Btn>
                    <Btn v="primary" style={{fontSize:11,padding:"6px 12px",background:"#1877f2",border:"none",marginLeft:8}} onClick={function(){
                      notify("Posting to Facebook…");
                      fetch(BACKEND_URL+"/post-to-facebook",{method:"POST",headers:bbotAdminHeaders(),body:JSON.stringify({message:full})})
                        .then(function(r){return r.json();}).then(function(d){
                          if(d&&d.ok) notify("Posted to Facebook ✓");
                          else if(d&&d.error==="facebook_not_configured") notify("Facebook isn't connected yet. Add the page token on the backend to enable posting.","error");
                          else notify(errText(d&&d.detail,"Facebook post failed"),"error");
                        }).catch(function(e){ notify("Facebook post failed: "+(e.message||"unknown"),"error"); });
                    }}>Post to Facebook</Btn>
                  </div>;
                })()}
                {/* Admin/staff: view who signed up */}
                {(cu.type==="staff"||bbotIsAdmin(cu)) && (
                  <div style={{marginTop:10,paddingTop:10,borderTop:"1px solid "+C.gray100}}>
                    {/* The composer sits at CARD level so it opens from the card's own button,
                        independent of whether the signups list happens to be expanded. */}
                    {blastFor===ev.id && (
                      <div style={{marginTop:10,padding:12,background:C.gray50,border:"1px solid "+C.border,borderRadius:10}}>
                        <div style={{fontSize:11,fontWeight:700,color:C.navy,marginBottom:6}}>
                          EMAIL THE ROSTER &middot; to {playerCount} registered player{playerCount===1?"":"s"}
                        </div>
                        <input value={blastSubject} onChange={function(e){setBlastSubject(e.target.value);}} placeholder="Subject" style={{width:"100%",padding:"8px 10px",marginBottom:8,border:"1px solid "+C.border,borderRadius:6,fontSize:13,boxSizing:"border-box"}}/>
                        <textarea value={blastBody} onChange={function(e){setBlastBody(e.target.value);}} rows={9} placeholder="Message (HTML allowed)" style={{width:"100%",padding:"8px 10px",marginBottom:8,border:"1px solid "+C.border,borderRadius:6,fontSize:12,boxSizing:"border-box",fontFamily:"inherit",lineHeight:1.5}}/>
                        {/* THE TEMPLATE IS A STARTING POINT, NOT THE ONLY THING IT CAN SEND. It
                            pre-fills with event instructions; an admin can clear it and write
                            anything -- a cancellation, a venue change, a reminder. */}
                        <div style={{fontSize:10,color:C.gray400,marginBottom:8,lineHeight:1.5}}>
                          Pre-filled with event instructions &mdash; edit freely before sending.
                          Sent individually, so players never see each other&rsquo;s addresses.
                          Goes to every registered player, paid or not.
                        </div>
                        <button onClick={function(){sendBlast(ev);}} disabled={blastSending}
                          style={{padding:"8px 16px",borderRadius:7,border:"none",background:blastSending?C.gray400:C.coral,color:C.white,fontSize:12,fontWeight:700,cursor:blastSending?"wait":"pointer"}}>
                          {blastSending?"Sending…":("Send to "+playerCount+" player"+(playerCount===1?"":"s"))}
                        </button>
                      </div>
                    )}
                    <button onClick={function(){setExpandedId(expandedId===ev.id?null:ev.id);}} style={{background:"transparent",border:"none",color:C.blue,fontSize:11,fontWeight:700,cursor:"pointer",padding:0,letterSpacing:.3}}>
                      {expandedId===ev.id?"▲ Hide signups":"▼ View signups ("+playerCount+")"}
                    </button>
                    {expandedId===ev.id && <EventAddRegistrant ev={ev} users={users} setEvents={setEvents} notify={notify}/>}
                    {expandedId===ev.id && (
                      playerCount===0 ? (
                        <div style={{fontSize:11,color:C.gray400,marginTop:8,fontStyle:"italic"}}>No players have signed up yet.</div>
                      ) : (
                        <div style={{marginTop:8,display:"flex",flexDirection:"column",gap:4}}>
                          {(ev.attending_player_ids||[]).map(function(pid){
                            var u=(users||[]).find(function(x){return String(x.id)===String(pid);});
                            var reg=(ev.event_registrations||{})[String(pid)]||{};
                            var paid=reg.paid===true;
                            return (
                              <div key={pid} style={{display:"flex",alignItems:"center",justifyContent:"space-between",gap:8,padding:"6px 8px",background:C.gray50,borderRadius:6}}>
                                <div style={{minWidth:0}}>
                                  {/* THE NAME IS THE LINK. An admin looking at a roster wants to
                                      check who this player actually is -- position, grad year,
                                      past reports -- and had no way through from here but to go
                                      to the directory and search the name back. A registration
                                      row already knows the player_id; it should spend it. */}
                                  <div style={{fontSize:12,color:C.gray800,fontWeight:600}}>
                                    {u && go
                                      ? <span onClick={function(){ go("profile-"+u.id); }}
                                          style={{color:C.blue,cursor:"pointer",textDecoration:"underline"}}
                                          title="Open this player's profile">{u.firstName+" "+u.lastName} →</span>
                                      : (u?(u.firstName+" "+u.lastName):("Player "+pid))}
                                    {" "}<span style={{color:C.coral}}>#{(ev.event_numbers||{})[String(pid)]||"—"}</span>
                                    {/* A SHAREABLE PROFILE URL, for pasting to a college coach or
                                        into a message -- the in-app link above cannot leave the app. */}
                                    {u && <button type="button" title="Copy this player's profile link" onClick={function(){
                                      var base=(typeof window!=="undefined")?window.location.origin:"https://www.643sportsmgmt.com";
                                      var url=base+"/?p="+encodeURIComponent(String(u.id));
                                      try{
                                        if(navigator.clipboard&&navigator.clipboard.writeText) navigator.clipboard.writeText(url).then(function(){notify("Profile link copied");},function(){window.prompt("Copy this profile link:",url);});
                                        else window.prompt("Copy this profile link:",url);
                                      }catch(e){ window.prompt("Copy this profile link:",url); }
                                    }} style={{marginLeft:6,background:"none",border:"none",color:C.gray400,fontSize:10,cursor:"pointer",padding:0}}>🔗</button>}
                                  </div>
                                  <div style={{fontSize:10,color:C.gray500}}>{u?[u.position,reg.size?("Size "+reg.size):null,reg.altJersey?"ALT":null].filter(Boolean).join(" · "):""}</div>
                                </div>
                                <div style={{display:"flex",alignItems:"center",gap:6,flexShrink:0}}>
                                  <span style={{fontSize:10,fontWeight:700,color:paid?C.green:C.gray400}}>{paid?"✓ PAID":"unpaid"}</span>
                                  {!paid && <button onClick={function(){markEventPaid(ev,pid);}} title="Force-confirm payment (cash/ATH/offline)" style={{padding:"3px 8px",borderRadius:5,border:"1px solid "+C.navy,background:C.white,color:C.navy,fontSize:10,fontWeight:700,cursor:"pointer"}}>Mark paid</button>}
                                  {/* RELEASING A SEAT IS DESTRUCTIVE AND EMAILS A FAMILY, so it
                                      confirms first and names who. A paid registration warns
                                      separately -- money has changed hands and the refund is a
                                      conversation the admin has to have, not something this
                                      button can settle. */}
                                  <button onClick={function(){
                                    var who=u?(u.firstName+" "+u.lastName):("Player "+pid);
                                    var msg="Release "+who+"'s registration for "+(ev.name||"this event")+"?\n\n"
                                          +"They will be removed from the roster and emailed a notice asking them to contact 643."
                                          +(paid?"\n\nTHIS REGISTRATION IS MARKED PAID — any refund is handled separately.":"");
                                    if(typeof window!=="undefined" && !window.confirm(msg)) return;
                                    unregisterEventPlayer(ev, pid, u, setEvents, notify);
                                  }} title="Remove this player from the event and email them a notice"
                                    style={{padding:"3px 8px",borderRadius:5,border:"1px solid "+C.coral,background:C.white,color:C.coral,fontSize:10,fontWeight:700,cursor:"pointer"}}>Release</button>
                                </div>
                              </div>
                            );
                          })}
                          <EventRosterBuilder ev={ev} users={users} setUsers={setUsers} notify={notify} onSaved={function(rosters,teamKeys,eventNumbers){ setEvents(function(list){return list.map(function(e){return e.id===ev.id?Object.assign({},e,{rosters:rosters,team_keys:teamKeys,event_numbers:eventNumbers}):e;});}); }}/>
                          <button onClick={function(){
                            // Shirt-order list: only PAID players (don't order jerseys for non-payers).
                            var allIds=(ev.attending_player_ids||[]);
                            var paidIds=allIds.filter(function(pid){ return ((ev.event_registrations||{})[String(pid)]||{}).paid===true; });
                            var unpaidCount=allIds.length-paidIds.length;
                            if(paidIds.length===0){ notify(unpaidCount>0?("No paid players yet — "+unpaidCount+" registered but unpaid"):"No registrations yet","error"); return; }
                            var rows=paidIds.map(function(pid){
                              var u=(users||[]).find(function(x){return String(x.id)===String(pid);})||{};
                              var team=null,rosters=ev.rosters||{}; Object.keys(rosters).forEach(function(tk){ if((rosters[tk]||[]).map(String).indexOf(String(pid))>=0){var t=LEAGUE_TEAMS.find(function(x){return x.key===tk;});team=t?t.label:tk;} });
                              var en=(ev.event_numbers||{});
                              var reg=(ev.event_registrations||{})[String(pid)]||{};
                              var num=(en[String(pid)]!=null?en[String(pid)]:"");
                              // BBOT tag ID == event number (the marker generator maps them 1:1).
                              return [num,(num!==""?("bbot_tag_"+String(num).padStart(3,"0")+".png"):""),(u.firstName||"")+" "+(u.lastName||""),u.position||"",(reg.size||u.jerseySize||u.shirtSize||"NO SIZE"),team||"unassigned",(reg.altJersey?"ALT JERSEY":"")];
                            });
                            var csv="Number,TagFile,Player,Position,ShirtSize,Team,Notes\n"+rows.map(function(r){return r.map(function(c){return '"'+String(c).replace(/"/g,'""')+'"';}).join(",");}).join("\n");
                            var blob=new Blob([csv],{type:"text/csv"}); var url=URL.createObjectURL(blob); var a=document.createElement("a");
                            a.href=url; a.download=("shirt_order_"+(ev.name||"event")).replace(/\s+/g,"_")+".csv"; a.click(); setTimeout(function(){URL.revokeObjectURL(url);},1000);
                            notify(paidIds.length+" paid player"+(paidIds.length===1?"":"s")+" exported"+(unpaidCount>0?(" · "+unpaidCount+" unpaid excluded"):""));
                          }} style={{marginTop:10,padding:"7px 14px",borderRadius:7,border:"1px solid "+C.navy,background:C.white,color:C.navy,fontSize:11,fontWeight:700,cursor:"pointer"}}>↓ Download shirt-order list (paid only)</button>
                        </div>
                      )
                    )}
                  </div>
                )}
              </Card>
            );
          })}
        </div>
      )}
      {registerFor && <EventRegisterModal ev={registerFor} cu={cu} notify={notify} onClose={function(){setRegisterFor(null);}} onRegistered={function(reg,onDone){ handleRegistered(registerFor, reg, onDone); }} onPaid={function(ev,pid){ handleEventPaid(ev,pid); }}/>}
    </div>
  );
}


function MessagesView({cu, users, go, notify}){
  cu = cu || {};
  var msgsS=useState([]); var msgs=msgsS[0]; var setMsgs=msgsS[1];
  var loadingS=useState(true); var loading=loadingS[0]; var setLoading=loadingS[1];
  var activeS=useState(null); var activeThread=activeS[0]; var setActiveThread=activeS[1];
  var replyS=useState(""); var reply=replyS[0]; var setReply=replyS[1];

  var myId = String(cu.id);
  var eligible = isMessagingEligible(cu);
  var elig = messagingEligibleDate(cu);

  function load(){
    setLoading(true);
    // messages where I'm sender OR recipient
    var q = "?or=(from_user_id.eq."+encodeURIComponent(myId)+",to_user_id.eq."+encodeURIComponent(myId)+")&order=created_at.asc&limit=500";
    sbSelect("bbot_communication_log", q).then(function(rows){
      setMsgs(Array.isArray(rows)?rows:[]); setLoading(false);
    }).catch(function(){ setMsgs([]); setLoading(false); });
  }
  useEffect(function(){ if(myId) load(); }, [myId]);

  // If arriving from a profile "Message" button, open that thread once loaded.
  useEffect(function(){
    if(typeof window==="undefined") return;
    var pending=window.__bbotOpenThread;
    if(pending && pending.otherId){
      setActiveThread({otherId:String(pending.otherId), otherName:pending.otherName||"User", messages:[]});
      window.__bbotOpenThread=null;
    }
  }, [msgs]);

  // group into threads by the other party
  var threads = {};
  (msgs||[]).forEach(function(m){
    var other = String(m.from_user_id)===myId ? String(m.to_user_id) : String(m.from_user_id);
    var otherName = String(m.from_user_id)===myId ? m.to_name : m.from_name;
    if(!threads[other]) threads[other]={otherId:other, otherName:otherName||"User", messages:[]};
    threads[other].messages.push(m);
  });
  var threadList = Object.keys(threads).map(function(k){return threads[k];})
    .sort(function(a,b){return (b.messages[b.messages.length-1].created_at||"").localeCompare(a.messages[a.messages.length-1].created_at||"");});

  function sendReply(){
    if(!reply.trim()) return;
    if(!eligible){ notify && notify("Messaging unlocks Aug 1 before your junior year","error"); return; }
    var other = (users||[]).find(function(u){return String(u.id)===String(activeThread.otherId);}) || {};
    if(cu.type==="player" && other.type==="coach" && other.acceptsMessages===false){
      notify && notify("This coach isn't accepting player messages","error"); return;
    }
    var msg = {
      from_user_id: myId, from_name: (cu.firstName||"")+" "+(cu.lastName||""),
      to_user_id: String(activeThread.otherId), to_name: activeThread.otherName,
      body: reply.trim(), created_at: new Date().toISOString(),
      eligible_verified: true, grad_year: (cu.type==="player"?cu.gradYear:other.gradYear)||null,
    };
    bbotWrite("bbot_communication_log","insert",[msg],null).then(function(r){
      // A 4xx response from Supabase doesn't reject the fetch promise — we have to check
      // r.ok explicitly, otherwise a silent DB rejection (e.g. missing column, RLS deny)
      // looks like a successful send and the message vanishes on refresh.
      if(!r.ok) return r.text().then(function(t){ throw new Error("Send failed ("+r.status+"): "+(t||"").slice(0,200)); });
      setMsgs(function(p){return (p||[]).concat([msg]);});
      setReply("");
      bbotWrite("bbot_notifications","insert",[{player_id:String(activeThread.otherId),type:"message",message:"New message from "+msg.from_name,read:false,created_at:new Date().toISOString()}],null).catch(function(){});
    }).catch(function(err){ notify && notify((err&&err.message)?err.message:"Could not send","error"); });
  }

  function fmt(iso){ try{var d=new Date(iso);return d.toLocaleDateString()+" "+d.toLocaleTimeString([], {hour:"2-digit",minute:"2-digit"});}catch(e){return "";} }

  return (
    <div style={{maxWidth:720,margin:"0 auto",padding:"0 0 40px"}}>
      <h2 style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:24,color:C.navy,letterSpacing:1,marginBottom:6}}>MESSAGES</h2>
      {cu.type==="player" && !eligible && (
        <Card style={{padding:16,marginBottom:14,background:C.blueFaint,borderLeft:"3px solid "+C.blue}}>
          <div style={{fontSize:13,color:C.gray700,lineHeight:1.5}}>Per NCAA recruiting guidelines, messaging with college coaches unlocks <strong>August 1 before your junior year of high school</strong>{elig?(" — "+elig.toLocaleDateString()):""}. You can view this inbox, but sending is disabled until then.</div>
        </Card>
      )}
      {loading ? <div><SkeletonCard/><SkeletonCard/></div> :
       activeThread ? (
        <div>
          <button onClick={function(){setActiveThread(null);}} style={{background:"none",border:"none",color:C.blue,fontSize:13,cursor:"pointer",marginBottom:10,padding:0}}>← All conversations</button>
          <div style={{fontWeight:700,fontSize:16,color:C.coral,marginBottom:12}}>{activeThread.otherName}</div>
          <div style={{display:"flex",flexDirection:"column",gap:8,marginBottom:14}}>
            {((threads[activeThread.otherId]&&threads[activeThread.otherId].messages)||[]).map(function(m,i){
              var mine = String(m.from_user_id)===myId;
              return <div key={i} style={{alignSelf:mine?"flex-end":"flex-start",maxWidth:"80%",background:mine?C.coral:C.gray100,color:mine?C.white:C.gray900,padding:"10px 14px",borderRadius:12,fontSize:13,lineHeight:1.5}}>
                {m.body}
                <div style={{fontSize:9,opacity:.6,marginTop:4}}>{fmt(m.created_at)}</div>
              </div>;
            })}
            {(!threads[activeThread.otherId] || !threads[activeThread.otherId].messages.length) && <div style={{fontSize:12,color:C.gray400,fontStyle:"italic",textAlign:"center",padding:14}}>No messages yet — say hello.</div>}
          </div>
          {eligible ? (
            <div style={{display:"flex",gap:8}}>
              <input value={reply} onChange={function(e){setReply(e.target.value);}} onKeyDown={function(e){if(e.key==="Enter")sendReply();}} placeholder="Type a message…" style={{flex:1,padding:"10px 12px",border:"1px solid "+C.border,borderRadius:8,fontSize:14}}/>
              <Btn v="primary" onClick={sendReply} disabled={!reply.trim()}>Send</Btn>
            </div>
          ) : <div style={{fontSize:12,color:C.gray400,fontStyle:"italic",textAlign:"center",padding:10}}>Sending unlocks Aug 1 before your junior year.</div>}
        </div>
       ) : threadList.length===0 ? (
        <EmptyCard icon="bbot" title="No Messages Yet" sub={cu.type==="player"?"Coaches who reach out will appear here.":"Start a conversation from a player's profile."}/>
       ) : (
        <div style={{display:"flex",flexDirection:"column",gap:8}}>
          {threadList.map(function(t){
            var last=t.messages[t.messages.length-1];
            return <Card key={t.otherId} style={{padding:14,cursor:"pointer"}} onClick={function(){setActiveThread(t);}}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"baseline",marginBottom:3}}>
                <div style={{fontWeight:700,fontSize:14,color:C.coral}}>{t.otherName}</div>
                <div style={{fontSize:10,color:C.gray400}}>{fmt(last.created_at)}</div>
              </div>
              <div style={{fontSize:12,color:C.gray500,whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"}}>{String(last.from_user_id)===myId?"You: ":""}{last.body}</div>
            </Card>;
          })}
        </div>
       )}
    </div>
  );
}

function LeaderboardPage({ users, scoutReports, cu }) {
  // RESTORED (Luis, 2026-09-15), and the 09-13 removal was an overreach on my part.
  //
  // WHAT I GOT WRONG. I ruled the whole surface off because "a cross-player ranking implies a
  // population". It does not. A list SORTED BY A MEASURED NUMBER needs no peer population -- it
  // is the readings BBOT took, in order. What genuinely needed a population was the STANDING
  // framing ("Updates live as new measurements are logged" reads as a league table) and any
  // column ranking a GRADE, which is a judgement and not a reading. Those come off; the boards
  // stay. The measured columns are radar MPH (exit / throw / fastball) and admin-entered times
  // (pop time, 60, home-to-first) -- device ground truth, the layer BBOT already stands behind.
  // [[admin-entered-times-are-ground-truth]]
  //
  // The distinction that matters: "fastest reading we recorded" is a fact about our own data.
  // "Ranked 3rd" is a claim about a field. The first is what these boards show.
  var DIVS = [
    { label:"13U", ages:[13] },
    { label:"14U", ages:[14] },
    { label:"15U", ages:[15] },
    { label:"16U", ages:[16] },
    { label:"17U", ages:[17] },
    { label:"18U", ages:[18] },
    { label:"19+ Overall", ages:[] },
  ];

  var isStaff = cu && cu.type === "staff";

  var [activeDiv, setActiveDiv] = useState("17U");
  var [posFilter, setPosFilter] = useState("ALL");
  var [stateFilter, setStateFilter] = useState("");

  function getCumulScore(playerId) {
    var pReports = (scoutReports||[]).filter(function(r){
      // score!=null guards against a malformed/in-progress approved report flowing into
      // the weighted average — without it, score*weight becomes NaN and the UI shows "NaN".
      return Number(r.playerId)===Number(playerId) && isLiveEval(r) && r.score!=null;
    }).sort(function(a,b){return a.id-b.id;});
    if(pReports.length===0) return null;
    if(pReports.length===1) return pReports[0].score;
    var total=0; var wSum=0;
    pReports.forEach(function(r,i){var w=i+1;total+=r.score*w;wSum+=w;});
    return Math.round(total/wSum);
  }

  function getPlayersForDiv(div) {
    var players = (users||[]).filter(function(u){ return u.type==="player" && !u.provisional; });
    var hasApproved=function(u){ return (scoutReports||[]).some(function(r){return Number(r.playerId)===Number(u.id)&&isLiveEval(r);}); };
    if(div.label==="19+ Overall") {
      // All players with at least 1 approved report
      return players.filter(hasApproved);
    }
    // Bucket by the player's REAL age (from DOB) via seasonAge — NOT grad year. Age and
    // class are independent (a player can be 19 and a junior), and BBOT's leaderboards are
    // age-group based. div.ages holds the age(s) that belong to this division.
    return players.filter(function(u){
      var ag = seasonAge(u);
      return ag!=null && div.ages.indexOf(ag)>=0;
    }).filter(hasApproved);
  }

  function getRanked(div) {
    var players = getPlayersForDiv(div);
    // Apply position filter
    if(posFilter && posFilter!=="ALL"){
      players = players.filter(function(u){
        var p1 = (u.position||"").toUpperCase();
        var p2 = (u.position2||"").toUpperCase();
        if(posFilter==="P") return p1==="P"||p1==="RHP"||p1==="LHP"||p1==="SP"||p1==="RP"||p2==="P"||p2==="RHP"||p2==="LHP";
        if(posFilter==="IF") return ["1B","2B","3B","SS"].indexOf(p1)>=0 || ["1B","2B","3B","SS"].indexOf(p2)>=0;
        if(posFilter==="OF") return ["LF","CF","RF","OF"].indexOf(p1)>=0 || ["LF","CF","RF","OF"].indexOf(p2)>=0;
        return p1===posFilter || p2===posFilter;
      });
    }
    // Apply state filter (matches user.state or orgState)
    if(stateFilter){
      var sf = stateFilter.toUpperCase();
      players = players.filter(function(u){
        return (u.state||"").toUpperCase().indexOf(sf)>=0 || (u.orgState||"").toUpperCase().indexOf(sf)>=0 || (u.hsName||"").toUpperCase().indexOf(sf)>=0;
      });
    }
    var withScores = players.map(function(u){
      return { user:u, score:getCumulScore(u.id) };
    }).filter(function(x){ return x.score !== null; });
    withScores.sort(function(a,b){ return b.score - a.score; });
    return withScores.slice(0,20);
  }

  return (
    <div style={{maxWidth:700,margin:"0 auto",padding:"0 0 40px 0"}}>
      <div style={{marginBottom:24}}>
        <h2 style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:26,color:C.navy,letterSpacing:1,marginBottom:4}}>LEADERBOARDS</h2>
        <p style={{fontSize:13,color:C.gray400}}>Device-measured readings from BBOT sessions, highest first. These are the
        readings we recorded &mdash; not a standing in a field.</p>
      </div>
      <MeasurementsLeaderboard users={users}/>
      <BattedBallLeaderboard users={users}/>
      <PitchChartLeaderboard users={users}/>
    </div>
  );
}

function MeasurementsLeaderboard({users}){
  // RESTORED (Luis, 2026-09-15). Sorting by a MEASURED READING needs no peer population --
  // it is our own data in order. The standing framing and any grade-ranked column are what
  // needed one, and those are gone. See LeaderboardPage for the full correction.
  // Per-tool rolling leaderboards from bbot_measurements
  var [playerType, setPlayerType] = useState("position");  // "position" | "pitcher" — the ten percentiled metrics split by type
  var [tool, setTool] = useState("dash60");
  var [ageGroup, setAgeGroup] = useState("17U");
  var [window, setWindow] = useState("90");  // 30 | 90 | 365 | all
  var [confidence, setConfidence] = useState("all"); // all | confirmed
  var [topN, setTopN] = useState(20); // default top 20; coaches can expand to search deeper
  var [rows, setRows] = useState([]);
  var [loading, setLoading] = useState(false);

  var _veloOK3=(typeof window!=="undefined")?window.__bbotVeloVisible:false;
  // Leaderboards hold ONLY the ten percentiled radar/timed metrics, split by player type. `key` = the
  // percentile-metric identity; `queryKey` = the bbot_measurements tool_key the data is stored under
  // (aligning the write-side tool_key to the percentile name is a separate data task).
  var POSITION_TOOLS = [
    {key:"exitVeloPeak",           queryKey:"exitVelo",    label:"Top Exit Velocity",      unit:"mph", velo:true},
    {key:"exitVeloAvg",            queryKey:"exitVelo",    label:"Avg Exit Velocity",      unit:"mph", velo:true, avg:true},
    // ONE THROW-VELOCITY BOARD FOR POSITION PLAYERS. This was three -- OF / IF / Catcher --
    // expecting tool_keys "throwVeloOf" / "throwVeloIf" / "throwVeloC" that the write side has
    // never produced. Every throw velo is logged under "throwVelo", so all three boards were
    // permanently empty while 7 real readings sat unqueried.
    //
    // THE SPLIT THAT MATTERS IS POSITION PLAYERS vs PITCHERS, and this board already has it: the
    // playerType toggle picks POSITION_TOOLS or PITCHER_TOOLS. A position player's throw velo and
    // a pitcher's fastball are different measurements and stay on different boards. Sub-dividing
    // position players further would need a per-position key nobody writes, and the readings do
    // carry their position on the row if that is ever wanted.
    {key:"throwVelo",              queryKey:"throwVelo",   label:"Throw Velocity",         unit:"mph", velo:true},
    {key:"popTime",                queryKey:"popTime",     label:"Top Pop Time",           unit:"sec", lower:true},
    {key:"dash60",                 queryKey:"sixtyYard",   label:"60-Yard Dash",           unit:"sec", lower:true},
    {key:"h2f",                    queryKey:"h2f",         label:"Home-to-First",          unit:"sec", lower:true},
    // SWING TEMPO IS OFF THIS BOARD (2026-09-15). It is the one POSE-derived entry among device
    // readings, and it is the least reliable value in the system: measured this week, the card
    // layer read it as absent on 105 of 105 reps (a field rename no reader followed), 9 of 109
    // cached values are one-frame detections the plant rule now refuses, and the corrected
    // detector has not run over any stored rep. Luis held it off the cards on 2026-09-14 for
    // exactly that; ranking players on it publicly would contradict the same ruling one surface
    // over. It returns when re-analysis has produced tempos under the corrected detector.
  ];
  var PITCHER_TOOLS = [
    {key:"pitchVeloPeak", queryKey:"fastballVelo",    label:"Top Fastball Velocity", unit:"mph", velo:true},
    {key:"pitchVeloAvg",  queryKey:"fastballVeloAvg", label:"Avg Fastball Velocity", unit:"mph", velo:true, avg:true},
  ];
  var TOOLS = (playerType==="pitcher"?PITCHER_TOOLS:POSITION_TOOLS).filter(function(t){ return _veloOK3 || !t.velo; });
  var AGES = ["12U-13U","14U","15U","16U","17U","18U","19+"];

  useEffect(function(){
    setLoading(true);
    var _tdef = POSITION_TOOLS.concat(PITCHER_TOOLS).filter(function(t){return t.key===tool;})[0];
    var _queryKey = _tdef ? _tdef.queryKey : tool;  // map the percentile key -> its bbot_measurements tool_key
    // MATCH THE BOARD KEY AS WELL AS THE MAPPED ONE. The write side stores some tools under the
    // percentile name and some under a legacy tool_key, and the map only carried the legacy one --
    // so the Exit Velocity board queried "exitVelo" (2 rows, both of them grade-only) while the 17
    // real readings sat under "exitVeloPeak"/"exitVeloAvg" and were never fetched. Asking for both
    // spellings fixes the boards without inventing a mapping that does not exist.
    var _keys = _queryKey===tool ? [_queryKey] : [_queryKey, tool];
    var q = "?tool_key=in.("+_keys.map(encodeURIComponent).join(",")+")&age_group=eq."+encodeURIComponent(ageGroup);
    if(confidence==="confirmed") q += "&confidence=eq.Confirmed";
    if(window!=="all"){
      var days = Number(window);
      var cutoff = new Date(Date.now()-days*86400*1000).toISOString();
      q += "&created_at=gte."+cutoff;
    }
    // ORDERED BY THE MEASURED VALUE, NOT THE GRADE. This board prints measured_value and ranked
    // by grade.desc, so the order could disagree with the column the reader is looking at -- and a
    // grade is a judgement, which is the one thing these boards must not rank on.
    q += "&select=*&order=measured_value.desc&limit=200";
    sbSelect("bbot_measurements", q).then(function(rs){
      setRows(rs||[]); setLoading(false);
    }).catch(function(){ setRows([]); setLoading(false); });
  }, [tool, ageGroup, window, confidence]);

  // When the player-type toggles, snap the selected tool to the first tool in that group.
  useEffect(function(){
    var g = (playerType==="pitcher"?PITCHER_TOOLS:POSITION_TOOLS).filter(function(t){ return _veloOK3 || !t.velo; });
    if(g.length && !g.some(function(t){ return t.key===tool; })) setTool(g[0].key);
  }, [playerType]);

  // Aggregate: per player, best value
  // AN EMPTY TOOL LIST CRASHED THIS PAGE. Velocity boards are visible to staff and admin only, and
  // PITCHER_TOOLS is velocity all the way down -- so any player, coach or logged-out visitor who
  // picked "Pitchers" from the ungated selector got TOOLS=[] and `toolDef` undefined, then a
  // TypeError on the next line reading `toolDef.lower`. A blank crash, on a page in their nav.
  //
  // `_noTools` carries the condition and a NEUTRAL default keeps the arithmetic below harmless, so
  // every hook still runs in the same order on every render -- the empty state is returned at the
  // render, not here. An early return at this point would sit above two more hooks.
  var _noTools = !TOOLS.length;
  var toolDef = TOOLS.filter(function(t){return t.key===tool;})[0] || TOOLS[0]
                || {key:"", label:"", unit:"", lower:false, avg:false};
  var byPlayer = {};
  rows.forEach(function(r){
    var pid = r.player_id;
    if(!pid) return;
    // A ROW WITH NO READING IS NOT RANKED ON ITS GRADE. `|| r.grade` silently substituted a
    // judgement for a measurement whenever the reading was missing, so a board captioned
    // "device-measured" could seat a player on a scout grade. An unmeasured row is dropped.
    // [[absence-is-not-a-finding]] [[substituted-events-and-segment-local-time]]
    var val = parseFloat(r.measured_value);
    if(!isFinite(val)) return;
    var existing = byPlayer[pid];
    if(!existing) byPlayer[pid] = {playerId:pid, best:val, sum:val, count:1, lastDate:r.session_date};
    else {
      byPlayer[pid].count++;
      byPlayer[pid].sum += val;
      if((toolDef.lower && val<existing.best) || (!toolDef.lower && val>existing.best)) {
        existing.best = val;
        existing.lastDate = r.session_date;
      }
    }
  });
  // For an AVG tool, rank by the player's average reading; otherwise by best.
  Object.values(byPlayer).forEach(function(p){ p.avg = Math.round(p.sum/p.count); });
  var _rankVal = function(p){ return toolDef.avg ? p.avg : p.best; };
  var ranked = Object.values(byPlayer).sort(function(a,b){return toolDef.lower ? _rankVal(a)-_rankVal(b) : _rankVal(b)-_rankVal(a);}).slice(0, topN);

  // #10 WEEKLY MOVEMENT. Compare each player's current rank to the most recent weekly
  // snapshot (>=7 days old). prevRanks maps playerId -> last week's rank. If the newest
  // snapshot for this tool+age is older than 7 days (or none exists), lazily write a fresh
  // one so next week has a baseline. Snapshot key namespaces by tool+ageGroup.
  var [prevRanks, setPrevRanks] = useState(null); // null = not loaded yet
  var snapKey = "ml_"+tool+"_"+ageGroup;
  useEffect(function(){
    if(loading) return;
    if(!ranked.length){ setPrevRanks({}); return; }
    var WEEK = 7*86400*1000;
    sbSelect("bbot_leaderboard_history","?board_key=eq."+encodeURIComponent(snapKey)+"&order=captured_at.desc&limit=1")
      .then(function(rows){
        var latest = rows && rows[0];
        var latestTime = latest ? new Date(latest.captured_at).getTime() : 0;
        var stale = !latest || (Date.now()-latestTime) > WEEK;
        // Expose previous ranks for the movement badges (use latest snapshot we have).
        var pr = {};
        if(latest && latest.ranks && typeof latest.ranks==="object") pr = latest.ranks;
        setPrevRanks(pr);
        // Lazily write a new weekly snapshot if the last one is stale.
        if(stale){
          var ranksNow = {};
          ranked.forEach(function(r,i){ ranksNow[String(r.playerId)] = i+1; });
          bbotWrite("bbot_leaderboard_history","insert",[{board_key:snapKey, ranks:ranksNow, captured_at:new Date().toISOString()}],null).catch(function(){});
        }
      })
      .catch(function(){ setPrevRanks({}); });
  }, [tool, ageGroup, loading, ranked.length]);

  // THE EMPTY STATE, RETURNED AFTER EVERY HOOK HAS RUN. See `_noTools` above for the crash this
  // replaces. The two groups stay visible in the selector because the distinction is real and a
  // reader should be able to see it; the copy states only that the group is empty for them.
  if(_noTools){
    return (
      <div style={{marginTop:30,paddingTop:24,borderTop:"2px solid "+C.gray100}}>
        <div style={{padding:"22px 18px",textAlign:"center",background:C.gray50,borderRadius:10}}>
          <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:13,color:C.gray500}}>
            No leaderboards are available in this group.
          </div>
        </div>
      </div>
    );
  }

  return (
    <div style={{marginTop:30,paddingTop:24,borderTop:"2px solid "+C.gray100}}>
      <div style={{marginBottom:14}}>
        <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:16,color:C.navy,letterSpacing:1,marginBottom:4}}>TOOL LEADERBOARDS</div>
        <div style={{fontSize:11,color:C.gray500}}>Device-measured readings from BBOT sessions, best first. This is what we recorded, not a standing in a field.</div>
      </div>

      <div style={{display:"flex",flexWrap:"wrap",gap:8,marginBottom:14}}>
        <select value={playerType} onChange={function(e){setPlayerType(e.target.value);}} style={{padding:"6px 10px",border:"1px solid "+C.border,borderRadius:6,fontSize:12,background:C.white,fontWeight:700}}>
          <option value="position">Position Players</option>
          <option value="pitcher">Pitchers</option>
        </select>
        <select value={tool} onChange={function(e){setTool(e.target.value);}} style={{padding:"6px 10px",border:"1px solid "+C.border,borderRadius:6,fontSize:12,background:C.white}}>
          {TOOLS.map(function(t){return <option key={t.key} value={t.key}>{t.label}</option>;})}
        </select>
        <select value={ageGroup} onChange={function(e){setAgeGroup(e.target.value);}} style={{padding:"6px 10px",border:"1px solid "+C.border,borderRadius:6,fontSize:12,background:C.white}}>
          {AGES.map(function(a){return <option key={a} value={a}>{a}</option>;})}
        </select>
        <select value={window} onChange={function(e){setWindow(e.target.value);}} style={{padding:"6px 10px",border:"1px solid "+C.border,borderRadius:6,fontSize:12,background:C.white}}>
          <option value="30">Last 30 days</option>
          <option value="90">Last 90 days</option>
          <option value="365">Last year</option>
          <option value="all">All time</option>
        </select>
        <select value={confidence} onChange={function(e){setConfidence(e.target.value);}} style={{padding:"6px 10px",border:"1px solid "+C.border,borderRadius:6,fontSize:12,background:C.white}}>
          <option value="all">All confidence</option>
          <option value="confirmed">Confirmed only (radar-verified)</option>
        </select>
        <select value={topN} onChange={function(e){setTopN(Number(e.target.value));}} title="How many ranked players to show" style={{padding:"6px 10px",border:"1px solid "+C.border,borderRadius:6,fontSize:12,background:C.white}}>
          <option value="20">Top 20</option>
          <option value="50">Top 50</option>
          <option value="100">Top 100</option>
          <option value="500">All ranked</option>
        </select>
      </div>

      {loading ? <div style={{padding:20,textAlign:"center",color:C.gray500,fontSize:12}}>Loading...</div> : ranked.length===0 ? (
        <div style={{padding:20,textAlign:"center",color:C.gray400,fontSize:12,background:C.gray50,borderRadius:8}}>No measurements yet for this tool / age / window. As BBOT evaluates more players, this leaderboard populates.</div>
      ) : (
        <table style={{width:"100%",borderCollapse:"collapse",fontSize:12}}>
          <thead><tr style={{background:C.gray50}}>
            <td style={{padding:"8px 10px",fontSize:10,color:C.gray500,letterSpacing:.5,fontWeight:700,width:50}}>RANK</td>
            <td style={{padding:"8px 10px",fontSize:10,color:C.gray500,letterSpacing:.5,fontWeight:700}}>PLAYER</td>
            <td style={{padding:"8px 10px",fontSize:10,color:C.gray500,letterSpacing:.5,fontWeight:700,textAlign:"right"}}>BEST</td>
            <td style={{padding:"8px 10px",fontSize:10,color:C.gray500,letterSpacing:.5,fontWeight:700,textAlign:"right"}}>READINGS</td>
          </tr></thead>
          <tbody>
            {ranked.map(function(r, i){
              var p = (users||[]).filter(function(u){return String(u.id)===String(r.playerId);})[0];
              var name = p ? (p.firstName+" "+p.lastName) : "Player";
              var meta = p ? [p.position, p.gradYear?"Class "+p.gradYear:null, p.hsName||p.clubName].filter(Boolean).join(" · ") : "";
              // Weekly movement vs last snapshot. prev rank known → arrow + delta; brand-new → "NEW".
              var curRank = i+1;
              var move = null;
              if(prevRanks){
                var pr = prevRanks[String(r.playerId)];
                if(pr==null) move = {kind:"new"};
                else if(pr>curRank) move = {kind:"up", n:pr-curRank};
                else if(pr<curRank) move = {kind:"down", n:curRank-pr};
                else move = {kind:"same"};
              }
              var _medal = i===0?C.coral:i===1?C.blue:i===2?C.navyMid:null;
              return <tr key={r.playerId} style={{borderTop:"1px solid "+C.gray100,background:i<3?C.blueFaint:"transparent"}}>
                <td style={{padding:"10px 10px"}}>
                  <div style={{display:"flex",alignItems:"center",gap:6}}>
                    {_medal
                      ? <span style={{display:"inline-flex",alignItems:"center",justifyContent:"center",width:22,height:22,borderRadius:99,background:_medal,color:C.white,fontSize:11,fontWeight:800}}>{curRank}</span>
                      : <span style={{fontSize:13,fontWeight:700,color:C.gray400,minWidth:22,textAlign:"center"}}>{curRank}</span>}
                    {move && move.kind==="up" && <span style={{fontSize:9,color:C.blue,fontWeight:700}} title={"Up "+move.n+" this week"}>▲{move.n}</span>}
                    {move && move.kind==="down" && <span style={{fontSize:9,color:C.coral,fontWeight:700}} title={"Down "+move.n+" this week"}>▼{move.n}</span>}
                    {move && move.kind==="new" && <span style={{fontSize:8,color:C.blue,fontWeight:700,background:C.blueFaint,padding:"1px 4px",borderRadius:4,letterSpacing:.3}} title="New on the board this week">NEW</span>}
                    {move && move.kind==="same" && <span style={{fontSize:9,color:C.gray300}} title="No change">–</span>}
                  </div>
                </td>
                <td style={{padding:"10px 10px"}}>
                  <div style={{fontWeight:700,fontSize:13,color:C.navy}}>{name}</div>
                  {meta && <div style={{fontSize:10,color:C.gray500,marginTop:2}}>{meta}</div>}
                </td>
                <td style={{padding:"10px 10px",textAlign:"right",fontWeight:800,color:C.coral,fontSize:16}}>{toolDef.avg?r.avg:r.best}<span style={{fontSize:10,color:C.gray400,marginLeft:2,fontWeight:600}}>{toolDef.unit}</span></td>
                <td style={{padding:"10px 10px",textAlign:"right",color:C.gray400,fontSize:11}}>{r.count}</td>
              </tr>;
            })}
          </tbody>
        </table>
      )}
    </div>
  );
}


// Batted-ball percentage leaderboards (GB%, FB%, Pull%, Oppo%) from bbot_batted_balls
function BattedBallLeaderboard({users}){
  // RESTORED (Luis, 2026-09-15). Sorting by a MEASURED READING needs no peer population --
  // it is our own data in order. The standing framing and any grade-ranked column are what
  // needed one, and those are gone. See LeaderboardPage for the full correction.
  var [metric, setMetric] = useState("avgEV");
  var [ageGroup, setAgeGroup] = useState("17U");
  var [rows, setRows] = useState([]);
  var [loading, setLoading] = useState(false);
  var _veloOK4=(typeof window!=="undefined")?window.__bbotVeloVisible:false;
  // Pull%/Oppo%/GB%/FB% (direction + contact-type tendencies) REMOVED from leaderboards —
  // BBOT does not reliably capture batted-ball direction/type from video, so ranking on them
  // would assert what isn't measured (CLAUDE.md §2). Exit velocity STAYS: it's a device/overlay
  // reading, reliably captured. (Velo rows respect the existing admin velo gate.)
  var METRICS = [
    {key:"avgEV", label:"Avg MPH", group:"ev_avg", velo:true},
    {key:"topEV", label:"Top MPH", group:"ev_top", velo:true},
  ].filter(function(m){ return _veloOK4 || !m.velo; });
  // A CRASHING BOARD IS WORSE THAN AN EMPTY ONE, AND THIS ONE CRASHED BY DEFAULT.
  // Both metrics above are velo:true, so when the video-velo gate is OFF -- its dormant default --
  // the filter empties the list, METRICS[0] is undefined, and `def.group` throws below. The error
  // boundary then replaces the page with "Something went wrong". Introduced 2026-05-24; latent
  // ever since, because the board is only reachable when signed in and the gate is only on for
  // admins.
  // The honest answer to "nothing is rankable" is to SAY SO, which is what this product does
  // everywhere else: an absence states its cause. It does not invent a metric to rank on.
  var AGES = ["12U-13U","14U","15U","16U","17U","18U","19+"];
  var def = METRICS.filter(function(m){return m.key===metric;})[0]||METRICS[0];
  if(!def){
    return (
      <Card style={{padding:28,textAlign:"center"}}>
        <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:12,letterSpacing:1.4,
                     color:C.gray400,marginBottom:8}}>BATTED-BALL LEADERBOARD</div>
        <div style={{fontSize:13,color:C.gray600,lineHeight:1.6,maxWidth:460,margin:"0 auto"}}>
          No measured metric is available to rank on right now. Exit velocity is the only
          leaderboard metric BBOT ranks &mdash; direction and contact-type tendencies were removed
          because they are not reliably measured from video &mdash; and it is not currently
          released for this view.
        </div>
      </Card>
    );
  }

  // SOURCE = the same reconciled measurements the report and the grade read. Exit velocity is a
  // DEVICE reading that now lands in measuredValues (the per-batted-ball rows carry no velo), so
  // ranking off those rows meant ranking off whatever happened to be left in the table. Pool the
  // device readings from the player's APPROVED reports instead: the board can never disagree with
  // the report it came from. Shaped like the old rows so the aggregation below is unchanged.
  useEffect(function(){
    setLoading(true);
    bbotReports({status:"eq.approved",select:"player_id,full_report",limit:5000}).then(function(reps){
      var out = [];
      (reps||[]).forEach(function(r){
        var fr = r.full_report || {};
        if(typeof fr === "string"){ try{ fr = JSON.parse(fr); }catch(e){ return; } }
        var mv = fr.measuredValues || {};
        var pid = r.player_id != null ? String(r.player_id) : null;
        if(!pid) return;
        var reads = Array.isArray(mv.exitVeloReadings) ? mv.exitVeloReadings.filter(function(v){ return v!=null && v>0; }) : [];
        if(reads.length){
          reads.forEach(function(v){ out.push({player_id: pid, exit_velo: v}); });
        } else if(mv.exitVeloPeak != null || mv.exitVeloAvg != null){
          // no per-reading list on this report — fall back to its reconciled peak/avg so the
          // player still ranks on measured data, never on an empty or stale table
          if(mv.exitVeloAvg != null) out.push({player_id: pid, exit_velo: mv.exitVeloAvg});
          if(mv.exitVeloPeak != null) out.push({player_id: pid, exit_velo: mv.exitVeloPeak});
        }
      });
      setRows(out); setLoading(false);
    }).catch(function(){ setRows([]); setLoading(false); });
  }, []);

  // aggregate per player: % matching dir/type, OR exit-velo avg/top
  var byPlayer = {};
  (rows||[]).forEach(function(r){
    var pid = r.player_id; if(!pid) return;
    byPlayer[pid] = byPlayer[pid] || {total:0, hit:0, evSum:0, evN:0, evTop:null};
    byPlayer[pid].total++;
    var ev = parseFloat(r.exit_velo!=null?r.exit_velo:(r.exitVelo!=null?r.exitVelo:r.exit_velocity));
    if(!isNaN(ev)){ byPlayer[pid].evSum+=ev; byPlayer[pid].evN++; if(byPlayer[pid].evTop==null||ev>byPlayer[pid].evTop) byPlayer[pid].evTop=ev; }
    var field = def.group==="direction" ? (r.direction||"") : (def.group==="type" ? (r.type||"") : "");
    if(field && String(field).toLowerCase().replace(/[\s_]/g,"")===String(def.dir||"").toLowerCase().replace(/[\s_]/g,"")) byPlayer[pid].hit++;
  });
  var isEV = def.group==="ev_avg" || def.group==="ev_top";
  // AGE SEGREGATION: only rank same-age peers (can't compare a 14yo to an 18yo). Bucket by the player's
  // league age (Aug-1 rollover). No DOB -> can't place in a bracket -> excluded from the age board.
  var _todayStr = new Date().toISOString().slice(0,10);
  function _ageBucket(u){
    var ag = seasonAge(u, _todayStr);
    if(ag==null) return null;
    return ag>=19 ? "19+" : (ag<=13 ? "12U-13U" : (ag+"U"));
  }
  var ranked = Object.keys(byPlayer).map(function(pid){
    var u = (users||[]).find(function(x){return String(x.id)===String(pid);});
    var rec = byPlayer[pid];
    var value;
    if(def.group==="ev_avg") value = rec.evN>=3 ? Math.round(rec.evSum/rec.evN) : null;
    else if(def.group==="ev_top") value = rec.evN>=1 ? Math.round(rec.evTop) : null;
    else value = rec.total>=5 ? Math.round(rec.hit/rec.total*100) : null;
    return {user:u, value:value, n:isEV?rec.evN:rec.total};
  }).filter(function(x){return x.user && x.value!=null && _ageBucket(x.user)===ageGroup;}).sort(function(a,b){return b.value-a.value;}).slice(0,20);

  return (
    <div style={{marginTop:30}}>
      <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:16,color:C.navy,letterSpacing:.5,marginBottom:4}}>BATTED BALL PROFILE</div>
      <div style={{fontSize:10,color:C.gray500,marginBottom:10,lineHeight:1.4}}>Exit velocity, ranked against same-age peers. Shown when read from a device/overlay.</div>
      <div style={{display:"flex",gap:6,flexWrap:"wrap",marginBottom:10}}>
        {METRICS.map(function(m){
          var a=metric===m.key;
          return <button key={m.key} onClick={function(){setMetric(m.key);}} style={{padding:"5px 12px",borderRadius:99,border:"1px solid "+(a?C.blue:C.border),background:a?C.blue:C.white,color:a?C.white:C.gray600,fontSize:12,fontWeight:600,cursor:"pointer"}}>{m.label}</button>;
        })}
      </div>
      <div style={{display:"flex",gap:6,flexWrap:"wrap",marginBottom:14,alignItems:"center"}}>
        <span style={{fontSize:10,color:C.gray500,fontWeight:600,letterSpacing:.4,marginRight:2}}>AGE</span>
        {AGES.map(function(a){var on=ageGroup===a;return <button key={a} onClick={function(){setAgeGroup(a);}} style={{padding:"4px 10px",borderRadius:99,border:"1px solid "+(on?C.coral:C.border),background:on?C.coral:C.white,color:on?C.white:C.gray600,fontSize:11,fontWeight:600,cursor:"pointer"}}>{a}</button>;})}
      </div>
      {loading ? <div style={{fontSize:12,color:C.gray400}}>Loading…</div> :
       ranked.length===0 ? <EmptyCard icon="bbot" title="Not Enough Data Yet" sub={isEV?"Players need tracked exit-velo readings to rank here":"Players need 5+ tracked batted balls to rank here"}/> :
       <div>
        {ranked.map(function(item,idx){
          var u=item.user;
          return <div key={u.id} style={{display:"flex",alignItems:"center",gap:14,padding:"12px 16px",background:idx<3?C.blueFaint:C.white,border:"1px solid "+(idx<3?C.blueLight:C.border),borderRadius:12,marginBottom:8}}>
            <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:18,color:idx<3?C.blue:C.gray400,minWidth:30,textAlign:"center"}}>{"#"+(idx+1)}</div>
            <div style={{flex:1}}>
              <div style={{fontWeight:700,fontSize:14,color:C.gray900}}>{u.firstName} {u.lastName}</div>
              <div style={{fontSize:11,color:C.gray400}}>{[u.position,u.gradYear?"Class "+u.gradYear:null].filter(Boolean).join(" · ")} · {item.n} {isEV?"readings":"tracked"}</div>
            </div>
            <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:24,color:C.blue}}>{isEV?(item.value+" mph"):(item.value+"%")}</div>
          </div>;
        })}
       </div>}
    </div>
  );
}

function PitchChartLeaderboard({users}){
  // Pitcher rankings derived from tracked pitches (bbot_pitches), the pitching
  // parallel to the batted-ball board. Velocity rows respect the velo gate.
  var [metric, setMetric] = useState("fbCount");
  var [ageGroup, setAgeGroup] = useState("17U");
  var [rows, setRows] = useState([]);
  var [loading, setLoading] = useState(false);
  var _veloOK=(typeof window!=="undefined")?window.__bbotVeloVisible:false;
  var AGES = ["12U-13U","14U","15U","16U","17U","18U","19+"];
  var METRICS = [
    {key:"fbCount", label:"Total Fastballs", velo:false},
    {key:"fbAvg", label:"AVG Fastball MPH", velo:true},
    {key:"fbTop", label:"Top Fastball MPH", velo:true},
  ].filter(function(m){ return _veloOK || !m.velo; });
  var def = METRICS.filter(function(m){return m.key===metric;})[0]||METRICS[0];

  // Map a player to an age bucket (same convention as elsewhere: grad ~age 18).
  var ageBucket = function(u){
    if(!u) return null;
    // seasonAge reads .dob; this view stores it as .birthDate — normalize.
    var p = { dob: u.dob || u.birthDate, gradYear: u.gradYear };
    var age = seasonAge(p);
    if(age==null||isNaN(age)) return null;
    if(age<=13) return "12U-13U"; if(age===14) return "14U"; if(age===15) return "15U";
    if(age===16) return "16U"; if(age===17) return "17U"; if(age===18) return "18U"; return "19+";
  };

  useEffect(function(){
    setLoading(true);
    sbRowsForApprovedReports("bbot_pitches").then(function(rs){
      setRows(rs||[]); setLoading(false);
    }).catch(function(){ setRows([]); setLoading(false); });
  }, []);

  // Group pitches per player, compute fastball cluster via the shared helper.
  var byPlayer = {};
  (rows||[]).forEach(function(r){
    var pid = r.player_id; if(!pid) return;
    byPlayer[pid] = byPlayer[pid] || [];
    byPlayer[pid].push(r);
  });
  var ranked = Object.keys(byPlayer).map(function(pid){
    var u = (users||[]).find(function(x){return String(x.id)===String(pid);});
    var st = computePitcherStats(byPlayer[pid]);
    var value = def.key==="fbAvg" ? st.fbAvg : def.key==="fbTop" ? st.fbTop : st.fbCount;
    return {user:u, value:value, n:st.total, isVelo:def.key==="fbAvg"};
  }).filter(function(x){return x.user && x.value!=null && x.value>0 && ageBucket(x.user)===ageGroup;}).sort(function(a,b){return b.value-a.value;}).slice(0,20);

  return (
    <div style={{marginTop:30}}>
      <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:16,color:C.navy,letterSpacing:.5,marginBottom:4}}>PITCHER PROFILE</div>
      <div style={{fontSize:10,color:C.gray500,marginBottom:10,lineHeight:1.4}}>Ranked on top-end velocity pitches (fastballs). Velocity shown when read from a device/overlay in the video.</div>
      <div style={{display:"flex",gap:5,flexWrap:"wrap",marginBottom:8}}>
        {AGES.map(function(a){var on=ageGroup===a;return <button key={a} onClick={function(){setAgeGroup(a);}} style={{padding:"4px 10px",borderRadius:99,border:"1px solid "+(on?C.coral:C.border),background:on?C.coral:C.white,color:on?C.white:C.gray600,fontSize:11,fontWeight:600,cursor:"pointer"}}>{a}</button>;})}
      </div>
      <div style={{display:"flex",gap:6,flexWrap:"wrap",marginBottom:14}}>
        {METRICS.map(function(m){
          var a=metric===m.key;
          return <button key={m.key} onClick={function(){setMetric(m.key);}} style={{padding:"5px 12px",borderRadius:99,border:"1px solid "+(a?C.blue:C.border),background:a?C.blue:C.white,color:a?C.white:C.gray600,fontSize:12,fontWeight:600,cursor:"pointer"}}>{m.label}</button>;
        })}
      </div>
      {loading ? <div style={{fontSize:12,color:C.gray400}}>Loading…</div> :
       ranked.length===0 ? <EmptyCard icon="bbot" title="Not Enough Data Yet" sub="Pitchers need tracked fastball velocity to rank here"/> :
       <div>
        {ranked.map(function(item,idx){
          var u=item.user; var _medal = idx===0?C.coral:idx===1?C.blue:idx===2?C.navyMid:null;
          return <div key={u.id} style={{display:"flex",alignItems:"center",gap:12,padding:"10px 12px",background:idx<3?C.blueFaint:"transparent",borderTop:"1px solid "+C.gray100,marginBottom:0}}>
            {_medal
              ? <span style={{display:"inline-flex",alignItems:"center",justifyContent:"center",width:22,height:22,borderRadius:99,background:_medal,color:C.white,fontSize:11,fontWeight:800,flexShrink:0}}>{idx+1}</span>
              : <span style={{fontSize:13,fontWeight:700,color:C.gray400,minWidth:22,textAlign:"center",flexShrink:0}}>{idx+1}</span>}
            <div style={{flex:1,minWidth:0}}>
              <div style={{fontWeight:700,fontSize:13,color:C.navy}}>{u.firstName} {u.lastName}</div>
              <div style={{fontSize:10,color:C.gray500,marginTop:2}}>{[u.position,u.gradYear?"Class "+u.gradYear:null].filter(Boolean).join(" · ")} · {item.n} pitches</div>
            </div>
            <div style={{fontWeight:800,fontSize:16,color:C.coral}}>{item.value}{item.isVelo?<span style={{fontSize:10,color:C.gray400,marginLeft:2,fontWeight:600}}>mph</span>:null}</div>
          </div>;
        })}
       </div>}
    </div>
  );
}

// Common option lists — reuse across signup, profile editor, etc.
var ORG_PRESETS_COLLEGE = ["Vanderbilt","LSU","Texas","Florida","Arkansas","Mississippi State","Tennessee","Stanford","Oregon State","Wake Forest","Virginia","UCLA","TCU","Ole Miss","Auburn","Georgia","Florida State","Miami","NC State","Clemson","Oklahoma","Texas Tech","Arizona","Arizona State","Coastal Carolina","Indiana","Louisville","Notre Dame","Duke","UNC","South Carolina","Kentucky","Texas A&M","Alabama","Connecticut","Boston College","ECU","Wichita State","Dallas Baptist","Oregon"];
var ORG_PRESETS_MLB = ["Arizona Diamondbacks","Atlanta Braves","Baltimore Orioles","Boston Red Sox","Chicago Cubs","Chicago White Sox","Cincinnati Reds","Cleveland Guardians","Colorado Rockies","Detroit Tigers","Houston Astros","Kansas City Royals","Los Angeles Angels","Los Angeles Dodgers","Miami Marlins","Milwaukee Brewers","Minnesota Twins","New York Mets","New York Yankees","Oakland Athletics","Philadelphia Phillies","Pittsburgh Pirates","San Diego Padres","San Francisco Giants","Seattle Mariners","St. Louis Cardinals","Tampa Bay Rays","Texas Rangers","Toronto Blue Jays","Washington Nationals"];
var ORG_PRESETS_TRAVEL = ["643 Sports","Canes Baseball","Scorpions","CBA","East Cobb Astros","FTB","Stix Baseball","Five Star","Top Tier","Marucci Elite","Team Elite","Banditos","Show Baseball","Midland Redskins","Dallas Tigers","Houston Banditos"];



// ════════════════════════════════════════════════════════════════════════════════════════════════
// ADMIN-TRIGGERED PASSWORD RESET (Luis, 2026-10-03)
// ════════════════════════════════════════════════════════════════════════════════════════════════
// NOTHING NEW IS BUILT HERE. The whole recovery path already exists and works:
// bbotSendPasswordReset() posts to Supabase /auth/v1/recover, bbotRecoveryToken() reads the token
// back out of the redirect hash, bbotSetPasswordWithToken() sets the password, and the recovery
// screen renders behind a guardian-consent gate. The only thing missing was a way for an admin to
// START it for somebody who cannot — a player who never received the first mail, or who is locked
// out of the inbox they signed up with. So this is a finder and a button, not a second flow.
//
// IT TELLS THE ADMIN THE TRUTH, UNLIKE THE LOGIN FORM. The public form answers "if that email has
// an account..." on purpose, because a stranger must not learn who is registered. An admin already
// sees the roster, so withholding it here would hide the one fact that makes the button
// actionable: whether there is an address to send to at all. A player with no email on file is
// reported as exactly that.
//
// ADMIN-ONLY BY PLACEMENT. It is registered in GROUPS_ALL, which only renders when _isAdmin --
// and a tab in TABS but in no group is not drawn at all (see the note on "register" by GROUPS_ALL).
function AdminPasswordReset({ users, notify }) {
  var [q, setQ] = useState("");
  var [busy, setBusy] = useState(null);
  var [sent, setSent] = useState({});

  var term = q.trim().toLowerCase();
  var matches = term.length < 2 ? [] : (users || []).filter(function (u) {
    var name = ((u.firstName || "") + " " + (u.lastName || "")).toLowerCase();
    return name.indexOf(term) >= 0 || String(u.email || "").toLowerCase().indexOf(term) >= 0;
  }).slice(0, 25);

  var send = function (u) {
    if (!u.email) return notify("No email on file for " + u.firstName + " — add one first", "error");
    setBusy(u.id);
    bbotSendPasswordReset(u.email)
      .then(function () {
        setSent(function (s) { var n = Object.assign({}, s); n[u.id] = Date.now(); return n; });
        notify("Reset email sent to " + u.email);
      })
      .catch(function (e) { notify(String((e && e.message) || "Could not send reset email"), "error"); })
      .then(function () { setBusy(null); });
  };

  return <div style={{ maxWidth: 760 }}>
    <Card style={{ padding: 16, marginBottom: 14 }}>
      <div style={{ fontSize: 13, fontWeight: 700, color: C.navy, marginBottom: 4 }}>Send a password reset</div>
      <div style={{ fontSize: 12, color: C.gray500, marginBottom: 10, lineHeight: 1.6 }}>
        Sends the same set-your-password email the login page sends. The link goes to the address on
        the player's profile — BBOT never sees or sets the password itself.
      </div>
      <input value={q} onChange={function (e) { setQ(e.target.value); }}
        placeholder="Search by name or email"
        style={{ width: "100%", padding: "9px 12px", border: "1px solid " + C.border, borderRadius: 8, fontSize: 13, boxSizing: "border-box" }} />
    </Card>

    {term.length >= 2 && matches.length === 0 &&
      <div style={{ fontSize: 13, color: C.gray500, padding: "6px 2px" }}>Nobody matches “{q}”.</div>}

    {matches.map(function (u) {
      var justSent = !!sent[u.id];
      return <div key={u.id} style={{ display: "flex", alignItems: "center", gap: 12, padding: "10px 14px", border: "0.5px solid " + C.border, borderRadius: 10, marginBottom: 8, background: C.white, flexWrap: "wrap" }}>
        <Avatar user={u} size={34} />
        <div style={{ flex: "1 1 180px", minWidth: 0 }}>
          <div style={{ fontWeight: 700, fontSize: 13, color: C.gray900 }}>{u.firstName} {u.lastName}</div>
          <div style={{ fontSize: 11, color: u.email ? C.gray500 : C.coral, wordBreak: "break-word" }}>
            {u.email || "No email on file"}
          </div>
        </div>
        <span style={{ fontSize: 11, color: C.gray400 }}>{u.type}</span>
        <Btn v={justSent ? "ghost" : "primary"} style={{ fontSize: 12, padding: "7px 14px" }}
          onClick={function () { send(u); }}
          disabled={busy === u.id || !u.email}>
          {busy === u.id ? "Sending…" : justSent ? "✓ Sent — send again" : "Send reset"}
        </Btn>
      </div>;
    })}
  </div>;
}

function RosterManager({ players, cu, notify, lineups, setLineups }) {
  var LINEUP_TYPES = ["Game","Batting Practice","Bullpen","Intrasquad","Live ABs","Showcase"];
  var POSITIONS    = ["P","C","1B","2B","3B","SS","LF","CF","RF","DH","UTIL","RP","SP"];

  var [view,      setView]      = useState("list");
  var [editing,   setEditing]   = useState(null);
  var [newName,   setNewName]   = useState("");
  var [newType,   setNewType]   = useState("Game");
  var [newDate,   setNewDate]   = useState("");

  var createLineup=function() {
    if (!newName) return notify("Enter a lineup name","error");
    var lu = {
      id: Date.now(),
      name: newName,
      type: newType,
      date: newDate || new Date().toISOString().slice(0,10),
      createdBy: cu.firstName+" "+cu.lastName,
      starters:  [],
      reserves:  [],
      pitchers:  [],
      subs:      [],   // [{type:"position"|"pitching", outPlayer, inPlayer, position, timestamp, note}]
    };
    setLineups(function(l){ return l.concat([lu]); });
    persistLineup(lu).catch(function(){ notify("Lineup created but not saved — check connection","error"); });
    setEditing(lu);
    setView("build");
    setNewName(""); setNewType("Game"); setNewDate("");
    notify("Lineup created — add players below");
  }

  var saveLineup=function(updated) {
    setLineups(function(l){ return l.map(function(x){ return x.id===updated.id?updated:x; }); });
    persistLineup(updated).catch(function(){ notify("Saved in view but not synced — check connection","error"); });
    notify("Lineup saved!");
  }

  var deleteLineup=function(id) {
    setLineups(function(l){ return l.filter(function(x){ return x.id!==id; }); });
    deleteLineupRow(id).catch(function(){ notify("Lineup not deleted — it will return on refresh","error"); });
    notify("Lineup deleted");
  }

  var makeSub=function(lu, outIdx, inPlayerId, newPosition) {
    var outPlayer = lu.starters[outIdx];
    var inPlayer  = players.find(function(p){ return p.id===parseInt(inPlayerId); });
    if (!inPlayer) return;
    var sub = {
      type:      "position",
      outPlayer: outPlayer,
      inPlayer:  { playerId:inPlayer.id, name:inPlayer.firstName+" "+inPlayer.lastName, position:newPosition||outPlayer.position, jerseyNum:"" },
      position:  newPosition || outPlayer.position,
      timestamp: new Date().toLocaleTimeString(),
    };
    var newStarters = lu.starters.slice();
    newStarters[outIdx] = sub.inPlayer;
    var newReserves = lu.reserves.filter(function(r){ return r.playerId!==inPlayer.id; });
    var updated = Object.assign({},lu,{
      starters: newStarters,
      reserves:  newReserves,
      subs:      lu.subs.concat([sub]),
    });
    setEditing(updated);
  }

  var makePitchingChange=function(lu, outIdx, inPlayerId, role) {
    var outPitcher = lu.pitchers[outIdx];
    var inPlayer   = players.find(function(p){ return p.id===parseInt(inPlayerId); });
    if (!inPlayer) return;
    var sub = {
      type:      "pitching",
      outPlayer: outPitcher,
      inPlayer:  { playerId:inPlayer.id, name:inPlayer.firstName+" "+inPlayer.lastName, role:role||"RP", throwingOrder:lu.pitchers.length+1 },
      timestamp: new Date().toLocaleTimeString(),
    };
    var newPitchers = lu.pitchers.slice();
    newPitchers[outIdx] = sub.inPlayer;
    var updated = Object.assign({},lu,{
      pitchers: newPitchers,
      subs:     lu.subs.concat([sub]),
    });
    setEditing(updated);
  }

  // List view
  if (view==="list") return (
    <div>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:18,flexWrap:"wrap",gap:12}}>
        <div>
          <h3 style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:18,color:C.blue,letterSpacing:1}}>ROSTER & LINEUPS</h3>
          <p style={{fontSize:13,color:C.gray400,marginTop:3}}>Build session rosters -- BBOT uses these as ground truth for player identification</p>
        </div>
        <Btn v="primary" style={{fontSize:13}} onClick={function(){setView("create");}}>+ Create Lineup</Btn>
      </div>
      {lineups.length===0 ? (
        <EmptyCard icon="L" title="No Lineups Yet" sub="Create a lineup to organize your session" action="+ Create Lineup" onAction={function(){setView("create");}}/>
      ) : (
        <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(280px,1fr))",gap:12}}>
          {lineups.map(function(lu){
            var typeCol={Game:C.blue,"Batting Practice":C.orange,Bullpen:C.green}[lu.type]||C.blue;
            return (
              <Card key={lu.id} style={{padding:0,overflow:"hidden"}}>
                <div style={{height:3,background:typeCol}}/>
                <div style={{padding:16}}>
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:10}}>
                    <div>
                      <div style={{fontWeight:700,fontSize:15,color:C.gray900,marginBottom:3}}>{lu.name}</div>
                      <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
                        <span style={{background:typeCol+"22",color:typeCol,fontSize:11,fontWeight:700,padding:"2px 8px",borderRadius:99}}>{lu.type}</span>
                        <span style={{fontSize:11,color:C.gray400}}>{lu.date}</span>
                      </div>
                    </div>
                    <button onClick={function(){deleteLineup(lu.id);}} style={{background:"none",border:"none",color:C.gray300,fontSize:18,cursor:"pointer",padding:0}}>x</button>
                  </div>
                  <div style={{display:"flex",gap:16,marginBottom:10}}>
                    <div style={{textAlign:"center"}}>
                      <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:22,color:C.blue}}>{lu.starters.length}</div>
                      <div style={{fontSize:10,color:C.gray400,textTransform:"uppercase",letterSpacing:.5}}>Starters</div>
                    </div>
                    <div style={{textAlign:"center"}}>
                      <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:22,color:C.orange}}>{lu.reserves.length}</div>
                      <div style={{fontSize:10,color:C.gray400,textTransform:"uppercase",letterSpacing:.5}}>Reserves</div>
                    </div>
                    <div style={{textAlign:"center"}}>
                      <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:22,color:C.green}}>{lu.pitchers.length}</div>
                      <div style={{fontSize:10,color:C.gray400,textTransform:"uppercase",letterSpacing:.5}}>Pitchers</div>
                    </div>
                    {lu.subs&&lu.subs.length>0&&(
                      <div style={{textAlign:"center"}}>
                        <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:22,color:C.gray500}}>{lu.subs.length}</div>
                        <div style={{fontSize:10,color:C.gray400,textTransform:"uppercase",letterSpacing:.5}}>Subs</div>
                      </div>
                    )}
                  </div>
                  <div style={{display:"flex",gap:8}}>
                    <Btn v="outline" style={{flex:1,fontSize:12,padding:"8px",justifyContent:"center"}} onClick={function(){setEditing(lu);setView("build");}}>Edit</Btn>
                    <Btn v="primary" style={{flex:1,fontSize:12,padding:"8px",justifyContent:"center"}} onClick={function(){setEditing(lu);setView("view");}}>View</Btn>
                  </div>
                </div>
              </Card>
            );
          })}
        </div>
      )}
    </div>
  );

  // Create view
  if (view==="create") return (
    <div style={{maxWidth:480}}>
      <Btn v="ghost" style={{marginBottom:16,fontSize:13}} onClick={function(){setView("list");}}>Back</Btn>
      <Card>
        <h3 style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:16,color:C.blue,letterSpacing:1,marginBottom:16}}>NEW LINEUP</h3>
        <div style={{marginBottom:12}}>
          <label>Lineup Name</label>
          <input value={newName} onChange={function(e){setNewName(e.target.value);}} placeholder="e.g. Tuesday Game vs Spartans"/>
        </div>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginBottom:14}}>
          <div>
            <label>Session Type</label>
            <select value={newType} onChange={function(e){setNewType(e.target.value);}}>
              {LINEUP_TYPES.map(function(t){return <option key={t}>{t}</option>;})}
            </select>
          </div>
          <div>
            <label>Date</label>
            <input type="date" value={newDate} onChange={function(e){setNewDate(e.target.value);}}/>
          </div>
        </div>
        <div style={{display:"flex",gap:10}}>
          <Btn v="primary" style={{fontSize:13}} onClick={createLineup}>Create Lineup</Btn>
          <Btn v="ghost" style={{fontSize:13}} onClick={function(){setView("list");}}>Cancel</Btn>
        </div>
      </Card>
    </div>
  );

  // Build / Edit / View
  if ((view==="build"||view==="view")&&editing) {
    var lu     = editing;
    var isEdit = view==="build";
    return (
      <div>
        <div style={{display:"flex",gap:12,alignItems:"center",marginBottom:16,flexWrap:"wrap"}}>
          <Btn v="ghost" style={{fontSize:13}} onClick={function(){setView("list");}}>Back</Btn>
          <div style={{flex:1}}>
            <h3 style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:17,color:C.gray900,letterSpacing:.5}}>{lu.name}</h3>
            <div style={{fontSize:12,color:C.gray400}}>{lu.type} -- {lu.date} -- by {lu.createdBy}</div>
          </div>
          {isEdit&&(
            <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
              <Btn v="outline" style={{fontSize:13}} onClick={function(){
                // Pull every player not already in the lineup into reserves as the available pool.
                var inLineup={};
                lu.starters.forEach(function(s){inLineup[String(s.playerId)]=true;});
                lu.reserves.forEach(function(s){inLineup[String(s.playerId)]=true;});
                lu.pitchers.forEach(function(s){inLineup[String(s.playerId)]=true;});
                var toAdd=(players||[]).filter(function(p){return !inLineup[String(p.id)];}).map(function(p){
                  return {playerId:p.id, name:p.firstName+" "+p.lastName, position:p.position||"UTIL", jerseyNum:p.jerseyNum||""};
                });
                if(!toAdd.length){ notify("All players are already in this lineup"); return; }
                setEditing(Object.assign({},lu,{reserves:lu.reserves.concat(toAdd)}));
                notify("Pulled "+toAdd.length+" player"+(toAdd.length===1?"":"s")+" into reserves — promote to starters or pitchers as needed");
              }}>⬇ Pull Full Roster</Btn>
              <Btn v="primary" style={{fontSize:13}} onClick={function(){saveLineup(lu);setView("list");}}>Save Lineup</Btn>
            </div>
          )}
        </div>

        {isEdit && (function(){
          // Quick roster check-in: tick players to drop them straight into the batting order
          // in the order ticked. Reorder afterward with the up/down controls on each slot.
          var inOrder = {};
          lu.starters.forEach(function(s){ inOrder[String(s.playerId)] = true; });
          var roster = (players||[]).slice().sort(function(a,b){ return (a.lastName||"").localeCompare(b.lastName||""); });
          if(!roster.length) return null;
          return (
            <Card style={{marginBottom:14,padding:14}}>
              <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:12,color:C.coral,letterSpacing:1,marginBottom:4}}>BUILD FROM ROSTER</div>
              <div style={{fontSize:11,color:C.gray500,marginBottom:10}}>Check players to add them to the batting order in the order you check. Reorder afterward with the controls on each slot.</div>
              <div style={{display:"flex",flexWrap:"wrap",gap:6}}>
                {roster.map(function(p){
                  var on = inOrder[String(p.id)];
                  return (
                    <button key={p.id} onClick={function(){
                      if(on){
                        setEditing(Object.assign({},lu,{starters:lu.starters.filter(function(s){return String(s.playerId)!==String(p.id);})}));
                      } else {
                        setEditing(Object.assign({},lu,{starters:lu.starters.concat([{playerId:p.id, name:p.firstName+" "+p.lastName, position:p.position||"UTIL", jerseyNum:p.jerseyNum||""}])}));
                      }
                    }} style={{display:"flex",alignItems:"center",gap:6,padding:"6px 10px",borderRadius:8,border:"1px solid "+(on?C.coral:C.border),background:on?C.coralFaint:C.white,color:on?C.coral:C.gray700,fontSize:12,fontWeight:on?700:500,cursor:"pointer"}}>
                      <span style={{width:14,height:14,borderRadius:3,border:"1.5px solid "+(on?C.coral:C.gray300),background:on?C.coral:C.white,color:C.white,fontSize:10,fontWeight:700,display:"flex",alignItems:"center",justifyContent:"center"}}>{on?"✓":""}</span>
                      {p.firstName} {p.lastName}{p.position?" · "+p.position:""}
                    </button>
                  );
                })}
              </div>
            </Card>
          );
        })()}

        <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(300px,1fr))",gap:14}}>

          {/* Starters */}
          <Card>
            <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:13,color:C.blue,letterSpacing:1,marginBottom:12}}>BATTING ORDER -- STARTERS</div>
            {lu.starters.length===0&&(
              <div style={{fontSize:13,color:C.gray400,marginBottom:12,fontStyle:"italic"}}>No starters added yet</div>
            )}
            {lu.starters.map(function(s,idx){
              var p=players.find(function(x){return x.id===s.playerId;});
              if(!p) return null;
              var availReserves=lu.reserves.filter(function(r){
                return !lu.starters.some(function(st,si){return si!==idx&&st.playerId===r.playerId;});
              });
              return (
                <div key={s.playerId} style={{marginBottom:10,paddingBottom:10,borderBottom:"1px solid "+C.border}}>
                  <div style={{display:"flex",alignItems:"center",gap:10}}>
                    <div style={{width:24,height:24,borderRadius:"50%",background:C.blue,color:C.white,fontFamily:"Inter,system-ui,sans-serif",fontWeight:700,fontSize:13,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>{idx+1}</div>
                    <div style={{flex:1}}>
                      <div style={{fontWeight:600,fontSize:13,color:C.gray800}}>{p.firstName} {p.lastName}</div>
                      <div style={{fontSize:11,color:C.gray500}}>{s.position}{s.jerseyNum?" -- #"+s.jerseyNum:""}</div>
                    </div>
                    {isEdit&&(
                      <div style={{display:"flex",gap:4}}>
                        {idx>0&&(
                          <button onClick={function(){
                            var arr=lu.starters.slice();
                            var tmp=arr[idx];arr[idx]=arr[idx-1];arr[idx-1]=tmp;
                            setEditing(Object.assign({},lu,{starters:arr}));
                          }} style={{background:"none",border:"none",cursor:"pointer",fontSize:14,color:C.gray400,padding:2}}>^</button>
                        )}
                        {idx<lu.starters.length-1&&(
                          <button onClick={function(){
                            var arr=lu.starters.slice();
                            var tmp=arr[idx];arr[idx]=arr[idx+1];arr[idx+1]=tmp;
                            setEditing(Object.assign({},lu,{starters:arr}));
                          }} style={{background:"none",border:"none",cursor:"pointer",fontSize:14,color:C.gray400,padding:2}}>v</button>
                        )}
                        <button onClick={function(){
                          setEditing(Object.assign({},lu,{starters:lu.starters.filter(function(_,j){return j!==idx;})}));
                        }} style={{background:"none",border:"none",color:C.red,cursor:"pointer",fontSize:16,padding:2}}>x</button>
                      </div>
                    )}
                  </div>
                  {isEdit&&availReserves.length>0&&(
                    <div style={{marginTop:8,display:"flex",gap:6,alignItems:"center"}}>
                      <span style={{fontSize:11,color:C.gray400}}>Sub in:</span>
                      <select onChange={function(e){
                        if(e.target.value) makeSub(lu,idx,e.target.value,s.position);
                        e.target.value="";
                      }} style={{fontSize:12,padding:"3px 6px",borderRadius:6,border:"1px solid "+C.border,flex:1}}>
                        <option value="">-- pick reserve --</option>
                        {availReserves.map(function(r){
                          var rp=players.find(function(x){return x.id===r.playerId;});
                          return rp?<option key={r.playerId} value={r.playerId}>{rp.firstName} {rp.lastName}</option>:null;
                        })}
                      </select>
                    </div>
                  )}
                </div>
              );
            })}
            {isEdit&&(
              <AddPlayerRow players={players} existing={lu.starters.map(function(s){return s.playerId;})}
                positions={POSITIONS} label="+ Add to lineup"
                onAdd={function(entry){setEditing(Object.assign({},lu,{starters:lu.starters.concat([entry])}));}}/>
            )}
          </Card>

          {/* Pitchers */}
          <Card>
            <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:13,color:C.green,letterSpacing:1,marginBottom:12}}>PITCHING STAFF</div>
            {lu.pitchers.length===0&&(
              <div style={{fontSize:13,color:C.gray400,marginBottom:12,fontStyle:"italic"}}>No pitchers added yet</div>
            )}
            {lu.pitchers.map(function(s,idx){
              var p=players.find(function(x){return x.id===s.playerId;});
              if(!p) return null;
              var allAvail=players.filter(function(pl){
                return !lu.pitchers.some(function(pt){return pt.playerId===pl.id;});
              });
              return (
                <div key={s.playerId} style={{marginBottom:10,paddingBottom:10,borderBottom:"1px solid "+C.border}}>
                  <div style={{display:"flex",alignItems:"center",gap:10}}>
                    <div style={{width:24,height:24,borderRadius:6,background:s.role==="SP"?C.green:C.orange,color:C.white,fontFamily:"Inter,system-ui,sans-serif",fontWeight:700,fontSize:10,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>{s.role||"P"}</div>
                    <div style={{flex:1}}>
                      <div style={{fontWeight:600,fontSize:13,color:C.gray800}}>{p.firstName} {p.lastName}</div>
                      <div style={{fontSize:11,color:C.gray500}}>{s.jerseyNum?"#"+s.jerseyNum:""}</div>
                    </div>
                    {isEdit&&(
                      <button onClick={function(){
                        setEditing(Object.assign({},lu,{pitchers:lu.pitchers.filter(function(_,j){return j!==idx;})}));
                      }} style={{background:"none",border:"none",color:C.red,cursor:"pointer",fontSize:16,padding:2}}>x</button>
                    )}
                  </div>
                  {isEdit&&allAvail.length>0&&(
                    <div style={{marginTop:8,display:"flex",gap:6,alignItems:"center"}}>
                      <span style={{fontSize:11,color:C.gray400}}>Change:</span>
                      <select onChange={function(e){
                        if(e.target.value) makePitchingChange(lu,idx,e.target.value,"RP");
                        e.target.value="";
                      }} style={{fontSize:12,padding:"3px 6px",borderRadius:6,border:"1px solid "+C.border,flex:1}}>
                        <option value="">-- pick pitcher --</option>
                        {allAvail.map(function(pl){
                          return <option key={pl.id} value={pl.id}>{pl.firstName} {pl.lastName}</option>;
                        })}
                      </select>
                    </div>
                  )}
                </div>
              );
            })}
            {isEdit&&(
              <AddPlayerRow players={players} existing={lu.pitchers.map(function(s){return s.playerId;})}
                positions={["SP","RP","CL"]} label="+ Add pitcher"
                onAdd={function(entry){setEditing(Object.assign({},lu,{pitchers:lu.pitchers.concat([Object.assign({},entry,{role:entry.position,throwingOrder:lu.pitchers.length+1})])}));}}/>
            )}
          </Card>

          {/* Reserves */}
          <Card>
            <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:13,color:C.orange,letterSpacing:1,marginBottom:12}}>RESERVES -- BENCH</div>
            {lu.reserves.length===0&&(
              <div style={{fontSize:13,color:C.gray400,marginBottom:12,fontStyle:"italic"}}>No reserves added yet</div>
            )}
            {lu.reserves.map(function(s,idx){
              var p=players.find(function(x){return x.id===s.playerId;});
              if(!p) return null;
              return (
                <div key={s.playerId} style={{display:"flex",alignItems:"center",gap:10,padding:"8px 0",borderBottom:"1px solid "+C.border}}>
                  <div style={{flex:1}}>
                    <div style={{fontWeight:600,fontSize:13,color:C.gray800}}>{p.firstName} {p.lastName}</div>
                    <div style={{fontSize:11,color:C.gray500}}>{s.position}{s.jerseyNum?" -- #"+s.jerseyNum:""}</div>
                  </div>
                  {isEdit&&(
                    <button onClick={function(){
                      setEditing(Object.assign({},lu,{reserves:lu.reserves.filter(function(_,j){return j!==idx;})}));
                    }} style={{background:"none",border:"none",color:C.red,cursor:"pointer",fontSize:16,padding:2}}>x</button>
                  )}
                </div>
              );
            })}
            {isEdit&&(
              <AddPlayerRow players={players} existing={lu.reserves.map(function(s){return s.playerId;})}
                positions={POSITIONS} label="+ Add reserve"
                onAdd={function(entry){setEditing(Object.assign({},lu,{reserves:lu.reserves.concat([entry])}));}}/>
            )}
          </Card>

        </div>

        {/* Substitution log */}
        {lu.subs&&lu.subs.length>0&&(
          <Card style={{marginTop:14}}>
            <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:13,color:C.gray700,letterSpacing:1,marginBottom:12}}>SUBSTITUTION LOG</div>
            {lu.subs.map(function(sub,idx){
              var outP=players.find(function(x){return x.id===(sub.outPlayer&&sub.outPlayer.playerId);});
              var inP=players.find(function(x){return x.id===sub.inPlayer.playerId;});
              return (
                <div key={idx} style={{display:"flex",alignItems:"center",gap:10,padding:"8px 0",borderBottom:"1px solid "+C.border,fontSize:13}}>
                  <span style={{background:sub.type==="pitching"?C.green+"22":C.blue+"22",color:sub.type==="pitching"?C.green:C.blue,fontSize:10,fontWeight:700,padding:"2px 8px",borderRadius:99,whiteSpace:"nowrap"}}>{sub.type==="pitching"?"PITCHING CHANGE":"POSITION SUB"}</span>
                  <span style={{color:C.red,fontWeight:600}}>{outP?outP.firstName+" "+outP.lastName:"Player"}</span>
                  <span style={{color:C.gray400}}>out</span>
                  <span style={{color:C.green,fontWeight:600}}>{inP?inP.firstName+" "+inP.lastName:"Player"}</span>
                  <span style={{color:C.gray400}}>in</span>
                  {sub.position&&<span style={{color:C.gray400,fontSize:11}}>{sub.position}</span>}
                  <span style={{color:C.gray300,fontSize:11,marginLeft:"auto"}}>{sub.timestamp}</span>
                </div>
              );
            })}
          </Card>
        )}

        {lu.starters.length>0&&(
          <div style={{marginTop:16,background:C.blueFaint,border:"1px solid "+C.blueLight,borderRadius:12,padding:"14px 16px"}}>
            <div style={{fontWeight:700,fontSize:13,color:C.blue,marginBottom:3}}>Ready for BBOT</div>
            <div style={{fontSize:12,color:C.gray500}}>{lu.starters.length} starters -- {lu.pitchers.length} pitchers -- {lu.reserves.length} reserves{lu.subs&&lu.subs.length>0?" -- "+lu.subs.length+" substitution"+(lu.subs.length!==1?"s":"")+" logged":""} -- go to BBOT tab to submit video</div>
          </div>
        )}
      </div>
    );
  }

  return null;
}

// NOTE: The backend (main.py) hardcodes its own evaluation system prompt and
// IGNORES any "system" field sent from the frontend. This stub exists only so
// the /evaluate fetch payload stays well-formed; editing it has no effect on
// evaluation output. The authoritative prompt lives in main.py.
var BBOT_SYSTEM_PROMPT="(backend-managed)";

// Card auto-generation fires on payment confirmed (see PdfUnlockButton)
function makeBbotRunner(ctx){
  var buildPrompt=function(player,pMetrics,pReports){
    // League age (Aug 1 rollover) — DERIVED FROM DOB ONLY, benchmarked to the session's
    // season. If there is no DOB, age is genuinely unknown — we send "Unknown" rather
    // than fabricate one, because grad year is NOT a valid age proxy (a player can be 19
    // and a junior). Grad year is passed separately below as class/recruiting context.
    var age = seasonAge(player, ctx.sessionDate);
    var ageStr = (age==null) ? "Unknown (no DOB on file — do NOT infer age from grad year; benchmark conservatively and note that age-graded tools are provisional)" : String(age);
    var classStr = player.gradYear ? ("Class of "+player.gradYear+" (academic class — NOT a basis for age)") : "Unknown";
    var metricsStr="No metrics on file.";
    if(pMetrics&&pMetrics.length){var latest=pMetrics[pMetrics.length-1];metricsStr="Latest session ("+latest.date+"): "+JSON.stringify(latest);}
    var reportsStr="No previous evaluations.";
    if(pReports&&pReports.length){
      reportsStr="Previous evaluations ("+pReports.length+"): "+pReports.map(function(r){
        var tools=(r.sections||[]).filter(function(s){return s.grade!=null;}).map(function(s){return s.label+" "+s.grade;}).join(", ");
        return (r.date||"?")+" — "+(tools||"no graded tools");
      }).join(" | ");
    }
    var rNames=(ctx.sessionRoster||[]).map(function(pid){var u=(ctx.allPlayers||[]).find(function(p){return String(p.id)===String(pid);});return u?(u.firstName+" "+u.lastName+(u.jerseyNum?" #"+u.jerseyNum:"")):"";}).filter(Boolean).join(", ");
    return "Evaluate the following player. Respond ONLY with valid JSON matching the schema in your instructions.\n\nSESSION ROSTER: "+(rNames||"Not specified")+"\n\nPLAYER: "+player.firstName+" "+player.lastName+"\nAGE: "+ageStr+"\nCLASS: "+classStr+"\nPOSITION: "+(player.position||"Unknown")+"\nBATS: "+(player.bats||"Unknown")+"\nTHROWS: "+(player.throws||"Unknown")+"\nSESSION TYPE: "+ctx.sessionType+"\nSESSION DATE: "+ctx.sessionDate+"\nVIDEO URL: "+(ctx.videoUrl||"No video submitted")+"\nMETRICS HISTORY: "+metricsStr+"\nPREVIOUS REPORTS: "+reportsStr+"\n\nGenerate a complete BBOT evaluation.";
  };
  return function(){
    if(!ctx.selP) return ctx.notify("Select a player","error");
    var player=(ctx.users||[]).find(function(u){return String(u.id)===String(ctx.selP);});
    if(!player) return ctx.notify("Player not found","error");
    // DOB guard — BBOT grades by age bracket. A player created before DOB
    // was enforced at signup may lack one; block the eval with a clear message rather
    // than produce an "Unknown age" report that can't be benchmarked or bucketed.
    if(!player.dob){
      ctx.setLoading&&ctx.setLoading(false);
      return ctx.notify("This player has no date of birth on file. Add their DOB to the profile before running an evaluation — BBOT grades by age bracket.","error");
    }
    var isCumulative = ctx.reportType==="player_eval";
    ctx.setLoading(true);

    // CUMULATIVE — compile approved sessions via /evaluate-player (no video required).
    if(isCumulative){
      fetch(BACKEND_URL+"/evaluate-player",{method:"POST",headers:bbotAdminHeaders(),body:JSON.stringify({playerId:player.id,playerName:(player.firstName+" "+player.lastName),position:player.position||null})}).then(function(r){
        return r.json().then(function(data){ return {ok:r.ok,status:r.status,data:data}; });
      }).then(function(res){
        ctx.setLoading(false);
        if(!res.ok){
          var msg=(res.data&&(res.data.detail||res.data.error))||("Backend "+res.status);
          return ctx.notify(typeof msg==="string"?msg:"Cumulative evaluation failed","error");
        }
        // Merge the new cumulative report into state so it shows immediately (no manual reload).
        var d=res.data||{};
        var pe=d.playerEvaluation||null;
        if(pe && ctx.setScoutReports){
          var merged=Object.assign({}, pe, {
            id: d.reportId || pe.id || Date.now(),
            playerId: player.id,
            reportType: "player_eval",
            status: pe.status || "draft",
            sessionType: "Cumulative",
            date: new Date().toISOString().slice(0,10),
            fullReport: pe
          });
          ctx.setScoutReports(function(prev){
            var others=(prev||[]).filter(function(p){return String(p.id)!==String(merged.id);});
            return others.concat([merged]);
          });
        }
        ctx.notify("Cumulative Player Evaluation generated.");
        // Auto-compile a highlights reel from this player's approved clips across all sessions.
        // Reuses the existing /compile-reel pipeline; the reel saves as pending_review (admin
        // must approve before it publishes — control step #12). Non-blocking: a reel failure
        // never affects the cumulative report itself.
        try {
          sbSelect("bbot_clips","?player_id=eq."+encodeURIComponent(String(player.id))+"&order=created_at.desc&limit=200").then(function(rows){
            var clips=(Array.isArray(rows)?rows:[]).filter(function(c){
              return c && c.clip_object_key && (c.approved===true || c.approved==="true");
            });
            if(clips.length<2){
              ctx.notify("Cumulative report ready. (Highlights reel needs 2+ approved clips — "+clips.length+" available; compile manually once more clips are approved.)");
              return;
            }
            // Cap the reel to a reasonable length: best/most-recent clips, ~90s target.
            var picked=clips.slice(0,12);
            ctx.notify("Compiling highlights reel from "+picked.length+" clips…");
            fetch(BACKEND_URL+"/compile-reel",{
              method:"POST", headers:bbotAdminHeaders(),
              body:JSON.stringify({
                playerId:String(player.id),
                playerName:player.firstName+" "+player.lastName,
                clips:picked.map(function(c){return {clipObjectKey:c.clip_object_key, durationSec:c.duration_sec};}),
                targetDurationSec:90,
                sessionDate:new Date().toISOString().slice(0,10)
              })
            }).then(function(r){
              if(!r.ok) return r.text().then(function(t){throw new Error(t||("HTTP "+r.status));});
              return r.json();
            }).then(function(){
              ctx.notify("✓ Highlights reel compiled — review and approve it to publish alongside the cumulative report.");
            }).catch(function(err){
              ctx.notify("Cumulative report ready; reel compile didn't complete ("+(err.message||"error")+"). You can compile it manually.","error");
            });
          }).catch(function(){ /* clip fetch failed — report still fine */ });
        } catch(_){}
      }).catch(function(e){
        ctx.setLoading(false);
        ctx.notify("Cumulative evaluation failed: "+(e.message||"unknown"),"error");
      });
      return;
    }

    // SINGLE SESSION — needs a video.
    if(!ctx.videoUrl){ ctx.setLoading(false); return ctx.notify("Upload a session video first","error"); }
    var pMetrics=(ctx.metrics||{})[player.id]||[];
    var pReports=(ctx.scoutReports||[]).filter(function(r){return String(r.playerId)===String(player.id);});
    var _objKey=(typeof window!=="undefined"&&window.__bbotLastUpload?window.__bbotLastUpload.objectKey:null);
    // AUTO-WARM pose first so the report carries mechanics/floor (else the completeness gate flags it
    // incomplete). Best-effort — warming never blocks the eval; on any failure it proceeds and the gate
    // is the safety net. kind: BP=hitter, Bullpen=pitcher, else by player role (so a Showcase hitter
    // gets hitter mechanics, not the sessionType-derived pitcher default).
    var _st=String(ctx.sessionType||"").toUpperCase();
    var _kind=(_st.indexOf("BP")>=0||_st.indexOf("BATTING")>=0)?"hitter":(_st.indexOf("BULLPEN")>=0?"pitcher":((player.position==="P"||player.isPitcher)?"pitcher":"hitter"));
    ctx.notify&&ctx.notify("Warming mechanics engine (pose)… ~1–2 min per clip window.");
    bbotWarmPose(_objKey, ctx.sessionType, function(done,total){ if(total>1&&ctx.notify) ctx.notify("Warming pose "+done+"/"+total+" windows…"); }, _kind, ((player&&(player.heightInches||heightToInches(player.height)))||null), (player?{name:((player.firstName||"")+" "+(player.lastName||"")).trim()||null, position:player.position||null, age:seasonAge(player), throws:player.throws||null}:null)).then(function(_w){
      if(_w&&isJobComplete(_w)&&ctx.notify) ctx.notify("✓ Pose ready — evaluating…");
      return fetch(BACKEND_URL+"/evaluate",{method:"POST",headers:bbotAdminHeaders(),body:JSON.stringify({system:BBOT_SYSTEM_PROMPT,prompt:buildPrompt(player,pMetrics,pReports),playerId:player.id,position:player.position||"",sessionDate:ctx.sessionDate,sessionType:ctx.sessionType,videoUrl:ctx.videoUrl,objectKey:_objKey,adminSpec:(ctx.adminSpec||null),sessionMode:(ctx.sessionMode||"individual"),hittingStartS:(ctx.hittingStartS!==""&&ctx.hittingStartS!=null?Number(ctx.hittingStartS):null),hittingEndS:(ctx.hittingEndS!==""&&ctx.hittingEndS!=null?Number(ctx.hittingEndS):null),activityBlocks:((ctx.activityBlocks&&ctx.activityBlocks.length)?ctx.activityBlocks:null)})});
    }).then(function(r){if(!r.ok)throw new Error("Backend "+r.status);return r.json();}).then(function(data){
      var parsed;
      if(data.evaluation){parsed=data.evaluation;}
      else if(data.content){var text=(data.content||[]).map(function(c){return c.text||"";}).join("");parsed=JSON.parse(text.replace(/```json|```/g,"").trim());}
      else{parsed=data;}
      // Player/video mismatch — surface a shortcut to create profile
      if(parsed && parsed.error==="player_video_mismatch"){
        ctx.setLoading(false);
        if(window.confirm((parsed.summary||"Video does not match player on file.")+"\n\nCreate a new player profile instead?")){
          // Store the video URL so registration page can prefill it
          try { sessionStorage.setItem("bbot_pending_video", ctx.videoUrl||""); } catch(e){}
          window.location.href = window.location.origin + window.location.pathname + "?bbot_create_profile=1";
        } else {
          ctx.notify("Evaluation rejected: player/video mismatch", "error");
        }
        return;
      }
      // Persist evaluation to Supabase
      var _reportId = parsed.id || Date.now();
      parsed.id = _reportId;
      try {
        reportSave({
          id: _reportId,
          player_id: String(player.id),
          player_name: player.firstName + " " + player.lastName,
          session_type: ctx.sessionType || "Evaluation",
          session_date: ctx.sessionDate || new Date().toISOString().slice(0,10),
          score: parsed.score || null,
          status: parsed.status || "draft",
          staff_id: (ctx.cu && ctx.cu.id) || parsed.staffId || null,
          staff_name: ctx.staffName || (parsed.staffName) || "",
          video_url: ctx.videoUrl || "",
          object_key: (typeof window!=="undefined"&&window.__bbotLastUpload?window.__bbotLastUpload.objectKey:null),
          summary: parsed.summary || "",
          sections: parsed.sections || [],
          full_report: parsed
        }).catch(function(err){ console.warn("Report sync failed:", err.message); });
      } catch(e) { console.warn("Report sync skipped:", e.message); }
      parsed.playerId=player.id;parsed.date=ctx.sessionDate;parsed.sessionType=ctx.sessionType;parsed.videoUrl=ctx.videoUrl;parsed.objectKey=(typeof window!=="undefined"&&window.__bbotLastUpload?window.__bbotLastUpload.objectKey:null);parsed.videoSource="bbot_recorded";parsed.staffId=ctx.cu.id;parsed.staffName=ctx.cu.firstName+" "+ctx.cu.lastName;parsed.status="draft";
      ctx.setScoutReports(function(prev){var others=(prev||[]).filter(function(p){return String(p.id)!==String(parsed.id);});return others.concat([parsed]);});
      if(parsed.highlights&&parsed.highlights.length){var newH=parsed.highlights.map(function(h){var m=(ctx.activeRoster||[]).find(function(r){return String(r.jerseyNum)===String(h.playerJersey);})||((ctx.allPlayers||[]).find(function(u){return String(u.jerseyNum)===String(h.playerJersey);}));var pid=m?(m.playerId||m.id):null; if(!pid && ctx.sessionMode==="multi" && h.playerJersey){ var prov=makeProvisionalPlayer({jerseyNum:h.playerJersey,teamName:ctx.teamName||"",users:ctx.allPlayers,setUsers:ctx.setUsers}); pid=prov.id; } return Object.assign({},h,{id:Date.now()+Math.random(),playerId:pid,videoUrl:ctx.videoUrl||"",date:ctx.sessionDate,staffId:ctx.cu.id,approved:false,source:"BBOT"});});ctx.setHighlights(function(prev){return(prev||[]).concat(newH);});ctx.notify(newH.length+" highlight clips detected");
        // Multi-player: backend tagged highlights to the single playerId, which is wrong here —
        // persist per-jersey from the frontend instead. (Individual sessions: backend already saved them.)
        if(ctx.sessionMode==="multi"){
          try {
            var hRows=newH.map(function(h){return {report_id:_reportId,player_id:(h.playerId!=null?String(h.playerId):null),player_jersey:h.playerJersey||null,video_url:ctx.videoUrl||"",start_sec:(h.startSec!=null?h.startSec:null),end_sec:(h.endSec!=null?h.endSec:null),action_type:h.actionType||null,label:h.label||"",metric_value:h.metricValue||"",metric_unit:h.metricUnit||"",confidence:h.confidence||"Confirmed",approved:false};});
              // REPLACE, NOT CLEAR-THEN-INSERT. These per-event tables are append-only, so a re-run
              // used to stack a second copy of the same events on one report_id and inflate every count
              // that aggregates over them. The first fix cleared the report's rows first -- but that
              // DELETE ran before the insert, so a failed insert left the report with nothing, and the
              // UI had already updated optimistically so the hole stayed invisible until a refresh.
              // The "replace" op inserts first and only then drops the previous generation, so a failed
              // insert removes nothing at all. The catch is still here because a failure now means the
              // rows never arrived -- not that the old ones were destroyed.
            if(hRows.length){ bbotWrite("bbot_highlights","replace",hRows,"report_id=eq."+encodeURIComponent(String(_reportId))).catch(function(err){console.warn("Highlight sync failed:",err&&err.message); ctx.notify("Highlights did not save — re-run this session to restore them","error");}); }
          } catch(e){ console.warn("Highlight sync skipped:",e&&e.message); }
        }
      }
      if(parsed.battedBalls&&parsed.battedBalls.length){
        var _nT=function(t){var s=String(t||"").toLowerCase().replace(/[\s_]/g,"");return s==="groundball"?"Ground Ball":s==="linedrive"?"Line Drive":s==="flyball"?"Fly Ball":s==="homerun"?"Home Run":(t||"");};
        var _nD=function(d){var s=String(d||"").toLowerCase().replace(/[\s_]/g,"");return s==="pull"?"Pull":s==="middle"?"Middle":s==="oppo"||s==="opposite"?"Oppo":(d||"");};
        var newBB=parsed.battedBalls.map(function(b){
          var m=(ctx.activeRoster||[]).find(function(r){return String(r.jerseyNum)===String(b.playerJersey);})||((ctx.allPlayers||[]).find(function(u){return String(u.jerseyNum)===String(b.playerJersey);}));
          var ev=(b.exitVeloMph!=null?b.exitVeloMph:(b.exitVelo!=null?b.exitVelo:null));
          var pid=m?(m.playerId||m.id):player.id;
          if(!m && ctx.sessionMode==="multi" && b.playerJersey){ var prov=makeProvisionalPlayer({jerseyNum:b.playerJersey,teamName:ctx.teamName||"",users:ctx.allPlayers,setUsers:ctx.setUsers}); pid=prov.id; }
          return Object.assign({},b,{id:Date.now()+Math.random(),playerId:pid,date:ctx.sessionDate,type:_nT(b.type),direction:_nD(b.direction),exitVelo:(ev!=null?Number(ev):null),distance:(b.approxDistanceFt!=null?b.approxDistanceFt:(b.distance||null))});
        });
        ctx.setBattedBalls(function(prev){return(prev||[]).concat(newBB);});
        if(typeof window!=="undefined"){window.__bbotBattedBalls=((window.__bbotBattedBalls||[])).concat(newBB);}
        // Persist to the bbot_batted_balls table so the chart survives page reload
        // (previously only kept in memory — charts vanished on the card/admin copy after refresh).
        // Persist per-jersey ONLY for a multi-player session — the backend handles individual
        // sessions (tagged to the one playerId). This prevents duplicate / mis-attributed rows.
        if(ctx.sessionMode==="multi"){
        try {
          var bbRows = newBB.map(function(b){return {
            report_id: _reportId,
            player_id: String(b.playerId||player.id),
            player_jersey: b.playerJersey||null,
            type: b.type||null,
            direction: b.direction||null,
            distance: (b.distance!=null?b.distance:null),
            exit_velo: (b.exitVelo!=null?b.exitVelo:null),
            confidence: b.confidence||null
          };});
          if(bbRows.length){
            bbotWrite("bbot_batted_balls","replace",bbRows,"report_id=eq."+encodeURIComponent(String(_reportId)))
              .catch(function(err){console.warn("Batted-ball sync failed:",err&&err.message); ctx.notify("Batted-ball data did not save — re-run this session to restore it","error");});
          }
        } catch(e){ console.warn("Batted-ball sync skipped:",e&&e.message); }
        }
      }
      if(parsed.pitches&&parsed.pitches.length){var newP=parsed.pitches.map(function(p){var m=(ctx.activeRoster||[]).find(function(r){return String(r.jerseyNum)===String(p.playerJersey);})||((ctx.allPlayers||[]).find(function(u){return String(u.jerseyNum)===String(p.playerJersey);}));var pid=m?(m.playerId||m.id):player.id; if(!m && ctx.sessionMode==="multi" && p.playerJersey){ var prov=makeProvisionalPlayer({jerseyNum:p.playerJersey,teamName:ctx.teamName||"",users:ctx.allPlayers,setUsers:ctx.setUsers}); pid=prov.id; } return{id:Date.now()+Math.random(),playerId:pid,reportId:parsed.id||null,pitchType:p.pitchType,velocityMph:p.velocityMph,plateX:p.plateX,plateZ:p.plateZ,result:p.result,batterSide:p.batterSide,count:p.count,confidence:p.confidence};});if(typeof window!=="undefined"){window.__bbotPitches=((window.__bbotPitches||[])).concat(newP);}
        if(ctx.sessionMode==="multi"){
        try {
          var pRows=newP.map(function(p){return {report_id:_reportId,player_id:String(p.playerId||player.id),player_jersey:p.playerJersey||null,pitch_type:p.pitchType||null,velocity_mph:(p.velocityMph!=null?p.velocityMph:null),plate_x:(p.plateX!=null?p.plateX:null),plate_z:(p.plateZ!=null?p.plateZ:null),result:p.result||null,batter_side:p.batterSide||null,count:p.count||null,confidence:p.confidence||null};});
          if(pRows.length){ bbotWrite("bbot_pitches","replace",pRows,"report_id=eq."+encodeURIComponent(String(_reportId))).catch(function(err){console.warn("Pitch sync failed:",err&&err.message); ctx.notify("Pitch data did not save — re-run this session to restore it","error");}); }
        } catch(e){ console.warn("Pitch sync skipped:",e&&e.message); }
        }
      }
      var _sessRecap={id:Date.now(),playerId:player.id,playerName:player.firstName+" "+player.lastName,staffId:ctx.cu.id,staffName:ctx.cu.firstName+" "+ctx.cu.lastName,date:ctx.sessionDate,sessionType:ctx.sessionType,videoUrl:ctx.videoUrl,objectKey:(typeof window!=="undefined"&&window.__bbotLastUpload?window.__bbotLastUpload.objectKey:null),reportId:parsed.id,score:parsed.score,highlightCount:(parsed.highlights||[]).length,battedBallCount:(parsed.battedBalls||[]).length,sections:parsed.sections||[],summary:parsed.summary||"",status:"pending",inferredVeloUsed:parsed.inferredVeloUsed||false};
      ctx.setRecaps(function(prev){return(prev||[]).concat([_sessRecap]);});
      // The recap is the session package the admin approves. An empty catch meant it could vanish
      // between "ready for approval" and the next refresh with nothing said.
      persistRecap(_sessRecap).catch(function(){ ctx.notify("Session recap did not save — re-run to restore it","error"); });
      ctx.notify("BBOT evaluation complete — session package ready for approval");
      ctx.setLoading(false);
    }).catch(function(err){ctx.notify("BBOT error: "+err.message,"error");ctx.setLoading(false);});
  };
}


function PlayerSelfUploadView({cu, notify, go}){
  // Player uploads their own video for a BBOT session eval (report + clips), priced at BBOT_PRICE_USD
  // Default session type to last-used (stored per user)
  var lastType = (typeof window!=="undefined" && localStorage.getItem("bbot_last_session_type_"+cu.id)) || "BP";
  var [sessionType, setSessionType] = useState(lastType);
  var [sessionDate, setSessionDate] = useState(new Date().toISOString().slice(0,10));
  var [uploadResult, setUploadResult] = useState(null);
  var [stage, setStage] = useState("upload"); // upload | uploaded | paying | processing | done
  var [detailsOpen, setDetailsOpen] = useState(false);
  var [reportId, setReportId] = useState(null);
  var [pollSeconds, setPollSeconds] = useState(0);
  var [acked, setAcked] = useState(false);
  var [typeAcked, setTypeAcked] = useState(false);
  // ---- THE CAPTURE REQUIREMENTS, ACKNOWLEDGED BEFORE UPLOAD ----------------------------------
  // `reqAcked` records that the customer has READ what BBOT needs. It does not stand in for any of
  // it: the radar reading and the frame rate are CONFIRMED from the pixels server-side, and an
  // acknowledged video with no radar in it is refused exactly like an unacknowledged one.
  var [reqAcked, setReqAcked] = useState(false);
  var [gateState, setGateState] = useState({checking:false, message:"", failed:[], passed:false});

  // Remember session type choice
  useEffect(function(){
    if(typeof window!=="undefined") localStorage.setItem("bbot_last_session_type_"+cu.id, sessionType);
  }, [sessionType, cu.id]);

  // EVAL POLLING: after Stripe payment returns, poll until report is ready
  useEffect(function(){
    if(stage !== "processing" || !reportId) return;
    // Cap the poll at ~10 minutes so the user doesn't sit on a spinner forever if BBOT is
    // genuinely stuck. After timeout we tell them their eval is taking longer than usual
    // and to check back; admin will see it in the queue regardless.
    var POLL_TIMEOUT_S = 600;
    var tick = setInterval(function(){
      setPollSeconds(function(s){
        var next = s+5;
        if(next >= POLL_TIMEOUT_S){
          clearInterval(tick);
          notify("Evaluation is taking longer than usual — admin will review it shortly. You can close this and check your profile in a few minutes.","error");
        }
        return next;
      });
      bbotReports({select:"id,status,score",limit:5000}).then(function(all){
        var rows=(all||[]).filter(function(x){return String(x.id)===String(reportId);});
        if(!rows || !rows[0] || !rows[0].status) return;
        var st = rows[0].status;
        if(st === "pending_payment") return; // still queued, keep polling
        clearInterval(tick);
        // Distinguish success from failure so the user gets the right message.
        if(st === "error" || st === "failed"){
          setStage("uploaded"); // back to a state where they can re-try
          notify("Your evaluation hit a technical issue. Please try uploading again, or contact 643sportsmgmt@gmail.com for a refund.","error");
        } else {
          setStage("done");
          notify("✓ Your BBOT evaluation is ready");
        }
      }).catch(function(){});
    }, 5000);
    return function(){clearInterval(tick);};
  }, [stage, reportId]);

  function startUploadFlow(result){
    setUploadResult(result);
    setStage("uploaded");
    // ---- THE GATE RUNS THE MOMENT THE FILE LANDS, NOT AT THE PAY BUTTON -------------------
    // Gating a single pay button would have left the ATH Movil path open: there are TWO ways to
    // start a purchase from this screen and only one of them was the obvious one. Running the
    // check on upload completion means the verdict is known before ANY payment control renders,
    // so there is no path to a charge that skips it — and a customer whose video is going to be
    // refused learns it immediately instead of after reading the payment terms.
    runSubmissionGate(result);
  }

  function runSubmissionGate(result){
    var ur = result || uploadResult;
    if(!ur || !ur.objectKey) return;
    setGateState({checking:true, message:"", failed:[], passed:false});
    fetch(BACKEND_URL+"/submission-gate", {
      method:"POST", headers: bbotAdminHeaders(),
      body: JSON.stringify({objectKey: ur.objectKey, acknowledged: !!reqAcked})
    }).then(function(r){ return r.json().then(function(j){ return {status:r.status, j:j}; }); })
      .then(function(res){
        var j = res.j || {};
        if(res.status >= 400 || j.held){
          // AN OUTAGE IS NOT A REJECTION. "We could not look" and "we looked and it is not there"
          // are different facts, and only one of them is about the customer's video.
          setGateState({checking:false, passed:false, failed:[],
            message:"This video could not be checked right now — nothing was charged and nothing was submitted. Please try again in a moment."});
          return;
        }
        if(!j.ok){
          setGateState({checking:false, passed:false, failed:j.failed||[],
            message:j.message||"This video does not meet BBOT's capture requirements."});
          return;
        }
        setGateState({checking:false, passed:true, failed:[], message:"",
                      radar:j.radar, fps:j.fps});
      }).catch(function(){
        setGateState({checking:false, passed:false, failed:[],
          message:"This video could not be checked right now — nothing was charged and nothing was submitted. Please try again in a moment."});
      });
  }

  function proceedToPayment(result){
    var ur = result || uploadResult;
    if(!ur) return notify("Upload a video first","error");
    // Block accounts that haven't been approved yet — protects against spam/cost abuse.
    if(cu.approvalStatus==="pending"){ notify("Your account is awaiting admin approval. You'll be able to purchase an evaluation once approved.","error"); return; }
    // DOB is required for an age-benchmarked evaluation. New signups always have it, but
    // guard here too so a legacy account can't pay for an eval that can't be graded.
    if(!cu.dob){ notify("Please add your date of birth on your profile before purchasing an evaluation — BBOT grades by age bracket.","error"); return; }
    // SECOND GUARD, not a second check. The gate already ran on upload completion and no payment
    // control renders without it; this refuses a call that reached here any other way, because a
    // charge must never depend on a button being hidden.
    if(!gateState.passed){ notify(gateState.message||"This video has not passed BBOT's capture check.","error"); return; }
    setStage("paying");
    var newReportId = Date.now();
    setReportId(newReportId);
    // DB row uses snake_case columns (Postgres). Keep a separate camelCase object
    // for startCheckout (which reads videoSource / _partialAcked client-side).
    var dbRow = {
      id: newReportId,
      player_id: String(cu.id),
      player_name: (cu.firstName||"")+" "+(cu.lastName||""),
      session_type: sessionType,
      session_date: sessionDate,
      status: "pending_payment",
      object_key: ur.objectKey,
      video_url: ur.readUrl,
      score: null,
      full_report: {videoSource:"player_upload"}
    };
    var pendingReport = {
      id: newReportId,
      playerId: String(cu.id),
      videoSource: "player_upload",
      objectKey: ur.objectKey,
      sessionType: sessionType,
      sessionDate: sessionDate,
      status: "pending_payment",
      _partialAcked: true,
    };
    reportSave(dbRow).then(function(){
      // PRE-CHECKOUT VALIDATION — make sure the video is readable before charging.
      notify("Checking video quality…");
      return fetch(BACKEND_URL+"/validate-video",{
        method:"POST",headers:bbotAdminHeaders(),
        body:JSON.stringify({objectKey:ur.objectKey})
      }).then(function(r){return r.json();}).then(function(v){
        if(v && v.ok===false){
          notify(v.reason||"Video couldn't be read — please re-upload.","error");
          setStage("uploaded");
          return;
        }
        startCheckout(pendingReport, cu);
      }).catch(function(){
        // If validation itself errors, fail open (don't block the sale).
        startCheckout(pendingReport, cu);
      });
    }).catch(function(){
      notify("Could not create payment session","error");
      setStage("uploaded");
    });
  }

  // ATH Móvil path for self-upload: ATH's button needs a report row to exist at
  // render time, so we create + validate the row first, then reveal the button.
  var athmReadyState = useState(null); var athmReady = athmReadyState[0]; var setAthmReady = athmReadyState[1];
  function prepareAthmPayment(result){
    var ur = result || uploadResult;
    if(!ur) return notify("Upload a video first","error");
    var newReportId = Date.now();
    setReportId(newReportId);
    var dbRow = {
      id: newReportId,
      player_id: String(cu.id),
      player_name: (cu.firstName||"")+" "+(cu.lastName||""),
      session_type: sessionType,
      session_date: sessionDate,
      status: "pending_payment",
      object_key: ur.objectKey,
      video_url: ur.readUrl,
      score: null,
      full_report: {videoSource:"player_upload"}
    };
    notify("Checking video quality…");
    reportSave(dbRow).then(function(){
      return fetch(BACKEND_URL+"/validate-video",{
        method:"POST",headers:bbotAdminHeaders(),
        body:JSON.stringify({objectKey:ur.objectKey})
      }).then(function(r){return r.json();}).then(function(v){
        if(v && v.ok===false){
          notify(v.reason||"Video couldn't be read — please re-upload.","error");
          return;
        }
        setAthmReady({ reportId: newReportId, objectKey: ur.objectKey });
      }).catch(function(){
        // Validation errored — fail open and let them pay.
        setAthmReady({ reportId: newReportId, objectKey: ur.objectKey });
      });
    }).catch(function(){ notify("Could not start payment","error"); });
  }

  // Show "processing" screen if we returned from Stripe with a paid report
  useEffect(function(){
    if(typeof window!=="undefined" && window.__bbotPaymentSuccess && reportId){
      setStage("processing");
    }
  }, []);

  return (
    <div style={{maxWidth:560,margin:"24px auto",padding:"0 16px"}}>
      <HowToUse role="player"/>
      {/* PHASE D — tiered filming guide, surfaced BEFORE upload so users film right the first time */}
      {stage === "upload" && <BbotCaptureGuide/>}
      <Card style={{padding:18}}>
        {/* Header — sized down */}
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",gap:10,marginBottom:14}}>
          <div>
            <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:16,color:C.navy,letterSpacing:1}}>UPLOAD VIDEO</div>
            <div style={{fontSize:11,color:C.gray500,marginTop:2}}>{BBOT_PRICE_LABEL} · Report + clips ready shortly after payment</div>
          </div>
          <div style={{fontSize:10,color:C.gray400,textAlign:"right",lineHeight:1.4}}>Session<br/><strong style={{color:C.coral,fontSize:12}}>{sessionType}</strong></div>
        </div>

        {/* Collapsible details — defaults to closed (most uploads are BP, today) */}
        {stage === "upload" && (
          <div style={{marginBottom:14}}>
            <button onClick={function(){setDetailsOpen(!detailsOpen);}} style={{background:"transparent",border:"none",color:C.gray500,fontSize:11,padding:"4px 0",cursor:"pointer",fontWeight:600,textDecoration:"underline"}}>
              {detailsOpen ? "▾ Hide session details" : "▸ Change session type or date"}
            </button>
            {detailsOpen && (
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8,marginTop:8}}>
                <div>
                  <label style={{fontSize:10,color:C.gray500,fontWeight:600,display:"block",marginBottom:3,letterSpacing:.5}}>TYPE</label>
                  <select value={sessionType} onChange={function(e){setSessionType(e.target.value);}} style={{width:"100%",padding:"7px 10px",border:"1px solid "+C.border,borderRadius:6,fontSize:12}}>
                    {SESSION_TYPES.map(function(t){return <option key={t.value} value={t.value}>{t.label}</option>;})}
                  </select>
                  <div style={{fontSize:10,color:C.gray500,marginTop:4,lineHeight:1.4}}>
                    {sessionType==="BP"?"Hitting only — swings off a pitch/tee/machine. Evaluates Hit & Power."
                    :sessionType==="Fielding Drill"?"Defensive reps — grounders, fly balls, throws. Evaluates Field & Arm."
                    :sessionType==="Bullpen"?"Pitching only — mound work. Evaluates pitch velocity & command."
                    :sessionType==="Live Game"?"Game footage — at-bats and/or defense in a game."
                    :"Multi-tool showcase — hitting, fielding, throwing, running."}
                  </div>
                </div>
                <div>
                  <label style={{fontSize:10,color:C.gray500,fontWeight:600,display:"block",marginBottom:3,letterSpacing:.5}}>DATE</label>
                  <input type="date" value={sessionDate} onChange={function(e){setSessionDate(e.target.value);}} style={{width:"100%",padding:"7px 10px",border:"1px solid "+C.border,borderRadius:6,fontSize:12}}/>
                </div>
              </div>
            )}
          </div>
        )}

        {/* Upload widget — only show when in upload stage, after confirming the type matches */}
        {(stage === "upload" || stage === "uploaded") && (
          <div>
            {/* ---- WHAT BBOT NEEDS, SAID BEFORE THE UPLOAD ------------------------------------
                A customer should learn the requirements before spending time uploading, not after
                a rejection. The first two are CONFIRMED FROM THE FOOTAGE server-side once the file
                lands; the last two are filming guidance BBOT cannot check and does not pretend to.
                Acknowledging this box is not evidence of any of it. */}
            {stage==="upload" && (
              <div style={{border:"1.5px solid "+C.coral,borderRadius:10,padding:"12px 14px",marginBottom:10,background:C.coralFaint}}>
                <div style={{fontSize:11,fontWeight:700,color:C.coral,letterSpacing:.5,marginBottom:8}}>WHAT YOUR VIDEO MUST HAVE</div>
                <ul style={{margin:0,paddingLeft:18,fontSize:12,color:C.gray700,lineHeight:1.7}}>
                  <li><b>Required — a radar reading visible in frame.</b> BBOT&rsquo;s velocities come off the radar&rsquo;s own screen in your footage &mdash; any make, as long as the display is facing the camera and large enough to read. It reads what it can read and refuses the rest rather than guessing, so a gun that is out of shot, turned away or blank at the moment of the rep produces no number. Higher frame rates read more reliably. <b>Checked automatically; no reading means no evaluation.</b></li>
                  <li><b>Recommended — film at 60fps.</b> Your radar velocities are read off the display in the footage whatever the frame rate. Filming at true 60fps <em>adds</em> movement-timing detail on top. Not required.</li>
                  <li><b>The player framed in shot</b> — whole body in frame through every rep, steady camera.</li>
                  <li><b>Good light</b> — avoid heavy backlight and dark or grainy footage.</li>
                </ul>
                <label style={{display:"flex",alignItems:"flex-start",gap:8,marginTop:10,cursor:"pointer",fontSize:12,color:C.gray700,lineHeight:1.45}}>
                  <input type="checkbox" checked={reqAcked} onChange={function(e){setReqAcked(e.target.checked);}} style={{marginTop:2,flexShrink:0}}/>
                  <span>I&rsquo;ve read the requirements. I understand BBOT checks for a readable radar reading automatically, and that a video without one is rejected before any charge.</span>
                </label>
              </div>
            )}
            {stage==="upload" && (
              <label style={{display:"flex",alignItems:"flex-start",gap:8,padding:"10px 12px",background:C.gray50,borderRadius:8,marginBottom:10,cursor:"pointer",fontSize:12,color:C.gray700,lineHeight:1.45}}>
                <input type="checkbox" checked={typeAcked} onChange={function(e){setTypeAcked(e.target.checked);}} style={{marginTop:2,flexShrink:0}}/>
                <span>I confirm this video is a <b>{sessionType}</b> session. Choosing the wrong type produces an inaccurate report and may require a re-do.</span>
              </label>
            )}
            {((typeAcked && reqAcked) || stage==="uploaded") ? (
              <VideoUploadWidget
                backendUrl={BACKEND_URL}
                purpose="player_self"
                playerId={cu.id}
                sessionDate={sessionDate}
                sessionType={sessionType}
                onUploaded={startUploadFlow}
                notify={notify}
              />
            ) : (
              <div style={{padding:"12px",textAlign:"center",fontSize:12,color:C.gray400,border:"1px dashed "+C.border,borderRadius:8}}>{!reqAcked?"Read and acknowledge the requirements above to upload.":"Confirm the session type above to upload."}</div>
            )}
            <p style={{fontSize:11,color:C.gray500,lineHeight:1.55,marginTop:10}}>This is a <strong>player-submitted</strong> video. 643 did not film or verify it — your clip is labeled as player-submitted, and the evaluation reflects only what your footage shows. You confirm you have the right to upload and record this video.</p>
          </div>
        )}

        {/* Upload complete — disclaimer + acknowledgment required before payment */}
        {stage === "uploaded" && uploadResult && (
          <div style={{marginTop:12}}>
            <div style={{padding:12,background:C.blueFaint,borderRadius:8,textAlign:"center",marginBottom:12}}>
              <div style={{fontSize:13,color:C.navy,fontWeight:600}}>✓ Upload complete</div>
            </div>

            {/* ---- THE CAPTURE CHECK, AND ITS VERDICT --------------------------------------
                While it runs, nothing about payment is on screen. If it refuses, the reason is
                named and no payment control renders at all — there is no path from a rejected
                video to a charge. */}
            {gateState.checking && (
              <div style={{padding:14,border:"1px solid "+C.border,borderRadius:10,marginBottom:12,textAlign:"center"}}>
                <div style={{width:26,height:26,border:"3px solid "+C.gray200,borderTopColor:C.coral,borderRadius:"50%",margin:"0 auto 8px",animation:"spin 0.8s linear infinite"}}/>
                <div style={{fontSize:12,color:C.gray600}}>Checking your video for a readable radar reading…</div>
                <div style={{fontSize:11,color:C.gray400,marginTop:4}}>Nothing is charged until this passes.</div>
              </div>
            )}
            {!gateState.checking && gateState.message && (
              <div style={{padding:"14px 16px",border:"1.5px solid "+C.coral,background:C.coralFaint,borderRadius:10,marginBottom:12}}>
                <div style={{fontSize:12,fontWeight:700,color:C.coral,letterSpacing:.4,marginBottom:6}}>
                  {gateState.failed && gateState.failed.length ? "SUBMISSION REJECTED" : "COULD NOT CHECK THIS VIDEO"}
                </div>
                <div style={{fontSize:12.5,color:C.gray700,lineHeight:1.6}}>{gateState.message}</div>
                <div style={{fontSize:11,color:C.gray500,lineHeight:1.55,marginTop:8}}>No evaluation was created and nothing was charged. Upload a video that meets the requirements to continue.</div>
              </div>
            )}
            {!gateState.checking && gateState.passed && (
              <div style={{padding:"10px 12px",border:"1px solid "+C.blue,background:C.blueFaint,borderRadius:8,marginBottom:12,fontSize:11.5,color:C.navy,lineHeight:1.55}}>
                ✓ Radar reading confirmed in your footage{gateState.radar&&gateState.radar.mph?" ("+gateState.radar.mph+" mph)":""} — your full measured evaluation is available.
                {gateState.enrichment&&gateState.enrichment.movement_timing
                  ? " True 60fps confirmed, so this session also supports movement-timing detail."
                  : " Filmed below 60fps, so movement-timing detail is not included — the radar measurements are unaffected."}
              </div>
            )}
            <div style={{padding:"12px 14px",background:"#fffbeb",border:"1px solid #fcd34d",borderRadius:10,marginBottom:12}}>
              <div style={{fontSize:12,fontWeight:700,color:"#92400e",marginBottom:6}}>Before you pay — about player-submitted video</div>
              <div style={{fontSize:11.5,color:"#78350f",lineHeight:1.6}}>
                BBOT only grades what is clearly observable in your footage. If your video doesn't show every tool (for example, no throws or no baserunning), BBOT will generate a <strong>partial evaluation</strong> — grading the tools it can see and marking the rest "not observable this session." A partial evaluation is still a complete, paid report of what your footage supported. Official 643-filmed sessions are designed to capture every tool.
              </div>
              <label style={{display:"flex",alignItems:"flex-start",gap:8,marginTop:10,cursor:"pointer"}}>
                <input type="checkbox" checked={acked} onChange={function(e){setAcked(e.target.checked);}} style={{marginTop:2}}/>
                <span style={{fontSize:11.5,color:"#78350f",lineHeight:1.5}}>I understand my video may produce a partial evaluation and I accept this before payment.</span>
              </label>
            </div>
            {gateState.passed && (BBOT_ATHM_ENABLED ? (
              athmReady ? (
                <div>
                  <AthMovilButton reportId={athmReady.reportId} amountUSD={BBOT_PRICE_SESSION_USD} playerId={cu.id} videoSource="player_upload" label="Recommended · lower fees in Puerto Rico" notify={notify} onPaid={function(){ setStage("processing"); }}/>
                  <div style={{textAlign:"center",marginTop:10}}>
                    <button onClick={function(){ if(acked) proceedToPayment(uploadResult); }} style={{background:"none",border:"none",color:C.gray500,fontSize:11,textDecoration:"underline",cursor:"pointer"}}>Pay by card instead (outside PR)</button>
                  </div>
                </div>
              ) : (
                <Btn v="primary" full disabled={!acked} style={{fontSize:13,padding:"11px",opacity:acked?1:0.5}} onClick={function(){ if(acked) prepareAthmPayment(uploadResult); }}>Continue to Payment — {BBOT_PRICE_LABEL}</Btn>
              )
            ) : (
              <div>
                <Btn v="primary" full disabled={!acked} style={{fontSize:13,padding:"11px",opacity:acked?1:0.5}} onClick={function(){ if(acked) proceedToPayment(uploadResult); }}>Continue to Payment — {BBOT_PRICE_LABEL}</Btn>
                <AthMovilButton reportId={0} amountUSD={BBOT_PRICE_SESSION_USD} playerId={cu.id} videoSource="player_upload" notify={notify}/>
              </div>
            ))}
          </div>
        )}

        {/* Paying / waiting for Stripe redirect */}
        {stage === "paying" && (
          <div style={{padding:16,textAlign:"center"}}>
            <div style={{width:32,height:32,border:"3px solid "+C.gray200,borderTopColor:C.coral,borderRadius:"50%",margin:"0 auto 10px",animation:"spin 0.8s linear infinite"}}/>
            <div style={{fontSize:12,color:C.gray600}}>Opening secure payment...</div>
          </div>
        )}

        {/* PROCESSING — eval polling */}
        {stage === "processing" && (
          <div style={{padding:18,textAlign:"center"}}>
            <div style={{width:40,height:40,border:"3px solid "+C.gray200,borderTopColor:C.coral,borderRadius:"50%",margin:"0 auto 12px",animation:"spin 0.8s linear infinite"}}/>
            <div style={{fontSize:14,color:C.navy,fontWeight:600,marginBottom:4}}>Generating your BBOT evaluation</div>
            <div style={{fontSize:11,color:C.gray500,marginBottom:8}}>{pollSeconds}s elapsed</div>
            <div style={{fontSize:10,color:C.gray400,fontStyle:"italic"}}>You can leave this page — we'll notify you when ready</div>
          </div>
        )}

        {/* DONE */}
        {stage === "done" && (
          <div style={{padding:16,textAlign:"center"}}>
            <div style={{fontSize:40,marginBottom:8}}>✓</div>
            <div style={{fontSize:15,color:C.navy,fontWeight:700,marginBottom:4}}>Your report is ready</div>
            <div style={{fontSize:12,color:C.gray500,marginBottom:14}}>Tap below to view your BBOT evaluation</div>
            <div style={{display:"flex",gap:8,justifyContent:"center",flexWrap:"wrap"}}>
              <Btn v="primary" onClick={function(){go("profile");}}>View Report</Btn>
              <Btn v="ghost" onClick={function(){
                setStage("upload");
                setUploadResult(null);
                setReportId(null);
                setPollSeconds(0);
              }}>Upload Another</Btn>
            </div>
          </div>
        )}
      </Card>
    </div>
  );
}

function InviteTeamView({cu, notify}){
  // Coaches bulk-onboard their roster via a shareable invite link.
  // Players who sign up via the link are auto-tagged to this coach's org.
  var origin = (typeof window!=="undefined") ? (window.location.origin + window.location.pathname) : "https://www.643sportsmgmt.com";
  var inviteLink = origin + "#join/" + encodeURIComponent(String(cu.id));
  var emailsS = useState(""); var emails = emailsS[0]; var setEmails = emailsS[1];

  function copyLink(){
    try { navigator.clipboard.writeText(inviteLink); notify("Invite link copied"); }
    catch(e){ notify("Copy failed — long-press to copy","error"); }
  }
  function shareLink(){
    if(navigator.share){ navigator.share({title:"Join my team on BBOT", text:"Get your verified baseball evaluation — join my roster on BBOT:", url:inviteLink}).catch(function(){}); }
    else copyLink();
  }
  function emailInvites(){
    var list = emails.split(/[\s,;]+/).filter(function(e){return e.indexOf("@")>0;});
    if(!list.length) return notify("Enter at least one email","error");
    var subject = encodeURIComponent("Join my team on BBOT — get your evaluation");
    var body = encodeURIComponent("I'm using BBOT for verified player evaluations. Join my roster here:\n\n"+inviteLink+"\n\nUpload a session video and get a verified report.");
    // Opens the coach's mail client with all recipients (BCC keeps the roster private)
    window.location.href = "mailto:?bcc="+list.join(",")+"&subject="+subject+"&body="+body;
    notify(list.length+" invite(s) queued in your email app");
  }

  return (
    <div style={{maxWidth:640,margin:"0 auto",padding:"0 16px 40px"}}>
      <SectionHeader>Invite Your Team</SectionHeader>
      <div style={{fontSize:13,color:C.gray600,marginBottom:18,lineHeight:1.6}}>Bring your whole roster onto BBOT. Players who join through your link are tagged to your team, so their profiles and evaluations show up in your roster automatically.</div>

      <Card style={{padding:16,marginBottom:16}}>
        <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:12,color:C.coral,letterSpacing:1,marginBottom:8}}>YOUR TEAM INVITE LINK</div>
        <div style={{display:"flex",gap:8,alignItems:"center",flexWrap:"wrap"}}>
          <input readOnly value={inviteLink} style={{flex:1,minWidth:200,padding:"10px 12px",border:"1px solid "+C.border,borderRadius:8,fontSize:12,color:C.gray600,background:C.gray50}}/>
          <Btn v="primary" style={{fontSize:12,padding:"9px 16px"}} onClick={copyLink}>Copy</Btn>
          <Btn v="outline" style={{fontSize:12,padding:"9px 16px"}} onClick={shareLink}>Share</Btn>
        </div>
        <div style={{fontSize:11,color:C.gray400,marginTop:8}}>Text or post this link to your players. One link works for your whole team.</div>
      </Card>

      <Card style={{padding:16}}>
        <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:12,color:C.coral,letterSpacing:1,marginBottom:8}}>OR EMAIL INVITES</div>
        <textarea value={emails} onChange={function(e){setEmails(e.target.value);}} rows={4} placeholder="Paste player (or parent) emails, separated by commas or new lines" style={{width:"100%",padding:12,border:"1px solid "+C.border,borderRadius:8,fontSize:13,resize:"vertical",fontFamily:"inherit"}}/>
        <div style={{display:"flex",justifyContent:"flex-end",marginTop:10}}>
          <Btn v="primary" style={{fontSize:12,padding:"9px 18px"}} onClick={emailInvites}>Send Invites</Btn>
        </div>
        <div style={{fontSize:11,color:C.gray400,marginTop:8}}>Opens your email app with the invites ready to send (recipients are BCC hidden to keep your roster private).</div>
      </Card>
    </div>
  );
}

function CoachUploadView({cu, users, notify}){
  // Coach uploads video tied to a specific player → goes to admin approval queue
  var [selectedPlayerId, setSelectedPlayerId] = useState("");
  var [sessionType, setSessionType] = useState("Live Game");
  var [sessionDate, setSessionDate] = useState(new Date().toISOString().slice(0,10));
  var [uploadResult, setUploadResult] = useState(null);
  var [note, setNote] = useState("");
  var [typeAcked, setTypeAcked] = useState(false);

  var players = (users||[]).filter(function(u){return u.type==="player";});

  function submitForApproval(){
    if(!uploadResult) return notify("Upload a video first","error");
    if(cu.approvalStatus==="pending"){ notify("Your account is awaiting admin approval. You'll be able to submit evaluations once approved.","error"); return; }
    if(!selectedPlayerId) return notify("Select the player this video is of","error");
    var player=(players||[]).find(function(p){return String(p.id)===String(selectedPlayerId);})||{};
    if(!player.dob){ notify("This player has no date of birth on file. They'll need to add it to their profile before an evaluation can be graded for their age bracket.","error"); return; }
    var rid=Date.now();
    // UNIVERSAL RULE: coaches only TRIGGER. Create a locked awaiting_payment report
    // for the player. BBOT generates and admin reviews only after the PLAYER pays.
    var row={
      id: rid,
      player_id: String(selectedPlayerId),
      player_name: (player.firstName||"")+" "+(player.lastName||""),
      session_type: sessionType||"Evaluation",
      session_date: sessionDate||new Date().toISOString().slice(0,10),
      status: "awaiting_payment",
      object_key: uploadResult.objectKey,
      video_url: uploadResult.readUrl,
      staff_id: cu.id,
      staff_name: cu.firstName+" "+cu.lastName+" ("+(cu.coachRole||"Coach")+")",
      summary: "",
      sections: [],
      full_report: {videoSource:"coach_submission", submitterNote:note, submitterOrg:cu.orgName||""}
    };
    reportSave(row).then(function(){
      notify("Evaluation requested for "+(player.firstName||"the player")+". It now unlocks for them to purchase — BBOT generates and 643 reviews after they pay.");
      setUploadResult(null);
      setNote("");
      setSelectedPlayerId("");
    }).catch(function(){
      notify("Submission failed","error");
    });
  }

  return (
    <div style={{maxWidth:680,margin:"24px auto",padding:"0 16px"}}>
      <Card>
        <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:18,color:C.navy,letterSpacing:1,marginBottom:6}}>SUBMIT PLAYER VIDEO</div>
        <div style={{fontSize:12,color:C.gray500,marginBottom:16}}>Submit footage of a player you've worked with or scouted. This requests an evaluation — the player chooses to purchase it, then BBOT generates the report and 643 reviews it before it appears on their profile.</div>

        {!cu.verified && (
          <div style={{padding:10,background:"#fef3c7",borderRadius:6,marginBottom:14,fontSize:11,color:"#92400e"}}>
            Your account is pending admin verification. Submissions are accepted but may take longer to review.
          </div>
        )}

        <div style={{marginBottom:14}}>
          <label style={{fontSize:10,color:C.gray500,fontWeight:600,display:"block",marginBottom:3,letterSpacing:.5}}>PLAYER *</label>
          <SearchSelect
            value={selectedPlayerId}
            onChange={function(v){setSelectedPlayerId(v);}}
            options={players.map(function(p){return {value:p.id, label:p.firstName+" "+p.lastName, sub:[p.position,p.gradYear?"Class "+p.gradYear:null,p.hsName||p.clubName].filter(Boolean).join(" · ")};})}
            placeholder="Search players..."
            allowCustom={false}
          />
        </div>

        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginBottom:14}}>
          <div>
            <label style={{fontSize:10,color:C.gray500,fontWeight:600,display:"block",marginBottom:3,letterSpacing:.5}}>SESSION TYPE</label>
            <select value={sessionType} onChange={function(e){setSessionType(e.target.value);}} style={{width:"100%",padding:"7px 10px",border:"1px solid "+C.border,borderRadius:6,fontSize:12}}>
              {SESSION_TYPES.map(function(t){return <option key={t.value} value={t.value}>{t.label}</option>;})}
            </select>
          </div>
          <div>
            <label style={{fontSize:10,color:C.gray500,fontWeight:600,display:"block",marginBottom:3,letterSpacing:.5}}>SESSION DATE</label>
            <input type="date" value={sessionDate} onChange={function(e){setSessionDate(e.target.value);}} style={{width:"100%",padding:"7px 10px",border:"1px solid "+C.border,borderRadius:6,fontSize:12}}/>
          </div>
        </div>

        <div style={{marginBottom:14}}>
          <label style={{fontSize:10,color:C.gray500,fontWeight:600,display:"block",marginBottom:3,letterSpacing:.5}}>NOTE TO ADMIN (optional)</label>
          <textarea value={note} onChange={function(e){setNote(e.target.value);}} placeholder="e.g. 5th inning at-bats only, ignore the warmup at start" rows="2" style={{width:"100%",padding:"8px 10px",border:"1px solid "+C.border,borderRadius:6,fontSize:12,resize:"vertical"}}/>
        </div>

        {selectedPlayerId && (
          <label style={{display:"flex",alignItems:"flex-start",gap:8,padding:"10px 12px",background:C.gray50,borderRadius:8,marginBottom:12,cursor:"pointer",fontSize:12,color:C.gray700,lineHeight:1.45}}>
            <input type="checkbox" checked={typeAcked} onChange={function(e){setTypeAcked(e.target.checked);}} style={{marginTop:2,flexShrink:0}}/>
            <span>I confirm this video is a <b>{sessionType}</b> session for the selected player. Wrong type or player produces an inaccurate report and may require a re-do.</span>
          </label>
        )}

        {typeAcked && selectedPlayerId ? (
        <VideoUploadWidget
          backendUrl={BACKEND_URL}
          purpose="coach_submission"
          playerId={selectedPlayerId}
          sessionDate={sessionDate}
          sessionType={sessionType}
          onUploaded={function(result){
            setUploadResult(result);
            notify("Upload complete. Click Submit to send for admin review.");
          }}
          notify={notify}
        />
        ) : (
          <div style={{padding:"12px",textAlign:"center",fontSize:12,color:C.gray400,border:"1px dashed "+C.border,borderRadius:8}}>{selectedPlayerId?"Confirm the session type above to upload.":"Select a player first."}</div>
        )}

        {uploadResult && selectedPlayerId && (<>
          <div style={{marginTop:12,padding:"10px 12px",background:"#fffbeb",border:"1px solid #fcd34d",borderRadius:8,fontSize:11,color:"#78350f",lineHeight:1.55}}>Player-submitted video that doesn't show every tool will produce a <strong>partial evaluation</strong> — BBOT grades what it can observe and marks the rest "not observable." The player accepts this before payment.</div>
          <Btn v="primary" full style={{marginTop:14,fontSize:13,justifyContent:"center"}} onClick={submitForApproval}>Submit for Admin Review</Btn></>
        )}
      </Card>
    </div>
  );
}

// ============================================================
// CAMERA ANGLE — NOBODY IS ASKED. BBOT determines it from the footage.
//
// This was a required three-option selector for one afternoon. It came out again, ruled
// 2026-08-09: a question that can go unanswered cannot be a dependency of certification, and an
// angle a customer guessed at is worse than one refused — a wrongly-claimed angle certifies the
// WRONG HUMAN, which is the exact failure subject certification exists to prevent.
//
// The angle is now read per segment from signals the pose pass already computes, stamped with its
// confidence and its evidence, and 'unknown' still fails closed. Admin override survives as the
// correction path. What stays here is GUIDANCE ONLY: it teaches better filming, and it asks for
// nothing.
// ============================================================
var BBOT_ANGLE_PRESCRIPTION = "Best angles: an open side view, or elevated behind the plate. Filming from directly behind the catcher blocks the batter's lower body — stride, foot plant and weight shift can't be measured from there.";

function CameraAngleGuidance(){
  return (
    <div style={{marginTop:10,padding:"10px 12px",background:C.blueFaint,borderRadius:8,fontSize:11,color:C.gray600,lineHeight:1.6}}>
      <div style={{fontWeight:700,color:C.navy,marginBottom:4,letterSpacing:.3}}>🎥 Where to film from:</div>
      {BBOT_ANGLE_PRESCRIPTION}
    </div>
  );
}

function VideoUploadWidget({backendUrl, purpose, playerId, sessionDate, sessionType, onUploaded, notify}){
  var statusS = useState("idle"); var status = statusS[0], setStatus = statusS[1];
  var progressS = useState(0); var progress = progressS[0], setProgress = progressS[1];
  var fileInfoS = useState(null); var fileInfo = fileInfoS[0], setFileInfo = fileInfoS[1];
  var errorS = useState(""); var error = errorS[0], setError = errorS[1];
  var qualityS = useState(false); var qualityChecked = qualityS[0], setQualityChecked = qualityS[1];
  var parentS = useState(false); var parentChecked = parentS[0], setParentChecked = parentS[1];
  var fileInputRef = useRef(null);

  var ACCEPTED = ".mp4,.mov,.m4v,.webm";
  var MAX_SIZE = 5 * 1024 * 1024 * 1024;
  var MIN_SIZE = 5 * 1024 * 1024;

  // FIX 1: Use DOM-attached input ref. iOS Safari has bugs with programmatically-created inputs
  // that aren't attached to the document. The hidden input below is properly mounted.
  function pickFile(){
    if(fileInputRef.current){
      // Reset value first so selecting the same file twice still triggers onChange
      fileInputRef.current.value = "";
      fileInputRef.current.click();
    }
  }

  function onFileInputChange(e){
    var f = e.target.files && e.target.files[0];
    if(f) handleFile(f);
  }

  // FIX 3: Content-type fallback by extension. iOS Safari sometimes returns empty f.type
  // for camera-roll videos. Map extension to MIME so the PUT request has a valid Content-Type.
  function contentTypeFor(f){
    if(f.type && f.type.length > 0) return f.type;
    var n = (f.name||"").toLowerCase();
    if(n.endsWith(".mp4")) return "video/mp4";
    if(n.endsWith(".mov")) return "video/quicktime";
    if(n.endsWith(".m4v")) return "video/x-m4v";
    if(n.endsWith(".webm")) return "video/webm";
    return "video/mp4";  // safe default
  }

  function handleFile(f){
    setError("");
    if(!qualityChecked || !parentChecked){
      setError("Please confirm both disclaimers below before uploading.");
      return;
    }
    var nameLower = (f.name||"").toLowerCase();
    var validExt = false;
    var exts = [".mp4",".mov",".m4v",".webm"];
    for(var i=0;i<exts.length;i++){ if(nameLower.endsWith(exts[i])) validExt=true; }
    if(!validExt){ setError("Unsupported format. Use MP4, MOV, M4V, or WebM."); return; }
    if(f.size < MIN_SIZE){ setError("File too small (min 5 MB)."); return; }
    if(f.size > MAX_SIZE){ setError("File too large (max 5 GB)."); return; }
    setFileInfo({name:f.name, size:f.size, type:contentTypeFor(f)});

    // VIDEO AUTHENTICITY CHECK — basic heuristic: load video, check duration & dimensions
    // Flag if duration < 3s (too short for meaningful eval), or dimensions seem off (sub-360p)
    try {
      var url = URL.createObjectURL(f);
      var v = document.createElement("video");
      v.preload = "metadata";
      v.muted = true;
      v.onloadedmetadata = function(){
        var warns = [];
        if(v.duration && v.duration < 3) warns.push("Video is very short ("+Math.round(v.duration)+"s) — eval quality may be limited");
        if(v.videoWidth && v.videoWidth < 480) warns.push("Low resolution detected ("+v.videoWidth+"x"+v.videoHeight+") — eval accuracy may be reduced");
        // Suspicious bitrate (file size to duration ratio extremely low suggests heavy compression / re-encoding)
        var bitrate = (f.size * 8) / (v.duration || 1) / 1000; // kbps
        if(bitrate < 200) warns.push("Very low bitrate ("+Math.round(bitrate)+" kbps) — re-encoded or heavily compressed");
        URL.revokeObjectURL(url);
        if(warns.length > 0){
          var msg = "Video quality notice:\n\n• "+warns.join("\n• ")+"\n\nProceed with upload anyway?";
          if(!window.confirm(msg)){
            setStatus("idle");
            return;
          }
        }
        uploadFile(f);
      };
      v.onerror = function(){
        // If we can't read metadata, the video may be corrupt — block upload
        URL.revokeObjectURL(url);
        setError("Unable to read video metadata. File may be corrupt or in an unsupported format variant.");
      };
      v.src = url;
    } catch(e){
      // If the check itself fails, fall through to upload (don't block on browser issues)
      uploadFile(f);
    }
  }

  function fmtSize(b){
    if(b<1024*1024) return (b/1024).toFixed(0)+" KB";
    if(b<1024*1024*1024) return (b/(1024*1024)).toFixed(1)+" MB";
    return (b/(1024*1024*1024)).toFixed(2)+" GB";
  }

  function uploadFile(f){
    setStatus("requesting");
    setProgress(0);
    var ct = contentTypeFor(f);
    // Refresh the auth token right before uploading — large files + time on the form mean
    // the token may have aged out. If the refresh fails (refresh token also expired after a
    // long idle), stop here with a clear re-login prompt rather than firing a request that
    // will bounce with a confusing "expired session" error.
    Promise.resolve(bbotRefreshSession()).then(function(sess){
    var hasToken = !!bbotAuthToken();
    if(!hasToken){
      setStatus("error");
      setError("Your session expired. Please sign out and sign back in, then retry the upload.");
      if(notify) notify("Session expired — please sign in again to upload","error");
      return;
    }
    return fetch(backendUrl+"/create-upload-url", {
      method:"POST",
      headers: bbotAdminHeaders(),
      body: JSON.stringify({
        fileName: f.name,
        fileSize: f.size,
        contentType: ct,
        purpose: purpose || "master",
        playerId: playerId ? String(playerId) : null
      })
    }).then(function(r){
      // If the server rejects the token (401), force one fresh refresh and retry the request
      // once before giving up. Handles the edge case where the access token expired in the gap
      // between our pre-refresh and this request.
      if(r.status===401){
        return Promise.resolve(bbotRefreshSession()).then(function(){
          if(!bbotAuthToken()) throw new Error("Your session expired. Sign out and back in, then retry.");
          return fetch(backendUrl+"/create-upload-url", {
            method:"POST",
            headers: bbotAdminHeaders(),
            body: JSON.stringify({
              fileName: f.name, fileSize: f.size, contentType: ct,
              purpose: purpose || "master", playerId: playerId ? String(playerId) : null
            })
          });
        });
      }
      return r;
    }).then(function(r){
      if(!r.ok) return r.text().then(function(t){ throw new Error(t || ("HTTP "+r.status)); });
      return r.json();
    }).then(function(meta){
      // meta = { uploadUrl, objectKey, objectId }
      setStatus("uploading");
      return new Promise(function(resolve, reject){
        var xhr = new XMLHttpRequest();
        xhr.open("PUT", meta.uploadUrl, true);
        xhr.setRequestHeader("Content-Type", ct);

        // FIX 2: Stall watchdog. Safari iOS can hang silently with no error and no progress.
        // If no progress for 60s, abort and surface the failure to the user.
        var lastProgressAt = Date.now();
        var watchdog = setInterval(function(){
          if(Date.now() - lastProgressAt > 60000){
            clearInterval(watchdog);
            try { xhr.abort(); } catch(_){}
            reject(new Error("Upload stalled (no progress for 60s). Try a smaller file or switch to WiFi."));
          }
        }, 5000);

        xhr.upload.onprogress = function(ev){
          lastProgressAt = Date.now();
          if(ev.lengthComputable){
            setProgress(Math.round((ev.loaded/ev.total)*100));
          }
        };
        xhr.onload = function(){
          clearInterval(watchdog);
          if(xhr.status>=200 && xhr.status<300){
            resolve(meta);
          } else {
            reject(new Error("Upload failed: HTTP "+xhr.status+" "+(xhr.responseText||"").slice(0,200)));
          }
        };
        xhr.onerror = function(){
          clearInterval(watchdog);
          reject(new Error("Network error during upload. Check connection and try again."));
        };
        xhr.onabort = function(){ clearInterval(watchdog); };
        // Set a hard timeout too (2hr cap for huge files)
        xhr.timeout = 2 * 60 * 60 * 1000;
        xhr.ontimeout = function(){
          clearInterval(watchdog);
          reject(new Error("Upload timed out after 2 hours"));
        };

        xhr.send(f);
      });
    }).then(function(meta){
      setStatus("confirming");
      return fetch(backendUrl+"/confirm-upload", {
        method:"POST",
        headers: bbotAdminHeaders(),
        body: JSON.stringify({
          objectKey: meta.objectKey,
          objectId: meta.objectId,
          purpose: purpose || "master",
          playerId: playerId ? String(playerId) : null,
          sessionDate: sessionDate || null,
          sessionType: sessionType || null,
          fileName: f.name,
          fileSize: f.size
        })
      }).then(function(r){ return r.json(); }).then(function(cd){
        return fetch(backendUrl+"/r2-read-url?key="+encodeURIComponent(meta.objectKey)).then(function(r){return r.json();}).then(function(ru){
          return Object.assign({}, meta, cd, {readUrl: ru.url});
        });
      });
    }).then(function(result){
      setStatus("done");
      setProgress(100);
      // TRUST THE SERVER'S ECHO, NOT THE FORM. If the angle did not reach the row, say so here —
      // the clip will be treated as unknown angle and BBOT will withhold rather than certify, and
      // that is a fact the person who filmed it should hear now, not read as a gap in a report.
      if(result && result.angleRecorded===false && notify){
        notify("Uploaded — but the camera angle was not recorded. Tell 643 so it can be set before evaluation.","error");
      }
      if(onUploaded) onUploaded({
        objectKey: result.objectKey,
        objectId: result.objectId,
        readUrl: result.readUrl,
        fileName: f.name,
        fileSize: f.size
      });
      if(notify) notify("Upload complete");
    }).catch(function(err){
      setStatus("error");
      setError(err.message || "Upload failed");
      if(notify) notify("Upload failed: "+(err.message||"unknown"));
    });
    });
  }

  return (
    <div>
      {status==="idle"||status==="error" ?
        <>
          <input ref={fileInputRef} type="file" accept={ACCEPTED} onChange={onFileInputChange} style={{position:"absolute",left:-9999,width:1,height:1,opacity:0}}/>
          <button
            onClick={function(){setQualityChecked(true);setParentChecked(true);pickFile();}}
            onDragOver={function(e){e.preventDefault();e.stopPropagation();e.currentTarget.style.background=C.coralLight;}}
            onDragLeave={function(e){e.preventDefault();e.stopPropagation();e.currentTarget.style.background=C.coralFaint;}}
            onDrop={function(e){
              e.preventDefault();
              e.stopPropagation();
              e.currentTarget.style.background=C.coralFaint;
              var files = e.dataTransfer && e.dataTransfer.files;
              if(files && files[0]){
                setQualityChecked(true);
                setParentChecked(true);
                handleFile(files[0]);
              }
            }}
            style={{width:"100%",padding:"22px 16px",border:"2px dashed "+C.coral,borderRadius:10,background:C.coralFaint,fontSize:14,fontWeight:700,color:C.coral,cursor:"pointer",transition:"background .15s"}}>
            {status==="error"?"↻ Try Again":"↑ Drop video here or tap to choose"}
          </button>
          <div style={{marginTop:10,padding:"10px 12px",background:C.blueFaint,borderRadius:8,fontSize:11,color:C.gray600,lineHeight:1.6}}>
            <div style={{fontWeight:700,color:C.navy,marginBottom:4,letterSpacing:.3}}>📹 For the most accurate evaluation:</div>
            • Film in <strong>60fps slow-motion</strong> if your phone supports it — sharper frames mean better measurements.<br/>
            • For <strong>verified velocity</strong>, include a radar reading visible in the frame (pitch gun or Pocket Radar). BBOT reads on-screen device numbers as confirmed.<br/>
            • Keep the player and ball in frame; steady camera, good lighting.
          </div>
          <CameraAngleGuidance/>
          <div style={{fontSize:10,color:C.gray500,marginTop:8,lineHeight:1.5,textAlign:"center"}}>
            By uploading you confirm the video accurately depicts the player and, if under 18, parent/guardian consents to BBOT evaluation.{" "}
            <a href="#" onClick={function(e){e.preventDefault();}} style={{color:C.coral,textDecoration:"underline"}}>Terms</a>
          </div>
        </>
      :
        <div style={{padding:"10px 14px",border:"1px solid "+C.border,borderRadius:8,background:C.white,fontSize:12}}>
          <div style={{display:"flex",justifyContent:"space-between",marginBottom:6}}>
            <span style={{fontWeight:600,color:C.navy}}>{fileInfo?fileInfo.name:"video.mp4"}</span>
            <span style={{color:C.gray500}}>{fileInfo?fmtSize(fileInfo.size):""}</span>
          </div>
          <div style={{height:6,background:C.gray100||"#e5e7eb",borderRadius:3,overflow:"hidden"}}>
            <div style={{height:"100%",width:progress+"%",background:status==="done"?(C.green||"#16a34a"):C.coral,transition:"width .2s"}}/>
          </div>
          <div style={{marginTop:6,fontSize:11,color:C.gray600,textAlign:"center"}}>
            {status==="requesting"&&"Preparing upload..."}
            {status==="uploading"&&("Uploading "+progress+"%")}
            {status==="confirming"&&"Finalizing..."}
            {status==="done"&&"✓ Upload complete"}
          </div>
        </div>
      }
      {error&&<div style={{marginTop:8,padding:"8px 10px",background:"#fff3f0",border:"1px solid "+C.coral,borderRadius:6,fontSize:11,color:"#b03a26"}}>{error}</div>}
    </div>
  );
}

// ============================================================
// MY ROSTER — staff/coach pull players onto their roster and view
// their published reports, clips, and a roster leaderboard.
// Roster membership = player.rosterStaffIds contains this staff's id.
// ============================================================
function MyRosterView({cu, users, setUsers, scoutReports, setScoutReports, battedBalls, metrics, notify, go, lineups, setLineups}){
  var tabS=useState("roster"); var tab=tabS[0]; var setTab=tabS[1];
  var addS=useState(""); var addQuery=addS[0]; var setAddQuery=addS[1];
  var selPlayerS=useState(null); var selPlayer=selPlayerS[0]; var setSelPlayer=selPlayerS[1];

  var myId=String(cu.id);
  var allPlayers=(users||[]).filter(function(u){return u.type==="player";});
  var roster=allPlayers.filter(function(p){return (p.rosterStaffIds||[]).map(String).indexOf(myId)>=0;});

  function pull(player){
    var updated=Object.assign({}, player, {rosterStaffIds:((player.rosterStaffIds||[]).map(String).concat([myId]))});
    setUsers(function(all){return all.map(function(u){return String(u.id)===String(player.id)?updated:u;});});
    persistUser(updated).then(function(){notify(player.firstName+" "+player.lastName+" added to your roster");}).catch(function(){notify("Could not update roster — try again","error");});
    setAddQuery("");
  }
  function removeFromRoster(player){
    if(!window.confirm("Remove "+player.firstName+" "+player.lastName+" from your roster?")) return;
    var updated=Object.assign({}, player, {rosterStaffIds:(player.rosterStaffIds||[]).map(String).filter(function(x){return x!==myId;})});
    setUsers(function(all){return all.map(function(u){return String(u.id)===String(player.id)?updated:u;});});
    persistUser(updated).then(function(){notify("Removed from roster");}).catch(function(){notify("Could not update roster — try again","error");});
  }

  // Add-player search results (players not already on roster)
  var q=addQuery.trim().toLowerCase();
  var addResults = q.length>=2 ? allPlayers.filter(function(p){
    if((p.rosterStaffIds||[]).map(String).indexOf(myId)>=0) return false;
    return (p.firstName+" "+p.lastName).toLowerCase().indexOf(q)>=0 || String(p.jerseyNum||"").indexOf(q)>=0;
  }).slice(0,8) : [];

  // Published reports for roster players
  var rosterIds = roster.map(function(p){return String(p.id);});
  var pubReports = (scoutReports||[]).filter(function(r){
    return rosterIds.indexOf(String(r.playerId))>=0 && (isLiveEval(r));
  });

  // Roster leaderboard — best peak exit velo / throw / pitch velo per player (admin/staff see velo)
  var leaderRows = roster.map(function(p){
    var pr=(scoutReports||[]).filter(function(r){return String(r.playerId)===String(p.id)&&(isLiveEval(r));});
    var peakEV=null, throwV=null, pitchV=null, topGrade=null;
    pr.forEach(function(r){
      var mv=r.measuredValues||(r.fullReport&&r.fullReport.measuredValues)||{};
      if(mv.exitVeloPeak&&(!peakEV||mv.exitVeloPeak>peakEV)) peakEV=mv.exitVeloPeak;
      if(mv.throwVelo&&(!throwV||mv.throwVelo>throwV)) throwV=mv.throwVelo;
      if(mv.pitchVeloPeak&&(!pitchV||mv.pitchVeloPeak>pitchV)) pitchV=mv.pitchVeloPeak;
      // A TOP GRADE MUST TRACE TO A MEASURED TOOL WITH A RECEIPT (ruled 2026-08-19).
      // This took the maximum `grade` across EVERY section, with no check that the section is a
      // measured tool and no check that its value has a receipt. Two ways that goes wrong, and
      // both are live classes rather than hypotheticals:
      //   * an OBSERVATION tool carrying a grade — Plate Discipline, Receiving, Arm Action and the
      //     rest have no benchmark, no unit and no device behind them, so a grade there is an
      //     opinion wearing a measurement's clothes;
      //   * a MEASURED tool whose value the product itself refuses — Jeniel Perez's approved report
      //     grades Pop Time 40 on a popTime his card withholds for having no timer behind it.
      // The measured-tool list is a product rule and lives here; the receipt question is the
      // credibility law's and is answered server-side, declared on the row as `gradeIntegrity`.
      var _fr_g = r.fullReport || {};
      var _withheld = ((_fr_g.gradeIntegrity||{}).withheld)||[];
      (r.sections||[]).forEach(function(s){
        if(!s || s.grade==null) return;
        if(BBOT_GRADED_TOOLS.indexOf(String(s.label||"").trim()) < 0) return;   // not a measured tool
        for(var _i=0;_i<_withheld.length;_i++){ if(_withheld[_i] && _withheld[_i].label===s.label) return; }
        if(!topGrade || s.grade>topGrade) topGrade=s.grade;
      });
    });
    return {player:p, peakEV:peakEV, throwV:throwV, pitchV:pitchV, topGrade:topGrade, reportCount:pr.length};
  }).sort(function(a,b){return (b.peakEV||0)-(a.peakEV||0);});

  var TABS=[["roster","My Roster ("+roster.length+")"],["lineups","Lineups"],["reports","Reports ("+pubReports.length+")"],["clips","Clips"],["leaderboard","Leaderboard"]];

  return (
    <div style={{maxWidth:860,margin:"0 auto",padding:"16px 14px"}}>
      <div style={{marginBottom:14}}>
        <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:20,color:C.navy,letterSpacing:1}}>MY ROSTER</div>
        <div style={{fontSize:12,color:C.gray500,marginTop:2,lineHeight:1.5}}>Pull players onto your roster to track their published evaluations, clips, and leaderboards in one place.</div>
      </div>

      <div style={{display:"flex",gap:6,marginBottom:16,flexWrap:"wrap"}}>
        {TABS.map(function(t){return (
          <button key={t[0]} onClick={function(){setTab(t[0]);setSelPlayer(null);}} style={{background:tab===t[0]?C.navy:C.white,color:tab===t[0]?C.white:C.gray600,border:"1px solid "+(tab===t[0]?C.navy:C.border),padding:"7px 14px",borderRadius:8,fontSize:12,fontWeight:600,cursor:"pointer"}}>{t[1]}</button>
        );})}
      </div>

      {tab==="roster"&&(
        <div>
          <Card style={{padding:14,marginBottom:14}}>
            <div style={{fontSize:12,fontWeight:700,color:C.navy,marginBottom:8}}>Add a player to your roster</div>
            <input value={addQuery} onChange={function(e){setAddQuery(e.target.value);}} placeholder="Search by name or jersey #" style={{width:"100%",padding:"8px 12px",border:"1px solid "+C.border,borderRadius:8,fontSize:13,boxSizing:"border-box"}}/>
            {addResults.length>0&&(
              <div style={{marginTop:8,border:"1px solid "+C.border,borderRadius:8,overflow:"hidden"}}>
                {addResults.map(function(p){return (
                  <div key={p.id} style={{display:"flex",alignItems:"center",justifyContent:"space-between",padding:"8px 10px",borderBottom:"1px solid "+C.gray50}}>
                    <div style={{display:"flex",alignItems:"center",gap:8}}>
                      <Avatar user={p} size={28}/>
                      <div><div style={{fontSize:13,fontWeight:600,color:C.gray900}}>{p.firstName} {p.lastName}</div><div style={{fontSize:10,color:C.gray400}}>{p.position||"—"}{p.gradYear?" · Class "+p.gradYear:""}</div></div>
                    </div>
                    <Btn v="primary" style={{fontSize:11,padding:"5px 12px"}} onClick={function(){pull(p);}}>+ Add</Btn>
                  </div>
                );})}
              </div>
            )}
            {q.length>=2&&addResults.length===0&&<div style={{fontSize:11,color:C.gray400,marginTop:8}}>No matching players not already on your roster.</div>}
          </Card>

          {roster.length===0
            ? <EmptyCard icon="bbot" title="No Players Yet" sub="Search above to pull players onto your roster."/>
            : <div style={{display:"flex",flexDirection:"column",gap:8}}>
                {roster.map(function(p){return (
                  <Card key={p.id} style={{padding:"12px 14px",display:"flex",alignItems:"center",justifyContent:"space-between"}}>
                    <div style={{display:"flex",alignItems:"center",gap:10,cursor:"pointer"}} onClick={function(){go("profile",p);}}>
                      <Avatar user={p} size={36}/>
                      <div><div style={{fontSize:14,fontWeight:700,color:C.gray900}}>{p.firstName} {p.lastName}</div><div style={{fontSize:11,color:C.gray400}}>{p.position||"—"}{p.gradYear?" · Class "+p.gradYear:""}</div></div>
                    </div>
                    <button onClick={function(){removeFromRoster(p);}} style={{background:"none",border:"1px solid "+C.border,color:C.gray500,padding:"5px 10px",borderRadius:8,fontSize:11,cursor:"pointer"}}>Remove</button>
                  </Card>
                );})}
              </div>}
        </div>
      )}

      {tab==="lineups"&&(
        <div>
          <div style={{fontSize:12,color:C.gray500,marginBottom:12,lineHeight:1.5}}>Build a lineup for a mass session. Use <strong>Pull Full Roster</strong> to load every player at once, then set your batting order and pitchers.</div>
          <RosterManager players={(roster.length>0?roster:allPlayers)} cu={cu} notify={notify} lineups={lineups||[]} setLineups={setLineups}/>
        </div>
      )}

      {tab==="reports"&&(
        roster.length===0 ? <EmptyCard icon="E" title="No Roster Players" sub="Add players to your roster to see their published evaluations."/>
        : pubReports.length===0 ? <EmptyCard icon="E" title="No Published Reports" sub="Approved evaluations for your roster players will appear here once players purchase them."/>
        : <div style={{display:"flex",flexDirection:"column",gap:10}}>
            {pubReports.slice().reverse().map(function(r){
              var p=(users||[]).find(function(u){return String(u.id)===String(r.playerId);})||{};
              return <ReportCard key={r.id} r={r} sc={p} isAdmin={false}/>;
            })}
          </div>
      )}

      {tab==="clips"&&(
        roster.length===0 ? <EmptyCard icon="C" title="No Roster Players" sub="Add players to your roster to browse their clips."/>
        : selPlayer ? (
          <div>
            <button onClick={function(){setSelPlayer(null);}} style={{background:"none",border:"none",color:C.blue,fontSize:12,cursor:"pointer",marginBottom:10,padding:0}}>← Back to roster</button>
            <PlayerClipsView userId={selPlayer.id} playerName={selPlayer.firstName+" "+selPlayer.lastName} dob={selPlayer.dob} gradYear={selPlayer.gradYear} ageBracket="career" isAdmin={false} cu={cu} notify={notify} scoutReports={scoutReports} setScoutReports={setScoutReports}/>
          </div>
        ) : (
          <div style={{display:"flex",flexDirection:"column",gap:8}}>
            <div style={{fontSize:11,color:C.gray500,marginBottom:2}}>Select a player to view their clips.</div>
            {roster.map(function(p){return (
              <Card key={p.id} style={{padding:"12px 14px",display:"flex",alignItems:"center",justifyContent:"space-between",cursor:"pointer"}} onClick={function(){setSelPlayer(p);}}>
                <div style={{display:"flex",alignItems:"center",gap:10}}>
                  <Avatar user={p} size={36}/>
                  <div><div style={{fontSize:14,fontWeight:700,color:C.gray900}}>{p.firstName} {p.lastName}</div><div style={{fontSize:11,color:C.gray400}}>{p.position||"—"}</div></div>
                </div>
                <span style={{color:C.gray400,fontSize:16}}>›</span>
              </Card>
            );})}
          </div>
        )
      )}

      {tab==="leaderboard"&&(
        roster.length===0 ? <EmptyCard icon="L" title="No Roster Players" sub="Add players to your roster to build a leaderboard."/>
        : <Card style={{padding:0,overflow:"hidden"}}>
            <div style={{padding:"12px 14px",borderBottom:"1px solid "+C.border}}><div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:13,color:C.navy,letterSpacing:1}}>ROSTER LEADERBOARD</div><div style={{fontSize:10,color:C.gray400,marginTop:2}}>Best confirmed readings across approved evaluations</div></div>
            <table style={{width:"100%",borderCollapse:"collapse"}}>
              <thead><tr style={{borderBottom:"1px solid "+C.border,background:C.gray50}}>
                <td style={{fontSize:9,color:C.gray400,fontWeight:700,padding:"8px 10px"}}>PLAYER</td>
                <td style={{fontSize:9,color:C.gray400,fontWeight:700,padding:"8px 6px",textAlign:"center"}}>PEAK EV</td>
                <td style={{fontSize:9,color:C.gray400,fontWeight:700,padding:"8px 6px",textAlign:"center"}}>THROW</td>
                <td style={{fontSize:9,color:C.gray400,fontWeight:700,padding:"8px 6px",textAlign:"center"}}>FB</td>
                <td style={{fontSize:9,color:C.gray400,fontWeight:700,padding:"8px 6px",textAlign:"center"}}>TOP GRADE</td>
              </tr></thead>
              <tbody>
                {leaderRows.map(function(row){return (
                  <tr key={row.player.id} style={{borderBottom:"1px solid "+C.gray50,cursor:"pointer"}} onClick={function(){go("profile",row.player);}}>
                    <td style={{padding:"8px 10px",fontSize:12,fontWeight:600,color:C.navy}}>{row.player.firstName} {row.player.lastName}</td>
                    <td style={{padding:"8px 6px",textAlign:"center",fontSize:12,color:C.gray700}}>{row.peakEV||"—"}</td>
                    <td style={{padding:"8px 6px",textAlign:"center",fontSize:12,color:C.gray700}}>{row.throwV||"—"}</td>
                    <td style={{padding:"8px 6px",textAlign:"center",fontSize:12,color:C.gray700}}>{row.pitchV||"—"}</td>
                    <td style={{padding:"8px 6px",textAlign:"center",fontSize:12,fontWeight:700,color:row.topGrade>=60?C.blue:C.gray600}}>{row.topGrade||"—"}</td>
                  </tr>
                );})}
              </tbody>
            </table>
          </Card>
      )}
    </div>
  );
}

function BbotRunner({users,setUsers,cu,metrics,scoutReports,setScoutReports,pushFeed,notify,lineups,approveReport,fields,battedBalls,setBattedBalls,highlights,setHighlights,recaps,setRecaps,go}){
  var videoUrlState=useState(""); var videoUrl=videoUrlState[0]; var setVideoUrl=videoUrlState[1];
  var sessionTypeState=useState("BP"); var sessionType=sessionTypeState[0]; var setSessionType=sessionTypeState[1];
  var sessionDateState=useState(new Date().toISOString().slice(0,10)); var sessionDate=sessionDateState[0]; var setSessionDate=sessionDateState[1];
  // Admin-declared HITTING WINDOW (seconds). Scopes swing detection + radar pairing to the batting
  // portion (gate b): events outside are surfaced as measurement events, never asserted as swings.
  // Empty => whole-clip (backend applies its partial-scope disclosure on mixed clips).
  // ACTIVITY BLOCKS FOR AN INDIVIDUAL EVALUATION, ruled by Luis 2026-10-20. Without these the
  // backend derives blocks from nearest-velocity-frame, which is how Jeniel's 30 seconds of
  // batting ended up inside a throwing span with ten exit velocities in it. The hitting WINDOW
  // below stays for compatibility; blocks are the better input because they name every activity
  // rather than answering one in-or-out question. [[mass-seg-tag-at-upload-architecture]]
  var abState=useState([]); var activityBlocks=abState[0]; var setActivityBlocks=abState[1];
  var atState=useState(false); var tagOpen=atState[0]; var setTagOpen=atState[1];
  var okState=useState(""); var uploadedKey=okState[0]; var setUploadedKey=okState[1];
  var hittingStartSState=useState(""); var hittingStartS=hittingStartSState[0]; var setHittingStartS=hittingStartSState[1];
  var hittingEndSState=useState(""); var hittingEndS=hittingEndSState[0]; var setHittingEndS=hittingEndSState[1];
  var loadingState=useState(false); var loading=loadingState[0]; var setLoading=loadingState[1];
  var selPState=useState(""); var selP=selPState[0]; var setSelP=selPState[1];
  var allPlayers=(users||[]).filter(function(u){return u.type==="player";});
  var activeRosterObj=(lineups||[]).find(function(l){return l.active;})||{players:[]};
  var activeRoster=activeRosterObj.players||[];
  var sessionRosterS=useState([]); var sessionRoster=sessionRosterS[0]; var setSessionRoster=sessionRosterS[1];
  var motionMetricsS=useState(null); var motionMetrics=motionMetricsS[0]; var setMotionMetrics=motionMetricsS[1];
  var _isAdminUser=cu&&bbotIsAdmin(cu);
  var adminSpecS=useState(""); var adminSpec=adminSpecS[0]; var setAdminSpec=adminSpecS[1];
  var adminSpecOpenS=useState(false); var adminSpecOpen=adminSpecOpenS[0]; var setAdminSpecOpen=adminSpecOpenS[1];
  // D3 — report mode: "session" (single video) vs "cumulative" (compiles approved sessions, no video).
  var reportModeS=useState("session"); var reportMode=reportModeS[0]; var setReportMode=reportModeS[1];
  var sessionModeS=useState(""); var sessionMode=sessionModeS[0]; var setSessionMode=sessionModeS[1]; // "" until staff chooses individual|multi (mandatory)
  // Count approved/published single-session reports on file for the selected player.
  var approvedSessionCount=(function(){
    if(!selP) return 0;
    return (scoutReports||[]).filter(function(r){
      return String(r.playerId)===String(selP)
        && !r.reportType                                   // single-session (not a prior cumulative)
        && (r.sections && r.sections.length)               // actually has tool sections
        && (isLiveEval(r));
    }).length;
  })();
  var cumulativeReady = approvedSessionCount>=2;
  var isCumulative = reportMode==="cumulative";

  var runBbot=makeBbotRunner({selP:selP,sessionType:sessionType,sessionDate:sessionDate,videoUrl:videoUrl,users:users,setUsers:setUsers,teamName:(activeRosterObj.teamName||activeRosterObj.name||""),metrics:metrics,scoutReports:scoutReports,setScoutReports:setScoutReports,cu:cu,setHighlights:setHighlights,setBattedBalls:setBattedBalls,setRecaps:setRecaps,notify:notify,activeRoster:activeRoster,allPlayers:allPlayers,sessionRoster:sessionRoster,setLoading:setLoading,motionMetrics:motionMetrics,adminSpec:(_isAdminUser&&adminSpecOpen?adminSpec:null),reportType:(isCumulative?"player_eval":null),sessionMode:sessionMode,hittingStartS:hittingStartS,hittingEndS:hittingEndS,activityBlocks:activityBlocks});

  // UNIVERSAL RULE: only the PLAYER pays, and BBOT generation + admin review happen
  // AFTER payment. Admin (the reviewer) may generate directly; staff/coach may only
  // TRIGGER an evaluation request, which sits locked until the player pays.
  function triggerEvaluation(){
    var player=(allPlayers||[]).find(function(p){return String(p.id)===String(selP);});
    if(!player){ notify("Select a player first","error"); return; }
    if(isCumulative && !cumulativeReady){ notify("This player hasn't met the required sessions for a cumulative evaluation (2+ approved sessions needed).","error"); return; }
    if(!isCumulative){
      var ok=(typeof window!=="undefined"&&window.__bbotLastUpload&&window.__bbotLastUpload.objectKey);
      if(!ok){ notify("Upload the player's video first","error"); return; }
    }
    setLoading(true);
    var rid=Date.now();
    var row={
      id: rid,
      player_id: String(player.id),
      player_name: player.firstName+" "+player.lastName,
      session_type: isCumulative?"Cumulative":(sessionType||"Evaluation"),
      session_date: sessionDate||new Date().toISOString().slice(0,10),
      status: "awaiting_payment",          // locked — not paid, not generated
      object_key: isCumulative?null:window.__bbotLastUpload.objectKey,
      video_url: isCumulative?"":(videoUrl||""),
      report_type: isCumulative?"player_eval":null,
      staff_id: cu.id,
      staff_name: cu.firstName+" "+cu.lastName,
      summary: "",
      sections: []
    };
    reportSave(row).then(function(){
      setLoading(false);
      notify("Evaluation requested for "+player.firstName+" "+player.lastName+". It unlocks for them to purchase — generation and review happen after they pay.");
    }).catch(function(err){
      setLoading(false);
      notify("Could not create request: "+(err.message||"error"),"error");
    });
  }
  return(
    <div style={{maxWidth:720}}>
      <Card style={{marginBottom:16}}>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12,marginBottom:12}}>
          <div style={{gridColumn:"1 / -1"}}>
            <label style={{fontSize:11,color:C.gray500,fontWeight:600,display:"block",marginBottom:4}}>SESSION ROSTER — Players in this video</label>
            <div style={{display:"flex",flexWrap:"wrap",gap:5,padding:"8px",background:C.gray50,borderRadius:8,border:"1px solid "+C.border,minHeight:36,marginBottom:6}}>
              {sessionRoster.length===0&&<span style={{fontSize:12,color:C.gray400,fontStyle:"italic"}}>No players added</span>}
              {sessionRoster.map(function(pid){var u=allPlayers.find(function(p){return String(p.id)===String(pid);});if(!u)return null;return <span key={pid} style={{display:"flex",alignItems:"center",gap:4,background:C.blue,color:C.white,fontSize:11,fontWeight:600,padding:"3px 8px",borderRadius:99}}>{u.firstName} {u.lastName}<button onClick={function(){setSessionRoster(function(r){return r.filter(function(x){return x!==pid;});});}} style={{background:"none",border:"none",color:"rgba(255,255,255,.7)",cursor:"pointer",fontSize:14,lineHeight:1,padding:0}}>×</button></span>;})}
            </div>
            <div style={{display:"flex",gap:6}}>
              <select onChange={function(e){var v=e.target.value;if(v&&!sessionRoster.includes(v)){setSessionRoster(function(r){return r.concat([v]);});}e.target.value="";}} style={{flex:1,padding:"7px 10px",borderRadius:8,border:"1px solid "+C.border,fontSize:12}}>
                <option value="">+ Add player to session...</option>
                {activeRoster.length>0&&<optgroup label="Active Roster">{activeRoster.map(function(lp){var u=allPlayers.find(function(p){return String(p.id)===String(lp.playerId);});if(!u||sessionRoster.includes(String(u.id)))return null;return <option key={u.id} value={String(u.id)}>{u.firstName} {u.lastName}{lp.position?" ("+lp.position+")":""}</option>;})}</optgroup>}
                <optgroup label="All Players">{allPlayers.filter(function(u){return !sessionRoster.includes(String(u.id));}).map(function(u){return <option key={u.id} value={String(u.id)}>{u.firstName} {u.lastName}{u.gradYear?" ("+u.gradYear+")":""}</option>;})}</optgroup>
              </select>
              {activeRoster.length>0&&<button onClick={function(){setSessionRoster(activeRoster.map(function(lp){return String(lp.playerId);}));}} style={{padding:"7px 12px",borderRadius:8,background:C.navy,color:C.white,border:"none",fontSize:11,fontWeight:700,cursor:"pointer",whiteSpace:"nowrap"}}>Load Roster</button>}
            </div>
          </div>
          <div>
            <label style={{fontSize:11,color:C.gray500,fontWeight:600,display:"block",marginBottom:4}}>EVALUATE PLAYER</label>
            <select value={selP} onChange={function(e){setSelP(e.target.value);}} style={{width:"100%",padding:"8px 12px",borderRadius:8,border:"1px solid "+C.border,fontSize:13}}>
              <option value="">Select from session...</option>
              {(sessionRoster.length>0?sessionRoster:allPlayers.map(function(u){return String(u.id);})).map(function(pid){var u=allPlayers.find(function(p){return String(p.id)===String(pid);});if(!u)return null;return <option key={pid} value={pid}>{u.firstName} {u.lastName}{u.position?" ("+u.position+")":""}</option>;})}
            </select>
          </div>
          <div style={{gridColumn:"1 / -1"}}>
            <label style={{fontSize:11,color:C.gray500,fontWeight:600,display:"block",marginBottom:4}}>REPORT TYPE</label>
            <div style={{display:"flex",gap:8}}>
              {[["session","Single Session"],["cumulative","Cumulative Player Eval"]].map(function(m){
                var on=reportMode===m[0];
                return <button key={m[0]} onClick={function(){setReportMode(m[0]);}} style={{flex:1,padding:"9px 10px",borderRadius:8,border:"1.5px solid "+(on?C.coral:C.border),background:on?C.coral:C.white,color:on?C.white:C.gray600,fontSize:12,fontWeight:700,cursor:"pointer"}}>{m[1]}</button>;
              })}
            </div>
            {isCumulative && (
              <div style={{marginTop:8,fontSize:11,lineHeight:1.5,padding:"8px 10px",borderRadius:6,background:cumulativeReady?C.blueFaint:C.coralFaint,color:cumulativeReady?C.blue:C.coral,border:"1px solid "+(cumulativeReady?C.blueLight:C.coralLight)}}>
                {!selP
                  ? "Select a player to check session eligibility."
                  : cumulativeReady
                    ? ("Compiles this player's "+approvedSessionCount+" approved sessions. No video upload needed.")
                    : ("This player has "+approvedSessionCount+" approved session"+(approvedSessionCount===1?"":"s")+". A cumulative evaluation requires at least 2 approved sessions on file. Run more single sessions first.")}
              </div>
            )}
          </div>
          <div>
            <label style={{fontSize:11,color:C.gray500,fontWeight:600,display:"block",marginBottom:4}}>SESSION TYPE</label>
            <select value={sessionType} onChange={function(e){setSessionType(e.target.value);}} disabled={isCumulative} style={{width:"100%",padding:"8px 12px",borderRadius:8,border:"1px solid "+C.border,fontSize:13,opacity:isCumulative?0.5:1}}>
              {SESSION_TYPES.map(function(t){return <option key={t.value} value={t.value}>{t.label}</option>;})}
            </select>
          </div>
          <div>
            <label style={{fontSize:11,color:C.gray500,fontWeight:600,display:"block",marginBottom:4}}>SESSION DATE</label>
            <input type="date" value={sessionDate} onChange={function(e){setSessionDate(e.target.value);}} style={{width:"100%",padding:"8px 12px",borderRadius:8,border:"1px solid "+C.border,fontSize:13}}/>
          </div>
          {!isCumulative && (
          <div style={{gridColumn:"1 / -1"}}>
            <label style={{fontSize:11,color:C.gray500,fontWeight:600,display:"block",marginBottom:4}}>HITTING WINDOW · SECONDS (optional — scopes swing detection to the batting portion of the clip)</label>
            <div style={{display:"flex",gap:8}}>
              <input type="number" min="0" step="1" placeholder="start (s)" value={hittingStartS} onChange={function(e){setHittingStartS(e.target.value);}} style={{width:"100%",padding:"8px 12px",borderRadius:8,border:"1px solid "+C.border,fontSize:13}}/>
              <input type="number" min="0" step="1" placeholder="end (s)" value={hittingEndS} onChange={function(e){setHittingEndS(e.target.value);}} style={{width:"100%",padding:"8px 12px",borderRadius:8,border:"1px solid "+C.border,fontSize:13}}/>
            </div>
          </div>
          )}
          {!isCumulative && (
          <div style={{gridColumn:"1 / -1"}}>
            <label style={{fontSize:11,color:C.gray500,fontWeight:600,display:"block",marginBottom:4}}>VIDEO FILE</label>
            <VideoUploadWidget
              backendUrl={BACKEND_URL}
              purpose="master"
              playerId={selP}
              sessionDate={sessionDate}
              sessionType={sessionType}
              onUploaded={function(result){
                // result = { objectKey, objectId, readUrl, fileName, fileSize }
                setVideoUrl(result.readUrl);
                setUploadedKey(result.objectKey||"");
                setActivityBlocks([]);          // a new upload invalidates the previous tags
                if(typeof window!=="undefined"){
                  window.__bbotLastUpload = result;
                }
              }}
              notify={notify}
            />
            {uploadedKey&&!isCumulative&&(
              <div style={{marginTop:10,border:"1px solid "+(activityBlocks.length?C.blue:C.border),borderRadius:8,overflow:"hidden"}}>
                {!tagOpen ? (
                  <button onClick={function(){setTagOpen(true);}} style={{display:"flex",alignItems:"center",gap:8,padding:"11px 12px",width:"100%",background:activityBlocks.length?C.blueFaint:C.white,border:"none",cursor:"pointer",textAlign:"left"}}>
                    <span style={{width:20,height:20,borderRadius:"50%",background:activityBlocks.length?C.blue:C.gray400,color:C.white,display:"inline-flex",alignItems:"center",justifyContent:"center",fontSize:12,fontWeight:700}}>{activityBlocks.length?"✓":"▶"}</span>
                    <span style={{fontSize:12,fontWeight:700,color:C.navy}}>
                      {activityBlocks.length
                        ? ("Activities tagged · "+activityBlocks.length+" block"+(activityBlocks.length===1?"":"s")+" — tap to re-tag")
                        : "Tag activities (Run / Field / Hit / Throw / Pitch) — frame-accurate"}
                    </span>
                  </button>
                ) : (
                  <div style={{padding:10}}>
                    {/* The MASS tagger, in solo mode: same frame-step, same 0.1x-1x preview
                        speed, same vocabulary. Untagged, the backend derives blocks and can put
                        a swing in a throwing span. */}
                    <TagSegmenter
                      objectKey={uploadedKey}
                      soloPlayer={(function(){
                        var _p=(allPlayers||[]).find(function(x){return String(x.id)===String(selP);});
                        return {playerId:selP,
                                playerName:_p?((_p.firstName||"")+" "+(_p.lastName||"")).trim():"",
                                jerseyNum:(_p&&_p.jerseyNum)||""};
                      })()}
                      sessionType={sessionType}
                      sessionDate={sessionDate}
                      onProposal={function(res){
                        if(res&&res.soloBlocks){ setActivityBlocks(res.soloBlocks); setTagOpen(false); }
                      }}
                      notify={notify}/>
                    <button onClick={function(){setTagOpen(false);}} style={{marginTop:6,padding:"6px 12px",borderRadius:6,border:"1px solid "+C.border,background:C.white,color:C.gray500,fontSize:11,fontWeight:600,cursor:"pointer"}}>Close</button>
                  </div>
                )}
              </div>
            )}
            {videoUrl&&<div style={{marginTop:8,borderRadius:8,overflow:"hidden",background:"#000"}}>
              <video {...bbotVideoGuard()} src={videoUrl} controls autoPlay loop muted playsInline style={{width:"100%",maxHeight:300,display:"block"}}/>
            </div>}
          </div>
          )}
        </div>
        {_isAdminUser&&(
          <div style={{marginBottom:10,border:"1px solid "+(adminSpecOpen?C.coral:C.border),borderRadius:8,overflow:"hidden"}}>
            {!adminSpecOpen ? (
              <button onClick={function(){setAdminSpecOpen(true);}} style={{display:"flex",alignItems:"center",gap:8,padding:"11px 12px",width:"100%",background:C.gray50,cursor:"pointer",fontSize:12,fontWeight:700,color:C.navy,border:"none",letterSpacing:.3,textAlign:"left"}}>
                <span style={{width:20,height:20,borderRadius:"50%",background:C.coral,color:C.white,display:"inline-flex",alignItems:"center",justifyContent:"center",fontSize:12,flexShrink:0}}>⚙</span>
                Build a Custom Report (internal only)
              </button>
            ) : (
              <div>
                <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",padding:"10px 12px",background:C.coralFaint,borderBottom:"1px solid "+C.coralLight}}>
                  <span style={{fontSize:12,fontWeight:700,color:C.coral,letterSpacing:.3}}>⚙ CUSTOM REPORT REQUEST</span>
                  <button onClick={function(){setAdminSpecOpen(false);setAdminSpec("");}} style={{background:"none",border:"none",color:C.gray500,fontSize:16,cursor:"pointer",lineHeight:1}}>×</button>
                </div>
                <div style={{padding:"12px"}}>
                  <label style={{fontSize:11,fontWeight:600,color:C.gray600,display:"block",marginBottom:5}}>What should BBOT focus this build on?</label>
                  <textarea value={adminSpec} onChange={function(e){setAdminSpec(e.target.value);}} rows={3} placeholder="e.g. 'Focus only on swing path and bat-to-ball; ignore baserunning. Compare against college-level benchmarks.'" style={{width:"100%",padding:"8px 10px",border:"1px solid "+C.border,borderRadius:6,fontSize:12,fontFamily:"inherit",resize:"vertical",boxSizing:"border-box"}}/>
                  <div style={{fontSize:10,color:C.gray400,marginTop:6,lineHeight:1.5}}>This build is internal and never shown to the player. BBOT's no-inference / observable-only rules still apply. The button below changes to <strong>Run Custom Report</strong> once a focus is set.</div>
                </div>
              </div>
            )}
          </div>
        )}
        {_isAdminUser && !isCumulative && (
          <div style={{marginBottom:12,padding:"12px 14px",border:"1px solid "+(sessionMode?C.border:C.coral),borderRadius:10,background:sessionMode?C.gray50:C.coralFaint}}>
            <div style={{fontSize:11,fontWeight:700,color:sessionMode?C.gray600:C.coral,letterSpacing:.5,marginBottom:8}}>SESSION TYPE {sessionMode?"":"· REQUIRED"}</div>
            <div style={{display:"flex",gap:8}}>
              {[["individual","Individual","One player in this video"],["multi","Multi-player","A team/game — several players by jersey"]].map(function(opt){
                var on=sessionMode===opt[0];
                return <button key={opt[0]} onClick={function(){setSessionMode(opt[0]);}} style={{flex:1,textAlign:"left",padding:"10px 12px",borderRadius:8,border:"1.5px solid "+(on?C.coral:C.border),background:C.white,cursor:"pointer"}}>
                  <div style={{display:"flex",alignItems:"center",gap:7,marginBottom:2}}>
                    <span style={{width:14,height:14,borderRadius:"50%",border:"1.5px solid "+(on?C.coral:C.gray300),background:on?C.coral:C.white,flexShrink:0}}/>
                    <span style={{fontSize:13,fontWeight:700,color:on?C.coral:C.navy}}>{opt[1]}</span>
                  </div>
                  <div style={{fontSize:10,color:C.gray500,marginLeft:21}}>{opt[2]}</div>
                </button>;
              })}
            </div>
          </div>
        )}
        {(function(){
          // D3 — cumulative requires 2+ approved sessions; block with a clear statement.
          var blockedCumulative = isCumulative && !cumulativeReady;
          // Disable when loading, when cumulative isn't ready, or (session mode) when no video yet for admin run.
          var needsMode = _isAdminUser && !isCumulative && !sessionMode;
          var runDisabled = loading || blockedCumulative || needsMode;
          var guardedRun = function(){
            if(blockedCumulative){ notify("This player hasn't met the required sessions for a cumulative evaluation (2+ approved sessions needed).","error"); return; }
            if(needsMode){ notify("Choose Individual or Multi-player session before running.","error"); return; }
            if(_isAdminUser){ runBbot(); } else { triggerEvaluation(); }
          };
          var labelIdle = _isAdminUser
            ? (adminSpecOpen ? "Run Custom Report" : (isCumulative ? "Run Cumulative Evaluation" : "Run BBOT Evaluation"))
            : (isCumulative ? "Request Cumulative Evaluation" : "Request Evaluation");
          return <Btn v={_isAdminUser&&adminSpecOpen?"coral":"primary"} onClick={guardedRun} disabled={runDisabled} style={{width:"100%",opacity:runDisabled?0.6:1}}>{loading?(_isAdminUser?"Running BBOT...":"Requesting..."):labelIdle}</Btn>;
        })()}
        {!_isAdminUser&&<div style={{fontSize:11,color:C.gray500,marginTop:8,lineHeight:1.5,textAlign:"center"}}>This sends an evaluation request. BBOT generates the report and admin reviews it only after the player pays.</div>}
      </Card>
      {approvableQueue(recaps,scoutReports).length>0 && (
      <div>
        <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:10}}><BbotMark size={24}/><span style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:12,color:C.blue,letterSpacing:1}}>SESSION EVALUATIONS — PENDING APPROVAL ({approvableQueue(recaps,scoutReports).length})</span></div>
        <div style={{fontSize:11,color:C.gray500,marginBottom:10,lineHeight:1.5}}>Review the grades, edit if needed (your corrections train BBOT), then approve. Approved evaluations unlock for the player to purchase.</div>
        <div>{approvableQueue(recaps,scoutReports).slice().reverse().map(function(pkg){
          var rep=(scoutReports||[]).find(function(r){return String(r.id)===String(pkg.reportId);});
          var player=(users||[]).find(function(u){return String(u.id)===String(pkg.playerId);})||{};
          if(!rep) return null;
          return <ReportCard key={pkg.id} r={rep} sc={player} isDraft={isDraftEval(rep)} isAdmin={true}/>;
        })}</div>
      </div>
      )}
    </div>
  );
}

function MotionAnalysisCard({analysis}){
  if(!analysis||!analysis.frames||analysis.frames.length===0) return null;
  var frameState=useState(0); var selFrame=frameState[0]; var setSelFrame=frameState[1];
  var frame=analysis.frames[selFrame]||{};
  var m=frame.metrics||{};
  var metrics=[
    {label:'Trunk Lean',   key:'trunk_lean_deg',    unit:'°'},
    {label:'Sh. Tilt',     key:'shoulder_tilt_deg', unit:'°'},
    {label:'Hip Tilt',     key:'hip_tilt_deg',       unit:'°'},
    {label:'Hip/Sh Sep',   key:'hip_shoulder_sep',  unit:'°'},
    {label:'Stance Width', key:'stance_width_pct',  unit:'%'},
    {label:'Arm Asym',     key:'arm_asymmetry_pct', unit:'%'},
  ];
  return(
    <div style={{marginTop:12}}>
      <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:11,color:C.navy,letterSpacing:1,marginBottom:8}}>
        BBOT MOTION ANALYSIS
        <span style={{fontSize:9,color:C.gray400,fontWeight:400,marginLeft:8,fontFamily:"inherit"}}>
          {analysis.frames.length} key frames · {analysis.sessionType}
        </span>
      </div>
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
        <div style={{background:"#0a0f14",borderRadius:8,overflow:"hidden",position:"relative"}}>
          {frame.imageUrl
            ?<img src={frame.imageUrl} style={{width:"100%",display:"block"}} alt={frame.label}/>
            :<div style={{height:140,display:"flex",alignItems:"center",justifyContent:"center"}}>
              <span style={{fontSize:11,color:"#64748b"}}>Frame: {frame.label}</span>
            </div>
          }
          <div style={{position:"absolute",bottom:0,left:0,right:0,background:"rgba(0,0,0,.7)",padding:"4px 8px"}}>
            <div style={{fontSize:10,color:"#94a3b8"}}>{frame.label} · {frame.t}s</div>
          </div>
        </div>
        <div>
          <div style={{display:"flex",gap:4,marginBottom:8,flexWrap:"wrap"}}>
            {analysis.frames.map(function(f,i){return(
              <button key={i} onClick={function(){setSelFrame(i);}} style={{fontSize:9,padding:"2px 6px",borderRadius:99,border:"1px solid "+C.border,background:selFrame===i?C.navy:"transparent",color:selFrame===i?C.white:C.gray400,cursor:"pointer"}}>{f.label}</button>
            );})}
          </div>
          <div style={{display:"flex",flexDirection:"column",gap:3}}>
            {metrics.map(function(mt){var val=m[mt.key];if(!val&&val!==0)return null;return(
              <div key={mt.key} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"3px 0",borderBottom:"1px solid "+C.border}}>
                <span style={{fontSize:10,color:C.gray500}}>{mt.label}</span>
                <span style={{fontSize:12,fontWeight:700,color:C.blue,fontFamily:"Inter,system-ui,sans-serif"}}>{val}{mt.unit}</span>
              </div>
            );})}
          </div>
        </div>
      </div>
      {analysis.synopsis&&(
        <div style={{marginTop:8,padding:"8px 10px",background:C.blueFaint,borderRadius:6,borderLeft:"3px solid "+C.blue}}>
          <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:9,color:C.blue,letterSpacing:.5,marginBottom:3}}>BBOT SYNOPSIS</div>
          <p style={{fontSize:10,color:C.gray600,margin:0,lineHeight:1.6}}>{analysis.synopsis}</p>
        </div>
      )}
    </div>
  );
}

function ReportHistoryView({scoutReports,setScoutReports,users,cu,notify}){
  var qS=useState(""); var q=qS[0]; var setQ=qS[1];
  var statusS=useState("all"); var statusF=statusS[0]; var setStatusF=statusS[1];
  var sortS=useState("date_desc"); var sortBy=sortS[0]; var setSortBy=sortS[1];
  var expandedS=useState(null); var expanded=expandedS[0]; var setExpanded=expandedS[1];
  var playerFilterS=useState(""); var playerFilter=playerFilterS[0]; var setPlayerFilter=playerFilterS[1];
  var playerById=function(id){return (users||[]).find(function(u){return String(u.id)===String(id);});};
  var rows=(scoutReports||[]).map(function(r){var p=playerById(r.playerId);return Object.assign({},r,{_playerName:p?(p.firstName+" "+p.lastName):"Unknown",_position:p?(p.position||""):"",_player:p});});
  if(statusF!=="all"){rows=rows.filter(function(r){return r.status===statusF;});}
  if(playerFilter){rows=rows.filter(function(r){return String(r.playerId)===String(playerFilter);});}
  if(q.trim()){var ql=q.toLowerCase();rows=rows.filter(function(r){return r._playerName.toLowerCase().indexOf(ql)>=0||(r.staffName||"").toLowerCase().indexOf(ql)>=0||(r.sessionType||"").toLowerCase().indexOf(ql)>=0;});}
  rows.sort(function(a,b){
    if(sortBy==="date_desc")return (b.date||"").localeCompare(a.date||"");
    if(sortBy==="date_asc")return (a.date||"").localeCompare(b.date||"");
    if(sortBy==="player")return a._playerName.localeCompare(b._playerName);
    return 0;
  });
  var total=(scoutReports||[]).length;
  var drafts=(scoutReports||[]).filter(function(r){return isDraftEval(r);}).length;
  var approved=(scoutReports||[]).filter(function(r){return isLiveEval(r);}).length;
  return(
    <div>
      <div style={{display:"flex",gap:10,marginBottom:14,flexWrap:"wrap"}}>
        <Card style={{padding:"10px 14px",flex:"1 1 110px"}}><div style={{fontSize:10,color:C.gray500,letterSpacing:.5,fontWeight:600}}>TOTAL</div><div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:22,color:C.navy}}>{total}</div></Card>
        <Card style={{padding:"10px 14px",flex:"1 1 110px"}}><div style={{fontSize:10,color:C.gray500,letterSpacing:.5,fontWeight:600}}>DRAFTS</div><div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:22,color:C.coral}}>{drafts}</div></Card>
        <Card style={{padding:"10px 14px",flex:"1 1 110px"}}><div style={{fontSize:10,color:C.gray500,letterSpacing:.5,fontWeight:600}}>APPROVED</div><div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:22,color:C.green||"#16a34a"}}>{approved}</div></Card>
      </div>
      <div style={{display:"flex",gap:8,marginBottom:14,flexWrap:"wrap",alignItems:"center"}}>
        <input value={q} onChange={function(e){setQ(e.target.value);}} placeholder="Search player, staff, session type..." style={{flex:"1 1 220px",padding:"8px 12px",border:"1px solid "+C.border,borderRadius:8,fontSize:13}}/>
        <select value={playerFilter} onChange={function(e){setPlayerFilter(e.target.value);}} style={{padding:"8px 10px",border:"1px solid "+C.border,borderRadius:8,fontSize:12,background:C.white,minWidth:140}}>
          <option value="">All Players</option>
          {(users||[]).filter(function(u){return u.type==="player";}).sort(function(a,b){return (a.lastName||"").localeCompare(b.lastName||"");}).map(function(p){return <option key={p.id} value={p.id}>{p.lastName}, {p.firstName}</option>;})}
        </select>
        <select value={statusF} onChange={function(e){setStatusF(e.target.value);}} style={{padding:"8px 10px",border:"1px solid "+C.border,borderRadius:8,fontSize:12,background:C.white}}>
          <option value="all">All Statuses</option>
          <option value="draft">Draft</option>
          <option value="approved">Approved</option>
          <option value="rejected">Rejected</option>
        </select>
        <select value={sortBy} onChange={function(e){setSortBy(e.target.value);}} style={{padding:"8px 10px",border:"1px solid "+C.border,borderRadius:8,fontSize:12,background:C.white}}>
          <option value="date_desc">Newest First</option>
          <option value="date_asc">Oldest First</option>
          <option value="player">Player A-Z</option>
        </select>
        <Btn v="ghost" style={{color:"#dc2626"}} onClick={function(){
          if(!window.confirm("Delete ALL rejected reports + reports older than 90 days?\\n\\nApproved reports newer than 90 days are kept.")) return;
          var cutoff = new Date(); cutoff.setDate(cutoff.getDate()-90);
          var toDelete = rows.filter(function(r){
            if(isRejectedEval(r)) return true;
            if(r.date && new Date(r.date) < cutoff) return true;
            return false;
          });
          if(!toDelete.length){ notify("Nothing to clean"); return; }
          notify("Cleaning "+toDelete.length+" reports…");
          var idset = {}; toDelete.forEach(function(r){ idset[String(r.id)]=true; });
          Promise.all(toDelete.map(function(r){
            return reportDelete([r.id]).then(function(){ return true; }).catch(function(){ return false; });
          })).then(function(results){
            var okCount = results.filter(Boolean).length;
            if(okCount>0 && setScoutReports){
              setScoutReports(function(prev){ return (prev||[]).filter(function(x){ return !idset[String(x.id)]; }); });
            }
            if(okCount===toDelete.length){ notify("Cleaned "+okCount+" reports"); }
            else if(okCount>0){ notify("Cleaned "+okCount+" of "+toDelete.length+" — others blocked (check delete permission)","error"); }
            else { notify("Delete blocked — run the DELETE permission SQL in Supabase","error"); }
          }).catch(function(){ notify("Some deletes failed — refresh to verify","error"); });
        }}>Clean Old</Btn>
      </div>
      {rows.length===0?
        <EmptyCard icon="H" title="No Reports Found" sub={total===0?"No BBOT evaluations have been generated yet":"No reports match your filters"}/>
      :
        <div style={{display:"flex",flexDirection:"column",gap:8}}>
          {rows.map(function(r){
            var isOpen=expanded===r.id;
            var statusColor=isLiveEval(r)?(C.green||"#16a34a"):(isRejectedEval(r)?"#dc2626":C.coral);
            return(
              <Card key={r.id} style={{padding:0,overflow:"hidden"}}>
                <div onClick={function(){setExpanded(isOpen?null:r.id);}} style={{display:"flex",alignItems:"center",gap:12,padding:"12px 14px",cursor:"pointer"}}>
                  {r._player&&<Avatar user={r._player} size={32}/>}
                  <div style={{flex:1,minWidth:0}}>
                    <div style={{display:"flex",alignItems:"center",gap:8,flexWrap:"wrap"}}>
                      <span style={{fontWeight:700,fontSize:13,color:C.gray900}}>{r._playerName}</span>
                      {r._position&&<span style={{fontSize:10,color:C.gray500,background:C.gray50,padding:"2px 6px",borderRadius:4}}>{r._position}</span>}
                      <span style={{fontSize:10,color:statusColor,background:statusColor+"15",padding:"2px 8px",borderRadius:99,fontWeight:600,textTransform:"uppercase",letterSpacing:.5}}>{r.status||"draft"}</span>
                    </div>
                    <div style={{fontSize:11,color:C.gray500,marginTop:2}}>{r.date||"No date"} · {r.sessionType||"Eval"}{r.staffName?" · by "+r.staffName:""}</div>
                  </div>
                  <button title="Delete this report permanently" onClick={function(e){
                    e.stopPropagation();
                    if(!window.confirm("Permanently delete this report for "+r._playerName+" ("+(r.date||"no date")+")? This cannot be undone.")) return;
                    reportDelete([r.id]).then(function(){
                      if(setScoutReports) setScoutReports(function(prev){ return (prev||[]).filter(function(x){ return String(x.id)!==String(r.id); }); });
                      notify("Report deleted");
                    }).catch(function(){ notify("Could not delete report — try again","error"); });
                  }} style={{background:"transparent",border:"1px solid #fecaca",color:"#dc2626",borderRadius:6,fontSize:11,fontWeight:600,padding:"5px 9px",cursor:"pointer",marginLeft:4,minHeight:"auto"}}>Delete</button>
                  <div style={{fontSize:14,color:C.gray400,marginLeft:4}}>{isOpen?"▾":"▸"}</div>
                </div>
                {isOpen&&<div style={{padding:"0 14px 14px",borderTop:"1px solid "+C.border}}><ReportCard r={r} sc={r._player} isDraft={isDraftEval(r)} isAdmin={true}/></div>}
              </Card>
            );
          })}
        </div>
      }
    </div>
  );
}

function YouTubeUploadPanel({video, player, notify}){
  // Prefill metadata from the player + session. Admin can edit before upload.
  var p = player || {};
  var pname = p.firstName ? (p.firstName+" "+p.lastName) : (video.playerName||"Player");
  var classYr = p.gradYear ? (" · Class of "+p.gradYear) : "";
  var posPart = (p.position||video.position) ? (" · "+(p.position||video.position)) : "";
  var defTitle = pname + posPart + classYr + " · " + (video.sessionType||"Evaluation") + (video.date?(" · "+video.date):"");
  var hsPart = p.hsName ? ("High School: "+p.hsName+"\n") : "";
  var clubPart = p.clubName ? ("Club/Travel: "+p.clubName+"\n") : "";
  var btPart = (p.bats||p.throws) ? ("Bats/Throws: "+(p.bats||"-")+"/"+(p.throws||"-")+"\n") : "";
  var htwt = (p.height||p.weight) ? ((p.height||"")+(p.weight?(" · "+p.weight+" lbs"):"")+"\n") : "";
  var defDesc = pname+posPart+classYr+"\n"+hsPart+clubPart+btPart+htwt+"\nVerified video evaluation by BBOT.\nFull report: https://www.643sportsmgmt.com";
  var defTags = [pname, p.position||video.position||"", p.gradYear?("Class of "+p.gradYear):"", "baseball", "recruiting", "BBOT"].filter(Boolean).join(", ");

  var openS=useState(false); var open=openS[0], setOpen=openS[1];
  var titleS=useState(defTitle); var title=titleS[0], setTitle=titleS[1];
  var descS=useState(defDesc); var desc=descS[0], setDesc=descS[1];
  var tagsS=useState(defTags); var tags=tagsS[0], setTags=tagsS[1];
  var privS=useState("unlisted"); var privacy=privS[0], setPrivacy=privS[1];
  var stateS=useState("idle"); var state=stateS[0], setState=stateS[1]; // idle | uploading | done | error | unconfigured
  var resultS=useState(null); var result=resultS[0], setResult=resultS[1];

  function doUpload(){
    setState("uploading");
    fetch(BACKEND_URL+"/youtube-upload", {
      method:"POST",
      headers:bbotAdminHeaders(),
      body: JSON.stringify({
        videoUrl: video.videoUrl,
        reportId: video.reportId,
        playerId: video.playerId,
        title: title.slice(0,100),
        description: desc.slice(0,4900),
        tags: tags.split(",").map(function(t){return t.trim();}).filter(Boolean),
        privacyStatus: privacy
      })
    }).then(function(r){ return r.json().then(function(j){ return {ok:r.ok, status:r.status, body:j}; }); })
    .then(function(res){
      if(res.status===501 || (res.body && res.body.error==="youtube_not_configured")){
        setState("unconfigured"); return;
      }
      if(res.ok && res.body && res.body.videoId){
        setResult(res.body); setState("done");
        notify&&notify("Uploaded to YouTube");
      } else {
        setResult(res.body||{}); setState("error");
        notify&&notify((res.body&&res.body.message)||"YouTube upload failed","error");
      }
    }).catch(function(){ setState("error"); notify&&notify("YouTube upload failed","error"); });
  }

  if(!open){
    return <button onClick={function(e){e.stopPropagation();setOpen(true);}} style={{marginTop:8,background:"#ff0000",color:"#fff",border:"none",padding:"7px 12px",borderRadius:6,fontSize:11,fontWeight:700,cursor:"pointer",display:"inline-flex",alignItems:"center",gap:6}}>▶ Upload to YouTube</button>;
  }
  return (
    <div onClick={function(e){e.stopPropagation();}} style={{marginTop:10,padding:12,background:C.gray50,border:"1px solid "+C.border,borderRadius:10}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:8}}>
        <div style={{fontSize:11,fontWeight:700,color:C.navy,letterSpacing:.5}}>UPLOAD TO YOUTUBE</div>
        <button onClick={function(){setOpen(false);}} style={{background:"none",border:"none",color:C.gray400,fontSize:16,cursor:"pointer",lineHeight:1}}>×</button>
      </div>
      {state==="done" ? (
        <div style={{fontSize:12,color:C.gray700}}>
          <div style={{marginBottom:6}}>✓ Uploaded.</div>
          {result&&result.videoId&&<a href={"https://youtu.be/"+result.videoId} target="_blank" rel="noopener noreferrer" style={{color:C.blue,fontSize:12,fontWeight:600}}>https://youtu.be/{result.videoId}</a>}
        </div>
      ) : state==="unconfigured" ? (
        <div style={{fontSize:11,color:C.gray600,lineHeight:1.6}}>
          YouTube isn't connected yet. To enable uploads, add your YouTube Data API credentials to the backend (Google Cloud project → OAuth client → channel authorization). Once the backend env vars are set, this button uploads with no code change.
        </div>
      ) : (
        <div style={{display:"flex",flexDirection:"column",gap:8}}>
          <div>
            <label style={{fontSize:10,color:C.gray500,fontWeight:600}}>Title <span style={{color:C.gray400}}>({title.length}/100)</span></label>
            <input value={title} onChange={function(e){setTitle(e.target.value);}} maxLength={100} style={{width:"100%",padding:"7px 9px",border:"1px solid "+C.border,borderRadius:6,fontSize:12,boxSizing:"border-box"}}/>
          </div>
          <div>
            <label style={{fontSize:10,color:C.gray500,fontWeight:600}}>Description</label>
            <textarea value={desc} onChange={function(e){setDesc(e.target.value);}} rows={5} style={{width:"100%",padding:"7px 9px",border:"1px solid "+C.border,borderRadius:6,fontSize:12,boxSizing:"border-box",resize:"vertical",fontFamily:"inherit"}}/>
          </div>
          <div>
            <label style={{fontSize:10,color:C.gray500,fontWeight:600}}>Tags (comma-separated)</label>
            <input value={tags} onChange={function(e){setTags(e.target.value);}} style={{width:"100%",padding:"7px 9px",border:"1px solid "+C.border,borderRadius:6,fontSize:12,boxSizing:"border-box"}}/>
          </div>
          <div style={{display:"flex",gap:8,alignItems:"center"}}>
            <label style={{fontSize:10,color:C.gray500,fontWeight:600}}>Privacy</label>
            <select value={privacy} onChange={function(e){setPrivacy(e.target.value);}} style={{padding:"6px 8px",border:"1px solid "+C.border,borderRadius:6,fontSize:12}}>
              <option value="unlisted">Unlisted</option>
              <option value="public">Public</option>
              <option value="private">Private</option>
            </select>
          </div>
          {state==="error"&&<div style={{fontSize:11,color:"#dc2626"}}>{(result&&result.message)||"Upload failed. Check backend logs."}</div>}
          <button disabled={state==="uploading"} onClick={doUpload} style={{background:state==="uploading"?C.gray300:"#ff0000",color:"#fff",border:"none",padding:"9px 14px",borderRadius:6,fontSize:12,fontWeight:700,cursor:state==="uploading"?"default":"pointer"}}>{state==="uploading"?"Uploading…":"Upload to YouTube"}</button>
        </div>
      )}
    </div>
  );
}

function VideoHistoryView({scoutReports, users, cu, notify, go}) {
  var qS = useState(""); var q = qS[0], setQ = qS[1];
  var expandedS = useState(null); var expanded = expandedS[0], setExpanded = expandedS[1];
  var playerById = function(id){ return (users||[]).find(function(u){ return String(u.id)===String(id); }); };
  // Build a per-player list of videos (each report contributes its videoUrl if present)
  // Include a session whenever it has a DURABLE identifier. Filtering on videoUrl hid 4 of 6 real
  // sessions (that column is null) and the two that showed carried presigned links that expire in ~1
  // hour — the broken-link class. object_key never expires, and is signed on demand below.
  var allVideos = (scoutReports||[]).filter(function(r){ return r.videoUrl||r.video_url||r.objectKey||r.object_key; }).map(function(r){
    var p = playerById(r.playerId);
    return {
      reportId: r.id,
      playerId: r.playerId,
      playerName: p ? (p.firstName + " " + p.lastName) : "Unknown",
      position: p ? (p.position||"") : "",
      videoUrl: r.videoUrl || r.video_url,
      objectKey: r.objectKey || r.object_key || null,
      date: r.date || "",
      sessionType: r.sessionType || "Evaluation",
      score: r.score,
      status: r.status || "draft"
    };
  });
  // Group by player
  var byPlayer = {};
  allVideos.forEach(function(v){ if(!byPlayer[v.playerId]) byPlayer[v.playerId]=[]; byPlayer[v.playerId].push(v); });
  // Sort each player's videos newest first
  Object.keys(byPlayer).forEach(function(pid){
    byPlayer[pid].sort(function(a,b){ return (b.date||"").localeCompare(a.date||""); });
  });
  // Filter players by query
  var playerIds = Object.keys(byPlayer);
  if(q.trim()) {
    var ql = q.toLowerCase();
    playerIds = playerIds.filter(function(pid){ return byPlayer[pid][0].playerName.toLowerCase().indexOf(ql)>=0; });
  }
  // Sort players alphabetically
  playerIds.sort(function(a,b){ return byPlayer[a][0].playerName.localeCompare(byPlayer[b][0].playerName); });
  var totalVideos = allVideos.length;
  var totalPlayers = Object.keys(byPlayer).length;
  return (
    <div>
      <div style={{display:"flex",gap:10,marginBottom:14,flexWrap:"wrap"}}>
        <Card style={{padding:"10px 14px",flex:"1 1 110px"}}><div style={{fontSize:10,color:C.gray500,letterSpacing:.5,fontWeight:600}}>VIDEOS</div><div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:22,color:C.navy}}>{totalVideos}</div></Card>
        <Card style={{padding:"10px 14px",flex:"1 1 110px"}}><div style={{fontSize:10,color:C.gray500,letterSpacing:.5,fontWeight:600}}>PLAYERS</div><div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:22,color:C.navy}}>{totalPlayers}</div></Card>
      </div>
      <div style={{display:"flex",gap:8,marginBottom:14,flexWrap:"wrap"}}>
        <input value={q} onChange={function(e){setQ(e.target.value);}} placeholder="Search player..." style={{flex:"1 1 220px",padding:"8px 12px",border:"1px solid "+C.border,borderRadius:8,fontSize:13}}/>
      </div>
      {playerIds.length===0 ?
        <EmptyCard icon="V" title="No Videos Yet" sub={totalVideos===0?"No videos have been submitted with BBOT evaluations":"No players match your search"}/>
      :
        <div style={{display:"flex",flexDirection:"column",gap:8}}>
          {playerIds.map(function(pid){
            var vids = byPlayer[pid];
            var first = vids[0];
            var isOpen = expanded === pid;
            return (
              <Card key={pid} style={{padding:0,overflow:"hidden"}}>
                <div onClick={function(){setExpanded(isOpen?null:pid);}} style={{display:"flex",alignItems:"center",gap:12,padding:"12px 14px",cursor:"pointer"}}>
                  <div style={{flex:1,minWidth:0}}>
                    <div style={{display:"flex",alignItems:"center",gap:8,flexWrap:"wrap"}}>
                      <span style={{fontWeight:700,fontSize:13,color:C.gray900}}>{first.playerName}</span>
                      {first.position&&<span style={{fontSize:10,color:C.gray500,background:C.gray50,padding:"2px 6px",borderRadius:4}}>{first.position}</span>}
                    </div>
                    <div style={{fontSize:11,color:C.gray500,marginTop:2}}>{vids.length} video{vids.length!==1?"s":""}</div>
                  </div>
                  <div style={{fontSize:14,color:C.gray400}}>{isOpen?"▾":"▸"}</div>
                </div>
                {isOpen&&<div style={{padding:"0 14px 14px",borderTop:"1px solid "+C.border}}>
                  {vids.map(function(v){
                    // An expiring signature is not a usable link — treat it as absent and sign from
                    // object_key on demand instead (same path clips already use).
                    var _raw=v.videoUrl||"";
                    var _expiring=/X-Amz-Signature|X-Amz-Credential/.test(_raw);
                    var vurl=_expiring?"":_raw;
                    var _signable=(!vurl && v.objectKey) ? v.objectKey : null;
                    var ytm=vurl.match(/(?:youtube\.com\/(?:watch\?(?:.*&)?v=|embed\/|shorts\/)|youtu\.be\/)([A-Za-z0-9_-]{11})/);
                    var ytId=ytm?ytm[1]:(/^[A-Za-z0-9_-]{11}$/.test(vurl)?vurl:"");
                    var isFullUrl=/^https?:\/\//.test(vurl);
                    var alreadyYT=!!ytId;
                    return (
                      <div key={v.reportId} style={{padding:"10px 0",borderBottom:"1px solid "+C.gray50}}>
                        {_signable && <button onClick={function(){
                          fetch(BACKEND_URL+"/r2-read-url?objectKey="+encodeURIComponent(_signable))
                            .then(function(r){return r.json();})
                            .then(function(d){ if(d&&d.url) window.open(d.url,"_blank"); else notify&&notify("Could not open video","error"); })
                            .catch(function(){ notify&&notify("Could not open video","error"); });
                        }} style={{marginBottom:6,padding:"5px 11px",borderRadius:6,border:"1px solid "+C.border,background:C.white,fontSize:11,fontWeight:600,color:C.blue,cursor:"pointer"}}>▶ Open source video</button>}
                        <div style={{fontSize:12,color:C.gray700,fontWeight:600,marginBottom:6}}>{v.sessionType} · {v.date||"no date"}</div>
                        {ytId
                          ? <iframe width="100%" height="160" src={"https://www.youtube.com/embed/"+ytId} frameBorder="0" allowFullScreen style={{borderRadius:8,display:"block"}}/>
                          : isFullUrl
                            ? <video {...bbotVideoGuard()} src={vurl} controls playsInline style={{width:"100%",maxHeight:200,borderRadius:8,background:"#000",display:"block"}}/>
                            : <button onClick={function(e){e.stopPropagation();go("profile-"+v.playerId);}} style={{background:C.blueFaint,color:C.blue,border:"none",padding:"8px 12px",borderRadius:6,fontSize:11,fontWeight:600,cursor:"pointer"}}>▶ View clip on player profile →</button>
                        }
                        {/* YouTube upload — only for hosted files not already on YouTube */}
                        {isFullUrl && !alreadyYT && (
                          <YouTubeUploadPanel video={v} player={playerById(v.playerId)} notify={notify}/>
                        )}
                        {alreadyYT && <div style={{fontSize:10,color:C.gray400,marginTop:6}}>Already on YouTube</div>}
                      </div>
                    );
                  })}
                </div>}
              </Card>
            );
          })}
        </div>
      }
    </div>
  );
}

function BulkPlayerImport({setUsers, notify, onClose}) {
  var csvS = useState(""); var csv = csvS[0], setCsv = csvS[1];
  var previewS = useState([]); var preview = previewS[0], setPreview = previewS[1];
  var errorS = useState(""); var error = errorS[0], setError = errorS[1];

  var TEMPLATE = "firstName,lastName,gradYear,position,position2,hsName,clubName,height,jerseyNum,jerseyColor,bats,throws,email\nExample,Player,2027,SS,2B,Westview HS,AZ Hotshots,5'11\",12,Blue,R,R,player@example.com";

  function downloadTemplate(){
    var blob = new Blob([TEMPLATE], {type:"text/csv"});
    var url = URL.createObjectURL(blob);
    var a = document.createElement("a"); a.href = url; a.download = "bbot_player_template.csv"; a.click();
    URL.revokeObjectURL(url);
  }

  function parseCSV(text){
    var lines = text.trim().split(/\r?\n/);
    if(lines.length < 2) return {rows:[], error:"Need at least 1 data row"};
    var header = lines[0].split(",").map(function(h){return h.trim();});
    var required = ["firstName","lastName"];
    for(var i=0;i<required.length;i++){
      if(header.indexOf(required[i])<0) return {rows:[], error:"Missing required column: "+required[i]};
    }
    var rows = [];
    for(var i=1;i<lines.length;i++){
      var cells = lines[i].split(",").map(function(c){return c.trim();});
      var row = {};
      header.forEach(function(h, idx){ row[h] = cells[idx] || ""; });
      if(!row.firstName || !row.lastName) continue;
      rows.push(row);
    }
    return {rows:rows, error:null};
  }

  function doPreview(){
    var r = parseCSV(csv);
    if(r.error){ setError(r.error); setPreview([]); return; }
    setError(""); setPreview(r.rows);
  }

  function doImport(){
    if(!preview.length) return;
    var newUsers = preview.map(function(row, i){
      return Object.assign({
        id: Date.now() + i,
        type: "player",
        avatarUrl: "",
        createdAt: new Date().toISOString()
      }, row);
    });
    setUsers(function(prev){ return prev.concat(newUsers); });
    newUsers.forEach(function(u){ persistUser(u).catch(function(){}); });
    notify("Imported " + newUsers.length + " player" + (newUsers.length===1?"":"s"));
    if(onClose) onClose();
  }

  return (
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.5)",zIndex:1000,display:"flex",alignItems:"center",justifyContent:"center",padding:20}}>
      <div style={{background:C.white,borderRadius:12,maxWidth:720,width:"100%",maxHeight:"90vh",overflow:"auto",padding:20}}>
        <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:12}}>
          <h3 style={{margin:0,fontSize:16,color:C.navy}}>Bulk Add Players</h3>
          <button onClick={onClose} style={{background:"none",border:"none",fontSize:18,cursor:"pointer",color:C.gray500}}>&times;</button>
        </div>
        <div style={{fontSize:12,color:C.gray600,marginBottom:12,lineHeight:1.5}}>
          Paste CSV data below. <strong>Required:</strong> <strong>firstName</strong>, <strong>lastName</strong>. <em>Optional:</em> gradYear, position, position2, hsName, clubName, height, jerseyNum, jerseyColor, bats, throws, email.
        </div>
        <div style={{display:"flex",gap:8,marginBottom:10,flexWrap:"wrap"}}>
          <Btn v="ghost" onClick={downloadTemplate}>Download Template CSV</Btn>
        </div>
        <textarea value={csv} onChange={function(e){setCsv(e.target.value);}} placeholder="firstName,lastName,gradYear,position,...&#10;John,Smith,2027,SS,..." rows={8} style={{width:"100%",padding:"10px 12px",border:"1px solid "+C.border,borderRadius:8,fontSize:12,fontFamily:"monospace",resize:"vertical"}}/>
        <div style={{display:"flex",gap:8,marginTop:10}}>
          <Btn v="primary" onClick={doPreview} disabled={!csv.trim()}>Preview</Btn>
          {preview.length>0&&<Btn v="primary" onClick={doImport} style={{background:C.green||"#16a34a"}}>{"Import "+preview.length+" Players"}</Btn>}
        </div>
        {error&&<div style={{padding:"8px 10px",background:"#fff3f0",border:"1px solid "+C.coral,borderRadius:6,fontSize:11,color:"#b03a26",marginTop:10}}>{error}</div>}
        {preview.length>0&&(
          <div style={{marginTop:14,border:"1px solid "+C.border,borderRadius:8,overflow:"hidden"}}>
            <div style={{background:C.gray50,padding:"6px 10px",fontSize:10,fontWeight:700,color:C.navy,letterSpacing:.5}}>PREVIEW &mdash; {preview.length} players will be created</div>
            <div style={{maxHeight:240,overflow:"auto"}}>
              {preview.map(function(r,i){
                return <div key={i} style={{padding:"6px 10px",borderBottom:"1px solid "+C.gray50,fontSize:11,display:"flex",gap:8,flexWrap:"wrap"}}>
                  <span style={{fontWeight:700,color:C.navy,minWidth:140}}>{r.firstName} {r.lastName}</span>
                  {r.position&&<span style={{color:C.gray600}}>{r.position}</span>}
                  {r.gradYear&&<span style={{color:C.gray500}}>'{String(r.gradYear).slice(-2)}</span>}
                  {r.hsName&&<span style={{color:C.gray500}}>{r.hsName}</span>}
                </div>;
              })}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}


function CompareView({users, scoutReports, metrics}){
  var [selected, setSelected] = useState(function(){
    if(typeof window!=="undefined" && window.__bbotCompareIds && window.__bbotCompareIds.length){
      var ids=window.__bbotCompareIds.slice(0,10); window.__bbotCompareIds=null; return ids;
    }
    return [];
  });
  var [posFilter, setPosFilter] = useState("");
  var [query, setQuery] = useState("");

  var players = (users||[]).filter(function(u){return u.type==="player";});
  if(posFilter){
    players = players.filter(function(u){
      return (u.position||"").toUpperCase()===posFilter.toUpperCase();
    });
  }
  if(query.trim()){
    var q = query.toLowerCase();
    players = players.filter(function(u){
      return (u.firstName+" "+u.lastName).toLowerCase().indexOf(q)>=0
          || (u.hsName||"").toLowerCase().indexOf(q)>=0
          || (u.clubName||"").toLowerCase().indexOf(q)>=0;
    });
  }

  function toggle(id){
    setSelected(function(s){
      if(s.indexOf(id)>=0) return s.filter(function(x){return x!==id;});
      if(s.length>=10) return s; // cap at 10
      return s.concat([id]);
    });
  }

  function latestReport(playerId){
    var pReports = (scoutReports||[]).filter(function(r){
      return String(r.playerId)===String(playerId) && isLiveEval(r);
    }).sort(function(a,b){return (b.date||"").localeCompare(a.date||"");});
    return pReports[0] || null;
  }

  function latestMetric(playerId, key){
    var pM = (metrics||{})[playerId] || [];
    if(!pM.length) return null;
    var latest = pM[pM.length-1];
    return latest[key] != null ? latest[key] : null;
  }

  var selectedPlayers = selected.map(function(id){return players.find(function(u){return String(u.id)===String(id);}) || (users||[]).find(function(u){return String(u.id)===String(id);});}).filter(Boolean);

  return (
    <div>
      <SectionHeader>Compare Players</SectionHeader>
      <div style={{fontSize:12,color:C.gray500,marginBottom:14}}>Pick up to 10 players for a side-by-side comparison.</div>

      <div style={{display:"flex",gap:8,marginBottom:12,flexWrap:"wrap"}}>
        <input value={query} onChange={function(e){setQuery(e.target.value);}} placeholder="Search players..." style={{flex:"1 1 200px",fontSize:12,padding:"7px 10px"}}/>
        <select value={posFilter} onChange={function(e){setPosFilter(e.target.value);}} style={{padding:"7px 10px",fontSize:12,minHeight:"auto"}}>
          <option value="">All positions</option>
          {["P","RHP","LHP","C","1B","2B","3B","SS","LF","CF","RF","OF","DH"].map(function(p){return <option key={p} value={p}>{p}</option>;})}
        </select>
      </div>

      {/* Picker */}
      <div style={{display:"flex",flexDirection:"column",gap:6,marginBottom:18,maxHeight:240,overflowY:"auto",padding:"4px",border:"1px solid "+C.border,borderRadius:8}}>
        {players.slice(0,30).map(function(p){
          var on = selected.indexOf(p.id)>=0;
          return (
            <div key={p.id} onClick={function(){toggle(p.id);}} style={{display:"flex",alignItems:"center",gap:8,padding:"6px 10px",background:on?C.coralFaint:C.white,borderRadius:6,cursor:"pointer",border:"1px solid "+(on?C.coral:C.gray100)}}>
              <div style={{width:14,height:14,borderRadius:3,border:"1.5px solid "+(on?C.coral:C.gray300),background:on?C.coral:C.white,display:"flex",alignItems:"center",justifyContent:"center",color:C.white,fontSize:10,fontWeight:700}}>{on?"✓":""}</div>
              <Avatar user={p} size={24}/>
              <div style={{flex:1,fontSize:13,fontWeight:600,color:C.navy}}>{p.firstName} {p.lastName}</div>
              {/* String() BEFORE slice. gradYear is a NUMBER on some rows and a string on others, and the
                  guard only tested truthiness -- so the Compare picker threw "gradYear.slice is not a
                  function" the moment one numeric row entered the list, and the boundary replaced the
                  whole tab with "Something went wrong". The two other sites that render a grad year
                  already coerce; this one was the survivor. */}
              <div style={{fontSize:10,color:C.gray500}}>{[p.position,p.gradYear?"'"+String(p.gradYear).slice(-2):null].filter(Boolean).join(" · ")}</div>
            </div>
          );
        })}
      </div>

      {selectedPlayers.length<2 ? (
        <EmptyCard icon="VS" title="Select up to 10 Players" sub="Tap players above to add them to the comparison."/>
      ) : (
        <div style={{overflowX:"auto"}}>
          <table style={{width:"100%",minWidth:selectedPlayers.length*180+"px",borderCollapse:"collapse",fontSize:12}}>
            <thead>
              <tr style={{borderBottom:"2px solid "+C.navy}}>
                <th style={{padding:"8px 6px",textAlign:"left",fontSize:10,color:C.gray500,letterSpacing:.5,width:90}}>METRIC</th>
                {selectedPlayers.map(function(p){return (
                  <th key={p.id} style={{padding:"8px 6px",textAlign:"center",fontSize:11,color:C.navy,fontWeight:700,verticalAlign:"top"}}>
                    <div style={{display:"flex",flexDirection:"column",alignItems:"center",gap:4}}>
                      <Avatar user={p} size={32}/>
                      <div style={{fontSize:11,fontWeight:700}}>{p.firstName} {p.lastName}</div>
                      <div style={{fontSize:9,color:C.gray500,fontWeight:400}}>{[p.position,p.gradYear?"Class "+p.gradYear:null].filter(Boolean).join(" · ")}</div>
                    </div>
                  </th>
                );})}
              </tr>
            </thead>
            <tbody>
              {[
                {label:"Age Group",get:function(p){return (typeof bbotAgeGroup==="function"?bbotAgeGroup(p.dob):null)||"—";}},
                {label:"Height",get:function(p){return p.height||"—";}},
                {label:"Weight",get:function(p){return p.weight?p.weight+" lbs":"—";}},
                {label:"B/T",get:function(p){return (p.bats||"?")+"/"+(p.throws||"?");}},
                {label:"GPA",get:function(p){return p.gpa||"—";}},
                {label:"School",get:function(p){return p.hsName||"—";}},
                {label:"EV Peak",get:function(p){var v=latestMetric(p.id,"exitVelo");return v!=null?v+" mph":"—";}},
                {label:"Throw",get:function(p){var v=latestMetric(p.id,"throwVelo");return v!=null?v+" mph":"—";}},
                {label:"H-to-1st",get:function(p){var v=latestMetric(p.id,"h2f");return v!=null?v+"s":"—";}},
                {label:"60-yd",get:function(p){var v=latestMetric(p.id,"dash60");return v!=null?v+"s":"—";}},
                {label:"Top Pop Time",get:function(p){var v=latestMetric(p.id,"popTime");return v!=null?v+"s":"—";}},
                {label:"Pitch Velo",get:function(p){var v=latestMetric(p.id,"pitchVelo");return v!=null?v+" mph":"—";}},
              ].map(function(row,i){return (
                <tr key={i} style={{borderBottom:"1px solid "+C.gray100}}>
                  <td style={{padding:"8px 6px",fontSize:11,color:C.gray500,fontWeight:600}}>{row.label}</td>
                  {selectedPlayers.map(function(p){return (
                    <td key={p.id} style={{padding:"8px 6px",textAlign:"center",fontSize:12,color:C.navy,fontWeight:600}}>{row.get(p)}</td>
                  );})}
                </tr>
              );})}
            </tbody>
          </table>
          <div style={{fontSize:10,color:C.gray400,marginTop:8,lineHeight:1.4}}>Comparison shows device-verified measurements only. Tools without an on-screen number are scouting observations and aren't compared numerically.</div>
        </div>
      )}
    </div>
  );
}

// ============================================================
// SYSTEM HEALTH — admin self-diagnostics. Runs data-integrity, workflow-backlog, and anomaly
// checks. Each check reports severity + a plain-English diagnosis (what it means / likely cause)
// and, where a fix is SAFE to automate, a one-click action. Destructive fixes always confirm.
// This is app-level data hygiene + anomaly surfacing — NOT malware/intrusion scanning, which is
// handled at the infrastructure layer (Vercel/Railway/Supabase), not in app code.
// ============================================================
function SystemHealthView({users, setUsers, scoutReports, setScoutReports, highlights, setHighlights, battedBalls, lineups, recaps, notify, go}){
  var nowS=useState(Date.now()); var refreshedAt=nowS[0]; var setRefreshedAt=nowS[1];
  // AUTOMATION: re-run checks automatically every 60s while the tab is open, and persist a
  // timestamped snapshot so the badge/report reflect the latest run without manual refresh.
  useEffect(function(){
    var iv=setInterval(function(){ setRefreshedAt(Date.now()); }, 60000);
    return function(){ clearInterval(iv); };
  },[]);
  var days=function(iso){ if(!iso) return Infinity; var t=new Date(iso).getTime(); return isNaN(t)?Infinity:(Date.now()-t)/86400000; };
  var playerIds={}; (users||[]).forEach(function(u){ if(u&&u.type==="player") playerIds[String(u.id)]=true; });

  // ---- run checks ----
  var checks=[];
  // 1. Orphaned reports (player_id points to no existing player)
  var orphanReports=(scoutReports||[]).filter(function(r){ return r.playerId!=null && !playerIds[String(r.playerId)]; });
  checks.push({ id:"orphan_reports", sev:orphanReports.length?"warn":"ok", title:"Orphaned evaluations",
    count:orphanReports.length, diag:"Evaluations whose player no longer exists (player deleted but eval left behind). They won't show on any profile and skew counts.",
    fix:orphanReports.length?{label:"Review in Report History",action:function(){go("history");}}:null });
  // 2. Duplicate reports (same player + date + type)
  var seen={}, dupes=0; (scoutReports||[]).forEach(function(r){ var k=String(r.playerId)+"|"+(r.date||r.sessionDate||"")+"|"+(r.sessionType||""); if(seen[k]) dupes++; else seen[k]=true; });
  checks.push({ id:"dupe_reports", sev:dupes?"warn":"ok", title:"Duplicate evaluations",
    count:dupes, diag:"Same player, date, and session type appearing more than once. Likely a double-submit or a session-mode mis-set (individual vs multi). Verify before deleting.",
    fix:dupes?{label:"Open Report History",action:function(){go("history");}}:null });
  // 3. Stuck drafts (>3 days in draft)
  var stuckDrafts=(scoutReports||[]).filter(function(r){ return isDraftEval(r) && days(r.createdAt||r.date)>3; });
  checks.push({ id:"stuck_drafts", sev:stuckDrafts.length?"warn":"ok", title:"Stale draft evaluations",
    count:stuckDrafts.length, diag:"Evaluations sitting in draft over 3 days — waiting on admin review. Players can't see or buy these until released.",
    fix:stuckDrafts.length?{label:"Go to Mass Approve",action:function(){go("mass");}}:null });
  // 4. Failed evals
  var failed=(scoutReports||[]).filter(function(r){ return isJobFailed(r); });
  checks.push({ id:"failed_evals", sev:failed.length?"warn":"ok", title:"Failed evaluations",
    count:failed.length, diag:"Evaluations that errored during generation (bad video, backend timeout, etc). Retry or remove them.",
    fix:failed.length?{label:"Go to Failed Evals",action:function(){go("failed");}}:null });
  // 5. Clips pending review (>5 days)
  var stuckClips=(highlights||[]).filter(function(h){ return !h.approved && days(h.date)>5; });
  checks.push({ id:"stuck_clips", sev:stuckClips.length?"warn":"ok", title:"Clips awaiting review",
    count:stuckClips.length, diag:"BBOT clips pending your approval for over 5 days. They stay hidden from players until the prep checklist is confirmed and approved.",
    fix:stuckClips.length?{label:"Go to Clip Review",action:function(){go("clips");}}:null });
  // 6. Accounts pending approval (>2 days)
  var stuckUsers=(users||[]).filter(function(u){ return u.approvalStatus==="pending" && days(u.createdAt)>2; });
  checks.push({ id:"stuck_users", sev:stuckUsers.length?"warn":"ok", title:"Accounts awaiting approval",
    count:stuckUsers.length, diag:"Signups pending over 2 days. They can't upload or buy until approved. (A sudden spike can also signal spam signups — review before bulk-approving.)",
    fix:stuckUsers.length?{label:"Go to Profile Approvals",action:function(){go("approvals");}}:null });
  // 7. Provisional players backlog
  var prov=(users||[]).filter(function(u){ return u&&u.provisional; });
  checks.push({ id:"provisional", sev:prov.length?"warn":"ok", title:"Unassigned players",
    count:prov.length, diag:"Placeholders from multi-player sessions not yet identified. Their data is held but won't rank or show publicly until you assign them to a real player.",
    fix:prov.length?{label:"Go to Profile Approvals",action:function(){go("approvals");}}:null });
  // 8. Signup-spike anomaly (sudden burst in last 24h vs typical)
  var last24=(users||[]).filter(function(u){ return days(u.createdAt)<1; }).length;
  checks.push({ id:"signup_spike", sev:last24>=15?"alert":"ok", title:"Signup anomaly",
    count:last24, diag:last24>=15?"Unusually high signups in the last 24h ("+last24+"). Could be legitimate, or a spam/bot burst. Review Profile Approvals before bulk-approving — approving spam wastes backend cost.":"Signup volume looks normal.",
    fix:last24>=15?{label:"Review signups",action:function(){go("approvals");}}:null });

  var alerts=checks.filter(function(c){return c.sev==="alert";}).length;
  var warns=checks.filter(function(c){return c.sev==="warn";}).length;
  var sevColor=function(s){ return s==="alert"?C.red:s==="warn"?C.orange:C.green; };
  var sevBg=function(s){ return s==="alert"?C.redLight:s==="warn"?C.orangeLight:C.greenLight; };

  return (
    <div>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:6,flexWrap:"wrap",gap:8}}>
        <SectionHeader>System Health</SectionHeader>
        <div style={{display:"flex",gap:8}}>
          <button onClick={function(){
            // Downloadable results report (plain text) — for records or sharing.
            var lines=["BBOT SYSTEM HEALTH REPORT","Generated: "+new Date().toLocaleString(),""];
            lines.push(alerts+" alert(s) · "+warns+" attention item(s)","");
            checks.forEach(function(c){ lines.push("["+(c.sev==="ok"?"OK":c.sev==="warn"?"ATTENTION":"ALERT")+"] "+c.title+(c.sev!=="ok"?" — "+c.count:""), "    "+c.diag, ""); });
            var blob=new Blob([lines.join("\n")],{type:"text/plain"});
            var url=URL.createObjectURL(blob); var a=document.createElement("a");
            a.href=url; a.download="bbot_health_"+new Date().toISOString().slice(0,10)+".txt"; a.click();
            setTimeout(function(){URL.revokeObjectURL(url);},1000);
            notify("Health report downloaded");
          }} style={{padding:"7px 14px",borderRadius:8,border:"1px solid "+C.border,background:C.white,color:C.gray700,fontSize:12,fontWeight:600,cursor:"pointer"}}>↓ Download report</button>
          <button onClick={function(){setRefreshedAt(Date.now());notify("Health checks re-run");}} style={{padding:"7px 14px",borderRadius:8,border:"1px solid "+C.border,background:C.white,color:C.gray700,fontSize:12,fontWeight:600,cursor:"pointer"}}>↻ Re-run checks</button>
        </div>
      </div>
      <div style={{fontSize:12,color:C.gray500,marginBottom:14,lineHeight:1.5}}>
        {alerts>0?(alerts+" alert"+(alerts>1?"s":"")+" · "):""}{warns>0?(warns+" item"+(warns>1?"s":"")+" need attention"):(alerts>0?"":"All clear — nothing needs attention.")} <span style={{color:C.gray400}}>· Auto-refreshes every 60s. Run daily/weekly. Infrastructure security (servers, malware) is handled by your hosting providers; these are app-level data + workflow checks.</span>
      </div>
      <div style={{display:"flex",flexDirection:"column",gap:8}}>
        {checks.sort(function(a,b){var o={alert:0,warn:1,ok:2};return o[a.sev]-o[b.sev];}).map(function(c){
          return (
            <Card key={c.id} style={{padding:"12px 14px",borderLeft:"4px solid "+sevColor(c.sev)}}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",gap:10}}>
                <div style={{flex:1}}>
                  <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:3}}>
                    <span style={{fontSize:10,fontWeight:700,letterSpacing:.5,color:sevColor(c.sev),background:sevBg(c.sev),padding:"2px 8px",borderRadius:99}}>{c.sev==="ok"?"OK":c.sev==="warn"?"ATTENTION":"ALERT"}</span>
                    <span style={{fontSize:14,fontWeight:700,color:C.navy}}>{c.title}</span>
                    {c.sev!=="ok"&&<span style={{fontSize:13,fontWeight:700,color:sevColor(c.sev)}}>· {c.count}</span>}
                  </div>
                  <div style={{fontSize:12,color:C.gray600,lineHeight:1.5}}>{c.diag}</div>
                </div>
                {c.fix&&<button onClick={c.fix.action} style={{flexShrink:0,padding:"7px 12px",borderRadius:7,border:"none",background:sevColor(c.sev),color:C.white,fontSize:11,fontWeight:700,cursor:"pointer",whiteSpace:"nowrap"}}>{c.fix.label}</button>}
              </div>
            </Card>
          );
        })}
      </div>
      <CalibrationInsights/>
    </div>
  );
}

// #32 CONTINUOUS LEARNING (read-only surface): aggregate the admin grade-override log (#31) into a
// per-tool calibration signal — where admins consistently correct BBOT, and by how much. This CLOSES the
// learning loop safely: it never touches the eval; it SURFACES the drift so the rubric is tuned deliberately.
function CalibrationInsights(){
  var st = useState(null); var rows = st[0], setRows = st[1];
  useEffect(function(){
    bbotAdminLogRead({action:"grade_override",limit:"1000"})
      .then(function(logs){
        var by={};
        (logs||[]).forEach(function(l){
          var m=l.metadata||{}; if(typeof m==="string"){try{m=JSON.parse(m);}catch(e){m={};}}
          var d=m.delta; if(typeof d!=="number") return;
          var key=(m.toolLabel||m.sectionKey||"tool")+(m.ageGroup?(" · "+m.ageGroup):"");
          if(!by[key]) by[key]={key:key, n:0, sum:0};
          by[key].n++; by[key].sum+=d;
        });
        var arr=Object.keys(by).map(function(k){var o=by[k];return {key:k, n:o.n, avg:o.sum/o.n};});
        arr.sort(function(a,b){return b.n-a.n;});
        setRows(arr);
      }).catch(function(){setRows([]);});
  }, []);
  if(rows===null) return null;
  return (
    <div style={{marginTop:22}}>
      <div style={{fontSize:14,fontWeight:700,color:C.navy,marginBottom:4}}>BBOT Calibration Signals</div>
      <div style={{fontSize:12,color:C.gray500,marginBottom:12,lineHeight:1.5}}>Where admins consistently adjust BBOT's grades — the learning signal. A repeated one-direction correction means that tool's benchmark should be tuned in the rubric. Surfaced only; no grade changes automatically.</div>
      {rows.length===0 ? (
        <Card style={{padding:"12px 14px",fontSize:12,color:C.gray500}}>No grade overrides logged yet. As admins refine grades, the pattern builds here.</Card>
      ) : (
        <Card style={{padding:0,overflow:"hidden"}}>
          {rows.map(function(r,i){
            var up=r.avg>0; var strong=Math.abs(r.avg)>=4 && r.n>=3;
            return (
              <div key={r.key} style={{display:"flex",alignItems:"center",gap:12,padding:"9px 14px",borderTop:i?"1px solid "+C.gray100:"none",fontSize:12}}>
                <div style={{flex:1,fontWeight:600,color:C.navy}}>{r.key}</div>
                <div style={{minWidth:70,textAlign:"right",color:C.gray500}}>{r.n} edit{r.n===1?"":"s"}</div>
                <div style={{minWidth:120,textAlign:"right",fontWeight:700,color:up?C.blue:C.coral}}>{up?"+":""}{r.avg.toFixed(1)} avg</div>
                <div style={{minWidth:150,fontSize:11,color:strong?(up?C.blue:C.coral):C.gray400}}>{strong?("benchmark may run "+(up?"LOW":"HIGH")):"—"}</div>
              </div>
            );
          })}
        </Card>
      )}
    </div>
  );
}
// ============================================================================
// FIXED-CURVE PERCENTILE — THE DISCLOSURE RECORD
// ============================================================================
// ORDERED BY LUIS, 2026-10-09: *"a percentile from a fixed curve in code is a fabricated number,
// and it reached customer PDFs ... List every report where it rendered to a customer — player,
// field, the number shown, date range it was live. That list goes in the admin dashboard, not just
// this chat."*
//
// WHAT RENDERED. `GradeTrack`, inside `ReportPdfContent`, with no admin gate. It drew whenever a
// section carried `gradeBasis.percentile` and printed the measured value, a dot on a blue-to-coral
// gradient, and the words "<n>th percentile · <bracket>". Deleted 2026-10-09, along with its twin
// in the pre-1.0 renderer, so this panel reconstructs what it drew from the rows it drew from.
//
// THE NUMBER IN THE "SHOWN" COLUMN is round(percentile) — the component rounded for its label, so
// that is the figure a reader saw rather than the stored float.
//
// WHY IT IS COMPUTED HERE AND NOT STORED. A stored list is a snapshot that goes stale the moment a
// row changes; this walks the rows every time the panel opens, so it cannot drift from the record
// it describes. If a basis is ever written again, it appears here without anyone remembering to
// update a table. [[receipt-is-an-artifact-not-a-sentence]]
function PercentileDisclosureView({users, scoutReports, go}){
  var [publicIds, setPublicIds] = useState(null);
  var [firstSave, setFirstSave] = useState(null);
  var [err, setErr] = useState("");

  useEffect(function(){
    // REACHABILITY IS NOT A GUESS ABOUT STATUS. `bbot_reports_public` is the view a logged-out
    // reader actually gets, so membership in it is the answer to "can a customer still open this
    // today" -- asked of the surface rather than inferred from the word "archived".
    // [[anon-caller-not-admin-view]]
    sbSelect("bbot_reports_public","?select=id&limit=1000").then(function(rows){
      setPublicIds((rows||[]).map(function(r){ return String(r.id); }));
    }).catch(function(){ setErr("could not read bbot_reports_public — reachability unknown"); setPublicIds([]); });
    // The admin measured-time save wrote its basis at the moment of the save; the row it wrote
    // alongside carries that timestamp. Composition-written bases are dated by the report instead.
    sbSelect("bbot_measurements","?select=report_id,tool_key,created_at&order=created_at.asc&limit=2000").then(function(rows){
      var first = {};
      (rows||[]).forEach(function(m){
        var k = String(m.report_id)+"|"+String(m.tool_key||"").toLowerCase();
        if(!first[k]) first[k] = m.created_at;
      });
      setFirstSave(first);
    }).catch(function(){ setFirstSave({}); });
  }, []);

  var TOOL_TO_MEAS = {run:["h2f","sixtyyard","dash60"], poptime:["poptime"],
                      hit:["exitveloavg","exitvelo"], power:["exitvelopeak","rawpower"],
                      throw:["throw","throwvelo"]};
  var CLOSED = "2026-10-09";

  var rows = [];
  (scoutReports||[]).forEach(function(r){
    var secs = (r.sections)||[];
    secs.forEach(function(s, i){
      var gb = s && s.gradeBasis;
      if(!gb || gb.percentile==null) return;
      var pl = (users||[]).find(function(u){ return String(u.id)===String(r.playerId); });
      var key = String(s.key||"").toLowerCase();
      // WHICH WRITER, from the basis's own shape: composition stamps `dial` and `ageRule`, the
      // admin time save does not. The same fingerprint that traced the grade writer.
      var byAdmin = !(gb.dial || gb.ageRule);
      var opened = null;
      if(byAdmin && firstSave){
        var cands = TOOL_TO_MEAS[key] || [key];
        for(var c=0;c<cands.length && !opened;c++) opened = firstSave[String(r.id)+"|"+cands[c]];
      }
      if(!opened) opened = r.created_at || r.date;
      rows.push({
        player: pl ? (pl.firstName+" "+pl.lastName) : (r.playerName || ("player "+r.playerId)),
        playerObj: pl || null,
        reportId: String(r.id),
        statusNow: r.status || "?",
        field: s.label || s.key,
        shown: Math.round(Number(gb.percentile))+"th percentile",
        bracket: gb.bracket || null,
        value: (gb.value!=null ? (gb.value + (gb.unit==="s" ? "s" : " mph")) : null),
        writer: byAdmin ? "admin measured-time save" : "report composition",
        from: String(opened||"").slice(0,10),
        until: CLOSED,
        reachable: publicIds ? (publicIds.indexOf(String(r.id))>=0) : null
      });
    });
  });
  rows.sort(function(a,b){
    return (a.player||"").localeCompare(b.player||"") || a.reportId.localeCompare(b.reportId)
        || String(a.field).localeCompare(String(b.field));
  });

  var nReports = {}; var nPlayers = {}; var nReachable = 0; var byWriter = {};
  rows.forEach(function(x){
    nReports[x.reportId]=1; nPlayers[x.player]=1;
    if(x.reachable) nReachable++;
    byWriter[x.writer]=(byWriter[x.writer]||0)+1;
  });

  var th = {padding:"7px 9px",fontSize:9.5,color:C.gray500,letterSpacing:.5,fontWeight:700,
            textTransform:"uppercase",textAlign:"left",whiteSpace:"nowrap"};
  var td = {padding:"7px 9px",fontSize:11.5,color:C.gray700,borderTop:"1px solid "+C.gray100,
            verticalAlign:"top"};

  return (
    <div>
      <div style={{marginBottom:14}}>
        <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:16,color:C.navy,letterSpacing:1}}>
          AGE-PEER PERCENTILE — DISCLOSURE RECORD
        </div>
        <div style={{fontSize:12,color:C.gray600,marginTop:6,lineHeight:1.6,maxWidth:760}}>
          Every place a percentile reached a customer. It was read off a fixed curve written into
          the code — an anchor, a multiplier per age bracket, a fixed spread — so no player, rep or
          session was in it, and it could not say where anyone stood among peers. The render was
          removed on {CLOSED}; the measured value and the bracket stay on the record.
          This list is computed from the rows each time this page opens, so it cannot go stale.
        </div>
      </div>

      {err ? <div style={{padding:"8px 10px",background:C.coralLight,color:C.coral,borderRadius:6,
                          fontSize:11.5,marginBottom:10,fontWeight:600}}>{err}</div> : null}

      <div style={{display:"flex",gap:8,flexWrap:"wrap",marginBottom:12}}>
        {[["renders", rows.length],
          ["reports", Object.keys(nReports).length],
          ["players", Object.keys(nPlayers).length],
          ["still reachable by a customer link", nReachable]].map(function(p){
          return (
            <div key={p[0]} style={{padding:"7px 11px",background:C.gray50,borderRadius:7,
                                    border:"1px solid "+C.border}}>
              <div style={{fontSize:17,fontWeight:700,color:C.navy,fontFamily:"Inter,system-ui,sans-serif"}}>{p[1]}</div>
              <div style={{fontSize:9.5,color:C.gray500,letterSpacing:.4,textTransform:"uppercase"}}>{p[0]}</div>
            </div>
          );
        })}
        {Object.keys(byWriter).sort().map(function(w){
          return (
            <div key={w} style={{padding:"7px 11px",background:C.gray50,borderRadius:7,
                                 border:"1px solid "+C.border}}>
              <div style={{fontSize:17,fontWeight:700,color:C.navy,fontFamily:"Inter,system-ui,sans-serif"}}>{byWriter[w]}</div>
              <div style={{fontSize:9.5,color:C.gray500,letterSpacing:.4,textTransform:"uppercase"}}>{w}</div>
            </div>
          );
        })}
      </div>

      {rows.length===0 ? (
        <div style={{padding:20,textAlign:"center",color:C.gray400,fontSize:12,background:C.gray50,
                     borderRadius:8}}>
          No section on any report carries an age-peer percentile. If this is empty and you expected
          rows, the reports have not loaded yet rather than the record being clean.
        </div>
      ) : (
        <div style={{overflowX:"auto",border:"1px solid "+C.border,borderRadius:8}}>
          <table style={{width:"100%",borderCollapse:"collapse",background:C.white}}>
            <thead><tr style={{background:C.gray50}}>
              <td style={th}>Player</td>
              <td style={th}>Report</td>
              <td style={th}>Status now</td>
              <td style={th}>Field</td>
              <td style={th}>Shown to the reader</td>
              <td style={th}>Written by</td>
              <td style={th}>Live from</td>
              <td style={th}>Until</td>
              <td style={th}>Customer link today</td>
            </tr></thead>
            <tbody>
              {rows.map(function(x, i){
                return (
                  <tr key={i}>
                    <td style={td}>
                      {x.playerObj && go
                        ? <span onClick={function(){ go("profile", x.playerObj); }}
                                style={{color:C.blue,cursor:"pointer",fontWeight:600}}>{x.player}</span>
                        : <span style={{fontWeight:600}}>{x.player}</span>}
                    </td>
                    <td style={Object.assign({},td,{fontFamily:"ui-monospace,Consolas,monospace",fontSize:10.5})}>{x.reportId}</td>
                    <td style={td}>{x.statusNow}</td>
                    <td style={td}>{cleanToolLabel(x.field)}</td>
                    <td style={td}>
                      <span style={{fontWeight:700,color:C.navy}}>{x.shown}</span>
                      {x.bracket ? <span style={{color:C.gray500}}>{" · "+x.bracket}</span> : null}
                      {x.value ? <div style={{fontSize:10,color:C.gray500,marginTop:1}}>beside {x.value}</div> : null}
                    </td>
                    <td style={td}>{x.writer}</td>
                    <td style={Object.assign({},td,{whiteSpace:"nowrap"})}>{x.from||"—"}</td>
                    <td style={Object.assign({},td,{whiteSpace:"nowrap"})}>{x.until}</td>
                    <td style={td}>
                      {x.reachable===null
                        ? <span style={{color:C.gray400}}>unknown</span>
                        : x.reachable
                          ? <span style={{color:C.coral,fontWeight:700}}>yes</span>
                          : <span style={{color:C.gray500}}>no</span>}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}

      <div style={{fontSize:11,color:C.gray500,marginTop:10,lineHeight:1.6,maxWidth:760}}>
        "Customer link today" asks the public view itself — <code>bbot_reports_public</code> — rather
        than reading the status word: a row is reachable if that view holds it. A report that is not
        reachable now was still reachable while it was live.
      </div>
    </div>
  );
}

function AuditLogView({users, scoutReports, go}){
  var [logs, setLogs] = useState([]);
  var [loading, setLoading] = useState(true);
  var [filter, setFilter] = useState("");

  useEffect(function(){
    bbotAdminLogRead({limit:"200"}).then(function(rows){
      setLogs(rows||[]);
      setLoading(false);
    }).catch(function(){setLoading(false);});
  }, []);

  var staffById = function(id){return (users||[]).find(function(u){return String(u.id)===String(id);});};

  // Resolve a target_id to a readable label + a click destination (player profile or report).
  var resolveTarget = function(l){
    var tid = l.target_id;
    if(tid==null||tid==="") return {label:"—", onClick:null};
    // Is it a user?
    var u=(users||[]).find(function(x){return String(x.id)===String(tid);});
    if(u) return {label:(u.firstName+" "+u.lastName)+(u.type?(" ("+u.type+")"):""), onClick:(go?function(){go("profile",u);}:null)};
    // Is it a report?
    var rep=(scoutReports||[]).find(function(x){return String(x.id)===String(tid);});
    if(rep){
      var pl=(users||[]).find(function(x){return String(x.id)===String(rep.playerId);});
      return {label:"Report · "+(pl?(pl.firstName+" "+pl.lastName):("player "+rep.playerId)), onClick:(go&&pl?function(){go("profile",pl);}:null)};
    }
    return {label:String(tid), onClick:null};
  };

  // Turn metadata object into a short readable phrase instead of raw JSON.
  var humanizeMeta = function(m){
    if(!m||typeof m!=="object") return "";
    var keys=Object.keys(m); if(!keys.length) return "";
    return keys.slice(0,4).map(function(k){
      var v=m[k]; if(v&&typeof v==="object") v=JSON.stringify(v);
      return k.replace(/_/g," ")+": "+v;
    }).join(" · ");
  };

  var filtered = filter ? logs.filter(function(l){
    var q = filter.toLowerCase();
    return (l.action||"").toLowerCase().indexOf(q)>=0
        || (l.target_id||"").toString().toLowerCase().indexOf(q)>=0
        || (JSON.stringify(l.metadata||{})).toLowerCase().indexOf(q)>=0;
  }) : logs;

  function relTime(iso){
    if(!iso) return "";
    try{
      var d = new Date(iso); if(isNaN(d.getTime())) return "";
      var now = new Date();
      var s = Math.floor((now-d)/1000);
      if(s<5) return "just now";
      if(s<60) return s+"s ago";
      if(s<3600) return Math.floor(s/60)+"m ago";
      if(s<86400) return Math.floor(s/3600)+"h ago";
      return Math.floor(s/86400)+"d ago";
    }catch(e){return "";}
  }

  function colorForAction(action){
    if(!action) return C.gray400;
    if(action.indexOf("approve")>=0) return C.green;
    if(action.indexOf("reject")>=0 || action.indexOf("delete")>=0) return C.red;
    if(action.indexOf("override")>=0 || action.indexOf("reassign")>=0) return C.orange;
    return C.blue;
  }

  return (
    <div>
      <SectionHeader>Audit Log</SectionHeader>
      <div style={{fontSize:12,color:C.gray500,marginBottom:14}}>Accountability trail of admin actions — approvals, rejections, deletes, overrides. Tap a name to open that profile. Last 200 entries.</div>
      <input value={filter} onChange={function(e){setFilter(e.target.value);}} placeholder="Filter by action or target ID..." style={{marginBottom:14}}/>
      {loading ? (
        <div><SkeletonCard/><SkeletonCard/><SkeletonCard/></div>
      ) : filtered.length===0 ? (
        <EmptyCard icon="A" title="No Audit Entries" sub="Admin actions will be logged here as they happen."/>
      ) : (
        <div style={{display:"flex",flexDirection:"column",gap:4}}>
          {filtered.map(function(l,i){
            var staff = staffById(l.admin_id);
            var ac = colorForAction(l.action);
            var tgt = resolveTarget(l);
            var meta = humanizeMeta(l.metadata);
            return (
              <div key={l.id||i} style={{padding:"10px 14px",background:C.white,borderRadius:8,border:"1px solid "+C.border,borderLeft:"3px solid "+ac}}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",gap:10,flexWrap:"wrap"}}>
                  <div style={{flex:1,minWidth:160}}>
                    <div style={{fontSize:12,fontWeight:700,color:C.navy}}>{(l.action||"unknown").replace(/_/g," ").toUpperCase()}</div>
                    <div style={{fontSize:11,color:C.gray500,marginTop:3}}>
                      {tgt.onClick
                        ? <span onClick={tgt.onClick} style={{color:C.blue,fontWeight:600,cursor:"pointer",textDecoration:"underline"}}>{tgt.label}</span>
                        : <span style={{color:C.gray700,fontWeight:600}}>{tgt.label}</span>}
                      {staff && <span> · by {staff.firstName} {staff.lastName}</span>}
                    </div>
                    {meta && (
                      <div style={{fontSize:10,color:C.gray500,marginTop:4}}>{meta}</div>
                    )}
                  </div>
                  <div style={{fontSize:10,color:C.gray400,letterSpacing:.3,whiteSpace:"nowrap"}}>{relTime(l.timestamp)}</div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

function FailedEvalsView({scoutReports, setScoutReports, users, notify}){
  // Errored reports stay in this queue UNTIL they're refunded. Refund flips status
  // to 'refunded', which automatically drops the row from this filter — no extra
  // archive logic needed.
  var failed = (scoutReports||[]).filter(function(r){return isJobFailed(r);});
  var pId = function(id){return (users||[]).find(function(u){return String(u.id)===String(id);});};
  function retryEval(r){
    // Shared core (warm pose + rich prompt + unified payload; writes back into the SAME row via targetReportId
    // so a retry never duplicates). Looks up the player for the rich context, same as the report-view Retry.
    var player=(users||[]).find(function(u){return String(u.id)===String(r.playerId);})||{};
    retryEvalCore(r, player).then(function(resp){
      if(resp && resp.ok) notify("Retry triggered for "+(pId(r.playerId)?pId(r.playerId).firstName:"player"));
      else notify("Retry failed: HTTP "+(resp&&resp.status),"error");
    }).catch(function(err){ notify("Retry error: "+((err&&err.message)||"unknown"),"error"); });
  }
  function refundEval(r){
    if(!window.confirm("Refund this faulty evaluation?\\n\\nThis issues a payment refund to the buyer. Only do this for evals that failed on our end.")) return;
    fetch(BACKEND_URL+"/refund-eval", {
      method:"POST", headers:bbotAdminHeaders(),
      body: JSON.stringify({reportId: r.id})
    }).then(function(resp){
      if(resp.ok){
        notify("Refund issued");
        // Sync local state — backend sets status='refunded'; mirror that here so the
        // errored-reports queue auto-archives this row immediately (no reload needed).
        if(setScoutReports){
          setScoutReports(function(prev){
            return (prev||[]).map(function(x){ return String(x.id)===String(r.id) ? Object.assign({}, x, {status:"refunded"}) : x; });
          });
        }
      }
      else { resp.json().then(function(d){ notify(errText(d.detail,"Refund failed: HTTP "+resp.status),"error"); }).catch(function(){ notify("Refund failed: HTTP "+resp.status,"error"); }); }
    }).catch(function(err){ notify("Refund error: "+(err.message||"unknown"),"error"); });
  }
  function deleteEval(r){
    if(!window.confirm("Delete this failed eval permanently?")) return;
    reportDelete([r.id])
      .then(function(){
        if(setScoutReports) setScoutReports(function(prev){ return (prev||[]).filter(function(x){ return String(x.id)!==String(r.id); }); });
        notify("Deleted");
      })
      .catch(function(){ notify("Delete request failed","error"); });
  }
  return (
    <div>
      <SectionHeader>Failed Evaluations</SectionHeader>
      <div style={{fontSize:12,color:C.gray500,marginBottom:14}}>Evals that errored during processing. Retry or delete.</div>
      {failed.length===0 ? (
        <EmptyCard icon="✓" title="No Failed Evals" sub="When BBOT eval errors out, the reports land here for retry."/>
      ) : (
        <div style={{display:"flex",flexDirection:"column",gap:10}}>
          {failed.map(function(r){
            var p = pId(r.playerId);
            return (
              <Card key={r.id} style={{padding:14}}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",gap:10,flexWrap:"wrap"}}>
                  <div style={{flex:1,minWidth:160}}>
                    <div style={{fontWeight:700,color:C.navy,fontSize:14}}>{p?(p.firstName+" "+p.lastName):"Unknown Player"}</div>
                    <div style={{fontSize:12,color:C.gray500,marginTop:3}}>{r.sessionType||"Session"} · {r.date||""}</div>
                    {r.errorMessage && <div style={{fontSize:11,color:C.red,marginTop:6,padding:"4px 8px",background:C.redLight,borderRadius:4}}>Error: {r.errorMessage}</div>}
                  </div>
                  <div style={{display:"flex",gap:6}}>
                    <Btn v="primary" style={{fontSize:11,padding:"6px 12px"}} onClick={function(){retryEval(r);}}>↻ Retry</Btn>
                    <Btn v="ghost" style={{fontSize:11,padding:"6px 12px",color:C.orange,border:"1px solid "+C.orangeLight}} onClick={function(){refundEval(r);}}>Refund</Btn>
                    <Btn v="ghost" style={{fontSize:11,padding:"6px 12px",color:C.red,border:"1px solid "+C.redLight}} onClick={function(){deleteEval(r);}}>Delete</Btn>
                  </div>
                </div>
              </Card>
            );
          })}
        </div>
      )}
    </div>
  );
}

// The rows have no border of their own now, so hover is what says they are clickable.
if(typeof document!=="undefined" && !document.getElementById("bbot-feedrow-css")){
  var _fs=document.createElement("style"); _fs.id="bbot-feedrow-css";
  _fs.textContent=".bbot-feedrow:hover{background:#f8fafc}";
  document.head.appendChild(_fs);
}
// -- THE SEAM DOT ------------------------------------------------------------------------------
// A like is one press of one mark: BBOT blue when it has not been pressed, coral when it has. No
// count badge shouting, no heart from somebody else's product, no second state to learn. The seam
// is the mark this product already uses for "a thing that ismeasured" everywhere else on a card.
// EVERY ACTIVITY ENTRY CAN BE LIKED, not only the ones an admin typed. The wall is mostly
// evaluations, clips, skeletons and signups; a seam dot on one kind of row and not the others reads
// as broken rather than as a rule, and there was no rule.
//
// ONE STORE, KEYED BY THE ITEM. Feed entries already carry stable ids (ev-, cl-, sk-, pr-, po-), so
// likes live in one place keyed by that id and need no foreign key into whichever table produced
// the entry. Posts moved here too -- two like mechanisms would be two sources of truth for one
// number. Counts for a whole page come back in ONE request; thirty round trips would make the like
// state the slowest thing on the screen.
function useActivityLikes(keys, cu){
  var mS=useState({}); var likes=mS[0]; var setLikes=mS[1];
  var bS=useState(""); var busy=bS[0]; var setBusy=bS[1];
  var joined=(keys||[]).join(",");
  useEffect(function(){
    if(!joined || !cu) return;
    var dead=false;
    fetch(BACKEND_URL+"/activity-likes?keys="+encodeURIComponent(joined),{headers:bbotAdminHeaders()})
      .then(function(r){ return r.ok?r.json():{likes:{}}; })
      .then(function(j){ if(!dead) setLikes(j.likes||{}); })
      .catch(function(){});
    return function(){ dead=true; };
  }, [joined, !!cu]);
  function toggle(key){
    if(!cu) return;
    setBusy(key);
    setLikes(function(m){
      var cur=m[key]||{count:0,liked:false};
      var o=Object.assign({},m); o[key]={count:cur.count+(cur.liked?-1:1), liked:!cur.liked};
      return o;
    });
    fetch(BACKEND_URL+"/activity-like",{method:"POST",headers:bbotAdminHeaders(),
      body:JSON.stringify({itemKey:key})})
      .then(function(r){ return r.ok?r.json():null; })
      .then(function(j){ if(j) setLikes(function(m){ var o=Object.assign({},m);
        o[key]={count:j.count,liked:j.liked}; return o; }); })
      .catch(function(){})
      .then(function(){ setBusy(""); });
  }
  return {likes:likes, busy:busy, toggle:toggle};
}

function SeamDot({liked, count, busy, onPress}){
  return (
    <button type="button" disabled={busy} onClick={onPress} aria-pressed={!!liked}
      title={liked?"Liked — press to undo":"Like"}
      style={{display:"inline-flex",alignItems:"center",gap:7,background:"transparent",border:"none",
              padding:"2px 0",cursor:busy?"wait":"pointer",lineHeight:0}}>
      {/* THE SAME GLYPH THE CARD DRAWS. A plain filled circle was a dot, not a ball -- and the
          product already has one seam mark, rendered by `seam()` in the card renderer at exactly
          this geometry. Ported rather than redrawn, so the like on the wall and the marks on a
          scout card are the same object in two places instead of two things that resemble each
          other. Colour is the only state: BBOT blue until pressed, coral after. */}
      <svg width="17" height="17" viewBox="0 0 24 24" style={{display:"block",overflow:"visible",
             transition:"transform .12s ease", transform:liked?"scale(1.06)":"none"}}>
        <circle cx="12" cy="12" r="11" fill={liked?C.coral:C.blue} stroke="#fff" strokeWidth="1.3"/>
        <path d="M6.5 3.8 C9 7,9 17,6.5 20.2" fill="none" stroke="#fff" strokeWidth="1.9" strokeLinecap="round"/>
        <path d="M17.5 3.8 C15 7,15 17,17.5 20.2" fill="none" stroke="#fff" strokeWidth="1.9" strokeLinecap="round"/>
      </svg>
      {count>0 && <span style={{fontSize:11,fontWeight:700,color:liked?C.coral:C.gray500,lineHeight:1}}>{count}</span>}
    </button>
  );
}

// -- ADMIN POSTS ON THE ACTIVITY FEED ------------------------------------------------------------
// Admin writes; everyone reads and can press the seam dot. THERE ARE NO COMMENTS -- not a hidden
// control, not a disabled button: there is no field to write one into and no endpoint that accepts
// one, so the absence is structural rather than a UI decision somebody could reverse by accident.
function ActivityPosts({cu, notify, isAdmin}){
  var pS=useState([]);      var posts=pS[0];   var setPosts=pS[1];
  var rS=useState(true);    var ready=rS[0];   var setReady=rS[1];
  var oS=useState(false);   var open=oS[0];    var setOpen=oS[1];
  var bS=useState("");      var body=bS[0];    var setBody=bS[1];
  var iS=useState("");      var img=iS[0];     var setImg=iS[1];
  var vS=useState("");      var vid=vS[0];     var setVid=vS[1];
  var busyS=useState("");   var busy=busyS[0]; var setBusy=busyS[1];
  var pS2=useState(0);      var vidPct=pS2[0]; var setVidPct=pS2[1];
  var wS=useState("");      var why=wS[0];     var setWhy=wS[1];
  var me=String((cu&&cu.email)||"").trim().toLowerCase();
  var _pl=useActivityLikes(posts.map(function(p){ return "po-"+p.id; }), cu);

  function load(){
    // WHY IT IS NOT SHOWING IS ITSELF INFORMATION. This collapsed a 401, a 503 and a network
    // fault into ready=false, and ready=false rendered NOTHING -- so an admin whose session had
    // expired saw no composer, no posts and no reason, which is indistinguishable from the
    // feature not having shipped. The reason is kept and shown to an admin.
    fetch(BACKEND_URL+"/activity-posts?limit=50",{headers:bbotAdminHeaders()})
      .then(function(r){
        if(r.status===401) return {ready:false,posts:[],why:"you are not signed in — sign out and back in"};
        if(!r.ok) return {ready:false,posts:[],why:"the server answered HTTP "+r.status};
        return r.json();
      })
      .then(function(j){
        setReady(j.ready!==false);
        setPosts(j.posts||[]);
        setWhy(j.why || (j.ready===false ? "the bbot_activity_posts table does not exist yet" : ""));
      })
      .catch(function(){ setReady(false); setWhy("could not reach the backend"); });
  }
  useEffect(function(){ load(); }, []);

  // A VIDEO FILE GOES TO STORAGE, NOT INTO THE ROW. An inline data URL is fine for a picture and
  // absurd for video: presign, PUT straight to R2 so the bytes never cross the backend, then ask
  // for the playable link. The row stores that link and nothing else.
  function pickVideo(){
    var i=document.createElement("input");
    i.type="file"; i.accept="video/mp4,video/quicktime,video/webm,.mp4,.mov,.m4v,.webm";
    i.onchange=function(e){
      var f=e.target.files&&e.target.files[0]; if(!f) return;
      if(f.size > 300*1024*1024){ notify("Video too large for a post (max 300MB)","error"); return; }
      setBusy("vid"); setVidPct(0);
      fetch(BACKEND_URL+"/create-upload-url",{method:"POST",headers:bbotAdminHeaders(),
        body:JSON.stringify({fileName:f.name, fileSize:f.size, contentType:f.type||"video/mp4", purpose:"post"})})
        .then(function(r){ return r.json().then(function(j){ if(!r.ok) throw new Error(j.detail||("HTTP "+r.status)); return j; }); })
        .then(function(meta){
          return new Promise(function(res, rej){
            var xhr=new XMLHttpRequest();
            xhr.open("PUT", meta.uploadUrl, true);
            xhr.setRequestHeader("Content-Type", f.type||"video/mp4");
            xhr.upload.onprogress=function(ev){ if(ev.lengthComputable) setVidPct(Math.round(ev.loaded/ev.total*100)); };
            xhr.onload=function(){ (xhr.status>=200&&xhr.status<300)?res(meta.objectKey):rej(new Error("upload HTTP "+xhr.status)); };
            xhr.onerror=function(){ rej(new Error("upload network error")); };
            xhr.send(f);
          });
        })
        .then(function(key){
          return fetch(BACKEND_URL+"/media-link?key="+encodeURIComponent(key),{headers:bbotAdminHeaders()})
            .then(function(r){ if(!r.ok) throw new Error("could not mint the playback link"); return r.json(); });
        })
        .then(function(j){ setBusy(""); setVidPct(0); setVid(BACKEND_URL + j.url); notify("Video attached"); })
        .catch(function(err){ setBusy(""); setVidPct(0); notify(err&&err.message?("Video upload failed — "+err.message):"Video upload failed","error"); });
    };
    i.click();
  }

  function submit(){
    if(!body.trim() && !img && !vid.trim()){ notify("Add some text, a picture or a video link","error"); return; }
    setBusy("post");
    fetch(BACKEND_URL+"/activity-post",{method:"POST",headers:bbotAdminHeaders(),
      body:JSON.stringify({body:body, imageUrl:img, videoUrl:vid.trim()})})
      .then(function(r){ return r.json().then(function(j){ if(!r.ok) throw new Error(j.detail||"HTTP "+r.status); return j; }); })
      .then(function(){ setBody(""); setImg(""); setVid(""); setOpen(false); notify("Posted","success"); load(); })
      .catch(function(e){ notify(e.message||"Could not post","error"); })
      .then(function(){ setBusy(""); });
  }

  // THE POST LIKE LIVES IN THE SHARED STORE, and this is where a second one used to live.
  // `like(p)` wrote `liked_by` on the post row via /activity-post-like while the seam dot beside it
  // already pressed _pl.toggle("po-"+id) into bbot_activity_likes -- two stores for one number, on
  // one row. It was dead code by the time it was noticed, but a dead writer of a live column is
  // exactly how the two drift back apart. The two likes that were in the column are migrated.

  function remove(p){
    if(!window.confirm("Delete this post?")) return;
    fetch(BACKEND_URL+"/activity-post?postId="+encodeURIComponent(String(p.id)),
      {method:"DELETE",headers:bbotAdminHeaders()})
      .then(function(r){ if(!r.ok) throw new Error("HTTP "+r.status); notify("Post deleted"); load(); })
      .catch(function(){ notify("Could not delete the post","error"); });
  }

  // A YouTube or Vimeo link becomes a player; anything else stays a link rather than being forced
  // into an iframe that may refuse to frame.
  function isOurMedia(url){ return !!url && String(url).indexOf(BACKEND_URL+"/media?key=")===0; }

  function embedFor(url){
    var m=/(?:youtube\.com\/watch\?v=|youtu\.be\/)([\w-]{6,})/.exec(url||"");
    if(m) return "https://www.youtube.com/embed/"+m[1];
    var v=/vimeo\.com\/(\d+)/.exec(url||"");
    if(v) return "https://player.vimeo.com/video/"+v[1];
    return null;
  }

  // AN ADMIN IS TOLD; A PLAYER IS NOT. A reader has nothing to do with a missing table or an
  // expired admin session, so for them the section stays absent and quiet. For the person who can
  // fix it, silence is the worst possible answer.
  if(!ready) return isAdmin ? (
    <Card style={{padding:"10px 12px",marginBottom:10,fontSize:12,color:C.gray500}}>
      Activity posts are unavailable{why?(" — "+why):""}.
    </Card>
  ) : null;

  return (
    <div style={{marginBottom:12}}>
      {isAdmin && (open ? (
        <Card style={{padding:12,marginBottom:10}}>
          <textarea value={body} onChange={function(e){setBody(e.target.value);}} rows={3}
            placeholder="Say something to the roster…"
            style={{width:"100%",padding:"9px 11px",border:"1px solid "+C.border,borderRadius:8,
                    fontSize:13,fontFamily:"inherit",boxSizing:"border-box",resize:"vertical"}}/>
          {img && <div style={{marginTop:9,display:"flex",gap:9,alignItems:"flex-start"}}>
            <img src={img} alt="" style={{width:120,height:80,objectFit:"cover",borderRadius:7,border:"1px solid "+C.border}}/>
            <Btn v="ghost" onClick={function(){setImg("");}}>Remove picture</Btn>
          </div>}
          {isOurMedia(vid) && (
            <div style={{marginTop:9,display:"flex",gap:9,alignItems:"center"}}>
              <video {...bbotVideoGuard()} src={vid} controls preload="metadata" style={{width:200,borderRadius:7,background:"#000"}}/>
              <Btn v="ghost" onClick={function(){setVid("");}}>Remove video</Btn>
            </div>
          )}
          {!isOurMedia(vid) && <input value={vid} onChange={function(e){setVid(e.target.value);}}
            placeholder="Video link (YouTube, Vimeo, or any URL) — optional"
            style={{width:"100%",padding:"8px 11px",marginTop:9,border:"1px solid "+C.border,
                    borderRadius:8,fontSize:12.5,boxSizing:"border-box"}}/>}
          <div style={{display:"flex",gap:9,marginTop:11,flexWrap:"wrap"}}>
            {!img && <button type="button" disabled={busy==="img"} onClick={function(){
              var i=document.createElement("input"); i.type="file"; i.accept="image/*";
              i.onchange=function(e){
                var f=e.target.files&&e.target.files[0]; if(!f) return;
                setBusy("img");
                bbotDownscaleImage(f,1400).then(function(u){ setBusy(""); setImg(u); })
                  .catch(function(err){ setBusy(""); notify(err&&err.message?("Could not add that picture — "+err.message):"Could not add that picture","error"); });
              };
              i.click();
            }} style={{padding:"7px 13px",background:C.white,border:"1px dashed "+C.border,borderRadius:8,fontSize:12,fontWeight:600,color:C.gray600,cursor:"pointer"}}>
              {busy==="img"?"Resizing…":"+ Picture"}</button>}
            <button type="button" disabled={busy==="vid"} onClick={pickVideo}
              style={{padding:"7px 13px",background:C.white,border:"1px dashed "+C.border,borderRadius:8,fontSize:12,fontWeight:600,color:C.gray600,cursor:busy==="vid"?"wait":"pointer"}}>
              {busy==="vid"?("Uploading "+vidPct+"%"):"+ Video"}</button>
            <Btn v="primary" disabled={busy==="post"||busy==="vid"} onClick={submit}>{busy==="post"?"Posting…":"Post"}</Btn>
            <Btn v="ghost" onClick={function(){setOpen(false);}}>Cancel</Btn>
          </div>
        </Card>
      ) : (
        <button type="button" onClick={function(){setOpen(true);}}
          style={{width:"100%",padding:"9px 12px",marginBottom:10,background:C.white,
                  border:"1px dashed "+C.border,borderRadius:9,fontSize:12.5,color:C.gray500,
                  textAlign:"left",cursor:"pointer"}}>Post to the activity feed…</button>
      ))}

      {posts.map(function(p){
        // ONE SOURCE FOR THE COUNT. This used to fall back to the post row's own `liked_by` until
        // the store loaded, which meant the dot could show a number the store did not agree with.
        var _k="po-"+p.id, _st=_pl.likes[_k];
        var liked=!!(_st&&_st.liked);
        var emb=embedFor(p.video_url);
        return (
          <Card key={p.id} style={{padding:12,marginBottom:8}}>
            {p.body && <div style={{fontSize:13,color:C.navy,lineHeight:1.5,whiteSpace:"pre-wrap"}}>{p.body}</div>}
            {p.image_url && <div style={{maxWidth:300,marginTop:9}}>
              <img src={p.image_url} alt="" style={{width:"100%",maxHeight:220,objectFit:"cover",
                    borderRadius:8,display:"block"}}/></div>}
            {/* 56.25% IS RELATIVE TO THIS BOX'S OWN WIDTH, not the page. Once the box is capped at
                300px that ratio already yields 300x169 -- a correct 16:9. I briefly changed it to
                31.6% as if the percentage were of the page, which would have squashed every
                embedded video to two-thirds height. */}
            {emb && <div style={{position:"relative",paddingTop:"56.25%",maxWidth:300,marginTop:9}}>
              <iframe title={"v"+p.id} src={emb} frameBorder="0" allowFullScreen
                style={{position:"absolute",inset:0,width:"100%",height:"100%",borderRadius:8}}/>
            </div>}
            {/* A FILE WE STORED PLAYS IN A REAL PLAYER. The /media route redirects to a presigned
                GET, so the browser range-requests R2 directly and scrubbing works. Anything else
                stays a link rather than being forced into a frame that may refuse to load. */}
            {/* THE SAME BOX THE WALL GIVES A CLIP. Full width at 360px tall made an uploaded
                video the largest thing on the page by a distance -- larger than the evaluation
                cards beside it. Bounded to 300px like every other clip on this surface, so a post
                with a video and a clip in the feed are the same object at the same size. */}
            {!emb && isOurMedia(p.video_url) && (
              <div style={{maxWidth:300,marginTop:9}}>
                <video {...bbotVideoGuard()} controls preload="metadata" src={p.video_url}
                  style={{width:"100%",maxHeight:220,objectFit:"contain",borderRadius:8,
                          display:"block",background:"#0f172a"}}/>
              </div>
            )}
            {p.video_url && !emb && !isOurMedia(p.video_url) && <a href={p.video_url} target="_blank" rel="noreferrer"
              style={{display:"inline-block",marginTop:9,fontSize:12.5,color:C.blue,fontWeight:600}}>{p.video_url}</a>}
            <div style={{display:"flex",alignItems:"center",gap:12,marginTop:10}}>
              <SeamDot liked={liked} count={_st?_st.count:0}
                busy={_pl.busy===_k}
                onPress={function(){ _pl.toggle(_k); }}/>
              <span style={{flex:1}}/>
              <span style={{fontSize:10,color:C.gray400}}>{String(p.created_at||"").slice(0,10)}</span>
              {isAdmin && <button type="button" onClick={function(){remove(p);}}
                style={{background:"transparent",border:"none",color:C.gray400,fontSize:11,cursor:"pointer",padding:0}}>Delete</button>}
            </div>
          </Card>
        );
      })}
    </div>
  );
}

function ActivityFeed({users, scoutReports, go, setAdminTab}){
  var [items, setItems] = useState([]);
  var [loading, setLoading] = useState(true);

  useEffect(function(){
    var collected = [];

    // 1. Recent BBOT evaluations
    (scoutReports||[]).slice().reverse().slice(0,15).forEach(function(r){
      var player = (users||[]).find(function(u){return String(u.id)===String(r.playerId);});
      collected.push({
        type: "eval",
        when: r.date || r.created_at || new Date().toISOString(),
        title: (player?(player.firstName+" "+player.lastName):"Player")+" — "+(r.sessionType||"Evaluation"),
        sub: "BBOT evaluation "+(isLiveEval(r)?"released":"in review"),
        action: function(){go("profile-"+r.playerId);},
        color: C.coral,
      });
    });

    // 2. Recent player signups
    (users||[]).filter(function(u){return u.type==="player";}).slice(-10).reverse().forEach(function(u){
      collected.push({
        type: "signup",
        when: u.created_at || u.createdAt || null,
        title: u.firstName+" "+u.lastName+" joined",
        sub: (u.position||"Player")+(u.gradYear?" · Class "+u.gradYear:""),
        action: function(){go("profile-"+u.id);},
        color: C.blue,
      });
    });

    // Coach submissions now flow through the universal payment-first pipeline:
    // they become awaiting_payment reports, and once paid they appear in the
    // standard pending-approval review queue — no separate submission queue.
    collected.sort(function(a,b){return new Date(b.when)-new Date(a.when);});
    setItems(collected.slice(0,30));
    setLoading(false);
  }, []);

  function relTime(iso){
    if(!iso) return "";
    try{
      var d = new Date(iso); if(isNaN(d.getTime())) return "";
      var now = new Date();
      var s = Math.floor((now-d)/1000);
      if(s<5) return "just now";
      if(s<60) return s+"s ago";
      if(s<3600) return Math.floor(s/60)+"m ago";
      if(s<86400) return Math.floor(s/3600)+"h ago";
      return Math.floor(s/86400)+"d ago";
    }catch(e){return "";}
  }

  return (
    <div>
      <SectionHeader>Recent Activity</SectionHeader>

      {/* RE-REVIEW REQUESTS — evals flagged by players/coaches for a second look */}
      {(function(){
        var flagged = (scoutReports||[]).filter(function(r){return r.reviewRequested;});
        if(flagged.length===0) return null;
        return (
          <Card style={{padding:"10px 12px",marginBottom:10,borderLeft:"3px solid "+C.orange,background:C.orangeLight}}>
            <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:10,color:"#854d0e",letterSpacing:1.1,marginBottom:7,fontWeight:700}}>RE-REVIEW REQUESTS ({flagged.length})</div>
            <div style={{display:"flex",flexDirection:"column",gap:4}}>
              {flagged.map(function(r){
                var p = (users||[]).find(function(u){return String(u.id)===String(r.playerId);});
                return (
                  <div key={r.id} onClick={function(){go("profile-"+r.playerId);}} style={{padding:"8px 10px",background:C.white,borderRadius:6,cursor:"pointer"}}>
                    <div style={{fontSize:12,fontWeight:600,color:C.navy}}>{p?(p.firstName+" "+p.lastName):"Player"} · {r.sessionType||"Eval"} · {r.date||""}</div>
                    {r.reviewReason && <div style={{fontSize:11,color:C.gray600,marginTop:3,fontStyle:"italic"}}>"{r.reviewReason}"</div>}
                  </div>
                );
              })}
            </div>
          </Card>
        );
      })()}

      {/* TOP MOVERS — players with biggest score gains across consecutive evals */}
      {(function(){
              // RULED OFF (Luis, 2026-09-13). Ranks players against each other on score gains
              // across consecutive evals, drawn from every report in the system -- nine approved.
              // A cross-player ranking implies a population BBOT does not have, and "biggest
              // gains" adds a trend claim on top of it. Restore with a cohort.
              return null;

        var byPlayer = {};
        (scoutReports||[]).filter(function(r){return isLiveEval(r) && r.score!=null;}).forEach(function(r){
          var k = String(r.playerId);
          if(!byPlayer[k]) byPlayer[k] = [];
          byPlayer[k].push(r);
        });
        var movers = [];
        Object.keys(byPlayer).forEach(function(pid){
          var rs = byPlayer[pid].sort(function(a,b){return (a.date||"").localeCompare(b.date||"");});
          if(rs.length < 2) return;
          var first = rs[0].score, last = rs[rs.length-1].score;
          var delta = last - first;
          if(delta <= 0) return;
          var player = (users||[]).find(function(u){return String(u.id)===pid;});
          if(!player) return;
          movers.push({player:player, delta:delta, first:first, last:last});
        });
        movers.sort(function(a,b){return b.delta - a.delta;});
        movers = movers.slice(0,3);
        if(movers.length===0) return null;
        return (
          <Card style={{padding:"10px 12px",marginBottom:10,borderLeft:"3px solid "+C.green}}>
            <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:10,color:C.green,letterSpacing:1.1,marginBottom:7}}>TOP MOVERS <span style={{fontSize:10,color:C.gray400,fontWeight:400,letterSpacing:.3}}>· Biggest gains</span></div>
            <div style={{display:"flex",flexDirection:"column",gap:4}}>
              {movers.map(function(m){return (
                <div key={m.player.id} onClick={function(){go("profile-"+m.player.id);}} style={{display:"flex",alignItems:"center",gap:10,padding:"6px 8px",borderRadius:6,cursor:"pointer",background:C.gray50}}>
                  <Avatar user={m.player} size={28}/>
                  <div style={{flex:1,minWidth:0}}>
                    <div style={{fontSize:12,fontWeight:600,color:C.navy}}>{m.player.firstName} {m.player.lastName}</div>
                    <div style={{fontSize:10,color:C.gray500}}>{m.first} → {m.last}</div>
                  </div>
                  <div style={{fontSize:13,fontWeight:700,color:C.green}}>+{m.delta}</div>
                </div>
              );})}
            </div>
          </Card>
        );
      })()}

      {loading ? (
        <div><SkeletonCard/><SkeletonCard/><SkeletonCard/></div>
      ) : items.length===0 ? (
        <EmptyCard icon="A" title="No Activity Yet" sub="Player signups, submissions, and evaluations will appear here"/>
      ) : (
        /* A LIST, NOT THIRTY CARDS. Every row carried its own 1px border, 10px radius, white fill
           and 8px of gap, so a feed of thirty repeated the same frame thirty times and the border
           weight competed with the content inside it. One container, hairline rows, and the eye
           reads down a column instead of across thirty boxes. Roughly 40% shorter at the same
           number of items, and nothing was removed to get there. */
        <div style={{background:C.white,border:"1px solid "+C.border,borderRadius:10,overflow:"hidden"}}>
          {items.map(function(item,i){return (
            <div key={i} onClick={item.action} className="bbot-feedrow" style={{padding:"7px 11px",cursor:"pointer",display:"flex",alignItems:"center",gap:9,borderTop:i?("1px solid "+C.gray100||"#f1f5f9"):"none"}}>
              <div style={{width:6,height:6,borderRadius:"50%",background:item.color,flexShrink:0}}/>
              {/* TITLE AND DETAIL ON ONE LINE. Two stacked lines cost a row 15px to say a thing and
                  then qualify it; the qualifier is short enough to sit beside it, dimmed. */}
              <div style={{flex:1,minWidth:0,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>
                <span style={{fontSize:12,fontWeight:600,color:C.navy}}>{item.title}</span>
                <span style={{fontSize:11,color:C.gray400,marginLeft:7}}>{item.sub}</span>
              </div>
              <div style={{fontSize:10,color:C.gray400,flexShrink:0,letterSpacing:.3}}>{relTime(item.when)}</div>
            </div>
          );})}
        </div>
      )}
    </div>
  );
}

// SIMPLE run/pop time queue — the ONLY way admin adds a time (no stopwatch). Lists evaluations whose run
// is still just an observation; admin picks H2F / 60 / Pop, types the seconds, hits Add → BBOT grades it,
// graphs it on the report, feeds the leaderboard, and stamps the clip. Omit it and it stays an observation.
function RunTimeQueue({reports, users, notify}){
  var doneS=useState({}); var done=doneS[0], setDone=doneS[1];
  var savedS=useState({}); var saved=savedS[0], setSaved=savedS[1];   // {reportId:{h2f,dash60,popTime}} added this session
  var draftS=useState({}); var draft=draftS[0], setDraft=draftS[1];
  function playerFor(rep){ return (users||[]).find(function(u){return String(u.id)===String(rep.playerId||rep.player_id);})||null; }
  // The activities a report STILL needs — a catcher needs BOTH pop and a run (H2F or 60); a runner needs a
  // run. Considers both saved values (measuredValues) and what was just added this session, so a multi-need
  // player (Jeniel: Pop + H2F) keeps its row until BOTH are entered.
  function remainingActs(rep, pl){
    var pos=String((pl&&pl.position)||"").trim().toUpperCase();
    var isC=pos==="C"||pos==="CATCHER";
    var fr=(rep.fullReport||rep.full_report)||rep||{};
    var mv=(rep.measuredValues)||fr.measuredValues||{};
    var sv=saved[rep.id]||{};
    var runDone=(mv.h2f!=null&&mv.h2f!=="")||(mv.dash60!=null&&mv.dash60!=="")||sv.h2f||sv.dash60;
    var popDone=(mv.popTime!=null&&mv.popTime!=="")||sv.popTime;
    var acts=[];
    if(isC && !popDone) acts.push(["popTime","Top Pop"]);
    if(!runDone) acts.push(["h2f","H2F"],["dash60","60"]);
    return acts;
  }
  function eligible(rep){
    if(!rep||done[rep.id]) return false;
    var st=(rep.status||"").toLowerCase();
    if(st!=="approved"&&st!=="draft"&&st!=="published") return false;
    var fr=(rep.fullReport||rep.full_report)||rep||{};
    if(fr.runTimeOptedOut) return false;
    var pl=playerFor(rep); if(!pl) return false;
    var pos=String((pl.position)||"").trim().toUpperCase();
    var isPitcher=/^(P|RHP|LHP|SP|RP|CP)$/.test(pos.split(/[\s,\/]/)[0])||rep.isPitcher;
    if(isPitcher) return false;
    return remainingActs(rep,pl).length>0;
  }
  var queue=(reports||[]).filter(eligible);
  function saveRow(rep,pl){
    var acts=remainingActs(rep,pl);
    var d=draft[rep.id]||{}; var field=d.field||(acts[0]&&acts[0][0]); var val=d.val;
    if(!field) return;
    if(val==null||val===""||isNaN(Number(val))){ notify&&notify("Enter a time first","error"); return; }
    saveMeasuredTime(rep, pl, field, Number(val), gradeForField(field, Number(val), pl.bats, _timeAgeGroup(pl, rep)));
    setSaved(function(p){ var c=Object.assign({},p); var s=Object.assign({},c[rep.id]); s[field]=true; c[rep.id]=s; return c; });
    setDraft(function(p){ var c=Object.assign({},p); c[rep.id]={val:"", field:undefined}; return c; });  // reset -> re-offers the remaining need (e.g. Pop after H2F)
  }
  // OPTIONALITY — dismiss a row without a value; persists runTimeOptedOut so it never nags again.
  function skipRow(rep){
    var base=rep.fullReport||rep.full_report; var fr=base?JSON.parse(JSON.stringify(base)):{};
    fr.runTimeOptedOut=true;
    reportPatch(rep.id,{full_report:fr}).catch(function(){});
    setDone(function(p){ var c=Object.assign({},p); c[rep.id]=true; return c; });
  }
  return (
    <Card style={{marginBottom:14}}>
      <div style={{fontSize:11,fontWeight:700,color:C.navy,letterSpacing:.5,textTransform:"uppercase",marginBottom:4}}>Run / Pop times to add {queue.length>0&&<span style={{color:C.coral}}>({queue.length})</span>}</div>
      <div style={{fontSize:11,color:C.gray500,marginBottom:10,lineHeight:1.5}}>Run is a scouting observation until you add a time. Pick H2F / 60 (or Pop for catchers), type the seconds, hit Add — BBOT grades it, graphs it, feeds the leaderboard, stamps the clip. Skip it and it stays an observation.</div>
      {!queue.length ? <div style={{fontSize:11,color:C.gray400,fontStyle:"italic"}}>Nothing pending — every runner/catcher report has a time or is left as an observation.</div> :
      <div style={{maxHeight:300,overflowY:"auto"}}>
        {queue.map(function(rep){
          var pl=playerFor(rep); var acts=remainingActs(rep,pl); var d=draft[rep.id]||{}; var field=d.field||(acts[0]&&acts[0][0]);
          var nm=((pl.firstName||pl.first_name||"")+" "+(pl.lastName||pl.last_name||"")).trim()||rep.playerName||"player";
          return <div key={rep.id} style={{display:"flex",alignItems:"center",gap:8,padding:"7px 0",borderBottom:"1px solid "+C.gray100,flexWrap:"wrap"}}>
            <div style={{flex:"1 1 150px",minWidth:0}}>
              <div style={{fontSize:12,color:C.navy,fontWeight:600,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{nm} <span style={{fontSize:10,color:C.gray400,fontWeight:500}}>· {pl.position||""}</span></div>
              <div style={{fontSize:10,color:C.gray400}}>{(rep.sessionType||rep.session_type||"")+" · "+(""+(rep.sessionDate||rep.session_date||rep.created_at||"")).slice(0,10)}</div>
            </div>
            <select value={field} onChange={function(e){var v=e.target.value; setDraft(function(p){var c=Object.assign({},p); c[rep.id]=Object.assign({},c[rep.id],{field:v}); return c;});}} style={{padding:"5px 6px",border:"1px solid "+C.border,borderRadius:6,fontSize:12,fontWeight:600,color:C.navy}}>
              {acts.map(function(a){return <option key={a[0]} value={a[0]}>{a[1]}</option>;})}
            </select>
            <input type="number" step="0.01" placeholder="sec" value={d.val==null?"":d.val}
              onKeyDown={function(e){ if(e.key==="Enter") saveRow(rep,pl); }}
              onChange={function(e){var v=e.target.value; setDraft(function(p){var c=Object.assign({},p); c[rep.id]=Object.assign({},c[rep.id],{val:v}); return c;});}}
              style={{width:64,textAlign:"center",padding:"5px 6px",border:"1px solid "+C.border,borderRadius:6,fontSize:12}}/>
            <Btn v="primary" style={{fontSize:11,padding:"5px 14px"}} onClick={function(){saveRow(rep,pl);}}>Add</Btn>
            <button onClick={function(){skipRow(rep);}} title="No time for this one — dismiss" style={{background:"none",border:"none",color:C.gray400,fontSize:11,cursor:"pointer",padding:"5px 4px"}}>Skip</button>
          </div>;
        })}
      </div>}
    </Card>
  );
}

// THE REPHRASE SURFACE (shipped 2026-08-18). Admin Dashboard -> Mass Approve -> expand a report.
//
// The gate behind it has existed and been proven for a while — /admin/refine-summary accepts a
// tightened rephrase and refuses an invented observation, naming the claim it refused — and NOTHING
// IN THE PRODUCT CALLED IT. Meanwhile the operative Terms tells customers "a BBOT administrator may
// refine the wording of an evaluation for clarity, and may never add an observation... edits that
// would introduce a new claim are rejected by the system rather than reviewed by a person." That
// sentence described a capability with no door. This is the door.
//
// It never writes on render, and it never commits without a press: the refusal path is a dry run.
function RephrasePanel({report, notify, setScoutReports}){
  var origin = (report && (report.summary || "")) || "";
  var draftS = useState(origin); var draft = draftS[0], setDraft = draftS[1];
  var busyS = useState(false); var busy = busyS[0], setBusy = busyS[1];
  var resS = useState(null); var res = resS[0], setRes = resS[1];
  var qualS = useState(null); var qual = qualS[0], setQual = qualS[1];

  // THE QUALITY LOOP. Every committed refinement is ledgered with its own delta, and the report
  // opens at ten edits — before that it says how many are still needed rather than drawing a
  // trend across three points.
  function loadQuality(){
    bbotAdminLogRead({action:"summary_refined",limit:"50",select:"target_id,metadata,timestamp"})
      .then(function(rows){
        rows = rows || [];
        var deltas = rows.map(function(x){ return (x.metadata||{}).delta_pct; })
                         .filter(function(v){ return typeof v === "number"; });
        var refused = rows.filter(function(x){ return (x.metadata||{}).refused; }).length;
        var med = null;
        if(deltas.length){
          var s = deltas.slice().sort(function(a,b){return a-b;});
          med = s[Math.floor(s.length/2)];
        }
        setQual({n: rows.length, median_delta_pct: med, refused: refused});
      })
      .catch(function(){ setQual({n: 0, median_delta_pct: null, refused: 0}); });
  }
  useEffect(function(){ loadQuality(); }, []);   // eslint-disable-line

  function ledger(reportId, accepted, before, after, added){
    var d = before ? Math.round(100 * (after.length - before.length) / before.length) : 0;
    return bbotAdminLog({
        action: "summary_refined", target_id: String(reportId),
        timestamp: new Date().toISOString(),
        metadata: {refused: !accepted, delta_pct: d, before_chars: before.length,
                   after_chars: after.length,
                   added: (added || []).map(function(a){ return a.value; }).slice(0, 6)}
      }).catch(function(){});
  }

  function submit(commit){
    if(!report || !report.id) return;
    setBusy(true); setRes(null);
    fetch(BACKEND_URL + "/admin/refine-summary", {
      method: "POST", headers: bbotAdminHeaders(),
      body: JSON.stringify({reportId: String(report.id), refined: draft, commit: !!commit})
    }).then(function(r){
      return r.json().then(function(j){ return {status: r.status, body: j}; });
    }).then(function(out){
      var ok = out.status === 200;
      var detail = (out.body && out.body.detail) || out.body || {};
      var added = detail.added || [];
      setRes({ok: ok, added: added, committed: ok && !!commit});
      ledger(report.id, ok, origin, draft, added).then(loadQuality);
      if(ok && commit){
        notify && notify("Refinement saved — the wording changed, no claim did", "success");
        if(setScoutReports){
          setScoutReports(function(prev){
            return (prev||[]).map(function(x){
              return String(x.id)===String(report.id) ? Object.assign({}, x, {summary: draft}) : x;
            });
          });
        }
      } else if(!ok){
        notify && notify("Refused — it would add a claim BBOT did not make", "error");
      }
    }).catch(function(){
      setRes({ok: false, added: [], error: true});
      notify && notify("Could not reach the refine endpoint", "error");
    }).then(function(){ setBusy(false); });
  }

  var changed = draft.trim() !== origin.trim();
  return (
    <div data-bbot-surface="rephrase" style={{border:"1px solid "+C.border,borderRadius:10,
         padding:14,background:C.gray50,marginTop:10}}>
      <div style={{fontSize:11,letterSpacing:1,fontWeight:700,color:C.navy,marginBottom:6}}>
        REFINE THE WORDING
      </div>
      <div style={{fontSize:11,color:C.gray500,lineHeight:1.55,marginBottom:8}}>
        Clarity only. You may tighten, reorder or drop a sentence. You may not add an observation,
        a figure or a descriptor BBOT did not produce — the system refuses those rather than
        trusting the edit.
      </div>
      <textarea value={draft} onChange={function(e){setDraft(e.target.value);}} rows={6}
        style={{width:"100%",fontSize:12,lineHeight:1.6,padding:10,borderRadius:8,
                border:"1px solid "+C.border,fontFamily:"inherit",resize:"vertical"}}/>
      <div style={{display:"flex",gap:8,marginTop:8,flexWrap:"wrap",alignItems:"center"}}>
        <Btn v="outline" style={{fontSize:11,padding:"6px 12px"}} disabled={busy||!changed}
             onClick={function(){submit(false);}}>Check without saving</Btn>
        <Btn v="primary" style={{fontSize:11,padding:"6px 12px"}} disabled={busy||!changed}
             onClick={function(){submit(true);}}>Check &amp; save</Btn>
        {!changed && <span style={{fontSize:11,color:C.gray400}}>unchanged</span>}
        {busy && <span style={{fontSize:11,color:C.gray500}}>checking…</span>}
      </div>
      {res && (
        <div style={{marginTop:10,padding:"9px 11px",borderRadius:8,fontSize:11.5,lineHeight:1.6,
             background: res.ok ? "#eefbf2" : "#fff5f6",
             border: "1px solid " + (res.ok ? "#bfe6cd" : "#ffd4dc"),
             color: res.ok ? "#1b6b3a" : "#8a2b3d"}}>
          {res.ok
            ? (res.committed ? "Accepted and saved — every claim in it was already BBOT's."
                             : "Accepted — it adds no claim. Press Check & save to commit it.")
            : (res.error ? "The endpoint could not be reached; nothing was saved."
                         : "Refused — it introduces something BBOT's evaluation does not contain:")}
          {!res.ok && (res.added||[]).length > 0 && (
            <ul style={{margin:"6px 0 0 16px",padding:0}}>
              {res.added.map(function(a,i){
                return <li key={i} style={{marginBottom:2}}>{a.why || (a.klass+": "+a.value)}</li>;
              })}
            </ul>
          )}
        </div>
      )}
      {qual && (
        <div style={{marginTop:10,fontSize:10.5,color:C.gray500,borderTop:"1px solid "+C.gray100,
             paddingTop:8,lineHeight:1.6}}>
          <strong style={{color:C.navy}}>Refinement quality</strong>{" — "}
          {qual.n >= 10
            ? (qual.n + " edits ledgered · median length change " +
               (qual.median_delta_pct > 0 ? "+" : "") + qual.median_delta_pct + "%" +
               " · " + qual.refused + " refused by the gate")
            : (qual.n + " of 10 edits ledgered — the delta report opens at ten, because a trend " +
               "across a handful of edits is a shape, not a finding")}
        </div>
      )}
    </div>
  );
}

function MassApprovalView({reports, setScoutReports, users, approveReport, notify}){
  var [expandedReportId, setExpandedReportId] = useState(null);
  // THE QUEUE IS "WHAT STILL NEEDS A DECISION", NOT "EVERYTHING THAT IS NOT APPROVED".
  // This excluded approved and rejected and nothing else, so when the census introduced `archived`
  // -- a status meaning REMOVED FROM VIEW, set on 13 superseded/empty/dead rows -- every one of
  // them kept sitting in the approval queue. The census had done its job; the queue had never been
  // told the word existed. Same class as the suite and the drift guard, which were taught it and
  // this was not.
  //
  // Named statuses, not a negation: a future status defaults to VISIBLE (needing a decision), which
  // is the safe direction -- a row nobody has ruled on should be seen, and a row somebody archived
  // should not.
  var QUEUE_HIDDEN = {approved:1, rejected:1, archived:1, superseded:1};
  var pendingReports = (reports||[]).filter(function(r){return !QUEUE_HIDDEN[r.status];});
  // Confidence of an eval — high-confidence evals are safe to approve fast.
  function confOf(r){
    var c = (r.evalConfidence || (r.fullReport&&r.fullReport.evalConfidence) || "").toLowerCase();
    if(c.indexOf("high")>=0) return "high";
    if(c.indexOf("low")>=0 || r.partial || (r.fullReport&&r.fullReport.partial)) return "low";
    if(c.indexOf("med")>=0) return "medium";
    return "medium";
  }
  var confRank = {high:0, medium:1, low:2};
  // Group by session date + sessionType (the natural grouping = one game/practice/showcase)
  // THE DATE FIELD IS `date`, AND IT ALWAYS WAS. The loader maps `date: r.session_date`
  // (App.js:1508) and never produces `sessionDate`, so this grouper read undefined on EVERY row
  // and every group was headed "Unknown date" -- on rows that all carry a session date. The rows
  // were never the problem; the grouper was reading a field nobody writes.
  // Read the mapped name first, then the raw column, so this works on either shape.
  function _sessionDateOf(r){ return r.date || r.sessionDate || r.session_date || null; }
  var groupsMap = {};
  pendingReports.forEach(function(r){
    var _d = _sessionDateOf(r);
    var key = (_d||"unknown")+"|"+(r.sessionType||"Eval");
    if(!groupsMap[key]) groupsMap[key] = {date:_d||"Undated", sessionType:r.sessionType||"Evaluation", reports:[]};
    groupsMap[key].reports.push(r);
  });
  // Sort reports within each group by confidence (high first), and sort groups by best confidence
  Object.keys(groupsMap).forEach(function(k){
    groupsMap[k].reports.sort(function(a,b){return confRank[confOf(a)]-confRank[confOf(b)];});
  });
  var groups = Object.keys(groupsMap).sort().reverse().map(function(k){return Object.assign({key:k}, groupsMap[k]);});
  var [selected, setSelected] = useState({});

  function approveAllHighConf(){
    var ids = pendingReports.filter(function(r){return confOf(r)==="high";}).map(function(r){return r.id;});
    if(!ids.length) return notify("No high-confidence evals to approve","error");
    if(!window.confirm("Approve "+ids.length+" HIGH-confidence evals?\\n\\nReview low/medium-confidence evals individually below.")) return;
    ids.forEach(function(id){ approveReport(id); });
    notify(ids.length+" high-confidence evals approved");
  }

  function toggleAll(grpKey){
    var grp = groupsMap[grpKey];
    var allSelected = grp.reports.every(function(r){return selected[r.id];});
    var update = {};
    grp.reports.forEach(function(r){update[r.id] = !allSelected;});
    setSelected(function(prev){return Object.assign({}, prev, update);});
  }
  function toggleOne(id){
    setSelected(function(prev){var copy = Object.assign({}, prev); copy[id] = !copy[id]; return copy;});
  }
  function approveSelected(){
    var ids = Object.keys(selected).filter(function(k){return selected[k];});
    if(!ids.length) return notify("No reports selected","error");
    if(!window.confirm("Approve "+ids.length+" reports? Players will be notified and PDFs become accessible.")) return;
    ids.forEach(function(id){ approveReport(id); });
    setSelected({});
    notify(ids.length+" reports approved");
  }
  function deleteSelected(){
    var ids = Object.keys(selected).filter(function(k){return selected[k];});
    if(!ids.length) return notify("No reports selected","error");
    if(!window.confirm("PERMANENTLY DELETE "+ids.length+" reports?\\n\\nThis cannot be undone. Clips remain. Eval data is removed.")) return;
    notify("Deleting "+ids.length+" reports…");
    Promise.all(ids.map(function(id){
      return reportDelete([id]).then(function(){ return String(id); }).catch(function(){ return null; });
    })).then(function(results){
      var okIds = results.filter(Boolean);
      if(okIds.length && setScoutReports){
        var idset={}; okIds.forEach(function(i){idset[i]=true;});
        setScoutReports(function(prev){ return (prev||[]).filter(function(x){ return !idset[String(x.id)]; }); });
      }
      setSelected({});
      if(okIds.length===ids.length){ notify(okIds.length+" reports deleted"); }
      else if(okIds.length>0){ notify("Deleted "+okIds.length+" of "+ids.length+" — others blocked (check delete permission)","error"); }
      else { notify("Delete blocked — run the DELETE permission SQL in Supabase","error"); }
    });
  }
  function approveGroup(grpKey){
    var grp = groupsMap[grpKey];
    if(!window.confirm("Approve ALL "+grp.reports.length+" reports for "+grp.date+" "+grp.sessionType+"?")) return;
    grp.reports.forEach(function(r){ approveReport(r.id); });
    notify(grp.reports.length+" reports approved");
  }
  function deleteGroup(grpKey){
    var grp = groupsMap[grpKey];
    if(!window.confirm("PERMANENTLY DELETE all "+grp.reports.length+" reports for "+grp.date+" "+grp.sessionType+"?\\n\\nThis cannot be undone.")) return;
    notify("Deleting "+grp.reports.length+" reports…");
    Promise.all(grp.reports.map(function(r){
      return reportDelete([r.id]).then(function(){ return String(r.id); }).catch(function(){ return null; });
    })).then(function(results){
      var okIds = results.filter(Boolean);
      if(okIds.length && setScoutReports){
        var idset={}; okIds.forEach(function(i){idset[i]=true;});
        setScoutReports(function(prev){ return (prev||[]).filter(function(x){ return !idset[String(x.id)]; }); });
      }
      if(okIds.length===grp.reports.length){ notify(okIds.length+" reports deleted"); }
      else if(okIds.length>0){ notify("Deleted "+okIds.length+" of "+grp.reports.length+" — others blocked (check delete permission)","error"); }
      else { notify("Delete blocked — run the DELETE permission SQL in Supabase","error"); }
    });
  }

  var totalSelected = Object.values(selected).filter(Boolean).length;

  return (
    <div>
      <SectionHeader>Mass Approval</SectionHeader>
      <RunTimeQueue reports={reports} users={users} notify={notify}/>
      <div style={{fontSize:12,color:C.gray500,marginBottom:14}}>Sorted by BBOT confidence — high-confidence evals first. You still approve each; this just surfaces the safe ones to clear fast.</div>

      {pendingReports.length>0 && (function(){
        var hi=pendingReports.filter(function(r){return confOf(r)==="high";}).length;
        if(!hi) return null;
        return <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",gap:10,padding:"12px 16px",background:"#f0fdf4",border:"1px solid #86efac",borderRadius:10,marginBottom:14}}>
          <div style={{fontSize:13,color:"#166534"}}><strong>{hi}</strong> high-confidence eval{hi===1?"":"s"} ready for fast approval</div>
          <Btn v="primary" style={{fontSize:12,padding:"7px 14px"}} onClick={approveAllHighConf}>Approve all high-confidence</Btn>
        </div>;
      })()}

      {pendingReports.length===0 ? (
        <EmptyCard icon="✓" title="No pending reports" sub="All reports have been reviewed."/>
      ) : (
        <div>
          {totalSelected>0 && (
            <div style={{position:"sticky",top:0,zIndex:10,background:C.navy,color:C.white,padding:"10px 16px",borderRadius:8,marginBottom:14,display:"flex",justifyContent:"space-between",alignItems:"center"}}>
              <div style={{fontSize:13,fontWeight:600}}>{totalSelected} reports selected across groups</div>
              <div style={{display:"flex",gap:8}}>
                <Btn v="outline" style={{fontSize:11,padding:"6px 12px",color:C.white,borderColor:"rgba(255,255,255,0.4)"}} onClick={function(){setSelected({});}}>Clear</Btn>
                <Btn v="outline" style={{fontSize:11,padding:"6px 12px",color:"#fca5a5",borderColor:"rgba(252,165,165,0.4)"}} onClick={deleteSelected}>✗ Delete {totalSelected}</Btn>
                <Btn v="primary" style={{fontSize:11,padding:"6px 14px",background:C.coral,border:"1px solid "+C.coral}} onClick={approveSelected}>✓ Approve {totalSelected}</Btn>
              </div>
            </div>
          )}

          {groups.map(function(grp){
            var allChecked = grp.reports.every(function(r){return selected[r.id];});
            return <Card key={grp.key} style={{marginBottom:12}}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:12,paddingBottom:10,borderBottom:"1px solid "+C.gray50}}>
                <div>
                  <div style={{fontSize:14,fontWeight:700,color:C.navy}}>{grp.date} &middot; {grp.sessionType}</div>
                  <div style={{fontSize:11,color:C.gray500,marginTop:2}}>{grp.reports.length} pending reports</div>
                </div>
                <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
                  <Btn v="outline" style={{fontSize:11,padding:"6px 12px"}} onClick={function(){toggleAll(grp.key);}}>{allChecked?"Deselect All":"Select All"}</Btn>
                  <Btn v="outline" style={{fontSize:11,padding:"6px 12px",color:"#dc2626",borderColor:"#fecaca"}} onClick={function(){deleteGroup(grp.key);}}>✗ Delete Group</Btn>
                  <Btn v="primary" style={{fontSize:11,padding:"6px 12px"}} onClick={function(){approveGroup(grp.key);}}>Approve Group</Btn>
                </div>
              </div>
              <div style={{display:"flex",flexDirection:"column",gap:4}}>
                {grp.reports.map(function(r){
                  var p = (users||[]).filter(function(u){return String(u.id)===String(r.playerId);})[0];
                  var name = p ? (p.firstName+" "+p.lastName) : "Unknown player";
                  var score = r.score!=null ? r.score : (r.bbotScore!=null ? r.bbotScore : null);
                  var isExp = String(expandedReportId)===String(r.id);
                  return <div key={r.id}>
                    <div onClick={function(){toggleOne(r.id);}} style={{display:"flex",alignItems:"center",gap:10,padding:"8px 10px",background:selected[r.id]?C.blueFaint:C.gray50,borderRadius:6,cursor:"pointer",border:"1px solid "+(selected[r.id]?C.blue:"transparent")}}>
                      <input type="checkbox" checked={!!selected[r.id]} onChange={function(){toggleOne(r.id);}} onClick={function(e){e.stopPropagation();}}/>
                      <div style={{flex:1}}>
                        <div style={{fontSize:13,fontWeight:600,color:C.navy}}>{name}</div>
                        <div style={{fontSize:10,color:C.gray500}}>{p&&p.position?p.position+" · ":""}{p&&p.gradYear?"Class "+p.gradYear+" · ":""}{r.sessionType||"Eval"}</div>
                      </div>
                      {(function(){var cf=confOf(r);var col=cf==="high"?C.green:cf==="low"?C.red:C.orange;return <div style={{fontSize:9,fontWeight:700,color:col,background:col+"18",padding:"3px 8px",borderRadius:99,textTransform:"uppercase",letterSpacing:.5,minWidth:54,textAlign:"center"}}>{cf} conf</div>;})()}
                      <button onClick={function(e){e.stopPropagation();setExpandedReportId(isExp?null:r.id);}} style={{background:"transparent",border:"1px solid "+C.border,color:C.blue,borderRadius:6,fontSize:10,fontWeight:700,padding:"5px 9px",cursor:"pointer",whiteSpace:"nowrap",minHeight:"auto"}}>{isExp?"▲ Hide":"▼ Full report"}</button>
                    </div>
                    {isExp && p && (
                      <div style={{margin:"6px 0 12px",paddingLeft:4}}>
                        <ReportCard r={r} sc={p} isDraft={true} isAdmin={true}/>
                        <RephrasePanel report={r} notify={notify} setScoutReports={setScoutReports}/>
                      </div>
                    )}
                  </div>;
                })}
              </div>
            </Card>;
          })}
        </div>
      )}
    </div>
  );
}

function CoachVerificationView({users, setUsers, notify}){
  var [filter, setFilter] = useState("pending");
  var coaches = (users||[]).filter(function(u){return u.type==="coach";});
  var filtered = coaches.filter(function(c){
    if(filter==="pending") return !c.verified && c.verificationStatus!=="rejected";
    if(filter==="verified") return !!c.verified;
    if(filter==="rejected") return c.verificationStatus==="rejected";
    return true;
  });

  function setStatus(coach, status){
    setUsers(function(all){
      return all.map(function(u){
        if(u.id!==coach.id) return u;
        var updated = Object.assign({}, u, {
          verified: status==="verified",
          verificationStatus: status,
          verifiedAt: status==="verified" ? new Date().toISOString() : u.verifiedAt,
          verifiedBy: status==="verified" ? "admin" : u.verifiedBy
        });
        persistUser(updated).catch(function(){});
        return updated;
      });
    });
    notify(coach.firstName+" "+coach.lastName+" "+(status==="verified"?"verified":status));
  }

  function verifyAllPending(){
    var pend = coaches.filter(function(c){return !c.verified && c.verificationStatus!=="rejected";});
    if(!pend.length) return notify("No pending coaches","error");
    if(!window.confirm("Verify all "+pend.length+" pending coaches?\\n\\nOnly do this if you have reviewed their org/email.")) return;
    pend.forEach(function(c){ setStatus(c,"verified"); });
  }

  return (
    <div>
      <SectionHeader>Coach &amp; Scout Verification</SectionHeader>
      <div style={{fontSize:12,color:C.gray500,marginBottom:14}}>Review pending coach/scout signups. Verified status grants access to player profiles and unlocks the verified badge on their account.</div>

      {/* PENDING STAFF — staff signups awaiting approval (limited powers once approved) */}
      {(function(){
        var pendingStaff=(users||[]).filter(function(u){return u.type==="staff" && u.staffApproved===false;});
        if(!pendingStaff.length) return null;
        function approveStaff(s, ok){
          setUsers(function(all){return all.map(function(u){
            if(u.id!==s.id) return u;
            var upd=Object.assign({},u,{staffApproved:ok});
            persistUser(upd).catch(function(e){ try{ console.warn("profile save failed:", e && e.message); }catch(_){} if(window.__bbotNotify) window.__bbotNotify("Your change didn't save — please try again.","error"); }); return upd;
          });});
          notify((s.firstName||"Staff")+(ok?" approved — can add players + run evals":" access denied"));
        }
        return <div style={{marginBottom:18,padding:14,border:"1px solid "+C.border,borderRadius:10,background:"#fffbeb"}}>
          <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:12,color:"#92400e",letterSpacing:1,marginBottom:10,fontWeight:700}}>PENDING STAFF ({pendingStaff.length})</div>
          {pendingStaff.map(function(s){
            return <div key={s.id} style={{display:"flex",justifyContent:"space-between",alignItems:"center",gap:10,padding:"8px 0",borderTop:"1px solid "+C.gray100}}>
              <div><div style={{fontWeight:700,fontSize:13,color:C.navy}}>{s.firstName} {s.lastName}</div><div style={{fontSize:11,color:C.gray500}}>{s.staffRole||"Staff"} · {s.email}</div></div>
              <div style={{display:"flex",gap:6}}>
                <Btn v="primary" style={{fontSize:11,padding:"6px 12px"}} onClick={function(){approveStaff(s,true);}}>✓ Approve</Btn>
                <Btn v="ghost" style={{fontSize:11,padding:"6px 12px",color:"#dc2626"}} onClick={function(){approveStaff(s,false);}}>Deny</Btn>
              </div>
            </div>;
          })}
          <div style={{fontSize:10,color:C.gray500,fontStyle:"italic",marginTop:8}}>Approved staff can add players and run evals. Their evals still require approval. Money, deletes, and verification stay admin-only.</div>
        </div>;
      })()}

      {filter==="pending" && coaches.filter(function(c){return !c.verified && c.verificationStatus!=="rejected";}).length>0 && (
        <div style={{display:"flex",justifyContent:"flex-end",marginBottom:10}}>
          <Btn v="primary" style={{fontSize:12,padding:"7px 14px"}} onClick={verifyAllPending}>✓ Verify all pending</Btn>
        </div>
      )}

      <div style={{display:"flex",gap:8,marginBottom:14}}>
        {[["pending","Pending Review"],["verified","Verified"],["rejected","Rejected"],["all","All"]].map(function(opt){
          return <button key={opt[0]} onClick={function(){setFilter(opt[0]);}} style={{padding:"6px 14px",borderRadius:14,border:"1px solid "+C.border,background:filter===opt[0]?C.navy:"transparent",color:filter===opt[0]?C.white:C.gray600,fontSize:11,fontWeight:600,cursor:"pointer"}}>{opt[1]} ({coaches.filter(function(c){
            if(opt[0]==="pending") return !c.verified && c.verificationStatus!=="rejected";
            if(opt[0]==="verified") return !!c.verified;
            if(opt[0]==="rejected") return c.verificationStatus==="rejected";
            return true;
          }).length})</button>;
        })}
      </div>

      {filtered.length===0 ? (
        <EmptyCard icon="C" title="No coaches" sub={"No "+filter+" coach/scout accounts."}/>
      ) : (
        <div style={{display:"flex",flexDirection:"column",gap:10}}>
          {filtered.map(function(c){
            return <Card key={c.id}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",flexWrap:"wrap",gap:12}}>
                <div style={{flex:1,minWidth:240}}>
                  <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:4}}>
                    <div style={{fontSize:14,fontWeight:700,color:C.navy}}>{c.firstName} {c.lastName}</div>
                    {c.verified && <span style={{background:"#dcfce7",color:"#166534",padding:"2px 8px",borderRadius:10,fontSize:9,fontWeight:700,letterSpacing:.5}}>✓ VERIFIED</span>}
                    {c.verificationStatus==="rejected" && <span style={{background:"#fee2e2",color:"#991b1b",padding:"2px 8px",borderRadius:10,fontSize:9,fontWeight:700,letterSpacing:.5}}>REJECTED</span>}
                    {!c.verified && c.verificationStatus!=="rejected" && <span style={{background:"#fef3c7",color:"#92400e",padding:"2px 8px",borderRadius:10,fontSize:9,fontWeight:700,letterSpacing:.5}}>PENDING</span>}
                  </div>
                  <div style={{fontSize:12,color:C.gray700,marginBottom:3}}><strong>{c.coachRole||c.level||"Coach"}</strong>{c.orgName?" · "+c.orgName:""}</div>
                  <div style={{fontSize:11,color:C.gray500}}>{c.email}</div>
                  {c.complianceAckDate && <div style={{fontSize:10,color:C.gray400,marginTop:4}}>Compliance acknowledged: {new Date(c.complianceAckDate).toLocaleDateString()}</div>}
                </div>
                <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
                  {!c.verified && <Btn v="primary" style={{fontSize:11,padding:"6px 12px"}} onClick={function(){setStatus(c,"verified");}}>✓ Verify</Btn>}
                  {c.verificationStatus!=="rejected" && <Btn v="outline" style={{fontSize:11,padding:"6px 12px",color:"#dc2626"}} onClick={function(){setStatus(c,"rejected");}}>✗ Reject</Btn>}
                  {c.verified && <Btn v="ghost" style={{fontSize:11,padding:"6px 12px"}} onClick={function(){setStatus(c,"pending");}}>Revoke</Btn>}
                </div>
              </div>
            </Card>;
          })}
        </div>
      )}
    </div>
  );
}

// PROFILE APPROVALS — every new account (player/coach/staff) lands here as "pending" until
// an admin approves it. Approval is what unlocks paid actions AND triggers the welcome email
// (so the email endpoint can't be abused to spam). Mirrors the coach-verification pattern.
function UnassignedPlayersPanel({users, setUsers, notify}){
  var openS=useState(false); var open=openS[0]; var setOpen=openS[1];
  var modeS=useState({}); var mode=modeS[0]; var setMode=modeS[1]; // per-stub: "fill" | "merge"
  var fillS=useState({}); var fill=fillS[0]; var setFill=fillS[1];   // per-stub form values
  var mergeS=useState({}); var mergeSel=mergeS[0]; var setMergeSel=mergeS[1];
  var provisional=(users||[]).filter(function(u){ return u && u.provisional; });
  var realPlayers=(users||[]).filter(function(u){ return u && u.type==="player" && !u.provisional; });
  if(!provisional.length) return null;
  function fillInPlace(stub){
    var f=fill[stub.id]||{};
    if(!f.firstName||!f.lastName){ notify("Enter first and last name","error"); return; }
    var updated=Object.assign({},stub,{firstName:f.firstName,lastName:f.lastName,dob:f.dob||null,provisional:false,provisionalTeam:undefined});
    setUsers(function(all){return all.map(function(x){return x.id===stub.id?updated:x;});});
    try{ persistUser(updated); }catch(e){}
    notify(stub.firstName+" identified as "+f.firstName+" "+f.lastName);
  }
  function mergeInto(stub){
    var targetId=mergeSel[stub.id];
    if(!targetId){ notify("Pick a player to merge into","error"); return; }
    // Reassign the stub's data to the target, then remove the stub. Data tables key on player_id.
    // /player-merge reassigns the stub's data (reports/highlights/batted_balls/pitches) to the
    // target AND deletes the stub bbot_users row server-side — all RLS-locked / cross-row writes.
    playerMerge(stub.id, targetId).catch(function(){ notify("Merge may not have fully saved — refresh to verify","error"); });
    setUsers(function(all){return all.filter(function(x){return x.id!==stub.id;});});
    var tgt=realPlayers.find(function(p){return String(p.id)===String(targetId);});
    notify("Merged "+stub.firstName+"'s data into "+(tgt?tgt.firstName+" "+tgt.lastName:"player"));
  }
  return (
    <Card style={{marginBottom:16,padding:0,overflow:"hidden",border:"1px solid "+C.coral}}>
      <div onClick={function(){setOpen(!open);}} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"12px 16px",cursor:"pointer",background:C.coralFaint}}>
        <div style={{fontWeight:700,color:C.coral,fontSize:13,letterSpacing:.3}}>UNASSIGNED PLAYERS · {provisional.length} need identification</div>
        <span style={{color:C.coral,fontSize:14}}>{open?"▾":"▸"}</span>
      </div>
      {open && <div style={{padding:"12px 16px"}}>
        <div style={{fontSize:11,color:C.gray500,marginBottom:12,lineHeight:1.5}}>These were detected in multi-player sessions but couldn't be matched to a player. Their data is held here. Identify each one — fill in the player's details, or merge the data into an existing player.</div>
        {provisional.map(function(stub){
          var m=mode[stub.id]||"fill"; var f=fill[stub.id]||{};
          return (
            <div key={stub.id} style={{border:"1px solid "+C.border,borderRadius:8,padding:12,marginBottom:10}}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:10}}>
                <div style={{fontWeight:700,color:C.navy,fontSize:14}}>{stub.firstName} {stub.lastName} {stub.provisionalTeam?<span style={{fontSize:11,color:C.gray500,fontWeight:400}}>· {stub.provisionalTeam}</span>:null}</div>
                <div style={{display:"flex",gap:4}}>
                  {["fill","merge"].map(function(opt){return <button key={opt} onClick={function(){setMode(function(p){var n=Object.assign({},p);n[stub.id]=opt;return n;});}} style={{padding:"4px 10px",borderRadius:6,border:"1px solid "+(m===opt?C.coral:C.border),background:m===opt?C.coral:C.white,color:m===opt?C.white:C.gray600,fontSize:11,fontWeight:600,cursor:"pointer"}}>{opt==="fill"?"Fill details":"Merge into player"}</button>;})}
                </div>
              </div>
              {m==="fill" ? (
                <div style={{display:"flex",gap:8,flexWrap:"wrap",alignItems:"center"}}>
                  <input placeholder="First name" value={f.firstName||""} onChange={function(e){var v=e.target.value;setFill(function(p){var n=Object.assign({},p);n[stub.id]=Object.assign({},n[stub.id],{firstName:v});return n;});}} style={{flex:"1 1 120px",padding:"7px 10px",border:"1px solid "+C.border,borderRadius:6,fontSize:12}}/>
                  <input placeholder="Last name" value={f.lastName||""} onChange={function(e){var v=e.target.value;setFill(function(p){var n=Object.assign({},p);n[stub.id]=Object.assign({},n[stub.id],{lastName:v});return n;});}} style={{flex:"1 1 120px",padding:"7px 10px",border:"1px solid "+C.border,borderRadius:6,fontSize:12}}/>
                  <input type="date" value={f.dob||""} onChange={function(e){var v=e.target.value;setFill(function(p){var n=Object.assign({},p);n[stub.id]=Object.assign({},n[stub.id],{dob:v});return n;});}} style={{flex:"1 1 130px",padding:"7px 10px",border:"1px solid "+C.border,borderRadius:6,fontSize:12}} title="DOB optional — can be added later"/>
                  <button onClick={function(){fillInPlace(stub);}} style={{padding:"7px 14px",borderRadius:6,border:"none",background:C.coral,color:C.white,fontSize:12,fontWeight:700,cursor:"pointer"}}>Save</button>
                </div>
              ) : (
                <div style={{display:"flex",gap:8,flexWrap:"wrap",alignItems:"center"}}>
                  <select value={mergeSel[stub.id]||""} onChange={function(e){var v=e.target.value;setMergeSel(function(p){var n=Object.assign({},p);n[stub.id]=v;return n;});}} style={{flex:"1 1 200px",padding:"7px 10px",border:"1px solid "+C.border,borderRadius:6,fontSize:12}}>
                    <option value="">Select existing player…</option>
                    {realPlayers.slice().sort(function(a,b){return (a.lastName||"").localeCompare(b.lastName||"");}).map(function(p){return <option key={p.id} value={p.id}>{p.firstName} {p.lastName}{p.gradYear?" · "+p.gradYear:""}</option>;})}
                  </select>
                  <button onClick={function(){if(window.confirm("Merge this data into the selected player and remove the placeholder?")) mergeInto(stub);}} style={{padding:"7px 14px",borderRadius:6,border:"none",background:C.coral,color:C.white,fontSize:12,fontWeight:700,cursor:"pointer"}}>Merge</button>
                </div>
              )}
            </div>
          );
        })}
      </div>}
    </Card>
  );
}
// Build a plain-text, role-aware welcome message.
function buildWelcomeText(u){
  var name=u.firstName||"there"; var role=u.type||"player"; var lead, steps;
  if(role==="coach"){
    lead="your coach profile lets you build rosters and scout objectively.";
    steps=["Create a roster (team or college name).","Upload videos or request evaluations for your players.","Use the compare tools to line prospects up side by side.","Follow players and get update notifications."];
  } else if(role==="staff"){
    lead="your staff profile is for running evaluations and managing your roster.";
    steps=["Run BBOT: pick a player, upload their video, run the evaluation.","It goes to admin review, then unlocks for the player to purchase.","Pull players onto your roster to track their reports and clips."];
  } else {
    lead="your player profile is your objective scouting record.";
    steps=["Upload a session video (or have 643 film you) to request a BBOT evaluation.","An admin reviews it for accuracy before it's released.","Pay once to unlock the report + your stamped clips.","Your reports, clips, and metrics populate your profile automatically."];
  }
  var body="Hi "+name+",\n\nWelcome to 643 BBOT — "+lead+"\n\nHow to use it:\n"+
    steps.map(function(s,i){return (i+1)+". "+s;}).join("\n")+
    "\n\nEvery grade is tied to something visible on video. BBOT never guesses.\n\nOpen BBOT: https://www.643sportsmgmt.com\n\n— 643 Sports MGMT";
  return {subject:"Welcome to 643 BBOT", body:body};
}
// The Gmail account the welcome email is sent FROM. authuser= picks this account in the
// compose window (Google prompts to sign in if it isn't already logged in on the device).
var WELCOME_FROM="643bbot@gmail.com";
// Send the welcome FROM the admin's own inbox — no email service, key, or DNS needed.
// Opens Gmail's compose (falls back to the device mail app) pre-filled; admin hits Send.
function openWelcomeEmail(u, notify){
  if(!u || !u.email){ notify && notify("This profile has no email address","error"); return; }
  var w=buildWelcomeText(u);
  var gmail="https://mail.google.com/mail/?authuser="+encodeURIComponent(WELCOME_FROM)+
    "&view=cm&fs=1&to="+encodeURIComponent(u.email)+
    "&su="+encodeURIComponent(w.subject)+"&body="+encodeURIComponent(w.body);
  try{
    var win=window.open(gmail,"_blank");
    if(!win) window.location.href="mailto:"+encodeURIComponent(u.email)+"?subject="+encodeURIComponent(w.subject)+"&body="+encodeURIComponent(w.body);
  }catch(e){
    window.location.href="mailto:"+encodeURIComponent(u.email)+"?subject="+encodeURIComponent(w.subject)+"&body="+encodeURIComponent(w.body);
  }
  notify && notify("Opened a welcome email to "+(u.firstName||u.email)+" — review and hit Send.");
}
function ProfileApprovalsView({users, setUsers, notify}){
  var [filter,setFilter]=useState("pending");
  var [busyId,setBusyId]=useState(null);
  function isPending(u){ return u.approvalStatus==="pending"; }
  function isApproved(u){ return u.approvalStatus==="approved" || (u.approvalStatus==null); } // legacy users w/o the field are treated approved
  function isDenied(u){ return u.approvalStatus==="denied"; }
  var all=(users||[]);
  var filtered=all.filter(function(u){
    if(filter==="pending") return isPending(u);
    if(filter==="approved") return isApproved(u);
    if(filter==="denied") return isDenied(u);
    return true;
  });

  function setStatus(u, status){
    setBusyId(u.id);
    var updated = Object.assign({}, u, {
      approvalStatus: status,
      approvedAt: status==="approved" ? new Date().toISOString() : u.approvedAt,
      approvedBy: status==="approved" ? "admin" : u.approvedBy
    });
    // Keep the legacy staff gate in sync: approving a staff profile also grants
    // staffApproved so the eval runner doesn't keep blocking them (and revoking removes it).
    if(u.type==="staff"){ updated.staffApproved = (status==="approved"); }
    // Update local state optimistically so the UI reflects the change instantly.
    setUsers(function(allU){
      return allU.map(function(x){ return x.id===u.id ? updated : x; });
    });
    // DB write — surface failures explicitly. Without this, an RLS/network error
    // would leave the admin thinking the user was approved while the DB stayed
    // unchanged. On failure: revert local state and notify so admin can retry.
    persistUser(updated).catch(function(err){
      console.warn("Approval persist failed:", err && err.message);
      setUsers(function(allU){
        return allU.map(function(x){ return x.id===u.id ? u : x; }); // revert
      });
      notify("Could not save status change — please try again. ("+(err && err.message ? err.message.slice(0,80) : "DB write failed")+")", "error");
      setBusyId(null);
    });
    if(status==="approved"){
      // No automatic email — approval just unlocks the account. The admin sends the
      // welcome from 643bbot@gmail.com with the "✉ Welcome email" button (opens a
      // pre-filled Gmail compose to review + Send). This avoids any email service/key
      // and, on "Approve all", avoids opening a compose tab per person.
      notify((u.firstName||"Profile")+" approved — use “✉ Welcome email” to send their welcome.");
      setBusyId(null);
    } else {
      notify((u.firstName||"Profile")+" "+status);
      setBusyId(null);
    }
  }

  // Open a pre-filled welcome email FROM 643bbot@gmail.com to this user — admin reviews
  // and hits Send. No email service, API key, or DNS involved.
  function resendWelcome(u){
    openWelcomeEmail(u, notify);
  }

  // HARD DELETE — removes the user + all their reports, clips, pitches, batted balls,
  // measurements, notifications, messages AND their Supabase Auth account. Irreversible.
  // Triple-confirms by typing the user's name to avoid accidents.
  function deleteUser(u){
    if(bbotIsAdmin(u)){
      notify("Cannot delete the admin account","error"); return;
    }
    var displayName=(u.firstName||"")+" "+(u.lastName||"");   // used in the success notice below
    // Deletes on press — the typed-name confirmation was removed per admin request. The action stays
    // admin-gated end to end (bbotAdminHeaders here, _require_admin on /delete-user) and the admin
    // account itself is still protected above. Irreversible: profile, reports, clips, pitches, batted
    // balls, measurements, notifications, messages and the login account all go.
    setBusyId(u.id);
    fetch(BACKEND_URL+"/delete-user",{
      method:"POST", headers:bbotAdminHeaders(),
      body: JSON.stringify({userId:String(u.id), email:u.email||null})
    }).then(function(r){
      if(!r.ok) return r.text().then(function(t){ throw new Error("HTTP "+r.status+": "+(t||"").slice(0,200)); });
      // Remove from local state so the row disappears without a refresh.
      setUsers(function(allU){ return allU.filter(function(x){return x.id!==u.id;}); });
      notify(displayName.trim()+" permanently deleted.");
    }).catch(function(err){
      notify("Delete failed: "+((err&&err.message)||"unknown"),"error");
    }).finally(function(){ setBusyId(null); });
  }

  var pendingCount=all.filter(isPending).length;
  function approveAllPending(){
    var pend=all.filter(isPending);
    if(!pend.length) return notify("No pending profiles","error");
    if(!window.confirm("Approve all "+pend.length+" pending profiles?\\n\\nThis unlocks their accounts. Send each their welcome with the “✉ Welcome email” button. Only do this if you've reviewed them.")) return;
    pend.forEach(function(u){ setStatus(u,"approved"); });
  }

  var typeBadge={player:["#dbeafe","#1e40af"],coach:["#ede9fe","#5b21b6"],staff:["#fef3c7","#92400e"]};
  return (
    <div>
      <SectionHeader>Profile Approvals</SectionHeader>
      <div style={{fontSize:12,color:C.gray500,marginBottom:14}}>Every new signup waits here until you approve it. Approving unlocks the account's access (uploads, evaluations). To welcome them, click “✉ Welcome email” — it opens a pre-filled email from 643bbot@gmail.com for you to review and Send. This protects the site from spam signups and unwanted backend costs.</div>

      <UnassignedPlayersPanel users={users} setUsers={setUsers} notify={notify}/>

      {filter==="pending" && pendingCount>0 && (
        <div style={{display:"flex",justifyContent:"flex-end",marginBottom:10,gap:8}}>
          <Btn v="primary" style={{fontSize:12,padding:"7px 14px"}} onClick={approveAllPending}>✓ Approve all pending ({pendingCount})</Btn>
        </div>
      )}

      {/* Orphan auth cleanup — sweeps Supabase Auth accounts left behind by interrupted
          signups (auth created, profile never written). Rare but accumulates over time.
          Hard-deletes them so the same email can re-sign up. Admin-only. */}
      <div style={{display:"flex",justifyContent:"flex-end",marginBottom:10}}>
        <button onClick={function(){
          if(!window.confirm("Sweep Supabase Auth for accounts with no matching profile?\n\nThis hard-deletes orphan auth rows so users with interrupted signups can retry. Admin accounts are protected.")) return;
          fetch(BACKEND_URL+"/cleanup-orphan-auth", {method:"POST", headers:bbotAdminHeaders()})
            .then(function(r){
              if(!r.ok) return r.json().then(function(d){notify(errText(d&&d.detail,"Cleanup failed: HTTP "+r.status),"error");}).catch(function(){notify("Cleanup failed: HTTP "+r.status,"error");});
              return r.json().then(function(d){
                notify("Orphan auth cleanup: "+d.deleted+" deleted ("+d.found+" found, "+d.protectedSkipped+" admin-protected)");
              });
            })
            .catch(function(err){ notify("Cleanup error: "+(err.message||"network"),"error"); });
        }} style={{background:"transparent",border:"1px solid "+C.border,color:C.gray600,fontSize:11,padding:"6px 12px",borderRadius:6,cursor:"pointer",fontWeight:600}}>🧹 Sweep orphan auth accounts</button>
      </div>

      <div style={{display:"flex",gap:8,marginBottom:14,flexWrap:"wrap"}}>
        {[["pending","Pending"],["approved","Approved"],["denied","Denied"],["all","All"]].map(function(opt){
          var cnt=all.filter(function(u){
            if(opt[0]==="pending") return isPending(u);
            if(opt[0]==="approved") return isApproved(u);
            if(opt[0]==="denied") return isDenied(u);
            return true;
          }).length;
          return <button key={opt[0]} onClick={function(){setFilter(opt[0]);}} style={{padding:"6px 14px",borderRadius:14,border:"1px solid "+C.border,background:filter===opt[0]?C.navy:"transparent",color:filter===opt[0]?C.white:C.gray600,fontSize:11,fontWeight:600,cursor:"pointer"}}>{opt[1]} ({cnt})</button>;
        })}
      </div>

      {filtered.length===0 ? (
        <EmptyCard icon="✓" title="Nothing here" sub={"No "+filter+" profiles."}/>
      ) : (
        <div style={{display:"flex",flexDirection:"column",gap:10}}>
          {filtered.map(function(u){
            var tb=typeBadge[u.type]||["#f1f5f9","#475569"];
            return <Card key={u.id}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",flexWrap:"wrap",gap:12}}>
                <div style={{flex:1,minWidth:220}}>
                  <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:4,flexWrap:"wrap"}}>
                    <div style={{fontSize:14,fontWeight:700,color:C.navy}}>{u.firstName} {u.lastName}</div>
                    <span style={{background:tb[0],color:tb[1],padding:"2px 8px",borderRadius:10,fontSize:9,fontWeight:700,letterSpacing:.5,textTransform:"uppercase"}}>{u.type||"user"}</span>
                    {isPending(u) && <span style={{background:"#fef3c7",color:"#92400e",padding:"2px 8px",borderRadius:10,fontSize:9,fontWeight:700,letterSpacing:.5}}>PENDING</span>}
                    {isApproved(u) && <span style={{background:"#dcfce7",color:"#166534",padding:"2px 8px",borderRadius:10,fontSize:9,fontWeight:700,letterSpacing:.5}}>APPROVED</span>}
                    {isDenied(u) && <span style={{background:"#fee2e2",color:"#991b1b",padding:"2px 8px",borderRadius:10,fontSize:9,fontWeight:700,letterSpacing:.5}}>DENIED</span>}
                  </div>
                  <div style={{fontSize:11,color:C.gray500}}>{u.email}</div>
                  {u.createdAt && <div style={{fontSize:10,color:C.gray400,marginTop:4}}>Signed up: {new Date(u.createdAt).toLocaleDateString()}</div>}
                </div>
                <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
                  {!isApproved(u) && <Btn v="primary" style={{fontSize:11,padding:"6px 12px",opacity:busyId===u.id?0.6:1}} onClick={function(){ if(busyId!==u.id) setStatus(u,"approved"); }}>{busyId===u.id?"…":"✓ Approve"}</Btn>}
                  {!isDenied(u) && <Btn v="outline" style={{fontSize:11,padding:"6px 12px",color:"#dc2626"}} onClick={function(){setStatus(u,"denied");}}>✗ Deny</Btn>}
                  {isApproved(u) && <Btn v="ghost" style={{fontSize:11,padding:"6px 12px"}} onClick={function(){setStatus(u,"pending");}}>Revoke</Btn>}
                  {isApproved(u) && u.email && <Btn v="ghost" style={{fontSize:11,padding:"6px 12px"}} title="Opens a pre-filled welcome email from 643bbot@gmail.com — review and hit Send" onClick={function(){ resendWelcome(u); }}>✉ Welcome email</Btn>}
                  <Btn v="ghost" style={{fontSize:11,padding:"6px 12px",color:"#991b1b",border:"1px solid #fecaca"}} onClick={function(){ if(busyId!==u.id) deleteUser(u); }}>🗑 Delete</Btn>
                </div>
              </div>
            </Card>;
          })}
        </div>
      )}
    </div>
  );
}

// WELCOME EMAIL TEMPLATES — admin edits the role-specific templates here. Saved to
// bbot_site_content under 'emailTemplates' (the SAME row + shape the backend reads at send
// time). Editing is plain text; the backend wraps it in the branded HTML shell, so an admin
// can't break the layout. Saving replaces the previous template (last-write-wins).
function EmailTemplatesView({siteContent, saveSiteContent, notify}){
  var DEFAULTS={
    player:{subject:"Welcome to 643 BBOT — here's how your profile works",
      lead:"Your player profile is your objective scouting record.",
      steps:["Upload a session video (or have 643 film you) to request a BBOT evaluation.","An admin reviews the evaluation for accuracy before it's released.","Pay once to unlock the report + your stamped video clips.","Your reports, clips, charts, and metrics populate your profile automatically.","After 2+ sessions, request a Cumulative Player Evaluation — no new video needed."],
      note:"Every grade is tied to something visible on video. BBOT never guesses.",enabled:true},
    coach:{subject:"Welcome to 643 BBOT — your coach tools",
      lead:"Your coach profile lets you build rosters and scout objectively.",
      steps:["Create a roster (team or college name required).","Upload videos or request evaluations on behalf of your players.","Specify your recruiting needs and get BBOT player suggestions.","Use the compare tools to line prospects up side by side.","Follow players and request update notifications."],
      note:"Evaluations you request still go through admin review and player payment before release.",enabled:true},
    staff:{subject:"Welcome to 643 BBOT — staff access",
      lead:"Your staff profile is focused on running evaluations and managing your roster.",
      steps:["Run BBOT: pick a player, upload their session video, and run the evaluation.","Your evaluation goes to admin for review — this is the calibration step.","Once approved, it unlocks for the player to purchase.","Pull players onto your roster to track their reports, clips, and leaderboards.","Your referrals and report activity are tracked on your staff profile."],
      note:"Running an evaluation triggers the request only — it never charges anyone.",enabled:true}
  };
  var saved=(siteContent && siteContent.emailTemplates) || {};
  var [role,setRole]=useState("player");
  // working copy for the active role, seeded from saved-or-default
  function seed(r){ var s=saved[r]||{}; var d=DEFAULTS[r]; return {
    subject: s.subject!=null?s.subject:d.subject,
    lead: s.lead!=null?s.lead:d.lead,
    steps: Array.isArray(s.steps)?s.steps.slice():d.steps.slice(),
    note: s.note!=null?s.note:d.note,
    enabled: s.enabled!==false
  };}
  var [draft,setDraft]=useState(seed("player"));
  var [saving,setSaving]=useState(false);
  function switchRole(r){ setRole(r); setDraft(seed(r)); }
  function setField(k,v){ setDraft(function(d){var n=Object.assign({},d); n[k]=v; return n;}); }
  function setStep(i,v){ setDraft(function(d){var st=d.steps.slice(); st[i]=v; return Object.assign({},d,{steps:st});}); }
  function addStep(){ setDraft(function(d){return Object.assign({},d,{steps:d.steps.concat([""])});}); }
  function removeStep(i){ setDraft(function(d){var st=d.steps.slice(); st.splice(i,1); return Object.assign({},d,{steps:st});}); }

  function save(){
    setSaving(true);
    var cleanSteps=(draft.steps||[]).map(function(s){return String(s||"").trim();}).filter(Boolean);
    if(!String(draft.subject||"").trim()){ setSaving(false); return notify("Subject can't be empty","error"); }
    if(!cleanSteps.length){ setSaving(false); return notify("Add at least one step","error"); }
    var tpl={subject:String(draft.subject).trim(),lead:String(draft.lead||"").trim(),steps:cleanSteps,note:String(draft.note||"").trim(),enabled:draft.enabled!==false};
    var nextTemplates=Object.assign({}, saved, {}); nextTemplates[role]=tpl;
    var nextContent=Object.assign({}, siteContent||{}, {emailTemplates:nextTemplates});
    Promise.resolve(saveSiteContent(nextContent)).then(function(){
      notify(role.charAt(0).toUpperCase()+role.slice(1)+" welcome email saved — now the standard for future approvals.");
    }).catch(function(){ notify("Saved locally; sync failed","error"); }).finally(function(){ setSaving(false); });
  }
  function resetToDefault(){
    if(!window.confirm("Reset the "+role+" template to the built-in default? This replaces your current text after you Save.")) return;
    var d=DEFAULTS[role];
    setDraft({subject:d.subject,lead:d.lead,steps:d.steps.slice(),note:d.note,enabled:true});
  }

  var inputStyle={width:"100%",padding:"9px 11px",border:"1px solid "+C.border,borderRadius:8,fontSize:13,boxSizing:"border-box",fontFamily:"inherit"};
  var safeName="Alex";
  function preview(s){ return String(s||"").replace(/\{firstName\}/gi,safeName); }
  return (
    <div>
      <SectionHeader>Welcome Email Templates</SectionHeader>
      <div style={{fontSize:12,color:C.gray500,marginBottom:14}}>Edit the welcome email each new profile type receives <strong>when you approve them</strong>. Plain text only — we wrap it in the branded 643/BBOT layout automatically. Use <code style={{background:C.gray100,padding:"1px 5px",borderRadius:4}}>{"{firstName}"}</code> to insert the person's first name. Saving replaces the previous template.</div>

      <div style={{display:"flex",gap:8,marginBottom:16}}>
        {[["player","Player"],["coach","Coach"],["staff","Staff"]].map(function(o){
          return <button key={o[0]} onClick={function(){switchRole(o[0]);}} style={{padding:"7px 16px",borderRadius:14,border:"1px solid "+C.border,background:role===o[0]?C.coral:"transparent",color:role===o[0]?C.white:C.gray600,fontSize:12,fontWeight:700,cursor:"pointer"}}>{o[1]}</button>;
        })}
      </div>

      <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(280px,1fr))",gap:20}}>
        {/* EDITOR */}
        <div>
          <label style={{fontSize:11,fontWeight:700,color:C.gray600,display:"block",marginBottom:4}}>SUBJECT</label>
          <input style={inputStyle} value={draft.subject} onChange={function(e){setField("subject",e.target.value);}}/>
          <label style={{fontSize:11,fontWeight:700,color:C.gray600,display:"block",margin:"12px 0 4px"}}>OPENING LINE</label>
          <textarea style={Object.assign({},inputStyle,{minHeight:54,resize:"vertical"})} value={draft.lead} onChange={function(e){setField("lead",e.target.value);}}/>
          <label style={{fontSize:11,fontWeight:700,color:C.gray600,display:"block",margin:"12px 0 4px"}}>"HOW TO USE IT" STEPS</label>
          {draft.steps.map(function(s,i){
            return <div key={i} style={{display:"flex",gap:6,marginBottom:6,alignItems:"flex-start"}}>
              <div style={{fontSize:12,color:C.gray400,paddingTop:9,minWidth:16}}>{i+1}.</div>
              <textarea style={Object.assign({},inputStyle,{minHeight:38,resize:"vertical"})} value={s} onChange={function(e){setStep(i,e.target.value);}}/>
              <button onClick={function(){removeStep(i);}} style={{background:"none",border:"none",color:"#dc2626",cursor:"pointer",fontSize:16,padding:"4px 6px"}} title="Remove step">×</button>
            </div>;
          })}
          <button onClick={addStep} style={{background:"none",border:"1px dashed "+C.border,borderRadius:8,padding:"6px 12px",fontSize:12,color:C.gray600,cursor:"pointer",marginTop:2}}>+ Add step</button>
          <label style={{fontSize:11,fontWeight:700,color:C.gray600,display:"block",margin:"12px 0 4px"}}>HIGHLIGHTED NOTE (the gray box)</label>
          <textarea style={Object.assign({},inputStyle,{minHeight:48,resize:"vertical"})} value={draft.note} onChange={function(e){setField("note",e.target.value);}}/>
          <label style={{display:"flex",alignItems:"center",gap:8,margin:"14px 0",fontSize:12,color:C.gray700,cursor:"pointer"}}>
            <input type="checkbox" checked={draft.enabled!==false} onChange={function(e){setField("enabled",e.target.checked);}}/>
            Auto-send this email on approval
          </label>
          <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
            <Btn v="primary" style={{opacity:saving?0.6:1}} onClick={function(){ if(!saving) save(); }}>{saving?"Saving…":"Save Template"}</Btn>
            <Btn v="ghost" onClick={resetToDefault}>Reset to default</Btn>
          </div>
        </div>

        {/* LIVE PREVIEW */}
        <div>
          <div style={{fontSize:11,fontWeight:700,color:C.gray600,marginBottom:6}}>PREVIEW</div>
          <div style={{border:"1px solid "+C.border,borderRadius:12,overflow:"hidden"}}>
            <div style={{background:C.gray100,padding:"8px 12px",fontSize:11,color:C.gray600,borderBottom:"1px solid "+C.border}}>Subject: <strong>{preview(draft.subject)||"(empty)"}</strong></div>
            <div style={{padding:"16px 18px",fontFamily:"Inter,system-ui,sans-serif",color:C.navy,fontSize:13,lineHeight:1.5}}>
              <p style={{margin:"0 0 10px"}}>Hi {safeName},</p>
              <p style={{margin:"0 0 10px"}}>{preview(draft.lead)}</p>
              <p style={{fontWeight:600,margin:"0 0 4px"}}>How to use it:</p>
              <ol style={{paddingLeft:18,margin:"0 0 10px"}}>{draft.steps.filter(Boolean).map(function(s,i){return <li key={i} style={{marginBottom:5}}>{preview(s)}</li>;})}</ol>
              {draft.note && <p style={{background:"#f1f5f9",padding:"10px 12px",borderRadius:8,fontSize:12,margin:"0 0 10px"}}>{preview(draft.note)}</p>}
              <p style={{margin:0}}><span style={{color:C.blue,fontWeight:600}}>Open 643 BBOT →</span></p>
              <p style={{color:"#888",fontSize:11,marginTop:10}}>643 Sports MGMT · BBOT AI Scouting</p>
            </div>
          </div>
          {draft.enabled===false && <div style={{marginTop:8,fontSize:11,color:"#92400e",background:"#fffbeb",border:"1px solid #fcd34d",borderRadius:8,padding:"8px 10px"}}>Auto-send is OFF for this role — approving these profiles won't email them.</div>}
        </div>
      </div>
    </div>
  );
}

// Admin FAQ editor. Edits siteContent.faq = { players:[{q,a}], coaches:[{q,a}] } and
// saves to bbot_site_content. The public FaqPage reads the same shape. If a category
// is empty/unset, the public page falls back to DEFAULT_FAQ so the page is never blank.
function FaqAdminView({siteContent, saveSiteContent, notify}){
  var existing = (siteContent && siteContent.faq && typeof siteContent.faq==="object") ? siteContent.faq : null;
  var seed = existing || DEFAULT_FAQ;
  var [cat, setCat] = useState("players");
  var [players, setPlayers] = useState((seed.players||[]).map(function(x){return {q:x.q||"",a:x.a||""};}));
  var [coaches, setCoaches] = useState((seed.coaches||[]).map(function(x){return {q:x.q||"",a:x.a||""};}));
  var items = cat==="players" ? players : coaches;
  var setItems = cat==="players" ? setPlayers : setCoaches;

  function update(i, field, val){ setItems(function(arr){ var c=arr.slice(); c[i]=Object.assign({},c[i],{[field]:val}); return c; }); }
  function addItem(){ setItems(function(arr){ return arr.concat([{q:"",a:""}]); }); }
  function removeItem(i){ setItems(function(arr){ return arr.filter(function(_,j){return j!==i;}); }); }
  function move(i, dir){ setItems(function(arr){ var c=arr.slice(); var j=i+dir; if(j<0||j>=c.length) return c; var t=c[i]; c[i]=c[j]; c[j]=t; return c; }); }

  function save(){
    // Drop fully-empty rows so saving doesn't persist blank entries.
    var cleanP = players.filter(function(x){return (x.q||"").trim() || (x.a||"").trim();});
    var cleanC = coaches.filter(function(x){return (x.q||"").trim() || (x.a||"").trim();});
    var next = Object.assign({}, siteContent, {faq:{players:cleanP, coaches:cleanC}});
    var r = saveSiteContent(next);
    if(r && r.then){ r.then(function(){ notify("FAQ saved"); }).catch(function(){ notify("Save failed — please retry","error"); }); }
    else notify("FAQ saved");
  }
  function resetDefaults(){
    if(!window.confirm("Reset the "+cat+" FAQ to the built-in defaults? Your custom entries for this category will be replaced.")) return;
    setItems((DEFAULT_FAQ[cat]||[]).map(function(x){return {q:x.q,a:x.a};}));
    notify("Reset to defaults (not yet saved — click Save FAQ to persist)");
  }

  return(
    <div style={{maxWidth:760}}>
      <div style={{fontSize:12,color:C.gray500,marginBottom:14}}>Edit the public FAQ. Entries show on the FAQ page, split by Players and Coaches. Empty rows are dropped on save. If a category is left empty, the page falls back to built-in defaults.</div>

      <div style={{display:"flex",gap:8,marginBottom:16}}>
        {[["players","Players"],["coaches","Coaches / Scouts"]].map(function(opt){
          var active=cat===opt[0];
          return <button key={opt[0]} onClick={function(){setCat(opt[0]);}} style={{padding:"7px 16px",borderRadius:99,border:"1px solid "+(active?C.coral:C.border),background:active?C.coral:"transparent",color:active?C.white:C.gray600,fontSize:12,fontWeight:600,cursor:"pointer"}}>{opt[1]} ({(opt[0]==="players"?players:coaches).length})</button>;
        })}
      </div>

      <div style={{display:"flex",flexDirection:"column",gap:12}}>
        {items.map(function(item,i){
          return <Card key={i} style={{padding:14}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:8}}>
              <span style={{fontSize:11,fontWeight:700,color:C.gray400,letterSpacing:.5}}>#{i+1}</span>
              <div style={{display:"flex",gap:6}}>
                <button onClick={function(){move(i,-1);}} disabled={i===0} style={{background:"transparent",border:"1px solid "+C.border,borderRadius:5,padding:"2px 8px",cursor:i===0?"default":"pointer",color:i===0?C.gray300:C.gray600,fontSize:12}}>↑</button>
                <button onClick={function(){move(i,1);}} disabled={i===items.length-1} style={{background:"transparent",border:"1px solid "+C.border,borderRadius:5,padding:"2px 8px",cursor:i===items.length-1?"default":"pointer",color:i===items.length-1?C.gray300:C.gray600,fontSize:12}}>↓</button>
                <button onClick={function(){removeItem(i);}} style={{background:"transparent",border:"1px solid "+C.coral,borderRadius:5,padding:"2px 8px",cursor:"pointer",color:C.coral,fontSize:11,fontWeight:600}}>Remove</button>
              </div>
            </div>
            <input value={item.q} onChange={function(e){update(i,"q",e.target.value);}} placeholder="Question" style={{width:"100%",padding:"8px 10px",border:"1px solid "+C.border,borderRadius:6,fontSize:13,fontWeight:600,marginBottom:8,boxSizing:"border-box"}}/>
            <textarea value={item.a} onChange={function(e){update(i,"a",e.target.value);}} placeholder="Answer" rows={3} style={{width:"100%",padding:"8px 10px",border:"1px solid "+C.border,borderRadius:6,fontSize:13,lineHeight:1.6,boxSizing:"border-box",resize:"vertical"}}/>
          </Card>;
        })}
      </div>

      <div style={{display:"flex",gap:10,marginTop:16,flexWrap:"wrap"}}>
        <Btn v="ghost" onClick={addItem}>+ Add question</Btn>
        <Btn v="ghost" onClick={resetDefaults}>Reset {cat} to defaults</Btn>
        <div style={{flex:1}}/>
        <Btn v="primary" onClick={save}>Save FAQ</Btn>
      </div>
    </div>
  );
}

// Re-open an already-uploaded master to add activity tags (Run/Field/Hit) — the tag screen otherwise only
// appears right after upload. Lets the admin generate per-activity skeletons on existing masters, no re-upload.
function ExistingMasters({onOpen}){
  var mS=useState([]); var masters=mS[0], setMasters=mS[1];
  var lS=useState(true); var loading=lS[0], setLoading=lS[1];
  var skS=useState(null); var skelPlayers=skS[0], setSkelPlayers=skS[1];   // player_ids that already have per-activity skeletons
  var allS=useState(false); var showAll=allS[0], setShowAll=allS[1];
  useEffect(function(){
    Promise.all([
      sbSelect("bbot_uploads","?purpose=eq.master&order=created_at.desc&limit=20&select=object_key,file_name,created_at,lineup,session_type,session_date,metadata"),
      sbSelect("bbot_clips","?clip_type=eq.skeleton&select=player_id")
    ]).then(function(res){
      // dedupe by object_key (same master re-uploaded/re-segmented shows once — newest first)
      var _seen={};
      var _ms=(Array.isArray(res[0])?res[0]:[]).filter(function(r){ if(!r||!r.object_key||_seen[r.object_key]) return false; _seen[r.object_key]=1; return true; });
      setMasters(_ms);
      setSkelPlayers(new Set((Array.isArray(res[1])?res[1]:[]).map(function(c){return String(c.player_id);})));
      setLoading(false);
    }).catch(function(){ setMasters([]); setSkelPlayers(new Set()); setLoading(false); });
  },[]);
  if(loading) return null;
  // "Needs updates" = a ROSTERED master whose players still lack per-activity skeletons. A master with NO
  // lineup can't be tagged (no players) — it's dormant, so hide it. Fully-skeletoned masters are hidden too.
  function needsUpdate(m){
    var lineup=Array.isArray(m.lineup)?m.lineup:[];
    if(!lineup.length) return false;                          // no roster => dormant => hide
    return lineup.some(function(e){ var pid=e&&(e.playerId||e.player_id); return pid && skelPlayers && !skelPlayers.has(String(pid)); });
  }
  var pending=masters.filter(needsUpdate);
  var doneCount=masters.length-pending.length;
  var shown=showAll?masters:pending;
  if(!masters.length) return null;
  return (
    <Card style={{marginBottom:14}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"baseline",gap:8}}>
        <div style={{fontSize:11,fontWeight:700,color:C.navy,letterSpacing:.5,marginBottom:4,textTransform:"uppercase"}}>Re-open a master to tag</div>
        {doneCount>0 && <button onClick={function(){setShowAll(!showAll);}} style={{background:"none",border:"none",color:C.blue,fontSize:10,fontWeight:700,cursor:"pointer",padding:0}}>{showAll?("Only pending ("+pending.length+")"):("Show all ("+doneCount+" done)")}</button>}
      </div>
      <div style={{fontSize:11,color:C.gray500,marginBottom:10,lineHeight:1.5}}>Showing masters that still need activity tags / per-activity skeletons &mdash; no re-upload, no re-cut.</div>
      {!shown.length ? <div style={{fontSize:11,color:C.gray400,fontStyle:"italic",padding:"6px 0"}}>All masters have per-activity skeletons — nothing pending.</div> :
      <div style={{maxHeight:220,overflowY:"auto"}}>
        {shown.map(function(m){
          var md=m.metadata||{}; if(typeof md==="string"){try{md=JSON.parse(md);}catch(e){md={};}}
          var lineup=Array.isArray(m.lineup)?m.lineup:[]; var nm=m.file_name||((m.object_key||"").split("/").pop());
          return <div key={m.object_key} style={{display:"flex",justifyContent:"space-between",alignItems:"center",gap:10,padding:"8px 0",borderBottom:"1px solid "+C.gray100}}>
            <div style={{minWidth:0,flex:1}}>
              <div style={{fontSize:12,color:C.navy,fontWeight:600,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{nm}</div>
              <div style={{fontSize:10,color:C.gray400}}>{(m.session_type||"")+" · "+(""+(m.session_date||m.created_at||"")).slice(0,10)+" · "+lineup.length+" player"+(lineup.length===1?"":"s")}</div>
            </div>
            <Btn v="outline" style={{fontSize:11,flexShrink:0}} onClick={function(){ onOpen({objectKey:m.object_key, lineup:lineup, sessionType:m.session_type, sessionDate:m.session_date, teamName:md.teamName}); }}>Tag &rarr;</Btn>
          </div>;
        })}
      </div>}
    </Card>
  );
}

function SessionsView({users, lineups, notify, goToBbot}){
  var phaseS = useState("upload"); var phase = phaseS[0], setPhase = phaseS[1];
  // upload | lineup | uploading | segmenting | review | clipping | done
  var fileS = useState(null); var file = fileS[0], setFile = fileS[1];
  var sessionTypeS = useState("Live Game"); var sessionType = sessionTypeS[0], setSessionType = sessionTypeS[1];
  var sessionDateS = useState(new Date().toISOString().slice(0,10)); var sessionDate = sessionDateS[0], setSessionDate = sessionDateS[1];
  var teamNameS = useState(""); var teamName = teamNameS[0], setTeamName = teamNameS[1];
  var lineupEntriesS = useState([]); var lineupEntries = lineupEntriesS[0], setLineupEntries = lineupEntriesS[1];
  var uploadProgressS = useState(0); var uploadProgress = uploadProgressS[0], setUploadProgress = uploadProgressS[1];
  var objectKeyS = useState(null); var objectKey = objectKeyS[0], setObjectKey = objectKeyS[1];
  var proposalS = useState(null); var proposal = proposalS[0], setProposal = proposalS[1];
  var proposalIdS = useState(null); var proposalId = proposalIdS[0], setProposalId = proposalIdS[1];
  var clipsResultS = useState(null); var clipsResult = clipsResultS[0], setClipsResult = clipsResultS[1];
  var uploadedMetaS = useState(null); var uploadedMeta = uploadedMetaS[0], setUploadedMeta = uploadedMetaS[1];
  var autoEvalS = useState(false); var autoEval = autoEvalS[0], setAutoEval = autoEvalS[1];
  var errorS = useState(""); var error = errorS[0], setError = errorS[1];
  var savedLineupsS = useState([]); var savedLineups = savedLineupsS[0], setSavedLineups = savedLineupsS[1];
  // YouTube game review (game-side path): paste the uploaded game link, BBOT describes
  // per-player game performance gated on confirmed ID. Reuses the lineup built above.
  var ytUrlS = useState(""); var ytUrl = ytUrlS[0], setYtUrl = ytUrlS[1];
  var ytBusyS = useState(false); var ytBusy = ytBusyS[0], setYtBusy = ytBusyS[1];
  var ytResultS = useState(null); var ytResult = ytResultS[0], setYtResult = ytResultS[1];
  var ytNotesS = useState(""); var ytNotes = ytNotesS[0], setYtNotes = ytNotesS[1];

  function runYoutubeReview(){
    var u=(ytUrl||"").trim();
    if(!u){ notify("Paste the YouTube game link first","error"); return; }
    if(!/youtube\.com|youtu\.be/.test(u)){ notify("That doesn't look like a YouTube link","error"); return; }
    setYtBusy(true); setYtResult(null);
    fetch(BACKEND_URL+"/review-youtube-game", {
      method:"POST", headers:bbotAdminHeaders(),
      body: JSON.stringify({
        youtubeUrl:u, sessionDate, teamName,
        lineup: lineupEntries.map(function(e){return {jerseyNum:String(e.jerseyNum), playerId:e.playerId?String(e.playerId):null, playerName:e.playerName, position:e.position, isPitcher:!!e.isPitcher};}),
        adminNotes:(ytNotes||"").trim()||null
      })
    }).then(function(r){ if(!r.ok) return r.text().then(function(t){throw new Error(t||("HTTP "+r.status));}); return r.json(); })
      .then(function(out){ setYtResult(out); setYtBusy(false); notify("Game review complete — "+(out.described||[]).length+" players described, "+(out.unconfirmed||[]).length+" unconfirmed"); })
      .catch(function(err){ setYtBusy(false); notify("Game review failed: "+(err.message||"unknown"),"error"); });
  }

  // Pull existing roster of players for lineup builder
  var allPlayers = (users||[]).filter(function(u){return u.type==="player";});

  // Saved event lineups (from the roster builder's "Lineups → BBOT") so segmentation reuses the
  // roster instead of re-typing it. Most-recent first; batting lineups only (skip practice groups).
  var savedEventLineups = (lineups||[]).filter(function(l){ return l && (l.batting || l.players || l.entries); }).slice(0,12);
  function applyLineup(l){
    var src = l.batting || l.players || l.entries || [];
    var rows = (src||[]).map(function(e,i){
      var pid = e.playerId||e.player_id||null;
      var p = pid ? (allPlayers.find(function(x){return String(x.id)===String(pid);})||{}) : {};
      return {
        jerseyNum: String(e.jerseyNum||e.num||e.jersey||(p.jerseyNum||"")),
        playerId: pid?String(pid):null,
        playerName: e.playerName||e.name||((p.firstName||"")+" "+(p.lastName||"")).trim(),
        position: e.position||e.pos||p.position||"",
        battingOrder: e.battingOrder||e.order||(i+1),
        isPitcher: !!(e.isPitcher||e.pitcher)
      };
    }).filter(function(r){return r.jerseyNum||r.playerId;});
    if(!rows.length){ notify("That lineup has no players to load","error"); return; }
    setLineupEntries(rows);
    if(l.teamName||l.team_name) setTeamName(l.teamName||l.team_name);
    notify("Loaded "+rows.length+" players from saved lineup");
  }

  function addRow(){
    setLineupEntries(function(prev){return prev.concat([{jerseyNum:"", playerId:null, playerName:"", position:"", battingOrder:prev.length+1, isPitcher:false}]);});
  }
  function updateRow(i, field, value){
    setLineupEntries(function(prev){
      var copy = prev.slice();
      copy[i] = Object.assign({}, copy[i], {[field]: value});
      // Auto-fill name + position when player picked from roster
      if(field==="playerId" && value){
        var p = allPlayers.filter(function(x){return String(x.id)===String(value);})[0];
        if(p){
          copy[i].playerName = p.firstName + " " + p.lastName;
          if(p.position && !copy[i].position) copy[i].position = p.position;
          if(p.jerseyNum && !copy[i].jerseyNum) copy[i].jerseyNum = String(p.jerseyNum);
        }
      }
      return copy;
    });
  }
  function removeRow(i){
    setLineupEntries(function(prev){return prev.filter(function(_,idx){return idx!==i;});});
  }

  // PUT one multipart chunk with retry — the resilience that fixes big-file uploads: a dropped
  // connection retries just that part instead of failing the whole 1GB upload.
  function putPartWithRetry(url, blob, onLoaded, maxTries){
    maxTries = maxTries || 4;
    return new Promise(function(resolve, reject){
      function attempt(n){
        var xhr = new XMLHttpRequest();
        xhr.open("PUT", url, true);
        xhr.upload.onprogress = function(ev){ if(ev.lengthComputable && onLoaded) onLoaded(ev.loaded); };
        xhr.onload = function(){
          if(xhr.status>=200 && xhr.status<300){ resolve(); }
          else if(n<maxTries){ setTimeout(function(){attempt(n+1);}, 1200*n); }
          else reject(new Error("Upload part failed (HTTP "+xhr.status+")"));
        };
        xhr.onerror = function(){ if(n<maxTries){ setTimeout(function(){attempt(n+1);}, 1200*n); } else reject(new Error("Upload part network error")); };
        xhr.send(blob);
      }
      attempt(1);
    });
  }
  // Upload the master. Large files (>100MB) go through RESILIENT multipart (chunk + per-part retry +
  // server-side assemble); smaller files keep the simple single PUT. Resolves {objectKey, objectId}.
  function uploadMaster(){
    var LARGE = 100*1024*1024;
    if(file.size > LARGE){
      return fetch(BACKEND_URL+"/create-multipart-upload", {method:"POST", headers:bbotAdminHeaders(),
        body:JSON.stringify({fileName:file.name, fileSize:file.size, contentType:file.type||"video/mp4", purpose:"master"})})
        .then(function(r){ if(!r.ok) return r.text().then(function(t){throw new Error(t||("HTTP "+r.status));}); return r.json(); })
        .then(function(init){
          var parts=init.parts||[], partSize=init.partSize, done=0;
          function nextPart(idx){
            if(idx>=parts.length) return Promise.resolve();
            var p=parts[idx], start=(p.partNumber-1)*partSize, end=Math.min(file.size, start+partSize);
            return putPartWithRetry(p.url, file.slice(start,end), function(loaded){
              setUploadProgress(Math.min(99, Math.round(((idx + (loaded/Math.max(1,end-start)))/parts.length)*100)));
            }).then(function(){ done++; setUploadProgress(Math.min(99, Math.round((done/parts.length)*100))); return nextPart(idx+1); });
          }
          return nextPart(0).then(function(){
            return fetch(BACKEND_URL+"/complete-multipart-upload", {method:"POST", headers:bbotAdminHeaders(),
              body:JSON.stringify({objectKey:init.objectKey, uploadId:init.uploadId})})
              .then(function(r){ if(!r.ok) return r.text().then(function(t){throw new Error(t||("HTTP "+r.status));}); return r.json(); })
              .then(function(){ setUploadProgress(100); return {objectKey:init.objectKey, objectId:init.objectId}; });
          });
        });
    }
    // small file: existing single PUT
    return fetch(BACKEND_URL+"/create-upload-url", {method:"POST", headers:bbotAdminHeaders(),
      body:JSON.stringify({fileName:file.name, fileSize:file.size, contentType:file.type||"video/mp4", purpose:"master"})})
      .then(function(r){ if(!r.ok) return r.text().then(function(t){throw new Error(t||("HTTP "+r.status));}); return r.json(); })
      .then(function(meta){
        return new Promise(function(resolve, reject){
          var xhr=new XMLHttpRequest();
          xhr.open("PUT", meta.uploadUrl, true);
          xhr.setRequestHeader("Content-Type", file.type||"video/mp4");
          xhr.upload.onprogress=function(ev){ if(ev.lengthComputable) setUploadProgress(Math.round((ev.loaded/ev.total)*100)); };
          xhr.onload=function(){ if(xhr.status>=200&&xhr.status<300) resolve({objectKey:meta.objectKey, objectId:meta.objectId}); else reject(new Error("Upload HTTP "+xhr.status)); };
          xhr.onerror=function(){ reject(new Error("Upload network error")); };
          xhr.send(file);
        });
      });
  }

  function startUpload(){
    setError("");
    if(!file){ setError("Choose a video file first."); return; }
    if(!lineupEntries.length){ setError("Add at least one lineup entry."); return; }
    if(lineupEntries.some(function(e){return !e.jerseyNum;})){ setError("Every lineup row needs a jersey number."); return; }
    setPhase("uploading");
    setUploadProgress(0);

    Promise.resolve(bbotRefreshSession()).then(function(){
    if(!bbotAuthToken()){
      setPhase("error");
      setError("Your session expired. Sign out and back in, then retry.");
      if(notify) notify("Session expired — please sign in again","error");
      return;
    }
    return uploadMaster().then(function(meta){
      setObjectKey(meta.objectKey);
      // Confirm + register
      return fetch(BACKEND_URL+"/confirm-upload", {
        method:"POST",
        headers: bbotAdminHeaders(),
        body: JSON.stringify({
          objectKey: meta.objectKey, objectId: meta.objectId,
          purpose:"master", sessionDate, sessionType,
          fileName: file.name, fileSize: file.size,
          lineup: lineupEntries,
          metadata: {teamName: teamName}
        })
      }).then(function(){return meta;});
    }).then(function(meta){
      // DON'T auto-segment — wait for admin to manually trigger when ready to spend API
      setUploadedMeta(meta);
      setPhase("uploaded");
      notify && notify("Master uploaded. Click 'Run Segmentation' when ready to process (~$1 API cost).");
    }).catch(function(err){
      setError(err.message || "Failed");
      setPhase("upload");
    });
    });
  }

  function runSegmentation(){
    if(!uploadedMeta){ notify("Upload a file first","error"); return; }
    if(!window.confirm("Run BBOT segmentation on this master video?\\n\\nThis costs ~$1 in API spend. Clips will be cut after segmentation.")) return;
    setPhase("segmenting");
    fetch(BACKEND_URL+"/segment-master", {
      method:"POST",
      headers:bbotAdminHeaders(),
      body: JSON.stringify({
        objectKey: uploadedMeta.objectKey,
        sessionType, sessionDate, teamName,
        lineup: lineupEntries.map(function(e){return {jerseyNum:String(e.jerseyNum), playerId:e.playerId?String(e.playerId):null, playerName:e.playerName, position:e.position, battingOrder:e.battingOrder?Number(e.battingOrder):null, isPitcher:!!e.isPitcher};})
      })
    }).then(function(r){
      if(!r.ok) return r.text().then(function(t){throw new Error(t || ("Segment HTTP "+r.status));});
      return r.json();
    }).then(function(seg){
      setProposal(seg);
      setProposalId(seg.proposalId);
      setPhase("review");
      notify && notify("Segmentation complete — review and approve");
    }).catch(function(err){
      setError(err.message || "Failed");
      setPhase("uploaded");
    });
  }

  function legacyAutoSegment_REMOVED(){
    return null;
  }

  function updateSegField(i, field, value){
    setProposal(function(prev){
      var copy = Object.assign({}, prev);
      var segs = (copy.segments||[]).slice();
      segs[i] = Object.assign({}, segs[i], {[field]: value});
      copy.segments = segs;
      return copy;
    });
  }
  // Observation 2: admin re-tags the correct player from the roster. Sets jersey+playerId+name
  // together (so the rest of the pipeline attributes clips to the RIGHT player), and logs the
  // correction as a calibration signal (what BBOT proposed vs what it actually was).
  function setSegPlayer(i, playerId){
    setProposal(function(prev){
      var copy = Object.assign({}, prev);
      var segs = (copy.segments||[]).slice();
      var prior = segs[i] || {};
      if(!playerId){
        segs[i] = Object.assign({}, prior, {playerId:null, playerName:"", corrected:true});
      } else {
        var p = (allPlayers||[]).find(function(x){return String(x.id)===String(playerId);}) || {};
        var lu = (lineupEntries||[]).find(function(e){return String(e.playerId)===String(playerId);}) || {};
        var jersey = lu.jerseyNum || p.jerseyNum || prior.jerseyNum || "";
        // Log the correction if BBOT's proposed jersey differs from the corrected player's jersey.
        var proposedJersey = prior.jerseyNum || "";
        if(String(proposedJersey) !== String(jersey)){
          try {
            bbotAdminLog({
                action:"segment_retag",
                detail:{ proposedJersey:proposedJersey, correctedJersey:jersey, correctedPlayerId:String(playerId),
                         startSec:prior.startSec, endSec:prior.endSec, proposalId:copy.proposalId||null, confidence:prior.confidence||null },
                created_at:new Date().toISOString()
              }).catch(function(){});
          } catch(e){}
        }
        segs[i] = Object.assign({}, prior, {playerId:String(playerId), playerName:((p.firstName||"")+" "+(p.lastName||"")).trim()||lu.playerName||"", jerseyNum:String(jersey), corrected:true});
      }
      copy.segments = segs;
      return copy;
    });
  }
  function removeSeg(i){
    setProposal(function(prev){
      var copy = Object.assign({}, prev);
      copy.segments = (copy.segments||[]).filter(function(_,idx){return idx!==i;});
      return copy;
    });
  }
  // RETROFIT: add per-activity (Run/Field/Hit) skeletons to EXISTING players from the current activity tags,
  // WITHOUT re-cutting clips or re-evaluating. Calls the backend per player (timeout-safe). Existing clips +
  // reports are untouched — only skeleton clips are (re)generated per activity.
  function skeletonsOnly(){
    var segs = (proposal.segments||[]).map(function(s){
      var pid = s.playerId || null, nm = s.playerName || null;
      if(!pid && s.jerseyNum){ var m = lineupEntries.filter(function(e){return String(e.jerseyNum)===String(s.jerseyNum);})[0]; if(m){ pid = m.playerId?String(m.playerId):null; nm = m.playerName||nm; } }
      return {playerId:pid, playerName:nm, actionType:s.actionType||"play", startSec:Number(s.startSec)||0, endSec:Number(s.endSec)||0};
    }).filter(function(s){return s.playerId && s.endSec>s.startSec && s.actionType && s.actionType!=="play";});
    if(!segs.length){ notify("Tag activities as Run / Field / Hit first (not left as 'play')","error"); return; }
    var byP = {}; segs.forEach(function(s){ (byP[s.playerId]=byP[s.playerId]||[]).push(s); });
    var pids = Object.keys(byP);
    notify("Rendering Run/Field/Hit skeletons for "+pids.length+" player"+(pids.length===1?"":"s")+"… keep this tab open.");
    var done=0, made=0;
    (function next(i){
      if(i>=pids.length){ notify("✓ Skeletons added for "+done+"/"+pids.length+" players ("+made+" clips). Review + approve on each profile."); return; }
      fetch(BACKEND_URL+"/generate-skeletons-from-segments",{method:"POST",headers:bbotAdminHeaders(),
        body:JSON.stringify({objectKey:objectKey, sessionType:sessionType, sessionDate:sessionDate, segments:byP[pids[i]]})})
        .then(function(r){ if(!r.ok) return r.text().then(function(t){throw new Error(t||("HTTP "+r.status));}); return r.json(); })
        .then(function(out){ done++; made+=(out.rendered||0); notify("Player "+(i+1)+"/"+pids.length+": "+(((out.skeletons||{})[pids[i]])||[]).join(", ")||"done"); })
        .catch(function(err){ notify("Skeletons failed for a player: "+(err.message||"error"),"error"); })
        .finally(function(){ next(i+1); });
    })(0);
  }
  function approveAndClip(){
    setPhase("clipping");
    setError("");
    var segs = (proposal.segments||[]).map(function(s){
      // Resolve playerId by matching jersey number against supplied lineup
      var resolvedPlayerId = s.playerId || null;
      var resolvedPlayerName = s.playerName || null;
      if(!resolvedPlayerId && s.jerseyNum){
        var match = lineupEntries.filter(function(e){return String(e.jerseyNum)===String(s.jerseyNum);})[0];
        if(match){
          resolvedPlayerId = match.playerId ? String(match.playerId) : null;
          resolvedPlayerName = match.playerName || resolvedPlayerName;
        }
      }
      return {
        jerseyNum: s.jerseyNum ? String(s.jerseyNum) : null,   // OPTIONAL — the tag is the identity
        playerId: resolvedPlayerId,
        playerName: resolvedPlayerName,
        actionType: s.actionType||"play",
        startSec: Number(s.startSec)||0,
        endSec: Number(s.endSec)||0,
        clipType: s.clipType || proposal.clipType || null
      };
    }).filter(function(s){return s.endSec > s.startSec;});
    // STEP 1 — cut + rinse each player's clip (branded, card from THEIR profile). We do NOT use the
    // server-side autoEvaluate (it can't warm pose and would time out over several players) — instead we
    // drive the SAME per-player warm+eval the individual flow uses (STEP 2), so each tagged player gets
    // pose (skeleton + mechanics graphs) + a full evaluation on their own profile. Tagging IS the trigger.
    fetch(BACKEND_URL+"/generate-clips", {
      method:"POST",
      headers:bbotAdminHeaders(),
      body: JSON.stringify({
        objectKey, proposalId,
        sessionType, sessionDate, teamName,
        clipType: proposal.clipType || null,
        autoEvaluate: false,
        videoSource: "643",
        segments: segs
      })
    }).then(function(r){
      if(!r.ok) return r.text().then(function(t){throw new Error(t || ("Clip HTTP "+r.status));});
      return r.json();
    }).then(function(out){
      setClipsResult(out);
      setPhase("done");
      // Only player-linked clips can be evaluated + land on a profile; a tag WITHOUT a profile is skipped.
      var evalClips = (out.clips||[]).filter(function(c){return c && c.clip_object_key && c.player_id;});
      notify && notify((out.clipsCreated||0)+" rinsed clip"+((out.clipsCreated===1)?"":"s")+" created"+(out.skippedCount?(" · "+out.skippedCount+" dupe skipped"):"")+(evalClips.length?" — evaluating each player…":""));
      // STEP 2 — sequential per player: warm pose (skeleton + mechanics), then evaluate (report + graphs).
      // HARDENED (fixes the bulk stall): each step is wrapped in a TIMEOUT so a hung warm or eval can't
      // freeze the whole run — on timeout OR error we record the failure and CONTINUE to the next player,
      // then report a summary so the admin can re-run only the ones that failed. Sequential so the pose
      // service is never overloaded; each player's profile fills as it finishes. NOTE: this loop runs in
      // THIS browser tab — keep it open until the summary shows (warm can't run server-side on the host).
      var WARM_MS = 6*60*1000;   // pose warm is ~1-2 min PER WINDOW (a clip may have several) — generous cap
      var EVAL_MS = 4*60*1000;
      function withTimeout(p, ms, label){
        return new Promise(function(resolve, reject){
          var to = setTimeout(function(){ reject(new Error((label||"step")+" timed out after "+Math.round(ms/1000)+"s")); }, ms);
          Promise.resolve(p).then(function(v){ clearTimeout(to); resolve(v); },
                                  function(e){ clearTimeout(to); reject(e); });
        });
      }
      var i = 0, okN = 0, failN = 0, fails = [];
      function finishBulk(){
        if(evalClips.length){
          notify && notify("✓ Bulk complete — "+okN+"/"+evalClips.length+" evaluated"
            +(failN?(" · "+failN+" failed ("+fails.join(", ")+") — re-run those from their profile"):"")
            +". Rinsed clip + skeleton + evaluation on each profile.");
        }
        setClipsResult(function(prev){ return Object.assign({}, prev||{}, {evalResults:{succeeded:okN, failed:failN, failedNames:fails}}); });
      }
      function nextPlayer(){
        if(i >= evalClips.length){ finishBulk(); return; }
        var c = evalClips[i++];
        var pl = (users||[]).filter(function(u){return String(u.id)===String(c.player_id);})[0] || {};
        var _kind = /BP|BATTING/i.test(String(sessionType||"")) ? "hitter"
                  : ((/^(P|RHP|LHP|SP|RP)$/i.test(String(pl.position||"")) || pl.isPitcher) ? "pitcher" : "hitter");
        var _nm = ((pl.firstName||"")+" "+(pl.lastName||"")).trim() || c.player_name || "player";
        notify && notify("Evaluating "+_nm+" ("+i+"/"+evalClips.length+")…");
        withTimeout(
          bbotWarmPose(c.clip_object_key, sessionType, function(){}, _kind,
            (pl.heightInches || heightToInches(pl.height)) || null,
            { name:_nm, position:pl.position||null, age:seasonAge(pl), throws:pl.throws||null }),
          WARM_MS, "pose warm")
        .then(function(){
          // HITTING WINDOW in CLIP time = the Hit (at_bat) fragments' band within this player's concatenated
          // clip (fragments concat in start order; clip-time offset = cumulative durations). The backend uses
          // it to attribute overlay readings: in-window = exit velo, out-of-window = throw velo (throws plural).
          var _pSegs = segs.filter(function(s){return String(s.playerId)===String(c.player_id);})
                           .slice().sort(function(a,b){return (a.startSec||0)-(b.startSec||0);});
          var _off=0, _hitS=null, _hitE=null;
          // CANONICALISED, NOT COMPARED TO A LITERAL. This read `=== "at_bat"`, which was the only
          // spelling the old flat option list could produce. The activity vocabulary emits
          // "hitting", so on every newly tagged session _hitS stayed null and the window silently
          // stopped shipping -- a compatibility path quietly losing its input because the thing
          // upstream of it learned a new word. Through bbotCanonKind it accepts at_bat, hitting,
          // bp and batting alike, which is the whole reason that map exists.
          _pSegs.forEach(function(s){ var d=Math.max(0,(Number(s.endSec)||0)-(Number(s.startSec)||0));
            if(bbotCanonKind(s.actionType)==="hitting"){ if(_hitS===null) _hitS=_off; _hitE=_off+d; } _off+=d; });
          var _body = { system: BBOT_SYSTEM_PROMPT, prompt: "Evaluate this "+sessionType+" session.",
              playerId: c.player_id, position: pl.position||"", sessionDate: sessionDate, sessionType: sessionType,
              objectKey: c.clip_object_key, sessionMode: "individual" };
          // BLOCKS ARE THE PRIMARY PATH. Every activity is sent with a canonical kind, so the backend
          // resolves each reading against the activity in progress instead of asking the single
          // question "was this inside the hitting window". The window still ships for compatibility,
          // but it is no longer what decides whether a throw becomes an exit velocity.
          var _blocks = bbotActivityBlocks(segs, c.player_id);
          if(_blocks.length) _body.activityBlocks = _blocks;
          if(_hitS!==null){ _body.hittingStartS=_hitS; _body.hittingEndS=_hitE; }
          return withTimeout(
            fetch(BACKEND_URL+"/evaluate", { method:"POST", headers:bbotAdminHeaders(), body: JSON.stringify(_body) })
              .then(function(r){ if(!r.ok) throw new Error("eval HTTP "+r.status); return r; }),
            EVAL_MS, "evaluation");
        })
        .then(function(){ okN++; nextPlayer(); })
        .catch(function(err){ failN++; fails.push(_nm);
          notify && notify("⚠ "+_nm+" didn't finish ("+((err&&err.message)||"error")+") — continuing to next player"); nextPlayer(); });
      }
      nextPlayer();
    }).catch(function(err){
      setError(err.message || "Clip generation failed");
      setPhase("review");
    });
  }

  function reset(){
    setFile(null); setLineupEntries([]); setObjectKey(null);
    setProposal(null); setProposalId(null); setClipsResult(null);
    setUploadedMeta(null);
    setUploadProgress(0); setError(""); setPhase("upload");
  }

  // RETIRED. This flat list was neither the confirmed tool vocabulary nor per-player-type: it
  // offered "defensive_position" and "warmup", which file to no tool at all, and offered a
  // pitcher an at-bat. The options now come from BBOT_TOOL_ACTIVITY, narrowed by the tagged
  // player's type, so the thing tagged at segmentation IS the tool the card reports on.

  return (
    <div>
      <SectionHeader>Master Session Upload &amp; Segmentation</SectionHeader>

      {error && <div style={{padding:"10px 14px",background:"#fff3f0",border:"1px solid "+C.coral,borderRadius:8,color:"#b03a26",marginBottom:14,fontSize:12}}>{error}</div>}

      {phase==="upload" && (
        <div style={{display:"flex",flexDirection:"column",gap:14}}>
          <ExistingMasters onOpen={function(m){
            setObjectKey(m.objectKey);
            setLineupEntries(Array.isArray(m.lineup)?m.lineup:[]);
            if(m.sessionType) setSessionType(m.sessionType);
            if(m.sessionDate) setSessionDate(m.sessionDate);
            setTeamName(m.teamName||"");
            setUploadedMeta({objectKey:m.objectKey});
            setPhase("uploaded");
            notify && notify("Master re-opened — tag activities (Run/Field/Hit), then use '+ Skeletons only'.");
          }}/>
          <div style={{padding:"12px 14px",background:C.blueFaint,border:"1px solid "+C.blueLight,borderRadius:8}}>
            <div style={{fontWeight:700,color:C.navy,marginBottom:4,letterSpacing:.3,fontSize:13}}>📹 For the most accurate evaluation:</div>
            <div style={{fontSize:12,color:C.gray600,lineHeight:1.55}}>Film each player so every tool is visible — hitting, fielding, throwing, and running. Footage that shows only part of a player's game produces a partial evaluation, grading what's observable and marking the rest "not observable this session." Official 643-filmed sessions are designed to capture every tool.</div>
          </div>
          <Card>
            <div style={{fontSize:11,fontWeight:700,color:C.navy,letterSpacing:.5,marginBottom:10,textTransform:"uppercase"}}>Session Details</div>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:10,marginBottom:14}}>
              <div>
                <label style={{fontSize:10,color:C.gray500,fontWeight:600,display:"block",marginBottom:3,letterSpacing:.5}}>SESSION TYPE</label>
                <select value={sessionType} onChange={function(e){setSessionType(e.target.value);}} style={{width:"100%",padding:"7px 10px",border:"1px solid "+C.border,borderRadius:6,fontSize:12}}>
                  {SESSION_TYPES.map(function(t){return <option key={t.value} value={t.value}>{t.label}</option>;})}
                </select>
              </div>
              <div>
                <label style={{fontSize:10,color:C.gray500,fontWeight:600,display:"block",marginBottom:3,letterSpacing:.5}}>SESSION DATE</label>
                <input type="date" value={sessionDate} onChange={function(e){setSessionDate(e.target.value);}} style={{width:"100%",padding:"7px 10px",border:"1px solid "+C.border,borderRadius:6,fontSize:12}}/>
              </div>
              <div>
                <label style={{fontSize:10,color:C.gray500,fontWeight:600,display:"block",marginBottom:3,letterSpacing:.5}}>TEAM NAME (optional)</label>
                <input value={teamName} onChange={function(e){setTeamName(e.target.value);}} placeholder="e.g. 643 Sports 17U" style={{width:"100%",padding:"7px 10px",border:"1px solid "+C.border,borderRadius:6,fontSize:12}}/>
              </div>
            </div>

            <div style={{fontSize:11,fontWeight:700,color:C.navy,letterSpacing:.5,marginBottom:10,textTransform:"uppercase"}}>Lineup &mdash; Active Jersey Numbers</div>
            <div style={{fontSize:11,color:C.gray500,marginBottom:10}}>BBOT identifies players by jersey. Add every player who appears in this video.</div>
            {savedEventLineups.length>0 && (
              <div style={{marginBottom:12,padding:"8px 10px",background:C.blueFaint,border:"1px solid "+C.blueLight,borderRadius:8}}>
                <div style={{fontSize:10,fontWeight:700,color:C.navy,letterSpacing:.5,marginBottom:6}}>↳ APPLY A SAVED EVENT LINEUP (from the roster builder)</div>
                <div style={{display:"flex",flexWrap:"wrap",gap:6}}>
                  {savedEventLineups.map(function(l,li){
                    var cnt=(l.batting||l.players||l.entries||[]).length;
                    return <button key={li} onClick={function(){applyLineup(l);}} style={{padding:"5px 10px",borderRadius:6,border:"1px solid "+C.blue,background:C.white,color:C.blue,fontSize:11,fontWeight:600,cursor:"pointer"}}>{(l.teamName||l.team_name||l.name||"Lineup")}{l.sessionDate||l.session_date?(" · "+(l.sessionDate||l.session_date)):""} ({cnt})</button>;
                  })}
                </div>
              </div>
            )}
            {lineupEntries.map(function(row, i){
              return <div key={i} style={{marginBottom:14,padding:10,background:C.gray50,borderRadius:8,border:"1px solid "+C.border}}>
                <div style={{marginBottom:6}}>
                  <SearchSelect
                    value={row.playerId||""}
                    onChange={function(v){updateRow(i,"playerId",v);}}
                    options={allPlayers.map(function(p){return {value:p.id, label:p.firstName+" "+p.lastName, sub:[p.position,p.jerseyNum?"#"+p.jerseyNum:null,p.hsName||p.clubName].filter(Boolean).join(" · ")};})}
                    placeholder="Search roster (player name)..."
                    allowCustom={false}
                  />
                </div>
                <div style={{display:"grid",gridTemplateColumns:"60px 70px 70px 1fr 28px",gap:6,alignItems:"center"}}>
                  <input value={row.jerseyNum} onChange={function(e){updateRow(i,"jerseyNum",e.target.value);}} placeholder="#" style={{padding:"6px 8px",border:"1px solid "+C.border,borderRadius:6,fontSize:12,textAlign:"center"}}/>
                  <input value={row.position} onChange={function(e){updateRow(i,"position",e.target.value);}} placeholder="Pos" style={{padding:"6px 8px",border:"1px solid "+C.border,borderRadius:6,fontSize:12}}/>
                  <input type="number" value={row.battingOrder} onChange={function(e){updateRow(i,"battingOrder",e.target.value);}} placeholder="Order" style={{padding:"6px 8px",border:"1px solid "+C.border,borderRadius:6,fontSize:12}}/>
                  <label style={{fontSize:10,color:C.gray600,display:"flex",alignItems:"center",gap:4,cursor:"pointer",justifyContent:"flex-start",whiteSpace:"nowrap"}}><input type="checkbox" checked={!!row.isPitcher} onChange={function(e){updateRow(i,"isPitcher",e.target.checked);}} style={{margin:0}}/><span>PITCHER</span></label>
                  <button onClick={function(){removeRow(i);}} style={{background:"none",border:"none",color:C.coral,cursor:"pointer",fontSize:14}}>×</button>
                </div>
              </div>;
            })}
            <button onClick={addRow} style={{padding:"6px 12px",background:"#fff",border:"1px dashed "+C.border,borderRadius:6,fontSize:11,color:C.navy,cursor:"pointer",marginTop:6,fontWeight:600}}>+ Add Lineup Row</button>

            <div style={{marginTop:18,paddingTop:14,borderTop:"1px solid "+C.border}}>
              <div style={{fontSize:11,fontWeight:700,color:C.navy,letterSpacing:.5,marginBottom:10,textTransform:"uppercase"}}>Master Video File</div>
              <CameraAngleGuidance/>
              <input type="file" accept=".mp4,.mov,.m4v,.webm" onChange={function(e){var f=e.target.files&&e.target.files[0];if(f)setFile(f);}} style={{display:"block",marginBottom:10,fontSize:12}}/>
              {file && <div style={{fontSize:11,color:C.gray600,marginBottom:10}}>{file.name} &middot; {Math.round(file.size/(1024*1024))} MB</div>}
              <Btn v="primary" onClick={startUpload} disabled={!file||!lineupEntries.length}>Upload &amp; Run BBOT Segmentation</Btn>
            </div>
          </Card>
        </div>
      )}

      {(phase==="uploading"||phase==="segmenting") && (
        <Card>
          <div style={{textAlign:"center",padding:20}}>
            <div style={{fontSize:13,color:C.navy,fontWeight:700,marginBottom:10}}>
              {phase==="uploading"?"Uploading master video... "+uploadProgress+"%":"BBOT is scanning frames..."}
            </div>
            <div style={{height:6,background:C.gray100||"#e5e7eb",borderRadius:3,overflow:"hidden",marginBottom:8}}>
              <div style={{height:"100%",width:(phase==="uploading"?uploadProgress:50)+"%",background:C.coral,transition:"width .3s"}}/>
            </div>
            <div style={{fontSize:11,color:C.gray500}}>
              {phase==="segmenting"?"Identifying players by jersey number — this may take 1-2 minutes for a full game.":"Direct upload to R2 storage."}
            </div>
          </div>
        </Card>
      )}

      {phase==="uploaded" && uploadedMeta && (
        <Card>
          <div style={{padding:20}}>
            <div style={{fontSize:16,color:C.green||"#16a34a",fontWeight:700,marginBottom:6}}>✓ Master video uploaded</div>
            <div style={{fontSize:12,color:C.gray600,marginBottom:14}}>Stored in R2 ({uploadedMeta.fileName || "master.mp4"}). No API cost yet.</div>

            {/* Editable metadata before segmentation */}
            <div style={{padding:12,background:C.gray50,borderRadius:8,marginBottom:14}}>
              <div style={{fontSize:10,letterSpacing:.8,color:C.gray500,fontWeight:700,marginBottom:8,textTransform:"uppercase"}}>Session Details — Edit before segmentation</div>
              <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(140px,1fr))",gap:8}}>
                <div>
                  <div style={{fontSize:10,color:C.gray500,marginBottom:3}}>Session Type</div>
                  <select value={sessionType} onChange={function(e){setSessionType(e.target.value);}} style={{width:"100%",padding:"7px 10px",border:"1px solid "+C.border,borderRadius:6,fontSize:12,background:C.white}}>
                    {SESSION_TYPES.map(function(t){return <option key={t.value} value={t.value}>{t.label}</option>;})}
                  </select>
                </div>
                <div>
                  <div style={{fontSize:10,color:C.gray500,marginBottom:3}}>Session Date</div>
                  <input type="date" value={sessionDate} onChange={function(e){setSessionDate(e.target.value);}} style={{width:"100%",padding:"7px 10px",border:"1px solid "+C.border,borderRadius:6,fontSize:12}}/>
                </div>
                <div>
                  <div style={{fontSize:10,color:C.gray500,marginBottom:3}}>Team Name</div>
                  <input value={teamName||""} onChange={function(e){setTeamName(e.target.value);}} placeholder="(optional)" style={{width:"100%",padding:"7px 10px",border:"1px solid "+C.border,borderRadius:6,fontSize:12}}/>
                </div>
              </div>
            </div>

            {objectKey && <TagSegmenter objectKey={objectKey} lineup={lineupEntries} sessionType={sessionType} sessionDate={sessionDate} onProposal={function(res){ setProposal(res); setProposalId(null); setPhase("review"); }} notify={notify}/>}

            <div style={{padding:10,background:C.gray50,border:"1px solid "+C.border,borderRadius:6,fontSize:11,color:C.gray500,marginBottom:10}}>
              <strong>Or:</strong> AI auto-segmentation reads jerseys for you (~$1 Claude API spend). Tagging above is free and exact.
            </div>
            <div style={{display:"flex",gap:10,flexWrap:"wrap"}}>
              <Btn v="ghost" style={{fontSize:13}} onClick={runSegmentation}>AI Auto-Segment (~$1)</Btn>
              <Btn v="ghost" style={{fontSize:13}} onClick={reset}>Done — Defer</Btn>
            </div>

            <div style={{marginTop:14,fontSize:10,color:C.gray400,fontStyle:"italic"}}>
              You can find this video later under Video History and segment it then.
            </div>
          </div>
        </Card>
      )}

      {phase==="review" && proposal && (
        <div style={{display:"flex",flexDirection:"column",gap:14}}>
          <Card>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:10}}>
              <div>
                <div style={{fontSize:13,fontWeight:700,color:C.navy}}>Segmentation Proposal &mdash; Review &amp; Edit</div>
                <div style={{fontSize:11,color:C.gray500,marginTop:3}}>{proposal.summary||""}</div>
              </div>
              <div style={{fontSize:11,color:C.gray600}}>{(proposal.segments||[]).length} segments &middot; {proposal.frameCount ? (proposal.frameCount+" frames analyzed") : "manually tagged"}</div>
            </div>

            <div style={{maxHeight:480,overflow:"auto",border:"1px solid "+C.border,borderRadius:8}}>
              <table style={{width:"100%",borderCollapse:"collapse",fontSize:11}}>
                <thead>
                  <tr style={{background:C.gray50,position:"sticky",top:0}}>
                    <th style={{padding:"8px 10px",textAlign:"left",fontSize:10,color:C.gray500,letterSpacing:.5}}>JERSEY</th>
                    <th style={{padding:"8px 10px",textAlign:"left",fontSize:10,color:C.gray500,letterSpacing:.5}}>PLAYER</th>
                    <th style={{padding:"8px 10px",textAlign:"left",fontSize:10,color:C.gray500,letterSpacing:.5}}>ACTION</th>
                    <th style={{padding:"8px 10px",textAlign:"left",fontSize:10,color:C.gray500,letterSpacing:.5}}>START</th>
                    <th style={{padding:"8px 10px",textAlign:"left",fontSize:10,color:C.gray500,letterSpacing:.5}}>END</th>
                    <th style={{padding:"8px 10px",textAlign:"left",fontSize:10,color:C.gray500,letterSpacing:.5}}>DUR</th>
                    <th style={{padding:"8px 10px",textAlign:"left",fontSize:10,color:C.gray500,letterSpacing:.5}}>CONF</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {(proposal.segments||[]).map(function(s, i){
                    var dur = (Number(s.endSec)||0) - (Number(s.startSec)||0);
                    return <tr key={i} style={{borderTop:"1px solid "+C.gray50}}>
                      <td style={{padding:"4px 8px"}}><input value={s.jerseyNum||""} onChange={function(e){updateSegField(i,"jerseyNum",e.target.value);}} style={{width:46,padding:"4px 6px",border:"1px solid "+(s.corrected?C.green:C.border),borderRadius:4,fontSize:11,textAlign:"center"}} title={s.confidence==="Confirmed"?"BBOT confirmed this #":"BBOT's proposed # — verify"}/></td>
                      <td style={{padding:"4px 8px"}}>
                        <select value={s.playerId||""} onChange={function(e){setSegPlayer(i, e.target.value||null);}} style={{padding:"4px 6px",border:"1px solid "+(s.playerId?(s.corrected?C.green:C.border):C.coral),borderRadius:4,fontSize:11,maxWidth:160,background:s.playerId?C.white:C.coralFaint}} title="Re-tag: pick the correct player from the roster">
                          <option value="">{s.playerName?("? "+s.playerName):"⚑ Unidentified — pick player"}</option>
                          {(lineupEntries&&lineupEntries.length?lineupEntries.map(function(e){return {id:e.playerId,label:"#"+e.jerseyNum+" "+(e.playerName||"")};}):(allPlayers||[]).map(function(p){return {id:p.id,label:(p.jerseyNum?("#"+p.jerseyNum+" "):"")+p.firstName+" "+p.lastName};})).filter(function(o){return o.id;}).map(function(o){return <option key={o.id} value={o.id}>{o.label}</option>;})}
                        </select>
                      </td>
                      <td style={{padding:"4px 8px"}}>
                        {/* THE ACTIVITY TAG — human truth at ground truth, from the CONFIRMED TOOL
                            vocabulary for this player's type. BBOT never infers an action; the
                            person who is already watching the segment supplies it, in the same
                            write as the player and the boundaries. The options narrow to the tools
                            that player's card actually carries, so a tag cannot file a reading to a
                            section that will never render. */}
                        {(function(){
                          var _p = (allPlayers||[]).filter(function(p){return String(p.id)===String(s.playerId);})[0];
                          var _opts = bbotActivityOptions(_p);
                          var _cur = bbotCanonKind(s.actionType) || "";
                          return <select value={_cur} onChange={function(e){updateSegField(i,"actionType",e.target.value);}}
                                   title={_cur&&BBOT_TOOL_ACTIVITY[_cur]?("files to "+BBOT_TOOL_ACTIVITY[_cur].files):"pick the activity"}
                                   style={{padding:"4px 6px",border:"1px solid "+(_cur?C.border:C.coral),borderRadius:4,fontSize:11}}>
                            <option value="">⚑ pick activity</option>
                            {_opts.map(function(a){return <option key={a} value={a}>{BBOT_TOOL_ACTIVITY[a].label}</option>;})}
                          </select>;
                        })()}
                        {(function(){
                          // GUARDED ON THE ENTRY, NOT ON THE KIND. A kind the vocabulary does not
                          // carry is a legacy tag, not a crash: this view must still open on rows
                          // tagged before the vocabulary existed.
                          var _e = BBOT_TOOL_ACTIVITY[bbotCanonKind(s.actionType)];
                          return _e ? <div style={{fontSize:9,color:C.gray400,marginTop:2}}>→ {_e.files}</div> : null;
                        })()}
                      </td>
                      <td style={{padding:"4px 8px"}}><input type="number" step="0.1" value={s.startSec||0} onChange={function(e){updateSegField(i,"startSec",parseFloat(e.target.value));}} style={{width:60,padding:"4px 6px",border:"1px solid "+C.border,borderRadius:4,fontSize:11}}/></td>
                      <td style={{padding:"4px 8px"}}><input type="number" step="0.1" value={s.endSec||0} onChange={function(e){updateSegField(i,"endSec",parseFloat(e.target.value));}} style={{width:60,padding:"4px 6px",border:"1px solid "+C.border,borderRadius:4,fontSize:11}}/></td>
                      <td style={{padding:"4px 8px",fontSize:11,color:C.gray500}}>{dur.toFixed(1)}s</td>
                      <td style={{padding:"4px 8px",fontSize:10,color:s.confidence==="Confirmed"?(C.green||"#16a34a"):C.gray500}}>{s.confidence||""}</td>
                      <td style={{padding:"4px 8px"}}><button onClick={function(){removeSeg(i);}} style={{background:"none",border:"none",color:C.coral,cursor:"pointer",fontSize:14}}>×</button></td>
                    </tr>;
                  })}
                </tbody>
              </table>
            </div>

            {(proposal.unassigned||[]).length>0 && (
              <div style={{marginTop:12,padding:10,background:"#fff7ed",border:"1px solid #fed7aa",borderRadius:6,fontSize:11,color:"#9a3412"}}>
                <strong>{(proposal.unassigned||[]).length} unassigned segments:</strong>
                <ul style={{margin:"4px 0 0 14px",padding:0}}>
                  {(proposal.unassigned||[]).map(function(u,i){return <li key={i} style={{marginBottom:6,display:"flex",alignItems:"flex-start",gap:8,listStyle:"none"}}>
                    <div style={{flex:1}}>{u.startSec}–{u.endSec}s: {u.reason}</div>
                    <button onClick={function(){
                      setProposal(function(prev){
                        var copy = Object.assign({}, prev);
                        copy.segments = (copy.segments||[]).concat([{
                          jerseyNum: "",
                          playerId: null,
                          playerName: "",
                          // UNTAGGED BY DEFAULT. "play" filed to nothing and read as a
                          // decision; an empty tag reads as what it is -- not yet named --
                          // and the selector shows it in coral until a human names it.
                          actionType: "",
                          startSec: Number(u.startSec)||0,
                          endSec: Number(u.endSec)||0,
                          confidence: "Manual"
                        }]);
                        copy.unassigned = (copy.unassigned||[]).filter(function(_,j){return j!==i;});
                        return copy;
                      });
                    }} style={{background:C.coral,color:C.white,border:"none",padding:"3px 8px",borderRadius:4,fontSize:10,fontWeight:600,cursor:"pointer",whiteSpace:"nowrap"}}>+ Add to clip list</button>
                  </li>;})}
                </ul>
              </div>
            )}

            <div style={{marginTop:16,display:"flex",gap:10,justifyContent:"space-between",alignItems:"center",flexWrap:"wrap"}}>
              <div style={{fontSize:11,color:C.gray500,maxWidth:360}}>Each tagged player gets their own rinsed clip + skeleton + evaluation on their profile — automatically. No jersey required; the tag is the identity.</div>
              <div style={{display:"flex",gap:10,flexWrap:"wrap"}}>
                <Btn v="ghost" onClick={reset}>Cancel</Btn>
                <Btn v="outline" onClick={skeletonsOnly} title="Add one Run/Field/Hit skeleton per activity to existing players — no re-cut, no re-evaluate">+ Skeletons only</Btn>
                <Btn v="primary" onClick={approveAndClip}>Tag &amp; Evaluate {(proposal.segments||[]).length} Player Clip{((proposal.segments||[]).length===1)?"":"s"}</Btn>
              </div>
            </div>
          </Card>
        </div>
      )}

      {phase==="clipping" && (
        <Card>
          <div style={{textAlign:"center",padding:20}}>
            <div style={{fontSize:13,color:C.navy,fontWeight:700,marginBottom:10}}>Generating clips...</div>
            <div style={{fontSize:11,color:C.gray500}}>BBOT is cutting + branding each player's clip (~5–10 sec each). Then it warms pose + evaluates each player (~1–2 min per player) — you'll see per-player progress. Keep this tab open until it's done.</div>
          </div>
        </Card>
      )}

      {phase==="done" && clipsResult && (
        <Card>
          <div style={{textAlign:"center",padding:20}}>
            <div style={{fontSize:18,color:C.green||"#16a34a",fontWeight:700,marginBottom:10}}>✓ {clipsResult.clipsCreated} clips generated</div>
            {!clipsResult.evalResults && (
              <div style={{marginBottom:14,padding:10,background:C.blueFaint,border:"1px solid "+C.blueLight,borderRadius:6,fontSize:11,color:C.navy,textAlign:"left"}}>
                ⏳ Warming pose + evaluating each player now (~1–2 min each). Watch the notifications for per-player progress. <strong>Keep this tab open</strong> until the completion summary appears.
              </div>
            )}
            {clipsResult.evalResults && (
              <div style={{marginBottom:14,padding:10,background:C.gray50,borderRadius:6,fontSize:11,textAlign:"left"}}>
                <div style={{fontWeight:700,color:C.navy,marginBottom:6,letterSpacing:.5,textTransform:"uppercase"}}>Auto-Eval Results</div>
                <div>✓ Succeeded: <strong style={{color:C.green||"#16a34a"}}>{clipsResult.evalResults.succeeded||0}</strong></div>
                {clipsResult.evalResults.failed>0 && <div>✗ Failed: <strong style={{color:"#dc2626"}}>{clipsResult.evalResults.failed}</strong></div>}
                {clipsResult.evalResults.failedNames && clipsResult.evalResults.failedNames.length>0 && <div style={{marginTop:4,fontSize:10,color:"#991b1b"}}>Re-run from their profile: {clipsResult.evalResults.failedNames.join(", ")}</div>}
                {clipsResult.evalResults.skipped_no_player>0 && <div>○ Skipped (no player ID matched): <strong>{clipsResult.evalResults.skipped_no_player}</strong></div>}
                {clipsResult.evalResults.errors && clipsResult.evalResults.errors.length>0 && (
                  <div style={{marginTop:6,padding:6,background:"#fee2e2",borderRadius:4,fontSize:10,color:"#991b1b"}}>
                    First error: {clipsResult.evalResults.errors[0]}
                  </div>
                )}
              </div>
            )}
            <div style={{fontSize:12,color:C.gray600,marginBottom:16}}>Each clip is now on the respective player's profile, watermarked and ready for evaluation.</div>

            {goToBbot && (
              <div style={{padding:14,background:C.coralFaint,border:"1px solid "+C.coralLight,borderRadius:8,marginBottom:14,textAlign:"left"}}>
                <div style={{fontSize:11,fontWeight:700,color:C.coral,letterSpacing:.5,marginBottom:6,textTransform:"uppercase"}}>Build a Custom Report</div>
                <div style={{fontSize:11,color:C.gray600,marginBottom:10,lineHeight:1.5}}>Want a tailored evaluation focused on a specific tool, situation, or instruction? Open BBOT and use the Custom Report option to direct the build.</div>
                <Btn v="primary" style={{fontSize:12}} onClick={goToBbot}>Open BBOT → Custom Report</Btn>
              </div>
            )}

            <div style={{padding:14,background:C.gray50,borderRadius:8,marginBottom:14,textAlign:"left"}}>
              <div style={{fontSize:11,fontWeight:700,color:C.navy,letterSpacing:.5,marginBottom:8,textTransform:"uppercase"}}>Post-Segmentation Actions</div>
              <div style={{fontSize:11,color:C.gray600,marginBottom:12}}>The master video is still in R2 storage. To save costs, upload it to YouTube for cold storage, then delete from R2.</div>

              <Btn v="primary" full style={{marginBottom:8,fontSize:12,justifyContent:"center"}} onClick={function(){
                // Get fresh signed URL for download then open YouTube upload
                fetch(BACKEND_URL+"/r2-read-url?objectKey="+encodeURIComponent(objectKey))
                  .then(function(r){return r.json();})
                  .then(function(d){
                    if(!d.url){ notify("Could not generate download URL","error"); return; }
                    // Build YouTube upload URL with pre-filled metadata
                    var title = encodeURIComponent("643 Sports "+sessionType+" - "+sessionDate+(teamName?" - "+teamName:""));
                    var desc = encodeURIComponent("BBOT-segmented "+sessionType+" footage. "+(lineupEntries.length?lineupEntries.length+" players identified.":"")+" BBOT.");
                    // Open download in new tab + YouTube upload in another
                    window.open(d.url, "_blank");
                    setTimeout(function(){
                      window.open("https://www.youtube.com/upload?title="+title+"&description="+desc, "_blank");
                    }, 800);
                    notify("Master video download started. YouTube upload page opening — drag the downloaded file to upload.");
                  })
                  .catch(function(){ notify("Could not prepare master download","error"); });
              }}>↑ Download Master &amp; Open YouTube Upload</Btn>

              <Btn v="outline" full style={{fontSize:12,justifyContent:"center",color:"#dc2626",borderColor:"#fecaca"}} onClick={function(){
                if(!window.confirm("Delete master video from R2 storage?\\n\\nThis is PERMANENT. Make sure you have:\\n1. Uploaded the master to YouTube (or saved locally)\\n2. Verified all clips look correct\\n\\nClips will remain on player profiles after deletion.")) return;
                fetch(BACKEND_URL+"/delete-master", {
                  method:"POST",
                  headers:bbotAdminHeaders(),
                  body: JSON.stringify({objectKey: objectKey})
                }).then(function(r){return r.json();})
                  .then(function(d){
                    if(d.ok) notify("Master video deleted from R2. Storage freed.");
                    else notify("Delete failed: "+(d.error||"unknown"),"error");
                  })
                  .catch(function(){ notify("Delete request failed","error"); });
              }}>✗ Delete Master from R2 Storage</Btn>
            </div>

            <Btn v="primary" onClick={reset}>Upload Another Session</Btn>
          </div>
        </Card>
      )}

      {/* YOUTUBE GAME REVIEW — game-side path. Always available; uses the lineup above. */}
      <Card style={{marginTop:16,borderLeft:"3px solid "+C.coral}}>
        <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:13,color:C.navy,letterSpacing:1,marginBottom:4}}>▶ YOUTUBE GAME REVIEW</div>
        <div style={{fontSize:11,color:C.gray500,marginBottom:12,lineHeight:1.5}}>Paste the link to the game you uploaded to YouTube. BBOT describes each player's game performance — but only for players whose jersey/tag it can confirm in the footage. Unconfirmed plays go to a review list instead of being guessed. Uses the lineup you built above to attach descriptions to profiles.</div>
        <input value={ytUrl} onChange={function(e){setYtUrl(e.target.value);}} placeholder="https://youtu.be/… or https://youtube.com/watch?v=…" style={{width:"100%",padding:"8px 10px",border:"1px solid "+C.border,borderRadius:6,fontSize:12,boxSizing:"border-box",marginBottom:8}}/>
        <textarea value={ytNotes} onChange={function(e){setYtNotes(e.target.value);}} placeholder="Admin notes (optional) — context BBOT should consider. It won't invent measurements from these." rows={2} style={{width:"100%",padding:"8px 10px",border:"1px solid "+C.border,borderRadius:6,fontSize:11,boxSizing:"border-box",fontFamily:"inherit",marginBottom:10,resize:"vertical"}}/>
        <Btn v="primary" style={{fontSize:13}} onClick={runYoutubeReview} disabled={ytBusy}>{ytBusy?"Reviewing game…":"Review Game (~$1)"}</Btn>

        {ytResult && (
          <div style={{marginTop:14}}>
            <div style={{fontSize:11,color:C.gray600,marginBottom:8}}>{ytResult.summary||""} <span style={{color:C.gray400}}>· ID: {ytResult.idMethod}{ytResult.tagsConfirmed&&ytResult.tagsConfirmed.length?(" · tags: "+ytResult.tagsConfirmed.join(", ")):""}</span></div>
            {(ytResult.described||[]).length>0 && <button onClick={function(){
              setYtBusy(true);
              fetch(BACKEND_URL+"/save-game-descriptions", {
                method:"POST", headers:bbotAdminHeaders(),
                body: JSON.stringify({ sessionDate:sessionDate, youtubeUrl:ytUrl, described:(ytResult.described||[]).filter(function(d){return d.playerId;}) })
              }).then(function(r){return r.json();}).then(function(out){
                setYtBusy(false);
                notify("Saved "+(out.count||0)+" session report"+((out.count===1)?"":"s")+" to profiles (draft — review & release)"+((out.skippedCount)?(" · "+out.skippedCount+" skipped (already had a session report this date)"):""));
              }).catch(function(err){ setYtBusy(false); notify("Save failed: "+(err.message||"unknown"),"error"); });
            }} disabled={ytBusy} style={{marginBottom:10,padding:"7px 14px",borderRadius:7,border:"none",background:C.green||"#16a34a",color:C.white,fontSize:11,fontWeight:700,cursor:"pointer"}}>↑ Save {(ytResult.described||[]).filter(function(d){return d.playerId;}).length} confirmed to profiles (draft)</button>}
            {(ytResult.described||[]).length>0 && <div style={{marginBottom:10}}>
              <div style={{fontSize:11,fontWeight:700,color:C.green,marginBottom:6}}>✓ CONFIRMED & DESCRIBED ({(ytResult.described||[]).length})</div>
              {(ytResult.described||[]).map(function(d,i){return (
                <div key={i} style={{padding:"8px 10px",background:C.gray50,borderRadius:7,marginBottom:6}}>
                  <div style={{fontSize:12,fontWeight:700,color:C.navy}}>#{d.jerseyNum} {d.playerName||""} {d.standout&&<span style={{color:C.coral,fontSize:10,fontWeight:700}}>★ STANDOUT</span>} <span style={{fontSize:9,color:C.gray400}}>({d.idMethod})</span></div>
                  <div style={{fontSize:11,color:C.gray700,marginTop:3,lineHeight:1.5}}>{d.performance}</div>
                  {(d.measurements||[]).filter(function(m){return m.value;}).map(function(m,j){return <span key={j} style={{display:"inline-block",marginTop:4,marginRight:6,fontSize:10,fontWeight:700,color:C.navy,background:C.white,border:"1px solid "+C.border,borderRadius:4,padding:"1px 6px"}}>{m.type}: {m.value}{m.unit}</span>;})}
                  {!d.playerId && (
                    <div style={{marginTop:6}}>
                      <span style={{fontSize:10,color:C.coral,fontWeight:700,marginRight:6}}>⚑ confirmed but not linked — pick player to save:</span>
                      <select defaultValue="" onChange={function(e){var pid=e.target.value; setYtResult(function(prev){var c=Object.assign({},prev); c.described=(c.described||[]).map(function(x,xi){ if(xi!==i) return x; var p=(allPlayers||[]).find(function(pp){return String(pp.id)===String(pid);})||{}; return Object.assign({},x,{playerId:pid||null, playerName:x.playerName||((p.firstName||"")+" "+(p.lastName||"")).trim()}); }); return c;});}} style={{padding:"3px 6px",border:"1px solid "+C.coral,borderRadius:4,fontSize:11}}>
                        <option value="">— pick player —</option>
                        {(lineupEntries&&lineupEntries.length?lineupEntries.map(function(e){return {id:e.playerId,label:"#"+e.jerseyNum+" "+(e.playerName||"")};}):(allPlayers||[]).map(function(p){return {id:p.id,label:(p.jerseyNum?("#"+p.jerseyNum+" "):"")+p.firstName+" "+p.lastName};})).filter(function(o){return o.id;}).map(function(o){return <option key={o.id} value={o.id}>{o.label}</option>;})}
                      </select>
                    </div>
                  )}
                </div>
              );})}
            </div>}
            {(ytResult.unconfirmed||[]).length>0 && <div>
              <div style={{fontSize:11,fontWeight:700,color:C.coral,marginBottom:6}}>⚑ UNCONFIRMED — ADMIN REVIEW ({(ytResult.unconfirmed||[]).length})</div>
              <div style={{fontSize:10,color:C.gray500,marginBottom:6,fontStyle:"italic"}}>BBOT could not confirm who these were, so it did not describe them. Tag a player manually if you can identify them.</div>
              {(ytResult.unconfirmed||[]).map(function(u,i){return (
                <div key={i} style={{padding:"6px 10px",background:C.coralFaint,borderRadius:6,marginBottom:5,fontSize:11,color:C.gray700}}>{u.startSec!=null?(u.startSec+"–"+u.endSec+"s · "):""}{u.note||"unidentified action"}{u.sawJersey?(" (saw: "+u.sawJersey+")"):""}</div>
              );})}
            </div>}
          </div>
        )}
      </Card>
    </div>
  );
}

function AdminReportingView({scoutReports, users, cu}){
  var costS=useState(null); var costRows=costS[0]; var setCostRows=costS[1];
  // Pull eval-cost telemetry (admin log) for cost-per-report. Safe if table/rows absent.
  useEffect(function(){
    sbSelect("bbot_admin_log","?action=eq.eval_cost&order=id.desc&limit=500")
      .then(function(rows){ setCostRows(Array.isArray(rows)?rows:[]); })
      .catch(function(){ setCostRows([]); });
  }, []);

  var reports=(scoutReports||[]);
  var paidStatuses=["approved","published"];
  // "Issued" = approved or published (released). "Bought" = has a paid amount recorded.
  var issued=reports.filter(function(r){return paidStatuses.indexOf(r.status)>=0;});
  var bought=reports.filter(isReleasedToBuyer);
  var pending=reports.filter(function(r){return isDraftEval(r);});

  // Revenue from recorded amounts (cents → dollars)
  var revenue=reports.reduce(function(sum,r){return sum+((r.amountCents||r.amount_cents||0)/100);},0);

  // Weekly totals (last 8 weeks) by report date
  function weekKey(d){var dt=new Date(d); if(isNaN(dt))return null; var onejan=new Date(dt.getFullYear(),0,1); var wk=Math.ceil((((dt-onejan)/86400000)+onejan.getDay()+1)/7); return dt.getFullYear()+"-W"+String(wk).padStart(2,"0");}
  var weekMap={};
  issued.forEach(function(r){var k=weekKey(r.date||r.sessionDate); if(k){weekMap[k]=(weekMap[k]||0)+1;}});
  var weeks=Object.keys(weekMap).sort().slice(-8);

  // Per-staff referral / production counts
  var staffMap={};
  var staffDisplayName=function(r,k){
    if(r.staffName && r.staffName!=="Staff "+k) return r.staffName;
    if(String(k)==="99") return "643 Sports MGMT — BBOT Admin";
    var su=(users||[]).find(function(u){return String(u.id)===String(k);});
    if(su) return (su.firstName||"")+" "+(su.lastName||"");
    return "Staff "+k;
  };
  reports.forEach(function(r){
    if(!r.staffId) return;
    var k=String(r.staffId);
    if(!staffMap[k]) staffMap[k]={name:staffDisplayName(r,k), ran:0, issued:0};
    staffMap[k].ran++;
    if(paidStatuses.indexOf(r.status)>=0) staffMap[k].issued++;
  });
  var staffRows=Object.keys(staffMap).map(function(k){return Object.assign({id:k}, staffMap[k]);}).sort(function(a,b){return b.ran-a.ran;});

  // Cost per report from telemetry: API spend isn't dollar-logged, but elapsed/attempts are.
  // We surface count + avg attempts as the operational signal; $ cost is a fixed per-eval estimate.
  var EST_COST_PER_EVAL=0.28; // ~60-frame Sonnet eval, matches prior cost modeling
  var costCount=(costRows||[]).length;
  var estSpend=costCount*EST_COST_PER_EVAL;

  function Stat({label,value,sub,color}){
    return <Card style={{padding:"14px 16px",textAlign:"center"}}>
      <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:26,color:color||C.navy}}>{value}</div>
      <div style={{fontSize:10,color:C.gray400,letterSpacing:.5,fontWeight:600,marginTop:2}}>{label}</div>
      {sub&&<div style={{fontSize:10,color:C.gray400,marginTop:2}}>{sub}</div>}
    </Card>;
  }

  return (
    <div>
      <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(min(140px,100%),1fr))",gap:10,marginBottom:18}}>
        <Stat label="REPORTS ISSUED" value={issued.length} color={C.blue}/>
        <Stat label="REPORTS BOUGHT" value={bought.length} color={C.coral}/>
        <Stat label="PENDING APPROVAL" value={pending.length} color={C.orange}/>
        <Stat label="REVENUE" value={"$"+revenue.toFixed(2)} sub="recorded payments"/>
        <Stat label="EST. EVAL SPEND" value={"$"+estSpend.toFixed(2)} sub={costCount+" evals · ~$"+EST_COST_PER_EVAL.toFixed(2)+" ea"}/>
        <Stat label="EST. MARGIN" value={"$"+(revenue-estSpend).toFixed(2)} color={(revenue-estSpend)>=0?C.green||"#16a34a":C.coral}/>
      </div>

      <Card style={{padding:0,marginBottom:18,overflow:"hidden"}}>
        <div style={{padding:"12px 14px",borderBottom:"1px solid "+C.border}}><div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:13,color:C.navy,letterSpacing:1}}>WEEKLY REPORTS ISSUED</div></div>
        {weeks.length===0
          ? <div style={{padding:"16px",fontSize:12,color:C.gray400}}>No issued reports yet.</div>
          : <div style={{padding:"14px"}}>
              {weeks.map(function(w){var n=weekMap[w]; var max=Math.max.apply(null,weeks.map(function(x){return weekMap[x];})); return (
                <div key={w} style={{display:"flex",alignItems:"center",gap:10,marginBottom:7}}>
                  <span style={{fontSize:10,color:C.gray400,width:64,flexShrink:0}}>{w}</span>
                  <div style={{flex:1,background:C.gray100,borderRadius:4,height:16,overflow:"hidden"}}><div style={{width:(max?(n/max*100):0)+"%",height:"100%",background:C.blue}}/></div>
                  <span style={{fontSize:11,fontWeight:700,color:C.navy,width:24,textAlign:"right"}}>{n}</span>
                </div>
              );})}
            </div>}
      </Card>

      <Card style={{padding:0,overflow:"hidden"}}>
        <div style={{padding:"12px 14px",borderBottom:"1px solid "+C.border}}><div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:13,color:C.navy,letterSpacing:1}}>STAFF / REFERRAL PRODUCTION</div><div style={{fontSize:10,color:C.gray400,marginTop:2}}>Evaluations run and issued per staff member</div></div>
        {staffRows.length===0
          ? <div style={{padding:"16px",fontSize:12,color:C.gray400}}>No staff-attributed reports yet.</div>
          : <table style={{width:"100%",borderCollapse:"collapse"}}>
              <thead><tr style={{borderBottom:"1px solid "+C.border,background:C.gray50}}>
                <td style={{fontSize:9,color:C.gray400,fontWeight:700,padding:"8px 12px"}}>STAFF</td>
                <td style={{fontSize:9,color:C.gray400,fontWeight:700,padding:"8px 8px",textAlign:"center"}}>RAN</td>
                <td style={{fontSize:9,color:C.gray400,fontWeight:700,padding:"8px 8px",textAlign:"center"}}>ISSUED</td>
                <td style={{fontSize:9,color:C.gray400,fontWeight:700,padding:"8px 12px",textAlign:"center"}}>PROFILE</td>
              </tr></thead>
              <tbody>
                {staffRows.map(function(s){
                  var u=(users||[]).find(function(x){return String(x.id)===String(s.id);});
                  return <tr key={s.id} style={{borderBottom:"1px solid "+C.gray50}}>
                    <td style={{padding:"8px 12px",fontSize:12,fontWeight:600,color:C.navy}}>{s.name}</td>
                    <td style={{padding:"8px 8px",textAlign:"center",fontSize:12,color:C.gray700}}>{s.ran}</td>
                    <td style={{padding:"8px 8px",textAlign:"center",fontSize:12,color:C.gray700}}>{s.issued}</td>
                    <td style={{padding:"8px 12px",textAlign:"center",fontSize:11}}>{u?<span style={{color:C.blue}}>{u.email}</span>:<span style={{color:C.gray300}}>—</span>}</td>
                  </tr>;
                })}
              </tbody>
            </table>}
      </Card>
      <div style={{fontSize:10,color:C.gray400,marginTop:10,lineHeight:1.5}}>Eval spend is an estimate (~$0.28/eval at 60-frame analysis). "Bought" counts reports with a recorded payment amount or published status. Revenue reflects payment amounts written back by the payment processor.</div>
    </div>
  );
}

function AdminMetricsView({users, metrics}){
  var players=(users||[]).filter(function(u){return u.type==="player";}).sort(function(a,b){return (a.firstName+a.lastName).localeCompare(b.firstName+b.lastName);});
  var selS=useState(players.length?String(players[0].id):""); var sel=selS[0]; var setSel=selS[1];
  var player=players.find(function(p){return String(p.id)===String(sel);});
  var pM=(metrics||{})[sel]||[];
  return (
    <div>
      <SectionHeader>Player Metrics</SectionHeader>
      <div style={{fontSize:12,color:C.gray500,marginBottom:12}}>Select a player to view their metric progression over time.</div>
      <select value={sel} onChange={function(e){setSel(e.target.value);}} style={{width:"100%",maxWidth:360,padding:"10px 12px",fontSize:14,border:"1px solid "+C.border,borderRadius:8,marginBottom:18}}>
        <option value="">Select a player…</option>
        {players.map(function(p){return <option key={p.id} value={String(p.id)}>{p.firstName} {p.lastName}{p.position?" · "+p.position:""}{p.gradYear?" · "+p.gradYear:""}</option>;})}
      </select>
      {!player ? <EmptyCard icon="M" title="Select a Player" sub="Choose a player above to see their metric graphs."/> :
       pM.length===0 ? <EmptyCard icon="M" title="No Metrics Yet" sub={(player.firstName||"This player")+" has no logged metrics. Metrics auto-log from BBOT evals or can be entered manually."}/> :
       <div>
         <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:14}}>
           <Avatar user={player} size={40}/>
           <div><div style={{fontWeight:700,fontSize:15}}>{player.firstName} {player.lastName}</div><div style={{fontSize:12,color:C.gray400}}>{player.position||"Player"}{player.gradYear?" · Class "+player.gradYear:""} · {pM.length} session{pM.length===1?"":"s"}</div></div>
         </div>
         <MetricsView uM={pM}/>
         <div style={{marginTop:18}}>
           <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:12,color:C.coral,letterSpacing:1,marginBottom:8}}>LOGGED ENTRIES ({pM.length})</div>
           <div style={{display:"flex",flexDirection:"column",gap:4}}>
             {pM.slice().reverse().map(function(entry,i){
               return <MetricEntryRow key={(entry.date||"")+"-"+i} entry={entry}/>;
             })}
           </div>
         </div>
       </div>}
    </div>
  );
}

function MetricEntryRow({entry}){
  var openS=useState(false); var open=openS[0]; var setOpen=openS[1];
  // Show every recorded numeric/string field for this session entry, except internal keys.
  var skip={date:true,reportId:true,id:true,playerId:true,player_id:true,report_id:true};
  var fields=Object.keys(entry||{}).filter(function(k){ return !skip[k] && entry[k]!=null && entry[k]!==""; });
  return (
    <Card style={{padding:0,overflow:"hidden"}}>
      <div onClick={function(){setOpen(!open);}} style={{display:"flex",alignItems:"center",justifyContent:"space-between",padding:"10px 14px",cursor:"pointer"}}>
        <div style={{fontSize:13,fontWeight:600,color:C.navy}}>{entry.date||"Undated session"}</div>
        <div style={{display:"flex",alignItems:"center",gap:8}}>
          <span style={{fontSize:11,color:C.gray500}}>{fields.length} value{fields.length===1?"":"s"}</span>
          <span style={{fontSize:14,color:C.gray400}}>{open?"▾":"▸"}</span>
        </div>
      </div>
      {open && (
        <div style={{padding:"0 14px 12px",borderTop:"1px solid "+C.border}}>
          {fields.length===0 ? <div style={{fontSize:12,color:C.gray400,fontStyle:"italic",paddingTop:8}}>No values recorded for this session.</div> :
            <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(140px,1fr))",gap:8,paddingTop:10}}>
              {fields.map(function(k){return (
                <div key={k} style={{background:C.gray50,borderRadius:6,padding:"6px 10px"}}>
                  <div style={{fontSize:9,color:C.gray500,letterSpacing:.5,textTransform:"uppercase"}}>{k}</div>
                  <div style={{fontSize:14,fontWeight:700,color:C.navy}}>{String(entry[k])}</div>
                </div>
              );})}
            </div>}
        </div>
      )}
    </Card>
  );
}

// ONE HOME FOR THE YOUTUBE METADATA. The title/description used to be built inline inside
// sendToYoutube, so nothing could show the operator what was about to be published without
// rebuilding the same string a second time -- two copies that drift the moment either is edited.
// The preview under each clip and the bytes actually sent now read from THIS function, so what
// is shown is what is uploaded, by construction rather than by matching care.
//
// The name is normalised here. The first ten uploads went up as "Arnaldo Yandyel  Just
// Rodriguez  " -- doubled inner spaces and a trailing one, straight off the clip row. Same defect
// already fixed in the clip stamper (bbot_t1_stamp.py) and never carried across to this path.
function bbotYoutubeMeta(c){
  var raw = String((c && c.player_name) || "").split(/\s+/).filter(Boolean).join(" ");
  // NO SILENT "Player" FALLBACK. Two of the first ten videos published as a bare "Player" and are
  // unidentifiable on the channel. An unnamed clip is labelled by something that can be traced
  // back to a row instead.
  var who = raw || ("Unnamed clip #" + String((c && c.id) || "?"));
  var parts = [who, String((c && c.session_type) || "Evaluation")];
  if(c && c.session_date) parts.push(String(c.session_date));
  var title = parts.join(" · ");
  return {
    title: title,
    description: bbotYoutubeDesc(title),
    privacyStatus: "unlisted",
    named: !!raw
  };
}

// The description follows whatever title is actually published -- including an edited one --
// so the two can never disagree on the channel.
function bbotYoutubeDesc(title){
  return String(title || "") + "\nVideo evaluation by BBOT · https://www.643sportsmgmt.com";
}

function ClipReviewView({users, notify, go}){
  var clipsS=useState([]); var clips=clipsS[0]; var setClips=clipsS[1];
  var loadingS=useState(true); var loading=loadingS[0]; var setLoading=loadingS[1];
  var filterS=useState("pending"); var filter=filterS[0]; var setFilter=filterS[1];
  // clip id -> youtube url, for uploads made in THIS session. See the note in sendToYoutube:
  // there is nowhere durable to put this yet.
  var ytS=useState({}); var ytDone=ytS[0]; var setYtDone=ytS[1];

  function load(){
    setLoading(true);
    // READ THE QUEUE THROUGH THE BACKEND, NOT STRAIGHT FROM THE TABLE. Reading bbot_clips from the
    // browser made an ADMIN's view depend on the RLS policy for their session rather than on being
    // an admin. On 2026-09-25 eight clips sat in pending_approval -- every row present, confirmed
    // server-side -- while this page rendered empty, because the query returned nothing to the
    // caller. An approval queue that silently shows nothing is indistinguishable from no work
    // waiting, so unreviewed clips wait forever and nobody is told.
    fetch(BACKEND_URL+"/admin/clips?limit=500",{headers:bbotAdminHeaders()})
      .then(function(r){ if(!r.ok) throw new Error("HTTP "+r.status); return r.json(); })
      .then(function(d){ setClips(Array.isArray(d&&d.clips)?d.clips:[]); setLoading(false); })
      .catch(function(e){
        // FAIL LOUDLY. The old catch set an empty list, which renders exactly like "nothing to
        // approve" -- the failure and the empty queue looked identical on screen.
        notify("Could not load the clip queue: "+(e.message||"unknown"),"error");
        setClips([]); setLoading(false);
      });
  }
  useEffect(function(){ load(); }, []);

  var shown = clips.filter(function(c){
    if(filter==="pending") return !c.approved;
    if(filter==="approved") return c.approved;
    return true;
  });
  // group by player+session
  var groups={};
  shown.forEach(function(c){
    var key=String(c.player_id||c.jersey_num||"unknown")+"|"+(c.session_date||"");
    if(!groups[key]) groups[key]={key:key, playerId:c.player_id, playerName:c.player_name||("#"+c.jersey_num), date:c.session_date, clips:[]};
    groups[key].clips.push(c);
  });
  var groupList=Object.keys(groups).map(function(k){return groups[k];});

  function clipUrl(c, cb){
    fetch(BACKEND_URL+"/r2-read-url?objectKey="+encodeURIComponent(c.clip_object_key))
      .then(function(r){return r.json();}).then(function(d){cb(d&&d.url?d.url:null);}).catch(function(){cb(null);});
  }
  function approve(ids, ok){
    fetch(BACKEND_URL+"/approve-clips",{method:"POST",headers:bbotAdminHeaders(),body:JSON.stringify({clipIds:ids,approved:ok})})
      .then(function(r){return r.json();}).then(function(d){
        if(d&&d.ok){ notify(ok?"Clips approved — player can now purchase":"Clips unapproved"); 
          setClips(function(prev){return prev.map(function(c){return ids.indexOf(c.id)>=0?Object.assign({},c,{approved:ok,status:ok?"approved":"pending_approval"}):c;});});
        } else notify("Approve failed","error");
      }).catch(function(){ notify("Approve failed","error"); });
  }

  function deleteClips(ids){
    if(!window.confirm("Delete "+ids.length+" clip"+(ids.length===1?"":"s")+"? This removes them from review and the player's profile, and deletes the underlying video file from storage.")) return;
    fetch(BACKEND_URL+"/delete-clips",{
      method:"POST",
      headers: bbotAdminHeaders(),
      body: JSON.stringify({clipIds: ids.map(function(x){var n=Number(x);return (typeof x==="number"||/^\d+$/.test(String(x)))?n:x;})})
    })
      .then(function(res){
        if(!res.ok){
          // Surface the BE error so admin sees what actually failed instead of a stale-state UI.
          return res.json().then(function(d){
            notify(errText(d && d.detail, "Delete failed: HTTP "+res.status), "error");
          }).catch(function(){ notify("Delete failed: HTTP "+res.status, "error"); });
        }
        // Only remove locally AFTER backend confirms success.
        setClips(function(prev){return prev.filter(function(c){return ids.indexOf(c.id)<0;});});
        notify("Clip"+(ids.length===1?"":"s")+" deleted");
      })
      .catch(function(err){ notify("Delete failed: "+(err.message||"network error"),"error"); });
  }

  // ONE-CLICK YOUTUBE: push a rinsed clip straight to YouTube (unlisted) via the backend uploader.
  // Resolves the clip's signed URL, auto-titles from the player + session. Needs the server's YouTube
  // credentials set (else it reports "not connected"). Fallback-safe.
  // titleOverride is what the operator typed into that clip's preview box. It only ever applies
  // to a single-clip send -- a group send has no one box to read, so each clip keeps its own
  // generated title rather than inheriting a neighbour's.
  function sendToYoutube(cs, titleOverride){
    if(!cs||!cs.length) return;
    notify("Uploading "+cs.length+" clip"+(cs.length===1?"":"s")+" to YouTube…");
    cs.forEach(function(c){
      clipUrl(c, function(url){
        if(!url){ notify("Couldn't get the clip file","error"); return; }
        var meta = bbotYoutubeMeta(c);
        if(cs.length===1 && typeof titleOverride==="string" && titleOverride.trim()){
          meta = {title:titleOverride.trim(), description:bbotYoutubeDesc(titleOverride.trim()),
                  privacyStatus:meta.privacyStatus, named:true};
        }
        fetch(BACKEND_URL+"/youtube-upload",{method:"POST",headers:bbotAdminHeaders(),body:JSON.stringify({
          videoUrl:url, title:meta.title, description:meta.description,
          privacyStatus:meta.privacyStatus, playerId:c.player_id, clipId:c.id
        })}).then(function(r){return r.json();}).then(function(d){
          if(d&&d.error==="youtube_not_configured"){ notify("YouTube isn't connected on the server yet — set the YouTube keys to enable.","error"); }
          else if(d&&(d.videoId||d.id||d.url||d.ok)){
            // The backend writes youtube_url onto the clip row; this mirrors it into view state so
            // the card updates without a refetch. The ROW is the record -- this is just the echo.
            setYtDone(function(prev){ var n={}; for(var k in prev) n[k]=prev[k]; n[c.id]=(d.url||("https://youtu.be/"+d.videoId)); return n; });
            // `recorded:false` means the video is live on YouTube but nothing links it back to
            // this clip. Say so -- a silent miss here is exactly how the first ten became
            // untraceable, and the operator is the only one who can notice.
            if(d.recorded===false){ notify("Uploaded, but the link was NOT saved to this clip — copy it now: "+(d.url||""),"error"); }
            else { notify("✓ Sent to YouTube (unlisted): "+meta.title); }
          }
          else { notify("YouTube upload failed","error"); }
        }).catch(function(){ notify("YouTube upload failed","error"); });
      });
    });
  }

  return (
    <div>
      <SectionHeader>Clip Review</SectionHeader>
      <div style={{fontSize:12,color:C.gray500,marginBottom:14}}>Review segmented clips before players can purchase them. Approve to make a session's clips available for the {BBOT_PRICE_LABEL} report+clips package.</div>
      <div style={{display:"flex",gap:6,marginBottom:16}}>
        {[["pending","Pending"],["approved","Approved"],["all","All"]].map(function(f){
          var a=filter===f[0];
          return <button key={f[0]} onClick={function(){setFilter(f[0]);}} style={{padding:"6px 14px",borderRadius:99,border:"1px solid "+(a?C.blue:C.border),background:a?C.blue:C.white,color:a?C.white:C.gray600,fontSize:12,fontWeight:600,cursor:"pointer"}}>{f[1]}</button>;
        })}
      </div>
      {loading ? <SkeletonCard/> :
       groupList.length===0 ? <EmptyCard icon="C" title="No Clips" sub={filter==="pending"?"No clips awaiting approval.":"No clips here."}/> :
       <div style={{display:"flex",flexDirection:"column",gap:16}}>
         {groupList.map(function(g){
           var ids=g.clips.map(function(c){return c.id;});
           var allApproved=g.clips.every(function(c){return c.approved;});
           return <Card key={g.key}>
             <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:10,flexWrap:"wrap",gap:8}}>
               <div>
                 <div style={{fontWeight:700,fontSize:14,color:C.navy,cursor:g.playerId?"pointer":"default"}} onClick={function(){if(g.playerId)go("profile-"+g.playerId);}}>{g.playerName}{g.playerId?" →":""}</div>
                 <div style={{fontSize:11,color:C.gray500}}>{g.date||"undated"} · {g.clips.length} clip{g.clips.length===1?"":"s"} {g.clips.some(function(c){return c.paid;})?"· PAID":""}</div>
               </div>
               <div style={{display:"flex",gap:6}}>
                 {!allApproved && <Btn v="primary" style={{fontSize:12,padding:"7px 14px"}} onClick={function(){approve(ids,true);}}>✓ Approve all</Btn>}
                 {allApproved && <Btn v="ghost" style={{fontSize:12,padding:"7px 14px",color:C.orange}} onClick={function(){approve(ids,false);}}>Unapprove</Btn>}
                 <Btn v="ghost" style={{fontSize:12,padding:"7px 12px"}} onClick={function(){sendToYoutube(g.clips);}}>▶ YouTube</Btn>
                 <Btn v="ghost" style={{fontSize:12,padding:"7px 12px",color:C.red}} onClick={function(){deleteClips(ids);}}>Delete</Btn>
               </div>
             </div>
             <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(200px,1fr))",gap:10}}>
               {g.clips.map(function(c){return <ClipPreview key={c.id} clip={c} clipUrl={clipUrl} onApprove={function(ok){approve([c.id],ok);}} onYoutube={function(t){sendToYoutube([c],t);}} ytUrl={ytDone[c.id]||c.youtube_url||null}/>;})}
             </div>
           </Card>;
         })}
       </div>}
    </div>
  );
}

function ClipPreview({clip, clipUrl, onApprove, onYoutube, ytUrl}){
  var s=useState(null); var url=s[0]; var setUrl=s[1];
  var sentS=useState(false); var sent=sentS[0]; var setSent=sentS[1];
  // Read the metadata from the same function the uploader uses -- never rebuild it here.
  var meta = bbotYoutubeMeta(clip);
  // The generated title is a DEFAULT, not a decision. What sits in this box at the moment the
  // button is pressed is what gets published.
  var titleS=useState(meta.title); var ytTitle=titleS[0]; var setYtTitle=titleS[1];
  useEffect(function(){ clipUrl(clip, function(u){setUrl(u);}); }, [clip.id]);
  return <div style={{border:"1px solid "+C.border,borderRadius:8,overflow:"hidden",background:C.gray50}}>
    {url ? <video {...bbotVideoGuard()} src={url} controls loop muted playsInline style={{width:"100%",maxHeight:160,display:"block",background:"#000"}}/>
         : <div style={{height:120,display:"flex",alignItems:"center",justifyContent:"center",fontSize:11,color:C.gray400}}>Loading clip…</div>}
    <div style={{padding:"6px 8px",fontSize:10,color:C.gray500,display:"flex",justifyContent:"space-between",alignItems:"center"}}>
      <span>{clip.action_type||"clip"} · {clip.duration_sec?Math.round(clip.duration_sec)+"s":""}</span>
      <span style={{fontWeight:700,color:clip.approved?C.green:C.orange}}>{clip.approved?"✓":"pending"}</span>
    </div>
    {/* WHAT WILL BE PUBLISHED, SHOWN BEFORE IT IS. An upload button whose payload the operator
        cannot see is how two videos went up titled "Player". */}
    <div style={{borderTop:"1px solid "+C.border,padding:"7px 8px",background:C.white}}>
      <div style={{fontSize:9,letterSpacing:.4,color:C.gray400,fontWeight:700,marginBottom:3}}>PUBLISHES AS — edit before sending</div>
      <textarea value={ytTitle} onChange={function(e){setYtTitle(e.target.value.slice(0,100));}} rows={2} disabled={!!ytUrl}
        style={{width:"100%",boxSizing:"border-box",padding:"5px 6px",borderRadius:6,resize:"vertical",
                border:"1px solid "+(ytTitle.trim()?C.border:C.orange),background:ytUrl?C.gray50:C.white,
                color:C.navy,fontSize:10.5,fontWeight:600,lineHeight:1.3,fontFamily:"inherit"}}/>
      <div style={{fontSize:9,color:ytTitle.length>=100?C.orange:C.gray400,marginTop:2}}>{ytTitle.length}/100 · YouTube cuts titles here</div>
      <div style={{fontSize:9.5,color:C.gray500,marginTop:3,lineHeight:1.35}}>
        <span style={{fontWeight:700}}>Description:</span> {ytTitle||"—"}<br/>Video evaluation by BBOT · 643sportsmgmt.com
      </div>
      <div style={{fontSize:9.5,color:C.gray500,marginTop:3}}>unlisted · 643 Sports MGMT, LLC</div>
      {!meta.named && !ytUrl && <div style={{fontSize:9.5,color:C.orange,marginTop:3,fontWeight:600}}>No player name on this clip's row — rename it above.</div>}
      {ytUrl
        ? <a href={ytUrl} target="_blank" rel="noreferrer" style={{display:"block",marginTop:6,fontSize:10.5,color:C.blue,fontWeight:700,textDecoration:"none"}}>✓ On YouTube — open ↗</a>
        : <button onClick={function(){ if(sent||!ytTitle.trim()) return; setSent(true); onYoutube&&onYoutube(ytTitle); }} disabled={!!sent||!ytTitle.trim()}
            style={{marginTop:6,width:"100%",padding:"5px 8px",borderRadius:6,border:"1px solid "+C.border,
                    background:sent?C.gray50:C.white,color:(sent||!ytTitle.trim())?C.gray400:C.navy,fontSize:10.5,fontWeight:700,
                    cursor:(sent||!ytTitle.trim())?"default":"pointer"}}>{sent?"Sending…":"▶ Send this clip"}</button>}
    </div>
  </div>;
}

function TransactionsView({scoutReports,users,cu}){
  var [events,setEvents]=useState([]);
  var [nameQ,setNameQ]=useState("");
  var [bracket,setBracket]=useState("ALL");
  var [type,setType]=useState("ALL");
  var [from,setFrom]=useState("");
  var [to,setTo]=useState("");
  var [sortKey,setSortKey]=useState("date");
  var [sortDir,setSortDir]=useState("desc");

  // Pull events (pickup/showcase registrations carry payments). Through `/events` rather than
  // straight at the table, so this transactions view survives revoking the `authenticated` grant
  // that was exposing every registrant's payment status to any signed-in account.
  useEffect(function(){
    fetch(BACKEND_URL+"/events",{headers:bbotAdminHeaders()})
      .then(function(r){ if(!r.ok) throw new Error("HTTP "+r.status); return r.json(); })
      .then(function(j){
        var rows=((j&&j.events)||[]).slice().sort(function(a,b){ return String(b.start_date||"").localeCompare(String(a.start_date||"")); });
        setEvents(rows);
      })
      .catch(function(){setEvents([]);});
  },[]);

  var userById=function(id){return (users||[]).filter(function(u){return String(u.id)===String(id);})[0]||null;};
  var nameOf=function(id){var u=userById(id);return u?(u.firstName+" "+u.lastName):("Player #"+id);};
  var bracketOf=function(id){var u=userById(id);return (u&&typeof bbotAgeGroup==="function")?(bbotAgeGroup(u.dob)||"—"):"—";};

  // Build unified transaction list from report payments + event registrations.
  var txns=[];
  (scoutReports||[]).forEach(function(r){
    var cents=r.amountCents||r.amount_cents||0;
    if(cents<=0) return;
    txns.push({
      date:(r.date||r.session_date||"").slice(0,10),
      playerId:r.playerId,
      player:nameOf(r.playerId),
      bracket:bracketOf(r.playerId),
      type:(r.reportType==="player_eval")?"Cumulative Eval":"Individual Session",
      amount:cents/100,
    });
  });
  (events||[]).forEach(function(ev){
    var regs=ev.event_registrations||{};
    Object.keys(regs).forEach(function(pid){
      var reg=regs[pid]||{};
      if(!reg.paid) return;
      txns.push({
        date:(reg.paidAt||ev.start_date||"").slice(0,10),
        playerId:pid,
        player:nameOf(pid),
        bracket:bracketOf(pid),
        type:(ev.event_type==="pickup_game")?"Pickup Game":(ev.event_type||"Event"),
        amount:Number(reg.amountPaid||reg.amount||0)||0,
        eventName:ev.name||"",
      });
    });
  });

  // Filters
  var filtered=txns.filter(function(t){
    if(nameQ && t.player.toLowerCase().indexOf(nameQ.toLowerCase())<0) return false;
    if(bracket!=="ALL" && t.bracket!==bracket) return false;
    if(type!=="ALL" && t.type!==type) return false;
    if(from && t.date<from) return false;
    if(to && t.date>to) return false;
    return true;
  });
  filtered.sort(function(a,b){
    var av=a[sortKey], bv=b[sortKey];
    if(sortKey==="amount"){av=Number(av);bv=Number(bv);}
    var c = av<bv?-1:av>bv?1:0;
    return sortDir==="desc"?-c:c;
  });

  var total=filtered.reduce(function(s,t){return s+t.amount;},0);
  var brackets=["ALL"].concat(Array.from(new Set(txns.map(function(t){return t.bracket;}).filter(function(x){return x&&x!=="—";}))).sort());
  var types=["ALL"].concat(Array.from(new Set(txns.map(function(t){return t.type;}))).sort());

  function setSort(k){ if(sortKey===k){setSortDir(sortDir==="desc"?"asc":"desc");}else{setSortKey(k);setSortDir("desc");} }

  function exportExcel(){
    var cols=["Date","Player","Age Bracket","Type","Event","Amount (USD)"];
    var rows=filtered.map(function(t){return [t.date,t.player,t.bracket,t.type,t.eventName||"",t.amount.toFixed(2)];});
    var csv=cols.join(",")+"\n"+rows.map(function(r){return r.map(function(c){return '"'+String(c).replace(/"/g,'""')+'"';}).join(",");}).join("\n");
    var blob=new Blob([csv],{type:"text/csv"}); var url=URL.createObjectURL(blob); var a=document.createElement("a");
    a.href=url; a.download="643_transactions_"+new Date().toISOString().slice(0,10)+".csv"; a.click(); setTimeout(function(){URL.revokeObjectURL(url);},1000);
  }

  var th={textAlign:"left",fontSize:11,color:C.gray500,fontWeight:700,letterSpacing:.4,padding:"8px 10px",cursor:"pointer",borderBottom:"1px solid "+C.border,userSelect:"none"};
  var td={fontSize:12,color:C.gray700,padding:"8px 10px",borderBottom:"1px solid "+C.gray100};

  return (
    <div>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"baseline",flexWrap:"wrap",gap:8,marginBottom:6}}>
        <div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:18,color:C.navy,letterSpacing:1}}>TRANSACTIONS</div>
        <div style={{fontSize:13,color:C.gray600}}>{filtered.length} transactions · <strong style={{color:C.navy}}>${total.toFixed(2)}</strong></div>
      </div>
      <div style={{display:"flex",flexWrap:"wrap",gap:8,marginBottom:12}}>
        <input value={nameQ} onChange={function(e){setNameQ(e.target.value);}} placeholder="Search player…" style={{padding:"6px 10px",border:"1px solid "+C.border,borderRadius:6,fontSize:12,minWidth:140}}/>
        <select value={bracket} onChange={function(e){setBracket(e.target.value);}} style={{padding:"6px 10px",border:"1px solid "+C.border,borderRadius:6,fontSize:12,background:C.white}}>{brackets.map(function(b){return <option key={b} value={b}>{b==="ALL"?"All ages":b}</option>;})}</select>
        <select value={type} onChange={function(e){setType(e.target.value);}} style={{padding:"6px 10px",border:"1px solid "+C.border,borderRadius:6,fontSize:12,background:C.white}}>{types.map(function(t){return <option key={t} value={t}>{t==="ALL"?"All types":t}</option>;})}</select>
        <input type="date" value={from} onChange={function(e){setFrom(e.target.value);}} title="From" style={{padding:"6px 10px",border:"1px solid "+C.border,borderRadius:6,fontSize:12}}/>
        <input type="date" value={to} onChange={function(e){setTo(e.target.value);}} title="To" style={{padding:"6px 10px",border:"1px solid "+C.border,borderRadius:6,fontSize:12}}/>
        <button onClick={exportExcel} style={{padding:"6px 14px",borderRadius:6,border:"none",background:"#1a2f5a",color:C.white,fontSize:12,fontWeight:700,cursor:"pointer"}}>Export to Excel</button>
      </div>
      <div style={{overflowX:"auto",border:"1px solid "+C.border,borderRadius:10}}>
        <table style={{width:"100%",borderCollapse:"collapse",minWidth:560}}>
          <thead><tr>
            <th style={th} onClick={function(){setSort("date");}}>Date {sortKey==="date"?(sortDir==="desc"?"↓":"↑"):""}</th>
            <th style={th} onClick={function(){setSort("player");}}>Player {sortKey==="player"?(sortDir==="desc"?"↓":"↑"):""}</th>
            <th style={th} onClick={function(){setSort("bracket");}}>Age {sortKey==="bracket"?(sortDir==="desc"?"↓":"↑"):""}</th>
            <th style={th} onClick={function(){setSort("type");}}>Type {sortKey==="type"?(sortDir==="desc"?"↓":"↑"):""}</th>
            <th style={Object.assign({},th,{textAlign:"right"})} onClick={function(){setSort("amount");}}>Amount {sortKey==="amount"?(sortDir==="desc"?"↓":"↑"):""}</th>
          </tr></thead>
          <tbody>
            {filtered.length===0 && <tr><td style={td} colSpan="5"><span style={{color:C.gray400}}>No transactions match these filters.</span></td></tr>}
            {filtered.map(function(t,i){return <tr key={i}>
              <td style={td}>{t.date||"—"}</td>
              <td style={td}>{t.player}{t.eventName?(" · "+t.eventName):""}</td>
              <td style={td}>{t.bracket}</td>
              <td style={td}>{t.type}</td>
              <td style={Object.assign({},td,{textAlign:"right",fontWeight:700,color:C.navy})}>${t.amount.toFixed(2)}</td>
            </tr>;})}
          </tbody>
        </table>
      </div>
    </div>
  );
}


// ── ADMIN: REGISTER A PLAYER BY PASTE ────────────────────────────────────────────────────────
// PARSE, PREVIEW, CONFIRM -- three steps, not one. The preview shows what BBOT UNDERSTOOD, not what
// was typed: 68" comes back as 68 in, "Shortstop" as SS. A misread is visible at the only moment it
// is still free to fix. Nothing is created until the admin confirms a clean parse, and a parse with
// any error creates nothing at all -- a half-built profile is worse than no profile, because
// somebody has to notice it is half-built and nobody ever does.
//
// THE PLACEHOLDER IS FICTION, AND HAS TO BE. This is an HTML `placeholder` attribute, so whatever
// it holds is compiled into the public bundle and served to everyone who loads the site -- logged
// in or not, admin or not. It was filled in with a REAL registered minor's name, school, height,
// weight and email address, which made a placeholder into a disclosure. Values here are invented:
// the name and school are plainly not real, and the address is at `example.com`, which RFC 2606
// reserves precisely so it can never belong to a person. Never paste a live player's block in here
// to test the screen -- type it into the textarea, where it stays on your own machine.
// Verified against the real parser (`bbot_player_paste.parse_block`): 0 errors, 0 unknown labels,
// so this still demonstrates a clean parse rather than an example that would fail.
const PASTE_PLACEHOLDER =
  "First Name: Juan\nLast Name: Ejemplo\nGrad Year: 2030\nPrimary Position: Shortstop\n" +
  "Secondary Position: Pitcher\nHigh School Name: Escuela Ejemplo\nClub Name: 643 Sports / BBOT\n" +
  "Height: 68\"\nWeight: 145 lbs\nBat R/L: R\nThrow R/L: R\nEmail: juan.ejemplo@example.com";

// -- THE STANDING-FRAME CHECK -------------------------------------------------------------------
// MOVEMENT LENGTHS is a percentage of standing height, so every one of those numbers is scaled off a
// single frame the pipeline believes shows the athlete standing still. Checked at full resolution,
// frames of that kind have turned out to be run-ups, follow-throughs and intro title cards -- and
// until this screen existed the card said the frame "has not been hand-verified" with nowhere in any
// repo to record that it had been. This is the place the check gets made and written down.
//
// THE VERDICT IS ABOUT ONE FRAME. It is recorded with the frame number, and the card honours it only
// when the frame the reps were actually scaled from is the frame that was looked at.
// -- CARD APPROVALS -----------------------------------------------------------------------------
// A re-run used to publish straight over the served card, so the only way to review a change was to
// have already shipped it. Re-runs land in a queue now and this is where they are decided. The live
// card keeps serving, untouched, until Approve is pressed -- that is the ONLY path that overwrites
// a published card.
//
// THE OLD CARD IS ON THE SCREEN BESIDE THE NEW ONE. "Does this look right?" is the wrong question;
// "is this better than what is live, and what actually changed?" is the one worth a click.
function CardApprovals({notify}){
  var qS=useState(null);   var q=qS[0];        var setQ=qS[1];
  var lS=useState(true);   var loading=lS[0];  var setLoading=lS[1];
  var bS=useState("");     var busy=bS[0];     var setBusy=bS[1];
  var nS=useState({});     var notes=nS[0];    var setNotes=nS[1];
  var oS=useState("");     var open=oS[0];     var setOpen=oS[1];

  function load(){
    setLoading(true);
    return fetch(BACKEND_URL+"/admin/card-pending",{headers:bbotAdminHeaders()})
      .then(function(r){ return r.json(); })
      .then(function(j){ setQ(j); return j; })
      .catch(function(){ notify("Could not load the approval queue","error"); })
      .then(function(x){ setLoading(false); return x; });
  }
  useEffect(function(){ load(); }, []);

  function decide(rid, approve){
    setBusy(rid);
    fetch(BACKEND_URL+"/admin/card-pending-"+(approve?"approve":"reject"),{
      method:"POST", headers:bbotAdminHeaders(),
      body:JSON.stringify({reportId:rid, note:notes[rid]||""})
    }).then(function(r){ return r.json().then(function(j){
        if(!r.ok) throw new Error((j.detail&&j.detail.note)||j.detail||("Request failed ("+r.status+")"));
        return j; }); })
      .then(function(){
        notify(approve?"Card approved and published":"Re-run discarded — the live card is unchanged",
               approve?"success":"info");
        setOpen(""); load();
      })
      .catch(function(e){ notify(e.message||"Could not record the decision","error"); })
      .then(function(){ setBusy(""); });
  }

  // APPROVE EVERY QUEUED CARD IN ONE ACTION. Luis 2026-10-17: *"cant keep doing these
  // individually"* — a requeue of ten after one wording fix meant ten clicks, three times in a
  // night.
  //
  // IT LOOPS THE SAME PER-CARD ENDPOINT, deliberately, and there is no bulk route on the server.
  // `/admin/card-pending-approve` copies each artifact to its live key, READS IT BACK, and only
  // then switches the manifest; a bulk endpoint would either repeat that per card anyway or skip
  // it, and skipping it is how a half-copied promotion leaves a manifest naming bytes that are
  // not there. The server rule is also untouched: every call carries the dashboard session, so
  // the key still cannot approve. [[card-approval-queue]] [[armed-is-not-proven-until-served]]
  //
  // ONE AT A TIME, NOT ALL AT ONCE. Ten parallel promotions against the same bucket is a way to
  // find a race nobody has tested for. Sequential costs a few seconds and keeps each failure
  // attributable to its own card.
  //
  // A FAILURE STOPS NOTHING AND IS NEVER SWALLOWED. Each card is reported by name, and the run
  // ends with how many went live and which did not — a partial result stated as a partial
  // result. [[silent-failure-write-sweep]]
  function approveAll(){
    var rows=(q&&q.queue)||[];
    if(!rows.length) return;
    if(typeof window!=="undefined" &&
       !window.confirm("Approve all "+rows.length+" queued card"+(rows.length===1?"":"s")+
                       "?\n\nEach replaces the card currently on that athlete's profile.")) return;
    setBusy("__all__");
    var done=0, failed=[];
    var step=function(i){
      if(i>=rows.length){
        setBusy(""); setOpen(""); load();
        notify(failed.length
          ? (done+" of "+rows.length+" published — these did not: "+failed.join(", "))
          : ("All "+done+" card"+(done===1?"":"s")+" published."),
          failed.length?"error":"success");
        return;
      }
      var row=rows[i];
      fetch(BACKEND_URL+"/admin/card-pending-approve",{
        method:"POST", headers:bbotAdminHeaders(),
        body:JSON.stringify({reportId:row.reportId, note:notes[row.reportId]||""})
      }).then(function(r){ return r.json().then(function(j){
          if(!r.ok) throw new Error((j.detail&&j.detail.note)||j.detail||("HTTP "+r.status));
          return j; }); })
       .then(function(){ done++; })
       .catch(function(){ failed.push(row.player||row.reportId); })
       .then(function(){ step(i+1); });
    };
    step(0);
  }

  // A PREVIEW OPENS IN ITS OWN TAB rather than an iframe: the card is a full US-Letter page and a
  // panel-sized frame of it is not what anyone is being asked to approve.
  function preview(rid, which){
    // ONE DOCUMENT, SO THE PREVIEW OPENS THE DOCUMENT (2026-10-09). This fetched
    // `card_admin.html` on both branches. The admin document was deleted the same day under the
    // one-PDF rule -- 72 objects across 24 reports -- and `ADMIN_ARTIFACTS` is now empty, so both
    // URLs would have 404'd and the approval queue would have been unable to show the very card it
    // is asking about. Three cards were sitting in that queue when this was found.
    //
    // The live card is served by `/card/{rid}/card.html`, which accepts an admin key as well as
    // the per-card token; the queued one by `/admin/card-pending/{rid}/card.html`, which admits
    // any name in ARTIFACTS. What an admin reviews is now exactly what the athlete receives, which
    // is the point of there being one document.
    var url = BACKEND_URL + (which==="live"
      ? "/card/"+rid+"/card.html"
      : "/admin/card-pending/"+rid+"/card.html");
    // The admin routes need a header, which a plain window.open cannot send, so the bytes are
    // fetched with credentials and handed to the new tab as a blob.
    fetch(url,{headers:bbotAdminHeaders()})
      .then(function(r){ if(!r.ok) throw new Error("HTTP "+r.status); return r.blob(); })
      .then(function(b){ window.open(URL.createObjectURL(b),"_blank"); })
      .catch(function(e){ notify("Could not open the "+which+" card ("+e.message+")","error"); });
  }

  function what(row){
    if(row.isFirstCard) return {t:"First card for this session", bg:"#eff6ff", fg:"#1d4ed8"};
    if(row.rowChanged)  return {t:"The record changed", bg:"#fff7ed", fg:"#c2410c"};
    if(row.rendererChanged) return {t:"Same record, new rendering", bg:"#f5f3ff", fg:"#6d28d9"};
    return {t:"No change detected", bg:"#f8fafc", fg:"#64748b"};
  }

  return (
    <div style={{maxWidth:960}}>
      <SectionHeader>Card Approvals</SectionHeader>
      <p style={{fontSize:13,color:C.gray500,lineHeight:1.6,margin:"0 0 16px"}}>
        Re-run cards waiting on a decision. Nothing here is on the athlete&rsquo;s profile yet &mdash;
        the card currently published keeps serving until you approve the replacement. Rejecting
        discards the re-run and leaves the live card exactly as it is.
      </p>

      {loading&&<Card style={{padding:18}}>Loading&hellip;</Card>}

      {!loading&&q&&(q.queue||[]).length===0&&(
        <Card style={{padding:18,fontSize:13,color:C.gray500}}>
          Nothing is waiting for approval. Queue a card for review and it appears here.
        </Card>
      )}

      {/* THE BULK BAR. It says how many and what approving them does, because "Approve all" on
          its own does not tell you that ten athletes' published cards are about to change. */}
      {!loading&&q&&(q.queue||[]).length>1&&(
        <Card style={{padding:"12px 14px",marginBottom:12,display:"flex",alignItems:"center",
                      gap:12,flexWrap:"wrap",background:"#f8fafc"}}>
          <div style={{flex:1,minWidth:260,fontSize:13,color:C.gray700,lineHeight:1.5}}>
            <strong>{(q.queue||[]).length} cards waiting.</strong> Approving all replaces the
            card currently published for each of these athletes. Rejecting stays per-card.
          </div>
          <Btn v="primary" style={{fontSize:13,padding:"8px 16px"}}
               onClick={approveAll} disabled={!!busy}>
            {busy==="__all__" ? "Publishing…" : "Approve all "+(q.queue||[]).length}
          </Btn>
        </Card>
      )}

      {!loading&&q&&(q.queue||[]).map(function(row){
        var w=what(row);
        var isOpen=open===row.reportId;
        return (
          <Card key={row.reportId} style={{padding:14,marginBottom:10}}>
            <div style={{display:"flex",alignItems:"center",gap:12,flexWrap:"wrap"}}>
              <div style={{flex:1,minWidth:220}}>
                <div style={{fontWeight:700,fontSize:14,color:C.navy}}>
                  {row.player||row.reportId}
                  {/* WHICH LANE THIS CARD IS. A player can have two cards for one session -- Marcos
                      and Christian each have a BULLPEN and a PREGAME clip off the same master on the
                      same date -- and the row showed only the name, so they read as duplicate
                      entries with no way to tell the pitcher card from the position-player card.
                      The backend sends clipType and role off the clip's own record. */}
                  {row.role&&(
                    <span style={{marginLeft:8,fontSize:11,fontWeight:700,letterSpacing:.4,
                                  textTransform:"uppercase",padding:"2px 7px",borderRadius:999,
                                  color:row.role==="pitching"?"#6d28d9":"#1d4ed8",
                                  background:row.role==="pitching"?"#f5f3ff":"#eff6ff"}}>
                      {row.role==="pitching"?"Pitching":"Position player"}
                      {row.clipType?(" · "+row.clipType):""}
                    </span>
                  )}
                </div>
                <div style={{fontSize:12,color:C.gray500,marginTop:2}}>
                  {row.sessionDate?String(row.sessionDate).slice(0,10):"no session date"}
                  {" \u00b7 report "}{row.reportId}
                  {row.reportStatus?(" \u00b7 "+row.reportStatus):""}
                  {row.pending&&row.pending.publishedAt?(" \u00b7 queued "+String(row.pending.publishedAt).slice(0,10)):""}
                </div>
              </div>
              <span style={{fontSize:11,fontWeight:700,padding:"4px 10px",borderRadius:99,
                            background:w.bg,color:w.fg}}>{w.t}</span>
              <Btn v={isOpen?"ghost":"primary"} onClick={function(){ setOpen(isOpen?"":row.reportId); }}>
                {isOpen?"Close":"Review"}
              </Btn>
            </div>

            {isOpen&&(
              <div style={{marginTop:14,borderTop:"1px solid "+C.border,paddingTop:14}}>
                <div style={{display:"flex",gap:10,flexWrap:"wrap",marginBottom:12}}>
                  <Btn v="ghost" onClick={function(){preview(row.reportId,"pending");}}>
                    Open the new card</Btn>
                  {!row.isFirstCard&&(
                    <Btn v="ghost" onClick={function(){preview(row.reportId,"live");}}>
                      Open the card it replaces</Btn>
                  )}
                </div>
                <div style={{fontSize:12,color:C.gray500,lineHeight:1.6,marginBottom:12}}>
                  <div>
                    <b>Record fingerprint</b>{" "}
                    {row.live?(row.live.dataFingerprint||"?"):"\u2014"} &rarr;{" "}
                    {(row.pending&&row.pending.dataFingerprint)||"?"}
                    {row.rowChanged?"  (the row this card draws has moved)":"  (same row)"}
                  </div>
                  <div>
                    <b>Renderer fingerprint</b>{" "}
                    {row.live?(row.live.componentFingerprint||"?"):"\u2014"} &rarr;{" "}
                    {(row.pending&&row.pending.componentFingerprint)||"?"}
                  </div>
                  {row.isFirstCard&&(
                    <div style={{color:C.gray400,marginTop:4}}>
                      Nothing is published for this report yet, so approving publishes the first card.
                    </div>
                  )}
                </div>
                <input value={notes[row.reportId]||""}
                  onChange={function(e){ var n=Object.assign({},notes); n[row.reportId]=e.target.value; setNotes(n); }}
                  placeholder="Why (recorded with the decision — the only record of what the queue caught)"
                  style={{width:"100%",padding:"10px 12px",border:"1px solid "+C.border,
                          borderRadius:8,fontSize:13,boxSizing:"border-box"}}/>
                <div style={{display:"flex",gap:10,marginTop:12}}>
                  <Btn v="primary" disabled={!!busy}
                       onClick={function(){decide(row.reportId,true);}}>
                    {busy===row.reportId?"Working\u2026":"Approve & publish"}</Btn>
                  <Btn v="coral" disabled={!!busy}
                       onClick={function(){decide(row.reportId,false);}}>
                    Reject &mdash; keep the live card</Btn>
                </div>
              </div>
            )}
          </Card>
        );
      })}
    </div>
  );
}

function StandingFrameCheck({notify}){
  var qS=useState(null);      var q=qS[0];       var setQ=qS[1];
  var selS=useState(null);    var sel=selS[0];   var setSel=selS[1];
  var frS=useState(null);     var shot=frS[0];   var setShot=frS[1];
  var noteS=useState("");     var note=noteS[0]; var setNote=noteS[1];
  var bS=useState(false);     var busy=bS[0];    var setBusy=bS[1];
  var lS=useState(true);      var loading=lS[0]; var setLoading=lS[1];

  function loadQueue(){
    setLoading(true);
    return fetch(BACKEND_URL+"/admin/standing-queue",{headers:bbotAdminHeaders()})
      .then(function(r){ return r.json(); })
      .then(function(j){ setQ(j); return j; })
      .catch(function(){ notify("Could not load the queue","error"); })
      .then(function(x){ setLoading(false); return x; });
  }
  useEffect(function(){ loadQueue(); }, []);

  function open(row){
    setSel(row); setShot(null); setNote((row.verdict&&row.verdict.note)||""); setBusy(true);
    fetch(BACKEND_URL+"/admin/standing-frame?objectKey="+encodeURIComponent(row.objectKey),
          {headers:bbotAdminHeaders()})
      .then(function(r){ return r.json(); })
      .then(function(j){ setShot(j); if(!j.png) notify("The frame could not be extracted","error"); })
      .catch(function(){ notify("Could not load the frame","error"); })
      .then(function(){ setBusy(false); });
  }

  function record(standing){
    if(!sel||!shot||shot.frame===null||shot.frame===undefined) return;
    setBusy(true);
    fetch(BACKEND_URL+"/admin/standing-frame",{
      method:"POST", headers:bbotAdminHeaders(),
      body:JSON.stringify({objectKey:sel.objectKey, frame:shot.frame,
                           standing:!!standing, note:note})
    }).then(function(r){ return r.json().then(function(j){
        if(!r.ok) throw new Error(j.detail||("Request failed ("+r.status+")")); return j; }); })
      .then(function(){
        notify(standing?("Recorded - frame "+shot.frame+" is a standing frame")
                       :("Recorded - frame "+shot.frame+" is not a standing frame"),"success");
        setSel(null); setShot(null); setNote(""); loadQueue();
      })
      .catch(function(e){ notify(e.message||"Could not record the verdict","error"); })
      .then(function(){ setBusy(false); });
  }

  // FULL RESOLUTION IS THE WHOLE POINT. A frame scaled to fit a panel hides exactly the detail this
  // check exists to catch, so the image opens 1:1 in its own tab and the panel view says so.
  function openFullSize(){
    if(!shot||!shot.png) return;
    var w=window.open(); if(!w) return;
    w.document.write("<title>frame "+shot.frame+"</title>"
      +"<body style=\"margin:0;background:#111\"><img src=\"data:image/png;base64,"+shot.png+"\"></body>");
    w.document.close();
  }

  var chip=function(v){
    if(!v) return {t:"Not checked", bg:"#fff7ed", fg:"#c2410c"};
    return v.standing ? {t:"Standing", bg:"#ecfdf5", fg:"#047857"}
                      : {t:"Not standing", bg:"#fef2f2", fg:"#b91c1c"};
  };

  return (
    <div style={{maxWidth:960}}>
      <SectionHeader>Standing-Frame Check</SectionHeader>
      <p style={{fontSize:13,color:C.gray500,lineHeight:1.6,margin:"0 0 16px"}}>
        Stride, weight shift and head movement are all percentages of standing height, measured from
        one frame per session. Open the frame at full size and say whether it shows the athlete
        standing still, in the same shot and at the same camera distance as the reps. Both answers
        are recorded &mdash; a refusal is the more useful one, because it names the cause on the card.
      </p>

      {loading&&<Card style={{padding:18}}>Loading&hellip;</Card>}

      {!loading&&q&&(
        <p style={{fontSize:12,color:C.gray400,margin:"0 0 10px"}}>
          {q.count} session{q.count===1?"":"s"} offer a single standing reference &middot; {q.pending} not yet checked.
          Sessions with no standing reference are not listed &mdash; there is nothing to look at.
        </p>
      )}

      {!loading&&q&&(q.sessions||[]).map(function(row){
        var c=chip(row.verdict);
        var isSel=sel&&sel.objectKey===row.objectKey;
        return (
          <Card key={row.objectKey} style={{padding:14,marginBottom:10}}>
            <div style={{display:"flex",alignItems:"center",gap:12,flexWrap:"wrap"}}>
              <div style={{flex:1,minWidth:220}}>
                <div style={{fontWeight:700,fontSize:14,color:C.navy}}>
                  {row.player||row.objectKey.split("/").pop()}
                </div>
                <div style={{fontSize:12,color:C.gray500,marginTop:2}}>
                  frame {row.frame} &middot; {row.reps} rep{row.reps===1?"":"s"}
                  {row.repsFromFallback>0
                    ? (" \u00b7 "+row.repsFromFallback+" scaled inside their own window instead")
                    : " \u00b7 all reps scale from this frame"}
                  {row.sessionDate?(" \u00b7 "+String(row.sessionDate).slice(0,10)):""}
                </div>
              </div>
              <span style={{fontSize:11,fontWeight:700,padding:"4px 10px",borderRadius:99,
                            background:c.bg,color:c.fg}}>{c.t}</span>
              <Btn v={isSel?"ghost":"primary"} onClick={function(){ if(isSel){setSel(null);}else{open(row);} }}>
                {isSel?"Close":(row.verdict?"Look again":"Open the frame")}
              </Btn>
            </div>

            {isSel&&(
              <div style={{marginTop:14,borderTop:"1px solid "+C.border,paddingTop:14}}>
                {busy&&!shot&&<div style={{fontSize:13,color:C.gray500}}>Pulling the frame&hellip;</div>}
                {shot&&shot.png&&(
                  <div>
                    <img src={"data:image/png;base64,"+shot.png} alt={"frame "+shot.frame}
                         onClick={openFullSize}
                         style={{width:"100%",borderRadius:8,display:"block",cursor:"zoom-in",
                                 background:"#111"}}/>
                    <p style={{fontSize:12,color:C.gray400,margin:"8px 0 0"}}>
                      Shown scaled to fit. Click it to open at full resolution &mdash; that is the size the
                      check is meant to be made at.
                    </p>
                  </div>
                )}
                {shot&&!shot.png&&(
                  <div style={{fontSize:13,color:C.gray500}}>{shot.why||"No frame could be extracted."}</div>
                )}
                {shot&&shot.existing&&(
                  <p style={{fontSize:12,color:C.gray500,margin:"10px 0 0"}}>
                    Already recorded: {shot.existing.standing?"standing":"not standing"} by{" "}
                    {shot.existing.by} on {String(shot.existing.at||"").slice(0,10)}. Recording again
                    supersedes it.
                  </p>
                )}
                {shot&&shot.png&&(
                  <div style={{marginTop:12}}>
                    <input value={note} onChange={function(e){setNote(e.target.value);}}
                      placeholder="What you saw (optional - it is quoted on the card when the answer is no)"
                      style={{width:"100%",padding:"10px 12px",border:"1px solid "+C.border,
                              borderRadius:8,fontSize:13,boxSizing:"border-box"}}/>
                    <div style={{display:"flex",gap:10,marginTop:12}}>
                      <Btn v="primary" disabled={busy} onClick={function(){record(true);}}>
                        Yes &mdash; standing still</Btn>
                      <Btn v="coral" disabled={busy} onClick={function(){record(false);}}>
                        No &mdash; not a standing frame</Btn>
                    </div>
                  </div>
                )}
              </div>
            )}
          </Card>
        );
      })}

      {!loading&&q&&(q.sessions||[]).length===0&&(
        <Card style={{padding:18,fontSize:13,color:C.gray500}}>
          No session currently offers a single standing reference to check.
        </Card>
      )}
    </div>
  );
}

function AdminRegisterPlayer({notify}){
  var pS=useState(""); var paste=pS[0]; var setPaste=pS[1];
  var gnS=useState(""); var gname=gnS[0]; var setGname=gnS[1];
  var geS=useState(""); var gmail=geS[0]; var setGmail=geS[1];
  var rS=useState(null); var res=rS[0]; var setRes=rS[1];
  var bS=useState(false); var busy=bS[0]; var setBusy=bS[1];

  function call(dryRun){
    setBusy(true);
    return fetch(BACKEND_URL+"/admin/register-player",{
      method:"POST", headers:bbotAdminHeaders(),
      body:JSON.stringify({paste:paste, guardianName:gname, guardianEmail:gmail, dryRun:!!dryRun})
    }).then(function(r){ return r.json().then(function(j){
        if(!r.ok) throw new Error(j.detail||j.error||("Request failed ("+r.status+")"));
        return j; }); })
      .then(function(j){ setRes(j);
        if(j.created){
          // NEVER SAY "SENT" WHEN IT WAS NOT SENT -- but not sending is the normal path here, so it
          // is reported as the next step rather than as a failure.
          notify(j.emailSent ? ("Registered — setup link emailed to "+j.guardian.email)
                             : ("Registered — now send "+(j.guardian.name||"the guardian")+" the message below"),
                 "success");
          setPaste(""); setGname(""); setGmail("");
        }
        return j; })
      .catch(function(e){ setRes(null); notify(e.message||"Could not register the player","error"); })
      .then(function(x){ setBusy(false); return x; });
  }

  var clean = res && res.ok && !res.created && (res.preview||[]).length>0;
  var lbl = {fontSize:11,fontWeight:600,color:C.gray700,letterSpacing:.5,marginBottom:6,display:"block"};
  var inp = {width:"100%",padding:"10px 12px",border:"1px solid "+C.border,borderRadius:8,fontSize:14,boxSizing:"border-box"};

  return (
    <div style={{maxWidth:760}}>
      <SectionHeader>Register a Player</SectionHeader>
      <p style={{fontSize:13,color:C.gray500,lineHeight:1.6,margin:"0 0 16px"}}>
        Paste the player's details below. BBOT creates the account on the player's own email, and
        emails the setup link to the parent or guardian — they confirm the relationship and choose
        the password, then the player signs in with their own address. The profile still goes
        through the normal approval queue.
      </p>

      <Card style={{padding:18,marginBottom:14}}>
        <label style={lbl}>PLAYER DETAILS *</label>
        <textarea value={paste} onChange={function(e){setPaste(e.target.value); setRes(null);}}
          placeholder={PASTE_PLACEHOLDER} rows={13}
          style={Object.assign({},inp,{fontFamily:"ui-monospace,Menlo,Consolas,monospace",fontSize:13,lineHeight:1.6,resize:"vertical"})}/>
        <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(min(240px,100%),1fr))",gap:12,marginTop:14}}>
          <div>
            <label style={lbl}>PARENT / GUARDIAN NAME *</label>
            <input value={gname} onChange={function(e){setGname(e.target.value); setRes(null);}}
              placeholder="Ana Ejemplo" style={inp}/>
          </div>
          <div>
            <label style={lbl}>PARENT / GUARDIAN EMAIL *</label>
            <input value={gmail} onChange={function(e){setGmail(e.target.value); setRes(null);}}
              placeholder="ana@example.com" style={inp}/>
          </div>
        </div>
        <p style={{fontSize:12,color:C.gray400,margin:"10px 0 0"}}>
          The setup link goes to this address. It may be the same as the player's — it is still
          recorded separately.
        </p>
        <div style={{display:"flex",gap:10,marginTop:14}}>
          <Btn v="primary" disabled={busy||!paste.trim()} onClick={function(){call(true);}}>
            {busy?"Checking…":"Check the paste"}</Btn>
          {clean&&<Btn v="coral" disabled={busy} onClick={function(){call(false);}}>
            {busy?"Creating…":"Create account & email the guardian"}</Btn>}
        </div>
      </Card>

      {/* THIS IS THE DELIVERY STEP, NOT AN ERROR. It first shipped as a red failure box explaining
          that email had not been configured -- which framed the normal, chosen way of working as a
          fault, every single time. No mail provider is being added, so handing the message to the
          admin IS the flow, and it should read like the next thing to do rather than an apology. */}
      {res&&res.created&&res.setupLink&&(
        <Card style={{padding:16,marginBottom:14,border:"2px solid "+C.blue}}>
          <div style={{fontSize:14,fontWeight:700,color:C.gray900,marginBottom:4}}>
            Next: send this to {res.guardian.name}
          </div>
          <div style={{fontSize:13,color:C.gray600,lineHeight:1.6,marginBottom:12}}>
            Paste it into WhatsApp, Messenger or a text to <strong>{res.guardian.email}</strong>.
            They confirm they are the parent or guardian and choose a password — then the player
            signs in with their own email address.
            {res.emailSent && " (A copy was also emailed.)"}
          </div>
          <textarea readOnly value={res.guardianMessage||res.setupLink} rows={11}
            onFocus={function(e){e.target.select();}}
            style={{width:"100%",padding:"10px 12px",border:"1px solid "+C.border,borderRadius:8,
                    fontSize:12.5,lineHeight:1.55,boxSizing:"border-box",resize:"vertical",
                    whiteSpace:"pre-wrap",wordBreak:"break-word"}}/>
          <div style={{display:"flex",gap:10,alignItems:"center",marginTop:10,flexWrap:"wrap"}}>
            <Btn v="coral" onClick={function(){
              var t=res.guardianMessage||res.setupLink;
              try{ navigator.clipboard.writeText(t); notify("Message copied — paste it to the guardian","success"); }
              catch(_){ notify("Select the text above and copy it","error"); }
            }}>Copy message</Btn>
            <Btn v="primary" onClick={function(){
              try{ navigator.clipboard.writeText(res.setupLink); notify("Link copied","success"); }
              catch(_){ notify("Select the text above and copy it","error"); }
            }}>Copy link only</Btn>
            <a href={"https://wa.me/?text="+encodeURIComponent(res.guardianMessage||res.setupLink)}
               target="_blank" rel="noreferrer"
               style={{fontSize:13,fontWeight:700,color:C.blue,textDecoration:"none"}}>Open in WhatsApp →</a>
          </div>
        </Card>
      )}

      {res&&(res.errors||[]).length>0&&(
        <Card style={{padding:16,marginBottom:14,border:"1px solid "+C.coral}}>
          <div style={{fontSize:13,fontWeight:700,color:C.coral,marginBottom:8}}>
            Nothing was created. {res.errors.length} thing{res.errors.length===1?"":"s"} could not be read:
          </div>
          <ul style={{margin:0,paddingLeft:18,fontSize:13,color:C.gray700,lineHeight:1.7}}>
            {res.errors.map(function(x,i){ return <li key={i}>{x}</li>; })}
          </ul>
        </Card>
      )}

      {clean&&(
        <Card style={{padding:16}}>
          <div style={{fontSize:13,fontWeight:700,color:C.gray900,marginBottom:4}}>This is what BBOT read</div>
          <div style={{fontSize:12,color:C.gray400,marginBottom:12}}>
            Values are shown normalised. Check them before creating the account.
          </div>
          <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(min(220px,100%),1fr))",gap:"8px 18px"}}>
            {res.preview.map(function(row,i){
              return (
                <div key={i} style={{display:"flex",justifyContent:"space-between",gap:10,padding:"6px 0",borderBottom:"1px solid "+C.gray100}}>
                  <span style={{fontSize:12,color:C.gray500}}>{row.label}</span>
                  <span style={{fontSize:13,fontWeight:600,color:C.gray900,textAlign:"right"}}>{row.value}</span>
                </div>
              );
            })}
          </div>
          <div style={{marginTop:14,paddingTop:12,borderTop:"1px solid "+C.border,fontSize:13,color:C.gray700}}>
            Setup link will be emailed to <strong>{res.guardian.name}</strong> at <strong>{res.guardian.email}</strong>.
          </div>
        </Card>
      )}
    </div>
  );
}

// ═══════════════════════════════════════════════════════════════════════════════════════════════
// ADVANCE SCOUTING — THE DOOR. Ruled by Luis 2026-10-30: "add link".
//
// IT IS A LINK AND NOTHING MORE, and that is the whole design. The scouting layer is a separate
// product with a different consent basis — its subjects are third parties recorded WITHOUT
// consent — and §0 of its brief says nothing in it "ever reaches a public or recruiting-side
// surface". This bundle is what every visitor of the public site downloads, so what ships here is
// one outbound href behind the admin gate: no scouting table names, no scouting API paths, no
// scouting data, no scouting component.
//
// THE HOST IS CONFIGURED, NOT HARDCODED. The scouting surfaces live on the backend host, and
// while the branch is in preview that host is a temporary Railway PR domain. REACT_APP_SCOUT_HOST
// carries it so moving to a permanent domain is an environment change and not a code change —
// and so a stale preview URL cannot be baked into a shipped bundle.
// ═══════════════════════════════════════════════════════════════════════════════════════════════
// SAME ORIGIN, VIA THE SITE'S OWN REWRITE — which is the house pattern, not an invention: /r,
// /c and /s already proxy to this backend in vercel.json and /scout joins them.
//
// WHY IT MATTERS AND IS NOT COSMETIC. The iPad tool keeps its offline queue in localStorage, and
// localStorage belongs to an ORIGIN. Served from the backend domain it was a third party to the
// site, and iOS Safari blocks third-party storage by default — the offline mode §2 requires
// ("full offline mode on the iPad: local queue, sync on return") would have failed on the one
// device it exists for. Behind the rewrite the tool and its queue are the site's own origin.
//
// It also removes CORS from every scouting call, and leaves ONE copy of the tool — the file stays
// in the backend repo and is proxied, never duplicated into this one. [[one-home-per-value]]
//
// The env var still wins where it is set, so a preview can point at its own backend.
var SCOUT_HOST = (process.env.REACT_APP_SCOUT_HOST || "").replace(/\/+$/,"");

// The order the bases are tapped in, and the one place that order is written. The rubber is
// LAST and optional on purpose: it is held out of the homography fit, so it is the only mark
// that can show the other four were placed accurately. A homography always reproduces the
// four points it was fitted to, so its own error proves nothing.
// FASTAPI'S 422 `detail` IS A LIST OF OBJECTS, NOT A STRING, and the panel was passing it
// straight into new Error(). JavaScript stringifies that to "[object Object]", so EVERY
// validation error -- a blank team name, a session with no date, any required field left empty --
// surfaced as unreadable noise. The create itself was working correctly and refusing correctly;
// what was broken was the only thing that told the admin which box to fill in.
// A refusal that cannot be read is indistinguishable from a crash. [[absence-with-no-recorded-cause]]
function scoutErrorText(d, status){
  if(!d) return "HTTP "+status;
  var det = d.detail!==undefined ? d.detail : d.message;
  if(typeof det === "string" && det) return det;
  if(Array.isArray(det)){
    var parts = det.map(function(x){
      if(typeof x === "string") return x;
      // loc is ["body","session_date"] -- the last element is the field the admin can act on
      var loc = Array.isArray(x.loc) ? x.loc.filter(function(v){ return v!=="body"; }) : [];
      var field = loc.length ? loc[loc.length-1] : null;
      // "team_id" is a column name; the admin sees a field called "team". Dropping the suffix
      // is the difference between a message about the form and a message about the schema.
      if(field) field = field.replace(/_id$/,"");
      var msg = x.msg || x.type || "is not valid";
      if(/valid string|Field required|none is not/i.test(msg) && field)
        return field.replace(/_/g," ")+" is required";
      return (field ? field.replace(/_/g," ")+": " : "")+msg;
    }).filter(Boolean);
    if(parts.length) return parts.join("; ");
  }
  if(det && typeof det === "object" && det.msg) return det.msg;
  return "HTTP "+status;
}

const CAL_ORDER = ["home","first","second","third","rubber"];

function AdvanceScoutingPanel({notify}){
  /* ── THE WORKFLOW IS THE SCREEN ────────────────────────────────────────────────────────────
     Luis, 2026-11-02: "no trace of where to create players, no bbot template applied, no order
     or synchronization in the existing workflow."

     ALL THREE HAD ONE ROOT AND IT WAS NOT COSMETIC: there was no POST /scout/session. Blocks,
     lineups, pitches and reports all hang off a session and nothing created one, so there was
     no chain to put in order. The ten endpoints that were missing are built now, and this panel
     is laid out in the order the brief actually works in, each stage showing whether it is done:

       1 teams and players   §3   the roster everything else names
       2 session             §3   date, venue, teams, template — §7 ties the template here
       3 blocks              §2   uploaded -> probed -> segmented -> logged, per half-inning
       4 lineups             §4   built FROM the rosters; a team scouted before loads its last
       5 scouting            §6   the iPad tool, four taps a pitch
       6 reports             §7   composed from the pitch log, approved by a person
       7 organizations       §8   created, granted, their rosters admin-editable
       8 operations          §7+  2FA, retention, export, merge, archive

     EVERY STAGE READS ITS OWN STATE, which is the "synchronization" that was missing — a stage
     that cannot say whether it is done leaves an admin guessing which step they are on.

     NOTHING IS DERIVED THAT THE SERVER ALREADY DECIDES. The counts, the block statuses and the
     grant countdown all come from the endpoints; a panel that recomputed them would be a second
     opinion about the state of the product. [[one-source-name-what-it-counts]] */
  var dS=useState(null); var home=dS[0]; var setHome=dS[1];
  var eS=useState(""); var err=eS[0]; var setErr=eS[1];
  var bS=useState(false); var busy=bS[0]; var setBusy=bS[1];
  var stS=useState("flow"); var stage=stS[0]; var setStage=stS[1];
  var aS=useState(localStorage.getItem("bbot.scout.actor")||""); var actor=aS[0]; var setActor=aS[1];

  var tmS=useState([]); var teams=tmS[0]; var setTeams=tmS[1];
  var plS=useState([]); var players=plS[0]; var setPlayers=plS[1];
  var pqS=useState(""); var pq=pqS[0]; var setPq=pqS[1];
  var ptS=useState(""); var pteam=ptS[0]; var setPteam=ptS[1];
  var ssS=useState([]); var sessions=ssS[0]; var setSessions=ssS[1];
  var orS=useState([]); var orgs=orS[0]; var setOrgs=orS[1];
  var blS=useState({}); var blocks=blS[0]; var setBlocks=blS[1];
  var orgRS=useState(null); var orgRoster=orgRS[0]; var setOrgRoster=orgRS[1];
  var upS=useState({}); var up=upS[0]; var setUp=upS[1];
  var tagS=useState(null); var tagging=tagS[0]; var setTagging=tagS[1];
  var prS=useState(null); var proposal=prS[0]; var setProposal=prS[1];
  // PULL AN EXISTING BBOT PROFILE INTO THE REGISTRATION. One direction only --
  // recruiting to scouting, never back -- and the copy creates NO link: a name is a
  // coincidence, so binding stays the deliberate separate act.
  var pqS=useState("");   var preQ=pqS[0];    var setPreQ=pqS[1];
  var prS2=useState(null); var preHits=prS2[0]; var setPreHits=prS2[1];

  // MAP THE FIELD. Four base taps fix a homography exactly, so every later frame of this
  // block converts to field feet. The rubber is a FIFTH tap held out of the fit — a
  // homography reproduces its own four points perfectly, so only a held-out point can say
  // whether the marks were accurate.
  var coS=useState(false); var calOpen=coS[0]; var setCalOpen=coS[1];
  var cmS=useState({});   var calMarks=cmS[0]; var setCalMarks=cmS[1];
  var cnS=useState(0);    var calNext=cnS[0];  var setCalNext=cnS[1];
  var cbS=useState(90);   var calBase=cbS[0];  var setCalBase=cbS[1];
  var cdS=useState(false);var calDone=cdS[0];  var setCalDone=cdS[1];
  var ceS=useState(null); var calErr=ceS[0];   var setCalErr=ceS[1];
  var cuS=useState('');   var calUrl=cuS[0];   var setCalUrl=cuS[1];
  var calVid=useRef(null);

  var fS=useState(null); var fa=fS[0]; var setFa=fS[1];
  var frmS=useState({}); var form=frmS[0]; var setForm=frmS[1];
  function f(k,v){ setForm(function(p){var n={...p}; n[k]=v; return n;}); }
  function remember(v){ setActor(v); localStorage.setItem("bbot.scout.actor", v); }

  /* THE ADMIN'S OWN SESSION IS THE CREDENTIAL. The scouting approval gate refuses the server key
     and requires a logged-in admin; bbotAdminHeaders() already carries exactly that token, so
     there is no second sign-in and no key in this bundle. */
  function call(path, opts){
    opts = opts || {};
    return fetch(SCOUT_HOST + path, {method: opts.method || "GET",
        headers: bbotAdminHeaders(),
        body: opts.body ? JSON.stringify(opts.body) : undefined})
      .then(function(r){ return r.text().then(function(t){
        var d=null; try{ d = t?JSON.parse(t):null; }catch(e){ d={raw:t}; }
        if(!r.ok){ var m=new Error(scoutErrorText(d, r.status));
                   m.status=r.status; throw m; }
        return d; }); });
  }
  function load(){
    setBusy(true); setErr("");
    Promise.all([call("/scout/home"), call("/scout/teams"), call("/scout/sessions"),
                 call("/scout/orgs")])
      .then(function(a){ setHome(a[0]); setTeams(a[1].teams||[]);
                         setSessions(a[2].sessions||[]); setOrgs(a[3].organizations||[]);
                         setBusy(false); })
      .catch(function(e){ setErr(String(e.message||e)); setBusy(false); });
  }
  useEffect(function(){ load(); }, []);   // eslint-disable-line react-hooks/exhaustive-deps

  function findPlayers(){
    var qs=[];
    if(pq.trim()) qs.push("q="+encodeURIComponent(pq.trim()));
    if(pteam) qs.push("team_id="+encodeURIComponent(pteam));
    call("/scout/players"+(qs.length?("?"+qs.join("&")):""))
      .then(function(d){ setPlayers(d.players||[]); })
      .catch(function(e){ notify&&notify("Could not load players: "+e.message); });
  }
  function act(path, body, ok){
    setBusy(true);
    call(path, {method:(body&&body.__m)||"POST", body:body})
      .then(function(d){ setBusy(false); ok&&ok(d); load(); })
      .catch(function(e){ setBusy(false); notify&&notify(e.message); });
  }

  /* ── BBOT DESIGN SYSTEM, not a generic admin table ──────────────────────────────────────────
     §9: everything rendered for scouting is built in the existing BBOT 1.0 design system and is
     visually continuous with the current renderings — the card's surfaces, its blue rule under a
     section head, Oswald numerals on a figure, the locked blue/coral pair. The one thing no
     customer surface has is the coral ADMIN rail, so an admin is never unsure which product is
     on screen. */
  var OSW = "Oswald,'Inter',system-ui,sans-serif";
  var card={background:C.white,border:"1px solid "+C.border,borderRadius:12,padding:16,
            marginBottom:12};
  var head={display:"flex",alignItems:"center",gap:8,paddingBottom:8,marginBottom:12,
            borderBottom:"2px solid "+C.blue};
  var hTxt={font:"800 12px/1 Inter",letterSpacing:".14em",color:C.navy};
  var step={fontFamily:OSW,fontWeight:700,fontSize:13,color:C.white,background:C.blue,
            width:22,height:22,borderRadius:11,display:"flex",alignItems:"center",
            justifyContent:"center",flexShrink:0};
  var lbl={font:"800 10px Inter",letterSpacing:".12em",color:C.gray500,margin:"0 0 6px"};
  var note={fontSize:11.5,color:C.gray500,lineHeight:1.5};
  var inp={padding:"8px 10px",border:"1px solid "+C.border,borderRadius:8,fontSize:13,
           minHeight:38,background:C.white};
  var btn={background:C.blue,color:C.white,border:"none",fontWeight:700,fontSize:12.5,
           padding:"9px 14px",borderRadius:8,cursor:"pointer",minHeight:38};
  var gbt={...btn,background:C.white,color:C.blue,border:"1px solid "+C.blue};
  var th={font:"800 9px Inter",letterSpacing:".09em",color:C.gray500,textAlign:"left",
          borderBottom:"1px solid "+C.border,padding:"6px 7px"};
  var td={padding:"6px 7px",borderBottom:"1px solid "+C.gray50,fontSize:12.5,
          verticalAlign:"top"};
  /* ── TABLES SCROLL THEMSELVES, THEY DO NOT PUSH THE PAGE ──────────────────────────────────
     A seven-column session row is wider than a phone. Without a scroller the TABLE sets the
     page width and the whole dashboard scrolls sideways — every heading, every form, the lot —
     which is the worst version of the problem because the thing that overflowed is off-screen
     and the thing you are looking at has moved. One box scrolls instead, and the minWidth keeps
     the columns legible rather than crushing eight of them into 320px. */
  /* ── SESSION VIDEO: THE PATH THAT DID NOT EXIST ───────────────────────────────────────────
     Luis: "there's no clear path to add session video and have bbot tag and rinse to a scouting
     player profile." The ENDPOINTS were all there — /scout/blocks/start hands back presigned
     part URLs, /complete assembles them and enqueues the motion_fps probe, and /generate-clips
     already accepts subjectType "scout_player" so the clip pipeline can target a scouted player
     rather than a recruiting one. What was missing was any screen that connected them.

     THE PARTS GO STRAIGHT FROM THE BROWSER TO R2. They never pass through the backend, which is
     why a 4K half-inning does not have to fit in a request body or a dyno's memory.

     A FAILED PART STOPS THE UPLOAD RATHER THAN COMPLETING A SHORT FILE. /complete lists what R2
     actually holds and refuses when there are no parts, but a block missing its middle would
     otherwise assemble into a video that plays and is wrong — and every pitch timed against it
     would be timed against the wrong frames. [[silent-failure-write-sweep]] */
  // The same signed-URL route the recruiting tagger uses, not a second one.
  useEffect(function(){
    if(!tagging||!tagging.objectKey){ setCalUrl(""); return; }
    fetch(BACKEND_URL+"/r2-read-url?objectKey="+encodeURIComponent(tagging.objectKey),
          {headers:bbotAdminHeaders()})
      .then(function(r){return r.json();})
      .then(function(d){ if(d&&d.url) setCalUrl(d.url); }).catch(function(){});
    // a map already saved for this block is shown as saved rather than asked for again
    call("/scout/blocks/calibration?session_id="+tagging.sessionId
         +"&block_index="+(tagging.blockIndex||0))
      .then(function(d){
        var c=d&&d.calibration;
        if(!c){ setCalDone(false); setCalMarks({}); setCalNext(0); setCalErr(null); return; }
        setCalDone(true); setCalMarks(c.marks||{}); setCalBase(c.base_ft||90);
        setCalErr(c.check&&c.check.error_ft!==undefined?c.check.error_ft:null);
      }).catch(function(){});
  },[tagging&&tagging.objectKey]);

  function findPrefill(){
    var term=(preQ||"").trim();
    if(term.length<2) return;
    setBusy(true);
    call("/scout/identity/prefill?q="+encodeURIComponent(term))
      .then(function(d){ setBusy(false); setPreHits((d&&d.matches)||[]); })
      .catch(function(e){ setBusy(false); setPreHits(null); notify&&notify(e.message); });
  }

  function uploadBlock(sessionId, file, blockIndex, startedAt, angle, onProgress){
    return call("/scout/blocks/start", {method:"POST", body:{
        session_id:sessionId, block_index:blockIndex, file_name:file.name,
        file_size:file.size, started_at:startedAt||null, camera_angle:angle||null}})
      .then(function(d){
        var parts=d.parts||[], size=d.partSize, done=0;
        function put(i){
          if(i>=parts.length) return Promise.resolve();
          var from=i*size, to=Math.min(file.size, from+size);
          return fetch(parts[i].url,{method:"PUT",body:file.slice(from,to)})
            .then(function(r){
              if(!r.ok) throw new Error("part "+(i+1)+" of "+parts.length+" failed ("+r.status
                +") — the upload is stopped rather than completed short");
              done++; onProgress&&onProgress(Math.round(100*done/parts.length));
              return put(i+1);
            });
        }
        return put(0).then(function(){
          return call("/scout/blocks/complete", {method:"POST", body:{
            session_id:sessionId, block_index:blockIndex, upload_id:d.uploadId}});
        }).catch(function(e){
          /* ABORT CLEARS THE PARTS ALREADY IN R2. An interrupted multipart leaves its parts
             behind as storage nobody can see and nobody is billing anyone for by accident. */
          return call("/scout/blocks/abort", {method:"POST", body:{
            session_id:sessionId, block_index:blockIndex, upload_id:d.uploadId}})
            .catch(function(){}).then(function(){ throw e; });
        });
      });
  }

  function Tbl(props){
    return <div style={{overflowX:"auto",WebkitOverflowScrolling:"touch",maxWidth:"100%"}}>
      <table style={{width:"100%",minWidth:props.min||540,borderCollapse:"collapse"}}>
        {props.children}</table></div>;
  }
  function pill(kind,txt){
    var m={ok:["#eaf6ee","#b7dfc4","#2e8b57"],off:["#fff3e2","#f0cf9c","#b4690e"],
            bad:["#fdecec","#f1b9b6","#b4231e"],n:[C.white,C.border,C.gray500]}[kind||"n"];
    return <span style={{font:"800 9px Inter",letterSpacing:".08em",padding:"2px 8px",
      borderRadius:12,whiteSpace:"nowrap",background:m[0],border:"1px solid "+m[1],
      color:m[2]}}>{txt}</span>;
  }
  function figure(n,t,kind){
    return <div key={t} style={{background:C.white,border:"1px solid "+C.border,borderRadius:12,
      padding:"12px 14px",flex:"1 1 150px",minWidth:150}}>
      <div style={{fontFamily:OSW,fontWeight:700,fontSize:26,lineHeight:1,
        color:kind==="warn"?C.coral:C.blue}}>{n}</div>
      <div style={{font:"800 9px Inter",letterSpacing:".1em",color:C.gray500,marginTop:4}}>{t}</div>
    </div>;
  }

  /* ── THE WORKFLOW STRIP: every stage says whether it is done ────────────────────────────── */
  var sess = sessions || [];
  var withBlocks = sess.filter(function(s){ return (s.n_blocks||0)>0; });
  var logged = sess.filter(function(s){
    var b=blocks[s.id]; return b&&b.complete; });
  var STAGES=[
    {id:"roster", n:1, label:"TEAMS & PLAYERS", ref:"§3",
     done:(teams.length>0), state:teams.length?(teams.length+" team(s)"):"no team yet"},
    {id:"session", n:2, label:"SESSION", ref:"§3",
     done:(sess.length>0), state:sess.length?(sess.length+" session(s)"):"no session yet"},
    {id:"blocks", n:3, label:"BLOCKS", ref:"§2",
     done:(withBlocks.length>0),
     state:withBlocks.length?(withBlocks.length+" session(s) with footage"):"no block uploaded"},
    {id:"lineups", n:4, label:"LINEUPS", ref:"§4", done:null, state:"built from the rosters"},
    {id:"scouting", n:5, label:"SCOUTING", ref:"§6", done:null, state:"the iPad tool"},
    // SEGMENT & RINSE IS ITS OWN STAGE because it is its own step: the clips that reach a
    // scouted player's profile come from here, and it was reachable only by expanding a
    // session row on stage 3. A step nobody can find is a step that is not built.
    {id:"segment", n:6, label:"SEGMENT & RINSE", ref:"§4",
     done:(withBlocks.length>0?null:false),
     state:withBlocks.length?("tag "+withBlocks.length+" session(s) with footage")
                            :"no block uploaded yet"},
    {id:"handtimes", n:7, label:"HAND TIMES", ref:"§5-A1", done:null,
     state:"your h2f and pop times, beside BBOT's"},
    {id:"reports", n:8, label:"REPORTS", ref:"§7",
     done:(home&&home.n_pending===0&&sess.length>0),
     state:home?((home.n_pending||0)+" awaiting approval"):"…"},
    {id:"orgs", n:9, label:"ORGANIZATIONS", ref:"§8",
     done:(orgs.length>0), state:orgs.length?(orgs.length+" organization(s)"):"none yet"},
    {id:"ops", n:10, label:"OPERATIONS", ref:"§7", done:null, state:"2FA, retention, export"},
  ];

  function Flow(){
    return <div style={card}>
      <div style={head}><span style={hTxt}>THE WORKFLOW, IN ORDER</span>
        <span style={{flex:1}}/>
        <span style={note}>tap a stage to work it</span></div>
      <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(190px,1fr))",gap:8}}>
        {STAGES.map(function(s){
          return <button key={s.id} onClick={function(){setStage(s.id);}}
            style={{textAlign:"left",background:stage===s.id?C.blueFaint:C.white,
              border:"1px solid "+(stage===s.id?C.blue:C.border),borderRadius:10,
              padding:"10px 12px",cursor:"pointer",minHeight:62}}>
            <div style={{display:"flex",alignItems:"center",gap:8}}>
              <span style={{...step,background:s.done===true?"#2e8b57":s.done===false?C.coral:C.blue}}>{s.n}</span>
              <span style={{font:"800 10.5px Inter",letterSpacing:".08em",color:C.navy}}>{s.label}</span>
              <span style={{...note,marginLeft:"auto"}}>{s.ref}</span>
            </div>
            <div style={{...note,marginTop:5}}>
              {s.done===true?"✓ ":s.done===false?"— ":""}{s.state}
            </div>
          </button>;})}
      </div>
      {/* WHAT IS BLOCKING, SAID ONCE AND PLAINLY — not left for an admin to infer from counts. */}
      <p style={{...note,marginTop:12,marginBottom:0}}>
        {!teams.length?"Start at stage 1: a team, then its players. Everything else names them."
         :!sess.length?"Stage 2: create a session. Blocks, lineups, pitches and reports all hang off one."
         :!withBlocks.length?"Stage 3: upload the half-inning blocks from the phone, then align them."
         :"Scout the session on the iPad tool, then compose and approve its reports."}
      </p>
    </div>;
  }

  /* ── 1 · TEAMS AND PLAYERS ─────────────────────────────────────────────────────────────── */
  function Roster(){
    return <div>
      <div style={card}>
        <div style={head}><span style={step}>1</span><span style={hTxt}>TEAMS</span></div>
        <div style={{display:"flex",gap:8,flexWrap:"wrap",marginBottom:10}}>
          <input style={{...inp,flex:"1 1 200px"}} placeholder="team name *"
            value={form.tname||""} onChange={function(e){f("tname",e.target.value);}}/>
          <input style={{...inp,flex:"0 1 150px"}} placeholder="league (MLB, LBPRC, HS…)"
            value={form.tleague||""} onChange={function(e){f("tleague",e.target.value);}}/>
          <button style={btn} disabled={busy||!(form.tname||"").trim()} onClick={function(){
            act("/scout/teams",{name:form.tname.trim(),league:form.tleague||null},
                function(){ f("tname",""); f("tleague",""); notify&&notify("Team created."); });
          }}>Create team</button>
        <span style={{...note,marginLeft:8}}>* required</span>
        </div>
        {!teams.length?<div style={note}>No team yet.</div>
         :<Tbl><tbody>
           <tr><th style={th}>Team</th><th style={th}>League</th><th style={th}>Id</th></tr>
           {teams.map(function(t){return <tr key={t.id}>
             <td style={td}>{t.name}</td><td style={td}>{t.league||"—"}</td>
             <td style={{...td,color:C.gray500}}>{t.id}</td></tr>;})}
         </tbody></Tbl>}
      </div>

      <div style={card}>
        <div style={head}><span style={step}>1</span><span style={hTxt}>PLAYERS</span>
          <span style={{flex:1}}/><span style={note}>no email, no account, no contact data — §3</span></div>
        {/* PULL AN EXISTING PROFILE. The admin types a name, picks a match, and the
            registration fields below are filled in. Nothing is linked and nothing travels back
            to the recruiting side -- this reads bbot_users and writes only to the form. */}
        <div style={{display:"flex",gap:8,flexWrap:"wrap",alignItems:"center",marginBottom:8}}>
          <input style={{...inp,flex:"1 1 200px"}} placeholder="pull an existing BBOT profile by name"
            value={preQ} onChange={function(e){setPreQ(e.target.value);}}
            onKeyDown={function(e){ if(e.key==="Enter") findPrefill(); }}/>
          <button style={gbt} disabled={busy||preQ.trim().length<2}
            onClick={findPrefill}>Search profiles</button>
          {preHits&&<button style={gbt} onClick={function(){setPreHits(null);setPreQ("");}}>
            Clear</button>}
        </div>
        {preHits&&(!preHits.length
          ? <div style={{...note,marginBottom:10}}>No BBOT profile matches that name. Type the
              player in by hand below — a scouted player does not need an account.</div>
          : <Tbl min={520}><tbody>
              <tr><th style={th}>Name</th><th style={th}>DOB</th><th style={th}>B/T</th>
                  <th style={th}>Pos</th><th style={th}>#</th><th style={th}></th></tr>
              {preHits.map(function(m){
                var d=m.prefill||{};
                return <tr key={m.bbot_user_id}>
                  <td style={td}>{(d.first_name||"")+" "+(d.last_name||"")}</td>
                  <td style={td}>{d.dob||"—"}</td>
                  <td style={td}>{(d.bats||"?")+"/"+(d.throws||"?")}</td>
                  <td style={td}>{(d.positions||[]).join(", ")||"—"}</td>
                  <td style={td}>{d.jersey_number||"—"}</td>
                  <td style={td}>
                    {m.already_scouted_as
                      ? pill("off","already scouted")
                      : <button style={{...gbt,padding:"4px 9px",minHeight:28}}
                          onClick={function(){
                            f("pf",d.first_name||""); f("pl",d.last_name||"");
                            f("pd",d.dob||"");        f("pj",d.jersey_number||"");
                            f("pb",d.bats||"");       f("pt",d.throws||"");
                            f("pp",(d.positions||[]).join(", "));
                            setPreHits(null);
                            notify&&notify("Form filled from the BBOT profile. Saving creates an "
                              +"UNLINKED scouted player — check the fields before you do.");
                          }}>Use</button>}
                  </td></tr>;})}
            </tbody></Tbl>)}
        {preHits&&!!preHits.length&&<p style={{...note,marginBottom:10}}>
          Filling the form copies these values. It does NOT link the two records — a name is a
          coincidence, and binding footage to the wrong account is the failure that rule exists
          for. Link deliberately afterwards if the match is certain.
        </p>}
        <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(130px,1fr))",
                     gap:8,marginBottom:10}}>
          <input style={inp} placeholder="first name *" value={form.pf||""}
            onChange={function(e){f("pf",e.target.value);}}/>
          <input style={inp} placeholder="last name *" value={form.pl||""}
            onChange={function(e){f("pl",e.target.value);}}/>
          <input style={inp} placeholder="jersey #" value={form.pj||""}
            onChange={function(e){f("pj",e.target.value);}}/>
          <input style={inp} placeholder="DOB (YYYY-MM-DD)" value={form.pd||""}
            onChange={function(e){f("pd",e.target.value);}}/>
          <select style={inp} value={form.pb||""} onChange={function(e){f("pb",e.target.value);}}>
            <option value="">bats…</option><option value="R">bats R</option>
            <option value="L">bats L</option><option value="S">bats S</option></select>
          <select style={inp} value={form.pt||""} onChange={function(e){f("pt",e.target.value);}}>
            <option value="">throws…</option><option value="R">throws R</option>
            <option value="L">throws L</option></select>
          <input style={inp} placeholder="positions (RHP, C, SS)" value={form.pp||""}
            onChange={function(e){f("pp",e.target.value);}}/>
          <select style={inp} value={form.pteamAdd||""}
            onChange={function(e){f("pteamAdd",e.target.value);}}>
            <option value="">add to roster…</option>
            {teams.map(function(t){return <option key={t.id} value={t.id}>{t.name}</option>;})}
          </select>
        </div>
        <button style={btn} disabled={busy||!((form.pf||"").trim()||(form.pl||"").trim())}
          onClick={function(){
            var body={first_name:(form.pf||"").trim()||null,last_name:(form.pl||"").trim()||null,
              jersey_number:(form.pj||"").trim()||null,dob:(form.pd||"").trim()||null,
              bats:form.pb||null,throws:form.pt||null,
              positions:(form.pp||"").split(",").map(function(x){return x.trim();})
                         .filter(Boolean)};
            setBusy(true);
            call("/scout/players",{method:"POST",body:body}).then(function(d){
              var id=(d&&(d.player||d.row||d)||{}).id;
              if(!id&&d) Object.keys(d).forEach(function(k){
                if(d[k]&&d[k].id) id=d[k].id; });
              /* ADDING TO A ROSTER IS A SECOND CALL AND IT IS NOT OPTIONAL BOOKKEEPING: §4 says
                 "lineups are built from rosters", so a player on no roster can never appear in
                 a lineup and would be invisible to the tool. */
              if(id&&form.pteamAdd)
                return call("/scout/roster",{method:"POST",
                  body:{player_id:Number(id),team_id:Number(form.pteamAdd)}});
            }).then(function(){ setBusy(false);
              ["pf","pl","pj","pd","pp"].forEach(function(k){f(k,"");});
              notify&&notify("Player created"+(form.pteamAdd?" and added to the roster.":"."));
              findPlayers(); load();
            }).catch(function(e){ setBusy(false); notify&&notify(e.message); });
          }}>Create player</button>
        <span style={{...note,marginLeft:8}}>* required</span>

        <div style={{...lbl,marginTop:16}}>PULL EXISTING PLAYERS — BY NAME, OR BY ROSTER</div>
        <div style={{display:"flex",gap:8,flexWrap:"wrap",marginBottom:8}}>
          <input style={{...inp,flex:"1 1 180px"}} placeholder="name"
            value={pq} onChange={function(e){setPq(e.target.value);}}
            onKeyDown={function(e){ if(e.key==="Enter") findPlayers(); }}/>
          <select style={{...inp,flex:"0 1 190px"}} value={pteam}
            onChange={function(e){setPteam(e.target.value);}}>
            <option value="">any roster</option>
            {teams.map(function(t){return <option key={t.id} value={t.id}>{t.name}</option>;})}
          </select>
          <button style={btn} onClick={findPlayers}>Find</button>
          <button style={gbt} onClick={function(){setPq("");setPteam("");findPlayers();}}>All</button>
        </div>
        {!players.length?<div style={note}>No player loaded — search, or pick a roster.</div>
         :<Tbl><tbody>
           <tr><th style={th}>Player</th><th style={th}>#</th><th style={th}>B/T</th>
               <th style={th}>Pos</th><th style={th}>Active</th><th style={th}>Id</th></tr>
           {players.slice(0,200).map(function(p){return <tr key={p.id}>
             <td style={td}>{((p.first_name||"")+" "+(p.last_name||"")).trim()||"—"}</td>
             <td style={td}>{p.jersey_number||"—"}</td>
             <td style={td}>{(p.bats||"—")+"/"+(p.throws||"—")}</td>
             <td style={td}>{(p.positions||[]).join(", ")||"—"}</td>
             <td style={td}>{p.active===false?pill("off","inactive"):pill("ok","active")}</td>
             <td style={{...td,color:C.gray500}}>{p.id}</td></tr>;})}
         </tbody></Tbl>}
        {players.length>200&&<p style={note}>{players.length} found; first 200 shown.</p>}
      </div>
    </div>;
  }

  /* ── 2 · SESSION ───────────────────────────────────────────────────────────────────────── */
  function Sessions(){
    return <div>
      <div style={card}>
        <div style={head}><span style={step}>2</span><span style={hTxt}>CREATE A SESSION</span>
          <span style={{flex:1}}/>
          <span style={note}>the template decides which sections may be delivered — §7</span></div>
        <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(140px,1fr))",
                     gap:8,marginBottom:10}}>
          <span style={{...note,alignSelf:"center"}}>date *</span>
          <input style={inp} type="date" value={form.sdate||""}
            onChange={function(e){f("sdate",e.target.value);}}/>
          <input style={inp} placeholder="venue" value={form.svenue||""}
            onChange={function(e){f("svenue",e.target.value);}}/>
          <select style={inp} value={form.shome||""} onChange={function(e){f("shome",e.target.value);}}>
            <option value="">home team…</option>
            {teams.map(function(t){return <option key={t.id} value={t.id}>{t.name}</option>;})}
          </select>
          <select style={inp} value={form.saway||""} onChange={function(e){f("saway",e.target.value);}}>
            <option value="">away team…</option>
            {teams.map(function(t){return <option key={t.id} value={t.id}>{t.name}</option>;})}
          </select>
          <select style={inp} value={form.stpl||"pro"} onChange={function(e){f("stpl",e.target.value);}}>
            <option value="pro">pro</option><option value="college">college</option>
            <option value="amateur">amateur</option></select>
          <input style={inp} placeholder="observer(s)" value={form.sobs||""}
            onChange={function(e){f("sobs",e.target.value);}}/>
        </div>
        <button style={btn} disabled={busy||!(form.sdate||"")} onClick={function(){
          act("/scout/session",{session_date:form.sdate,venue:form.svenue||null,
            home_team_id:form.shome?Number(form.shome):null,
            away_team_id:form.saway?Number(form.saway):null,
            template:form.stpl||"pro",observers:form.sobs||null,actor:actor||null},
            function(){ ["sdate","svenue","sobs"].forEach(function(k){f(k,"");});
                        notify&&notify("Session created. Upload its blocks next."); });
        }}>Create session</button>
        <span style={{...note,marginLeft:8}}>* required</span>
        <p style={{...note,marginTop:8,marginBottom:0}}>
          An amateur session delivers observations and charts only — no measured or hand-timed
          layer in the PDF — until that ruling changes. §0.
        </p>
      </div>

      <div style={card}>
        <div style={head}><span style={step}>3</span><span style={hTxt}>SESSIONS AND THEIR BLOCKS</span></div>
        {!sess.length?<div style={note}>No session yet.</div>
         :<Tbl><tbody>
           <tr><th style={th}>Date</th><th style={th}>Venue</th><th style={th}>Home / Away</th>
               <th style={th}>Template</th><th style={th}>Status</th><th style={th}>Blocks</th>
               <th style={th}>Video</th></tr>
           {sess.slice(0,60).map(function(s){
             var bd=blocks[s.id];
             return <Fragment key={s.id}>
               <tr>
                 <td style={td}>{s.session_date}</td><td style={td}>{s.venue||"—"}</td>
                 <td style={td}>{(s.home||"—")+" / "+(s.away||"—")}</td>
                 <td style={td}>{s.template||"—"}</td>
                 <td style={td}>{pill(s.status==="approved"?"ok":"n",s.status||"—")}</td>
                 <td style={td}>{s.n_blocks?<button style={{background:"none",border:"none",
                     color:C.blue,fontWeight:700,fontSize:12.5,cursor:"pointer",padding:0,
                     textDecoration:"underline"}} onClick={function(){
                       if(bd){ setBlocks(function(p){var n={...p}; delete n[s.id]; return n;}); return; }
                       call("/scout/blocks?session_id="+s.id).then(function(d){
                         setBlocks(function(p){var n={...p}; n[s.id]=d; return n;}); })
                         .catch(function(e){ notify&&notify(e.message); });
                     }}>{s.n_blocks}{bd?" ▾":" ▸"}</button>:0}</td>
                 <td style={td}>
                   {/* ONE HALF-INNING, ONE BLOCK. §2: "filmed in blocks per half-inning, blocks
                       upload as-is, never reassembled" — so the control takes one file and the
                       index is the block's own, not a running total of files picked. */}
                   <label style={{...gbt,padding:"5px 9px",minHeight:30,display:"inline-block",
                     cursor:busy?"not-allowed":"pointer",marginRight:6}}>
                     {up[s.id]!==undefined?("Uploading "+up[s.id]+"%"):"Add video"}
                     <input type="file" accept="video/*" style={{display:"none"}} disabled={busy}
                       onChange={function(e){
                         var file=e.target.files&&e.target.files[0]; e.target.value="";
                         if(!file) return;
                         if(file.size<5*1024*1024){
                           notify&&notify("That file is under 5 MB — R2's multipart minimum. "
                             +"A half-inning block is bigger than that, so this is probably the "
                             +"wrong file."); return; }
                         var idx=(s.n_blocks||0);
                         setUp(function(x){var n={...x}; n[s.id]=0; return n;});
                         setBusy(true);
                         uploadBlock(s.id,file,idx,new Date().toISOString(),null,
                           function(pc){ setUp(function(x){var n={...x}; n[s.id]=pc; return n;}); })
                           .then(function(){ setBusy(false);
                             setUp(function(x){var n={...x}; delete n[s.id]; return n;});
                             notify&&notify("Block "+idx+" uploaded. The motion_fps probe runs "
                               +"on it; its status moves to probed when the rate is measured.");
                             setBlocks(function(x){var n={...x}; delete n[s.id]; return n;});
                             load(); })
                           .catch(function(err){ setBusy(false);
                             setUp(function(x){var n={...x}; delete n[s.id]; return n;});
                             notify&&notify("Upload failed: "+err.message); });
                       }}/>
                   </label>
                   <button style={{...gbt,padding:"5px 9px",minHeight:30}}
                   disabled={busy||!s.n_blocks} title="bind the iPad taps to their blocks — §4"
                   onClick={function(){ act("/scout/blocks/align",{session_id:s.id,
                     actor:actor||null}, function(d){ notify&&notify("Aligned: "+d.n_bound+
                     " bound, "+d.n_unbound+" unbound ("+d.offset_basis+" offset).");
                     setBlocks(function(p){var n={...p}; delete n[s.id]; return n;}); }); }}
                   >Align</button></td>
               </tr>
               {bd&&<tr><td colSpan={7} style={{...td,background:C.gray50}}>
                 {!(bd.blocks||[]).length?<span style={note}>No block recorded.</span>
                  :<Tbl><tbody>
                    <tr><th style={th}>Block</th><th style={th}>Status</th><th style={th}>Angle</th>
                        <th style={th}>Measured fps</th><th style={th}>Resolution</th>
                        <th style={th}>Bound</th><th style={th}></th></tr>
                    {bd.blocks.map(function(b,i){var st=String(b.status||"uploading");
                      return <tr key={i}>
                        <td style={td}>{b.index!==undefined?b.index:i}</td>
                        <td style={td}>{pill(st==="logged"?"ok":/fail/.test(st)?"bad":"off",st)}</td>
                        <td style={td}>{b.camera_angle||<span style={{color:C.gray500}}>not read</span>}</td>
                        <td style={td}>{b.motion_fps||<span style={{color:C.gray500}}>not probed</span>}</td>
                        <td style={td}>{b.resolution_ms?(b.resolution_ms+" ms"):"—"}</td>
                        <td style={td}>{b.n_bound||0}</td>
                        <td style={td}><button style={{...gbt,padding:"4px 8px",minHeight:26}}
                          disabled={!b.r2_key}
                          onClick={function(){ setTagging({sessionId:s.id, objectKey:b.r2_key, blockIndex:b.index,
                            date:s.session_date, blocks:(bd&&bd.blocks)||[]});
                            setProposal(null); setStage("segment"); }}>Tag &amp; rinse</button></td></tr>;})}
                  </tbody></Tbl>}
                 <p style={{...note,margin:"6px 0 0"}}>
                   uploaded → probed → segmented → logged. A block with no tap in its span stays
                   <b> probed</b> rather than reading as finished.
                 </p>
               </td></tr>}
             </Fragment>;})}
         </tbody></Tbl>}
      </div>
    </div>;
  }

  /* ── HAND TIMES ────────────────────────────────────────────────────────────────────────
     Luis 2026-11-03: "you also always allow admin to override any h2f, pop times manually".
     IT IS NOT AN OVERRIDE THAT SUPPRESSES BBOT — the schema's own rule is that admin and
     measured live in separate columns, print side by side, and a disagreement is flagged rather
     than reconciled. And the standing rule is that an admin-entered time is GROUND TRUTH, so
     where they differ it is BBOT's number under suspicion, not his stopwatch. */
  function HandTimes(){
    var pS=useState([]); var plays=pS[0], setPlays=pS[1];
    var sS=useState(null); var hsid=sS[0], setHsid=sS[1];

    function load(sid){
      setHsid(sid);
      call("/scout/pitch?session_id="+sid)
        .then(function(d){ setPlays((d&&d.pitches)||[]); })
        .catch(function(e){ notify&&notify(e.message); });
    }
    function put(row, field, val){
      var body={}; body[field]=(val===""?-1.0:Number(val));   // -1 clears a mistyped time
      if(val!=="" && !isFinite(Number(val))) { notify&&notify("That is not a time."); return; }
      setBusy(true);
      call("/scout/pitch/"+row.id,{method:"PATCH",body:body})
        .then(function(){ setBusy(false); load(hsid);
          notify&&notify(val===""?"Cleared.":"Saved — BBOT's own value stays beside it."); })
        .catch(function(e){ setBusy(false); notify&&notify(e.message); });
    }
    function measuredOf(row, key){
      var m=(row&&row.measured)||{}; var q=m[key]||{};
      return (q.seconds!==undefined&&q.seconds!==null)
        ? (Number(q.seconds).toFixed(2)+(q.plus_minus_s?(" ±"+Number(q.plus_minus_s).toFixed(3)):""))
        : null;
    }
    function verdict(row, key, col){
      var m=((row&&row.measured)||{})[key]||{}; var hand=row[col];
      if(hand===null||hand===undefined) return m.seconds!=null?pill("ok","BBOT only"):null;
      if(m.seconds===undefined||m.seconds===null) return pill("ok","hand-timed");
      if(m.plus_minus_s===undefined||m.plus_minus_s===null)
        return pill("off","no ± — not comparable");
      // the same rule the backend applies: agreement means inside the COMBINED uncertainty,
      // which includes ~0.1 s of human reaction on the stopwatch side
      var diff=Math.abs(Number(m.seconds)-Number(hand));
      return diff<=(Number(m.plus_minus_s)+0.10)
        ? pill("ok","agree")
        : pill("off","DISAGREE by "+diff.toFixed(2)+"s");
    }

    return <div style={card}>
      <div style={head}><span style={step}>7</span><span style={hTxt}>HAND TIMES</span>
        <span style={{flex:1}}/>
        <span style={note}>your stopwatch is ground truth — §5-A1</span></div>

      <p style={note}>
        Type a home-to-first or pop time against any logged pitch. It is stored in its own column,
        never into BBOT's: both print side by side on the report and a disagreement is flagged
        rather than averaged away. Clear a field to delete a mistyped value.
      </p>

      <div style={{display:"flex",gap:8,flexWrap:"wrap",marginBottom:10}}>
        {sess.map(function(x){
          return <button key={x.id} style={hsid===x.id?btn:gbt}
            onClick={function(){ load(x.id); }}>{x.session_date}{x.venue?(" · "+x.venue):""}</button>;})}
        {!sess.length&&<span style={note}>No session yet.</span>}
      </div>

      {hsid&&(!plays.length
        ? <div style={note}>No pitch is logged for this session, so there is no play to time
            against. Hand times attach to a pitch — that is what binds them to an inning, a
            batter and a catcher.</div>
        : <Tbl min={720}><tbody>
            <tr><th style={th}>Inn</th><th style={th}>Batter</th><th style={th}>Result</th>
                <th style={{...th,textAlign:"right"}}>H2F (hand)</th>
                <th style={{...th,textAlign:"right"}}>H2F (BBOT)</th><th style={th}></th>
                <th style={{...th,textAlign:"right"}}>Pop (hand)</th>
                <th style={{...th,textAlign:"right"}}>Pop (BBOT)</th><th style={th}></th></tr>
            {plays.map(function(row){
              var k="p"+row.id;
              return <tr key={row.id}>
                <td style={td}>{row.inning||"—"}{row.half?String(row.half)[0]:""}</td>
                <td style={td}>{row.batter_id||"—"}</td>
                <td style={td}>{row.result||"—"}</td>
                <td style={{...td,textAlign:"right"}}>
                  <input type="number" step="0.01" inputMode="decimal"
                    defaultValue={row.h2f_s!==null&&row.h2f_s!==undefined?row.h2f_s:""}
                    style={{width:72,textAlign:"right",font:"600 13px Inter",padding:"4px 6px",
                            border:"1px solid "+C.border,borderRadius:6,minHeight:32}}
                    onBlur={function(e){
                      var v=e.target.value;
                      if(String(v)!==String(row.h2f_s===null||row.h2f_s===undefined?"":row.h2f_s))
                        put(row,"h2f_s",v); }}/>
                </td>
                <td style={{...td,textAlign:"right",fontVariantNumeric:"tabular-nums"}}>
                  {measuredOf(row,"home_to_first")||<span style={{color:C.gray500}}>—</span>}</td>
                <td style={td}>{verdict(row,"home_to_first","h2f_s")}</td>
                <td style={{...td,textAlign:"right"}}>
                  <input type="number" step="0.01" inputMode="decimal"
                    defaultValue={row.pop_time_s!==null&&row.pop_time_s!==undefined?row.pop_time_s:""}
                    style={{width:72,textAlign:"right",font:"600 13px Inter",padding:"4px 6px",
                            border:"1px solid "+C.border,borderRadius:6,minHeight:32}}
                    onBlur={function(e){
                      var v=e.target.value;
                      if(String(v)!==String(row.pop_time_s===null||row.pop_time_s===undefined?"":row.pop_time_s))
                        put(row,"pop_time_s",v); }}/>
                </td>
                <td style={{...td,textAlign:"right",fontVariantNumeric:"tabular-nums"}}>
                  {measuredOf(row,"pop_time")||<span style={{color:C.gray500}}>—</span>}</td>
                <td style={td}>{verdict(row,"pop_time","pop_time_s")}</td>
              </tr>;})}
          </tbody></Tbl>)}
    </div>;
  }

  /* ── 6 · REPORTS ───────────────────────────────────────────────────────────────────────── */
  function Reports(){
    var pend=(home&&home.pending_approvals)||[];
    return <div style={card}>
      <div style={head}><span style={step}>8</span><span style={hTxt}>REPORTS AND APPROVAL</span>
        <span style={{flex:1}}/>
        <span style={note}>the server key cannot approve — §0</span></div>
      <div style={{display:"flex",gap:8,flexWrap:"wrap",marginBottom:10}}>
        <input style={{...inp,flex:"1 1 200px"}} placeholder="your name — an approval is signed"
          value={actor} onChange={function(e){remember(e.target.value);}}/>
      </div>
      {!pend.length?<div style={note}>Nothing is waiting for approval.</div>
       :<Tbl><tbody>
         <tr><th style={th}>#</th><th style={th}>Kind</th><th style={th}>Subject</th>
             <th style={th}>Lang / Units</th><th style={th}>Content hash</th><th style={th}></th></tr>
         {pend.map(function(p){return <tr key={p.id}>
           <td style={td}>{p.id}</td><td style={td}>{p.kind}</td>
           <td style={td}>{p.player_id?("player "+p.player_id):p.team_id?("team "+p.team_id)
             :("session "+p.session_id)}</td>
           <td style={td}>{(p.lang||"—")+" / "+(p.units||"—")}</td>
           <td style={{...td,color:C.gray500,fontSize:11}}>
             {p.content_hash?(String(p.content_hash).slice(0,12)+"…"):"no content hash"}</td>
           <td style={td}><button style={{...btn,opacity:p.content_hash?1:.45,
             cursor:p.content_hash?"pointer":"not-allowed"}}
             disabled={!p.content_hash||busy} onClick={function(){
               if(!(actor||"").trim()){ notify&&notify("Name the admin approving this."); return; }
               if(!window.confirm("Approve report "+p.id+"?\n\nThis releases the document under "
                 +"its content hash. A re-approval later creates a new version and keeps this "
                 +"one.")) return;
               act("/scout/report/approve",{report_id:Number(p.id),
                 content_hash:p.content_hash,actor:actor.trim()},
                 function(d){ notify&&notify("Approved. Version "+(d.version||1)+
                   (d.second_factor&&d.second_factor.required?" · second factor verified":"")); });
             }}>Approve</button></td></tr>;})}
       </tbody></Tbl>}
    </div>;
  }

  /* ── 7 · ORGANIZATIONS ─────────────────────────────────────────────────────────────────── */
  function Orgs(){
    return <div>
      <div style={card}>
        <div style={head}><span style={step}>9</span><span style={hTxt}>ORGANIZATIONS</span>
          <span style={{flex:1}}/>
          <span style={note}>a grant is the only thing that makes anything visible — §8</span></div>
        <div style={{display:"flex",gap:8,flexWrap:"wrap",marginBottom:10}}>
          <input style={{...inp,flex:"1 1 160px"}} placeholder="organization name *"
            value={form.oname||""} onChange={function(e){f("oname",e.target.value);}}/>
          <input style={{...inp,flex:"0 1 130px"}} placeholder="league"
            value={form.oleague||""} onChange={function(e){f("oleague",e.target.value);}}/>
          <input style={{...inp,flex:"0 1 160px"}} placeholder="contact"
            value={form.ocontact||""} onChange={function(e){f("ocontact",e.target.value);}}/>
          <select style={{...inp,flex:"0 1 170px"}} value={form.oteam||""}
            onChange={function(e){f("oteam",e.target.value);}}>
            <option value="">its roster team…</option>
            {teams.map(function(t){return <option key={t.id} value={t.id}>{t.name}</option>;})}
          </select>
          <button style={btn} disabled={busy||!(form.oname||"").trim()} onClick={function(){
            act("/scout/orgs",{name:form.oname.trim(),league:form.oleague||null,
              contact:form.ocontact||null,
              roster_team_id:form.oteam?Number(form.oteam):null,actor:actor||null},
              function(d){ ["oname","oleague","ocontact"].forEach(function(k){f(k,"");});
                window.alert("Organization created.\n\nCredential (shown ONCE):\n\n"+
                  d.credential+"\n\nOnly its hash is stored. The organization sees NOTHING "+
                  "until a grant exists."); });
          }}>Create organization</button>
        <span style={{...note,marginLeft:8}}>* required</span>
        </div>
        {!orgs.length?<div style={note}>No organization yet.</div>
         :orgs.map(function(o){return <div key={o.id} style={{border:"1px solid "+C.border,
           borderRadius:10,padding:12,marginBottom:8}}>
           <div style={{display:"flex",alignItems:"center",gap:8,flexWrap:"wrap"}}>
             <b style={{fontSize:13.5}}>{o.name}</b>
             {pill(o.status==="active"?"ok":o.status==="paused"?"off":"bad",o.status)}
             <span style={note}>{o.league||"no league"} · roster: {o.roster_team||"none set"}</span>
             {!o.has_credential&&pill("off","no credential")}
             <span style={{flex:1}}/>
             <button style={{...gbt,padding:"5px 9px",minHeight:30}} onClick={function(){
               call("/scout/orgs/roster?org_id="+o.id).then(function(d){ setOrgRoster(d); })
                 .catch(function(e){ notify&&notify(e.message); }); }}>Roster</button>
             <button style={{...gbt,padding:"5px 9px",minHeight:30}} onClick={function(){
               act("/scout/orgs",{__m:"PATCH",org_id:o.id,
                 status:o.status==="active"?"paused":"active",actor:actor||null},
                 function(){ notify&&notify("Status changed — it takes effect on the "+
                   "organization's next request."); }); }}>
               {o.status==="active"?"Pause":"Resume"}</button>
             <button style={{...gbt,padding:"5px 9px",minHeight:30}} onClick={function(){
               if(!window.confirm("Rotate "+o.name+"'s credential?\n\nThe current one stops "+
                 "working immediately.")) return;
               act("/scout/orgs",{__m:"PATCH",org_id:o.id,rotate_credential:true,
                 actor:actor||null}, function(d){ window.alert("New credential (shown ONCE):\n\n"+
                   d.credential); }); }}>Rotate key</button>
           </div>
           <div style={{...lbl,marginTop:10}}>GRANTS</div>
           {!(o.grants||[]).length?<div style={note}>No grant — this organization sees nothing.</div>
            :<Tbl><tbody>
              <tr><th style={th}>Grant</th><th style={th}>Subject</th><th style={th}>Window</th>
                  <th style={th}>Status</th><th style={th}></th></tr>
              {o.grants.map(function(g){return <tr key={g.id}>
                <td style={{...td,color:C.gray500}}>{g.id}</td>
                <td style={td}>{g.team_id?("roster: "+(g.team||g.team_id)):("session "+g.session_id)}</td>
                <td style={td}>{(g.starts_on||"—")+" → "+(g.ends_on||"open")}</td>
                <td style={td}>{pill(g.status==="active"?"ok":"off",g.status)}</td>
                <td style={td}><button style={{...gbt,padding:"4px 8px",minHeight:26}}
                  onClick={function(){ act("/scout/grants",{__m:"PATCH",grant_id:g.id,
                    status:g.status==="active"?"paused":"active",actor:actor||null}); }}>
                  {g.status==="active"?"Pause":"Resume"}</button></td></tr>;})}
            </tbody></Tbl>}
           <div style={{display:"flex",gap:8,flexWrap:"wrap",marginTop:8}}>
             <select style={{...inp,flex:"0 1 200px"}} value={form["g"+o.id]||""}
               onChange={function(e){f("g"+o.id,e.target.value);}}>
               <option value="">grant a session…</option>
               {sess.map(function(s){return <option key={s.id} value={"s"+s.id}>
                 {s.session_date+" "+(s.venue||"")}</option>;})}
               {teams.map(function(t){return <option key={"t"+t.id} value={"t"+t.id}>
                 roster: {t.name}</option>;})}
             </select>
             <input style={{...inp,flex:"0 1 140px"}} type="date" placeholder="ends"
               value={form["ge"+o.id]||""} onChange={function(e){f("ge"+o.id,e.target.value);}}/>
             <button style={btn} disabled={busy||!form["g"+o.id]} onClick={function(){
               var v=form["g"+o.id]; var body={org_id:o.id,actor:actor||null,
                 ends_on:form["ge"+o.id]||null};
               if(v[0]==="s") body.session_id=Number(v.slice(1)); else body.team_id=Number(v.slice(1));
               act("/scout/grants",body,function(){ f("g"+o.id,""); f("ge"+o.id,"");
                 notify&&notify("Granted."); });
             }}>Grant</button>
           </div>
         </div>;})}
      </div>

      {orgRoster&&<div style={card}>
        <div style={head}><span style={step}>9</span>
          <span style={hTxt}>ROSTER — {String((orgRoster.organization||{}).name||"").toUpperCase()}</span>
          <span style={{flex:1}}/>
          <button style={{...gbt,padding:"5px 9px",minHeight:30}}
            onClick={function(){setOrgRoster(null);}}>Close</button></div>
        {orgRoster.why?<div style={note}>{orgRoster.why}</div>:null}
        {!(orgRoster.players||[]).length&&!orgRoster.why?<div style={note}>No player on this roster.</div>
         :<Tbl><tbody>
           <tr><th style={th}>Player</th><th style={th}>#</th><th style={th}>Pos</th>
               <th style={th}>Active</th><th style={th}></th></tr>
           {(orgRoster.players||[]).map(function(p){return <tr key={p.id}>
             <td style={td}>{((p.first_name||"")+" "+(p.last_name||"")).trim()}</td>
             <td style={td}><input style={{...inp,width:70,minHeight:30,padding:"4px 6px"}}
               defaultValue={p.jersey_number||""} onBlur={function(e){
                 if(e.target.value===(p.jersey_number||"")) return;
                 act("/scout/orgs/roster",{org_id:(orgRoster.organization||{}).id,
                   player_id:p.id,jersey_number:e.target.value,actor:actor||null},
                   function(){ notify&&notify("Jersey updated."); }); }}/></td>
             <td style={td}>{(p.positions||[]).join(", ")||"—"}</td>
             <td style={td}>{p.active===false?pill("off","inactive"):pill("ok","active")}</td>
             <td style={td}><button style={{...gbt,padding:"4px 8px",minHeight:26}}
               onClick={function(){
                 act("/scout/orgs/roster",{org_id:(orgRoster.organization||{}).id,
                   player_id:p.id,active:(p.active===false),actor:actor||null},
                   function(){ call("/scout/orgs/roster?org_id="+(orgRoster.organization||{}).id)
                     .then(setOrgRoster); }); }}>
               {p.active===false?"Reactivate":"Mark inactive"}</button></td></tr>;})}
         </tbody></Tbl>}
        <p style={{...note,marginTop:8}}>
          A player is never deleted — §8. One it no longer carries is marked inactive, and the
          record and every session scouted on him stay.
        </p>
        <div style={{display:"flex",gap:8,flexWrap:"wrap",marginTop:8}}>
          <input style={{...inp,flex:"1 1 120px"}} placeholder="first" value={form.orf||""}
            onChange={function(e){f("orf",e.target.value);}}/>
          <input style={{...inp,flex:"1 1 120px"}} placeholder="last" value={form.orl||""}
            onChange={function(e){f("orl",e.target.value);}}/>
          <input style={{...inp,flex:"0 1 90px"}} placeholder="#" value={form.orj||""}
            onChange={function(e){f("orj",e.target.value);}}/>
          <button style={btn} disabled={busy||!((form.orf||"")+(form.orl||"")).trim()}
            onClick={function(){
              act("/scout/orgs/roster",{org_id:(orgRoster.organization||{}).id,
                first_name:form.orf||null,last_name:form.orl||null,
                jersey_number:form.orj||null,actor:actor||null}, function(){
                ["orf","orl","orj"].forEach(function(k){f(k,"");});
                call("/scout/orgs/roster?org_id="+(orgRoster.organization||{}).id)
                  .then(setOrgRoster); }); }}>Add to roster</button>
        </div>
      </div>}
    </div>;
  }

  /* ── 8 · OPERATIONS ────────────────────────────────────────────────────────────────────── */
  function Ops(){
    function fa2(path, body){
      return call("/scout/ops/2fa/"+path, body?{method:"POST",body:body}:undefined);
    }
    return <div style={card}>
      <div style={head}><span style={step}>10</span><span style={hTxt}>OPERATIONS</span></div>
      <div style={lbl}>SECOND FACTOR — §1</div>
      <div style={{display:"flex",gap:8,flexWrap:"wrap",alignItems:"center"}}>
        <input style={{...inp,flex:"1 1 180px"}} placeholder="admin name"
          value={actor} onChange={function(e){remember(e.target.value);}}/>
        <button style={gbt} onClick={function(){
          if(!actor.trim()){ setFa({why:"Name the admin first."}); return; }
          fa2("state?actor="+encodeURIComponent(actor.trim())).then(setFa)
            .catch(function(e){ setFa({why:e.message}); }); }}>Check</button>
        <button style={gbt} onClick={function(){
          if(!actor.trim()){ setFa({why:"Name the admin first."}); return; }
          if(!window.confirm("Enrol a NEW second factor for "+actor.trim()+"?\n\nThis REPLACES "
            +"any existing secret — the old one stops working.")) return;
          fa2("enrol",{actor:actor.trim()}).then(setFa)
            .catch(function(e){ setFa({why:e.message}); }); }}>Enrol</button>
        <input style={{...inp,flex:"0 1 120px"}} placeholder="6-digit code" inputMode="numeric"
          value={form.code||""} onChange={function(e){f("code",e.target.value);}}/>
        <button style={btn} onClick={function(){
          fa2("verify",{actor:(actor||"").trim(),code:(form.code||"").trim()})
            .then(function(d){ setFa(d); f("code",""); })
            .catch(function(e){ setFa({why:e.message}); }); }}>Verify</button>
      </div>
      {fa&&<div style={{...note,marginTop:8,wordBreak:"break-all"}}>
        {fa.enrolled===false&&<div>Not enrolled — approval does not require a factor for this
          admin, and the approval response says so rather than implying a protection.</div>}
        {fa.secret&&<div><b>Secret (shown once):</b> {fa.secret}<br/>{fa.otpauth}</div>}
        {fa.ok&&<div>Verified {fa.verified_at||"now"} — valid {Math.round((fa.valid_for_s||0)/60)} min.</div>}
        {fa.why&&<div>{fa.why}</div>}{fa.note&&<div>{fa.note}</div>}
      </div>}
      <div style={{...lbl,marginTop:16}}>DATASET</div>
      <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
        <a style={{...gbt,textDecoration:"none",display:"inline-block"}}
           href={SCOUT_HOST+"/scout/ops/export"} target="_blank" rel="noopener noreferrer">
          Export the scouting dataset</a>
      </div>
      <p style={{...note,marginTop:8,marginBottom:0}}>
        Retention, merge and archive are endpoints with destructive effects; they stay on the API
        until each has a confirmation flow worth trusting.
      </p>
    </div>;
  }

  /* ── SHELL ─────────────────────────────────────────────────────────────────────────────── */
  /* maxWidth:100% + minWidth:0 on the shell: a grid or flex CHILD defaults to min-content
     width, so one wide descendant can still stretch the whole column even with a scroller
     inside it. This is the belt to that braces. */
  return <div style={{maxWidth:"100%",minWidth:0,overflowX:"hidden"}}>
    {/* the coral rail and the ADMIN mark: no customer surface has either */}
    <div style={{height:3,background:C.coral,borderRadius:2,marginBottom:10}}/>
    <div style={{...card,display:"flex",alignItems:"center",gap:10,flexWrap:"wrap",
                 marginBottom:12}}>
      <span style={{font:"800 12px Inter",letterSpacing:".12em",color:C.coral}}>BBOT SCOUTING</span>
      <span style={note}>admin only · never on a public or recruiting surface</span>
      <span style={{flex:1}}/>
      <a style={{...gbt,textDecoration:"none",display:"inline-block"}} href={SCOUT_HOST+"/scout/tool"}
         target="_blank" rel="noopener noreferrer">Open the scouting tool</a>
      <button style={gbt} onClick={load} disabled={busy}>{busy?"Loading…":"Refresh"}</button>
    </div>

    {err&&<div style={{...card,background:"#fdecec",border:"1px solid #f1b9b6",color:"#7d1d19",
      fontSize:12.5}}>
      <b>Could not load scouting.</b> {err}
      {/^HTTP 40[13]/.test(err)&&<div style={{marginTop:4}}>Your admin session was not accepted.
        Sign out and in again.</div>}
      {/HTTP 404/.test(err)&&<div style={{marginTop:4}}>This backend has no scouting router.</div>}
    </div>}

    {home&&<div style={{display:"flex",gap:8,flexWrap:"wrap",marginBottom:12}}>
      {figure(teams.length,"TEAMS")}
      {figure(sess.length,"SESSIONS")}
      {figure(home.n_pending,"AWAITING APPROVAL",home.n_pending?"warn":null)}
      {figure(orgs.length,"ORGANIZATIONS")}
      {figure(home.n_expiring,"GRANTS ENDING ≤30d",home.n_expiring?"warn":null)}
    </div>}

    <Flow/>

    {stage!=="flow"&&<div style={{display:"flex",gap:8,marginBottom:10,flexWrap:"wrap"}}>
      <button style={gbt} onClick={function(){setStage("flow");}}>← all stages</button>
      <span style={{flex:1}}/>
      <input style={{...inp,flex:"0 1 240px"}} placeholder="search player, team, date or venue"
        value={form.q||""} onChange={function(e){f("q",e.target.value);}}
        onKeyDown={function(e){ if(e.key==="Enter"){
          call("/scout/home?q="+encodeURIComponent(form.q||"")).then(setHome)
            .catch(function(x){ notify&&notify(x.message); }); } }}/>
    </div>}

    {/* ── TAG AND CLIP: THE EXISTING TAGGER, NOT A SECOND ONE ──────────────────────────────
        TagSegmenter is the recruiting product's tagger — admin scrubs the master, tags where
        each player's segment starts, and /segment-from-tags builds the segments. It already
        has the frame step, the 0.1x-1x preview and the millisecond readout, and cloning it for
        scouting would create two implementations of one tagging contract that drift apart. It
        is handed a SCOUTING block's object key and its proposal is sent to /generate-clips with
        subjectType "scout_player" — the subject gate §1 requires, which _resolve_subject has
        supported since the module merged and which nothing was calling.
        [[use-the-built-pipeline]] [[existing-pattern-before-assumed-api]] */}
    {(stage==="flow"||stage==="segment")&&(tagging||stage==="segment")&&<div style={card}>
      <div style={head}><span style={step}>5</span>
        <span style={hTxt}>SEGMENT &amp; RINSE</span>
        <span style={{flex:1}}/>
        {tagging&&<span style={note}>{String(tagging.objectKey).split("/").pop()}</span>}
        {tagging&&<button style={{...gbt,padding:"5px 9px",minHeight:30}}
          onClick={function(){setTagging(null);setProposal(null);}}>Close</button>}</div>

      {/* THE BLOCK IS PICKED HERE rather than by expanding the right session row on stage 3.
          The path existed and was reachable only by knowing where to look, which is how a built
          path reads as a missing one. */}
      {!tagging&&<div>
        <p style={note}>Tag a half-inning block, review what the tagger proposed, then rinse the
          clips onto the scouted players. Pull the players on stage 1 first — a clip can only
          bind to a player it can name.</p>
        {!sess.length?<div style={note}>No session yet.</div>
         :<Tbl min={460}><tbody>
           <tr><th style={th}>Session</th><th style={th}>Venue</th><th style={th}>Blocks</th>
               <th style={th}></th></tr>
           {sess.filter(function(x){return (x.n_blocks||0)>0;}).map(function(x){
             return <tr key={x.id}>
               <td style={td}>{x.session_date}</td><td style={td}>{x.venue||"—"}</td>
               <td style={td}>{x.n_blocks}</td>
               <td style={td}><button style={{...gbt,padding:"4px 9px",minHeight:28}}
                 onClick={function(){
                   call("/scout/blocks?session_id="+x.id).then(function(d){
                     var bl=(d.blocks||[])[0];
                     if(!bl||!bl.r2_key){ notify&&notify("That session's blocks carry no key yet."); return; }
                     setTagging({sessionId:x.id, objectKey:bl.r2_key, blockIndex:bl.index,
                                 date:x.session_date, blocks:d.blocks||[]});
                   }).catch(function(e){ notify&&notify(e.message); }); }}>Tag</button></td>
             </tr>;})}
           {!sess.filter(function(x){return (x.n_blocks||0)>0;}).length&&
             <tr><td style={td} colSpan={4}><span style={note}>No session has a block uploaded
               yet — add the video on stage 3.</span></td></tr>}
         </tbody></Tbl>}
      </div>}

      {/* ── MAP THE FIELD — the four taps the whole position layer waits on ──────────────────
          Luis: "the view will always have the visible bases showing when runner steps on 1st and
          when catchers throw reaches 2b". So the correspondences are on screen at the moments
          that matter, and four taps turn every later frame of this block into field feet.
          A homography is fixed EXACTLY by four points, which is why this is taps and not
          calibration: no scale, no depth, nothing the record's scale blockers apply to. */}
      {tagging&&<div style={{border:"1px solid "+C.border,borderRadius:10,padding:12,
        marginBottom:12,background:C.gray50}}>
        <div style={{display:"flex",alignItems:"center",gap:8,flexWrap:"wrap"}}>
          <span style={{...lbl,marginTop:0}}>MAP THE FIELD</span>
          {calDone
            ?pill("ok","mapped"+(calErr!==null?(" · rubber off by "+calErr+" ft"):""))
            :pill("off","not mapped — positions cannot be placed")}
          <span style={{flex:1}}/>
          <button style={{...gbt,padding:"4px 9px",minHeight:26}}
            onClick={function(){ setCalOpen(!calOpen); }}>{calOpen?"Hide":"Open"}</button>
        </div>

        {calOpen&&<div style={{marginTop:10}}>
          <p style={note}>
            Scrub to a frame where all four bases are visible, pick the base distance for the
            level, then tap <b>home, first, second, third</b> in that order. Tap the pitching
            rubber too if you can see it — it is held out of the fit, so it is the only thing
            that can tell you the marks were accurate.
          </p>

          <div style={{display:"flex",gap:8,flexWrap:"wrap",alignItems:"center",marginBottom:8}}>
            <span style={note}>Base distance</span>
            {[90,80,70,60].map(function(bf){
              return <button key={bf} style={calBase===bf?btn:gbt}
                onClick={function(){ setCalBase(bf); }}>{bf} ft</button>;})}
          </div>

          {!calUrl?<div style={note}>Loading the block…</div>:<div>
            <div style={{position:"relative",display:"inline-block",maxWidth:"100%"}}>
              {/* the click lands in DISPLAY pixels and the homography needs FRAME pixels, so the
                  ratio of naturalWidth to clientWidth is applied here. Storing display pixels
                  would silently rescale the whole map with the browser window. */}
              <video ref={calVid} src={calUrl} controls playsInline
                style={{maxWidth:"100%",display:"block",borderRadius:8,cursor:"crosshair"}}
                onClick={function(e){
                  var v=e.target, r=v.getBoundingClientRect();
                  if(!v.videoWidth) return;
                  var sx=v.videoWidth/r.width, sy=v.videoHeight/r.height;
                  var px=(e.clientX-r.left)*sx, py=(e.clientY-r.top)*sy;
                  var nm=CAL_ORDER[calNext]||CAL_ORDER[0];
                  var next={}; for(var k in calMarks) next[k]=calMarks[k];
                  next[nm]=[Math.round(px),Math.round(py)];
                  setCalMarks(next);
                  setCalNext(Math.min(calNext+1,CAL_ORDER.length-1));
                  setCalDone(false);
                }}/>
            </div>
            <div style={{display:"flex",gap:6,flexWrap:"wrap",marginTop:8}}>
              {CAL_ORDER.map(function(nm,i){
                var got=calMarks[nm];
                return <button key={nm} style={i===calNext?btn:(got?gbt:{...gbt,opacity:0.6})}
                  onClick={function(){ setCalNext(i); }}>
                  {nm}{got?(" ✓"):""}{nm==="rubber"?" (check)":""}</button>;})}
              <button style={gbt} onClick={function(){
                setCalMarks({}); setCalNext(0); setCalDone(false); setCalErr(null); }}>Clear</button>
            </div>
            <p style={{...note,marginTop:6}}>
              Tapping a name re-places that mark. The next tap on the video goes to the
              highlighted one.
            </p>

            <button style={{...btn,marginTop:8}}
              disabled={busy||!(calMarks.home&&calMarks.first&&calMarks.second&&calMarks.third)}
              onClick={function(){
                setBusy(true);
                var v=calVid.current;
                call("/scout/blocks/calibrate",{method:"POST",body:{
                  session_id:tagging.sessionId, block_index:(tagging.blockIndex||0),
                  marks:{home:calMarks.home,first:calMarks.first,
                         second:calMarks.second,third:calMarks.third},
                  base_ft:calBase, rubber:calMarks.rubber||null,
                  frame_w:v&&v.videoWidth?v.videoWidth:null,
                  frame_h:v&&v.videoHeight?v.videoHeight:null}})
                .then(function(d){
                  setBusy(false); setCalDone(true);
                  var c=(d&&d.check)||{};
                  setCalErr(c.error_ft!==undefined?c.error_ft:null);
                  notify&&notify(c.ok===true
                    ?("Field mapped — the rubber lands "+c.error_ft+" ft from where the rule puts "
                      +"it, so the marks are good.")
                    :(c.ok===false
                      ?("Mapped, but the rubber is off by "+c.error_ft+" ft — re-tap the bases, "
                        +"every position would inherit that error.")
                      :"Field mapped. The rubber was not marked, so the accuracy is unverified."));
                })
                .catch(function(e){ setBusy(false); notify&&notify(e.message); });
              }}>Save the map</button>
          </div>}
        </div>}
      </div>}

      {/* TAG — the recruiting product's own tagger, not a second one. TagSegmenter already has
          the frame step, the 0.1x-1x preview and the millisecond readout; cloning it for
          scouting would create two implementations of one tagging contract that drift apart.
          [[use-the-built-pipeline]] */}
      {tagging&&!proposal&&<div>
        {(tagging.blocks||[]).length>1&&<div style={{display:"flex",gap:8,flexWrap:"wrap",
          marginBottom:10}}>
          {tagging.blocks.map(function(bl,i){
            return <button key={i} style={bl.r2_key===tagging.objectKey?btn:gbt}
              onClick={function(){ setTagging({...tagging, objectKey:bl.r2_key, blockIndex:bl.index}); }}>
              block {bl.index!==undefined?bl.index:i}</button>;})}
        </div>}
        <TagSegmenter objectKey={tagging.objectKey}
          lineup={(players||[]).map(function(x){
            return {playerId:x.id, playerName:((x.first_name||"")+" "+(x.last_name||"")).trim(),
                    jerseyNum:x.jersey_number||""}; })}
          sessionType="Game" sessionDate={tagging.date}
          notify={notify}
          onProposal={function(res){ setProposal(res); }}/>
      </div>}

      {/* REVIEW BEFORE RINSE — the product's own order, and it was missing here. The recruiting
          flow goes tag -> review -> generate; mine fired /generate-clips straight out of
          onProposal, so nobody saw what was about to be cut. A clip bound to the wrong player is
          a scouting record about the wrong person, and this is the only place that is catchable.
          [[existing-pattern-before-assumed-api]] [[subject-provenance]] */}
      {tagging&&proposal&&<div>
        <div style={{...lbl,marginTop:4}}>REVIEW — {(proposal.segments||[]).length} SEGMENT(S)</div>
        <Tbl min={520}><tbody>
          <tr><th style={th}>Player</th><th style={th}>#</th><th style={th}>Action</th>
              <th style={th}>Start</th><th style={th}>End</th><th style={th}>Binds</th></tr>
          {(proposal.segments||[]).map(function(sg,i){
            return <tr key={i}>
              <td style={td}>{sg.playerName||<span style={{color:C.gray500}}>unnamed</span>}</td>
              <td style={td}>{sg.jerseyNum||"—"}</td>
              <td style={td}>{sg.actionType||"play"}</td>
              <td style={td}>{Number(sg.startSec||0).toFixed(1)}s</td>
              <td style={td}>{Number(sg.endSec||0).toFixed(1)}s</td>
              <td style={td}>{sg.playerId?pill("ok","scouted player")
                                         :pill("off","no player — reaches no profile")}</td>
            </tr>;})}
        </tbody></Tbl>
        <p style={{...note,marginTop:8}}>
          A segment with no player is cut but binds to nobody, so it reaches no profile. §4 binds
          a clip to a roster entry, and an unnamed one has no entry to bind to.
        </p>
        <div style={{display:"flex",gap:8,flexWrap:"wrap",marginTop:8}}>
          <button style={btn} disabled={busy||!(proposal.segments||[]).length} onClick={function(){
            var segs=(proposal.segments||[]).map(function(sg){
              return {jerseyNum:sg.jerseyNum?String(sg.jerseyNum):null, playerId:sg.playerId||null,
                      playerName:sg.playerName||null, actionType:sg.actionType||"play",
                      startSec:Number(sg.startSec)||0, endSec:Number(sg.endSec)||0,
                      clipType:sg.clipType||proposal.clipType||null};
            }).filter(function(sg){ return sg.endSec>sg.startSec; });
            if(!segs.length){ notify&&notify("No segment has an end after its start."); return; }
            setBusy(true);
            /* THE SAME REQUEST THE RECRUITING FLOW SENDS, plus the subject gate. autoEvaluate
               stays false for the reason the product states where it builds this body: the
               server-side evaluation cannot warm pose and would time out across several
               players. subjectType is what keeps these clips on the scouted population — §1
               requires every job to carry one and refuses a job with neither. */
            fetch(BACKEND_URL+"/generate-clips",{method:"POST",headers:bbotAdminHeaders(),
              body:JSON.stringify({objectKey:tagging.objectKey,
                proposalId:proposal.proposalId||null,
                sessionType:"Game", sessionDate:tagging.date, teamName:null,
                clipType:proposal.clipType||null, autoEvaluate:false, videoSource:"643",
                subjectType:"scout_player", segments:segs})})
              .then(function(r){ return r.text().then(function(t){
                if(!r.ok) throw new Error(t.slice(0,200)); return t?JSON.parse(t):{}; }); })
              .then(function(out){ setBusy(false); setProposal(null); setTagging(null);
                notify&&notify((out.clipsCreated||0)+" rinsed clip"+
                  ((out.clipsCreated===1)?"":"s")+" created"+
                  (out.skippedCount?(" · "+out.skippedCount+" duplicate skipped"):"")+
                  " — bound to the scouted players."); })
              .catch(function(e){ setBusy(false); notify&&notify("Clips not created: "+e.message); });
          }}>Rinse {(proposal.segments||[]).length} clip(s)</button>
          <button style={gbt} onClick={function(){setProposal(null);}}>Back to tagging</button>
        </div>
      </div>}
    </div>}

    {(stage==="flow"||stage==="roster")&&<Roster/>}
    {(stage==="flow"||stage==="session"||stage==="blocks")&&<Sessions/>}
    {(stage==="flow"||stage==="lineups")&&stage==="lineups"&&<div style={card}>
      <div style={head}><span style={step}>4</span><span style={hTxt}>LINEUPS</span></div>
      <p style={note}>§4: lineups are built from the rosters, and a team scouted before loads its
        last lineup. The tool builds them on the session screen, where the chips are — building
        them here would be a second place to do one thing.</p>
      <a style={{...btn,textDecoration:"none",display:"inline-block"}} href={SCOUT_HOST+"/scout/tool"}
         target="_blank" rel="noopener noreferrer">Open the tool</a>
    </div>}
    {(stage==="flow"||stage==="scouting")&&stage==="scouting"&&<div style={card}>
      <div style={head}><span style={step}>5</span><span style={hTxt}>SCOUTING</span></div>
      <p style={note}>§6: one screen, four taps a pitch, every entry written and read back, and a
        local queue that survives an inning with the Wi-Fi off. On a phone the three panes become
        a switcher at the bottom.</p>
      <a style={{...btn,textDecoration:"none",display:"inline-block"}} href={SCOUT_HOST+"/scout/tool"}
         target="_blank" rel="noopener noreferrer">Open the tool</a>
    </div>}
    {(stage==="flow"||stage==="handtimes")&&<HandTimes/>}
    {(stage==="flow"||stage==="reports")&&<Reports/>}
    {(stage==="flow"||stage==="orgs")&&<Orgs/>}
    {stage==="ops"&&<Ops/>}

    {home&&home.n_expiring>0&&(stage==="flow")&&<div style={card}>
      <div style={head}><span style={hTxt}>GRANTS ENDING WITHIN 30 DAYS</span></div>
      <Tbl><tbody>
        <tr><th style={th}>Grant</th><th style={th}>Org</th><th style={th}>Ends</th>
            <th style={th}>Days</th></tr>
        {(home.grants_expiring||[]).map(function(g){return <tr key={g.grant_id}>
          <td style={td}>{g.grant_id}</td><td style={td}>{g.org_id}</td>
          <td style={td}>{g.ends_on}</td>
          <td style={td}>{pill(g.lapsed?"bad":"off",
            g.lapsed?("lapsed "+Math.abs(g.days_left)+"d ago"):(g.days_left+"d"))}</td>
        </tr>;})}
      </tbody></Tbl>
    </div>}
  </div>;
}

function AdminPanel({users,setUsers,cu,metrics,setMetrics,scoutReports,setScoutReports,pushFeed,notify,go,lineups,setLineups,approveReport,highlights,setHighlights,coachUpdates,setCoachUpdates,siteContent,setSiteContent,saveSiteContent,fields,setFields,battedBalls,setBattedBalls,recaps,setRecaps,adminTab,setAdminTab,initialTab}){
  var bulkOpenS=useState(false); var bulkOpen=bulkOpenS[0]; var setBulkOpen=bulkOpenS[1];
  var tabState=useState(initialTab||adminTab||"activity"); var tab=tabState[0]; var setTab=tabState[1];

  var TABS=[
    ["activity","Activity"],
    ["roster","Roster"],
    ["register","Register Player"],
    ["pwreset","Password Resets"],
    ["metrics","Metrics"],
    ["compare","Compare"],
    // — Operate
    ["sessions","Master Sessions"],
    ["bbot","BBOT Eval"],
    ["reports","Reports"],
    ["failed","Failed Evals"],
    ["standing","Standing Frames"],
    ["cardapprovals","Card Approvals"],
    // — Review
    ["mass","Mass Approve"],
    ["history","Report History"],
    ["coaches","Coach Verification"],
    ["audit","Audit Log"],
    ["percentile","Percentile Disclosure"],
    ["calibration","BBOT Calibration"],
    ["events","Events"],
    ["transactions","Transactions"],
    // — Library
    ["videos","Videos"],
    ["reels","Reels"],
    ["recaps","Recaps"],
    // ONE SOCIAL TAB. The generator and the standout queue were separate tabs for a day and they do
  // the same job -- make a post, approve a post. Two doors to one workflow is two places to look
  // for the thing you were already doing.
  ["social","Social"],
    ["content","Site Content"],
    // ADVANCE SCOUTING — A DOOR, NOT A DASHBOARD. The scouting layer is served from the backend
    // host and nothing of it lives in this bundle: §0 of the scouting brief says nothing in that
    // layer "ever reaches a public or recruiting-side surface", and this bundle is what every
    // visitor of the public site downloads. What ships here is ONE outbound link behind the
    // admin gate. No scouting route names, no scouting API paths, no scouting data.
    ["scouting","BBOT Scouting"],
  ];

  var tabLabels={roster:"Roster",register:"Register Player",metrics:"Metrics",bbot:"BBOT",sessions:"Master Sessions",coaches:"Coach Verification",reports:"Roster Evaluations",mass:"Mass Approve",history:"Report History",clips:"Clip Review",videos:"Video History",recaps:"Session Reports",reels:"Highlights Reels",activity:"Activity",health:"System Health",reporting:"Reporting",social:"Social Posts",content:"Site Content",audit:"Audit Log",approvals:"Profile Approvals",emails:"Welcome Emails",faq:"FAQ",failed:"Failed Evals",standing:"Standing Frames",cardapprovals:"Card Approvals",compare:"Compare",events:"Events",transactions:"Transactions",scouting:"BBOT Scouting"};
  // TWO HOMES FOR ONE LABEL, and the rename only reached the other one. The array above is
  // the tab ORDER; `tabLabels` is what the tab actually renders, so renaming the array left
  // the visible name unchanged and the live bundle shipped both spellings at once. Keep the
  // two in step until the duplication itself is removed. [[one-home-per-value]]
  var tabIcons={roster:"",metrics:"",bbot:"",reports:"",recaps:"",highlights:"",content:""};

  // Limited staff (approved, non-admin) get add-players + run-evals only.
  // Money, deletes, coach verification, audit stay admin-only.
  var _isAdmin = cu && bbotIsAdmin(cu);
  var GROUPS_ALL=[
    {id:"today", label:"Today", tabs:["activity","health","reporting","transactions"]},
    {id:"evaluate", label:"Evaluate", tabs:["sessions","bbot","failed","standing"]},
    {id:"review", label:"Review", tabs:["approvals","cardapprovals","mass","reports","history"]},
    // A TAB THAT BELONGS TO NO GROUP IS NOT DRAWN. TABS only declares that a tab exists; the
    // sidebar renders from GROUPS, so "register" shipped complete and reachable by nothing --
    // present in the bundle, absent from the screen. Admin-only here on purpose: the endpoint
    // behind it is _require_admin, so staff would only find a button that 403s.
    // "pwreset" is listed HERE and not only in TABS, which is the whole point of the note above --
    // a tab in TABS but in no group ships complete and reachable by nothing. Roster is its group
    // because that is where people are; GROUPS_ALL renders only for _isAdmin, which is also the
    // access control, so no separate role check is needed inside the component.
    {id:"roster", label:"Roster", tabs:["roster","register","pwreset","metrics","compare","coaches"]},
    // HIGHLIGHT REELS REMOVED (Luis, 2026-09-07): no purpose. The tab is dropped from the
  // sidebar; the component and its endpoints are left in place, so nothing that already
  // exists is destroyed and re-listing it is a one-line change if it is ever wanted.
  {id:"library", label:"Library", tabs:["clips","videos","recaps","social","events","audit","calibration","content","emails","faq"]},
  // ITS OWN GROUP, which is what §1 of the scouting brief means by "separate admin tab": the
  // scouting layer sits beside the recruiting product, never inside one of its groups. Listed
  // only in GROUPS_ALL, and GROUPS_ALL renders only for _isAdmin — so the admin gate IS the
  // group membership and no separate role check is needed.
  {id:"scout", label:"Scouting", tabs:["scouting"]},
  ];
  var GROUPS_STAFF=[
    {id:"today", label:"Today", tabs:["activity"]},
    {id:"evaluate", label:"Evaluate", tabs:["sessions","bbot"]},
    {id:"roster", label:"Roster", tabs:["roster","metrics","compare"]},
  ];
  var GROUPS = _isAdmin ? GROUPS_ALL : GROUPS_STAFF;
  var groupForTab=function(t){var g=GROUPS.find(function(gr){return gr.tabs.indexOf(t)>=0;});return g?g.id:"today";};
  var groupState=useState(groupForTab(tab)); var activeGroup=groupState[0]; var setActiveGroup=groupState[1];
  useEffect(function(){ setActiveGroup(groupForTab(tab)); }, [tab]);
  function selectGroup(gid){
    setActiveGroup(gid);
    var g=GROUPS.find(function(gr){return gr.id===gid;});
    if(g && g.tabs.indexOf(tab)<0){ setTab(g.tabs[0]); setAdminTab(g.tabs[0]); }
  }
  return(
    <div style={{maxWidth:960,margin:"0 auto",padding:"0 16px 40px"}}>
      <div style={{background:"linear-gradient(135deg,"+C.navy+","+C.navyMid+")",borderRadius:16,padding:"20px 24px",marginBottom:20}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",flexWrap:"wrap",gap:10}}>
          <div>
            <div style={{display:"flex",alignItems:"center",gap:10}}><BbotMark tile="transparent" size={36}/><div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:22,color:C.white,letterSpacing:1.5}}>STAFF DASHBOARD</div></div>
            <div style={{fontSize:12,color:"rgba(255,255,255,.62)",marginTop:2}}>{cu.firstName} {cu.lastName} — {cu.staffRole||"Staff"}</div>
          </div>
          <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
            <div style={{textAlign:"center",minWidth:52}}><div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:20,color:C.white}}>{(users||[]).filter(function(u){return u.type==="player";}).length}</div><div style={{fontSize:9,color:"rgba(255,255,255,.4)",letterSpacing:.5}}>PLAYERS</div></div>
            <div style={{textAlign:"center",minWidth:52}}><div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:20,color:C.coral}}>{(scoutReports||[]).filter(function(r){return isDraftEval(r);}).length}</div><div style={{fontSize:9,color:"rgba(255,255,255,.4)",letterSpacing:.5}}>PENDING</div></div>
            <div style={{textAlign:"center",minWidth:52}}><div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:20,color:C.white}}>{(scoutReports||[]).filter(function(r){return isLiveEval(r);}).length}</div><div style={{fontSize:9,color:"rgba(255,255,255,.4)",letterSpacing:.5}}>APPROVED</div></div>
          </div>
        </div>
      </div>
      {/* Group nav — 5 sections */}
      <div style={{display:"flex",gap:6,marginBottom:14,flexWrap:"wrap"}}>
        {GROUPS.map(function(g){
          var active=activeGroup===g.id;
          // pending counts for badges
          var badge=0;
          if(g.id==="today"){
            // Surface health alerts on the Today group so issues are seen without opening the tab.
            var _orphan=(scoutReports||[]).filter(function(r){return r.playerId!=null && !(users||[]).some(function(u){return u.type==="player"&&String(u.id)===String(r.playerId);});}).length;
            var _signupSpike=(users||[]).filter(function(u){var t=u.createdAt?new Date(u.createdAt).getTime():0;return t&&(Date.now()-t)/86400000<1;}).length>=15?1:0;
            badge=_orphan+_signupSpike;
          }
          if(g.id==="review") badge=(scoutReports||[]).filter(function(r){return isDraftEval(r);}).length + (users||[]).filter(function(u){return u.approvalStatus==="pending";}).length;
          if(g.id==="evaluate") badge=(scoutReports||[]).filter(function(r){return isJobFailed(r);}).length;
          return <button key={g.id} onClick={function(){selectGroup(g.id);}} style={{background:active?C.navy:C.white,color:active?C.white:C.gray600,border:"1px solid "+(active?C.navy:C.border),borderRadius:10,padding:"10px 16px",fontFamily:"Inter,system-ui,sans-serif",fontSize:13,fontWeight:600,letterSpacing:.5,cursor:"pointer",display:"flex",alignItems:"center",gap:7}}>
            {g.label}
            {badge>0&&<span style={{background:C.coral,color:C.white,fontSize:10,fontWeight:700,borderRadius:99,padding:"1px 7px",minWidth:18,textAlign:"center"}}>{badge}</span>}
          </button>;
        })}
      </div>
      {/* Sub-tabs for active group (hidden for single-tab groups like Today) */}
      {(function(){
        var g=GROUPS.find(function(gr){return gr.id===activeGroup;})||GROUPS[0];
        if(g.tabs.length<=1) return null;
        // Wrapping pill buttons instead of a single overflowing underline row. The underline
        // strip overlapped and was hard to tap on mobile once a group had many tabs (Library
        // has 11); pills wrap to multiple rows, each one a clear tap target.
        return <div style={{display:"flex",flexWrap:"wrap",gap:8,marginBottom:20}}>
          {g.tabs.map(function(tk){
            var active=tab===tk;
            return <button key={tk} onClick={function(){setTab(tk);setAdminTab(tk);}} style={{background:active?C.coral:C.blueFaint,border:"1px solid "+(active?C.coral:C.blueLight),borderRadius:8,padding:"8px 14px",fontSize:12,fontWeight:active?700:600,color:active?C.white:C.blue,cursor:"pointer",whiteSpace:"nowrap",letterSpacing:.3,transition:"all .15s"}}>{tabLabels[tk]||tk}</button>;
          })}
        </div>;
      })()}
      <div style={{marginBottom:16}}><div style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:16,color:C.navy,letterSpacing:1}}>{tabIcons[tab]} {(tabLabels[tab]||"").toUpperCase()}</div></div>
      {/* TODAY quick actions — jump straight to what needs attention */}
      {tab==="activity"&&(function(){
        var pending=(scoutReports||[]).filter(function(r){return isDraftEval(r);}).length;
        var failed=(scoutReports||[]).filter(function(r){return isJobFailed(r);}).length;
        var reReview=(scoutReports||[]).filter(function(r){return r.reviewRequested;}).length;
        var pendingUsers=(users||[]).filter(function(u){return u.approvalStatus==="pending";}).length;
        var readyToRelease=(scoutReports||[]).filter(function(r){return isJobReady(r);}).length;
        var cards=[];
        if(readyToRelease>0) cards.push(["Evals ready to release",readyToRelease,C.coral,function(){setTab("mass");setAdminTab("mass");}]);
        if(pending>0) cards.push(["Evaluations to approve",pending,C.coral,function(){setTab("mass");setAdminTab("mass");}]);
        if(pendingUsers>0) cards.push(["Accounts to approve",pendingUsers,C.blue,function(){setTab("approvals");setAdminTab("approvals");}]);
        if(failed>0) cards.push(["Failed evals to retry",failed,C.red,function(){setTab("failed");setAdminTab("failed");}]);
        if(reReview>0) cards.push(["Re-review requests",reReview,C.orange,function(){setTab("reports");setAdminTab("reports");}]);
        if(!cards.length) return (
          <div style={{padding:"9px 12px",marginBottom:12,background:C.gray50,borderRadius:9,textAlign:"center",color:C.gray500,fontSize:12}}>
            ✓ All caught up — nothing needs your attention right now.
          </div>
        );
        /* THE COUNT AND ITS LABEL ON ONE LINE. A 30px numeral above a 12px label made each box
           58px tall to carry a number that is almost always single-digit, and five of them pushed
           the feed itself below the fold on a laptop. Same information, one line, half the height. */
        return <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(148px,1fr))",gap:8,marginBottom:12}}>
          {cards.map(function(c,i){
            return <button key={i} onClick={c[3]} style={{background:C.white,border:"1px solid "+C.border,borderLeft:"3px solid "+c[2],borderRadius:9,padding:"8px 11px",textAlign:"left",cursor:"pointer",display:"flex",alignItems:"baseline",gap:8}}>
              <span style={{fontFamily:"Inter,system-ui,sans-serif",fontSize:18,fontWeight:800,color:c[2],lineHeight:1}}>{c[1]}</span>
              <span style={{fontSize:11.5,color:C.gray600,fontWeight:600,lineHeight:1.25}}>{c[0]}</span>
            </button>;
          })}
        </div>;
      })()}
      {tab==="roster"&&<div><div style={{display:"flex",justifyContent:"flex-end",marginBottom:10}}><Btn v="primary" onClick={function(){setBulkOpen(true);}}>+ Bulk Add Players</Btn></div>{bulkOpen&&<BulkPlayerImport setUsers={setUsers} notify={notify} onClose={function(){setBulkOpen(false);}}/>}</div>}
      {tab==="roster"&&<RosterManager players={(users||[]).filter(function(u){return u.type==="player";})} cu={cu} notify={notify} lineups={lineups} setLineups={setLineups}/>}
      {tab==="pwreset"&&<AdminPasswordReset users={users} notify={notify}/>}
      {tab==="sessions"&&<SessionsView users={users} lineups={lineups} notify={notify} goToBbot={function(){setTab("bbot");setAdminTab("bbot");}}/>}
      {tab==="activity"&&<ActivityPosts cu={cu} notify={notify} isAdmin={_isAdmin}/>}
      {tab==="activity"&&<ActivityFeed users={users||[]} scoutReports={scoutReports||[]} go={go} setAdminTab={function(t){setTab(t);setAdminTab(t);}}/>}
      {tab==="health"&&<SystemHealthView users={users||[]} setUsers={setUsers} scoutReports={scoutReports||[]} setScoutReports={setScoutReports} highlights={highlights||[]} setHighlights={setHighlights} battedBalls={battedBalls||[]} lineups={lineups||[]} recaps={recaps||[]} notify={notify} go={function(t){setTab(t);setAdminTab(t);}}/>}
      {tab==="failed"&&<FailedEvalsView scoutReports={scoutReports||[]} setScoutReports={setScoutReports} users={users||[]} notify={notify}/>}
      {tab==="register"&&<AdminRegisterPlayer notify={notify}/>}
      {tab==="standing"&&<StandingFrameCheck notify={notify}/>}
      {tab==="cardapprovals"&&<CardApprovals notify={notify}/>}
      {tab==="audit"&&<AuditLogView users={users||[]} scoutReports={scoutReports||[]} go={go}/>}
      {tab==="percentile"&&<PercentileDisclosureView users={users||[]} scoutReports={scoutReports||[]} go={go}/>}
      {tab==="events"&&<EventsView users={users||[]} setUsers={setUsers} cu={cu} notify={notify} go={go}/>}
      {tab==="compare"&&<CompareView users={users||[]} scoutReports={scoutReports||[]} metrics={metrics||{}}/>}
      {tab==="coaches"&&<CoachVerificationView users={users} setUsers={setUsers} notify={notify}/>}
      {tab==="approvals"&&<ProfileApprovalsView users={users} setUsers={setUsers} notify={notify}/>}
      {tab==="emails"&&<EmailTemplatesView siteContent={siteContent} saveSiteContent={saveSiteContent} notify={notify}/>}
      {tab==="faq"&&<FaqAdminView siteContent={siteContent} saveSiteContent={saveSiteContent} notify={notify}/>}
      {tab==="scouting"&&_isAdmin&&<AdvanceScoutingPanel notify={notify}/>}
      {tab==="mass"&&<MassApprovalView reports={scoutReports||[]} setScoutReports={setScoutReports} users={users||[]} approveReport={approveReport} notify={notify}/>}
      {tab==="metrics"&&<AdminMetricsView users={users} metrics={metrics}/>}
      {tab==="reporting"&&<AdminReportingView scoutReports={scoutReports} users={users} cu={cu}/>}
      {tab==="transactions"&&<TransactionsView scoutReports={scoutReports} users={users} cu={cu}/>}
      {tab==="bbot"&&<BbotRunner users={users} setUsers={setUsers} cu={cu} metrics={metrics} scoutReports={scoutReports} setScoutReports={setScoutReports} pushFeed={pushFeed} notify={notify} lineups={lineups} approveReport={approveReport} fields={fields} battedBalls={battedBalls} setBattedBalls={setBattedBalls} highlights={highlights} setHighlights={setHighlights} coachUpdates={coachUpdates} setCoachUpdates={setCoachUpdates} recaps={recaps} setRecaps={setRecaps}/>}
      {tab==="reports"&&<MyReportsView myReports={scoutReports} users={users} scoutReports={scoutReports} setScoutReports={setScoutReports} cu={cu} notify={notify} approveReport={approveReport}/>}
      {tab==="history"&&<ReportHistoryView scoutReports={scoutReports} setScoutReports={setScoutReports} users={users} cu={cu} notify={notify}/>}
      {tab==="videos"&&<VideoHistoryView scoutReports={scoutReports} users={users} cu={cu} notify={notify} go={go}/>}
      {tab==="recaps"&&<RecapsPage recaps={recaps||[]} setRecaps={setRecaps} users={users} cu={cu} notify={notify} isStaff={true} scoutReports={scoutReports} go={go}/>}
      {tab==="highlights"&&<HighlightsAdminView highlights={highlights||[]} setHighlights={setHighlights} users={users} cu={cu} notify={notify}/>}
      {/* THE STANDOUT REGISTRY IS HIDDEN (Luis, 2026-09-07). This tab kept a running list of every
          report BBOT flagged as a standout, with a per-row approve/reject state -- a registry the
          site maintained on top of the reports it already holds. The job here is to GENERATE a post
          when one is wanted, not to keep a second ledger of who was notable.

          HIDDEN, NOT DELETED. SocialPostsView and the `standout` fields it reads are untouched, and
          nothing stored is removed -- restoring the list is putting this one element back. */}
      {tab==="social"&&<SocialManagerView notify={notify}/>}
      {tab==="reels"&&<ReelBuilderView users={users} cu={cu} notify={notify}/>}
      {tab==="clips"&&<ClipReviewView users={users} notify={notify} go={go}/>}
      {tab==="content"&&(
        <div style={{maxWidth:600}}>
          <SectionHeader>Site Content Editor</SectionHeader>
          <p style={{fontSize:12,color:C.gray400,marginBottom:16}}>Edit public-facing text across the Landing, About, Pricing, and Footer areas. Saved changes go live for all visitors immediately. More fields are wired over time — request any specific text you want made editable.</p>
          {Object.keys(siteContent||{}).map(function(k){
            var LABELS={aboutHero:"About — Hero",aboutP1:"About — Paragraph 1",aboutP2:"About — Paragraph 2",aboutP3:"About — Paragraph 3",aboutP4:"About — Paragraph 4",landingTagline:"Landing — Tagline",landingSub:"Landing — Subtitle",landingHeadline:"Landing — Main Headline",landingSubtext:"Landing — Hero Subtext",whatBbotDelivers:"Landing — 'What BBOT Delivers' Heading",pricingSessionNote:"Pricing — Session Note",pricingPlayerNote:"Pricing — Player Eval Note",footerTagline:"Footer — Tagline",contactEmail:"Contact Email"};
            return(
            <div key={k} style={{marginBottom:14}}>
              <label style={{fontSize:11,fontWeight:600,color:C.gray500,display:"block",marginBottom:4,letterSpacing:.5}}>{LABELS[k]||k}</label>
              <textarea value={(siteContent||{})[k]||""} onChange={function(e){var v=e.target.value;setSiteContent(function(prev){var next=Object.assign({},prev);next[k]=v;return next;});}} style={{width:"100%",padding:"8px 12px",borderRadius:8,border:"1px solid "+C.border,fontSize:13,lineHeight:1.6,minHeight:72,resize:"vertical",boxSizing:"border-box",fontFamily:"inherit"}}/>
            </div>
          );})}
          <Btn v="primary" onClick={function(){
            if(saveSiteContent){ saveSiteContent(siteContent).then(function(){notify("Content saved — live for all visitors.");}).catch(function(){notify("Saved locally; sync failed.","error");}); }
            else notify("Content saved!");
          }} style={{marginTop:8}}>Save Changes</Btn>
        </div>
      )}
    </div>
  );
}


// Card auto-generation fires on payment confirmed (see PdfUnlockButton)

